webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _redux = __webpack_require__(2);
	
	var redux = _interopRequireWildcard(_redux);
	
	var _ngRedux = __webpack_require__(15);
	
	var _ngRedux2 = _interopRequireDefault(_ngRedux);
	
	var _angularUiRouter = __webpack_require__(41);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(42);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _angularAnimate = __webpack_require__(44);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularAside = __webpack_require__(46);
	
	var _angularAside2 = _interopRequireDefault(_angularAside);
	
	var _angularjsToaster = __webpack_require__(48);
	
	var _angularjsToaster2 = _interopRequireDefault(_angularjsToaster);
	
	var _angularCookies = __webpack_require__(50);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularMessages = __webpack_require__(52);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _angularUiMask = __webpack_require__(54);
	
	var _angularUiMask2 = _interopRequireDefault(_angularUiMask);
	
	var _angularSpinners = __webpack_require__(58);
	
	var _angularSpinners2 = _interopRequireDefault(_angularSpinners);
	
	var _ngmap = __webpack_require__(59);
	
	var _ngmap2 = _interopRequireDefault(_ngmap);
	
	var _angularTooltips = __webpack_require__(60);
	
	var _angularTooltips2 = _interopRequireDefault(_angularTooltips);
	
	var _ngMeta = __webpack_require__(62);
	
	var _ngMeta2 = _interopRequireDefault(_ngMeta);
	
	__webpack_require__(65);
	
	__webpack_require__(67);
	
	var _router = __webpack_require__(68);
	
	var _app = __webpack_require__(69);
	
	var _reducer = __webpack_require__(78);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__(80);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _constants = __webpack_require__(82);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	__webpack_require__(85);
	
	__webpack_require__(87);
	
	__webpack_require__(88);
	
	__webpack_require__(89);
	
	__webpack_require__(90);
	
	var _main = __webpack_require__(102);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _main3 = __webpack_require__(133);
	
	var _main4 = _interopRequireDefault(_main3);
	
	var _main5 = __webpack_require__(171);
	
	var _main6 = _interopRequireDefault(_main5);
	
	var _main7 = __webpack_require__(257);
	
	var _main8 = _interopRequireDefault(_main7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/*eslint-enable*/
	
	/*eslint-disable*/
	
	
	// Constants
	
	
	// Reducers
	
	
	// Router
	var reducers = redux.combineReducers({
	  auth: _reducer2.default,
	  order: _reducer4.default,
	  ngMeta: _ngMeta2.default
	});
	
	// Styles
	
	
	// Apps
	
	
	var angular = __webpack_require__(55);
	__webpack_require__(295);
	var googleanalaytics = __webpack_require__(297);
	var remarketing = __webpack_require__(299);
	
	var app = angular.module('app', [_ngRedux2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _angularAnimate2.default, _angularAside2.default, _angularjsToaster2.default, _angularCookies2.default, _angularMessages2.default, _angularUiMask2.default, _ngmap2.default, _angularSpinners2.default, 'angularjs-dropdown-multiselect', 'angulartics', googleanalaytics, remarketing, 'app.components', 'app.auth', 'app.dashboard', 'app.order', _angularTooltips2.default, 'ngMeta', 'ngSanitize']).run(['$anchorScroll', 'ngMeta', '$rootScope', function ($anchorScroll, ngMeta) {
	  console.log("Heartland ", window.Heartland);
	  console.log("Tsys ", window.GlobalPayments);
	  console.log("Moneris", window.monerisCheckout);
	  $anchorScroll.yOffset = 350; // always scroll by 50 extra pixels
	  // console.log(ngMeta);
	  ngMeta.init();
	}]).constant('APP', _constants2.default).constant('Heartland', window.Heartland).constant('POWERREVIEWS', window.POWERREVIEWS).constant('GlobalPayments', window.GlobalPayments)
	// .constant('paypal', window.paypal)
	
	.constant('MonerisCheckout', window.monerisCheckout).component('app', _app.AppComponent).config(_router.routerConfig).config(['$ngReduxProvider', function ($ngReduxProvider) {
	
	  $ngReduxProvider.createStoreWith(reducers);
	}]).config(['$analyticsProvider', function ($analyticsProvider) {
	  $analyticsProvider.firstPageview(true);
	  $analyticsProvider.withAutoBase(true);
	}]);
	
	angular.element(document).ready(function () {
	  angular.bootstrap(document, [app.name], { strictDi: true });
	});

/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {/*global require,module*/
	(function commonJS(require, module) {
	  'use strict';
	
	  __webpack_require__(61);
	
	  module.exports = '720kb.tooltips';
	}(require, module));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)(module)))

/***/ },
/* 61 */
/***/ function(module, exports) {

	/*
	 * angular-tooltips
	 * 1.2.2
	 * 
	 * Angular.js tooltips module.
	 * http://720kb.github.io/angular-tooltips
	 * 
	 * MIT license
	 * Tue Jun 20 2017
	 */
	/*global angular,window*/
	(function withAngular(angular, window) {
	  'use strict';
	
	  var directiveName = 'tooltips'
	  , resizeObserver = (function resizeObserver() {
	
	    var callbacks = []
	      , lastTime = 0
	      , runCallbacks = function runCallbacks(currentTime) {
	
	        if (currentTime - lastTime >= 15) {
	
	          callbacks.forEach(function iterator(callback) {
	
	            callback();
	          });
	          lastTime = currentTime;
	        } else {
	
	          window.console.log('Skipped!');
	        }
	      }
	      , resizeTimeout
	      , resize = function resize() {
	        window.clearTimeout(resizeTimeout);
	        resizeTimeout = window.setTimeout(function onResizeTimeout() {
	          window.requestAnimationFrame(runCallbacks);
	        }, 500);
	      }
	      , addCallback = function addCallback(callback) {
	
	        if (callback) {
	
	          callbacks.push(callback);
	        }
	      };
	
	    return {
	      'add': function add(callback) {
	
	        if (!callbacks.length) {
	
	          window.addEventListener('resize', resize);
	        }
	        addCallback(callback);
	      },
	      'remove': function remove() {
	        if (!callbacks.length) {
	          window.clearTimeout(resizeTimeout);
	          window.removeEventListener('resize', resize);
	        }
	      }
	    };
	  }())
	  , getAttributesToAdd = function getAttributesToAdd(element) {
	    var attributesToAdd = {};
	
	    element.removeAttr(directiveName);
	    if (element.attr('tooltip-template') !== undefined) {
	
	      attributesToAdd['tooltip-template'] = element.attr('tooltip-template');
	      element.removeAttr('tooltip-template');
	    }
	
	    if (element.attr('tooltip-template-url') !== undefined) {
	
	      attributesToAdd['tooltip-template-url'] = element.attr('tooltip-template-url');
	      element.removeAttr('tooltip-template-url');
	    }
	
	    if (element.attr('tooltip-template-url-cache') !== undefined) {
	
	      attributesToAdd['tooltip-template-url-cache'] = element.attr('tooltip-template-url-cache');
	      element.removeAttr('tooltip-template-url-cache');
	    }
	
	    if (element.attr('tooltip-controller') !== undefined) {
	
	      attributesToAdd['tooltip-controller'] = element.attr('tooltip-controller');
	      element.removeAttr('tooltip-controller');
	    }
	
	    if (element.attr('tooltip-side') !== undefined) {
	
	      attributesToAdd['tooltip-side'] = element.attr('tooltip-side');
	      element.removeAttr('tooltip-side');
	    }
	
	    if (element.attr('tooltip-show-trigger') !== undefined) {
	
	      attributesToAdd['tooltip-show-trigger'] = element.attr('tooltip-show-trigger');
	      element.removeAttr('tooltip-show-trigger');
	    }
	
	    if (element.attr('tooltip-hide-trigger') !== undefined) {
	
	      attributesToAdd['tooltip-hide-trigger'] = element.attr('tooltip-hide-trigger');
	      element.removeAttr('tooltip-hide-trigger');
	    }
	
	    if (element.attr('tooltip-smart') !== undefined) {
	
	      attributesToAdd['tooltip-smart'] = element.attr('tooltip-smart');
	      element.removeAttr('tooltip-smart');
	    }
	
	    if (element.attr('tooltip-class') !== undefined) {
	
	      attributesToAdd['tooltip-class'] = element.attr('tooltip-class');
	      element.removeAttr('tooltip-class');
	    }
	
	    if (element.attr('tooltip-show') !== undefined) {
	
	      attributesToAdd['tooltip-show'] = element.attr('tooltip-show');
	      element.removeAttr('tooltip-show');
	    }
	
	    if (element.attr('tooltip-close-button') !== undefined) {
	
	      attributesToAdd['tooltip-close-button'] = element.attr('tooltip-close-button');
	      element.removeAttr('tooltip-close-button');
	    }
	
	    if (element.attr('tooltip-size') !== undefined) {
	
	      attributesToAdd['tooltip-size'] = element.attr('tooltip-size');
	      element.removeAttr('tooltip-size');
	    }
	
	    if (element.attr('tooltip-speed') !== undefined) {
	
	      attributesToAdd['tooltip-speed'] = element.attr('tooltip-speed');
	      element.removeAttr('tooltip-speed');
	    }
	
	    return attributesToAdd;
	  }
	  , getStyle = function getStyle(anElement) {
	
	    if (window.getComputedStyle) {
	
	      return window.getComputedStyle(anElement, '');
	    } else if (anElement.currentStyle) {
	
	      return anElement.currentStyle;
	    }
	  }
	  , getAppendedTip = function getAppendedTip(theTooltipElement) {
	    var tipsInBody = window.document.querySelectorAll('._exradicated-tooltip')
	      , aTipInBody
	      , tipsInBodyIndex = 0
	      , tipsInBodyLength = tipsInBody.length
	      , angularizedElement;
	
	    for (; tipsInBodyIndex < tipsInBodyLength; tipsInBodyIndex += 1) {
	
	      aTipInBody = tipsInBody.item(tipsInBodyIndex);
	      if (aTipInBody) {
	
	        angularizedElement = angular.element(aTipInBody);
	        if (angularizedElement.data('_tooltip-parent') &&
	          angularizedElement.data('_tooltip-parent') === theTooltipElement) {
	
	          return angularizedElement;
	        }
	      }
	    }
	  }
	  , removeAppendedTip = function removeAppendedTip(theTooltipElement) {
	    var tipElement = getAppendedTip(theTooltipElement);
	
	    if (tipElement) {
	
	      tipElement.remove();
	    }
	  }
	  , isOutOfPage = function isOutOfPage(theTipElement) {
	
	    if (theTipElement) {
	      var squarePosition = theTipElement[0].getBoundingClientRect();
	
	      if (squarePosition.top < 0 ||
	        squarePosition.top > window.document.body.offsetHeight ||
	        squarePosition.left < 0 ||
	        squarePosition.left > window.document.body.offsetWidth ||
	        squarePosition.bottom < 0 ||
	        squarePosition.bottom > window.document.body.offsetHeight ||
	        squarePosition.right < 0 ||
	        squarePosition.right > window.document.body.offsetWidth) {
	
	        theTipElement.css({
	          'top': '',
	          'left': '',
	          'bottom': '',
	          'right': ''
	        });
	        return true;
	      }
	
	      return false;
	    }
	
	    throw new Error('You must provide a position');
	  }
	  , getSideClasses = function getSideClasses(sides) {
	    
	    return sides.split(' ').map(function mapSideClasses(side) {
	      
	      return '_' + side;
	    }).join(' ');
	  }
	  , directions = ['_top', '_top _left', '_left', '_bottom _left', '_bottom', '_bottom _right', '_right', '_top _right']
	  , smartPosition = function smartPosition(tipElement, tooltipElement, startSide) {
	    
	    var directionsIndex = directions.indexOf(getSideClasses(startSide))
	      , directionsLength = directions.length
	      , directionsCount = 0;
	    
	    for (; directionsCount < directionsLength && isOutOfPage(tipElement); directionsCount += 1) {
	      
	      directionsIndex += 1;
	      if (directionsIndex >= directions.length) {
	        
	        directionsIndex = 0;
	      }
	      tooltipElement.removeClass('_top _left _bottom _right');
	      tooltipElement.addClass(directions[directionsIndex]);
	    }
	  }
	  , tooltipConfigurationProvider = function tooltipConfigurationProvider() {
	
	    var tooltipConfiguration = {
	      'side': 'top',
	      'showTrigger': 'mouseenter',
	      'hideTrigger': 'mouseleave',
	      'class': '',
	      'smart': false,
	      'closeButton': false,
	      'size': '',
	      'speed': 'steady',
	      'tooltipTemplateUrlCache': false,
	      'show': null
	    };
	
	    return {
	      'configure': function configure(configuration) {
	        var configurationKeys = Object.keys(tooltipConfiguration)
	          , configurationIndex = 0
	          , aConfigurationKey;
	
	        if (configuration) {
	
	          for (; configurationIndex < configurationKeys.length; configurationIndex += 1) {
	
	            aConfigurationKey = configurationKeys[configurationIndex];
	            if (aConfigurationKey &&
	              configuration[aConfigurationKey]) {
	
	              tooltipConfiguration[aConfigurationKey] = configuration[aConfigurationKey];
	            }
	          }
	        }
	      },
	      '$get': /*@ngInject*/ function instantiateProvider() {
	
	        return tooltipConfiguration;
	      }
	    };
	  }
	  , tooltipDirective = /*@ngInject*/ ['$log', '$http', '$compile', '$timeout', '$controller', '$injector', 'tooltipsConf', '$templateCache', '$q', function tooltipDirective($log, $http, $compile, $timeout, $controller, $injector, tooltipsConf, $templateCache, $q) {
	
	    var linkingFunction = function linkingFunction($scope, $element, $attrs, $controllerDirective, $transcludeFunc) {
	
	      if ($attrs.tooltipTemplate &&
	        $attrs.tooltipTemplateUrl) {
	
	        throw new Error('You can not define tooltip-template and tooltip-template-url together');
	      }
	
	      if (!($attrs.tooltipTemplateUrl || $attrs.tooltipTemplate) &&
	        $attrs.tooltipController) {
	
	        throw new Error('You can not have a controller without a template or templateUrl defined');
	      }
	
	      var oldTooltipSide = getSideClasses(tooltipsConf.side)
	        , oldTooltipShowTrigger = tooltipsConf.showTrigger
	        , oldTooltipHideTrigger = tooltipsConf.hideTrigger
	        , oldTooltipClass
	        , oldSize = tooltipsConf.size
	        , oldSpeed = '_' + tooltipsConf.speed;
	
	      $attrs.tooltipSide = $attrs.tooltipSide || tooltipsConf.side;
	      $attrs.tooltipShowTrigger = $attrs.tooltipShowTrigger || tooltipsConf.showTrigger;
	      $attrs.tooltipHideTrigger = $attrs.tooltipHideTrigger || tooltipsConf.hideTrigger;
	      $attrs.tooltipShow = $attrs.tooltipShow || tooltipsConf.show;
	      $attrs.tooltipClass = $attrs.tooltipClass || tooltipsConf.class;
	      $attrs.tooltipSmart = $attrs.tooltipSmart === 'true' || tooltipsConf.smart;
	      $attrs.tooltipCloseButton = $attrs.tooltipCloseButton || tooltipsConf.closeButton.toString();
	      $attrs.tooltipSize = $attrs.tooltipSize || tooltipsConf.size;
	      $attrs.tooltipSpeed = $attrs.tooltipSpeed || tooltipsConf.speed;
	      $attrs.tooltipAppendToBody = $attrs.tooltipAppendToBody === 'true';
	
	      $transcludeFunc($scope, function onTransclusionDone(element, scope) {
	        var attributes = getAttributesToAdd(element)
	          , tooltipElement = angular.element(window.document.createElement('tooltip'))
	          , tipContElement = angular.element(window.document.createElement('tip-cont'))
	          , tipElement = angular.element(window.document.createElement('tip'))
	          , tipTipElement = angular.element(window.document.createElement('tip-tip'))
	          , closeButtonElement = angular.element(window.document.createElement('span'))
	          , tipArrowElement = angular.element(window.document.createElement('tip-arrow'))
	          , whenActivateMultilineCalculation = function whenActivateMultilineCalculation() {
	
	            return tipContElement.html();
	          }
	          , calculateIfMultiLine = function calculateIfMultiLine(newValue) {
	
	            if (newValue !== undefined &&
	              tipContElement[0].getClientRects().length > 1) {
	
	              tooltipElement.addClass('_multiline');
	            } else {
	
	              tooltipElement.removeClass('_multiline');
	            }
	          }
	          , onTooltipShow = function onTooltipShow(event) {
	
	            if (event && !tooltipElement.hasClass('active')) {
	              
	              event.stopImmediatePropagation();
	            }
	
	            tipElement.addClass('_hidden');
	            if ($attrs.tooltipSmart) {
	
	              switch ($attrs.tooltipSide) {
	                case 'top':
	                case 'left':
	                case 'bottom':
	                case 'right':
	                case 'top left':
	                case 'top right':
	                case 'bottom left':
	                case 'bottom right': {
	
	                  smartPosition(tipElement, tooltipElement, $attrs.tooltipSide);
	                  break;
	                }
	                
	                default: {
	
	                  throw new Error('Position not supported');
	                }
	              }
	            }
	
	            if ($attrs.tooltipAppendToBody) {
	
	              var tipTipElementStyle = getStyle(tipTipElement[0])
	                , tipArrowElementStyle = getStyle(tipArrowElement[0])
	                , tipElementStyle = getStyle(tipElement[0])
	                , tipElementBoundingClientRect = tipElement[0].getBoundingClientRect()
	                , exradicatedTipElement = angular.copy(tipElement)
	                , tipTipStyleIndex = 0
	                , tipTipStyleLength = tipTipElementStyle.length
	                , tipArrowStyleIndex = 0
	                , tipArrowStyleLength = tipArrowElementStyle.length
	                , tipStyleIndex = 0
	                , tipStyleLength = tipElementStyle.length
	                , aStyleKey
	                , tipTipCssToSet = {}
	                , tipCssToSet = {}
	                , tipArrowCssToSet = {}
	                , paddingTopValue
	                , paddingBottomValue
	                , paddingLeftValue
	                , paddingRightValue;
	
	              tipElement.removeClass('_hidden');
	              exradicatedTipElement.removeClass('_hidden');
	              exradicatedTipElement.data('_tooltip-parent', tooltipElement);
	              removeAppendedTip(tooltipElement);
	
	              for (; tipTipStyleIndex < tipTipStyleLength; tipTipStyleIndex += 1) {
	
	                aStyleKey = tipTipElementStyle[tipTipStyleIndex];
	                if (aStyleKey &&
	                  tipTipElementStyle.getPropertyValue(aStyleKey)) {
	
	                  tipTipCssToSet[aStyleKey] = tipTipElementStyle.getPropertyValue(aStyleKey);
	                }
	              }
	
	              for (; tipArrowStyleIndex < tipArrowStyleLength; tipArrowStyleIndex += 1) {
	
	                aStyleKey = tipArrowElementStyle[tipArrowStyleIndex];
	                if (aStyleKey &&
	                  tipArrowElementStyle.getPropertyValue(aStyleKey)) {
	
	                  tipArrowCssToSet[aStyleKey] = tipArrowElementStyle.getPropertyValue(aStyleKey);
	                }
	              }
	
	              for (; tipStyleIndex < tipStyleLength; tipStyleIndex += 1) {
	
	                aStyleKey = tipElementStyle[tipStyleIndex];
	                if (aStyleKey &&
	                    aStyleKey !== 'position' &&
	                    aStyleKey !== 'display' &&
	                    aStyleKey !== 'opacity' &&
	                    aStyleKey !== 'z-index' &&
	                    aStyleKey !== 'bottom' &&
	                    aStyleKey !== 'height' &&
	                    aStyleKey !== 'left' &&
	                    aStyleKey !== 'right' &&
	                    aStyleKey !== 'top' &&
	                    aStyleKey !== 'width' &&
	                  tipElementStyle.getPropertyValue(aStyleKey)) {
	
	                  tipCssToSet[aStyleKey] = tipElementStyle.getPropertyValue(aStyleKey);
	                }
	              }
	              paddingTopValue = window.parseInt(tipElementStyle.getPropertyValue('padding-top'), 10);
	              paddingBottomValue = window.parseInt(tipElementStyle.getPropertyValue('padding-bottom'), 10);
	              paddingLeftValue = window.parseInt(tipElementStyle.getPropertyValue('padding-left'), 10);
	              paddingRightValue = window.parseInt(tipElementStyle.getPropertyValue('padding-right'), 10);
	
	              tipCssToSet.top = tipElementBoundingClientRect.top + window.pageYOffset + 'px';
	              tipCssToSet.left = tipElementBoundingClientRect.left + window.pageXOffset + 'px';
	              tipCssToSet.height = tipElementBoundingClientRect.height - (paddingTopValue + paddingBottomValue) + 'px';
	              tipCssToSet.width = tipElementBoundingClientRect.width - (paddingLeftValue + paddingRightValue) + 'px';
	
	              exradicatedTipElement.css(tipCssToSet);
	
	              exradicatedTipElement.children().css(tipTipCssToSet);
	              exradicatedTipElement.children().next().css(tipArrowCssToSet);
	              if (event &&
	                $attrs.tooltipHidden !== 'true') {
	
	                exradicatedTipElement.addClass('_exradicated-tooltip');
	                angular.element(window.document.body).append(exradicatedTipElement);
	              }
	            } else {
	
	              tipElement.removeClass('_hidden');
	              if (event &&
	                $attrs.tooltipHidden !== 'true') {
	
	                tooltipElement.addClass('active');
	              }
	            }
	          }
	          , onTooltipHide = function onTooltipHide(event) {
	
	            if (event && tooltipElement.hasClass('active')) {
	  
	              event.stopImmediatePropagation();
	            }
	
	            if ($attrs.tooltipAppendToBody) {
	
	              removeAppendedTip(tooltipElement);
	            } else {
	
	              tooltipElement.removeClass('active');
	            }
	          }
	          , registerOnScrollFrom = function registerOnScrollFrom(theElement) {
	            var parentElement = theElement.parent()
	              , timer;
	
	            if (theElement[0] &&
	              (theElement[0].scrollHeight > theElement[0].clientHeight ||
	              theElement[0].scrollWidth > theElement[0].clientWidth)) {
	
	              theElement.on('scroll', function onScroll() {
	                var that = this;
	
	                if (timer) {
	
	                  $timeout.cancel(timer);
	                }
	
	                timer = $timeout(function doLater() {
	
	                  var theTipElement = getAppendedTip(tooltipElement)
	                    , tooltipBoundingRect = tooltipElement[0].getBoundingClientRect()
	                    , thatBoundingRect = that.getBoundingClientRect();
	
	                  if (tooltipBoundingRect.top < thatBoundingRect.top ||
	                    tooltipBoundingRect.bottom > thatBoundingRect.bottom ||
	                    tooltipBoundingRect.left < thatBoundingRect.left ||
	                    tooltipBoundingRect.right > thatBoundingRect.right) {
	
	                    removeAppendedTip(tooltipElement);
	                  } else if (theTipElement) {
	
	                    onTooltipShow(true);
	                  }
	                });
	              });
	            }
	
	            if (parentElement &&
	              parentElement.length) {
	
	              registerOnScrollFrom(parentElement);
	            }
	          }
	          , showTemplate = function showTemplate(template) {
	          
	            tooltipElement.removeClass('_force-hidden'); //see lines below, this forces to hide tooltip when is empty
	            tipTipElement.empty();
	            tipTipElement.append(closeButtonElement);
	            tipTipElement.append(template);
	            $timeout(function doLater() {
	              
	              onTooltipShow();
	            });
	          }
	          , hideTemplate = function hideTemplate() {
	          
	            //hide tooltip because is empty
	            tipTipElement.empty();
	            tooltipElement.addClass('_force-hidden'); //force to be hidden if empty
	          }
	          , getTemplate = function getTemplate(tooltipTemplateUrl) {
	          
	            var template = $templateCache.get(tooltipTemplateUrl);
	
	            if (typeof template !== 'undefined') {
	              // Wrap template in a Promise so that getTemplate always returns a Promise
	              return $q.resolve(template);
	            }
	
	            // How should failing to load the template be handled?
	            return $http.get(tooltipTemplateUrl).then(function onGetTemplateSuccess(response) {
	              $templateCache.put(tooltipTemplateUrl, response.data);
	
	              return response.data;
	            });
	          }
	          , onTooltipTemplateChange = function onTooltipTemplateChange(newValue) {
	          
	            if (newValue) {
	              
	              showTemplate(newValue);
	            } else {
	              
	              hideTemplate();
	            }
	          }
	          , onTooltipTemplateUrlChange = function onTooltipTemplateUrlChange(newValue) {
	          
	            if (newValue && !$attrs.tooltipTemplateUrlCache) {
	              
	              getTemplate(newValue).then(function onGetTemplateSuccess(template) {
	                
	                showTemplate($compile(template)(scope));
	              }).catch(function onGetTemplateFailure(reason) {
	                
	                $log.error(reason);
	              });
	            } else {
	              
	              hideTemplate();
	            }
	          }
	          , onTooltipTemplateUrlCacheChange = function onTooltipTemplateUrlCacheChange(newValue) {
	          
	            if (newValue && $attrs.tooltipTemplateUrl) {
	              
	              getTemplate($attrs.tooltipTemplateUrl).then(function onGetTemplateSuccess(template) {
	                
	                showTemplate($compile(template)(scope));
	              }).catch(function onGetTemplateFailure(reason) {
	
	                $log.error(reason);
	              });
	            } else {
	              
	              hideTemplate();
	            }
	          }
	          , onTooltipSideChange = function onTooltipSideChange(newValue) {
	
	            if (newValue) {
	
	              if (oldTooltipSide) {
	
	                tooltipElement.removeClass(oldTooltipSide);
	              }
	              tooltipElement.addClass(getSideClasses(newValue));
	              oldTooltipSide = newValue;
	            }
	          }
	          , onTooltipShowTrigger = function onTooltipShowTrigger(newValue) {
	
	            if (newValue) {
	
	              if (oldTooltipShowTrigger) {
	
	                tooltipElement.off(oldTooltipShowTrigger);
	              }
	              tooltipElement.on(newValue, onTooltipShow);
	              oldTooltipShowTrigger = newValue;
	            }
	          }
	          , onTooltipHideTrigger = function onTooltipHideTrigger(newValue) {
	
	            if (newValue) {
	
	              if (oldTooltipHideTrigger) {
	
	                tooltipElement.off(oldTooltipHideTrigger);
	              }
	              tooltipElement.on(newValue, onTooltipHide);
	              oldTooltipHideTrigger = newValue;
	            }
	          }
	          , onTooltipShowTooltip = function onTooltipShowTooltip(newValue) {
	
	            if (newValue === 'true') {
	
	              tooltipElement.addClass('active');
	            } else {
	              tooltipElement.removeClass('active');
	            }
	          }
	          , onTooltipClassChange = function onTooltipClassChange(newValue) {
	
	            if (newValue) {
	
	              if (oldTooltipClass) {
	
	                tipElement.removeClass(oldTooltipClass);
	              }
	              tipElement.addClass(newValue);
	              oldTooltipClass = newValue;
	            }
	          }
	          , onTooltipSmartChange = function onTooltipSmartChange() {
	
	            if (typeof $attrs.tooltipSmart !== 'boolean') {
	
	              $attrs.tooltipSmart = $attrs.tooltipSmart === 'true';
	            }
	          }
	          , onTooltipCloseButtonChange = function onTooltipCloseButtonChange(newValue) {
	            var enableButton = newValue === 'true';
	
	            if (enableButton) {
	
	              closeButtonElement.on('click', onTooltipHide);
	              closeButtonElement.css('display', 'block');
	            } else {
	
	              closeButtonElement.off('click');
	              closeButtonElement.css('display', 'none');
	            }
	          }
	          , onTooltipTemplateControllerChange = function onTooltipTemplateControllerChange(newValue) {
	
	            if (newValue) {
	
	              var tipController = $controller(newValue, {
	                  '$scope': scope
	                })
	                , newScope = scope.$new(false, scope)
	                , indexOfAs = newValue.indexOf('as')
	                , controllerName;
	
	              if (indexOfAs >= 0) {
	
	                controllerName = newValue.substr(indexOfAs + 3);
	                newScope[controllerName] = tipController;
	              } else {
	
	                angular.extend(newScope, tipController);
	              }
	
	              tipTipElement.replaceWith($compile(tipTipElement)(newScope));
	              /*eslint-disable no-use-before-define*/
	              unregisterOnTooltipControllerChange();
	              /*eslint-enable no-use-before-define*/
	            }
	          }
	          , onTooltipSizeChange = function onTooltipSizeChange(newValue) {
	
	            if (newValue) {
	
	              if (oldSize) {
	
	                tipTipElement.removeClass('_' + oldSize);
	              }
	              tipTipElement.addClass('_' + newValue);
	              oldSize = newValue;
	            }
	          }
	          , onTooltipSpeedChange = function onTooltipSpeedChange(newValue) {
	
	            if (newValue) {
	
	              if (oldSpeed) {
	
	                tooltipElement.removeClass('_' + oldSpeed);
	              }
	              tooltipElement.addClass('_' + newValue);
	              oldSpeed = newValue;
	            }
	          }
	          , unregisterOnTooltipTemplateChange = $attrs.$observe('tooltipTemplate', onTooltipTemplateChange)
	          , unregisterOnTooltipTemplateUrlChange = $attrs.$observe('tooltipTemplateUrl', onTooltipTemplateUrlChange)
	          , unregisterOnTooltipTemplateUrlCacheChange = $attrs.$observe('tooltipTemplateUrlCache', onTooltipTemplateUrlCacheChange)
	          , unregisterOnTooltipSideChangeObserver = $attrs.$observe('tooltipSide', onTooltipSideChange)
	          , unregisterOnTooltipShowTrigger = $attrs.$observe('tooltipShowTrigger', onTooltipShowTrigger)
	          , unregisterOnTooltipHideTrigger = $attrs.$observe('tooltipHideTrigger', onTooltipHideTrigger)
	          , unregisterOnTooltipShowTooltip = $attrs.$observe('tooltipShow', onTooltipShowTooltip)
	          , unregisterOnTooltipClassChange = $attrs.$observe('tooltipClass', onTooltipClassChange)
	          , unregisterOnTooltipSmartChange = $attrs.$observe('tooltipSmart', onTooltipSmartChange)
	          , unregisterOnTooltipCloseButtonChange = $attrs.$observe('tooltipCloseButton', onTooltipCloseButtonChange)
	          , unregisterOnTooltipControllerChange = $attrs.$observe('tooltipController', onTooltipTemplateControllerChange)
	          , unregisterOnTooltipSizeChange = $attrs.$observe('tooltipSize', onTooltipSizeChange)
	          , unregisterOnTooltipSpeedChange = $attrs.$observe('tooltipSpeed', onTooltipSpeedChange)
	          , unregisterTipContentChangeWatcher = scope.$watch(whenActivateMultilineCalculation, calculateIfMultiLine);
	
	        closeButtonElement.addClass('close-button');
	        closeButtonElement.html('&times;');
	
	        tipElement.addClass('_hidden');
	
	        tipTipElement.append(closeButtonElement);
	        tipTipElement.append($attrs.tooltipTemplate);
	
	        tipElement.append(tipTipElement);
	        tipElement.append(tipArrowElement);
	
	        tipContElement.append(element);
	
	        tooltipElement.attr(attributes);
	        tooltipElement.addClass('tooltips');
	
	        tooltipElement.append(tipContElement);
	        tooltipElement.append(tipElement);
	        $element.after(tooltipElement);
	
	        if ($attrs.tooltipAppendToBody) {
	
	          resizeObserver.add(function onResize() {
	
	            registerOnScrollFrom(tooltipElement);
	          });
	          registerOnScrollFrom(tooltipElement);
	        }
	
	        resizeObserver.add(function registerResize() {
	
	          calculateIfMultiLine();
	          onTooltipShow();
	        });
	
	        $timeout(function doLater() {
	
	          onTooltipShow();
	          tipElement.removeClass('_hidden');
	          tooltipElement.addClass('_ready');
	        });
	
	        scope.$on('$destroy', function unregisterListeners() {
	
	          unregisterOnTooltipTemplateChange();
	          unregisterOnTooltipTemplateUrlChange();
	          unregisterOnTooltipTemplateUrlCacheChange();
	          unregisterOnTooltipSideChangeObserver();
	          unregisterOnTooltipShowTrigger();
	          unregisterOnTooltipHideTrigger();
	          unregisterOnTooltipShowTooltip();
	          unregisterOnTooltipClassChange();
	          unregisterOnTooltipSmartChange();
	          unregisterOnTooltipCloseButtonChange();
	          unregisterOnTooltipSizeChange();
	          unregisterOnTooltipSpeedChange();
	          unregisterTipContentChangeWatcher();
	          resizeObserver.remove();
	          element.off($attrs.tooltipShowTrigger + ' ' + $attrs.tooltipHideTrigger);
	        });
	      });
	    };
	
	    return {
	      'restrict': 'A',
	      'transclude': 'element',
	      'priority': 1,
	      'terminal': true,
	      'link': linkingFunction
	    };
	  }];
	
	  angular.module('720kb.tooltips', [])
	  .provider(directiveName + 'Conf', tooltipConfigurationProvider)
	  .directive(directiveName, tooltipDirective);
	}(angular, window));


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(63)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require('angular'));
	  } else {
	    // Browser globals (root is window)
	    root.returnExports = factory(root.angular);
	  }
	}(this, function(angular) {
	  /**
	   * @ngdoc service
	   * @name ngMeta.ngMeta
	   * @description
	   * # A metatags service for single-page applications
	   * that supports setting arbitrary meta tags
	   */
	  return angular.module('ngMeta', [])
	    .provider('ngMeta', function() {
	
	      'use strict';
	
	      //Object for storing default tag/values
	      var defaults = {};
	
	      //One-time configuration
	      var config = {
	        useTitleSuffix: false
	      };
	
	      function Meta($rootScope, $injector) {
	
	        /**
	         * @ngdoc method
	         * @name ngMeta#setTitle
	         * @description
	         * Sets the title of the page, optionally
	         * appending a title suffix.
	         *
	         * If suffix usage is enabled and the title suffix
	         * parameter is missing, the default title suffix
	         * (if available) is used as a fallback.
	         *
	         * @example
	         * //title and titleSuffix
	         * ngMeta.setTitle('Page name', ' - Site name | Tagline of the site');
	         *
	         * //title only (default titleSuffix may be suffixed,
	         * //depending on useTitleSuffix configuration)
	         * ngMeta.setTitle('Page name');
	         *
	         * @returns {Object} self
	         */
	        var setTitle = function(title, titleSuffix) {
	          if (!$rootScope.ngMeta) {
	            throw new Error('Cannot call setTitle when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	          }
	
	          $rootScope.ngMeta.title = angular.isDefined(title) ? title : (defaults.title || '');
	          if (config.useTitleSuffix) {
	            $rootScope.ngMeta.title += angular.isDefined(titleSuffix) ? titleSuffix : (defaults.titleSuffix || '');
	          }
	          return this;
	        };
	
	        /**
	         * @ngdoc method
	         * @name ngMeta#setTag
	         * @description
	         * Sets the value of a meta tag, using
	         * the default value (if available) as
	         * a fallback.
	         *
	         * @example
	         * ngMeta.setTag('og:image', 'http://example.com/a.png');
	         *
	         * @returns {Object} self
	         */
	        var setTag = function(tag, value) {
	          if (!$rootScope.ngMeta) {
	            throw new Error('Cannot call setTag when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	          }
	          if (tag === 'title' || tag === 'titleSuffix') {
	            throw new Error('Attempt to set \'' + tag + '\' through \'setTag\': \'title\' and \'titleSuffix\' are reserved tag names. Please use \'ngMeta.setTitle\' instead');
	          }
	
	          $rootScope.ngMeta[tag] = angular.isDefined(value) ? value : defaults[tag];
	          return this;
	        };
	
	        /**
	         * @ngdoc method
	         * @name ngMeta#setDefaultTag
	         * @description
	         * Sets the default tag for all routes that are missing a custom
	         * `tag` property in their meta objects.
	         *
	         * @example
	         * ngMeta.setDefaultTag('titleSuffix', ' | Tagline of the site');
	         *
	         * @returns {Object} self
	         */
	        var setDefaultTag = function(tag, value) {
	          if (!$rootScope.ngMeta) {
	            throw new Error('Cannot call setDefaultTag when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
	          }
	
	          defaults[tag] = value;
	
	          if (tag === 'title' || tag === 'titleSuffix') {
	            this.setTitle($rootScope.ngMeta.title, $rootScope.ngMeta.titleSuffix);
	          } else {
	            this.setTag(tag, $rootScope.ngMeta[tag]);
	          }
	
	          return this;
	        };
	
	        /**
	         * @ngdoc method
	         * @name readRouteMeta
	         * @description
	         * Helper function to process meta tags on route/state
	         * change.
	         *
	         * It:
	         * 1. Sets the title (with titleSuffix, as appropriate)
	         * 2. Iterates through all the state/route tags (other than title)
	         *    and sets their values
	         * 3. Iterates through all default tags and sets the ones
	         *    that were not utilized while setting the state/route tags.
	         *
	         * @returns void
	         */
	        var readRouteMeta = function(meta) {
	          meta = meta || {};
	
	          if (meta.disableUpdate) {
	            return false;
	          }
	
	          setTitle(meta.title, meta.titleSuffix);
	
	          var def = angular.copy(defaults);
	
	          delete meta.title;
	          delete meta.titleSuffix;
	          delete def.title;
	          delete def.titleSuffix;
	
	          var metaKeys = Object.keys(meta);
	          for (var i = 0; i < metaKeys.length; i++) {
	            if (def.hasOwnProperty(metaKeys[i])) {
	              delete def[metaKeys[i]];
	            }
	            setTag(metaKeys[i], meta[metaKeys[i]]);
	          }
	
	          var defaultKeys = Object.keys(def);
	          for (var j = 0; j < defaultKeys.length; j++) {
	            setTag(defaultKeys[j], def[defaultKeys[j]]);
	          }
	        };
	
	        var update = function(event, current) {
	          readRouteMeta(angular.copy(current.meta || (current.data && current.data.meta)));
	        };
	
	        /**
	         * @ngdoc method
	         * @name resetMeta
	         * @description
	         * Helper function to reset ngMeta data and apply defaults. Useful when setting up ngmeta data in a
	         * UI-router resolve function.
	         *
	         * @returns {Object} self
	         */
	        var resetMeta = function() {
	          readRouteMeta();
	
	          return this;
	        };
	
	        /**
	         * @ngdoc method
	         * @name ngMeta#init
	         * @description
	         * Initializes the ngMeta object and sets up
	         * listeners for route/state change broadcasts
	         *
	         * @example
	         * angular.module('yourApp', ['ngRoute', 'ngMeta'])
	         * .config(function($routeProvider, ngMetaProvider) {
	         *   ....
	         * })
	         * .run(function(ngMeta) {
	         *   ngMeta.init();
	         * });
	         */
	        var init = function() {
	          $rootScope.ngMeta = {};
	          $rootScope.$on('$routeChangeSuccess', update);
	          $rootScope.$on('$stateChangeSuccess', update);
	          if ($injector.has('$transitions')) {
	            var $transitions = $injector.get('$transitions');
	            $transitions.onSuccess({}, function(transition) {
	              update(null, transition.$to());
	            });
	          }
	        };
	
	        return {
	          'init': init,
	          'setTitle': setTitle,
	          'setTag': setTag,
	          'setDefaultTag': setDefaultTag,
	          'resetMeta' : resetMeta
	        };
	      }
	
	      /* Set defaults */
	
	      /**
	       * @ngdoc method
	       * @name ngMetaProvider#setDefaultTitle
	       * @param {string} titleStr The default title of the page. If a
	       * route/state does not define a `title` param in its meta object, this
	       * value is used instead.
	       *
	       * @description
	       * Sets the default title for all routes that are missing a custom `title`
	       * property in their meta objects.
	       *
	       * @returns {Object} self
	       */
	      this.setDefaultTitle = function(titleStr) {
	        defaults.title = titleStr;
	        return this;
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngMetaProvider#setDefaultTitleSuffix
	       * @param {string} titleSuffix The default title suffix of the page. If a
	       * route/state does not define a `titleSuffix` param in its meta object,
	       * this value is used instead.
	       *
	       * @description
	       * Sets the default title suffix for all routes that are missing a custom
	       * `titleSuffix` property in their meta objects.
	       *
	       * @returns {Object} self
	       */
	      this.setDefaultTitleSuffix = function(titleSuffix) {
	        defaults.titleSuffix = titleSuffix;
	        return this;
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngMetaProvider#setDefaultTag
	       * @param {string} tag The default tag name. The default tag can be
	       * overridden by defining a custom property of the same name in the meta
	       * object of any route.
	       *
	       * @param {string} value The value of the tag.
	       *
	       * @description
	       * Sets the default tag for all routes that are missing a custom
	       * `tag` property in their meta objects.
	       *
	       * @returns {Object} self
	       */
	      this.setDefaultTag = function(tag, value) {
	        defaults[tag] = value;
	        return this;
	      };
	
	      /* One-time config */
	
	      /**
	       * @ngdoc method
	       * @name ngMetaProvider#useTitleSuffix
	       * @param {boolean} bool A boolean indicating the use of title suffix.
	       * Defaults to false.
	       *
	       * @description
	       * Toggles the use of the title suffix throughout the site.
	       *
	       * @returns {Object} self
	       */
	      this.useTitleSuffix = function(bool) {
	        config.useTitleSuffix = !!bool;
	        return this;
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngMetaProvider#mergeNestedStateData
	       * @param {string} mergeNestedStateData [Optional] method to deep merge
	       * meta data for nested views.
	       *
	       * @description
	       * Helper function to Extend $stateProvider.decorator('state') to merge nested
	       * view meta data if using ui-router.
	       *
	       * @returns {Object} data
	       */
	      this.mergeNestedStateData = function(state, parentDecoratorFn) {
	      // original data
	        var originalData = parentDecoratorFn(state) || {};
	
	        // create new merged meta
	        var parentMetaData = state.parent && state.parent.data && state.parent.data.meta;
	
	        //Assign the merged meta if necessary to current state and return
	        if (originalData.meta || parentMetaData) {
	          var mergedMeta = angular.merge({}, parentMetaData, originalData.meta);
	          originalData.meta = mergedMeta;
	        }
	        state.self.data = originalData;
	        return originalData;
	      };
	
	
	      this.$get = ["$rootScope", "$injector", function($rootScope, $injector) {
	        return new Meta($rootScope, $injector);
	      }];
	    });
	}));


/***/ },
/* 63 */
[631, 64],
/* 64 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.9/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest
	* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.9',
	  major: 1,
	  minor: 6,
	  dot: 9,
	  codeName: 'fiery-basilisk'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.9' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` (*DEPRECATED*)
	 *
	 * `replace` will be removed in next major release - i.e. v2.0).
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
	   * current strictComponentBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
	   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
	   * on the component's HTML tag.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestAborted;
	      xhr.ontimeout = requestTimeout;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        markQExceptionHandled(intervals[promise.$$intervalId].promise);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (parsedExpression.oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      return unwatch;
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      if (fn.inputs) {
	        fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // potentially non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  markQStateExceptionHandled(q.$$state);
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * `$watchGroup` is more performant than watching each expression individually, and should be
	       * used when the listener does not need to know which expression has changed.
	       * If the listener needs to know which expression has changed,
	       * {@link ng.$rootScope.Scope#$watch $watch()} or
	       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`.
	       *
	       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
	       *    expression, and not the difference of the values between each call of the listener.
	       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
	       *    which expression has changed / remained stable:
	       *
	       *    ```js
	       *
	       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
	       *      console.log(newValues, oldValues);
	       *    });
	       *
	       *    // newValues, oldValues initially
	       *    // [undefined, undefined], [undefined, undefined]
	       *
	       *    $scope.v1 = 'a';
	       *    $scope.v2 = 'a';
	       *
	       *    // ['a', 'a'], [undefined, undefined]
	       *
	       *    $scope.v2 = 'b'
	       *
	       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
	       *    // ['a', 'b'], [undefined, 'a']
	       *
	       *    ```
	       *
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes AngularJS accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var expression = attr[name].trim();
	        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');
	
	        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
	        var watchExpression = $parse(expression, watchInterceptor);
	        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;
	
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch(watchExpression, watchAction, isOneTime);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClass[OneTime]WatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassOneTimeWatchAction(newClassValue) {
	          var newClassString = toClassString(newClassValue);
	
	          if (newClassString !== oldClassString) {
	            ngClassWatchAction(newClassString);
	          }
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	
	  function toFlatValue(classValue) {
	    var flatValue = classValue;
	
	    if (isArray(classValue)) {
	      flatValue = classValue.map(toFlatValue);
	    } else if (isObject(classValue)) {
	      var hasUndefined = false;
	
	      flatValue = Object.keys(classValue).filter(function(key) {
	        var value = classValue[key];
	
	        if (!hasUndefined && isUndefined(value)) {
	          hasUndefined = true;
	        }
	
	        return value;
	      });
	
	      if (hasUndefined) {
	        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
	        // the watcher, by including at least one `undefined` value.
	        flatValue.push(undefined);
	      }
	    }
	
	    return flatValue;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 *
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur click',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *
	 *     "default" also applies to all events that are listed in `updateOn` but are not
	 *     listed in `debounce`, i.e. "click" would also be debounced by 500 milliseconds.
	 *
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @knownIssue
	 *
	 * In Firefox, the select model is only updated when the select element is blurred. For example,
	 * when switching between options with the keyboard, the select model is only set to the
	 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
	 * outside the select.
	 *
	 * This is due to an ambiguity in the select element specification. See the
	 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
	 * for more information, and this
	 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(66);
	module.exports = 'ngSanitize';


/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.7
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      angular.extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (angular.isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = toMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = toMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, toMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	// Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	// They can potentially allow for arbitrary javascript to be executed. See #11290
	var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	        "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	        "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	// Blocked Elements (will be stripped)
	var blockedElements = toMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	    'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	    'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	    'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	    'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	    'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	    'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	    'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	    'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	    'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	    'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	    'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	    'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	    'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function toMap(str, lowercaseKeys) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	  }
	  return obj;
	}
	
	var inertBodyElement;
	(function(window) {
	  var doc;
	  if (window.document && window.document.implementation) {
	    doc = window.document.implementation.createHTMLDocument("inert");
	  } else {
	    throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	  }
	  var docElement = doc.documentElement || doc.getDocumentElement();
	  var bodyElements = docElement.getElementsByTagName('body');
	
	  // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	  if (bodyElements.length === 1) {
	    inertBodyElement = bodyElements[0];
	  } else {
	    var html = doc.createElement('html');
	    inertBodyElement = doc.createElement('body');
	    html.appendChild(inertBodyElement);
	    doc.appendChild(html);
	  }
	})(window);
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (html === null || html === undefined) {
	    html = '';
	  } else if (typeof html !== 'string') {
	    html = '' + html;
	  }
	  inertBodyElement.innerHTML = html;
	
	  //mXSS protection
	  var mXSSAttempts = 5;
	  do {
	    if (mXSSAttempts === 0) {
	      throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	    }
	    mXSSAttempts--;
	
	    // strip custom-namespaced attributes on IE<=11
	    if (window.document.documentMode) {
	      stripCustomNsAttrs(inertBodyElement);
	    }
	    html = inertBodyElement.innerHTML; //trigger mXSS
	    inertBodyElement.innerHTML = html;
	  } while (html !== inertBodyElement.innerHTML);
	
	  var node = inertBodyElement.firstChild;
	  while (node) {
	    switch (node.nodeType) {
	      case 1: // ELEMENT_NODE
	        handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	        break;
	      case 3: // TEXT NODE
	        handler.chars(node.textContent);
	        break;
	    }
	
	    var nextNode;
	    if (!(nextNode = node.firstChild)) {
	      if (node.nodeType == 1) {
	        handler.end(node.nodeName.toLowerCase());
	      }
	      nextNode = node.nextSibling;
	      if (!nextNode) {
	        while (nextNode == null) {
	          node = node.parentNode;
	          if (node === inertBodyElement) break;
	          nextNode = node.nextSibling;
	          if (node.nodeType == 1) {
	            handler.end(node.nodeName.toLowerCase());
	          }
	        }
	      }
	    }
	    node = nextNode;
	  }
	
	  while (node = inertBodyElement.firstChild) {
	    inertBodyElement.removeChild(node);
	  }
	}
	
	function attrToMap(attrs) {
	  var map = {};
	  for (var i = 0, ii = attrs.length; i < ii; i++) {
	    var attr = attrs[i];
	    map[attr.name] = attr.value;
	  }
	  return map;
	}
	
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.join('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignoreCurrentElement = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && blockedElements[tag]) {
	        ignoreCurrentElement = tag;
	      }
	      if (!ignoreCurrentElement && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out('>');
	      }
	    },
	    end: function(tag) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	        out('</');
	        out(tag);
	        out('>');
	      }
	      if (tag == ignoreCurrentElement) {
	        ignoreCurrentElement = false;
	      }
	    },
	    chars: function(chars) {
	      if (!ignoreCurrentElement) {
	        out(encodeEntities(chars));
	      }
	    }
	  };
	}
	
	
	/**
	 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	 * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	 * to allow any of these custom attributes. This method strips them all.
	 *
	 * @param node Root element to process
	 */
	function stripCustomNsAttrs(node) {
	  if (node.nodeType === window.Node.ELEMENT_NODE) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var attrNode = attrs[i];
	      var attrName = attrNode.name.toLowerCase();
	      if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	        node.removeAttributeNode(attrNode);
	        i--;
	        l--;
	      }
	    }
	  }
	
	  var nextNode = node.firstChild;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	
	  nextNode = node.nextSibling;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	}
	
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      angular.isFunction(attributes) ? attributes :
	      angular.isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (angular.isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 67 */
/***/ function(module, exports) {

	/******/!function(e){function t(l){if(n[l])return n[l].exports;var o=n[l]={exports:{},id:l,loaded:!1};return e[l].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}// webpackBootstrap
	/******/
	var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function l(e){return e&&e.__esModule?e:{"default":e}}var o=n(1),s=l(o);angular.module("angularjs-dropdown-multiselect",[]).directive("dmDropdownStaticInclude",["$compile",function(e){"ngInject";return function(t,n,l){var o=l.dmDropdownStaticInclude,s=n.html(o).contents();e(s)(t)}}]).directive("ngDropdownMultiselect",s["default"])},function(e,t,n){"use strict";function l(e){return e&&e.__esModule?e:{"default":e}}function o(){return{restrict:"AE",scope:{selectedModel:"=",options:"=",extraSettings:"=",events:"=",searchFilter:"=?",translationTexts:"=",disabled:"="},transclude:{toggleDropdown:"?toggleDropdown"},controller:i["default"],templateUrl:"app/component/angularjs-dropdown-multiselect.html"}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=o;var s=n(2),i=l(s)},function(e,t){"use strict";function n(e,t){var n=!1;return e.some(function(e){return e===t?(n=!0,!0):!1}),n}function l(e,t,n){var l=-1;return e.some(function(e,o){return e[n]===t[n]?(l=o,!0):!1}),l}function o(e,t,o,s){"ngInject";function i(){setTimeout(function(){var e=angular.element(t)[0].querySelector(".option");angular.isDefined(e)&&null!=e&&e.focus()},0)}function r(){e.open?e.close():e.open=!0,e.settings.keyboardControls&&e.open&&(1===e.settings.selectionLimit&&e.settings.enableSearch?setTimeout(function(){angular.element(t)[0].querySelector(".searchField").focus()},0):i()),e.settings.enableSearch&&e.open&&setTimeout(function(){angular.element(t)[0].querySelector(".searchField").focus()},0)}function c(t,n){e.setSelectedItem(n,!1,!0),t.stopImmediatePropagation()}function a(){e.open=!1,e.input.searchFilter=e.settings.clearSearchOnClose?"":e.input.searchFilter,e.externalEvents.onClose()}function d(t){e.selectedModel.splice(0,e.selectedModel.length),e.options.forEach(function(n){n[e.settings.groupBy]===t&&e.setSelectedItem(n,!1,!1)}),e.externalEvents.onSelectionChanged()}function u(t){return null!==e.settings.groupByTextProvider?e.settings.groupByTextProvider(t):t}function g(e){var n=t.find("button"),l=document.createElement("canvas"),o=l.getContext("2d");return o.font=n.css("font-size")+n.css("font-family"),o.originalFont=n.css("font-size")+n.css("font-family"),o.fillStyle="#000000",o.measureText(e).width}function p(){if(e.settings.dynamicTitle&&e.selectedModel&&e.selectedModel.length>0){if(angular.isFunction(e.settings.smartButtonTextProvider))return e.settings.smartButtonTextProvider(e.selectedModel);if(e.settings.smartButtonMaxItems>0){var n=24,l=2,o=8,s=t[0].offsetWidth-n-l-o,i=[];angular.forEach(e.options,function(t){if(e.isChecked(t)){var n=e.getPropertyForObject(t,e.settings.displayProp),l=e.settings.smartButtonTextConverter(n,t);i.push(l||n)}}),e.selectedModel.length>e.settings.smartButtonMaxItems&&(i=i.slice(0,e.settings.smartButtonMaxItems),i.push("..."));var r=i.join(", "),c=r.length-4;if(0===t[0].offsetWidth)return r;if(s<=g("..."))return"...";for(;g(r)>s;)"..."!==i[i.length-1]&&(i.push("..."),r+="...",c=r.length-4),r=r.slice(0,c)+r.slice(c+1),c-=1;return r}var a=angular.isDefined(e.selectedModel)?e.selectedModel.length:0;return 0===a?e.texts.buttonDefaultText:e.settings.showAllSelectedText&&a===e.options.length?e.texts.allSelectedText:a+" "+e.texts.dynamicButtonTextSuffix}return e.texts.buttonDefaultText}function h(e,t){return angular.isDefined(e)&&Object.prototype.hasOwnProperty.call(e,t)?e[t]:void 0}function f(){e.deselectAll(!0),e.externalEvents.onSelectAll();var t=o("filter")(e.options,e.getFilter(e.input.searchFilter));angular.forEach(t,function(t){e.setSelectedItem(t,!0,!1)}),e.externalEvents.onSelectionChanged(),e.selectedGroup=null}function m(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:!1;t||e.externalEvents.onDeselectAll(),e.selectedModel.splice(0,e.selectedModel.length),t||e.externalEvents.onSelectionChanged(),e.selectedGroup=null}function y(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:!1,o=arguments[2],s=void 0,i=void 0;angular.isDefined(A.idProperty)?(s=-1!==l(e.selectedModel,t,A.idProperty),i=l(e.selectedModel,t,A.idProperty)):(s=-1!==e.selectedModel.indexOf(t),i=e.selectedModel.indexOf(t)),!n&&s?(e.selectedModel.splice(i,1),e.externalEvents.onItemDeselect(t),e.settings.closeOnDeselect&&e.close()):!s&&(0===e.settings.selectionLimit||e.selectedModel.length<e.settings.selectionLimit)?(e.selectedModel.push(t),o&&e.externalEvents.onItemSelect(t),e.settings.closeOnSelect&&e.close(),e.settings.selectionLimit>0&&e.selectedModel.length===e.settings.selectionLimit&&e.externalEvents.onMaxSelectionReached()):1!==e.settings.selectionLimit||s||e.selectedModel.length!==e.settings.selectionLimit||(e.selectedModel.splice(0,1),e.selectedModel.push(t),o&&e.externalEvents.onItemSelect(t),e.settings.closeOnSelect&&e.close()),o&&e.externalEvents.onSelectionChanged(),e.selectedGroup=null}function v(t){return angular.isDefined(A.idProperty)?-1!==l(e.selectedModel,t,A.idProperty):-1!==e.selectedModel.indexOf(t)}function k(t){var n=angular.element(t.target).scope(),l=void 0,o=t.target.parentNode;if(e.settings.keyboardControls)if(13===t.keyCode||32===t.keyCode)t.preventDefault(),n.option?e.setSelectedItem(n.option,!1,!0):"deselectAll"===t.target.id?e.deselectAll():"selectAll"===t.target.id&&e.selectAll();else if(38===t.keyCode){for(t.preventDefault(),o.previousElementSibling&&(l=o.previousElementSibling.querySelector("a")||o.previousElementSibling.querySelector("input"));!l&&o;)o=o.previousElementSibling,o&&(l=o.querySelector("a")||o.querySelector("input"));l&&l.focus()}else if(40===t.keyCode){for(t.preventDefault(),o.nextElementSibling&&(l=o.nextElementSibling.querySelector("a")||o.nextElementSibling.querySelector("input"));!l&&o;)o=o.nextElementSibling,o&&(l=o.querySelector("a")||o.querySelector("input"));l&&l.focus()}else 27===t.keyCode&&(t.preventDefault(),e.toggleDropdown())}function b(t){var n=t.target.parentNode.parentNode,l=void 0;if(e.settings.keyboardControls)if(9===t.keyCode||40===t.keyCode)t.preventDefault(),i();else if(38===t.keyCode){for(t.preventDefault(),n.previousElementSibling&&(l=n.previousElementSibling.querySelector("a")||n.previousElementSibling.querySelector("input"));!l&&n;)n=n.previousElementSibling,n&&(l=n.querySelector("a")||n.querySelector("input"));l&&l.focus()}else 27===t.keyCode&&(t.preventDefault(),e.toggleDropdown())}function x(t,n){var l=void 0;e.settings.keyboardControls&&13===t.keyCode&&(1===e.settings.selectionLimit&&e.settings.enableSearch?(l=o("filter")(e.options,e.getFilter(n)),1===l.length&&e.setSelectedItem(l[0],!1,!0)):e.settings.enableSearch&&e.selectAll())}function S(t){var n={};return n[e.settings.searchField]=t,n}function w(t){t&&t.stopPropagation(),e.settings.enableSearch=!e.settings.enableSearch,e.settings.enableSearch||(e.input.searchFilter="")}function C(){e.settings.keyboardControls&&13===event.keyCode&&(e.toggleSearch(),e.settings.enableSearch?setTimeout(function(){angular.element(t)[0].querySelector(".searchField").focus()},0):i())}function D(t,n){if(angular.isUndefined(n))return-1;if(angular.isUndefined(t))return 1;if("object"!==t.type||"object"!==n.type)return t.index<n.index?-1:1;var l=t.value,o=n.value;return e.settings.groupBy&&l[e.settings.groupBy]!==o[e.settings.groupBy]?l[e.settings.groupBy]<o[e.settings.groupBy]?1:-1:e.settings.selectedToTop?!e.isChecked(l)&&!e.isChecked(o)||e.isChecked(l)&&e.isChecked(o)?e.options.indexOf(l)<e.options.indexOf(o)?-1:1:e.isChecked(l)?-1:1:e.options.indexOf(l)<e.options.indexOf(o)?-1:1}var B=t.children()[0],E={onItemSelect:angular.noop,onItemDeselect:angular.noop,onSelectAll:angular.noop,onDeselectAll:angular.noop,onInitDone:angular.noop,onMaxSelectionReached:angular.noop,onSelectionChanged:angular.noop,onClose:angular.noop},A={dynamicTitle:!0,scrollable:!1,scrollableHeight:"300px",closeOnBlur:!0,displayProp:"label",enableSearch:!1,clearSearchOnClose:!1,selectionLimit:0,showCheckAll:!0,showUncheckAll:!0,showEnableSearchButton:!1,closeOnSelect:!1,buttonClasses:"btn btn-default",closeOnDeselect:!1,groupBy:void 0,checkBoxes:!1,groupByTextProvider:null,smartButtonMaxItems:0,smartButtonTextConverter:angular.noop,styleActive:!1,selectedToTop:!1,keyboardControls:!1,template:"{{getPropertyForObject(option, settings.displayProp)}}",searchField:"$",showAllSelectedText:!1},M={checkAll:"Check All",uncheckAll:"Uncheck All",selectionCount:"checked",selectionOf:"/",searchPlaceholder:"Search...",buttonDefaultText:"Select",dynamicButtonTextSuffix:"checked",disableSearch:"Disable search",enableSearch:"Enable search",selectGroup:"Select all:",allSelectedText:"All"},T={searchFilter:e.searchFilter||""};angular.extend(A,e.extraSettings||[]),angular.extend(E,e.events||[]),angular.extend(M,e.translationTexts),A.closeOnBlur&&s.on("click",function(t){if(e.open){for(var l=t.target.parentElement,o=!1;angular.isDefined(l)&&null!==l&&!o;)l.className.split&&n(l.className.split(" "),"multiselect-parent")&&!o&&l===B&&(o=!0),l=l.parentElement;o||e.$apply(function(){e.close()})}}),angular.extend(e,{toggleDropdown:r,checkboxClick:c,externalEvents:E,settings:A,texts:M,input:T,close:a,selectCurrentGroup:d,getGroupLabel:u,getButtonText:p,getPropertyForObject:h,selectAll:f,deselectAll:m,setSelectedItem:y,isChecked:v,keyDownLink:k,keyDownSearchDefault:b,keyDownSearch:x,getFilter:S,toggleSearch:w,keyDownToggleSearch:C,orderFunction:D}),e.externalEvents.onInitDone()}o.$inject=["$scope","$element","$filter","$document"],Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=o}]),angular.module("angularjs-dropdown-multiselect").run(["$templateCache",function(e){e.put("app/component/angularjs-dropdown-multiselect.html",'<div class="multiselect-parent btn-group dropdown-multiselect" ng-class="{open: open}"><div ng-transclude=toggleDropdown ng-click=toggleDropdown()><button ng-disabled=disabled type=button class=dropdown-toggle ng-class=settings.buttonClasses>{{getButtonText()}}&nbsp;<span class=caret></span></button></div><ul class="dropdown-menu dropdown-menu-form" ng-if=open ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\', overflow: \'auto\' }"><li ng-if="settings.showCheckAll && settings.selectionLimit === 0"><a ng-keydown=keyDownLink($event) data-ng-click=selectAll() tabindex=-1 id=selectAll><span class="glyphicon glyphicon-ok"></span> {{texts.checkAll}}</a></li><li ng-if=settings.showUncheckAll><a ng-keydown=keyDownLink($event) data-ng-click=deselectAll(); tabindex=-1 id=deselectAll><span class="glyphicon glyphicon-remove"></span> {{texts.uncheckAll}}</a></li><li ng-if="settings.selectByGroups && ((settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll)" class=divider></li><li ng-repeat="currentGroup in settings.selectByGroups track by $index" ng-click=selectCurrentGroup(currentGroup)><a ng-class="{\'dropdown-selected-group\': selectedGroup === currentGroup}" tabindex=-1>{{::texts.selectGroup}} {{::getGroupLabel(currentGroup)}}</a></li><li ng-if="settings.selectByGroups && settings.showEnableSearchButton" class=divider></li><li ng-if="settings.showEnableSearchButton && settings.enableSearch"><a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click=toggleSearch($event); tabindex=-1>{{texts.disableSearch}}</a></li><li ng-if="settings.showEnableSearchButton && !settings.enableSearch"><a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click=toggleSearch($event); tabindex=-1>{{texts.enableSearch}}</a></li><li ng-if="(settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll || settings.showEnableSearchButton" class=divider></li><li ng-if=settings.enableSearch><div class=dropdown-header><input type=text class="form-control searchField" ng-keydown="keyDownSearchDefault($event); keyDownSearch($event, input.searchFilter);" ng-style="{width: \'100%\'}" ng-model=input.searchFilter placeholder={{texts.searchPlaceholder}}></div></li><li ng-if=settings.enableSearch class=divider></li><li ng-if=settings.groupBy ng-repeat-start="option in orderedItems = ( options | filter:getFilter(input.searchFilter) | orderBy:\'\':false:orderFunction)" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role=presentation class=dropdown-header>{{ getGroupLabel(getPropertyForObject(option, settings.groupBy)) }}</li><li ng-if=settings.groupBy ng-class="{\'active\': isChecked(option) && settings.styleActive}" ng-repeat-end role=presentation><a ng-keydown="option.disabled || keyDownLink($event)" role=menuitem class=option tabindex=-1 ng-click="option.disabled || setSelectedItem(option, false, true)" ng-disabled=option.disabled><div ng-if=settings.checkBoxes class=checkbox><label><input class=checkboxInput type=checkbox ng-click="checkboxClick($event, option)" ng-checked=isChecked(option)> <span dm-dropdown-static-include={{settings.template}}></span></label></div><span ng-if=!settings.checkBoxes data-ng-class="{\'glyphicon glyphicon-ok\': isChecked(option)}"></span> <span dm-dropdown-static-include={{settings.template}}></span></a></li><li ng-if=!settings.groupBy ng-class="{\'active\': isChecked(option) && settings.styleActive}" role=presentation ng-repeat="option in options | filter:getFilter(input.searchFilter) | orderBy:\'\':false:orderFunction"><a ng-keydown="option.disabled || keyDownLink($event)" role=menuitem class=option tabindex=-1 ng-click="option.disabled || setSelectedItem(option, false, true)" ng-disabled=option.disabled><div ng-if=settings.checkBoxes class=checkbox><label><input class=checkboxInput type=checkbox ng-click="checkboxClick($event, option)" ng-checked=isChecked(option)> <span dm-dropdown-static-include={{settings.template}}></span></label></div><span ng-if=!settings.checkBoxes data-ng-class="{\'glyphicon glyphicon-ok\': isChecked(option)}"></span> <span ng-if=!settings.checkBoxes dm-dropdown-static-include={{settings.template}}></span></a></li><li class=divider ng-show="settings.selectionLimit > 1"></li><li role=presentation ng-show="settings.selectionLimit > 1"><a role=menuitem>{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li></ul></div>')}]);
	//# sourceMappingURL=maps/angularjs-dropdown-multiselect.min.js.map


/***/ },
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerConfig = routerConfig;
	routerConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider', 'APP'];
	
	function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, APP) {
	
	  $stateProvider.state({
	    abstract: true,
	    name: 'app',
	    url: '',
	    views: {
	      '': {
	        template: '<app></app>'
	      }
	    }
	  });
	  $urlRouterProvider.otherwise(function ($injector, $location) {
	    var params = $location.path();
	    // return  "/"+params;
	    return "";
	  });
	
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	  $httpProvider.interceptors.push('authInterceptor');
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(70);
	
	Object.keys(_app).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _app[key];
	    }
	  });
	});

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _spinner = __webpack_require__(74);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _app = __webpack_require__(75);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _logoFooter = __webpack_require__(76);
	
	var _logoFooter2 = _interopRequireDefault(_logoFooter);
	
	var _franchisePng = __webpack_require__(77);
	
	var _franchisePng2 = _interopRequireDefault(_franchisePng);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppComponent = exports.AppComponent = (_dec = (0, _utils.Component)({
	  controllerAs: 'app',
	  template: _app2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function AppComponent($state, $location, $window, $rootScope, $uibModal, $stateParams, APP, $auth, $ngRedux, $cookies) {
	    _classCallCheck(this, AppComponent);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$state = $state;
	    this.$location = $location;
	    this.spinner = _spinner2.default;
	    this.headerFixed = true;
	    this.$window = $window;
	    this.$rootScope = $rootScope;
	    this.logo = _logoFooter2.default;
	    this.$uibModal = $uibModal;
	    this.$stateParams = $stateParams;
	    this.APP = APP;
	    this.$auth = $auth;
	    this.$cookies = $cookies;
	    this.testfranchise = _franchisePng2.default;
	    this.hasFranchiseUrl = false;
	
	    var isCookieAgreed = this.$cookies.get('moove_gdpr_popup_mywbu');
	    if (isCookieAgreed == "true") {
	      this.isAgreed = true;
	    } else {
	      this.isAgreed = false;
	    }
	    console.log("this.$cookies", this.$cookies);
	    console.log("This is agreed : ", isCookieAgreed);
	    console.log("This is agreed : ", this.isAgreed);
	
	    this.$auth.getPwrKeys();
	
	    this.openFreeShippingPopUp(false);
	    this.setFranchiseUrl();
	    // to show freeshipping in footer
	    var ctr1 = this;
	    var listener1 = $rootScope.$on('FreeShipping', function (evt, storeName) {
	      ctr1.freeShippingCheckForStore(storeName);
	    });
	    $rootScope.$on('$destroy', function () {
	      listener1();
	    });
	
	    if ('serviceWorker' in navigator) {
	      window.addEventListener('load', function () {
	        navigator.serviceWorker.register('/service-worker.js').then(function (registration) {
	          console.log('ServiceWorker registered:', registration.scope);
	        }).catch(function (error) {
	          console.log('ServiceWorker registration failed:', error);
	        });
	      });
	    }
	
	    this.$rootScope.$on('$stateChangeSuccess', function () {
	      document.body.scrollTop = document.documentElement.scrollTop = 0;
	    });
	  }
	
	  _createClass(AppComponent, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }, {
	    key: 'isRulesFaq',
	    value: function isRulesFaq() {
	      return this.$location.path().indexOf('rules') !== -1;
	    }
	  }, {
	    key: 'toogleHeaderFixed',
	    value: function toogleHeaderFixed() {
	      this.headerFixed = !this.headerFixed;
	    }
	  }, {
	    key: 'toogleFooterFixed',
	    value: function toogleFooterFixed() {
	      this.footerFixed = !this.footerFixed;
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      // return ( this.$window.innerWidth < 752 && this.$window.innerHeight < 752 );
	      return this.$window.innerWidth < 752;
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'getClassConfigs',
	    value: function getClassConfigs() {
	      if (this.isLoggedIn() && !this.isMobileOnly()) {
	        return 'wbu-container';
	      }
	      return '';
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      if (!this.isMobileOnly()) {
	        var header_height = document.getElementsByClassName("navbar-fixed-top")[0];
	        if (header_height) {
	          return "height:" + header_height.clientHeight + "px";
	        }
	      }
	      return "";
	    }
	  }, {
	    key: 'getContentStyle',
	    value: function getContentStyle() {
	
	      if (!this.isMobileOnly()) {
	        var header_height = document.getElementsByClassName("wbu-header-content")[0];
	        var footer_height = document.getElementsByClassName("wbu-footer-content")[0];
	        var window_height = this.$window.innerHeight;
	        // console.log("Header_Height : ",header_height.clientHeight);
	        // console.log("Footer_Height : ",footer_height.clientHeight);
	        // console.log("Content_Height : ",window_height);
	        var body_height = 0;
	        if (header_height.clientHeight && footer_height) {
	          body_height = window_height - (header_height.clientHeight + footer_height.clientHeight);
	
	          return "min-height:" + body_height + "px";
	        }
	      }
	      return "";
	    }
	  }, {
	    key: 'openFreeShippingPopUp',
	    value: function openFreeShippingPopUp(isShow) {
	      var _this = this;
	
	      var storeName = '';
	      var freeShippingPrice = '';
	      var country = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile && this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.freeShippingCheckForStore(storeName);
	        if (isShow) {
	          this.$auth.getFreeShippingFromStore(storeName).then(function (success) {
	            console.log("Success -- ", success);
	            freeShippingPrice = success.data.thresholdValue;
	            country = success.data.country;
	            var tittle = '';
	            var detailInfo = '';
	            if (country.countryCode == 'US') {
	              tittle = 'Free Shipping within Zone 2';
	              detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + freeShippingPrice + ' or more after any other discounts applied.</li></ul></p>';
	            } else {
	              tittle = 'Free shipping in Zones 0-1';
	              detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + freeShippingPrice + ' or more after any other discounts applied.</li></ul></p>';
	            }
	            // tittle = 'Free Shipping/Shipping Rates';
	            // detailInfo = '<p><ul>'+
	            // '<li>Flat-rate shipping is available for $7.99 within shipping Zone 2 (US) or $14.99 within shipping Zones 0-1 (CAN) as determined by our preferred shipping partner, FedEx. Each additional zone of distance from the store will add an additional charge to the flat-rate shipping amount.</li>'+
	            // '<li>Free shipping is available for orders over $75 (US) and $99 (CAN). Free shipping promotions apply to the base flat-rate charge. Any additional distance zones of shipping distance will still incur additional per-zone shipping charges. Shipping charges can be determined at checkout.</li>'+
	            // '</li></ul></p>';
	            _this.$uibModal.open({
	              size: 'sm',
	              template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	              controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	                $scope.ok = function () {
	                  $uibModalInstance.close();
	                };
	              }]
	            });
	          }).catch(function (err) {
	            console.log("Error -- ", err);
	          });
	        }
	      } else {
	        this.showFreeShippingPopup = false;
	      }
	    }
	  }, {
	    key: 'freeShippingCheckForStore',
	    value: function freeShippingCheckForStore(storeName) {
	      var _this2 = this;
	
	      this.$auth.getStoreDetail(storeName).then(function (success) {
	        //  this.freeshippingData =success.data;
	        if (success.data.isFreeShipping && success.data.freeShipping) {
	          var shippingOfferStartDate = new Date(success.data.freeShipping.startDate);
	          var shippingOfferEndDate = new Date(success.data.freeShipping.endDate);
	          var currentDate = new Date();
	          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	            _this2.showFreeShippingPopup = true;
	          } else {
	            _this2.showFreeShippingPopup = false;
	          }
	        } else {
	          _this2.showFreeShippingPopup = false;
	        }
	      });
	    }
	  }, {
	    key: 'setAgreedCookie',
	    value: function setAgreedCookie() {
	      var isAgreedCookie = this.$cookies.get('moove_gdpr_popup_mywbu');
	      console.log("isAgreedCookie", isAgreedCookie);
	      this.$auth.setAgreedCookie();
	      this.isAgreed = true;
	    }
	  }, {
	    key: 'setFranchiseUrl',
	    value: function setFranchiseUrl() {
	      var _this3 = this;
	
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile && this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	
	      if (storeName) {
	        this.$auth.getStoreByStoreName(storeName).then(function (success) {
	          console.log("Franchise success", success);
	          if (success.data.franchiseUrl) {
	            console.log(success.data.franchiseUrl.substring(success.data.franchiseUrl.length - 1));
	            _this3.hasFranchiseUrl = true;
	            var constructedStoreCode = success.data.storeCode;
	            while (constructedStoreCode.length < 3) {
	              constructedStoreCode = '0' + constructedStoreCode;
	            }
	            if (success.data.franchiseUrl.substring(success.data.franchiseUrl.length - 1) == "/") {
	              _this3.franchiseUrl = success.data.franchiseUrl + "own-a-franchise?OS=" + constructedStoreCode;
	            } else {
	              _this3.franchiseUrl = success.data.franchiseUrl + "/own-a-franchise?OS=" + constructedStoreCode;
	            }
	          } else {
	            _this3.hasFranchiseUrl = false;
	          }
	        }).catch(function (error) {
	          _this3.hasFranchiseUrl = false;
	          console.log("FranchiseUrl error -- ", error);
	        });
	      } else {
	        this.hasFranchiseUrl = false;
	      }
	    }
	  }]);
	
	  return AppComponent;
	}(), _class2.$inject = ['$state', '$location', '$window', '$rootScope', '$uibModal', '$stateParams', 'APP', 'authService', '$ngRedux', '$cookies'], _temp)) || _class);

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _componentDecorator = __webpack_require__(72);
	
	Object.keys(_componentDecorator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _componentDecorator[key];
	    }
	  });
	});
	
	var _createMockStore = __webpack_require__(73);
	
	Object.keys(_createMockStore).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createMockStore[key];
	    }
	  });
	});

/***/ },
/* 72 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Component = exports.Component = function Component(config) {
	  return function (target) {
	    config.controller = target;
	    return config;
	  };
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createMockStore = createMockStore;
	
	var _redux = __webpack_require__(2);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createMockStore(state, expectedActions, middleware, done) {
	  if (!Array.isArray(expectedActions)) {
	    throw new Error('ERROR # createMockStore : `expectedActions` must be an array of expected actions.');
	  }
	
	  if (typeof done !== 'undefined' && typeof done !== 'function') {
	    throw new Error('ERROR # createMockStore : `done` must be undefined or a function.');
	  }
	
	  function store() {
	    return {
	      dispatch: function dispatch(action) {
	        var expectedAction = expectedActions.shift();
	
	        try {
	          if (typeof expectedAction === 'function') {
	            expect(expectedAction(action)).toBe(true);
	          } else {
	            expect(action).toEqual(expectedAction);
	          }
	
	          return action;
	        } catch (error) {
	          done(error);
	        }
	      },
	      getState: function getState() {
	        return typeof state === 'function' ? state() : state;
	      }
	    };
	  }
	
	  return _redux.applyMiddleware.apply(undefined, _toConsumableArray(middleware))(store)();
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ecb61ab7e886a4d73c2396ad9a8192f4.gif";

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = "<toaster-container toaster-options=\"{'position-class': 'toast-bottom-center', 'limit':1, 'time-out': 2500}\"></toaster-container>\r\n<spinner name=\"appSpinner\" class=\"spinner\" img-src=\"{{app.spinner}}\"></spinner>\r\n<div class=\"container-fluid fill\">\r\n  <div class=\"row fill\">\r\n    <div class=\"hidden-xl-down p-x-0\"\r\n      ng-if=\"app.isLoggedIn()\">\r\n      <div ui-view=\"sidenav\"></div>\r\n    </div>\r\n    <div class=\"p-x-0\"\r\n      ng-class=\"app.isLoggedIn() || app.isRulesFaq() ? 'col-xs-12 fill' : 'col-xs-12 bg-color fill'\">\r\n     <!-- <div ui-view=\"header\" ng-class=\"app.headerFixed ? 'navbar-fixed-top' : ''\"></div>\r\n      <div class=\"container \" ui-view=\"content\" ng-class=\"app.headerFixed ? 'header-footer-fixed' : ''\"></div>-->\r\n        <div ui-view=\"header\" class=\"wbu-header-content\" style=\"{{app.getStyle()}}\"></div>\r\n        <div  ui-view=\"content\" style=\"{{app.getContentStyle()}}\" class=\"{{app.getClassConfigs()}}\" ></div>\r\n\r\n      <!-- Desktop -->\r\n      <nav class=\"hidden-sm-down wbu-footer-background\" style=\"{{ app.hasFranchiseUrl==true ? 'padding-top: 7px !important' : 'padding-top:25px !important'}}\">\r\n         <div class=\"wbu-footer-content\">\r\n\r\n             <div class=\"footer-logo\" style=\"{{ app.hasFranchiseUrl==true ? 'margin-left: 34px !important' : ''}}\">\r\n               <a target=\"_blank\" href=\"https://www.wbu.com/\"><img ng-src=\"{{app.logo}}\" ></a></div>\r\n\r\n             <div class=\"footer-copyright\">\r\n                 <p>&copy; 2017-2026 Wild Birds Unlimited, Inc. All Rights Reserved</p>\r\n                 \r\n                 <p><a ng-if=\"app.showFreeShippingPopup\" ng-click=\"app.openFreeShippingPopUp(true)\"> *Free Shipping | </a> \r\n                  <a target=\"_self\" ui-sref=\"terms-conditions\">Terms and Conditions</a>&nbsp;|\r\n                  <a target=\"_blank\" href=\"https://www.wbu.com/products-warranties-parts/\">Product Warranties and Parts</a>&nbsp;| <a target=\"_blank\" href=\"https://wwws-canada2.givex.com/merchant_balcheck/3684_en/\">WBU Gift Cards Balance Check</a><br>\r\n                  <a target=\"_self\" ui-sref=\"accessibility\">Accessibility Statement</a>&nbsp;|\r\n                  <a target=\"_blank\" href=\"https://www.wbu.com/privacy-statement/\">Privacy Statement</a>&nbsp;|\r\n                  <a target=\"_blank\" href=\"https://www.wbu.com/legal/\">Legal Notice</a>&nbsp;|\r\n                  <a target=\"_blank\" href=\"https://www.wbu.com/allergen-statement/\">Allergen Statement</a>&nbsp;\r\n \r\n                </p>\r\n             </div>\r\n\r\n             <div class=\"hidden-sm-down footer-copyright\" > \r\n              <a target=\"_blank\" href=\"https://franchise.wbu.com/storereferral/\" >\r\n                <img style=\"max-width:60%\" ng-src=\"{{app.testfranchise}}\" >\r\n                <p style=\"color: #f3f0dc;\">Own a Franchise</p>\r\n              </a>\r\n            </div>\r\n\r\n      </div>\r\n      </nav>\r\n\r\n      <!-- Mobile -->\r\n      <nav  ng-if=\"app.isLoggedIn()\" \r\n      class=\"hidden-md-up wbu-footer-background\" style=\"{{ app.hasFranchiseUrl==true ? 'padding-top: 7px !important' : 'padding-top:25px !important'}}\">\r\n         <div class=\"wbu-footer-content\">\r\n            \r\n             <div class=\"footer-logo\" style=\"margin-top: 15px; margin-bottom: 15px; width:50%; margin-left:0px;\">\r\n               <a target=\"_blank\" href=\"https://www.wbu.com/\"><img ng-src=\"{{app.logo}}\" ></a></div>\r\n\r\n              <div class=\"footer-copyright \" style=\"width:50%; margin-left:0px;\"> \r\n                <a target=\"_blank\" href=\"https://franchise.wbu.com/storereferral/\" >\r\n                  <img style=\"max-width:60%\" ng-src=\"{{app.testfranchise}}\" >\r\n                  <p style=\"color: #f3f0dc;\">Own a Franchise</p>\r\n                </a>\r\n              </div>\r\n\r\n             <div class=\"footer-copyright\" style=\"margin-left:0px;\">\r\n                 <p>&copy; 2017-2026 Wild Birds Unlimited, Inc. All Rights Reserved</p>\r\n                  <p >\r\n                    <a ng-if=\"app.showFreeShippingPopup\" ng-click=\"app.openFreeShippingPopUp(true)\"> *Free Shipping | </a> \r\n                    <a target=\"_self\" ui-sref=\"terms-conditions\">Terms and Conditions</a>&nbsp;\r\n                  </p>\r\n                  <p><a target=\"_blank\" href=\"https://www.wbu.com/products-warranties-parts/\">Product Warranties and Parts</a>&nbsp;</p>\r\n                  <p >\r\n                    <a target=\"_blank\" href=\"https://wwws-canada2.givex.com/merchant_balcheck/3684_en/\">WBU Gift Cards Balance Check</a>\r\n                    <a target=\"_self\" ui-sref=\"accessibility\">Accessibility Statement</a>&nbsp;\r\n                  </p>\r\n                  <p >\r\n                    <a target=\"_blank\" href=\"https://www.wbu.com/privacy-statement/\">Privacy Statement</a>&nbsp;|\r\n                    <a target=\"_blank\" href=\"https://www.wbu.com/legal/\">Legal Notice</a>&nbsp;|\r\n                    <a target=\"_blank\" href=\"https://www.wbu.com/allergen-statement/\">Allergen Statement</a>&nbsp;\r\n                  </p>\r\n             </div>\r\n      </div>\r\n      </nav>\r\n\r\n\r\n    </div>\r\n  </div>\r\n  <!-- <div class=\"agree-this\">\r\n    This site uses cookies to enhance your user experience and to help us analyze site traffic. By continuing to use this site, you consent our use of cookies.\r\n  </div> -->\r\n     <!-- <aside ng-hide=\"app.isAgreed\" id=\"moove_gdpr_cookie_info_bar\" class=\"moove-gdpr-align-center moove-gdpr-dark-scheme gdpr_infobar_postion_bottom\" role=\"note\" >\r\n      <div class=\"moove-gdpr-info-bar-container\">\r\n        <div class=\"moove-gdpr-info-bar-content row\">\r\n          <div class=\"moove-gdpr-cookie-notice col-xs-10\">\r\n            <p>This site uses cookies to enhance your user experience and to help us analyze site traffic. By continuing to use this site, you consent our use of cookies.<br/><a href=\"https://www.wbu.com/privacy-statement/\">MORE INFO</a></p>\r\n          </div>   \r\n          <div class=\"moove-gdpr-button-holder col-xs-2\">\r\n            <button class=\"mgbutton moove-gdpr-infobar-allow-all\" ng-click=\"app.setAgreedCookie(true)\" aria-label=\"Agree\">Agree</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </aside>  -->\r\n\r\n    <div ng-hide=\"app.isAgreed\" id=\"moove_gdpr_cookie_info_bar\" role=\"note\" >\r\n      <div class=\"center\">\r\n          <div class=\"row moove-gdpr-cookie-notice agree_terms\">\r\n            <div ng-if=\"app.isMobileOnly()\" ng-class=\"app.isMobileOnly()?'agree_terms_mob_text':'agree_terms_text'\">This site uses cookies to enhance your user experience and to help us analyze site traffic. By continuing to use this site, you consent our use of cookies.<br/><a href=\"https://www.wbu.com/privacy-statement/\" target=\"_blank\">MORE INFO</a></div>\r\n            <div ng-if=\"app.isMobileOnly()\" ng-class=\"app.isMobileOnly()?'agree_terms_mob_button_div':'agree_terms_button'\"><button ng-class=\"app.isMobileOnly()?'agree_terms_mob_button':''\" type=\"button\" class=\"mb-4 btn btn-lg btn-primary  btn-block btn-md-text \" ng-click=\"app.setAgreedCookie(true)\" >Agree</button></div>\r\n            <div ng-if=\"!app.isMobileOnly()\" ng-class=\"app.isIpad()?'agree_terms_ipad_text':'agree_terms_text'\">This site uses cookies to enhance your user experience and to help us analyze site traffic. By continuing to use this site, you consent our use of cookies.<br/><a href=\"https://www.wbu.com/privacy-statement/\" target=\"_blank\">MORE INFO</a></div>\r\n            <div ng-if=\"!app.isMobileOnly()\" ng-class=\"app.isIpad()?'agree_terms_ipad_button_div':'agree_terms_button'\"><button type=\"button\" class=\"mb-4 btn btn-lg btn-primary  btn-block btn-md-text \" ng-click=\"app.setAgreedCookie(true)\" >Agree</button></div>\r\n          </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n"

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9821630ecc94c9565024993e5790e822.png";

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6949cca9a390573d5a1ebdad3cf246f9.png";

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = authReducer;
	
	var _actionTypes = __webpack_require__(79);
	
	var INITIAL_STATE = {
	  storeDetail: {},
	  profile: {},
	  countries: [],
	  storesList: [],
	  guestCartList: [],
	  store: {}
	};
	
	function authReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  if (!action || !action.type) {
	    return state;
	  }
	  switch (action.type) {
	    case _actionTypes.SET_STORE_DETAIL:
	      return Object.assign({}, state, {
	        storeDetail: action.data
	      });
	    case _actionTypes.SET_USER_PROFILE:
	      return Object.assign({}, state, {
	        profile: action.data
	      });
	    case _actionTypes.SET_GUEST_USER_PROFILE:
	      return Object.assign({}, state, {
	        guestprofile: action.data
	      });
	    case _actionTypes.SET_COUNTRIES_INFO:
	      return Object.assign({}, state, {
	        countries: action.data
	      });
	    case _actionTypes.SET_STORES_INFO:
	      return Object.assign({}, state, {
	        storesList: action.data
	      });
	    case _actionTypes.SET_GUEST_CART:
	      return Object.assign({}, state, {
	        guestCartList: action.data
	      });
	    case _actionTypes.SET_STORE:
	      return Object.assign({}, state, {
	        store: action.data
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_STORE_DETAIL = exports.SET_STORE_DETAIL = 'SET_STORE_DETAIL';
	var SET_USER_PROFILE = exports.SET_USER_PROFILE = 'SET_USER_PROFILE';
	var SET_GUEST_USER_PROFILE = exports.SET_GUEST_USER_PROFILE = 'SET_GUEST_USER_PROFILE';
	var SET_COUNTRIES_INFO = exports.SET_COUNTRIES_INFO = 'SET_COUNTRIES_INFO';
	var SET_STORES_INFO = exports.SET_STORES_INFO = 'SET_STORES_INFO';
	var SET_GUEST_CART = exports.SET_GUEST_CART = 'SET_GUEST_CART';
	var SET_STORE = exports.SET_STORE = 'SET_STORE';
	
	exports.default = {
	  SET_STORE_DETAIL: SET_STORE_DETAIL,
	  SET_USER_PROFILE: SET_USER_PROFILE,
	  SET_GUEST_USER_PROFILE: SET_GUEST_USER_PROFILE,
	  SET_COUNTRIES_INFO: SET_COUNTRIES_INFO,
	  SET_STORES_INFO: SET_STORES_INFO,
	  SET_GUEST_CART: SET_GUEST_CART,
	  SET_STORE: SET_STORE
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = orderReducer;
	
	var _actionTypes = __webpack_require__(81);
	
	var INITIAL_STATE = {
	  /*eslint-disable*/
	  cartDetail: {
	    cartItems: []
	  },
	  categories: [],
	  // categories: [{"category":{"id":1,"name":"Bird Food","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"subCategoryList":[{"id":1,"name":"Food Blends1","description":"This is food blends produc 1t for all season birds","category":{"id":1,"name":"Bird Food","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/subcategory-images/Image.png"},{"id":2,"name":"Food Blends2","description":"This is food blends product 2for all season birds","category":{"id":1,"name":"Bird Food","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/subcategory-images/Image.png"}]},{"category":{"id":2,"name":"Bird Feeders","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"subCategoryList":[{"id":3,"name":"Bird Fooders","description":"This is the bird fooders sub category","category":{"id":2,"name":"Bird Feeders","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/subcategory-images/Image.png"}]},{"category":{"id":3,"name":"Hardware","code":null,"department":{"id":1,"name":"Products","code":null},"imageURL":"https://wbu-app-dev.s3.amazonaws.com/category-images/Image.png","description":null},"subCategoryList":[]}],
	  tiles: [],
	  subCategories: [],
	  products: [],
	  productDetail: {},
	  storeDetail: {},
	  shippingCharges: [],
	  orderDetail: {},
	  paymentInfo: [],
	  recentOrder: [],
	  zoneDeliveryCharges: [],
	  searchResults: [],
	  coupon: {},
	  taxes: {},
	  storeLocations: [],
	  userShippingZone: {},
	  subscriptions: [],
	  subscriptionsDetail: {},
	  availableSubscriptionsInterval: [],
	  subscribableProducts: [],
	  subscriptionConfig: {},
	  discountCoupon: {},
	  promoImage: {},
	  storeFeatures: {},
	  birdBucksList: {},
	  storeDiscountMap: {},
	  referralProducts: [],
	  orderPoints: {},
	  giftCards: []
	
	  /*eslint-enable*/
	};
	
	function orderReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  if (!action || !action.type) {
	    return state;
	  }
	  switch (action.type) {
	    case _actionTypes.SET_CART_DETAIL:
	      return Object.assign({}, state, {
	        cartDetail: action.data
	      });
	    case _actionTypes.SET_SUBSCRIPTIONS:
	      return Object.assign({}, state, {
	        subscriptions: action.data
	      });
	    case _actionTypes.SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL:
	      return Object.assign({}, state, {
	        availableSubscriptionsInterval: action.data
	      });
	    case _actionTypes.SET_SUBSCRIPTIONS_DETAIL:
	      return Object.assign({}, state, {
	        subscriptionsDetail: action.data
	      });
	    case _actionTypes.SET_SUBSCRIPTION_CONFIG:
	      return Object.assign({}, state, {
	        subscriptionConfig: action.data
	      });
	    case _actionTypes.SET_CATEGORIES:
	      return Object.assign({}, state, {
	        categories: action.data.categories
	      });
	    case _actionTypes.SET_TILES:
	      return Object.assign({}, state, {
	        tiles: action.data
	      });
	    case _actionTypes.SET_SUB_CATEGORIES:
	      return Object.assign({}, state, {
	        subCategories: action.data.subCategories
	      });
	    case _actionTypes.SET_PRODUCTS:
	      return Object.assign({}, state, {
	        products: action.data
	      });
	    case _actionTypes.SET_PRODUCT_DETAIL:
	      return Object.assign({}, state, {
	        productDetail: action.data
	      });
	    case _actionTypes.SET_STORE_DETAIL:
	      return Object.assign({}, state, {
	        storeDetail: action.data
	      });
	    case _actionTypes.SET_SHIPPING_CHARGES:
	      return Object.assign({}, state, {
	        shippingCharges: action.data
	      });
	    case _actionTypes.SET_ORDER_DETAIL:
	      return Object.assign({}, state, {
	        orderDetail: action.data
	      });
	    case _actionTypes.SET_PAYMENT_INFO:
	      return Object.assign({}, state, {
	        paymentInfo: action.data
	      });
	    case _actionTypes.SET_RECENT_ORDER:
	      return Object.assign({}, state, {
	        recentOrder: action.data
	      });
	    case _actionTypes.SET_ZONEWISE_DELIVERYCHARGES:
	      return Object.assign({}, state, {
	        zoneDeliveryCharges: action.data
	      });
	    case _actionTypes.SET_SEARCH_RESULTS:
	      return Object.assign({}, state, {
	        searchResults: action.data
	      });
	    case _actionTypes.SET_BIRDBUCK_COUPON:
	      return Object.assign({}, state, {
	        coupon: action.data
	      });
	    case _actionTypes.SET_TAXES:
	      return Object.assign({}, state, {
	        taxes: action.data
	      });
	    case _actionTypes.SET_STORE_LOCATIONS:
	      return Object.assign({}, state, {
	        storeLocations: action.data
	      });
	    case _actionTypes.SET_USER_SHIPPING_ZONE_INFO:
	      return Object.assign({}, state, {
	        userShippingZone: action.data
	      });
	    case _actionTypes.SET_SUBSCRIBABLE_PRODUCTS:
	      return Object.assign({}, state, {
	        subscribableProducts: action.data
	      });
	    case _actionTypes.SET_DISCOUNT_COUPON:
	      return Object.assign({}, state, {
	        discountCoupon: action.data
	      });
	    case _actionTypes.SET_PROMO_IMAGE:
	      return Object.assign({}, state, {
	        promoImage: action.data
	      });
	    case _actionTypes.SET_STORE_FEATURE:
	      return Object.assign({}, state, {
	        storeFeatures: action.data
	      });
	    case _actionTypes.SET_BIRDBUCKS_BY_USER:
	      return Object.assign({}, state, {
	        birdBucksList: action.data
	      });
	    case _actionTypes.SET_STORE_DISCOUNT_MAP:
	      return Object.assign({}, state, {
	        storeDiscountMap: action.data
	      });
	    case _actionTypes.SET_REFERRAL_PRODUCTS:
	      return Object.assign({}, state, {
	        referralProducts: action.data
	      });
	    case _actionTypes.SET_ORDER_POINTS:
	      return Object.assign({}, state, {
	        orderPoints: action.data
	      });
	    case _actionTypes.SET_GIFT_CARDS:
	      return Object.assign({}, state, {
	        giftCards: action.data
	      });
	    case _actionTypes.SET_ERPLY_BIRDBUCKS_BY_USER:
	      return Object.assign({}, state, {
	        erplyBirdBucksList: action.data
	      });
	    case _actionTypes.SET_BASE_SHIPPING_CHARGE:
	      return Object.assign({}, state, {
	        baseShippingCharge: action.data
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_CART_DETAIL = exports.SET_CART_DETAIL = 'SET_CART_DETAIL';
	var SET_CATEGORIES = exports.SET_CATEGORIES = 'SET_CATEGORIES';
	var SET_TILES = exports.SET_TILES = 'SET_TILES';
	var SET_SUB_CATEGORIES = exports.SET_SUB_CATEGORIES = 'SET_SUB_CATEGORIES';
	var SET_PRODUCTS = exports.SET_PRODUCTS = 'SET_PRODUCTS';
	var SET_PRODUCT_DETAIL = exports.SET_PRODUCT_DETAIL = 'SET_PRODUCT_DETAIL';
	var SET_STORE_DETAIL = exports.SET_STORE_DETAIL = 'SET_STORE_DETAIL';
	var SET_SHIPPING_CHARGES = exports.SET_SHIPPING_CHARGES = 'SET_SHIPPING_CHARGES';
	var SET_ORDER_DETAIL = exports.SET_ORDER_DETAIL = 'SET_ORDER_DETAIL';
	var SET_PAYMENT_INFO = exports.SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
	var SET_RECENT_ORDER = exports.SET_RECENT_ORDER = 'SET_RECENT_ORDER';
	var SET_ZONEWISE_DELIVERYCHARGES = exports.SET_ZONEWISE_DELIVERYCHARGES = 'SET_ZONEWISE_DELIVERYCHARGES';
	var SET_SEARCH_RESULTS = exports.SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
	var SET_BIRDBUCK_COUPON = exports.SET_BIRDBUCK_COUPON = 'SET_BIRDBUCK_COUPON';
	var SET_TAXES = exports.SET_TAXES = 'SET_TAXES';
	var SET_STORE_LOCATIONS = exports.SET_STORE_LOCATIONS = 'SET_STORE_LOCATIONS';
	var SET_USER_SHIPPING_ZONE_INFO = exports.SET_USER_SHIPPING_ZONE_INFO = 'SET_USER_SHIPPING_ZONE_INFO';
	var SET_SUBSCRIPTIONS = exports.SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
	var SET_SUBSCRIPTIONS_DETAIL = exports.SET_SUBSCRIPTIONS_DETAIL = 'SET_SUBSCRIPTIONS_DETAIL';
	var SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL = exports.SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL = 'SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL';
	var SET_SUBSCRIBABLE_PRODUCTS = exports.SET_SUBSCRIBABLE_PRODUCTS = 'SET_SUBSCRIBABLE_PRODUCTS';
	var SET_SUBSCRIPTION_CONFIG = exports.SET_SUBSCRIPTION_CONFIG = 'SET_SUBSCRIPTION_CONFIG';
	var SET_DISCOUNT_COUPON = exports.SET_DISCOUNT_COUPON = 'SET_DISCOUNT_COUPON';
	var SET_PROMO_IMAGE = exports.SET_PROMO_IMAGE = 'SET_PROMO_IMAGE';
	var SET_STORE_FEATURE = exports.SET_STORE_FEATURE = 'SET_STORE_FEATURE';
	var SET_BIRDBUCKS_BY_USER = exports.SET_BIRDBUCKS_BY_USER = 'SET_BIRDBUCKS_BY_USER';
	var SET_STORE_DISCOUNT_MAP = exports.SET_STORE_DISCOUNT_MAP = 'SET_STORE_DISCOUNT_MAP';
	var SET_REFERRAL_PRODUCTS = exports.SET_REFERRAL_PRODUCTS = 'SET_REFERRAL_PRODUCTS';
	var SET_ORDER_POINTS = exports.SET_ORDER_POINTS = 'SET_ORDER_POINTS';
	var SET_GIFT_CARDS = exports.SET_GIFT_CARDS = 'SET_GIFT_CARDS';
	var SET_ERPLY_BIRDBUCKS_BY_USER = exports.SET_ERPLY_BIRDBUCKS_BY_USER = 'SET_ERPLY_BIRDBUCKS_BY_USER';
	var SET_BASE_SHIPPING_CHARGE = exports.SET_BASE_SHIPPING_CHARGE = 'SET_BASE_SHIPPING_CHARGE';
	
	exports.default = {
	  SET_CART_DETAIL: SET_CART_DETAIL,
	  SET_CATEGORIES: SET_CATEGORIES,
	  SET_TILES: SET_TILES,
	  SET_SUB_CATEGORIES: SET_SUB_CATEGORIES,
	  SET_PRODUCTS: SET_PRODUCTS,
	  SET_PRODUCT_DETAIL: SET_PRODUCT_DETAIL,
	  SET_STORE_DETAIL: SET_STORE_DETAIL,
	  SET_SHIPPING_CHARGES: SET_SHIPPING_CHARGES,
	  SET_ORDER_DETAIL: SET_ORDER_DETAIL,
	  SET_PAYMENT_INFO: SET_PAYMENT_INFO,
	  SET_RECENT_ORDER: SET_RECENT_ORDER,
	  SET_ZONEWISE_DELIVERYCHARGES: SET_ZONEWISE_DELIVERYCHARGES,
	  SET_SEARCH_RESULTS: SET_SEARCH_RESULTS,
	  SET_BIRDBUCK_COUPON: SET_BIRDBUCK_COUPON,
	  SET_TAXES: SET_TAXES,
	  SET_STORE_LOCATIONS: SET_STORE_LOCATIONS,
	  SET_USER_SHIPPING_ZONE_INFO: SET_USER_SHIPPING_ZONE_INFO,
	  SET_SUBSCRIPTIONS: SET_SUBSCRIPTIONS,
	  SET_SUBSCRIPTIONS_DETAIL: SET_SUBSCRIPTIONS_DETAIL,
	  SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL: SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL,
	  SET_SUBSCRIBABLE_PRODUCTS: SET_SUBSCRIBABLE_PRODUCTS,
	  SET_SUBSCRIPTION_CONFIG: SET_SUBSCRIPTION_CONFIG,
	  SET_DISCOUNT_COUPON: SET_DISCOUNT_COUPON,
	  SET_PROMO_IMAGE: SET_PROMO_IMAGE,
	  SET_STORE_FEATURE: SET_STORE_FEATURE,
	  SET_BIRDBUCKS_BY_USER: SET_BIRDBUCKS_BY_USER,
	  SET_STORE_DISCOUNT_MAP: SET_STORE_DISCOUNT_MAP,
	  SET_REFERRAL_PRODUCTS: SET_REFERRAL_PRODUCTS,
	  SET_ORDER_POINTS: SET_ORDER_POINTS,
	  SET_GIFT_CARDS: SET_GIFT_CARDS,
	  SET_ERPLY_BIRDBUCKS_BY_USER: SET_ERPLY_BIRDBUCKS_BY_USER,
	  SET_BASE_SHIPPING_CHARGE: SET_BASE_SHIPPING_CHARGE
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(83);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _constants3 = __webpack_require__(84);
	
	var _constants4 = _interopRequireDefault(_constants3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  AUTH: _constants2.default,
	  ORDER: _constants4.default
	};

/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AUTH_URL = exports.AUTH_URL = {
	  baseRoot: '/api/v1',
	  root: '/api/v1/customer',
	  storeCustomer: '/api/v1/storecustomer',
	  verify: '/api/v1/verifystoreemail',
	  findCustomer: '/api/v1/findstorecustomer',
	  login: '/login',
	  logout: '/logout',
	  storeLoc: '/store/location',
	  countries: {
	    list: '/region/country'
	  },
	  store: {
	    list: '/accounts/getallaccountsforuser',
	    change: '/changestore/check'
	  },
	  tax: {
	    validate: '/api/v1/tax/validate/address'
	  },
	  // Test
	  pwr: {
	    api_key: '',
	    locale: '',
	    merchant_group_id: '',
	    merchant_id: ''
	  },
	
	  version: {
	    num: '26.06.24'
	  }
	
	};
	
	exports.default = { AUTH_URL: AUTH_URL };

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ORDER_URL = exports.ORDER_URL = {
	  root: '/api/v1/customer',
	  category: '/category/all',
	  tiles: '/tiles/all',
	  subCategory: '/subcategory/all',
	  product: '/item/all',
	  browseUrl: 'shop',
	  siteTitle: 'Wild Birds Unlimited',
	  cart: {
	    base: '/cart',
	    erplyBase: '/erply/cart',
	    add: '/add',
	    update: '/update',
	    remove: '/remove',
	    tax: '/tax/details'
	  },
	  paymentInfo: '/payment/info',
	  shippingCharge: '/api/v1/customer/shipping/charge/all',
	  checkout: '/cart/checkout',
	  guestCheckout: '/cart/guest/checkout',
	  order: {
	    base: '/order',
	    payment: '/payment',
	    initPayment: '/initialize/payment',
	    savedPayment: '/payment/savedcard',
	    newCard: '/newcard',
	    summary: '/summary',
	    recentOrder: '/summary',
	    reOrder: '/reorder'
	
	  },
	  cards: {
	    base: '/wbu/customer/card',
	    update: '/Initializecardinfo',
	    card: '/card',
	    remove: '/remove',
	    heartlandUpdate: '/card/update',
	    monerisProcess: '/process'
	  },
	  currencyType: {
	    US: 'USD',
	    CA: 'CAD'
	  },
	  discount: {
	    amount: '/discount?discountCode='
	  },
	  countries: {
	    list: '/region/country'
	  },
	  heartland: '/heartland',
	  tsys: '/tsys',
	  moneris: '/moneris',
	  paypal: '/paypal'
	};
	
	var PAYMENT_TYPE = exports.PAYMENT_TYPE = {
	  heartLand: 'HeartLand',
	  worldPay: 'WorldPay',
	  tsys: 'Tsys',
	  moneris: 'Moneris',
	  paypal: 'paypal'
	};
	
	var MONERIS_LOADED = exports.MONERIS_LOADED = {
	  loaded: false,
	  update_page_loaded: false
	};
	
	var USER_ACTION = exports.USER_ACTION = {
	  REORDER: 'REORDER',
	  PROFILE_UPDATE: 'PROFILE_UPDATE',
	  NEW_DSC_MEMBER: 'NEW_DSC_MEMBER',
	  DSC_RENEWAL: 'DSC_RENEWAL',
	  DSC_RETURN: 'DSC_RETURN',
	  STORE_SWITCH: 'STORE_SWITCH',
	  RENEW_DSC_BUTTON: 'RENEW_DSC_BUTTON',
	  GUEST_REGISTERATION: 'GUEST_REGISTERATION',
	  GUEST_OPTING: 'GUEST_OPTING',
	  PAYPAL: 'PAYPAL',
	  PAY_LATER: 'PAY_LATER',
	  VENMO: 'VENMO'
	};
	
	var DISPLAY_IN = exports.DISPLAY_IN = {
	  PRODUCT: 'PRODUCT'
	};
	
	var REMAINDER_TYPE = exports.REMAINDER_TYPE = {
	  OUT_OF_STOCK: 'OUT_OF_STOCK'
	};
	
	var SESSION_STORAGE = exports.SESSION_STORAGE = {
	  OUT_OF_STOCK_REMAINDERS: 'OUT_OF_STOCK_REMAINDERS'
	};
	
	var FEDEX_ERROR_DETAILS = exports.FEDEX_ERROR_DETAILS = {
	  address_errorCodes: [313, 317, 420, 507, 520, 521, 522, 526, 705, 706, 707, 708, 710, 711, 712, 819, 820, 821, 822, 835, 836, 838, 839, 864, 865, 866, 916, 917, 925, 965, 970, 975, 984, 1002, 1003]
	};
	
	var CLOSED_STORE = exports.CLOSED_STORE = {
	  storeCode: '995'
	};
	
	var LIMITATIONS = exports.LIMITATIONS = {
	  noOfItemsAllowed: 40
	};
	
	var TILES_TYPE = exports.TILES_TYPE = {
	  category: 'CATEGORY',
	  subcategory: 'SUBCATEGORY'
	};
	
	exports.default = { ORDER_URL: ORDER_URL, PAYMENT_TYPE: PAYMENT_TYPE, MONERIS_LOADED: MONERIS_LOADED, FEDEX_ERROR_DETAILS: FEDEX_ERROR_DETAILS, USER_ACTION: USER_ACTION, REMAINDER_TYPE: REMAINDER_TYPE, SESSION_STORAGE: SESSION_STORAGE, CLOSED_STORE: CLOSED_STORE, DISPLAY_IN: DISPLAY_IN, LIMITATIONS: LIMITATIONS, TILES_TYPE: TILES_TYPE };

/***/ },
/* 85 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 86 */,
/* 87 */
85,
/* 88 */
85,
/* 89 */
85,
/* 90 */
85,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(103);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _actions = __webpack_require__(104);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _interceptor = __webpack_require__(105);
	
	var _interceptor2 = _interopRequireDefault(_interceptor);
	
	var _service = __webpack_require__(106);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _login = __webpack_require__(107);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _signup = __webpack_require__(114);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _forgotPassword = __webpack_require__(117);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _resetPassword = __webpack_require__(120);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _activate = __webpack_require__(123);
	
	var _activate2 = _interopRequireDefault(_activate);
	
	var _inactive = __webpack_require__(125);
	
	var _inactive2 = _interopRequireDefault(_inactive);
	
	var _otpactive = __webpack_require__(127);
	
	var _otpactive2 = _interopRequireDefault(_otpactive);
	
	var _subscriptionEmail = __webpack_require__(129);
	
	var _subscriptionEmail2 = _interopRequireDefault(_subscriptionEmail);
	
	var _subscriptionModify = __webpack_require__(131);
	
	var _subscriptionModify2 = _interopRequireDefault(_subscriptionModify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.auth', []).config(_router2.default).value('authActions', _actions2.default).factory('authInterceptor', _interceptor2.default).factory('authService', _service2.default).component('login', _login2.default).component('signup', _signup2.default).component('forgotPassword', _forgotPassword2.default).component('resetPassword', _resetPassword2.default).component('activate', _activate2.default).component('inactive', _inactive2.default).component('otpactivate', _otpactive2.default).component('subscriptionEmail', _subscriptionEmail2.default).component('subscriptionModify', _subscriptionModify2.default);

/***/ },
/* 103 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routerConfig;
	routerConfig.$inject = ['$stateProvider'];
	
	function routerConfig($stateProvider) {
	
	  $stateProvider.state({
	    name: 'login',
	    parent: 'app',
	    url: '/login/:storeName',
	    params: {
	      productId: '',
	      categoryId: '',
	      subCategoryId: ''
	    },
	    views: {
	      'content@app': {
	        template: '<login></login>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'login-buyagain',
	    parent: 'app',
	    url: '/buyagain/:storeName',
	    params: {
	      productId: '',
	      categoryId: '',
	      subCategoryId: '',
	      buyAgain: true
	    },
	    views: {
	      'content@app': {
	        template: '<login></login>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'signup',
	    parent: 'app',
	    url: '/signup/:storeName?email',
	    reloadOnSearch: false,
	    views: {
	      'content@app': {
	        template: '<signup></signup>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'auth',
	    parent: 'app',
	    url: '/auth',
	    abstract: true,
	    views: {
	      'header@app': {
	        template: '<auth-header></auth-header>'
	      }
	    }
	  }).state({
	    name: 'tnc',
	    parent: 'auth',
	    url: '/terms-and-conditions',
	    views: {
	      'content@app': {
	        template: '<terms-conditions></terms-conditions>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'rules',
	    parent: 'auth',
	    url: '/rules',
	    views: {
	      'content@app': {
	        template: '<rules-faq></rules-faq>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'cawarn',
	    parent: 'auth',
	    url: '/cawarn',
	    views: {
	      'header@app': {
	        template: '<header></header>'
	      },
	      'sidenav@app': {
	        template: '<sidenav></sidenav>'
	      },
	      'content@app': {
	        template: '<ca-warn></ca-warn>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'birds-critters',
	    parent: 'rules',
	    url: '/birds-and-critters',
	    views: {
	      'content@app': {
	        template: '<birds-critters></birds-critters>'
	      }
	    }
	  }).state({
	    name: 'franchising',
	    parent: 'rules',
	    url: '/franchising',
	    views: {
	      'content@app': {
	        template: '<franchising></franchising>'
	      }
	    }
	  }).state({
	    name: 'product-warranties',
	    parent: 'rules',
	    url: '/product-warranties',
	    views: {
	      'content@app': {
	        template: '<product-warranties></product-warranties>'
	      }
	    }
	  }).state({
	    name: 'forgotPassword',
	    parent: 'auth',
	    url: '/forgot-password',
	    views: {
	      'content@app': {
	        template: '<forgot-password></forgot-password>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'resetPassword',
	    parent: 'auth',
	    url: '/account/password/reset/:storeName/:id/*token',
	    views: {
	      'content@app': {
	        template: '<reset-password></reset-password>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'activate',
	    parent: 'auth',
	    url: '/account/activate/:storeName/:id/*token',
	    views: {
	      'content@app': {
	        template: '<activate></activate>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'inactive',
	    parent: 'auth',
	    url: '/account/inactive',
	    views: {
	      'content@app': {
	        template: '<inactive></inactive>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'otpactivate',
	    parent: 'auth',
	    url: '/account/otpactivate/:storeName/:id',
	    params: {
	      email: null
	    },
	    views: {
	      'content@app': {
	        template: '<otpactivate></otpactivate>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'cancelsubscription',
	    parent: 'auth',
	    url: '/subcription/cancel/:storeName/:token',
	    views: {
	      'content@app': {
	        template: '<subscription-email></subscription-email>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  }).state({
	    name: 'modifysubscription',
	    parent: 'auth',
	    url: '/subcription/modify/:storeName/:token',
	    views: {
	      'content@app': {
	        template: '<subscription-modify></subscription-modify>'
	      }
	    },
	    resolve: {
	      nonLoggedInOnly: ['authService', function (authService) {
	        return authService.nonLoggedInOnly();
	      }]
	    }
	  });
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setStoreDetail = setStoreDetail;
	exports.setUserProfile = setUserProfile;
	exports.setGuestUserProfile = setGuestUserProfile;
	exports.setCountriesInfo = setCountriesInfo;
	exports.setStoresInfo = setStoresInfo;
	exports.setStore = setStore;
	exports.setGuestCart = setGuestCart;
	
	var _actionTypes = __webpack_require__(79);
	
	function setStoreDetail(data) {
	  return {
	    type: _actionTypes.SET_STORE_DETAIL,
	    data: data
	  };
	}
	
	function setUserProfile(data) {
	  return {
	    type: _actionTypes.SET_USER_PROFILE,
	    data: data
	  };
	}
	
	function setGuestUserProfile(data) {
	  return {
	    type: _actionTypes.SET_GUEST_USER_PROFILE,
	    data: data
	  };
	}
	
	function setCountriesInfo(data) {
	  return {
	    type: _actionTypes.SET_COUNTRIES_INFO,
	    data: data
	  };
	}
	
	function setStoresInfo(data) {
	  return {
	    type: _actionTypes.SET_STORES_INFO,
	    data: data
	  };
	}
	
	function setStore(data) {
	  return {
	    type: _actionTypes.SET_STORE,
	    data: data
	  };
	}
	
	function setGuestCart(data) {
	  return {
	    type: _actionTypes.SET_GUEST_CART,
	    data: data
	  };
	}
	
	exports.default = {
	  setStoreDetail: setStoreDetail,
	  setUserProfile: setUserProfile,
	  setGuestUserProfile: setGuestUserProfile,
	  setCountriesInfo: setCountriesInfo,
	  setStoresInfo: setStoresInfo,
	  setGuestCart: setGuestCart,
	  setStore: setStore
	};

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AuthInterceptor;
	AuthInterceptor.$inject = ['$q', '$cookies', '$injector', '$rootScope'];
	
	function AuthInterceptor($q, $cookies, $injector, $rootScope) {
	
	  var service = {
	    request: request,
	    response: response,
	    requestError: requestError,
	    responseError: responseError
	  };
	  return service;
	
	  function request(config) {
	    //  console.log(config);
	    config.headers = config.headers || {};
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      if (config.url.includes('api.taxjar.com')) {
	        config.headers.Authorization = 'Token token=920436a58e41be430c1de5bae3c72c9b';
	      } else if (sessionStorage.getItem('guestoauth') && sessionStorage.getItem('isGuestUserLoggedIn')) {
	        if (config.url.startsWith('/api/v1/customer/cart?isCartPage') || config.url == '/api/v1/customer/isgivexavailable' || config.url == '/api/v1/customer' || config.url.startsWith('/api/v1/customer/order') || config.url == '/api/v1/customer/payment/keys' || config.url == '/api/v1/customer/getgiftcardbalance' || config.url == '/api/v1/customer/orderusinggiftcards' || config.url.startsWith('/api/v1/customer/payment/print') && config.url.indexOf('/logs') !== -1 || config.url.startsWith('/api/v1/customer/order') && config.url.endsWith('/summary') || config.url == '/api/v1/customer/heartland/initialize/payment' || config.url == '/api/v1/customer/tsys/initialize/payment' || config.url == '/api/v1/customer/moneris/payment/process' || config.url == '/api/v1/customer/paypal/createorder' || config.url == '/api/v1/customer/paypal/captureorder' || config.url == '/api/v1/store/features') {
	          config.headers.Authorization = 'OAuth ' + sessionStorage.getItem('guestoauth');
	        }
	      } else if (sessionStorage.getItem('oauth')) {
	        config.headers.Authorization = 'OAuth ' + sessionStorage.getItem('oauth');
	      }
	      if (sessionStorage.getItem('storeId') && sessionStorage.getItem('storeId') != '') {
	        // let guestStore = sessionStorage.getItem('guestStoreName');
	        // if(guestStore && guestStore != '') {
	        //   config.headers.storeCode = '';
	        // }
	        // else {
	        config.headers.storeCode = sessionStorage.getItem('storeId');
	        // }
	      } else {
	        config.headers.storeCode = '';
	      }
	    } catch (e) {
	      if (config.url.includes('api.taxjar.com')) {
	        config.headers.Authorization = 'Token token=920436a58e41be430c1de5bae3c72c9b';
	      } else if ($cookies.get('oauth')) {
	        config.headers.Authorization = 'OAuth ' + $cookies.get('oauth');
	      }
	      config.headers.storeCode = '';
	      if ($cookies.get('storeId') && $cookies.get('storeId') != '') {
	        config.headers.storeCode = $cookies.get('storeId');
	      } else {
	        config.headers.storeCode = '';
	      }
	    }
	    return config;
	  }
	
	  function requestError(rejection) {
	    return $q.reject(rejection);
	  }
	
	  function response(response) {
	    return response;
	  }
	
	  function responseError(rejection) {
	    if (rejection.status === 403) {
	      var $state = $injector.get('$state');
	      var $location = $injector.get('$location');
	      var toaster = $injector.get('toaster');
	      // console.log(toaster);
	      if ($location.path().indexOf('auth') === -1 && $state.current.name !== 'login' && $state.current.name !== 'signup') {
	        sessionStorage.removeItem('oauth');
	        $rootScope.$emit('forbidden');
	
	        /* $state.go('login');
	        toaster.pop('success', 'Your session has expired. Please login again.');*/
	      }
	    }
	    return $q.reject(rejection);
	  }
	}

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = authService;
	authService.$inject = ['$ngRedux', '$http', '$state', '$window', '$timeout', '$cookies', 'authActions', 'APP', '$uibModal', '$stateParams', '$rootScope'];
	
	function authService($ngRedux, $http, $state, $window, $timeout, $cookies, authActions, APP, $uibModal, $stateParams, $rootScope) {
	
	  var service = {
	    nonLoggedInOnly: nonLoggedInOnly,
	    isAuthenticated: isAuthenticated,
	    isMobileOnly: isMobileOnly,
	    getStoreDetail: getStoreDetail,
	    registerLogin: registerLogin,
	    logout: logout,
	    registerUser: registerUser,
	    registerStoreUser: registerStoreUser,
	    verifyCustomerEmail: verifyCustomerEmail,
	    sendEmailToStore: sendEmailToStore,
	    findCustomerInfo: findCustomerInfo,
	    forgotPassword: forgotPassword,
	    resetPassword: resetPassword,
	    changePassword: changePassword,
	    activate: activate,
	    oTPactivate: oTPactivate,
	    activateUser: activateUser,
	    resendEmail: resendEmail,
	    getUserProfile: getUserProfile,
	    getGuestUserProfile: getGuestUserProfile,
	    updateUserProfile: updateUserProfile,
	    isGuestLogin: isGuestLogin,
	    showLoginPopUp: showLoginPopUp,
	    addtoGuestCart: addtoGuestCart,
	    updatetoGuestCart: updatetoGuestCart,
	    removetoGuestCart: removetoGuestCart,
	    getGuestCart: getGuestCart,
	    doGuestLogin: doGuestLogin,
	    doGuestLogout: doGuestLogout,
	    removeGuestCart: removeGuestCart,
	    getGuestStoreDetail: getGuestStoreDetail,
	    isLoggedIn: isLoggedIn,
	    addToSubscriptionCart: addToSubscriptionCart,
	    getSubscribedItems: getSubscribedItems,
	    setSubscribedItems: setSubscribedItems,
	    setSubscribedInfo: setSubscribedInfo,
	    getSubscribedInfo: getSubscribedInfo,
	    resetSubscriptionCart: resetSubscriptionCart,
	    cancelSubscriptionfromEmail: cancelSubscriptionfromEmail,
	    subscriptionmodifyId: subscriptionmodifyId,
	    modifySubscripitonfromEmail: modifySubscripitonfromEmail,
	    getSubscriptionId: getSubscriptionId,
	    saveSubscriptionLocalState: saveSubscriptionLocalState,
	    getSubscriptionLocalState: getSubscriptionLocalState,
	    getCountries: getCountries,
	    isMobileDevice: isMobileDevice,
	    isMobileLandscapeDevice: isMobileLandscapeDevice,
	    isBrowseUrl: isBrowseUrl,
	    getStoresbyZipcode: getStoresbyZipcode,
	    getAllStores: getAllStores,
	    changeStore: changeStore,
	    setAllStores: setAllStores,
	    getDscImage: getDscImage,
	    getFreeShippingFromStore: getFreeShippingFromStore,
	    validatingPoBoxAddress: validatingPoBoxAddress,
	    addGuestUser: addGuestUser,
	    getGuestUser: getGuestUser,
	    removeGuestUser: removeGuestUser,
	    saveGuestUser: saveGuestUser,
	    getGuestUserById: getGuestUserById,
	    createGuestCart: createGuestCart,
	    getStore: getStore,
	    avalaraResolveAddress: avalaraResolveAddress,
	    openPopUpForAddressResolve: openPopUpForAddressResolve,
	    isValidatedAddressSame: isValidatedAddressSame,
	    setAgreedCookie: setAgreedCookie,
	    getPwrKeys: getPwrKeys,
	    getBBDetails: getBBDetails,
	    getStoreByStoreName: getStoreByStoreName,
	    togglePassword: togglePassword,
	    removeRemainderSession: removeRemainderSession,
	    getBaseShippingCharge: getBaseShippingCharge,
	    printCustomerGenericLogs: printCustomerGenericLogs
	  };
	  return service;
	
	  function base() {
	    return APP.AUTH.AUTH_URL;
	  }
	
	  function baseOrderConstants() {
	    return APP.ORDER;
	  }
	
	  function nonLoggedInOnly() {
	    return $timeout(function () {
	      var oauth = null;
	      try {
	        sessionStorage.setItem('dummy', 'value');
	        oauth = sessionStorage.getItem('oauth');
	      } catch (e) {
	        oauth = $cookies.get('oauth');
	      }
	      if (oauth) {
	        $state.go('home');
	      }
	    });
	  }
	  function isLoggedIn() {
	
	    var oauth = null;
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      oauth = sessionStorage.getItem('oauth');
	    } catch (e) {
	      oauth = $cookies.get('oauth');
	    }
	    if (oauth) {
	      return true;
	    }
	    return false;
	  }
	  function isBrowseUrl() {
	    return $timeout(function () {
	      $state.go('browse-sub-category', { 'categoryId': $stateParams.categoryId });
	    }, 200);
	  }
	  function isAuthenticated() {
	    return $timeout(function () {
	      var oauth = null;
	      var browseAsGuest = null;
	
	      try {
	        sessionStorage.setItem('dummy', 'value');
	        oauth = sessionStorage.getItem('oauth');
	        browseAsGuest = sessionStorage.getItem('browseAsGuest');
	      } catch (e) {
	        oauth = $cookies.get('oauth');
	        browseAsGuest = $cookies.get('browseAsGuest');
	      }
	      if (!oauth && !browseAsGuest) {
	
	        //  $state.go('login');
	      }
	    }, 1000);
	  }
	
	  function addtoGuestCart(cart) {
	    if (cart) {
	      try {
	        var cartList = getGuestCart();
	        if (cartList && cartList.length) {
	          var index = cartList.findIndex(function (data) {
	            return data.itemId === cart.itemId;
	          });
	          if (~index) {
	            cartList[index].quantity = cartList[index].quantity + cart.quantity;
	          } else {
	            cartList.push(cart);
	          }
	        } else {
	          cartList = [cart];
	        }
	        $ngRedux.dispatch(authActions.setGuestCart(cartList));
	        sessionStorage.setItem('guestCart', JSON.stringify(cartList));
	        // $cookies.put('guestCart', JSON.stringify(cartList));
	      } catch (e) {
	        $cookies.put('guestCart', JSON.stringify(cart), {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    }
	  }
	  function updatetoGuestCart(cartList) {
	    if (cartList) {
	      try {
	        $ngRedux.dispatch(authActions.setGuestCart(cartList));
	        sessionStorage.setItem('guestCart', JSON.stringify(cartList));
	        // $cookies.put('guestCart', JSON.stringify(cartList));
	      } catch (e) {
	        $cookies.put('guestCart', JSON.stringify(cartList), {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    }
	  }
	  function removetoGuestCart(cartItemId) {
	    if (cartItemId) {
	      var cartList = getGuestCart();
	      try {
	        if (cartList && cartList.length) {
	          cartList = cartList.filter(function (data) {
	            return data.itemId !== cartItemId;
	          });
	        }
	        $ngRedux.dispatch(authActions.setGuestCart(cartList));
	        sessionStorage.setItem('guestCart', JSON.stringify(cartList));
	        // $cookies.put('guestCart', JSON.stringify(cartList));
	      } catch (e) {
	        $cookies.put('guestCart', JSON.stringify(cartList));
	      }
	    }
	  }
	  function getGuestCart() {
	    var guestCartStr = null;
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      guestCartStr = sessionStorage.getItem('guestCart');
	      if (!guestCartStr && !sessionStorage.getItem('guestOrderCheckedOut')) {
	        if (sessionStorage.getItem('storeId') == $cookies.get('storeId')) {
	          guestCartStr = $cookies.get('guestCart');
	        }
	      }
	    } catch (e) {
	
	      guestCartStr = $cookies.get('guestCart');
	    }
	    if (guestCartStr) {
	      $ngRedux.dispatch(authActions.setGuestCart(JSON.parse(guestCartStr)));
	      return JSON.parse(guestCartStr);
	    }
	    return guestCartStr;
	  }
	  function doGuestLogin(store) {
	    try {
	
	      if (sessionStorage.getItem('storeId') != store.storeId) {
	        removeGuestCart();
	      }
	
	      sessionStorage.setItem('browseAsGuest', 'true');
	      sessionStorage.setItem('guestStoreName', store.storeName);
	      sessionStorage.setItem('storeId', store.storeId);
	      // Set Cookies 
	      // $cookies.put('browseAsGuest', 'true');
	      // $cookies.put('guestStoreName', store.storeName);
	      // $cookies.put('storeId', store.storeId);
	    } catch (e) {
	      $cookies.put('browseAsGuest', 'true', {
	        secure: true,
	        samesite: 'lax'
	      });
	      $cookies.put('guestStoreName', store.storeName, {
	        secure: true,
	        samesite: 'lax'
	      });
	      $cookies.put('storeId', store.storeId, {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	    $rootScope.$emit('onGuestLogin');
	  }
	  function removeGuestCart() {
	    try {
	      $ngRedux.dispatch(authActions.setGuestCart([]));
	      sessionStorage.removeItem('guestCart');
	      sessionStorage.removeItem('GuestCartRequest');
	      sessionStorage.removeItem('guestUserDetails');
	      sessionStorage.removeItem('curbSideDetails');
	      sessionStorage.removeItem('discountCoupon');
	      $cookies.remove('guestCart');
	      $cookies.remove('GuestCartRequest');
	    } catch (e) {
	      $cookies.remove('guestCart');
	      $cookies.remove('GuestCartRequest');
	    }
	  }
	  function doGuestLogout() {
	    try {
	      $ngRedux.dispatch(authActions.setGuestCart([]));
	      sessionStorage.removeItem('browseAsGuest');
	      sessionStorage.removeItem('guestStoreName');
	      sessionStorage.removeItem('storeId');
	      sessionStorage.removeItem('guestoauth');
	      sessionStorage.removeItem('isGuestUserLoggedIn');
	      $cookies.remove('browseAsGuest');
	      $cookies.remove('guestStoreName');
	      $cookies.remove('storeId');
	      removeGuestUser();
	      removeRemainderSession();
	    } catch (e) {
	      $cookies.remove('browseAsGuest');
	      $cookies.remove('guestStoreName');
	      $cookies.remove('storeId');
	      removeGuestUser();
	      removeRemainderSession();
	    }
	  }
	  function isGuestLogin() {
	    var isGuest = false;
	    if (this.isLoggedIn()) {
	      this.doGuestLogout();
	      return false;
	    }
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      isGuest = sessionStorage.getItem('browseAsGuest');
	    } catch (e) {
	      isGuest = $cookies.get('browseAsGuest');
	    }
	
	    return isGuest === 'true';
	  }
	  function getGuestStoreDetail() {
	    var guestStore = { 'storeName': null, 'storeId': null };
	    try {
	      guestStore.storeName = sessionStorage.getItem('guestStoreName');
	      guestStore.storeId = sessionStorage.getItem('storeId');
	      // if (!guestStore.storeName && !guestStore.storeId) {
	      //   guestStore.storeName = $cookies.get('guestStoreName');
	      //   guestStore.storeId = $cookies.get('storeId');
	      // }
	    } catch (e) {
	      guestStore.storeName = $cookies.get('guestStoreName');
	      guestStore.storeId = $cookies.get('storeId');
	    }
	    return guestStore;
	  }
	  function addGuestUser(userId, clientIP) {
	    if (userId) {
	      try {
	        sessionStorage.setItem('guestUserId', userId);
	        sessionStorage.setItem('guestClientIP', clientIP);
	      } catch (e) {
	        // No code here
	      }
	    }
	  }
	  function getGuestUser() {
	    try {
	      return {
	        guestUserId: sessionStorage.getItem('guestUserId'),
	        guestClientIP: sessionStorage.getItem('guestClientIP')
	      };
	    } catch (e) {
	      return {};
	    }
	  }
	  function removeGuestUser() {
	    sessionStorage.removeItem('guestUserId');
	    sessionStorage.removeItem('guestClientIP');
	    sessionStorage.removeItem('guestUserDetails');
	    sessionStorage.removeItem('curbSideDetails');
	  }
	  function isMobileOnly() {
	    return $timeout(function () {
	      if ($window.innerWidth > 543) {
	        $state.go('category', { 'storeName': getGuestStoreDetail().storeName });
	      }
	    });
	  }
	
	  function getStoreDetail(storeName) {
	    console.log("$stateParams : ", $stateParams);
	    if (storeName) {
	      return $http.get('' + base().root + base().storeLoc + '/' + storeName).success(function (success) {
	        if (success) {
	          try {
	            var storeDetailsForInteractionStudio = {
	              "store": {
	                'storeCode': success.storeCode,
	                'storeName': success.storeUrlName
	              }
	            };
	            console.log("Sending store info to Interaction studio from scope : ", storeDetailsForInteractionStudio);
	            $window.dataLayer = $window.dataLayer || [];
	            for (var i = 0; i < $window.dataLayer.length; i++) {
	              if ($window.dataLayer[i] && $window.dataLayer[i].store) {
	                $window.dataLayer.splice(i, 1);
	              }
	            }
	            $window.dataLayer.push(storeDetailsForInteractionStudio);
	            console.log("$window : ", $window);
	          } catch (e) {
	            console.log("Error at header : ", e);
	          }
	        }
	        $ngRedux.dispatch(authActions.setStoreDetail(success));
	      });
	    } else if ($rootScope.storeDetailForInteractionStudio) {
	      console.log("Sending store info to Interaction studio from rscope : ", $rootScope.storeDetailForInteractionStudio);
	      $window.dataLayer = $window.dataLayer || [];
	      for (var i = 0; i < $window.dataLayer.length; i++) {
	        if ($window.dataLayer[i] && $window.dataLayer[i].store) {
	          $window.dataLayer.splice(i, 1);
	        }
	      }
	      $window.dataLayer.push($rootScope.storeDetailForInteractionStudio);
	      console.log("$window : ", $window);
	    }
	    return null;
	  }
	
	  function getStore() {
	    return $http.get(base().root + '/store').success(function (success) {
	      return $ngRedux.dispatch(authActions.setStore(success));
	    });
	  }
	
	  function getStoreByStoreName(storeUrlName) {
	    return $http.get(base().root + '/franchise/store/' + storeUrlName);
	  }
	
	  function registerLogin(data) {
	    return $http.post(base().root + base().login, data).success(function (success) {
	      try {
	        sessionStorage.setItem('oauth', success.accessToken);
	      } catch (e) {
	        $cookies.put('oauth', success.accessToken, {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    });
	  }
	
	  function logout(profile) {
	    var _this = this;
	
	    var storeName = profile.store.storeURLName;
	
	    // var logoutObj = {"isEmailUpdate" : profile.emailUpdated };
	
	
	    return $http.post(base().root + base().logout + '?isEmailUpdate=' + profile.emailUpdated).finally(function () {
	      doGuestLogout();
	      resetSubscriptionCart();
	      removeRemainderSession();
	      try {
	        sessionStorage.setItem('dummy', 'value');
	        sessionStorage.removeItem('oauth');
	        sessionStorage.removeItem('addressChangeOption');
	        sessionStorage.removeItem('subscriptionLocalState');
	        sessionStorage.removeItem('discountCoupon');
	        sessionStorage.removeItem('birdbuckCoupon');
	        sessionStorage.removeItem('erplyBBDiscount');
	        sessionStorage.removeItem('erplyPromotionDiscount');
	        sessionStorage.removeItem('guestCart');
	        sessionStorage.removeItem('orderNotesSession');
	        sessionStorage.removeItem('guestoauth');
	        sessionStorage.removeItem('isGuestUserLoggedIn');
	        sessionStorage.setItem('activationId', profile.connectionId);
	        sessionStorage.setItem('userEmail', profile.email);
	        sessionStorage.setItem('isEmailUpdated', profile.emailUpdated);
	
	        // Remove data in cookies
	        $cookies.remove('oauth');
	        $cookies.remove('addressChangeOption');
	        $cookies.remove('subscriptionLocalState');
	        $cookies.remove('discountCoupon');
	        $cookies.remove('birdbuckCoupon');
	        $cookies.remove('guestCart');
	        $cookies.remove('activationId');
	        $cookies.remove('userEmail');
	        $cookies.remove('erplyBBDiscount');
	        $cookies.remove('erplyPromotionDiscount');
	        $cookies.remove('orderNotesSession');
	
	        _this.activationId = _this.profile.connectionId;
	        _this.email = _this.profile.email;
	      } catch (e) {
	        $cookies.remove('oauth');
	        $cookies.remove('addressChangeOption');
	        $cookies.remove('subscriptionLocalState');
	        $cookies.remove('discountCoupon');
	        $cookies.remove('birdbuckCoupon');
	        $cookies.remove('guestCart');
	        $cookies.remove('activationId');
	        $cookies.remove('userEmail');
	        $cookies.remove('erplyBBDiscount');
	        $cookies.remove('erplyPromotionDiscount');
	        $cookies.remove('orderNotesSession');
	        $cookies.remove('guestoauth');
	        $cookies.remove('isGuestUserLoggedIn');
	      }
	      if (profile.emailUpdated) {
	        $state.go('signup', {
	          storeName: profile.store.storeName
	        });
	      } else {
	        $window.location.href = '/' + storeName;
	      }
	      // $state.go('login');
	    });
	  }
	
	  function registerUser(data, isRegisteringFromGuest) {
	    return $http.post(base().root + '?isRegisteringFromGuest=' + isRegisteringFromGuest, data);
	  }
	
	  function registerStoreUser(data) {
	    return $http.post(base().storeCustomer, data);
	  }
	
	  function sendEmailToStore(isCustomerMapped, data) {
	    return $http.post(base().root + '/' + isCustomerMapped + '/verify/mail/sendmailtostore', data);
	  }
	
	  function verifyCustomerEmail(data) {
	    return $http.post(base().verify, data);
	  }
	
	  function findCustomerInfo(data) {
	    return $http.post(base().findCustomer + '?pageFrom=user', data);
	  }
	
	  function forgotPassword(data) {
	    return $http.post(base().root + '/password/reset?email=' + data.email);
	  }
	
	  function resetPassword(data) {
	    var password = data.password;
	    return $http.post(base().root + '/' + data.id + '/password/reset?p1=' + data.token, { password: password });
	  }
	
	  function changePassword(data) {
	    return $http.post(base().root + '/password/change', data);
	  }
	
	  function activate(data) {
	    return $http.post(base().root + '/' + data.id + '/verify?p1=' + data.token);
	  }
	
	  function oTPactivate(data) {
	    return $http.post(base().root + '/' + data.id + '/verifyotp?otp=' + data.otp);
	  }
	
	  function activateUser(email) {
	    return $http.post(base().root + '/verify/mail/resend?email=' + email);
	  }
	
	  function resendEmail(data) {
	    return $http.post(base().root + '/' + data.id + '/verify/mail/resend?email=' + data.email);
	  }
	
	  function getUserProfile() {
	    return $http.get(base().root).success(function (success) {
	      $rootScope.storeDetailForInteractionStudio = {
	        "store": {
	          "storeCode": success.customer.store.storeCode,
	          "storeName": success.customer.store.storeURLName
	        }
	      };
	      $ngRedux.dispatch(authActions.setUserProfile(success));
	    });
	  }
	
	  function getGuestUserProfile() {
	    return $http.get(base().root).success(function (success) {
	      return $ngRedux.dispatch(authActions.setGuestUserProfile(success));
	    });
	  }
	
	  function updateUserProfile(data, id) {
	    return $http.put(base().root + '/' + id, data).then(function (success) {
	      return $ngRedux.dispatch(authActions.setUserProfile(success.data));
	    });
	  }
	
	  function saveGuestUser(data) {
	    return $http.post('/guest' + base().root + '/', data);
	  }
	
	  function getGuestUserById(userId) {
	    return $http.get('/guest' + base().root + '/' + userId).then(function (success) {
	      return $ngRedux.dispatch(authActions.setUserProfile(success.data));
	    });
	  }
	
	  function createGuestCart(data) {
	    return $http.post('/guest' + base().root + '/cart/create/', data);
	  }
	
	  function showLoginPopUp(msg) {
	    $uibModal.open({
	      size: 'sm',
	      template: '<div class="modal-body p-1-1 login_redirect_modal" id="modal-body" >You have to login/register to ' + msg + '<hr>' + '<h6><b><center>Do you want to continue?</center></b></h6>' + '</div>' + '<div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()" >Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" ">OK</button>' + '</div>',
	      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', function ($rootScope, $scope, $uibModalInstance, $auth) {
	        $scope.ok = function () {
	          // console.log('ok guestLoginConfirmed');
	          $rootScope.$emit('guestLoginConfirmed');
	          $uibModalInstance.close();
	        };
	        $scope.cancel = function () {
	          // $auth.removeGuestCart();
	          $uibModalInstance.close();
	        };
	      }]
	
	    });
	  }
	  function resetSubscriptionCart() {
	
	    try {
	      sessionStorage.removeItem('subscribedItems');
	      sessionStorage.removeItem('subscribedInfo');
	      sessionStorage.removeItem('subscriptionLocalState');
	      localStorage.removeItem('deliveryAddress');
	
	      // Remove Cookies
	      $cookies.remove('subscribedItems');
	      $cookies.remove('subscribedInfo');
	      $cookies.remove('subscriptionLocalState');
	    } catch (e) {
	      $cookies.remove('subscribedItems');
	      $cookies.remove('subscribedInfo');
	      $cookies.remove('subscriptionLocalState');
	      localStorage.removeItem('deliveryAddress');
	    }
	  }
	  function addToSubscriptionCart(cartItem, quantity) {
	
	    var subscribedItems = this.getSubscribedItems();
	
	    if (subscribedItems.length > 0) {
	      // check for if product is already in subscribed list
	      var existingItems = subscribedItems.filter(function (item) {
	        return item.item.id === parseInt(cartItem.id);
	      });
	      if (existingItems.length > 0) {
	        existingItems[0].quantity += quantity;
	      } else {
	
	        var newItem = { 'item': cartItem, 'quantity': quantity };
	        subscribedItems.push(newItem);
	      }
	    } else {
	      newItem = { 'item': cartItem, 'quantity': quantity };
	      subscribedItems.push(newItem);
	    }
	    var subscribedItemsString = JSON.stringify(subscribedItems);
	    try {
	      sessionStorage.setItem('subscribedItems', subscribedItemsString);
	    } catch (e) {
	      $cookies.put('subscribedItems', subscribedItemsString, {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	  }
	  function setSubscribedItems(subscribedItems) {
	    var subscribedItemsString = JSON.stringify(subscribedItems);
	    try {
	      sessionStorage.setItem('subscribedItems', subscribedItemsString);
	    } catch (e) {
	      $cookies.put('subscribedItems', subscribedItemsString, {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	  }
	  function getSubscribedItems() {
	    var subscribedItems = [];
	    var subscribedItemsString = '[]';
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      subscribedItemsString = sessionStorage.getItem('subscribedItems');
	    } catch (e) {
	      subscribedItemsString = $cookies.get('subscribedItems');
	    }
	
	    subscribedItems = JSON.parse(subscribedItemsString);
	
	    return subscribedItems ? subscribedItems : [];
	  }
	  function setSubscribedInfo(info) {
	
	    var subscribeInfoString = JSON.stringify(info);
	    try {
	      sessionStorage.setItem('subscribedInfo', subscribeInfoString);
	    } catch (e) {
	      $cookies.put('subscribedInfo', subscribeInfoString, {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	  }
	  function getSubscribedInfo() {
	    var subscribedInfo = '';
	    var subscribedInfoString = '';
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      subscribedInfoString = sessionStorage.getItem('subscribedInfo');
	    } catch (e) {
	      subscribedInfoString = $cookies.get('subscribedInfo');
	    }
	
	    subscribedInfo = JSON.parse(subscribedInfoString);
	
	    return subscribedInfo;
	  }
	
	  function cancelSubscriptionfromEmail(data) {
	    return $http.post('/api/v1/customer/email/subscription/cancel?requestString=' + data.token);
	  }
	
	  function modifySubscripitonfromEmail(data) {
	    return $http.post('/api/v1/customer/email/subscription/modifycheck?requestString=' + data.token);
	  }
	  function subscriptionmodifyId(data) {
	
	    try {
	      sessionStorage.setItem('subscriptionmodifyId', JSON.stringify(data));
	    } catch (e) {
	      $cookies.put('subscriptionmodifyId', JSON.stringify(data), {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	  }
	
	  function getSubscriptionId() {
	    var subscriptionmodifyId = null;
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      subscriptionmodifyId = sessionStorage.getItem('subscriptionmodifyId');
	    } catch (e) {
	
	      subscriptionmodifyId = $cookies.get('subscriptionmodifyId');
	    }
	    if (subscriptionmodifyId) {
	      return JSON.parse(subscriptionmodifyId);
	    }
	    return subscriptionmodifyId;
	  }
	  function getSubscriptionLocalState() {
	    var subscriptionLocalState = null;
	    try {
	      sessionStorage.setItem('dummy', 'value');
	      subscriptionLocalState = sessionStorage.getItem('subscriptionLocalState');
	    } catch (e) {
	
	      subscriptionLocalState = $cookies.get('subscriptionLocalState');
	    }
	    if (subscriptionLocalState) {
	      return JSON.parse(subscriptionLocalState);
	    }
	    return subscriptionLocalState;
	  }
	  function saveSubscriptionLocalState(localState) {
	    try {
	      sessionStorage.setItem('subscriptionLocalState', JSON.stringify(localState));
	    } catch (e) {
	      $cookies.put('subscriptionLocalState', JSON.stringify(localState), {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	  }
	  function getCountries() {
	    return $http.get(base().root + base().countries.list).then(function (success) {
	      return $ngRedux.dispatch(authActions.setCountriesInfo(success.data));
	    });
	  }
	  function isMobileDevice() {
	    // return ( $window.innerWidth < 752 && $window.innerHeight < 752 );
	    return $window.innerWidth < 752;
	  }
	
	  function isMobileLandscapeDevice() {
	    return $window.innerWidth < 1000;
	  }
	
	  function getStoresbyZipcode(data) {
	    return $http.post('/api/v1/customer/storelocator/getnearbystores', data);
	  }
	
	  function getAllStores() {
	    return $http.get(base().root + base().store.list);
	    // .then(success => $ngRedux.dispatch(authActions.setStoresInfo(success.data)));
	  }
	
	  function setAllStores() {
	    return $http.get(base().root + base().store.list).then(function (success) {
	      return $ngRedux.dispatch(authActions.setStoresInfo(success.data));
	    });
	  }
	
	  function changeStore(data) {
	    return $http.post(base().root + base().store.change, data).success(function (success) {
	      try {
	        sessionStorage.setItem('oauth', success.accessToken);
	        sessionStorage.removeItem('discountCoupon');
	        sessionStorage.removeItem('birdbuckCoupon');
	        sessionStorage.removeItem('erplyBBDiscount');
	        sessionStorage.removeItem('erplyBBCouponCodes');
	        sessionStorage.removeItem('erplyPromotionCodes');
	        sessionStorage.removeItem('erplyPromotionDiscount');
	        sessionStorage.removeItem('orderNotesSession');
	      } catch (e) {
	        $cookies.put('oauth', success.accessToken, {
	          secure: true,
	          samesite: 'lax'
	        });
	        $cookies.remove('discountCoupon');
	        $cookies.remove('birdbuckCoupon');
	        $cookies.remove('erplyBBDiscount');
	        $cookies.remove('erplyBBCouponCodes');
	        $cookies.remove('erplyPromotionCodes');
	        $cookies.remove('erplyPromotionDiscount');
	        $cookies.remove('orderNotesSession');
	      }
	    });
	  }
	
	  function getDscImage() {
	    return $http.get(base().root + '/getdscimage');
	  }
	
	  function getFreeShippingFromStore(storeName) {
	    return $http.get(base().root + '/store/freeshipping/' + storeName);
	  }
	
	  function validatingPoBoxAddress(postboxaddress, shippingaddress) {
	    if (!postboxaddress) {
	      if (shippingaddress.match(/(([p]{1}[\.\s]?o{1}[\.\s]?)|(post)|(postoffice)|(post office))[\s]*?(box)/gim)) {
	        $uibModal.open({
	          size: 'md',
	          template: '<div class="modal-header modalheaderbg btn-primary"><h5>PO Box Restriction</h5></div>' + '<div class="modal-body" id="modal-body">' +
	          // '<span ng-bind-html="'+detailed+'" > </span>'+
	          'Sorry, we do not deliver to PO boxes at this time.  Please provide an alternate address.' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	          controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	
	            $scope.ok = function () {
	              $uibModalInstance.close();
	            };
	          }]
	        });
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function avalaraResolveAddress(userDetail, store) {
	    userDetail.store = store;
	    return $http.post(base().tax.validate, userDetail);
	  }
	
	  function openPopUpForAddressResolve(userDetail, success, callback) {
	    console.log("Is this getting called");
	    this.userDetail = userDetail;
	    this.success = success;
	    var $ctrl = this;
	    if ($ctrl.userDetail.store.validateAddressType === 'NOT_VALIDATE' || isValidatedAddressSame(userDetail, success)) {
	      callback(userDetail);
	    } else {
	      var modalInstance = $uibModal.open({
	        backdrop: 'static',
	        keyboard: false,
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5 ng-if="hasValidatedAddress">We found a validated address</h5><h5 ng-if="!hasValidatedAddress">We could not find the address you entered</h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' + '<div class="row">' + '<div class="col-md-4"></div>\n                <div class="col-md-6">\n                  <div class="col-md-12 mb-4">\n                    <h6><strong>Entered Address</strong></h6>\n                  </div>\n    \n                  <div class="col-md-12 mb-4">\n                    {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : \'\')}}\n                  </div>\n    \n                  \n                  <div class="col-md-12 mb-4">\n                    {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : \'\')}}\n                  </div>\n    \n                  \n                  <div class="col-md-12 mb-4" >\n                    {{(user.shippingCity ? user.shippingCity.trim() : \'\')}},{{(user.shippingState ? user.shippingState.code : \'\')}}\n                  </div>\n    \n    \n                  <div class="col-md-12 mb-4">\n                    {{(user.shippingZipCode ? user.shippingZipCode.trim() : \'\')}}\n                  </div>\n                </div>\n          </div>' + '<div  class="row" ng-if="isValidAddress && selected.addressLine1.trim()!=null && selected.addressLine1.trim()!=\'\'">\n              <hr>\n              <div class="col-md-4"></div>\n              <div class="col-md-6">\n              \n              <div class="col-md-12 mb-4" >\n                <h6><strong>Validated Address</strong></h6>\n              </div>\n      \n              <div class="col-md-12 mb-4" >\n                {{(selected.addressLine1 ? selected.addressLine1.trim() : \'\')}}\n              </div>\n      \n              <div class="col-md-12 mb-4" >\n                {{(selected.addressLine2 ? selected.addressLine2.trim() : \'\')}}\n              </div>\n      \n\n              <div class="col-md-12 mb-4" >\n                {{(selected.city ? selected.city.trim() : \'\')}}, {{(selected.state ? selected.state.code : \'\')}}\n              </div>\n      \n\n              <div class="col-md-12 mb-4" >\n                {{(selected.zip ? selected.zip.trim() : \'\')}}\n              </div>\n              </div>\n          </div>\n  \n          <div class="col-md-12" ng-if="!hasValidatedAddress">\n          <hr>\n          <div class="col-md-5">\n            <label style="color: #b58150;font-weight: bold;">Entered Address not Validated with our records</label>\n          </div>\n          <div class="col-md-7">\n            {{summary}}\n          </div>\n          </div>\n          ' + '</div>' + '</div>' + '<div class="modal-footer">' + '<button  ng-if="!hasValidatedAddress" class="btn col-md-5" type="button m-l-1" type="button" ng-click="fix()" style="float: left;width: 45%;">I will fix the address</button>' + '<button  ng-if="isValidAddress && hasValidatedAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;width: 45%;">Use the Validated Address</button>' + '<button  ng-if="!hasValidatedAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: right;width: 45%;">Use the Entered Address</button>' + '<button  ng-if="hasValidatedAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;width: 45%;">Use the Entered Address</button>' + '</div>',
	        controller: ['$scope', '$state', '$uibModalInstance', function ($scope, $state, $uibModalInstance) {
	          $scope.error = { message: '' };
	          $scope.user = JSON.parse(JSON.stringify($ctrl.userDetail));
	          $scope.isValidAddress = false;
	          $scope.hasValidatedAddress = false;
	          $scope.count = 1;
	          if ($ctrl.userDetail.store.validateAddressType === 'BOTH_BILL_SHIP') {
	            $scope.count = 2;
	          }
	          if ($ctrl.success.data.resolutionQuality != null) {
	            if ($ctrl.success.data.resolutionQuality === 'Intersection' || $ctrl.success.data.resolutionQuality === 'External') {
	              $scope.isValidAddress = true;
	              $scope.hasValidatedAddress = success.data.isAddressValidated;
	              if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
	                $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
	                if (!success.data.isAddressValidated && $scope.selected.summary != '') {
	                  $scope.invalidDetails = $scope.selected.details;
	                  $scope.summary = $scope.selected.summary;
	                }
	              } else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
	                $scope.selected = $ctrl.success.data.billingAddresstoResolve;
	                if (!success.data.isAddressValidated && $scope.selected.summary != '') {
	                  $scope.invalidDetails = $scope.selected.details;
	                  $scope.summary = $scope.selected.summary;
	                }
	              }
	            } else {
	              $scope.hasValidatedAddress = success.data.isAddressValidated;
	              if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
	                if ($ctrl.success.data.shippingAddresstoResolve.details != null) {
	                  $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
	                  $scope.summary = $ctrl.success.data.shippingAddresstoResolve.summary;
	                } else {
	                  $scope.invalidDetails = "";
	                  $scope.summary = "We haven't find the exact match for given original address";
	                }
	              } else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
	                if ($ctrl.success.data.billingAddresstoResolve.details != null) {
	                  $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
	                  $scope.summary = $ctrl.success.data.billingAddresstoResolve.summary;
	                } else {
	                  $scope.invalidDetails = "";
	                  $scope.summary = "We haven't find the exact match for given original address";
	                }
	              }
	            }
	          } else {
	            $scope.hasValidatedAddress = success.data.isAddressValidated;
	            $scope.summary = "We haven't find the exact match for given original address";
	          }
	
	          $scope.submit = function () {
	            // $ctrl.$spinner.show('appSpinner');
	            console.log("It calls from submit");
	            // $scope.user.isCanceled = false;
	            $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	            $scope.user.shippingAddressLine1 = $scope.selected.addressLine1;
	            // $scope.user.shippingAddressLine2 = $scope.selected.addressLine1;
	            if ($scope.selected.addressLine2 != '') {
	              $scope.user.shippingAddressLine2 = $scope.selected.addressLine2;
	            }
	            $scope.user.shippingCity = $scope.selected.city;
	            $scope.user.shippingState.code = $scope.selected.state.code;
	            // $scope.user.shippingCountry.code = $scope.selected.country.code;
	            $scope.user.shippingZipCode = $scope.selected.zip;
	            $uibModalInstance.close($scope.user);
	          };
	          // $scope.cancel = () => $uibModalInstance.dismiss('cancel');
	          $scope.back = function () {
	            // $scope.user.isCanceled = false;
	            $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	            $uibModalInstance.close($scope.user);
	          };
	          $scope.fix = function () {
	            console.log("In fixing ");
	            $scope.user.isCanceled = true;
	            $uibModalInstance.close($scope.user);
	          };
	        }],
	        resolve: {}
	      });
	      modalInstance.result.then(function (data) {
	        console.log('user clicked ok', data);
	        callback(data);
	        // return data;
	      });
	    }
	  }
	
	  function isValidatedAddressSame(userDetail, success) {
	    if (!success.data.isAddressValidated) {
	      return false;
	    }
	    if (success.data.resolutionQuality != null) {
	      if (success.data.resolutionQuality === 'Intersection' || success.data.resolutionQuality === 'External') {
	        if (userDetail.store.validateAddressType === 'NOT_VALIDATE') {
	          return true;
	        }
	        if (userDetail.store.validateAddressType === 'Shipping') {
	          if (userDetail.shippingAddressLine1 === success.data.shippingAddresstoResolve.addressLine1 && userDetail.shippingAddressLine2 === success.data.shippingAddresstoResolve.addressLine2 && userDetail.shippingCity === success.data.shippingAddresstoResolve.city && userDetail.shippingCountry.countryCode === success.data.shippingAddresstoResolve.country.countryCode && userDetail.shippingState.code === success.data.shippingAddresstoResolve.state.code && userDetail.shippingZipCode === success.data.shippingAddresstoResolve.zip) {
	            return true;
	          } else {
	            return false;
	          }
	        } else if (userDetail.store.validateAddressType === 'Billing') {
	          if (userDetail.billingAddressLine1 === success.data.billingAddresstoResolve.addressLine1 && userDetail.billingAddressLine2 === success.data.billingAddresstoResolve.addressLine2 && userDetail.billingCity === success.data.billingAddresstoResolve.city && userDetail.billingCountry.countryCode === success.data.billingAddresstoResolve.country.countryCode && userDetail.billingState.code === success.data.billingAddresstoResolve.state.code && userDetail.billingZipCode === success.data.billingAddresstoResolve.zip) {
	            return true;
	          } else {
	            return false;
	          }
	        } else if (userDetail.store.validateAddressType === 'BOTH_BILL_SHIP') {
	          var counter = 0;
	          if (userDetail.billingAddressLine1 === success.data.billingAddresstoResolve.addressLine1 && userDetail.billingAddressLine2 === success.data.billingAddresstoResolve.addressLine2 && userDetail.billingCity === success.data.billingAddresstoResolve.city && userDetail.billingCountry.countryCode === success.data.billingAddresstoResolve.country.countryCode && userDetail.billingState.code === success.data.billingAddresstoResolve.state.code && userDetail.billingZipCode === success.data.billingAddresstoResolve.zip) {
	            counter = counter + 1;
	          }
	          if (userDetail.shippingAddressLine1 === success.data.shippingAddresstoResolve.addressLine1 && userDetail.shippingAddressLine2 === success.data.shippingAddresstoResolve.addressLine2 && userDetail.shippingCity === success.data.shippingAddresstoResolve.city && userDetail.shippingCountry.countryCode === success.data.shippingAddresstoResolve.country.countryCode && userDetail.shippingState.code === success.data.shippingAddresstoResolve.state.code && userDetail.shippingZipCode === success.data.shippingAddresstoResolve.zip) {
	            counter = counter + 1;
	          }
	          if (counter == 2) {
	            return true;
	          } else {
	            return false;
	          }
	        } else {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    }
	    return false;
	  }
	
	  function setAgreedCookie() {
	    try {
	      var now = new Date();
	      var time = now.getTime();
	      var expireTime = time + 1000 * 3600 * 24 * 31;
	      now.setTime(expireTime);
	      console.log("Cookie expiry time : ", now.toUTCString());
	      $cookies.put('moove_gdpr_popup_mywbu', true, {
	        'expires': now.toUTCString(),
	        secure: true,
	        samesite: 'lax'
	      });
	    } catch (e) {
	      $cookies.put('moove_gdpr_popup_mywbu', true, {
	        secure: true,
	        samesite: 'lax'
	      });
	    }
	  }
	
	  function getPwrKeys() {
	    return $http.get(base().baseRoot + '/pwr/keys').success(function (success) {
	      // console.log("App1 : ",APP.AUTH.AUTH_URL.pwr);
	      // console.log("success pwr keys : ",success);
	      APP.AUTH.AUTH_URL.pwr.api_key = success.pwr_api_key;
	      APP.AUTH.AUTH_URL.pwr.locale = success.pwr_locale;
	      APP.AUTH.AUTH_URL.pwr.merchant_group_id = success.pwr_merchant_group_id;
	      APP.AUTH.AUTH_URL.pwr.merchant_id = success.pwr_merchant_id;
	      // console.log("App2 : ",APP.AUTH.AUTH_URL.pwr);
	    });
	  }
	
	  function getBBDetails() {
	    return $http.get(base().baseRoot + '/customer/birdbucks/bb-details');
	  }
	
	  function togglePassword(passwordIdTag, togglei) {
	    var x = document.getElementById(passwordIdTag);
	    var y = document.getElementById(togglei);
	    console.log("Password tag ", x);
	    if (x.type === "password") {
	      x.type = "text";
	      y.classList.remove('fa-eye-slash');
	      y.classList.add('fa-eye');
	    } else {
	      x.type = "password";
	      y.classList.remove('fa-eye');
	      y.classList.add('fa-eye-slash');
	    }
	  }
	
	  function removeRemainderSession() {
	    try {
	      sessionStorage.removeItem(baseOrderConstants().SESSION_STORAGE.OUT_OF_STOCK_REMAINDERS);
	      // $cookies.remove(baseOrderConstants().SESSION_STORAGE.OUT_OF_STOCK_REMAINDERS);
	    } catch (e) {
	      // $cookies.remove(baseOrderConstants().SESSION_STORAGE.OUT_OF_STOCK_REMAINDERS);
	    }
	  }
	
	  function getBaseShippingCharge() {
	    return $http.get('/api/v1/customer/shipping/base/charge');
	  }
	
	  function printCustomerGenericLogs(dataValue) {
	
	    var stringData = {};
	    stringData.config = {};
	    if (dataValue && dataValue.config) {
	      stringData.config.data = JSON.stringify(dataValue.config.data);
	      stringData.config.headers = JSON.stringify(dataValue.config.headers);
	      stringData.config.method = JSON.stringify(dataValue.config.method);
	      stringData.config.url = JSON.stringify(dataValue.config.url);
	    }
	    if (dataValue && dataValue.data) {
	      stringData.data = {};
	      stringData.data.diagnostic = JSON.stringify(dataValue.data.diagnostic);
	      stringData.data.message = JSON.stringify(dataValue.data.message);
	      stringData.data.httpCode = JSON.stringify(dataValue.data.httpCode);
	    }
	    return $http.post('/api/v1/customer/print/logs', stringData);
	  }
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _bannerImage = __webpack_require__(108);
	
	var _bannerImage2 = _interopRequireDefault(_bannerImage);
	
	var _bannerImageDesktop = __webpack_require__(109);
	
	var _bannerImageDesktop2 = _interopRequireDefault(_bannerImageDesktop);
	
	var _logoS = __webpack_require__(110);
	
	var _logoS2 = _interopRequireDefault(_logoS);
	
	var _logo = __webpack_require__(111);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _login = __webpack_require__(112);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _question = __webpack_require__(113);
	
	var _question2 = _interopRequireDefault(_question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'login',
	  template: _login2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function LoginContainer($scope, $ngRedux, $state, $stateParams, $cookies, $spinner, authService, $toaster, $window, $order, $rootScope) {
	    _classCallCheck(this, LoginContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$cookies = $cookies;
	    this.$state = $state;
	    this.toaster = $toaster;
	    this.storeName = $stateParams.storeName;
	    this.authService = authService;
	    this.subHeaderImg = _bannerImage2.default;
	    this.subHeaderImgDesktop = _bannerImageDesktop2.default;
	    this.logo = _logoS2.default;
	    this.logoOutline = _logo2.default;
	    this.$window = $window;
	    this.info = _question2.default;
	    this.$spinner = $spinner;
	    this.$rootScope = $rootScope;
	    this.$stateParams = $stateParams;
	    this.isForBuyAgain = $stateParams.buyAgain;
	
	    this.$order = $order;
	    if ($stateParams.storeName) {
	      this.$spinner.show('appSpinner');
	      authService.getStoreDetail($stateParams.storeName).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    }
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(LoginContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        store: state.auth.storeDetail
	      };
	    }
	  }, {
	    key: 'isScreenSmall',
	    value: function isScreenSmall() {
	      if (this.$window.innerHeight < 300) return true;
	    }
	  }, {
	    key: 'submit1',
	    value: function submit1(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      form.error = {};
	      // if (this.email === 'test@gmail.com' && this.password === 'password') {
	      //   try {
	      //     sessionStorage.setItem('oauth', 'qwertyuiop');
	      //   }
	      //   catch (e) {
	      //     this.$cookies.put('oauth', 'qwertyuiop');
	      //   }
	      //   this.$state.go('home');
	      // }
	      this.authService.registerLogin({
	        email: this.email,
	        password: this.password
	      }).then(function (success) {
	        //  console.log('success', success);
	        var profile = success.data.user;
	        //  console.log('profile', profile);
	        var guestCart = _this.authService.getGuestCart();
	        var subscription = _this.authService.getSubscriptionId();
	        if (!profile.shippingAddressLine1 || !profile.shippingState || !profile.shippingCity || !profile.shippingZipCode || !profile.shippingCountry || !profile.billingCountry || !profile.billingAddressLine1 || !profile.billingState || !profile.billingCity || !profile.billingZipCode) {
	          _this.authService.doGuestLogout();
	          _this.toaster.pop('success', 'You need to complete your Profile');
	          _this.$state.go('profile.edit');
	        } else if (subscription) {
	          _this.authService.resetSubscriptionCart();
	          _this.$state.go('subscription-detail', { subscriptionId: subscription.id, option: 'edit' });
	        } else {
	          // if(this.authService.getGuestStoreDetail().storeId != profile.store.storeId) {
	          //   this.authService.doGuestLogout();
	          //   this.authService.removeGuestCart();
	          //   this.redirectUsertoStore(success.data);
	          //   this.$window.location.href = '/'+ profile.store.storeURLName;
	          //   return;
	          // }
	          if (guestCart) {
	            if (guestCart.isDscCard) {
	              _this.$order.getCartDetail().then(function (success) {
	                _this.detail = success.data;
	                if (_this.isDscAddedinCart()) {
	                  _this.authService.doGuestLogout();
	                  _this.$state.go('cart');
	                } else {
	                  _this.$order.buyDscMembership().then(function () {
	                    _this.authService.doGuestLogout();
	                    _this.$state.go('cart');
	                  });
	                }
	              }).catch(function (err) {
	                _this.$order.buyDscMembership().then(function () {
	                  _this.authService.doGuestLogout();
	                  _this.$state.go('cart');
	                });
	              });
	            } else if (guestCart.isGiftCard) {
	              _this.$order.getCartDetail().then(function (success) {
	                _this.detail = success.data;
	
	                _this.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId).then(function () {
	                  _this.authService.doGuestLogout();
	                  _this.authService.removeGuestCart();
	                  _this.$state.go('cart');
	                });
	              }).catch(function (err) {
	                _this.$order.buyGiftCard(guestCart.quantity, guestCart.masterCode).then(function () {
	                  _this.authService.doGuestLogout();
	                  _this.authService.removeGuestCart();
	                  _this.$state.go('cart');
	                });
	              });
	            } else {
	              _this.$window.location.href = '//' + guestCart.categoryId + '/sub-category/' + guestCart.subCategoryId + '/product/' + guestCart.masterProductId + '/detail';
	            }
	          } else {
	
	            _this.$state.go('home');
	            _this.redirectUsertoStore(success.data);
	            // this.$window.location.href ='/'+this.storeName;
	            _this.authService.doGuestLogout();
	          }
	        }
	      }, function (error) {
	        //  console.log('error', error);
	        if (error.data.errorCode === 621) {
	          _this.noEmailError = true;
	          _this.$state.go('inactive');
	        } else {
	          _this.noEmailError = false;
	          form.error = error.data;
	        }
	      });
	    }
	
	    // 
	
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this2 = this;
	
	      // console.log('form',form);
	      if (form.$invalid) {
	        return;
	      }
	      form.error = {};
	      // if (this.email === 'test@gmail.com' && this.password === 'password') {
	      //   try {
	      //     sessionStorage.setItem('oauth', 'qwertyuiop');
	      //   }
	      //   catch (e) {
	      //     this.$cookies.put('oauth', 'qwertyuiop');
	      //   }
	      //   this.$state.go('home');
	      // }
	      this.$spinner.show('appSpinner');
	      this.authService.registerLogin({
	        email: this.email,
	        password: this.password
	      }).then(function (success) {
	        //  console.log('success', success);
	        // if(success.data.dscPop){
	        //   this.dscPopUp(success.data.dscPop);
	        // }
	        var profile = success.data.user;
	        //  console.log('profile', profile);
	        _this2.$spinner.hide('appSpinner');
	        var guestCart = _this2.authService.getGuestCart();
	        var subscription = _this2.authService.getSubscriptionId();
	        if (!profile.shippingAddressLine1 || !profile.shippingState || !profile.shippingCity || !profile.shippingZipCode || !profile.shippingCountry || !profile.billingCountry || !profile.billingAddressLine1 || !profile.billingState || !profile.billingCity || !profile.billingZipCode) {
	          _this2.authService.doGuestLogout();
	          // this.$rootScope.$emit('onLoginSuccess');
	          _this2.toaster.pop('success', 'You need to complete your Profile');
	          _this2.$state.go('profile.edit');
	        } else if (_this2.isForBuyAgain) {
	          _this2.$state.go('recent-order');
	        } else if (subscription) {
	          _this2.authService.resetSubscriptionCart();
	          _this2.$state.go('subscription-detail', { subscriptionId: subscription.id, option: 'edit' });
	        } else {
	          // If store not matched with guest login then redirect to home
	          var store = _this2.authService.getGuestStoreDetail();
	          console.log(_this2.$stateParams);
	          if (store.storeId != profile.store.storeId) {
	            _this2.authService.doGuestLogout();
	            _this2.authService.removeGuestCart();
	            // this.$rootScope.$emit('onLoginSuccess');
	            if (_this2.$stateParams.productId) {
	              //   this.$state.go('product.detail', {
	              //     categoryId: this.$stateParams.categoryId, 
	              //     subCategoryId: this.$stateParams.subCategoryId, 
	              //     productId: this.$stateParams.productId,
	              //     storeName: profile.store.storeURLName
	              //    });
	
	              _this2.$window.location.href = '/' + profile.store.storeURLName + '/' + _this2.$stateParams.categoryId + '/' + _this2.$stateParams.subCategoryId + '/' + _this2.$stateParams.productId;
	            } else {
	              _this2.$window.location.href = '/' + profile.store.storeURLName;
	              return;
	            }
	            //   this.redirectUsertoStore(success.data);
	            //   // this.$window.location.href = '/'+ profile.store.storeURLName;
	            //  //  return;
	          }
	
	          if (guestCart) {
	
	            if (store.storeId != profile.store.storeId) {
	
	              _this2.authService.removeGuestCart();
	            }
	            if (guestCart.isDscCard) {
	              _this2.$spinner.show('appSpinner');
	              _this2.$window.scrollTo(0, 0);
	              _this2.$order.getCartDetail().then(function (success) {
	                _this2.detail = success.data;
	                if (_this2.isDscAddedinCart()) {
	                  _this2.authService.doGuestLogout();
	                  // this.$rootScope.$emit('onLoginSuccess');
	                  _this2.$state.go('cart');
	                } else {
	                  _this2.$order.buyDscMembership().then(function () {
	                    _this2.authService.doGuestLogout();
	                    // this.$rootScope.$emit('onLoginSuccess');
	                    _this2.$state.go('cart');
	                  });
	                }
	                _this2.$spinner.hide('appSpinner');
	              }).catch(function (err) {
	                _this2.$order.buyDscMembership().then(function () {
	                  _this2.authService.doGuestLogout();
	                  // this.$rootScope.$emit('onLoginSuccess');
	                  _this2.$state.go('cart');
	                });
	              });
	            } else if (guestCart.isGiftCard) {
	              _this2.$spinner.show('appSpinner');
	              _this2.$window.scrollTo(0, 0);
	              _this2.$order.getCartDetail().then(function (success) {
	                _this2.detail = success.data;
	
	                _this2.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId).then(function () {
	                  _this2.authService.doGuestLogout();
	                  _this2.authService.removeGuestCart();
	                  _this2.$rootScope.$emit('onLoginSuccess');
	                  _this2.$state.go('cart');
	                });
	
	                _this2.$spinner.hide('appSpinner');
	              }).catch(function (err) {
	                _this2.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId).then(function () {
	                  _this2.authService.doGuestLogout();
	                  _this2.authService.removeGuestCart();
	                  _this2.$rootScope.$emit('onLoginSuccess');
	                  _this2.$state.go('cart');
	                });
	              });
	            } else {
	              _this2.authService.doGuestLogout();
	              _this2.$rootScope.$emit('onLoginSuccess');
	              // this.$window.location.href = 'order/category//' + guestCart.categoryId + '/sub-category/' + guestCart.subCategoryId + '/product/' + guestCart.masterProductId + '/detail';
	            }
	          } else {
	            _this2.authService.doGuestLogout();
	            _this2.redirectUsertoStore(success.data);
	            if (_this2.$stateParams.productId) {
	
	              _this2.$window.location.href = '/' + profile.store.storeURLName + '/' + _this2.$stateParams.categoryId + '/' + _this2.$stateParams.subCategoryId + '/' + _this2.$stateParams.productId;
	            } else {
	              _this2.$window.location.href = '/' + profile.store.storeURLName;
	              return;
	            }
	          }
	        }
	        // this.$window.location.reload(); 
	      }, function (error) {
	        //  console.log('error', error);
	        _this2.$spinner.hide('appSpinner');
	        if (error.data.errorCode === 621) {
	          _this2.noEmailError = true;
	          _this2.$state.go('inactive');
	        } else {
	          _this2.noEmailError = false;
	          form.error = error.data;
	        }
	      });
	    }
	    // 
	
	    // redirectUsertoStore(userData) {
	    //   console.log("UserData : ", userData);
	    //   this.$auth.getAllStores();
	    // }
	
	  }, {
	    key: 'redirectUsertoStore',
	    value: function redirectUsertoStore(userData) {
	      var _this3 = this;
	
	      var $ctrl;
	      $ctrl = this;
	      if (this.isDscMember(userData)) {
	        // this.$window.location.href = '/'+ userData.user.store.storeURLName;
	        return;
	        // this.authService.getAllStores();
	      } else {
	        var isDsc = false;
	        this.authService.getAllStores().then(function (success) {
	          console.log(success.data);
	          angular.forEach(success.data, function (store) {
	            console.log(store);
	            if (store.dscId == 'C') {
	              isDsc = true;
	            }
	          });
	          if (isDsc) {
	            _this3.$window.location.href = '/dashboard/profile/user';
	          } else {
	            //  this.$window.location.href = '/'+ userData.user.store.storeURLName;
	            return;
	          }
	        });
	      }
	      // this.authService.getAllStores();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember(profile) {
	      if (!profile.user.customer) return false;
	      return profile.user.customer.dscId === 'C' && new Date() <= new Date(profile.user.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired(profile) {
	      if (!profile.customer) return false;
	      return profile.customer.dscId === 'C' && new Date() > new Date(profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'doGuestLogin',
	    value: function doGuestLogin() {
	      var store = {};
	      store.storeName = this.storeName;
	      store.storeId = this.store.storeId;
	      this.authService.doGuestLogin(store);
	      this.$window.location.href = '/' + this.storeName;
	    }
	  }, {
	    key: 'doGuestLogout',
	    value: function doGuestLogout() {
	      try {
	        sessionStorage.removeItem('browseAsGuest');
	      } catch (e) {
	        this.$cookies.remove('browseAsGuest');
	      }
	    }
	  }, {
	    key: 'isDscAddedinCart',
	    value: function isDscAddedinCart() {
	      return this.detail.cartItems.some(function (cartItem) {
	        return cartItem.item.storeItemCode === 'C';
	      });
	    }
	  }, {
	    key: 'togglePassword',
	    value: function togglePassword(passwordIdTag, togglei) {
	      var x = document.getElementById(passwordIdTag);
	      var y = document.getElementById(togglei);
	      console.log("Password tag ", x);
	      if (x.type === "password") {
	        x.type = "text";
	        y.classList.remove('fa-eye-slash');
	        y.classList.add('fa-eye');
	      } else {
	        x.type = "password";
	        y.classList.remove('fa-eye');
	        y.classList.add('fa-eye-slash');
	      }
	    }
	  }]);
	
	  return LoginContainer;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', '$stateParams', '$cookies', 'spinnerService', 'authService', 'toaster', '$window', 'orderService', '$rootScope'], _temp)) || _class);
	exports.default = LoginContainer;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dbfc37bba72a55d349a4a5b635a7915b.jpg";

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc7bcec22ca2fd04d6d1a43504e426ff.jpg";

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "69cafb30086c64c0c04924280a7c120c.png";

/***/ },
/* 111 */
110,
/* 112 */
/***/ function(module, exports) {

	module.exports = "<div class=\"bg-color xs-screen\">\r\n  <img class=\"subheader-img hidden-md-up\" img-lazy-loader={{login.subHeaderImg}} alt=\"image\" />\r\n  <img class=\"subheader-img hidden-sm-down\" img-lazy-loader={{login.subHeaderImgDesktop}} alt=\"image\" />\r\n  <div class=\"text-xs-center\">\r\n    <a href=\"/\">\r\n      <img class=\"sub-header-logo logo-overlap\" src={{login.logo}} alt=\"Wild Birds Unlimited\" />\r\n    </a>\r\n    <h5 class=\"login-margin m-b-0\" ng-if=\"login.store.storeName\">\r\n      <strong>{{login.store.storeName}}, {{login.store.state.code}} {{login.store.zipCode}}</strong>\r\n    </h5>\r\n    <h5>\r\n      {{login.store.addressLine1 ? login.store.addressLine1 : ''}}\r\n      <br>\r\n      {{login.store.phoneNumber | telFormat}}\r\n    </h5>\r\n  </div>\r\n\r\n  <div class=\"row login-margin m-x-0\">\r\n    <div class=\"m-b-1\">\r\n      <form class=\"login-form\" name=\"loginForm\" ng-submit=\"login.submit(loginForm)\" autocomplete=\"off\" novalidate>\r\n        <div class=\"error-text\" ng-bind=\"loginForm.error.message\"></div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (loginForm.$submitted || loginForm.email.$touched) && loginForm.email.$invalid }\">\r\n          <label>Email <span><a href=\"#\" tooltips\r\n                tooltip-template=\"Please note: Daily Savings Club Members must register with the same email address that is associated with the 'in-store' account in order to receive membership benefits. If you do not know which email address was provided, please contact the store.\"\r\n                tooltip-size=\"small\" tooltip-smart=\"true\" tooltip-class=\"info-tooltip\" tooltip-side=\"right\"><img\r\n                  src=\"{{login.info}}\" alt=\"info\"></a></span></label>\r\n          <input name=\"email\" type=\"email\"\r\n            ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n            class=\"form-control\" ng-model=\"login.email\" required>\r\n          <div ng-messages=\"loginForm.email.$error\" class=\"form-control-feedback\"\r\n            ng-show=\"loginForm.email.$touched || loginForm.$submitted\">\r\n            <div ng-message=\"required\">Enter email address</div>\r\n            <div ng-message=\"pattern\">Enter a valid email address</div>\r\n            <div ng-message=\"email\">Enter a valid email address</div>\r\n            <div class=\"error-text\"\r\n              ng-show=\"loginForm.errors.email && !loginForm.email.$error.required && !loginForm.email.$error.pattern\">{{\r\n              loginForm.errors.email[0] }}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (loginForm.$submitted || loginForm.password.$touched) && loginForm.password.$invalid }\">\r\n            <label>Password</label>\r\n            <div class=\"password-container\">\r\n              <input name=\"password\" type=\"password\" class=\"form-control\" ng-model=\"login.password\" ng-minlength=\"6\"\r\n                ng-maxlength=\"60\" id=\"passwordId\" required />\r\n                <i class=\"far fa-eye-slash\" ng-click=\"login.togglePassword('passwordId','togglePasswordId')\" id=\"togglePasswordId\"\r\n                style=\"cursor: pointer;\"></i>\r\n            </div>\r\n            <div ng-messages=\"loginForm.password.$error\" class=\"form-control-feedback\"\r\n              ng-if=\"loginForm.password.$touched || loginForm.$submitted\">\r\n              <div ng-message=\"required\">Password is required</div>\r\n              <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n              <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n              <div class=\"error-text\" ng-show=\"loginForm.errors.password && !loginForm.password.$error.required\">{{\r\n                loginForm.errors.password[0] }}</div>\r\n            </div>\r\n        </div>\r\n\r\n        <p class=\"text-xs-center gray-text mb-4\">\r\n          By using this site, you agree to <a target=\"_blank\" ui-sref=\"tnc\" class=\"link-text\">Terms and Conditions</a>\r\n          and <a target=\"_blank\" ui-sref=\"rules\" class=\"link-text\">Rules</a>.\r\n        </p>\r\n\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block login-margin btn-sm-text \">Log in</button>\r\n\r\n        <p class=\"mt-4 m-b-1\">\r\n          <a ui-sref=\"forgotPassword\" class=\"link-text gray-text\">Forgot Password?</a>\r\n          <!-- <a ng-if=\"login.store.storeName&&login.storeName\" href ng-click=\"login.doGuestLogin()\" class=\"link-text gray-text pull-right\">Browse as guest</a> -->\r\n\r\n          <span ng-if=\"login.isScreenSmall()\" class=\"pull-xs-right\">Don't have an account?</span>\r\n        </p>\r\n        <p class=\"mb-4 pull-xs-right\" ng-if=\"!login.isScreenSmall()\">Don't have an account?</p>\r\n\r\n        <button type=\"button\" ng-disabled=\"!login.storeName\" class=\"btn btn-primary btn-block btn-sm-text\"\r\n          ui-sref=\"signup({storeName: login.storeName})\">\r\n          <span>Register here</span>\r\n        </button>\r\n\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n<style type=\"text/css\">\r\n  .login-form {\r\n    min-width: 400px;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  @media (max-width : 544px) {\r\n    .login-form {\r\n      min-width: 80%;\r\n      max-width: 80%;\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n</style>"

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NkI0RDkxREI0RjNCMTFFNzg4RTQ4M0JGMTEzMDQ5QTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkI0RDkxREM0RjNCMTFFNzg4RTQ4M0JGMTEzMDQ5QTQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2QjREOTFEOTRGM0IxMUU3ODhFNDgzQkYxMTMwNDlBNCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2QjREOTFEQTRGM0IxMUU3ODhFNDgzQkYxMTMwNDlBNCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrHM/V0AAAIVSURBVHjarJRfSFNxFMdbzBIMqsUg82GWCZkvQj2UQoEgJSKMCiHwJSN8KNiLMHCjUIMo9jLwTZpoL2msEEQm6KPRS/hiD82GzChUoh7y31w5PwfOHT9vu2NFFz773nt+5/e9Z/f8fj9XLpc78D8vl5NhNBqtQTrgOlzR8BwkYCwQCCyWZIiRGxmEbiO8CZJYYcRicB/jbUdDzLzIWzgLKRiAOJPWdfwo0g4hOAdpaGT86x+GJLvU5DQ8IylovOg8kiGWMmJ9yEP4Aj7Gfkv8oFHtczWLWGZMqoeP3H6AT9zPwhEZI+cR0g9VMLKvQpIquZeyl0n0Gd8yq3lx8GpzXpNz06g0idRCNfG0VWGXatDWtHcwTOItuMr9KtzAxGxOj+o9+XHrg1910srC4Bdy2ahEGnJYH3cNw4SqVB22KrwIG1Y3C6xJv378Y/CEvC3jxTvId+16vkLHCzOp6o0+illvsXyrwveyaG3fxroOqWYLmTGnDPFA0jScUG21T8DkJ3INmhyKajFWQt4wpvq0QAWSIw057mAYUR3KG1KFfPAXcAaDx7YJ8pfGYbrAy8JIHbzCY8m+U+7AZ9mnuq2sv5zRhXvKZhbSvb4GnU6Hw0ldzD7dblLtDKbfdPwE0gzSnAZYgUuyQ4odX+V6fN01wj/0+PIYsVF4oE0r6YCVhXob2uCChudhCl5itPBXJ/a/XnsCDABQMM/C33AI5AAAAABJRU5ErkJggg=="

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _bannerImage = __webpack_require__(108);
	
	var _bannerImage2 = _interopRequireDefault(_bannerImage);
	
	var _bannerImageDesktop = __webpack_require__(109);
	
	var _bannerImageDesktop2 = _interopRequireDefault(_bannerImageDesktop);
	
	var _tickSent = __webpack_require__(115);
	
	var _tickSent2 = _interopRequireDefault(_tickSent);
	
	var _logoS = __webpack_require__(110);
	
	var _logoS2 = _interopRequireDefault(_logoS);
	
	var _logo = __webpack_require__(111);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _question = __webpack_require__(113);
	
	var _question2 = _interopRequireDefault(_question);
	
	var _signup = __webpack_require__(116);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'signup',
	  template: _signup2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function SignupContainer($scope, $ngRedux, $state, $stateParams, authActions, $spinner, authService, $analytics, $location, $sce, $uibModal, APP, $rootScope, $order) {
	    var _this = this;
	
	    _classCallCheck(this, SignupContainer);
	
	    this.protect_email = function (user_email) {
	      var avg, splitted, part1, part2;
	      splitted = user_email.split("@");
	      part1 = splitted[0];
	      avg = part1.length / 2;
	      // part1 = part1.substring(0, (part1.length - avg)) + part1.substring(avg, part1.length - 1).replace(/./g, '*') + part1[part1.length - 1];
	      // part1 = part1.substring(0, (part1.length - avg)) + '***' + part1[part1.length - 1];
	      part1 = part1.substring(0, 2) + '***' + part1[part1.length - 1];
	      part2 = splitted[1];
	      return part1 + "@" + part2;
	    };
	
	    this.protect_address = function (address) {
	      var splitted = address.split(" ");
	      splitted = splitted.map(function (item, index) {
	        if (index !== 0) {
	          // const average = item.length / 2;
	          var average = 2;
	          // item = item.substring(0, average) + item.substring(average, item.length - 1).replace(/./g, '*') + item[item.length - 1];
	          item = item.substring(0, average) + '***' + item[item.length - 1];
	        }
	        return item;
	      });
	      return splitted.join(' ');
	    };
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    if ($stateParams.email) {
	      this.email = $stateParams.email;
	      $location.search('email', null);
	    }
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.APP = APP;
	    this.authActions = authActions;
	    this.authService = authService;
	    this.subHeaderImg = _bannerImage2.default;
	    this.subHeaderImgDesktop = _bannerImageDesktop2.default;
	    this.confirmImg = _tickSent2.default;
	    this.logo = _logoS2.default;
	    this.logoOutline = _logo2.default;
	    this.$order = $order;
	    if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      this.storeName = $stateParams.storeName;
	    } else {
	      this.storeName = this.authService.getGuestStoreDetail().storeName;
	    }
	    this.$analytics = $analytics;
	    this.info = _question2.default;
	    this.$spinner = $spinner;
	    this.$sce = $sce;
	    this.$uibModal = $uibModal;
	    this.$rootScope = $rootScope;
	    this.textline1 = "Please allow up to 5 minutes before clicking the 'Resend Email' button.";
	    this.textline2 = "This email may end up in your junk or spam folder.  Please whitelist donotreply@wbu.com to ensure delivery.";
	    this.textline3 = "If you click 'Resend Email' please choose on the most recently sent email to confirm your email address.";
	    var eventAction = 'Registration';
	    this.isRegistering = false;
	
	    this.emailUpdated = sessionStorage.getItem('isEmailUpdated');
	    if (this.emailUpdated && !this.$rootScope.inOrderPage) {
	      this.requestSent = true;
	      this.success = null;
	      this.error = null;
	      this.activationId = sessionStorage.getItem('activationId');
	      this.email = sessionStorage.getItem('userEmail');
	      sessionStorage.removeItem('activationId');
	      sessionStorage.removeItem('isEmailUpdated');
	      sessionStorage.removeItem('userProfile');
	    }
	    // console.log(typeof $analytics);
	    $analytics.eventTrack(eventAction, {
	      category: 'Registration',
	      label: this.storeName
	    });
	    $spinner.show('appSpinner');
	    authService.getStoreDetail(this.storeName).then(function () {
	      return $spinner.hide('appSpinner');
	    });
	    authService.getCountries().then(function () {});
	
	    var guestUserDetails = sessionStorage.getItem('userDetailsFromGuestSuccessfulOrder') ? JSON.parse(sessionStorage.getItem('userDetailsFromGuestSuccessfulOrder')) : null;
	    console.log("guestUserDetails==", guestUserDetails);
	    if (guestUserDetails && guestUserDetails.email != null && guestUserDetails.inOrderPage) {
	      this.requestSent = false;
	      this.doGuestOptIn(guestUserDetails.orderId);
	      this.isOrderPage = guestUserDetails.inOrderPage;
	      this.email = guestUserDetails.email;
	      this.firstName = guestUserDetails.firstName;
	      this.lastName = guestUserDetails.lastName;
	      sessionStorage.removeItem('userDetailsFromGuestSuccessfulOrder');
	    }
	
	    // this.isOrderPage = this.$rootScope.inOrderPage;
	    // if (this.isOrderPage) {
	    //   this.email = this.$rootScope.guestCheckoutEmail;
	    // }
	    $scope.$on('$destroy', function () {
	      _this.$rootScope.inOrderPage = false;
	      _this.$rootScope.guestCheckoutEmail = null;
	    });
	  }
	
	  _createClass(SignupContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        store: state.auth.storeDetail,
	        billingCountries: state.auth.countries
	      };
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this2 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      form.error = {};
	      var ctrl = this;
	      if (this.confirmPassword === this.password) {
	        ctrl.signupForm = form;
	        ctrl.$spinner.show('appSpinner');
	        ctrl.isRegistering = true;
	        this.authService.verifyCustomerEmail({
	          email: this.email,
	          agreement: this.agreement,
	          phoneNumber: this.phoneNumber,
	          store: {
	            storeURLName: this.storeName
	          }
	        }).then(function (success) {
	          ctrl.sendEmailStore = false;
	          ctrl.$spinner.hide('appSpinner');
	          ctrl.registration(ctrl);
	        }, function (error) {
	          ctrl.$spinner.hide('appSpinner');
	          ctrl.isRegistering = false;
	          if (error.data.errorCode === 607) {
	            _this2.noEmailError = true;
	            return;
	          } else if (error.data.errorCode === 705) {
	            if (ctrl.isOrderPage) {
	              ctrl.registration(ctrl);
	            } else {
	              ctrl.registrationWelcome(ctrl);
	            }
	          } else {
	            _this2.noEmailError = false;
	            if (error.data.errorCode === 615 || error.data.errorCode === 605) {
	              ctrl.signupForm.error = error.data;
	            } else if (error.data.errorCode === 667) {
	              ctrl.signupForm.error = error.data;
	            } else {
	              ctrl.signupForm.error = { message: 'Registration Failed Please try again!' };
	            }
	          }
	        });
	      } else {
	        form.error.message = 'Password mismatch';
	      }
	    }
	  }, {
	    key: 'registration',
	    value: function registration(ctrl) {
	      var _this3 = this;
	
	      ctrl.$spinner.show('appSpinner');
	      var isRegisteringFromGuest = ctrl.isOrderPage != null ? ctrl.isOrderPage : false;
	      var reqBody = {
	        email: this.email,
	        password: this.password,
	        agreement: this.agreement,
	        phoneNumber: this.phoneNumber,
	        customer: {
	          firstName: this.firstName,
	          lastName: this.lastName
	        },
	        store: {
	          storeURLName: this.storeName
	        },
	        isExistingRegistration: ctrl.isExistingRegistration,
	        percentage: ctrl.percentage ? ctrl.percentage : 0,
	        scenario: ctrl.scenario ? ctrl.scenario : 0
	      };
	      if (ctrl.isExistingRegistration) {
	        var state = void 0;
	        var country = void 0;
	        if (ctrl.billingCountries.length && ctrl.searchRequest && ctrl.searchRequest.country) {
	          var selected = ctrl.billingCountries.find(function (data) {
	            return data.label === ctrl.searchRequest.country;
	          });
	          country = {
	            id: selected.value,
	            countryCode: selected.label,
	            name: selected.name
	          };
	          if (ctrl.searchRequest.state) {
	            var selectedState = selected.states.find(function (data) {
	              return data.value === ctrl.searchRequest.state;
	            });
	            state = {
	              id: selectedState.id,
	              name: selectedState.label,
	              code: selectedState.value
	            };
	          }
	        }
	        reqBody = {
	          email: this.email,
	          password: this.password,
	          agreement: this.agreement,
	          phoneNumber: this.phoneNumber,
	          store: {
	            storeURLName: this.storeName
	          },
	          isExistingRegistration: ctrl.isExistingRegistration,
	          percentage: ctrl.percentage ? ctrl.percentage : 0,
	          scenario: ctrl.scenario ? ctrl.scenario : 0,
	          billingAddressLine1: ctrl.searchRequest ? ctrl.searchRequest.addressLine1 : null,
	          billingCity: ctrl.searchRequest ? ctrl.searchRequest.city : null,
	          billingState: state ? state : null,
	          billingCountry: country ? country : null,
	          billingZipCode: ctrl.searchRequest ? ctrl.searchRequest.zipCode : null,
	          shippingAddressLine1: ctrl.searchRequest ? ctrl.searchRequest.addressLine1 : null,
	          shippingCity: ctrl.searchRequest ? ctrl.searchRequest.city : null,
	          shippingState: state ? state : null,
	          shippingCountry: country ? country : null,
	          shippingZipCode: ctrl.searchRequest ? ctrl.searchRequest.zipCode : null,
	          customer: {
	            firstName: ctrl.searchRequest ? ctrl.searchRequest.firstName : null,
	            lastName: ctrl.searchRequest ? ctrl.searchRequest.lastName : null
	          }
	        };
	      }
	      this.authService.registerUser(reqBody, isRegisteringFromGuest).then(function (success) {
	        ctrl.$spinner.hide('appSpinner');
	        ctrl.isRegistering = false;
	        var eventAction = 'RegistrationSuccessful';
	        _this3.requestSent = true;
	        _this3.activationId = success.data.additionalInfo;
	        if (ctrl.sendEmailStore) {
	          ctrl.sendEmailToStore(0);
	        }
	        ctrl.reset(ctrl);
	        _this3.$analytics.eventTrack(eventAction, {
	          category: 'RegistrationSuccessful',
	          label: _this3.storeName + '/' + _this3.email
	        });
	        _this3.goToOTPpage(_this3.activationId, _this3.email, _this3.storeName);
	      }, function (error) {
	        ctrl.$spinner.hide('appSpinner');
	        ctrl.isRegistering = false;
	        if (error.data.errorCode === 607) {
	          _this3.noEmailError = true;
	          return;
	        } else {
	          _this3.noEmailError = false;
	          if (error.data.errorCode === 707 || error.data.errorCode === 615 || error.data.errorCode === 613 || error.data.errorCode === 605) {
	            ctrl.signupForm.error = error.data;
	          } else {
	            ctrl.signupForm.error = { message: 'Registration Failed Please try again!' };
	          }
	        }
	        ctrl.reset(ctrl);
	      });
	    }
	  }, {
	    key: 'registrationStore',
	    value: function registrationStore(ctrl) {
	      var _this4 = this;
	
	      ctrl.$spinner.show('appSpinner');
	      var potentialRecords = ctrl.customerDetails.filter(function (item) {
	        return !item.isFakeAddress;
	      }).map(function (ele) {
	        return ele.customerID;
	      });
	      this.authService.registerStoreUser({
	        email: this.email,
	        password: this.password,
	        agreement: this.agreement,
	        phoneNumber: this.phoneNumber,
	        store: {
	          storeURLName: this.storeName
	        },
	        customer: {
	          id: this.customerId
	        },
	        isExistingRegistration: ctrl.isExistingRegistration,
	        percentage: ctrl.percentage ? ctrl.percentage : 0,
	        potentialRecords: potentialRecords && potentialRecords.length ? potentialRecords.toString() : null
	      }).then(function (success) {
	        ctrl.$spinner.hide('appSpinner');
	        ctrl.isRegistering = false;
	        var eventAction = 'RegistrationSuccessful';
	        _this4.$analytics.eventTrack(eventAction, {
	          category: 'RegistrationSuccessful',
	          label: _this4.storeName + '/' + _this4.email
	        });
	        _this4.requestSent = true;
	        _this4.activationId = success.data.additionalInfo;
	        ctrl.customerDetails = [];
	        if (ctrl.sendEmailStore) {
	          ctrl.sendEmailToStore(1);
	        }
	        // ctrl.infoPopUp(this.email);
	        ctrl.reset(ctrl);
	        _this4.goToOTPpage(_this4.activationId, _this4.email, _this4.storeName);
	      }, function (error) {
	        ctrl.$spinner.hide('appSpinner');
	        ctrl.isRegistering = false;
	        ctrl.customerDetails = [];
	        if (error.data.errorCode === 607) {
	          _this4.noEmailError = true;
	          return;
	        } else {
	          _this4.noEmailError = false;
	          if (error.data.errorCode === 707 || error.data.errorCode === 605) {
	            ctrl.signupForm.error = error.data;
	          } else {
	            ctrl.signupForm.error = { message: 'Registration Failed Please try again!' };
	          }
	        }
	        ctrl.reset(ctrl);
	      });
	    }
	  }, {
	    key: 'registrationWelcome',
	    value: function registrationWelcome(ctrl) {
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5></h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="row">' + '<div class="col-md-12 p-t-1">' + '<h6>We don&#146t find that email address in our records.  If you have shopped with us before, we can get more information to connect to our in-store account.</h6>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="modal-footer">' + '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok(true)" style="float: right;">\n        <span>Create New Account </span>\n        </button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok(false)" style="float: right;">\n        <span>Find Me</span>\n        </button>' + '</div>',
	        controller: ['$scope', '$state', '$uibModalInstance', '$sce', function ($scope, $state, $uibModalInstance, $sce) {
	          // eslint-disable-next-line arrow-parens
	          // $scope.$sce = $sce;
	          $scope.ok = function (isregister) {
	            $uibModalInstance.close();
	            if (!isregister) {
	              ctrl.registrationInfo(ctrl);
	            } else {
	              ctrl.sendEmailStore = false;
	              ctrl.isExistingRegistration = false;
	              ctrl.registration(ctrl);
	            }
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'registrationInfo',
	    value: function registrationInfo(ctrl) {
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5></h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="row">' + ' <form name="registrationForm"\n        ng-submit="submit(registrationForm)"\n        autocomplete="off"\n        novalidate>\n        <div class="col-md-12 error-text" ng-if="registrationForm.error.message">{{registrationForm.error.message}}</div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>First Name </label>\n              <input name="fName" type="text" ng-model="fName" class="form-control"/>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>Last Name* </label>\n              <input name="lName" type="text" required ng-model="lName" class="form-control"/>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>Address </label>\n              <input name="address" type="text" ng-model="address" class="form-control"/>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>City </label>\n              <input name="city" type="text" ng-model="city" class="form-control"/>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>Country </label>\n              <select name="country"\n                ng-model="country"\n                class="form-control"\n                ng-change=\'getStates(country)\'>\n                <option value="">Select</option>\n                <option ng-repeat="item in billingCountries" value="{{item.label}}">\n                  {{ item.label }}\n                </option>\n              </select>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>State/Province </label>\n              <select name="state"\n                ng-model="state"\n                class="form-control">\n                <option value="">Select</option>\n                <option ng-repeat="item in billingStates" value="{{item.value}}">\n                  {{ item.label }}\n                </option>\n              </select>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>Zip code </label>\n              <input name="zip" type="text" ng-model="zip" class="form-control"/>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group">\n              <label>Alternate Email </label>\n              <input name="aEmail" type="text" ng-model="aEmail" class="form-control"/>\n            </div>\n        </div>\n      </form>' + '</div>' + '</div>' + '</div>' + '<div class="modal-footer">' + '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="submit(registrationForm)" style="float: right;">Find</button>' + '</div>',
	        controller: ['$scope', '$state', '$uibModalInstance', function ($scope, $state, $uibModalInstance) {
	          $scope.billingCountries = ctrl.billingCountries;
	          // eslint-disable-next-line arrow-parens
	          $scope.getStates = function (country) {
	            var billingStates = '';
	            angular.forEach(ctrl.billingCountries, function (value) {
	              if (country === value.label) {
	                billingStates = value.states;
	              }
	            });
	
	            $scope.billingStates = billingStates;
	          };
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	          // eslint-disable-next-line arrow-parens
	          $scope.submit = function (registrationForm) {
	            if ($scope.fName || $scope.lName || $scope.address || $scope.city || $scope.state || $scope.zip || $scope.aEmail) {
	              if (($scope.fName || $scope.zip) && $scope.lName) {
	                ctrl.findUserInfo(ctrl, $scope, $uibModalInstance);
	              } else {
	                if (!$scope.lName) {
	                  registrationForm.error = { message: 'Please enter Last Name!' };
	                } else {
	                  registrationForm.error = { message: 'Please enter First Name or Zip Code!' };
	                }
	              }
	            } else {
	              registrationForm.error = { message: 'Please enter any of these details!' };
	            }
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'userDetails',
	    value: function userDetails() {
	      var ctrl = this;
	      this.$uibModal.open({
	        size: 'lgmd',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5></h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<h6 ng-if="customerDetails.length">Please select your account. If you do not recognize an account, please call your store for assistance.</h6>' + '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' + '<div class="row">' + '\n        <div class="table-responsive table-striped" ng-if="customerDetails.length">\n          <table class="table list-table">\n            <thead class="thead-inverse">\n              <tr>\n                <th></th>\n                <th>Name</th>\n                <th>Address</th>\n                <th>Phone Number</th>\n                <th>Email</th>\n              </tr>\n            </thead>\n            <tbody>\n             <tr class="default-cursor" ng-repeat="item in customerDetails">\n                <td width="40" >\n                <input type="radio" name="selected" ng-model="selected" ng-click="selectedId(item.customerID)" ng-value="$index" class="form-radio-input" />                \n                </td>\n                <td width="100" ng-bind="item.name"></td>\n                <td width="160">{{item.addressLine}} <br/> {{(item.city ? item.city : \'\') + \' \' + (item.state ? item.state : \'\') + \' \' + (item.zipCode ? item.zipCode : \'\') }}</td>\n                <td width="60">{{item.phoneNumber ? item.phoneNumber : \'\'}}</td>\n                <td width="100">{{item.email ? item.email : \'\'}}</td>\n              </tr>\n              <tr class="default-cursor">\n              <td width="40">\n              <input type="radio" name="selected" ng-model="selected" ng-click="selectedId(-1)" ng-value="-1" class="form-radio-input" />\n              </td>\n                <td width="40" colspan="4">None of the above\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>' + '<div class="col-sm-12 gray-text" style="text-align: center" ng-if="!customerDetails.length">\n        <h6>We couldn\'t find a record with the information you provided. For more help, please contact your local store and ask which email is on file, or proceed to create a new account. Thank you, and happy birding!</h6>\n        </div>' + '</div>' + '</div>' + '</div>' + '<div class="modal-footer">' + '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Register</button>' +
	        // '<button class="btn btn-primary m-l-1" type="button" ng-click="submitRegister()" style="float: right;">Register Without selecting</button>' +
	        '<button class="btn " type="button m-l-1" ng-click="back()" style="float: right;">Back</button>' + '</div>',
	        controller: ['$scope', '$state', '$uibModalInstance', function ($scope, $state, $uibModalInstance) {
	          $scope.customerDetails = ctrl.customerDetails;
	          $scope.selectedCustomer = null;
	          $scope.error = { message: '' };
	          $scope.back = function () {
	            $uibModalInstance.close();
	            ctrl.registrationInfo(ctrl);
	          };
	          // eslint-disable-next-line arrow-parens
	          $scope.selectedId = function (id) {
	            $scope.selectedCustomer = id;
	          };
	          $scope.submit = function () {
	            if (!$scope.customerDetails || !$scope.customerDetails.length) {
	              ctrl.sendEmailStore = true;
	              ctrl.isExistingRegistration = true;
	              ctrl.scenario = 1;
	              ctrl.registration(ctrl);
	              $uibModalInstance.close();
	              return;
	            }
	            if ($scope.selectedCustomer === -1) {
	              ctrl.sendEmailStore = true;
	              ctrl.isExistingRegistration = true;
	              ctrl.scenario = 1;
	              ctrl.registration(ctrl);
	              $uibModalInstance.close();
	            } else if ($scope.selectedCustomer || $scope.selectedCustomer === 0) {
	              $uibModalInstance.close();
	              var selected = $scope.customerDetails.find(function (item) {
	                return item.customerID === $scope.selectedCustomer;
	              });
	              if (selected && !selected.email) {
	                ctrl.percentage = 0;
	                ctrl.sendEmailStore = true;
	                ctrl.isExistingRegistration = true;
	                ctrl.customerId = $scope.selectedCustomer;
	                ctrl.registrationStore(ctrl);
	              } else {
	
	                // Selecting preferance email is commented may be used in future
	                // ctrl.withPreferanceEmail(ctrl, $scope.selectedCustomer, selected);
	
	                // Without Preferance email i.e registering with selected store email
	                ctrl.withoutPreferanceEmail(ctrl, $scope.selectedCustomer, selected);
	              }
	            } else {
	              $scope.error.message = 'Please select any!';
	            }
	          };
	          $scope.submitRegister = function () {
	            ctrl.sendEmailStore = true;
	            ctrl.isExistingRegistration = true;
	            ctrl.scenario = 1;
	            ctrl.registration(ctrl);
	            $uibModalInstance.close();
	            return;
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'withoutPreferanceEmail',
	    value: function withoutPreferanceEmail(ctrl, selectedCustomer, selected) {
	      if (selected && selected.isFakeAddress) {
	        ctrl.sendEmailStore = true;
	        ctrl.isExistingRegistration = true;
	        ctrl.scenario = 2;
	        ctrl.registration(ctrl);
	      } else {
	        var alterEmail = ctrl.searchRequest ? ctrl.searchRequest.email : '';
	        var originalCustomer = ctrl.originalCustomerDetails.find(function (ele) {
	          return ele.customerID === selectedCustomer;
	        });
	        if (originalCustomer && originalCustomer.email === alterEmail) {
	          ctrl.percentage = 100;
	          ctrl.sendEmailStore = false;
	        } else {
	          ctrl.percentage = 0;
	          ctrl.sendEmailStore = true;
	        }
	        ctrl.isExistingRegistration = true;
	        ctrl.email = originalCustomer.email;
	        ctrl.customerId = selectedCustomer;
	        ctrl.registrationStore(ctrl);
	      }
	    }
	  }, {
	    key: 'withPreferanceEmail',
	    value: function withPreferanceEmail(ctrl, selectedCustomer, selected) {
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Preferred Email</h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' + '<h6>Please select an email to Activate/ Register your account with?</h6>' + '<input type="radio" name="emailselected" ng-model="emailselected" ng-click="selectedemail(\'store\')" value="store" class="form-radio-input m-l-1" /> ' + selected.email + '   ' + '<input type="radio" name="emailselected" ng-model="emailselected" ng-click="selectedemail(\'entered\')" value="entered" class="form-radio-input m-l-1" /> ' + ctrl.email + '</div>' + '<div class="modal-footer">' + '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">Register</button>' + '<button class="btn " type="button m-l-1" ng-click="back()" style="float: right;">Back</button>' + '</div>',
	        controller: ['$scope', '$state', '$uibModalInstance', function ($scope, $state, $uibModalInstance) {
	          $scope.selected = selected;
	          $scope.entered = ctrl.email;
	          $scope.error = { message: null };
	          $scope.back = function () {
	            $uibModalInstance.close();
	            ctrl.userDetails();
	          };
	          $scope.ok = function () {
	            if (!$scope.emailselected) {
	              $scope.error.message = 'Please select any!';
	              return;
	            }
	            if (selected && selected.isFakeAddress) {
	              ctrl.sendEmailStore = true;
	              ctrl.isExistingRegistration = true;
	              ctrl.scenario = 2;
	              ctrl.registration(ctrl);
	            } else {
	              var alterEmail = ctrl.searchRequest ? ctrl.searchRequest.email : '';
	              var originalCustomer = ctrl.originalCustomerDetails.find(function (ele) {
	                return ele.customerID === selectedCustomer;
	              });
	              if (originalCustomer && originalCustomer.email === alterEmail) {
	                ctrl.percentage = 100;
	                ctrl.sendEmailStore = false;
	              } else {
	                ctrl.percentage = 0;
	                ctrl.sendEmailStore = true;
	              }
	              ctrl.isExistingRegistration = true;
	              ctrl.customerId = selectedCustomer;
	              if ($scope.emailselected === 'store') {
	                ctrl.email = originalCustomer.email;
	                // ctrl.percentage = 100;
	              }
	              ctrl.registrationStore(ctrl);
	            }
	            $uibModalInstance.close();
	          };
	          // eslint-disable-next-line arrow-parens
	          $scope.selectedemail = function (email) {
	            $scope.emailselected = email;
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'findUserInfo',
	    value: function findUserInfo(ctrl, scope, uibModalInstance) {
	      var _this5 = this;
	
	      ctrl.$spinner.show('appSpinner');
	      ctrl.customerDetails = [];
	      ctrl.searchRequest = {
	        firstName: scope.fName,
	        lastName: scope.lName,
	        email: scope.aEmail,
	        phoneNumber: this.phoneNumber,
	        addressLine1: scope.address,
	        city: scope.city,
	        // state: scope.state,
	        zipCode: scope.zip,
	        store: {
	          storeURLName: this.storeName
	        }
	      };
	      this.authService.findCustomerInfo(ctrl.searchRequest).then(function (success) {
	        if (success && success.data && success.data.length) {
	          ctrl.originalCustomerDetails = _this5.refineCustomerList(success.data);
	          ctrl.customerDetails = ctrl.maskUpCustomerData(JSON.parse(JSON.stringify(ctrl.originalCustomerDetails)));
	        } else {
	          ctrl.originalCustomerDetails = [];
	          ctrl.customerDetails = [];
	        }
	        ctrl.$spinner.hide('appSpinner');
	        ctrl.userDetails();
	      }, function (error) {
	        ctrl.$spinner.hide('appSpinner');
	      });
	      uibModalInstance.close();
	      ctrl.searchRequest = {
	        firstName: scope.fName,
	        lastName: scope.lName,
	        email: scope.aEmail,
	        phoneNumber: this.phoneNumber,
	        addressLine1: scope.address,
	        city: scope.city,
	        state: scope.state,
	        zipCode: scope.zip,
	        country: scope.country
	      };
	    }
	  }, {
	    key: 'refineCustomerList',
	    value: function refineCustomerList(list) {
	      if (list && list.length) {
	        var refined = [];
	        list.forEach(function (item) {
	          if (item.isFakeAddress) {
	            refined.push(item);
	          } else {
	            var ele = refined.find(function (e) {
	              return e.email && item.email ? e.email.toUpperCase() === item.email.toUpperCase() : e.email === item.email;
	            });
	            if (ele) {
	              // eslint-disable-next-line arrow-parens
	              var index = refined.findIndex(function (el) {
	                return el === ele;
	              });
	              if (ele.email === null || ele.email.trim() === '') {
	                if (item.lastName.toUpperCase() === ele.lastName.toUpperCase() && item.firstName.toUpperCase() === ele.firstName.toUpperCase() && item.zipCode === ele.zipCode && item.addressLine && ele.addressLine) {
	                  if (item.dscId === 'C' && item.dscExpireDate > ele.dscExpireDate) {
	                    refined[index] = item;
	                  }
	                } else {
	                  refined.push(item);
	                }
	              } else if (item.dscId === 'C' && item.dscExpireDate > ele.dscExpireDate) {
	                refined[index] = item;
	              }
	            } else {
	              refined.push(item);
	            }
	          }
	        });
	        return refined;
	      }
	      return list;
	    }
	  }, {
	    key: 'maskUpCustomerData',
	    value: function maskUpCustomerData(customerList) {
	      var _this6 = this;
	
	      // customerList = this.generateFake(customerList);
	      return [].concat(_toConsumableArray(customerList)).map(function (item) {
	        item.email = item.email && item.email.trim() !== '' ? _this6.protect_email(item.email) : '';
	        item.addressLine = item.addressLine ? item.addressLine.trim() ? _this6.protect_address(item.addressLine.trim()) : '' : '';
	        item.state = item.state ? item.state.trim() : '';
	        item.city = item.city ? item.city.trim() : '';
	        item.zipCode = item.zipCode ? item.zipCode.trim() : '';
	        item.phoneNumber = item.phoneNumber && item.phoneNumber.trim() !== '' ? "(XXX) XXX-" + item.phoneNumber.substring(item.phoneNumber.length - 4) : '';
	        return item;
	      });
	    }
	  }, {
	    key: 'sendEmailToStore',
	    value: function sendEmailToStore(isCustomerMapped) {
	      this.authService.sendEmailToStore(isCustomerMapped, {
	        email: this.email,
	        phoneNumber: this.phoneNumber,
	        store: {
	          storeURLName: this.storeName
	        }
	      }).then(function (success) {});
	    }
	  }, {
	    key: 'resendEmail',
	    value: function resendEmail() {
	      var _this7 = this;
	
	      this.success = null;
	      this.error = null;
	      this.authService.resendEmail({
	        id: this.activationId,
	        email: this.email
	      }).then(function (success) {
	        return _this7.success = success.data.message;
	      }).catch(function (err) {
	        return _this7.error = err.data.message;
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset(ctrl) {
	      ctrl.originalCustomerDetails = [];
	      ctrl.customerDetails = [];
	      ctrl.sendEmailStore = null;
	      ctrl.isExistingRegistration = null;
	      ctrl.customerId - null;
	      ctrl.percentage = null;
	      ctrl.searchRequest = null;
	    }
	  }, {
	    key: 'goToOTPpage',
	    value: function goToOTPpage(id, email, storeName) {
	      if (this.store && this.store.hasOtp) {
	        this.$state.go('otpactivate', { storeName: storeName, id: id, email: email });
	      }
	    }
	  }, {
	    key: 'togglePassword',
	    value: function togglePassword(passwordId, toggleId) {
	      this.authService.togglePassword(passwordId, toggleId);
	    }
	  }, {
	    key: 'infoPopUp',
	    value: function infoPopUp(registeredEmail) {
	      console.log("Showing pop up for registering Email : " + registeredEmail);
	
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Registeration Successful</h5></div>' + '<div class="modal-body" id="modal-body">' + '<h6>One more step! We have sent an email to the email on file (' + registeredEmail + ') to verify your identity. Please use this email to finalize your account setup. </h6>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' + '</div>',
	        controller: ['$scope', '$state', 'orderService', '$uibModalInstance', function ($scope, $state, $order, $uibModalInstance) {
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'doGuestOptIn',
	    value: function doGuestOptIn(orderId) {
	      var data = {};
	      data.orderId = orderId;
	      this.$order.doGuestOptIn(data);
	    }
	  }]);
	
	  return SignupContainer;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', '$stateParams', 'authActions', 'spinnerService', 'authService', '$analytics', '$location', '$sce', '$uibModal', 'APP', '$rootScope', 'orderService'], _temp)) || _class);
	exports.default = SignupContainer;

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = "<auth-header ng-if=\"signup.requestSent\"></auth-header>\r\n<div class=\"{{signup.isOrderPage ? 'content-full xs-screen' : 'bg-color content-full xs-screen'}}\"\r\n  ng-if=\"! signup.requestSent\">\r\n  <img class=\"subheader-img hidden-md-up\" ng-if=\"!signup.isOrderPage\" img-lazy-loader={{signup.subHeaderImg}}\r\n    alt=\"image\" />\r\n  <img class=\"subheader-img hidden-sm-down\" ng-if=\"!signup.isOrderPage\" img-lazy-loader={{signup.subHeaderImgDesktop}}\r\n    alt=\"image\" />\r\n  <div class=\"text-xs-center\" ng-if=\"!signup.isOrderPage\">\r\n    <a href=\"/\">\r\n      <img class=\"sub-header-logo logo-overlap\" src={{signup.logo}} alt=\"Wild Birds Unlimited\" />\r\n    </a>\r\n    <h5 class=\"m-t-1 m-b-0 heading-text\" ng-if=\"signup.store.storeName\">\r\n      <strong>{{signup.store.storeName}}, {{signup.store.state.code}} {{signup.store.zipCode}}</strong>\r\n    </h5>\r\n    <h5>\r\n      {{signup.store.addressLine1 ? signup.store.addressLine1 + ',' : ''}} {{signup.store.addressLine2 ?\r\n      signup.store.addressLine2 + ',' : ''}}\r\n      {{signup.store.phoneNumber | telFormat}}\r\n    </h5>\r\n  </div>\r\n\r\n  <div class=\"mt-4 m-x-0\">\r\n    <form name=\"signupForm\" ng-submit=\"signup.submit(signupForm)\" autocomplete=\"off\" novalidate>\r\n      <div class=\"signup-form\">\r\n        <!-- fake field workaround for browser autofill -->\r\n        <div ng-if=\"signup.isOrderPage\">\r\n          <strong>Enter a password to register your account. </strong>\r\n          <br />\r\n          &#x25CF Keep your order history\r\n          <br />\r\n          &#x25CF Easy reorder option\r\n          <br />\r\n          &#x25CF Eligible to join the Daily Savings Club\r\n          <br />\r\n          If you are currently a DSC member, please register with the same email address that you use in-store to\r\n          immediately see your benefits.\r\n          <br />\r\n          <br />\r\n        </div>\r\n\r\n        <input name=\"password\" type=\"password\" class=\"form-control\" ng-hide=\"true\" />\r\n        <div layout-xs=\"column\" layout-sm=\"column\">\r\n          <div class=\"error-text\" ng-if=\"!signup.noEmailError\">{{signupForm.error.message}}</div>\r\n          <div class=\"error-text\" ng-if=\"signup.noEmailError\">\r\n            We are not finding your email address in our store records. Perhaps you are using a different email address.\r\n            Please try a different email address, or call the store at <a class=\"blue-colored\"\r\n              href=\"tel:{{signup.store.storePhoneNunber}}\">{{signup.store.storePhoneNunber | telFormat}}\r\n            </a>.\r\n          </div>\r\n          <div ng-if=\"!signup.isOrderPage\" style=\"margin-bottom:15px\"> <strong>Please note:</strong> Daily Savings Club Members must register\r\n            with the same email address that is associated with the 'in-store' account in order to receive\r\n            membership benefits. If you do not know which email address was provided, please contact the store.\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"form-group col-md-6 md-block m-b-1\"\r\n              ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.firstName.$touched) && signupForm.firstName.$invalid }\"\r\n              flex-gt-sm>\r\n              <label>First Name*</label>\r\n              <input name=\"firstName\" type=\"text\" ng-model=\"signup.firstName\" class=\"form-control\" required />\r\n              <div ng-messages=\"signupForm.firstName.$error\" class=\"form-control-feedback\"\r\n                ng-if=\"signupForm.firstName.$touched || signupForm.$submitted\">\r\n                <div ng-message=\"required\">First name is required</div>\r\n                <div class=\"error-text\" ng-show=\"signupForm.errors.firstName && !signupForm.firstName.$error.required\">\r\n                  {{signupForm.errors.firstName[0]}}</div>\r\n              </div>\r\n            </div>\r\n              <div class=\"md-block col-md-6 form-group m-b-1\"\r\n                ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.lastName.$touched) && signupForm.lastName.$invalid }\"\r\n                flex-gt-sm>\r\n                <label>Last Name*</label>\r\n                <input name=\"lastName\" type=\"text\" ng-model=\"signup.lastName\" class=\"form-control\" required />\r\n                <div ng-messages=\"signupForm.lastName.$error\" class=\"form-control-feedback\"\r\n                  ng-if=\"signupForm.lastName.$touched || signupForm.$submitted\">\r\n                  <div ng-message=\"required\">Last name is required</div>\r\n                  <div class=\"error-text\" ng-show=\"signupForm.errors.lastName && !signupForm.lastName.$error.required\">\r\n                    {{signupForm.errors.lastName[0]}}</div>\r\n                </div>\r\n              </div>\r\n          </div>\r\n\r\n          <!-- <div class=\"{{signup.isOrderPage ? 'form-group' : 'form-group form-group-stdmsg'}}\" class=\"md-block\"  -->\r\n          <div class=\"form-group\" class=\"md-block\" \r\n            ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.email.$touched) && signupForm.email.$invalid }\">\r\n            <label>Email* </label>\r\n            <input name=\"email\" type=\"email\"\r\n              ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n              ng-model=\"signup.email\" class=\"form-control\" ng-disabled=\"signup.isOrderPage\" required />\r\n            <div ng-messages=\"signupForm.email.$error\" class=\"form-control-feedback\"\r\n              ng-if=\"signupForm.email.$touched || signupForm.$submitted\">\r\n              <div ng-message=\"required\">Enter email address</div>\r\n              <div ng-message=\"pattern\">Enter a valid email address</div>\r\n              <div ng-message=\"email\">Enter a valid email address</div>\r\n              <div class=\"error-text\"\r\n                ng-show=\"signupForm.errors.email && !signupForm.email.$error.required && !signupForm.email.$error.pattern\">\r\n                {{signupForm.errors.email[0]}}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\"\r\n            ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.password.$touched) && signupForm.password.$invalid }\"\r\n            class=\"md-block\" flex-gt-sm>\r\n            <label>Password*</label>\r\n            <div class=\"password-container margin-ten\">\r\n            <input name=\"password\" type=\"password\" ng-model=\"signup.password\" ng-minlength=\"6\" ng-maxlength=\"60\"\r\n            id=\"passwordIdRegister\" class=\"form-control\" required />\r\n            <i class=\"far fa-eye-slash\" ng-click=\"signup.togglePassword('passwordIdRegister','togglePasswordRegister')\" id=\"togglePasswordRegister\"\r\n                style=\"cursor: pointer;\"></i>\r\n            </div>\r\n            <div ng-messages=\"signupForm.password.$error\" class=\"form-control-feedback\"\r\n              ng-if=\"signupForm.password.$touched || signupForm.$submitted\">\r\n              <div ng-message=\"required\">Password is required</div>\r\n              <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n              <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n              <div class=\"error-text\" ng-show=\"signupForm.errors.password && !signupForm.password.$error.required\">\r\n                {{signupForm.errors.password[0]}}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\"\r\n            ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.confirmPassword.$touched) && signupForm.confirmPassword.$invalid }\"\r\n            class=\"md-block\" flex-gt-sm>\r\n            <label>Confirm Password*</label>\r\n            <div class=\"password-container margin-ten\">\r\n            <input name=\"confirmPassword\" type=\"password\" ng-model=\"signup.confirmPassword\" ng-minlength=\"6\"\r\n            id=\"passwordIdConfirm\"  ng-maxlength=\"60\" class=\"form-control\" required />\r\n            <i class=\"far fa-eye-slash\" ng-click=\"signup.togglePassword('passwordIdConfirm','togglePasswordConfirm')\" id=\"togglePasswordConfirm\"\r\n              style=\"cursor: pointer;\"></i>\r\n            </div>\r\n            <div ng-messages=\"signupForm.confirmPassword.$error\" class=\"form-control-feedback\"\r\n              ng-if=\"signupForm.confirmPassword.$touched || signupForm.$submitted\">\r\n              <div ng-message=\"required\">Confirmation Password is required</div>\r\n              <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n              <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n              <div class=\"error-text\"\r\n                ng-show=\"signupForm.errors.confirmPassword && !signupForm.confirmPassword.$error.required\">\r\n                {{signupForm.errors.confirmPassword[0]}}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\"\r\n            ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.phoneNumber.$touched) && signupForm.phoneNumber.$invalid }\"\r\n            class=\"md-block\" flex-gt-sm>\r\n            <label>Phone*</label>\r\n            <input name=\"phoneNumber\" type=\"tel\" ui-mask=\"(999) 999-9999\" ng-model=\"signup.phoneNumber\"\r\n              class=\"form-control\" required />\r\n            <div ng-messages=\"signupForm.phoneNumber.$error\" class=\"form-control-feedback\"\r\n              ng-if=\"signupForm.phoneNumber.$touched || signupForm.$submitted\">\r\n              <div ng-message=\"required\">Enter Phone Number</div>\r\n              <div ng-message=\"pattern\">Enter a valid Phone Number</div>\r\n              <div class=\"error-text\"\r\n                ng-if=\"signupForm.errors.phoneNumber && !signupForm.phoneNumber.$error.required && !signupForm.phoneNumber.$error.pattern\">\r\n                {{signupForm.errors.phoneNumber[0]}}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group.height\"\r\n            ng-class=\"{'has-danger': (signupForm.$submitted || signupForm.agreement.$touched) && signupForm.agreement.$invalid }\"\r\n            class=\"md-block\" flex-gt-sm>\r\n            <input type=\"checkbox\" name=\"agreement\" ng-model=\"agreement\" class=\"form-control text-xs-left d-inline\"\r\n              style=\"width: auto;\" required />\r\n            <div class=\"d-inline\"> I agree to the <a ui-sref=\"rules\" class=\"link-text\">Rules </a>and <a ui-sref=\"tnc\"\r\n                class=\"link-text\">Terms and Conditions.</a></div>\r\n            <div ng-messages=\"signupForm.agreement.$error\" class=\"form-control-feedback\"\r\n              ng-if=\"signupForm.agreement.$touched || signupForm.$submitted\">\r\n              <div ng-message=\"required\">Please agree to rules and the terms and conditions.</div>\r\n              <div class=\"error-text\"\r\n                ng-if=\"signupForm.errors.agreement && !signupForm.agreement.$error.required && !signupForm.agreement.$error.pattern\">\r\n                {{signupForm.errors.agreement[0]}}</div>\r\n            </div>\r\n          </div>\r\n          <button type=\"submit\" class=\"btn btn-primary m-t-1 btn-block btn-sm-text\" ng-disabled=\"signup.isRegistering\">\r\n            <span>Register</span>\r\n          </button>\r\n          <!-- <p class=\"text-xs-center gray-text mb-4\">\r\n            By clicking submit you are agreeing to the <a ui-sref=\"rules\" class=\"link-text\">Rules </a>and <a ui-sref=\"tnc\" class=\"link-text\">Terms and Conditions.</a>\r\n          </p> -->\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row p-t-2 m-x-0\" ng-if=\"signup.requestSent\">\r\n  <div class=\"col-xs-10 offset-xs-1\">\r\n    <div ng-if=\"!signup.success && !signup.error\">\r\n      <h4 class=\"font-weight-bold\">Welcome</h4>\r\n      <p class=\"m-t-1\" ng-if=\"signup.emailUpdated\">We have emailed you a verification link on your updated email.</p>\r\n      <p class=\"m-t-1\" ng-if=\"!signup.emailUpdated\">One more step! We have sent an email to {{signup.email}} to verify\r\n        your identity. Please use this email to finalize your account setup.</p>\r\n      <li ng-bind-html=\"signup.$sce.trustAsHtml(signup.textline1)\"></li>\r\n      <li ng-bind-html=\"signup.$sce.trustAsHtml(signup.textline2)\"></li>\r\n      <li ng-bind-html=\"signup.$sce.trustAsHtml(signup.textline3)\"></li>\r\n\r\n      <div class=\"col-xs-12 col-md-4\">\r\n        <button type=\"button\" class=\"btn btn-primary btn-block m-t-3 btn-sm-text\" ng-click=\"signup.resendEmail()\">Resend\r\n          Email</button>\r\n      </div>\r\n      <div class=\"col-xs-12 col-md-4\">\r\n        <button type=\"button\" class=\"btn btn-primary btn-block m-t-3 btn-sm-text\"\r\n          ui-sref=\"login({storeName: signup.storeName})\">Go to Login Page</button>\r\n      </div>\r\n    </div>\r\n\r\n    <div ng-if=\"signup.success\">\r\n      <h5 class=\"font-weight-bold\">Email Sent</h5>\r\n      <p class=\"m-t-1\">We have sent an e-mail to <strong>{{signup.email}}</strong></p>\r\n      <p class=\"m-t-1\">Please click on the link sent to verify your email address.</p>\r\n    </div>\r\n\r\n    <div ng-if=\"signup.error\">\r\n      <h5 class=\"font-weight-bold\">Email Sending Failed</h5>\r\n      <p class=\"m-t-1\">We could not send an e-mail to <strong>{{signup.email}}</strong></p>\r\n      <p class=\"m-t-1\">Retry after sometime.</p>\r\n    </div>\r\n  </div>\r\n</div>\r\n<style type=\"text/css\">\r\n  .signup-form {\r\n    min-width: 400px;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  @media (max-width : 544px) {\r\n    .signup-form {\r\n      min-width: 80%;\r\n      max-width: 80%;\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n\r\n  .material-switch>input[type=\"checkbox\"] {\r\n    display: none;\r\n  }\r\n\r\n  .material-switch>label {\r\n    cursor: pointer;\r\n    height: 0px;\r\n    position: relative;\r\n    width: 40px;\r\n  }\r\n\r\n  .material-switch>label::before {\r\n    background: rgb(0, 0, 0);\r\n    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n    border-radius: 8px;\r\n    content: '';\r\n    height: 16px;\r\n    margin-top: -8px;\r\n    position: absolute;\r\n    opacity: 0.3;\r\n    transition: all 0.4s ease-in-out;\r\n    width: 40px;\r\n  }\r\n\r\n  .material-switch>label::after {\r\n    background: rgb(255, 255, 255);\r\n    border-radius: 16px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\r\n    content: '';\r\n    height: 24px;\r\n    left: -4px;\r\n    margin-top: -8px;\r\n    position: absolute;\r\n    top: -4px;\r\n    transition: all 0.3s ease-in-out;\r\n    width: 24px;\r\n  }\r\n\r\n  .material-switch>input[type=\"checkbox\"]:checked+label::before {\r\n    background: inherit;\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .material-switch>input[type=\"checkbox\"]:checked+label::after {\r\n    background: inherit;\r\n    left: 20px;\r\n  }\r\n\r\n  .label-success {\r\n    background-color: #5cb85c;\r\n  }\r\n\r\n  [type=\"radio\"] {\r\n    visibility: visible;\r\n  }\r\n</style>"

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _forgotPassword = __webpack_require__(118);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _resetPass = __webpack_require__(119);
	
	var _resetPass2 = _interopRequireDefault(_resetPass);
	
	var _tickSent = __webpack_require__(115);
	
	var _tickSent2 = _interopRequireDefault(_tickSent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForgotPasswordContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'forgotPwd',
	  template: _forgotPassword2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ForgotPasswordContainer(authService) {
	    _classCallCheck(this, ForgotPasswordContainer);
	
	    this.authService = authService;
	    this.resetPwdImg = _resetPass2.default;
	    this.confirmImg = _tickSent2.default;
	  }
	
	  _createClass(ForgotPasswordContainer, [{
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      form.error = {};
	      this.authService.forgotPassword({
	        email: this.email
	      }).then(function () {
	        return _this.requestSent = true;
	      }).catch(function (err) {
	        return form.error = err.data;
	      });
	    }
	  }]);
	
	  return ForgotPasswordContainer;
	}(), _class2.$inject = ['authService'], _temp)) || _class);
	exports.default = ForgotPasswordContainer;

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row m-x-0\">\r\n  <div class=\"col-xs-12 secondary-bg p-y-1 text-xs-center\">\r\n    <img src={{forgotPwd.resetPwdImg}}\r\n      height=\"95\" ng-if=\"!forgotPwd.requestSent\" class=\"m-y-1\" />\r\n    <img src={{forgotPwd.confirmImg}}\r\n      height=\"95\" ng-if=\"forgotPwd.requestSent\" class=\"m-y-1\" />\r\n  </div>\r\n  <div class=\"row m-x-0 bg-color\">\r\n    <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2\">\r\n      <div class=\"p-t-2\" ng-if=\"!forgotPwd.requestSent\">\r\n        <h5 class=\"font-weight-bold\">Forgot your password?</h5>\r\n        <p class=\"gray-text m-t-1 p-b-2\">Enter your email address below and we'll send you a secured link to reset your password.</p>\r\n        <form name=\"forgotPwdForm\"\r\n          ng-submit=\"forgotPwd.submit(forgotPwdForm)\"\r\n          autocomplete=\"off\"\r\n          novalidate>\r\n          <div class=\"error-text\" ng-bind=\"forgotPwdForm.error.message\"></div>\r\n          <div class=\"form-group\"\r\n            ng-class=\"{'has-danger': (forgotPwdForm.$submitted || forgotPwdForm.email.$touched) && forgotPwdForm.email.$invalid }\">\r\n            <label>Email</label>\r\n            <input name=\"email\"\r\n              type=\"email\"\r\n              ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n              ng-model=\"forgotPwd.email\"\r\n              class=\"form-control\" \r\n              required />\r\n            <div ng-messages=\"forgotPwdForm.email.$error\"\r\n              class=\"form-control-feedback\"\r\n              ng-if=\"forgotPwdForm.email.$touched || forgotPwdForm.$submitted\">\r\n              <div ng-message=\"required\">Enter email address</div>\r\n              <div ng-message=\"pattern\">Enter a valid email address</div>\r\n              <div ng-message=\"email\">Enter a valid email address</div>\r\n              <div class=\"error-text\" ng-show=\"forgotPwdForm.errors.email && !forgotPwdForm.email.$error.required && !forgotPwdForm.email.$error.pattern\">{{ forgotPwdForm.errors.email[0] }}</div>\r\n            </div>\r\n          </div>\r\n          <button type=\"submit\" class=\"btn btn-primary btn-block m-y-2 btn-sm-text\" ng-disabled=\"forgotPwd.isRegistering\">\r\n            <span>Reset Password</span>\r\n            <span class=\"spinner\" ng-show=\"forgotPwd.isRegistering\">\r\n              <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\r\n            </span>\r\n          </button>\r\n        </form>\r\n      </div>\r\n\r\n      <div class=\"p-t-2\" ng-if=\"forgotPwd.requestSent\">\r\n        <h5 class=\"font-weight-bold\">Email Sent</h5>\r\n        <p class=\"m-t-1\">We have sent an e-mail to <strong>{{forgotPwd.email}}</strong></p>\r\n        <p class=\"gray-text m-t-1\">Click the secure link we sent you to reset your password.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _resetPassword = __webpack_require__(121);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _resetPass = __webpack_require__(122);
	
	var _resetPass2 = _interopRequireDefault(_resetPass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResetPasswordContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'resetPwd',
	  template: _resetPassword2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ResetPasswordContainer($state, $stateParams, authService) {
	    _classCallCheck(this, ResetPasswordContainer);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.authService = authService;
	    this.resetPwdImg = _resetPass2.default;
	  }
	
	  _createClass(ResetPasswordContainer, [{
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      form.error = {};
	      if (this.password === this.confirmPassword) {
	        this.authService.resetPassword({
	          password: this.password,
	          id: this.$stateParams.id,
	          token: this.$stateParams.token
	        }).then(function () {
	          return _this.$state.go('category', { storeName: _this.$stateParams.storeName });
	        }).catch(function (err) {
	          return form.error = err.data;
	        });
	      } else {
	        form.error.message = 'Password mismatch';
	      }
	    }
	  }]);
	
	  return ResetPasswordContainer;
	}(), _class2.$inject = ['$state', '$stateParams', 'authService'], _temp)) || _class);
	exports.default = ResetPasswordContainer;

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row m-x-0\">\r\n  <div class=\"col-xs-12 secondary-bg p-y-1 text-xs-center\">\r\n    <img src={{resetPwd.resetPwdImg}} height=\"95\" class=\"m-y-1\" />\r\n  </div>\r\n  <div class=\"row m-x-0 bg-color\">\r\n    <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2 p-t-2\" ng-if=\"!forgotPwd.requestSent\">\r\n      <form name=\"resetPwdForm\"\r\n        ng-submit=\"resetPwd.submit(resetPwdForm)\"\r\n        autocomplete=\"off\"\r\n        novalidate>\r\n        <div class=\"error-text\" ng-bind=\"resetPwdForm.error.message\"></div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (resetPwdForm.$submitted || resetPwdForm.password.$touched) && resetPwdForm.password.$invalid }\">\r\n          <label>New Password</label>\r\n          <input name=\"password\"\r\n            type=\"password\"\r\n            ng-model=\"resetPwd.password\"\r\n            ng-minlength=\"6\"\r\n            ng-maxlength=\"60\"\r\n            class=\"form-control\" \r\n            required>\r\n          <div ng-messages=\"resetPwdForm.password.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"resetPwdForm.password.$touched || resetPwdForm.$submitted\">\r\n            <div ng-message=\"required\">Password is required</div>\r\n            <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n            <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n            <div class=\"error-text\"\r\n              ng-show=\"resetPwdForm.errors.password && !resetPwdForm.password.$error.required\">{{ resetPwdForm.errors.password[0] }}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (resetPwdForm.$submitted || resetPwdForm.confirmPassword.$touched) && resetPwdForm.confirmPassword.$invalid }\">\r\n          <label>Confirm New Password</label>\r\n          <input name=\"confirmPassword\"\r\n            type=\"password\"\r\n            ng-model=\"resetPwd.confirmPassword\"\r\n            ng-minlength=\"6\"\r\n            ng-maxlength=\"60\"\r\n            class=\"form-control\" \r\n            required>\r\n          <div ng-messages=\"resetPwdForm.confirmPassword.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"resetPwdForm.confirmPassword.$touched || resetPwdForm.$submitted\">\r\n            <div ng-message=\"required\">Password is required</div>\r\n            <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n            <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n            <div class=\"error-text\"\r\n              ng-show=\"resetPwdForm.errors.confirmPassword && !resetPwdForm.confirmPassword.$error.required\">{{ resetPwdForm.errors.confirmPassword[0] }}</div>\r\n          </div>\r\n        </div>\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block m-b-1 m-t-2 btn-sm-text\" ng-disabled=\"resetPwd.isRegistering\">\r\n          <span>Save Password</span>\r\n          <span class=\"spinner\" ng-show=\"resetPwd.isRegistering\">\r\n            <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\r\n          </span>\r\n        </button>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _activate = __webpack_require__(124);
	
	var _activate2 = _interopRequireDefault(_activate);
	
	var _resetPass = __webpack_require__(119);
	
	var _resetPass2 = _interopRequireDefault(_resetPass);
	
	var _tickSent = __webpack_require__(115);
	
	var _tickSent2 = _interopRequireDefault(_tickSent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActivateContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'activate',
	  template: _activate2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ActivateContainer($scope, $stateParams, $ngRedux, authActions, authService, $window) {
	    _classCallCheck(this, ActivateContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$ngRedux = $ngRedux;
	    this.$stateParams = $stateParams;
	    this.authActions = authActions;
	    this.authService = authService;
	    this.resetPwdImg = _resetPass2.default;
	    this.confirmImg = _tickSent2.default;
	    this.storeName = $stateParams.storeName;
	    this.activate();
	    this.$window = $window;
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(ActivateContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        auth: state.auth
	      };
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var _this = this;
	
	      this.authService.activate({
	        id: this.$stateParams.id,
	        token: this.$stateParams.token
	      }).then(function () {
	        return _this.activationsuccess = true;
	      }).catch(function (err) {
	        //  console.log(err);
	        if (err.data.errorCode === 624) {
	          _this.alreadyUser = 'You have already successfully registered using this Activation.';
	        } else {
	          _this.activationerror = err.data.message;
	        }
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this2 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      this.activationerror = null;
	      this.error = null;
	      this.authService.resendEmail({
	        id: this.$stateParams.id,
	        email: this.email
	      }).then(function (success) {
	        return _this2.success = success.data.message;
	      }).catch(function (err) {
	        return _this2.error = err.data.message;
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      this.$window.location.href = '/' + this.storeName;
	    }
	  }]);
	
	  return ActivateContainer;
	}(), _class2.$inject = ['$scope', '$stateParams', '$ngRedux', 'authActions', 'authService', '$window'], _temp)) || _class);
	exports.default = ActivateContainer;

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row m-x-0\">\r\n  <div class=\"col-xs-12 secondary-bg p-y-1 text-xs-center\">\r\n    <img src={{activate.resetPwdImg}}\r\n      height=\"95\" ng-if=\"activate.activationerror || activate.error\" class=\"m-y-1\" />\r\n    <img src={{activate.confirmImg}}\r\n      height=\"95\" ng-if=\"activate.activationsuccess || activate.success\" class=\"m-y-1\" />\r\n  </div>\r\n</div>\r\n<div class=\"row m-x-0 bg-color\">\r\n  <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2 p-t-2\">\r\n\r\n    <div ng-if=\"activate.alreadyUser\">\r\n      <h5 class=\"font-weight-bold\">Account already registered.</h5>\r\n      <p class=\"gray-text m-t-1\">{{activate.alreadyUser}}</p>\r\n      <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n              ng-click=\"activate.login()\">Go to Home</button>\r\n    </div>\r\n    \r\n    <div ng-if=\"activate.activationerror\">\r\n      <h5 class=\"font-weight-bold\">Activation failed?</h5>\r\n      <p class=\"gray-text m-t-1\">Enter your email address below and we'll resend you a secured link to activate your account.</p>\r\n      <form name=\"activateForm\"\r\n        ng-submit=\"activate.submit(activateForm)\"\r\n        autocomplete=\"off\"\r\n        novalidate>\r\n        <div class=\"success-text\" ng-bind=\"activate.success\"></div>\r\n        <div class=\"error-text\" ng-bind=\"activate.error\"></div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (activateForm.$submitted || activateForm.email.$touched) && activateForm.email.$invalid }\">\r\n          <label>Email</label>\r\n          <input name=\"email\"\r\n            type=\"email\"\r\n            ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n            class=\"form-control\"\r\n            ng-model=\"activate.email\"\r\n            required />\r\n          <div ng-messages=\"activateForm.email.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"activateForm.email.$touched || activateForm.$submitted\">\r\n            <div ng-message=\"required\">Enter email address</div>\r\n            <div ng-message=\"email\">Enter a valid email address</div>\r\n            <div ng-message=\"pattern\">Enter a valid email address</div>\r\n            <div class=\"error-text\" ng-show=\"activateForm.errors.email && !activateForm.email.$error.required && !activateForm.email.$error.pattern\">{{activateForm.errors.email[0]}}</div>\r\n          </div>\r\n        </div>\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block m-y-2 btn-sm-text\">\r\n          <span>Resend Email</span>\r\n        </button>\r\n      </form>\r\n    </div>\r\n\r\n\r\n\r\n    <div ng-if=\"activate.activationsuccess\">\r\n      <h5 class=\"font-weight-bold\">Account activated</h5>\r\n      <p class=\"gray-text m-t-1\">Your account has been successfully activated. Login with your credentials.</p>\r\n      <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ng-click=\"activate.login()\">Go to Home</button>\r\n    </div>\r\n\r\n    <div ng-if=\"activate.success\">\r\n      <h5 class=\"font-weight-bold\">Email Sent</h5>\r\n      <p class=\"m-t-1\">We have sent an e-mail to <strong>{{activate.email}}</strong></p>\r\n      <p class=\"m-t-1\">Please click on the link sent to verify your email address.</p>\r\n    </div>\r\n\r\n    <div ng-if=\"activate.error\">\r\n      <h5 class=\"font-weight-bold\">Email Sending Failed</h5>\r\n      <p class=\"m-t-1\">We could not send an e-mail to <strong>{{activate.email}}</strong></p>\r\n      <p class=\"m-t-1\">Retry after sometime.</p>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _inactive = __webpack_require__(126);
	
	var _inactive2 = _interopRequireDefault(_inactive);
	
	var _resetPass = __webpack_require__(119);
	
	var _resetPass2 = _interopRequireDefault(_resetPass);
	
	var _tickSent = __webpack_require__(115);
	
	var _tickSent2 = _interopRequireDefault(_tickSent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InactiveContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'inactive',
	  template: _inactive2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function InactiveContainer($scope, $stateParams, $ngRedux, authActions, authService) {
	    _classCallCheck(this, InactiveContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$ngRedux = $ngRedux;
	    this.$stateParams = $stateParams;
	    this.authActions = authActions;
	    this.authService = authService;
	    this.resetPwdImg = _resetPass2.default;
	    this.confirmImg = _tickSent2.default;
	    this.storeName = $stateParams.storeName;
	    this.userInactive = true;
	    this.sendmail = true;
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(InactiveContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        auth: state.auth
	      };
	    }
	
	    // activate() {
	    //   this.authService.activateUser(this.email)
	    //     .then(() => this.activationsuccess = true)
	    //     .catch(err => {
	    //       console.log(err);
	    //       if (err.data.errorCode === 624 ) {
	    //         this.alreadyUser = 'You have already successfully registered using this Activation.';
	    //       }
	    //       else {
	    //         this.activationerror = err.data.message;
	    //       }
	    //     });
	    // }
	
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      this.activationerror = null;
	      this.error = null;
	      if (this.sendmail) {
	        this.authService.activateUser(this.email).then(function (success) {
	          _this.userInactive = false;
	          _this.success = success.data.message;
	        }).catch(function (err) {
	          _this.userInactive = false;
	          _this.error = err.data.message;
	        });
	        this.sendmail = false;
	      }
	    }
	  }]);
	
	  return InactiveContainer;
	}(), _class2.$inject = ['$scope', '$stateParams', '$ngRedux', 'authActions', 'authService'], _temp)) || _class);
	exports.default = InactiveContainer;

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row m-x-0\">\r\n  <div class=\"col-xs-12 secondary-bg p-y-1 text-xs-center\">\r\n    <img src={{inactive.resetPwdImg}}\r\n      height=\"95\" ng-if=\"inactive.userInactive || inactive.error\" class=\"m-y-1\" />\r\n    <img src={{inactive.confirmImg}}\r\n      height=\"95\" ng-if=\"inactive.success\" class=\"m-y-1\" />\r\n  </div>\r\n</div>\r\n<div class=\"row m-x-0 bg-color\">\r\n  <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2 p-t-2\">\r\n\r\n    <!-- <div ng-if=\"inactive.alreadyUser\">\r\n      <h5 class=\"font-weight-bold\">Account already registered.</h5>\r\n      <p class=\"gray-text m-t-1\">{{inactive.alreadyUser}}</p>\r\n      <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ui-sref=\"login({storeName: inactive.storeName})\">Go to Login</button>\r\n    </div> -->\r\n    \r\n    <div ng-if=\"inactive.userInactive || inactive.error\">\r\n      <h5 class=\"font-weight-bold\">Activate your account</h5>\r\n      <p class=\"gray-text m-t-1\">Enter your email address below and we'll send you a secured link to activate your account.</p>\r\n      <form name=\"activateForm\"\r\n        ng-submit=\"inactive.submit(activateForm)\"\r\n        autocomplete=\"off\"\r\n        novalidate>\r\n        <div class=\"success-text\" ng-bind=\"inactive.success\"></div>\r\n        <div class=\"error-text\" ng-bind=\"inactive.error\"></div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (activateForm.$submitted || activateForm.email.$touched) && activateForm.email.$invalid }\">\r\n          <label>Email</label>\r\n          <input name=\"email\"\r\n            type=\"email\"\r\n            ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n            class=\"form-control\"\r\n            ng-model=\"inactive.email\"\r\n            required />\r\n          <div ng-messages=\"activateForm.email.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"activateForm.email.$touched || activateForm.$submitted\">\r\n            <div ng-message=\"required\">Enter email address</div>\r\n            <div ng-message=\"pattern\">Enter a valid email address</div>\r\n            <div ng-message=\"email\">Enter a valid email address</div>\r\n            <div class=\"error-text\" ng-show=\"activateForm.errors.email && !activateForm.email.$error.required && !activateForm.email.$error.pattern\">{{activateForm.errors.email[0]}}</div>\r\n          </div>\r\n        </div>\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block m-y-2 btn-sm-text\">\r\n          <span>Send Email</span>\r\n        </button>\r\n      </form>\r\n    </div>\r\n\r\n\r\n\r\n    <!-- <div ng-if=\"inactive.activationsuccess\">\r\n      <h5 class=\"font-weight-bold\">Account activated</h5>\r\n      <p class=\"gray-text m-t-1\">Your account has been successfully activated. Login with your credentials.</p>\r\n      <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ui-sref=\"login({storeName: inactive.storeName})\">Go to Login</button>\r\n    </div> -->\r\n\r\n    <div ng-if=\"inactive.success\">\r\n      <h5 class=\"font-weight-bold\">Email Sent</h5>\r\n      <p class=\"m-t-1\">We have sent an e-mail to <strong>{{inactive.email}}</strong></p>\r\n      <p class=\"m-t-1\">Please click on the link sent to verify your email address.</p>\r\n    </div>\r\n\r\n    <!-- <div ng-if=\"inactive.error\">\r\n      <h5 class=\"font-weight-bold\">Email Sending Failed</h5>\r\n      <div class=\"error-text\" ng-bind=\"inactive.error\"></div>\r\n      <p class=\"m-t-1\">We could not send an e-mail to <strong>{{inactive.email}}</strong></p>\r\n      <p class=\"m-t-1\">Retry after sometime.</p>\r\n    </div> -->\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _otpactive = __webpack_require__(128);
	
	var _otpactive2 = _interopRequireDefault(_otpactive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OtpActivateContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'otpactivate',
	  template: _otpactive2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function OtpActivateContainer($scope, $stateParams, $ngRedux, authActions, authService, $state) {
	    _classCallCheck(this, OtpActivateContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$state = $state;
	    this.$ngRedux = $ngRedux;
	    this.$stateParams = $stateParams;
	    this.authActions = authActions;
	    this.authService = authService;
	    this.storeName = $stateParams.storeName;
	    this.userInactive = true;
	    this.registeredEmail = this.$stateParams.email;
	    this.otp = null;
	    this.startCountdown(60);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(OtpActivateContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        auth: state.auth
	      };
	    }
	  }, {
	    key: 'startCountdown',
	    value: function startCountdown(seconds) {
	      var counter = seconds;
	      var ctrl = this;
	      var interval = setInterval(function () {
	        var m = Math.floor(counter / 60);
	        var s = counter % 60;
	        var timerMsg = document.getElementById("timerMsg");
	        var resendEmail = document.getElementById("resendEmail");
	        if (resendEmail) {
	          resendEmail.disabled = true;
	        }
	        m = m < 10 ? '0' + m : m;
	        s = s < 10 ? '0' + s : s;
	        counter--;
	        if (timerMsg) {
	          timerMsg.innerHTML = 'Please wait to resend email for ' + m + ':' + s;
	        }
	        if (counter < 0) {
	          if (resendEmail) {
	            resendEmail.disabled = false;
	          }
	          if (timerMsg) {
	            timerMsg.innerHTML = '';
	          }
	          clearInterval(interval);
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      this.activationerror = null;
	      this.error = null;
	      this.authService.oTPactivate({
	        id: this.$stateParams.id,
	        otp: this.otp
	      }).then(function (success) {
	        _this.userInactive = false;
	        _this.success = success.data.message;
	        setTimeout(function () {
	          _this.login();
	        }, 200);
	      }).catch(function (err) {
	        _this.userInactive = true;
	        _this.error = err.data.message;
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      this.$state.go('login');
	    }
	  }, {
	    key: 'resendEmail',
	    value: function resendEmail() {
	      var _this2 = this;
	
	      this.resendEmailsuccess = null;
	      this.resendEmailerror = null;
	      if (this.$stateParams && this.$stateParams.email) {
	        this.authService.resendEmail({
	          id: this.$stateParams.id,
	          email: this.$stateParams.email
	        }).then(function (success) {
	          return _this2.resendEmailsuccess = success.data.message;
	        }).catch(function (err) {
	          return _this2.resendEmailerror = err.data.message;
	        });
	        this.startCountdown(60);
	      } else {
	        this.$state.go('inactive');
	      }
	    }
	  }]);
	
	  return OtpActivateContainer;
	}(), _class2.$inject = ['$scope', '$stateParams', '$ngRedux', 'authActions', 'authService', '$state'], _temp)) || _class);
	exports.default = OtpActivateContainer;

/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row p-t-2 m-x-0 bg-color\">\r\n  <div class=\"col-md-8 offset-md-2 col-xs-12 p-t-2\">\r\n    <h4 class=\"font-weight-bold\">Welcome</h4>\r\n    <p class=\"m-t-1\">\r\n        One more step! We have sent an email to {{otpactivate.registeredEmail}} to verify your identity. Please use this email to finalize your account setup.\r\n    </p>\r\n    <li>\r\n      Please allow up to 5 minutes before clicking the 'Resend Email' button.\r\n    </li>\r\n    <li>\r\n      This email may end up in your junk or spam folder. Please whitelist\r\n      donotreply@wbu.com to ensure delivery.\r\n    </li>\r\n    <li>\r\n      If you click 'Resend Email' please choose on the most recently sent email\r\n      to confirm your email address.\r\n    </li>\r\n  </div>\r\n  <div class=\"col-md-8 offset-md-2 col-xs-12 p-t-2\">\r\n    <div class=\"success-text\" ng-if=\"otpactivate.resendEmailsuccess\">Verification email sent</div>\r\n    <div class=\"error-text\" ng-bind=\"otpactivate.resendEmailerror\"></div>\r\n  </div>\r\n  <div\r\n    class=\"col-md-8 offset-md-2 col-xs-12 p-t-2\"\r\n    ng-if=\"otpactivate.userInactive || otpactivate.error\"\r\n  >\r\n    <h5 class=\"font-weight-bold\">Activate your account</h5>\r\n    <p class=\"gray-text m-t-1 p-l-1\">\r\n      Enter the one-time password sent to your email address\r\n    </p>\r\n    <form\r\n      name=\"activateForm\"\r\n      ng-submit=\"otpactivate.submit(activateForm)\"\r\n      autocomplete=\"off\"\r\n      novalidate\r\n    >\r\n      <div class=\"col-xs-12 col-md-4\">\r\n        <input\r\n          name=\"otp\"\r\n          type=\"text\"\r\n          ng-pattern=\"/^[0-9]*$/\"\r\n          maxlength=\"6\"\r\n          class=\"form-control\"\r\n          ng-model=\"otpactivate.otp\"\r\n          required\r\n        />\r\n        <div\r\n          ng-messages=\"activateForm.otp.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-if=\"activateForm.otp.$touched || activateForm.$submitted\"\r\n        >\r\n          <div ng-message=\"required\">Enter one-time password</div>\r\n          <div ng-message=\"pattern\">Enter a valid one-time password</div>\r\n          <div ng-message=\"otp\">Enter a valid one-time password</div>\r\n          <div\r\n            class=\"error-text\"\r\n            ng-show=\"activateForm.errors.otp && !activateForm.otp.$error.required && !activateForm.otp.$error.pattern\"\r\n          >\r\n            {{activateForm.errors.otp[0]}}\r\n          </div>\r\n        </div>\r\n        <div class=\"success-text\" ng-bind=\"otpactivate.success\"></div>\r\n        <div class=\"error-text\" ng-bind=\"otpactivate.error\"></div>\r\n        <div\r\n          class=\"form-group\"\r\n          ng-class=\"{'has-danger': (activateForm.$submitted || activateForm.otp.$touched) && activateForm.otp.$invalid }\"\r\n        ></div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-md-4\">\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block btn-sm-text\">\r\n          <span>Submit</span>\r\n        </button>\r\n      </div>\r\n      <div class=\"col-xs-12 col-md-4\">\r\n        <button\r\n          id=\"resendEmail\"\r\n          type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-sm-text\"\r\n          ng-click=\"otpactivate.resendEmail()\"\r\n        >\r\n          Resend Email\r\n        </button>\r\n      </div>\r\n      <div class=\"col-xs-12 col-md-12\">\r\n        <p class=\"gray-text\">\r\n          <span id=\"timerMsg\"></span>\r\n        </p>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n  <div class=\"col-md-8 offset-md-2 col-xs-12\">\r\n    <!-- <div class=\"col-xs-12 col-md-4\">\r\n      <button type=\"submit\" class=\"btn btn-primary btn-block btn-sm-text\">\r\n        <span>Submit</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"col-xs-12 col-md-4\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn btn-primary btn-block btn-sm-text\"\r\n        ng-click=\"otpactivate.resendEmail()\"\r\n      >\r\n        Resend Email\r\n      </button>\r\n    </div> -->\r\n    <!-- <div class=\"col-xs-12 col-md-4\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn btn-primary btn-block btn-sm-text\"\r\n        ui-sref=\"login({storeName: signup.storeName})\"\r\n      >\r\n        Go to Login Page\r\n      </button>\r\n    </div> -->\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _subscriptionEmail = __webpack_require__(130);
	
	var _subscriptionEmail2 = _interopRequireDefault(_subscriptionEmail);
	
	var _resetPass = __webpack_require__(119);
	
	var _resetPass2 = _interopRequireDefault(_resetPass);
	
	var _tickSent = __webpack_require__(115);
	
	var _tickSent2 = _interopRequireDefault(_tickSent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActivateContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'subscriptionEmail',
	  template: _subscriptionEmail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ActivateContainer($scope, $stateParams, $ngRedux, authActions, authService) {
	    _classCallCheck(this, ActivateContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$ngRedux = $ngRedux;
	    this.$stateParams = $stateParams;
	    this.authActions = authActions;
	    this.authService = authService;
	    this.resetPwdImg = _resetPass2.default;
	    this.confirmImg = _tickSent2.default;
	    this.storeName = $stateParams.storeName;
	    this.activate();
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(ActivateContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        auth: state.auth
	      };
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var _this = this;
	
	      this.authService.cancelSubscriptionfromEmail({
	        token: this.$stateParams.token
	      }).then(function () {
	        return _this.activationsuccess = true;
	      }).catch(function (err) {
	        //  console.log(err);
	        if (err.data.errorCode === 624) {
	          _this.alreadyUser = 'The Subscripiton Cycle is expired';
	        } else {
	          _this.activationerror = err.data.message;
	        }
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      if (form.$invalid) {
	        return;
	      }
	    }
	  }]);
	
	  return ActivateContainer;
	}(), _class2.$inject = ['$scope', '$stateParams', '$ngRedux', 'authActions', 'authService'], _temp)) || _class);
	exports.default = ActivateContainer;

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row m-x-0\">\r\n  <div class=\"col-xs-12 secondary-bg p-y-1 text-xs-center\">\r\n    <img src={{subscriptionEmail.resetPwdImg}}\r\n      height=\"95\" ng-if=\"subscriptionEmail.activationerror || subscriptionEmail.error\" class=\"m-y-1\" />\r\n    <img src={{subscriptionEmail.confirmImg}}\r\n      height=\"95\" ng-if=\"subscriptionEmail.activationsuccess || subscriptionEmail.success\" class=\"m-y-1\" />\r\n  </div>\r\n</div>\r\n<div class=\"row m-x-0 bg-color\">\r\n  <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2 p-t-2\">\r\n\r\n\r\n    <div ng-if=\"subscriptionEmail.activationerror\">\r\n      <h5 class=\"font-weight-bold\">Your Subscripiton cycle is expired.</h5>\r\n       <p class=\"gray-text m-t-1\">Please login to manage with your credentials.</p>\r\n       <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ui-sref=\"login({storeName: subscriptionEmail.storeName})\">Go to Login</button>\r\n    </div>\r\n\r\n\r\n    <div ng-if=\"subscriptionEmail.activationsuccess\">\r\n      <h5 class=\"font-weight-bold\">Subscription Cancelled</h5>\r\n      <p class=\"gray-text m-t-1\">Your subscription has been successfully cancelled. Login with your credentials.</p>\r\n\r\n      <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ui-sref=\"login({storeName: subscriptionEmail.storeName})\">Go to Login</button>\r\n    </div>\r\n\r\n    \r\n  </div>\r\n</div>\r\n"

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _subscriptionModify = __webpack_require__(132);
	
	var _subscriptionModify2 = _interopRequireDefault(_subscriptionModify);
	
	var _resetPass = __webpack_require__(119);
	
	var _resetPass2 = _interopRequireDefault(_resetPass);
	
	var _tickSent = __webpack_require__(115);
	
	var _tickSent2 = _interopRequireDefault(_tickSent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActivateContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'subscriptionModify',
	  template: _subscriptionModify2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ActivateContainer($scope, $stateParams, $ngRedux, authActions, authService, $state) {
	    _classCallCheck(this, ActivateContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$ngRedux = $ngRedux;
	    this.$stateParams = $stateParams;
	    this.authActions = authActions;
	    this.authService = authService;
	    this.resetPwdImg = _resetPass2.default;
	    this.confirmImg = _tickSent2.default;
	    this.storeName = $stateParams.storeName;
	    this.$state = $state;
	    this.activate();
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(ActivateContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        auth: state.auth
	      };
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var _this = this;
	
	      this.authService.modifySubscripitonfromEmail({
	        token: this.$stateParams.token
	
	      }).then(function (success) {
	        // console.log(success);
	        var tokensubstring = _this.$stateParams.token.split('_')[1].substring(1);
	        _this.authService.subscriptionmodifyId({ 'id': tokensubstring.substring(0, tokensubstring.length - 1) });
	        _this.$state.go('login', { storeName: _this.$stateParams.storeName });
	      }).catch(function (err) {
	        //  console.log(err);
	        if (err.data.errorCode === 624) {
	          _this.alreadyUser = 'The Subscripiton Cycle is expired';
	        } else {
	          _this.activationerror = err.data.message;
	        }
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      if (form.$invalid) {
	        return;
	      }
	    }
	  }]);
	
	  return ActivateContainer;
	}(), _class2.$inject = ['$scope', '$stateParams', '$ngRedux', 'authActions', 'authService', '$state'], _temp)) || _class);
	exports.default = ActivateContainer;

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row m-x-0\">\r\n  <div class=\"col-xs-12 secondary-bg p-y-1 text-xs-center\">\r\n    <img src={{subscriptionModify.resetPwdImg}}\r\n      height=\"95\" ng-if=\"subscriptionModify.activationerror || subscriptionModify.error\" class=\"m-y-1\" />\r\n    <img src={{subscriptionModify.confirmImg}}\r\n      height=\"95\" ng-if=\"subscriptionModify.activationsuccess || subscriptionModify.success\" class=\"m-y-1\" />\r\n  </div>\r\n</div>\r\n<div class=\"row m-x-0 bg-color\">\r\n  <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2 p-t-2\">\r\n\r\n\r\n    <div ng-if=\"subscriptionModify.activationerror\">\r\n      <h5 class=\"font-weight-bold\">Your Subscripiton cycle is expired.</h5>\r\n       <p class=\"gray-text m-t-1\">Please login to manage with your credentials.</p>\r\n       <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ui-sref=\"login({storeName: subscriptionModify.storeName})\">Go to Login</button>\r\n    </div>\r\n\r\n\r\n    <div ng-if=\"subscriptionModify.activationsuccess\">\r\n      <h5 class=\"font-weight-bold\">Subscription Cancelled</h5>\r\n      <p class=\"gray-text m-t-1\">Your subscription has been successfully cancelled. Login with your credentials.</p>\r\n\r\n      <button class=\"btn btn-primary btn-block m-y-3 btn-sm-text\"\r\n        ui-sref=\"login({storeName: subscriptionModify.storeName})\">Go to Login</button>\r\n    </div>\r\n\r\n    \r\n  </div>\r\n</div>\r\n"

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(134);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _category = __webpack_require__(135);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _userProfile = __webpack_require__(145);
	
	var _userProfile2 = _interopRequireDefault(_userProfile);
	
	var _changePassword = __webpack_require__(151);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _edit = __webpack_require__(153);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _settings = __webpack_require__(155);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _termsConditions = __webpack_require__(157);
	
	var _termsConditions2 = _interopRequireDefault(_termsConditions);
	
	var _rulesFaq = __webpack_require__(159);
	
	var _rulesFaq2 = _interopRequireDefault(_rulesFaq);
	
	var _caWarn = __webpack_require__(161);
	
	var _caWarn2 = _interopRequireDefault(_caWarn);
	
	var _faqBirdsCritters = __webpack_require__(163);
	
	var _faqBirdsCritters2 = _interopRequireDefault(_faqBirdsCritters);
	
	var _faqFranchising = __webpack_require__(165);
	
	var _faqFranchising2 = _interopRequireDefault(_faqFranchising);
	
	var _faqProductWarranties = __webpack_require__(167);
	
	var _faqProductWarranties2 = _interopRequireDefault(_faqProductWarranties);
	
	var _privacy = __webpack_require__(169);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.dashboard', []).config(_router2.default).component('home', _category2.default).component('userProfile', _userProfile2.default).component('editProfile', _edit2.default).component('changePassword', _changePassword2.default).component('settings', _settings2.default).component('termsConditions', _termsConditions2.default).component('rulesFaq', _rulesFaq2.default).component('caWarn', _caWarn2.default).component('birdsCritters', _faqBirdsCritters2.default).component('franchising', _faqFranchising2.default).component('productWarranties', _faqProductWarranties2.default).component('privacy', _privacy2.default);

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routerConfig;
	routerConfig.$inject = ['$stateProvider'];
	
	function routerConfig($stateProvider) {
	  $stateProvider.state({
	    name: 'dashboard',
	    parent: 'app',
	    url: '/dashboard',
	    abstract: true,
	    views: {
	      'header@app': {
	        template: '<header></header>'
	      },
	      'sidenav@app': {
	        template: '<sidenav></sidenav>'
	      }
	    },
	    resolve: {
	      isAuthenticated: ['authService', function (authService) {
	        return authService.isAuthenticated();
	      }]
	    }
	  }).state({
	    name: 'home',
	    parent: 'app',
	    url: '',
	    views: {
	      'content@app': {
	        template: '<home></home>'
	      }
	    },
	    resolve: {
	      isMobileOnly: ['authService', function (authService) {
	        return authService.isMobileOnly();
	      }]
	    }
	  }).state({
	    name: 'profile',
	    parent: 'dashboard',
	    url: '/profile/user',
	    views: {
	      'content@app': {
	        template: '<user-profile></user-profile>'
	      }
	    }
	  }).state({
	    name: 'profile.edit',
	    url: '/edit',
	    views: {
	      'content@app': {
	        template: '<edit-profile></edit-profile>'
	      }
	    }
	  }).state({
	    name: 'changepassword',
	    parent: 'dashboard',
	    url: '/changepassword',
	    views: {
	      'content@app': {
	        template: '<change-password></change-password>'
	      }
	    }
	  }).state({
	    name: 'settings',
	    parent: 'dashboard',
	    url: '/settings',
	    views: {
	      'content@app': {
	        template: '<settings></settings>'
	      }
	    }
	  }).state({
	    name: 'terms-conditions',
	    parent: 'dashboard',
	    url: '/terms-and-conditions',
	    views: {
	      'content@app': {
	        template: '<terms-conditions></terms-conditions>'
	      }
	    }
	  }).state({
	    name: 'privacy',
	    parent: 'dashboard',
	    url: '/privacy',
	    views: {
	      'content@app': {
	        template: '<privacy></privacy>'
	      }
	    }
	  }).state({
	    name: 'cards-management',
	    parent: 'dashboard',
	    url: '/cards-management/:status',
	    views: {
	      'content@app': {
	        template: '<cards-management></cards-management>'
	      }
	    }
	  }).state({
	    name: 'rules-faq',
	    parent: 'dashboard',
	    url: '/rules-faq',
	    views: {
	      'content@app': {
	        template: '<rules-faq></rules-faq>'
	      }
	    }
	  }).state({
	    name: 'faq-birds-critters',
	    parent: 'rules-faq',
	    url: '/birds-and-critters',
	    views: {
	      'content@app': {
	        template: '<birds-critters></birds-critters>'
	      }
	    }
	  }).state({
	    name: 'faq-franchising',
	    parent: 'rules-faq',
	    url: '/franchising',
	    views: {
	      'content@app': {
	        template: '<franchising></franchising>'
	      }
	    }
	  }).state({
	    name: 'faq-product-warranties',
	    parent: 'rules-faq',
	    url: '/product-warranties',
	    views: {
	      'content@app': {
	        template: '<product-warranties></product-warranties>'
	      }
	    }
	  });
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _newOrder = __webpack_require__(136);
	
	var _newOrder2 = _interopRequireDefault(_newOrder);
	
	var _recentOrder = __webpack_require__(137);
	
	var _recentOrder2 = _interopRequireDefault(_recentOrder);
	
	var _favorites = __webpack_require__(138);
	
	var _favorites2 = _interopRequireDefault(_favorites);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _DSC = __webpack_require__(142);
	
	var _DSC2 = _interopRequireDefault(_DSC);
	
	var _bannerImage = __webpack_require__(108);
	
	var _bannerImage2 = _interopRequireDefault(_bannerImage);
	
	var _category = __webpack_require__(143);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _logoS = __webpack_require__(110);
	
	var _logoS2 = _interopRequireDefault(_logoS);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Category = (_dec = (0, _utils.Component)({
	  controllerAs: 'category',
	  template: _category2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Category($scope, $ngRedux, $state, $auth, $order, $interval, $rootScope, $timeout, $stateParams, $window, APP, $location, ngMeta, $uibModal) {
	    var _this = this;
	
	    _classCallCheck(this, Category);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$state = $state;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.newOrderImg = _newOrder2.default;
	    this.recentOrderImg = _recentOrder2.default;
	    this.favoriteImg = _favorites2.default;
	    this.dscImg = _DSC2.default;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$uibModal = $uibModal;
	    this.$auth = $auth;
	    this.$order = $order;
	    this.subHeaderImg = _bannerImage2.default;
	    this.logo = _logoS2.default;
	    this.dscCard = _WBUDSCCard2.default;
	    this.$rootScope = $rootScope;
	    this.$window = $window;
	    this.APP = APP;
	    this.$location = $location;
	    this.ngMeta = ngMeta;
	    this.isMiscelleneousCategory = 4;
	    // this.testPopup2();
	    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '');
	      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + this.$stateParams.storeName;
	    } else {
	      this.canUrl = this.$location.$$absUrl;
	    }
	    // $order.getGiftCards();
	    console.log("this.canUrl.category : ", this.canUrl);
	    this.ngMeta.setTag('canUrl', this.canUrl);
	    this.$interval = $interval;
	    $rootScope.$on('rotateBanner', function () {
	      console.log("Banner will rotate");
	      _this.promoSlider();
	    });
	    $rootScope.$on('rotateMobileBanner', function () {
	      console.log("Mobile Banner will rotate - Code commented now. Will be used in next release");
	      _this.mobilePromoSlider();
	    });
	    this.$window.document.title = this.APP.ORDER.ORDER_URL.siteTitle;
	
	    // this.testPopup1();
	
	    $scope.$on('$destroy', function () {
	      _this.$interval.cancel(_this.promoSlideInterval);
	      _this.$interval.cancel(_this.mobilePromoSlideInterval);
	      disconnect();
	    });
	  }
	
	  _createClass(Category, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      console.log("state.order.tiles", state.order.tiles);
	      return {
	        profile: state.auth.profile,
	        list: state.order.categories,
	        tiles: state.order.tiles,
	        giftCards: state.order.giftCards
	      };
	    }
	  }, {
	    key: 'goToSavingsClub',
	    value: function goToSavingsClub() {
	      // this.closeSideNav();
	      this.$state.go('savings-club', { 'storeName': this.$auth.getGuestStoreDetail().storeName });
	    }
	  }, {
	    key: 'getCarousalSetting',
	    value: function getCarousalSetting() {
	      var carousalHeight = document.getElementById('carousel-item-bar').clientHeight;
	      carousalHeight = 340;
	      // console.log('carousalHeight',carousalHeight);
	      this.settings = {};
	      if (window.innerWidth < 1367) {
	        var img = 2000 + "px " + carousalHeight + "px";
	        this.settings = { "background-size": img };
	        return this.settings;
	      } else {
	        this.settings = { "background-size": "2000px 340px" };
	        return this.settings;
	      }
	    }
	  }, {
	    key: 'getCarousalSettingMob',
	    value: function getCarousalSettingMob() {
	      var carousalHeight = document.getElementById('carousel-item-bar-mob').clientHeight;
	      carousalHeight = 340;
	      // console.log('carousalHeight',carousalHeight);
	      this.settings = {};
	      if (window.innerWidth < 1367) {
	        var img = 2000 + "px " + carousalHeight + "px";
	        this.settings = { "background-size": img };
	        return this.settings;
	      } else {
	        this.settings = { "background-size": "2000px 340px" };
	        return this.settings;
	      }
	    }
	  }, {
	    key: 'goToNextState',
	    value: function goToNextState(item) {
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      // let storeName =  false;
	      if (storeName) {
	        if (this.isMiscellaneousCategory(item)) {
	          this.goToGiftPage(storeName);
	        } else {
	          if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
	            this.$state.go('browse-product', {
	              categoryId: item.category.prettyUrl,
	              subCategoryId: item.subCategoryList[0].prettyUrl,
	              storeName: storeName
	            });
	          } else {
	            this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl, storeName: storeName });
	          }
	        }
	      } else {
	        if (this.isMiscellaneousCategory(item)) {
	          this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
	        } else {
	          if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
	            this.$state.go('browse-product', {
	              categoryId: item.category.prettyUrl,
	              subCategoryId: item.subCategoryList[0].prettyUrl,
	              storeName: this.$auth.getGuestStoreDetail().storeName
	            });
	          } else {
	            // console.log('sc',item.category.id);
	            this.$state.go('browse-sub-category', {
	              categoryId: item.category.prettyUrl, storeName: 'shop'
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'goToNextTile',
	    value: function goToNextTile(item) {
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	
	      if (storeName == null || !storeName) {
	        storeName = 'shop';
	      }
	
	      if (storeName) {
	        if (item.type == this.APP.ORDER.TILES_TYPE.category) {
	          if (this.isMiscellaneousCategory(item)) {
	            if (storeName == "shop") {
	              this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
	            } else {
	              this.goToGiftPage(storeName);
	            }
	          } else {
	            this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl, storeName: storeName });
	          }
	        } else if (item.type == this.APP.ORDER.TILES_TYPE.subcategory) {
	          console.log("item.subcat--", item);
	          this.$state.go('browse-product', {
	            categoryId: item.category.prettyUrl,
	            subCategoryId: item.subCategory.prettyUrl,
	            storeName: storeName
	          });
	        } else {
	          this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl, storeName: storeName });
	        }
	      }
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'getBackgroundTitle',
	    value: function getBackgroundTitle(category) {
	      if (category.alt) {
	        return category.alt;
	      } else {
	        return 'Wild Birds Unlimited';
	      }
	    }
	  }, {
	    key: 'getBackgroundStyle',
	    value: function getBackgroundStyle(category) {
	      if (window.innerWidth < 544) {
	        return category.smallImageUrl;
	      } else if (window.innerWidth < 768) {
	        return category.largeImageUrl;
	      } else {
	        return category.largeImageUrl;
	      }
	    }
	  }, {
	    key: 'getBackgroundTyleStyle',
	    value: function getBackgroundTyleStyle(tile) {
	      if (window.innerWidth < 544) {
	        return tile.smallImageUrl;
	      } else if (window.innerWidth < 768) {
	        return tile.largeImageUrl;
	      } else {
	        return tile.largeImageUrl;
	      }
	    }
	  }, {
	    key: 'syncedToday',
	    value: function syncedToday() {
	      var syncDate = new Date(this.profile.customer.lastSyncDateTime);
	      var currentDate = new Date();
	      return syncDate.getDate() === currentDate.getDate();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'activePromo',
	    value: function activePromo(activeindex) {
	      if (this.$rootScope.promo) {
	        this.$interval.cancel(this.promoSlideInterval);
	        this.$rootScope.promo.promoImages.forEach(function (promo, index) {
	          // console.log(index);
	          promo.active = false;
	          // console.log(index);
	        });
	        this.$rootScope.promo.promoImages[activeindex].active = true;
	        this.promoSlider();
	      }
	    }
	  }, {
	    key: 'promoSlider',
	    value: function promoSlider() {
	      var _this2 = this;
	
	      if (this.$rootScope.promo) {
	        return this.promoSlideInterval = this.$interval(function () {
	          var activeIndex = null;
	          _this2.$rootScope.promo.promoImages.forEach(function (promo, index) {
	            if (promo.active) {
	              activeIndex = index;
	            }
	          });
	          var nextIndex = _this2.$rootScope.promo.promoImages.length - 1 == activeIndex ? 0 : activeIndex + 1;
	          _this2.$rootScope.promo.promoImages[activeIndex].active = false;
	          _this2.$rootScope.promo.promoImages[nextIndex].active = true;
	        }, 10000);
	      }
	    }
	  }, {
	    key: 'activeMobilePromo',
	    value: function activeMobilePromo(activeindex) {
	      if (this.$rootScope.promo) {
	        this.$interval.cancel(this.mobilePromoSlideInterval);
	        this.$rootScope.promo.mobilePromoImages.forEach(function (promo, index) {
	          // console.log(index);
	          promo.active = false;
	          // console.log(index);
	        });
	        this.$rootScope.promo.mobilePromoImages[activeindex].active = true;
	        this.mobilePromoSlider();
	      }
	    }
	  }, {
	    key: 'isMobileDevice',
	    value: function isMobileDevice() {
	      return this.$auth.isMobileLandscapeDevice();
	    }
	  }, {
	    key: 'mobilePromoSlider',
	    value: function mobilePromoSlider() {
	      var _this3 = this;
	
	      if (this.$rootScope.promo) {
	        if (this.$rootScope.promo.mobilePromoImages != null && this.$rootScope.promo.mobilePromoImages.length > 0) {
	          return this.mobilePromoSlideInterval = this.$interval(function () {
	            var activeIndex = null;
	            _this3.$rootScope.promo.mobilePromoImages.forEach(function (promo, index) {
	              if (promo.active) {
	                activeIndex = index;
	              }
	            });
	            var nextIndex = _this3.$rootScope.promo.mobilePromoImages.length - 1 == activeIndex ? 0 : activeIndex + 1;
	            _this3.$rootScope.promo.mobilePromoImages[activeIndex].active = false;
	            _this3.$rootScope.promo.mobilePromoImages[nextIndex].active = true;
	          }, 10000);
	        }
	      }
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isMiscellaneousCategory',
	    value: function isMiscellaneousCategory(item) {
	      if (item) {
	        if (item.category.id === this.isMiscelleneousCategory) {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    }
	  }, {
	    key: 'goToGiftPage',
	    value: function goToGiftPage(store) {
	      this.$state.go('gift-card', { 'storeName': store });
	    }
	  }, {
	    key: 'testPopup1',
	    value: function testPopup1() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        backdrop: 'static',
	        keyboard: false,
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5><span>{{registerPopUp?"Would you like to register?":"Interested in our products!"}}</span></h5></div>\n      <div ng-if="registerPopUp">\n          <div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >\n            <button class="btn btn-primary m-l-1" type="button" ng-click="cancelRegisterPopUp()" >No</button>\n            <button class="btn btn-primary m-l-1" type="button" ng-click="okForRegister()">Yes</button>\n          </div>\n        </div>\n        <div ng-if="marketingPopUp">\n          <div class="form-group.height" style="padding: 15px;">\n              <input type="checkbox" name="agreement" ng-model="agreement" class="form-control text-xs-left d-inline"\n                style="width: auto;" required /> Receive important information about our products.\n          </div>\n          <div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >\n            <button class="btn btn-primary m-l-1" type="button" ng-click="cancelMarketingPopUp()" >No</button>\n            <button class="btn btn-primary m-l-1" type="button" ng-click="okForMarketing()" ng-disabled="!agreement">Yes</button>\n          </div>\n        </div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', function ($rootScope, $scope, $uibModalInstance, $auth) {
	          $scope.registerPopUp = true;
	          $scope.marketingPopUp = false;
	          $scope.agreement = false;
	          $scope.okForRegister = function () {
	            $ctrl.$state.go('signup', {
	              storeName: 'indianapolis'
	            });
	            $uibModalInstance.close();
	          };
	          $scope.cancelRegisterPopUp = function () {
	            $scope.marketingPopUp = true;
	            $scope.registerPopUp = false;
	          };
	          $scope.cancelMarketingPopUp = function () {
	            $uibModalInstance.close();
	          };
	          $scope.okForMarketing = function () {
	            $uibModalInstance.close();
	            $ctrl.doGuestOptIn();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'testPopup2',
	    value: function testPopup2() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        backdrop: 'static',
	        keyboard: false,
	        template: '\n                <div class="modal-body"><a class="close" href="#" ng-click="cancelMarketingPopUp()">&times;</a>\n                    <div class="d-flex flex-column gap-3" style="margin:10px">\n                        <div class="py-2" style="margin-bottom:3px;">\n                          <strong style="font-size: 18px;">Register an account today!*</strong>\n                          <br />\n                          &#x25CF Keep your order history\n                          <br />\n                          &#x25CF Reorder with ease\n                          <br />\n                          &#x25CF Enjoy exclusive offers\n                          <br />\n                          <br />\n                          *Already a Daily Savings Club Member? Register with the same email you use in-store to access your member savings online instantly.\n                          <br />\n                          <button class="btn btn-primary btn-block" ng-click="okForRegister()">Register NOW!</button>\n                        </div>\n\n                        <div class="py-2" style="margin-bottom:3px; margin-top:10%">\n                          <strong style="font-size: 18px;">Stay Connected!</strong>\n                          <br />\n                          &#x25CF Join our email community and never miss what\u2019s new.\n                          <br />\n                          &#x25CF Receive helpful bird-feeding tips and seasonal savvy advice.\n                          <br />\n                          &#x25CF Eligible for special offers from your local store.\n                          <br />\n                          <button class="btn btn-primary btn-block ng-click="okForMarketing()">Yes, Sign Me Up!</button>\n                        </div> \n                        \n                        \n                        <div class="py-2" style="margin-bottom:3px; margin-top:10%">\n                          <strong style="font-size: 18px;">Dismiss Option</strong>\n                          \n                          <button class="btn btn-primary btn-block ng-click="cancelMarketingPopUp()">Maybe Later!</button>\n                        </div>\n\n\n                      </div>\n                </div>\n          ',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', function ($rootScope, $scope, $uibModalInstance, $auth) {
	          $scope.agreement = false;
	          $scope.okForRegister = function () {
	            $ctrl.$state.go('signup', {
	              storeName: 'indianapolis'
	            });
	            $uibModalInstance.close();
	          };
	
	          $scope.okForMarketing = function () {
	            $ctrl.removeUserDetailsFromSession();
	            $uibModalInstance.close();
	            $ctrl.doGuestOptIn();
	          };
	
	          $scope.cancelMarketingPopUp = function () {
	            $ctrl.removeUserDetailsFromSession();
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }]);
	
	  return Category;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'authService', 'orderService', '$interval', '$rootScope', '$timeout', '$stateParams', '$window', 'APP', '$location', 'ngMeta', '$uibModal'], _temp)) || _class);
	exports.default = Category;

/***/ },
/* 136 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 139 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 140 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 143 */
/***/ function(module, exports) {

	module.exports = "<div class=\"\" ng-if=\"category.isMobileDevice()\">\r\n  <!-- <img class=\"subheader-img\" src={{category.subHeaderImg}} alt=\"image\" /> -->\r\n  <div class=\"row full-width mob-promo-hgt\">\r\n\r\n    <!-- Categories -->\r\n    <div class=\"\">\r\n      <div class=\" \">\r\n\r\n        <div id=\"wbu-carousel-container-mob\" class=\"carousel slide promo-carousel-mob\" data-ride=\"carousel\">\r\n          <!-- <img class=\"subheader-img\" src={{category.subHeaderImg}} alt=\"image\" /> -->\r\n          <ol class=\"carousel-indicators\">\r\n            <li ng-click=\"category.activeMobilePromo($index)\" ng-class=\"promo.active?'active':''\"\r\n              ng-repeat=\"promo in $root.promo.mobilePromoImages track by $index\"></li>\r\n          </ol>\r\n          <div class=\"carousel-inner\" id=\"carousel-item-bar-mob\">\r\n            <div class=\"carousel-item\" ng-class=\"promo.active?'active':''\"\r\n              ng-repeat=\"promo in $root.promo.mobilePromoImages track by $index\">\r\n              <a href=\"{{promo.link}}\">\r\n                <div  class=\"promo-bg  bg-cover\">\r\n                  <img  bg-img=\"true\" ng-style=\"category.getCarousalSettingMob()\" class=\"promo-category-img\" src={{promo.mobileImageUrl}} alt=\"image\" />\r\n                </div>\r\n              </a>\r\n            </div>\r\n\r\n          </div>\r\n          <a class=\"carousel-control-prev\" href=\"#carouselExampleIndicators\" role=\"button\" data-slide=\"prev\">\r\n            <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\">Previous</span>\r\n          </a>\r\n          <a class=\"carousel-control-next\" href=\"#carouselExampleIndicators\" role=\"button\" data-slide=\"next\">\r\n            <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\">Next</span>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- <div class=\"p-x-0 hidden-md-up\">\r\n  <div class=\"row sub-header-bg m-x-0 sub-header-wrap\">\r\n    <div class=\"text-xs-center\" class=\"hidden-md-up\">\r\n      <img class=\"sub-header-logo\" src={{category.logo}} alt=\"image\" />\r\n    </div>\r\n  </div>\r\n</div> -->\r\n<div class=\"p-x-0 \">\r\n  <mobile-navigationbar ng-if=\"category.isMobileDevice()\" class=\"\"></mobile-navigationbar>\r\n  <div ng-if=\"!category.isMobileDevice()\" class=\"row full-width\">\r\n\r\n    <!-- Categories -->\r\n    <div class=\"p-b-1\">\r\n      <div class=\" \">\r\n\r\n        <div id=\"wbu-carousel-container\" class=\"carousel slide promo-carousel\" data-ride=\"carousel\">\r\n          <ol class=\"carousel-indicators\">\r\n            <li ng-click=\"category.activePromo($index)\" ng-class=\"promo.active?'active':''\"\r\n              ng-repeat=\"promo in $root.promo.promoImages track by $index\"></li>\r\n          </ol>\r\n          <div class=\"carousel-inner\" id=\"carousel-item-bar\">\r\n            <div class=\"carousel-item\" ng-class=\"promo.active?'active':''\"\r\n              ng-repeat=\"promo in $root.promo.promoImages track by $index\">\r\n              <a href=\"{{promo.link}}\">\r\n                <div ng-style=\"category.getCarousalSetting()\" class=\"promo-bg  bg-cover\" bg-img=\"true\"\r\n                  img-lazy-loader=\"{{promo.url}}\">\r\n                </div>\r\n                <!-- <img class=\"d-block w-100\"  ng-src=\"{{promo.url}}\" alt=\"First slide\" >-->\r\n              </a>\r\n            </div>\r\n\r\n          </div>\r\n          <a class=\"carousel-control-prev\" href=\"#carouselExampleIndicators\" role=\"button\" data-slide=\"prev\">\r\n            <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\">Previous</span>\r\n          </a>\r\n          <a class=\"carousel-control-next\" href=\"#carouselExampleIndicators\" role=\"button\" data-slide=\"next\">\r\n            <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\">Next</span>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n  <div class=\"row m-x-0\" ng-if=\"!category.isMobileDevice()\">\r\n    <!-- Categories -->\r\n    <div class=\" col-xs-4 col-sm-4 col-md-4 col-lg-4 cursor-pointer mb-10\" ng-click=\"category.goToNextTile(item)\"\r\n      ng-repeat=\"item in category.tiles\">\r\n      <div>\r\n        <img ng-src=\"{{category.getBackgroundTyleStyle(item)}}\" alt={{category.getBackgroundTitle(item.category)}}\r\n          class=\"img-fluid rounded cursor-pointer\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row m-x-0 \" ng-if=\"category.isMobileDevice()\">\r\n\r\n    <!-- Categories -->\r\n    <div class=\"p-b-1\">\r\n      <div class=\" col-xs-4 col-sm-4 col-md-4 cursor-pointer\" style=\"padding: 5px 4px !important;\"\r\n        ng-repeat=\"item in category.tiles\" ng-click=\"category.goToNextTile(item)\">\r\n        <img ng-src=\"{{category.getBackgroundTyleStyle(item)}}\" class=\"img-fluid rounded cursor-pointer\">\r\n      </div>\r\n    </div>\r\n    <!-- Advertisement sections -->\r\n  </div>\r\n  <div class=\"row m-x-0 p-b-2\">\r\n    <div class=\" m-y-1 p-l-0 footer-promo\" ng-if=\"!category.isMobileDevice()\">\r\n      <div ng-class=\"category.isIpad()?'col-md-4':'col-md-4'\">\r\n        <img id=\"store_promo_img\" ng-src={{$root.promo.subPromo1Desktop}} class=\"img-fluid rounded\" />\r\n      </div>\r\n      <div ng-class=\"category.isIpad()?'col-md-8':'col-md-8'\">\r\n        <store-promo></store-promo>\r\n      </div>\r\n    </div>\r\n    <div class=\"  p-l-0 footer-promo\" ng-if=\"category.isMobileDevice()\">\r\n      <div class=\"col-sm-12 col-xs-12 mobile-promo-images\">\r\n        <img id=\"store_promo_img\" ng-src={{$root.promo.subPromo1Mobile}} class=\"img-fluid rounded\" />\r\n      </div>\r\n      <div class=\"  col-sm-12 col-xs-12 mobile-promo-images\">\r\n        <store-promo></store-promo>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "690bc5cc683b85afaaf9db1c180dff15.jpg";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _user = __webpack_require__(146);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _search = __webpack_require__(147);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _userProfile = __webpack_require__(148);
	
	var _userProfile2 = _interopRequireDefault(_userProfile);
	
	var _wbuPointer = __webpack_require__(149);
	
	var _wbuPointer2 = _interopRequireDefault(_wbuPointer);
	
	var _wbuMapPointer = __webpack_require__(150);
	
	var _wbuMapPointer2 = _interopRequireDefault(_wbuMapPointer);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserProfile = (_dec = (0, _utils.Component)({
	  controllerAs: 'userProfile',
	  template: _userProfile2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function UserProfile($scope, $ngRedux, $state, $spinner, $auth, $uibModal, $timeout, toaster, $rootScope, $stateParams, APP, $window) {
	    var _this = this;
	
	    _classCallCheck(this, UserProfile);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$ngRedux = $ngRedux;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	
	    this.APP = APP;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.user = _user2.default;
	    this.dscImage = _WBUDSCCard2.default;
	    this.$uibModal = $uibModal;
	    this.searchIcon = _search2.default;
	    this.markerIcon = _wbuMapPointer2.default;
	    this.higlightedmarkerIcon = _wbuPointer2.default;
	    this.$timeout = $timeout;
	    this.toaster = toaster;
	    this.spinner = $spinner;
	    $spinner.show('appSpinner');
	    $auth.getDscImage().then(function (success) {
	      // console.log("DSC image: ",success.data);
	      _this.cloudDscImage = success.data.dscImage;
	    }).catch(function (err) {
	      _this.$auth.printCustomerGenericLogs(err);
	      console.log("Error in fetching DSC image: ");
	      _this.cloudDscImage = _this.dscImage;
	    });
	    $spinner.show('appSpinner');
	    $auth.setAllStores();
	    if ($auth.isLoggedIn()) {
	      $auth.getUserProfile().then(function (success) {
	        return $auth.getStoreDetail(success.data.store.storeURLName);
	      }).catch(function (err) {
	        _this.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        $spinner.hide('appSpinner');
	        if (_this.store.storeCode == _this.APP.ORDER.CLOSED_STORE.storeCode) {
	          _this.closedStorePopup();
	        }
	      });
	    } else {
	      var guestStore = $auth.getGuestStoreDetail();
	      $auth.getStoreDetail(guestStore.storeName).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    }
	    var listener1 = $rootScope.$on('storeSelected', function () {
	      _this.confirmChangeStore($rootScope.selectedStoreId);
	    });
	
	    $scope.$on('$destroy', disconnect);
	    listener1();
	  }
	
	  _createClass(UserProfile, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        detail: state.auth.profile,
	        store: state.auth.storeDetail,
	        storesList: state.auth.storesList
	      };
	    }
	  }, {
	    key: 'confirmChangeStore',
	    value: function confirmChangeStore(storeId) {
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.storeId = storeId;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body" >' + '<div class="password-container margin-ten">' + '<input class="form-control" type="password" id="passwordIdUserProfile" ng-model="password" placeholder="Enter Password">' + '<i class="far fa-eye-slash" ng-click="togglePassword(\'passwordIdUserProfile\',\'togglePasswordUserProfile\')" id="togglePasswordUserProfile"\n                style="cursor: pointer;"></i></div>' + '<h5 class="font-weight-bold">Please enter your password to change your store</h5>' + '<p class="font-weight-bold" style="font-size:smaller">Please Note: You are changing your active home store. All WBU stores are locally owned and operated, and Daily Savings Club memberships are only valid at the store where purchased.  You may purchase a new DSC membership at your new home store. Club discounts, points balance, and Bird Bucks will be displayed for your active store if applicable. <span ng-if="!isClosedStore">You may switch back to your original home store at any time and all eligible points, discounts, and Bird Bucks will be available.</span><span ng-if="isClosedStore"><br><br><bold style="font-weight:800">Note:</bold> You cannot switch back to this store.</span> </p>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-disabled="!password" ng-click="ok()">OK</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Go Back</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', 'authService', function ($scope, $uibModalInstance, $auth) {
	
	          $scope.isClosedStore = $ctrl.detail.store.storeCode == $ctrl.APP.ORDER.CLOSED_STORE.storeCode ? true : false;
	          $scope.togglePassword = function (passwordId, toggleId) {
	            $auth.togglePassword(passwordId, toggleId);
	          };
	
	          $scope.ok = function () {
	            // console.log($scope.password,  $ctrl.storeId);
	
	            var data = {
	              "newStoreId": $ctrl.storeId,
	              "password": $scope.password
	
	            };
	            $ctrl.spinner.show('appSpinner');
	            $auth.changeStore(data).then(function (data) {
	              if (data.status == 200) {
	                $ctrl.toaster.pop('success', 'Store has been changed successfully');
	                $ctrl.$timeout(function () {
	                  location.reload();
	                }, 1500);
	              } else {
	                $ctrl.toaster.pop('success', data.statusText);
	              }
	              // 
	              $ctrl.spinner.hide('appSpinner');
	            }).catch(function (err) {
	              $ctrl.$auth.printCustomerGenericLogs(err);
	              $ctrl.spinner.hide('appSpinner');
	              $ctrl.toaster.pop('success', err.data.message);
	            });
	
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showLoginPopUp',
	    value: function showLoginPopUp() {
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button" class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          this.$state = $state;
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	
	          NgMap.getMap().then(function (map) {
	            console.log('map', map);
	            $scope.map = map;
	          });
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	            console.log('storeObj', storeObj);
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	
	            };
	            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.isSEORequest = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.isSEORequest = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              console.log(success.data);
	              // this.test();
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	          $scope.selectStore = function (index, store, item) {
	            $scope.showStoreInfo(item, index, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.long = store.lng;
	          };
	
	          // InfoWindow fix for googlemap
	          $scope.changeStyle = function () {
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                      }
	                    }
	                  }
	                } catch (e) {
	                  // console.log("Some Error");
	                  $ctrl.$auth.printCustomerGenericLogs(e);
	                }
	              }
	            } else {
	              // console.log("Else part :");
	            }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToProductPage = function (store, item) {
	            $rootScope.selectedStoreId = store.id;
	            $rootScope.$emit('storeSelected');
	            $uibModalInstance.close();
	          };
	          $scope.goToSignUp = function (store, item) {
	            $rootScope.selectedStoreId = store.id;
	            $rootScope.$emit('storeSelected');
	            $ctrl.confirmChangeStore(store.id);
	            // $uibModalInstance.close();
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.detail.store && this.detail.store.storeName) {
	          storeName = this.detail.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'getFormattedDate',
	    value: function getFormattedDate(date) {
	      return date ? new Date(date).getMonth() + 1 + '/' + new Date(date).getDate() + '/' + new Date(date).getFullYear() : '';
	    }
	  }, {
	    key: 'syncedToday',
	    value: function syncedToday() {
	      var syncDate = new Date(this.detail.customer.lastSyncDateTime);
	      var currentDate = new Date();
	      // console.log(syncDate.getDate() === currentDate.getDate());
	      return syncDate.getDate() === currentDate.getDate();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.detail.customer) return false;
	      return this.detail.customer.dscId === 'C' && new Date() <= new Date(this.detail.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.detail.customer) return false;
	      return this.detail.customer.dscId === 'C' && new Date() > new Date(this.detail.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      return this.$auth.isMobileDevice();
	    }
	  }, {
	    key: 'closedStorePopup',
	    value: function closedStorePopup() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body" >' + '<h5 class="font-weight-bold">Store is closed</h5>' + '<p class="font-weight-bold" style="font-size:smaller">Your current Wild Birds Unlimited Store is permanently closed. You can continue shopping by selecting another nearby location. Please scroll down to the bottom of the page and click "Shop Another Store." </p>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', 'authService', function ($scope, $uibModalInstance, $auth) {
	          $scope.ok = function () {
	            $uibModalInstance.dismiss('cancel');
	          };
	          // $scope.cancel = () => $uibModalInstance.dismiss('cancel');
	        }]
	      });
	    }
	  }]);
	
	  return UserProfile;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'spinnerService', 'authService', '$uibModal', '$timeout', 'toaster', '$rootScope', '$stateParams', 'APP', '$window'], _temp)) || _class);
	exports.default = UserProfile;

/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABBCAYAAACO98lFAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACNdJREFUeNrkW2tIVFsUXo5mL810SKwhaW5SmSQ3Jij/ZP0oikISguhFCWGNGEGk3UKIQEru9CeoO/T09iYIhIEoEnpBUJekULh6w24xZQxeMi17mdZd3/Gc4TTNmcfZ+4yGCzZnHOfss9Z31l7PvZNevXpFI5kmT55MKYl40JQpUxx8WcLDxcPJI0cdDt3POngEePzHo51HE49GfkkdVvOXYqHgc/hSyqMkJyfHVVxcTIWFhTR16lTKzs5WBn8f/H0gEHB0dnY6Xr9+Tc+fP6fm5ma6c+cO5gEYPh4NDEiLFbwmyVwOzHAuX9w81uXn5+cuX76cli5dqghvlgDGjRs36Nq1a9Ta2urnry7y8DLfflnLQQoILPxsCG+32yu3bt1KpaWl5HA4pL+xjo4OamhooGPHjhFrzBEVjL+HFAQWPpUv+1m1f9uxYwetXbuWxowZY7mN+fTpE126dIkOHz5MvITq+Kt9LEdfwkFgADYnJyfXl5WV0a5du2jChAkJt+xv376lQ4cOUX19PQ0MDGxhWU4lDAQG4Pdp06ZVHT16lObOnTvkbg52Y9u2bTCoHpanOl4QbHEKP4nHHytXrqxqbGwcFgCAYHjBD/gCf+AznvttcQAAl7d/586d7uPHj9P48eOHVdADfsAX+AOfKr/yXCQm5PXfXFtbS5s2bRr2UeCZM2eopqYGdqIwWmwR03JgADLg/n4WAEDgE/yCb5V/4YjxYGVlpVsGAPxm6PPnz9TX10dfvnyhr1+/0rdv3ygpKYlsNhuNGjWKUlNTafTo0cSaJwwExxXuI0cQTlCFaRAYxYNsbNx79+4VYgjCfvjwgT5+/KgIbwQQ/offAYyxY8fSuHHjFHDMEvhmjwFt6OFlsSdum4A4IDc3tx4hq0gMAMHgz6EB8RI0As8GKCKxBEJ3v99fxrL+GXOcwACwNib3+3w+ITcItX/z5o3ylk1neCkpNHHiRGWZmKVHjx5RSUkJ+EhheQdiNYy1GzZsEAKgv7+furu7hQDQz2O0jGIhyAF5IFdMy4G1YCanuG23b982vQxg7KABiPFlEXKSzMxMxYiaXRaLFi1Cyl6gT7qMNMFdUVEhZAdg3MzYgEiE+WBYzRLk2b59O6mpvrEmsBY4OSP89/79+6azQXiCrq4uxR7IJtiFrKws0x4DmrlgwQJknr+w3M+MNMFdXl4ulA5rMYAVhHlF5oZckC9UG4KaoHmEpqYmpfRllnp7e5X1ZxVBrdPS0kzfz1pALpcr6ClCNWHJwoULhQCAQbRKC/TagOeYJcgHOWmw8PtDFrlx9erVQgyCOdgEK0kLtUVIlXNjOBCKi4qKhJkUZTARtHjxYuQm62ACgiCgUDpjxgyHvgRulsz68UQSItBZs2bh4xy9JhTBWIgSXBfCXCsJ88sAWm0DuPQgzJw+fboUJkWSnVhjBRkgqPLO1IOA5SANBNFagBFhXlkgq/LO1oOQ53Q6pYEgkvFFS61lLTdV3jw9CFkwFrIIwYxIMcRIC2QWd9W50vQgZMhsnkAbRKI6I6Zl2pv09HRFbj0IqbINGpiW9eZkzhVJE/pkh7uw4NAuUeZxP+aRHX+8f/9eSXX0IPRYkfRoQGRkZMTtMfB73GcFAKB3794pciuxh/pdV3d39yS73W4JEHibsOwoiiCnR8ksNMTWBIX1R8qLSrNVrjZUEzQQnvn9fmkBk1GkB2MEQLD0AATqj1rfAQJjwL3K9izhiOVV5NYvh5bW1taExO0QEFqhrXVN5fE3NCARAIBUeVv0IPzz9OlTGkmEfVE0uEEsCMJfjx8/HlEgoBcBuYM2AZ1bTqcDnZ2dOSKVpUg1Bqx/rdWm9SG1/8EmaAPxipZ/YFjhGdDHaGtrCy4HfSB+8969e+uw6UqW4BA2tAEbjbSyemiDFp9lAXLr1i28kItaN0pvhc5duXJFivAQBM0XlN7hjwFEvGU3/B734X7MozVzZFSuVDnPBT2X7n+Nd+/eVaqxZpcEmIb/ldl50gDBnBjwIFrcYYawWRRyQt6gx9I+QDWYPGa0AWsdEafs1ls4wvx4Dp5nps95+fJl3OfRN2ZDnbIX+37iEUTrPKPfYHWlWa8ZeB6eG0+nC3JBPsj5Xeyi/wOtKV4OXqAVC2HtW9Vyi+cFxPrSIBfk01pwRpqgoISdompsHRGAnp6ehL39SEsRLi9asxbyQK5QLQgLAmKGQCDgUTc+GarVcABAvzzATySNOHDgANrynnC72YwC9T3nz59XdoqGU8HhBEAoEOGWJuQ4e/asIlfYfCbcl6qn2IKtsvo6A1QPDxLdfWLl0gjlD/xDDnXv80DMIKhAnOIko666uvq7QoTVDVdRAn9qwUQh8A85Im3+jli/xrY3bIZ0Op1ubOUX2SmSSNICKxhCn8/njbR9LyoIKtVgsvT0dPeqVat+ChBgH06fPg0Q4AlqotY4ov2AUeyCW4F1lZFbJILAJ/ilwZMxXcIgANUWJr4W1tXVeXH0ZjgT+AOf4Fflm4RBgMvBePjwIfzrvhMnTnh3796t7FAbTgR+wBf4A5/gN9b9UymxgKClrzwxzixWzJs3r/fJkydVCKgKCgqGHADUC7GP+cWLFx7msVqf1oP/aBlnxPMOkbbjMRCbbTZb/Zo1a8jtdisl8qF4+16vV8kJmNctDMAPbjDatr+oZ6AgPEAwWlcMBNrPtXa7vQpHAVesWGE6z4+3bnH16lU6efIkEiIPPAADEDaLQzUK/RSjTnlUEIA0kpNoxGD8yhd3ZmZm+fr162nZsmUkY+tPKHHsT9evX6cLFy4ge0RO7GXho1aIsR0YRwdMgYDISx99xQBG8IRsXl5eLjZIYbtcfn6+0HpHJQh1wfb29uAJWRY+5hOyaPqoXej4QYAWmPUCDEjwrHR2drZr/vz5ChgcgSrqiRKevu2HshdKe6gPvHz5UhH+wYMH+C54Vlr1UHET7JXR/ouoIIAxGQUTl8sV7tS8Q70GtZ0GT85/d2q+qalJ+NQ87IFRnxUgjHiCG/1fgAEATTP3PBP9r6EAAAAASUVORK5CYII="

/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAC5ElEQVRoQ+2a7W0UMRCG31RAqACoIFBBoAKggoQKgApCKgAqACoAKiBUQDoAKgAqIHqQHVmO7Z2xd8neKiPdj9PuefyM58uT7GkjsrcRDt2AhJPcl3Qo6Ymku5L4fj88O5f0W9IPSZ8kfQ3fF3GC3hN5KOl5APBsDKBTSUDOKl4QrH4i6XhwF+8DEKc1i3hAcJ93wX3mUI7bPQtuN7yeFQQ3elPR9jNsBrdhc9FtiBViBgPwuVP5/QtJb0dJLCAoel1QRPC+knRm3ARxxfskh1xeNgxlWn4KBEt+nFlxzTBPR9ysBUJgf8ti4o8kLDuadXA7TvJWYiTc8kFI16ZTSF9qgZBZjrIVUTQKEZcEBkOl8qE3I9ZAsPqXTMmwHxfMXHKzLmPVQMhAjxPFBDZwSwguliaAzx2FtthrkTJ/ZTt+5MhOXtjS6d/2tjOlE8kzFXWCwF9SqPBpnXFnsBJIHuQUK3x5SaHYUnSjuIO+BJL77JJuFTeeu5c7JksgpMTYiqOoK4s4jy9PxaR49JqlBPI3+/VU9Tcrm3hxSO+mQTjWg8R61+Fa7ky56WBfQ/p1p3xLQaRY3ZsroivrfM+K7iwFcTMtCkbLm0aKJIVxCaHLThtSd1VnU5tv44Fc+mJV6nq7WvjWifCMjpeakl9HcbHRWyItCS5FPEbhGo1OrrxumWo/asOHkRFObbREXJKtumQKhEVrUw8SAONPzziIKWXrpok7M7RziwWkBcOzOKTGorhHOqDDLeOAzno564KxgrBhNoSSNGbcljP+wA3jAYkJgGlhPiYy7u/yNWoF0lrHBeMFiTsh6wCUTlosMACwwRhXpRSfrmOG6QWJykifBG/6h554BYjxQszwiUPuHHgWmFEQyylY3hmGWQsIsEMwawIZglkbSDfMGkG6YNYKYoGhlSGu/smaQVowVy5fawcpwRRvkLsAksJUr8G7AgIM/6RwGRN5ld0lkGaHcANiaaD+5zsXraKkM4k4VxwAAAAASUVORK5CYII="

/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0 fill\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"userProfile.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{userProfile.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Profile Setting</span>\r\n  </nav>\r\n\r\n\r\n\r\n  <div class=\"row m-x-0 fill\">\r\n    <div class=\"row gray-bg m-x-0 p-y-1 p-x-2-md\">\r\n      <div class=\"col-sm-6 col-xs-8\">\r\n        <div class=\"media\">\r\n          <a href class=\"media-left\">\r\n            <img alt=\"User\" ng-src=\"{{userProfile.detail.profilePictureUrl || userProfile.user}}\" class=\"media-object sub-header-user-img\"\r\n            />\r\n          </a>\r\n          <div class=\"media-body\">\r\n            <h5 class=\"m-b-0\" ng-bind=\"'Hello, ' + userProfile.detail.customer.firstName\"></h5>\r\n            <p class=\"m-b-0 mt-4\" ng-if=\"userProfile.isDscMember()\">\r\n              Daily Savings Club - {{(userProfile.detail.customer.totalPoints | number: 2) || 0}} Pts\r\n              <br> Membership valid through {{userProfile.detail.customer.dscExpireDate | date: 'MM/dd/yyyy'}}\r\n            </p>\r\n            <p class=\"m-b-0 mt-4\" ng-if=\"userProfile.isDscButExpired()\">\r\n              Daily Savings Club -\r\n              <s uib-tooltip=\"Your Club Membership has expired\">{{(userProfile.detail.customer.totalPoints | number: 2) || 0}} Pts</s>\r\n              <br> Expired on {{userProfile.detail.customer.dscExpireDate | date: 'MM/dd/yyyy'}}\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6 col-xs-4 text-xs-right\">\r\n        <button type=\"button\" class=\"btn btn-primary\" ui-sref=\"profile.edit\">Edit</button>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div>\r\n\r\n\r\n      <div class=\"col-xs-12 p-t-1 fill p-x-2-md\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-12\">\r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Name</label>\r\n              <h5 class=\"black\">{{userProfile.detail.customer.firstName}} {{userProfile.detail.customer.lastName}}</h5>\r\n            </div>\r\n\r\n            <!-- <div class=\"col-sm-6 m-b-2\">\r\n              <label>Date Of Birth (MM/DD/YYYY)</label>\r\n              <h5 class=\"black\">{{userProfile.getFormattedDate(userProfile.detail.customer.dateOfBirth)}}</h5>\r\n            </div> -->\r\n\r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Phone</label>\r\n              <h5 class=\"black\">{{userProfile.detail.phoneNumber | telFormat}}</h5>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Email</label>\r\n              <h5 class=\"black\">{{userProfile.detail.customer.email}}</h5>\r\n            </div>\r\n\r\n            <!-- <div class=\"col-sm-6 m-b-2\">\r\n              <label>City</label>\r\n              <h5 class=\"black\">{{userProfile.detail.customer.city}}</h5>\r\n            </div>\r\n  \r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>State</label>\r\n              <h5 class=\"black\">{{userProfile.detail.customer.state.code}}</h5>\r\n            </div>\r\n  \r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Country</label>\r\n              <h5 class=\"black\">{{userProfile.detail.customer.country}}</h5>\r\n            </div>\r\n  \r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Zip Code</label>\r\n              <h5 class=\"black\">{{userProfile.detail.customer.zipCode}}</h5>\r\n            </div> -->\r\n\r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Credit Card Billing Address</label>\r\n              <h5 class=\"black\">\r\n                <span ng-if=\"userProfile.detail.billingAddressLine1\">{{userProfile.detail.billingAddressLine1}},\r\n                </span>\r\n                <span ng-if=\"userProfile.detail.billingAddressLine2\">{{userProfile.detail.billingAddressLine2}},\r\n                </span>\r\n                <span ng-if=\"userProfile.detail.billingCity\">{{userProfile.detail.billingCity}}, </span>\r\n                <span ng-if=\"userProfile.detail.billingState.code\">{{userProfile.detail.billingState.code}}, </span>\r\n                <span ng-if=\"userProfile.detail.billingCountry\">{{userProfile.detail.billingCountry.name}} </span>\r\n                <span ng-if=\"userProfile.detail.shippingZipCode\"> - {{userProfile.detail.billingZipCode}}</span>\r\n              </h5>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Shipping Address</label>\r\n              <h5 class=\"black\">\r\n                <span ng-if=\"userProfile.detail.shippingAddressLine1\">{{userProfile.detail.shippingAddressLine1}},\r\n                </span>\r\n                <span ng-if=\"userProfile.detail.shippingAddressLine2\">{{userProfile.detail.shippingAddressLine2}},\r\n                </span>\r\n                <span ng-if=\"userProfile.detail.shippingCity\">{{userProfile.detail.shippingCity}}, </span>\r\n                <span ng-if=\"userProfile.detail.shippingState.code\">{{userProfile.detail.shippingState.code}}, </span>\r\n                <span ng-if=\"userProfile.detail.shippingCountry\">{{userProfile.detail.shippingCountry.name}} </span>\r\n                <span ng-if=\"userProfile.detail.shippingZipCode\"> - {{userProfile.detail.shippingZipCode}}</span>\r\n              </h5>\r\n            </div>\r\n\r\n\r\n            <div class=\"col-sm-6 m-b-2\">\r\n              <label>Preferred Store</label>\r\n              <h5 class=\"black\">\r\n                <span ng-if=\"userProfile.store.addressLine1\"> {{userProfile.store.addressLine1}}, </span>\r\n                <span ng-if=\"userProfile.store.addressLine2\"> {{userProfile.store.addressLine2}} </span>\r\n                <span ng-if=\"userProfile.store.city\">{{userProfile.store.city}} </span>\r\n                <span ng-if=\"userProfile.store.state.name\">{{userProfile.store.state.name}}, </span>\r\n                <span ng-if=\"userProfile.store.country.countryCode\"> {{storeDetail.store.country.countryCode}}</span>\r\n                <span ng-if=\"userProfile.store.zipCode\"> - {{userProfile.store.zipCode}}</span>\r\n              </h5>\r\n\r\n\r\n\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div>\r\n      <div class=\"col-xs-12 p-t-1 fill p-x-2-md\" ng-if=\"userProfile.storesList && userProfile.storesList.length >0\">\r\n        <hr />\r\n        <b>My Stores</b>\r\n          <div ng-if=\"!userProfile.isMobileOnly()\" ng-repeat=\"storeObj in userProfile.storesList\">\r\n            <div ng-if=\"storeObj.store.storeCode!=userProfile.APP.ORDER.CLOSED_STORE.storeCode\" class=\"row new_stores_desktop\" >\r\n              <br />\r\n              <div ng-class=\"userProfile.store.storeId == storeObj.store.storeId?'text_to_bold':''\" class=\"col-md-3 p-r-0\">\r\n                  <span ng-if=\"storeObj.dscId =='C'\"><br /></span>\r\n                {{storeObj.store.storeName}}, {{storeObj.store.state.code}} {{storeObj.store.zipCode}}\r\n                <br> {{storeObj.store.addressLine1}},{{storeObj.store.addressLine2}}\r\n                <br> {{storeObj.store.phoneNumber | telFormat}}\r\n              </div>\r\n\r\n              <div class=\"col-md-4\">\r\n                <div class=\"row\" ng-if=\"storeObj.dscId =='C'\">\r\n                  <div class=\"col-md-6 p-l-0\">\r\n                    <!-- <img style=\"height: 100%;\r\n                      width: 100%;\" src={{userProfile.dscImage}} alt=\"logo\" /> -->\r\n                      <img style=\"height: 100%;\r\n                      width: 100%;\" src={{userProfile.cloudDscImage}} alt=\"logo\" />\r\n                  </div>\r\n                  <div ng-class=\"userProfile.store.storeId == storeObj.store.storeId?'text_to_bold':''\" class=\"col-md-6\">\r\n                    <span ng-if=\"storeObj.dscId =='C'\"><br /></span>\r\n                    <!-- Expires {{storeObj.dscExpireDate | date : 'MM/yyyy'}}\r\n                    <br> Club Points, {{storeObj.totalPoints}}pts -->\r\n                    <!-- <br> Bird Bucks Available -->\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\" ng-if=\"storeObj.dscId !=='C'\">\r\n                  <div ng-class=\"userProfile.store.storeId == storeObj.store.storeId?'text_to_bold':''\" class=\"col-md-6\">\r\n                    Not a member\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                  <span ng-if=\"storeObj.dscId =='C'\"><br /></span>\r\n                <button ng-if=\"userProfile.store.storeId !== storeObj.store.storeId\" class=\"btn btn-primary \" style=\"font-size: .9rem !important;\"\r\n                  ng-click=\"userProfile.confirmChangeStore(storeObj.store.storeId)\">Shop This Store</button>\r\n                <span ng-if=\"userProfile.store.storeId == storeObj.store.storeId\">\r\n                    <span ng-if=\"storeObj.dscId =='C'\"><br /></span>\r\n                  <strong >Active Shopping Store</strong>\r\n                </span>\r\n              </div>\r\n              <br />\r\n              <br />\r\n            </div>\r\n          </div>\r\n\r\n        <div ng-if=\"userProfile.isMobileOnly()\" class=\"row new_stores_mobile\" ng-repeat=\"storeObj in userProfile.storesList\" style=\"line-height:20px\">\r\n          <br />\r\n          <div class=\"col-xs-12\">\r\n            <div class=\"row\" ng-if=\"storeObj.dscId !=='C'\">\r\n              <div ng-class=\"userProfile.store.storeId == storeObj.store.storeId?'text_to_bold':''\" class=\"col-xs-8\">\r\n                <br> {{storeObj.store.storeName}}, {{storeObj.store.state.code}} {{storeObj.store.zipCode}}\r\n                <br> {{storeObj.store.addressLine1}},{{storeObj.store.addressLine2}}\r\n                <br> {{storeObj.store.phoneNumber | telFormat}}\r\n              </div>\r\n              <div class=\"col-xs-4 p-l-1\">\r\n                <div style=\"float:right\">\r\n                  <div ng-class=\"userProfile.store.storeId == storeObj.store.storeId?'text_to_bold':''\" class=\"p-l-1\">\r\n                    Not a member\r\n                  </div>\r\n                  <div class=\"p-l-2\">\r\n                    <button ng-if=\"userProfile.store.storeId !== storeObj.store.storeId\" class=\"btn btn-primary edit-btn\" style=\"font-size: .9rem !important; height:61px;\"\r\n                      ng-click=\"userProfile.confirmChangeStore(storeObj.store.storeId)\">Shop This Store</button>\r\n                  </div>\r\n                  <div ng-if=\"userProfile.store.storeId == storeObj.store.storeId\" class=\"p-l-1\">\r\n                    <span>\r\n                      <strong>Active Shopping Store</strong>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n            <div class=\"row\" ng-if=\"storeObj.dscId =='C'\">\r\n              <div ng-class=\"userProfile.store.storeId == storeObj.store.storeId?'text_to_bold':''\" class=\"col-xs-8\">\r\n                {{storeObj.store.storeName}}, {{storeObj.store.state.code}} {{storeObj.store.zipCode}}\r\n                <br> {{storeObj.store.addressLine1}},{{storeObj.store.addressLine2}}\r\n                <br> {{storeObj.store.phoneNumber | telFormat}}\r\n                <!-- <br> Expires {{storeObj.dscExpireDate | date : 'MM/yyyy'}} Club Points, {{storeObj.totalPoints}}pts -->\r\n                <!-- <br> Bird Bucks Available -->\r\n              </div>\r\n              <div class=\"col-xs-4 p-l-1\">\r\n                <div style=\"float:right\">\r\n                  <div class=\"p-l-1\">\r\n                      <!-- Not a member -->\r\n                  </div>\r\n                  <div class=\"p-l-2 p-r-1\">\r\n                    <button ng-if=\"userProfile.store.storeId !== storeObj.store.storeId\" class=\"btn btn-primary edit-btn\" style=\"font-size: .9rem !important; height:61px;\"\r\n                      ng-click=\"userProfile.confirmChangeStore(storeObj.store.storeId)\">Shop This Store</button>\r\n                  </div>\r\n                  <div ng-if=\"userProfile.store.storeId == storeObj.store.storeId\" class=\"p-l-1\">\r\n                    <span>\r\n                      <strong>Active Shopping Store</strong>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <!--<div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <img style=\"height: 100%;\r\n                            width: 100%;\" src={{userProfile.dscImage}} alt=\"logo\" />\r\n                  </div> -->\r\n              <!-- <div class=\"col-md-6\">\r\n                  Expires {{storeObj.dscExpireDate | date : 'MM/yyyy'}}\r\n                  DSC Points, {{storeObj.totalPoints}}pts\r\n                  Bird Bucks\r\n                </div> \r\n              </div>-->\r\n            </div>\r\n          </div>\r\n          <br />\r\n          <br />\r\n        </div>\r\n        <br />\r\n        \r\n      </div>\r\n      <div class=\"col-xs-12 p-t-1 fill p-x-2-md\">\r\n        <button type=\"button\" ng-click=\"userProfile.showLoginPopUp()\" style=\"font-size: .9rem !important;\" class=\"btn btn-primary  m-b-1\">Shop Another Store</button>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 149 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _changePassword = __webpack_require__(152);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ChangePassword = (_dec = (0, _utils.Component)({
	  controllerAs: 'changePassword',
	  template: _changePassword2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ChangePassword($scope, $ngRedux, $state, $stateParams, $timeout, toaster, authService) {
	    _classCallCheck(this, ChangePassword);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$ngRedux = $ngRedux;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.authService = authService;
	    this.toaster = toaster;
	    this.$timeout = $timeout;
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        detail: state.auth.profile,
	        store: state.auth.storeDetail
	      };
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      form.error = {};
	      if (!this.currentpassword) {
	        form.error.message = 'Please enter current password!';
	        return;
	      }
	      if (this.password === this.currentpassword) {
	        form.error.message = 'Current password and new password are same!. Please change it!';
	        return;
	      }
	      if (this.password === this.confirmPassword) {
	        var $ctrl = this;
	        $ctrl.authService.changePassword({
	          password: this.password,
	          currentpassword: this.currentpassword,
	          userId: this.detail.userId
	        }).then(function (data) {
	          if (data.status == 200) {
	            $ctrl.toaster.pop('success', 'Password changed successfully');
	          } else {
	            $ctrl.toaster.pop('success', data.statusText);
	          }
	          $ctrl.$timeout(function () {
	            _this.$state.go('home');
	          }, 1000);
	        }).catch(function (err) {
	          if (err.data.errorCode === 706 || err.data.errorCode === 605) {
	            form.error.message = err.data.message;
	          }
	          $ctrl.toaster.pop('success', 'Password failed to changed. Please Try again!');
	        });
	      } else {
	        form.error.message = 'Password mismatch';
	      }
	    }
	  }]);
	
	  return ChangePassword;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', '$stateParams', '$timeout', 'toaster', 'authService'], _temp)) || _class);
	exports.default = ChangePassword;

/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = "  <div class=\"row m-x-0\">\r\n    <div class=\"col-md-4 offset-md-4 col-xs-8 offset-xs-2 p-t-2\" ng-if=\"!forgotPwd.requestSent\">\r\n      <form name=\"resetPwdForm\"\r\n        ng-submit=\"changePassword.submit(resetPwdForm)\"\r\n        autocomplete=\"off\"\r\n        novalidate>\r\n        <div class=\"error-text\" ng-bind=\"resetPwdForm.error.message\"></div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (resetPwdForm.$submitted || resetPwdForm.currentpassword.$touched) && resetPwdForm.currentpassword.$invalid }\">\r\n          <label>Current Password</label>\r\n          <input name=\"currentpassword\"\r\n            type=\"password\"\r\n            ng-model=\"changePassword.currentpassword\"\r\n            ng-minlength=\"6\"\r\n            ng-maxlength=\"60\"\r\n            class=\"form-control\" \r\n            required>\r\n          <div ng-messages=\"resetPwdForm.currentpassword.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"resetPwdForm.currentpassword.$touched || resetPwdForm.$submitted\">\r\n            <div ng-message=\"required\">Current Password is required</div>\r\n            <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n            <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n            <div class=\"error-text\"\r\n              ng-show=\"resetPwdForm.errors.currentpassword && !resetPwdForm.currentpassword.$error.required\">{{ resetPwdForm.errors.currentpassword[0] }}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (resetPwdForm.$submitted || resetPwdForm.password.$touched) && resetPwdForm.password.$invalid }\">\r\n          <label>New Password</label>\r\n          <input name=\"password\"\r\n            type=\"password\"\r\n            ng-model=\"changePassword.password\"\r\n            ng-minlength=\"6\"\r\n            ng-maxlength=\"60\"\r\n            class=\"form-control\" \r\n            required>\r\n          <div ng-messages=\"resetPwdForm.password.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"resetPwdForm.password.$touched || resetPwdForm.$submitted\">\r\n            <div ng-message=\"required\">Password is required</div>\r\n            <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n            <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n            <div class=\"error-text\"\r\n              ng-show=\"resetPwdForm.errors.password && !resetPwdForm.password.$error.required\">{{ resetPwdForm.errors.password[0] }}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\"\r\n          ng-class=\"{'has-danger': (resetPwdForm.$submitted || resetPwdForm.confirmPassword.$touched) && resetPwdForm.confirmPassword.$invalid }\">\r\n          <label>Confirm New Password</label>\r\n          <input name=\"confirmPassword\"\r\n            type=\"password\"\r\n            ng-model=\"changePassword.confirmPassword\"\r\n            ng-minlength=\"6\"\r\n            ng-maxlength=\"60\"\r\n            class=\"form-control\" \r\n            required>\r\n          <div ng-messages=\"resetPwdForm.confirmPassword.$error\"\r\n            class=\"form-control-feedback\"\r\n            ng-if=\"resetPwdForm.confirmPassword.$touched || resetPwdForm.$submitted\">\r\n            <div ng-message=\"required\">Password is required</div>\r\n            <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n            <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n            <div class=\"error-text\"\r\n              ng-show=\"resetPwdForm.errors.confirmPassword && !resetPwdForm.confirmPassword.$error.required\">{{ resetPwdForm.errors.confirmPassword[0] }}</div>\r\n          </div>\r\n        </div>\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block m-b-1 m-t-2 btn-sm-text\" ng-disabled=\"changePassword.isRegistering\">\r\n          <span>Save Password</span>\r\n          <span class=\"spinner\" ng-show=\"changePassword.isRegistering\">\r\n            <md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\r\n          </span>\r\n        </button>\r\n      </form>\r\n    </div>\r\n  </div>"

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _user = __webpack_require__(146);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _edit = __webpack_require__(154);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditProfile = (_dec = (0, _utils.Component)({
	  controllerAs: 'editProfile',
	  template: _edit2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function EditProfile($scope, $ngRedux, $state, $spinner, $auth, $timeout, $toaster, $stateParams, $window, $uibModal, APP) {
	    var _this = this;
	
	    _classCallCheck(this, EditProfile);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$ngRedux = $ngRedux;
	    this.$state = $state;
	    this.$auth = $auth;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.APP = APP;
	    this.toaster = $toaster;
	    this.$spinner = $spinner;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.user = _user2.default;
	    this.$uibModal = $uibModal;
	    // this.defaultLastName = 'MYWBU';
	    this.init();
	    this.$timeout = $timeout;
	    $auth.getCountries().then(function () {
	      $timeout(function () {
	
	        _this.getStates(_this.detail.billingCountry.countryCode, "billingAddress", 0);
	        _this.getStates(_this.detail.shippingCountry.countryCode, "shippingAddress", 0);
	        _this.validateShippingBillingAddress();
	      }, 300);
	    });
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(EditProfile, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        detail: state.auth.profile,
	        shippingCountries: state.auth.countries,
	        billingCountries: state.auth.countries
	      };
	    }
	  }, {
	    key: 'getStates',
	    value: function getStates(country, type, time) {
	      if (this.isCopyAsShipping) {
	        this.getStatesForShippingAddress(this.detail.billingCountry.countryCode, time);
	        var billingCountry = angular.copy(this.detail.billingCountry);
	        this.detail.shippingCountry = billingCountry;
	      }
	
	      switch (type) {
	        case 'billingAddress':
	          this.getStatesForBillingAddress(country, time);
	          break;
	
	        case 'shippingAddress':
	          this.getStatesForShippingAddress(country, time);
	          break;
	
	        default:
	          break;
	
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      this.COUNTRIES = [{ value: 'US', label: 'US' }];
	      this.STATES = [{ value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AS', label: 'American Samoa' }, { value: 'AZ', label: 'Arizona' }, { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' }, { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'DC', label: 'District of Columbia' }, { value: 'FM', label: 'Federated States of Micronesia' }, { value: 'FL', label: 'Florida' }, { value: 'GA', label: 'Georgia' }, { value: 'GU', label: 'Guam' }, { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' }, { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' }, { value: 'ME', label: 'Maine' }, { value: 'MH', label: 'Marshall Islands' }, { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' }, { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' }, { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' }, { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' }, { value: 'ND', label: 'North Dakota' }, { value: 'MP', label: 'Northern Mariana Islands' }, { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' }, { value: 'OR', label: 'Oregon' }, { value: 'PW', label: 'Palau' }, { value: 'PA', label: 'Pennsylvania' }, { value: 'PR', label: 'Puerto Rico' }, { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' }, { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' }, { value: 'VI', label: 'Virgin Islands' }, { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' }, { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' }];
	      if (this.detail.customer && this.detail.customer.dateOfBirth) {
	        this.detail.customer.dateOfBirth = new Date(this.detail.customer.dateOfBirth);
	      }
	      this.$spinner.show('appSpinner');
	      this.$auth.getUserProfile().then(function () {
	
	        _this2.userEmail = _this2.detail.customer.email;
	        _this2.detail.customer.dateOfBirth = new Date(_this2.detail.customer.dateOfBirth);
	        // if(this.detail.customer.lastName==this.defaultLastName){
	        //   this.detail.customer.lastName = '';
	        // }
	      }).finally(function () {
	        return _this2.$spinner.hide('appSpinner');
	      });
	    }
	  }, {
	    key: 'onZipKeyUp1',
	    value: function onZipKeyUp1() {
	      this.mask1 = '99999';
	      if (this.detail.shippingZipCode && this.detail.shippingZipCode.length > 5) {
	        this.mask1 = '99999-9999';
	      }
	    }
	  }, {
	    key: 'onZipKeyUp2',
	    value: function onZipKeyUp2() {
	      this.mask2 = '99999';
	      if (this.detail.customer.zipCode && this.detail.customer.zipCode.length > 5) {
	        this.mask2 = '99999-9999';
	      }
	    }
	  }, {
	    key: 'onZipKeyUp3',
	    value: function onZipKeyUp3() {
	      this.mask3 = '99999';
	      if (this.detail.billingZipCode && this.detail.billingZipCode.length > 5) {
	        this.mask3 = '99999-9999';
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this3 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      var country = '';
	      var state = '';
	      var detail = this.detail;
	      angular.forEach(this.shippingCountries, function (country1) {
	
	        if (detail.shippingCountry.countryCode === country1.label) {
	
	          country = {
	            "id": parseInt(country1.value),
	            "countryCode": country1.label,
	            "name": country1.name
	          };
	
	          angular.forEach(country1.states, function (state1) {
	
	            if (detail.shippingState.code === state1.value) {
	              state = {
	                "id": 1,
	                "code": state1.value,
	                "name": state1.label
	              };
	            }
	          });
	        }
	      });
	      this.detail.shippingCountry = country;
	      this.detail.shippingState = state;
	      country = '';
	      state = '';
	      this.detail.customer.email = this.userEmail;
	      detail = this.detail;
	      angular.forEach(this.billingCountries, function (country1) {
	
	        if (detail.billingCountry.countryCode === country1.label) {
	
	          country = {
	            "id": parseInt(country1.value),
	            "countryCode": country1.label,
	            "name": country1.name
	          };
	
	          angular.forEach(country1.states, function (state1) {
	
	            if (detail.billingState.code === state1.value) {
	              state = {
	                "id": 1,
	                "code": state1.value,
	                "name": state1.label
	              };
	            }
	          });
	        }
	      });
	      this.detail.billingCountry = country;
	      this.detail.billingState = state;
	      // if(this.detail.customer.lastName==null || this.detail.customer.lastName==''){
	      //   this.detail.customer.lastName=this.defaultLastName;
	      // }
	
	      // Validating PO Box character in address 
	      if (this.$auth.validatingPoBoxAddress(this.detail.store.postboxAddress, this.detail.shippingAddressLine1)) {
	        // this.toaster.pop('success', 'We do not deliver to PO Boxes. Please enter a street address.');
	        return false;
	      }
	
	      var userDetail = {
	        'phoneNumber': this.detail.phoneNumber,
	        'customer': {
	          'firstName': this.detail.customer.firstName,
	          'lastName': this.detail.customer.lastName,
	          'dateOfBirth': new Date(this.detail.customer.dateOfBirth).getTime(),
	          'addressLine1': null,
	          'addressLine2': null,
	          'city': null,
	          'state': {
	            'code': null
	          },
	          'country': null,
	          'zipCode': this.detail.customer.zipCode
	        },
	        'email': this.detail.customer.email,
	        'billingAddressLine1': this.detail.billingAddressLine1,
	        'billingAddressLine2': this.detail.billingAddressLine2,
	        'billingCity': this.detail.billingCity,
	        'billingState': this.detail.billingState,
	        'billingCountry': this.detail.billingCountry,
	        'billingZipCode': this.detail.billingZipCode,
	        'shippingAddressLine1': this.detail.shippingAddressLine1,
	        'shippingAddressLine2': this.detail.shippingAddressLine2,
	        'shippingCity': this.detail.shippingCity,
	        'shippingState': this.detail.shippingState,
	        'shippingCountry': this.detail.shippingCountry,
	        'shippingZipCode': this.detail.shippingZipCode
	      };
	      if (!this.detail.billingState) {
	        userDetail.billingState = {
	          'code': null
	        };
	      }
	      if (!this.detail.shippingState) {
	        userDetail.shippingState = {
	          'code': null
	        };
	      }
	      form.error = {};
	      this.isUserUpdateLoading = true;
	
	      // Resolving avalara address
	      // this.avalaraResolveAddress(userDetail, this.detail.store);
	
	      // check the below one if can implement for effiency
	      this.$auth.avalaraResolveAddress(userDetail, this.detail.store).then(function (resolveAddress) {
	        console.log("ResolveAddress : ", resolveAddress);
	        _this3.$auth.openPopUpForAddressResolve(userDetail, resolveAddress, function (addResolved) {
	          console.log("Call back function", addResolved);
	          if (addResolved.isCanceled) {
	            console.log("Canceled");
	            _this3.isUserUpdateLoading = false;
	          } else {
	            if (_this3.isCopyAsShipping) {
	              addResolved.billingAddressLine1 = addResolved.shippingAddressLine1;
	              addResolved.billingAddressLine2 = addResolved.shippingAddressLine2;
	              addResolved.billingCity = addResolved.shippingCity;
	              if (addResolved.shippingCountry) {
	                if (addResolved.shippingCountry.countryCode) {
	                  _this3.getStatesForBillingAddress(addResolved.shippingCountry.countryCode, 1);
	                  var billingCountry1 = angular.copy(_this3.detail.billingCountry);
	                  addResolved.billingCountry = billingCountry1;
	                }
	              }
	              if (addResolved.shippingState) {
	                var billingState1 = angular.copy(addResolved.shippingState);
	                addResolved.billingState = billingState1;
	              }
	              // this.detail.shippingState.code=this.detail.billingState.code;
	              addResolved.billingZipCode = addResolved.shippingZipCode;
	            }
	            _this3.updateProfile(addResolved);
	          }
	        });
	        // .then( addResolved => {
	        //   console.log("Address Resolved : ", resolveAddress);
	        //     this.updateProfile(addResolved);
	        //     })
	        // .catch( addNotResolved => {
	        //   console.log("AddNotResolved : ", addNotResolved);
	        // });
	        console.log("This should not run first");
	      }).catch(function (err) {
	        console.log("Error in edit : ", err);
	      });
	    }
	  }, {
	    key: 'syncedToday',
	    value: function syncedToday() {
	      var syncDate = new Date(this.detail.customer.lastSyncDateTime);
	      var currentDate = new Date();
	      return syncDate.getDate() === currentDate.getDate();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.detail.customer) return false;
	      return this.detail.customer.dscId === 'C' && new Date() <= new Date(this.detail.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.detail.customer) return false;
	      return this.detail.customer.dscId === 'C' && new Date() > new Date(this.detail.customer.dscExpireDate);
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.detail.store && this.detail.store.storeName) {
	          storeName = this.detail.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'copyToShippingAddress',
	    value: function copyToShippingAddress() {
	      if (this.isCopyAsShipping) {
	        this.detail.shippingAddressLine1 = this.detail.billingAddressLine1;
	        this.detail.shippingAddressLine2 = this.detail.billingAddressLine2;
	        this.detail.shippingCity = this.detail.billingCity;
	        if (this.detail.billingCountry) {
	          this.getStatesForShippingAddress(this.detail.billingCountry.countryCode, 1);
	          var billingCountry = angular.copy(this.detail.billingCountry);
	          this.detail.shippingCountry = billingCountry;
	        }
	        if (this.detail.billingState) {
	          var billingState = angular.copy(this.detail.billingState);
	          this.detail.shippingState = billingState;
	        }
	        // this.detail.shippingState.code=this.detail.billingState.code;
	        this.detail.shippingZipCode = this.detail.billingZipCode;
	      }
	    }
	  }, {
	    key: 'validateShippingBillingAddress',
	    value: function validateShippingBillingAddress() {
	      console.log(this.detail.shippingCountry);
	      console.log(this.detail.billingCountry);
	      if (this.detail.shippingAddressLine1 === this.detail.billingAddressLine1 && this.detail.shippingAddressLine2 === this.detail.billingAddressLine2 && this.detail.shippingCity === this.detail.billingCity && this.detail.shippingZipCode === this.detail.billingZipCode && this.detail.shippingCountry.countryCode === this.detail.billingCountry.countryCode && this.detail.shippingState.code === this.detail.billingState.code) {
	        console.log("equ");
	        this.isCopyAsShipping = true;
	      } else {
	        console.log("Not equ");
	        this.isCopyAsShipping = false;
	      }
	    }
	  }, {
	    key: 'copyAddressLine1',
	    value: function copyAddressLine1(Address1, isCopyAsShipping) {
	      if (isCopyAsShipping) {
	        this.detail.shippingAddressLine1 = Address1;
	      }
	    }
	  }, {
	    key: 'copyAddressLine2',
	    value: function copyAddressLine2(Address2, isCopyAsShipping) {
	      if (isCopyAsShipping) {
	        this.detail.shippingAddressLine2 = Address2;
	      }
	    }
	  }, {
	    key: 'copyCity',
	    value: function copyCity(city, isCopyAsShipping) {
	      if (isCopyAsShipping) {
	        this.detail.shippingCity = city;
	      }
	    }
	  }, {
	    key: 'copyCountry',
	    value: function copyCountry(countryCode, isCopyAsShipping) {
	      if (isCopyAsShipping) {
	        this.detail.shippingCountry.countryCode = countryCode;
	        this.getStates(countryCode, "shippingAddress");
	      }
	    }
	  }, {
	    key: 'copyState',
	    value: function copyState(stateCode, isCopyAsShipping) {
	      if (isCopyAsShipping) {
	        if (this.detail.shippingState) {
	          var billingState = angular.copy(this.detail.billingState);
	          this.detail.shippingState.code = stateCode;
	        } else {
	          this.detail.shippingState = {};
	          this.detail.shippingState.code = stateCode;
	        }
	      }
	    }
	  }, {
	    key: 'copyZipCode',
	    value: function copyZipCode(zipCode, isCopyAsShipping) {
	      if (isCopyAsShipping) {
	        this.detail.shippingZipCode = zipCode;
	      }
	    }
	  }, {
	    key: 'getStatesForBillingAddress',
	    value: function getStatesForBillingAddress(country, time) {
	      if (this.detail && time !== 0) {
	        if (this.detail.billingState) {
	          this.detail.billingState.code = '';
	          this.detail.billingZipCode = '';
	        }
	      }
	      var billingStates = '';
	      // console.log(this.billingCountries);
	      angular.forEach(this.billingCountries, function (value) {
	
	        if (country === value.label) {
	          billingStates = value.states;
	        }
	      });
	
	      this.billingStates = billingStates;
	    }
	  }, {
	    key: 'getStatesForShippingAddress',
	    value: function getStatesForShippingAddress(country, time) {
	      if (this.detail && time !== 0) {
	        if (this.detail.shippingState) {
	          this.detail.shippingState.code = '';
	          this.detail.shippingZipCode = '';
	        }
	      }
	      var shippingStates = '';
	      // console.log(this.shippingCountries);
	      angular.forEach(this.shippingCountries, function (value) {
	        // console.log(country,"==",value.label);
	        if (country === value.label) {
	          shippingStates = value.states;
	        }
	      });
	
	      this.shippingStates = shippingStates;
	    }
	  }, {
	    key: 'avalaraResolveAddress',
	    value: function avalaraResolveAddress(userDetail, store) {
	      var _this4 = this;
	
	      console.log("Calling Resolve address : ", userDetail);
	      // if(store.validateAddressType !== 'NOT_VALIDATE' && store.validateAddressType != this.detail.validatedAddressType){
	      userDetail.store = store;
	      this.$auth.avalaraResolveAddress(userDetail, store).then(function (success) {
	        console.log("Success validating : ", success);
	        var $ctrl = _this4;
	        $ctrl.userDetail = userDetail;
	        $ctrl.success = success;
	        var modalInstance;
	        if (success.data) {
	          modalInstance = _this4.$uibModal.open({
	            size: 'md',
	            template: '<div class="modal-header modalheaderbg btn-primary"><h5>Resolve Shipping Address</h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' + '<div class="row">' + '<div class="col-md-12">\n                          <div class="col-md-12 mb-4" style="text-align: center;">\n                            <h6><strong>From</strong></h6>\n                          </div>\n      \n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">Address Line 1</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">Address Line 2</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">City</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingCity ? user.shippingCity.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">State</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingState ? user.shippingState.code : \'\')}}\n                          </div>\n                          </div>\n      \n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">Zip</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingZipCode ? user.shippingZipCode.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n                    </div>' + '<div ng-if="isValidAddress">\n                    <br>\n                    <div class="col-md-12">\n                    <div class="col-md-12 mb-4" style="text-align: center;">\n                      <h6><strong>To</strong></h6>\n                    </div>\n      \n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Address Line 1</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.addressLine1 ? selected.addressLine1.trim() : \'\')}}\n                    </div>\n                    </div>\n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Address Line 2</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.addressLine2 ? selected.addressLine2.trim() : \'\')}}\n                    </div>\n                    </div>\n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">City</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.city ? selected.city.trim() : \'\')}}\n                    </div>\n                    </div>\n      \n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">State</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.state ? selected.state.code : \'\')}}\n                    </div>\n                    </div>\n      \n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Zip</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.zip ? selected.zip.trim() : \'\')}}\n                    </div>\n                    </div>\n                    </div>\n                    </div>\n\n                    <div class="col-md-12" ng-if="!isValidAddress">\n                    <br>\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Given Address not Validated with our records</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{summary}}\n                    </div>\n                    </div>\n                    ' + '</div>' + '</div>' + '<div class="modal-footer">' + '<button  ng-if="isValidAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Update</button>' + '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;">Use this address anyway</button>' + '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="fix()" style="float: right;">I will fix the address</button>' + '</div>',
	            controller: ['$scope', '$state', '$uibModalInstance', function ($scope, $state, $uibModalInstance) {
	              $scope.error = { message: '' };
	              $scope.user = $ctrl.userDetail;
	              $scope.isValidAddress = false;
	              $scope.count = 1;
	              if ($ctrl.userDetail.store.validateAddressType === 'BOTH_BILL_SHIP') {
	                $scope.count = 2;
	              }
	              if ($ctrl.success.data.resolutionQuality === 'Intersection') {
	                $scope.isValidAddress = true;
	                if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
	                  $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
	                } else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
	                  $scope.selected = $ctrl.success.data.billingAddresstoResolve;
	                }
	              } else {
	                if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
	                  $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
	                  $scope.summary = $ctrl.success.data.shippingAddresstoResolve.summary;
	                } else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
	                  $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
	                  $scope.summary = $ctrl.success.data.billingAddresstoResolve.summary;
	                }
	              }
	              $scope.submit = function () {
	                // $ctrl.$spinner.show('appSpinner');
	                console.log("It calls from submit");
	                $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	                $scope.user.shippingAddressLine1 = $scope.selected.addressLine1;
	                // $scope.user.shippingAddressLine2 = $scope.selected.addressLine1;
	                $scope.user.shippingCity = $scope.selected.city;
	                $scope.user.shippingState.code = $scope.selected.state.code;
	                $scope.user.shippingCountry.code = $scope.selected.country.code;
	                $scope.user.shippingZipCode = $scope.selected.zip;
	                $uibModalInstance.close($scope.user);
	              };
	              $scope.cancel = function () {
	                return $uibModalInstance.dismiss('cancel');
	              };
	              $scope.back = function () {
	                $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	                $uibModalInstance.close($scope.user);
	              };
	              $scope.fix = function () {
	                console.log("In fixing ");
	                $ctrl.isUserUpdateLoading = false;
	                $uibModalInstance.dismiss('cancel');
	                // $ctrl.$state.go('profile.edit');
	                // $uibModalInstance.close($scope.user);
	              };
	            }],
	            resolve: {}
	          });
	          modalInstance.result.then(function (data) {
	            console.log('user clicked ok', data);
	            $ctrl.updateProfile(data);
	          });
	        }
	      }).catch(function (error) {
	        console.log("Didn't call service resolve address : ", error);
	      });
	    }
	  }, {
	    key: 'updateProfile',
	    value: function updateProfile(userDetail) {
	      var _this5 = this;
	
	      this.$spinner.show('appSpinner');
	      this.$auth.updateUserProfile(userDetail, this.detail.userId).then(function () {
	        _this5.$spinner.hide('appSpinner');
	        _this5.isUserUpdateLoading = false;
	        if (_this5.detail.emailUpdated) {
	          _this5.$auth.logout(_this5.detail);
	        } else {
	          _this5.$timeout(function () {
	            _this5.$state.go('home');
	          }, 1000);
	        }
	        localStorage.removeItem('deliveryAddress');
	        _this5.toaster.pop('success', 'Profile updated successfully');
	      }).catch(function (err) {
	        _this5.$spinner.hide('appSpinner');
	        _this5.isUserUpdateLoading = false;
	        _this5.toaster.pop('success', err.data.message);
	      });
	    }
	  }]);
	
	  return EditProfile;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'spinnerService', 'authService', '$timeout', 'toaster', '$stateParams', '$window', '$uibModal', 'APP'], _temp)) || _class);
	exports.default = EditProfile;

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0 fill\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"editProfile.goToHomePage()\"   >\r\n      <img class=\"breadcrumb-logo-icon\" src={{editProfile.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Profile Setting</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 fill\">\r\n    <form name=\"editUserForm\" layout=\"column\"\r\n      autocomplete=\"off\" novalidate\r\n      ng-submit=\"editProfile.submit(editUserForm)\">\r\n      <div class=\"row gray-bg m-x-0 p-y-1\">\r\n        <div class=\"col-sm-6 col-xs-8\">\r\n          <div class=\"media\">\r\n            <a href class=\"media-left\">\r\n              <img alt=\"User\"\r\n                ng-src=\"{{editProfile.detail.profilePictureUrl || editProfile.user}}\"\r\n                class=\"media-object sub-header-user-img\" />\r\n            </a>\r\n            <div class=\"media-body\">\r\n              <h5 class=\"m-b-0\"\r\n                ng-bind=\"'Hello, ' + editProfile.detail.customer.firstName\"></h5>\r\n              <p class=\"m-b-0 mt-4\"\r\n                ng-if=\"editProfile.isDscMember()\">\r\n                Daily Savings Club - {{(editProfile.detail.customer.totalPoints | number: 2) || 0}} Pts\r\n                <br>\r\n                Membership valid through {{editProfile.detail.customer.dscExpireDate | date: 'MM/dd/yyyy'}}\r\n              </p>\r\n              <p class=\"m-b-0 mt-4\"\r\n                ng-if=\"editProfile.isDscButExpired()\">\r\n                Daily Savings Club - <s uib-tooltip=\"Your Club Membership has expired\">{{(editProfile.detail.customer.totalPoints | number: 2) || 0}} Pts</s><br>\r\n                Expired on {{editProfile.detail.customer.dscExpireDate | date: 'MM/dd/yyyy'}}\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      <div class=\"col-sm-6 col-xs-4 text-xs-right\">\r\n          <button type=\"submit\" ng-disabled=\"editUserForm.$pristine || editProfile.isUserUpdateLoading\"\r\n            class=\"btn btn-primary\">Save</button>\r\n        </div> \r\n      </div>\r\n\r\n      <div class=\"col-xs-12 p-t-1 bg-color fill\">\r\n        <div class=\"error-text\" ng-bind=\"editUserForm.error.message\"></div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-4\">\r\n            <h6>&nbsp;</h6>\r\n            <div class=\"row\">\r\n              <div class=\"form-group col-xs-6\"\r\n                ng-class=\"{'has-danger':  editUserForm.firstName.$invalid}\">\r\n                <label>First Name</label>\r\n                <input name=\"firstName\"\r\n                  type=\"text\"\r\n                  class=\"form-control\"\r\n                  ng-model=\"editProfile.detail.customer.firstName\" required\r\n                   />\r\n                <div ng-messages=\"editUserForm.firstName.$error\"\r\n                  class=\"form-control-feedback\">\r\n                  <div ng-message=\"required\">Enter First Name</div>\r\n                  <div class=\"error-text\" ng-show=\"editUserForm.errors.firstName && !editUserForm.firstName.$error.required\">\r\n                    {{editUserForm.errors.firstName[0]}}\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group col-xs-6\"\r\n                ng-class=\"{'has-danger':  editUserForm.lastName.$invalid}\">\r\n                <label>Last Name</label>\r\n                <input name=\"lastName\"\r\n                  type=\"text\"\r\n                  class=\"form-control\"\r\n                  ng-model=\"editProfile.detail.customer.lastName\" required\r\n                   />\r\n                <div ng-messages=\"editUserForm.lastName.$error\"\r\n                  class=\"form-control-feedback\">\r\n                  <div ng-message=\"required\">Enter Last Name</div>\r\n                  <div class=\"error-text\" ng-show=\"editUserForm.errors.lastName && !editUserForm.lastName.$error.required\">\r\n                    {{editUserForm.errors.lastName[0]}}\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.email.$touched) && editUserForm.email.$invalid}\">\r\n              <label>Email</label>\r\n              <input name=\"email\" \r\n                type=\"email\"\r\n                class=\"form-control\"\r\n                ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n                ng-model=\"editProfile.userEmail\"\r\n                required />\r\n              <div ng-messages=\"editUserForm.email.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.email.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Email</div>\r\n                <div ng-message=\"pattern\">Enter a valid email address</div>\r\n                <div ng-message=\"email\">Enter a valid email address</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.email && !editUserForm.email.$error.required && !editUserForm.email.$error.pattern\">\r\n                  {{editUserForm.errors.email[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.phoneNumber.$invalid}\">\r\n              <label>Phone</label>\r\n              <input name=\"phoneNumber\"\r\n                type=\"tel\"\r\n                ui-mask=\"(999) 999-9999\"\r\n                class=\"form-control\"\r\n                ng-model=\"editProfile.detail.phoneNumber\"\r\n                required />\r\n              <div ng-messages=\"editUserForm.phoneNumber.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.phoneNumber.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Phone Number</div>\r\n                <div ng-message=\"pattern\">Enter a valid Phone Number</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.phoneNumber && !editUserForm.phoneNumber.$error.required && !editUserForm.phoneNumber.$error.pattern\">\r\n                  {{editUserForm.errors.phoneNumber[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.addressLine1.$touched) && editUserForm.addressLine1.$invalid}\" ng-hide=\"true\">\r\n              <label>Address Line 1</label>\r\n              <input name=\"addressLine1\"\r\n                type=\"text\"\r\n                class=\"form-control\" disabled\r\n                ng-model=\"editProfile.detail.customer.addressLine1\" />\r\n              <div ng-messages=\"editUserForm.addressLine1.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.addressLine1.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Address Line 1</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.addressLine1 && !editUserForm.addressLine1.$error.required\">\r\n                  {{editUserForm.errors.addressLine1[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.addressLine2.$touched) && editUserForm.addressLine2.$invalid}\" ng-hide=\"true\">\r\n              <label>Address Line 2</label>\r\n              <input name=\"addressLine2\"\r\n                type=\"text\"\r\n                class=\"form-control\" disabled\r\n                ng-model=\"editProfile.detail.customer.addressLine2\" />\r\n              <div ng-messages=\"editUserForm.addressLine2.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.addressLine2.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Address Line 2</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.addressLine2 && !editUserForm.addressLine2.$error.required\">\r\n                  {{editUserForm.errors.addressLine2[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.city.$touched) && editUserForm.city.$invalid}\" ng-hide=\"true\">\r\n              <label>City</label>\r\n              <input name=\"city\" disabled\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-model=\"editProfile.detail.customer.city\"\r\n                maxlength=\"50\" />\r\n              <div ng-messages=\"editUserForm.city.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.city.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter City</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.city && !editUserForm.city.$error.required\">{{editUserForm.errors.city[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.state.$touched) && editUserForm.state.$invalid}\" ng-hide=\"true\">\r\n              <label>State/Province</label>\r\n              <select name=\"state\" disabled\r\n                ng-model=\"editProfile.detail.customer.state.code\"\r\n                class=\"form-control\">\r\n                <option value=\"\">Select</option>\r\n                <option ng-repeat=\"item in editProfile.STATES\" value=\"{{item.value}}\">\r\n                  {{ item.label }}\r\n                </option>\r\n              </select>\r\n              <div ng-messages=\"editUserForm.state.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.state.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Select State/Province</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.state && !editUserForm.state.$error.required\">{{editUserForm.errors.state[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.country.$touched) && editUserForm.country.$invalid}\" ng-hide=\"true\">\r\n              <label>Country</label>\r\n              <select name=\"country\" disabled\r\n                ng-model=\"editProfile.detail.customer.country\"\r\n                class=\"form-control\">\r\n                <option value=\"\">Select</option>\r\n                <option ng-repeat=\"item in editProfile.countries\" value=\"{{item.value}}\">\r\n                  {{ item.label }}\r\n                </option>\r\n              </select>\r\n              <div ng-messages=\"editUserForm.country.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.country.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Select Country</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.country && !editUserForm.country.$error.required\">{{editUserForm.errors.country[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.zipCode.$touched) && editUserForm.zipCode.$invalid}\" ng-hide=\"true\">\r\n              <label>Zip/Postal Code</label>\r\n              <input name=\"zipCode\" disabled\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                placeholder=\"XXXXX or XXXXX-XXXX\" \r\n                ng-pattern=\"/^\\d{5}(-\\d{4})?$/\"\r\n                ng-model=\"editProfile.detail.customer.zipCode\"\r\n                required />\r\n              <div ng-messages=\"editUserForm.zipCode.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.zipCode.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Zip/Postal Code</div>\r\n                <div ng-message=\"pattern\">Enter a valid Zip/Postal Code</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.zipCode && !editUserForm.zipCode.$error.required && !editUserForm.zipCode.$error.pattern\">\r\n                  {{editUserForm.errors.zipCode[0]}}\r\n                </div>\r\n              </div>\r\n            </div> -->\r\n          </div>\r\n\r\n          <div class=\"col-sm-4\">\r\n            <h6 class=\"font-weight-bold\">Credit Card Billing Address </h6>\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.billingAddressLine1.$invalid}\">\r\n              <label>Address Line 1</label>\r\n              <input name=\"billingAddressLine1\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-minlength=\"3\"\r\n                ng-model=\"editProfile.detail.billingAddressLine1\"\r\n                ng-change=\"editProfile.copyAddressLine1(editProfile.detail.billingAddressLine1,editProfile.isCopyAsShipping)\"\r\n                required/>\r\n              <div ng-messages=\"editUserForm.billingAddressLine1.$error\"\r\n                class=\"form-control-feedback error-container\">\r\n                <div ng-message=\"required\">Enter Address Line 1</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.billingAddressLine1 && !editUserForm.billingAddressLine1.$error.required\">\r\n                  {{editUserForm.errors.billingAddressLine1[0]}}\r\n                </div>\r\n                <div class=\"error-text\" ng-show=\" editUserForm.billingAddressLine1.$error.minlength\">\r\n                  Address Line needs to be at least 3 characters.\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.billingAddressLine2.$touched) && editUserForm.billingAddressLine2.$invalid}\">\r\n              <label>Address Line 2</label>\r\n              <input name=\"billingAddressLine2\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-model=\"editProfile.detail.billingAddressLine2\"\r\n                ng-change=\"editProfile.copyAddressLine2(editProfile.detail.billingAddressLine2,editProfile.isCopyAsShipping)\"\r\n                 />\r\n                \r\n              <div ng-messages=\"editUserForm.billingAddressLine2.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.billingAddressLine2.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Address Line 2</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.billingAddressLine2 && !editUserForm.billingAddressLine2.$error.required\">\r\n                  {{editUserForm.errors.billingAddressLine2[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.billingCity.$invalid}\">\r\n              <label>City</label>\r\n              <input name=\"billingCity\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-model=\"editProfile.detail.billingCity\"\r\n                ng-change=\"editProfile.copyCity(editProfile.detail.billingCity,editProfile.isCopyAsShipping)\"\r\n                maxlength=\"50\" \r\n                required/>\r\n              <div ng-messages=\"editUserForm.billingCity.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Enter City</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.billingCity && !editUserForm.billingCity.$error.required\">{{editUserForm.errors.billingCity[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n            \r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.billingCountry.$invalid}\">\r\n              <label>Country</label>\r\n              <select name=\"billingCountry\"\r\n                ng-model=\"editProfile.detail.billingCountry.countryCode\"\r\n                class=\"form-control\"\r\n                ng-change='editProfile.getStates(editProfile.detail.billingCountry.countryCode,\"billingAddress\")'\r\n                required>\r\n                <option value=\"\">Select</option>\r\n                <option ng-repeat=\"item in editProfile.billingCountries\" value=\"{{item.label}}\">\r\n                  {{ item.label }}\r\n                </option>\r\n              </select>\r\n              <div ng-messages=\"editUserForm.billingCountry.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Select Country</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.billingCountry && !editUserForm.billingCountry.$error.required\">{{editUserForm.errors.billingCountry[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.billingState.$invalid}\">\r\n              <label>State/Province</label>\r\n              <select name=\"billingState\"\r\n                ng-model=\"editProfile.detail.billingState.code\"\r\n                ng-change=\"editProfile.copyState(editProfile.detail.billingState.code,editProfile.isCopyAsShipping)\"\r\n                class=\"form-control\"\r\n                required>\r\n                <option value=\"\">Select</option>\r\n                <option ng-repeat=\"item in editProfile.billingStates\" value=\"{{item.value}}\">\r\n                  {{ item.label }}\r\n                </option>\r\n              </select>\r\n              <div ng-messages=\"editUserForm.billingState.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Select State/Province</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.billingState && !editUserForm.billingState.$error.required\">{{editUserForm.errors.billingState[0]}}</div>\r\n              </div>\r\n            </div>\r\n            \r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.billingZipCode.$invalid}\">\r\n              <label>Zip/Postal Code</label>\r\n              <input name=\"billingZipCode\" ng-if='editProfile.detail.billingCountry.countryCode!=\"CA\"'\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                placeholder=\"XXXXX or XXXXX-XXXX\" \r\n                ng-pattern=\"/^\\d{5}(-\\d{4})?$/\"\r\n                ng-model=\"editProfile.detail.billingZipCode\"\r\n                ng-change=\"editProfile.copyZipCode(editProfile.detail.billingZipCode,editProfile.isCopyAsShipping)\"\r\n                required />\r\n              <input name=\"billingZipCode\" ng-if='editProfile.detail.billingCountry.countryCode==\"CA\"'\r\n                type=\"text\"\r\n                class=\"form-control fontSize\"\r\n                ng-model=\"editProfile.detail.billingZipCode\"  \r\n                placeholder=\"XXX XXX\" \r\n                ng-change=\"editProfile.copyZipCode(editProfile.detail.billingZipCode,editProfile.isCopyAsShipping)\"\r\n                ng-pattern=\"/^([a-z])(\\d)([a-z])(\\s+)(\\d)([a-z])(\\d)?$/i\"\r\n                required />\r\n              <div ng-messages=\"editUserForm.billingZipCode.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Enter Zip/Postal Code</div>\r\n                <div ng-message=\"pattern\">Enter a valid Zip/Postal Code</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.billingZipCode && !editUserForm.billingZipCode.$error.required && !editUserForm.billingZipCode.$error.pattern\">\r\n                  {{editUserForm.errors.billingZipCode[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"col-sm-4\">\r\n          <div><h6 class=\"font-weight-bold\">Shipping Address <span style=\"float:right;font-weight:normal\"><input type=\"checkbox\"\r\n            name=\"copyshipping\"\r\n            ng-model=\"editProfile.isCopyAsShipping\"\r\n            class=\"form-control text-xs-left d-inline\"\r\n            style=\"width: auto;\" \r\n            ng-change=\"editProfile.copyToShippingAddress()\"\r\n            /> Same as billing address</span></h6></div>\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.shippingAddressLine1.$invalid}\">\r\n              <label>Address Line 1</label>\r\n              <input name=\"shippingAddressLine1\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-minlength=\"3\"\r\n                ng-model=\"editProfile.detail.shippingAddressLine1\"\r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                required/>\r\n              <div ng-messages=\"editUserForm.shippingAddressLine1.$error\"\r\n                class=\"form-control-feedback error-container\">\r\n                <div ng-message=\"required\">Enter Address Line 1</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.shippingAddressLine1 && !editUserForm.shippingAddressLine1.$error.required\">\r\n                  {{editUserForm.errors.shippingAddressLine1[0]}}\r\n                </div>\r\n                <div class=\"error-text\" ng-show=\" editUserForm.shippingAddressLine1.$error.minlength\">\r\n                  Address Line needs to be at least 3 characters.\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': (editUserForm.$submitted || editUserForm.shippingAddressLine2.$touched) && editUserForm.shippingAddressLine2.$invalid}\">\r\n              <label>Address Line 2</label>\r\n              <input name=\"shippingAddressLine2\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                ng-model=\"editProfile.detail.shippingAddressLine2\" />\r\n              <div ng-messages=\"editUserForm.shippingAddressLine2.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-show=\"editUserForm.shippingAddressLine2.$touched || editUserForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Address Line 2</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.shippingAddressLine2 && !editUserForm.shippingAddressLine2.$error.required\">\r\n                  {{editUserForm.errors.shippingAddressLine2[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.shippingCity.$invalid}\">\r\n              <label>City</label>\r\n              <input name=\"shippingCity\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                ng-model=\"editProfile.detail.shippingCity\"\r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                maxlength=\"50\" \r\n                required/>\r\n              <div ng-messages=\"editUserForm.shippingCity.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Enter City</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.shippingCity && !editUserForm.shippingCity.$error.required\">{{editUserForm.errors.shippingCity[0]}}</div>\r\n              </div>\r\n            </div>\r\n           \r\n            \r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.shippingCountry.$invalid}\">\r\n              <label>Country</label>\r\n              <select name=\"shippingCountry\"\r\n                ng-model=\"editProfile.detail.shippingCountry.countryCode\"\r\n                class=\"form-control\"\r\n                ng-change='editProfile.getStates(editProfile.detail.shippingCountry.countryCode,\"shippingAddress\")'\r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                required>\r\n                <option value=\"\">Select</option>\r\n                <option ng-repeat=\"item in editProfile.shippingCountries\" value=\"{{item.label}}\">\r\n                  {{ item.label }}\r\n                </option>\r\n              </select>\r\n              <div ng-messages=\"editUserForm.shippingCountry.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Select Country</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.shippingCountry && !editUserForm.shippingCountry.$error.required\">{{editUserForm.errors.shippingCountry[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.shippingState.$invalid}\">\r\n              <label>State/Province</label>\r\n              <select name=\"shippingState\"\r\n                ng-model=\"editProfile.detail.shippingState.code\"\r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                class=\"form-control\"\r\n                required>\r\n                <option value=\"\">Select</option>\r\n                <option ng-repeat=\"item in editProfile.shippingStates\" value=\"{{item.value}}\">\r\n                  {{ item.label }}\r\n                </option>\r\n              </select>\r\n              <div ng-messages=\"editUserForm.shippingState.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Select State/Province</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.shippingState && !editUserForm.shippingState.$error.required\">{{editUserForm.errors.shippingState[0]}}</div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n\r\n            <div class=\"form-group\"\r\n              ng-class=\"{'has-danger': editUserForm.shippingZipCode.$invalid}\">\r\n              <label>Zip/Postal Code</label>\r\n              <input name=\"shippingZipCode\"\r\n                ng-if='editProfile.detail.shippingCountry.countryCode!=\"CA\"'\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                placeholder=\"XXXXX or XXXXX-XXXX\" \r\n                ng-pattern=\"/^\\d{5}(-\\d{4})?$/\"\r\n                ng-model=\"editProfile.detail.shippingZipCode\" \r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                required />\r\n                <input name=\"shippingZipCode\"\r\n                ng-if='editProfile.detail.shippingCountry.countryCode==\"CA\"'\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                placeholder=\"XXX XXX\" \r\n                ng-pattern=\"/^([a-z])(\\d)([a-z])(\\s+)(\\d)([a-z])(\\d)?$/i\"\r\n                ng-model=\"editProfile.detail.shippingZipCode\" \r\n                ng-disabled=\"editProfile.isCopyAsShipping\"\r\n                required />\r\n              <div ng-messages=\"editUserForm.shippingZipCode.$error\"\r\n                class=\"form-control-feedback\">\r\n                <div ng-message=\"required\">Enter Zip/Postal Code</div>\r\n                <div ng-message=\"pattern\">Enter a valid Zip/Postal Code</div>\r\n                <div class=\"error-text\" ng-show=\"editUserForm.errors.shippingZipCode && !editUserForm.shippingZipCode.$error.required && !editUserForm.shippingZipCode.$error.pattern\">\r\n                  {{editUserForm.errors.shippingZipCode[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row gray-bg m-x-0 p-y-1\">\r\n          <div class=\"col-sm-12 col-xs-4 p-t-1 text-xs-right\">\r\n              <button type=\"submit\" ng-disabled=\"editUserForm.$pristine || editProfile.isUserUpdateLoading\"\r\n                class=\"btn btn-primary\">Save</button>\r\n            </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _settings = __webpack_require__(156);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Settings = (_dec = (0, _utils.Component)({
	  controllerAs: 'settings',
	  template: _settings2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Settings($scope, $ngRedux, $auth, toaster, $rootScope, $state, $stateParams, $window, APP) {
	    _classCallCheck(this, Settings);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$auth = $auth;
	    this.toaster = toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$rootScope = $rootScope;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Settings, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      var data = Object.assign({}, this.profile);
	      if (!data.billingState) {
	        data.billingState = {
	          'code': null
	        };
	      }
	      if (!data.shippingState) {
	        data.shippingState = {
	          'code': null
	        };
	      }
	      if (!data.customer.state) {
	        data.customer.state = {
	          'code': null
	        };
	      }
	      form.error = {};
	      this.$auth.updateUserProfile(data, data.userId).then(function () {
	        _this.toaster.pop('success', 'Your delivery mode has been updated successfully.');
	        _this.$rootScope.tempdeliveryMode = null;
	      }).catch(function (err) {
	        return form.error = err.data;
	      });
	    }
	  }]);
	
	  return Settings;
	}(), _class2.$inject = ['$scope', '$ngRedux', 'authService', 'toaster', '$rootScope', '$stateParams', '$window', 'APP', '$state'], _temp)) || _class);
	exports.default = Settings;

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\"   ng-click=\"settings.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{settings.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Settings</span>\r\n  </nav>\r\n\r\n  <form name=\"settingsForm\"\r\n    ng-submit=\"settings.submit(settingsForm)\"\r\n    autocomplete=\"off\"\r\n    novalidate>\r\n    <div class=\"row m-x-0 p-t-2\">\r\n      <div class=\"col-xs-12 p-t-0 setting_content\">\r\n        <h6><strong>Delivery Preference</strong></h6>\r\n      </div>\r\n      <div class=\"col-xs-12 mt-5 p-b-1 delivery setting_content\">\r\n        <div class=\"form-check d-inline m-r-3\">\r\n          <label class=\"form-check-label\">\r\n            <input type=\"radio\" class=\"form-check-input\"\r\n              ng-model=\"settings.profile.deliveryMode\" value=\"Home Delivery\" />\r\n           <span> Ground Delivery </span>\r\n          </label>\r\n        </div>\r\n        <div class=\"form-check d-inline\">\r\n          <label class=\"form-check-label\">\r\n            <input type=\"radio\" class=\"form-check-input\"\r\n              ng-model=\"settings.profile.deliveryMode\" value=\"In Store Pickup\" />\r\n            <span> In Store Pickup </span>\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 setting_content\">\r\n        <button type=\"submit\" class=\"btn btn-primary btn-md-text \">Save</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n"

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _termsConditions = __webpack_require__(158);
	
	var _termsConditions2 = _interopRequireDefault(_termsConditions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tnc = (_dec = (0, _utils.Component)({
	  controllerAs: 'tnc',
	  template: _termsConditions2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Tnc($scope, $state, $ngRedux, $location, $stateParams, $auth, APP, $window) {
	    _classCallCheck(this, Tnc);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$state = $state;
	    this.$location = $location;
	    this.$window = $window;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	
	    this.APP = APP;
	    if (!$auth.isGuestLogin()) {
	      $auth.getUserProfile().then(function (success) {
	        return $auth.getStoreDetail(success.data.store.storeURLName);
	      });
	    } else {
	      var guestStore = $auth.getGuestStoreDetail();
	      $auth.getStoreDetail(guestStore.storeName);
	    }
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Tnc, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'goToPrevState',
	    value: function goToPrevState() {
	      this.$window.history.back();
	    }
	  }]);
	
	  return Tnc;
	}(), _class2.$inject = ['$scope', '$state', '$ngRedux', '$location', '$stateParams', 'authService', 'APP', '$window'], _temp)) || _class);
	exports.default = Tnc;

/***/ },
/* 158 */
/***/ function(module, exports) {

	module.exports = "<!--\r\n<navigation-bar ng-if=\"tnc.isLoggedIn()\" class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n<nav ng-if=\"tnc.isLoggedIn()\" class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n  <a class=\"nav\" ng-click=\"tnc.goToHomePage()\"  >\r\n    <img class=\"breadcrumb-logo-icon\" src={{tnc.houseIcon}} alt=\"logo\" />\r\n    <span>Home</span>\r\n  </a>\r\n  <span>Terms of Use</span>\r\n</nav>\r\n\r\n<div class=\"static-content\" style=\"background-color: #fff;\">\r\n  <div class=\"row m-x-0 p-b-1 p-t-2\">\r\n    <div class=\"col-xs-12\">\r\n      <h6 class=\"font-weight-bold mb-8\">USER AGREEMENT</h6>\r\n      <h6 class=\"font-weight-bold mb-8\">TERMS AND CONDITIONS\r\n        <span style=\"float:right\">Updated: 7/1/2025</span>\r\n      </h6>\r\n      <p>\r\n          By using this website, you signify your agreement to these terms of use. If you do not accept all of the terms and conditions contained in this agreement, please do not use the site.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Modification of Services</h6>\r\n      <p>\r\n        The website reserves the right, in its sole discretion, to modify the services from time to time and without notice, including by removing, adding, or modifying Products and/or third-party vendors from the Product Catalog. The website shall have no liability to you for any modification or discontinuation of the services. If you object to any such changes, your sole recourse shall be to cease using the services.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Limitations on Your Use of Services</h6>\r\n      <p>\r\n          You may not attempt, or authorize, encourage, or support others' attempts, to circumvent, reverse engineer, decrypt, break or otherwise alter or interfere with the service. You acknowledge and agree that you may not copy, distribute, sell, resell, or exploit for any commercial purposes any portion of the services, or any products accessible through the services.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Modification of the Agreement</h6>\r\n      <p>\r\n          The website may amend, supplement, or modify this agreement from time to time by posting the amended agreement on the site, and you agree to be bound by any such amendment or modification. If you object to any such changes, your sole recourse shall be to cease using the services.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Termination</h6>\r\n      <p>\r\n          If you materially breach the terms of this agreement, the website may suspend your ability to use the services or may terminate this agreement effective immediately and without notice to you.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Payment and Billing</h6>\r\n      <p>\r\n       You acknowledge and agree that for each order you place through the service, the full cost of Products you order (for which prices are subject to change without notice) assessed against your credit card or charge card. You acknowledge and agree that a SMS or web browser command originating from your account constitutes an authorization for the website to charge this amount and you assume all liability for and shall promptly pay any and all charges. Without limiting the foregoing, you acknowledge and agree that you will pay assessed charges for any and all orders placed from your account, regardless of whether you actually receive the Products. The website will provide you with reasonable notice of any material modification in the fees charged for the services, which notice may be provided by posting the new fee schedule on the site.\r\n      </p>\r\n\r\n      <h6 id=\"returnpolicy-terms\" class=\"font-weight-bold mb-8\">Refund Policy</h6>\r\n        <ul>\r\n          <li>\r\n            Returns can be made at the store listed above.\r\n          </li>\r\n          <li>\r\n            Returns must be made within 30 days of receipt in new (unused) condition.\r\n          </li>\r\n          <li>\r\n            Due to variables beyond our control in shipping, food products may not be returnable. Food returns are made at the discretion of the local store.\r\n          </li>\r\n          <li>\r\n            Returns and exchanges without a receipt may be issued a store credit.\r\n          </li>\r\n          <li>\r\n            If an entire purchase is canceled, refunds will be issued in the same form of payment originally used. Individual items from an online purchase may be returned to the store from which the original purchase was made. Refunds for returned items will be issued in the form of a store credit or a Wild Birds Unlimited gift card. Store credits may be redeemed at the store from which the original purchase was made. Gift cards may be redeemed in-store or online at any Wild Birds Unlimited location.\r\n          </li>\r\n          <li>\r\n            Damaged (due to store or shipping error) or defective items will be replaced or credited.\r\n          </li>\r\n          <li>\r\n            Original shipping fees may be deducted from the value of your refund, unless the return is a result of our\r\n            error or item is defective.\r\n          </li>\r\n        </ul>\r\n\r\n      <h6 class=\"font-weight-bold mb-8\">Disclaimer of Warranties</h6>\r\n      <p>\r\n       YOU EXPRESSLY AGREE THAT USE OF THE SERVICES IS AT YOUR OWN RISK. THE SERVICES ARE PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. THE WEBSITE EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR USE OR PURPOSE, AND NON-INFRINGEMENT. THE WEBSITE MAKES NO WARRANTY THAT THE SERVICES WILL MEET YOUR REQUIREMENTS, OR THAT THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE. YOU UNDERSTAND AND AGREE THAT ANY PRODUCTS YOU OBTAIN THROUGH USE OF THE SERVICES IS DONE AT YOUR OWN RISK, AND THE WEBSITE MAKES NO WARRANTY REGARDING ANY DEALINGS WITH OR TRANSACTIONS ENTERED INTO WITH ANY OTHER PARTIES THROUGH THE SERVICES. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM THE WEBSITE OR THROUGH THE SERVICES SHALL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Limitation of Liability</h6>\r\n      <p>\r\n        YOU UNDERSTAND THAT TO THE EXTENT PERMITTED UNDER APPLICABLE LAW, IN NO EVENT WILL THE WEBSITE OR ITS OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES, AGENTS OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES (EVEN IF SUCH PARTIES WERE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES OR PRODUCTS, REGARDLESS OF WHETHER SUCH DAMAGES ARE BASED ON CONTRACT, TORT OR OTHERWISE. THE PARTIES ACKNOWLEDGE THAT THE TERMS OF THIS PARAGRAPH REFLECT THE ALLOCATION OF RISK SET FORTH IN THIS AGREEMENT AND THAT THE PARTIES WOULD NOT ENTER INTO THIS AGREEMENT WITHOUT THESE LIMITATIONS OF LIABILITY. THE AGGREGATE LIABILITY OF THE WEBSITE TO YOU FOR ALL CLAIMS ARISING FROM OR RELATED TO THE SERVICES OR PRODUCTS IS LIMITED TO ONE HUNDRED DOLLARS. Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages. Accordingly, some of the above limitations and disclaimers may not apply to you. To the extent that we may not, as a matter of applicable law, disclaim any implied warranty or limit its liabilities, the scope and duration of such warranty and the extent of our liability shall be the minimum permitted under such applicable law.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Privacy</h6>\r\n      <p>\r\n        We collect personal information about our customers so we can better serve you, and we make reasonable efforts to ensure the security of your personal information and to treat that information responsibly. We collect the personal information that you give us voluntarily or in response to our request when you choose to purchase a product from us. This may include your name, email address, physical address, and telephone number. Registration with MyWBU Store is generally required to make a purchase. If you purchase a product, we will also ask you for financial information such as your credit card number and for a billing address and a shipping address. The personal information you provide is available only to Wild Birds Unlimited, Inc., its franchise stores and assigned agents.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Indemnification</h6>\r\n      <p>\r\n          You agree to indemnify, defend and hold harmless the website, its agents, employees, representatives, licensors, affiliates, officers and directors, from and against any and all claims, liabilities, damages, losses, costs, expenses, fees (including reasonable attorneys' fees and court costs) resulting or arising from any third-party claim in connection with (a) any information you (or anyone accessing the services using your password) submit or transmit through the services, (b) your use of or access to the services, (c) your violation of this agreement, (d) your violation of any rights of any third party, or (e) any viruses, trojan horses, worms, time bombs, cancelbots, spyware, or other similar harmful or deleterious programming routines input by you into the services.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Intellectual Property</h6>\r\n      <p>\r\n          The services contain copyrighted and/or proprietary subject matter that is owned by Wild Birds Unlimited, Inc. and/or its licensors. All such material is protected by relevant intellectual property laws, including copyright, trademark, patent and/or trade secret laws. Such material may not be modified, reproduced, transmitted, sold, offered for sale, publicly displayed, or redistributed in any way without our prior written permission and the prior written permission of any other applicable rights licensor. All trademarks, slogans and other indicia of origin (\"Marks\") that appear on or in connection with the services are the property of Wild Birds Unlimited, Inc. and/or its affiliates, licensors and/or licensees. You are not authorized to use any such Marks.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Subscription Policy</h6>\r\n      <p>\r\n          By choosing a subscription program, you give your WBU store the right to automatically charge your credit card on file at the pre-set interval, and ship your products to you. You will receive two emails notifying you that your subscription will soon be fulfilled, and offered the chance to change or cancel your subscription. Subscriptions may be cancelled up to the day they ship. Subscriptions purchases are subject to our standard return policy.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">Miscellaneous</h6>\r\n      <p>\r\n          Any legal action, suit, or proceeding arising out of or relating to this agreement, or your use of the services, shall be instituted exclusively in the federal or state courts located in Hamilton County, Indiana. This agreement shall be governed by Indiana state law, without regard to conflict of law principles. You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of the services or this agreement must be filed within one year after such claim or cause of action arose or be forever barred. If any provision of this agreement is found by a court of competent jurisdiction to be unenforceable, the parties agree that the court should endeavor to give effect to the parties' intentions as reflected in the provision, and that the enforceable provisions of this agreement shall remain in full force and effect.\r\n      </p>\r\n      <h6 class=\"font-weight-bold mb-8\">GIFT CARDS</h6>\r\n      <p>\r\n          Use of a gift card constitutes acceptance of the following. The value associated with the card may be applied toward purchase at any participating Wild Birds Unlimited stores. Card cannot be refunded or redeemed for cash (except as required by law). Card will not be replaced or replenished if it is lost, stolen or used without your permission (except as required by law). Card has no value until purchased and activated. Card is transferable. For balance information, contact your local Wild Birds Unlimited Store or go to www.wbu.com.\r\n      </p>\r\n    </div>\r\n    <div class=\"col-xs-10 col-sm-6 col-md-4 offset-xs-1 offset-sm-3 offset-md-4\">\r\n      <!-- <a href class=\"btn btn-primary btn-block btn-md-text\"\r\n        ng-if=\"!tnc.isLoggedIn()\"\r\n        ng-click=\"tnc.goToPrevState()\">I Agree</a> -->\r\n      <a ng-click=\"tnc.goToPrevState()\" class=\"btn btn-primary btn-block btn-md-text white\"\r\n        ng-if=\"tnc.isLoggedIn()\">Back</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _rulesFaq = __webpack_require__(160);
	
	var _rulesFaq2 = _interopRequireDefault(_rulesFaq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RulesFaq = (_dec = (0, _utils.Component)({
	  controllerAs: 'rulesFaq',
	  template: _rulesFaq2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function RulesFaq($scope, $state, $location, $ngRedux, authService, $order, $window, APP, $stateParams, $anchorScroll) {
	    var _this = this;
	
	    _classCallCheck(this, RulesFaq);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$state = $state;
	    this.$location = $location;
	    this.host = $location.host();
	    this.authService = authService;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.listArrow = _homeArrow2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = authService;
	    this.$order = $order;
	    this.us_zone_2 = 7.99;
	    this.can_zone_0 = 14.99;
	    this.us_shipping_available_for = 75;
	    this.can_shipping_available_for = 99;
	
	    this.APP = APP;
	    var ctrl = this;
	    this.authService.getUserProfile().then(function () {
	      return ctrl.authService.getStoreDetail(ctrl.profile.store.storeURLName);
	    });
	    this.authService.getBaseShippingCharge().then(function (success) {
	      console.log("Base Shipping Charge -- ", success);
	      _this.us_zone_2 = success.data.us_zone_2;
	      _this.can_zone_0 = success.data.can_zone_0;
	      _this.us_shipping_available_for = success.data.us_shipping_available_for;
	      _this.can_shipping_available_for = success.data.can_shipping_available_for;
	    });
	    $anchorScroll.yOffset = 50;
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(RulesFaq, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        store: state.auth.storeDetail,
	        baseShippingCharge: state.auth.baseShippingCharge
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }]);
	
	  return RulesFaq;
	}(), _class2.$inject = ['$scope', '$state', '$location', '$ngRedux', 'authService', 'orderService', '$window', '$stateParams', 'APP', '$anchorScroll'], _temp)) || _class);
	exports.default = RulesFaq;

/***/ },
/* 160 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!-- <navigation-bar ng-if=\"rulesFaq.isLoggedIn()\" class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav ng-if=\"rulesFaq.isLoggedIn()\" class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"rulesFaq.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{rulesFaq.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Rules / FAQs</span>\r\n  </nav>\r\n\r\n  <!-- <div class=\"row m-x-0 p-b-1 p-t-1\">\r\n    <div class=\"col-xs-12\">\r\n      <div class=\"list-group\">\r\n        <a ui-sref=\"{{rulesFaq.isLoggedIn() ? 'faq-birds-critters' : 'birds-critters'}}\" class=\"list-group-item list-group-item-action\">\r\n          <span class=\"home-tab-text\">Birds & Critters</span>\r\n          <img src={{rulesFaq.listArrow}} class=\"list-arrow pull-xs-right\"/>\r\n        </a>\r\n        <a ui-sref=\"{{rulesFaq.isLoggedIn() ? 'faq-franchising' : 'franchising'}}\"  class=\"list-group-item list-group-item-action\">\r\n          <span class=\"home-tab-text\">Franchising</span>\r\n          <img src={{rulesFaq.listArrow}} class=\"list-arrow pull-xs-right\"/>\r\n        </a>\r\n        <a ui-sref=\"{{rulesFaq.isLoggedIn() ? 'faq-product-warranties' : 'product-warranties'}}\" class=\"list-group-item list-group-item-action\">\r\n          <span class=\"home-tab-text\">Product Warranties</span>\r\n          <img src={{rulesFaq.listArrow}} class=\"list-arrow pull-xs-right\"/>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div> -->\r\n\r\n  <div class=\"static-content\" style=\"background-color: #fff;\">\r\n    <div class=\"row m-x-0 p-b-1 p-t-2\">\r\n      <div class=\"col-xs-12\">\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">RULES\r\n          <span style=\"float:right\">Updated: 7/1/2025</span>\r\n        </h6>\r\n\r\n        <p>\r\n          To purchase merchandise using the Online Order System (\"OOS\") for Wild Birds Unlimited, Inc. (\"WBU\"), the\r\n          following Rules and FAQ may be helpful. Specific questions should be directed to your local WBU store. The\r\n          store may not immediately know the answer to a specific question, but will seek and reply with the best\r\n          response for you.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">User Profile</h6>\r\n        <ul>\r\n          <li>\r\n            To purchase merchandise, customers are required to provide contact, telephone, billing, and shipping\r\n            information at the time of order. Your contact information in the Online Order System is separate, and could\r\n            be different from the contact information you have on file in the local store.\r\n          </li>\r\n          <li>\r\n            We collect this information only for WBU use and will never sell your information to a third party.\r\n          </li>\r\n          <li>\r\n            For your convenience and security, credit card information is tokenized and saved for future use. These\r\n            single-use tokens do not expose your credit card information in case of a security breach. If a token has\r\n            not been used within six months, it will be automatically deleted.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Local Store</h6>\r\n        <ul>\r\n          <li>\r\n            One convenience of this Online Order System is that the price you see displayed is the same as the price\r\n            that you would see if you visited your preferred store. Unlike other online order systems, therefore, it is\r\n            necessary for you to select your \"Home Store\" early in your experience from which to display the local\r\n            stores pricing on the items you are shopping.\r\n          </li>\r\n          <li>\r\n            Each online sale ultimately gets recorded as a local store sales transaction. Order history is available as\r\n            of the next business day at the store if you have inquiries.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Local Pricing</h6>\r\n        <ul>\r\n          <li>\r\n            A merchandise item's price that is displayed is specific to the selected/assigned store.\r\n          </li>\r\n          <li>\r\n            Prices are uploaded from the local store's Point of Sale system to the Online Order System daily shortly\r\n            after 12:00 AM local time. During the day, there may be a management price adjustment (up or down) at the\r\n            local store. So there is slight chance that the online price may be different from the price you see in the\r\n            store due to the daily synchronization lag time.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Local Store Inventory</h6>\r\n        <ul>\r\n          <li>\r\n            The local stores items for sale on the Online Order System are updated each morning before 6AM. We expect\r\n            our stores to carry enough inventory to cover sales of those listed items. There is a slight chance that\r\n            in-store purchases will deplete the inventory of an item offered online. The store staff will contact the\r\n            customer and make necessary arrangements and remedies in those rare occasions.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Daily Savings Club</h6>\r\n        <ul>\r\n          <li>\r\n            WBU offers customers a loyalty club program called \"Daily Savings Club.\" This paid subscription program\r\n            allows customers to experience extra \"club savings\" not afforded to \"non-club\" customers.\r\n          </li>\r\n          <li>\r\n            Daily Savings Club program is a local store program. When you purchase an annual membership, those savings\r\n            and program benefits are only applied to the local store. If you visit another WBU store, or shop online by\r\n            selecting another store where you are not a \"club member\" you will see the retail price for items. DSC\r\n            pricing and benefits are only afforded at the store with which you purchased the subscription membership.\r\n          </li>\r\n          <li>\r\n            Your membership expires annually. Once expired, you will cease to be afforded club benefits. A membership\r\n            renewal payment is required to re-establish your membership privileges. While your membership may lapse, any\r\n            accumulated points do not go away. When you renew, your point totals will remain the same and not start\r\n            over.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Daily Savings Club Bird Bucks</h6>\r\n        <ul>\r\n          <li>\r\n            The Daily Savings Club benefit is that once a club member accumulates 200 club points, a $10 \"Bird Buck\" is\r\n            issued to the customer. That Bird Buck can be used in the local store as additional savings on in-store\r\n            merchandise purchases. A Bird Buck issued for an online order can be redeemed in-store or online.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Delivery</h6>\r\n        <ul>\r\n          <li>\r\n            You have the option to receive your order via convenient in-store pickup or delivery to your home or a\r\n            destination of your choice.\r\n          </li>\r\n          <li>\r\n            Delivered items use the courier and standard ground delivery method of choice by the local store.\r\n          </li>\r\n          <li>\r\n            Purchased items are packaged in sturdy boxes and labeled according to the specific couriers' requirements.\r\n          </li>\r\n          <li>\r\n            The shipping cost is set on the Online Order System at the time the purchase is placed.\r\n          </li>\r\n          <li>\r\n            Additional shipping charges are incurred when the shipping address is outside of Zone 2 (US) and Zone 0-1\r\n            (CAN), as determined by FedEx shipping zones. Additional charges will be displayed at the time of the order.\r\n          </li>\r\n          <li>\r\n            Every box may contain up to 70 pounds (US) or 100 lbs/45 kg (CAN) of merchandise. The heaviness of the boxes\r\n            delivered to the destination may require the customer to unpack the boxes on, for example, a front porch\r\n            where the package was delivered. Customers should consider this when selecting this delivery method.\r\n          </li>\r\n          <li>\r\n            Because the package may be delivered to your destination and left unattended for a length of time, there is\r\n            the risk of damage by animals (e.g. Raccoons, etc.) and other potential vandalism sources. Customer should\r\n            consider these additional risks when selecting this delivery method.\r\n          </li>\r\n        </ul>\r\n        <!-- Adding Free shipping -->\r\n        <h6 class=\"font-weight-bold mb-8\">Free Shipping/Shipping Rates</h6>\r\n        <ul>\r\n          <li>\r\n            Flat-rate shipping is available for ${{rulesFaq.us_zone_2}} within shipping Zone 2 (US) or ${{rulesFaq.can_zone_0}} within shipping Zones 0-1 (CAN) as determined by our preferred shipping partner, FedEx. Each additional zone of distance from the store will add an additional charge to the flat-rate shipping amount.\r\n          </li>\r\n          <li>\r\n            Free shipping is available for orders over ${{rulesFaq.us_shipping_available_for}} (US) and ${{rulesFaq.can_shipping_available_for}} (CAN). Free shipping promotions apply to the base flat-rate charge. Any additional distance zones of shipping distance will still incur additional per-zone shipping charges. Shipping charges can be determined at checkout.\r\n          </li>\r\n        </ul>\r\n        <!-- Free shipping Ends -->\r\n        <h6 class=\"font-weight-bold mb-8\">In-Store Pickup</h6>\r\n        <ul>\r\n          <li>\r\n            You have the option to receive the merchandise in the store, already packaged and ready for quick pickup in\r\n            the local store.\r\n          </li>\r\n          <li>\r\n            You will be notified by the online order system when your order will be packaged and ready for your pickup.\r\n          </li>\r\n          <li>\r\n            When you arrive, please have your order confirmation and appropriate identification present.\r\n          </li>\r\n          <li>\r\n            Our WBU staff, as usual, will assist loading your order in your vehicle.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 id=\"returnpolicy\" class=\"font-weight-bold mb-8\">Refund Policy</h6>\r\n        <ul>\r\n          <li>\r\n            Returns can be made at the store listed above.\r\n          </li>\r\n          <li>\r\n            Returns must be made within 30 days of receipt in new (unused) condition.\r\n          </li>\r\n          <li>\r\n            Due to variables beyond our control in shipping, food products may not be returnable. Food returns are made at the discretion of the local store.\r\n          </li>\r\n          <li>\r\n            Returns and exchanges without a receipt may be issued a store credit.\r\n          </li>\r\n          <li>\r\n            If an entire purchase is canceled, refunds will be issued in the same form of payment originally used. Individual items from an online purchase may be returned to the store from which the original purchase was made. Refunds for returned items will be issued in the form of a store credit or a Wild Birds Unlimited gift card. Store credits may be redeemed at the store from which the original purchase was made. Gift cards may be redeemed in-store or online at any Wild Birds Unlimited location.\r\n          </li>\r\n          <li>\r\n            Damaged (due to store or shipping error) or defective items will be replaced or credited.\r\n          </li>\r\n          <li>\r\n            Original shipping fees may be deducted from the value of your refund, unless the return is a result of our\r\n            error or item is defective.\r\n          </li>\r\n        </ul>\r\n\r\n        <h6 class=\"font-weight-bold mb-8 p-t-1\">IN-STORE PICKUP and FAQ</h6>\r\n        <h6 class=\"font-weight-bold mb-8 p-t-1\">In-Store Pickup - Save Time, Shop Online and Pickup In-Store. No minimum\r\n          order.</h6>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Here's how it works:</h6>\r\n        <ol>\r\n          <li>\r\n            During your checkout, choose In-Store Pickup.\r\n          </li>\r\n          <li>\r\n            The estimated pickup date and time will be indicated\r\n          </li>\r\n          <li>\r\n            Place your order and you will receive an email stating your order is ready for pickup. (This is a separate\r\n            email from your order confirmation).\r\n          </li>\r\n          <li>\r\n            Bring your ID and email confirmation to the store.\r\n          </li>\r\n          <li>\r\n            Orders will be held in-store for up to 5 days. If you don't make it in by then, we will contact you to\r\n            discuss your options for refund or cancellation.\r\n          </li>\r\n        </ol>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Bring to the store:</h6>\r\n        <ol>\r\n          <li>\r\n            Photo ID\r\n          </li>\r\n          <li>\r\n            Order confirmation email\r\n          </li>\r\n        </ol>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">In-Store Pickup and our Price Match Guarantee:</h6>\r\n        <p>\r\n          If your product is available at a lower price in the store at the time of pickup an in-store credit will be\r\n          issued for the price difference. Some exclusions may apply.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Cancelling an In-Store Pickup:</h6>\r\n        <ul>\r\n          <li>\r\n            To cancel an In-Store Pickup order, call the store.\r\n          </li>\r\n          <li>\r\n            Orders can be changed from In-Store Pickup to a shipped order by calling the store.\r\n          </li>\r\n        </ul>\r\n\r\n\r\n        <h6 class=\"font-weight-bold mb-8 p-t-2\">Frequently Asked Questions:</h6>\r\n\r\n        <p>\r\n          <h6 class=\"font-weight-bold mb-8\">How do I pickup my order?</h6>\r\n        </p>\r\n        <p>\r\n          Please stop in the store and let one of our sales associates know you are there to pickup an online order. You\r\n          must have a valid ID and we recommend bringing a copy of your order confirmation that was emailed.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">When can I pickup my order?</h6>\r\n        <p>\r\n          Most orders are fulfilled in 2-4 hours (varies by store). If you place an order near closing time, then your\r\n          order will be available to pick up the next day. You will receive an email when your order is ready for\r\n          pickup.\r\n        </p>\r\n\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">How do I know my order is ready?</h6>\r\n        <p>\r\n          You will receive an email indicating your order is ready for pickup. Please wait for this email confirmation\r\n          before coming to the store to ensure your order is ready for you.\r\n        </p>\r\n        \r\n        <h6 class=\"font-weight-bold mb-8\">Do I need to bring anything with me to the store for pickup?</h6>\r\n        <p>When picking your order, we ask that you present:\r\n          <ul>\r\n            <li>\r\n              Photo ID\r\n            </li>\r\n            <li>\r\n              Order Confirmation Email\r\n            </li>\r\n          </ul>\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Can my order be changed from In-Store Pickup to being shipped?</h6>\r\n        <p>\r\n          Please contact the store.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Can I pickup my order at another Wild Birds Unlimited Store?</h6>\r\n        <p>\r\n          All orders must be picked up from the store in which your online order was placed. The location will be listed\r\n          on the email confirmation.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Can I send someone else to pickup my order?</h6>\r\n        <p>\r\n          Yes, once you have placed your online order please contact the store to inform them you've arranged for\r\n          someone else to pickup your order. The person picking up your order will need to provide valid ID and present\r\n          the email confirmation.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">What happens if I cannot pickup my order at the designated time?</h6>\r\n        <p>\r\n          Call the store to let us know and we can hold it until you are available to pick it up or up to five days.\r\n        </p>\r\n\r\n        <h6 class=\"font-weight-bold mb-8\">Will I still earn Bird Buck Coupons with my online order?</h6>\r\n        <p>\r\n          Yes and if you earn a Bird Buck Coupon with your purchase, this will be provided to you by our sales associate\r\n          at time of pickup.\r\n        </p>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n</div>"

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _newOrder = __webpack_require__(136);
	
	var _newOrder2 = _interopRequireDefault(_newOrder);
	
	var _recentOrder = __webpack_require__(137);
	
	var _recentOrder2 = _interopRequireDefault(_recentOrder);
	
	var _favorites = __webpack_require__(138);
	
	var _favorites2 = _interopRequireDefault(_favorites);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _DSC = __webpack_require__(142);
	
	var _DSC2 = _interopRequireDefault(_DSC);
	
	var _bannerImage = __webpack_require__(108);
	
	var _bannerImage2 = _interopRequireDefault(_bannerImage);
	
	var _logoS = __webpack_require__(110);
	
	var _logoS2 = _interopRequireDefault(_logoS);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	var _caWarn = __webpack_require__(162);
	
	var _caWarn2 = _interopRequireDefault(_caWarn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var caWarn = (_dec = (0, _utils.Component)({
	  controllerAs: 'caWarn',
	  template: _caWarn2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function caWarn($scope, $state, $location, $ngRedux, authService, $order, $window, APP, $stateParams, $anchorScroll) {
	    _classCallCheck(this, caWarn);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$state = $state;
	    this.$location = $location;
	    this.host = $location.host();
	    this.authService = authService;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = authService;
	    this.$order = $order;
	    this.us_zone_2 = 7.99;
	    this.can_zone_0 = 14.99;
	    this.us_shipping_available_for = 75;
	    this.can_shipping_available_for = 99;
	
	    this.APP = APP;
	    var ctrl = this;
	    this.authService.getUserProfile().then(function () {
	      return ctrl.authService.getStoreDetail(ctrl.profile.store.storeURLName);
	    });
	    $anchorScroll.yOffset = 50;
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(caWarn, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        store: state.auth.storeDetail
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }, {
	    key: 'isMobileDevice',
	    value: function isMobileDevice() {
	      return this.$auth.isMobileLandscapeDevice();
	    }
	  }]);
	
	  return caWarn;
	}(), _class2.$inject = ['$scope', '$state', '$location', '$ngRedux', 'authService', 'orderService', '$window', '$stateParams', 'APP', '$anchorScroll'], _temp)) || _class);
	exports.default = caWarn;

/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports = "<div class=\"cawarning\">\r\n  <div class=\"content-block\">\r\n    <h1>California Warning -</h1>\r\n    <h2>Proposition 65</h2>\r\n    <p>\r\n      Risk of cancer from exposure to lead, phthalates, BPA and reproductive harm from \r\n      exposure to lead, phalates, BPA. See \r\n      <a href=\"https://www.p65warnings.ca.gov/\" target=\"_blank\">www.p65warnings.ca.gov</a>.\r\n    </p>\r\n  </div>\r\n</div>"

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _faqBirdsCritters = __webpack_require__(164);
	
	var _faqBirdsCritters2 = _interopRequireDefault(_faqBirdsCritters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BirdsCritters = (_dec = (0, _utils.Component)({
	  controllerAs: 'birdsCritters',
	  template: _faqBirdsCritters2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function BirdsCritters($state, $location, $stateParams, $window, APP, $auth) {
	    _classCallCheck(this, BirdsCritters);
	
	    this.$state = $state;
	    this.$location = $location;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	  }
	
	  _createClass(BirdsCritters, [{
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }]);
	
	  return BirdsCritters;
	}(), _class2.$inject = ['$state', '$location', '$window', '$stateParams', 'APP', 'authService'], _temp)) || _class);
	exports.default = BirdsCritters;

/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar ng-if=\"birdsCritters.isLoggedIn()\" class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav ng-if=\"birdsCritters.isLoggedIn()\" class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"birdsCritters.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{birdsCritters.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"rules-faq\">Rules / FAQs</a>\r\n    <span>Birds & Critters</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 p-b-1 p-t-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <uib-accordion>\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc1\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc1, 'accordion-plus': !acc1}\">How do I encourage to the birds to be tidy?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">Encourage your birds to have tidy dining habits. Here are some things you can do that will help prevent bird food from reaching the ground.</p>\r\n            <p class=\"mb-8\">Select foods that minimize the amount of scattered seed that reaches the ground; Wild Birds Unlimited No-mess Blends or seeds without their shells like sunflower chips or shelled peanuts work very well.</p>\r\n            <p class=\"mb-8\">Avoid discount seed blends as they may contain large amounts of cereal grain fillers, which the birds don't like to eat and usually end up on the ground.</p>\r\n            <p class=\"mb-8\">Don't overfeed. Put out only as much food as the birds will eat each day. All Wild Birds Unlimited custom seed blends are regionally selected to contain the seeds your local birds prefer – so fewer seeds are wasted and dropped to the ground. The Certified Bird Feeding Specialists at Wild Birds Unlimited stores can help you choose the right seed for your situation.</p>\r\n            <p class=\"mb-8\">Use tray feeders to keep foods from falling to the ground. The Dinner Bell feeder has a built-in tray and a protective, adjustable roof. You can offer any blend or straight seed from the Dinner Bell as well as cylinder and stackable foods.</p>\r\n            <p class=\"mb-8\">Use trays under feeders to keep debris from falling to the ground. Round trays are perfect to attach to seed tube feeders and rectangular trays suit hopper feeders best. And bigger is better because there's more area to catch falling seeds!</p>\r\n            <p>With proper planning you can enjoy the backyard bird feeding hobby and have a tidy backyard. Stop by the store and chat with our Certified Bird Feeding Specialists about tidy bird feeding solutions that are right for you!</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc2\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc2, 'accordion-plus': !acc2}\">Where are the birds?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">So, you set out a new feeder and the birds are not eating from it? This is normal. After installing a new feeder it can take a day or a number of weeks before the birds will readily take to it; even if it replaces an existing feeder.</p>\r\n            <p class=\"mb-8\">Here are a few things to consider:</p>\r\n            <p class=\"mb-8\">Patience is key when birds are getting used to a new feeder.</p>\r\n            <p class=\"mb-8\">Birds generally find their food by sight. Placing your feeder where it will be visible to them should decrease the time it takes for birds to start feeding.</p>\r\n            <p class=\"mb-8\">Sometimes sprinkling some food on the ground or on top of the feeder will let the birds know that you are open for business.</p>\r\n            <p class=\"mb-8\">It is important that you use a food based on the birds in your area and for the type of feeder. Blends with a lot of millet are great for hopper feeders; but, not for tube feeders. Seed blends high in sunflower and peanuts do best in tube feeders.</p>\r\n            <p class=\"mb-8\">Birds often have a preference with their food as well as perching options. The jays, grosbeaks, towhees and cardinals prefer a platform on which to land and feed. This can be accomplished by adding a tray to a tube feeder.</p>\r\n            <p class=\"mb-8\">Place the feeder near cover. Birds are often most comfortable when there is cover about 5-10 feet away. They can hide to make sure the coast is clear or duck quickly into the cover if a predator arrives.</p>\r\n            <p class=\"mb-8\">Remember to keep your feeders clean and change the food at least once per month if the birds have not begun eating.</p>\r\n            <p>In order to not waste seed until the birds start using the feeder, consider placing only enough food to fill the feeder to the first level of feeding ports. Once the birds find it and are eating regularly, you can fill it up completely.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc3\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc3, 'accordion-plus': !acc3}\">I put out my finch feeder and no birds are using it. What am I doing wrong?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>Sometimes finches are picky eaters. It may take them a while to get used to coming to your new finch feeder. Check the seed in the tube by shaking it every week for freshness and to be sure that the seed is not getting moist. If the seed is getting moist or a month or two has passed, replace the seed. Be patient, it is worth the wait!</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc4\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc4, 'accordion-plus': !acc4}\">Why do I see lots of goldfinches at my feeders some days and none on other days?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">Goldfinches move around a lot. It is reported that 25 to 100 different goldfinches can visit a feeder in one day.</p>\r\n            <p>In most areas throughout North America, they increase their feeding activities at feeders during the spring and will feed all summer long. The southern states are their typical wintering ground, and they fly farther north to spend the spring and summer.</p>\r\n            <p class=\"mb-8\">Because goldfinches are known to be picky eaters, there are several things you can do to make sure goldfinches find your yard attractive:</p>\r\n            <ul type=\"disc\" class=\"p-l-1\">\r\n              <li class=\"mb-8\">Keep seed fresh and dry inside the tube. Shake the tube periodically to make sure that the seed inside the tube feeder is dry.</li>\r\n              <li class=\"mb-8\">Make sure the seed does not stay in the feeder uneaten for more than a month (two to four weeks in wet climates).</li>\r\n              <li class=\"mb-8\">Transfer the seed (as long as it is not moldy) into another feeder if it goes uneaten in your finch tube feeder.</li>\r\n              <li class=\"mb-8\">Place your tube feeder away from the feeders where larger birds are feeding. This allows the smaller birds access to the finch feeder without being harassed by larger birds.</li>\r\n              <li class=\"mb-8\">A tray is not recommended for finch feeders because it may encourage larger unwelcome birds. In addition, because finches typically sit at the feeder to eat, their droppings fall to the tray where food may spill</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc5\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc5, 'accordion-plus': !acc5}\">How do I deter blackbirds?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">To deter blackbirds you need to deny them the food they want to eat, either by not offering it, or by putting it in the feeders and/or cages that have been proven to keep them out.</p>\r\n            <p class=\"mb-8\">Blackbirds are very opportunistic and tend move on when the picking gets slim. By removing your problem feeders and seeds you should see the blackbirds leave the area after a short-time (unless a lot of neighbors are also feeding them or they are nesting). Replace the feeders a few days after the population has dropped. As for your other resident birds, they should return to your feeders soon after you put them back up.</p>\r\n            <p class=\"mb-8\">If blackbirds are gobbling up all your bird seed, you can try the safflower solution! Safflower is a small, white seed that is high in protein and fat. Many favorite backyard birds – including cardinals, House Finches, jays, chickadees, doves, Red-bellied Woodpeckers, titmice and White-breasted Nuthatches – savor safflower. Blackbirds, grackles and squirrels typically do not.</p>\r\n            <p class=\"mb-8\">Offer plain suet in a suet feeder. Woodpeckers and other clinging birds will still eat it; but, the blackbirds usually don't care for it.</p>\r\n            <p class=\"mb-8\">Offer peanuts-in-the-shell to help attract jays, titmice, chickadees, nuthatches and woodpeckers!</p>\r\n            <p class=\"mb-8\">Try feeding sunflower chips in tube and tray feeders. Starlings generally eat a little and move on leaving most of it for your other birds.</p>\r\n            <p class=\"mb-8\">Continue to feed Nyjer (thistle) seed to your Goldfinches. The Starlings don't seem to care for this seed. And, you might be surprised to see a few other visitors to your finch feeder; such as Chickadees and Nuthatches!</p>\r\n            <p class=\"mb-8\">Another good way to exclude blackbirds is to use feeders that will not allow them access to the food.</p>\r\n            <ul type=\"disc\" class=\"p-l-1\">\r\n              <li class=\"mb-8\">The WBU Upside Down Suet Feeder deters blackbirds as they do not naturally feed upside down. Woodpeckers and other clinging birds are quite comfortable feeding in this fashion.</li>\r\n              <li class=\"mb-8\">The WBU Upside Down Suet Feeder deters blackbirds as they do not naturally feed upside down. Woodpeckers and other clinging birds are quite comfortable feeding in this fashion.</li>\r\n              <li class=\"mb-8\">The WBU Dinner Bell feeder has a hood that can be adjusted to eliminate larger birds while allowing smaller birds to feed.</li>\r\n              <li class=\"mb-8\">Weight sensitive feeders, like the WBU Eliminator, can be adjusted to close when a larger bird tries to use it.</li>\r\n              <li class=\"mb-8\"> WBU On-guard Cages can be purchased in 1.5″ and 2″ opening sizes that when put on the outside of existing feeders, allowing smaller birds through while keeping out larger birds.</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc6\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc6, 'accordion-plus': !acc6}\">How do I deter doves and pigeons?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">In deterring pigeons and doves, food is the first thing to address. Cracked corn, millet and cereal grains are preferred by pigeons and doves! Use blends without them such as a No-Mess Blend without millet.</p>\r\n            <p class=\"mb-8\">The type of feeder used can also allow doves and pigeons easy access to the seed or deter them. Here are a few suggestions that should encourage the smaller birds while keeping the pigeons and doves at bay:</p>\r\n            <p class=\"mb-8\">Wild Birds Unlimited tube feeders without a tray on the bottom should be difficult for pigeons to use because of the perch length. However, on-guard cages on seed tube feeders keep out both doves and pigeons.</p>\r\n            <p class=\"mb-8\">The WBU Dinner Bell feeder has a hood that can be adjusted to eliminate larger birds while allowing smaller birds to feed.</p>\r\n            <p class=\"mb-8\">Weight sensitive feeders, like the WBU Eliminator, can be adjusted to close when a larger bird tries to use it.</p>\r\n            <p class=\"mb-8\">Pigeon Guards can be installed on most WBU wooden hopper feeders.</p>\r\n            <p class=\"mb-8\">Feed finches with a finch feeder and Nyjer (thistle) and use an on-guard cage (a cage that goes over the feeder to deter larger birds) if it is needed.</p>\r\n            <p>Offer suet in an upside-down suet feeder for woodpeckers and other insect-eating birds. Offer nectar feeders for the hummingbirds.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc7\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc7, 'accordion-plus': !acc7}\">How do I deter raccoons?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">We recommend placing feeders on a pole system that has a raccoon baffle. The raccoon baffle for our Advanced Pole System (APS) is most effective when mounted with the top of the baffle about 5 feet high and all feeders are above the top of the baffle. Also, the APS set-up should be installed out of reach of a raccoon that may climb a tree or something else like a deck rail to reach over to the set-up.</p>\r\n            <p>You can feed birds from your deck rail and still deny raccoons access using a baffle on an APS setup. The Certified Bird Feeding Specialist at your local Wild Birds Unlimited store can show you how.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc8\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc8, 'accordion-plus': !acc8}\">How do I keep cats away from my bird feeders?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">Deterring cats from accessing birds at feeders is a tough situation. However, there are few techniques that you can implement to help keep the birds safe.</p>\r\n            <p class=\"mb-8\">Place feeders in the open about 10 feet away from any low shrubs or areas of concealment where cats can hide. The open space allows birds time to recognize the danger and get away safely.</p>\r\n            <p class=\"mb-8\">Avoid feeding birds at ground-level or low to the ground. Use tidy feeding techniques to prevent food from falling to the ground where birds are vulnerable to cats. Use no-mess blends and place trays under feeders to catch any falling seeds.</p>\r\n            <p class=\"mb-8\">You can fence off the bird feeding area to create a barrier that will help slow down any attack by a cat. The cats will probably climb any fence you install; but, it will give the birds some additional time to get away.</p>\r\n            <p class=\"mb-8\">There are motion activated sprinklers that reportedly work on cats. Be aware they work on people, too, when you forget they are activated.</p>\r\n            <p>There are scent deterrents on the market which may or may not work to deter cats. They can be applied around the perimeter of your yard and may be worth trying.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc9\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc9, 'accordion-plus': !acc9}\">What do I do about hawks at my feeders?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">Having a hawk in the neighborhood that is eating an occasional songbird is a natural behavior and part of the cycle of life. The raptor is just doing what is necessary to survive and studies have shown that bird-eating hawks, like a Cooper's hawk, succeed in catching prey in about 30 percent of their attempts. They will catch their meals somewhere regardless of whether you are feeding the birds or not... but, let's try to send them elsewhere to do it!</p>\r\n            <p class=\"mb-8\">The first step to help discourage the hawk from hanging around your backyard is to take down your feeders for a few days. The hawk should go elsewhere for food and will hopefully find a new location for hunting and not return. However, the hawk or a different one may return again and the process will need to be repeated. Your songbirds will leave while the feeders are down, but will return once you replace your feeders.</p>\r\n            <p class=\"mb-8\">When you do see the hawk, make sure to create a lot of noise and commotion to scare it away. Hopefully, it will be startled enough not to return to a location that it feels is threatening.</p>\r\n            <p class=\"mb-8\">Also, help your songbirds be a more difficult target for the hawk by making sure your feeders are located where there is ample natural protection. Nearby evergreen shrubs, bushes, trees or a brush pile will provide birds with an easy escape when they are threatened by a hawk.</p>\r\n            <p>Federal and state laws prohibit the harassment or harming of hawks and owls, so any direct action that may endanger them is not an option.</p>\r\n          </div>\r\n        </div>\r\n      </uib-accordion>\r\n\r\n      <h5 class=\"font-weight-bold m-t-3 m-b-2\">Hummingbirds</h5>\r\n      <uib-accordion>\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc10\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc10, 'accordion-plus': !acc10}\">What do I put in the hummingbird feeder?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>Four parts water to one part sugar. This can be one cup of water and a quarter cup of sugar. Use only table sugar and never honey, other sugars or artificial sweeteners.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc11\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc11, 'accordion-plus': !acc11}\">How often do I clean my feeder?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>Clean your feeder every three to four days. Use only warm or hot water and a soft brush to clean the feeder.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc12\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc12, 'accordion-plus': !acc12}\">What more can I do to attract hummingbirds? I know they are here, but they don't come to my feeder.</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>During nesting time hummingbirds may not be as likely to come to feeders. They are feeding insects to their young. Once the young have left the nest and during the fall migration you will probably noticed increased activity at your feeder.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc13\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc13, 'accordion-plus': !acc13}\">Where are the hummingbirds?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>During nesting season the females are probably busy nesting. Once the babies have hatched, the hummingbirds are gathering a lot of insects to feed their babies, so they probably aren't spending a lot of time at the feeder.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc14\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc14, 'accordion-plus': !acc14}\">What can I do to keep ants off my feeder?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>An ant trap can be purchased. Ant traps are designed to keep ants that crawl up a pole onto the feeder from actually entering the feeder. The ant traps do not necessarily work if ants are jumping from trees onto the feeder.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc15\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc15, 'accordion-plus': !acc15}\">What can I do to keep bees off my feeder?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>Use a tray-style feeder. Clean the feeder. Remove any yellow portions. Install bee guard tips. Move the feeder a few feet away from its location till the bees find it again.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc16\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc16, 'accordion-plus': !acc16}\">Can I put Vaseline on the feeder to keep ants and bees from landing on the feeder?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>It is not suggested that Vaseline be used because it is too likely that the greasy substance could get onto the birds and make it hard for the birds to clean their feathers properly.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc18\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc18, 'accordion-plus': !acc18}\">Will I keep the hummingbirds here if I feed them into the fall?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>Remember, it is not necessary to take down feeders to force the birds to fly south. They will migrate. If hummingbirds are sticking around, it could be because they are sick or injured. Some experts recommend leaving the feeder up with a spot light (150 watt bulb) on the feeder to keep the nectar from freezing). Amazingly enough some hummingbirds are still able to find insect larvae in the bark of trees. It is not necessary to &lsquo;fly&rsquo; the birds south. Nature is nature and is never a guarantee that all birds will survive.</p>\r\n          </div>\r\n        </div>\r\n      </uib-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _faqFranchising = __webpack_require__(166);
	
	var _faqFranchising2 = _interopRequireDefault(_faqFranchising);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Franchising = (_dec = (0, _utils.Component)({
	  controllerAs: 'franchising',
	  template: _faqFranchising2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Franchising($state, $location, $auth, $window, $stateParams, APP) {
	    _classCallCheck(this, Franchising);
	
	    this.$state = $state;
	    this.$location = $location;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	
	    this.APP = APP;
	  }
	
	  _createClass(Franchising, [{
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }]);
	
	  return Franchising;
	}(), _class2.$inject = ['$state', '$location', 'APP', '$stateParams', '$window', 'authService'], _temp)) || _class);
	exports.default = Franchising;

/***/ },
/* 166 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n <!-- <navigation-bar ng-if=\"franchising.isLoggedIn()\" class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav ng-if=\"franchising.isLoggedIn()\" class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\"  ng-click=\"franchising.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{franchising.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"rules-faq\">Rules / FAQs</a>\r\n    <span>Franchising</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 p-b-1 p-t-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <p>Click a question below to reveal the answer.</p>\r\n      <uib-accordion>\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc1\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc1, 'accordion-plus': !acc1}\">How much does a Wild Birds Unlimited franchise cost?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p>The typical investment for a Wild Birds Unlimited franchise is from $125,978 to $199,172, including franchise fee and working capital.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc2\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc2, 'accordion-plus': !acc2}\">How long does it take to open a Wild Birds Unlimited?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>Our step-by-step franchise development process takes between 45-60 days. Once your site has been selected and a lease is signed, the site preparation takes approximately 8-12 weeks.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc3\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc3, 'accordion-plus': !acc3}\">Do I need to have retail experience before opening a Wild Birds Unlimited franchise?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>We're looking for entrepreneurs who want to build a business that fulfills their passion for birds and nature and gives back to their community. Wild Birds Unlimited provides an easy-to-operate, scalable business model. Our intense training, both classroom and in-store, provides you with all the experience you will need.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc4\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc4, 'accordion-plus': !acc4}\">Do I need to be a bird expert to successfully own and operate a Wild Birds Unlimited franchise?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>You do need to have a level of passion and interest in nature and the hobby of back yard bird feeding, but we will teach you how become your community's back yard bird feeding expert. All you need is the desire and interest to learn.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc5\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc5, 'accordion-plus': !acc5}\">What are the financial qualifications to become a franchisee?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>We are seeking someone with a minimum net worth of $300,000 and at least $30,000 in liquid capital.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc6\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc6, 'accordion-plus': !acc6}\">How much is the franchise fee for Wild Birds Unlimited franchises?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>New franchisees pay a $25,000 franchise fee upon signing the franchise agreement.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc7\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc7, 'accordion-plus': !acc7}\">How long is the franchise agreement?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>We offer 10-year renewable franchising agreements. Our renewal term is 5 years, with no fee upon renewal.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc8\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc8, 'accordion-plus': !acc8}\">What is the best location for a Wild Birds Unlimited?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>The best location for a Wild Birds Unlimited store is in a busy retail shopping center, typically anchored by big-box retailers and/or grocery stores that attract our target customers three to four times a week. We find that drive-by visibility is the #1 way to attract new customers... and once they find you the first time, it is your job to deliver an exceptional customer experience (and we will show you how to do just that!)</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc9\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc9, 'accordion-plus': !acc9}\">How big is the bird feeding industry?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>According to the U.S. Fish & Wildlife Service, 2011 National Survey of Fishing, Hunting, and Wildlife-Associated Recreation National Overview (Issued August 2012):\r\n            <ul type=\"disc\">\r\n              <li>52.8 Million people participate in feeding birds and other wildlife</li>\r\n              <li>$5 Billion is spent annually on birdseed and wildlife food</li>\r\n              <li>$969 Million is spent annually on bird feeders, bird baths and nesting boxes</li>\r\n              <li>$918 Million is spent annually on binoculars and spotting scopes</li>\r\n              <li>$6.9 Billion is spent annually on bird feeding and watching wildlife</li>\r\n            </ul></p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc10\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc10, 'accordion-plus': !acc10}\">How many employees will I need before opening my Wild Birds Unlimited franchise?</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p>Before you open your store, we strongly recommend that you hire and train two part-time employees.</p>\r\n          </div>\r\n        </div>\r\n      </uib-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _faqProductWarranties = __webpack_require__(168);
	
	var _faqProductWarranties2 = _interopRequireDefault(_faqProductWarranties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductWarranties = (_dec = (0, _utils.Component)({
	  controllerAs: 'productWarranties',
	  template: _faqProductWarranties2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ProductWarranties($state, $location, $stateParams, $auth, $window, APP) {
	    _classCallCheck(this, ProductWarranties);
	
	    this.$state = $state;
	    this.$location = $location;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	  }
	
	  _createClass(ProductWarranties, [{
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }]);
	
	  return ProductWarranties;
	}(), _class2.$inject = ['$state', '$location', '$stateParams', '$window', 'APP', 'authService'], _temp)) || _class);
	exports.default = ProductWarranties;

/***/ },
/* 168 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar ng-if=\"productWarranties.isLoggedIn()\" class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav ng-if=\"productWarranties.isLoggedIn()\" class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"productWarranties.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{productWarranties.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"rules-faq\">Rules / FAQs</a>\r\n    <span>Product Warranties</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 p-b-1 p-t-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <p>For best results, contact your local Wild Birds Unlimited store to inquire on the availability of replacement parts for warranted products. If your local store does not have the needed parts, contact the manufacturers within the link below.</p>\r\n      <uib-accordion>\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc1\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc1, 'accordion-plus': !acc1}\">WBU Squirrel Proof Bird Feeders</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">The WBU Eliminator and Fundamentals Squirrel Proof Feeders are designed to be easy to maintain and repair. Should a part wear out or break, it can be replaced.</p>\r\n            <p class=\"m-b-0\"><strong>Replacement Parts:</strong></p>\r\n            <p>To order replacement parts or for help, please contact Brome Bird Care's Customer Care Team at 800-856-5685 or by email at info@bromebirdcare.com. Instructional videos are also available at http://www.bromebirdcare.com/videos/instructional-videos.</p>\r\n            <p class=\"m-b-0\"><strong>Warranty:</strong></p>\r\n            <p class=\"mb-4\">The WBU Eliminator Squirrel Proof Feeder is guaranteed to be free of material and manufacturing defects and against squirrel damage or the lifetime of the first owner.</p>\r\n            <p class=\"mb-4\">The Fundamentals Squirrel Proof Feeder is guaranteed to be free of material or manufacturing defects and against squirrel damage for a period of 24 months from the date of purchase.</p>\r\n            <p class=\"mb-4\">The warranty applies only when the product is used according to the manufacturer's instructions. The warranty does not apply to damage from attempted or unauthorized repairs, cosmetic scratches from squirrels or other animals, damage from accidents, dropped or fallen feeders, improper handling, shipping, misuse, abuse, neglect, or damage from chipmunks, raccoons, bears, or other animals.</p>\r\n            <p>Proof of purchase and the prepared return of a defective part(s) or product(s) may be required by Brome Bird Care.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc2\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc2, 'accordion-plus': !acc2}\">WBU Plastic or Mesh Bird Feeders</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"mb-8\">Includes tube feeders, mesh tube feeders, hummingbird feeders, window feeders, the Dinner Bell Feeder, and tube feeder accessories.</p>\r\n            <p>For replacement marts, please contact Aspects' Customer Service Team at 888-277-3287 or by email at aspects@aspectsinc.com.</p>\r\n            <p class=\"m-b-0\"><strong>Warranty:</strong></p>\r\n            <p class=\"mb-4\">Lifetime guarantee except EcoClean Perch Covers.</p>\r\n            <p>Squirrel damage is covered. Call for replacement parts. Repair or replacement of products is at Aspects' discretion.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc3\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc3, 'accordion-plus': !acc3}\">EcoTough<sup>&reg;</sup> Bird Feeders, EcoTough<sup>&reg;</sup> Nesting Boxes</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"m-b-0\"><strong>Replacement Parts:</strong></p>\r\n            <p>Please contact your local store for replacement parts.</p>\r\n            <p class=\"m-b-0\"><strong>Warranty:</strong></p>\r\n            <p>Lifetime guarantee on recycled plastic, to not fade, warp, or crack. Will replace part if feeder is non-functional due to squirrel damage. No guarantee on wood.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc4\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc4, 'accordion-plus': !acc4}\">Advanced Pole System (APS) Hardware</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"m-b-0\"><strong>Replacement Parts:</strong></p>\r\n            <p>Please contact your local store for replacement parts.</p>\r\n            <p class=\"m-b-0\"><strong>Warranty:</strong></p>\r\n            <p>Manufacturer defects are covered for 10 years. Rusting/Powder coating covered for 1 year. Drippers and Misters are a 90 day guarantee. Receipt of purchase is required.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc5\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc5, 'accordion-plus': !acc5}\">Suet Cylinder Bird Feeder, Peanut Ball Feeder, or WBU Mini Peanut Bird Feeder</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25\">\r\n            <p class=\"m-b-0\"><strong>Replacement Parts:</strong></p>\r\n            <p>Please contact your local store for replacement parts.</p>\r\n            <p class=\"m-b-0\"><strong>Warranty:</strong></p>\r\n            <p>Satisfaction guaranteed.</p>\r\n          </div>\r\n        </div>\r\n      </uib-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _privacy = __webpack_require__(170);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Privacy = (_dec = (0, _utils.Component)({
	  controllerAs: 'privacy',
	  template: _privacy2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Privacy($state, $ngRedux, $scope, $auth, $window, APP, $stateParams) {
	    _classCallCheck(this, Privacy);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Privacy, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }]);
	
	  return Privacy;
	}(), _class2.$inject = ['$state', '$ngRedux', '$scope', 'authService', '$window', '$stateParams', 'APP'], _temp)) || _class);
	exports.default = Privacy;

/***/ },
/* 170 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"privacy.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{privacy.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Privacy</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 p-b-1 p-t-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <p>Your privacy on the Internet is important to us. Because we gather certain types of information about the users of our web site, we feel you should fully understand the conditions under which we collect and use that information. This Privacy Policy discloses what information we gather, how we use it, and how to correct or change it.</p>\r\n      <p class=\"m-b-2\">Our site offers links to other sites. Although we make every effort to select sites that we feel might be of interest to our visitors Wild Birds Unlimited cannot guarantee your privacy when linking to one of these sites. This policy covers the following:</p>\r\n      <uib-accordion>\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc1\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc1, 'accordion-plus': !acc1}\">What information this site gathers / tracks about you</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <strong>Information We Collect</strong>\r\n            <p class=\"mb-8\">Our site will not collect any personal information about individuals except when specifically and knowingly provided by such individuals.</p>\r\n            <p class=\"mb-8\">Our site uses order forms for customers to request information, provide feedback to the web site, and sign up for free offers and newsletters. We collect visitor's contact information in order to fulfill the requests made by our visitors for the aforementioned services.</p>\r\n            <p>Our site uses forms to enable visitors to express an interest in franchise opportunities. We collect visitor's contact information (like their mailing address and email address) and financial status information (like present net worth and amount of capital available for investment). Contact information is used to send information about franchise opportunities.</p>\r\n            <strong>Your IP Address / Use of Cookies</strong>\r\n            <p>IP addresses along with browser type and access times are logged in aggregate by our servers to help determine patterns of use of specific areas of our site. We do not link this automatically-collected data to personally identifiable information.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc2\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc2, 'accordion-plus': !acc2}\"> What this site does with the information it gathers / tracks</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p class=\"m-b-0\"><strong>How information is used</strong></p>\r\n            <p class=\"mb-8\">Our site collects contact information primarily to keep lines of communication open with our customers by sending them our newsletters and allowing them to provide us with feedback.</p>\r\n            <p class=\"mb-8\">Your contact data is available only to Wild Birds Unlimited, Inc., its franchise stores and assigned agents. Users may opt out of receiving communications from Wild Birds Unlimited, Inc., its franchise stores and assigned agents; see the choice/opt out section below.</p>\r\n            <p>Though we make every effort to preserve user privacy, we may need to disclose personal information when required by law wherein we have a good-faith belief that such action is necessary to comply with a current judicial proceeding, a court order or legal process served on our Web site.</p>\r\n            <p class=\"m-b-0\"><strong>Service Providers</strong></p>\r\n            <p class=\"mb-8\">We use ExactTarget to provide email marketing services on our site. When you sign up for our email newsletters, we will share your name and email address as necessary for the third party to provide that service. We also use Process Peak to manage and process franchise opportunity inquiries. We will share the information you submit when requesting information about a franchise opportunity with them as neccessary to provide that service.</p>\r\n            <p>We do not share, sell, trade, or rent your personal information to third parties for their promotional use.</p>\r\n            <p class=\"m-b-0\"><strong>Security</strong></p>\r\n            <p class=\"mb-8\">This site has security measures in place to protect the loss, misuse and alteration of the information under our control.</p>\r\n            <p>All of our users' information is restricted in our offices. Only employees who need the information to perform a specific job (for example, our billing clerk or a customer service representative) are granted access to personally identifiable information. Our employees must use password-protected screen-savers when they leave their desk. When they return, they must re-enter their password to re-gain access to user information. Furthermore, ALL employees are kept up-to-date on our security and privacy practices. Every six months, as well as any time new policies are added, our employees are notified and/or reminded about the importance we place on privacy, and what they can do to ensure our user's information is protected. Finally, the servers that store personally identifiable information are in a secure environment in a locked room.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc3\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc3, 'accordion-plus': !acc3}\">With whom this site shares the information it gathers / tracks</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p class=\"m-b-0\"><strong>Where your information is available</strong></p>\r\n            <p>Contact data you provide anywhere on our site (such as name, address and email address) is available only to Wild Birds Unlimited, Inc., its franchise stores and assigned agents. Your e-mail address may be released to a third party used only for the purpose of fulfilling subscriptions for our opt-in e-mailed newsletter.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc4\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc4, 'accordion-plus': !acc4}\">Opt-out policy</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p class=\"m-b-0\"><strong>Choice/Opt-Out</strong></p>\r\n            <p>Visitors to our site receive communications from us only when they opt-in to doing so (such as by subscribing to our email newsletter) or when necessary to confirm details of an order or fulfill any other form of visitor request. You can also send email to <a href=\"mailto:mywbuadmin@wbu.com\" class=\"link-text\">mywbuadmin@wbu.com</a> to remove your information from our database. This will ensure that you do not receive future communications from us or that you no longer receive our service.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc5\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc5, 'accordion-plus': !acc5}\">Correcting and Updating Personally Identifiable Information</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p class=\"m-b-0\"><strong>Correct/Update</strong></p>\r\n            <p>This site gives users the option to change and modify information previously provided. You can send email to <a href=\"mailto:mywbuadmin@wbu.com\" class=\"link-text\">mywbuadmin@wbu.com</a> to correct or update your information in our database.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc6\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc6, 'accordion-plus': !acc6}\">Deleting or Deactivating Your Name from Our Database</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p class=\"m-b-0\"><strong>Delete/Deactivate</strong></p>\r\n            <p>This site gives users the option to change and modify information previously provided. Users who have subscribed to our opt-in e-mail newsletter may change their subscription e-mail address, account preferences or unsubscribe directly from our site. Additionally you can send email to <a href=\"mailto:mywbuadmin@wbu.com\" class=\"link-text\">mywbuadmin@wbu.com</a> to correct or update your information in our database. You will receive a confirmation via e-mail when the requested changes have been made.</p>\r\n          </div>\r\n        </div>\r\n\r\n        <div uib-accordion-group class=\"panel-default\" is-open=\"acc7\">\r\n          <uib-accordion-heading>\r\n            <h5 class=\"pl-25 p-t-1\" ng-class=\"{'accordion-minus': acc7, 'accordion-plus': !acc7}\">Notification of Changes</h5>\r\n          </uib-accordion-heading>\r\n          <div class=\"pl-25 m-b-2\">\r\n            <p class=\"m-b-0\"><strong>Notification of Changes</strong></p>\r\n            <p>Wild Birds Unlimited, Inc. may edit this privacy policy from time to time. If at some point in the future, there is a change to our information usage practices that affect your Personally Identifiable Information, we will notify you by email of the relevant changes. At the time of this message, you will be able to opt-in to this information usage by sending a message to mywbuadmin@wbu.com. You should also check this posted privacy statement for changes.</p>\r\n            <p>If you have any questions about this privacy statement, the practices of this site, or your dealings with this web site, you can contact:</p>\r\n            <p class=\"m-b-0\"><strong>Legal Department</strong></p>\r\n            <p class=\"m-b-0\">Wild Birds Unlimited, Inc.</p>\r\n            <p class=\"m-b-0\">11711 N. College Avenue</p>\r\n            <p class=\"m-b-0\">Suite 146</p>\r\n            <p class=\"m-b-0\">Carmel, IN 46032</p>\r\n            <p class=\"m-b-0\"><a href=\"mailto:mywbuadmin@wbu.com\" class=\"link-text\">mywbuadmin@wbu.com</a></p>\r\n          </div>\r\n        </div>\r\n      </uib-accordion>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(172);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _actions = __webpack_require__(173);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _service = __webpack_require__(174);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _category = __webpack_require__(135);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _subCategory = __webpack_require__(175);
	
	var _subCategory2 = _interopRequireDefault(_subCategory);
	
	var _product = __webpack_require__(178);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _detail = __webpack_require__(183);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _review = __webpack_require__(196);
	
	var _review2 = _interopRequireDefault(_review);
	
	var _cart = __webpack_require__(198);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _guestCart = __webpack_require__(203);
	
	var _guestCart2 = _interopRequireDefault(_guestCart);
	
	var _storeDetail = __webpack_require__(205);
	
	var _storeDetail2 = _interopRequireDefault(_storeDetail);
	
	var _delivery = __webpack_require__(207);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	var _guestDelivery = __webpack_require__(209);
	
	var _guestDelivery2 = _interopRequireDefault(_guestDelivery);
	
	var _accessibility = __webpack_require__(211);
	
	var _accessibility2 = _interopRequireDefault(_accessibility);
	
	var _address = __webpack_require__(213);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _cardDetail = __webpack_require__(215);
	
	var _cardDetail2 = _interopRequireDefault(_cardDetail);
	
	var _orderDetail = __webpack_require__(221);
	
	var _orderDetail2 = _interopRequireDefault(_orderDetail);
	
	var _failure = __webpack_require__(223);
	
	var _failure2 = _interopRequireDefault(_failure);
	
	var _recentOrder = __webpack_require__(225);
	
	var _recentOrder2 = _interopRequireDefault(_recentOrder);
	
	var _savingsClub = __webpack_require__(227);
	
	var _savingsClub2 = _interopRequireDefault(_savingsClub);
	
	var _search = __webpack_require__(229);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _storelocator = __webpack_require__(231);
	
	var _storelocator2 = _interopRequireDefault(_storelocator);
	
	var _subscription = __webpack_require__(233);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _subscriptionProduct = __webpack_require__(235);
	
	var _subscriptionProduct2 = _interopRequireDefault(_subscriptionProduct);
	
	var _productDetail = __webpack_require__(237);
	
	var _productDetail2 = _interopRequireDefault(_productDetail);
	
	var _subscriptionDetail = __webpack_require__(239);
	
	var _subscriptionDetail2 = _interopRequireDefault(_subscriptionDetail);
	
	var _subscriptionSuccess = __webpack_require__(242);
	
	var _subscriptionSuccess2 = _interopRequireDefault(_subscriptionSuccess);
	
	var _cardsManagement = __webpack_require__(244);
	
	var _cardsManagement2 = _interopRequireDefault(_cardsManagement);
	
	var _giftCard = __webpack_require__(248);
	
	var _giftCard2 = _interopRequireDefault(_giftCard);
	
	var _constants = __webpack_require__(84);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _paymentDetail = __webpack_require__(251);
	
	var _paymentDetail2 = _interopRequireDefault(_paymentDetail);
	
	var _tsysPayment = __webpack_require__(253);
	
	var _tsysPayment2 = _interopRequireDefault(_tsysPayment);
	
	var _monerisPayment = __webpack_require__(255);
	
	var _monerisPayment2 = _interopRequireDefault(_monerisPayment);
	
	var _cardUpdate = __webpack_require__(219);
	
	var _cardUpdate2 = _interopRequireDefault(_cardUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.order', []).config(_router2.default).value('orderActions', _actions2.default).factory('orderService', _service2.default).constant('APP', _constants2.default).component('category', _category2.default).component('subCategory', _subCategory2.default).component('product', _product2.default).component('productDetail', _detail2.default).component('productReview', _review2.default).component('cart', _cart2.default).component('storeDetail', _storeDetail2.default).component('delivery', _delivery2.default).component('deliveryAddress', _address2.default).component('cardDetail', _cardDetail2.default).component('paymentSuccess', _orderDetail2.default).component('paymentFailure', _failure2.default).component('recentOrder', _recentOrder2.default).component('savingsClub', _savingsClub2.default).component('search', _search2.default).component('storelocator', _storelocator2.default).component('subscription', _subscription2.default).component('subscriptionProducts', _subscriptionProduct2.default).component('productsDetail', _productDetail2.default).component('subscriptionDetail', _subscriptionDetail2.default).component('subscriptionSuccess', _subscriptionSuccess2.default).component('cardsManagement', _cardsManagement2.default).component('giftCard', _giftCard2.default).component('paymentDetail', _paymentDetail2.default).component('tsysPayment', _tsysPayment2.default).component('monerisPayment', _monerisPayment2.default).component('cardUpdate', _cardUpdate2.default).component('guestcart', _guestCart2.default).component('guestdelivery', _guestDelivery2.default).component('accessibility', _accessibility2.default).filter('trustAsResourceUrl', ['$sce', function ($sce) {
	  return function (val) {
	    return $sce.trustAsResourceUrl(val);
	  };
	}]);

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routerConfig;
	routerConfig.$inject = ['$urlRouterProvider', '$stateProvider', 'APP'];
	
	function routerConfig($urlRouterProvider, $stateProvider, APP) {
	  // $urlRouterProvider.otcerwise('/');
	  $stateProvider.state({
	    name: 'order',
	    parent: 'app',
	    url: '/order',
	    abstract: true,
	    views: {
	      'header@app': {
	        template: '<header></header>'
	      },
	      'sidenav@app': {
	        template: '<sidenav></sidenav>'
	      }
	    },
	    resolve: {
	      isAuthenticated: ['authService', '$stateParams', function (authService) {
	        return authService.isAuthenticated();
	      }]
	    }
	  }).state({
	    name: 'cart',
	    parent: 'order',
	    url: '/cart',
	    views: {
	      'content@app': {
	        template: '<cart></cart>'
	      }
	    }
	  }).state({
	    name: 'guestcart',
	    parent: 'order',
	    url: '/guestcart',
	    views: {
	      'content@app': {
	        template: '<guestcart></guestcart>'
	      }
	    }
	  }).state({
	    name: 'guestdelivery',
	    parent: 'order',
	    url: '/guestdelivery',
	    views: {
	      'content@app': {
	        template: '<guestdelivery></guestdelivery>'
	      }
	    }
	  }).state({
	    name: 'accessibility',
	    parent: 'order',
	    url: '/accessibility',
	    views: {
	      'content@app': {
	        template: '<accessibility></accessibility>'
	      }
	    }
	  }).state({
	    name: 'savings-club',
	    parent: 'order',
	    url: '/daily-savings-club/:storeName',
	    views: {
	      'content@app': {
	        template: '<savings-club></savings-club>'
	      }
	    },
	    resolve: {
	      isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
	        $timeout(function () {
	          if ($stateParams.storeName && $stateParams.storeName != APP.ORDER_URL.browseUrl && !authService.isLoggedIn()) {
	            authService.getStoreDetail($stateParams.storeName).then(function (success) {
	              var store = {};
	              store.storeId = success.data.storeId;
	              store.storeName = $stateParams.storeName;
	              authService.doGuestLogin(store);
	              return authService.isAuthenticated();
	            }, function (error) {
	              if (error) {
	                return authService.isAuthenticated();
	              }
	            });
	          } else {
	            return authService.isAuthenticated();
	          }
	        });
	      }]
	    }
	  }).state({
	    name: 'gift-card',
	    parent: 'order',
	    url: '/gift-card/:storeName',
	    views: {
	      'content@app': {
	        template: '<gift-card></gift-card>'
	      }
	    },
	    resolve: {
	      isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
	        $timeout(function () {
	          if ($stateParams.storeName && $stateParams.storeName != APP.ORDER_URL.browseUrl && !authService.isLoggedIn()) {
	            authService.getStoreDetail($stateParams.storeName).then(function (success) {
	              var store = {};
	              store.storeId = success.data.storeId;
	              store.storeName = $stateParams.storeName;
	              authService.doGuestLogin(store);
	              return authService.isAuthenticated();
	            }, function (error) {
	              if (error) {
	                return authService.isAuthenticated();
	              }
	            });
	          } else {
	            return true;
	          }
	        });
	      }]
	    }
	  }).state({
	    name: 'search',
	    parent: 'order',
	    url: '/search/:storeName?searchTerm',
	    views: {
	      'content@app': {
	        template: '<search></search>'
	      }
	    }
	  })
	  // .state({
	  //   name: 'browse',
	  //   parent: 'app',
	  //   url: '/browse/:categoryName',
	  //   controller :'category',
	  //   views: {
	  //     'header@app': {
	  //       template: '<header></header>'
	  //     },
	  //     'sidenav@app': {
	  //       template: '<sidenav></sidenav>'
	  //     },
	  //     'content@app': {
	  //       template: '<category></category>'
	  //     }
	  //   },
	  //   data: {
	  //     meta: {
	  //       'title': 'Category Page',
	  //       'description': 'Category Page Description',
	  //       'url':'Category  Url',
	  //       'type':'Category Type',
	  //       'image':'Category Image',
	  //       'alt':'Category Alt'
	
	  //     }
	  //   },
	  //   resolve: {
	  //     isAuthenticated: ['authService', '$stateParams', '$timeout', function(authService, $stateParams, $timeout) {
	  //       $timeout(() => {
	  //         if (!authService.isLoggedIn()) {
	  //           let storeName = $stateParams.storeName;
	  //           let categoryName = $stateParams.categoryName;
	  //           if(storeName && storeName!='') {
	  //           authService.getStoreDetail(storeName).then(success => {
	  //             let store = {};
	  //             store.storeId = success.data.storeId;
	  //             store.storeName = storeName;
	  //             authService.doGuestLogin(store);
	  //             return authService.isAuthenticated();
	  //           },
	  //         error => {
	  //           if (error) {
	  //             return authService.isAuthenticated();
	  //           }
	  //         }
	  //       ); }
	  //       else {
	  //         let store = {};
	  //         store.storeId = '';
	  //         store.storeName = '';
	  //         authService.doGuestLogin(store);
	  //         return authService.isAuthenticated();
	  //       }
	
	  //         }
	  //         else {
	  //           return authService.isAuthenticated();
	  //         }
	  //       });
	  //     }]
	  //   }
	  // })
	  .state({
	    name: 'category',
	    parent: 'app',
	    url: '/:storeName',
	    controller: 'category',
	    views: {
	      'header@app': {
	        template: '<header></header>'
	      },
	      'sidenav@app': {
	        template: '<sidenav></sidenav>'
	      },
	      'content@app': {
	        template: '<category></category>'
	      }
	    },
	    data: {
	      meta: {
	        'title': 'Category Page',
	        'description': 'Category Page Description',
	        'url': 'Category  Url',
	        'type': 'Category Type',
	        'image': 'Category Image',
	        'alt': 'Category Alt'
	
	      }
	    },
	    resolve: {
	      isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
	        var _this = this;
	
	        $timeout(function () {
	          if ($stateParams.storeName == APP.ORDER_URL.browseUrl && $stateParams.subCategoryId != undefined && !$stateParams.subCategoryId) {
	
	            // let value = authService.isBrowseUrl();
	            return false;
	          }
	          if (!authService.isLoggedIn()) {
	            var storeName = '';
	            if ($stateParams.storeName) {
	              storeName = $stateParams.storeName;
	            } else {
	              if (_this.profile && _this.profile.store && _this.profile.store.storeName) {
	                storeName = _this.profile.store.storeURLName;
	              } else {
	                storeName = authService.getGuestStoreDetail().storeName;
	              }
	            }
	            if (storeName && storeName != '') {
	              authService.getStoreDetail(storeName).then(function (success) {
	                var store = {};
	                store.storeId = success.data.storeId;
	                store.storeName = storeName;
	                authService.doGuestLogin(store);
	                return authService.isAuthenticated();
	              }, function (error) {
	                if (error) {
	                  return authService.isAuthenticated();
	                }
	              });
	            } else {
	              // let store = {};
	              // store.storeId = '';
	              // store.storeName = '';
	              // authService.doGuestLogin(store);
	              return authService.isAuthenticated();
	            }
	          } else {
	            return authService.isAuthenticated();
	          }
	        });
	      }]
	    }
	  }).state({
	    name: 'browse-sub-category',
	    parent: 'app',
	    url: '/:storeName/:categoryId',
	    controller: 'sub-category',
	    views: {
	      'header@app': {
	        template: '<header></header>'
	      },
	      'sidenav@app': {
	        template: '<sidenav></sidenav>'
	      },
	      'content@app': {
	        template: '<sub-category></sub-category>'
	      }
	    },
	    data: {
	      meta: {
	        'title': 'subCategory Page',
	        'description': 'subCategory Page Description /:categoryId',
	        'url': 'subCategory  Url',
	        'type': 'subCategory Type',
	        'image': 'subCategory Image',
	        'alt': 'subCategory Alt'
	
	      }
	    },
	    resolve: {
	      isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
	        var _this2 = this;
	
	        $timeout(function () {
	
	          if (!authService.isLoggedIn()) {
	            var storeName = '';
	            if ($stateParams.storeName) {
	              if (!'shop' === $stateParams.storeName) {
	                storeName = $stateParams.storeName;
	              }
	            } else {
	
	              if (_this2.profile && _this2.profile.store && _this2.profile.store.storeName) {
	                storeName = _this2.profile.store;
	              } else {
	                storeName = authService.getGuestStoreDetail().storeName;
	              }
	            }
	            if (storeName && storeName != '') {
	              authService.getStoreDetail(storeName).then(function (success) {
	                var store = {};
	                store.storeId = success.data.storeId;
	                store.storeName = storeName;
	                authService.doGuestLogin(store);
	                return authService.isAuthenticated();
	              }, function (error) {
	                if (error) {
	                  return authService.isAuthenticated();
	                }
	              });
	            } else {
	              // let store = {};
	              // store.storeId = '';
	              // store.storeName = '';
	              // authService.doGuestLogin(store);
	              return authService.isAuthenticated();
	            }
	          } else {
	            return authService.isAuthenticated();
	          }
	        });
	      }]
	    }
	  })
	  /* .state({
	    name: 'sub-category',
	    parent: 'category',
	    url: '/:categoryId',
	    controller :'sub-category',
	    views: {
	      'content@app': {
	        template: '<sub-category></sub-category>'
	      }
	    },
	    data: {
	      meta: {
	        'title': 'subCategory Page',
	        'description': 'subCategory Page Description /:categoryId',
	        'url':'subCategory  Url',
	        'type':'subCategory Type',
	        'image':'subCategory Image',
	        'alt':'subCategory Alt'
	        }
	    }
	  })*/
	  .state({
	    name: 'browse-product',
	    parent: 'browse-sub-category',
	    url: '/:subCategoryId',
	    views: {
	      'content@app': {
	        template: '<product></product>'
	      }
	    }
	  })
	  /* .state({
	     name: 'product',
	     parent: 'browse-sub-category',
	     url: '/:subCategoryId',
	     views: {
	       'content@app': {
	         template: '<product></product>'
	       }
	     }
	   })*/
	  /*  .state({
	      name: 'product.detail',
	      url: '/:productId',
	      controller:'productDetail',
	      params: {
	        forSubscription: false
	      },
	      views: {
	        'content@app': {
	          template: '<product-detail></product-detail>'
	        }
	      },
	      data: {
	        meta: {
	          'title': 'Product Page',
	          'description': 'Product Page Description /:categoryId',
	          'url':'URL',
	          'type':'website',
	          'image':'Product Image',
	          'alt':'Product Alt'
	      
	        }
	      }
	        })*/
	  .state({
	    name: 'browse-product.detail2',
	    url: '/:productId',
	
	    controller: 'productDetail',
	    params: {
	      forSubscription: false
	    },
	    views: {
	      'content@app': {
	        template: '<product-detail></product-detail>'
	      }
	    },
	    data: {
	      meta: {
	        'title': 'Product Page',
	        'description': 'Product Page Description /:categoryId',
	        'url': 'URL',
	        'type': 'website',
	        'image': 'Product Image',
	        'alt': 'Product Alt'
	
	      }
	    }
	  }).state({
	    name: 'browse-product.detail',
	    url: '/:productId/:itemGroupNumber',
	    controller: 'productDetail',
	    params: {
	      forSubscription: false
	    },
	    views: {
	      'content@app': {
	        template: '<product-detail></product-detail>'
	      }
	    },
	    data: {
	      meta: {
	        'title': 'Product Page',
	        'description': 'Product Page Description /:categoryId',
	        'url': 'URL',
	        'type': 'website',
	        'image': 'Product Image',
	        'alt': 'Product Alt'
	
	      }
	    }
	
	  }).state({
	    name: 'browse-product.detail1',
	    url: '/:productId/reminder/:reminderId',
	    controller: 'productDetail',
	    params: {
	      forSubscription: false
	    },
	    views: {
	      'content@app': {
	        template: '<product-detail></product-detail>'
	      }
	    },
	    data: {
	      meta: {
	        'title': 'Product Page',
	        'description': 'Product Page Description /:categoryId',
	        'url': 'URL',
	        'type': 'website',
	        'image': 'Product Image',
	        'alt': 'Product Alt'
	
	      }
	    }
	
	  }).state({
	    name: 'browse-product.review',
	    url: '/:productId/write-a-review',
	    controller: 'productReview',
	    views: {
	      'content@app': {
	        template: '<product-review></product-review>'
	      }
	    }
	  }).state({
	    name: 'browse-product.review1',
	    url: '/:productId/:itemGroupNumber/write-a-review',
	    controller: 'productReview',
	    views: {
	      'content@app': {
	        template: '<product-review></product-review>'
	      }
	    }
	  })
	  // .state({
	  //   name: 'product.review',
	  //   parent: 'browse-sub-category',
	  //   url: '/write-a-review',
	  //   controller: 'product-review',
	  //   views: {
	  //     'content@app': {
	  //       template: '<product-review></product-review>'
	  //     }
	  //   }
	  // })
	  .state({
	    name: 'store-detail',
	    parent: 'order',
	    url: '/store-detail',
	    views: {
	      'content@app': {
	        template: '<store-detail></store-detail>'
	      }
	    }
	  }).state({
	    name: 'storelocator',
	    parent: 'order',
	    url: '/store-locator',
	    views: {
	      'content@app': {
	        template: '<storelocator></storelocator>'
	      }
	    }
	  }).state({
	    name: 'delivery',
	    parent: 'order',
	    url: '/delivery',
	    views: {
	      'content@app': {
	        template: '<delivery></delivery>'
	      }
	    }
	  }).state({
	    name: 'delivery.address',
	    url: '/address',
	    views: {
	      'content@app': {
	        template: '<delivery-address></delivery-address>'
	      }
	    }
	  }).state({
	    name: 'payment',
	    parent: 'order',
	    url: '/:orderId/payment',
	    params: { isCardSaved: null },
	    abstract: true
	  }).state({
	    name: 'card-detail',
	    parent: 'payment',
	    url: '/card-detail',
	    views: {
	      'content@app': {
	        template: '<card-detail></card-detail>'
	      }
	    }
	  }).state({
	    name: 'payment.success',
	    url: '/success',
	    views: {
	      'content@app': {
	        template: '<payment-success></payment-success>'
	      }
	    }
	  }).state({
	    name: 'payment.failure',
	    url: '/failure?reasonCode',
	    params: { logString: null },
	    views: {
	      'content@app': {
	        template: '<payment-failure></payment-failure>'
	      }
	    }
	  }).state({
	    name: 'payment.summary',
	    url: '/summary-failure',
	    views: {
	      'content@app': {
	        template: '<summary-failure></summary-failure>'
	      }
	    }
	  }).state({
	    name: 'recent-order',
	    parent: 'order',
	    url: '/recent-order',
	    views: {
	      'content@app': {
	        template: '<recent-order></recent-order>'
	      }
	    }
	  }).state({
	    name: 'subscription',
	    parent: 'order',
	    url: '/subscription',
	    views: {
	      'content@app': {
	        template: '<subscription></subscription>'
	      }
	    }
	  }).state({
	    name: 'subscribable-products',
	    parent: 'subscription',
	    url: '/subscribable-products',
	    views: {
	      'content@app': {
	        template: '<subscription-products></subscription-products>'
	      }
	    }
	  }).state({
	    name: 'detail',
	    parent: 'subscribable-products',
	    url: '/:subsProductId/detail',
	    views: {
	      'content@app': {
	        template: '<Products-detail></Products-detail>'
	      }
	    }
	  }).state({
	    name: 'subscription-detail',
	    parent: 'subscription',
	    url: '/:subscriptionId/subscription-detail/:option',
	    views: {
	      'content@app': {
	        template: '<subscription-detail></subscription-detail>'
	      }
	    }
	  }).state({
	    name: 'subscription-success',
	    parent: 'subscription-detail',
	    url: '/success',
	    views: {
	      'content@app': {
	        template: '<subscription-success></subscription-success>'
	      }
	    }
	  }).state({
	    name: 'store-redirect',
	    url: '/store/:storeName',
	    controller: ['$scope', '$stateParams', '$state', function ($scope, $stateParams, $state) {
	      console.log("Indirect Routing to store : ", $stateParams.storeName);
	      $state.go('category', { 'storeName': $stateParams.storeName });
	    }]
	  }).state({
	    name: 'payment-detail',
	    params: { giftcardReq: null, storeCreditAmountToBeCharged: 0.00 },
	    parent: 'payment',
	    url: '/payment',
	    views: {
	      'content@app': {
	        template: '<payment-detail></payment-detail>'
	      }
	    }
	  }).state({
	    name: 'tsys-payment',
	    params: { giftcardReq: null, storeCreditAmountToBeCharged: 0.00 },
	    parent: 'payment',
	    url: '/tsys',
	    views: {
	      'content@app': {
	        template: '<tsys-payment></tsys-payment>'
	      }
	    }
	  }).state({
	    name: 'moneris-payment',
	    params: { giftcardReq: null, storeCreditAmountToBeCharged: 0.00 },
	    parent: 'payment',
	    url: '/moneris',
	    views: {
	      'content@app': {
	        template: '<moneris-payment></moneris-payment>'
	      }
	    }
	  }).state({
	    name: 'card-update',
	    parent: 'cards-management',
	    url: '/card/:cardId',
	    views: {
	      'content@app': {
	        template: '<card-update></card-update>'
	      }
	    }
	  }).state({
	    name: 'tsyscard-update',
	    parent: 'cards-management',
	    url: '/tsys/card/:cardId',
	    views: {
	      'content@app': {
	        template: '<tsyscard-update></tsyscard-update>'
	      }
	    }
	  });
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCartDetail = setCartDetail;
	exports.setAvailableSubscriptionsInterval = setAvailableSubscriptionsInterval;
	exports.setSubscriptions = setSubscriptions;
	exports.setCategories = setCategories;
	exports.setTiles = setTiles;
	exports.setSubCategories = setSubCategories;
	exports.setProducts = setProducts;
	exports.setProductDetail = setProductDetail;
	exports.setStoreDetail = setStoreDetail;
	exports.setShippingCharges = setShippingCharges;
	exports.setOrderDetail = setOrderDetail;
	exports.setPaymentInfo = setPaymentInfo;
	exports.setRecentOrder = setRecentOrder;
	exports.setZoneWiseDeliveryCharges = setZoneWiseDeliveryCharges;
	exports.setSearchResults = setSearchResults;
	exports.setBirdBuckCoupon = setBirdBuckCoupon;
	exports.setTaxes = setTaxes;
	exports.setStoreLocations = setStoreLocations;
	exports.setUserShippingZoneInfo = setUserShippingZoneInfo;
	exports.setSubscriptionsDetail = setSubscriptionsDetail;
	exports.setSubscribableProducts = setSubscribableProducts;
	exports.setSubscriptionConfig = setSubscriptionConfig;
	exports.setDiscountCoupon = setDiscountCoupon;
	exports.setPromoImage = setPromoImage;
	exports.setStoreFeatures = setStoreFeatures;
	exports.setBirdBucksByUser = setBirdBucksByUser;
	exports.setStoreDiscountMap = setStoreDiscountMap;
	exports.setReferralProducts = setReferralProducts;
	exports.setOrderPoints = setOrderPoints;
	exports.setGiftCards = setGiftCards;
	exports.setErplyBirdBucksByUser = setErplyBirdBucksByUser;
	exports.setBaseShippingCharge = setBaseShippingCharge;
	
	var _actionTypes = __webpack_require__(81);
	
	function setCartDetail(data) {
	  return {
	    type: _actionTypes.SET_CART_DETAIL,
	    data: data
	  };
	}
	function setAvailableSubscriptionsInterval(data) {
	  return {
	    type: _actionTypes.SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL,
	    data: data
	  };
	}
	function setSubscriptions(data) {
	  return {
	    type: _actionTypes.SET_SUBSCRIPTIONS,
	    data: data
	  };
	}
	
	function setCategories(data) {
	  return {
	    type: _actionTypes.SET_CATEGORIES,
	    data: data
	  };
	}
	
	function setTiles(data) {
	  return {
	    type: _actionTypes.SET_TILES,
	    data: data
	  };
	}
	
	function setSubCategories(data) {
	  return {
	    type: _actionTypes.SET_SUB_CATEGORIES,
	    data: data
	  };
	}
	
	function setProducts(data) {
	  return {
	    type: _actionTypes.SET_PRODUCTS,
	    data: data
	  };
	}
	
	function setProductDetail(data) {
	  return {
	    type: _actionTypes.SET_PRODUCT_DETAIL,
	    data: data
	  };
	}
	function setStoreDetail(data) {
	  return {
	    type: _actionTypes.SET_STORE_DETAIL,
	    data: data
	  };
	}
	
	function setShippingCharges(data) {
	  return {
	    type: _actionTypes.SET_SHIPPING_CHARGES,
	    data: data
	  };
	}
	
	function setOrderDetail(data) {
	  return {
	    type: _actionTypes.SET_ORDER_DETAIL,
	    data: data
	  };
	}
	
	function setPaymentInfo(data) {
	  return {
	    type: _actionTypes.SET_PAYMENT_INFO,
	    data: data
	  };
	}
	
	function setRecentOrder(data) {
	  return {
	    type: _actionTypes.SET_RECENT_ORDER,
	    data: data
	  };
	}
	
	function setZoneWiseDeliveryCharges(data) {
	  return {
	    type: _actionTypes.SET_ZONEWISE_DELIVERYCHARGES,
	    data: data
	  };
	}
	
	function setSearchResults(data) {
	  return {
	    type: _actionTypes.SET_SEARCH_RESULTS,
	    data: data
	  };
	}
	
	function setBirdBuckCoupon(data) {
	  return {
	    type: _actionTypes.SET_BIRDBUCK_COUPON,
	    data: data
	  };
	}
	
	function setTaxes(data) {
	  return {
	    type: _actionTypes.SET_TAXES,
	    data: data
	  };
	}
	
	function setStoreLocations(data) {
	  return {
	    type: _actionTypes.SET_STORE_LOCATIONS,
	    data: data
	  };
	}
	function setUserShippingZoneInfo(data) {
	  return {
	    type: _actionTypes.SET_USER_SHIPPING_ZONE_INFO,
	    data: data
	  };
	}
	function setSubscriptionsDetail(data) {
	  return {
	    type: _actionTypes.SET_SUBSCRIPTIONS_DETAIL,
	    data: data
	  };
	}
	function setSubscribableProducts(data) {
	  return {
	    type: _actionTypes.SET_SUBSCRIBABLE_PRODUCTS,
	    data: data
	  };
	}
	function setSubscriptionConfig(data) {
	  return {
	    type: _actionTypes.SET_SUBSCRIPTION_CONFIG,
	    data: data
	  };
	}
	function setDiscountCoupon(data) {
	  return {
	    type: _actionTypes.SET_DISCOUNT_COUPON,
	    data: data
	  };
	}
	function setPromoImage(data) {
	  return {
	    type: _actionTypes.SET_PROMO_IMAGE,
	    data: data
	  };
	}
	function setStoreFeatures(data) {
	  return {
	    type: _actionTypes.SET_STORE_FEATURE,
	    data: data
	  };
	}
	function setBirdBucksByUser(data) {
	  return {
	    type: _actionTypes.SET_BIRDBUCKS_BY_USER,
	    data: data
	  };
	}
	
	function setStoreDiscountMap(data) {
	  return {
	    type: _actionTypes.SET_STORE_DISCOUNT_MAP,
	    data: data
	  };
	}
	
	function setReferralProducts(data) {
	  return {
	    type: _actionTypes.SET_REFERRAL_PRODUCTS,
	    data: data
	  };
	}
	
	function setOrderPoints(data) {
	  return {
	    type: _actionTypes.SET_ORDER_POINTS,
	    data: data
	  };
	}
	
	function setGiftCards(data) {
	  return {
	    type: _actionTypes.SET_GIFT_CARDS,
	    data: data
	  };
	}
	
	function setErplyBirdBucksByUser(data) {
	  return {
	    type: _actionTypes.SET_ERPLY_BIRDBUCKS_BY_USER,
	    data: data
	  };
	}
	
	function setBaseShippingCharge(data) {
	  return {
	    type: _actionTypes.SET_BASE_SHIPPING_CHARGE,
	    data: data
	  };
	}
	
	exports.default = {
	  setCartDetail: setCartDetail,
	  setCategories: setCategories,
	  setTiles: setTiles,
	  setSubCategories: setSubCategories,
	  setProducts: setProducts,
	  setProductDetail: setProductDetail,
	  setStoreDetail: setStoreDetail,
	  setShippingCharges: setShippingCharges,
	  setOrderDetail: setOrderDetail,
	  setPaymentInfo: setPaymentInfo,
	  setRecentOrder: setRecentOrder,
	  setZoneWiseDeliveryCharges: setZoneWiseDeliveryCharges,
	  setSearchResults: setSearchResults,
	  setBirdBuckCoupon: setBirdBuckCoupon,
	  setTaxes: setTaxes,
	  setStoreLocations: setStoreLocations,
	  setUserShippingZoneInfo: setUserShippingZoneInfo,
	  setSubscriptions: setSubscriptions,
	  setSubscriptionsDetail: setSubscriptionsDetail,
	  setAvailableSubscriptionsInterval: setAvailableSubscriptionsInterval,
	  setSubscribableProducts: setSubscribableProducts,
	  setSubscriptionConfig: setSubscriptionConfig,
	  setDiscountCoupon: setDiscountCoupon,
	  setPromoImage: setPromoImage,
	  setStoreFeatures: setStoreFeatures,
	  setBirdBucksByUser: setBirdBucksByUser,
	  setStoreDiscountMap: setStoreDiscountMap,
	  setReferralProducts: setReferralProducts,
	  setOrderPoints: setOrderPoints,
	  setGiftCards: setGiftCards,
	  setErplyBirdBucksByUser: setErplyBirdBucksByUser,
	  setBaseShippingCharge: setBaseShippingCharge
	};

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = orderService;
	orderService.$inject = ['$ngRedux', '$http', '$state', '$timeout', 'orderActions', 'APP', 'authService', '$cookies', '$stateParams'];
	
	function orderService($ngRedux, $http, $state, $timeout, orderActions, APP, $auth, $cookies, $stateParams) {
	
	  this.giftCardRequest = [];
	
	  var service = {
	    getCategories: getCategories,
	    getTiles: getTiles,
	    getSubCategories: getSubCategories,
	    getProducts: getProducts,
	    getProductsByGroupNumber: getProductsByGroupNumber,
	    getProductOfSameGroupByPrettyUrl: getProductOfSameGroupByPrettyUrl,
	    getCartDetail: getCartDetail,
	    removeCart: removeCart,
	    addItemToCart: addItemToCart,
	    addMultipleItemToCart: addMultipleItemToCart,
	    updateItemInCart: updateItemInCart,
	    removeItemFromCart: removeItemFromCart,
	    getGoogleDistance: getGoogleDistance,
	    getShippingCharges: getShippingCharges,
	    orderCheckout: orderCheckout,
	    orderGuestCheckout: orderGuestCheckout,
	    initializePayment: initializePayment,
	    getPaymentInfo: getPaymentInfo,
	    paymentSubmit: paymentSubmit,
	    saveCardDetail: saveCardDetail,
	    getOrderSummary: getOrderSummary,
	    getRecentOrder: getRecentOrder,
	    getSubscriptions: getSubscriptions,
	    getSubscriptionsDetail: getSubscriptionsDetail,
	    getZoneWiseDeliveryCharges: getZoneWiseDeliveryCharges,
	    getZoneWiseDeliveryChargesForGuest: getZoneWiseDeliveryChargesForGuest,
	    reOrder: reOrder,
	    buyDscMembership: buyDscMembership,
	    buyGiftCard: buyGiftCard,
	    getSearchResults: getSearchResults,
	    getBirdBuckCoupon: getBirdBuckCoupon,
	    calculateTaxes: calculateTaxes,
	    getStoreLocations: getStoreLocations,
	    searchStores: searchStores,
	    getUserZone: getUserZone,
	    getAvailableSubscriptionsInterval: getAvailableSubscriptionsInterval,
	    getSubcribableProducts: getSubcribableProducts,
	    updateSubscriptionsDetail: updateSubscriptionsDetail,
	    cancelSubscription: cancelSubscription,
	    getSubscriptionConfig: getSubscriptionConfig,
	    updateCreditCard: updateCreditCard,
	    removeCreditCard: removeCreditCard,
	    getCouponDiscount: getCouponDiscount,
	    getCurrencyType: getCurrencyType,
	    getPromoImage: getPromoImage,
	    getStoreFeatures: getStoreFeatures,
	    getBirdBucksByUser: getBirdBucksByUser,
	    getStoreDiscountMapping: getStoreDiscountMapping,
	    getCateoryNamebyId: getCateoryNamebyId,
	    getSubCateoryNamebyId: getSubCateoryNamebyId,
	    getReferralProducts: getReferralProducts,
	    getOrderPoints: getOrderPoints,
	    getGiftCards: getGiftCards,
	    validateGiftCardDetails: validateGiftCardDetails,
	    getOrderAmount: getOrderAmount,
	    isIpad: isIpad,
	    paymentUsingGiftCards: paymentUsingGiftCards,
	    paymentUsingStoreCredit: paymentUsingStoreCredit,
	    isGiveXAvailable: isGiveXAvailable,
	    getItemTaxDetails: getItemTaxDetails,
	    getPaymentKeys: getPaymentKeys,
	    getHeartlandPaymentCharge: getHeartlandPaymentCharge,
	    setGiftCardRequest: setGiftCardRequest,
	    getGiftCardRequest: getGiftCardRequest,
	    initializePaymentHeartland: initializePaymentHeartland,
	    paymentSubmitHeartland: paymentSubmitHeartland,
	    updateCardHeartland: updateCardHeartland,
	    getErplyBirdBucksByUser: getErplyBirdBucksByUser,
	    getErplyCartDetail: getErplyCartDetail,
	    doErplyZeroDollarTransaction: doErplyZeroDollarTransaction,
	    dscPremembership: dscPremembership,
	    deleteDscPremembership: deleteDscPremembership,
	    getGuestCartDetail: getGuestCartDetail,
	    initializePaymentTsys: initializePaymentTsys,
	    paymentSubmitTsys: paymentSubmitTsys,
	    paymentSubmitMoneris: paymentSubmitMoneris,
	    initializePaymentMoneris: initializePaymentMoneris,
	    monerisProcess: monerisProcess,
	    updateCardTsys: updateCardTsys,
	    canSaveUserCard: canSaveUserCard,
	    updateCardMoneris: updateCardMoneris,
	    getProductByPrettyUrl: getProductByPrettyUrl,
	    getMultipleImage: getMultipleImage,
	    getReferrals: getReferrals,
	    getDSCDetails: getDSCDetails,
	    updateUserAction: updateUserAction,
	    updateUserActionFromOrder: updateUserActionFromOrder,
	    saveRemainder: saveRemainder,
	    remainderUsed: remainderUsed,
	    printPaymentLogs: printPaymentLogs,
	    doGuestOptIn: doGuestOptIn,
	    printCustomerGenericLogs: printCustomerGenericLogs,
	    getLinksByMasterId: getLinksByMasterId,
	    checkAndUpdateStoreCreditAmount: checkAndUpdateStoreCreditAmount,
	    paypalCreateOrder: paypalCreateOrder,
	    paypalCreateOrderReturnUser: paypalCreateOrderReturnUser,
	    paypalCaptureOrder: paypalCaptureOrder,
	    savePaypalAuthorizedOrder: savePaypalAuthorizedOrder,
	    paypalCreateVaultOrder: paypalCreateVaultOrder
	  };
	  return service;
	
	  function isIpad() {
	    return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	  }
	
	  function base() {
	    return APP.ORDER.ORDER_URL;
	  }
	  function hostUrl() {
	    if ($auth.isGuestLogin()) {
	      return '/guest';
	    }
	    return '';
	  }
	
	  function getCategories() {
	    return $http.get(hostUrl() + base().root + base().category).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setCategories(success.data));
	    });
	  }
	
	  function getTiles() {
	    return $http.get(hostUrl() + base().root + base().tiles).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setTiles(success.data));
	    });
	  }
	
	  function getSubCategories(id) {
	    return $http.get(hostUrl() + base().root + '/category/' + id + base().subCategory).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setSubCategories(success));
	    });
	  }
	
	  function getProducts(categoryId, subCategoryId) {
	    // if($cookies.get('storeId')){
	    return $http.get(hostUrl() + base().root + '/category/' + categoryId + '/subcategory/' + subCategoryId + base().product).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setProducts(success));
	    });
	  }
	
	  function getProductsByGroupNumber(categoryId, subCategoryId, itemGroupNumber) {
	    var url = '';
	    if (itemGroupNumber) {
	      url = hostUrl() + base().root + '/category/' + categoryId + '/subcategory/' + subCategoryId + (base().product + '?itemGroupNumber=' + itemGroupNumber);
	    } else {
	      url = hostUrl() + base().root + '/category/' + categoryId + '/subcategory/' + subCategoryId + base().product;
	    }
	    return $http.get(url).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setProducts(success));
	    });
	  }
	
	  function getProductOfSameGroupByPrettyUrl(subCategoryId, prettyUrl) {
	    var url = '';
	    url = hostUrl() + base().root + '/subcategory/' + subCategoryId + '/item/' + prettyUrl;
	    return $http.get(url).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setProducts(success));
	    });
	  }
	
	  function getProductByPrettyUrl(categoryId, subCategoryId, productId) {
	    return $http.get(hostUrl() + base().root + '/category/' + categoryId + '/subcategory/' + subCategoryId + '/item/' + productId).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setProducts(success));
	    });
	  }
	
	  function getCartDetail(isCartPage) {
	    if (isCartPage == undefined) {
	      isCartPage = true;
	    }
	    return $http.get('' + base().root + base().cart.base + '?isCartPage=' + isCartPage).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setCartDetail(success));
	    }).error(function () {
	      return $ngRedux.dispatch(orderActions.setCartDetail({
	        cartItems: []
	      }));
	    });
	  }
	
	  function getErplyCartDetail(data) {
	    // return $http.post(`${base().root}${base().cart.erplyBase}`)
	    return $http.post(base().root + base().cart.erplyBase, data).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setCartDetail(success));
	    }).error(function () {
	      return $ngRedux.dispatch(orderActions.setCartDetail({
	        cartItems: []
	      }));
	    });
	  }
	
	  function getGuestCartDetail(data) {
	    return $http.post('' + base().root + base().cart.base + '/guest', data).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setCartDetail(success));
	    }).error(function () {
	      return $ngRedux.dispatch(orderActions.setCartDetail({
	        cartItems: []
	      }));
	    });
	  }
	
	  function getItemTaxDetails(orderRequest) {
	    // return $http.post(base().root+base().cart.tax,orderRequest)
	    //   .success(success => $ngRedux.dispatch(orderActions.setTaxDetail(success)))
	    //   .error(() => $ngRedux.dispatch(orderActions.setTaxDetail({
	    //     cartTaxItems: []
	    //   })));
	    return $http.post(base().root + base().cart.tax, orderRequest);
	  }
	
	  function removeCart() {
	    try {
	      sessionStorage.removeItem('discountCoupon');
	      sessionStorage.removeItem('birdbuckCoupon');
	      sessionStorage.removeItem('erplyBBDiscount');
	      sessionStorage.removeItem('erplyPromotionDiscount');
	      sessionStorage.removeItem('orderNotesSession');
	    } catch (e) {
	      $cookies.remove('discountCoupon');
	      $cookies.remove('birdbuckCoupon');
	      $cookies.remove('erplyBBDiscount');
	      $cookies.remove('erplyPromotionDiscount');
	      $cookies.remove('orderNotesSession');
	    }
	    return $http.post(base().root + base().cart.base + base().cart.remove);
	  }
	
	  function addItemToCart(quantity, id, subCategoryId) {
	    return $http.post('' + base().root + base().cart.base + '/item/' + subCategoryId + '/' + id + base().cart.add + '?quantity=' + quantity);
	  }
	  function addMultipleItemToCart(data) {
	    return $http.post('' + base().root + base().cart.base + '/item/addItems', data);
	  }
	
	  function updateItemInCart(quantity, id, subCategoryId) {
	    return $http.post('' + base().root + base().cart.base + '/item/' + subCategoryId + '/' + id + base().cart.update + '?quantity=' + quantity);
	  }
	
	  function removeItemFromCart(id) {
	    return $http.post('' + base().root + base().cart.base + '/item/' + id + base().cart.remove);
	  }
	
	  function getGoogleDistance(data) {
	    delete $http.defaults.headers.common['X-Requested-With'];
	    return $http.get('https://maps.googleapis.com/maps/api/distancematrix/json?origins=' + (data.store.addressLine1 + ', ' + data.store.city + ', ' + data.store.state.name) + ('&destinations=' + data.shippingAddressLine1 + ', ' + data.shippingCity + ', ' + data.shippingState.name) + '&mode=driving&language=fr-FR&key=AIzaSyApwGHe4vFBVU-SO1Cb0NgXmPQ3w_gr9oE');
	  }
	
	  function getShippingCharges() {
	    return $http.get(base().shippingCharge).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setShippingCharges(success));
	    });
	  }
	
	  function orderCheckout(data) {
	    return $http.post(base().root + base().checkout, data);
	  }
	
	  function orderGuestCheckout(data) {
	    return $http.post(base().root + base().guestCheckout, data).success(function (success) {
	      sessionStorage.setItem('guestoauth', success.userToken);
	      sessionStorage.setItem('isGuestUserLoggedIn', success.isGuestUser);
	    });
	  }
	
	  function initializePayment(id, device, data) {
	    return $http.post('' + base().root + base().order.base + '/' + id + '/' + device + base().order.initPayment, data);
	  }
	
	  function getPaymentInfo() {
	    return $http.get('' + base().root + base().paymentInfo).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setPaymentInfo(success));
	    });
	  }
	
	  function saveCardDetail(id) {
	    return $http.post(base().root + '/payment/' + id + '/info');
	  }
	
	  function paymentSubmit(orderId, cardId, cardNo, data) {
	    return $http.post(base().root + '/order/' + orderId + '/card/' + cardId + '/' + cardNo + '/pay', data);
	  }
	
	  function getOrderSummary(id) {
	    return $http.get('' + base().root + base().order.base + '/' + id + base().order.summary).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setOrderDetail(success));
	    });
	  }
	
	  function getRecentOrder() {
	    return $http.get('' + base().root + base().order.base + base().order.recentOrder).success(function (success) {
	      return $ngRedux.dispatch(orderActions.setRecentOrder(success));
	    });
	  }
	
	  function getZoneWiseDeliveryCharges() {
	    return $http.get('/api/v1/customer/shipping/charge/all').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setZoneWiseDeliveryCharges(success.data));
	    });
	  }
	
	  function getZoneWiseDeliveryChargesForGuest() {
	    return $http.get('/api/v1/customer/shipping/charge/all/guest').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setZoneWiseDeliveryCharges(success.data));
	    });
	  }
	
	  function reOrder(orderId) {
	    return $http.put('' + base().root + base().order.base + '/' + orderId + base().order.reOrder);
	  }
	
	  function buyDscMembership() {
	    return $http.post('/api/v1/customer/cart/buy/dsc/membership/88888888');
	  }
	
	  function buyGiftCard(quantity, masterCode) {
	    return $http.post('/api/v1/customer/gift/buy/' + masterCode + '/' + quantity);
	  }
	
	  function getSubscriptions() {
	
	    return $http.get('/api/v1/customer/subscription/all').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setSubscriptions(success.data));
	    });
	  }
	  function getAvailableSubscriptionsInterval() {
	    return $http.get('/api/v1/customer/intervals').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setAvailableSubscriptionsInterval(success.data));
	    });
	  }
	  function getSubscriptionConfig() {
	    return $http.get('/api/v1/customer/subscriptionconfig').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setSubscriptionConfig(success.data));
	    });
	  }
	  function getSubscriptionsDetail(id) {
	    return $http.get('/api/v1/customer/subscription?subscriptionId=' + id).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setSubscriptionsDetail(success.data));
	    });
	  }
	
	  function getSearchResults(searchTerm) {
	    return $http.get(hostUrl() + '/api/v1/customer/item/search?searchParam=' + searchTerm).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setSearchResults(success.data));
	    });
	  }
	
	  //  Old Birdbuck Coupon Code
	  // function getBirdBuckCoupon(coupon) {
	  //   return $http.get('/api/v1/customer/birdbucks/coupon/' + coupon)
	  //   .then(success => {
	  //     $ngRedux.dispatch(orderActions.setBirdBuckCoupon(success.data));
	  //     return success.data;
	  //   });
	  //  }
	
	  function calculateTaxes(params) {
	    return $http.post('/api/v1/customer/getTaxableAmount', params).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setTaxes(success.data));
	    });
	  }
	
	  function getStoreLocations() {
	    return $http.get('/api/v1/customer/all/store/location').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setStoreLocations(success.data));
	    });
	  }
	  function getPromoImage(storeCode) {
	    // let guestStore = null;
	    // try {
	    //   guestStore = sessionStorage.getItem('guestStoreName');
	    // }
	    // catch (e) {
	    //   guestStore = $cookies.get('guestStoreName');
	    // }
	    // if( guestStore || $stateParams.storeName ){
	    // return $http.get('/api/v1/customer/store/'+storeCode+'/promos/get')
	    // .then(success => $ngRedux.dispatch(orderActions.setPromoImage(success.data))); 
	    // } else {
	    return $http.get('/api/v1/customer/promos/get').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setPromoImage(success.data));
	    });
	    // }
	  }
	
	  function getStoreFeatures() {
	    return $http.get('/api/v1/store/features').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setStoreFeatures(success.data));
	    });
	  }
	
	  function searchStores(data) {
	    return $http.post('/api/v1/customer/storelocator/getnearbystores', data).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setStoreLocations(success.data));
	    });
	  }
	  function updateSubscriptionsDetail(data) {
	    return $http.post('/api/v1/customer/subscription/update', data);
	  }
	  function getUserZone(data) {
	    return $http.post('/api/v1/customer/fedex/getratezone', data).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setUserShippingZoneInfo(success.data));
	    });
	  }
	  function getSubcribableProducts() {
	    return $http.get(hostUrl() + '/api/v1/customer/subscriptionAvailItems').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setSubscribableProducts(success.data));
	    });
	  }
	  function cancelSubscription(orderId) {
	    return $http.post(base().root + '/subscription/cancel?subscriptionId=' + orderId);
	  }
	  function updateCreditCard(id, device) {
	    return $http.post(base().cards.base + '/' + id + '/' + device + base().cards.update);
	  }
	  function removeCreditCard(id) {
	    return $http.post('' + base().root + base().cards.card + '/' + id + base().cards.remove);
	  }
	
	  function getCouponDiscount(id, isInStorePickUp, shipToStateId) {
	
	    return $http.get('' + base().root + base().discount.amount + id + '&isInstorePickuP=' + isInStorePickUp + '&shipToStateId=' + shipToStateId).then(function (success) {
	      $ngRedux.dispatch(orderActions.setDiscountCoupon(success.data));
	
	      try {
	        sessionStorage.setItem('discountCoupon', id);
	      } catch (e) {
	        $cookies.put('discountCoupon', id, {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    }, function (error) {
	      try {
	        sessionStorage.removeItem('discountCoupon');
	      } catch (e) {
	        $cookies.remove('discountCoupon');
	      }
	      throw error;
	    }).catch(function (error) {
	      try {
	        sessionStorage.removeItem('discountCoupon');
	      } catch (e) {
	        $cookies.remove('discountCoupon');
	      }
	      throw error;
	    });
	  }
	  function getBirdBuckCoupon(coupon) {
	
	    return $http.get('/api/v1/customer/birdbucks/coupon/' + coupon).then(function (success) {
	      $ngRedux.dispatch(orderActions.setBirdBuckCoupon(success.data));
	
	      try {
	        sessionStorage.setItem('birdbuckCoupon', coupon);
	      } catch (e) {
	        $cookies.put('birdbuckCoupon', coupon, {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    }, function (error) {
	      try {
	        sessionStorage.removeItem('birdbuckCoupon');
	      } catch (e) {
	        $cookies.remove('birdbuckCoupon');
	      }
	      throw error;
	    }).catch(function (error) {
	      try {
	        sessionStorage.removeItem('birdbuckCoupon');
	      } catch (e) {
	        $cookies.remove('birdbuckCoupon');
	      }
	      throw error;
	    });
	  }
	  function getCurrencyType(country) {
	    return '' + base().currencyType[country];
	  }
	
	  function getBirdBucksByUser(userId) {
	    return $http.get('/api/v1/customer/birdbucks').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setBirdBucksByUser(success.data));
	    });
	  }
	
	  function getStoreDiscountMapping(discountCode) {
	    return $http.get('/api/v1/customer/discounts/' + discountCode + '/storemap').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setStoreDiscountMap(success.data));
	    });
	  }
	
	  function getSubCateoryNamebyId(subCategoryId) {
	
	    return $http.get(hostUrl() + base().root + '/item/name/false/url/' + subCategoryId);
	  }
	
	  function getCateoryNamebyId(categoryId) {
	
	    return $http.get(hostUrl() + base().root + '/item/name/true/url/' + categoryId);
	  }
	
	  function getReferralProducts(masterCode) {
	    return $http.get(hostUrl() + base().root + '/product/referral/' + masterCode).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setReferralProducts(success.data));
	    });
	  }
	
	  function getOrderPoints(data) {
	    return $http.post(hostUrl() + base().root + '/getorderpoints', data).then(function (success) {
	      return $ngRedux.dispatch(orderActions.setOrderPoints(success.data));
	    });
	  }
	
	  function getGiftCards() {
	    return $http.get(hostUrl() + base().root + '/gifts/all').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setGiftCards(success.data));
	    });
	  }
	
	  function validateGiftCardDetails(data) {
	    return $http.post(base().root + '/getgiftcardbalance', data);
	  }
	
	  function getOrderAmount(id) {
	    return $http.get(base().root + '/order/' + id);
	  }
	
	  function paymentUsingGiftCards(data) {
	    return $http.post(base().root + '/orderusinggiftcards', data);
	  }
	
	  function paymentUsingStoreCredit(data) {
	    return $http.post(base().root + '/orderusingstorecredit', data);
	  }
	
	  function isGiveXAvailable(data) {
	    return $http.get(base().root + '/isgivexavailable');
	  }
	  function getPaymentKeys() {
	    return $http.get(base().root + '/payment/keys');
	  }
	  function getHeartlandPaymentCharge(data) {
	    return $http.post(hostUrl() + base().root + '/payment/charge');
	  }
	
	  // getter and setter for giftCardRequest
	  function setGiftCardRequest(giftCardRequest) {
	    this.giftCardRequest = giftCardRequest;
	  }
	
	  function getGiftCardRequest() {
	    return this.giftCardRequest;
	  }
	
	  function initializePaymentHeartland(data) {
	    return $http.post(base().root + base().heartland + base().order.initPayment, data);
	  }
	
	  function initializePaymentTsys(data) {
	    return $http.post(base().root + base().tsys + base().order.initPayment, data);
	  }
	
	  function initializePaymentMoneris(data) {
	    return $http.post(base().root + base().moneris + base().order.initPayment, data);
	  }
	
	  function monerisProcess(data) {
	    return $http.post(base().root + base().moneris + base().order.payment + base().cards.monerisProcess, data);
	  }
	
	  function paymentSubmitHeartland(data) {
	    return $http.post(base().root + base().heartland + base().order.savedPayment, data);
	  }
	
	  function paymentSubmitTsys(data) {
	    return $http.post(base().root + base().tsys + base().order.savedPayment, data);
	  }
	
	  function paymentSubmitMoneris(data) {
	    return $http.post(base().root + base().moneris + base().order.savedPayment, data);
	  }
	
	  function updateCardHeartland(data) {
	    console.log(base().root + base().heartland + base().cards.heartlandUpdate);
	    return $http.post(base().root + base().heartland + base().cards.heartlandUpdate, data);
	  }
	
	  function updateCardTsys(data) {
	    console.log(base().root + base().tsys + base().cards.heartlandUpdate);
	    return $http.post(base().root + base().tsys + base().cards.heartlandUpdate, data);
	  }
	
	  function updateCardMoneris(data) {
	    console.log(base().root + base().moneris + base().cards.heartlandUpdate);
	    return $http.post(base().root + base().moneris + base().cards.heartlandUpdate, data);
	  }
	
	  function getErplyBirdBucksByUser(userId) {
	    return $http.get('/api/v1/customer/erply/getIssuedCoupons').then(function (success) {
	      return $ngRedux.dispatch(orderActions.setErplyBirdBucksByUser(success.data));
	    });
	  }
	
	  function doErplyZeroDollarTransaction(orderId) {
	    return $http.post('/api/v1/customer/erply/payment/order/' + orderId + '/zerodollar');
	  }
	
	  function dscPremembership() {
	    return $http.post('/api/v1/customer/cart/dsc/pre-membership');
	  }
	
	  function deleteDscPremembership() {
	    return $http.delete('/api/v1/customer/cart/dsc/pre-membership');
	  }
	
	  function canSaveUserCard(canSave) {
	    return $http.post(base().root + '/card/' + canSave);
	  }
	  function getMultipleImage(id) {
	    return $http.get('/api/v1/masterproduct/' + id + '/multi_images/get');
	  }
	  function getReferrals(masterCode) {
	    return $http.get(hostUrl() + base().root + '/product/referral/' + masterCode);
	  }
	
	  function getDSCDetails() {
	    return $http.get('/api/v1/customer/dsc/details');
	  }
	
	  function updateUserAction(userAction, comments) {
	    return $http.post('/api/v1/analytics/action/' + userAction, comments);
	  }
	
	  function updateUserActionFromOrder(userAction, orderId) {
	    return $http.post('/api/v1/analytics/action/' + userAction + '/order/' + orderId);
	  }
	
	  function saveRemainder(remainderType, remainder) {
	    return $http.post('/api/v1/customer/remainder/' + remainderType, remainder);
	  }
	
	  function remainderUsed(id) {
	    $http.post('/api/v1/customer/remainder/used?id=' + id);
	  }
	
	  function printPaymentLogs(orderId, data, comments) {
	    return $http.post('/api/v1/customer/payment/print/' + orderId + '/logs?comments=' + comments, data);
	  }
	
	  function printCustomerGenericLogs(dataValue) {
	
	    var stringData = {};
	    stringData.config = {};
	    if (dataValue && dataValue.config) {
	      stringData.config.data = JSON.stringify(dataValue.config.data);
	      stringData.config.headers = JSON.stringify(dataValue.config.headers);
	      stringData.config.method = JSON.stringify(dataValue.config.method);
	      stringData.config.url = JSON.stringify(dataValue.config.url);
	    }
	    if (dataValue && dataValue.data) {
	      stringData.data = {};
	      stringData.data.diagnostic = JSON.stringify(dataValue.data.diagnostic);
	      stringData.data.message = JSON.stringify(dataValue.data.message);
	      stringData.data.httpCode = JSON.stringify(dataValue.data.httpCode);
	    }
	    return $http.post('/api/v1/customer/print/logs', stringData);
	  }
	
	  function getLinksByMasterId(id) {
	    return $http.get('/api/v1/links/masterproduct/' + id);
	  }
	
	  function checkAndUpdateStoreCreditAmount(storeCreditValue) {
	    return $http.post('/api/v1/customer/storecredit/amount', storeCreditValue);
	  }
	
	  function paypalCreateOrder(data) {
	    return $http.post(base().root + base().paypal + '/createorder', data);
	  }
	
	  function paypalCreateOrderReturnUser(data) {
	    return $http.post(base().root + base().paypal + '/returnuser/createorder', data);
	  }
	
	  function paypalCreateVaultOrder(data) {
	    return $http.post(base().root + base().paypal + '/order/vault', data);
	  }
	
	  function paypalCaptureOrder(data) {
	    return $http.post(base().root + base().paypal + '/captureorder', data);
	  }
	
	  function savePaypalAuthorizedOrder(data) {
	    return $http.post(base().root + base().paypal + '/order/authorized', data);
	  }
	  function doGuestOptIn(data) {
	    $http.post('/api/v1/customer/guest/opt-in', data);
	  }
	}

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _categoryImg = __webpack_require__(176);
	
	var _categoryImg2 = _interopRequireDefault(_categoryImg);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _subCategory = __webpack_require__(177);
	
	var _subCategory2 = _interopRequireDefault(_subCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SubCategory = (_dec = (0, _utils.Component)({
	  controllerAs: 'subCategory',
	  template: _subCategory2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function SubCategory($rootScope, $scope, $ngRedux, $stateParams, $toaster, $state, $order, $spinner, orderActions, $auth, $window, APP, $location, ngMeta) {
	    var _this = this;
	
	    _classCallCheck(this, SubCategory);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.categoryImg = _categoryImg2.default;
	    this.$toaster = $toaster;
	    this.$state = $state;
	    this.$auth = $auth;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.storeName = '';
	    this.$window = $window;
	    this.APP = APP;
	    this.$location = $location;
	    this.ngMeta = ngMeta;
	    $ngRedux.dispatch(orderActions.setSubCategories({ subCategories: [] }));
	    this.$spinner = $spinner;
	    this.$spinner.show('appSpinner');
	    if (this.$auth.isLoggedIn() || this.$auth.isGuestLogin()) {
	      if (this.list.length == 0) {
	        this.loadSubCategories();
	      }
	    } else {
	      if (this.list != null) {
	        if (this.list.length == 0) {
	          setTimeout(function () {
	            _this.loadSubCategories();
	          }, 2000);
	        }
	      }
	    }
	    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.APP.ORDER.ORDER_URL.browseUrl +'/' + this.$stateParams.categoryId;
	      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + this.$stateParams.storeName + '/' + this.$stateParams.categoryId;
	    } else {
	      this.canUrl = this.$location.$$absUrl;
	    }
	    // console.log("this.canUrl.subcategory : ",this.canUrl);
	    this.ngMeta.setTag('canUrl', this.canUrl);
	    // var listener1 =  $rootScope.$on('onGuestLogin', () => this.loadSubCategories());
	    $scope.$on('$destroy', function () {
	      disconnect();
	      // if(this.list.length == 0) {
	      //   listener1();
	      // }
	    });
	  }
	
	  _createClass(SubCategory, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        list: state.order.subCategories
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'loadSubCategories',
	    value: function loadSubCategories() {
	      var _this2 = this;
	
	      if (this.profile.store && this.profile.store.storeName) {
	        this.storeName = this.profile.store;
	      } else {
	        this.storeName = this.$auth.getGuestStoreDetail().storeName;
	      }
	
	      this.$order.getSubCategories(this.$stateParams.categoryId).then(function (success) {
	
	        if (!success.data.subCategories.length) {
	          _this2.$toaster.pop('success', 'Sorry, There are no products currently');
	          _this2.$state.go('category', { 'storeName': _this2.$auth.getGuestStoreDetail().storeName });
	        } else {
	          _this2.ngMeta.setTitle(success.data.subCategories[0].category.name);
	          _this2.ngMeta.setTag('description', success.data.subCategories[0].category.description ? success.data.subCategories[0].category.description : 'Product Page description');
	          _this2.ngMeta.setTag('image', success.data.subCategories[0].category.smallImageUrl);
	          _this2.ngMeta.setTag('alt', success.data.subCategories[0].category.alt ? success.data.subCategories[0].category.alt : 'Product Image');
	
	          _this2.$window.document.title = success.data.subCategories[0].category.title ? success.data.subCategories[0].category.title + ' | Wild Birds Unlimited' : _this2.APP.ORDER.ORDER_URL.siteTitle;
	        }
	      }).finally(function () {
	        return _this2.$spinner.hide('appSpinner');
	      });
	    }
	  }, {
	    key: 'goToNextState',
	    value: function goToNextState(item) {
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      // let storeName =  false;
	      if (storeName) {
	        this.$state.go('browse-product', {
	          subCategoryId: item.prettyUrl
	        });
	      } else {
	        this.$state.go('browse-product', {
	          subCategoryId: item.prettyUrl
	        });
	      }
	    }
	  }, {
	    key: 'getImageUrl',
	    value: function getImageUrl(subCategory) {
	      if (window.innerWidth < 768) {
	        return subCategory.mediumImageUrl;
	      } else {
	        return subCategory.largeImageUrl;
	      }
	    }
	  }, {
	    key: 'getImageTitle',
	    value: function getImageTitle(subCategory) {
	      if (subCategory.alt) {
	        return subCategory.alt;
	      } else {
	        return 'Wild Birds Unlimited';
	      }
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }]);
	
	  return SubCategory;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$stateParams', 'toaster', '$state', 'orderService', 'spinnerService', 'orderActions', 'authService', '$window', 'APP', '$location', 'ngMeta'], _temp)) || _class);
	exports.default = SubCategory;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc9f9f3c2c6e632e0993b8a4bd38be34.png";

/***/ },
/* 177 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"subCategory.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{subCategory.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>{{subCategory.list[0].category.name}}</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0  hidden-sm-down\">\r\n    <!-- Category Name -->\r\n    <div ng-class=\"subCategory.isIpad()?'col-md-8':'col-md-9'\" style=\"padding-top: 29px;\">\r\n      <h4 class=\"font-weight-bold p-x-2\">{{subCategory.list[0].category.name}}</h4>\r\n    </div>\r\n    <div ng-class=\"subCategory.isIpad()?'col-md-4':'col-md-3'\" ng-hide=\"subCategory.storeName && subCategory.storeName != ''\">\r\n      <product-promo></product-promo>\r\n    </div>\r\n  </div>\r\n\r\n  <div id=\"tiles\" class=\"row m-x-0 p-b-2\">\r\n    <!-- Categories -->\r\n    <div class=\"col-md-4 col-lg-3 col-sm-4 col-xs-6 category-item subcat-item\" ng-repeat=\"item in subCategory.list\">\r\n      <a ng-click=\"subCategory.goToNextState(item)\">\r\n        <img ng-src={{subCategory.getImageUrl(item)}} alt=\"{{subCategory.getImageTitle(item)}}\" class=\"subcat-rounded img-fluid cursor-pointer\" />\r\n        <h6 class=\"sub-category-text m-b-0\" ng-bind=\"item.name\"></h6>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"hidden-md-up\" style=\"text-align: center;\" ng-hide=\"subCategory.storeName && subCategory.storeName != ''\">\r\n    <product-promo></product-promo> <br>\r\n  </div>\r\n</div>"

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _birdFood = __webpack_require__(179);
	
	var _birdFood2 = _interopRequireDefault(_birdFood);
	
	var _product = __webpack_require__(180);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _tempunavailable_L = __webpack_require__(181);
	
	var _tempunavailable_L2 = _interopRequireDefault(_tempunavailable_L);
	
	var _tempunavailable = __webpack_require__(182);
	
	var _tempunavailable2 = _interopRequireDefault(_tempunavailable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Product = (_dec = (0, _utils.Component)({
	  controllerAs: 'product',
	  template: _product2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Product($rootScope, $scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP, ngMeta, $location) {
	    var _this = this;
	
	    _classCallCheck(this, Product);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.birdFood = _birdFood2.default;
	    this.$state = $state;
	    this.$toaster = $toaster;
	    this.$auth = $auth;
	    this.$window = $window;
	    this.APP = APP;
	    this.ngMeta = ngMeta;
	    this.$location = $location;
	    this.tempUnavailable = _tempunavailable_L2.default;
	    this.tempUnavailable_S = _tempunavailable2.default;
	    $ngRedux.dispatch(orderActions.setProducts([]));
	    this.$spinner = $spinner;
	    this.$spinner.show('appSpinner');
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.subCategoryName = '';
	    this.categoryName = '';
	    this.storeName = '';
	    if (this.$auth.isLoggedIn() || this.$auth.isGuestLogin()) {
	      this.loadProducts();
	    }
	    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + this.APP.ORDER.ORDER_URL.browseUrl + '/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId;
	      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.$stateParams.storeName +'/' + this.$stateParams.categoryId +'/' + this.$stateParams.subCategoryId;
	    } else {
	      this.canUrl = this.$location.$$absUrl;
	    }
	
	    console.log("this.canUrl.product : ", this.canUrl);
	    this.ngMeta.setTag('canUrl', this.canUrl);
	
	    var listener1 = $rootScope.$on('onGuestLogin', function () {
	      return _this.loadProducts();
	    });
	    $scope.$on('$destroy', function () {
	      disconnect();
	      listener1();
	    });
	  }
	
	  _createClass(Product, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        list: state.order.products
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'loadProducts',
	    value: function loadProducts() {
	      var _this2 = this;
	
	      if (this.profile.store && this.profile.store.storeName) {
	        this.storeName = this.profile.store;
	      } else {
	        this.storeName = this.$auth.getGuestStoreDetail().storeName;
	      }
	      var categoryNameResponse = this.$order.getCateoryNamebyId(this.$stateParams.categoryId);
	      categoryNameResponse.then(function (success) {
	
	        _this2.categoryName = success.data;
	        // this.$window.document.title =  this.categoryName.title ? this.categoryName.title : this.APP.ORDER.ORDER_URL.siteTitle;
	      });
	      var subCategoryNameResponse = this.$order.getSubCateoryNamebyId(this.$stateParams.subCategoryId);
	      subCategoryNameResponse.then(function (success) {
	
	        _this2.subCategoryName = success.data;
	        // console.log("subCatName", this.subCategoryName);
	        _this2.$window.document.title = _this2.subCategoryName.title ? _this2.subCategoryName.title + ' | Wild Birds Unlimited' : _this2.APP.ORDER.ORDER_URL.siteTitle;
	      });
	      this.$order.getProducts(this.$stateParams.categoryId, this.$stateParams.subCategoryId).then(function (success) {
	        // console.log("Products Data", success.data);
	        _this2.ngMeta.setTitle(success.data[0].itemList[0].masterProduct.subCategories[0].displayName);
	        _this2.ngMeta.setTag('description', success.data[0].itemList[0].masterProduct.subCategories[0].description ? success.data[0].itemList[0].masterProduct.subCategories[0].description : 'Product Page description');
	        _this2.ngMeta.setTag('image', success.data[0].itemList[0].masterProduct.subCategories[0].smallImageUrl);
	        _this2.ngMeta.setTag('alt', success.data[0].itemList[0].masterProduct.subCategories[0].alt ? success.data[0].itemList[0].masterProduct.subCategories[0].alt : 'Product Image');
	        if (success.data[0] === null) {
	          _this2.$toaster.pop('success', 'Sorry, There are no products currently');
	          _this2.$state.go('category', { 'storeName': _this2.$auth.getGuestStoreDetail().storeName });
	        }
	        console.log("Product list : ", _this2.list);
	        var pwrItem = {};
	        var pwrItemList = [];
	        // var pwrIdDiv = document.getElementsByClassName("pwr-review");
	        // console.log("pwrdIdDiv : ", pwrIdDiv);
	        for (var i = 1; i <= _this2.list.length; i++) {
	          // pwrIdDiv[i-1].id = "category-snippet-" + i;
	          // pwrIdDiv[i-1].setAttribute("id", "category-snippet-" + i);
	          pwrItem = {
	            api_key: _this2.APP.AUTH.AUTH_URL.pwr.api_key,
	            locale: _this2.APP.AUTH.AUTH_URL.pwr.locale,
	            merchant_group_id: _this2.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
	            merchant_id: _this2.APP.AUTH.AUTH_URL.pwr.merchant_id,
	            page_id: _this2.list[i - 1].itemList[0].masterProduct.masterCode.substring(0, 7),
	            components: {
	              CategorySnippet: 'category-snippet-' + i
	            }
	          };
	          if (i > 1) {
	            pwrItem.enable_content_collection_modal = false;
	          }
	          pwrItemList.push(pwrItem);
	        }
	        console.log("pwrItemList : ", pwrItemList);
	        window.pwr = window.pwr || function () {
	          (window.pwr.q = window.pwr.q || []).push(arguments);
	        };
	        setTimeout(function () {
	          window.pwr("render", pwrItemList);
	        }, 1500);
	      }).finally(function () {
	        return _this2.$spinner.hide('appSpinner');
	      });
	    }
	  }, {
	    key: 'isCategorySubcatSame',
	    value: function isCategorySubcatSame() {
	      return this.list.length && this.list[0].itemList[0].masterProduct.subCategories[0].name === this.list[0].itemList[0].masterProduct.subCategories[0].category.name;
	    }
	
	    // parent is subcategory or category depending on subcategory existance
	
	  }, {
	    key: 'getParentDetails',
	    value: function getParentDetails() {
	      if (this.isCategorySubcatSame()) {
	        return this.list[0].itemList[0].masterProduct.subCategories[0].category;
	      } else {
	        return this.list.length && this.list[0].itemList[0].masterProduct.subCategories[0];
	      }
	    }
	  }, {
	    key: 'goToDSCDetailPage',
	    value: function goToDSCDetailPage() {
	      //  console.log('goToDSCDetailPage');
	      this.$state.go('savings-club');
	    }
	  }, {
	    key: 'isMobileDevice',
	    value: function isMobileDevice() {
	      return this.$auth.isMobileDevice();
	    }
	  }, {
	    key: 'getCurrencyType',
	    value: function getCurrencyType(item) {
	      if (item) {
	        return item.store.country.countryCode == "US" ? 'USD' : 'CAD';
	      }
	      return 'USD';
	    }
	
	    // returns dsc price if it has else return normal price
	
	  }, {
	    key: 'getRegularPrice',
	    value: function getRegularPrice(item) {
	      return ' $' + item.price.toFixed(2);
	    }
	  }, {
	    key: 'getDscPrice',
	    value: function getDscPrice(item) {
	      return ' $' + (item.price * 85 / 100).toFixed(2);
	    }
	  }, {
	    key: 'getPriceTag',
	    value: function getPriceTag(product, isDsc) {
	      var priceTag;
	      var isDscCategory = product.itemList[0].masterProduct.subCategories[0].category.dscCategory;
	      var maxItem = product.itemList[0];
	      var regularMaxPrice = isDsc ? this.getDscPrice(maxItem) : this.getRegularPrice(maxItem);
	      // checking max price
	      if (product.itemList.length > 1) {
	        var minItem = product.itemList[product.itemList.length - 1];
	
	        var regularMinPrice = isDsc ? this.getDscPrice(minItem) : this.getRegularPrice(minItem);
	        priceTag = regularMaxPrice;
	      } else {
	        priceTag = regularMaxPrice;
	      }
	
	      return priceTag;
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isIpad_potrait',
	    value: function isIpad_potrait() {
	      return this.$window.innerWidth < 769 && this.$window.innerWidth > 1247;
	    }
	  }, {
	    key: 'isOutOfStock',
	    value: function isOutOfStock(items) {
	      var isSubcatOutOfStock = false;
	      var j = 0;
	      for (var i = 0; i < items.itemList.length; i++) {
	        if (items.itemList[i].isOutOfStock) {
	          j++;
	        }
	      }
	      if (j == items.itemList.length) {
	        return true;
	      }
	    }
	  }, {
	    key: 'isAvailablebackon',
	    value: function isAvailablebackon(items) {
	      var availableOn = null;
	      for (var i = 0; i < items.itemList.length; i++) {
	        if (items.itemList[i].isOutOfStock) {
	          availableOn = items.itemList[i].availableBackOn;
	          break;
	        }
	      }
	      return availableOn;
	    }
	  }]);
	
	  return Product;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$stateParams', '$state', 'toaster', 'orderService', 'spinnerService', 'orderActions', 'authService', '$window', 'APP', 'ngMeta', '$location'], _temp)) || _class);
	exports.default = Product;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a0f20b660cfd3c21ee4cb90964a5c10.png";

/***/ },
/* 180 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"product.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{product.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\"\r\n      ng-if=\"product.categoryName.name !== product.subCategoryName.name\" \r\n      ui-sref=\"browse-sub-category({categoryId: product.categoryName.prettyUrl})\">\r\n      {{product.categoryName.name}}\r\n    </a>\r\n    <span>{{product.subCategoryName.name}}</span>\r\n  </nav>\r\n\r\n  <div class=\"row p-t-2 m-x-0 hidden-md-up\">\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <h5 class=\"font-weight-bold p-x-1\"\r\n        ng-bind=\"product.subCategoryName.name\">\r\n      </h5>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row  p-x-2 m-x-0 hidden-sm-down\">\r\n    <!-- Product Details -->\r\n    <div ng-class=\"product.isIpad()?'col-md-8':'col-md-9'\" style=\"padding-top: 29px;\" class=\" p-x-0\">\r\n      <h4 class=\"font-weight-bold  p-x-2\"\r\n        ng-bind=\"product.subCategoryName.name\"></h4>\r\n    </div>\r\n    <div ng-class=\"product.isIpad()?'col-md-4':'col-md-3'\"  ng-hide=\"product.storeName && product.storeName != ''\">\r\n        <product-promo></product-promo>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Large device sub category details -->\r\n  <div class=\"row hidden-sm-down  m-x-0\" style=\"height: 0px !important; overflow: hidden;\">\r\n    <!-- <div class=\"col-md-6 p-x-2 text-xs-center\">\r\n      <img class=\"product-image\" ng-if=\"product.list[0].itemList\" img-lazy-loader={{product.getParentDetails().largeImageUrl}}>\r\n    </div> -->\r\n    <div class=\"col-md-12 p-x-2 text-xs-left\">\r\n      <p class=\"lead\" ng-bind=\"product.getParentDetails().description\"></p>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- small device sub category details -->\r\n  <div class=\"row m-x-0 hidden-md-up\" ng-if=\"product.getParentDetails().description\">\r\n    <div class=\"col-xs-12 p-x-1\">\r\n      <p ng-bind=\"product.getParentDetails().description\"></p>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0\">\r\n    <!-- creates list view of products in xs devices -->\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <div class=\"list-group list-container hidden-md-up\" ng-repeat=\"item in product.list\" ng-if=\"product.isMobileDevice()\">\r\n        <a ui-sref=\"browse-product.detail({productId: item.itemList[0].masterProduct.prettyUrl,itemGroupNumber: item.itemList[0].masterProduct.itemGroupNumber})\"\r\n          class=\"list-group-item list-group-item-action media\" ng-if=\"item.itemList[0].masterProduct.masterCode != 88888888\">\r\n          <!-- <div class=\"media-left\">\r\n            <img ng-src={{item.itemList[0].smallImageUrl}} alt=\"{{item.itemList[0].alt ? item.itemList[0].alt : item.itemList[0].name}}\" class=\"media-object\" style=\"max-width: 60px\" />\r\n          </div> -->\r\n          <div class=\"{{product.isOutOfStock(item) ? 'm_pngcontainer1 media-left' : 'media-left'}}\">\r\n            <img ng-src={{item.itemList[0].smallImageUrl}} alt=\"{{item.itemList[0].alt ? item.itemList[0].alt : item.itemList[0].name}}\" class=\"media-object\" style=\"max-width: 60px\" />\r\n            <img ng-if=\"product.isOutOfStock(item)\" src={{product.tempUnavailable_S}}  alt=\"smiley\" style=\"max-width: 60px; margin-top: -10px\" class=\"media-object \"/>\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <h4 class=\"media-heading\" ng-bind=\"item.name\"></h4>\r\n            <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n          </div>\r\n          <div class=\"media-right\">\r\n            <img ng-src={{product.homeArrow}} class=\"sub-category-icon-arr\" />\r\n          </div>\r\n        </a>\r\n         <button class=\"hidden-btn list-group-item list-group-item-action media\" ng-click=\"product.goToDSCDetailPage()\" ng-if=\"item.itemList[0].masterProduct.masterCode == 88888888\">\r\n          <div class=\"media-left\">\r\n            <img ng-src={{item.itemList[0].smallImageUrl}} alt=\"{{item.itemList[0].alt?item.itemList[0].alt : item.itemList[0].name}}\" class=\"media-object\" style=\"max-width: 60px\" />\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <h4 class=\"media-heading\" ng-bind=\"item.name\"></h4>\r\n            <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n          </div>\r\n          <div class=\"media-right\">\r\n            <img ng-src={{product.homeArrow}} class=\"sub-category-icon-arr\" />\r\n          </div>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div id=\"tiles\" class=\"row p-x-2 m-x-0 \" ng-if=\"!product.isMobileDevice()\">\r\n    <!-- creates normal expanded view on md devices -->\r\n    <div class=\"col-md-4 col-lg-3 category-item\"\r\n      ng-repeat=\"item in product.list\">\r\n      <a ui-sref=\"browse-product.detail({productId: item.itemList[0].masterProduct.prettyUrl,itemGroupNumber: item.itemList[0].masterProduct.itemGroupNumber})\" ng-if=\"item.itemList[0].masterProduct.masterCode != 88888888\">\r\n        <div class=\"{{product.isOutOfStock(item) ? (product.isIpad_potrait ? 'm_pngcontainer1' : 'pngcontainer1') : ''}}\"> \r\n          <img ng-src={{item.itemList[0].largeImageUrl}}  alt=\"{{item.itemList[0].alt?item.itemList[0].alt:item.itemList[0].name}}\" \r\n          ng-style=\"product.isIpad() ? (product.isIpad_potrait ? {'left':'0px'} :  {'padding-left':'17px'})  : {'padding-left':'17px'}\" \r\n          class=\"product-thumbnail subcat-rounded\"/>\r\n          <img  ng-if=\"product.isOutOfStock(item)\" src={{product.tempUnavailable}} \r\n          ng-style=\"product.isIpad() ? (product.isIpad_potrait ? {'left':'0px'} :  {'padding-left':'17px'})  : {'padding-left':'17px'}\" \r\n          class=\"{{product.isOutOfStock(item) ? 'product-thumbnail-override subcat-rounded' : 'product-thumbnail subcat-rounded'}}\" alt=\"smiley\" />\r\n        </div>\r\n        <div class=\" m-b-0\">\r\n            <!-- <span ng-if=\"item.itemList[0].isOutOfStock\">Temporarily Unavailable<br/></span> -->\r\n            <!-- <span ng-if=\"product.isOutOfStock(item) && product.isAvailablebackon(item)\" class=\"s_out_of_stock\">Expected availability: {{item.itemList[0].availableBackOn | date:'MM/dd/yyyy'}}<br/></span> -->\r\n            <span class=\"sub-category-text\">{{item.name}}</span>\r\n            <div id=\"{{'category-snippet-'+($index+1)}}\"></div>\r\n           <p>\r\n            <span class=\"gray-text\">{{item.itemList[0].masterProduct.briefDescription}}</span>\r\n\r\n            <br>\r\n            <span ng-if=\"product.storeName && product.storeName != ''\">\r\n            <span>\r\n            <span class=\"sub-category-text\" ng-bind=\"product.getPriceTag(item,false)\"> </span> <span  ng-if=\"item.itemList[0].masterProduct.subCategories[0].category.dscCategory\" > {{item.itemList[0].weight}} lbs</span>\r\n            </span>\r\n             <br>\r\n             <span  ng-if=\"item.itemList[0].masterProduct.subCategories[0].category.dscCategory\" >\r\n             <span class=\"sub-category-text\" ng-bind=\"product.getPriceTag(item,true)\"> </span> Daily Savings Club\r\n          </span>\r\n             <br>\r\n             <strong ng-if=\"item.itemList.length > 1\"  style=\"font-style: italic\">click for more sizes</strong>\r\n            </span>\r\n          </p>\r\n\r\n        </div>\r\n      </a>\r\n       <button class=\"hidden-btn\" ng-click=\"product.goToDSCDetailPage()\" ng-if=\"item.itemList[0].masterProduct.masterCode == 88888888\">\r\n        <img ng-src={{item.itemList[0].largeImageUrl}} alt=\"{{item.itemList[0].alt?item.itemList[0].alt : item.itemList[0].name}}\" class=\"product-thumbnail subcat-rounded\"/>\r\n        <h6 class=\"sub-category-text m-b-0\" ng-bind=\"item.name\"></h6>\r\n        <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"hidden-md-up m-t-10 m-b-10\" style=\"text-align: center;\" ng-hide=\"product.storeName && product.storeName != ''\">\r\n    <br>\r\n    <product-promo></product-promo> <br>\r\n</div>\r\n</div>\r\n"

/***/ },
/* 181 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bacc0dca3d5fb38c8603d54218fe0f06.png";

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* File: detail.js
	                                   ------------------
	                                   This file does calculations and api calls for detail.html template.
	                                   Important assumptions are noted here for reference.
	                                   * Weight field in template is assumed that
	                                    1 - it would be only 8 char long only.
	                                    2 - it would not be null
	                                    3 - 8th char should not be zero.
	                                  
	                                    if all 3 conditions are met then only weight element will be shown on consumer app. This validation is
	                                    not done at the backoffice app.
	                                  */
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _up = __webpack_require__(184);
	
	var _up2 = _interopRequireDefault(_up);
	
	var _up_menu = __webpack_require__(185);
	
	var _up_menu2 = _interopRequireDefault(_up_menu);
	
	var _fbLogo = __webpack_require__(186);
	
	var _fbLogo2 = _interopRequireDefault(_fbLogo);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _wbuPointer = __webpack_require__(149);
	
	var _wbuPointer2 = _interopRequireDefault(_wbuPointer);
	
	var _wbuMapPointer = __webpack_require__(150);
	
	var _wbuMapPointer2 = _interopRequireDefault(_wbuMapPointer);
	
	var _detail = __webpack_require__(187);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _search = __webpack_require__(147);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _oopsPage = __webpack_require__(188);
	
	var _oopsPage2 = _interopRequireDefault(_oopsPage);
	
	var _hamburger = __webpack_require__(189);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _DSCCard = __webpack_require__(190);
	
	var _DSCCard2 = _interopRequireDefault(_DSCCard);
	
	var _productPromoMobile = __webpack_require__(191);
	
	var _productPromoMobile2 = _interopRequireDefault(_productPromoMobile);
	
	var _alert = __webpack_require__(192);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _tempunavailable_L = __webpack_require__(181);
	
	var _tempunavailable_L2 = _interopRequireDefault(_tempunavailable_L);
	
	var _power = __webpack_require__(193);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _red_tick = __webpack_require__(194);
	
	var _red_tick2 = _interopRequireDefault(_red_tick);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'productDetail',
	  template: _detail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ProductDetail($rootScope, $scope, $ngRedux, $state, $stateParams, $auth, $order, orderActions, $spinner, toaster, $uibModal, $timeout, ngMeta, $location, $window, APP, $sce) {
	    var _this = this;
	
	    _classCallCheck(this, ProductDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.ngMeta = ngMeta;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$auth = $auth;
	    this.$order = $order;
	    this.dscCardMobileDefault = _productPromoMobile2.default;
	    this.$rootScope = $rootScope;
	    this.toaster = toaster;
	    this.FBLogo = _fbLogo2.default;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.alertIcon = _alert2.default;
	    this.tempUnavailable = _tempunavailable_L2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$uibModal = $uibModal;
	    this.subCategoryName = '';
	    this.storeName = '';
	    this.searchIcon = _search2.default;
	    this.oopsImage = _oopsPage2.default;
	    this.productNotFound = false;
	    this.isDeliveryError = false;
	    this.dscCardDefault = _DSCCard2.default;
	    this.dscAltTag = 'DSC Offer';
	    this.markerIcon = _wbuMapPointer2.default;
	    this.$sce = $sce;
	    this.isMiscelleneousCategory = 4;
	    this.canShowQAhr = false;
	    this.cylinder = 'Cylinder';
	    this.browserUrl = 'shop';
	    this.showDescription = true;
	    this.showSpecifications = false;
	    this.showWarranty = false;
	    this.showMaterials = false;
	    this.showAllergen = false;
	    this.showIngredients = false;
	    this.addedtoCartTick = _red_tick2.default;
	    this.isAddToCartPopUpShown = false;
	    this.customSpecification = "";
	    this.isDscClickable = false;
	    this.savedTick = _shippingTick2.default;
	    this.APP = APP;
	    this.link = {};
	    this.currentLink = { "hasFetched": false, "hasLinkToShow": false };
	    this.hasLinkToShow = false;
	    this.constructedLink = null;
	    this.OutOfStockRemainderText = {
	      'new': 'Reminder set to notify when item is in-stock',
	      'exist': 'Reminder already set to notify when item is in-stock'
	    };
	
	    this.quantityAction = {
	      "AddingQuantity": "AddingQuantity",
	      "ReducingQuantity": "ReducingQuantity"
	    };
	
	    this.userAction = {
	      "ViewCart": "ViewCart",
	      "ContinueShopping": "ContinueShopping",
	      "NoAction": "NoAction"
	    };
	
	    this.productImageStyle = {
	      'text-align': 'center',
	      'padding-left': '15px'
	    };
	    // this.productDescStyle = {
	    //   'padding-left': '21px',
	    //   'padding-right': '6px'
	    // };
	    this.marleft20 = {
	      'margin-left': '20px'
	    };
	    this.productDescStyle = {
	      'right': '40px'
	    };
	    this.noPadding = {
	      'padding': '0px'
	    };
	    this.Padding = {
	      'padding-right': '24px',
	      'padding-left': '24px'
	    };
	    this.Padding_Mob = {
	      'padding-right': '24px',
	      'padding-left': '24px'
	      // 'display': 'inline-grid'
	    };
	    this.higlightedmarkerIcon = _wbuPointer2.default;
	    this.leftArrow = _hamburger2.default;
	    this.selectedItem = {};
	    this.isItemAdded = false;
	    this.imageList = [];
	    this.videoList = [];
	    this.imgVideoList = [];
	    this.imageListArr = [];
	    this.imageListZoom = [];
	    this.videoListZoom = [];
	    this.imgVideoIpadList = [];
	    this.referralProducts = [];
	    this.slideIndex = 1;
	    this.slideIndexZoom = 1;
	    this.slideIndexIpad = 1;
	    this.selectedImgZoom = '';
	    this.upArrow = _up2.default;
	    this.downArrow = _up_menu2.default;
	    this.isShowImage = false;
	    this.isShowVideo = false;
	    this.currentImagePosition = 0;
	    this.currentImagePositionHeight = 0;
	    this.multiImageViewPortSlideSize = 3;
	    if (window && window.location) {
	      this.domain = window.location.origin;
	    }
	
	    console.log("this.$stateParams.productId -------", this.$stateParams.productId);
	    console.log("this.$stateParams.reminderId -------", this.$stateParams.reminderId);
	
	    if (this.$stateParams.reminderId) {
	      this.$order.remainderUsed(this.$stateParams.reminderId);
	    }
	
	    var forSeoSite = $location.path().split(/\//g);
	    if (forSeoSite.length > 0 && forSeoSite[1]) {
	      if (forSeoSite[1] == this.browserUrl) {
	        this.isSeoSite = true;
	      } else {
	        this.isSeoSite = false;
	      }
	    }
	
	    this.$order.getStoreFeatures();
	
	    this.guestCart = this.$auth.getGuestCart();
	    this.isLoggedIn = this.$auth.isLoggedIn();
	    // console.log(isLoggedIn);
	    this.checkForGuestCart();
	    $window.scrollTo(0, 0);
	    this.$window = $window;
	
	    this.pwrProduct = {};
	    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + this.APP.ORDER.ORDER_URL.browseUrl + '/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
	      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.$stateParams.storeName +'/' + this.$stateParams.categoryId +'/' + this.$stateParams.subCategoryId+'/' + this.$stateParams.productId;
	    } else {
	      this.canUrl = this.$location.$$absUrl;
	    }
	    this.ngMeta.setTag('canUrl', this.canUrl);
	
	    this.forSubscription = this.$stateParams.forSubscription;
	    $ngRedux.dispatch(orderActions.setProductDetail({}));
	    $spinner.show('appSpinner');
	    this.$spinner = $spinner;
	    this.$order = $order;
	    this.$stateParams = $stateParams;
	    this.orderActions = orderActions;
	    this.$ngRedux = $ngRedux;
	    this.$timeout = $timeout;
	    this.subCategoryName = '';
	    this.categoryName = '';
	    this.storeName = '';
	    this.productLoadCount = 0;
	    if ((this.$auth.isLoggedIn() || this.$auth.isGuestLogin()) && this.$stateParams) {
	      if (this.$auth.isLoggedIn()) {
	        $auth.getUserProfile().then(function () {
	          if (_this.isDscMember()) {
	            _this.isDscClickable = false;
	            _this.getDSCDetails(true);
	          } else {
	            _this.isDscClickable = true;
	            _this.getDSCDetails(false);
	          }
	          _this.loadProducts();
	          $order.getCartDetail().then(function () {});
	        });
	      } else {
	        this.isDscClickable = true;
	        this.getDSCDetails(false);
	        $timeout(function () {
	          _this.loadProducts();
	        }, 300);
	      }
	    } else {
	      this.getDSCDetails(false);
	      this.isDscClickable = true;
	    }
	
	    var listener1 = $rootScope.$on('onLoginSuccess', function () {
	      _this.checkForGuestCart();
	    });
	    var listener2 = $rootScope.$on('onGuestLogin', function () {
	      return _this.loadProducts();
	    });
	    var listener3 = $rootScope.$on('storeSelected', function () {
	      _this.confirmChangeStore($rootScope.selectedStoreId, $rootScope.selectedStore);
	    });
	
	    $scope.$on('$destroy', function () {
	      disconnect();
	      listener1();
	      listener2();
	      listener3();
	    });
	
	    $scope.trustSrc = function (src) {
	      return $sce.trustAsResourceUrl(src);
	    };
	  }
	
	  _createClass(ProductDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        detail: state.order.productDetail,
	        // referralProducts: state.order.referralProducts,
	        cartDetail: state.order.cartDetail,
	        storeLocation: state.auth.storeDetail,
	        storeFeatures: state.order.storeFeatures
	      };
	    }
	  }, {
	    key: 'loadProducts',
	    value: function loadProducts() {
	      var _this2 = this;
	
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        this.storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          this.storeName = this.profile.store.storeURLName;
	        } else {
	          this.storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      var categoryNameResponse = this.$order.getCateoryNamebyId(this.$stateParams.categoryId);
	      categoryNameResponse.then(function (success) {
	
	        _this2.categoryName = success.data;
	      });
	      var subCategoryNameResponse = this.$order.getSubCateoryNamebyId(this.$stateParams.subCategoryId);
	      subCategoryNameResponse.then(function (success) {
	
	        _this2.subCategoryName = success.data;
	      });
	      var categoryId = this.$stateParams.categoryId;
	      // console.log('lthis.$stateParams.subCategoryId;',this.$stateParams.subCategoryId);
	      var subCategoryId = this.$stateParams.subCategoryId;
	      var productPrettyId = this.$stateParams.productId;
	      var itemGroupNumber = this.$stateParams.itemGroupNumber;
	      this.selectedItem = {};
	      var $ctrl = this;
	      // this.$order.getProductsByGroupNumber(categoryId, subCategoryId,itemGroupNumber)
	      // this.$order.getProducts(categoryId, subCategoryId)
	      this.$order.getProductOfSameGroupByPrettyUrl(subCategoryId, productPrettyId).then(function (success) {
	        _this2.productLoadCount++;
	        if (success.data && success.data[0]) {
	
	          var productAvailable = success.data.filter(function (product) {
	            var idArray = product.itemList.filter(function (item) {
	              item.masterProduct.prettyUrl == $ctrl.$stateParams.productId;
	              _this2.link[item.masterProduct.id] = {};
	              _this2.link[item.masterProduct.id].hasFetched = false;
	              _this2.link[item.masterProduct.id].hasLinkToShow = false;
	            });
	
	            if (idArray.length == 0) {
	              if (success.data[0].itemList.length > 0) {
	                idArray = success.data[0].itemList;
	              }
	            }
	
	            if (idArray.length > 0) {
	              _this2.imageList = [];
	              _this2.videoList = [];
	              _this2.imgVideoList = [];
	              _this2.imgVideoIpadList = [];
	              _this2.imageListZoom = [];
	              _this2.videoListZoom = [];
	              product.itemList.forEach(function (item) {
	                console.log('item.masterProduct.id', item.masterProduct.id);
	                _this2.getMultipleImage(item.masterProduct);
	              });
	              _this2.ngMeta.setTitle(idArray[0].masterProduct.itemName);
	              _this2.ngMeta.setTag('description', idArray[0].masterProduct.description ? idArray[0].masterProduct.description : 'Product Page description');
	              _this2.ngMeta.setTag('image', idArray[0].masterProduct.smallImageUrl);
	              _this2.ngMeta.setTag('alt', idArray[0].masterProduct.alt ? idArray[0].masterProduct.alt : 'Product Image');
	
	              // console.log("IdArray ::::", idArray[0].masterProduct.masterCode);
	              // this.getMultipleImage(idArray[0].masterProduct.id, true);
	
	              setTimeout(function () {
	                // $ctrl.$order.getReferralProducts(idArray[0].masterProduct.masterCode);
	                $ctrl.referralProducts = [];
	                $ctrl.$order.getReferrals(idArray[0].masterProduct.masterCode).then(function (success) {
	                  if (success.data && success.data) {
	                    $ctrl.referralProducts = success.data;
	                  }
	                });
	                document.getElementById('headline').classList.remove('hide');
	                document.getElementById('headlinefooter').classList.remove('hide');
	                if (document.getElementById('dotimage')) {
	                  document.getElementById('dotimage').classList.remove('hide');
	                }
	              }, 1000);
	            }
	            return idArray.length ? true : false;
	          }).length;
	          // console.log('success data', success.data);
	          console.log('productAvailable', productAvailable);
	          // console.log('paramid', this.$stateParams.productId);
	          if (success.data[0] === null) {
	            _this2.productNotFound = true;
	            // this.toaster.pop('success', 'You are trying to access wrong Sub-Category.');
	            // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
	          }
	          if (!productAvailable) {
	            _this2.productNotFound = true;
	            // this.toaster.pop('success', 'Product is not available');
	            // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
	          } else {
	
	            _this2.productNotFound = false;
	          }
	          if (_this2.$stateParams.productId) {
	            // if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	            //   this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '');
	            // } 
	            // else{
	            //   this.canUrl = '';
	            // }
	            // console.log("Shop Url :",  this.APP.ORDER.ORDER_URL.browseUrl);
	            // console.log('STORENAME :', this.$stateParams.storeName);
	            // this.ngMeta.setTag('canUrl',this.canUrl);
	            var productDetail = success.data.filter(function (item) {
	
	              if (item.itemList.filter(function (itemVariety) {
	                return itemVariety.masterProduct.prettyUrl === _this2.$stateParams.productId;
	              })[0]) {
	
	                /* ngMeta.setTitle(item.itemList[0].name);
	                 ngMeta.setTag('description',item.itemList[0].briefDescription);
	                 ngMeta.setTag('url','https://order.wbu.com/store/order/category/indianapolis/'+this.$stateParams.categoryId+'/sub-category/'+$stateParams.subCategoryId+'/product/'+$stateParams.productId+'/detail');
	                 ngMeta.setTag('image',item.itemList[0].largeImageUrl);
	                 ngMeta.setTag('alt',item.itemList[0].name);*/
	              }
	              var productFound = item.itemList.filter(function (itemVariety) {
	                return itemVariety.masterProduct.prettyUrl === _this2.$stateParams.productId;
	              })[0];
	              // From SEO Site, there may be chances that selected product weight might
	              // not available in store. So, since we are fetching based on groups
	              // we can show the available item of different weight if product not found.
	              if (productFound != null) {
	                return productFound;
	              } else {
	                return success.data[0].itemList[0];
	              }
	            })[0];
	            console.log("productDetail--", productDetail);
	            if (productDetail) {
	              console.log("this.seosite : ", _this2.isSeoSite);
	              if (!_this2.isSeoSite && productDetail.itemList && productDetail.itemList.length && !productDetail.itemList[0].price && _this2.productLoadCount < 5) {
	                _this2.loadProducts();
	              }
	
	              _this2.$window.document.title = productDetail.itemList[0].masterProduct.title ? productDetail.itemList[0].masterProduct.title + ' | Wild Birds Unlimited' : _this2.APP.ORDER.ORDER_URL.siteTitle;
	
	              var weight = 0;
	              var itemToSelect = productDetail.itemList[0];
	              _this2.currencyType = (productDetail.itemList[0].store && productDetail.itemList[0].store.country.countryCode) == "US" ? 'USD' : 'CAD';
	              if (itemToSelect.name.indexOf(_this2.cylinder) === -1) {
	                if (itemToSelect.weight) {
	                  weight = productDetail.itemList[0].weight;
	                  for (var i = 0; i < productDetail.itemList.length; i++) {
	                    if (productDetail.itemList[i].weight > weight) {
	                      itemToSelect = productDetail.itemList[i];
	                      weight = productDetail.itemList[i].weight;
	                    }
	                  }
	                }
	              } else {
	                if (itemToSelect.weight) {
	                  weight = productDetail.itemList[0].weight;
	                  for (var j = 0; j < productDetail.itemList.length; j++) {
	                    if (productDetail.itemList[j].weight < weight) {
	                      itemToSelect = productDetail.itemList[j];
	                      weight = productDetail.itemList[j].weight;
	                    }
	                  }
	                }
	              }
	
	              // this.setDimension(itemToSelect);
	
	              _this2.selectedItem = itemToSelect;
	              if (_this2.selectedItem != null) {
	                _this2.currentItemGroupNumber = _this2.selectedItem.masterProduct.itemGroupNumber;
	                _this2.getLinks(_this2.selectedItem);
	              }
	              if (_this2.selectedItem.isOutOfStock) {
	                if (_this2.profile.email) {
	                  _this2.emailToRemainder = _this2.profile.email;
	                }
	                // May enhance the below code to save cache and show the remainder set already.
	                // THe below codes works for guest but not for logged in user.
	                // let outOfStockRemainders = sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS') ? JSON.parse(sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS')) : null;
	                // if(outOfStockRemainders!=null && outOfStockRemainders[this.selectedItem.id]){
	                //   this.isRemainderSetAlready = true;
	                //   this.outOfStockRemainderText = this.OutOfStockRemainderText.exist;
	                // }
	              }
	
	              // Power review updates for product detail paged
	              var forSeoSite = $ctrl.$location.path().split(/\//g);
	              var replacePattern = '';
	              if (forSeoSite.length > 0 && forSeoSite[1]) {
	                replacePattern = new RegExp(forSeoSite[1], "gi");
	              }
	              console.log("replacePattern string for store in wrapper url for power reivew : ", replacePattern);
	              var urlToString = $ctrl.$location.absUrl().replace(replacePattern, _this2.APP.ORDER.ORDER_URL.browseUrl);
	              _this2.pwrProduct.api_key = _this2.APP.AUTH.AUTH_URL.pwr.api_key;
	              _this2.pwrProduct.locale = _this2.APP.AUTH.AUTH_URL.pwr.locale;
	              _this2.pwrProduct.merchant_group_id = _this2.APP.AUTH.AUTH_URL.pwr.merchant_group_id;
	              _this2.pwrProduct.merchant_id = _this2.APP.AUTH.AUTH_URL.pwr.merchant_id;
	              _this2.pwrProduct.style_sheet = _power2.default;
	              _this2.pwrProduct.review_wrapper_url = urlToString + "/write-a-review?";
	              // this.pwrProduct.on_render = function(config, data) {
	              //   if(config!=null){
	              //     if(config.component=='QuestionSnippet'){
	              //       if(data!=null && data.question_count<1){
	              //         var node = document.querySelectorAll('[title="Questions & Answers"]');
	              //         for (var index=0; index < node.length; index++) {
	              //           if(index==0){
	              //             node[index].style.display='none';
	              //           }
	              //         }
	              //       }
	              //     }
	              //   }
	              // };
	              _this2.pwrProduct.on_render = function (config, data) {
	                if (config != null) {
	                  // console.log("config : ",config);
	                  // console.log("data : ",data);
	                  if (config.component == 'QuestionSnippet') {
	                    if (data != null && data.question_count < 1) {
	                      var nodelist = document.getElementsByClassName("pr-qa-display");
	                      // console.log("nodelist : ", nodelist[0]);
	                      nodelist[0].style.display = 'none';
	                      $ctrl.canShowQAhr = false;
	                    } else {
	                      $ctrl.canShowQAhr = true;
	                    }
	                    // console.log("this.canShowQAhr : ",$ctrl.canShowQAhr);
	                  }
	                  if (!$ctrl.isNotMobile()) {
	                    var prreview_list = document.getElementsByClassName("pr-review");
	                    for (var i = 0; i < prreview_list.length; i++) {
	                      prreview_list[i].style.padding = '15px';
	                      var spacebtwreviews = prreview_list[i].querySelector('.pr-rd-footer');
	                      // console.log("spacebtwreviews :- ",spacebtwreviews);
	                      if (spacebtwreviews != null) {
	                        $ctrl.removeClass(spacebtwreviews, "pr-rd-footer");
	                        $ctrl.addClass(spacebtwreviews, "pwr-pr-rd-footer");
	                      }
	                    }
	                    var askQuestionButton = document.getElementById("pr-question-form-link");
	                    // console.log("askQuestionButton : ", askQuestionButton);
	                    if (askQuestionButton != null) {
	                      askQuestionButton.style.padding = '12px';
	                      if (askQuestionButton.hasChildNodes()) {
	                        askQuestionButton.firstElementChild.style.marginTop = '12px';
	                        askQuestionButton.firstElementChild.style.color = 'white !important';
	                        if (askQuestionButton.childNodes.length > 1) {
	                          // "pr-qa-display-text"
	                          $ctrl.removeClass(askQuestionButton.childNodes[1], "pr-qa-display-text");
	                          $ctrl.addClass(askQuestionButton.childNodes[1], "pwr-ask-question-text");
	                          console.log("askQuestionButton update : ", askQuestionButton);
	                        }
	                      }
	                    }
	                  }
	                }
	              };
	              if (productDetail.itemList && productDetail.itemList.length > 0) {
	                var desc = "";
	                if (_this2.selectedItem.briefDescription && _this2.selectedItem.briefDescription != null) {
	                  desc = _this2.selectedItem.briefDescription;
	                } else {
	                  desc = _this2.selectedItem.name;
	                }
	                _this2.pwrProduct.product = {
	                  'name': _this2.selectedItem.name,
	                  'url': _this2.$location.absUrl(),
	                  'image_url': _this2.selectedItem.masterProduct.smallImageUrl,
	                  'description': desc,
	                  'category_name': _this2.categoryName.prettyUrl,
	                  'manufacturer_id': '',
	                  'upc': '',
	                  'brand_name': 'Wild Birds Unlimited',
	                  'price': _this2.selectedItem.price,
	                  'in_stock': true,
	                  'asin': ''
	                };
	                $ctrl.pwrProduct.page_id = productDetail.itemList[0].masterProduct.masterCode.substring(0, 7);
	                if (productDetail.itemList.length > 0) {
	                  $ctrl.pwrProduct.product.variants = [];
	                  productDetail.itemList.forEach(function (item) {
	                    if (item.weight) {
	                      var itemDesc = "";
	                      if (item.briefDescription && item.briefDescription != null) {
	                        itemDesc = item.briefDescription;
	                      } else {
	                        itemDesc = item.masterProduct.itemName;
	                      }
	                      $ctrl.pwrProduct.product.variants.push({
	                        'name': item.masterProduct.itemName,
	                        'manufacturer_id': '',
	                        'page_id_variant': item.weight,
	                        'upc': '',
	                        'description': itemDesc
	                      });
	                    }
	                  });
	                }
	              }
	              _this2.pwrProduct.components = {
	                'ReviewDisplay': 'pr-reviewdisplay',
	                'ReviewSnippet': 'pr-reviewsnippet',
	                'QuestionSnippet': 'pr-questionsnippet',
	                'QuestionDisplay': 'pr-questiondisplay'
	              };
	              console.log("this.pwrProduct", _this2.pwrProduct);
	              window.pwr = window.pwr || function () {
	                (window.pwr.q = window.pwr.q || []).push(arguments);
	              };
	              console.log("window.pwr : ", window.pwr);
	              setTimeout(function () {
	                window.pwr("render", _this2.pwrProduct);
	              }, 1000);
	              _this2.$ngRedux.dispatch(_this2.orderActions.setProductDetail(productDetail));
	            }
	            if (!productDetail) {
	              _this2.productNotFound = true;
	              // this.toaster.pop('success', 'You are trying to access wrong Product Details.');
	              // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
	              // return;
	            }
	          }
	        } else {
	          _this2.productNotFound = true;
	        }
	      }).catch(function (err) {
	        _this2.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        _this2.$spinner.hide('appSpinner');
	        _this2.sendDataToInteractionStudio(_this2.detail);
	      });
	    }
	  }, {
	    key: 'getLinks',
	    value: function getLinks(item) {
	      var _this3 = this;
	
	      var masterId = item.masterProduct.id;
	      var tempLink = this.link[masterId];
	      if (this.currentItemGroupNumber == item.masterProduct.itemGroupNumber) {
	        if (tempLink != null && !tempLink.hasFetched) {
	          this.$order.getLinksByMasterId(masterId).then(function (success) {
	            if (success.data && success.data.link) {
	              tempLink.hasLinkToShow = true;
	              tempLink.constructedLink = success.data.link;
	              tempLink.linkName = success.data.linkName;
	              tempLink.display_in = success.data.display_in;
	            } else {
	              tempLink.hasLinkToShow = false;
	            }
	            tempLink.hasFetched = true;
	            _this3.currentLink = tempLink;
	            _this3.link[masterId] = tempLink;
	          }).catch(function (error) {
	            tempLink.hasFetched = true;
	            tempLink.hasLinkToShow = false;
	            _this3.currentLink = tempLink;
	            _this3.link[masterId] = tempLink;
	          });
	        } else {
	          this.currentLink = this.link[masterId];
	        }
	        console.log("this.link----", this.link);
	      } else {
	        this.currentLink = { "hasFetched": false, "hasLinkToShow": false };
	      }
	    }
	  }, {
	    key: 'sendDataToInteractionStudio',
	    value: function sendDataToInteractionStudio(productInfo) {
	      var _this4 = this;
	
	      try {
	        console.log("Inside finally : ", productInfo);
	        if (this.productNotFound) {
	          this.$order.getProductByPrettyUrl(this.$stateParams.categoryId, this.$stateParams.subCategoryId, this.$stateParams.productId).then(function (success) {
	            if (success.data != null) {
	              productInfo = success.data[0];
	              console.log("ProductInfo :  ", productInfo);
	              if (productInfo != null && productInfo.itemList != null && productInfo.itemList.length > 0 && productInfo.itemList[0].id != null) {
	                productInfo.itemList[0].isActive = false;
	                console.log("Sending inactive item info to interaction studio: ", productInfo);
	                _this4.$window.dataLayer = _this4.$window.dataLayer || [];
	                _this4.$window.dataLayer.push(productInfo);
	              }
	            }
	          });
	        } else {
	          this.$window.dataLayer = this.$window.dataLayer || [];
	          this.$window.dataLayer.push(productInfo);
	        }
	      } catch (e) {
	        console.log("Error : ", e);
	      }
	    }
	  }, {
	    key: 'hasClass',
	    value: function hasClass(ele, cls) {
	      return ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
	    }
	  }, {
	    key: 'addClass',
	    value: function addClass(ele, cls) {
	      if (!this.hasClass(ele, cls)) ele.className += " " + cls;
	    }
	  }, {
	    key: 'removeClass',
	    value: function removeClass(ele, cls) {
	      if (this.hasClass(ele, cls)) {
	        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
	        ele.className = ele.className.replace(reg, ' ');
	      }
	    }
	  }, {
	    key: 'replaceClass',
	    value: function replaceClass(ele, oldClass, newClass) {
	      if (this.hasClass(ele, oldClass)) {
	        this.removeClass(ele, oldClass);
	        this.addClass(ele, newClass);
	      }
	      return;
	    }
	  }, {
	    key: 'toggleClass',
	    value: function toggleClass(ele, cls1, cls2) {
	      if (this.hasClass(ele, cls1)) {
	        this.replaceClass(ele, cls1, cls2);
	      } else if (this.hasClass(ele, cls2)) {
	        this.replaceClass(ele, cls2, cls1);
	      } else {
	        this.addClass(ele, cls1);
	      }
	    }
	  }, {
	    key: 'fbshare',
	    value: function fbshare() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      try {
	        if (storeName) {
	          // this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '')+'/fb/'+ storeName + '/category/'+this.$stateParams.categoryId+'/sub-category/'+this.$stateParams.subCategoryId+'/product/'+this.$stateParams.productId+'/details';
	
	          this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/fb/' + storeName + '/category/' + this.$stateParams.categoryId + '/sub-category/' + this.$stateParams.subCategoryId + '/product/' + this.$stateParams.productId + '/details';
	          // this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/' + storeName + '/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
	          // this.shareURL = this.shareURL.replace("http://localhost:9000", 'qa-order.wbu.com');
	        } else {
	          this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/fb/category/' + this.$stateParams.categoryId + '/sub-category/' + this.$stateParams.subCategoryId + '/product/' + this.$stateParams.productId + '/details';
	          // this.shareURL = this.$location.$$absUrl.replace(this.$location.$$url, '') + '/shop/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
	          // this.shareURL = this.shareURL.replace("http://localhost:9000", 'qa-order.wbu.com');
	        }
	        window.open('https://www.facebook.com/sharer/sharer.php?u=' + String(this.shareURL), 'pop', 'width=600, height=400, scrollbars=no');
	      } catch (err) {
	        // console.log(err);
	      }
	    }
	  }, {
	    key: 'openLoginPopup',
	    value: function openLoginPopup() {
	      this.$rootScope.$emit('guestLoginConfirmed');
	    }
	  }, {
	    key: 'addItemToCart',
	    value: function addItemToCart(form) {
	      var _this5 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      if (this.$auth.isGuestLogin()) {
	        this.disableAddToCart = true;
	        this.isDeliveryError = '';
	        // Validating instore and Delivery only items in cart
	        if (!this.deliveryTypeValidation()) {
	          return;
	        }
	        if (this.storeLocation && !this.storeLocation.hasGuestCheckout) {
	          var $ctrl = this;
	          this.$uibModal.open({
	            size: 'sm',
	            template: '<div class="modal-body p-1-1 login_redirect_modal" id="modal-body" >You have to login/register to  add this item to cart<hr>' + '<h6><b><center>Do you want to continue?</center></b></h6>' + '</div>' + '<div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()" >Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" ">OK</button>' + '</div>',
	            controller: ['$scope', '$uibModalInstance', 'authService', '$cookies', '$rootScope', '$timeout', function ($scope, $uibModalInstance, $auth, $cookies, $rootScope, $timeout) {
	              $scope.ok = function () {
	                $uibModalInstance.close();
	
	                $rootScope.$emit('guestLoginConfirmed');
	              };
	              $scope.cancel = function () {
	                try {
	                  sessionStorage.removeItem('guestCart');
	                } catch (e) {
	                  $cookies.remove('guestCart');
	                }
	                $uibModalInstance.close();
	              };
	            }],
	            resolve: {
	              id: function id() {
	                return $ctrl.id;
	              }
	            }
	          });
	          this.disableAddToCart = false;
	          this.isDeliveryError = '';
	          return;
	        }
	
	        var cartList = this.$auth.getGuestCart();
	        if (cartList && cartList.length) {
	          var index = cartList.findIndex(function (data) {
	            return data.itemId === _this5.selectedItem.id;
	          });
	          if (~index) {
	            this.quantityToBeAdded = cartList[index].quantity + this.quantity;
	          } else {
	            this.quantityToBeAdded = this.quantity;
	          }
	        } else {
	          this.quantityToBeAdded = this.quantity;
	        }
	
	        var cart = null;
	        cart = {
	          'quantity': this.quantity,
	          'itemId': this.selectedItem.id,
	          'categoryId': this.selectedItem.masterProduct.category.id,
	          'subCategoryId': this.selectedItem.masterProduct.subCategories[0].id,
	          'masterProductId': this.selectedItem.masterProduct.id,
	          'deliveryType': this.selectedItem.deliveryType
	        };
	        this.isItemAdded = true;
	        this.$auth.addtoGuestCart(cart);
	        if (this.isNotMobile()) {
	          this.showAddtoCartpopup();
	        } else {
	          this.showAddtoCartMobilepopup();
	        }
	        // this.toaster.pop('success', 'Item added to cart');
	      } else {
	        var item;
	        item = {
	          'itemId': this.selectedItem.id,
	          'subCategoryId': this.selectedItem.masterProduct.subCategories[0].id
	        };
	        this.addToCart(this.quantity, item);
	      }
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(quantity, item) {
	      var _this6 = this;
	
	      this.disableAddToCart = true;
	      this.isDeliveryError = '';
	      // Validating instore and Delivery only items in cart
	      if (!this.deliveryTypeValidation()) {
	        return;
	      }
	
	      this.$order.addItemToCart(quantity, item.itemId, item.subCategoryId).then(function (success) {
	        _this6.isItemAdded = true;
	        // this.toaster.pop('success', 'Item added to cart');
	        _this6.$auth.getUserProfile();
	        _this6.quantityToBeAdded = success.data.itemsAddedToCart;
	        if (_this6.isNotMobile()) {
	          _this6.showAddtoCartpopup();
	        } else {
	          _this6.showAddtoCartMobilepopup();
	        }
	      }, function (error) {
	        if (error.data.errorCode == 692) {
	          _this6.toaster.pop('success', error.data.message);
	        } else {
	          _this6.toaster.pop('success', 'Item already exists in cart. Click on cart icon on top right.');
	        }
	      }).finally(function () {
	        _this6.disableAddToCart = false;
	        if (_this6.$auth.getGuestCart()) {
	          _this6.$auth.removeGuestCart();
	        }
	      });
	    }
	  }, {
	    key: 'buyNow',
	    value: function buyNow(form) {
	      var _this7 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      this.$order.addItemToCart(this.quantity, this.selectedItem.id).finally(function () {
	        return _this7.$state.go('cart');
	      });
	    }
	  }, {
	    key: 'selectWeight',
	    value: function selectWeight(item) {
	      this.showImagelist(item.masterProduct.id);
	      this.getLinks(item);
	      // this.setDimension(item);
	      this.selectedItem = item;
	      this.isItemAdded = false;
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'masterCodeChecker',
	    value: function masterCodeChecker(item) {
	      return item.masterProduct.masterCode && (item.masterProduct.masterCode.length === 8 || item.masterProduct.masterCode.length === 9) && item.masterProduct.masterCode[7] !== '0' && item.weight !== null;
	    }
	  }, {
	    key: 'addItemToSubscription',
	    value: function addItemToSubscription(form) {
	      if (form.$invalid) {
	        return;
	      }
	      // console.log(this.selectedItem);
	      this.$auth.addToSubscriptionCart(this.selectedItem, this.quantity);
	      var subScribedInfo = this.$auth.getSubscribedInfo();
	      this.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });
	    }
	  }, {
	    key: 'goToSubscriptionDetail',
	    value: function goToSubscriptionDetail() {
	      var subScribedInfo = this.$auth.getSubscribedInfo();
	      if (subScribedInfo) {
	        this.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });
	      }
	    }
	  }, {
	    key: 'checkForGuestCart',
	    value: function checkForGuestCart() {
	      var guestCart = this.$auth.getGuestCart();
	      // console.log('Guest Cart ', guestCart);
	      // console.log('gc',guestCart);
	      if (guestCart && this.$auth.isLoggedIn()) {
	        this.addToCart(guestCart.quantity, guestCart);
	        this.$auth.doGuestLogout();
	      }
	    }
	  }, {
	    key: 'canUserJoin',
	    value: function canUserJoin() {
	      return !(this.isDscMember() || this.isDscButExpired());
	    }
	  }, {
	    key: 'goToSavingsClub',
	    value: function goToSavingsClub() {
	      this.$state.go('savings-club', { 'storeName': this.$auth.getGuestStoreDetail().storeName });
	    }
	  }, {
	    key: 'chooseStore',
	    value: function chooseStore() {
	      // console.log('store');
	    }
	  }, {
	    key: 'confirmChangeStore',
	    value: function confirmChangeStore(storeId, store) {
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.storeId = storeId;
	      $ctrl.store = store;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<div class="password-container margin-ten">' + '<input class="form-control" type="password" id="passwordIdDetail" ng-model="password" placeholder="Enter Password">' + '<i class="far fa-eye-slash" ng-click="togglePassword(\'passwordIdDetail\',\'togglePasswordDetail\')" id="togglePasswordDetail"\n                style="cursor: pointer;"></i></div>' + '<h5 class="font-weight-bold">Please enter your password to confirm the changing of your store</h5>' + '<p class="font-weight-bold" style="font-size:smaller">Please Note: You are changing your active home store. All WBU stores are locally owned and operated, and Daily Savings Club memberships are only valid at the store where purchased.  You may purchase a new DSC membership at your new home store. Club discounts, points balance, and Bird Bucks will be displayed for your active store if applicable. You may switch back to your original home store at any time and all eligible points, discounts, and Bird Bucks will be available.</p>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-disabled="!password" ng-click="ok()">OK</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Go Back</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', 'authService', '$stateParams', '$window', function ($scope, $uibModalInstance, $auth, $stateParams, $window) {
	
	          $scope.togglePassword = function (passwordId, toggleId) {
	            $ctrl.$auth.togglePassword(passwordId, toggleId);
	          };
	
	          $scope.ok = function () {
	            // console.log($scope.password,  $ctrl.storeId);
	
	            var data = {
	              "newStoreId": $ctrl.storeId,
	              "password": $scope.password
	
	            };
	            $auth.changeStore(data).then(function (data) {
	              // console.log(data);
	              if (data.status == 200) {
	                $ctrl.toaster.pop('success', data.statusText);
	                $ctrl.$timeout(function () {
	                  $stateParams.storeName = $ctrl.store;
	                  $window.location.href = '/' + $stateParams.storeName + '/' + $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
	                  // location.reload(); 
	                }, 1500);
	              } else {
	                $ctrl.toaster.pop('success', data.statusText);
	              }
	              // 
	            }).catch(function (err) {
	              $ctrl.toaster.pop('success', err.data.message);
	            });
	
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showLoginPopUp',
	    value: function showLoginPopUp() {
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" > {{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          this.$state = $state;
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	          NgMap.getMap().then(function (map) {
	            // console.log('map', map);
	            $scope.map = map;
	          });
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	            // console.log('storeObj', storeObj);
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	
	            };
	            if ($ctrl.storeName == null || $ctrl.storeName == '' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	              data.showRedirectStores = true;
	            }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              // console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            if ($ctrl.storeName == null || $ctrl.storeName == '' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	              data.showRedirectStores = true;
	            }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              // console.log(success.data);
	              // this.test();
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	          $scope.selectStore = function (index, store, item) {
	            $scope.showStoreInfo(item, index, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.long = store.lng;
	          };
	
	          // InfoWindow fix for googlemap
	          $scope.changeStyle = function () {
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                      }
	                    }
	                  }
	                } catch (e) {
	                  // console.log("Some Error");
	                }
	              }
	            } else {
	                // console.log("Else part :");
	              }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToProductPage = function (store, item) {
	            $rootScope.selectedStoreId = store.id;
	            $rootScope.$emit('storeSelected');
	            $uibModalInstance.close();
	          };
	          $scope.goToSignUp = function (store, item) {
	            $rootScope.selectedStoreId = store.id;
	            $rootScope.selectedStore = item;
	            $rootScope.$emit('storeSelected');
	            // $ctrl.confirmChangeStore(store.id);
	            // $uibModalInstance.close();
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'openStoreSelector',
	    value: function openStoreSelector() {
	
	      if (this.$auth.isLoggedIn()) {
	        this.showLoginPopUp();
	        return;
	      }
	
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"   ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div id="searchResults" ng-if="stores.length > 0" style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore(store, $index)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          this.$state = $state;
	
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	
	          NgMap.getMap().then(function (map) {
	            // console.log('map', map);
	            $scope.map = map;
	          });
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	            // console.log('storeObj', storeObj);
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	            };
	            if ($ctrl.storeName == null || $ctrl.storeName == '' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	              data.showRedirectStores = true;
	            }
	
	            $scope.stores = [];
	            var stores = $auth.getStoresbyZipcode(data);
	
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              // console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            if ($ctrl.storeName == null || $ctrl.storeName == '' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	              data.showRedirectStores = true;
	            }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              //  console.log(success.data);
	              var elmnt = document.getElementById("searchResults");
	              elmnt.scrollTo(0, 0);
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	          $scope.selectStore = function (store, index) {
	            var item = store.storeURLName;
	            $scope.showStoreInfo(item, index, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.selectedIndex = index + 1;
	            $scope.long = store.lng;
	          };
	
	          // InfoWindow fix for googlemap
	          $scope.changeStyle = function () {
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                      }
	                    }
	                  }
	                } catch (e) {
	                  // console.log("Some Error");
	                }
	              }
	            } else {
	                // console.log("Else part :");
	              }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToSignUp = function (store, item) {
	            // console.log($stateParams);
	            $stateParams.storeName = item;
	            $window.location.href = '/' + $stateParams.storeName + '/' + $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
	            // $uibModalInstance.close();
	            //  this.$state.go('signup', {
	            //    storeName: item
	            //  });
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'goToSubCategory',
	    value: function goToSubCategory(selectedItem) {
	      var item = selectedItem.masterProduct;
	      if (item && item != {}) {
	        var storeName = '';
	        if (this.$stateParams.storeName) {
	          storeName = this.$stateParams.storeName;
	        } else {
	          if (this.profile.store && this.profile.store.storeName) {
	            storeName = this.profile.store.storeURLName;
	          } else {
	            storeName = this.$auth.getGuestStoreDetail().storeName;
	          }
	        }
	        // let storeName =  false;
	        if (storeName) {
	          if (item.category.name === item.subCategories[0].name) {
	            this.$state.go('product', {
	              categoryId: item.category.prettyUrl,
	              subCategoryId: item.subCategories[0].prettyUrl,
	              storeName: storeName
	            });
	          } else {
	            // this.$state.go('sub-category', { categoryId: item.category.prettyUrl, storeName: storeName });
	            this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl });
	          }
	        } else {
	          this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl });
	        }
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isMobileDevice',
	    value: function isMobileDevice() {
	      return this.$auth.isMobileDevice();
	    }
	  }, {
	    key: 'goToGiftPage',
	    value: function goToGiftPage(store) {
	      this.$state.go('gift-card', { 'storeName': store });
	    }
	  }, {
	    key: 'isGiftCard',
	    value: function isGiftCard(masterProduct) {
	      var seriesNumber = masterProduct.masterCode.charAt(0);
	      var categoryId = masterProduct.category.id;
	      return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
	    }
	  }, {
	    key: 'goToProductPage',
	    value: function goToProductPage(item) {
	
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (this.isGiftCard(item.masterProduct)) {
	        this.goToGiftPage(storeName);
	        return;
	      }
	      // let storeName =  false;
	      if (storeName) {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.masterProduct.category.prettyUrl,
	          subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
	          productId: item.masterProduct.prettyUrl,
	          itemGroupNumber: item.masterProduct.itemGroupNumber,
	          storeName: storeName
	        });
	      } else {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.masterProduct.category.prettyUrl,
	          subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
	          productId: item.masterProduct.prettyUrl,
	          itemGroupNumber: item.masterProduct.itemGroupNumber
	        });
	      }
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isNotMobile',
	    value: function isNotMobile() {
	      return this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isIpadLandscape',
	    value: function isIpadLandscape() {
	      if (this.isIpad()) {
	        return this.$window.innerWidth > 1037;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'deliveryTypeValidation',
	    value: function deliveryTypeValidation() {
	      var _this8 = this;
	
	      var existingItem = this.$auth.isGuestLogin() ? this.$auth.getGuestCart() : this.cartDetail && this.cartDetail.cartItems ? this.cartDetail.cartItems : [];
	      if (existingItem && existingItem.length && this.selectedItem.deliveryType && this.selectedItem.deliveryType != 'All') {
	        var itemExist = existingItem.filter(function (element) {
	          return element.deliveryType == (_this8.selectedItem.deliveryType === 'InStore' ? 'DropShip' : 'InStore');
	        });
	        if (!this.$auth.isGuestLogin()) {
	          itemExist = existingItem.filter(function (element) {
	            return element.item.deliveryType == (_this8.selectedItem.deliveryType === 'InStore' ? 'DropShip' : 'InStore');
	          });
	        }
	        if (itemExist && itemExist.length) {
	          this.disableAddToCart = false;
	          this.isDeliveryError = 'Your cart contains some items that are ' + (this.selectedItem.deliveryType === 'InStore' ? 'delivery' : 'in-store/curbside pickup') + ' only. If you would like to add this item to your cart, please remove those items or complete a separate order.';
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'goToCart',
	    value: function goToCart() {
	      if (this.$auth.isGuestLogin()) {
	        this.$state.go('guestcart', { 'storeName': this.storeName });
	      } else {
	        this.$state.go('cart');
	      }
	    }
	  }, {
	    key: 'getMultipleImage',
	    value: function getMultipleImage(masterproduct) {
	      var _this9 = this;
	
	      this.$spinner.show('appSpinner');
	      console.log('item.masterProduct.id', masterproduct.id);
	      this.imageListArr[masterproduct.id] = [];
	      this.$order.getMultipleImage(masterproduct.id).then(function (success) {
	        _this9.imageListArr[masterproduct.id] = success.data;
	        console.log('imageList :', _this9.imageListArr);
	        console.log('this.selectedItem :', _this9.selectedItem);
	        _this9.imageListArr[masterproduct.id].forEach(function (item) {
	          if (item.masterCode === _this9.selectedItem.masterProduct.masterCode) {
	            _this9.showImagelist(masterproduct.id);
	          } else {
	            _this9.$spinner.hide('appSpinner');
	          }
	        });
	      });
	    }
	  }, {
	    key: 'showImagelist',
	    value: function showImagelist(id) {
	      var _this10 = this;
	
	      this.imageList = [];
	      this.videoList = [];
	      this.mediaListSize = 0;
	      this.imgVideoList = [];
	      this.imgVideoIpadList = [];
	      if (this.imageListArr[id].length > 0) {
	        this.imageListArr[id].forEach(function (item) {
	          _this10.mediaListSize = _this10.mediaListSize + 1;
	          if (item.fileType === 'IMAGE') {
	            if (item.isDefault === 1) {
	              _this10.imageList.unshift(item);
	              _this10.imgVideoList.unshift(item);
	              _this10.imgVideoIpadList.unshift(item);
	            } else {
	              _this10.imageList.push(item);
	              _this10.imgVideoList.push(item);
	              _this10.imgVideoIpadList.push(item);
	            }
	          }
	          if (item.fileType === 'VEDIO') {
	            if (item.isDefault === 1) {
	              _this10.videoList.unshift(item);
	              _this10.imgVideoList.unshift(item);
	              _this10.imgVideoIpadList.unshift(item);
	            } else {
	              _this10.videoList.push(item);
	              _this10.imgVideoList.push(item);
	              _this10.imgVideoIpadList.push(item);
	            }
	          }
	        });
	        this.slideIndex = 1;
	        setTimeout(function () {
	          if (document.getElementById('dotimage')) {
	            document.getElementById('dotimage').classList.remove('hide');
	          }
	          _this10.showSlides(1);
	          if (_this10.isIpad()) {
	            _this10.showSlidesIpad(1);
	          }
	        }, 200);
	        this.$spinner.hide('appSpinner');
	      }
	    }
	  }, {
	    key: 'showSlides',
	    value: function showSlides(n) {
	      var slides = document.getElementsByClassName("mySlides");
	      var dots = document.getElementsByClassName("dot");
	      // console.log('slides:', slides);
	      if (n > slides.length) {
	        this.slideIndex = 1;
	      }
	      if (n < 1) {
	        this.slideIndex = slides.length;
	      }
	      for (var i = 0; i < slides.length; i++) {
	        // console.log('i:', i);
	        slides[i].style.display = "none";
	      }
	      for (i = 0; i < dots.length; i++) {
	        dots[i].className = dots[i].className.replace(" active", "");
	      }
	      console.log('n:', n);
	      if (slides[this.slideIndex - 1]) {
	        slides[this.slideIndex - 1].style.display = "contents";
	      }
	      if (dots[this.slideIndex - 1]) {
	        dots[this.slideIndex - 1].className += " active";
	      }
	    }
	  }, {
	    key: 'showSlidesIpad',
	    value: function showSlidesIpad(n) {
	      var slides = document.getElementsByClassName("mySlidesIpad");
	      console.log('slides:', slides.length);
	      if (n > slides.length) {
	        this.slideIndexIpad = 1;
	      }
	      if (n < 1) {
	        this.slideIndexIpad = slides.length;
	      }
	      for (var i = 0; i < slides.length; i++) {
	        // console.log('i:', i);
	        slides[i].style.display = "none";
	      }
	      console.log('n:', n);
	      if (slides[this.slideIndexIpad - 1]) {
	        slides[this.slideIndexIpad - 1].style.display = "contents";
	      }
	    }
	  }, {
	    key: 'plusSlides',
	    value: function plusSlides(n) {
	      for (var i = 0; i < this.imgVideoList.length; i++) {
	        if (document.getElementById("mobileVideo" + i)) {
	          document.getElementById("mobileVideo" + i).pause();
	          document.getElementById("mobileVideo" + i).currentTime = 0;
	        }
	        if (document.getElementById("ipadVideo" + i)) {
	          document.getElementById("ipadVideo" + i).pause();
	          document.getElementById("ipadVideo" + i).currentTime = 0;
	        }
	      }
	      this.showSlides(this.slideIndex += n);
	    }
	  }, {
	    key: 'plusSlidesIpad',
	    value: function plusSlidesIpad(n) {
	      for (var i = 0; i < this.imgVideoIpadList.length; i++) {
	        if (document.getElementById("ipadVideo" + i)) {
	          document.getElementById("ipadVideo" + i).pause();
	          document.getElementById("ipadVideo" + i).currentTime = 0;
	        }
	      }
	      this.showSlidesIpad(this.slideIndexIpad += n);
	    }
	  }, {
	    key: 'currentSlide',
	    value: function currentSlide(n) {
	      this.showSlides(this.slideIndex = n);
	    }
	  }, {
	    key: 'scrollToBottom',
	    value: function scrollToBottom(id) {
	      var element = document.getElementById(id);
	      // console.log("element.scrollHeight",element.scrollHeight);
	
	      if (this.mediaListSize > this.multiImageViewPortSlideSize && this.currentImagePosition < this.mediaListSize) {
	        if (this.currentImagePosition === 0) {
	          this.currentImagePosition = this.multiImageViewPortSlideSize + 1;
	        } else {
	          this.currentImagePosition = this.currentImagePosition + 1;
	        }
	        // 60 is height of image view show in multi image view port
	        this.currentImagePositionHeight = this.currentImagePositionHeight + 60;
	      }
	      // console.log("this.currentImagePositionHeight ",this.currentImagePositionHeight );
	      element.scrollTop = this.currentImagePositionHeight;
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop(id) {
	      var element = document.getElementById(id);
	      // console.log("element",element);
	      if (this.currentImagePosition > this.multiImageViewPortSlideSize) {
	        this.currentImagePosition = this.currentImagePosition - 1;
	        // 60 is height of image view show in multi image view port
	        this.currentImagePositionHeight = this.currentImagePositionHeight - 60;
	      }
	      // console.log("this.currentImagePositionHeight ",this.currentImagePositionHeight );
	      element.scrollTop = this.currentImagePositionHeight;
	    }
	  }, {
	    key: 'showImgPopup',
	    value: function showImgPopup(img) {
	      var _this11 = this;
	
	      var modal = document.getElementById("myModal");
	      modal.style.display = "block";
	      console.log('this.selectedItem :', this.selectedItem);
	      this.selectedImgZoom = img;
	      this.isShowImage = false;
	      this.isShowVideo = true;
	      this.imageListArr.forEach(function (item) {
	        item.forEach(function (data) {
	          console.log('item :', item);
	          if (data.masterCode === _this11.selectedImgZoom.masterCode && data.fileType === 'VEDIO') {
	            _this11.showVideolistZoom(_this11.selectedItem.masterProduct.id);
	          } else {
	            _this11.$spinner.hide('appSpinner');
	          }
	        });
	      });
	    }
	  }, {
	    key: 'showImagelistZoom',
	    value: function showImagelistZoom(id) {
	      var _this12 = this;
	
	      this.imageListZoom = [];
	      if (this.imageListArr[id].length > 0) {
	        this.imageListArr[id].forEach(function (item) {
	          if (item.fileType === 'IMAGE') {
	            if (item.isDefault === 1) {
	              _this12.imageListZoom.unshift(item);
	            } else {
	              _this12.imageListZoom.push(item);
	            }
	          }
	        });
	        this.slideIndexZoom = 1;
	        setTimeout(function () {
	          _this12.showSlidesZoom(1);
	        }, 200);
	        this.$spinner.hide('appSpinner');
	      }
	    }
	  }, {
	    key: 'showVideolistZoom',
	    value: function showVideolistZoom(id) {
	      var _this13 = this;
	
	      this.videoListZoom = [];
	      if (this.imageListArr[id].length > 0) {
	        this.imageListArr[id].forEach(function (item) {
	          if (item.fileType === 'VEDIO') {
	            if (item.isDefault === 1) {
	              _this13.videoListZoom.unshift(item);
	            } else {
	              _this13.videoListZoom.push(item);
	            }
	          }
	        });
	        this.slideIndexZoom = 1;
	        setTimeout(function () {
	          _this13.showSlidesZoom(1);
	        }, 200);
	        this.$spinner.hide('appSpinner');
	      }
	    }
	  }, {
	    key: 'showSlidesZoom',
	    value: function showSlidesZoom(n) {
	      var slides = document.getElementsByClassName("mySlides1");
	      var dots = document.getElementsByClassName("dot1");
	      console.log('slides:', slides);
	      if (n > slides.length) {
	        this.slideIndexZoom = 1;
	      }
	      if (n < 1) {
	        this.slideIndexZoom = slides.length;
	      }
	      for (var i = 0; i < slides.length; i++) {
	        // console.log('i:', i);
	        slides[i].style.display = "none";
	      }
	      for (i = 0; i < dots.length; i++) {
	        dots[i].className = dots[i].className.replace(" active", "");
	      }
	      console.log('n:', n);
	      if (slides[this.slideIndexZoom - 1]) {
	        slides[this.slideIndexZoom - 1].style.display = "contents";
	      }
	      if (dots[this.slideIndexZoom - 1]) {
	        dots[this.slideIndexZoom - 1].className += " active";
	      }
	    }
	  }, {
	    key: 'plusSlidesZoom',
	    value: function plusSlidesZoom(n) {
	      this.showSlidesZoom(this.slideIndexZoom += n);
	    }
	  }, {
	    key: 'currentSlideZoom',
	    value: function currentSlideZoom(n) {
	      for (var i = 0; i < this.videoListZoom.length; i++) {
	        if (i != n - 1 && document.getElementById("itemVideo" + i)) {
	          document.getElementById("itemVideo" + i).pause();
	          document.getElementById("itemVideo" + i).currentTime = 0;
	        }
	      }
	      this.showSlidesZoom(this.slideIndexZoom = n);
	    }
	  }, {
	    key: 'closepopup',
	    value: function closepopup() {
	      var modal = document.getElementById("myModal");
	      for (var i = 0; i < this.videoListZoom.length; i++) {
	        if (document.getElementById("itemVideo" + i)) {
	          document.getElementById("itemVideo" + i).pause();
	          document.getElementById("itemVideo" + i).currentTime = 0;
	        }
	      }
	      modal.style.display = "none";
	    }
	  }, {
	    key: 'showImage',
	    value: function showImage() {
	      var _this14 = this;
	
	      this.isShowImage = true;
	      this.isShowVideo = false;
	      this.imageListArr.forEach(function (item) {
	        item.forEach(function (data) {
	          console.log('item :', item);
	          if (data.masterCode === _this14.selectedImgZoom.masterCode) {
	            _this14.showImagelistZoom(_this14.selectedItem.masterProduct.id);
	          } else {
	            _this14.$spinner.hide('appSpinner');
	          }
	        });
	      });
	    }
	  }, {
	    key: 'showVideo',
	    value: function showVideo() {
	      var _this15 = this;
	
	      this.isShowImage = false;
	      this.isShowVideo = true;
	      this.imageListArr.forEach(function (item) {
	        item.forEach(function (data) {
	          console.log('item :', item);
	          if (data.masterCode === _this15.selectedImgZoom.masterCode && data.fileType === 'VEDIO') {
	            _this15.showVideolistZoom(_this15.selectedItem.masterProduct.id);
	          } else {
	            _this15.$spinner.hide('appSpinner');
	          }
	        });
	      });
	    }
	  }, {
	    key: 'showHideDescription',
	    value: function showHideDescription() {
	      this.showDescription = !this.showDescription;
	      this.showSpecifications = false;
	      this.showWarranty = false;
	      this.showMaterials = false;
	      this.showAllergen = false;
	      this.showIngredients = false;
	    }
	  }, {
	    key: 'showHideIngredients',
	    value: function showHideIngredients() {
	      this.showIngredients = !this.showIngredients;
	      this.showDescription = false;
	      this.showSpecifications = false;
	      this.showWarranty = false;
	      this.showMaterials = false;
	      this.showAllergen = false;
	    }
	  }, {
	    key: 'showHideSpecifications',
	    value: function showHideSpecifications() {
	      this.showSpecifications = !this.showSpecifications;
	      this.showDescription = false;
	      this.showWarranty = false;
	      this.showMaterials = false;
	      this.showAllergen = false;
	      this.showIngredients = false;
	    }
	  }, {
	    key: 'showHideWarranty',
	    value: function showHideWarranty() {
	      this.showWarranty = !this.showWarranty;
	      this.showDescription = false;
	      this.showSpecifications = false;
	      this.showMaterials = false;
	      this.showAllergen = false;
	      this.showIngredients = false;
	    }
	  }, {
	    key: 'showHideMaterials',
	    value: function showHideMaterials() {
	      this.showMaterials = !this.showMaterials;
	      this.showAllergen = false;
	      this.showDescription = false;
	      this.showSpecifications = false;
	      this.showWarranty = false;
	      this.showIngredients = false;
	    }
	  }, {
	    key: 'showHideAllergen',
	    value: function showHideAllergen() {
	      this.showAllergen = !this.showAllergen;
	      this.showMaterials = false;
	      this.showDescription = false;
	      this.showSpecifications = false;
	      this.showWarranty = false;
	      this.showIngredients = false;
	    }
	  }, {
	    key: 'showAddtoCartpopup',
	    value: function showAddtoCartpopup() {
	      this.isAddToCartPopUpShown = true;
	      var modal = document.getElementById("addtocartModal");
	      modal.style.display = "block";
	    }
	  }, {
	    key: 'closeAddtoCartpopup',
	    value: function closeAddtoCartpopup() {
	      this.isAddToCartPopUpShown = false;
	      var modal = document.getElementById("addtocartModal");
	      modal.style.display = "none";
	    }
	  }, {
	    key: 'showAddtoCartMobilepopup',
	    value: function showAddtoCartMobilepopup() {
	      var modal = document.getElementById("addtocartMobileModal");
	      modal.style.display = "block";
	    }
	  }, {
	    key: 'closeAddtoCartMobilepopup',
	    value: function closeAddtoCartMobilepopup() {
	      var modal = document.getElementById("addtocartMobileModal");
	      modal.style.display = "none";
	    }
	  }, {
	    key: 'updateItemInCart',
	    value: function updateItemInCart(quantityAction, quantity, item) {
	
	      var ctrl = this;
	      ctrl.itemToBePassed = item;
	      // For Guest : Adding / Removing Items in guest cart
	      if (this.$auth.isGuestLogin()) {
	        var cartList = ctrl.$auth.getGuestCart();
	        if (cartList && cartList.length) {
	          var index = cartList.findIndex(function (data) {
	            return data.itemId === item.id;
	          });
	          if (~index) {
	            if (quantityAction == ctrl.quantityAction.AddingQuantity) {
	              ctrl.quantityToBeAdded = cartList[index].quantity + 1;
	            } else if (quantityAction == ctrl.quantityAction.ReducingQuantity) {
	              ctrl.quantityToBeAdded = cartList[index].quantity - 1;
	            }
	            cartList[index].quantity = ctrl.quantityToBeAdded;
	          } else {
	            // cartList.push(cart);
	            console.log("Check what's need to be done in here");
	          }
	        }
	        ctrl.$auth.updatetoGuestCart(cartList);
	      } else {
	        // For Logged in user : Adding / Removing Items in guest cart
	        if (quantityAction == ctrl.quantityAction.AddingQuantity) {
	          ctrl.quantityToBeAdded = quantity + 1;
	        } else if (quantityAction == ctrl.quantityAction.ReducingQuantity) {
	          ctrl.quantityToBeAdded = quantity - 1;
	        }
	        ctrl.$order.updateItemInCart(ctrl.quantityToBeAdded, item.id, item.masterProduct.subCategories[0].id).then(function () {
	          ctrl.isItemAdded = true;
	          ctrl.$auth.getUserProfile();
	        }, function (error) {
	          // If no item in cart (error code = 637), then add item to cart
	          if (error.data.errorCode == 637) {
	            if (ctrl.$auth.isGuestLogin()) {
	              var cart = null;
	              cart = {
	                'quantity': ctrl.quantity,
	                'itemId': ctrl.selectedItem.id,
	                'categoryId': ctrl.selectedItem.masterProduct.category.id,
	                'subCategoryId': ctrl.selectedItem.masterProduct.subCategories[0].id,
	                'masterProductId': ctrl.selectedItem.masterProduct.id,
	                'deliveryType': ctrl.selectedItem.deliveryType
	              };
	              ctrl.$auth.addtoGuestCart(cart);
	            } else {
	              var item;
	              item = {
	                'itemId': ctrl.selectedItem.id,
	                'subCategoryId': ctrl.selectedItem.masterProduct.subCategories[0].id
	              };
	              ctrl.addToCart(ctrl.quantity, item);
	            }
	          } else if (error.data.errorCode == 692) {
	            ctrl.toaster.pop('success', error.data.message);
	          } else {
	            ctrl.toaster.pop('success', 'Item already exists in cart. Click on cart icon on top right.');
	          }
	        });
	        this.$auth.getUserProfile();
	      }
	    }
	  }, {
	    key: 'getDSCDetails',
	    value: function getDSCDetails(isDscMember) {
	      var _this16 = this;
	
	      this.$order.getDSCDetails().then(function (success) {
	        if (success.data) {
	          _this16.dscDetails = success.data.filter(function (element) {
	            return element.dscType == 'dsc';
	          })[0];
	          _this16.nondscDetails = success.data.filter(function (element) {
	            return element.dscType == 'nondsc';
	          })[0];
	          if (isDscMember) {
	
	            if (_this16.dscDetails) {
	              _this16.dscCard = _this16.dscDetails.dscImage;
	              _this16.dscCardMobile = _this16.dscDetails.dscImageMobile;
	              _this16.dscAltTag = _this16.dscDetails.alt;
	            } else {
	              _this16.dscCard = _this16.dscCardDefault;
	              _this16.dscCardMobile = _this16.dscCardMobileDefault;
	            }
	          } else {
	            if (_this16.nondscDetails) {
	              _this16.dscCard = _this16.nondscDetails.dscImage;
	              _this16.dscCardMobile = _this16.nondscDetails.dscImageMobile;
	              _this16.dscAltTag = _this16.nondscDetails.alt;
	              _this16.dscLink = _this16.nondscDetails.link;
	            } else {
	              _this16.dscCard = _this16.dscCardDefault;
	              _this16.dscCardMobile = _this16.dscCardMobileDefault;
	            }
	          }
	          console.log(_this16.dscDetails);
	          console.log(_this16.nondscDetails);
	        }
	      });
	    }
	  }, {
	    key: 'getDSCImage',
	    value: function getDSCImage(isMobileDevice) {
	      if (this.isDscMember()) {
	        if (isMobileDevice) {
	          if (this.NonDSCImgMobile) {
	            return this.NonDSCImgMobile;
	          } else {
	            return _productPromoMobile2.default;
	          }
	        } else {
	          if (this.NonDSCImgDesktop) {
	            return this.NonDSCImgDesktop;
	          } else {
	            return _DSCCard2.default;
	          }
	        }
	      } else {
	        if (isMobileDevice) {
	          if (this.DSCImgMobile) {
	            return this.DSCImgMobile;
	          } else {
	            return _productPromoMobile2.default;
	          }
	        } else {
	          if (this.DSCImgDesktop) {
	            return this.DSCImgDesktop;
	          } else {
	            return _DSCCard2.default;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'setDimension',
	    value: function setDimension(selectedItem) {
	      var customSpec = "";
	      if (selectedItem && selectedItem.masterProduct.dimensions) {
	        customSpec = "Dimensions : " + selectedItem.masterProduct.dimensions;
	        if (selectedItem.masterProduct.specifications) {
	          customSpec = customSpec + "<br>" + selectedItem.masterProduct.specifications;
	        }
	      } else {
	        if (selectedItem.masterProduct.specifications) {
	          customSpec = selectedItem.masterProduct.specifications;
	        }
	      }
	      this.customSpecification = customSpec;
	      return selectedItem;
	    }
	  }, {
	    key: 'goToDsc',
	    value: function goToDsc() {
	      if (!this.isDscMember()) {
	        if (this.dscLink) {
	          this.$window.location.href = this.dscLink;
	        } else {
	          this.$state.go('savings-club');
	        }
	      } else {
	        // this.$window.location.href = this.dscLink;
	      }
	    }
	  }, {
	    key: 'updateUserAction',
	    value: function updateUserAction(userAction) {
	      this.$order.updateUserAction(userAction);
	    }
	  }, {
	    key: 'saveRemainder',
	    value: function saveRemainder(remainderType) {
	      var _this17 = this;
	
	      var $ctrl = this;
	      var remainder = {};
	      remainder.email = this.emailToRemainder;
	      remainder.isRemainded = false;
	      remainder.masterProduct = this.selectedItem.masterProduct;
	      remainder.store = {};
	      remainder.store.storeCode = this.selectedItem.store.storeCode;
	      remainder.type = remainderType;
	      remainder.isGuest = this.profile == null || this.profile.userId == null ? true : false;
	      this.$order.saveRemainder(remainderType, remainder).then(function (success) {
	        if (success.data) {
	          _this17.isRemainderSetAlready = true;
	          if (success.data && success.data.isAddedAlready) {
	            _this17.outOfStockRemainderText = _this17.OutOfStockRemainderText.exist;
	          } else {
	            _this17.outOfStockRemainderText = _this17.OutOfStockRemainderText.new;
	          }
	          // let outOfStockRemainders = sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS') ? JSON.parse(sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS')) : null;
	          var outOfStockRemainders = sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS') ? JSON.parse(sessionStorage.getItem('OUT_OF_STOCK_REMAINDERS')) : null;
	          if (outOfStockRemainders != null) {
	            outOfStockRemainders[$ctrl.selectedItem.id] = $ctrl.emailToRemainder;
	            sessionStorage.setItem('OUT_OF_STOCK_REMAINDERS', JSON.stringify(outOfStockRemainders));
	          } else {
	            outOfStockRemainders = {};
	            outOfStockRemainders[$ctrl.selectedItem.id] = $ctrl.emailToRemainder;
	            sessionStorage.setItem('OUT_OF_STOCK_REMAINDERS', JSON.stringify(outOfStockRemainders));
	          }
	        }
	      });
	    }
	  }]);
	
	  return ProductDetail;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$state', '$stateParams', 'authService', 'orderService', 'orderActions', 'spinnerService', 'toaster', '$uibModal', '$timeout', 'ngMeta', '$location', '$window', 'APP', '$sce'], _temp)) || _class);
	exports.default = ProductDetail;

/***/ },
/* 184 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAY5JREFUeJzt0jtuFEEYhdEbk3g5MAvA9pa9A5ZiZ0Bgk0HA/BLC9nj6XdV9jlRhq6v03QQAAAAAAAAAAAAAAAAAAAAAAAAAAGBrN+fDAd0k+XY+RnAwFf/3+RjBgfwf3wgO5L34RnAAH8U3gh27Nr4R7NDQ+EawI2PjG8EOTI1vBB2bK74RdGju+EbQkaXiG0EHlo5vBA1bK74RNGhK/Jckv0Z+awQNmBr/Lsl9jKBLc8QvRtCZOeMXI+jEEvGLETRuyfjFCBo1Nf7tgH8ZQWPWjF+MoBFbxC9GsLEt4xcj2EgL8YsRrKyl+MUIVtJi/GIEC5sa/+sKdzSChfQQvxjBzHqKX4xgJj3GL0Ywg4f0Gb9MGcHDBvdtzuckP9Jn/DJmBN/z9+1k2Aie01b8MmQE4r/hSz4eQavxyzUjEP+CSyNoPX65NALxr3DK6xH0Er+8NQLxBzgl+Zk+45d/RyD+CKckT+kzfrlP8hjxR/u09QVmsIc3AAAAAAAAAAAAAAAAAAAAAAAAAAAAALCEPyKGUOBHCyBTAAAAAElFTkSuQmCC"

/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAfJJREFUeJzt0k1K3lAYhuF3INTV6LzgUorWhbV7KHQgdFftWB3Yg/JJyN9Jzt91QSCTwEueOwIAAAAAAAAAAAAAAAAAAAAAAAAAgC7dRsSX0kd07DoibkofMeUuIv5FxK8QwRGuI+J3RPyNiK+Fb/kkjf/y/xFBXmn89H+riuByfBHkdTl+VRFMjS+CPKbGryKCufFFsM/c+EUjWDq+CLZZOn6RCNaOL4J11o5/egQPEfG84UARzNs6/ku8bfLtrEMfQwS57R3//uyDRZBPc+MnItiv2fETEWzX/PiJCNbrZvxEBMt1N34ignndjp+IYFr34yci+GyY8RMRvBtu/EQEA4+fjBzB8OMnI0Zg/AsjRWD8CSNEYPwZPUdg/IV6jMD4K/UUgfE36iEC4+/UcgTGz6TFCIyfWUsRGP8gLURg/IPVHIHxT1JjBMY/WU0RGL+QGiIwfmElIzB+JUpEYPzKnBmB8St1RgTGr9yRERi/EUdEYPzG5IzA+I3KEYHxG7cngqeI+LPxW+NXZE8Exu/EWREYv2JHR2D8BhwVgfEbkjsC4zcoVwTGb9jeCIzfga0RGL8jayMwfoeWRmD8js1FYPwBTEVg/IFcRmD8AaUIniPie+FbirkqfUBBPz68/yx2BQAAAAAAAAAAAAAAAACs8woXQKWr9ZFb6wAAAABJRU5ErkJggg=="

/***/ },
/* 186 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6CAYAAACI7Fo9AAAACXBIWXMAAAsSAAALEgHS3X78AAAI4UlEQVR4Ae3dXYhU5xnA8ePumLqu0Rg/U2u2JiJNbZuSkBRSqiH246IsFRoSelMDhURCL2oLzU0pIeQ6Df2U0ot61RQClUgvhEoRkrSUhsa2pk1QozWmju46WbOzs3VXt5xlNJt1d3Vn1p3zzvP7wYDKgmee499z5sw7cxaMjY1lM9m2c9/HsyzbXn9snfGHgfl0MMuyvfnjwO7e4zP9vdOGXg/86SzLdth1UHh78l6nC37K0Lft3PedLMt+ZN9CcnYd2N37/OSNvir0bTv3/dpRHJK258Du3scmPoGOib8RObSFHfWWr7gSev10XeTQHnbUmx43fupev/D2th0MbWdDfoHu8hH9afsX2tJ42wseeuIlR3Nobxs66gthgPa1XejQ/sZDt6wV2tvWDjsY2p/QIQChQwBChwCEDgEIHQIQOgQgdAhA6BCA0CEAoUMAQocAhA4BCB0CEDoEIHQIQOgQgNAhAKFDAEKHAIQOAQgdAhA6BCB0CEDoEEDJTiZlG9cvzbq7Fjb9DI6+cz4bHBpp238LQqfw8pg39dxSu2Pd0jP33rWq1N1VKq1YtmjNjd7u/oHh8vCFi8OXf3/4aKVUrY2M5r8+dur86lNnql1ZIv9JCJ3CycO+b/PqygN3rx3ctH7ZylKpIw8qf/TM57ZO/s9k3aruGX/+u8+9mh16q/9Gb1ZDhE4h5HFvf3BD35Z7buvs7lq4PMuyyw/mgNBpmSWLF2a9W3oqj355Y8fNixcuy7Jspb1xYwidebd2xeLsyUc2lz+3efXSUqnDUXseCJ15kx/Bv7/js+XP3702f+17wy+m8QGhMy8e+dKdw9/62ifGSqUOgbeA0Lmh8otszz55f9+q5V1ef7eQ0Llh8qP4E1//5CIX2VpP6My5/LX4Mzvv67t70wqBF4TQmVNO1YtJ6MyZPPKfPfWFWqnUIfKC8ek15sSEyLtMtHiETtNEXnxCpyn5KjeRF5/QaVh+df257z1wTuTFJ3Qalr+FtubWrltNsPiETkPyxTDeJ0+H0Jm1/OJbfcUbiRA6s5YviDG1tAidWclP2a16S4/QuW75Vfb8o6Ymlh6hc92+8ZWNA95KS5PQuS75wpiHv3hH81+gTksInevSu6VnoNTZsdi00iR0ril/bf7wtjtuMql0CZ1r2nLPbdayJ07oXNM3v7qpakppEzozylfBed88fUJnRvltkkwofUJnRvm90EwofUJnWvV7j7tlUhsQOtPKb11sOu1B6Exr2/0fu2A67UHoTGv96u6lptMefK87U8pfn7fDIplTZ6snDh+tlP5z+v3FbxyrXLneUK2NZEdOnm/txs0joTOlTT231LIsSy700dFLtdf+3df3+5dPrH/l9dP5H/W0fqtaT+hM6dMbV5zLsmxdStN5Yf+Rgd/sP7JscGhkfQE2p1CEzpQ237l8NJXJnK3U+n7w87+sPHLy/LICbE4hCZ0prVnetTqFyZTP1c49/uzBlYNDIwXYmuJy1Z0ppXAhbmT00vDjzx68VeTXJnSukl9xT8FTP/7zIpFfH6Fzle6u4n9j1Nvvvl8+9FZ/AbYkDUInST954R9r7LnrJ3Su8sBn1paLPJVqbaTiaD47QucqnZ0Lhos8lVcOlYcKsBlJETrJefn1/ya1kKcIhE5yyv0O6LMldJIT6cMoc0XoJCX/0Io9NntCJynlSu2MPTZ7QocAhA4BCB0CEDoEIHQIQOgQgNAhAKFDAEKHAIQOAQgdAhA6BCB0CEDoEIDQIQChQwBChwCEDgEIHQIQOgQgdAhA6BCA0CEAoUMAQocAhA4BLHjoiZfG7Ohi+dUPHyzftLCjZfcoX37zR5YsXlRaUcTZXLw0Vj3dP9RXgE35kGd++deeIt/8sVSAbWCSDR+9eY2ZTK2zY0H3ulXd3UXbrtP9xb73o1N3mAODQyOFHqPQoUn9A8Plos9Q6NCkam10tOgzFDo06bV/nRU6tLuLF8cWFf0pCh2a9OrfTxf+XRKhQwBChyYdequ/8CMUOgQgdGjCqbPVEynMT+jQhIHBC0k0JHRowpvH37uUwvyEDk3oHxhemsL8hA5NeONYZXkK8xM6NKFaK/an1i4TOjShyF82MZHQoUGjo5eK/W0TEwgdGlSu1M6kMjuhQ4PeKVeT6Ufo0KB3z1aTeA89Ezo07tip86tTGZ/QoUGnzlS7Upmd0KFB5YJ/xfNEQocGne4fSmZ0QocGVGsjlZTmJnRowHuDF9JYElcndGjA4aOVpG5nJnRoQLU2Uvjvcp9I6NCAv73Z15PS3IQODSj6TRUnEzo04Og7SV2LEzo0whEd2lwKt0meTOgwSyncJnkyocMspXCb5MmEDrOUwm2SJ0tqdU8UL/7hWLmzc8Fwq57uvXetKt2+dsm6Io57aHi0f/+fTg62cht+98e3k3oPPRN6Mf3ixcMtvd/2tx/91Inb1y4p5Gwq7/9v8Ke//WdyobWaU3cIQOgQgNAhAKFDAEKHAIQOAQgdAhA6BCB0CEDoEIDQIQChQwBChwCEDgEIHQIQOgQgdAhA6BCA0CEAoUMAQocAhA4BCB0CEDoEIHQIQOgQgNAhAKFDAEKHAIQOAQgdAhA6BCB0CEDoEIDQIQChQwBChwCEDgEIHQIQOgQgdAhA6BCA0CEAoUMAQocAhA4BCB0CEDoEIHQIQOgQgNAhAKFDAEKHAIQOAQgdAhA6BCB0CEDoEIDQIQChQwBChwCEDgEIHQIQOgQgdAhA6BCA0CEAoUMAQocAhA4BCB0CEDoEIHQIQOgQgNAhAKFDAEKHAIQOAQgdAhA6BCB0CEDoEIDQIQChQwB56AftaGhrB/PQ99rH0Nb2Ch3a396OA7t7j2dZtsfOhra0J2/88sW4p+1jaEvjbY+HXj+q77Kfoa3sqrf9wdtrB3b3Pu8UHtrGnnrT4z70PvqB3b2PiR2St6fe8hVXLZip/4DTeEjTrsmRZ9OtjKsf8jc4ukMy8lY3TDxdn6g03bOov4h/bNvOfflVu+31x1b7HQojX9War4PZe/mi25SyLPs/yaXii9gL+38AAAAASUVORK5CYII="

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\"\r\n    ng-if=\"!productDetail.forSubscription\">\r\n    <a class=\"nav\" ng-click=\"productDetail.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{productDetail.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\"\r\n      ng-if=\"productDetail.detail.name && productDetail.categoryName.name !== productDetail.subCategoryName.name\"\r\n      ui-sref=\"browse-sub-category({categoryId: productDetail.categoryName.prettyUrl})\">\r\n      {{productDetail.categoryName.name}}\r\n    </a>\r\n    <a class=\"nav\" ng-if=\"productDetail.detail.name\"\r\n      ui-sref=\"browse-product({subCategoryId: productDetail.subCategoryName.prettyUrl})\">\r\n      {{productDetail.subCategoryName.name}}\r\n    </a>\r\n    <span>{{productDetail.productNotFound ? 'Product Not Found' : productDetail.detail.name}}</span>\r\n  </nav>\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\"\r\n    ng-if=\"productDetail.forSubscription\">\r\n    <a class=\"nav\" ng-click=\"productDetail.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{productDetail.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"subscription\">\r\n      My Subscriptions\r\n    </a>\r\n    <a class=\"nav\" href ng-click=\"productDetail.goToSubscriptionDetail()\">\r\n      My Subscription Detail\r\n    </a>\r\n    <a class=\"nav\" href ui-sref=\"subscribable-products\">\r\n      List of Products\r\n    </a>\r\n    <span>{{productDetail.detail.name}}</span>\r\n  </nav>\r\n  <div ng-if=\"productDetail.productNotFound\" class=\"row m-x-1 p-a-1\">\r\n    <div class=\"col-md-12 p-x-0\">\r\n      <img src={{productDetail.oopsImage}} class=\"product-image img-fluid\" />\r\n    </div>\r\n    <div class=\"col-md-3 hidden-sm-down\"></div>\r\n    <div class=\"col-md-3 hidden-sm-down text-xs-center\"\r\n      ng-show=\"productDetail.storeName && productDetail.storeName != ''\" ng-if=\"!productDetail.forSubscription\">\r\n      <button ng-click=\"productDetail.goToSubCategory(productDetail.selectedItem)\" type=\"button\"\r\n        class=\"btn btn-lg btn-primary  btn-block btn-md-text ng-scope\">\r\n        Continue Shopping\r\n      </button>\r\n    </div>\r\n\r\n    <!-- <div class=\"col-md-3 hidden-sm-down text-xs-center\" ng-if=\"!productDetail.isLoggedIn\">\r\n      <button ng-click=\"productDetail.openStoreSelector()\" type=\"button\" class=\"btn btn-lg btn-primary  btn-block btn-md-text ng-scope\">\r\n        Choose Another Store\r\n      </button>\r\n      Find this product at another WBU store.\r\n    </div> -->\r\n  </div>\r\n  <div ng-if=\"productDetail.productNotFound\" class=\"row m-x-0 p-y-1 p-x-0 hidden-md-up\">\r\n    <div class=\"col-xs-12 place_order_btn hidden-md-up\">\r\n\r\n      <button ui-sref=\"category\" type=\"button\" ng-show=\"productDetail.productNotFound\"\r\n        class=\"btn btn-primary btn-block btn-md-text\">Continue\r\n        Shopping</button>\r\n\r\n    </div>\r\n    <!-- <div class=\"col-xs-6 p-x-0 hidden-md-up\" ng-if=\"!productDetail.isLoggedIn\">\r\n\r\n      <button ng-hide=\"!productDetail.productNotFound\" ng-click=\"productDetail.openStoreSelector()\" type=\"button\" class=\"btn btn-lg btn-primary btn-bdr btn-block m-t-0\">\r\n        Choose Another Store\r\n      </button>\r\n\r\n\r\n    </div> -->\r\n  </div>\r\n\r\n  <form ng-if=\"productDetail.selectedItem.id\" name=\"productDetailForm\" autocomplete=\"off\" novalidate>\r\n\r\n    <div class=\"row  mb-40\" ng-if=\"!productDetail.productNotFound\"\r\n      ng-style=\"!productDetail.isNotMobile() ? {'margin':'1px'} : ''\"\r\n      ng-class=\"productDetail.isNotMobile() ? 'm-x-1' : ''\">\r\n\r\n      <div ng-class=\"productDetail.isIpad()?'col-md-9':'col-md-10'\" class=\"p-x-0\"\r\n        ng-style=\"productDetail.isNotMobile() && !productDetail.isIpad() ? {'width': '78%'} : ''\">\r\n        <img ng-hide=\"productDetail.detail.name\" src={{productDetail.oopsImage}} class=\"product-image img-fluid\" />\r\n\r\n        <div class=\"row\" ng-class=\"productDetail.isNotMobile() ? '' : 'm-x-0'\">\r\n          <div class=\"col-md-5\" ng-style=\"productDetail.isIpad() ? productDetail.productImageStyle :''\"\r\n            ng-class=\"productDetail.isNotMobile()?'Product_detail_Image_desktop':''\">\r\n            <div class=\"slide_row\" style=\"width:50px;\"></div>\r\n            <div style=\"height: auto;position: absolute;\"\r\n              ng-if=\"productDetail.selectedItem.isOutOfStock && !productDetail.isIpad()\"\r\n              ng-style=\"productDetail.isIpad() ? '' : ''\"\r\n              class=\"{{productDetail.selectedItem.isOutOfStock ? 'm-y-1 hidden-sm-down pngcontainer1' : 'm-y-1 hidden-sm-down'}}\">\r\n              <img src={{productDetail.selectedItem.largeImageUrl}}\r\n                ng-style=\"productDetail.isIpad() ? {'margin-left': '-15px'} : ''\" class=\"product-image img-fluid\"\r\n                alt=\"{{productDetail.selectedItem.alt ? productDetail.selectedItem.alt : productDetail.selectedItem.name}}\" />\r\n              <!-- Temporarily Unavailable -->\r\n              <img ng-if=\"productDetail.selectedItem.isOutOfStock\" src={{productDetail.tempUnavailable}}\r\n                ng-style=\"productDetail.isIpad() ? {'margin-left': '-15px'} : ''\"\r\n                ng-class=\"productDetail.isIpad() ? '' :''\" class=\"product-image img-fluid\" alt=\"smiley\" />\r\n            </div>\r\n            <!-- desktop -->\r\n            <div class=\"slideshow-container\" style=\"margin-top:0px !important\"\r\n              ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.imgVideoList.length > 0 && productDetail.isNotMobile() && !productDetail.isIpad()\">\r\n              <div class=\"slide_row\" ng-if=\"productDetail.imgVideoList.length > 1\"\r\n                ng-style=\"productDetail.imgVideoList.length > 5 ? {'top': '-3px'} : {'top': '20px'}\"\r\n                ng-style=\"!productDetail.isIpad() ? {'width':'50px'} : ''\">\r\n                <img ng-click=\"productDetail.scrollToTop('slide')\" ng-if=\"productDetail.imgVideoList.length > 5\"\r\n                  style=\"height:24px;\" src={{productDetail.upArrow}} />\r\n                <div class=\"limit\" id=\"slide\" thumbnail-slider=\"100\" style=\"max-height:300px;overflow: hidden;\">\r\n                  <div class=\"content\" ng-if=\"productDetail.imgVideoList.length > 0\">\r\n                    <div id=\"multiImageViewPort\" class=\"position-rel\"\r\n                      style=\"height:52px;border: 1px solid lightgrey; margin-bottom:10px;\"\r\n                      ng-repeat=\"item in productDetail.imgVideoList\">\r\n                      <img ng-if=\"item.fileType === 'IMAGE'\" class=\"demo cursor\" src=\"{{item.largeUrl}}\"\r\n                        style=\"width:100%; height:50px;\" ng-click=\"productDetail.currentSlide($index + 1)\"\r\n                        ng-mouseenter=\"productDetail.currentSlide($index + 1)\">\r\n                      <video ng-if=\"item.fileType === 'VEDIO'\" class=\"demo cursor thumbnail\"\r\n                        src=\"{{trustSrc(item.rawUrl)}}\" style=\"width:100%; height:50px;\"\r\n                        ng-click=\"productDetail.showImgPopup(item)\"\r\n                        ng-mouseenter=\"productDetail.currentSlide($index + 1)\"></video>\r\n                      <div ng-if=\"item.fileType === 'VEDIO'\" class=\"playButton\"\r\n                        ng-click=\"productDetail.showImgPopup(item)\"></div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <img ng-click=\"productDetail.scrollToBottom('slide')\" ng-if=\"productDetail.imgVideoList.length > 5\"\r\n                  style=\"height:15px;\" src={{productDetail.downArrow}} />\r\n              </div>\r\n              <div style=\"height: auto;margin-top: 20px;position: absolute;\"\r\n                ng-style=\"productDetail.isIpad() ? {'margin-left':'25%'} : {'margin-left':'60px'}\">\r\n                <div class=\"mySlides slidefade\" ng-repeat=\"item in productDetail.imgVideoList\">\r\n                  <img ng-if=\"item.fileType === 'IMAGE'\" src=\"{{item.largeUrl}}\"\r\n                    ng-class=\"productDetail.isIpad() ? 'product-img-size-ipad' :'product-img-size-desktop'\">\r\n                  <video ng-if=\"item.fileType === 'VEDIO'\" class=\"demo cursor thumbnail\" src=\"{{trustSrc(item.rawUrl)}}\"\r\n                    ng-class=\"productDetail.isIpad() ? 'product-img-size-ipad' :'product-img-size-desktop'\"\r\n                    ng-click=\"productDetail.showImgPopup(item)\"></video>\r\n                  <div ng-if=\"item.fileType === 'VEDIO'\" class=\"playButton\" ng-click=\"productDetail.showImgPopup(item)\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row m-x-0\" ng-if=\"productDetail.isIpad()\">\r\n              <div ng-style=\"productDetail.imgVideoIpadList.length > 1 ? '' : {'margin-left': '-15px'}\"\r\n                class=\"{{productDetail.selectedItem.isOutOfStock ? 'text-xs-center m-y-1 col-xs-12 pngcontainer1' : 'text-xs-center m-y-1 col-xs-12'}}\">\r\n                <img ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.imgVideoIpadList.length == 1\"\r\n                  src={{productDetail.selectedItem.largeImageUrl}} class=\"m_product-image img-fluid\"\r\n                  alt=\"{{productDetail.selectedItem.alt ? productDetail.selectedItem.alt :productDetail.selectedItem.name}}\" />\r\n                <div class=\"slideshow-container\"\r\n                  ng-style=\"productDetail.isIpadLandscape() ? {'margin-left': '-100px'} : {'margin-left': '-70px'}\"\r\n                  ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.imgVideoIpadList.length > 1\">\r\n                  <a class=\"prev\" style=\"margin-left: -10%\" ng-click=\"productDetail.plusSlidesIpad(-1)\">&#10094;</a>\r\n                  <div class=\"mySlidesIpad slidefade\" ng-repeat=\"item in productDetail.imgVideoIpadList\">\r\n                    <img ng-if=\"item.fileType === 'IMAGE'\" src=\"{{item.largeUrl}}\" style=\"width:150px;height:150px\">\r\n                    <video ng-if=\"item.fileType === 'VEDIO'\" id=\"ipadVideo{{$index}}\" controls\r\n                      class=\"demo cursor slide-tumb thumbnail\" src=\"{{trustSrc(item.rawUrl)}}\"\r\n                      style=\"width:150px;height:150px\"></video>\r\n                  </div>\r\n                  <a class=\"next\"\r\n                    ng-style=\"productDetail.isIpadLandscape() ? {'margin-left': '-3%'} : {'right': '40px'}\"\r\n                    ng-click=\"productDetail.plusSlidesIpad(1)\">&#10095;</a>\r\n                </div>\r\n\r\n                <img ng-if=\"productDetail.selectedItem.isOutOfStock\" src={{productDetail.selectedItem.largeImageUrl}}\r\n                  class=\"m_product-image img-fluid\"\r\n                  alt=\"{{productDetail.selectedItem.alt ? productDetail.selectedItem.alt :productDetail.selectedItem.name}}\" />\r\n                <img ng-if=\"productDetail.selectedItem.isOutOfStock\" src={{productDetail.tempUnavailable}}\r\n                  class=\"m_product-image img-fluid\" alt=\"smiley\" style=\"left: 10px !important;\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"row m-x-0 hidden-md-up\">\r\n              <div\r\n                class=\"{{productDetail.selectedItem.isOutOfStock ? 'text-xs-center m-y-1 col-xs-12 pngcontainer1' : 'text-xs-center m-y-1 col-xs-12'}}\">\r\n                <img ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.imgVideoList.length == 1\"\r\n                  src={{productDetail.selectedItem.largeImageUrl}} class=\"m_product-image img-fluid\"\r\n                  alt=\"{{productDetail.selectedItem.alt ? productDetail.selectedItem.alt :productDetail.selectedItem.name}}\" />\r\n                <div class=\"slideshow-container\"\r\n                  ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.imgVideoList.length > 1\">\r\n                  <a class=\"prev\" style=\"margin-left: -65px;\" ng-click=\"productDetail.plusSlides(-1)\">&#10094;</a>\r\n                  <div class=\"mySlides slidefade\" ng-repeat=\"item in productDetail.imgVideoList\">\r\n                    <img ng-if=\"item.fileType === 'IMAGE'\" src=\"{{item.largeUrl}}\" style=\"width:200px;height:200px\">\r\n                    <video ng-if=\"item.fileType === 'VEDIO'\" id=\"mobileVideo{{$index}}\" controls\r\n                      class=\"demo cursor slide-tumb thumbnail\" src=\"{{trustSrc(item.rawUrl)}}\"\r\n                      style=\"width:200px;height:200px\"></video>\r\n                  </div>\r\n                  <a class=\"next\" style=\"margin-right: -87px;\" ng-click=\"productDetail.plusSlides(1)\">&#10095;</a>\r\n                </div>\r\n                <img ng-if=\"productDetail.selectedItem.isOutOfStock\" src={{productDetail.selectedItem.largeImageUrl}}\r\n                  class=\"m_product-image img-fluid\"\r\n                  alt=\"{{productDetail.selectedItem.alt ? productDetail.selectedItem.alt :productDetail.selectedItem.name}}\" />\r\n                <img ng-if=\"productDetail.selectedItem.isOutOfStock\" src={{productDetail.tempUnavailable}}\r\n                  class=\"m_product-image img-fluid\" alt=\"smiley\" style=\"left: 10px !important;\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"row m-x-0 thumbnail-slider hidden-sm-down\"\r\n              ng-style=\"productDetail.isIpad() ? {'text-align': 'center', 'width' : '82%'} :{'margin-top' : '330px'}\"\r\n              ng-if=\"productDetail.referralProducts && productDetail.referralProducts.length > 0 && productDetail.referralProducts[0].referredItems && productDetail.referralProducts[0].referredItems.length > 0\">\r\n              <br />\r\n              <div style=\"text-align:left; margin-bottom: 0px;\"\r\n                ng-style=\"productDetail.isIpad() ? {'padding': '0px 33px'} : {'padding': '0px 52px'}\"\r\n                class=\"prod-detail-desc\">Related items: </div>\r\n\r\n              <img ng-click=\"scrollToLeft()\" ng-class=\"productDetail.isIpad() ? 'arrow-icons-ipad' :'arrow-icons'\"\r\n                class=\"\" src={{productDetail.leftArrow}} />\r\n              <div class=\"limit-details\" thumbnail-slider=\"100\"\r\n                ng-style=\"productDetail.isIpad() ? {'max-width':'79%'} :''\">\r\n\r\n                <div class=\"content\">\r\n                  <div ng-click=\"productDetail.goToProductPage(item)\" class=\"slide-item\"\r\n                    ng-repeat=\"item in productDetail.referralProducts[0].referredItems\">\r\n                    <img ng-style=\"productDetail.isIpad() ? {'width': '45px'} : {'width': '73px'}\"\r\n                      src={{item.smallImageUrl}} alt=\"{{item.alt ? item.alt : item.name}}\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <img ng-click=\"scrollToRight()\" ng-class=\"productDetail.isIpad() ? 'arrow-icons-ipad' :'arrow-icons'\"\r\n                class=\"\" src={{productDetail.homeArrow}}>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-7\"\r\n            ng-style=\"productDetail.isIpad() ? productDetail.productDescStyle:( !productDetail.isNotMobile() ? productDetail.Padding_Mob: '')\"\r\n            ng-class=\"productDetail.isNotMobile() && !productDetail.isIpad()?'Product_detail_desc_desktop':''\">\r\n            <div class=\"font-weight-bold m-t-1 hidden-sm-down\">\r\n              <span class=\"font-weight-bold m-t-1 \" style=\"font-size: 1.1rem\"\r\n                ng-bind=\"productDetail.detail.name\"></span>\r\n              <!-- <img src={{productDetail.FBLogo}} ng-click=\"productDetail.fbshare()\" class=\"m-l-1\" style=\"height: 27px; \"\r\n                title=\"Share on Facebook\"> -->\r\n            </div>\r\n            <div ng-if=\"productDetail.isNotMobile()\" style=\"position: relative;\">\r\n              <hr id=\"headline\" class=\"hide\">\r\n              <div id=\"pr-reviewsnippet\"></div>\r\n              <div id=\"pr-questionsnippet\"></div>\r\n              <hr id=\"headlinefooter\" class=\"hide\">\r\n            </div>\r\n            <!-- Quantity Manipulation on Large Devices -->\r\n            <div class=\"col-xs-12 col-md-12 hidden-sm-down \" style=\"padding:0px;\">\r\n              <!-- Regular Price and Quantity if not DSC -->\r\n              <div class=\"col-xs-6 p-x-0 bag-detail-bg\"\r\n                ng-if=\"!productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\">\r\n                  <!--Regular Price if not DSC -->\r\n                  <div class=\"col-xs-6\" style=\"padding:0px;\">\r\n                    <p class=\"product-text-md\">Regular Price</p>\r\n                    <h5 class=\" font-weight-bold\" style=\"margin-top:12px\">\r\n                      $ {{productDetail.selectedItem.price | number : 2}}\r\n                    </h5>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- Regular Price and Quantity if DSC -->\r\n              <div ng-show=\"productDetail.storeName && productDetail.storeName != ''\"\r\n                class=\"col-xs-6 p-x-0 bag-detail-bg\"\r\n                ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                <!--Regular price if DSC -->\r\n                <div class=\"col-xs-6 p-l-0\" style=\"padding:0px\">\r\n                  <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\">\r\n                    <p class=\"product-text-md\">Regular Price</p>\r\n                    <h5 class=\" font-weight-bold\">\r\n                      <span ng-if=\"!productDetail.isDscMember()\">$ {{productDetail.selectedItem.price | number :\r\n                        2}}</span>\r\n                      <strike ng-if=\"productDetail.isDscMember()\">$ {{productDetail.selectedItem.price | number :\r\n                        2}}</strike>\r\n                    </h5>\r\n                  </div>\r\n                </div>\r\n\r\n              </div>\r\n\r\n              <!-- DSC and Bag Weight -->\r\n              <div class=\"col-xs-6 p-x-0\">\r\n                <!-- DSC Price if exists -->\r\n                <div class=\"col-xs-12 text-xs-left p-l-0\"\r\n                  ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                  <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\">\r\n                    <h6 class=\"product-text-md\">Daily Savings Club Price</h6>\r\n                    <h5 class=\"font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                      ${{(productDetail.selectedItem.price * 85 / 100) | number : 2}}\r\n                      <!--DSC Label-->\r\n                      <span class=\"row m-l-1\" style=\"min-height:57px;\" ng-if=\"!productDetail.isDscMember()\">\r\n                        <span ng-if=\"productDetail.canUserJoin()\" style=\"cursor: pointer\" ui-sref=\"savings-club\">\r\n                          <a href ng-click=\"productDetail.goToSavingsClub()\">\r\n                            <span class=\"white-med-bold-text  hidden-md-down\" style=\"display:inline-block\">\r\n                              <button class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                                ui-sref=\"savings-club\">Join\r\n                                Now</button>\r\n                            </span>\r\n                          </a>\r\n                          <span class=\"white-med-bold-text hidden-lg-up \" style=\"display:inline-block;margin-top: 0px;\">\r\n                            <button class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                              style=\"margin-top: 0px !important;\" ui-sref=\"savings-club\">Join Now</button>\r\n                          </span>\r\n                        </span>\r\n\r\n                        <span ui-sref=\"savings-club\"\r\n                          ng-if=\"productDetail.isDscMember() && productDetail.profile.customer.email\"\r\n                          class=\"cursor-pointer\" style=\"line-height: 13px;\">\r\n                          <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                            <button class=\"hidden-md-down renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                              ng-click=\"productDetail.updateUserAction(productDetail.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                              ui-sref=\"savings-club\">Renew</button>\r\n                          </span>\r\n                        </span>\r\n\r\n                        <span ng-if=\"productDetail.isDscButExpired() && productDetail.profile.customer.email\"\r\n                          style=\"line-height: 13px;\">\r\n                          <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                            <button class=\" renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                              ng-click=\"productDetail.updateUserAction(productDetail.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                              ui-sref=\"savings-club\">Renew</button>\r\n                          </span>\r\n                        </span>\r\n\r\n                      </span>\r\n                    </h5>\r\n                  </div>\r\n                  <!--DSC Label-->\r\n                </div>\r\n              </div>\r\n              <!-- Buttons on Large Devices-->\r\n            </div>\r\n\r\n            <div\r\n              ng-if=\"productDetail.selectedItem.isOutOfStock && productDetail.storeFeatures.hasOutOfStockNotification\"\r\n              class=\"hidden-md-down\">\r\n              <br />\r\n              <div class=\"col-xs-12 notify-instock\" ng-if=\"!productDetail.isRemainderSetAlready\">\r\n\r\n                <div class=\"std\">\r\n                  <div class=\"col-xs-1 p-x-0\" style=\"width:23px\">\r\n                    <img ng-src={{productDetail.alertIcon}} />\r\n                  </div>\r\n                  <div class=\"col-xs-11\" style=\"padding-left:0px;margin-left:0px\">\r\n                    <div class=\"text1\">THIS ITEM IS OUT OF STOCK</div>\r\n                    <div class=\"text2\">Enter your email below and we'll notify you the moment it's available again.</div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"std div2\">\r\n                  <input name=\"emailToRemainder\" type=\"email\"\r\n                    ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n                    class=\"form-control rounded_boarders\" ng-model=\"productDetail.emailToRemainder\"\r\n                    placeholder=\"Enter email address\" required />\r\n                </div>\r\n\r\n                <div class=\"std\">\r\n                  <button ng-click=\"productDetail.saveRemainder(productDetail.APP.ORDER.REMAINDER_TYPE.OUT_OF_STOCK)\"\r\n                    ng-disabled=\"productDetailForm.emailToRemainder.$error.pattern || productDetailForm.emailToRemainder.$invalid\"\r\n                    class=\"btn btn-primary btn-block btn-md-text rounded_boarders\">Notify me when it's back</button>\r\n                    <div class=\"solid-box-outofstock text2\">Your email will only be used to send a one-time back-in-stock notification.</div>\r\n                </div>\r\n\r\n              </div>\r\n              <div ng-if=\"productDetail.isRemainderSetAlready\">\r\n                <strong>\r\n                  <a\r\n                    style=\"margin-right: 15px;margin-top: 0px;font-size: 0.85rem;height: 30px;color:seagreen;padding-top: 8px;\">\r\n                    <img ng-src={{productDetail.savedTick}} class=\"mb-8\"\r\n                      style=\"padding-right: 5px; padding-top: 4px; height: 18px;\" />{{productDetail.outOfStockRemainderText}}</a></strong>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <div class=\"font-weight-bold m-t-1 hidden-md-up\"\r\n              ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\">\r\n              <center><span style=\"font-size: 1rem\" ng-bind=\"productDetail.detail.name\"></center>\r\n\r\n              </span>\r\n              <!-- <img src={{productDetail.FBLogo}} style=\"height: 27px; position:relative;top: -9px;\" class=\"\" ng-click=\"productDetail.fbshare()\"\r\n                title=\"Share on Facebook\">                 -->\r\n              <span\r\n                ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.deliveryType === 'InStore'\"\r\n                class=\"delivery-type-only hidden-md-up\"><br />In Store/Curbside Pickup Only</span>\r\n              <span\r\n                ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.deliveryType === 'DropShip'\"\r\n                class=\"delivery-type-only hidden-md-up\"><br />Delivery Only</span>\r\n              <span ng-if=\"productDetail.selectedItem.isOutOfStock\" class=\"out_of_stock hidden-md-up\"><br />\r\n                <center>Temporarily\r\n                  Unavailable</center>\r\n              </span>\r\n              <span\r\n                ng-if=\"productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.availableBackOn\">Expected\r\n                availability: {{productDetail.selectedItem.availableBackOnDateString}}<br /></span>\r\n            </div>\r\n\r\n            <!-- Out of stock Notification for Mobile -->\r\n            <div\r\n              ng-if=\"productDetail.selectedItem.isOutOfStock && productDetail.storeFeatures.hasOutOfStockNotification\"\r\n              class=\"hidden-md-up col-xs-12 p-x-0 p-y-1\">\r\n              <div class=\"col-xs-12 notify-instock \"  ng-if=\"!productDetail.isRemainderSetAlready\">\r\n                <div class=\"mobile\">\r\n                  <div class=\"std\">\r\n                    <div class=\"col-xs-1 p-x-0\" style=\"width:23px\">\r\n                      <img ng-src={{productDetail.alertIcon}} />\r\n                    </div>\r\n                    <div class=\"col-xs-11\" style=\"padding-left:0px;margin-left:0px\">\r\n                      <div class=\"text1\">THIS ITEM IS OUT OF STOCK</div>\r\n                      <div class=\"text2\">Enter your email below and we'll notify you the moment it's available again.</div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"std div2\">\r\n                    <input name=\"emailToRemainder\" type=\"email\"\r\n                      ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n                      class=\"form-control rounded_boarders\" ng-model=\"productDetail.emailToRemainder\"\r\n                      placeholder=\"Enter email address\" required />\r\n                  </div>\r\n\r\n                  <div class=\"std\">\r\n                    <button ng-click=\"productDetail.saveRemainder(productDetail.APP.ORDER.REMAINDER_TYPE.OUT_OF_STOCK)\"\r\n                      ng-disabled=\"productDetailForm.emailToRemainder.$error.pattern || productDetailForm.emailToRemainder.$invalid\"\r\n                      class=\"btn btn-primary btn-block btn-md-text rounded_boarders\">Notify me when it's back</button>\r\n                      <div class=\"solid-box-outofstock text2\">Your email will only be used to send a one-time back-in-stock notification.</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"productDetail.isRemainderSetAlready\">\r\n                <strong>\r\n                  <a\r\n                    style=\"margin-right: 15px;margin-top: 0px;font-size: 0.80rem;height: 30px;color:seagreen;padding-top: 8px;\">\r\n                    <img ng-src={{productDetail.savedTick}} class=\"mb-8\"\r\n                      style=\"padding-right: 5px; padding-top: 4px; height: 18px;\" />{{productDetail.outOfStockRemainderText}}</a></strong>\r\n              </div>\r\n            </div>\r\n            <!-- Out of stock Notification for Mobile -->\r\n\r\n            \r\n            <div ng-if=\"!productDetail.isNotMobile()\"  style=\"clear:both\">\r\n              <hr id=\"headline\" class=\"hide\">\r\n              <div id=\"pr-reviewsnippet\"></div>\r\n              <div id=\"pr-questionsnippet\"></div>\r\n              <hr id=\"headlinefooter\" class=\"hide\">\r\n            </div>\r\n            <div class=\"row\" ng-class=\"productDetail.isNotMobile() ? '' : 'm-x-0'\">\r\n              <!-- Quantity Details on SM, XS devices-->\r\n              <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\"\r\n                class=\"col-xs-12 hidden-md-up p-x-0-xs p-x-2-md\">\r\n\r\n                <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\">\r\n                  <!-- Price section if not DSC with no margin-bottom -->\r\n                  <div class=\"col-xs-12 p-x-0 p-y-1 bag-detail-bg\"\r\n                    ng-if=\"!productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n\r\n                    <!--Regular Price if not DSC -->\r\n                    <div class=\"col-xs-6\" ng-style=\"productDetail.isNotMobile()? '{padding: 0px}' : ''\">\r\n                      <p class=\"product-text-md\">Regular Price</p>\r\n                      <h5 class=\"font-weight-bold\">\r\n                        $ {{productDetail.selectedItem.price | number : 2}}\r\n                      </h5>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <!-- Price and DSC section if DSC Removed margin-bottom-->\r\n                  <div class=\"col-xs-12 p-x-0 p-y-1 bag-detail-bg\"\r\n                    ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                    <!--Regular price if DSC -->\r\n                    <div class=\"col-xs-6\" style=\"padding:0px\">\r\n                      <p class=\"product-text-md\">Regular Price</p>\r\n                      <h5 class=\"font-weight-bold\" style=\"padding-top: 3px;\">\r\n                        <span ng-if=\"!productDetail.isDscMember()\"> $ {{productDetail.selectedItem.price | number :\r\n                          2}}</span>\r\n                        <strike ng-if=\"productDetail.isDscMember()\"> $ {{productDetail.selectedItem.price | number :\r\n                          2}}</strike>\r\n                      </h5>\r\n                    </div>\r\n                    <!-- DSC Price -->\r\n                    <div class=\"col-xs-6 text-xs-right p-l-0\"\r\n                      ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                      <h6 class=\"product-text-md\">Daily Savings Club Price</h6>\r\n                      <h5 class=\"font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                        ${{(productDetail.selectedItem.price * 85 / 100) | number : 2}}\r\n                        <span class=\"row m-l-1\" style=\"min-height:57px;margin-left: 0.4rem !important\"\r\n                          ng-if=\"!productDetail.isDscMember()\">\r\n                          <span ng-if=\"productDetail.canUserJoin()\" style=\"cursor: pointer\" ui-sref=\"savings-club\">\r\n                            <a href ng-click=\"productDetail.goToSavingsClub()\">\r\n                              <span class=\"white-med-bold-text  hidden-md-down\" style=\"display:inline-block\">\r\n                                <button style=\"width: 86px;\"\r\n                                  class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                                  ui-sref=\"savings-club\">Join Now</button>\r\n                              </span>\r\n                            </a>\r\n                            <span class=\"white-med-bold-text hidden-lg-up \"\r\n                              style=\"display:inline-block;margin-top: 0px;\">\r\n                              <button style=\"width: 86px;\"\r\n                                class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                                style=\"margin-top: 0px !important;\" ui-sref=\"savings-club\">Join Now</button>\r\n                            </span>\r\n                          </span>\r\n\r\n                          <span ui-sref=\"savings-club\"\r\n                            ng-if=\"productDetail.isDscMember() && productDetail.profile.customer.email\"\r\n                            class=\"cursor-pointer\" style=\"line-height: 13px;\">\r\n                            <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                              <button class=\"hidden-md-down renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                                ng-click=\"productDetail.userAction(productDetail.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                                ui-sref=\"savings-club\">Renew</button>\r\n                            </span>\r\n                          </span>\r\n\r\n                          <span ng-if=\"productDetail.isDscButExpired() && productDetail.profile.customer.email\"\r\n                            style=\"line-height: 13px;\">\r\n                            <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                              <button class=\" renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                                ng-click=\"productDetail.userAction(productDetail.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                                ui-sref=\"savings-club\">Renew</button>\r\n                            </span>\r\n                          </span>\r\n\r\n                        </span>\r\n                      </h5>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n\r\n                <!--Quantity manipulation column -->\r\n                <div class=\"col-xs-12 product-weight-align p-x-0 p-y-1 bag-detail-bg\" style=\"margin-left: 0px;\">\r\n                  <!-- Bag Weight -->\r\n                  <div\r\n                    ng-if=\"productDetail.storeName && productDetail.storeName != '' && productDetail.filteredList.length && productDetail.filteredList.length > 0\"\r\n                    class=\"p-x-0\" ng-class=\"productDetail.filteredList.length > 2 ? 'col-xs-12' : 'col-xs-6'\">\r\n                    <p class=\"product-text\"\r\n                      ng-if=\"productDetail.filteredList.length && productDetail.filteredList.length == 1\">Weight</p>\r\n                    <p class=\"product-text\"\r\n                      ng-if=\"productDetail.filteredList.length && productDetail.filteredList.length > 1\">\r\n                      Select Weight</p>\r\n                    <span class=\"tag m-b-10 product-weight\"\r\n                      ng-class=\"item.id === productDetail.selectedItem.id ? 'tag-primary-updated' : 'tag-default-updated'\"\r\n                      ng-repeat=\"item in productDetail.filteredList = (productDetail.detail.itemList | filter: productDetail.masterCodeChecker | orderBy: 'weight')\"\r\n                      ng-click=\"productDetail.selectWeight(item)\">\r\n                      {{item.weight}}\r\n                      <span class=\"lb-text\">lbs</span>\r\n                    </span>\r\n                  </div>\r\n                  <!-- Quantity -->\r\n                  <div class=\"col-xs-6 col-sm-3\"\r\n                    ng-class=\"{'has-danger': (productDetailForm.$submitted || productDetailForm.quantity.$touched) && productDetailForm.quantity.$invalid}\"\r\n                    ng-style=\"productDetail.filteredList.length == 0? productDetail.marleft20:''\">\r\n                    <p class=\"product-text\">Quantity</p>\r\n                    <div class=\"input-group\" style=\"min-width:100px;\">\r\n                      <span class=\"input-group-btn\">\r\n                        <button type=\"button\" ng-disabled=\"productDetail.quantity < 2\"\r\n                          class=\"btn btn-primary counter-btn\"\r\n                          ng-click=\"productDetail.quantity = productDetail.quantity - 1\">&#150;</button>\r\n                      </span>\r\n                      <input name=\"quantity\" disabled type=\"number\" class=\"form-control counter-input\"\r\n                        ng-init=\"productDetail.quantity = 1\" ng-model=\"productDetail.quantity\" ng-min=\"1\"\r\n                        ng-max=\"999999\" />\r\n                      <span class=\"input-group-btn\">\r\n                        <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                          ng-click=\"productDetail.quantity = productDetail.quantity + 1\">+</button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-12 p-x-0 p-y-1 bag-detail-bg\">\r\n                  <div ng-if=\"!productDetail.forSubscription \" class=\"mt-4 place_order_btn\">\r\n\r\n                    <button type=\"button\" ng-show=\"productDetail.storeName && productDetail.storeName != '' \"\r\n                      class=\"btn btn-primary btn-block btn-md-text\"\r\n                      ng-disabled=\"productDetail.selectedItem.isOutOfStock\"\r\n                      ng-click=\"productDetail.addItemToCart(productDetailForm)\">Add to Cart\r\n                    </button>\r\n\r\n                    <!-- <button type=\"button\" ng-show=\"productDetail.storeName && productDetail.storeName != ''\"  ng-click=\"productDetail.goToCart()\" class=\"btn btn-primary btn-block btn-md-text\"\r\n                      ng-if=\"productDetail.isItemAdded\">Go to Cart</button> -->\r\n                  </div>\r\n                </div>\r\n\r\n\r\n                <div class=\"col-xs-12 p-x-0 p-y-1 mb-40\"\r\n                  ng-hide=\"productDetail.storeName && productDetail.storeName != ''\"></div>\r\n\r\n              </div>\r\n\r\n              <!-- Not all product available mobile div -->\r\n              <div class=\" row hidden-md-up product-detail-page\" ng-class=\"productDetail.isNotMobile() ? '' : 'm-x-0'\"\r\n                ng-hide=\"productDetail.storeName && productDetail.storeName != ''\">\r\n                <div class=\"col-md-12  text-xs-center\">\r\n                  <br><product-promo></product-promo> <br>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-12 p-x-0 bag-detail-bg hidden-md-up\">\r\n                <span ng-style=\"!productDetail.isNotMobile()? productDetail.Padding:''\" class=\"font-weight-bold\"\r\n                  style=\"font-size: 0.9rem; padding-bottom: 5px;font-size:16px;\"\r\n                  ng-hide=\"productDetail.storeName && productDetail.storeName != ''\">Ready to Order ?</span>\r\n                <span\r\n                  ng-if=\"productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.availableBackOn\">Expected\r\n                  availability: {{productDetail.selectedItem.availableBackOnDateString}}</span>\r\n              </div>\r\n\r\n              <div class=\"col-xs-12 hidden-md-up p-x-0-xs p-x-2-md\">\r\n                <div ng-if=\"!productDetail.forSubscription \" class=\"col-xs-6 p-x-0\">\r\n                  <button ng-hide=\"productDetail.storeName && productDetail.storeName != ''\"\r\n                    ng-click=\"productDetail.openStoreSelector()\" type=\"button\"\r\n                    class=\"btn-pad-mob btn btn-lg btn-primary btn-bdr btn-block m-t-0\">\r\n                    <!-- class=\"btn-pad-mob btn btn-lg btn-primary btn-bdr btn-block m-t-0\" Find my store-->\r\n                    <span class=\"font-weight-bold\" style=\"font-size: 14px;\">Find My Store</span> <br><span\r\n                      style=\"font-size: 9px;\">for pricing & availability</span>\r\n                  </button>\r\n                </div>\r\n\r\n                <div ng-if=\"!productDetail.isLoggedIn\" class=\"col-xs-6 p-x-0\">\r\n                  <button ng-click=\"productDetail.openLoginPopup()\"\r\n                    ng-hide=\"productDetail.storeName && productDetail.storeName != '' \" type=\"button\"\r\n                    class=\"btn btn-lg btn-primary btn-block\">\r\n                    <!-- class=\"btn btn-lg btn-primary btn-block \" -->\r\n                    Login\r\n                  </button>\r\n                </div>\r\n              </div>\r\n\r\n\r\n            </div>\r\n            <div class=\"col-xs-12 p-x-0 bag-detail-bg\">\r\n              <p class=\"product-text-md p-t-2 \" style=\"padding-bottom: 5px;font-size:16px;\">About this Item:</p>\r\n              <div ng-if=\"productDetail.selectedItem.masterProduct.description\">\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"!productDetail.showDescription\" ng-click=\"productDetail.showHideDescription()\">+ Description\r\n                </p>\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"productDetail.showDescription\" ng-click=\"productDetail.showHideDescription()\">- Description\r\n                </p>\r\n                <p style=\"padding-left:10px;\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.description)\"\r\n                  ng-if=\"productDetail.showDescription\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n                <p ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.description)\"\r\n                  ng-if=\"productDetail.showDescription\" class=\"p-t-1 hidden-md-up\"></p>\r\n              </div>\r\n              <div ng-if=\"productDetail.selectedItem.masterProduct.ingredients\">\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"!productDetail.showIngredients\" ng-click=\"productDetail.showHideIngredients()\">+ Ingredients\r\n                </p>\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"productDetail.showIngredients\" ng-click=\"productDetail.showHideIngredients()\">- Ingredients</p>\r\n                <p style=\"padding-left:10px;\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.ingredients)\"\r\n                  ng-if=\"productDetail.showIngredients\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n                <p ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.ingredients)\"\r\n                  ng-if=\"productDetail.showIngredients\" class=\"p-t-1 hidden-md-up\"></p>\r\n              </div>\r\n              <div ng-if=\"productDetail.selectedItem.masterProduct.specifications\">\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"!productDetail.showSpecifications\" ng-click=\"productDetail.showHideSpecifications()\">+\r\n                  Specifications</p>\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"productDetail.showSpecifications\" ng-click=\"productDetail.showHideSpecifications()\">-\r\n                  Specifications</p>\r\n                <p style=\"padding-left:10px;\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.specifications)\"\r\n                  ng-if=\"productDetail.showSpecifications\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n                <p ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.specifications)\"\r\n                  ng-if=\"productDetail.showSpecifications\" class=\"p-t-1 hidden-md-up\"></p>\r\n              </div>\r\n              <div ng-if=\"productDetail.selectedItem.masterProduct.warranty\">\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"!productDetail.showWarranty\" ng-click=\"productDetail.showHideWarranty()\">+ Warranty</p>\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"productDetail.showWarranty\" ng-click=\"productDetail.showHideWarranty()\">- Warranty</p>\r\n                <p style=\"padding-left:10px;\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.warranty)\"\r\n                  ng-if=\"productDetail.showWarranty\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n                <p ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.warranty)\"\r\n                  ng-if=\"productDetail.showWarranty\" class=\"p-t-1 hidden-md-up\"></p>\r\n              </div>\r\n              <div ng-if=\"productDetail.selectedItem.masterProduct.material\">\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"!productDetail.showMaterials\" ng-click=\"productDetail.showHideMaterials()\">+ Materials</p>\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"productDetail.showMaterials\" ng-click=\"productDetail.showHideMaterials()\">- Materials</p>\r\n                <p style=\"padding-left:10px;\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.material)\"\r\n                  ng-if=\"productDetail.showMaterials\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n                <p ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.material)\"\r\n                  ng-if=\"productDetail.showMaterials\" class=\"p-t-1 hidden-md-up\"></p>\r\n              </div>\r\n              <!--  Allergen Information -->\r\n              <div ng-if=\"productDetail.selectedItem.masterProduct.allergen\">\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"!productDetail.showAllergen\" ng-click=\"productDetail.showHideAllergen()\">+ Allergen Information</p>\r\n                <p class=\"product-text-md\"\r\n                  style=\"cursor: pointer;padding-top: 5px;border-top: 1px solid rgba(0,0,0,.1);\"\r\n                  ng-if=\"productDetail.showAllergen\" ng-click=\"productDetail.showHideAllergen()\">- Allergen Information</p>\r\n                <p style=\"padding-left:10px;\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.allergen)\"\r\n                  ng-if=\"productDetail.showAllergen\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n                <p ng-style=\"!productDetail.isNotMobile() ? productDetail.Padding : ''\"\r\n                  ng-bind-html=\"productDetail.$sce.trustAsHtml(productDetail.selectedItem.masterProduct.allergen)\"\r\n                  ng-if=\"productDetail.showAllergen\" class=\"p-t-1 hidden-md-up\"></p>\r\n              </div>\r\n              <!--  Allergen Information ends-->\r\n              <p style=\"padding-left:10px;border-bottom: 1px solid rgba(0,0,0,.1);\"\r\n                class=\"prod-detail-desc hidden-sm-down\"></p>\r\n            </div>\r\n            \r\n            <div ng-if=\"productDetail.currentLink.hasLinkToShow && productDetail.currentLink.display_in==productDetail.APP.ORDER.DISPLAY_IN.PRODUCT\">\r\n              <p class=\"gray-text mb-4\" style=\"font-size:12px;\">\r\n              <a href=\"{{productDetail.currentLink.constructedLink}}\" target=\"_blank\">{{productDetail.currentLink.linkName}}</a></p>\r\n\r\n              <p style=\"padding-left:10px;border-bottom: 1px solid rgba(0,0,0,.1);\" class=\"prod-detail-desc hidden-sm-down\"></p>\r\n            </div>\r\n\r\n            <div class=\"row m-x-0 thumbnail-slider hidden-md-up\"\r\n              ng-style=\"productDetail.isIpad() ? {'text-align': 'center'} :(!productDetail.isNotMobile() ? '' : '')\"\r\n              ng-if=\"productDetail.referralProducts && productDetail.referralProducts.length > 0 && productDetail.referralProducts[0].referredItems && productDetail.referralProducts[0].referredItems.length > 0\">\r\n              <br />\r\n              <div style=\"text-align:left;\"\r\n                ng-style=\"productDetail.isIpad() ? {'padding': '0px 33px'} : {'padding': '0px 30px'}\"\r\n                class=\"prod-detail-desc\">Related items: </div>\r\n\r\n              <img ng-click=\"scrollToLeft()\" class=\"arrow-icons\" src={{productDetail.leftArrow}} />\r\n              <div class=\"limit\" thumbnail-slider=\"100\"\r\n                ng-style=\"productDetail.isIpad() ? {'max-width':'79%'} :{'max-width':'84%'}\">\r\n\r\n                <div class=\"content\">\r\n                  <div ng-click=\"productDetail.goToProductPage(item)\" class=\"slide-item\"\r\n                    ng-repeat=\"item in productDetail.referralProducts[0].referredItems\">\r\n                    <img ng-style=\"productDetail.isIpad() ? {'width': '62px'} : {'width': '71px'}\"\r\n                      src={{item.smallImageUrl}} alt=\"{{item.alt ? item.alt : item.name}}\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <img ng-click=\"scrollToRight()\" class=\"arrow-icons\" src={{productDetail.homeArrow}}>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- <div class=\"row product-detail-page\" ng-class=\"productDetail.isNotMobile() ? '' : 'm-x-0'\"> -->\r\n        <div ng-click=\"productDetail.goToDsc();\" class=\"col-md-12 hidden-md-up\"\r\n          ng-style=\"!productDetail.isNotMobile()? productDetail.noPadding:''\">\r\n          <img style=\" position: relative;width:100%; \" src={{productDetail.dscCardMobile}}\r\n            title=\"{{productDetail.dscAltTag}}\">\r\n        </div>\r\n        <!-- </div> -->\r\n      </div>\r\n      <div ng-class=\"productDetail.isIpad()?'col-md-3':'col-md-2'\" class=\"p-x-0 \"\r\n        style=\"text-align: center;min-height:7vh;\"\r\n        ng-style=\"productDetail.isNotMobile() && !productDetail.isIpad()? {'width':'21.40%'} : ''\">\r\n        <!-- Regular Price and Quantity if not DSC -->\r\n        <div class=\"row hidden-sm-down\"\r\n          style=\"border: 1px solid lightgrey;height: auto;margin-top: 21px;padding: 10px;width: 100%;\">\r\n          <div class=\"col-xs-12 p-x-0 bag-detail-bg hidden-sm-down\"\r\n            ng-if=\"!productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n            <!-- Quantity -->\r\n            <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\" class=\"col-sm-12 \"\r\n              ng-class=\"{'has-danger': (productDetailForm.$submitted || productDetailForm.quantity.$touched) && productDetailForm.quantity.$invalid}\">\r\n\r\n              <p class=\"product-text-md\" style=\"float:left;\">Quantity</p>\r\n              <div class=\"input-group\" style=\"max-width:170px;\">\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" ng-disabled=\"productDetail.quantity < 2\" class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.quantity = productDetail.quantity - 1\">&#150;</button>\r\n                </span>\r\n                <input name=\"quantity\" disabled type=\"number\" class=\"form-control counter-input\"\r\n                  ng-init=\"productDetail.quantity = 1\" ng-model=\"productDetail.quantity\" ng-min=\"1\" ng-max=\"999999\" />\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.quantity = productDetail.quantity + 1\">+</button>\r\n                </span>\r\n              </div>\r\n\r\n            </div>\r\n\r\n          </div>\r\n          <!-- Regular Price and Quantity if DSC -->\r\n          <div ng-show=\"productDetail.storeName && productDetail.storeName != ''\"\r\n            class=\" hidden-sm-down col-xs-12 p-x-0 bag-detail-bg\"\r\n            ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n\r\n            <!-- Bag Weight -->\r\n            <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\" class=\"hidden-sm-down\">\r\n              <div class=\"col-xs-12 product-weight-align col-sm-12 p-l-0 p-r-0\">\r\n                <p class=\"product-text-md\"\r\n                  ng-if=\"productDetail.filteredList.length && productDetail.filteredList.length == 1\">Weight</p>\r\n                <p class=\"product-text-md\"\r\n                  ng-if=\"productDetail.filteredList.length && productDetail.filteredList.length > 1\">Select Weight</p>\r\n                <span class=\"tag m-b-10 product-weight\"\r\n                  ng-class=\"item.id === productDetail.selectedItem.id ? 'tag-primary-updated' : 'tag-default-updated'\"\r\n                  ng-repeat=\"item in productDetail.filteredList = (productDetail.detail.itemList | filter: productDetail.masterCodeChecker | orderBy: 'weight')\"\r\n                  ng-click=\"productDetail.selectWeight(item)\">\r\n                  {{item.weight}}\r\n                  <span class=\"lb-text\">lbs</span>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <!-- Quantity -->\r\n            <div ng-if=\"productDetail.storeName && productDetail.storeName != ''\" class=\"col-sm-12 p-t-0\"\r\n              ng-class=\"{'has-danger': (productDetailForm.$submitted || productDetailForm.quantity.$touched) && productDetailForm.quantity.$invalid}\">\r\n\r\n              <p class=\"product-text-md\" style=\"float:left;\">Quantity</p>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" ng-disabled=\"productDetail.quantity < 2\" class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.quantity = productDetail.quantity - 1\">&#150;</button>\r\n                </span>\r\n                <input name=\"quantity\" disabled type=\"number\" class=\"form-control counter-input\"\r\n                  ng-init=\"productDetail.quantity = 1\" ng-model=\"productDetail.quantity\" ng-min=\"1\" ng-max=\"999999\" />\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.quantity = productDetail.quantity + 1\">+</button>\r\n                </span>\r\n              </div>\r\n\r\n            </div>\r\n\r\n          </div>\r\n          <!-- Not all product available div -->\r\n          <div class=\" row  product-detail-page\" ng-class=\"productDetail.isNotMobile() ? '' : 'm-x-0'\"\r\n            ng-hide=\"productDetail.storeName && productDetail.storeName != ''\">\r\n            <div class=\"col-md-12 hidden-md-up text-xs-center\">\r\n\r\n              <br><product-promo></product-promo> <br>\r\n            </div>\r\n            <div class=\"col-md-12 hidden-sm-down\" style=\"height:60px; padding:0;\">\r\n              <product-promo></product-promo> <br>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-xs-12 p-x-0\">\r\n            <span ng-style=\"!productDetail.isNotMobile()? productDetail.Padding:''\" class=\"font-weight-bold\"\r\n              style=\"font-size: 0.9rem;float: left;padding-left: 15px;\"\r\n              ng-hide=\"productDetail.storeName && productDetail.storeName != ''\">Ready\r\n              to Order ? <span ng-if=\"!productDetail.isNotMobile()\" ng-click=\"productDetail.openStoreSelector()\"><a\r\n                  href=\"\" class=\"anchor_link_find_stores\">find my store for pricing and <span\r\n                    ng-style=\"!productDetail.isNotMobile()? 'padding-left: 24px':''\">availability</span></a></span></span>\r\n            <span ng-if=\"productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.availableBackOn\">Expected\r\n              availability: {{productDetail.selectedItem.availableBackOnDateString}}</span>\r\n          </div>\r\n\r\n          <!-- <div class=\"col-xs-12 p-x-0 p-y-1 hidden-sm-down\" ng-if=\"productDetail.selectedItem.masterProduct.dimensions\"> -->\r\n          <!-- <div class=\"col-sm-12\">\r\n            <p class=\"product-text-md\" style=\"float:left;position:absolute;\">Dimensions: </p>\r\n            <span class=\"product-dimension-value\">\r\n          {{productDetail.selectedItem.masterProduct.dimensions}}</span>\r\n        </h6>\r\n      </div> -->\r\n          <!-- </div> -->\r\n          <div class=\"hidden-sm-down\" ng-if=\"productDetail.isDeliveryError\">\r\n            <div class=\"col-md-12\">\r\n              <span class=\"alert-text\" style=\"font-size:13px;\">\r\n                {{productDetail.isDeliveryError}}\r\n              </span>\r\n            </div>\r\n          </div>\r\n\r\n\r\n          <div ng-class=\"productDetail.isIpad()?'col-md-12':'col-md-12'\" class=\"hidden-sm-down\"\r\n            ng-show=\"productDetail.storeName && productDetail.storeName != ''\" ng-if=\"!productDetail.forSubscription\"\r\n            style=\"margin-top: 15px;\">\r\n            <span\r\n              ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.deliveryType === 'InStore'\"\r\n              class=\"delivery-type-only hidden-sm-down\">In Store/Curbside Pickup Only</span>\r\n            <span\r\n              ng-if=\"!productDetail.selectedItem.isOutOfStock && productDetail.selectedItem.deliveryType === 'DropShip'\"\r\n              class=\"delivery-type-only hidden-sm-down\">Delivery Only</span>\r\n            <span ng-if=\"productDetail.selectedItem.isOutOfStock\" class=\"out_of_stock hidden-sm-down\">Temporarily\r\n              Unavailable</span>\r\n            <button type=\"button\" class=\"mb-4 btn btn-lg btn-primary  btn-block btn-md-text ng-scope\"\r\n              ng-disabled=\"productDetail.selectedItem.isOutOfStock\"\r\n              ng-click=\"productDetail.addItemToCart(productDetailForm)\">\r\n              Add to Cart\r\n            </button>\r\n          </div>\r\n          <!-- <div ng-class=\"productDetail.isIpad()?'col-md-12':'col-md-12'\" class=\"hidden-sm-down\" ng-show=\"productDetail.storeName && productDetail.storeName != ''\"\r\n          ng-if=\"productDetail.isItemAdded && !productDetail.forSubscription\" >\r\n          <button type=\"button\" ng-click=\"productDetail.goToCart()\" class=\" mb-4 btn btn-lg btn-primary  btn-block btn-md-text ng-scope\" style=\"margin-top: 15px;\">\r\n            Go to Cart\r\n          </button>\r\n        </div> -->\r\n          <div ng-class=\"productDetail.isIpad()?'col-md-12':'col-md-12'\" class=\"hidden-sm-down\"\r\n            ng-show=\"productDetail.storeName && productDetail.storeName != ''\" ng-if=\"productDetail.forSubscription\">\r\n            <button ng-click=\"productDetail.addItemToSubscription(productDetailForm)\" type=\"button\"\r\n              class=\" mb-4 btn btn-lg btn-primary  btn-block btn-md-text ng-scope\" style=\"margin-top: 15px;\">\r\n              ADD TO SUBSCRIPTION\r\n            </button>\r\n          </div>\r\n          <div ng-class=\"productDetail.isIpad()?'col-md-12':'col-md-12'\" class=\"hidden-sm-down\" style=\"display:none;\"\r\n            ng-if=\"!productDetail.isLoggedIn\">\r\n            <button ng-click=\"productDetail.openStoreSelector()\" type=\"button\"\r\n              class=\" mb-4 btn btn-lg btn-primary  btn-block btn-md-text ng-scope\" style=\"margin-top: 15px;\">\r\n              Choose Another Store\r\n            </button>\r\n          </div>\r\n          <div ng-class=\"productDetail.isIpad()?'col-md-12':'col-md-13'\" class=\"hidden-sm-down\" style=\"display:none;\">\r\n            <button type=\"button\" class=\" mb-4 btn btn-lg btn-primary  btn-block btn-md-text ng-scope\"\r\n              style=\"margin-top: 15px;\">\r\n              Continue\r\n            </button>\r\n          </div>\r\n          <div ng-if=\"productDetail.isLoggedIn\" class=\"hidden-sm-down\"\r\n            ng-class=\"productDetail.isIpad()?'col-md-12':'col-md-12'\"\r\n            ng-hide=\"productDetail.storeName && productDetail.storeName != ''\">\r\n            <button ng-click=\"productDetail.openStoreSelector()\" type=\"button\"\r\n              class=\" mb-4 btn btn-lg btn-primary  btn-block btn-md-text ng-scope\" style=\"margin-top: 15px;\">\r\n              Choose Store\r\n            </button>\r\n          </div>\r\n          <div class=\"hidden-sm-down col-md-12\" style=\"display: inline-flex;margin-top: 15px;\"\r\n            ng-hide=\"productDetail.storeName && productDetail.storeName != ''\">\r\n            <button ng-click=\"productDetail.openStoreSelector()\" style=\"width:50%;padding: 5px 5px;\" type=\"button\"\r\n              class=\"btn-pad mb-4 btn btn-lg btn-primary btn-md-text\">\r\n              <span class=\"font-weight-bold\" style=\"font-size: 12px;float:left;\">Find My Store</span> <br><span\r\n                class=\"find_stores_availability\">for pricing & availability</span>\r\n            </button>\r\n            <button ng-click=\"productDetail.openLoginPopup()\" type=\"button\" style=\"width:50%;font-size: 12px;\"\r\n              class=\"btn-pad font-weight-bold login-btn mb-4 btn btn-lg btn-primary btn-md-text ng-scope\">\r\n              Login\r\n            </button>\r\n          </div>\r\n\r\n        </div>\r\n\r\n\r\n        <!-- ng-if=\"!productDetail.isMobileDevice()\" -->\r\n        <div class=\"row hidden-sm-down\" style=\"height: auto;margin-top:10px;width: 100%;\"\r\n          ng-style=\"productDetail.isDscClickable ? {'cursor': 'pointer'} : ''\">\r\n          <img ng-click=\"productDetail.goToDsc();\" class=\"hidden-sm-down\" src={{productDetail.dscCard}}\r\n            ng-class=\"productDetail.isIpad() ? 'dsc-img-size-ipad' :'dsc-img-size-desktop'\"\r\n            title=\"{{productDetail.dscAltTag}}\">\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n    <hr ng-if=\"productDetail.canShowQAhr\">\r\n    <div>\r\n      <div ng-if=\"!productDetail.productNotFound\" id=\"pr-reviewdisplay\"></div>\r\n      <div ng-style=\"!productDetail.isNotMobile() ? {'padding': '15px'} : ''\" ng-if=\"!productDetail.productNotFound\"\r\n        id=\"pr-questiondisplay\"></div>\r\n    </div>\r\n    <!-- Buttons on SM, XS devices -->\r\n\r\n    <div class=\"row m-x-0 p-x-0 btn-product-detail hidden-md-up\">\r\n      <!-- <div ng-if=\"!productDetail.forSubscription \" class=\"col-xs-6 p-x-0\">\r\n        <button type=\"button\" ng-show=\"productDetail.storeName && productDetail.storeName != '' \" class=\"btn btn-lg btn-primary btn-bdr btn-block\"\r\n          ng-disabled=\"productDetail.disableAddToCart || productDetail.selectedItem.isOutOfStock\" ng-if=\"!productDetail.isItemAdded\" ng-click=\"productDetail.addItemToCart(productDetailForm)\">Add\r\n          to Cart\r\n        </button>\r\n\r\n        <button type=\"button\" ng-show=\"productDetail.storeName && productDetail.storeName != ''\"  ng-click=\"productDetail.goToCart()\" class=\"btn btn-lg btn-primary btn-bdr btn-block\"\r\n          ng-if=\"productDetail.isItemAdded\">Go\r\n          to Cart</button>\r\n        <button ng-hide=\"productDetail.storeName && productDetail.storeName != '' \" ng-click=\"productDetail.openStoreSelector()\"\r\n          type=\"button\" class=\"btn-pad-mob btn btn-lg btn-primary btn-bdr btn-block m-t-0\">\r\n          <span class=\"font-weight-bold\"  style=\"font-size: 14px;\">Find My Store</span> <br><span style=\"font-size: 9px;\" >for pricing & availability</span>\r\n        </button>\r\n\r\n      </div>       -->\r\n      <div class=\"p-t-1 col-md-12\" ng-if=\"productDetail.isDeliveryError\">\r\n        <div class=\"alert-user oos-msg\">\r\n          <span><img class=\"alert-icon\" src={{productDetail.alertIcon}}></span>\r\n          <span class=\"alert-text\">\r\n            {{productDetail.isDeliveryError}}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <div ng-if=\"!productDetail.forSubscription \" class=\"col-xs-6 p-x-0\">\r\n        <!-- <div ng-if=\"!productDetail.isLoggedIn\">\r\n        <button ng-click=\"productDetail.openLoginPopup()\" ng-hide=\"productDetail.storeName && productDetail.storeName != '' \"\r\n          type=\"button\" class=\"btn btn-lg btn-primary btn-block \">\r\n          Login\r\n        </button>\r\n      </div> -->\r\n\r\n\r\n      </div>\r\n      <div class=\"col-xs-12 p-x-0\" ng-if=\"productDetail.forSubscription \">\r\n        <a>\r\n          <button type=\"button\" class=\"btn btn-lg btn-primary btn-block btn-md-text\"\r\n            ng-click=\"productDetail.addItemToSubscription(productDetailForm)\">ADD\r\n            TO SUBSCRIPTION</button>\r\n        </a>\r\n      </div>\r\n    </div>\r\n\r\n\r\n  </form>\r\n</div>\r\n\r\n<div class=\"modal\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\">\r\n  <div class=\"modal-dialog\" style=\"max-width:1000px !important\" role=\"document\">\r\n    <div class=\"modal-content\" style=\"overflow: hidden;\">\r\n      <div class=\"modal-header-imgpopup modalheaderbg\" style=\"\">\r\n        <div class=\"row\" style=\"width: 100%;padding: 5px;\">\r\n          <div class=\"col-md-12\" style=\"\">\r\n            <ul class=\"nav\" style=\"display: inline-flex;\">\r\n              <li ng-class=\"{ 'active-tab': productDetail.isShowVideo }\" style=\"padding: 5px;\">\r\n                <h5><a href ng-click=\"productDetail.showVideo()\">Video(s)</a></h5>\r\n              </li>\r\n              <li ng-class=\"{ 'active-tab': productDetail.isShowImage }\" style=\"padding: 5px; margin-left: 20px;\">\r\n                <h5><a href ng-click=\"productDetail.showImage()\">Image(s)</a></h5>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <button type=\"button\" style=\"position: relative;float: right;\" class=\"close\" data-dismiss=\"modal\"\r\n          aria-label=\"Close\" ng-click=\"productDetail.closepopup()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n      </div>\r\n      <div class=\"modal-body modalbody\">\r\n\r\n        <div class=\"slideshow-container\"\r\n          ng-if=\"!productDetail.selectedItem.isOutOfStock && (productDetail.imageListZoom.length > 0 || productDetail.videoListZoom.length > 0) && productDetail.isNotMobile()\">\r\n          <div class=\"slide_row_zoom\">\r\n            <div class=\"limit slide-height\" id=\"slide1\" thumbnail-slider=\"100\" style=\"\">\r\n              <div class=\"content\" ng-if=\"productDetail.isShowImage\">\r\n                <div class=\"position-rel\" style=\"height:60px;\" ng-repeat=\"item in productDetail.imageListZoom\">\r\n                  <img class=\"demo cursor slide-tumb\" src=\"{{item.largeUrl}}\" style=\"\"\r\n                    ng-click=\"productDetail.currentSlideZoom($index + 1)\">\r\n                </div>\r\n              </div>\r\n              <div class=\"content\" ng-if=\"productDetail.isShowVideo\">\r\n                <div class=\"position-rel\" style=\"height:60px;\" ng-repeat=\"item in productDetail.videoListZoom\">\r\n                  <video class=\"demo cursor slide-tumb thumbnail\" src=\"{{trustSrc(item.rawUrl)}}\" style=\"\"\r\n                    ng-click=\"productDetail.currentSlideZoom($index + 1)\"></video>\r\n                  <div class=\"playButton\" ng-click=\"productDetail.currentSlideZoom($index + 1)\"></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div ng-If=\"productDetail.isShowImage\">\r\n            <div class=\"image-display\">\r\n              <div class=\"mySlides1 slidefade\" ng-repeat=\"item in productDetail.imageListZoom\">\r\n                <img src=\"{{item.largeUrl}}\" style=\"width:300px;height:300px\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div ng-If=\"productDetail.isShowVideo\">\r\n            <div class=\"image-display\">\r\n              <div class=\"mySlides1 slidefade\" ng-repeat=\"video in productDetail.videoListZoom\">\r\n                <video controls class=\"embed-responsive-item\" style=\"width:300px;height:300px\" id=\"itemVideo{{$index}}\">\r\n                  <source src=\"{{trustSrc(video.rawUrl)}}\" type=\"video/mp4\" />\r\n                </video>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"mt-2\">\r\n          <button class=\"pull-right mb-2 mr-2 btn btn-primary bg-white border-primary btncancel\"\r\n            ng-click=\"productDetail.closepopup()\">\r\n            Cancel\r\n          </button>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Add to cart popup start desktop -->\r\n\r\n<div class=\"modal\" id=\"addtocartModal\" tabindex=\"-1\" role=\"dialog\">\r\n  <div class=\"modal-dialog\" style=\"max-width:700px !important\">\r\n    <div class=\"modal-content modal-content-popup-width\" style=\"overflow: hidden;\">\r\n      <div class=\"modal-header-addtocartpopup modalheaderbg\">\r\n        <div class=\"row m-x-0\" style=\"width: 100%;padding: 5px;\">\r\n          <div class=\"col-md-8\">\r\n            <ul class=\"nav\" style=\"display: inline-flex;\">\r\n              <li style=\"padding: 5px;\">\r\n                <strong><a class=\" pull-xs-right\"\r\n                    style=\"margin-right: 15px;margin-top: 0px;font-size: 0.85rem;height: 30px;color:#a4182d;padding-top: 8px;\"><img\r\n                      ng-src={{productDetail.addedtoCartTick}} class=\"mb-8\"\r\n                      style=\"padding-right: 5px; padding-top: 4px; height: 18px;\" />Added to Cart!</a></strong>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"col-md-4\" style=\"margin-top: 12px;\">\r\n            <button type=\"button\" class=\"close addtocart-popup-closeicon\" data-dismiss=\"modal\" aria-label=\"Close\"\r\n              ng-click=\"productDetail.closeAddtoCartpopup()\">\r\n              <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n            <span class=\"addtocart-popup-close\" ng-click=\"productDetail.closeAddtoCartpopup()\">Close</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-body modalbody\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-3\">\r\n            <img class=\"cursor\" src=\"{{productDetail.selectedItem.largeImageUrl}}\" style=\"width:100%;margin-top: 10px;\">\r\n          </div>\r\n          <div class=\"col-md-9\">\r\n            <div class=\"font-weight-bold hidden-sm-down m-t-15\">\r\n              <span class=\"font-weight-bold \" style=\"font-size: 1rem\" ng-bind=\"productDetail.detail.name\"></span>\r\n            </div>\r\n\r\n            <span\r\n              ng-repeat=\"item in productDetail.filteredList_d = (productDetail.detail.itemList | filter: productDetail.masterCodeChecker | orderBy: 'weight')\"></span>\r\n            <div class=\"font-weight-bold hidden-sm-down m-t-15 \" style=\"display: inline-flex\"\r\n              ng-if=\"productDetail.filteredList_d.length && productDetail.filteredList_d.length >= 1\">\r\n              <span style=\"margin-top:10px\" ng-if=\"productDetail.selectedItem.weight\">Weight</span>\r\n              <span class=\"tag product-weight tag-primary-updated\" style=\"margin-left:20px\">\r\n                {{productDetail.selectedItem.weight}}\r\n                <span class=\"lb-text\">lbs</span>\r\n              </span>\r\n            </div>\r\n\r\n\r\n            <div class=\"font-weight-bold m-t-15 hidden-sm-down\" style=\"display: inline-flex\">\r\n              Quantity\r\n              <div class=\"input-group popup-qty-input\">\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" ng-disabled=\"productDetail.quantityToBeAdded < 2\"\r\n                    class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.updateItemInCart(productDetail.quantityAction.ReducingQuantity,productDetail.quantityToBeAdded,productDetail.selectedItem)\">&#150;</button>\r\n                </span>\r\n                <input name=\"quantityToBeAdded\" disabled type=\"number\" class=\"form-control counter-input\"\r\n                  ng-init=\"productDetail.quantityToBeAdded = 1\" ng-model=\"productDetail.quantityToBeAdded\" ng-min=\"1\"\r\n                  ng-max=\"100\" />\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.updateItemInCart(productDetail.quantityAction.AddingQuantity,productDetail.quantityToBeAdded,productDetail.selectedItem)\">+</button>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"row m-t-15 \">\r\n              <div class=\" col-md-5 font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                <span class=\"product-text-md\">Regular Price</span>\r\n              </div>\r\n              <!-- DSC Price -->\r\n              <div class=\"col-md-7 font-weight-bold\"\r\n                ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                <span class=\"product-text-md\">Daily Savings Club Price</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" ng-if=\"!productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n              <div class=\" col-md-5 font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                <span class=\"product-text-md\">$ {{productDetail.selectedItem.price | number : 2}}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n              <div class=\" col-md-5 font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                <span ng-if=\"!productDetail.isDscMember()\" class=\"product-text-md\">$ {{productDetail.selectedItem.price\r\n                  | number : 2}}</span>\r\n                <strike ng-if=\"productDetail.isDscMember()\" class=\"product-text-md\">$ {{productDetail.selectedItem.price\r\n                  | number : 2}}</strike>\r\n              </div>\r\n              <!-- DSC Price -->\r\n              <div class=\"col-md-7 font-weight-bold\"\r\n                ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                <span class=\"product-text-md\">$ {{(productDetail.selectedItem.price * 85 / 100) | number : 2}}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"modal-footer modal-footer-addcart-popup\">\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"mt-2\">\r\n          <button class=\"pull-left mb-2 continue-shopping-font mr-2 btn bg-white border-primary btncancel\"\r\n            ng-click=\"productDetail.closeAddtoCartpopup()\">\r\n            Continue Shopping\r\n          </button>\r\n          <button class=\"pull-right mb-2 continue-shopping-font mr-2 btn btn-primary bg-white border-primary btncancel\"\r\n            ng-click=\"productDetail.goToCart()\">\r\n            View Cart & Checkout\r\n          </button>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Add to cart popup end desktop-->\r\n\r\n<!-- Add to cart popup start mobile-->\r\n\r\n<div class=\"modal\" id=\"addtocartMobileModal\" tabindex=\"-1\" role=\"dialog\">\r\n  <div class=\"modal-dialog\" style=\"max-width:1000px !important\">\r\n    <div class=\"modal-content modal-content-popup-width-mob\" style=\"overflow: hidden;\">\r\n      <div class=\"modal-header-addtocartpopup modalheaderbg\">\r\n        <div class=\"row m-x-0\" style=\"width: 100%;padding: 5px;display: inline-flex;\">\r\n          <div class=\"col-md-8\" style=\"width: 75%;\">\r\n            <ul class=\"nav\" style=\"display: inline-flex;\">\r\n              <li style=\"padding: 5px;\">\r\n                <strong><a class=\" pull-xs-right\"\r\n                    style=\"margin-right: 15px;margin-top: 0px;font-size: 0.85rem;height: 30px;color:#a4182d;padding-top: 8px;\"><img\r\n                      ng-src={{productDetail.addedtoCartTick}} class=\"mb-8\"\r\n                      style=\"padding-right: 5px; padding-top: 4px; height: 18px;\" />Added to Cart!</a></strong>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"col-md-4\" style=\"margin-top: 17px;width: 34%;\">\r\n            <button type=\"button\" class=\"close addtocart-popup-closeicon-mob\" data-dismiss=\"modal\" aria-label=\"Close\"\r\n              ng-click=\"productDetail.closeAddtoCartMobilepopup()\">\r\n              <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n            <span class=\"addtocart-popup-close-mob\" ng-click=\"productDetail.closeAddtoCartMobilepopup()\">Close</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-body modalbody\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-3 col-md-3-mob\">\r\n            <img class=\"cursor img-mob\" src=\"{{productDetail.selectedItem.largeImageUrl}}\">\r\n          </div>\r\n          <div class=\"col-md-9 col-md-9-mob\">\r\n            <div class=\"font-weight-bold m-t-1 hidden-md-up\">\r\n              <span class=\"font-weight-bold m-t-1\" style=\"font-size: 0.9rem\" ng-bind=\"productDetail.detail.name\"></span>\r\n            </div>\r\n            <span\r\n              ng-repeat=\"item in productDetail.filteredList_m = (productDetail.detail.itemList | filter: productDetail.masterCodeChecker | orderBy: 'weight')\"></span>\r\n            <div class=\"font-weight-bold m-t-1\" style=\"display: inline-flex\"\r\n              ng-if=\"productDetail.filteredList_m.length && productDetail.filteredList_m.length >= 1\">\r\n              <span style=\"margin-top:10px\">Weight</span>\r\n              <span class=\"tag product-weight tag-primary-updated\" style=\"margin-left:20px\">\r\n                {{productDetail.selectedItem.weight}}\r\n                <span class=\"lb-text\">lbs</span>\r\n              </span>\r\n            </div>\r\n            <div class=\"font-weight-bold m-t-1 hidden-md-up\" style=\"display: inline-flex\">\r\n              Quantity\r\n              <div class=\"input-group popup-qty-input-mob\">\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" ng-disabled=\"productDetail.quantityToBeAdded < 2\"\r\n                    class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.updateItemInCart(productDetail.quantityAction.ReducingQuantity,productDetail.quantityToBeAdded,productDetail.selectedItem)\">&#150;</button>\r\n                </span>\r\n                <input name=\"quantityToBeAdded\" disabled type=\"number\" class=\"form-control counter-input \"\r\n                  ng-init=\"productDetail.quantityToBeAdded = 1\" ng-model=\"productDetail.quantityToBeAdded\" ng-min=\"1\"\r\n                  ng-max=\"100\" />\r\n                <span class=\"input-group-btn\">\r\n                  <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                    ng-click=\"productDetail.updateItemInCart(productDetail.quantityAction.AddingQuantity,productDetail.quantityToBeAdded,productDetail.selectedItem)\">+</button>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"row m-t-1\"\r\n              ng-if=\"!productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n              <div class=\" col-md-6 font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                <span class=\"product-text-md\">Regular Price: </span>\r\n                <span class=\"product-text-md\">$ {{productDetail.selectedItem.price | number : 2}}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"row m-t-1\"\r\n              ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n              <div class=\" col-md-6 font-weight-bold\" ng-if=\"productDetail.selectedItem.price\">\r\n                <span class=\"product-text-md\">Regular Price: </span>\r\n                <span ng-if=\"!productDetail.isDscMember()\" class=\"product-text-md\">$ {{productDetail.selectedItem.price\r\n                  | number : 2}}</span>\r\n                <strike ng-if=\"productDetail.isDscMember()\" class=\"product-text-md\">$ {{productDetail.selectedItem.price\r\n                  | number : 2}}</strike>\r\n              </div>\r\n              <!-- DSC Price -->\r\n              <div class=\"col-md-6 m-t-1 font-weight-bold\"\r\n                ng-if=\"productDetail.selectedItem.masterProduct.subCategories[0].category.dscCategory\">\r\n                <span class=\"product-text-md\">Daily Savings Club Price</span>\r\n                $ {{(productDetail.selectedItem.price * 85 / 100) | number : 2}}\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"modal-footer modal-footer-addcart-popup\">\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"mt-2 display-grid\">\r\n          <button class=\"pull-right mb-5 mr-2 btn btn-primary bg-white border-primary btncancel\"\r\n            ng-click=\"productDetail.goToCart()\">\r\n            View Cart & Checkout\r\n          </button>\r\n\r\n          <button style=\"margin-top: 3%;\" class=\"pull-left mb-5 mr-2 btn bg-white border-primary btncancel\"\r\n            ng-click=\"productDetail.closeAddtoCartMobilepopup()\">\r\n            Continue Shopping\r\n          </button>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Add to cart popup end mobile-->"

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08c15882317b0b3c4b3871c08aa63416.png";

/***/ },
/* 189 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "de8175a0fcc989773a2faa993e8bb9c4.png";

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07bb7d5531aed00c1ea0fbc630ac4372.png";

/***/ },
/* 192 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAIRSURBVDhPbZPPTxNBFMff/FgRBUraqKESLAcTNXAwcOFGgiEQT3rXg/FoNPHgQSUkAmej8S/QOwc1SLRHE0JCFLloUhIkpbVp0tJ2DbR2Z9b3hmnZ3fJJJjvvu/Nm5739DoMIiUSitzrx8IqOJad97gyTxrzmDnfzn2Nrr3+VSiXXLLQEN3DkzPyYlxx9AZzfwDiyue+D1mlZ2JrzVha+odAktbXIEbdezqr40DtgrM9qMH6p36zY+F2xCuJDVexn76jlR6sYNTlp9OVo8rWBXlh/NgnrTydh9GJbpg1jKj74Vt6cv04hp5q95MhCMJnoOS2BM2aGI8x3ArB+78LIIuVyahhwMWXftMlX6uaJlUO2fGDmIZiYqk08uMyp2xQeqccU3QZozG54CsoHpl9h8HAqNjjLW78qyj9PQ7HWgEK1AUrjMU6AcqPFhcjuH0Kucmijk+FkEjvv4MOPArzf/GOjTihXiNR4Xfecv49hRx+2i39hK1cDt+5ZJYDva1nOPOFkT3KYldukEmdge2kaMjiG4t1WDaBVum/tTYaTt8me5DD7ytB9SkCXw6FLcjMP41dkbnOOco+tfPvVDDkMS0H/HmGsjGzsBqyMyaK8e1ctPzZWbm2t/Z+rO3LgalqfPZfC3g7jf2b5ah1oGLBmPPYXuff9nvr4/CsqocvUhuxJDiOTBK+zcPc+Uc3h6wzwHzgZ1j4f4ztoAAAAAElFTkSuQmCC"

/***/ },
/* 193 */
85,
/* 194 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 195 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _birdFood = __webpack_require__(179);
	
	var _birdFood2 = _interopRequireDefault(_birdFood);
	
	var _power = __webpack_require__(193);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _review = __webpack_require__(197);
	
	var _review2 = _interopRequireDefault(_review);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductReview = (_dec = (0, _utils.Component)({
	  controllerAs: 'productReview',
	  template: _review2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ProductReview($rootScope, $scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP, ngMeta, $location) {
	    var _this = this;
	
	    _classCallCheck(this, ProductReview);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.birdFood = _birdFood2.default;
	    this.$state = $state;
	    this.$toaster = $toaster;
	    this.$auth = $auth;
	    this.$window = $window;
	    this.APP = APP;
	    this.ngMeta = ngMeta;
	    this.$location = $location;
	    this.$spinner = $spinner;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.subCategoryName = '';
	    this.categoryName = '';
	    this.storeName = '';
	    var $ctrl = this;
	    console.log("Inside power review document ");
	    // if( window.localStorage )
	    //   {
	    //     if( !localStorage.getItem('first.load.for.write.review') )
	    //     {
	    //       localStorage['first.load.for.write.review'] = true;
	    //       window.location.reload();
	    //     }  
	    //     else {
	    //       localStorage.removeItem('first.load.for.write.review');
	    //     } 
	    //   }
	
	    setTimeout(function () {
	      console.log("Waiting for 2 secs before loading power reviews to write a review");
	    }, 1000);
	
	    window.pwr = window.pwr || function () {
	      (window.pwr.q = window.pwr.q || []).push(arguments);
	    };
	    setTimeout(function () {
	      window.pwr("render", {
	        api_key: _this.APP.AUTH.AUTH_URL.pwr.api_key,
	        locale: _this.APP.AUTH.AUTH_URL.pwr.locale,
	        merchant_group_id: _this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
	        merchant_id: _this.APP.AUTH.AUTH_URL.pwr.merchant_id,
	        style_sheet: _power2.default,
	        on_render: function on_render(config, data) {
	          if (config != null) {
	            if (!$ctrl.isNotMobile()) {
	              var questionform = document.getElementsByClassName("pr-question-form");
	              if (questionform.length > 0) {
	                questionform[0].style.padding = '15px';
	              }
	              var reviewform = document.getElementsByClassName("pr-war");
	              if (reviewform.length > 0) {
	                reviewform[0].style.padding = '15px';
	              }
	            }
	          }
	        },
	        on_submit: function on_submit(config, data) {
	          window.scrollTo(0, 0);
	        },
	        components: {
	          Write: 'pr-write'
	        }
	      });
	    }, 1000);
	  }
	
	  _createClass(ProductReview, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {};
	    }
	  }, {
	    key: 'isNotMobile',
	    value: function isNotMobile() {
	      return this.$window.innerWidth > 767;
	    }
	  }]);
	
	  return ProductReview;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$stateParams', '$state', 'toaster', 'orderService', 'spinnerService', 'orderActions', 'authService', '$window', 'APP', 'ngMeta', '$location'], _temp)) || _class);
	exports.default = ProductReview;

/***/ },
/* 197 */
/***/ function(module, exports) {

	module.exports = "<div id=\"pr-write\"></div>"

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _cart = __webpack_require__(199);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _close = __webpack_require__(200);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _alert = __webpack_require__(192);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _shippingInfo = __webpack_require__(201);
	
	var _shippingInfo2 = _interopRequireDefault(_shippingInfo);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	var _lodash = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cart = (_dec = (0, _utils.Component)({
	  controllerAs: 'cart',
	  template: _cart2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Cart($scope, $rootScope, $ngRedux, $spinner, $auth, $order, $state, $uibModal, $timeout, $window, $stateParams, APP, toaster) {
	    var _this = this;
	
	    _classCallCheck(this, Cart);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.dscMasterCode = '88888888'; // Named constant
	    this.$window = $window;
	    this.APP = APP;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.$order = $order;
	    this.$scope = $scope;
	    this.$toaster = toaster;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.$stateParams = $stateParams;
	    this.houseIcon = _houseIcon2.default;
	    this.closeIcon = _close2.default;
	    this.alertIcon = _alert2.default;
	    this.$rootScope = $rootScope;
	    this.shippingOffer = {};
	    this.shippingOffer.isOfferAvailable = false;
	    this.shippingOffer.isOfferEligible = false;
	    this.couponAmount = 0;
	    this.taxableDiscountAmount = 0;
	    this.discountCouponAmount = 0;
	    this.discountCode = null;
	    this.discountType = null;
	    this.isMiscelleneousCategory = 4;
	    this.giftCardMasterCodeStartsWith = '9';
	    this.appliedDiscountCoupon = sessionStorage.getItem('discountCoupon');
	    this.appliedBirdBuckCoupon = sessionStorage.getItem('birdbuckCoupon');
	    this.erplyBBCouponDiscount = sessionStorage.getItem('erplyBBDiscount');
	    this.erplyPromotionDiscount = sessionStorage.getItem('erplyPromotionDiscount');
	    console.log("this.erplyBBCouponDiscount : ", this.erplyBBCouponDiscount);
	    console.log("this.appliedErplyPromotionDiscount : ", this.erplyPromotionDiscount);
	    this.isValidToApplyPromo = true;
	    this.baseMicroSecs = 500;
	    this.startMicroSecs = 500;
	    this.addMicroSecs = 600;
	    this.hasErplyCalShopcartRes = false;
	    this.$spinner = $spinner;
	    this.dscDiscount = 'dscdiscount';
	    this.dscPercentage = 'dscpercentage';
	    this.dscDiscountedPrice = 'dscDiscountedPrice';
	    this.loadCartPageOnce = 1;
	    this.numberOfItemsAllowedToPurchase = 40;
	    this.doPageNeedsToBeRefreshed = false;
	    //
	    this.addressDetail = {};
	    this.promoLengthToBeShown = 25;
	    var $ctrl = this;
	
	    // this.addressDetail.shippingState ? this.addressDetail.shippingState.code : ''
	
	    //
	
	    var shipToStateId;
	    $spinner.show('appSpinner');
	    var userProfile = this.$auth.getUserProfile().then(function (success) {
	      var addressObj = localStorage.getItem('deliveryAddress');
	      _this.addressDetail = addressObj ? JSON.parse(addressObj) : success.data;
	      if (_this.appliedDiscountCoupon) {
	        var isInStorePickUp = true;
	        if (_this.$rootScope.tempdeliveryMode) {
	          if (_this.$rootScope.tempdeliveryMode !== '') {
	            isInStorePickUp = _this.$rootScope.tempdeliveryMode === 'In Store Pickup' ? true : false;
	            shipToStateId = _this.getShipToStateId(isInStorePickUp);
	          } else {
	            shipToStateId = _this.getShipToStateId(true);
	          }
	        } else {
	          shipToStateId = _this.getShipToStateId(true);
	        }
	
	        _this.$order.getCouponDiscount(_this.appliedDiscountCoupon, isInStorePickUp, shipToStateId).then(function () {
	          _this.calculateDiscounts();
	          _this.validatePromoCoupon();
	        }).catch(function (err) {
	          _this.discountCouponAmount = 0;
	          _this.$auth.printCustomerGenericLogs(err);
	        });
	      }
	      if (_this.appliedBirdBuckCoupon) {
	        _this.$order.getBirdBuckCoupon(_this.appliedBirdBuckCoupon).then(function () {
	          _this.couponAmount = _this.coupon.bbCouponAmount;
	          _this.validateBBCoupon();
	        }).catch(function (err) {
	          _this.couponAmount = 0;
	          _this.$auth.printCustomerGenericLogs(err);
	        });
	      }
	      // $spinner.hide('appSpinner');
	    }).catch(function (err) {
	      _this.$auth.printCustomerGenericLogs(err);
	    }).finally(function () {
	      $spinner.hide('appSpinner');
	    });
	
	    this.shippingOffer.thresholdAmount = 1500;
	    this.shippingOfferInfoIcon = _shippingInfo2.default;
	    this.shippingOfferAvailableIcon = _shippingTick2.default;
	    this.maxPrice = 0;
	    this.maxPriceId = 0;
	    this.discountPercentage = 0.00;
	    this.$uibModal = $uibModal;
	    this.erplyDis = [];
	    $window.scrollTo(0, 0);
	    // $spinner.show('appSpinner');
	    $order.getStoreDiscountMapping();
	
	    console.log("this.profile--", this.profile);
	    var bbCoupon = [];
	    if (sessionStorage.getItem('erplyBBCouponCodes')) {
	      bbCoupon = sessionStorage.getItem('erplyBBCouponCodes').split(',');
	    }
	    var promoCoupon = [];
	    if (sessionStorage.getItem('erplyPromotionCodes')) {
	      promoCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
	    }
	    var customerId = null;
	    if (this.profile.customer) {
	      customerId = this.profile.customer.id;
	    }
	    var cartDetails = {
	      "isGuestUser": this.profile.isGuest,
	      "checkForShippingTax": false,
	      "isDiscountApplied": promoCoupon.length > 0 ? true : false,
	      "manualPromotionIDs": promoCoupon ? promoCoupon : null,
	      "couponIdentifiers": bbCoupon ? bbCoupon : null,
	      "customerId": customerId
	    };
	    userProfile.then(function () {
	      $spinner.show('appSpinner');
	      if ($ctrl.profile.store && !$ctrl.profile.store.hasErply) {
	        $order.getCartDetail().finally(function () {
	          $spinner.hide('appSpinner');
	        });
	      } else {
	        $order.getErplyCartDetail(cartDetails).then(function (success) {
	          if (success.data) {
	            if (success.data.itemToBeRemovedFromCart) {
	              _this.doPageNeedsToBeRefreshed = true;
	              var title = "Some Items removed from cart due to an internal issue";
	              var detailInfo = "Item(s) : \n";
	              if (success.data.itemToBeRemovedFromCart.hasItemsToRemoveFromCart) {
	                for (var i = 0; i < success.data.itemToBeRemovedFromCart.itemsToBeRemoved.length; i++) {
	                  detailInfo = detailInfo + success.data.itemToBeRemovedFromCart.itemsToBeRemoved[i].itemName;
	                  if (i + 1 < success.data.itemToBeRemovedFromCart.itemsToBeRemoved.length) {
	                    detailInfo = detailInfo + ",";
	                  }
	                }
	                _this.$uibModal.open({
	                  size: 'sm',
	                  backdrop: 'static',
	                  keyboard: false,
	                  template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + title + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	                  controller: ['$scope', 'orderService', '$uibModalInstance', '$window', function ($scope, $order, $uibModalInstance, $window) {
	                    $scope.ok = function () {
	                      $window.location.reload();
	                      $uibModalInstance.close();
	                    };
	                  }],
	                  resolve: {}
	                });
	              } else {
	                _this.doPageNeedsToBeRefreshed = false;
	              }
	            }
	          }
	          if ($ctrl.cartContainsDsc()) {
	            $ctrl.$order.dscPremembership().then(function (sucess1) {
	              if ($ctrl.loadCartPageOnce == 1) {
	                $spinner.show('appSpinner');
	                $ctrl.loadCartPageOnce = $ctrl.loadCartPageOnce + 1;
	                $order.getErplyCartDetail(cartDetails).then(function (success2) {}).finally(function () {
	                  $ctrl.setErplyCartResponseValue();
	                  $spinner.hide('appSpinner');
	                  // $ctrl.$auth.getUserProfile();
	                });
	              }
	            });
	          } else {
	            $ctrl.setErplyCartResponseValue();
	            $spinner.hide('appSpinner');
	          }
	          console.log('this.erplyDis', $ctrl.erplyDis);
	          console.log('this.detail.erplyPromoAndDiscount', $ctrl.detail.erplyPromoAndDiscount);
	          $spinner.hide('appSpinner');
	        }).catch(function (err) {
	          $spinner.hide('appSpinner');
	        });
	      }
	    }).catch(function (err) {
	      _this.$auth.printCustomerGenericLogs(err);
	    }).finally(function () {
	      $ctrl.calculateDiscounts();
	      $ctrl.calculateClubPoints();
	      // $spinner.hide('appSpinner');
	      // $ctrl.$auth.getUserProfile();
	    });
	
	    this.currencyType = 'USD';
	    $timeout(function () {
	      if (_this.profile.store) {
	        _this.isErplyStore = _this.profile.store.hasErply;
	        _this.country = _this.profile.store.country && _this.profile.store.country.countryCode ? _this.profile.store.country.countryCode : 'US';
	        _this.currencyType = $order.getCurrencyType(_this.country);
	      }
	    }, 800);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Cart, [{
	    key: 'mapState',
	    value: function mapState(state) {
	
	      return {
	        profile: state.auth.profile,
	        detail: state.order.cartDetail,
	        discountCoupon: state.order.discountCoupon,
	        coupon: state.order.coupon,
	        storeDiscountMap: state.order.storeDiscountMap,
	        orderPoints: state.order.orderPoints
	      };
	    }
	  }, {
	    key: 'getRetailPrice',
	    value: function getRetailPrice(quantity, price) {
	      return quantity * price;
	    }
	  }, {
	    key: 'getClubDiscount',
	    value: function getClubDiscount(quantity, price) {
	      return this.getRetailPrice(quantity, price) - this.getDiscountedPrice(quantity, price);
	    }
	  }, {
	    key: 'getDiscountedPrice',
	    value: function getDiscountedPrice(quantity, price) {
	      return quantity * (Math.round(0.85 * price * 100) / 100);
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'getMaxItemDiscount',
	    value: function getMaxItemDiscount(discount, price) {
	
	      return Math.round(discount * price / 100 * 100) / 100;
	    }
	  }, {
	    key: 'totalRetailPrice',
	    value: function totalRetailPrice() {
	      return this.detail.cartItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      });
	    }
	  }, {
	    key: 'getSavedAmount',
	    value: function getSavedAmount() {
	      return this.getSubtotal() - this.getDSCAmount();
	    }
	  }, {
	    key: 'getErplySaveAmount',
	    value: function getErplySaveAmount() {
	      return this.detail.erplyShopCartResponse.originalPriceTotal - this.getDSCAmount();
	    }
	  }, {
	    key: 'getDSCAmount',
	    value: function getDSCAmount() {
	      var totalPrice = 0;
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          var maxPrice = 0;
	          var maxPriceId = 0;
	          var isDscMember = true;
	          angular.forEach(this.detail.cartItems, function (item, key) {
	            // console.log(key);
	            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	              maxPriceId = item.item.id;
	              maxPrice = item.item.price;
	            }
	          });
	
	          angular.forEach(this.detail.cartItems, function (item, key) {
	            // console.log(key);
	            if (maxPriceId === item.item.id) {
	              if (item.subCategory.category.dscCategory && isDscMember) {
	                totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	              }
	              totalPrice = totalPrice + item.item.price;
	            } else {
	              if (item.subCategory.category.dscCategory && isDscMember) {
	                totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	              }
	            }
	          });
	        }
	      } else {
	        var dscItems = this.detail.cartItems.filter(function (item) {
	          return item.subCategory.category.dscCategory;
	        });
	        var dscTotal = dscItems.map(function (item) {
	          return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var nondscItems = this.detail.cartItems.filter(function (item) {
	          return !item.subCategory.category.dscCategory;
	        });
	        var nonDscTotal = nondscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        totalPrice = dscTotal + nonDscTotal;
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'isCartHasDSCItems',
	    value: function isCartHasDSCItems() {
	      var dscItems = this.detail.cartItems.filter(function (item) {
	        return item.subCategory.category.dscCategory;
	      });
	      if (dscItems.length > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'getCouldSaveDSCPrice',
	    value: function getCouldSaveDSCPrice() {
	      var totalPrice = 0;
	      var dscItems = this.detail.cartItems.filter(function (item) {
	        return item.subCategory.category.dscCategory;
	      });
	      var dscTotal = dscItems.map(function (item) {
	        return Math.round(0.15 * item.item.price * 100) / 100 * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	      var nondscItems = this.detail.cartItems.filter(function (item) {
	        return !item.subCategory.category.dscCategory;
	      });
	      var nonDscTotal = nondscItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	      totalPrice = dscTotal + nonDscTotal;
	      return totalPrice;
	    }
	  }, {
	    key: 'getSubtotal',
	    value: function getSubtotal() {
	      var totalPrice = 0;
	      if (this.profile.store.hasErply) {
	        // console.log("This erplyShop : ", this.detail.erplyShopCartResponse);
	        totalPrice = this.detail.erplyShopCartResponse.subTotal; // subtotal has promotions and BB discounted
	      }
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          var maxPrice = 0;
	          var maxPriceId = 0;
	          var isDscMember = this.isDscMember() || this.cartContainsDsc();
	          angular.forEach(this.detail.cartItems, function (item, key) {
	            // console.log(key);
	            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	              maxPriceId = item.item.id;
	              maxPrice = item.item.price;
	            }
	          });
	
	          angular.forEach(this.detail.cartItems, function (item, key) {
	            // console.log(key);
	            if (maxPriceId === item.item.id) {
	              if (item.subCategory.category.dscCategory && isDscMember) {
	                totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	              } else {
	                totalPrice = totalPrice + item.item.price * (item.quantity - 1);
	              }
	              totalPrice = totalPrice + item.item.price;
	            } else {
	              if (item.subCategory.category.dscCategory && isDscMember) {
	                totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	              } else {
	                totalPrice = totalPrice + item.item.price * item.quantity;
	              }
	            }
	          });
	        }
	      } else {
	        if (this.isDscMember() || this.cartContainsDsc()) {
	          var dscItems = this.detail.cartItems.filter(function (item) {
	            return item.subCategory.category.dscCategory;
	          });
	          var dscTotal = dscItems.map(function (item) {
	            return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	          }).reduce(function (prev, curr) {
	            return prev + curr;
	          }, 0);
	          var nondscItems = this.detail.cartItems.filter(function (item) {
	            return !item.subCategory.category.dscCategory;
	          });
	          var nonDscTotal = nondscItems.map(function (item) {
	            return item.item.price * item.quantity;
	          }).reduce(function (prev, curr) {
	            return prev + curr;
	          }, 0);
	          totalPrice = dscTotal + nonDscTotal;
	        } else {
	          totalPrice = this.totalRetailPrice();
	        }
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'getTotalSaving',
	    value: function getTotalSaving() {
	      return this.totalRetailPrice() - this.getSubtotal() + this.calculateDiscounts();
	    }
	  }, {
	    key: 'calculateDiscounts',
	    value: function calculateDiscounts() {
	      if (this.appliedDiscountCoupon) {
	        if (this.discountCoupon.enabled && !this.discountCoupon.expired) {
	          var discountCouponAmount = 0;
	          var discountPer = 0;
	          var discountTotalAmount = 0;
	          var isDscMember = this.isDscMember() || this.cartContainsDsc();
	          if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	            var maxPrice = 0;
	            var maxPriceId = 0;
	            discountPer = this.discountCoupon.discountPercentage;
	            this.discountType = this.discountCoupon.discountType;
	            angular.forEach(this.detail.cartItems, function (item, key) {
	              // console.log(key);
	              if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	                maxPriceId = item.item.id;
	                maxPrice = item.item.price;
	                discountCouponAmount = Math.round(discountPer * maxPrice / 100 * 100) / 100;
	              }
	            });
	
	            this.maxPriceId = maxPriceId;
	            this.discountPercentage = this.discountCoupon.discountPercentage;
	            this.discountCouponAmount = discountCouponAmount;
	          }
	
	          if (this.discountCoupon.discountType === 'SUBCATEGORY') {
	            this.discountType = this.discountCoupon.discountType;
	            var dscDiscountPer = this.discountCoupon.dscDiscountPercentage;
	            var nonDSCDiscountPer = this.discountCoupon.nonDscDiscountPercentage;
	
	            var subCategoriesList = this.discountCoupon.subCategories;
	            angular.forEach(this.detail.cartItems, function (item, key) {
	              // console.log(key);
	              if (item.item.masterProduct.isDiscountable && item.subCategory.category.dscCategory && isDscMember) {
	                for (var i = 0; i < subCategoriesList.length; i++) {
	                  for (var j = 0; j < item.item.masterProduct.subCategories.length; j++) {
	                    if (subCategoriesList[i].id === item.item.masterProduct.subCategories[j].id) {
	                      discountTotalAmount = discountTotalAmount + item.item.price * item.quantity;
	                      discountCouponAmount = Math.round(dscDiscountPer * discountTotalAmount / 100 * 100) / 100;
	                    }
	                  }
	                }
	              } else if (item.item.masterProduct.isDiscountable) {
	                for (var k = 0; k < subCategoriesList.length; k++) {
	                  for (var l = 0; l < item.item.masterProduct.subCategories.length; l++) {
	                    if (subCategoriesList[k].id === item.item.masterProduct.subCategories[l].id) {
	                      discountTotalAmount = discountTotalAmount + item.item.price * item.quantity;
	                      discountCouponAmount = Math.round(dscDiscountPer * discountTotalAmount / 100 * 100) / 100;
	                    }
	                  }
	                }
	              }
	            });
	            this.discountCouponAmount = discountCouponAmount;
	          }
	
	          if (this.discountCoupon.discountType === 'PERCENTAGE') {
	            this.discountType = this.discountCoupon.discountType;
	
	            discountPer = this.discountCoupon.discountPercentage;
	            angular.forEach(this.detail.cartItems, function (item, key) {
	              // console.log(key);
	              if (item.item.masterProduct.isDiscountable && item.subCategory.category.dscCategory && isDscMember) {
	                discountTotalAmount = discountTotalAmount + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	                discountCouponAmount = Math.round(discountPer * discountTotalAmount / 100 * 100) / 100;
	              } else if (item.item.masterProduct.isDiscountable) {
	                discountTotalAmount = discountTotalAmount + item.item.price * item.quantity;
	                discountCouponAmount = Math.round(discountPer * discountTotalAmount / 100 * 100) / 100;
	              }
	            });
	            this.discountCouponAmount = discountCouponAmount;
	          }
	
	          if (this.discountCoupon.discountType === 'AMOUNT') {
	            this.discountType = this.discountCoupon.discountType;
	            this.discountCouponAmount = this.discountCoupon.couponAmount;
	          }
	          if (this.discountCoupon.discountType === 'FREEITEM') {
	            this.discountType = this.discountCoupon.discountType;
	            this.discountCouponAmount = this.discountCoupon.couponAmount;
	          }
	          if (this.discountCoupon.discountType === 'BUYXGETY') {
	            this.discountType = this.discountCoupon.discountType;
	            this.discountCouponAmount = this.discountCoupon.couponAmount;
	          }
	        }
	      }
	      return this.discountCouponAmount;
	    }
	    // DSC Points is equal to subtotal (Price - discount).
	
	  }, {
	    key: 'getDscPoints',
	    value: function getDscPoints() {
	      return this.getSubtotal() - this.calculateDiscounts();
	    }
	  }, {
	    key: 'updateItemInCart',
	    value: function updateItemInCart(quantity, item) {
	      var _this2 = this;
	
	      // console.log(item);
	      var ctrl = this;
	      ctrl.startMicroSecs = ctrl.startMicroSecs + ctrl.addMicroSecs;
	      // console.log("ctrl.startMicroSecs : ",ctrl.startMicroSecs);
	      this.$order.updateItemInCart(quantity, item.item.id, item.item.masterProduct.subCategories[0].id).then(function () {
	        _this2.calculateClubPoints();
	        var bbCoupon = [];
	        if (sessionStorage.getItem('erplyBBCouponCodes')) {
	          bbCoupon = sessionStorage.getItem('erplyBBCouponCodes').split(',');
	        }
	        var promoCoupon = [];
	        if (sessionStorage.getItem('erplyPromotionCodes')) {
	          promoCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
	        }
	        var customerId = null;
	        if (_this2.profile.customer) {
	          customerId = _this2.profile.customer.id;
	        }
	        var cartDetails = {
	          "isGuestUser": _this2.profile.isGuest,
	          "checkForShippingTax": false,
	          "isDiscountApplied": promoCoupon.length > 0 ? true : false,
	          "manualPromotionIDs": promoCoupon ? promoCoupon : null,
	          "couponIdentifiers": bbCoupon ? bbCoupon : null,
	          "customerId": customerId
	        };
	        if (_this2.profile.store && _this2.profile.store.hasErply) {
	          if (!_this2.hasErplyCalShopcartRes) {
	            ctrl.hasErplyCalShopcartRes = true;
	            setTimeout(function () {
	              // console.log("Inside set time ctrl.startMicroSecs : ",ctrl.startMicroSecs);
	              ctrl.$spinner.show('appSpinner');
	              ctrl.$order.getErplyCartDetail(cartDetails).then(function () {
	                ctrl.setErplyCartResponseValue();
	                ctrl.hasErplyCalShopcartRes = false;
	                ctrl.$spinner.hide('appSpinner');
	                ctrl.startMicroSecs = ctrl.baseMicroSecs;
	              }).catch(function () {
	                ctrl.hasErplyCalShopcartRes = false;
	                ctrl.startMicroSecs = ctrl.baseMicroSecs;
	                ctrl.$spinner.hide('appSpinner');
	              });
	            }, ctrl.startMicroSecs);
	            // console.log("After set time call, ctrl.startMicroSecs: ", this.startMicroSecs);
	          }
	        } else {
	          ctrl.$order.getCartDetail();
	        }
	        _this2.$auth.getUserProfile();
	      }).catch(function (err) {
	        _this2.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'removeItemFromCart',
	    value: function removeItemFromCart(itemId) {
	      var _this3 = this;
	
	      var ctrl = this;
	      ctrl.startMicroSecs = ctrl.startMicroSecs + ctrl.addMicroSecs;
	      // console.log("ctrl.startMicroSecs : ",ctrl.startMicroSecs);
	      this.$order.removeItemFromCart(itemId).then(function () {
	        if (ctrl.appliedDiscountCoupon && ctrl.discountFreeItemId && ctrl.discountFreeItemId === itemId) {
	          sessionStorage.removeItem('discountCoupon');
	          ctrl.appliedDiscountCoupon = null;
	        }
	        _this3.calculateClubPoints();
	        var bbCoupon = [];
	        if (sessionStorage.getItem('erplyBBCouponCodes')) {
	          bbCoupon = sessionStorage.getItem('erplyBBCouponCodes').split(',');
	        }
	        var promoCoupon = [];
	        if (sessionStorage.getItem('erplyPromotionCodes')) {
	          promoCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
	        }
	        var customerId = null;
	        if (_this3.profile.customer) {
	          customerId = _this3.profile.customer.id;
	        }
	        var cartDetails = {
	          "isGuestUser": _this3.profile.isGuest,
	          "checkForShippingTax": false,
	          "isDiscountApplied": promoCoupon.length > 0 ? true : false,
	          "manualPromotionIDs": promoCoupon ? promoCoupon : null,
	          "couponIdentifiers": bbCoupon ? bbCoupon : null,
	          "customerId": customerId
	        };
	        if (_this3.profile.store.hasErply) {
	          if (!_this3.hasErplyCalShopcartRes) {
	            ctrl.hasErplyCalShopcartRes = true;
	            var dscItem = ctrl.getDSCItemFromCart();
	            if (dscItem && dscItem.id == itemId) {
	              ctrl.$order.deleteDscPremembership();
	            }
	            setTimeout(function () {
	              ctrl.$spinner.show('appSpinner');
	              ctrl.$order.getErplyCartDetail(cartDetails).then(function () {
	                ctrl.setErplyCartResponseValue();
	                ctrl.hasErplyCalShopcartRes = false;
	                ctrl.startMicroSecs = ctrl.baseMicroSecs;
	                ctrl.$spinner.hide('appSpinner');
	              }).catch(function () {
	                ctrl.hasErplyCalShopcartRes = false;
	                ctrl.startMicroSecs = ctrl.baseMicroSecs;
	                ctrl.$spinner.hide('appSpinner');
	              });
	            }, ctrl.startMicroSecs);
	          }
	        } else {
	          ctrl.$order.getCartDetail();
	        }
	        _this3.$auth.getUserProfile();
	      }).catch(function (err) {
	        _this3.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'updateItemInCart_old',
	    value: function updateItemInCart_old(quantity, item) {
	      var _this4 = this;
	
	      // console.log(item);
	      var ctrl = this;
	      this.$order.updateItemInCart(quantity, item.item.id, item.item.masterProduct.subCategories[0].id).then(function () {
	        _this4.calculateClubPoints();
	        ctrl.$order.getCartDetail();
	        _this4.$auth.getUserProfile();
	      }).catch(function (err) {
	        _this4.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'removeItemFromCart_old',
	    value: function removeItemFromCart_old(itemId) {
	      var _this5 = this;
	
	      this.$order.removeItemFromCart(itemId).then(function () {
	        _this5.calculateClubPoints();
	        _this5.$order.getCartDetail();
	        _this5.$auth.getUserProfile();
	      }).catch(function (err) {
	        _this5.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'canUserJoin',
	    value: function canUserJoin() {
	      return !(this.isDscMember() || this.isDscButExpired());
	    }
	  }, {
	    key: 'isAnyItemInactive',
	    value: function isAnyItemInactive() {
	
	      var arr = this.detail ? this.detail.cartItems.filter(function (item) {
	        return !(item.item.isActive && item.item.masterProduct.isActive && item.item.price != 0 && item.item.price >= item.item.regionalPrice && !item.item.isOutOfStock);
	      }) : [];
	      return !(arr.length === 0);
	    }
	  }, {
	    key: 'cartContainsDsc',
	    value: function cartContainsDsc() {
	      var _this6 = this;
	
	      var arr = this.detail ? this.detail.cartItems.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this6.dscMasterCode;
	      }) : [];
	      return arr.length === 1;
	    }
	  }, {
	    key: 'goToDetailPage',
	    value: function goToDetailPage(item) {
	      if (this.isItemDscMembership(item)) {
	        this.$state.go('savings-club');
	      } else {
	        var storeName = '';
	        if (this.$stateParams.storeName) {
	          storeName = this.$stateParams.storeName;
	        } else {
	          if (this.profile.store && this.profile.store.storeName) {
	            storeName = this.profile.store.storeURLName;
	          } else {
	            storeName = this.$auth.getGuestStoreDetail().storeName;
	          }
	        }
	        // let storeName =  false;
	        if (storeName) {
	          this.$state.go('browse-product.detail', {
	            categoryId: item.item.masterProduct.category.prettyUrl,
	            subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl,
	            productId: item.item.masterProduct.prettyUrl,
	            itemGroupNumber: item.item.masterProduct.itemGroupNumber,
	            storeName: storeName
	          });
	        } else {
	          this.$state.go('browse-product.detail', {
	            categoryId: item.item.masterProduct.category.prettyUrl,
	            subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl,
	            productId: item.item.masterProduct.prettyUrl,
	            itemGroupNumber: item.item.masterProduct.itemGroupNumber
	          });
	        }
	      }
	    }
	  }, {
	    key: 'isItemDscMembership',
	    value: function isItemDscMembership(item) {
	      return item.item.masterProduct.masterCode === this.dscMasterCode;
	    }
	  }, {
	    key: 'isItemActive',
	    value: function isItemActive(item) {
	      return item.item.isActive && item.item.masterProduct.isActive && item.item.price != 0 && item.item.price >= item.item.regionalPrice && !item.item.isOutOfStock;
	    }
	  }, {
	    key: 'isFreeShippingOfferAvailable',
	    value: function isFreeShippingOfferAvailable() {
	      if (this.profile && this.detail.freeshipping) {
	        var shippingOfferStartDate = new Date(this.detail.freeshipping.startDate);
	        var shippingOfferEndDate = new Date(this.detail.freeshipping.endDate);
	        var currentDate = new Date();
	        var result = false;
	        if (this.profile.store) {
	          if (this.profile.store.isFreeShipping) {
	            if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	              result = true;
	            }
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'shippingGrossPrice',
	    value: function shippingGrossPrice() {
	      var totalGiftCardAmountPurchasing = 0.00;
	      var $ctrl = this;
	      angular.forEach(this.detail.cartItems, function (item, key) {
	        if (item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory && item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith) {
	          totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + item.item.price * item.quantity;
	        }
	      });
	      if (this.profile.store.hasErply) {
	        return this.getSubtotal() - totalGiftCardAmountPurchasing;
	      } else {
	        return this.getSubtotal() - totalGiftCardAmountPurchasing - this.couponAmount - this.discountCouponAmount;
	      }
	    }
	  }, {
	    key: 'getFreeShippingRemainingAmount',
	    value: function getFreeShippingRemainingAmount() {
	      if (this.detail) {
	        if (this.detail.freeshipping) {
	          this.shippingOffer.thresholdAmount = this.detail.freeshipping.thresholdValue;
	        }
	      }
	      var remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
	      if (remainingAmount >= 0) {
	        this.shippingOffer.isOfferEligible = true;
	      } else {
	        this.shippingOffer.isOfferEligible = false;
	      }
	      return remainingAmount * -1;
	    }
	  }, {
	    key: 'showFreeShippingOfferDetail',
	    value: function showFreeShippingOfferDetail() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free Shipping within Zone 2';
	      } else {
	        tittle = 'Free Shipping within Zone 2';
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showFreeShippingOfferDetailCan',
	    value: function showFreeShippingOfferDetailCan() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free shipping in Zones 0-1';
	      } else {
	        tittle = 'Free shipping in Zones 0-1';
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'isDscAddedinCart',
	    value: function isDscAddedinCart() {
	      return this.detail.cartItems.some(function (cartItem) {
	        return cartItem.item.storeItemCode === 'C';
	      });
	    }
	  }, {
	    key: 'getClubPoints',
	    value: function getClubPoints() {
	      var points = 0;
	      var tempPoints = 0;
	      // For HighPercentage discount points will be calculated in getPoints method
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        points = this.getPoints(this.storeDiscountMap);
	      } else {
	        var promoAmount = this.calculateDiscounts();
	        tempPoints = this.getPoints(this.storeDiscountMap);
	        if (tempPoints >= promoAmount && this.isValidToApplyPromo) {
	          points = tempPoints - promoAmount;
	        } else {
	          points = tempPoints;
	        }
	      }
	      if (this.isValidToApplyBB && points >= this.couponAmount) {
	        points = points - this.couponAmount;
	      }
	      return points;
	    }
	  }, {
	    key: 'getPoints',
	    value: function getPoints(storeDiscountMap) {
	      var points = 0;
	      var dscTotal = 0;
	      var nonDscTotal = 0;
	      var $ctrl = this;
	      // update
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          var promoAmount = Math.round(this.calculateDiscounts() * 100) / 100;
	
	          var maxPrice = 0;
	          var maxPriceId = 0;
	          var isDscMember = this.isDscMember() || this.cartContainsDsc();
	          angular.forEach(this.detail.cartItems, function (item, key) {
	            // console.log(key);
	            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	              maxPriceId = item.item.id;
	              maxPrice = item.item.price;
	            }
	          });
	
	          angular.forEach(this.detail.cartItems, function (item, key) {
	            // console.log(key);
	            // console.log("High Percentage promo: Item id for " +maxPriceId + " Item Price : " + maxPrice);
	            if (maxPriceId === item.item.id) {
	              if (item.item.masterProduct.applyDscPoints) {
	                if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100 * (item.quantity - 1);
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price - promoAmount) * 100) / 100;
	                  } else {
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100 * (item.quantity - 1);
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price - promoAmount) * 100) / 100;
	                  }
	                } else {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	                    points = points + (item.item.price - promoAmount);
	                  } else {
	                    points = points + Math.round(item.item.price * 100) / 100 * (item.quantity - 1);
	                    points = points + (item.item.price - promoAmount);
	                  }
	                  // console.log("item ND"+item.item.name+" : "+item.item.subCategory.category.dscCategory + "Points: "+ points);
	                }
	              }
	            } else {
	              if (item.item.masterProduct.applyDscPoints) {
	                if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100 * item.quantity;
	                  } else {
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100 * item.quantity;
	                  }
	                } else {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	                  } else {
	                    points = points + Math.round(item.item.price * 100) / 100 * item.quantity;
	                  }
	                }
	              }
	            }
	          });
	        }
	      }
	      // update end
	      else {
	          var dscItems = this.detail.cartItems.filter(function (item) {
	            return item.subCategory.category.dscCategory;
	          });
	          var nondscItems = this.detail.cartItems.filter(function (item) {
	            return !item.subCategory.category.dscCategory;
	          });
	          $ctrl = this;
	          dscItems.forEach(function (item) {
	            if (item.item.masterProduct.applyDscPoints) {
	              if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	                dscTotal = dscTotal + Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100 * item.quantity;
	              } else {
	                dscTotal = dscTotal + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	              }
	            }
	          });
	
	          nondscItems.forEach(function (item) {
	            if (item.item.masterProduct.applyDscPoints) {
	              if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	                nonDscTotal = nonDscTotal + Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100 * item.quantity;
	              } else {
	                nonDscTotal = nonDscTotal + Math.round(item.item.price * 100) / 100 * item.quantity;
	              }
	            }
	          });
	          points = dscTotal + nonDscTotal;
	        }
	      return points;
	    }
	  }, {
	    key: 'doubleTheValue',
	    value: function doubleTheValue(value) {
	      return value * 2;
	    }
	  }, {
	    key: 'getDSCItemFromCart',
	    value: function getDSCItemFromCart() {
	      var _this7 = this;
	
	      var dscItem = '';
	      this.detail.cartItems.forEach(function (item) {
	        if (item.item.masterProduct.masterCode === _this7.dscMasterCode) {
	          dscItem = item.item;
	        }
	      });
	      return dscItem;
	    }
	  }, {
	    key: 'validateBBCoupon',
	    value: function validateBBCoupon() {
	      if (this.couponAmount >= this.getSubtotal()) {
	        this.isValidToApplyBB = false;
	      } else if (this.getDSCItemFromCart()) {
	        if (this.couponAmount >= this.getSubtotal() - this.discountCouponAmount - this.getDSCItemFromCart().price) {
	          this.isValidToApplyBB = false;
	        } else {
	          this.isValidToApplyBB = true;
	        }
	      } else {
	        this.isValidToApplyBB = true;
	      }
	    }
	  }, {
	    key: 'validatePromoCoupon',
	    value: function validatePromoCoupon() {
	      if (this.discountCouponAmount >= this.getSubtotal()) {
	        this.isValidToApplyPromo = false;
	      } else if (this.getDSCItemFromCart()) {
	        if (this.discountCouponAmount >= this.getSubtotal() - this.couponAmount - this.getDSCItemFromCart().price) {
	          this.isValidToApplyPromo = false;
	        } else {
	          this.isValidToApplyPromo = true;
	        }
	      } else {
	        this.isValidToApplyPromo = true;
	      }
	    }
	  }, {
	    key: 'getClubPointsOld',
	    value: function getClubPointsOld() {
	      return this.orderPoints.dscPoints;
	      // return 12;
	    }
	  }, {
	    key: 'calculateClubPoints',
	    value: function calculateClubPoints() {
	      var _this8 = this;
	
	      this.appliedDiscountCoupon = sessionStorage.getItem('discountCoupon');
	      this.appliedBirdBuckCoupon = sessionStorage.getItem('birdbuckCoupon');
	      var isInStorePickUp = true;
	      var shipToStateId;
	      if (this.$rootScope.tempdeliveryMode) {
	        if (this.$rootScope.tempdeliveryMode !== '') {
	          isInStorePickUp = this.$rootScope.tempdeliveryMode === 'In Store Pickup' ? true : false;
	          shipToStateId = this.getShipToStateId(isInStorePickUp);
	        } else {
	          shipToStateId = this.getShipToStateId(true);
	        }
	      }
	      var data = {
	        'bbcouponId': this.appliedBirdBuckCoupon ? this.appliedBirdBuckCoupon : null,
	        'discountcoupon': this.appliedDiscountCoupon ? this.appliedDiscountCoupon : null,
	        'isInStorePickUp': isInStorePickUp,
	        'shipToStateId': shipToStateId
	      };
	      this.$order.getOrderPoints(data).then(function (success) {
	        if (_this8.appliedDiscountCoupon) {
	          _this8.discountCouponAmount = _this8.orderPoints.discountWrapper.couponAmount;
	        } else {
	          _this8.discountCouponAmount = 0;
	        }
	
	        if (_this8.orderPoints && _this8.orderPoints.discountWrapper && _this8.orderPoints.discountWrapper.discountType === 'FREEITEM') {
	          if (_this8.orderPoints.discountWrapper.cartItemset && _this8.orderPoints.discountWrapper.cartItemset.length) {
	            _this8.discountFreeItemId = _this8.orderPoints.discountWrapper.cartItemset ? _this8.orderPoints.discountWrapper.cartItemset.find(function (ele) {
	              return ele.discountTypeApplied === 'FREEITEM' && ele.isDiscountApplied && _this8.orderPoints.discountWrapper.couponAmount;
	            }) : null;
	            if (_this8.discountFreeItemId && _this8.discountFreeItemId.item) {
	              _this8.discountFreeItemId = _this8.discountFreeItemId.item.id;
	            }
	          } else {
	            _this8.discountFreeItemId = null;
	          }
	        }
	
	        if (_this8.orderPoints && _this8.orderPoints.discountWrapper && _this8.orderPoints.discountWrapper.discountType === 'BUYXGETY') {
	          if (_this8.orderPoints.discountWrapper.cartItemset && _this8.orderPoints.discountWrapper.cartItemset.length) {
	            _this8.discountFreeItemId = _this8.orderPoints.discountWrapper.cartItemset ? _this8.orderPoints.discountWrapper.cartItemset.find(function (ele) {
	              return ele.discountTypeApplied === 'BUYXGETY' && ele.isDiscountApplied && _this8.orderPoints.discountWrapper.couponAmount;
	            }) : null;
	            if (_this8.discountFreeItemId && _this8.discountFreeItemId.item) {
	              _this8.discountFreeItemId = _this8.discountFreeItemId.item.id;
	            }
	          } else {
	            _this8.discountFreeItemId = null;
	          }
	        }
	      }).catch(function (err) {
	        _this8.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'getShipToStateId',
	    value: function getShipToStateId(isInStorePickUp) {
	      if (isInStorePickUp) {
	        return this.profile.store.storeId;
	      } else {
	        return this.addressDetail.shippingState.id;
	      }
	    }
	  }, {
	    key: 'deliveryTypeValidation',
	    value: function deliveryTypeValidation() {
	      if (this.detail && this.detail.cartItems && this.detail.cartItems.length) {
	        var pickupExist = this.detail.cartItems.filter(function (element) {
	          return element.item.deliveryType == 'InStore';
	        });
	        var dropExist = this.detail.cartItems.filter(function (element) {
	          return element.item.deliveryType == 'DropShip';
	        });
	        if (pickupExist && pickupExist.length && dropExist && dropExist.length) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getErplyPromotionInfo',
	    value: function getErplyPromotionInfo(item, key) {
	      if (this.detail != null) {
	        if (this.detail.erplyShopCartResponse != null && this.detail.erplyShopCartResponse.erplyPromotionDetails) {
	          if (this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id] && this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].isDscPromo) {
	            if (key === this.dscPercentage) {
	              return this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].dscPercentage;
	            } else if (key == this.dscDiscount) {
	              return this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].dscDiscount;
	            } else if (key == this.dscDiscountedPrice) {
	              return this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].discountedPriced;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'proceedToCheckout',
	    value: function proceedToCheckout() {
	      if (this.doPageNeedsToBeRefreshed) {
	        this.$window.location.reload();
	        return;
	      }
	      var activeCartItems = this.detail ? this.detail.cartItems.filter(function (item) {
	        return !item.isItemRemoved;
	      }) : [];
	      if (this.numberOfItemsAllowedToPurchase < activeCartItems.length) {
	        var detailInfo = "An order can have a maximum of 40 items. Please remove some items from the cart to proceed.";
	        this.showErrorMsgPopup(detailInfo);
	        return;
	      }
	
	      if (this.isAnyItemInactive()) {
	        this.$toaster.pop('success', 'Some items in your cart are temporarily unavailable.  Please remove those items to continue with your purchase.');
	      } else {
	        this.$state.go('delivery');
	      }
	    }
	
	    /* AddToCart for interaction studio
	      addToCart(quantity, item) {
	      console.log("Adding item to cart", item);
	      var ctrl = this;
	      // Validating instore and Delivery only items in cart
	      if (!this.deliveryTypeValidationForInjectingItem(item)) {
	        var deliveryError = 'Your cart contains some items that are ' + (item.deliveryType === 'InStore' ? 'delivery' : 'in-store/curbside pickup') + ' only. If you would like to add this item to your cart, please remove those items or complete a separate order.';
	        this.$toaster.pop('success', deliveryError);
	        return false;
	      }
	        this.$order.addItemToCart(quantity, item.itemId, item.subCategoryId)
	        .then(
	          () => {
	                    this.calculateClubPoints();
	                  if(this.profile.store.hasErply){
	                    if(!this.hasErplyCalShopcartRes){
	                      ctrl.hasErplyCalShopcartRes=true;
	                      setTimeout(function(){
	                        // console.log("Inside set time ctrl.startMicroSecs : ",ctrl.startMicroSecs);
	                        ctrl.$spinner.show('appSpinner');
	                        ctrl.$order.getCartDetail().then(() => {
	                          ctrl.hasErplyCalShopcartRes=false;
	                          ctrl.$spinner.hide('appSpinner');
	                          ctrl.startMicroSecs=ctrl.baseMicroSecs;
	                        })
	                        .catch(() => {
	                          ctrl.hasErplyCalShopcartRes=false;
	                          ctrl.startMicroSecs=ctrl.baseMicroSecs;
	                          ctrl.$spinner.hide('appSpinner');
	                        });
	                      },ctrl.startMicroSecs);
	                      // console.log("After set time call, ctrl.startMicroSecs: ", this.startMicroSecs);
	                    }
	                  } else {
	                    ctrl.$order.getCartDetail();
	                  }
	                  this.$auth.getUserProfile();
	            this.$toaster.pop('success', 'Item added to cart');
	          },
	          error => {
	            if (error.data.errorCode == 692) {
	              this.$toaster.pop('success', error.data.message);
	            }
	            else {
	              this.$toaster.pop('success', 'Item already exists in cart');
	            }
	          }
	        )
	        .finally(() => {
	          // Console.log("Check if we need to do something");
	        }
	        );
	    }
	      */
	
	  }, {
	    key: 'deliveryTypeValidationForInjectingItem',
	    value: function deliveryTypeValidationForInjectingItem(item) {
	      if (item.isOutOfStock) {
	        return false;
	      }
	      if (this.detail && this.detail.cartItems && this.detail.cartItems.length) {
	        var pickupExist = this.detail.cartItems.filter(function (element) {
	          return element.item.deliveryType == 'InStore';
	        });
	        var dropExist = this.detail.cartItems.filter(function (element) {
	          return element.item.deliveryType == 'DropShip';
	        });
	        if (pickupExist && pickupExist.length && dropExist && dropExist.length) {
	          return false;
	        } else if (item.deliveryType == 'InStore' && dropExist && dropExist.length) {
	          return false;
	        } else if (item.deliveryType == 'DropShip' && pickupExist && pickupExist.length) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'getFinalPriceInfo',
	    value: function getFinalPriceInfo(item) {
	      if (this.detail != null) {
	        if (this.detail.erplyShopCartResponse != null && this.detail.erplyShopCartResponse.erplyItemDetails) {
	          if (this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode]) {
	            return this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode].finalPriceOfItem;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'setErplyCartResponseValue',
	    value: function setErplyCartResponseValue(success) {
	      this.erplyDis = [];
	      var dis = {};
	      var ctrl = this;
	      var i = 0;
	      console.log(this.detail.erplyPromoAndDiscount);
	      console.log("this.detail.promotionsAppliedOnItems", this.detail.promotionsAppliedOnItems);
	
	      if (ctrl.detail.promotionsAppliedOnItems) {
	        angular.forEach(ctrl.detail.promotionsAppliedOnItems, function (id, value) {
	          console.log('value', value);
	          angular.forEach(ctrl.detail.cartItems, function (item) {
	            if (item.item.masterProduct.masterCode == value) {
	              item.item.promotionsAppliedOnItems = id;
	            }
	          });
	        });
	        // console.log(this.detail.cartItems);
	      }
	      angular.forEach(this.detail.erplyPromoAndDiscount, function (item, key) {
	        dis = {};
	        console.log('key', key);
	        console.log('item', item);
	        dis.key = key;
	        dis.value = item;
	        dis.sortId = i + 1;
	        i = i + 1;
	        ctrl.erplyDis.push(dis);
	      });
	      console.log("Cart - ctrl.erplyDis", ctrl.erplyDis);
	    }
	  }, {
	    key: 'getAdjustedLabelName',
	    value: function getAdjustedLabelName(promoLabel) {
	      if (promoLabel != null && promoLabel.length > this.promoLengthToBeShown) {
	        return promoLabel.substring(0, this.promoLengthToBeShown - 3) + "...";
	      } else {
	        return promoLabel;
	      }
	    }
	  }, {
	    key: 'hideinfoPopup',
	    value: function hideinfoPopup(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopuponhover',
	    value: function infoPopuponhover(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'showErrorMsgPopup',
	    value: function showErrorMsgPopup(detailInfo) {
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold"> </h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'userAction',
	    value: function userAction(_userAction) {
	      this.$order.updateUserAction(_userAction);
	    }
	  }]);
	
	  return Cart;
	}(), _class2.$inject = ['$scope', '$rootScope', '$ngRedux', 'spinnerService', 'authService', 'orderService', '$state', '$uibModal', '$timeout', '$window', '$stateParams', 'APP', 'toaster'], _temp)) || _class);
	exports.default = Cart;

/***/ },
/* 199 */
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"cart.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{cart.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Your Cart</span>\r\n  </nav>\r\n\r\n  <!-- Out of stock notice -->\r\n  <div class=\"cart_header p-t-1\" ng-if=\"cart.isAnyItemInactive() && !cart.cartContainsDsc()\">\r\n    <div class=\"alert-user oos-msg\">\r\n      <span><img class=\"alert-icon\" src={{cart.alertIcon}}></span>\r\n      <span class=\"alert-text\">\r\n        Some items in your cart are temporarily unavailable. Please remove those items to continue with your purchase.\r\n      </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Delivery Type Validation -->\r\n  <div class=\"cart_header p-t-1\" ng-if=\"cart.deliveryTypeValidation()\">\r\n    <div class=\"alert-user oos-msg\">\r\n      <span><img class=\"alert-icon\" src={{cart.alertIcon}}></span>\r\n      <span class=\"alert-text\">\r\n        Your cart contains some items that are in-store/curbside pickup and delivery only. If you would like to proceed\r\n        to checkout, please remove those items or complete a separate order.\r\n      </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Your cart heading -->\r\n  <div class=\"row m-y-1 p-t-1 cart_header hidden-sm-down m-x-0\" ng-if=\"cart.detail.cartItems.length\">\r\n    <h4 class=\"font-weight-bold\">Your Cart</h4>\r\n  </div>\r\n\r\n  <!-- Row for cart items and prices -->\r\n  <div class=\"row cart-content-spacing m-y-1 m-x-0 padding-0-sm\" ng-if=\"cart.detail.cartItems.length\">\r\n\r\n    <!-- List of CartItems -->\r\n    <div class=\"col-xs-12 col-md-8 m-x-0 p-x-0\">\r\n      <form name=\"cartForm\" ng-repeat=\"item in cart.detail.cartItems | orderBy : 'item.name'\" autocomplete=\"off\"\r\n        novalidate>\r\n\r\n        <div class=\"row m-x-0 p-x-0\">\r\n          <!-- Product Image -->\r\n          <div class=\"col-xs-4 col-md-3 hidden-sm-down\">\r\n            <button class=\"hidden-btn\" ng-disabled=\"!(cart.isItemActive(item) || cart.isItemDscMembership(item))\"\r\n              ng-click=\"cart.goToDetailPage(item)\">\r\n              <img src={{item.item.mediumImageUrl}}\r\n                ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? 'product-thumbnail cursor-pointer' : 'product-thumbnail inactive-item'\" />\r\n            </button>\r\n          </div>\r\n\r\n          <div class=\"col-xs-8 col-md-8 p-r-0 p-l-1 m-x-0\">\r\n            <div class=\"col-xs-12 col-md-7 m-b-1 p-x-0\">\r\n              <!-- Out of stock Button -->\r\n              <button class=\"btn btn-primary remove-btn out-of-stock-btn mb-8\"\r\n                ng-if=\"!(cart.isItemActive(item) || cart.isItemDscMembership(item))\">\r\n                Temporarily Unavailable\r\n              </button>\r\n              <!-- Product Name -->\r\n              <div ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? '' : 'inactive-item'\">\r\n                <button class=\"hidden-btn\" ng-disabled=\"!(cart.isItemActive(item) || cart.isItemDscMembership(item))\"\r\n                  ng-click=\"cart.goToDetailPage(item)\">\r\n                  <h4 class=\"font-weight-bold m-b-0 text-xs-left\" style=\"color:black\" ng-bind=\"item.item.name\"></h4>\r\n                </button>\r\n\r\n              </div>\r\n              <!-- Product Weight -->\r\n              <div\r\n                ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? 'weight_cell weight-text hidden-sm-down' : 'inactive-item weight_cell weight-text hidden-sm-down'\">\r\n                <span ng-show=\"item.item.weight\">{{item.item.weight}} lbs</span>\r\n                <span ng-if=\"item.item.deliveryType === 'InStore'\" class=\"delivery-type-only\"><br />In Store/Curbside\r\n                  Pickup Only</span>\r\n                <span ng-if=\"item.item.deliveryType === 'DropShip'\" class=\"delivery-type-only\"><br />Delivery\r\n                  Only</span>\r\n              </div>\r\n\r\n              <!-- Cart Item Individual Price detail -->\r\n              <div\r\n                ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? 'normal-text m-b-0 m-t-1 hidden-sm-down' : 'inactive-item normal-text m-b-0 m-t-1 hidden-sm-down'\">\r\n\r\n                <!-- Regular price -->\r\n                <div class=\"col-xs-9 p-a-0\">Regular Price: {{item.quantity}} x ${{item.item.price | number : 2}}</div>\r\n                <div class=\"col-xs-3 p-a-0 text-xs-right\">${{cart.getRetailPrice(item.quantity, item.item.price) |\r\n                  number : 2}}</div>\r\n\r\n\r\n                <!-- erplyPromoAndDiscount -->\r\n                <div ng-if=\"item.item.promotionsAppliedOnItems && cart.isErplyStore\">\r\n                  <div ng-repeat=\"displayVal in item.item.promotionsAppliedOnItems | orderBy: 'sortId'\">\r\n                    <span class=\"col-xs-9 p-a-0\">{{cart.getAdjustedLabelName(displayVal.label)}}\r\n                      <span ng-if=\"displayVal.label.length>cart.promoLengthToBeShown\">\r\n                        <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"cart.infoPopuponhover('desktop_popup',$index,item.item.name,displayVal.label)\" ng-mouseleave=\"cart.hideinfoPopup('desktop_popup',$index,item.item.name,displayVal.label)\"></i>\r\n                        <div style=\"position: relative;\">\r\n                          <div id=\"{{'desktop_popup'+$index+item.item.name+displayVal.label}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                            {{displayVal.label}}\r\n                          </div>\r\n                        </div>\r\n                      </span>\r\n                    </span>\r\n                    <span class=\"col-xs-3 p-a-0 text-xs-right\" class=\"col-xs-4 p-a-0 text-xs-right\">-${{displayVal.discountValue | number : 2}}</span>\r\n                  </div>\r\n                </div>\r\n                <!-- Club Discount -->\r\n                <!-- Club Discount Erply doesn't give discount amount sometimes -->\r\n                <div class=\"col-xs-9 p-a-0\"\r\n                  ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != cart.maxPriceId  && (!cart.isErplyStore)\">\r\n                  Club Discount<small class=\"primary-text discount-text\"\r\n                    ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.id!= cart.maxPriceId\">(15%\r\n                    Off)</small>: </div>\r\n\r\n                <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                  ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id!= cart.maxPriceId && (!cart.isErplyStore)\">\r\n                  -${{cart.getClubDiscount(item.quantity, item.item.price) | number : 2}}</div>\r\n\r\n                <div class=\"col-xs-9 p-a-0\"\r\n                  ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == cart.maxPriceId && item.quantity>1 && (!cart.isErplyStore)\">\r\n                  Club Discount <small class=\"primary-text discount-text\"\r\n                    ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == cart.maxPriceId && item.quantity > 1 \">(15%\r\n                    Off on {{item.quantity-1}} items)</small>: </div>\r\n\r\n                <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                  ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == cart.maxPriceId && item.quantity > 1 && (!cart.isErplyStore)\">\r\n                  -${{cart.getClubDiscount(item.quantity-1, item.item.price) | number : 2}}</div>\r\n\r\n                <!-- <div class=\"col-xs-8 p-a-0\" ng-if=\"item.item.id == cart.maxPriceId\">\r\n                  Special Discount <small class=\"primary-text discount-text\" ng-if=\"item.item.id == cart.maxPriceId\"> ({{cart.discountPercentage}}% off)</small>:</div>\r\n                 <div class=\"col-xs-4 p-a-0 text-xs-right\" ng-if=\"item.item.id== cart.maxPriceId\">-${{cart.getMaxItemDiscount(cart.discountPercentage,item.item.price)| number : 2}}\r\n                 </div> -->\r\n\r\n                <div class=\"col-xs-9 p-a-0 font-weight-bold\">Your Price</div>\r\n                <div ng-if=\"!cart.isErplyStore\">\r\n                  <div ng-if=\"item.item.id != cart.maxPriceId\">\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                      ng-if=\"!(cart.isDscMember() || cart.cartContainsDsc()) || !item.subCategory.category.dscCategory\">\r\n                      ${{cart.getRetailPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                      ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != cart.maxPriceId && (!cart.isErplyStore)\">\r\n                      ${{cart.getDiscountedPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                      ng-if=\"item.item.id != cart.maxPriceId && cart.isErplyStore\">\r\n                      ${{cart.getFinalPriceInfo(item) | number : 2}}</div>\r\n                  </div>\r\n                  <div class=\"col-xs-34 p-a-0 text-xs-right\"\r\n                    ng-if=\"!(cart.isDscMember() || cart.cartContainsDsc()) && item.item.id == cart.maxPriceId && (!cart.isErplyStore)\">\r\n                    ${{cart.getRetailPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n                  <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                    ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.item.id == cart.maxPriceId && (!cart.isErplyStore)\">\r\n                    ${{cart.getRetailPrice(item.quantity, item.item.price) - cart.getClubDiscount(item.quantity-1,\r\n                    item.item.price) | number : 2}}</div>\r\n                </div>\r\n                <div ng-if=\"cart.isErplyStore\">\r\n                  <div class=\"col-xs-3 p-a-0 text-xs-right\">\r\n                    ${{ cart.getFinalPriceInfo(item) | number : 2}}</div>\r\n                </div>\r\n\r\n                <div ng-if=\"cart.discountType  === 'SUBCATEGORY' && item.item.masterProduct.isDiscountable\">\r\n                  <span ng-repeat=\"subCategory in cart.discountCoupon.subCategories\">\r\n                    <span ng-repeat=\"itemsubCategory in item.item.masterProduct.subCategories\">\r\n                      <span ng-if=\"itemsubCategory.id == subCategory.id\">\r\n                        </br>*Extra discount provided during checkout\r\n                      </span>\r\n                    </span>\r\n                  </span>\r\n                </div>\r\n                <div class=\"col-xs-12 p-a-0 \"\r\n                  ng-if=\"item.item.id == cart.maxPriceId && cart.discountType  === 'HIGHPERCENTAGE'\">\r\n                  <span>*Extra discount provided during checkout </span>\r\n                </div>\r\n\r\n                <div ng-if=\"cart.discountType  === 'PERCENTAGE' && item.item.masterProduct.isDiscountable\">\r\n                  <span>*Extra discount provided during checkout </span>\r\n                </div>\r\n                <div ng-if=\"cart.discountType == 'FREEITEM' && item.item.id == cart.discountFreeItemId\"\r\n                  class=\"delivery-type-only\"><br />*Extra discount provided during checkout </div>\r\n                <div ng-if=\"cart.discountType == 'BUYXGETY' && item.item.id == cart.discountFreeItemId\"\r\n                  class=\"delivery-type-only\"><br />*Extra discount provided during checkout </div>\r\n              </div>\r\n\r\n\r\n            </div>\r\n\r\n            <!-- Quantity, Remove Button and Mobile Calculations -->\r\n            <div class=\"col-xs-12 col-md-5 p-l-1 p-r-0 m-x-0 p-b-1\">\r\n              <p\r\n                ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? 'product-text' : 'inactive-item product-text'\">\r\n                Quantity</p>\r\n              <div ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? '' : 'inactive-item'\">\r\n                <div class=\"form-group height p-x-0 m-x-0\"\r\n                  ng-class=\"{'has-danger': (cartForm.$submitted || cartForm.quantity.$touched) && cartForm.quantity.$invalid}\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\"\r\n                        ng-disabled=\"item.quantity < 2 || !(cart.isItemActive(item) || cart.isItemDscMembership(item))\"\r\n                        class=\"btn btn-primary counter-btn\"\r\n                        ng-click=\"item.quantity = item.quantity - 1; cart.updateItemInCart(item.quantity, item)\">&#150;</button>\r\n                    </span>\r\n                    <input name=\"quantity\" disabled type=\"number\" class=\"form-control counter-input\"\r\n                      ng-model=\"item.quantity\" ng-min=\"1\" ng-max=\"999999\" />\r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                        ng-disabled=\"!(cart.isItemActive(item)) || cart.isItemDscMembership(item)\"\r\n                        ng-click=\"item.quantity = item.quantity + 1; cart.updateItemInCart(item.quantity, item);\">+</button>\r\n                    </span>\r\n                    <!-- <span class=\"primary-text lbs-text weight_cell hidden-sm-down\" style=\"width:65px;\">\r\n                      <span ng-show=\"item.item.weight\">{{item.item.weight}} lbs</span>\r\n                    </span> -->\r\n                  </div>\r\n                  <div ng-messages=\"cartForm.quantity.$error\" class=\"form-control-feedback\"\r\n                    ng-show=\"cartForm.quantity.$touched || cartForm.$submitted\">\r\n                    <div ng-message=\"required\">Enter Quantity</div>\r\n                    <div ng-message=\"min\">Enter a valid Quantity</div>\r\n                    <div ng-message=\"max\">Enter a valid Quantity</div>\r\n                    <div class=\"error-text\" ng-show=\"cartForm.errors.quantity && !cartForm.quantity.$error.required\">{{\r\n                      cartForm.errors.quantity[0] }}</div>\r\n                  </div>\r\n                  <div class=\"lbs-text p-x-0 weight_cell hidden-md-up ng-binding p-t-1\" ng-show=\"item.item.weight\">\r\n                    {{item.item.weight}} lbs\r\n                    <span ng-if=\"item.item.deliveryType === 'InStore'\" class=\"delivery-type-only\"><br />In\r\n                      Store/Curbside Pickup Only</span>\r\n                    <span ng-if=\"item.item.deliveryType === 'DropShip'\" class=\"delivery-type-only\"><br />Delivery\r\n                      Only</span>\r\n                  </div>\r\n\r\n\r\n                  <!-- Calculations for Small Devices -->\r\n                  <div class=\"normal-text m-b-0 m-t-1 hidden-md-up\">\r\n                    <div class=\"col-xs-9 p-a-0\">Regular Price: {{item.quantity}} x ${{item.item.price | number : 2}}\r\n                    </div>\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\">${{cart.getRetailPrice(item.quantity, item.item.price) |\r\n                      number : 2}}</div>\r\n                    <div class=\"col-xs-9 p-a-0\"\r\n                      ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != cart.maxPriceId && !cart.isErplyStore\">\r\n                      Club Discount <small class=\"primary-text discount-text\"\r\n                        ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.id == cart.maxPriceId && item.quantity > 1\">(15%\r\n                        Off)</small>: </div>\r\n\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                      ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id!= cart.maxPriceId && (!cart.isErplyStore)\">\r\n                      -${{cart.getClubDiscount(item.quantity, item.item.price) | number : 2}}</div>\r\n\r\n                    <div class=\"col-xs-9 p-a-0\"\r\n                      ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == cart.maxPriceId && item.quantity>1 && !cart.isErplyStore\">\r\n                      Club Discount <small class=\"primary-text discount-text\"\r\n                        ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == cart.maxPriceId && item.quantity > 1 && (!cart.isErplyStore || cart.detail.erplyShopCartResponse.erplyPromotionDetails)\">(15%\r\n                        Off on {{item.quantity-1}} items)</small>: </div>\r\n\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                      ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == cart.maxPriceId && item.quantity > 1  && (!cart.isErplyStore || cart.detail.erplyShopCartResponse.erplyPromotionDetails)\">\r\n                      -${{cart.getClubDiscount(item.quantity-1, item.item.price) | number : 2}}</div>\r\n                    <!-- erplyPromoAndDiscount -->\r\n                    <div ng-if=\"item.item.promotionsAppliedOnItems && cart.isErplyStore\">\r\n                      <div ng-repeat=\"displayVal in item.item.promotionsAppliedOnItems | orderBy: 'sortId'\">\r\n                        <span class=\"col-xs-9 p-a-0\">{{cart.getAdjustedLabelName(displayVal.label)}}\r\n                          <span ng-if=\"displayVal.label.length>cart.promoLengthToBeShown\">\r\n                            <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"cart.infoPopuponhover('mobile_popup',$index ,item.item.name,displayVal.label)\" ng-mouseleave=\"cart.hideinfoPopup('mobile_popup',$index,item.item.name, displayVal.label)\"></i>\r\n                            <div style=\"position: relative; position: relative; margin-left: 40%;\">\r\n                              <div id=\"{{'mobile_popup'+$index+item.item.name+displayVal.label}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                                {{displayVal.label}}\r\n                              </div>\r\n                            </div>\r\n                          </span>\r\n                        </span>\r\n                        <span class=\"col-xs-3 p-a-0 text-xs-right\">-${{displayVal.discountValue | number : 2}}</span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"col-xs-9 p-a-0 font-weight-bold\">\r\n                      Your Price </div>\r\n                    <div ng-if=\"!cart.isErplyStore\">\r\n                      <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                        ng-if=\"!(cart.isDscMember() || cart.cartContainsDsc()) || !item.subCategory.category.dscCategory && item.item.id != cart.maxPriceId \">\r\n                        ${{cart.getRetailPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n                      <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                        ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != cart.maxPriceId && (!cart.isErplyStore)\">\r\n                        ${{cart.getDiscountedPrice(item.quantity, item.item.price) | number : 2}} </div>\r\n                      <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                        ng-if=\"item.item.id == cart.maxPriceId && (!cart.isErplyStore)\">\r\n                        ${{cart.getRetailPrice(item.quantity, item.item.price) - cart.getClubDiscount(item.quantity-1,\r\n                        item.item.price) | number : 2}}</div>\r\n                    </div>\r\n                    <div ng-if=\"cart.isErplyStore\">\r\n                      <div class=\"col-xs-3 p-a-0 text-xs-right\">${{cart.getFinalPriceInfo(item) | number : 2}}</div>\r\n                    </div>\r\n\r\n\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"hidden-sm-down\">\r\n                <button class=\"btn btn-primary btn-block remove-btn\"\r\n                  ng-click=\"cart.removeItemFromCart(item.item.id)\">Remove</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- <div class=\"col-md-1 m-l-0 p-x-0 hidden-sm-down\">\r\n            <img ng-click=\"cart.removeItemFromCart(item.item.id)\"\r\n              src={{cart.closeIcon}} class=\"close-icon\"/>\r\n          </div> -->\r\n\r\n          <div class=\"col-xs-4 col-md-2 hidden-md-up\">\r\n            <button class=\"hidden-btn\" ng-disabled=\"!(cart.isItemActive(item) || cart.isItemDscMembership(item))\"\r\n              ng-click=\"cart.goToDetailPage(item)\">\r\n              <img img-lazy-loader={{item.item.mediumImageUrl}}\r\n                ng-class=\"cart.isItemActive(item) || cart.isItemDscMembership(item) ? 'product-thumbnail cursor-pointer' : 'product-thumbnail inactive-item'\" />\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <hr class=\"m-x-1 hidden-sm-down\">\r\n\r\n        <!--Discount Message -->\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"cart.discountType  === 'SUBCATEGORY' && item.item.masterProduct.isDiscountable\">\r\n          <span ng-repeat=\"subCategory in cart.discountCoupon.subCategories\">\r\n            <span ng-repeat=\"itemsubCategory in item.item.masterProduct.subCategories\">\r\n              <span ng-if=\"itemsubCategory.id == subCategory.id\">\r\n                </br>*Extra discount provided during checkout\r\n              </span>\r\n            </span>\r\n          </span>\r\n        </div>\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"item.item.id == cart.maxPriceId && cart.discountType  === 'HIGHPERCENTAGE'\">\r\n          <span>*Extra discount provided during checkout </span>\r\n        </div>\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"cart.discountType  === 'PERCENTAGE' && item.masterProduct.isDiscountable\">\r\n          <span>*Extra discount provided during checkout </span>\r\n        </div>\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"cart.discountType == 'FREEITEM' && item.item.id == cart.discountFreeItemId\" class=\"delivery-type-only\">\r\n          <br />*Extra discount provided during checkout\r\n        </div>\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"cart.discountType == 'BUYXGETY' && item.item.id == cart.discountFreeItemId\" class=\"delivery-type-only\">\r\n          <br />*Extra discount provided during checkout\r\n        </div>\r\n\r\n        <!-- Remove button mobile -->\r\n        <div class=\"col-xs-12 m-b-1 place_order_btn cart-form-border hidden-md-up\">\r\n          <!-- <button type=\"button\" disabled\r\n            class=\"col-xs-6 btn btn-primary btn-bdr btn-md-text\">Favorite</button> -->\r\n          <button type=\"button\" class=\"col-xs-12 btn btn-primary btn-md-text m-b-15\"\r\n            ng-click=\"cart.removeItemFromCart(item.item.id)\">Remove</button>\r\n        </div>\r\n        <!--  <hr class=\"hidden-md-up xs-ruler\">\r\n -->\r\n      </form>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 col-md-4 m-x-0 p-x-0\">\r\n      <div class=\"div_border m-x-0 p-x-0\">\r\n        <div class=\"border_pdding\">\r\n          <h5 class=\"font-weight-bold m-y-1\">Order Detail</h5>\r\n          <!-- Erply Changes for subtotal -->\r\n          <h6 class=\"m-b-1\" ng-if=\"!cart.isErplyStore\">\r\n            <span>Subtotal</span>\r\n            <span class=\"font-weight-bold pull-xs-right\">${{cart.getSubtotal() | number : 2}}</span>\r\n          </h6>\r\n          \r\n          <h6 class=\"m-b-1\" ng-if=\"cart.isErplyStore\">\r\n            <span>Subtotal</span>\r\n            <span class=\"font-weight-bold pull-xs-right\">${{cart.detail.erplyShopCartResponse.totalRetailPrice |\r\n              number : 2}}</span>\r\n          </h6>\r\n          \r\n          <h6 class=\"m-b-1\" ng-if=\"cart.orderPoints.discountWrapper\">\r\n            <span ng-if=\"cart.orderPoints.discountWrapper.couponAmount\">Promo Code</span>\r\n            <span class=\" pull-xs-right\" ng-if=\"cart.orderPoints.discountWrapper.couponAmount\">-$\r\n              {{cart.orderPoints.discountWrapper.couponAmount | number : 2}}</span>\r\n          </h6 ng-if=\"cart.orderPoints.discountWrapper\">\r\n          <h6 class=\"m-b-1\" ng-if=\"cart.couponAmount && cart.isValidToApplyBB && !cart.isErplyStore\">\r\n            <span>Bird Buck Code</span>\r\n            <span class=\"pull-xs-right\">-${{cart.couponAmount | number : 2}}</span>\r\n          </h6>\r\n          <!-- Erply BB coupon discount -->\r\n          <h6 ng-if=\"cart.isErplyStore && cart.detail.erplyPromoAndDiscount && cart.erplyDis && cart.erplyDis.length>0\">\r\n            <hr>\r\n            <div ng-repeat=\"item in cart.erplyDis | orderBy: 'sortId'\">\r\n              <span >{{cart.getAdjustedLabelName(item.key)}}\r\n                <span ng-if=\"item.key.length>cart.promoLengthToBeShown\">\r\n                  <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"cart.infoPopuponhover('popup_order',$index,null,item.key)\" ng-mouseleave=\"cart.hideinfoPopup('popup_order',$index,null,item.key)\"></i>\r\n                  <div id=\"{{'popup_order'+$index+item.key}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                      {{item.key}}\r\n                  </div>\r\n                </span>  \r\n              </span>\r\n              <span class=\"pull-xs-right\">-${{item.value | number : 2}}</span>\r\n            </div>\r\n          </h6>\r\n\r\n          <!-- Erply Promotion discount {{cart.erplyShopCartResponse}}-->\r\n          <!-- <h6 class=\"m-b-1\" ng-if=\"cart.isErplyStore && cart.detail.erplyShopCartResponse && cart.detail.erplyShopCartResponse.erplyPromotionDiscount\">\r\n            <span>Promo Code</span>\r\n            <span class=\"pull-xs-right\">(-)${{cart.detail.erplyShopCartResponse.erplyPromotionDiscount | number : 2}}</span>\r\n          </h6> -->\r\n\r\n          <h6 class=\"m-b-1\" ng-if=\"!cart.isErplyStore && (cart.isDscMember() || cart.cartContainsDsc())\">\r\n            <span>Club Points</span>\r\n            <span class=\"pull-xs-right\">{{cart.orderPoints.dscPoints | number : 2}}</span>\r\n          </h6>\r\n          <h6 class=\"m-b-1\" ng-if=\"!cart.isErplyStore && cart.isDscButExpired() && !cart.cartContainsDsc()\">\r\n            <span>Club Points</span>\r\n            <span class=\"pull-xs-right\"><s uib-tooltip=\"Your Club Membership has expired\">{{cart.orderPoints.dscPoints |\r\n                number : 2}}</s></span>\r\n          </h6>\r\n        </div>\r\n\r\n        <h6 class=\"m-b-1 gray-bg p-a-1 font-weight-bold\" style=\"margin-bottom: 0px !important\"\r\n          ng-if=\"cart.isErplyStore && cart.detail.erplyShopCartResponse.totalRetailPrice!=cart.detail.erplyShopCartResponse.subtotalAfterDiscount\">\r\n          <span>Subtotal (after discount)</span>\r\n          <span class=\"pull-xs-right\">${{cart.detail.erplyShopCartResponse.subtotalAfterDiscount | number : 2}}</span>\r\n        </h6>\r\n\r\n      </div>\r\n\r\n      <div class=\"div_border m-x-0 p-x-0\" style=\"margin-top: 10px; margin-bottom: 10px;\" ng-if=\"((!cart.isErplyStore && cart.getTotalSaving()>0) || (cart.isErplyStore && cart.detail.erplyShopCartResponse.totalSavings>0))\">\r\n        <div class=\"border_pdding\">\r\n          <h6 class=\"m-y-1\">\r\n            <span style=\"font-weight: 700; font-size: 1.2rem;\">\r\n              <span>You Saved</span>\r\n              <span class=\"pull-xs-right\" ng-if=\"!cart.isErplyStore\">\r\n                ${{cart.getTotalSaving() | number : 2}}</span>\r\n              <span class=\"pull-xs-right\" ng-if=\"cart.isErplyStore\">\r\n                ${{cart.detail.erplyShopCartResponse.totalSavings | number : 2}}</span>\r\n            </span>\r\n          </h6>\r\n        </div>\r\n      </div>\r\n      \r\n      <div class=\"div_border m-x-0 p-x-0\" style=\"margin-top: 10px; margin-bottom: 10px;\"\r\n        ng-if=\"(!cart.isErplyStore && cart.getTotalSaving()==0) || (cart.isErplyStore && cart.detail.erplyShopCartResponse.totalSavings==0)\r\n        && (!cart.isDscMember() && !cart.isDscAddedinCart())\">\r\n        <div class=\"border_pdding\">\r\n          <h6 class=\"m-y-1\">\r\n            <span ng-if=\"!cart.isDscMember() && !cart.isDscAddedinCart()\">You could save ${{cart.getSavedAmount() |\r\n              number : 2}}</span>\r\n            <!--DSC Label-->\r\n            <span class=\"row m-l-1 pull-xs-right\" style=\"min-height:57px;\" ng-if=\"!cart.isDscMember()\">\r\n              <span ng-if=\"cart.canUserJoin() && !cart.isDscAddedinCart()\" style=\"line-height: 13px; cursor: pointer\"\r\n                ui-sref=\"savings-club\">\r\n                <a href ng-click=\"cart.goToSavingsClub()\">\r\n                  <span class=\"white-med-bold-text  hidden-md-down\" style=\"display:inline-block\">\r\n                    <button class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\">Join\r\n                      Now</button>\r\n                  </span>\r\n                </a>\r\n                <span class=\"white-med-bold-text hidden-lg-up \" style=\"display:inline-block;margin-top: 0px;\">\r\n                  <button class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                    style=\"margin-top: 0px !important; padding: 0px !important;\" ui-sref=\"savings-club\">Join\r\n                    Now</button>\r\n                </span>\r\n              </span>\r\n\r\n              <span ui-sref=\"savings-club\"\r\n                ng-if=\"cart.isDscMember() && cart.profile.customer.email && !cart.isDscAddedinCart()\"\r\n                class=\"cursor-pointer\" style=\"line-height: 13px;\">\r\n                <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                  <button class=\"hidden-md-down renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                    ng-click=\"cart.userAction(cart.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                    ui-sref=\"savings-club\">Renew</button>\r\n                </span>\r\n              </span>\r\n\r\n              <span ng-if=\"cart.isDscButExpired() && cart.profile.customer.email && !cart.isDscAddedinCart()\"\r\n                style=\"line-height: 13px;\">\r\n                <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                  <button class=\" renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                    ng-click=\"cart.userAction(cart.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                    ui-sref=\"savings-club\">Renew</button>\r\n                </span>\r\n              </span>\r\n            </span>\r\n          </h6>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"m-x-0 p-x-0\" style=\"margin-top: 10px; margin-bottom: 10px;\"\r\n        ng-if=\"(!cart.isErplyStore && cart.getTotalSaving()>0) || (cart.isErplyStore && cart.detail.erplyShopCartResponse.totalSavings>0)\r\n        && (!cart.isDscMember() && !cart.isDscAddedinCart())\">\r\n        <div class=\"border_pdding\" style=\"font-weight: 700;font-size : 0.75rem\">\r\n            <span>Want to save more? <a ui-sref=\"savings-club\" style=\"color: blue;\">Click here to join the Daily Savings Club</a></span></div>\r\n      </div>\r\n\r\n      <div class=\"mt-4 place_order_btn\">\r\n        <button ng-click=\"cart.proceedToCheckout()\"\r\n          ng-disabled=\"(cart.isAnyItemInactive() && !cart.cartContainsDsc()) || cart.deliveryTypeValidation()\"\r\n          class=\"btn btn-primary btn-block btn-md-text\">Proceed to Checkout</button>\r\n      </div>\r\n      <div class=\"mt-4 place_order_btn\">\r\n        <a ui-sref=\"category\" class=\"btn btn-primary btn-block btn-md-text\">Continue Shopping </a>\r\n      </div>\r\n\r\n      <div class=\"mt-4 place_order_btn\" ng-show=\"cart.isFreeShippingOfferAvailable() && !cart.isErplyStore\">\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"cart.shippingOffer.isOfferEligible && cart.detail.user.store.country.countryCode =='US'\"> <img\r\n            ng-src={{cart.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Your order qualifies\r\n            for <a class=\"blue-colored\" href ng-click=\"cart.showFreeShippingOfferDetail(true)\"><u><b>FREE\r\n                  Shipping*</b></u></a></span></div>\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"cart.shippingOffer.isOfferEligible && cart.detail.user.store.country.countryCode =='CA'\"> <img\r\n            ng-src={{cart.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Your order qualifies\r\n            for <a class=\"blue-colored\" href ng-click=\"cart.showFreeShippingOfferDetailCan(true)\"><u><b>FREE\r\n                  Shipping*</b></u></a></span></div>\r\n\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"!cart.shippingOffer.isOfferEligible && cart.detail.user.store.country.countryCode =='US'\"> <img\r\n            ng-src={{cart.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Add <span\r\n              class=\"shipping-offer-remaining-amount\">${{cart.getFreeShippingRemainingAmount() | number : 2}} </span>to\r\n            your order to qualify for <a class=\"blue-colored\" href\r\n              ng-click=\"cart.showFreeShippingOfferDetail(true)\"><u><b>FREE Shipping*</b></u></a>\r\n          </span></div>\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"!cart.shippingOffer.isOfferEligible && cart.detail.user.store.country.countryCode =='CA'\"> <img\r\n            ng-src={{cart.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Add <span\r\n              class=\"shipping-offer-remaining-amount\">${{cart.getFreeShippingRemainingAmount() | number : 2}} </span>to\r\n            your order to qualify for <a class=\"blue-colored\" href\r\n              ng-click=\"cart.showFreeShippingOfferDetailCan(true)\"><u><b>FREE Shipping*</b></u></a>\r\n          </span></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!--    <div class=\"col-md-7 m-y-1 p-r-0\">\r\n        <h4 class=\"font-weight-bold m-b-0\"\r\n          ng-bind=\"item.item.name\"></h4>\r\n        <p ng-bind=\"item.item.subCategory.name\"></p>\r\n        <div class=\"col-xs-12 p-x-0\">\r\n          <p class=\"product-text\">Quantity</p>\r\n          <div class=\"form-group height col-xs-7 p-x-0\"\r\n            ng-class=\"{'has-danger': (cartForm.$submitted || cartForm.quantity.$touched) && cartForm.quantity.$invalid}\">\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  ng-disabled=\"item.quantity < 2\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"item.quantity = item.quantity - 1; cart.updateItemInCart(item.quantity, item.item.id)\">&#150;</button>\r\n              </span>\r\n              <input name=\"quantity\" disabled\r\n                type=\"number\"\r\n                class=\"form-control counter-input\"\r\n                ng-model=\"item.quantity\"\r\n                ng-min=\"1\" ng-max=\"999999\" />\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"item.quantity = item.quantity + 1; cart.updateItemInCart(item.quantity, item.item.id);\">+</button>\r\n              </span>\r\n            </div>\r\n            <div ng-messages=\"cartForm.quantity.$error\"\r\n              class=\"form-control-feedback\"\r\n              ng-show=\"cartForm.quantity.$touched || cartForm.$submitted\">\r\n              <div ng-message=\"required\">Enter Quantity</div>\r\n              <div ng-message=\"min\">Enter a valid Quantity</div>\r\n              <div ng-message=\"max\">Enter a valid Quantity</div>\r\n              <div class=\"error-text\"\r\n                ng-show=\"cartForm.errors.quantity && !cartForm.quantity.$error.required\">{{ cartForm.errors.quantity[0] }}</div>\r\n            </div>\r\n          </div>\r\n          <span class=\"primary-text lbs-text\">{{item.item.weight}} lbs</span>\r\n        </div>\r\n\r\n        <h5 class=\"m-t-1 font-weight-bold m-b-0\">\r\n          <span>{{cart.currencyType}} ${{item.itemTotalPrice | number : 2}}</span>\r\n          <small class=\"primary-text discount-text\"\r\n            ng-if=\"(cart.isDscMember() || cart.cartContainsDsc()) && item.item.subCategory.category.dscCategory\">15% Off</small>\r\n        </h5>\r\n      </div>\r\n      <div class=\"col-xs-5 m-y-1\">\r\n        <img src={{item.item.mediumImageUrl}} class=\"img-fluid product-img-cart\" />\r\n      </div>\r\n      <div class=\"col-xs-12 p-x-0\">\r\n        <button type=\"button\" disabled\r\n          class=\"col-xs-6 btn btn-primary btn-bdr btn-md-text\">Favorite</button>\r\n        <button type=\"button\"\r\n          class=\"col-xs-6 btn btn-primary btn-md-text\"\r\n          ng-click=\"cart.removeItemFromCart(item.item.id)\">Remove</button>\r\n      </div>\r\n    </form>\r\n    <div class=\"col-xs-12 p-t-2 p-b-1\">\r\n      <h5 class=\"font-weight-bold m-b-1\">Order Detail</h5>\r\n      <h6 class=\"m-b-1\">\r\n        <span>Price</span>\r\n        <span class=\"pull-xs-right\">${{cart.totalRetailPrice() | number : 2}}</span>\r\n      </h6>\r\n      <h6 class=\"m-b-1\">\r\n       <span>Tax</span>\r\n       <span class=\"pull-xs-right\">${{cart.totalTax() | number : 2}}</span>\r\n      </h6>\r\n      <h6 ng-if=\"(cart.isDscMember() || cart.cartContainsDsc())\">\r\n        <span>Club Discount</span>\r\n        <span class=\"pull-xs-right\">- ${{cart.totalDSC() | number : 2}}</span>\r\n      </h6>\r\n    </div>\r\n    <div class=\"col-xs-12 gray-bg p-y-1\">\r\n      <h3 class=\"font-weight-bold m-b-0\">Total\r\n        <span class=\"pull-xs-right\">${{(cart.totalRetailPrice() + cart.totalTax() - cart.totalDSC()) | number : 2}}</span>\r\n      </h3>\r\n    </div>\r\n    <div class=\"col-xs-10 offset-xs-1 col-sm-4 offset-sm-4 p-y-2\">\r\n      <a ui-sref=\"delivery\"\r\n        class=\"btn btn-primary btn-block btn-md-text\">Proceed to Checkout</a>\r\n    </div>\r\n  </div> -->\r\n  <div class=\"row p-t-2 m-x-0\" ng-if=\"!cart.detail || (cart.detail.cartItems && !cart.detail.cartItems.length)\">\r\n    <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n      <h5 class=\"font-weight-bold\">Cart Empty</h5>\r\n      <p class=\"m-t-1\">Add Items in the cart to purchase.</p>\r\n      <div class=\"m-t-3 p-t-3\">\r\n        <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"category\">Start New Order</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAvUlEQVQ4T7WUUQ6CQAxEp95qPyQa9RzgzfAcmmj0g1u5ZkkwJZROPxb+yE7ezrTdCip/UpmH7YH3z3C47NMr4tzSzhwWwQ54IqM/NenqQR/voRdB+wWO2sAi8iT0oJMmZ9zOTer0xWYNPagHK+DVplhQBnOB5VBDx1iCzopJI2vBHwqAwajDmcvyE+i+O9i6ZuPtgpZBaVN0zMhIuWNj1YxBVwfba4AHNZ9epJvhp1d1OUQ2DNNsvw+ZA3b+A/RulhXEbTcqAAAAAElFTkSuQmCC"

/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmZDI4MGYxNy0yNGU2LTQ3N2YtOWU0OS05MGY2MjdhMGQ2MTAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODc1RDcwN0U0NzkwMTFFN0EyMDVDQzUwMkJBMkZDQjgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODc1RDcwN0Q0NzkwMTFFN0EyMDVDQzUwMkJBMkZDQjgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDplNjYzNWNmZi03MWE2LTRkZTgtODJmNC0zYTNlODI3NzFjMzYiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpiNGYyZGEzMi04ZmQzLTExN2EtYmYxNS1jYjA3MWUwZGQ5YTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7MWxgEAAAGPklEQVR42txaDWwVRRDe11q1QBFEEVSioFJEKVHxJwholbZqMGqK8afYSEL9QyVpNGqUCGr8oZKINSAxGhTFAFUhovhTlVoxES1UCkSCJkXRSmlVaG2E0j6/yc2r67y9e+/u9jV9TPLlcrt3e/vtzszOzm0kGo2qI1GOCttA7qJd+m0EyAPOASYApwMnAUOAHH6mHWgF9gGNwGZgG1APdPn9/s45Z6WGGMt5wHSgEBgNDPT5PpH9CfgMWAVsAkKpUiSoKmKmMnC5GriTCR1jaZC6gc+BpcAa4HCQGcsISOpi/ug64NokSR1O1EmtT1OB1cCHwGUptzEQysblYeABoJ+HWu1g2/kO2AP8CXSwetF7g4CTgQsYY7lMSgETWwzMA/ZbV0WQysXlJR5Nk5BdvAl8yc7AjyMgZ3MpUMLXTJf27wHqklHFpIiBFH1sOTDSUL0BWAR8AHSGtC/yqkXA/Wy/UpqAmcDHoW0MpPJxec9AqolHsIjtrdOC46BR/ojtthTYLeqHs+1dl4yhJpopcr8niioasSkYrSW4HkrB+trFGjIReFfU0Xq4ArgqEDGQOgOXt4ETRNWrQDFI/dgLAcRvwE3A86K8HxOf4IsYSJH7fgUYIapeBMpA6u9ejI5oiXiQvaIuNOCvoa8D/czYI0C+KKMRKgepaEjnEFTmAwtE2TigIiliGAGa3odE8VfAbJDqCtChHF731rNtzgWOD0juUaBKlJWhz9d4uns8kMkebpr2zAFgEkg1JBEEm0itNLjuWuAGDob9yjBgIzBKrHH56GOH24wVCFIkC9xIJSF3u6xHkw1akaz8zu/qJnERO5l4VcTIk/7fKxrZDlQG7AC1faVH/aQQgXMVx6m6zOaQL27G8gwdqcRsHUiRt4uEfH+hCAoo5pxiIkZTeax2/4vBUP1uP2o96r8BDoZovwb4QpSV/I8YO41C8dBqzFZryFGlda/aJaB9xsKsL5PqDS6D9W0LRde5ImZbb+HDpMY3AvcBV/BAbmTCey20T201A0P5/jRWyeoYsXOBAdoLv7LjsCF/AU8Cz7FdHbRopz9zrqRQ00Bah6szNMPT5QeoYZNlZ3HIMqmYfG3Iv/So4ihRucvSR0fzCHYbdu6kEVssfON7cT9CJya3JTstEaPF+QWXukpLxJoMwXGPux8iKlssZpy8onYbQvnJNu2+v04sRzz8j6WPRgPW+ZEOQSyiE5MfyVTpI1GvbYvcOGanEbFssVRFdWJ/iIdPTSNiQ4UpdejE9omHz04jYsNEQN2qE2sUD5/J8WM6yDhxv0cnVic3xkQuTYhNFPf1OrGGmG6yUB79/DQgdUoshNIcx7c6sW2GMGp6GhC7RDnZYV0N63qIIeDtNOybCmBnfd2JlMqAGFxa5A56pdhqkwud1YdJ0T+6IlG2wpQa2MzbbV1mYtbG9FFi5SIZ1KCnCnqIcTJ0sXh5MG8S+5pQgrRYlC0BhzbTjJGsM9haMWbt9oAd8PpjenTANmknUiHi2a3AW6ZYUWlOZL7YUtCqXgFy4wN0Yi+reJ3AFt7WBxH68zJWlD0h04TGP5ogsZB1WBdaEqahgd3iWa9OZCknpSc/Est9+P23Rj9LnhZlNFOl6Fe364xpMje20GlCCZ8qEBnpoyOdvFdqF2gLQGoO8JQhhVEuSbkS4+T+LBWfIqP8xRqQy+tFR0Gz+zinGPT+0gkC+lfX7LUfM5Hbygtgu6giUp+C3G29QGo4r03zRDnN9h2G5SkxMSb3CS63iq13bA/0BsgtT1GwnMWDSgnRmw3qTaRWeTWQ8NQAyL3PcaMpzzhDOT8Fn1VOqs0GoeuVcyLndRV/UoEOwpRwnbf++jjAQvb1sopPriptF06D8A5HAY1JkqEf5ZRin8yzc6HbGCvn3FaNGPhwxJjcII5E7kqw+NLs7mBsZydEDqmbF+bjlHPkL4/XpDEeCzZ1cJlyjjo1GzQqPDGNIB07ekwFPMDlQzbxurXWw1SC2ZhLY9UcWc9gA7ctdLisTDl/aNYGWiPCHp3F7JHB0wmeW4DL2eCzfDZDAThFNLW8faoRO3rld8ZsnDAl97uB0Z+dy3hOLdD/KsqlD9C2GLQGUR6zRf33G6ieY8j9tqY8cqQedv5XgAEA5Sa/PXcZjk4AAAAASUVORK5CYII="

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.13.1';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError',
	    'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a cache value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to stub `Date#getTime` use in `_.now`.
	   * var stubbed = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': stubGetTime };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype,
	        stringProto = context.String.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice;
	
	    /** Built-in method references that are mockable. */
	    var setTimeout = function(func, wait) { return context.setTimeout.call(root, func, wait); };
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetPrototype = Object.getPrototypeOf,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReplace = stringProto.replace,
	        nativeReverse = arrayProto.reverse,
	        nativeSplit = stringProto.split;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	     * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	     * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	     * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	     * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	     * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	     * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	     * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	     * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	     * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      return getMapData(this, key)['delete'](key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      getMapData(this, key).set(key, value);
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      this.__data__ = new ListCache(entries);
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      return this.__data__['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var cache = this.__data__;
	      if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	        cache = this.__data__ = new MapCache(cache.__data__);
	      }
	      cache.set(key, value);
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      // Recursively populate clone (susceptible to call stack limits).
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined &&
	              !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return object != null &&
	        (hasOwnProperty.call(object, key) ||
	          (typeof object == 'object' && key in object && getPrototype(object) === null));
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = keysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      stack['delete'](srcValue);
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce `n` to an integer.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var index = -1,
	          props = getAllKeysIn(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]);
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && baseHas(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        predicate = getIteratee(predicate, 3);
	        if (!isArrayLike(collection)) {
	          var props = keys(collection);
	        }
	        var index = findIndexFunc(props || collection, function(value, key) {
	          if (props) {
	            key = value;
	            value = iterable[key];
	          }
	          return predicate(value, key, iterable);
	        }, fromIndex);
	        return index > -1 ? collection[props ? props[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return 0;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
	          : arrayMap(baseFlatten(iteratees, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!seen.has(othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.add(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and
	          // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	          // not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	          stack.set(object, other);
	
	          // Recursively compare objects (susceptible to call stack limits).
	          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a
	     * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	     * Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the `[[Prototype]]` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {null|Object} Returns the `[[Prototype]]`.
	     */
	    function getPrototype(value) {
	      return nativeGetPrototype(Object(value));
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    function getSymbols(object) {
	      // Coerce `object` to an object to avoid non-object errors in V8.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	      return getOwnPropertySymbols(Object(object));
	    }
	
	    // Fallback for IE < 11.
	    if (!getOwnPropertySymbols) {
	      getSymbols = stubArray;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isString(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value);
	    }
	
	    /**
	     * Checks if `value` is a flattenable array and not a `_.matchesProperty`
	     * iteratee shorthand.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenableIteratee(value) {
	      return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          args = Array(length ? length - 1 : 0),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return length
	        ? arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other given
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index - 1, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = baseFlatten(indexes, 1);
	
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function, it's
	     * invoked for and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      if (isObjectLike(collection)) {
	        var tag = getTag(collection);
	        if (tag == mapTag || tag == setTag) {
	          return collection.size;
	        }
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	        ? iteratees[0]
	        : baseFlatten(iteratees, 1, isFlattenableIteratee);
	
	      return baseOrderBy(collection, iteratees, []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    function now() {
	      return Date.now();
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [transforms[_.identity]] The functions to transform.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value)) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? stubFalse : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element,
	     *  else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) || isFunction(value.splice) ||
	            isArguments(value) || isBuffer(value))) {
	        return !value.length;
	      }
	      if (isObjectLike(value)) {
	        var tag = getTag(value);
	        if (tag == mapTag || tag == setTag) {
	          return !value.size;
	        }
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return !(nonEnumShadows && keys(value).length);
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object,
	     *  else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number,
	     *  else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array and weak map constructors,
	      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length,
	     *  else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the
	     * presence of the `core-js` package because `core-js` circumvents this kind
	     * of detection. Despite multiple requests, the `core-js` maintainer has made
	     * it clear: any attempt to fix the detection will be obstructed. As a result,
	     * we're left with little choice but to throw an error. Unfortunately, this
	     * also affects packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on `core-js`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error('This method is not supported with `core-js`. Try https://github.com/es-shims.');
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object,
	     *  else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer,
	     *  else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keysIn(source), object);
	        return;
	      }
	      for (var key in source) {
	        assignValue(object, key, source[key]);
	      }
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : nativeReplace.call(string, args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (separator == '' && reHasComplexSymbol.test(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return nativeSplit.call(string, separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(baseToString(target), position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['onClick']);
	     * jQuery(element).on('click', view.onClick);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        key = toKey(key);
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': function(n) { return n > 38; } }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A method that returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return rest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * A method that returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * A method that returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * A method that returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * A method that returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * A method that returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    });
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    });
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    });
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    });
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose Lodash on the free variable `window` or `self` when available so it's
	  // globally accessible, even when bundled with Browserify, Webpack, etc. This
	  // also prevents errors in cases where Lodash is loaded by a script tag in the
	  // presence of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch
	  // for more details. Use `_.noConflict` to remove Lodash from the global object.
	  (freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)(module), (function() { return this; }())))

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _question = __webpack_require__(113);
	
	var _question2 = _interopRequireDefault(_question);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _guestCart = __webpack_require__(204);
	
	var _guestCart2 = _interopRequireDefault(_guestCart);
	
	var _close = __webpack_require__(200);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _alert = __webpack_require__(192);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _shippingInfo = __webpack_require__(201);
	
	var _shippingInfo2 = _interopRequireDefault(_shippingInfo);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var guestCart = (_dec = (0, _utils.Component)({
	  controllerAs: 'guestCart',
	  template: _guestCart2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function guestCart($scope, $rootScope, $ngRedux, $spinner, $auth, $order, $state, $uibModal, $timeout, $window, $stateParams, APP, toaster) {
	    var _this = this;
	
	    _classCallCheck(this, guestCart);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.dscMasterCode = '88888888'; // Named constant
	    this.$window = $window;
	    this.APP = APP;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.$order = $order;
	    this.$scope = $scope;
	    this.$uibModal = $uibModal;
	    this.homeArrow = _homeArrow2.default;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$spinner = $spinner;
	    this.$toaster = toaster;
	    this.info = _question2.default;
	    // Icons
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.closeIcon = _close2.default;
	    this.alertIcon = _alert2.default;
	    this.shippingOfferInfoIcon = _shippingInfo2.default;
	    this.shippingOfferAvailableIcon = _shippingTick2.default;
	    // Variables
	    this.shippingOffer = {};
	    this.shippingOffer.thresholdAmount = 1500;
	    this.shippingOffer.isOfferEligible = false;
	    this.discountType = null;
	    this.isMiscelleneousCategory = 4;
	    this.giftCardMasterCodeStartsWith = '9';
	    this.isErplyStore = false;
	    this.promoLengthToBeShown = 25;
	    this.numberOfItemsAllowedToPurchase = 40;
	    this.doPageNeedsToBeRefreshed = false;
	    $window.scrollTo(0, 0);
	    this.currencyType = 'USD';
	    $spinner.show('appSpinner');
	    if (this.$auth.isGuestLogin()) {
	      // Getting Session Guest cart details
	      $auth.getGuestCart();
	
	      // End Saving Guest User and cart in Guest DB--------------------------------
	      // const guestUser = this.$auth.getGuestUser();
	      // this.$auth.getGuestUserById(guestUser.guestUserId).then(success => {
	      //   $spinner.hide('appSpinner');
	      // },
	      //   error => {
	      //     $spinner.hide('appSpinner');
	      //   });
	      // End Saving Guest User and cart in Guest DB--------------------------------
	      // if (this.guestCartList && this.guestCartList.length) {
	      // const user = {
	      //   role: 7, // Guest User Role
	      //   storeURLName: store ? store.storeName : null,
	      //   cartTotalItems: this.guestCartList.length ? this.guestCartList.map(data => data.quantity).reduce((total, data) => total + data) : 0
	      // };
	      // this.$auth.saveGuestUser(user).then(success => {
	      //   this.$auth.addGuestUser(success.data.userId, success.data.ipaddress);
	      //   $spinner.hide('appSpinner');
	      // }, error => {
	      //   $spinner.hide('appSpinner');
	      // });
	      // } else {
	      $spinner.hide('appSpinner');
	      // }
	      if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        this.storeName = $stateParams.storeName;
	      } else {
	        this.storeName = this.$auth.getGuestStoreDetail().storeName;
	      }
	      this.$auth.getStoreDetail(this.storeName).then(function (success) {
	        if (_this.storeDetail) {
	          if (_this.storeDetail.hasErply) {
	            _this.isErplyStore = true;
	          }
	          $timeout(function () {
	            _this.country = _this.storeDetail.country.countryCode ? _this.storeDetail.country.countryCode : 'US';
	            _this.currencyType = $order.getCurrencyType(_this.country);
	          }, 500);
	        }
	      }).catch(function (err) {
	        _this.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        // Gettig Guest cart Details
	        _this.getGuestCartDetails();
	      });
	    }
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(guestCart, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        detail: state.order.cartDetail,
	        storeDetail: state.auth.storeDetail,
	        discountCoupon: state.order.discountCoupon,
	        coupon: state.order.coupon,
	        storeDiscountMap: state.order.storeDiscountMap,
	        orderPoints: state.order.orderPoints,
	        guestCartList: state.auth.guestCartList,
	        isAnyItemInactive: state.order.cartDetail && state.order.cartDetail.cartItems ? state.order.cartDetail.cartItems.find(function (item) {
	          return !(item.item.isActive && item.item.masterProduct.isActive && item.item.price >= item.item.regionalPrice && !item.item.isOutOfStock);
	        }) : false
	      };
	    }
	  }, {
	    key: 'getGuestCartDetails',
	    value: function getGuestCartDetails() {
	      var _this2 = this;
	
	      this.$spinner.show('appSpinner');
	      this.$order.getGuestCartDetail(this.createGuestCartRequest()).then(function (success) {
	        _this2.$spinner.hide('appSpinner');
	        if (success.data) {
	          if (success.data.itemToBeRemovedFromCart) {
	            _this2.doPageNeedsToBeRefreshed = true;
	            var title = "Some Items removed from cart due to an internal issue";
	            var detailInfo = "Item(s) : \n";
	            if (success.data.itemToBeRemovedFromCart.hasItemsToRemoveFromCart) {
	              for (var b = 0; b < success.data.itemToBeRemovedFromCart.itemsToBeRemoved.length; b++) {
	                // For guest, remove items from
	                _this2.removeItemFromCart(success.data.itemToBeRemovedFromCart.itemsToBeRemoved[b].itemId);
	                detailInfo = detailInfo + success.data.itemToBeRemovedFromCart.itemsToBeRemoved[b].itemName;
	                if (b + 1 < success.data.itemToBeRemovedFromCart.itemsToBeRemoved.length) {
	                  detailInfo = detailInfo + ",";
	                }
	              }
	              _this2.$uibModal.open({
	                size: 'sm',
	                backdrop: 'static',
	                keyboard: false,
	                template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + title + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	                controller: ['$scope', 'orderService', '$uibModalInstance', '$window', function ($scope, $order, $uibModalInstance, $window) {
	                  $scope.ok = function () {
	                    $uibModalInstance.close();
	                  };
	                }],
	                resolve: {}
	              });
	            } else {
	              _this2.doPageNeedsToBeRefreshed = false;
	            }
	          }
	        }
	
	        if (_this2.detail && _this2.detail.shopCartResponse) {
	          _this2.discountType = _this2.detail.shopCartResponse.promoCode;
	        }
	        if (_this2.detail && _this2.detail.cartItems && _this2.detail.cartItems.length && _this2.guestCartList) {
	          _this2.guestCartList.forEach(function (ele) {
	            if (ele && ele.itemId && !_this2.detail.cartItems.find(function (item) {
	              return ele.itemId === item.item.id;
	            })) {
	              _this2.$auth.removetoGuestCart(ele.itemId);
	              _this2.$auth.getGuestCart();
	            }
	          });
	          if (_this2.detail.cartItems.length > _this2.guestCartList.length) {
	            _this2.detail.cartItems.forEach(function (ele) {
	              if (ele && ele.item && !_this2.guestCartList.find(function (item) {
	                return item.itemId === ele.item.id;
	              })) {
	                _this2.$auth.addtoGuestCart({
	                  'quantity': ele.quantity, 'itemId': ele.item.id,
	                  'subCategoryId': ele.subCategory.id, 'categoryId': ele.subCategory.category.id, 'masterProductId': ele.item.masterProduct.id
	                });
	              }
	            });
	          }
	          _this2.erplyDis = [];
	          var dis = {};
	          var ctrl = _this2;
	          if (ctrl.detail.promotionsAppliedOnItems) {
	            angular.forEach(ctrl.detail.promotionsAppliedOnItems, function (id, value) {
	              angular.forEach(ctrl.detail.cartItems, function (item) {
	                if (item.item.masterProduct.masterCode == value) {
	                  item.item.promotionsAppliedOnItems = id;
	                }
	              });
	            });
	            console.log(_this2.detail.cartItems);
	          }
	          var i = 0;
	          angular.forEach(_this2.detail.erplyPromoAndDiscount, function (item, key) {
	            dis = {};
	            console.log('key', key);
	            console.log('item', item);
	            dis.key = key;
	            dis.value = item;
	            dis.sortId = i + 1;
	            i = i + 1;
	            ctrl.erplyDis.push(dis);
	          });
	        }
	      }).catch(function (err) {
	        _this2.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        _this2.$spinner.hide('appSpinner');
	      });
	    }
	  }, {
	    key: 'createGuestCartRequest',
	    value: function createGuestCartRequest() {
	      var cartData = this.guestCartList.filter(function (data) {
	        return !data.isDscCard;
	      });
	      var guestCartDeliveryRequest = sessionStorage.getItem('GuestCartRequest') ? JSON.parse(sessionStorage.getItem('GuestCartRequest')) : null;
	      var appliedPromoCoupon = [];
	      if (sessionStorage.getItem('discountCoupon')) {
	        appliedPromoCoupon = sessionStorage.getItem('discountCoupon').split(',');
	      }
	      if (guestCartDeliveryRequest && guestCartDeliveryRequest.guestCartItems && guestCartDeliveryRequest.guestCartItems.length > 0) {
	        guestCartDeliveryRequest.guestCartItems = [].concat(_toConsumableArray(cartData));
	        return guestCartDeliveryRequest;
	      } else {
	        return {
	          isGuest: true,
	          deliveryType: 'In Store Pickup',
	          shipTo: null,
	          manualPromotionIDs: appliedPromoCoupon,
	          guestCartItems: cartData
	        };
	      }
	    }
	  }, {
	    key: 'proceedToCheckout',
	    value: function proceedToCheckout() {
	      if (this.doPageNeedsToBeRefreshed) {
	        this.$window.location.reload();
	        return;
	      }
	
	      var activeCartItems = this.guestCartList ? this.guestCartList : [];
	      if (this.numberOfItemsAllowedToPurchase < activeCartItems.length) {
	        var detailInfo = "An order can have a maximum of 40 items. Please remove some items from the cart to proceed.";
	        this.showErrorMsgPopup(detailInfo);
	        return;
	      }
	
	      if (this.isAnyItemInactive) {
	        this.$toaster.pop('success', 'Some items in your cart are temporarily unavailable.  Please remove those items to continue with your purchase.');
	        return false;
	      }
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-body" id="modal-body">\n            <div class="row">\n              <div class="col-md-6">\n                <button ng-if="isStoreActive" ng-click="ok()" ui-sref="guestdelivery" class="btn btn-primary btn-block btn-md-text">Continue as Guest</button>\n                <div ng-if="!isStoreActive" class="error-text" ng-bind="errorMessage"></div>\n                <button ng-if="!isStoreActive" class="btn btn-primary btn-block btn-md-text">Continue as Guest</button>\n                <span>You can register an account later </span>\n                <br/>\n                <br/>\n                <button type="button" class="btn btn-primary btn-block btn-sm-text mockup-btn" ng-click="ok()" \n                        ui-sref="signup({storeName: ' + $ctrl.storeURLName + '})">\n                        <span>Register Now</span>\n                        </button>\n              </div>\n              <div class="col-md-6" style="border-left: 1px solid #c1c1c1;">\n                            <form class="login-form" name="loginForm"\n                            ng-submit="submit(loginForm)"\n                            autocomplete="off"\n                            novalidate>\n                        <div class="error-text" ng-bind="loginForm.error.message"></div>\n                        <div class="form-group"\n                            ng-class="{\'has-danger\': (loginForm.$submitted || loginForm.email.$touched) && loginForm.email.$invalid }">\n                          <label>Email&nbsp<span><a href="#" tooltips tooltip-template="Daily Savings Club Members must register with the same email address that is associated with the \'in-store\' account in order to receive membership benefits. If you do not know which email address was provided, please contact the store." tooltip-size="small" tooltip-smart="true" tooltip-class="info-tooltip" tooltip-side="right">\n                          <img src="' + $ctrl.info + '" alt="info"></a></span></label>\n                          <input name="email"\n                                type="email"\n                                ng-pattern="/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+.[A-Za-z0-9_-]*.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+.[A-Za-z0-9_-]*.[A-Za-z]{2,}.[A-Za-z]{2,})$/"\n                                class="form-control"\n                                ng-model="login.email"\n                                required>\n                          <div ng-messages="loginForm.email.$error"\n                              class="form-control-feedback"\n                              ng-show="loginForm.email.$touched || loginForm.$submitted">\n                            <div ng-message="required">Enter email address</div>\n                            <div ng-message="pattern">Enter a valid email address</div>\n                            <div ng-message="email">Enter a valid email address</div>\n                            <div class="error-text"\n                                ng-show="loginForm.errors.email && !loginForm.email.$error.required && !loginForm.email.$error.pattern">{{ loginForm.errors.email[0] }}</div>\n                          </div>\n                        </div>\n                        <div class="form-group"\n                            ng-class="{\'has-danger\': (loginForm.$submitted || loginForm.password.$touched) && loginForm.password.$invalid }">\n                          <label>Password</label>\n                          <div class="password-container margin-ten">\n                          <input name="password"\n                                type="password"\n                                class="form-control"\n                                ng-model="login.password"\n                                ng-minlength="6"\n                                ng-maxlength="60"\n                                id="passwordIdGuestCart"\n                                required>\n                            <i class="far fa-eye-slash" ng-click="togglePassword(\'passwordIdGuestCart\',\'togglePasswordGuestCart\')" id="togglePasswordGuestCart"\n                            style="cursor: pointer;"></i>\n                          </div>\n                          <div ng-messages="loginForm.password.$error"\n                              class="form-control-feedback"\n                              ng-if="loginForm.password.$touched || loginForm.$submitted">\n                            <div ng-message="required">Password is required</div>\n                            <div ng-message="minlength">Minimum Password length should be 6</div>\n                            <div ng-message="maxlength">Maximum Password length should be 60</div>\n                            <div class="error-text"\n                                ng-show="loginForm.errors.password && !loginForm.password.$error.required">{{ loginForm.errors.password[0] }}</div>\n                          </div>\n                        </div>\n                      \n                        <p class="text-xs-center gray-text mb-4">\n                          By using this site, you agree to <a target="_blank" ng-click="ok()" ui-sref="tnc" class="link-text">Terms and Conditions</a> and <a target="_blank" ui-sref="rules" class="link-text">Rules</a>.\n                        </p>\n                      \n                        <button type="submit"\n                                class="btn btn-primary btn-block login-margin btn-sm-text mockup-btn">Log in</button>\n                      \n                        <p class="mt-4 m-b-1">\n                          <a ui-sref="forgotPassword" ng-click="ok()" class="link-text gray-text">Forgot Password?</a>\n                        </p>\n                      \n                      </form>\n              </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-primary" type="button" ng-click="ok()">Cancel</button>\n        </div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.isStoreActive = $ctrl.storeDetail.isActive;
	          if (!$scope.isStoreActive) {
	            $scope.errorMessage = "Your store is currently undergoing maintenance.  Please try again, or contact the store at (" + $ctrl.storeDetail.phoneNumber.substring(0, 3) + " ) " + $ctrl.storeDetail.phoneNumber.substring(3, 6) + " - " + $ctrl.storeDetail.phoneNumber.substring(6, 10);
	          }
	
	          $scope.togglePassword = function (passwordId, toggleId) {
	            $ctrl.$auth.togglePassword(passwordId, toggleId);
	          };
	
	          $scope.ok = function () {
	            if (!$scope.isStoreActive) {
	              $scope.errorMessage = "Your store is currently undergoing maintenance.  Please try again, or contact the store at (" + $ctrl.storeDetail.phoneNumber.substring(0, 3) + " ) " + $ctrl.storeDetail.phoneNumber.substring(3, 6) + " - " + $ctrl.storeDetail.phoneNumber.substring(6, 10);
	              return false;
	            }
	            $uibModalInstance.close();
	          };
	
	          $scope.isScreenSmall = function () {
	            if ($ctrl.$window.innerHeight < 300) return true;
	          };
	
	          $scope.submit = function (form) {
	            var _this3 = this;
	
	            if (form.$invalid) {
	              return;
	            }
	            form.error = {};
	            $ctrl.$spinner.show('appSpinner');
	            $ctrl.$auth.registerLogin({
	              email: form.email.$viewValue,
	              password: form.password.$viewValue
	            }).then(function (success) {
	              $ctrl.$spinner.hide('appSpinner');
	              $uibModalInstance.close();
	              $ctrl.$rootScope.$emit('loginFromPopup', success);
	            }, function (error) {
	              $ctrl.$spinner.hide('appSpinner');
	              if (error.data.errorCode === 621) {
	                $uibModalInstance.close();
	                $ctrl.$state.go('inactive');
	              } else {
	                form.error = error.data;
	              }
	            }).catch(function (err) {
	              _this3.$auth.printCustomerGenericLogs(err);
	            });
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'getRetailPrice',
	    value: function getRetailPrice(quantity, price) {
	      return quantity * price;
	    }
	  }, {
	    key: 'getClubDiscount',
	    value: function getClubDiscount(quantity, price) {
	      return this.getRetailPrice(quantity, price) - this.getDiscountedPrice(quantity, price);
	    }
	  }, {
	    key: 'getDiscountedPrice',
	    value: function getDiscountedPrice(quantity, price) {
	      return quantity * (Math.round(0.85 * price * 100) / 100);
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'getMaxItemDiscount',
	    value: function getMaxItemDiscount(discount, price) {
	      return Math.round(discount * price / 100 * 100) / 100;
	    }
	  }, {
	    key: 'totalRetailPrice',
	    value: function totalRetailPrice() {
	      return this.detail.cartItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      });
	    }
	  }, {
	    key: 'getSavedAmount',
	    value: function getSavedAmount() {
	      return this.getSubtotal() - this.getDSCAmount();
	    }
	  }, {
	    key: 'getDSCAmount',
	    value: function getDSCAmount() {
	      var totalPrice = 0;
	      var dscItems = this.detail.cartItems.filter(function (item) {
	        return item.subCategory.category.dscCategory;
	      });
	      var dscTotal = dscItems.map(function (item) {
	        return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	      var nondscItems = this.detail.cartItems.filter(function (item) {
	        return !item.subCategory.category.dscCategory;
	      });
	      var nonDscTotal = nondscItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	      totalPrice = dscTotal + nonDscTotal;
	      return totalPrice;
	    }
	  }, {
	    key: 'getSubtotal',
	    value: function getSubtotal() {
	      var totalPrice = 0;
	      if (this.isErplyStore) {
	        totalPrice = this.detail.erplyShopCartResponse.subTotal;
	      } else {
	        totalPrice = this.totalRetailPrice();
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'getTotalSaving',
	    value: function getTotalSaving() {
	      return this.totalRetailPrice() - this.getSubtotal();
	    }
	  }, {
	    key: 'getDscPoints',
	    value: function getDscPoints() {
	      return this.getSubtotal();
	    }
	  }, {
	    key: 'updateItemInCart',
	    value: function updateItemInCart(quantity, item) {
	      var _this4 = this;
	
	      var guestCartItems = this.guestCartList.map(function (element) {
	        if (element.itemId === item.item.id) {
	          element.quantity = quantity;
	        }
	        return element;
	      });
	      if (guestCartItems) {
	        this.$auth.updatetoGuestCart(guestCartItems);
	        this.$auth.getGuestCart();
	        setTimeout(function () {
	          _this4.getGuestCartDetails();
	        }, 1000);
	      }
	    }
	  }, {
	    key: 'removeItemFromCart',
	    value: function removeItemFromCart(itemId) {
	      var cartItem = this.guestCartList.find(function (element) {
	        return element.itemId === itemId;
	      });
	      if (cartItem) {
	        this.$auth.removetoGuestCart(cartItem.itemId);
	        // Check Freeitem and buxgety
	        var freeItem = this.detail.cartItems.find(function (ele) {
	          return (ele.discountTypeApplied === 'FREEITEM' || ele.discountTypeApplied === 'BUYXGETY') && ele.isDiscountApplied;
	        });
	        if (freeItem && freeItem.item.id === itemId) {
	          sessionStorage.removeItem('discountCoupon');
	          var guestCartDeliveryRequest = sessionStorage.getItem('GuestCartRequest') ? JSON.parse(sessionStorage.getItem('GuestCartRequest')) : null;
	          guestCartDeliveryRequest.manualPromotionIDs = [];
	          sessionStorage.setItem('GuestCartRequest', JSON.stringify(guestCartDeliveryRequest));
	        }
	        this.$auth.getGuestCart();
	        this.getGuestCartDetails();
	      }
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!(this.profile && this.profile.customer)) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'canUserJoin',
	    value: function canUserJoin() {
	      return !(this.isDscMember() || this.isDscButExpired());
	    }
	  }, {
	    key: 'cartContainsDsc',
	    value: function cartContainsDsc() {
	      var _this5 = this;
	
	      var arr = this.detail ? this.detail.cartItems.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this5.dscMasterCode;
	      }) : [];
	      return arr.length === 1;
	    }
	  }, {
	    key: 'goToDetailPage',
	    value: function goToDetailPage(item) {
	      if (this.isItemDscMembership(item)) {
	        this.$state.go('savings-club');
	      } else {
	        var storeName = '';
	        if (this.$stateParams.storeName) {
	          storeName = this.$stateParams.storeName;
	        } else {
	          if (this.profile.store && this.profile.store.storeName) {
	            storeName = this.profile.store.storeURLName;
	          } else {
	            storeName = this.$auth.getGuestStoreDetail().storeName;
	          }
	        }
	        // let storeName =  false;
	        if (storeName) {
	          this.$state.go('browse-product.detail', {
	            categoryId: item.item.masterProduct.category.prettyUrl,
	            subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl,
	            productId: item.item.masterProduct.prettyUrl,
	            itemGroupNumber: item.item.masterProduct.itemGroupNumber,
	            storeName: storeName
	          });
	        } else {
	          this.$state.go('browse-product.detail', {
	            categoryId: item.item.masterProduct.category.prettyUrl,
	            subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl,
	            productId: item.item.masterProduct.prettyUrl,
	            itemGroupNumber: item.item.masterProduct.itemGroupNumber
	          });
	        }
	      }
	    }
	  }, {
	    key: 'isItemDscMembership',
	    value: function isItemDscMembership(item) {
	      return item.item.masterProduct.masterCode === this.dscMasterCode;
	    }
	  }, {
	    key: 'isItemActive',
	    value: function isItemActive(item) {
	      return item.item.isActive && item.item.masterProduct.isActive && item.item.price >= item.item.regionalPrice && !item.item.isOutOfStock;
	    }
	  }, {
	    key: 'isFreeShippingOfferAvailable',
	    value: function isFreeShippingOfferAvailable() {
	      var store = this.profile && this.profile.store || this.storeDetail;
	      if (store && this.detail.freeshipping) {
	        var shippingOfferStartDate = new Date(this.detail.freeshipping.startDate);
	        var shippingOfferEndDate = new Date(this.detail.freeshipping.endDate);
	        var currentDate = new Date();
	        var result = false;
	        if (store) {
	          if (store.isFreeShipping) {
	            if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	              result = true;
	            }
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'shippingGrossPrice',
	    value: function shippingGrossPrice() {
	      var totalGiftCardAmountPurchasing = 0.00;
	      var $ctrl = this;
	      angular.forEach(this.detail.cartItems, function (item, key) {
	        if (item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory && item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith) {
	          totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + item.item.price * item.quantity;
	        }
	      });
	      if (this.isErplyStore) {
	        return this.getSubtotal() - totalGiftCardAmountPurchasing;
	      } else {
	        return this.getSubtotal() - totalGiftCardAmountPurchasing - (this.detail && this.detail.shopCartResponse && this.detail.shopCartResponse.promoDiscount ? this.detail.shopCartResponse.promoDiscount : 0);
	      }
	    }
	  }, {
	    key: 'getFreeShippingRemainingAmount',
	    value: function getFreeShippingRemainingAmount() {
	      if (this.detail) {
	        if (this.detail.freeshipping) {
	          this.shippingOffer.thresholdAmount = this.detail.freeshipping.thresholdValue;
	        }
	      }
	      var remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
	      if (remainingAmount >= 0) {
	        this.shippingOffer.isOfferEligible = true;
	      } else {
	        this.shippingOffer.isOfferEligible = false;
	      }
	      return remainingAmount * -1;
	    }
	  }, {
	    key: 'showFreeShippingOfferDetail',
	    value: function showFreeShippingOfferDetail() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free Shipping within Zone 2';
	      } else {
	        tittle = 'Free Shipping within Zone 2';
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showFreeShippingOfferDetailCan',
	    value: function showFreeShippingOfferDetailCan() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free shipping in Zones 0-1';
	      } else {
	        tittle = 'Free shipping in Zones 0-1';
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'isDscAddedinCart',
	    value: function isDscAddedinCart() {
	      return this.detail.cartItems.some(function (cartItem) {
	        return cartItem.item.storeItemCode === 'C';
	      });
	    }
	  }, {
	    key: 'deliveryTypeValidation',
	    value: function deliveryTypeValidation() {
	      if (this.detail && this.detail.cartItems && this.detail.cartItems.length) {
	        var pickupExist = this.detail.cartItems.filter(function (element) {
	          return element.item.deliveryType == 'InStore';
	        });
	        var dropExist = this.detail.cartItems.filter(function (element) {
	          return element.item.deliveryType == 'DropShip';
	        });
	        if (pickupExist && pickupExist.length && dropExist && dropExist.length) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getFinalPriceInfo',
	    value: function getFinalPriceInfo(item) {
	      if (this.detail != null) {
	        if (this.detail.erplyShopCartResponse != null && this.detail.erplyShopCartResponse.erplyItemDetails) {
	          if (this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode]) {
	            return this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode].finalPriceOfItem;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getCouldSaveDSCAmount',
	    value: function getCouldSaveDSCAmount() {
	      return this.detail.erplyShopCartResponse.originalPriceTotal - this.getDSCAmount();
	    }
	  }, {
	    key: 'isCartHasDSCItems',
	    value: function isCartHasDSCItems() {
	      var dscItems = this.detail.cartItems.filter(function (item) {
	        return item.subCategory.category.dscCategory;
	      });
	      if (dscItems.length > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'getAdjustedLabelName',
	    value: function getAdjustedLabelName(promoLabel) {
	      if (promoLabel != null && promoLabel.length > this.promoLengthToBeShown) {
	        return promoLabel.substring(0, this.promoLengthToBeShown - 3) + "...";
	      } else {
	        return promoLabel;
	      }
	    }
	  }, {
	    key: 'hideinfoPopup',
	    value: function hideinfoPopup(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopuponhover',
	    value: function infoPopuponhover(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'showErrorMsgPopup',
	    value: function showErrorMsgPopup(detailInfo) {
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold"> </h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }]);
	
	  return guestCart;
	}(), _class2.$inject = ['$scope', '$rootScope', '$ngRedux', 'spinnerService', 'authService', 'orderService', '$state', '$uibModal', '$timeout', '$window', '$stateParams', 'APP', 'toaster'], _temp)) || _class);
	exports.default = guestCart;

/***/ },
/* 204 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"guestCart.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{guestCart.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Your Cart</span>\r\n  </nav>\r\n\r\n  <!-- Out of stock notice -->\r\n  <div class=\"cart_header p-t-1\" ng-if=\"guestCart.isAnyItemInactive\">\r\n    <div class=\"alert-user oos-msg\">\r\n      <span><img class=\"alert-icon\" src={{guestCart.alertIcon}}></span>\r\n      <span class=\"alert-text\">\r\n        Some items in your cart are temporarily unavailable. Please remove those items to continue with your purchase.\r\n      </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Delivery Type Validation -->\r\n  <div class=\"cart_header p-t-1\" ng-if=\"guestCart.deliveryTypeValidation()\">\r\n    <div class=\"alert-user oos-msg\">\r\n      <span><img class=\"alert-icon\" src={{guestCart.alertIcon}}></span>\r\n      <span class=\"alert-text\">\r\n        Your cart contains some items that are store pickup and delivery only. If you would like to proceed to checkout,\r\n        please remove those items or complete a separate order.\r\n      </span>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Your cart heading -->\r\n  <div class=\"row m-y-1 p-t-1 cart_header hidden-sm-down m-x-0\" ng-if=\"guestCart.detail.cartItems.length\">\r\n    <h4 class=\"font-weight-bold\">Your Cart</h4>\r\n  </div>\r\n\r\n  <!-- Row for cart items and prices -->\r\n  <div class=\"row cart-content-spacing m-y-1 m-x-0 padding-0-sm\" ng-if=\"guestCart.detail.cartItems.length\">\r\n\r\n    <!-- List of CartItems -->\r\n    <div class=\"col-xs-12 col-md-8 m-x-0 p-x-0\">\r\n      <form name=\"cartForm\" ng-repeat=\"item in guestCart.detail.cartItems | orderBy : 'item.name'\" autocomplete=\"off\"\r\n        novalidate>\r\n\r\n        <div class=\"row m-x-0 p-x-0\">\r\n          <!-- Product Image -->\r\n          <div class=\"col-xs-4 col-md-3 hidden-sm-down\">\r\n            <button class=\"hidden-btn\"\r\n              ng-disabled=\"!(guestCart.isItemActive(item) || guestCart.isItemDscMembership(item))\"\r\n              ng-click=\"guestCart.goToDetailPage(item)\">\r\n              <img src={{item.item.mediumImageUrl}}\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? 'product-thumbnail cursor-pointer' : 'product-thumbnail inactive-item'\" />\r\n            </button>\r\n          </div>\r\n\r\n          <div class=\"col-xs-8 col-md-8 p-r-0 p-l-1 m-x-0\">\r\n            <div class=\"col-xs-12 col-md-7 m-b-1 p-x-0\">\r\n              <!-- Out of stock Button -->\r\n              <button class=\"btn btn-primary remove-btn out-of-stock-btn mb-8\"\r\n                ng-if=\"!(guestCart.isItemActive(item) || guestCart.isItemDscMembership(item))\">\r\n                Temporarily Unavailable\r\n              </button>\r\n              <!-- Product Name -->\r\n              <div\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? '' : 'inactive-item'\">\r\n                <button class=\"hidden-btn\"\r\n                  ng-disabled=\"!(guestCart.isItemActive(item) || guestCart.isItemDscMembership(item))\"\r\n                  ng-click=\"guestCart.goToDetailPage(item)\">\r\n                  <h4 class=\"font-weight-bold m-b-0 text-xs-left\" style=\"color:black\" ng-bind=\"item.item.name\"></h4>\r\n                </button>\r\n\r\n              </div>\r\n              <!-- Product Weight -->\r\n              <div\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? 'weight_cell weight-text hidden-sm-down' : 'inactive-item weight_cell weight-text hidden-sm-down'\">\r\n                <span ng-show=\"item.item.weight\">{{item.item.weight}} lbs</span>\r\n                <span ng-if=\"item.item.deliveryType === 'InStore'\" class=\"delivery-type-only\"><br />In Store/Curbside\r\n                  Pickup Only</span>\r\n                <span ng-if=\"item.item.deliveryType === 'DropShip'\" class=\"delivery-type-only\"><br />Delivery\r\n                  Only</span>\r\n              </div>\r\n\r\n              <!-- Cart Item Individual Price detail -->\r\n              <div\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? 'normal-text m-b-0 m-t-1 hidden-sm-down' : 'inactive-item normal-text m-b-0 m-t-1 hidden-sm-down'\">\r\n\r\n                <!-- Regular price -->\r\n                <div class=\"col-xs-9 p-a-0\">Regular Price: {{item.quantity}} x ${{item.item.price | number : 2}}</div>\r\n                <div class=\"col-xs-3 p-a-0 text-xs-right\">${{guestCart.getRetailPrice(item.quantity, item.item.price) |\r\n                  number : 2}}</div>\r\n\r\n                <!-- erplyPromoAndDiscount -->\r\n                <div ng-if=\"item.item.promotionsAppliedOnItems\">\r\n                  <div ng-repeat=\"displayVal in item.item.promotionsAppliedOnItems | orderBy: 'sortId'\">\r\n                    <span class=\"col-xs-9 p-a-0\">{{guestCart.getAdjustedLabelName(displayVal.label)}}\r\n                      <span ng-if=\"displayVal.label.length>guestCart.promoLengthToBeShown\">\r\n                        <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"guestCart.infoPopuponhover('guest_desktop_popup',$index,item.item.name,displayVal.label)\" ng-mouseleave=\"guestCart.hideinfoPopup('guest_desktop_popup',$index,item.item.name,displayVal.label)\"></i>\r\n                        <div style=\"position: relative;\">\r\n                          <div id=\"{{'guest_desktop_popup'+$index+item.item.name+displayVal.label}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                            {{displayVal.label}}\r\n                          </div>\r\n                        </div>\r\n                      </span>\r\n                    </span>\r\n                    <span class=\"col-xs-3 p-a-0 text-xs-right\">-${{displayVal.discountValue | number : 2}}</span>\r\n                  </div>\r\n                </div>\r\n                <!-- Club Discount -->\r\n                <!-- <div class=\"col-xs-9 p-a-0\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != guestCart.maxPriceId\">\r\n                  Club Discount <small class=\"primary-text discount-text\"\r\n                 ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.id!= guestCart.maxPriceId\">(15% Off)</small>: </div>\r\n\r\n                 <div class=\"col-xs-3 p-a-0 text-xs-right\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id!= guestCart.maxPriceId\">-${{guestCart.getClubDiscount(item.quantity, item.item.price) | number : 2}}\r\n                 </div>\r\n\r\n\r\n                 <div class=\"col-xs-9 p-a-0\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == guestCart.maxPriceId && item.quantity>1\">\r\n                  Club Discount <small class=\"primary-text discount-text\"\r\n                 ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == guestCart.maxPriceId && item.quantity > 1\">(15% Off on {{item.quantity-1}} items)</small>: </div>\r\n\r\n                 <div class=\"col-xs-3 p-a-0 text-xs-right\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == guestCart.maxPriceId && item.quantity > 1\">-${{guestCart.getClubDiscount(item.quantity-1, item.item.price) | number : 2}}\r\n                 </div> -->\r\n\r\n                <div class=\"col-xs-9 p-a-0 font-weight-bold\"> Your Price </div>\r\n                <div ng-if=\"!guestCart.isErplyStore\">\r\n                  <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                    ng-if=\"!(guestCart.isDscMember() || guestCart.cartContainsDsc()) || !item.subCategory.category.dscCategory && item.item.id != guestCart.maxPriceId\">\r\n                    ${{guestCart.getRetailPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n\r\n                  <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                    ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != guestCart.maxPriceId\">\r\n                    ${{guestCart.getDiscountedPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n\r\n                  <div class=\"col-xs-3 p-a-0 text-xs-right\" ng-if=\"item.item.id == guestCart.maxPriceId \">\r\n                    ${{guestCart.getRetailPrice(item.quantity, item.item.price) -\r\n                    guestCart.getClubDiscount(item.quantity-1, item.item.price) | number : 2}}</div>\r\n                </div>\r\n                <div ng-if=\"guestCart.isErplyStore\">\r\n                  <div class=\"col-xs-3 p-a-0 text-xs-right\"> ${{guestCart.getFinalPriceInfo(item) | number : 2}}</div>\r\n                </div>\r\n\r\n                <div ng-if=\"guestCart.discountType  === 'SUBCATEGORY' && item.item.masterProduct.isDiscountable\">\r\n                  <span ng-repeat=\"subCategory in guestCart.discountCoupon.subCategories\">\r\n                    <span ng-repeat=\"itemsubCategory in item.item.masterProduct.subCategories\">\r\n                      <span ng-if=\"itemsubCategory.id == subCategory.id\">\r\n                        </br>*Extra discount provided during checkout\r\n                      </span>\r\n                    </span>\r\n                  </span>\r\n                </div>\r\n                <div class=\"col-xs-12 p-a-0 \"\r\n                  ng-if=\"item.item.id == guestCart.maxPriceId && guestCart.discountType  === 'HIGHPERCENTAGE'\">\r\n                  <span>*Extra discount provided during checkout </span>\r\n                </div>\r\n\r\n                <div ng-if=\"guestCart.discountType  === 'PERCENTAGE' && item.item.masterProduct.isDiscountable\">\r\n                  <span>*Extra discount provided during checkout </span>\r\n                </div>\r\n                <span ng-if=\"guestCart.discountType == 'FREEITEM' && item.isDiscountApplied\"\r\n                  class=\"delivery-type-only\"><br />*Extra discount provided during checkout </span>\r\n                <span ng-if=\"guestCart.discountType == 'BUYXGETY' && item.isDiscountApplied\"\r\n                  class=\"delivery-type-only\"><br />*Extra discount provided during checkout </span>\r\n              </div>\r\n\r\n\r\n            </div>\r\n\r\n            <!-- Quantity, Remove Button and Mobile Calculations -->\r\n            <div class=\"col-xs-12 col-md-5 p-l-1 p-r-0 m-x-0 p-b-1\">\r\n              <p\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? 'product-text' : 'inactive-item product-text'\">\r\n                Quantity</p>\r\n              <div\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? '' : 'inactive-item'\">\r\n                <div class=\"form-group height p-x-0 m-x-0\"\r\n                  ng-class=\"{'has-danger': (cartForm.$submitted || cartForm.quantity.$touched) && cartForm.quantity.$invalid}\">\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\"\r\n                        ng-disabled=\"item.quantity < 2 || !(guestCart.isItemActive(item) || guestCart.isItemDscMembership(item))\"\r\n                        class=\"btn btn-primary counter-btn\"\r\n                        ng-click=\"item.quantity = item.quantity - 1; guestCart.updateItemInCart(item.quantity, item)\">&#150;</button>\r\n                    </span>\r\n                    <input name=\"quantity\" disabled type=\"number\" class=\"form-control counter-input\"\r\n                      ng-model=\"item.quantity\" ng-min=\"1\" ng-max=\"999999\" />\r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\" class=\"btn btn-primary counter-btn\"\r\n                        ng-disabled=\"!(guestCart.isItemActive(item)) || guestCart.isItemDscMembership(item)\"\r\n                        ng-click=\"item.quantity = item.quantity + 1; guestCart.updateItemInCart(item.quantity, item);\">+</button>\r\n                    </span>\r\n                  </div>\r\n                  <div ng-messages=\"cartForm.quantity.$error\" class=\"form-control-feedback\"\r\n                    ng-show=\"cartForm.quantity.$touched || cartForm.$submitted\">\r\n                    <div ng-message=\"required\">Enter Quantity</div>\r\n                    <div ng-message=\"min\">Enter a valid Quantity</div>\r\n                    <div ng-message=\"max\">Enter a valid Quantity</div>\r\n                    <div class=\"error-text\" ng-show=\"cartForm.errors.quantity && !cartForm.quantity.$error.required\">{{\r\n                      cartForm.errors.quantity[0] }}</div>\r\n                  </div>\r\n                  <div class=\"lbs-text p-x-0 weight_cell hidden-md-up ng-binding p-t-1\" ng-show=\"item.item.weight\">\r\n                    {{item.item.weight}} lbs\r\n                    <span ng-if=\"item.item.deliveryType === 'InStore'\" class=\"delivery-type-only\"><br />In\r\n                      Store/Curbside Pickup Only</span>\r\n                    <span ng-if=\"item.item.deliveryType === 'DropShip'\" class=\"delivery-type-only\"><br />Drop Ship\r\n                      Only</span>\r\n                    <span ng-if=\"item.item.weight == '1'\" class=\"delivery-type-only\"><br />Discount Applied</span>\r\n                  </div>\r\n\r\n\r\n                  <!-- Calculations for Small Devices -->\r\n                  <div class=\"normal-text m-b-0 m-t-1 hidden-md-up\">\r\n                    <div class=\"col-xs-9 p-a-0\">Regular Price: {{item.quantity}} x ${{item.item.price | number : 2}}\r\n                    </div>\r\n                    <div class=\"col-xs-3 p-a-0 text-xs-right\">${{guestCart.getRetailPrice(item.quantity,\r\n                      item.item.price) | number : 2}}</div>\r\n\r\n                    <!-- erplyPromoAndDiscount -->\r\n                    <div ng-if=\"item.item.promotionsAppliedOnItems\">\r\n                      <div ng-repeat=\"displayVal in item.item.promotionsAppliedOnItems  | orderBy: 'sortId'\">\r\n                        <span class=\"col-xs-9 p-a-0\">{{guestCart.getAdjustedLabelName(displayVal.label)}}\r\n                          <span ng-if=\"displayVal.label.length>guestCart.promoLengthToBeShown\">\r\n                            <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"guestCart.infoPopuponhover('guest_mobile_popup',$index,item.item.name,displayVal.label)\" ng-mouseleave=\"guestCart.hideinfoPopup('guest_mobile_popup',$index,item.item.name,displayVal.label)\"></i>\r\n                            <div style=\"position: relative;\">\r\n                              <div id=\"{{'guest_mobile_popup'+$index+item.item.name+displayVal.label}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                                {{displayVal.label}}\r\n                              </div>\r\n                            </div>\r\n                          </span>\r\n                        </span>\r\n                        <span class=\"col-xs-3 p-a-0 text-xs-right\">-${{displayVal.discountValue | number : 2}}</span>\r\n                      </div>\r\n                    </div>\r\n                    <!-- <div class=\"col-xs-8 p-a-0\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != guestCart.maxPriceId\">\r\n                      Club Discount <small class=\"primary-text discount-text\"\r\n                     ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.id == guestCart.maxPriceId && item.quantity > 1\">(15% Off)</small>: </div>\r\n\r\n                     <div class=\"col-xs-3 p-a-0 text-xs-right\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id!= guestCart.maxPriceId\">-${{guestCart.getClubDiscount(item.quantity, item.item.price) | number : 2}}\r\n                     </div>\r\n                                 <div class=\"col-xs-9 p-a-0\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == guestCart.maxPriceId && item.quantity>1\">\r\n                  Club Discount <small class=\"primary-text discount-text\"\r\n                 ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == guestCart.maxPriceId && item.quantity > 1\">(15% Off on {{item.quantity-1}} items)</small>: </div>\r\n\r\n                 <div class=\"col-xs-4 p-a-0 text-xs-right\" ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id == guestCart.maxPriceId && item.quantity > 1\">-${{guestCart.getClubDiscount(item.quantity-1, item.item.price) | number : 2}}\r\n                 </div> -->\r\n                    <div class=\"col-xs-9 p-a-0 font-weight-bold\">Your Price </div>\r\n                    <div ng-if=\"!guestCart.isErplyStore\">\r\n\r\n                      <div class=\"col-xs-3 p-a-0 text-xs-right\"\r\n                        ng-if=\"(guestCart.isDscMember() || guestCart.cartContainsDsc()) && item.subCategory.category.dscCategory && item.item.id != guestCart.maxPriceId\">\r\n                        ${{guestCart.getDiscountedPrice(item.quantity, item.item.price) | number : 2}}</div>\r\n                      <div class=\"col-xs-9 p-a-0 text-xs-right\" ng-if=\"item.item.id == guestCart.maxPriceId \">\r\n                        ${{guestCart.getRetailPrice(item.quantity, item.item.price) -\r\n                        guestCart.getClubDiscount(item.quantity-1, item.item.price) | number : 2}}</div>\r\n                    </div>\r\n                    <div ng-if=\"guestCart.isErplyStore\">\r\n                      <div class=\"col-xs-3 p-a-0 text-xs-right\">\r\n                        ${{guestCart.getFinalPriceInfo(item) | number : 2}}</div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"hidden-sm-down\">\r\n                <button class=\"btn btn-primary btn-block remove-btn\"\r\n                  ng-click=\"guestCart.removeItemFromCart(item.item.id)\">Remove</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"col-xs-4 col-md-2 hidden-md-up\">\r\n            <button class=\"hidden-btn\"\r\n              ng-disabled=\"!(guestCart.isItemActive(item) || guestCart.isItemDscMembership(item))\"\r\n              ng-click=\"guestCart.goToDetailPage(item)\">\r\n              <img img-lazy-loader={{item.item.mediumImageUrl}}\r\n                ng-class=\"guestCart.isItemActive(item) || guestCart.isItemDscMembership(item) ? 'product-thumbnail cursor-pointer' : 'product-thumbnail inactive-item'\" />\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <hr class=\"m-x-1 hidden-sm-down\">\r\n\r\n        <!--Discount Message -->\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"guestCart.discountType  === 'SUBCATEGORY' && item.item.masterProduct.isDiscountable\">\r\n          <span ng-repeat=\"subCategory in guestCart.discountCoupon.subCategories\">\r\n            <span ng-repeat=\"itemsubCategory in item.item.masterProduct.subCategories\">\r\n              <span ng-if=\"itemsubCategory.id == subCategory.id\">\r\n                </br>*Extra discount provided during checkout\r\n              </span>\r\n            </span>\r\n          </span>\r\n        </div>\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"item.item.id == guestCart.maxPriceId && guestCart.discountType  === 'HIGHPERCENTAGE'\">\r\n          <span>*Extra discount provided during checkout </span>\r\n        </div>\r\n        <div class=\"col-xs-12 p-l-2 p-b-1 hidden-md-up\"\r\n          ng-if=\"guestCart.discountType  === 'PERCENTAGE' && item.masterProduct.isDiscountable\">\r\n          <span>*Extra discount provided during checkout </span>\r\n        </div>\r\n\r\n        <!-- Remove button mobile -->\r\n        <div class=\"hidden-md-up\">\r\n          <div class=\"m-b-1 mt-4 place_order_btn\">\r\n            <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text \"\r\n              ng-click=\"guestCart.removeItemFromCart(item.item.id)\">Remove</button>\r\n          </div>\r\n          <hr>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 col-md-4 m-x-0 p-x-0\">\r\n      <div class=\"div_border m-x-0 p-x-0\">\r\n        <div class=\"border_pdding\">\r\n          <h5 class=\"font-weight-bold m-y-1\">Order Detail</h5>\r\n          <!-- Erply Changes for subtotal -->\r\n          <h6 class=\"m-b-1\" ng-if=\"!guestCart.isErplyStore\">\r\n            <span>Subtotal</span>\r\n            <span class=\"font-weight-bold pull-xs-right\">${{guestCart.detail.shopCartResponse.subTotal | number :\r\n              2}}</span>\r\n          </h6>\r\n          <h6 class=\"m-b-1\" ng-if=\"guestCart.isErplyStore\">\r\n            <span>Subtotal</span>\r\n            <span class=\"font-weight-bold pull-xs-right\">${{guestCart.detail.erplyShopCartResponse.totalRetailPrice |\r\n              number : 2}}</span>\r\n          </h6>\r\n          <h6 class=\"m-b-1\"\r\n            ng-if=\"guestCart.detail.shopCartResponse.promoCode && guestCart.detail.shopCartResponse.promoDiscount\">\r\n            <span>Promo Code</span>\r\n            <span class=\" pull-xs-right\" ng-if=\"guestCart.detail.shopCartResponse.promoDiscount\">-$\r\n              {{guestCart.detail.shopCartResponse.promoDiscount | number : 2}}</span>\r\n          </h6>\r\n          <!-- Erply coupon discount -->\r\n          <h6\r\n            ng-if=\"guestCart.isErplyStore && guestCart.detail.erplyPromoAndDiscount && guestCart.erplyDis && guestCart.erplyDis.length>0\">\r\n            <hr>\r\n            <div class=\"m-b-1\" ng-repeat=\"item in guestCart.erplyDis | orderBy: 'sortId'\">\r\n              <span>{{guestCart.getAdjustedLabelName(item.key)}}</span>\r\n              <span ng-if=\"item.key.length>guestCart.promoLengthToBeShown\">\r\n                <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"guestCart.infoPopuponhover('guest_popup_order',$index,null,item.key)\" ng-mouseleave=\"guestCart.hideinfoPopup('guest_popup_order',$index,null,item.key)\"></i>\r\n                <div id=\"{{'guest_popup_order'+$index+item.key}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                    {{item.key}}\r\n                </div>\r\n              </span>  \r\n            </span>\r\n              <span class=\"pull-xs-right\">-${{item.value | number : 2}}</span>\r\n            </div>\r\n          </h6>\r\n\r\n          <h6 class=\"m-b-1\" ng-if=\"!guestCart.isErplyStore && (guestCart.isDscMember() || guestCart.cartContainsDsc())\">\r\n            <span>Club Points</span>\r\n            <span class=\"pull-xs-right\">{{guestCart.detail.shopCartResponse.dscDiscountAmount | number : 2}}</span>\r\n          </h6>\r\n          <h6 class=\"m-b-1\"\r\n            ng-if=\"!guestCart.isErplyStore && guestCart.isDscButExpired() && !guestCart.cartContainsDsc()\">\r\n            <span>Club Points</span>\r\n            <span class=\"pull-xs-right\"><s\r\n                uib-tooltip=\"Your Club Membership has expired\">{{guestCart.detail.shopCartResponse.dscDiscountAmount |\r\n                number : 2}}</s></span>\r\n          </h6>\r\n        </div>\r\n        <h6 class=\"m-b-1 gray-bg p-a-1 font-weight-bold\" style=\"margin-bottom: 0px !important\"\r\n          ng-if=\"guestCart.isErplyStore && guestCart.detail.erplyShopCartResponse.subtotalAfterDiscount!=guestCart.detail.erplyShopCartResponse.totalRetailPrice\">\r\n          <span>Subtotal (after discount)</span>\r\n          <span class=\"pull-xs-right\">{{guestCart.detail.erplyShopCartResponse.subtotalAfterDiscount | number :\r\n            2}}</span>\r\n        </h6>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"div_border m-x-0 p-x-0\" style=\"margin-top: 10px; margin-bottom: 10px;\"\r\n        ng-if=\"((!guestCart.isErplyStore && guestCart.getTotalSaving()>0) || (guestCart.isErplyStore && guestCart.detail.erplyShopCartResponse.totalSavings>0))\">\r\n        <div class=\"border_pdding\">\r\n          <h6 class=\"m-y-1\">\r\n            <span style=\"font-weight: 700; font-size: 1.2rem;\">\r\n            <span >You Saved</span>\r\n            <span class=\"pull-xs-right\" ng-if=\"!guestCart.isErplyStore\">${{guestCart.getTotalSaving() | number : 2}}</span>\r\n            <span class=\"pull-xs-right\" ng-if=\"guestCart.isErplyStore\">${{guestCart.detail.erplyShopCartResponse.totalSavings\r\n              | number : 2}}</span>\r\n              </span>\r\n          </h6>\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n\r\n      <div class=\"div_border m-x-0 p-x-0\" style=\"margin-top: 10px; margin-bottom: 10px;\"\r\n        ng-if=\"((!guestCart.isErplyStore && guestCart.getTotalSaving()==0) || (guestCart.isErplyStore && guestCart.detail.erplyShopCartResponse.totalSavings==0))\r\n        && (!guestCart.isDscMember() && !guestCart.isDscAddedinCart())\">\r\n        <div class=\"border_pdding\">\r\n          <h6 class=\"m-y-1\">\r\n            <span ng-if=\"!guestCart.isDscMember() && !guestCart.isDscAddedinCart()\">You could save $\r\n              {{guestCart.getSavedAmount() | number : 2}}</span>\r\n            <!--DSC Label-->\r\n            <span class=\"row m-l-1 pull-xs-right\" style=\"min-height:57px;\" ng-if=\"!guestCart.isDscMember()\">\r\n\r\n              <span ng-if=\"guestCart.canUserJoin() && !guestCart.isDscAddedinCart()\"\r\n                style=\"line-height: 13px; cursor: pointer\" ui-sref=\"savings-club\">\r\n                <a href ng-click=\"guestCart.goToSavingsClub()\">\r\n                  <span class=\"white-med-bold-text  hidden-md-down\" style=\"display:inline-block\">\r\n                    <button class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                      ui-sref=\"savings-club\">Join Now</button>\r\n                  </span>\r\n                </a>\r\n                <span class=\"white-med-bold-text hidden-lg-up \" style=\"display:inline-block;margin-top: 0px;\">\r\n                  <button class=\"join_now_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                    style=\"margin-top: 0px !important; width: 92px;\" ui-sref=\"savings-club\">Join Now</button>\r\n                </span>\r\n              </span>\r\n\r\n              <span ui-sref=\"savings-club\"\r\n                ng-if=\"guestCart.isDscMember() && guestCart.profile.customer.email && !guestCart.isDscAddedinCart()\"\r\n                class=\"cursor-pointer\" style=\"line-height: 13px;\">\r\n                <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                  <button class=\"hidden-md-down renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                    ui-sref=\"savings-club\">Renew</button>\r\n                </span>\r\n              </span>\r\n\r\n              <span\r\n                ng-if=\"guestCart.isDscButExpired() && guestCart.profile.customer.email && !guestCart.isDscAddedinCart()\"\r\n                style=\"line-height: 13px;\">\r\n                <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n                  <button class=\" renew_dsc_button btn btn-primary detail-btn mockup-btn\"\r\n                    ui-sref=\"savings-club\">Renew</button>\r\n                </span>\r\n              </span>\r\n\r\n            </span>\r\n          </h6>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"m-x-0 p-x-0\" style=\"margin-top: 10px; margin-bottom: 10px;\"\r\n          ng-if=\"((!guestCart.isErplyStore && guestCart.getTotalSaving()>0) || (guestCart.isErplyStore && guestCart.detail.erplyShopCartResponse.totalSavings>0))\r\n          && (!guestCart.isDscMember() && !guestCart.isDscAddedinCart())\">\r\n        <div class=\"border_pdding\" style=\"font-weight: 700;font-size : 0.75rem\">\r\n            <span>Want to save more? <a ui-sref=\"savings-club\" style=\"color: blue;\">Click here to join the Daily Savings Club</a></span>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"mt-4 place_order_btn\">\r\n        <button ng-click=\"guestCart.proceedToCheckout()\"\r\n          ng-disabled=\"guestCart.isAnyItemInactive || guestCart.deliveryTypeValidation()\"\r\n          class=\"btn btn-primary btn-block btn-md-text\">Proceed to Checkout</button>\r\n      </div>\r\n\r\n      <div class=\"mt-4 place_order_btn\">\r\n        <a ui-sref=\"category\" class=\"btn btn-primary btn-block btn-md-text\">Continue Shopping </a>\r\n      </div>\r\n\r\n      <div class=\"mt-4 place_order_btn\" ng-show=\"guestCart.isFreeShippingOfferAvailable() && !guestCart.isErplyStore\">\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"guestCart.shippingOffer.isOfferEligible && guestCart.storeDetail.country.countryCode =='US'\"> <img\r\n            ng-src={{guestCart.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Your order\r\n            qualifies for <a class=\"blue-colored\" href ng-click=\"guestCart.showFreeShippingOfferDetail(true)\"><u><b>FREE\r\n                  Shipping*</b></u></a></span></div>\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"guestCart.shippingOffer.isOfferEligible && guestCart.storeDetail.country.countryCode =='CA'\"> <img\r\n            ng-src={{guestCart.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Your order\r\n            qualifies for <a class=\"blue-colored\" href\r\n              ng-click=\"guestCart.showFreeShippingOfferDetailCan(true)\"><u><b>FREE Shipping*</b></u></a></span></div>\r\n\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"!guestCart.shippingOffer.isOfferEligible && guestCart.storeDetail.country.countryCode =='US'\"> <img\r\n            ng-src={{guestCart.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Add <span\r\n              class=\"shipping-offer-remaining-amount\">${{guestCart.getFreeShippingRemainingAmount() | number : 2}}\r\n            </span>to your order to qualify for <a class=\"blue-colored\" href\r\n              ng-click=\"guestCart.showFreeShippingOfferDetail(true)\"><u><b>FREE Shipping*</b></u></a>\r\n          </span></div>\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"!guestCart.shippingOffer.isOfferEligible && guestCart.storeDetail.country.countryCode =='CA'\"> <img\r\n            ng-src={{guestCart.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" /> <span>Add <span\r\n              class=\"shipping-offer-remaining-amount\">${{guestCart.getFreeShippingRemainingAmount() | number : 2}}\r\n            </span>to your order to qualify for <a class=\"blue-colored\" href\r\n              ng-click=\"guestCart.showFreeShippingOfferDetailCan(true)\"><u><b>FREE Shipping*</b></u></a>\r\n          </span></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row p-t-2 m-x-0\"\r\n    ng-if=\"!guestCart.detail || (guestCart.detail.cartItems && !guestCart.detail.cartItems.length)\">\r\n    <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n      <h5 class=\"font-weight-bold\">Cart Empty</h5>\r\n      <p class=\"m-t-1\">Add Items in the cart to purchase.</p>\r\n      <div class=\"m-t-3 p-t-3\">\r\n        <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"category\">Start New Order</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _storeDetail = __webpack_require__(206);
	
	var _storeDetail2 = _interopRequireDefault(_storeDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StoreDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'storeDetail',
	  template: _storeDetail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function StoreDetail($scope, $ngRedux, $spinner, $auth, $stateParams, $window, $state, APP) {
	    _classCallCheck(this, StoreDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	    this.onMarkerClick = this.onMarkerClick.bind(this);
	
	    $spinner.show('appSpinner');
	    if (!$auth.isGuestLogin()) {
	      $auth.getUserProfile().then(function (success) {
	        return $auth.getStoreDetail(success.data.store.storeURLName);
	      }).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    } else {
	      var guestStore = $auth.getGuestStoreDetail();
	      $auth.getStoreDetail(guestStore.storeName).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    }
	
	    $scope.$on('$destroy', disconnect);
	    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	    var d = new Date();
	    this.dayName = days[d.getDay()];
	  }
	
	  _createClass(StoreDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        store: state.auth.storeDetail
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'getStoreTiming',
	    value: function getStoreTiming(date) {
	      var fordate = date || new Date();
	      var mapping = {
	        '0': 'Sunday',
	        '1': 'Monday',
	        '2': 'Tuesday',
	        '3': 'Wednesday',
	        '4': 'Thursday',
	        '5': 'Friday',
	        '6': 'Saturday'
	      };
	      var day = mapping[fordate.getDay()];
	      return this.store.storeTimings && this.store.storeTimings.filter(function (el) {
	        return el.day === day;
	      })[0];
	    }
	  }, {
	    key: 'storeClosingTime',
	    value: function storeClosingTime(forDate) {
	      if (this.store.storeTimings) {
	        var today = forDate || new Date();
	        var close = this.getStoreTiming(forDate).closeTime;
	        var hours = close.split(':')[0];
	        var minutes = close.split(':')[1];
	        today.setHours(hours);
	        today.setMinutes(minutes);
	        return today;
	      }
	    }
	  }, {
	    key: 'storeOpeningTime',
	    value: function storeOpeningTime(forDate) {
	      if (this.store.storeTimings) {
	        var today = forDate || new Date();
	        var close = this.getStoreTiming(forDate).openTime;
	        var hours = close.split(':')[0];
	        var minutes = close.split(':')[1];
	        today.setHours(hours);
	        today.setMinutes(minutes);
	        return today;
	      }
	    }
	  }, {
	    key: 'formattedTime',
	    value: function formattedTime(dateTime) {
	      var date = dateTime ? new Date(dateTime) : new Date();
	      var hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
	      var time = (hours < 10 ? '0' + hours : hours) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	      var ampm = date.getHours() >= 12 ? ' PM' : ' AM';
	      return time + ampm;
	    }
	
	    // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
	
	  }, {
	    key: 'changeStringtoDateObject',
	    value: function changeStringtoDateObject(stringTime) {
	      var timeArray = stringTime.split(':');
	      var hours = timeArray[0];
	      var minutes = timeArray[1];
	      var timeObject = new Date();
	      timeObject.setMinutes(minutes);
	      return timeObject.setHours(hours);
	    }
	  }, {
	    key: 'onMarkerClick',
	    value: function onMarkerClick() {
	      window.open('http://maps.google.com/?daddr=' + (this.store.addressLine1 + ', ' + this.store.city + ', ' + this.store.state.name));
	    }
	  }]);
	
	  return StoreDetail;
	}(), _class2.$inject = ['$scope', '$ngRedux', 'spinnerService', 'authService', '$stateParams', '$window', '$state', 'APP'], _temp)) || _class);
	exports.default = StoreDetail;

/***/ },
/* 206 */
/***/ function(module, exports) {

	module.exports = "\r\n<!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n<!--breadcrum section -->\r\n<nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n  <a class=\"nav\" ng-click=\"storeDetail.goToHomePage()\"  >\r\n    <img class=\"breadcrumb-logo-icon\" src={{storeDetail.houseIcon}} alt=\"logo\" />\r\n    <span>Home</span>\r\n  </a>\r\n  <span>Store Details</span>\r\n</nav>\r\n\r\n<div class=\"p-x-3-md\">\r\n  <div class=\"row m-x-0 p-t-2\">\r\n    <div class=\"col-sm-12 col-xs-10\">\r\n      <h5 class=\"font-weight-bold m-b-1\"\r\n        ng-bind=\"storeDetail.store.storeName\"></h5>\r\n    </div>\r\n  </div>\r\n  <div class=\"row m-x-0 p-b-1 p-t-1\" ng-if=\"storeDetail.store.addressLine1\" >\r\n     <div class=\"col-sm-12 col-md-12 col-lg-5\" >\r\n     <!-- <div map-lazy-load=\"https://maps.google.com/maps/api/js?key=AIzaSyDhfDv6nd9Y7pV59mHAORfo__rYqN9ZU7g\"\r\n        ng-if=\"storeDetail.store\">\r\n        <ng-map zoom=\"16\" class=\"store-map\">\r\n          <marker on-click=\"storeDetail.onMarkerClick()\" position=\"{{storeDetail.store.addressLine1}}, {{storeDetail.store.city}}, {{storeDetail.store.state.name}}\" centered=\"true\"></marker>\r\n        </ng-map>\r\n      </div> -->\r\n     <!--  <iframe src=\"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12241.718373522806!2d-86.0984235!3d39.9094015!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xae354fb8fe5f1da7!2sWild+Birds+Unlimited!5e0!3m2!1sen!2sus!4v1513349556359\" width=\"400\" height=\"300\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe> -->\r\n     <iframe src=\"{{storeDetail.store.mapURL | trustAsResourceUrl}}\" width=\"100%\" height=\"300\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe>\r\n   </div>\r\n\r\n\r\n    <div class=\"col-sm-12 col-md-12 col-lg-7 m-t-sm-2\">\r\n      <h5 class=\"font-weight-bold mb-4\">Store Address</h5>\r\n      <h5 class=\"m-b-1\">\r\n        <span ng-if=\"storeDetail.store.addressLine1\">{{storeDetail.store.addressLine1}}, {{storeDetail.store.addressLine2}}</span><br />\r\n        <span ng-if=\"storeDetail.store.country\">{{storeDetail.store.city}} {{storeDetail.store.state.name}}, {{storeDetail.store.country.countryCode}} {{storeDetail.store.zipCode}}</span>\r\n      </h5>\r\n      <h5 class=\"m-b-1\"\r\n        ng-if=\"storeDetail.store.storeAdminEmail\">\r\n        <strong>Email: </strong>\r\n        <a class=\"blue-colored\" href=\"mailto:{{storeDetail.store.storeAdminEmail}}\">{{storeDetail.store.storeAdminEmail}}</a>\r\n      </h5>\r\n      <h5 class=\"m-b-1\"\r\n        ng-if=\"storeDetail.store.phoneNumber\">\r\n        <strong>Phone: </strong>\r\n        <a class=\"blue-colored\" href=\"tel:{{storeDetail.store.phoneNumber}}\">{{storeDetail.store.phoneNumber | telFormat}}</a>\r\n      </h5>\r\n      <!-- <h5 class=\"m-b-1\"\r\n        ng-if=\"storeDetail.getStoreTiming().openTime\">\r\n        <strong>Store Hours: </strong>{{storeDetail.formattedTime(storeDetail.storeOpeningTime())}} to {{storeDetail.formattedTime(storeDetail.storeClosingTime())}}\r\n      </h5> -->\r\n      <h5 class=\"m-b-1\"\r\n        ng-if=\"storeDetail.getStoreTiming().openTime\">\r\n        <strong>Store Hours: </strong>\r\n      </h5>\r\n      <h5 class=\"m-b-1\"\r\n        ng-repeat=\"item in storeDetail.store.storeTimings\">\r\n          {{item.day}}: {{((item.isHoliday)) ? ' Closed' : storeDetail.formattedTime(storeDetail.changeStringtoDateObject(item.openTime)) +' to '+ storeDetail.formattedTime(storeDetail.changeStringtoDateObject(item.closeTime)) }}\r\n      </h5>\r\n\r\n             \r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* File: delivery.js
	                                   * -----------------
	                                   * File calculates the distances from Google APIs and accordingly gives the
	                                   * user option for selecting delivery option and also calcualtes the prices
	                                   * and various times for the delivery.
	                                   */
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _delivery = __webpack_require__(208);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	var _shippingInfo = __webpack_require__(201);
	
	var _shippingInfo2 = _interopRequireDefault(_shippingInfo);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Delivery = (_dec = (0, _utils.Component)({
	  controllerAs: 'delivery',
	  template: _delivery2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Delivery($scope, $rootScope, $ngRedux, $state, $uibModal, toaster, $spinner, $auth, $order, $q, $window, $cookies, $stateParams, APP, $sce) {
	    _classCallCheck(this, Delivery);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$rootScope = $rootScope;
	    this.$sce = $sce;
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.toaster = toaster;
	    this.$order = $order;
	    this.$auth = $auth;
	    this.giftCards = [];
	    this.$spinner = $spinner;
	    this.$q = $q;
	    this.$stateParams = $stateParams;
	    this.$cookies = $cookies;
	    this.logoIcon = _smallLogo2.default;
	    this.shippingOffer = {};
	    this.shippingOffer.isOfferAvailable = false;
	    this.shippingOffer.isOfferEligible = false;
	    this.houseIcon = _houseIcon2.default;
	    this.isMiscelleneousCategory = 4;
	    this.giftCardMasterCodeStartsWith = '9';
	    this.dscMasterCode = '88888888'; // Named constant
	    this.noTimeForOrderReadyBy = false;
	    // this.mode = 'In Store Pickup';
	    this.mode = '';
	    this.APP = APP;
	    this.$window = $window;
	    this.noItemsInCart = false;
	    this.addressDetail = {};
	    this.estimatedDeliveryDateTime = null;
	    this.couponAmount = 0;
	    this.couponNumber = null;
	    this.example1model = [];
	    this.multiselect_checkbox = { checkBoxes: true, idProperty: 'id' };
	    this.isAddressValidated = false;
	    this.showPopup = false;
	    this.showPopupFee = false;
	    this.erplyDis = [];
	    this.toDecimalPlaces = 2;
	    // this.example1data = [ {id: 1, label: "David"}, {id: 2, label: "Jhon"}, {id: 3, label: "Danny"} ];
	    // this.example3data = [{"id":0,"label":"1500100001022341","bbCouponAmount":null},{"id":1,"label":"1500100001036501","bbCouponAmount":null},{"id":2,"label":"1500100001046720","bbCouponAmount":null}];
	    this.init();
	    this.rateZoneRetryCount = 0;
	    this.shippingOffer.thresholdAmount = 1500;
	    this.shippingOfferInfoIcon = _shippingInfo2.default;
	    this.shippingOfferAvailableIcon = _shippingTick2.default;
	    this.taxableDiscountAmount = 0;
	    this.calledTaxCount = 0;
	    this.nextDayDelivery = 'Next Day Delivery';
	    this.inStoreDelivery = 'In Store Pickup';
	    this.instorePickupOnly = 'InStore';
	    this.dropShipOnly = 'DropShip';
	    this.isCurbside = false;
	    this.isGiftOrder = false;
	    this.hasCartError = false;
	    this.fedexErrorMsg = "There seems to be a problem with your address. <br /> Please check your entry. Contact the store for assistance at <a class='blue-colored' href='tel:{{delivery.profile.store.phoneNumber}}'>{{delivery.profile.store.phoneNumber | telFormat}}</a>.";
	    this.showDefaultFedexErrorMessage = true;
	    this.promoLengthToBeShown = 25;
	    this.ordernotesPattern = "^[ a-zA-Z0-9~%!@#$^&*()_+={}|\\\\,.?:\"'\/:;<`>-]*$";
	    // this.ordernotesPattern = `/^([\\\[\\\]a-zA-Z0-91234567890-=={};:<>,./?' |\\\s\\\\-])+$/`;
	    $window.scrollTo(0, 0);
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Delivery, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        store: state.auth.storeDetail,
	        cartDetail: state.order.cartDetail,
	        shippingCharges: state.order.shippingCharges,
	        cardInfo: state.order.paymentInfo,
	        zoneDeliveryCharges: state.order.zoneDeliveryCharges,
	        coupon: state.order.coupon,
	        taxes: state.order.taxes,
	        userShippingZone: state.order.userShippingZone,
	        discountCoupon: state.order.discountCoupon,
	        birdBucksList: state.order.birdBucksList,
	        storeDiscountMap: state.order.storeDiscountMap,
	        orderPoints: state.order.orderPoints,
	        erplyShop: state.order.cartDetail.erplyShopCartResponse,
	        erplyBirdBucksList: state.order.erplyBirdBucksList,
	        shippingCountries: state.auth.countries,
	        billingCountries: state.auth.countries
	      };
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      var ctrl = this;
	      var $spinner = this.$spinner,
	          $order = this.$order,
	          $q = this.$q;
	
	      this.promise1 = $q.defer();
	      this.cError = false;
	      this.promise2 = $q.defer();
	      this.couponAmount = 0;
	      this.taxableDiscountAmount = 0;
	      this.discountCouponAmount = 0;
	      this.discountCode = null;
	      this.appliedDiscountCoupon = sessionStorage.getItem('discountCoupon');
	      this.appliedBirdBuckCoupon = sessionStorage.getItem('birdbuckCoupon');
	      this.appliedErplyBBDiscount = sessionStorage.getItem('erplyBBDiscount');
	      this.appliedErplyPromotionDiscount = sessionStorage.getItem('erplyPromotionDiscount');
	      this.orderNotes = sessionStorage.getItem('orderNotesSession');
	
	      if (!this.orderNotes || this.orderNotes == "undefined") {
	        this.orderNotes = "";
	      }
	
	      if (this.taxes) {
	        this.taxes.deliveryReceiptFee = 0;
	      }
	      if (this.erplyShop) {
	        this.erplyShop.deliveryReceiptFee = 0;
	      }
	      console.log("appliedDiscountCoupon---", this.appliedDiscountCoupon);
	      console.log("appliedBirdBuckCoupon---", this.appliedBirdBuckCoupon);
	      // this.calculateClubPoints();
	
	      //
	
	      if (!this.appliedDiscountCoupon && !this.appliedBirdBuckCoupon) {
	        this.callTaxCount = 0;
	      } else if (this.appliedDiscountCoupon && this.appliedBirdBuckCoupon) {
	        this.callTaxCount = 2;
	      } else {
	        this.callTaxCount = 1;
	      }
	      //
	
	      var promise3 = $order.getCartDetail(false).then(function (success) {
	
	        if (success.data.cartItems && success.data.cartItems.length > 0) {
	          if (success.data.cartItems.length > _this.APP.ORDER.LIMITATIONS.noOfItemsAllowed) {
	            _this.showExcessItemsPopUp();
	          }
	        }
	
	        _this.getUserProfile();
	      }).catch(function (err) {
	        _this.noItemsInCart = true;
	        _this.promise1.reject();
	        _this.promise2.reject();
	        _this.$auth.printCustomerGenericLogs(err);
	      });
	      var promise4 = $order.getShippingCharges();
	      var promise5 = $order.getPaymentInfo();
	      var promise6 = $order.getZoneWiseDeliveryCharges();
	      var promise7 = $order.getStoreDiscountMapping();
	
	      $spinner.show('appSpinner');
	      var promises = [this.promise1.promise, this.promise2.promise, promise3, promise4, promise5, promise6, promise7];
	      $q.all(promises).then(function () {
	        if (_this.profile) {
	          console.log("Checking profile has firstname : ", _this.profile);
	          if (!_this.profile.store.hasErply) {
	            $order.getBirdBucksByUser(_this.profile.userId);
	          } else {
	            if (_this.cartContainsDsc()) {
	              _this.$order.dscPremembership();
	            }
	            $order.getErplyBirdBucksByUser().then(function () {
	              _this.setSelectedBBCoupons();
	            }).catch(function (err) {
	              _this.removeErplyBBDiscountCookie();
	              console.log("Something went wrong in selecting Erply BB coupon");
	              _this.$auth.printCustomerGenericLogs(err);
	            });
	            _this.setErplyPromotionCodes();
	          }
	        }
	
	        // For non erply store we save discount coupon code in appliedDiscountCoupon
	        // For Erply store we save code in appliedErplyPromotionDiscount
	        if (_this.appliedDiscountCoupon) {
	          _this.mobileDiscountCoupon = _this.appliedDiscountCoupon;
	          _this.discountCouponCode = _this.appliedDiscountCoupon;
	          _this.checkDiscountCoupon({ $error: {}, $$success: {}, $pending: undefined, $name: "discountCouponForm", $dirty: false }, _this.appliedDiscountCoupon, false);
	        } else {
	          _this.discountCoupon = null;
	          // this.getTax();
	        }
	
	        // For non erply store we save discount coupon code in appliedBirdBuckCoupon
	        // For Erply store we save code in appliedErplyBBDiscount
	        if (_this.appliedBirdBuckCoupon) {
	          _this.mobileCouponNumber = _this.appliedBirdBuckCoupon;
	          _this.desktopCouponNumber = _this.appliedBirdBuckCoupon;
	          _this.checkBirdbuck({ $error: {}, $$success: {}, $pending: undefined, $name: "couponForm", $dirty: false }, _this.appliedBirdBuckCoupon, false);
	        } else {
	          _this.couponAmount = 0;
	          // this.getTax();
	        }
	        if (!_this.appliedBirdBuckCoupon && !_this.appliedDiscountCoupon) {
	          _this.callingTax(0);
	        }
	      }).catch(function (err) {
	        _this.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        _this.calculateClubPoints();
	        $spinner.hide('appSpinner');
	      });
	    }
	
	    // isApply is for either discount or BB coupon applied directly then call tax
	    // isApply false is when page loads calls tax based on either BB or discount 
	
	  }, {
	    key: 'callingTax',
	    value: function callingTax(count, isApply) {
	      if (!isApply) {
	        this.calledTaxCount = this.calledTaxCount + count;
	        if (this.callTaxCount == this.calledTaxCount) {
	          this.getTax();
	        }
	      } else {
	        this.getTax();
	      }
	    }
	  }, {
	    key: 'getUserProfile',
	    value: function getUserProfile() {
	      var _this2 = this;
	
	      this.$auth.getUserProfile().then(function (success) {
	        _this2.$auth.getCountries().then(function (success) {
	          _this2.getStates(_this2.profile.shippingCountry.countryCode, "shippingAddress", 0);
	        }).catch(function (err) {
	          _this2.$auth.printCustomerGenericLogs(err);
	        });
	
	        if (_this2.$rootScope.tempdeliveryMode) {
	
	          if (_this2.$rootScope.tempdeliveryMode === _this2.nextDayDelivery && _this2.cartContainsOnlyDsc()) {
	            _this2.mode = _this2.inStoreDelivery;
	            _this2.resetDeliveryMode(_this2.mode);
	          } else {
	            _this2.mode = _this2.$rootScope.tempdeliveryMode;
	          }
	          if (_this2.$rootScope.isCurbside) {
	            _this2.isCurbside = _this2.$rootScope.isCurbside;
	            _this2.curbSideDetails = _this2.$rootScope.curbSideDetails;
	          }
	        } else {
	          _this2.mode = "";
	        }
	
	        // In store pickup only changes - when items contain deliverytype instore then hide shipping option
	        if (_this2.cartDetail && _this2.cartDetail.cartItems && _this2.cartDetail.cartItems.length > 0) {
	          var filteredInstoreItem = _this2.cartDetail.cartItems.filter(function (item) {
	            return item.item.deliveryType === _this2.instorePickupOnly;
	          });
	          if (filteredInstoreItem && filteredInstoreItem.length > 0) {
	            _this2.filteredInstoreItem = true;
	            _this2.mode = _this2.inStoreDelivery;
	            _this2.resetDeliveryMode(_this2.mode);
	          } else {
	            _this2.filteredInstoreItem = false;
	          }
	          var filteredDropShipItem = _this2.cartDetail.cartItems.filter(function (item) {
	            return item.item.deliveryType === _this2.dropShipOnly;
	          });
	          if (filteredDropShipItem && filteredDropShipItem.length > 0) {
	            _this2.filteredDropShipItem = true;
	            _this2.mode = _this2.nextDayDelivery;
	            _this2.resetDeliveryMode(_this2.mode);
	          } else {
	            _this2.filteredDropShipItem = false;
	          }
	        }
	
	        var addressObj = localStorage.getItem('deliveryAddress');
	        _this2.addressDetail = addressObj ? JSON.parse(addressObj) : success.data;
	        if (!_this2.addressDetail.firstName) {
	          _this2.addressDetail.firstName = _this2.addressDetail.customer.firstName;
	          _this2.addressDetail.lastName = _this2.addressDetail.customer.lastName;
	        }
	        // console.log('addressDetail--');
	        // console.log(this.addressDetail);
	        _this2.$auth.getStoreDetail(success.data.store.storeURLName).then(function (success) {
	          return _this2.holidays = success.data.storeTimings.filter(function (e) {
	            return e.isHoliday;
	          });
	        }).catch(function (err) {
	          _this2.$auth.printCustomerGenericLogs(err);
	        });
	        // console.log('this.profile.billingAddressLine1---', this.profile.billingAddressLine1);
	        // console.log('this.addressDetail.shippingAddressLine1---', this.addressDetail.shippingAddressLine1);
	        _this2.calculateDeliveryOption();
	        _this2.promise2.resolve();
	      }, function () {
	        _this2.toaster.pop('success', 'We do not deliver at this address');
	        _this2.promise2.reject();
	        _this2.promise1.reject();
	      }).catch(function (err) {
	        _this2.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'calculateDeliveryOption',
	    value: function calculateDeliveryOption() {
	      var _this3 = this;
	
	      //  console.log(profile);
	      var addressInfo = {
	        'addressLine1': this.addressDetail.shippingAddressLine1,
	        'city': this.addressDetail.shippingCity,
	        'state': {
	          'code': this.addressDetail.shippingState ? this.addressDetail.shippingState.code : ''
	        },
	        'zip': this.addressDetail.shippingZipCode,
	        'country': this.addressDetail.shippingCountry
	      };
	      var ctrl = this;
	      ctrl.rateZoneRetryCount++;
	      this.notDeliverable = true;
	      this.$order.getUserZone(addressInfo).then(function () {
	
	        _this3.promise1.resolve();
	        _this3.mode = (!_this3.mode || _this3.mode === 'Home Delivery') && !_this3.cartContainsOnlyDsc() ? _this3.nextDayDelivery : _this3.inStoreDelivery;
	        _this3.notDeliverable = false;
	        if (_this3.$rootScope.deliveryMode && !_this3.cartContainsOnlyDsc()) _this3.mode = _this3.$rootScope.deliveryMode;
	        if (_this3.$rootScope.tempdeliveryMode) {
	          _this3.mode = _this3.$rootScope.tempdeliveryMode;
	        } else {
	          _this3.mode = "";
	        }
	        // this.getTax();
	      }, function (error) {
	
	        if (error.data.errorCode === 200) {
	          if (ctrl.rateZoneRetryCount <= 3) {
	            ctrl.calculateDeliveryOption();
	          } else {
	            ctrl.promise1.resolve();
	            ctrl.notDeliverable = true;
	          }
	        } else if (error.data.errorCode === 676) {
	          // Error Code 676 is Fedex Exception from WBU
	          ctrl.promise1.resolve();
	          ctrl.notDeliverable = true;
	          if (error.data.message.includes("FedexError")) {
	            ctrl.fedexErrorMsg = error.data.message.split("|")[1];
	            ctrl.showDefaultFedexErrorMessage = false;
	          } else {
	            ctrl.showDefaultFedexErrorMessage = true;
	          }
	        } else {
	          ctrl.promise1.resolve();
	          ctrl.notDeliverable = true;
	        }
	      }).catch(function (err) {
	        _this3.$auth.printCustomerGenericLogs(err);
	      });
	
	      /* const distanceService = new window.google.maps.DistanceMatrixService();
	      const originAddr = profile.store.state
	        ? `${profile.store.addressLine1}, ${profile.store.city}, ${profile.store.state.name}`
	        : `${profile.store.addressLine1}, ${profile.store.city}`;
	      const destAddr = addressDetail.shippingState
	        ? `${addressDetail.shippingAddressLine1}, ${addressDetail.shippingCity}, ${addressDetail.shippingState.name}`
	        : `${addressDetail.shippingAddressLine1}, ${addressDetail.shippingCity}`;
	      distanceService.getDistanceMatrix(
	        {
	          origins: [originAddr],
	          destinations: [destAddr],
	          travelMode: window.google.maps.TravelMode.DRIVING,
	          unitSystem: window.google.maps.UnitSystem.IMPERIAL
	        },
	        (response, status) => {
	          if (status === window.google.maps.DirectionsStatus.OK) {
	            let distance = response.rows[0].elements[0].distance && response.rows[0].elements[0].distance.value / 1600;
	            this.charge = this.shippingCharges.filter(el => {
	              var min = el.distanceRange.split('-')[0];
	              var max = el.distanceRange.split('-')[1];
	              return min < distance && max > distance;
	            });
	            if (!this.charge.length || !distance) {
	              this.notDeliverable = true;
	            }
	            this.mode = (!this.mode || this.mode === 'Home Delivery') && this.charge.length && !this.cartContainsOnlyDsc() ?
	            'Next Day Delivery' : 'In Store Pickup';
	            if (this.$rootScope.deliveryMode && !this.cartContainsOnlyDsc()) this.mode = this.$rootScope.deliveryMode;
	          }
	          else {
	            this.notDeliverable = true;
	            // this.toaster.pop('success', 'We do not deliver at this address');
	          }
	          this.promise1.resolve();
	        }
	      );*/
	    }
	  }, {
	    key: 'getTotalWeight',
	    value: function getTotalWeight() {
	      return this.cartDetail.cartItems && this.cartDetail.cartItems.map(function (item) {
	        return item.item.weight * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	    }
	  }, {
	    key: 'getSameDayCharge',
	    value: function getSameDayCharge() {
	      if (this.charge && this.calculateSameDay()) {
	        return this.getTotalWeight() > 70 ? this.charge[0].sameDayChargeover70lbs : this.charge[0].sameDayCharge;
	      }
	      return null;
	    }
	  }, {
	    key: 'getNextDayCharge',
	    value: function getNextDayCharge() {
	      if (this.userShippingZone) {
	        return this.userShippingZone.nextDayCharge;
	      }
	      return null;
	    }
	  }, {
	    key: 'getShippingDiscountCharge',
	    value: function getShippingDiscountCharge() {
	      if (this.cartContainsOnlyGift()) {
	        return 0.00;
	      } else if (this.cartContainsOnlyGiftAndDSC()) {
	        return 0.00;
	      }
	      if (this.cartDetail) {
	        if (this.cartDetail.freeshipping.zone && this.isShippingDiscountEligible() && this.mode !== this.inStoreDelivery) {
	          return this.cartDetail.freeshipping.zone.nextDayCharge;
	        }
	      }
	      return 0;
	    }
	  }, {
	    key: 'getSelectedShipmentCharge',
	    value: function getSelectedShipmentCharge() {
	      if (this.cartContainsOnlyGift()) {
	        return 0.00;
	      } else if (this.cartContainsOnlyGiftAndDSC()) {
	        return 0.00;
	      }
	
	      if (this.userShippingZone && this.mode !== this.inStoreDelivery) {
	        return this.userShippingZone.nextDayCharge;
	      }
	      /*  if (this.mode === 'Same Day Delivery' && this.charge) {
	        return this.getTotalWeight() > 70 ? this.charge[0].sameDayChargeover70lbs : this.charge[0].sameDayCharge;
	      }
	      else if (this.mode === 'Next Day Delivery' && this.charge) {
	        return this.getTotalWeight() > 70 ? this.charge[0].nextDayChargeover70lbs : this.charge[0].nextDayCharge;
	      }*/
	      return 0;
	    }
	
	    // Retail price is the undiscounted price of items * quantity.
	
	  }, {
	    key: 'retailPrice',
	    value: function retailPrice() {
	      return this.cartDetail.cartItems && this.cartDetail.cartItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	    }
	
	    // DSC discount of 15% price on retail price
	    // dscDiscount() {
	    //   if (this.isDscMember() || this.cartContainsDsc()) {
	    //     let dscItems = this.cartDetail.cartItems &&
	    //     this.cartDetail.cartItems.filter(item => item.item.subCategory.category.dscCategory);
	    //     let totalPrice = dscItems && dscItems.map(item => item.item.price * item.quantity)
	    //       .reduce((prev, curr) => prev + curr, 0);
	    //     return totalPrice * 15 / 100;
	    //   }
	    //   return 0;
	    // }
	
	    // Subtotal is retail price minus 15% dsc discount price.
	    // subtotal() {
	    //   return this.retailPrice() - this.dscDiscount();
	    // }
	
	  }, {
	    key: 'subtotal',
	    value: function subtotal() {
	      var totalPrice = 0;
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	
	        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          var maxPrice = 0;
	          var maxPriceId = 0;
	          var isDscMember = this.isDscMember() || this.cartContainsDsc();
	          angular.forEach(this.cartDetail.cartItems, function (item, key) {
	            // console.log(key);
	            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	              maxPriceId = item.item.id;
	              maxPrice = item.item.price;
	            }
	          });
	          angular.forEach(this.cartDetail.cartItems, function (item, key) {
	            // console.log(key);
	            if (maxPriceId === item.item.id) {
	              if (item.subCategory.category.dscCategory && isDscMember) {
	                totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	              } else {
	                totalPrice = totalPrice + item.item.price * (item.quantity - 1);
	              }
	              totalPrice = totalPrice + item.item.price;
	            } else {
	              if (item.subCategory.category.dscCategory && isDscMember) {
	                totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	              } else {
	                totalPrice = totalPrice + item.item.price * item.quantity;
	              }
	            }
	          });
	        }
	      } else {
	        if (this.isDscMember() || this.cartContainsDsc()) {
	          var dscItems = this.cartDetail.cartItems && this.cartDetail.cartItems.filter(function (item) {
	            return item.subCategory.category.dscCategory;
	          });
	          var dscTotal = dscItems.map(function (item) {
	            return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	          }).reduce(function (prev, curr) {
	            return prev + curr;
	          }, 0);
	          var nondscItems = this.cartDetail.cartItems && this.cartDetail.cartItems.filter(function (item) {
	            return !item.subCategory.category.dscCategory;
	          });
	          var nonDscTotal = nondscItems.map(function (item) {
	            return item.item.price * item.quantity;
	          }).reduce(function (prev, curr) {
	            return prev + curr;
	          }, 0);
	          totalPrice = dscTotal + nonDscTotal;
	        } else {
	          totalPrice = this.retailPrice();
	        }
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'taxableAmount',
	    value: function taxableAmount() {
	      var totalTaxablePrice = 0;
	      var taxable = false;
	      var ctrl = this;
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        // console.log("Inside1--");
	        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          var maxPrice = 0;
	          var maxPriceId = 0;
	
	          var isDscMember = this.isDscMember() || this.cartContainsDsc();
	          angular.forEach(ctrl.cartItemTaxDetails, function (item, key) {
	            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	              maxPriceId = item.item.id;
	              maxPrice = item.item.price;
	            }
	          });
	          angular.forEach(ctrl.cartItemTaxDetails, function (item, key) {
	            taxable = ctrl.getCheckForShippingTaxable(item);
	            if (maxPriceId === item.item.id) {
	              if (item.subCategory.category.dscCategory && isDscMember && taxable) {
	                totalTaxablePrice = totalTaxablePrice + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	              } else if (taxable) {
	                totalTaxablePrice = totalTaxablePrice + item.item.price * (item.quantity - 1);
	              }
	              if (taxable) {
	                totalTaxablePrice = totalTaxablePrice + item.item.price;
	              }
	            } else {
	              if (item.subCategory.category.dscCategory && isDscMember && taxable) {
	                totalTaxablePrice = totalTaxablePrice + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	              } else if (taxable) {
	                totalTaxablePrice = totalTaxablePrice + item.item.price * item.quantity;
	              }
	            }
	          });
	        }
	      } else {
	        if (this.isDscMember() || this.cartContainsDsc()) {
	          var dscItems = this.cartItemTaxDetails && this.cartItemTaxDetails.filter(function (item) {
	            return item.subCategory.category.dscCategory;
	          });
	          var nondscItems = this.cartItemTaxDetails && this.cartItemTaxDetails.filter(function (item) {
	            return !item.subCategory.category.dscCategory;
	          });
	          var taxableDscItems = dscItems.filter(function (item) {
	            return item.item.taxable;
	          });
	          var taxableNonDscItems = nondscItems.filter(function (item) {
	            return item.item.taxable;
	          });
	          var taxableDscAmount = 0.00;
	          var taxableNonDscAmount = 0.00;
	          angular.forEach(this.cartItemTaxDetails, function (item, key) {
	            taxable = ctrl.getCheckForShippingTaxable(item);
	            if (taxable) {
	              if (item.subCategory.category.dscCategory) {
	                totalTaxablePrice = totalTaxablePrice + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	              } else {
	                totalTaxablePrice = totalTaxablePrice + item.item.price * item.quantity;
	              }
	            }
	          });
	        } else {
	          var taxablePrice = 0.00;
	          // let taxableItems = this.cartItemTaxDetails && this.cartItemTaxDetails.filter(item => (item.item.taxable));
	          angular.forEach(this.cartItemTaxDetails, function (item, key) {
	            taxable = ctrl.getCheckForShippingTaxable(item);
	            if (taxable) {
	              taxablePrice = taxablePrice + item.item.price * item.quantity;
	            }
	          });
	          totalTaxablePrice = taxablePrice;
	        }
	      }
	      return totalTaxablePrice;
	    }
	  }, {
	    key: 'getTax',
	    value: function getTax() {
	      var _this4 = this;
	
	      // console.log("Tax Here",this.mode);
	
	      console.log("Tax Here", this.mode);
	      if (this.mode == '') {
	        // this.$spinner.hide('appSpinner');
	        return 0;
	      }
	      if (this.mode === this.nextDayDelivery && this.profile.store.validateAddressType !== 'NOT_VALIDATE' && this.profile.store.validateAddressType != this.profile.validatedAddressType && !this.isAddressValidated) {
	        var userDetail = this.profile;
	        console.log("this.profile : userDetail : ", this.profile);
	        userDetail.shippingAddressLine1 = this.addressDetail.shippingAddressLine1;
	        userDetail.shippingAddressLine2 = this.addressDetail.shippingAddressLine2;
	        userDetail.shippingCity = this.addressDetail.shippingCity;
	        userDetail.shippingZipCode = this.addressDetail.shippingZipCode;
	
	        // this.avalaraResolveAddress(userDetail,this.profile.store, 1);
	        this.$auth.avalaraResolveAddress(userDetail, this.profile.store).then(function (resolveAddress) {
	          console.log("ResolveAddress : ", resolveAddress);
	          _this4.$auth.openPopUpForAddressResolve(userDetail, resolveAddress, function (addResolved) {
	            _this4.isAddressValidated = true;
	            console.log("Call back function", addResolved);
	            if (addResolved.isCanceled) {
	              console.log("Canceled");
	              _this4.changeAddress();
	            } else {
	              _this4.setTempDeliveryAddress(addResolved);
	              _this4.calculateTaxes();
	            }
	          });
	        }).catch(function (err) {
	          _this4.isAddressValidated = true;
	          console.log("Error in edit : ", err);
	          _this4.calculateTaxes();
	          _this4.$auth.printCustomerGenericLogs(err);
	        });
	      } else {
	        // this.avalaraResolveAddress(this.profile,this.profile.store, 1);
	        this.calculateTaxes();
	      }
	    }
	  }, {
	    key: 'calculateTaxUponBBandDiscount',
	    value: function calculateTaxUponBBandDiscount(taxableDiscountAmount, discountAmount) {
	      var _this5 = this;
	
	      var bbdiscount = 0.00;
	
	      if (this.cartContainsDsc() || this.cartContainsGiftCard()) {
	        bbdiscount = Math.round((this.taxableAmount() - taxableDiscountAmount) / (this.subtotal() - this.detuctTotalDscMemberAndGiftAmount() - discountAmount) * this.couponAmount * 100) / 100;
	      } else {
	        bbdiscount = Math.round((this.taxableAmount() - taxableDiscountAmount) / (this.subtotal() - discountAmount) * this.couponAmount * 100) / 100;
	      }
	      if (isNaN(bbdiscount)) {
	        bbdiscount = 0.00;
	      }
	      var data = {
	        'shipTo': {
	          'name': this.addressDetail.customer.firstName + this.addressDetail.customer.lastName,
	          'addressLine1': this.addressDetail.shippingAddressLine1,
	          'addressLine2': this.addressDetail.shippingAddressLine2,
	          'city': this.addressDetail.shippingCity,
	          'state': this.addressDetail.shippingState,
	          'country': this.addressDetail.shippingCountry,
	          'zip': this.addressDetail.shippingZipCode,
	          'addressType': 'Shipping',
	          'deliveryType': this.mode,
	          'expectedDeliveryTime': '',
	          'estimatedDeliveryDateTime': '',
	          'phoneNumber': this.addressDetail.phoneNumber
	        },
	        'totalAmount': this.subtotal() - this.couponAmount - this.discountCouponAmount,
	        'taxableAmount': this.taxableAmount() - taxableDiscountAmount,
	        // 'shippingCharge': this.getSelectedShipmentCharge() - this.getShippingDiscountCharge(),
	        'shippingCharge': this.getSelectedShipmentCharge(),
	        'shippingDiscount': this.getShippingDiscountCharge(),
	        'discount': bbdiscount,
	        'appliedBBCoupon': this.appliedBirdBuckCoupon,
	        'discountCode': this.discountCode
	      };
	      this.isCallingAPI = true;
	      this.$order.calculateTaxes(data).then(function (success) {
	        // console.log("success",success);
	        // if (this.taxes.tax && this.taxes.tax.amountToCollect >= 0) {
	        //   this.isCallingAPI = false;
	        // }
	        console.log("this.taxes :  : ", _this5.taxes);
	        if (_this5.taxes != null && _this5.taxes.amountToCollect >= 0) {
	          _this5.isCallingAPI = false;
	        }
	      }, function (error) {
	        // console.log("Error on tax calc",error);
	        _this5.toaster.pop('success', 'Error in tax calculation');
	        _this5.$auth.printCustomerGenericLogs(error);
	      }).catch(function (err) {
	        _this5.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'getTotalTax',
	    value: function getTotalTax() {
	      if (this.taxes.amountToCollect && this.mode != '') {
	        // return this.taxes.tax.amountToCollect;
	        return this.taxes.amountToCollect;
	      }
	      return 0;
	    }
	  }, {
	    key: 'getDeliveryReceiptFee',
	    value: function getDeliveryReceiptFee() {
	      if (this.taxes.deliveryReceiptFee && this.mode != '') {
	        // return this.taxes.tax.amountToCollect;
	        return this.getTotalTax() - this.taxes.deliveryReceiptFee;
	      }
	      return 0;
	    }
	  }, {
	    key: 'getDSCPoints',
	    value: function getDSCPoints() {
	      return this.subtotal() - this.couponAmount;
	    }
	
	    // totalPrice excludes shipping charge. getTotalAmount() includes shipping charge as well.
	
	  }, {
	    key: 'totalPrice',
	    value: function totalPrice() {
	
	      if (this.couponAmount == null) {
	
	        this.couponAmount = 0;
	      }
	
	      if (this.discountCouponAmount == null) {
	
	        this.discountCouponAmount = 0;
	      }
	      return this.subtotal() + this.getTotalTax() - this.couponAmount - this.discountCouponAmount;
	    }
	  }, {
	    key: 'shippingGrossPrice',
	    value: function shippingGrossPrice() {
	      var totalGiftCardAmountPurchasing = 0.00;
	      var $ctrl = this;
	      angular.forEach(this.cartDetail.cartItems, function (item, key) {
	        // console.log("this.isMiscelleneousCategory", $ctrl.isMiscelleneousCategory);
	        if (item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory && item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith) {
	          totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + item.item.price * item.quantity;
	        }
	      });
	
	      if (this.profile.store.hasErply) {
	        return this.getSubtotal() - totalGiftCardAmountPurchasing;
	      } else {
	        return this.getSubtotal() - totalGiftCardAmountPurchasing - this.couponAmount - this.discountCouponAmount;
	      }
	    }
	
	    // total amount is totalPrice + shipping price.
	
	  }, {
	    key: 'isShippingDiscountEligible',
	    value: function isShippingDiscountEligible() {
	      var grossPrice = this.shippingGrossPrice();
	      var res = false;
	      var result = false;
	      if (!this.notDeliverable) {
	        res = this.cartDetail.user.store.isFreeShipping && grossPrice >= this.cartDetail.freeshipping.thresholdValue;
	        var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
	        var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
	        var currentDate = new Date();
	        if (res) {
	          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	            result = true;
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'getTotalAmount',
	    value: function getTotalAmount() {
	
	      if (this.mode === this.inStoreDelivery || this.mode === '') {
	        return this.totalPrice();
	      }
	      if (this.notDeliverable) {
	        return this.totalPrice();
	      }
	      if (this.isShippingDiscountEligible()) {
	        return +(this.getSelectedShipmentCharge() + this.totalPrice() - this.getShippingDiscountCharge()).toFixed(2);
	      } else {
	        return +(this.getSelectedShipmentCharge() + this.totalPrice()).toFixed(2);
	      }
	    }
	  }, {
	    key: 'getDiscountedSubTotalAmount',
	    value: function getDiscountedSubTotalAmount() {
	
	      if (this.mode === this.inStoreDelivery) {
	        return this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount;
	      }
	      if (this.notDeliverable) {
	        return this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount;
	      }
	      if (this.isShippingDiscountEligible()) {
	        return +(this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount - this.getSelectedShipmentCharge() + this.getShippingDiscountCharge()).toFixed(2);
	      } else {
	        return +(this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount + this.getSelectedShipmentCharge()).toFixed(2);
	      }
	    }
	  }, {
	    key: 'cartContainsGiftCard',
	    value: function cartContainsGiftCard() {
	      var _this6 = this;
	
	      return this.cartDetail.cartItems ? this.cartDetail.cartItems.filter(function (item) {
	        var masterCode = item.item.masterProduct.masterCode;
	        var seriesNumber = masterCode.charAt(0);
	        var categoryId = item.item.masterProduct.category.id;
	        return seriesNumber === '9' && categoryId === _this6.isMiscelleneousCategory;
	      }).length : false;
	    }
	  }, {
	    key: 'cartContainsDsc',
	    value: function cartContainsDsc() {
	      var _this7 = this;
	
	      return this.cartDetail.cartItems ? this.cartDetail.cartItems.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this7.dscMasterCode;
	      }).length : false;
	    }
	
	    // cartContainsOnlyDsc() {
	    //   // console.log(this.cartContainsGiftCard());
	    //   const totalItemsInCart = this.cartDetail.cartItems.length;
	    //   if (
	    //     this.cartContainsDsc() && (totalItemsInCart === this.cartContainsDsc())
	    //     ||
	    //     this.cartContainsGiftCard() && (totalItemsInCart === this.cartContainsGiftCard())
	    //     ||
	    //     (this.cartContainsGiftCard() && this.cartContainsDsc() && (totalItemsInCart === 2))) {
	    //     this.mode = this.inStoreDelivery;
	    //     this.resetDeliveryMode(this.mode);
	    //     return true;
	    //   } else {
	    //     if (this.$rootScope.tempdeliveryMode) {
	    //       this.mode = this.$rootScope.tempdeliveryMode;
	    //     } else {
	    //       this.mode = "";
	    //     }
	    //     return false;
	    //   }
	    // }
	
	  }, {
	    key: 'cartContainsOnlyDsc',
	    value: function cartContainsOnlyDsc() {
	      // console.log(this.cartContainsGiftCard());
	      var totalItemsInCart = this.cartDetail.cartItems.length;
	      if (this.cartContainsDsc() && totalItemsInCart === this.cartContainsDsc()) {
	        this.mode = this.inStoreDelivery;
	        this.resetDeliveryMode(this.mode);
	        // console.log("If This mode is :", this.mode);
	        return true;
	      } else {
	        if (this.$rootScope.tempdeliveryMode) {
	          this.mode = this.$rootScope.tempdeliveryMode;
	        } else {
	          this.mode = "";
	        }
	        // console.log("Else This mode is :", this.mode);
	        return false;
	      }
	    }
	  }, {
	    key: 'cartContainsOnlyGift',
	    value: function cartContainsOnlyGift() {
	      var totalItemsInCart = this.cartDetail.cartItems.length;
	      return this.cartContainsGiftCard() && totalItemsInCart === this.cartContainsGiftCard();
	    }
	  }, {
	    key: 'cartContainsOnlyGiftAndDSC',
	    value: function cartContainsOnlyGiftAndDSC() {
	      var _this8 = this;
	
	      var totalItemsInCart = this.cartDetail.cartItems.length;
	      var noOfItems = this.cartDetail.cartItems ? this.cartDetail.cartItems.filter(function (item) {
	        var masterCode = item.item.masterProduct.masterCode;
	        var seriesNumber = masterCode.charAt(0);
	        var categoryId = item.item.masterProduct.category.id;
	        return seriesNumber === '9' && categoryId === _this8.isMiscelleneousCategory || item.item.masterProduct.masterCode === _this8.dscMasterCode;
	      }).length : false;
	      return totalItemsInCart === noOfItems;
	    }
	
	    // converts date to UTC date
	
	  }, {
	    key: 'convertDatetoUTC',
	    value: function convertDatetoUTC(date) {
	      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
	    }
	
	    // Function assumes that the timezone is sent in format "+-HH:MM"
	
	  }, {
	    key: 'convertTimezoneToMilliseconds',
	    value: function convertTimezoneToMilliseconds(timezone) {
	      var arr = timezone.split(':');
	      var signAndHours = arr[0];
	      var minutes = +arr[1];
	      var sign = signAndHours.charAt(0);
	      var hours = +signAndHours.substr(1);
	      var milliseconds = (hours * 60 + minutes) * 60000;
	      var result = sign === '+' ? +milliseconds : -milliseconds;
	      return result;
	    }
	
	    // creates date object in Store's timezone. Does not inc daytime saving, Use for current time only.
	    // See momentJs library for daytime features etc. not implementing as we do not require it here.
	
	  }, {
	    key: 'getStoreDate',
	    value: function getStoreDate() {
	      var systemDate = new Date();
	      var UTCDate = this.convertDatetoUTC(systemDate);
	      var timezoneInMilliseconds = this.store.timeZone && this.convertTimezoneToMilliseconds(this.store.timeZone);
	      var storeDateInMilliseconds = UTCDate.getTime() + timezoneInMilliseconds;
	      var storeDate = new Date(storeDateInMilliseconds);
	      return storeDate;
	    }
	
	    // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
	
	  }, {
	    key: 'changeStringtoDateObject',
	    value: function changeStringtoDateObject(stringTime) {
	      var timeArray = stringTime.split(':');
	      var hours = timeArray[0];
	      var minutes = timeArray[1];
	      var timeObject = this.getStoreDate();
	      timeObject.setMinutes(minutes);
	      return timeObject.setHours(hours);
	    }
	  }, {
	    key: 'formattedTime',
	    value: function formattedTime(dateTime) {
	      var date = dateTime ? new Date(dateTime) : this.getStoreDate();
	      var hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
	      var time = (hours < 10 ? '0' + hours : hours) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	      var ampm = date.getHours() >= 12 ? ' PM' : ' AM';
	      return time + ampm;
	    }
	  }, {
	    key: 'getStoreTiming',
	    value: function getStoreTiming(date) {
	      var forDate = date || this.getStoreDate();
	      var mapping = {
	        '0': 'Sunday',
	        '1': 'Monday',
	        '2': 'Tuesday',
	        '3': 'Wednesday',
	        '4': 'Thursday',
	        '5': 'Friday',
	        '6': 'Saturday'
	      };
	      var day = mapping[forDate.getDay()];
	      return this.store.storeTimings && this.store.storeTimings.filter(function (el) {
	        return el.day === day;
	      })[0];
	    }
	  }, {
	    key: 'storeOpeningTime',
	    value: function storeOpeningTime(forDate) {
	      if (this.store.storeTimings) {
	        var today = forDate || this.getStoreDate();
	        var open = this.getStoreTiming(forDate).openTime;
	        var hours = open.split(':')[0];
	        var minutes = open.split(':')[1];
	        today.setHours(hours);
	        today.setMinutes(minutes);
	        return today;
	      }
	    }
	  }, {
	    key: 'storeClosingTime',
	    value: function storeClosingTime(forDate) {
	      if (this.store.storeTimings) {
	        var today = forDate || this.getStoreDate();
	        var close = this.getStoreTiming(forDate).closeTime;
	        var hours = close.split(':')[0];
	        var minutes = close.split(':')[1];
	        today.setHours(hours);
	        today.setMinutes(minutes);
	        return today;
	      }
	    }
	  }, {
	    key: 'getNextWorkingDay',
	    value: function getNextWorkingDay() {
	      var mapping = {
	        'sunday': '0',
	        'monday': '1',
	        'tuesday': '2',
	        'wednesday': '3',
	        'thursday': '4',
	        'friday': '5',
	        'saturday': '6'
	      };
	      var forDate = this.getStoreDate();
	      var workingDays = this.store.storeTimings.filter(function (el) {
	        return !el.isHoliday;
	      });
	      var nextWorkingDay = void 0;
	      for (var i = 0; i < workingDays.length; i++) {
	        if (forDate.getDay() < mapping[workingDays[i].day.toLowerCase()]) {
	          nextWorkingDay = workingDays[i];
	          break;
	        }
	      }
	      nextWorkingDay = nextWorkingDay || workingDays[0];
	      if (nextWorkingDay && mapping[nextWorkingDay.day.toLowerCase()] == forDate.getDay()) {
	        nextWorkingDay.isSameDay = true;
	      }
	      return nextWorkingDay;
	    }
	  }, {
	    key: 'calculateInStorePick',
	    value: function calculateInStorePick() {
	      if (this.store.storeTimings) {
	        var orderPlacing = this.getStoreDate();
	        // this.store.inStorePickupTime is assumed to be coming in minutes e.g. 120
	        var pickupTime = this.storeClosingTime().setMinutes(this.storeClosingTime().getMinutes() - parseInt(this.store.inStorePickupTime));
	        // console.log("orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime))",orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime)));
	        if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime)) < pickupTime && !this.getStoreTiming().isHoliday) {
	          var origOrderPlacing = this.getStoreDate();
	          // If Order is placed before opening of Store
	          if (origOrderPlacing < this.storeOpeningTime()) {
	            var opening = this.storeOpeningTime();
	            var finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime)));
	            this.estimatedDeliveryDateTime = opening;
	            return finalTime;
	          }
	          this.estimatedDeliveryDateTime = orderPlacing;
	          return 'Today, ' + this.formattedTime(orderPlacing);
	        } else {
	          return this.calculateNextDay();
	        }
	      }
	    }
	  }, {
	    key: 'calculateSameDay',
	    value: function calculateSameDay() {
	      if (this.store.storeTimings) {
	        var orderPlacing = this.getStoreDate();
	        var lastDeliveryTime = this.changeStringtoDateObject(this.store.deliveryPickupTime);
	        if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime)) < lastDeliveryTime &&
	        // let deliveryBoy = this.storeClosingTime().setMinutes(this.storeClosingTime().getMinutes() - this.store.deliveryPickupTime);
	        // if (orderPlacing.setMinutes(orderPlacing.getMinutes() + this.store.fullFillTime) < deliveryBoy &&
	        !this.getStoreTiming().isHoliday) {
	          var origOrderPlacing = this.getStoreDate();
	          // If Order is placed before opening of Store
	          if (origOrderPlacing < this.storeOpeningTime()) {
	            var opening = this.storeOpeningTime();
	            var finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime)));
	            this.estimatedDeliveryDateTime = opening;
	            return finalTime;
	          }
	          this.estimatedDeliveryDateTime = orderPlacing;
	          return 'Today, ' + this.formattedTime(orderPlacing);
	        }
	        return null;
	      }
	    }
	  }, {
	    key: 'calculateNextDay',
	    value: function calculateNextDay() {
	      if (this.store.storeTimings) {
	        var date = void 0;
	        var nextDate = void 0;
	        var opening = void 0;
	        for (var z = 1; z <= 7; z++) {
	          date = this.getStoreDate();
	          nextDate = new Date(date.setDate(date.getDate() + z));
	          if (!this.getStoreTiming(nextDate).isHoliday) {
	            opening = this.storeOpeningTime(nextDate);
	            // opening.setDate(opening.getDate() + 1);
	            opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime));
	            this.estimatedDeliveryDateTime = opening;
	            if (z == 7) {
	              return 'next ' + this.getNextWorkingDay().day + ', ' + this.formattedTime(opening);
	            }
	            return this.getNextWorkingDay().day + ', ' + this.formattedTime(opening);
	          }
	          if (z == 7) {
	            this.noTimeForOrderReadyBy = true;
	            break;
	          }
	        }
	        // else {
	        //   let d = this.getStoreDate();
	        //   const nextWorkingDate = d.setDate(d.getDate() + (this.getNextWorkingDay().id + 6 - d.getDay()) % 7);
	        //   let opening = this.storeOpeningTime(new Date(nextWorkingDate));
	        //   opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime));
	        //   this.estimatedDeliveryDateTime = opening;
	        //   if (this.getNextWorkingDay().isSameDay) {
	        //     return `next ${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
	        //   } else {
	        //     return `${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
	        //   }        
	        // }
	      }
	    }
	  }, {
	    key: 'dateToString',
	    value: function dateToString(dateobj) {
	      if (dateobj != null) {
	        var yr = dateobj.getFullYear();
	        var month = dateobj.getMonth() + 1;
	        var date = dateobj.getDate();
	        var hr = dateobj.getHours();
	        var min = dateobj.getMinutes();
	        var sec = dateobj.getSeconds();
	        return '' + yr + '-' + month + '-' + date + ' ' + hr + ':' + min + ':' + sec;
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'showExcessItemsPopUp',
	    value: function showExcessItemsPopUp() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        backdrop: 'static',
	        keyboard: false,
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Items Limit Reached</h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12">Your cart has reached the current limit of {{noOfItemsAllowed}} items. Please remove some items from the cart.  You can purchase those items in another order.</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">Go to Cart</button>' + '</div>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	          $scope.noOfItemsAllowed = $ctrl.APP.ORDER.LIMITATIONS.noOfItemsAllowed;
	          $scope.ok = function () {
	            $ctrl.$state.go('cart');
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this9 = this;
	
	      if (this.filteredInstoreItem && this.filteredDropShipItem) {
	        this.toaster.pop('success', 'Please modify your cart!');
	        return false;
	      }
	
	      var storeCreditAmount = this.getRoundoffValue(parseFloat(this.profile.customer.storeCredit), this.toDecimalPlaces);
	      if (storeCreditAmount > 0) {
	        var storeCreditWrapper = {
	          "value": storeCreditAmount
	        };
	        this.$order.checkAndUpdateStoreCreditAmount(storeCreditWrapper);
	      }
	
	      // Validating PO Box character in address
	      if (this.mode === this.nextDayDelivery && this.$auth.validatingPoBoxAddress(this.profile.store.postboxAddress, this.addressDetail.shippingAddressLine1)) {
	        // this.toaster.pop('success', 'We do not deliver to PO Boxes. Please enter a street address.');
	        return false;
	      }
	
	      // Validation for curbside detail collection popup
	      if (this.isCurbside) {
	        if (!this.curbSideDetails) {
	          this.getCurbsideDetails(true);
	          return false;
	        }
	      }
	
	      var expectedDeliveryTime = void 0;
	      if (this.mode === this.inStoreDelivery) {
	        expectedDeliveryTime = this.calculateInStorePick();
	      } else if (this.mode === 'Same Day Delivery') {
	        expectedDeliveryTime = this.calculateSameDay();
	      } else {
	        expectedDeliveryTime = this.calculateNextDay();
	      }
	      var data = {
	        "couponIdentifiers": []
	      };
	      this.appliedBirdBuckCoupon = "";
	      if (!this.profile.store.hasErply) {
	        this.appliedBirdBuckCoupon = this.couponNumber;
	      } else {
	        var bbApplied = "";
	        for (var i = 0; i < this.example1model.length; i++) {
	          if (this.example1model[i] != null && this.example1model[i].label != null) {
	            bbApplied = bbApplied + this.example1model[i].label;
	            if (i < this.example1model.length - 1) {
	              bbApplied = bbApplied + ",";
	            }
	          }
	        }
	        this.appliedBirdBuckCoupon = bbApplied;
	      }
	
	      // console.log('expectedDeliveryTime', expectedDeliveryTime);
	      //  console.log('this.estimatedDeliveryDateTime', this.estimatedDeliveryDateTime);
	      var dateStr = this.dateToString(this.estimatedDeliveryDateTime);
	      // console.log('dateStr', dateStr);
	      var deliveryDetail = {
	        'shipTo': {
	          'name': this.addressDetail.firstName + " " + this.addressDetail.lastName,
	          'addressLine1': this.addressDetail.shippingAddressLine1,
	          'addressLine2': this.addressDetail.shippingAddressLine2,
	          'city': this.addressDetail.shippingCity,
	          'state': this.addressDetail.shippingState,
	          'country': this.addressDetail.shippingCountry,
	          'zip': this.addressDetail.shippingZipCode,
	          'addressType': 'Shipping',
	          'deliveryType': this.mode,
	          'expectedDeliveryTime': dateStr,
	          'estimatedDeliveryDateTime': this.estimatedDeliveryDateTime,
	          'phoneNumber': this.addressDetail.phoneNumber,
	          'isCurbside': this.isCurbside,
	          'curbSideDetails': JSON.stringify(this.curbSideDetails)
	        },
	        'appliedBBCoupon': this.appliedBirdBuckCoupon,
	        'discountCode': this.discountCode,
	        'shippingCharge': +this.getSelectedShipmentCharge() ? this.getSelectedShipmentCharge().toFixed(2) || 0 : 0,
	        'shippingDiscount': +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0,
	        // 'shippingCharge': +(this.getSelectedShipmentCharge()).toFixed(2) || 0,
	        // 'shippingDiscount': +this.getShippingDiscountCharge().toFixed(2),
	        'totalPrice': +parseFloat(this.totalPrice()).toFixed(2),
	        'orderNotes': this.orderNotes,
	        'manualPromotionIDs': this.discountCouponCode,
	        'isGiftOrder': this.isGiftOrder
	      };
	      if (this.isDscMember() || this.cartContainsDsc()) {
	        // deliveryDetail.dscPoints = this.subtotal();
	        deliveryDetail.dscPoints = this.getClubPoints();
	        // console.log("Delivery Pg : "+ deliveryDetail.dscPoints);
	      }
	      this.isCallingAPI = true;
	      this.$order.orderCheckout(deliveryDetail).then(function (success) {
	        // if (this.cardInfo.length) {
	        _this9.isCallingAPI = false;
	        _this9.$state.go('card-detail', { orderId: success.data.additionalInfo });
	        // }
	        /* else {
	           let device = this.getDeviceParameter();
	           this.$order.initializePayment(success.data.additionalInfo, device)
	             .then(
	               success => {
	                 if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
	                   this.toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
	                   this.isCallingAPI = false;
	                   return;
	                 }
	                 this.goToMerchantPage(success.data);
	               },
	               err => {
	                 this.toaster.pop('success', err.data.message);
	                 this.isCallingAPI = false;
	               }
	             );
	         }*/
	      }, function (error) {
	        _this9.isCallingAPI = false;
	        if (error.data.errorCode === 640) {
	          _this9.toaster.pop('success', 'Please select Delivery Option.');
	          return;
	        }
	        if (error.data.errorCode === 645) {
	          _this9.toaster.pop('success', error.data.message);
	          return;
	        }
	        if (error.data.errorCode === 665 || error.data.errorCode === 671) {
	          _this9.$state.go('cart');
	          return;
	        }
	        if (error.data.errorCode === 659) {
	          _this9.billingError = error.data.message;
	          var $ctrl = _this9;
	          _this9.$uibModal.open({
	            size: 'sm',
	            template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">{{billingError}}</h5>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' + '</div>',
	            controller: ['$scope', 'orderService', '$uibModalInstance', '$state', function ($scope, $order, $uibModalInstance, $state) {
	              $scope.billingError = $ctrl.billingError;
	              $scope.ok = function () {
	                $uibModalInstance.close();
	                $state.go('profile.edit');
	              };
	              $scope.cancel = function () {
	                return $uibModalInstance.dismiss('cancel');
	              };
	            }]
	          });
	          return;
	        } else {
	          _this9.$uibModal.open({
	            size: 'sm',
	            template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">We can\'t process your order at this time. Please call the store.</h5>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">OK</button>' + '</div>',
	            controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	              $scope.ok = function () {
	                $uibModalInstance.close();
	                location.reload();
	              };
	              $scope.cancel = function () {
	                return $uibModalInstance.dismiss('cancel');
	              };
	            }]
	          });
	        }
	        /*
	        this.$uibModal.open({
	          size: 'sm',
	          template: '<div class="modal-body" id="modal-body">' +
	            '<h5 class="font-weight-bold">Price has been updated for this order. Confirm to reload your Cart details.</h5>' +
	            '</div>' +
	            '<div class="modal-footer">' +
	            '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
	            '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
	            '</div>',
	          controller: ['$scope', 'orderService', '$uibModalInstance',
	            function ($scope, $order, $uibModalInstance) {
	              $scope.ok = () => {
	                $uibModalInstance.close();
	                location.reload();
	              };
	              $scope.cancel = () => $uibModalInstance.dismiss('cancel');
	            }
	          ]
	        });
	        */
	      }).catch(function (err) {
	        _this9.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'goToMerchantPage',
	    value: function goToMerchantPage(data, method) {
	      method = method || 'post';
	
	      var form = document.createElement('form');
	      form.setAttribute('method', method);
	      form.setAttribute('action', data.message);
	
	      var payIdField = document.createElement('input');
	      payIdField.setAttribute('type', 'hidden');
	      payIdField.setAttribute('name', 'PaymentID');
	      payIdField.setAttribute('value', data.additionalInfo);
	      form.appendChild(payIdField);
	
	      var returnMethodField = document.createElement('input');
	      returnMethodField.setAttribute('type', 'hidden');
	      returnMethodField.setAttribute('name', 'ReturnMethod');
	      returnMethodField.setAttribute('value', 'POST');
	      form.appendChild(returnMethodField);
	
	      document.body.appendChild(form);
	      form.submit();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'getDeviceParameter',
	    value: function getDeviceParameter() {
	      if (window.innerWidth <= 576) {
	        return 'm';
	      } else if (window.innerWidth > 576 && window.innerWidth <= 768) {
	        return 't';
	      } else if (window.innerWidth > 768) {
	        return 'd';
	      }
	    }
	  }, {
	    key: 'checkGiftCard',
	    value: function checkGiftCard(form, giftCard) {
	      // console.log(this.giftCards);
	      this.giftCards.push(giftCard);
	    }
	  }, {
	    key: 'checkDiscountCoupon',
	    value: function checkDiscountCoupon(form, coupon, isApply) {
	      var _this10 = this;
	
	      // var highPrice=0;appliedDiscountCoupon
	      // console.log(this.cartDetail.cartItems);
	      // this.removeFreeItems();
	      if (form.$invalid) {
	        this.discountCouponNumber = null;
	        this.discountCouponAmount = 0;
	        this.taxableDiscountAmount = 0;
	        this.isDiscountCouponValid = false;
	        this.discountCouponStatus = 'Invalid Code';
	        this.discountCoupon.couponCode = null;
	        this.appliedDiscountCoupon = null;
	        this.callingTax(1, isApply);
	        // this.getTax();
	        return;
	      }
	      form.error = {};
	      var shipToStateId;
	      var isInStorePickUp = true;
	      if (this.mode !== '') {
	        isInStorePickUp = this.mode === this.inStoreDelivery ? true : false;
	        shipToStateId = this.getShipToStateId(isInStorePickUp);
	      } else {
	        shipToStateId = this.getShipToStateId(true);
	      }
	
	      var discountPromise = this.$order.getCouponDiscount(coupon, isInStorePickUp, shipToStateId).then(function (success) {
	        if (!_this10.profile.store.hasErply) {
	          if (_this10.discountCoupon && (_this10.discountCoupon.discountType === 'FREEITEM' || _this10.discountCoupon.discountType === 'BUYXGETY')) {
	            _this10.$order.getCartDetail(false).then(function () {
	              _this10.getUserProfile();
	            }).catch(function (err) {
	              _this10.$auth.printCustomerGenericLogs(err);
	            });
	          }
	        }
	        _this10.appliedDiscountCoupon = _this10.discountCoupon.couponCode;
	        _this10.isValidToApplyPromo = true;
	        _this10.discountCode = _this10.discountCoupon.couponCode;
	        _this10.isDiscountTotalNegative = false;
	        _this10.isDiscountCouponValid = true;
	        _this10.discountCouponDiscountType = _this10.discountCoupon.discountType;
	
	        _this10.discountCouponAmount = _this10.getDiscountValue(_this10.discountCoupon, 'discount');
	        _this10.discountCouponAmount = Math.round(100 * _this10.discountCouponAmount) / 100;
	        _this10.isDiscountCouponExpired = _this10.discountCoupon.expired;
	        _this10.isDiscountCouponEnabled = _this10.discountCoupon.enabled;
	        // console.log(this.discountCoupon);
	        // console.log(this.subtotal());
	        _this10.discountCouponID = _this10.discountCoupon.id;
	        // console.log("BB----");
	        // console.log(this.couponAmount);
	        // console.log("DC");
	        // console.log(this.discountCouponAmount);
	        if (_this10.discountCoupon.message) {
	          _this10.cError = true;
	          _this10.discountCouponStatus = _this10.discountCoupon.message;
	          _this10.discountCouponID = null;
	          _this10.discountCoupon.discountCouponCode = null;
	          _this10.discountCouponAmount = 0;
	          _this10.taxableDiscountAmount = 0;
	          // this.discountCouponCode=null;
	          _this10.discountCode = null;
	          _this10.appliedDiscountCoupon = null;
	          return 1;
	        }
	        if (_this10.couponAmount + _this10.discountCouponAmount >= _this10.subtotal()) {
	
	          _this10.isDiscountTotalNegative = true;
	          _this10.discountCouponID = null;
	          _this10.discountCouponAmount = 0;
	          _this10.discountCouponCode = null;
	          _this10.discountCode = null;
	          _this10.discountCoupon.couponCode = null;
	          _this10.appliedDiscountCoupon = null;
	        }
	        if (_this10.getDSCItemFromCart()) {
	          if (_this10.couponAmount + _this10.discountCouponAmount >= _this10.subtotal() - _this10.getDSCItemFromCart().price) {
	
	            _this10.isValidToApplyPromo = false;
	            _this10.discountCouponID = null;
	            _this10.discountCouponAmount = 0;
	            // this.discountCouponCode=null;
	            _this10.discountCode = null;
	            _this10.discountCoupon.couponCode = null;
	            _this10.appliedDiscountCoupon = null;
	          }
	
	          var cartItemCount = _this10.cartDetail.cartItems.length;
	          if (cartItemCount - 1 === _this10.getTotalGiftCardsCountFromCart()) {
	            _this10.isValidToApplyPromo = false;
	            _this10.discountCouponID = null;
	            _this10.discountCouponAmount = 0;
	            // this.discountCouponCode=null;
	            _this10.discountCode = null;
	            _this10.discountCoupon.couponCode = null;
	            _this10.appliedDiscountCoupon = null;
	          }
	        }
	
	        if (_this10.getTotalGiftCardsCountFromCart()) {
	          var _cartItemCount = _this10.cartDetail.cartItems.length;
	          if (_cartItemCount === _this10.getTotalGiftCardsCountFromCart()) {
	            _this10.isValidToApplyPromo = false;
	            _this10.discountCouponID = null;
	            _this10.discountCouponAmount = 0;
	            // this.discountCouponCode=null;
	            _this10.discountCode = null;
	            _this10.discountCoupon.couponCode = null;
	            _this10.appliedDiscountCoupon = null;
	          }
	        }
	
	        if (_this10.isDiscountCouponExpired || !_this10.isDiscountCouponEnabled) {
	
	          _this10.discountCouponID = null;
	          _this10.discountCouponAmount = 0;
	          // this.discountCouponCode=null;
	          _this10.discountCode = null;
	          _this10.discountCoupon.couponCode = null;
	          _this10.appliedDiscountCoupon = null;
	        }
	        // this.getTax();
	
	        // Remove discountCoupon from cookies if promo code not valid to apply
	        if (!_this10.isValidToApplyPromo || !_this10.discountCode || !_this10.discountCoupon.couponCode || _this10.isDiscountTotalNegative) {
	          _this10.discountCouponAmount = 0;
	          _this10.discountCode = null;
	          _this10.removePromoCookies();
	        }
	        _this10.generateDiscountValidityMsg();
	      }).catch(function (err) {
	
	        _this10.discountCoupon = null;
	        _this10.isDiscountCouponValid = false;
	        _this10.discountCouponID = null;
	        _this10.discountCouponAmount = 0;
	        _this10.appliedDiscountCoupon = null;
	        _this10.discountCouponCode = null;
	        _this10.mobileDiscountCoupon = null;
	        _this10.taxableDiscountAmount = 0;
	        _this10.discountCode = null;
	        _this10.removePromoCookies();
	        // this.getTax();
	        _this10.generateDiscountValidityMsg();
	
	        _this10.cError = true;
	        _this10.discountCouponStatus = err.data.message;
	        _this10.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        // this.getTax();
	        _this10.callingTax(1, isApply);
	      });
	    }
	  }, {
	    key: 'getShipToStateId',
	    value: function getShipToStateId(isInStorePickUp) {
	
	      if (isInStorePickUp) {
	        return this.store.storeId;
	      } else {
	        return this.addressDetail && this.addressDetail.shippingState ? this.addressDetail.shippingState.id : null;
	      }
	    }
	  }, {
	    key: 'checkBirdbuck',
	    value: function checkBirdbuck(form, coupon, isApply) {
	      var _this11 = this;
	
	      if (form.$invalid || angular.isUndefined(coupon)) {
	        this.couponNumber = null;
	        this.couponAmount = 0;
	        this.isCouponValid = false;
	        this.couponStatus = 'Invalid Code';
	        this.appliedBirdBuckCoupon = null;
	        this.callingTax(1, isApply);
	        // this.getTax();
	        return;
	      }
	      form.error = {};
	      this.$order.getBirdBuckCoupon(coupon).then(function () {
	        _this11.isTotalNegative = false;
	        _this11.isBBAndSubtotalValid = true;
	        _this11.isCouponValid = true;
	        _this11.couponNumber = _this11.coupon.bbCouponNumber;
	        _this11.couponAmount = _this11.coupon.bbCouponAmount;
	        _this11.appliedBirdBuckCoupon = _this11.couponNumber;
	
	        if (_this11.couponAmount >= _this11.subtotal()) {
	          _this11.isTotalNegative = true;
	          _this11.couponNumber = null;
	          _this11.couponAmount = 0;
	        }
	        if (_this11.getDSCItemFromCart()) {
	          if (_this11.couponAmount >= _this11.subtotal() - _this11.discountCouponAmount - _this11.getDSCItemFromCart().price) {
	            _this11.isTotalNegative = true;
	            _this11.isBBAndSubtotalValid = false;
	            _this11.couponNumber = null;
	
	            _this11.couponAmount = 0;
	          }
	          var cartItemCount = _this11.cartDetail.cartItems.length;
	          if (cartItemCount - 1 === _this11.getTotalGiftCardsCountFromCart()) {
	            _this11.isTotalNegative = true;
	            _this11.isBBAndSubtotalValid = false;
	            _this11.couponNumber = null;
	
	            _this11.couponAmount = 0;
	          }
	        }
	
	        if (_this11.getGiftCardItemFromCart()) {
	          var _cartItemCount2 = _this11.cartDetail.cartItems.length;
	          if (_cartItemCount2 === _this11.getTotalGiftCardsCountFromCart()) {
	            _this11.isTotalNegative = true;
	            _this11.isBBAndSubtotalValid = false;
	            _this11.couponNumber = null;
	            _this11.couponAmount = 0;
	          }
	        }
	        // this.getTax();
	        if (!_this11.isBBAndSubtotalValid || _this11.isTotalNegative || !_this11.isCouponValid) {
	          _this11.couponAmount = 0;
	          _this11.removeBBCookies();
	        }
	        _this11.generateValidityMsg();
	      }).catch(function (err) {
	        _this11.appliedBirdBuckCoupon = null;
	        _this11.isCouponValid = false;
	        _this11.couponNumber = null;
	        _this11.couponAmount = 0;
	        _this11.removeBBCookies();
	        // this.getTax();
	        _this11.generateValidityMsg();
	        _this11.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        // this.getTax();
	        _this11.callingTax(1, isApply);
	      });
	    }
	  }, {
	    key: 'resetDeliveryMode',
	    value: function resetDeliveryMode(mode) {
	      this.$rootScope.tempdeliveryMode = mode;
	      // Validating PO Box character in address
	      if (mode === this.nextDayDelivery && this.addressDetail.shippingAddressLine1 && this.$auth.validatingPoBoxAddress(this.profile.store.postboxAddress, this.addressDetail.shippingAddressLine1)) {
	        // this.toaster.pop('success', 'We do not deliver to PO Boxes. Please enter a street address.');
	        return false;
	      }
	    }
	  }, {
	    key: 'resetCouponValues',
	    value: function resetCouponValues() {
	      /* this.couponNumber = null;
	      this.couponAmount = 0;
	      this.mobileCouponNumber = null;
	      this.desktopCouponNumber = null;
	      this.generateValidityMsg(true);
	      this.discountCode = null;
	      this.discountCouponAmount=0;
	      this.taxableDiscountAmount = 0;
	      this.discountCouponCode=null;
	      this.mobileDiscountCoupon=null;
	      this.generateDiscountValidityMsg(true); */
	    }
	  }, {
	    key: 'resetBBCouponValues',
	    value: function resetBBCouponValues() {
	      this.couponNumber = null;
	      this.couponAmount = 0;
	      this.mobileCouponNumber = null;
	      this.desktopCouponNumber = null;
	      this.generateValidityMsg(true);
	    }
	  }, {
	    key: 'resetCouponForm',
	    value: function resetCouponForm(form) {
	      form.$setUntouched();
	      form.$setPristine();
	      this.couponNumber = null;
	      this.couponAmount = 0;
	      this.isCouponValid = false;
	      this.mobileCouponNumber = null;
	      this.desktopCouponNumber = null;
	    }
	  }, {
	    key: 'generateValidityMsg',
	    value: function generateValidityMsg(status) {
	      this.couponStatus = null;
	      if (status) return;
	      if (this.isCouponValid === true && !this.isTotalNegative) {
	        this.couponStatus = 'Successfully Applied';
	      } else if (this.isCouponValid === false) {
	        this.couponStatus = 'Invalid Code';
	      } else if (this.isTotalNegative && this.isCouponValid && this.isBBAndSubtotalValid) {
	        this.couponStatus = 'Your Subtotal Amount should be more than the Bird Buck Code amount';
	      } else if (this.isTotalNegative && this.isCouponValid && !this.isBBAndSubtotalValid) {
	        this.couponStatus = "Bird Bucks cannot be used to purchase a DSC membership or Gift cards.  Please add more product to use a Bird Buck.";
	      } else {
	        this.couponStatus = null;
	      }
	      return this.couponStatus;
	    }
	  }, {
	    key: 'getDiscountValue',
	    value: function getDiscountValue(discountInfo, type) {
	
	      var ctrl = this;
	      if (type === 'discount') {
	        return discountInfo.couponAmount;
	      }
	      if (type === 'taxableDiscount') {
	        return discountInfo.discountTaxable;
	      }
	      var taxable = false;
	      this.discountPercentage = discountInfo.discountPercentage;
	      this.discountAmount = discountInfo.discountAmount;
	      this.dscDiscountPercentage = discountInfo.dscDiscountPercentage;
	      this.nonDscDiscountPercentage = discountInfo.nonDscDiscountPercentage;
	      this.nonTaxableAmount = this.subtotal() - this.taxableAmount();
	      this.discountInfo = discountInfo;
	      this.taxableDiscountAmount = 0;
	      switch (discountInfo.discountType) {
	        case 'AMOUNT':
	          this.taxableDiscount = this.taxableAmount() / this.subtotal() * this.discountAmount;
	          this.nonTaxableDiscount = this.nonTaxableAmount / this.subtotal() * this.discountAmount;
	          this.discountValue = this.taxableDiscount + this.nonTaxableDiscount;
	          // console.log('-----------SubTotal Amount -----------'+this.subtotal());
	          // console.log('-----------Taxable Amount -----------'+this.taxableAmount());
	          // console.log('-----------Non Taxable Amount -----------'+this.nonTaxableAmount);
	          // console.log('-----------Taxable Discount Amount -----------'+this.taxableDiscount);
	          // console.log('-----------Non Taxable Discount Amount -----------'+this.nonTaxableDiscount);
	
	          // console.log('-----------App Calculated Discount Amount -----------'+discountInfo.couponAmount);
	          // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
	          if (type === 'discount') {
	            return discountInfo.couponAmount;
	          }
	          if (type === 'taxableDiscount') {
	            return this.taxableDiscount;
	          }
	          break;
	
	        case 'FREEITEM':
	          this.taxableDiscount = this.taxableAmount() / this.subtotal() * this.discountAmount;
	          this.nonTaxableDiscount = this.nonTaxableAmount / this.subtotal() * this.discountAmount;
	          this.discountValue = this.taxableDiscount + this.nonTaxableDiscount;
	          if (type === 'discount') {
	            return discountInfo.couponAmount;
	          }
	          if (type === 'taxableDiscount') {
	            return this.taxableDiscount;
	          }
	          break;
	
	        case 'BUYXGETY':
	          this.taxableDiscount = this.taxableAmount() / this.subtotal() * this.discountAmount;
	          this.nonTaxableDiscount = this.nonTaxableAmount / this.subtotal() * this.discountAmount;
	          this.discountValue = this.taxableDiscount + this.nonTaxableDiscount;
	          if (type === 'discount') {
	            return discountInfo.couponAmount;
	          }
	          if (type === 'taxableDiscount') {
	            return this.taxableDiscount;
	          }
	          break;
	
	        case 'PERCENTAGE':
	          var discountValue = 0;
	          var taxableDiscountAmount = this.taxableDiscountAmount;
	          var discountPercentage = this.discountPercentage;
	
	          angular.forEach(this.cartItemTaxDetails, function (value) {
	            taxable = ctrl.getCheckForShippingTaxable(value);
	            discountValue = discountValue + value.itemPrice * value.quantity * discountPercentage / 100;
	            // console.log(value.item.id+'------ '+value.itemPrice*value.quantity+'$ ------- '+value.item.taxable);
	            if (taxable) {
	              taxableDiscountAmount = taxableDiscountAmount + value.itemPrice * value.quantity * discountPercentage / 100;
	            }
	          });
	          // console.log('-----------App Calculated Discount Amount -----------'+discountValue);
	          // console.log('-----------App Calculated Taxble Discount Amount -----------'+taxableDiscountAmount);
	          // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
	          if (type === 'discount') {
	            return discountValue;
	          }
	          if (type === 'taxableDiscount') {
	            return taxableDiscountAmount;
	          }
	          break;
	        case 'HIGHPERCENTAGE':
	          // console.log(this.cartDetail);
	
	          var maxItemPrice = 0;
	          taxableDiscountAmount = this.taxableDiscountAmount;
	          discountPercentage = this.discountPercentage;
	          angular.forEach(this.cartItemTaxDetails, function (value) {
	            if (value.itemPrice > maxItemPrice) {
	              taxable = ctrl.getCheckForShippingTaxable(value);
	              maxItemPrice = value.itemPrice;
	              if (taxable) {
	                taxableDiscountAmount = value.itemPrice * discountPercentage / 100;
	              }
	            }
	          });
	          this.discountValue = maxItemPrice * discountPercentage / 100;
	
	          // console.log('-----------App Calculated Discount Amount -----------'+this.discountValue);
	          // console.log('-----------App Calculated Taxable  Discount Amount -----------'+this.taxableDiscountAmount);
	          // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
	          if (type === 'discount') {
	            return this.discountValue;
	          }
	          if (type === 'taxableDiscount') {
	            return taxableDiscountAmount;
	          }
	          break;
	        case 'SUBCATEGORY':
	          // console.log('4');
	          // console.log(this.cartDetail);
	          // console.log(this.discountCoupon);
	          // console.log(this.profile);
	          var profile = this.profile;
	          var currentDate = new Date();
	          var discountCoupon = this.discountCoupon;
	          var dscDiscountPercentage = this.dscDiscountPercentage;
	          var nonDscDiscountPercentage = this.nonDscDiscountPercentage;
	          discountValue = 0;
	          taxableDiscountAmount = this.taxableDiscountAmount;
	          angular.forEach(this.cartItemTaxDetails, function (value) {
	            taxable = ctrl.getCheckForShippingTaxable(value);
	            angular.forEach(discountCoupon.subCategories, function (value1) {
	
	              if (value.subCategory.id === value1.id) {
	                if (value.dscDiscountAmount && profile.customer.dscId) {
	                  if (value.dscDiscountAmount > 0 && profile.customer.dscId === 'C' && profile.customer.dscExpireDate >= currentDate) {
	                    discountValue = discountValue + value.itemPrice * value.quantity * dscDiscountPercentage / 100;
	                    if (taxable) {
	                      taxableDiscountAmount = taxableDiscountAmount + value.itemPrice * value.quantity * dscDiscountPercentage / 100;
	                    }
	                  } else {
	                    discountValue = discountValue + value.itemPrice * value.quantity * nonDscDiscountPercentage / 100;
	                    if (taxable) {
	                      taxableDiscountAmount = taxableDiscountAmount + value.itemPrice * value.quantity * nonDscDiscountPercentage / 100;
	                    }
	                  }
	                } else {
	                  discountValue = discountValue + value.itemPrice * value.quantity * nonDscDiscountPercentage / 100;
	                  if (taxable) {
	                    taxableDiscountAmount = taxableDiscountAmount + value.itemPrice * value.quantity * nonDscDiscountPercentage / 100;
	                  }
	                }
	              }
	            });
	          });
	          // console.log('-----------App calculated Discount Amount -----------'+discountValue);
	          // console.log('-----------App calculated Taxable  Discount Amount -----------'+taxableDiscountAmount);
	          // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
	          // console.log('-----------Server Calculated Taxable Discount Amount -----------'+discountInfo.discountTaxable); 
	          if (type === 'discount') {
	            return discountValue;
	          }
	          if (type === 'taxableDiscount') {
	            return taxableDiscountAmount;
	          }
	          break;
	        default:
	          return 1;
	
	      }
	    }
	  }, {
	    key: 'generateDiscountValidityMsg',
	    value: function generateDiscountValidityMsg(status) {
	      this.discountCouponStatus = null;
	      this.cError = false;
	      if (status) return;else if (this.isDiscountCouponValid === false) {
	        this.cError = true;
	        this.discountCouponStatus = 'Invalid Code';
	      }
	      if (this.isDiscountCouponEnabled === false) {
	        this.cError = true;
	        return this.discountCouponStatus = 'Invalid Code';
	      }
	      if (this.isDiscountCouponExpired === true) {
	        this.cError = true;
	        return this.discountCouponStatus = 'This Code  was expired.';
	      }
	      if (!this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
	        this.cError = true;
	        return this.discountCouponStatus = "Promo Code cannot be used to purchase a DSC membership or GiftCard.  Please add more product to use a Promo code.";
	      }
	      if (this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
	        this.discountCouponStatus = 'Successfully Applied';
	      } else if (this.isDiscountCouponValid === false) {
	        this.cError = true;
	        this.discountCouponStatus = 'Invalid Code';
	      } else if (this.isDiscountTotalNegative && this.isDiscountCouponValid) {
	        this.cError = true;
	        this.discountCouponStatus = 'Your Subtotal Amount should be more than the Discount Code amount';
	      } else {
	
	        this.discountCouponStatus = null;
	      }
	      return this.discountCouponStatus;
	    }
	  }, {
	    key: 'changeAddress',
	    value: function changeAddress() {
	      var subScribedInfo = this.$auth.getSubscribedInfo();
	      if (subScribedInfo && subScribedInfo.addressChange) {
	        subScribedInfo.addressChange = false;
	        this.$auth.setSubscribedInfo(subScribedInfo);
	      }
	      this.$state.go('delivery.address');
	    }
	  }, {
	    key: 'isFreeShippingOfferAvailable',
	    value: function isFreeShippingOfferAvailable() {
	      if (this.profile && this.cartDetail.freeshipping) {
	        var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
	        var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
	        var currentDate = new Date();
	        var result = false;
	        if (this.profile.store) {
	          if (this.profile.store.isFreeShipping) {
	            if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	              result = true;
	            }
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'getFreeShippingRemainingAmount',
	    value: function getFreeShippingRemainingAmount() {
	      if (this.cartDetail) {
	        if (this.cartDetail.freeshipping) {
	          this.shippingOffer.thresholdAmount = this.cartDetail.freeshipping.thresholdValue;
	        }
	      }
	      var remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
	      if (remainingAmount >= 0) {
	        this.shippingOffer.isOfferEligible = true;
	      } else {
	        this.shippingOffer.isOfferEligible = false;
	      }
	      return remainingAmount * -1;
	    }
	  }, {
	    key: 'showFreeShippingOfferDetail',
	    value: function showFreeShippingOfferDetail() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free Shipping within Zone 2';
	      } else {
	        tittle = 'Free Shipping within Zone 2';
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showFreeShippingOfferDetailCan',
	    value: function showFreeShippingOfferDetailCan() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free shipping in Zones 0-1';
	      } else {
	        tittle = 'Free shipping in Zones 0-1';
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'getSubtotal',
	    value: function getSubtotal() {
	      var totalPrice = 0;
	      if (this.profile.store.hasErply) {
	        totalPrice = this.erplyShop.subTotal; // subtotal has promotions and BB discounted
	      } else {
	        if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	            var maxPrice = 0;
	            var maxPriceId = 0;
	            var isDscMember = this.isDscMember() || this.cartContainsDsc();
	            angular.forEach(this.cartDetail.cartItems, function (item, key) {
	              // console.log(key);
	              if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	                maxPriceId = item.item.id;
	                maxPrice = item.item.price;
	              }
	            });
	
	            angular.forEach(this.cartDetail.cartItems, function (item, key) {
	              // console.log(key);
	              if (maxPriceId === item.item.id) {
	                if (item.subCategory.category.dscCategory && isDscMember) {
	                  totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	                } else {
	                  totalPrice = totalPrice + item.item.price * (item.quantity - 1);
	                }
	
	                totalPrice = totalPrice + item.item.price;
	              } else {
	                if (item.subCategory.category.dscCategory && isDscMember) {
	                  totalPrice = totalPrice + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	                } else {
	                  totalPrice = totalPrice + item.item.price * item.quantity;
	                }
	              }
	            });
	          }
	        } else {
	          if (this.isDscMember() || this.cartContainsDsc()) {
	            var dscItems = this.cartDetail.cartItems.filter(function (item) {
	              return item.subCategory.category.dscCategory;
	            });
	            var dscTotal = dscItems.map(function (item) {
	              return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	            }).reduce(function (prev, curr) {
	              return prev + curr;
	            }, 0);
	            var nondscItems = this.cartDetail.cartItems.filter(function (item) {
	              return !item.subCategory.category.dscCategory;
	            });
	            var nonDscTotal = nondscItems.map(function (item) {
	              return item.item.price * item.quantity;
	            }).reduce(function (prev, curr) {
	              return prev + curr;
	            }, 0);
	            totalPrice = dscTotal + nonDscTotal;
	          } else {
	            totalPrice = this.totalRetailPrice();
	          }
	        }
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'totalRetailPrice',
	    value: function totalRetailPrice() {
	      return this.cartDetail.cartItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      });
	    }
	  }, {
	    key: 'getClubPoints',
	    value: function getClubPoints() {
	      // console.log(this.storeDiscountMap);
	      var points = 0;
	      var tempPoints = 0;
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        points = this.getPoints(this.storeDiscountMap);
	      } else {
	        tempPoints = this.getPoints(this.storeDiscountMap);
	        if (tempPoints >= this.discountCouponAmount) {
	          points = tempPoints - this.discountCouponAmount;
	        } else {
	          points = tempPoints;
	        }
	      }
	      if (points >= this.couponAmount) {
	        points = points - this.couponAmount;
	      }
	      return points;
	    }
	  }, {
	    key: 'getPoints',
	    value: function getPoints(storeDiscountMap) {
	      var points = 0;
	      var dscTotal = 0;
	      var nonDscTotal = 0;
	      var $ctrl = this;
	      // Update
	      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
	          var promoAmount = Math.round(this.discountCouponAmount * 100) / 100;
	          var maxPrice = 0;
	          var maxPriceId = 0;
	          var isDscMember = this.isDscMember() || this.cartContainsDsc();
	          angular.forEach(this.cartDetail.cartItems, function (item, key) {
	            // console.log(key);
	            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
	              maxPriceId = item.item.id;
	              maxPrice = item.item.price;
	            }
	          });
	
	          angular.forEach(this.cartDetail.cartItems, function (item, key) {
	            // console.log(key);
	            // console.log("High Percentage promo: Item id for " +maxPriceId + " Item Price : " + maxPrice);
	            if (maxPriceId === item.item.id) {
	              if (item.item.masterProduct.applyDscPoints) {
	                if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100 * (item.quantity - 1);
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price - promoAmount) * 100) / 100;
	                  } else {
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100 * (item.quantity - 1);
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price - promoAmount) * 100) / 100;
	                  }
	                } else {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round(0.85 * item.item.price * 100) / 100 * (item.quantity - 1);
	                    points = points + (item.item.price - promoAmount);
	                  } else {
	                    points = points + Math.round(item.item.price * 100) / 100 * (item.quantity - 1);
	                    points = points + (item.item.price - promoAmount);
	                  }
	                  // console.log("item ND"+item.item.name+" : "+item.item.subCategory.category.dscCategory + "Points: "+ points);
	                }
	              }
	            } else {
	              if (item.item.masterProduct.applyDscPoints) {
	                if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100 * item.quantity;
	                  } else {
	                    points = points + Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100 * item.quantity;
	                  }
	                } else {
	                  if (item.subCategory.category.dscCategory) {
	                    points = points + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	                  } else {
	                    points = points + Math.round(item.item.price * 100) / 100 * item.quantity;
	                  }
	                }
	              }
	            }
	          });
	        }
	      } else {
	
	        // Update end
	
	        var dscItems = this.cartDetail.cartItems.filter(function (item) {
	          return item.subCategory.category.dscCategory;
	        });
	        dscItems.forEach(function (item) {
	          // console.log(item.item.masterProduct.itemName +": "+ item.item.masterProduct.applyDscPoints);
	          if (item.item.masterProduct.applyDscPoints) {
	            if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	              dscTotal = dscTotal + Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100 * item.quantity;
	            } else {
	              dscTotal = dscTotal + Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	            }
	          }
	        });
	
	        var nondscItems = this.cartDetail.cartItems.filter(function (item) {
	          return !item.subCategory.category.dscCategory;
	        });
	        nondscItems.forEach(function (item) {
	          if (item.item.masterProduct.applyDscPoints) {
	            if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
	              nonDscTotal = nonDscTotal + Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100 * item.quantity;
	            } else {
	              nonDscTotal = nonDscTotal + Math.round(item.item.price * 100) / 100 * item.quantity;
	            }
	          }
	        });
	        points = dscTotal + nonDscTotal;
	      }
	      return points;
	    }
	  }, {
	    key: 'doubleTheValue',
	    value: function doubleTheValue(value) {
	      return value * 2;
	    }
	  }, {
	    key: 'getDSCItemFromCart',
	    value: function getDSCItemFromCart() {
	      var _this12 = this;
	
	      var dscItem = '';
	      this.cartDetail.cartItems.forEach(function (item) {
	        if (item.item.masterProduct.masterCode === _this12.dscMasterCode) {
	          dscItem = item.item;
	        }
	      });
	      return dscItem;
	    }
	  }, {
	    key: 'getGiftCardItemFromCart',
	    value: function getGiftCardItemFromCart() {
	      var giftCardItem = '';
	      this.cartDetail.cartItems.forEach(function (item) {
	        if (item.item.masterProduct.masterCode.charAt(0) === '9') {
	          giftCardItem = item.item;
	        }
	      });
	      // console.log('giftCardItem',giftCardItem);
	      return giftCardItem;
	    }
	  }, {
	    key: 'getTotalGiftCardsCountFromCart',
	    value: function getTotalGiftCardsCountFromCart() {
	      var giftCardItem = 0;
	
	      this.cartDetail.cartItems.forEach(function (item) {
	        if (item.item.masterProduct.masterCode.charAt(0) === '9') {
	          giftCardItem = giftCardItem + 1;
	        }
	      });
	
	      return giftCardItem;
	    }
	  }, {
	    key: 'removePromoCookies',
	    value: function removePromoCookies() {
	      try {
	        sessionStorage.removeItem('discountCoupon');
	      } catch (e) {
	        this.$cookies.remove('discountCoupon');
	      }
	    }
	  }, {
	    key: 'removeBBCookies',
	    value: function removeBBCookies() {
	      try {
	        sessionStorage.removeItem('birdbuckCoupon');
	      } catch (e) {
	        this.$cookies.remove('birdbuckCoupon');
	      }
	    }
	  }, {
	    key: 'getClubPointsOld',
	    value: function getClubPointsOld() {
	      return this.orderPoints.dscPoints;
	      // return 12;
	    }
	  }, {
	    key: 'calculateClubPoints',
	    value: function calculateClubPoints() {
	      this.appliedDiscountCoupon = sessionStorage.getItem('discountCoupon');
	      this.appliedBirdBuckCoupon = sessionStorage.getItem('birdbuckCoupon');
	      var isInStorePickUp = true;
	      var shipToStateId;
	      if (this.mode !== '') {
	        isInStorePickUp = this.mode === this.inStoreDelivery ? true : false;
	        shipToStateId = this.getShipToStateId(isInStorePickUp);
	      } else {
	        shipToStateId = this.getShipToStateId(true);
	      }
	      var data = {
	        'bbcouponId': this.appliedBirdBuckCoupon ? this.appliedBirdBuckCoupon : null,
	        'discountcoupon': this.appliedDiscountCoupon ? this.appliedDiscountCoupon : null,
	        'isInStorePickUp': isInStorePickUp,
	        'shipToStateId': shipToStateId
	      };
	
	      this.$order.getOrderPoints(data);
	    }
	
	    // This method is used to reduce the totalAmount for calculation bbDiscount to be dutucted in taxableAmount
	
	  }, {
	    key: 'detuctTotalDscMemberAndGiftAmount',
	    value: function detuctTotalDscMemberAndGiftAmount() {
	      var _this13 = this;
	
	      var amountToExclude = 0.00;
	      var ctrl = this;
	      this.cartItemTaxDetails.forEach(function (item) {
	        if (item.item.masterProduct.masterCode.charAt(0) === '9' || item.item.masterProduct.masterCode === _this13.dscMasterCode) {
	          var taxable = ctrl.getCheckForShippingTaxable(item);
	          if (!taxable) {
	            amountToExclude = amountToExclude + item.item.price * item.quantity;
	          }
	        }
	      });
	      return amountToExclude;
	    }
	  }, {
	    key: 'getTaxDetailRequest',
	    value: function getTaxDetailRequest(isBBApplied) {
	      var isInStorePickUP = true;
	      if (this.mode === '' || this.mode === this.inStoreDelivery) {
	        isInStorePickUP = true;
	      } else {
	        isInStorePickUP = false;
	      }
	      //
	      if (!isBBApplied) {
	        this.setSelectedBBCoupons();
	      }
	      //
	      var data = {
	        'shipTo': {
	          'name': this.addressDetail.customer.firstName + this.addressDetail.customer.lastName,
	          'addressLine1': this.addressDetail.shippingAddressLine1,
	          'addressLine2': this.addressDetail.shippingAddressLine2,
	          'city': this.addressDetail.shippingCity,
	          'state': this.addressDetail.shippingState,
	          'country': this.addressDetail.shippingCountry,
	          'zip': this.addressDetail.shippingZipCode,
	          'addressType': 'Shipping',
	          'deliveryType': this.mode,
	          'expectedDeliveryTime': '',
	          'estimatedDeliveryDateTime': '',
	          'phoneNumber': this.addressDetail.phoneNumber
	        },
	        'isInStorePickUP': isInStorePickUP,
	        // 'shippingCharge': +(this.getSelectedShipmentCharge()).toFixed(2) || 0,
	        // 'shippingDiscount': +this.getShippingDiscountCharge().toFixed(2),
	        'shippingCharge': +this.getSelectedShipmentCharge() ? this.getSelectedShipmentCharge().toFixed(2) || 0 : 0,
	        'shippingDiscount': +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0,
	        "couponIdentifiers": [],
	        "manualPromotionIDs": []
	      };
	
	      if (this.example1model != null && this.example1model.length >= 1) {
	        angular.forEach(this.example1model, function (item, key) {
	          if (item != null && item.label != null) {
	            data.couponIdentifiers.push(item.label);
	          }
	        });
	      }
	
	      if (this.discountCouponCode != null) {
	        data.manualPromotionIDs.push(this.discountCouponCode);
	      } else if (this.mobileDiscountCoupon != null) {
	        data.manualPromotionIDs.push(this.mobileDiscountCoupon);
	      }
	      return data;
	    }
	  }, {
	    key: 'getCheckForShippingTaxable',
	    value: function getCheckForShippingTaxable(value) {
	      var taxable = false;
	      if (this.checkForShippingTaxable) {
	        taxable = value.item.shippingTaxableForState;
	      } else {
	        taxable = value.item.taxable;
	      }
	      return taxable;
	    }
	  }, {
	    key: 'applyDiscounts',
	    value: function applyDiscounts(isDiscountApplied, isBBApplied) {
	      var _this14 = this;
	
	      // this.removeFreeItems();
	      var $ctrl = this;
	      // if(isDiscountApplied){
	      //   if(this.discountCouponCode || this.mobileDiscountCoupon){
	      //     $ctrl.erplyCampaignStatus =  'Promotion Applied automatically';
	      //     $ctrl.isErplyCampaignValid = true;
	      //   } else {
	      //     $ctrl.erplyCampaignStatus =  'Invalid Code';
	      //     $ctrl.isErplyCampaignValid = false;
	      //   }
	      //   return;
	      // }
	
	
	      // starts - new changes
	      // this.avalaraResolveAddress(this.profile, this.profile.store, 2,isDiscountApplied, isBBApplied);
	      if (this.mode === this.nextDayDelivery && this.profile.store.validateAddressType !== 'NOT_VALIDATE' && this.profile.store.validateAddressType != this.profile.validatedAddressType) {
	        this.$spinner.show('appSpinner');
	        this.$auth.avalaraResolveAddress(this.profile, this.profile.store).then(function (resolveAddress) {
	          console.log("ResolveAddress : ", resolveAddress);
	          _this14.$spinner.hide('appSpinner');
	          _this14.$auth.openPopUpForAddressResolve(_this14.profile, resolveAddress, function (addResolved) {
	            _this14.isAddressValidated = true;
	
	            console.log("Call back function", addResolved);
	            if (addResolved.isCanceled) {
	              console.log("Canceled");
	              _this14.changeAddress();
	            } else {
	              _this14.setTempDeliveryAddress(addResolved);
	              _this14.calculateDiscounts(isDiscountApplied, isBBApplied);
	            }
	          });
	        }).catch(function (err) {
	          _this14.isAddressValidated = true;
	          _this14.$spinner.hide('appSpinner');
	          console.log("Error in edit : ", err);
	          _this14.$auth.printCustomerGenericLogs(err);
	        });
	      } else {
	        this.calculateDiscounts(isDiscountApplied, isBBApplied);
	      }
	    }
	  }, {
	    key: 'getDeliveryMode',
	    value: function getDeliveryMode() {
	      var isInStorePickUp = true;
	      if (this.mode !== '') {
	        isInStorePickUp = this.mode === 'In Store Pickup' ? true : false;
	      } else {
	        this.mode = "In Store Pickup";
	        this.resetDeliveryMode(this.mode);
	      }
	      return isInStorePickUp;
	    }
	  }, {
	    key: 'setErplyBBDiscountCookie',
	    value: function setErplyBBDiscountCookie(erplyShop) {
	      try {
	        sessionStorage.setItem('erplyBBDiscount', erplyShop.erplyBBDiscount);
	        sessionStorage.setItem('erplyBBCouponCodes', erplyShop.usedBirdBuckcoupons);
	      } catch (e) {
	        this.$cookies.put('erplyBBDiscount', erplyShop.erplyBBDiscount, {
	          secure: true,
	          samesite: 'lax'
	        });
	        this.$cookies.put('erplyBBCouponCodes', erplyShop.usedBirdBuckcoupons, {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    }
	  }, {
	    key: 'setErplyPromotionCookie',
	    value: function setErplyPromotionCookie(erplyShop) {
	      try {
	        sessionStorage.setItem('erplyPromotionDiscount', erplyShop.erplyPromotionDiscount);
	        sessionStorage.setItem('erplyPromotionCodes', erplyShop.manuallyAppliedPromotions);
	      } catch (e) {
	        this.$cookies.put('erplyPromotionDiscount', erplyShop.erplyPromotionDiscount, {
	          secure: true,
	          samesite: 'lax'
	        });
	        this.$cookies.put('erplyPromotionCodes', erplyShop.manuallyAppliedPromotions, {
	          secure: true,
	          samesite: 'lax'
	        });
	      }
	    }
	  }, {
	    key: 'removeErplyBBDiscountCookie',
	    value: function removeErplyBBDiscountCookie() {
	      try {
	        sessionStorage.removeItem('erplyBBDiscount');
	        sessionStorage.removeItem('erplyBBCouponCodes');
	      } catch (e) {
	        this.$cookies.remove('erplyBBDiscount');
	        this.$cookies.remove('erplyBBCouponCodes');
	      }
	    }
	  }, {
	    key: 'removeErplyPromotionCookie',
	    value: function removeErplyPromotionCookie() {
	      try {
	        sessionStorage.removeItem('erplyPromotionDiscount');
	        sessionStorage.removeItem('erplyPromotionCodes');
	      } catch (e) {
	        this.$cookies.remove('erplyPromotionDiscount');
	        this.$cookies.remove('erplyPromotionCodes');
	      }
	    }
	  }, {
	    key: 'setSelectedBBCoupons',
	    value: function setSelectedBBCoupons() {
	      var _this15 = this;
	
	      if (this.appliedErplyBBDiscount) {
	        if (this.erplyBirdBucksList && this.erplyBirdBucksList.length > 0) {
	          this.getAndSetSelectedErplyBBCoupons();
	        } else {
	          this.$order.getBirdBucksByUser(this.profile.userId).then(function () {
	            _this15.getAndSetSelectedErplyBBCoupons();
	          }).catch(function (err) {
	            _this15.removeErplyBBDiscountCookie();
	            _this15.$auth.printCustomerGenericLogs(err);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getAndSetSelectedErplyBBCoupons',
	    value: function getAndSetSelectedErplyBBCoupons() {
	      var ctrl = this;
	      var selectedBBcoupons = {};
	      var usedErplyCoupons = [];
	      if (ctrl.example1model.length <= 0) {
	        console.log("sessionStorage.getItem('erplyBBCouponCodes') : ", sessionStorage.getItem('erplyBBCouponCodes'));
	        if (sessionStorage.getItem('erplyBBCouponCodes')) {
	          usedErplyCoupons = sessionStorage.getItem('erplyBBCouponCodes').split(',');
	        }
	
	        angular.forEach(usedErplyCoupons, function (selectedBB, key) {
	          selectedBBcoupons = ctrl.erplyBirdBucksList.filter(function (item) {
	            return item.label == selectedBB;
	          });
	          // console.log("Selected BB Coupons : ",selectedBBcoupons);
	          console.log("Selected BB : ", ctrl.example1model);
	          ctrl.example1model.push(selectedBBcoupons[0]);
	        });
	      }
	      // console.log("Example1model : ",ctrl.example1model);
	    }
	  }, {
	    key: 'setErplyPromotionCodes',
	    value: function setErplyPromotionCodes() {
	      var usedErplyCoupon = [];
	      if (this.appliedErplyPromotionDiscount) {
	        usedErplyCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
	        this.discountCouponCode = usedErplyCoupon[0];
	        console.log("this.discountCouponCode : ", this.discountCouponCode);
	      }
	    }
	  }, {
	    key: 'getDefaultDeliveryMode',
	    value: function getDefaultDeliveryMode() {
	      var mode;
	      if (this.profile != null && this.profile.store != null && !this.profile.store.isInStorePickup) {
	        mode = this.nextDayDelivery;
	      } else {
	        mode = '';
	      }
	      return mode;
	    }
	  }, {
	    key: 'resetErplyBBAndPromotionCookies',
	    value: function resetErplyBBAndPromotionCookies() {
	      if (this.erplyShop) {
	        if (this.erplyShop.erplyBBDiscount > 0) {
	          this.setErplyBBDiscountCookie(this.erplyShop);
	          // this.$spinner.hide('appSpinner');
	        } else {
	          this.removeErplyBBDiscountCookie();
	        }
	        // Set Erply Promotions cookies
	        if (this.erplyShop.erplyPromotionDiscount > 0) {
	          this.setErplyPromotionCookie(this.erplyShop);
	          // this.$spinner.hide('appSpinner');
	        } else {
	          this.removeErplyPromotionCookie();
	        }
	      }
	    }
	  }, {
	    key: 'getAndSetAppliedErplyBBCoupons',
	    value: function getAndSetAppliedErplyBBCoupons(usedErplyCoupons) {
	      var ctrl = this;
	      var selectedBBcoupons = {};
	      this.example1model = [];
	      // if(ctrl.example1model.length<=0){
	      if (usedErplyCoupons != "" && usedErplyCoupons.length >= 1) {
	        angular.forEach(usedErplyCoupons, function (selectedBB, key) {
	          selectedBBcoupons = ctrl.erplyBirdBucksList.filter(function (item) {
	            return item.label == selectedBB;
	          });
	          // console.log("Selected BB Coupons : ",selectedBBcoupons);
	          console.log("Selected BB : ", ctrl.example1model);
	          console.log("selectedBBcoupons[0] : ", selectedBBcoupons[0]);
	          if (selectedBBcoupons[0] && selectedBBcoupons[0] != null) {
	            ctrl.example1model.push(selectedBBcoupons[0]);
	          }
	        });
	      }
	      // }
	      // console.log("Example1model : ",ctrl.example1model);
	    }
	  }, {
	    key: 'orderNotesSession',
	    value: function orderNotesSession() {
	      sessionStorage.setItem('orderNotesSession', this.orderNotes);
	      console.log("orderNotesSession --- ", sessionStorage.getItem('orderNotesSession'));
	    }
	  }, {
	    key: 'navigateCart',
	    value: function navigateCart() {
	      this.$state.go('cart');
	    }
	  }, {
	    key: 'deliveryModechanges',
	    value: function deliveryModechanges(mode) {
	      var isCurbside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (mode !== this.nextDayDelivery) {
	        this.resetDeliveryMode(mode);
	        this.mode = mode;
	        this.isCurbside = isCurbside;
	        this.$rootScope.isCurbside = isCurbside;
	        if (this.isCurbside) {
	          this.getCurbsideDetails();
	        }
	        this.resetCouponValues();
	        this.getTax();
	      } else {
	        this.isCurbside = false;
	        this.$rootScope.isCurbside = false;
	      }
	    }
	  }, {
	    key: 'getCurbsideDetails',
	    value: function getCurbsideDetails() {
	      var fromSubmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Curbside pickup details</h5></div>\n        <div class="modal-body" id="modal-body">\n          <div class="container-fluid"> \n            <div class="row"> \n              <form name="curbsideForm" ng-submit="submit(curbsideForm)" autocomplete="off" novalidate>\n                <div class="col-md-12 error-text" ng-if="curbsideForm.error.message">{{curbsideForm.error.message}}</div>\n                  <div class="col-md-12">\n                    <div class="form-group">\n                      <label>Car make/model/color * </label>\n                      <input name="carName" type="text" required ng-model="carName" class="form-control"/>\n                    </div>\n                </div>\n                <div class="col-md-12">\n                    <div class="form-group">\n                      <label>Phone Number * </label>\n                      <input name="phNo" type="tel" required ui-mask="(999) 999-9999" ng-model="phNo" class="form-control"/>\n                    </div>\n                </div>\n                <div class="col-md-12" style="margin-top: -3%;">\n                    <div class="form-group">\n                      <label>You will receive an email when your order is placed and a second email when your order is ready.</label><br/>\n                      <strong>Store Instructions</strong><br/>\n                      <label ng-bind="storeInstruction"></label>\n                    </div>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n        <div class="modal-footer m-t-1">\n            <button class="btn" type="button" ng-click="cancel()">Cancel</button>\n            <button class="btn btn-primary m-l-1" type="button" ng-click="ok(curbsideForm)">Submit</button>\n        </div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	          $scope.phNo = $ctrl.profile.phoneNumber;
	          $scope.storeInstruction = $ctrl.profile.store.curbSideInstruction;
	          if ($ctrl.curbSideDetails) {
	            $scope.carName = $ctrl.curbSideDetails.carName ? $ctrl.curbSideDetails.carName : "";
	            $scope.phNo = $ctrl.curbSideDetails.phNo ? $ctrl.curbSideDetails.phNo : $scope.phNo;
	          }
	          // eslint-disable-next-line arrow-parens
	          $scope.ok = function (curbsideForm) {
	            if ($scope.carName && $scope.phNo) {
	              $ctrl.curbSideDetails = {
	                carName: $scope.carName ? $scope.carName : "",
	                phNo: $scope.phNo ? $scope.phNo : ""
	              };
	              $ctrl.$rootScope.curbSideDetails = $ctrl.curbSideDetails;
	              $uibModalInstance.close();
	              if (fromSubmit) {
	                $ctrl.submit();
	              }
	            } else {
	              curbsideForm.error = { message: 'Please fill All details!' };
	            }
	          };
	          $scope.cancel = function () {
	            $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        backdrop: 'static',
	        keyboard: false
	      });
	    }
	  }, {
	    key: 'removeFreeItems',
	    value: function removeFreeItems() {
	      if (this.discountCouponCode !== 'FREEITEM') {
	        // Removing Free item when promo code removed
	        if (this.orderPoints && this.orderPoints.discountWrapper && this.orderPoints.discountWrapper.cartItemset.length) {
	          var findItem = this.orderPoints.discountWrapper.cartItemset.find(function (item) {
	            return item.discountTypeApplied === 'FREEITEM' && item.isDiscountApplied;
	          });
	          // Removing Free item when discount is removed
	          if (findItem && findItem.item && findItem.discountTypeApplied === 'FREEITEM' && findItem.isDiscountApplied) {
	            if (findItem.quantity === 1) {
	              this.$order.removeItemFromCart(findItem.item.id);
	            } else {
	              this.$order.updateItemInCart(findItem.quantity - 1, findItem.item.id, findItem.item.masterProduct.subCategories[0].id);
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'avalaraResolveAddress',
	    value: function avalaraResolveAddress(userDetail, store, Type, isDiscountApplied, isBBApplied) {
	      var _this16 = this;
	
	      userDetail.store = store;
	      console.log("Calling Resolve address : ", userDetail);
	      if (this.mode === this.nextDayDelivery && this.profile.store.validateAddressType !== 'NOT_VALIDATE' && this.profile.store.validateAddressType != this.profile.validatedAddressType) {
	        this.$auth.avalaraResolveAddress(userDetail, store).then(function (success) {
	          console.log("Success validating : ", success);
	          var $ctrl = _this16;
	          $ctrl.userDetail = userDetail;
	          $ctrl.success = success;
	          $ctrl.Type = Type;
	          var modalInstance;
	          if (success.data) {
	            modalInstance = _this16.$uibModal.open({
	              size: 'md',
	              template: '<div class="modal-header modalheaderbg btn-primary"><h5>Resolve Shipping Address</h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' + '<div class="row">' + '<div class="col-md-12">\n                          <div class="col-md-12 mb-4" style="text-align: center;">\n                            <h6><strong>From</strong></h6>\n                          </div>\n      \n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">Address Line 1</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">Address Line 2</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">City</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingCity ? user.shippingCity.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">State</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingState ? user.shippingState.code : \'\')}}\n                          </div>\n                          </div>\n      \n      \n                          <div class="col-md-12">\n                          <div class="col-md-5">\n                            <label style="color: #b58150;font-weight: bold;">Zip</label>\n                          </div>\n                          <div class="col-md-7">\n                            {{(user.shippingZipCode ? user.shippingZipCode.trim() : \'\')}}\n                          </div>\n                          </div>\n      \n                    </div>' + '<div ng-if="isValidAddress">\n                    <br>\n                    <div class="col-md-12">\n                    <div class="col-md-12 mb-4" style="text-align: center;">\n                      <h6><strong>To</strong></h6>\n                    </div>\n      \n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Address Line 1</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.addressLine1 ? selected.addressLine1.trim() : \'\')}}\n                    </div>\n                    </div>\n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Address Line 2</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.addressLine2 ? selected.addressLine2.trim() : \'\')}}\n                    </div>\n                    </div>\n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">City</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.city ? selected.city.trim() : \'\')}}\n                    </div>\n                    </div>\n      \n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">State</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.state ? selected.state.code : \'\')}}\n                    </div>\n                    </div>\n      \n      \n                    <div class="col-md-12">\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Zip</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{(selected.zip ? selected.zip.trim() : \'\')}}\n                    </div>\n                    </div>\n                    </div>\n                    </div>\n  \n                    <div class="col-md-12" ng-if="!isValidAddress">\n                    <br>\n                    <div class="col-md-5">\n                      <label style="color: #b58150;font-weight: bold;">Given Address not Validated with our records</label>\n                    </div>\n                    <div class="col-md-7">\n                      {{summary}}\n                    </div>\n                    </div>\n                    ' + '</div>' + '</div>' + '<div class="modal-footer">' + '<button  ng-if="isValidAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Update</button>' + '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;">Use this address anyway</button>' + '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="fix()" style="float: right;">I will fix the address</button>' + '</div>',
	              controller: ['$scope', '$state', '$uibModalInstance', function ($scope, $state, $uibModalInstance) {
	                $scope.error = { message: '' };
	                $scope.user = $ctrl.userDetail;
	                $scope.isValidAddress = false;
	                $scope.count = 1;
	                if ($ctrl.userDetail.store.validateAddressType === 'BOTH_BILL_SHIP') {
	                  $scope.count = 2;
	                }
	                if ($ctrl.success.data.resolutionQuality === 'Intersection') {
	                  $scope.isValidAddress = true;
	                  if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
	                    $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
	                  } else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
	                    $scope.selected = $ctrl.success.data.billingAddresstoResolve;
	                  }
	                } else {
	                  if ($ctrl.userDetail.store.validateAddressType === 'Shipping') {
	                    $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
	                    $scope.summary = $ctrl.success.data.shippingAddresstoResolve.summary;
	                  } else if ($ctrl.userDetail.store.validateAddressType === 'Billing') {
	                    $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
	                    $scope.summary = $ctrl.success.data.billingAddresstoResolve.summary;
	                  }
	                }
	                $scope.submit = function () {
	                  // $ctrl.$spinner.show('appSpinner');
	                  console.log("It calls from submit");
	                  $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	                  $ctrl.addressDetail.shippingAddressLine1 = $scope.selected.addressLine1;
	                  $ctrl.addressDetail.shippingAddressLine2 = $scope.selected.addressLine2;
	                  $ctrl.addressDetail.shippingCity = $scope.selected.city;
	                  $ctrl.addressDetail.shippingState = $scope.selected.state;
	                  $ctrl.addressDetail.shippingCountry = $scope.selected.country;
	                  $ctrl.addressDetail.shippingZipCode = $scope.selected.zip;
	
	                  $uibModalInstance.close($scope.user);
	                };
	                $scope.cancel = function () {
	                  return $uibModalInstance.dismiss('cancel');
	                };
	                $scope.back = function () {
	                  $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	                  $uibModalInstance.close($scope.user);
	                };
	                $scope.fix = function () {
	                  console.log("In fixing ");
	                  $uibModalInstance.dismiss('cancel');
	                };
	              }],
	              resolve: {}
	            });
	            modalInstance.result.then(function (data) {
	              console.log('user clicked ok', data);
	              if ($ctrl.Type == 1) {
	                $ctrl.calculateTaxes();
	              } else if ($ctrl.Type == 2) {
	                $ctrl.calculateDiscounts(isDiscountApplied, isBBApplied);
	              }
	            }).catch(function (err) {
	              $ctrl.$auth.printCustomerGenericLogs(err);
	            });
	          }
	        }).catch(function (error) {
	          console.log("Didn't call service resolve address : ", error);
	          _this16.$auth.printCustomerGenericLogs(error);
	        });
	      } else {
	        if (Type == 1) {
	          this.calculateTaxes();
	        } else if (Type == 2) {
	          this.calculateDiscounts();
	        }
	      }
	    }
	  }, {
	    key: 'calculateTaxes',
	    value: function calculateTaxes() {
	      var _this17 = this;
	
	      this.$spinner.show('appSpinner');
	      var shipToStateId;
	      var isInStorePickUp = true;
	      if (this.mode !== '') {
	        isInStorePickUp = this.mode === this.inStoreDelivery ? true : false;
	        shipToStateId = this.getShipToStateId(isInStorePickUp);
	      } else {
	        shipToStateId = this.getShipToStateId(true);
	      }
	      var ctrl = this;
	      var taxableDiscountAmount = 0;
	      var discountAmount = 0;
	      var bbdiscount = 0;
	      console.log("Calling calculate Taxes ");
	      var taxDetailRequestData = this.getTaxDetailRequest();
	      this.isCallingAPI = true;
	      this.$order.getItemTaxDetails(taxDetailRequestData).then(function (success) {
	        _this17.isCallingAPI = false;
	        _this17.cartItemTaxDetails = success.data.cartItems;
	        _this17.checkForShippingTaxable = success.data.checkForShippingTaxable;
	        if (_this17.profile.store.hasErply) {
	          _this17.erplyShop = success.data.showCart.erplyShopCartResponse;
	          _this17.setErplyCartResponseValue(success.data.showCart);
	
	          var usedErplyCoupons = _this17.erplyShop.usedBirdBuckcoupons.split(',');
	          _this17.getAndSetAppliedErplyBBCoupons(usedErplyCoupons);
	
	          _this17.resetErplyBBAndPromotionCookies(_this17.erplyShop);
	          console.log("Checking for showcart error :  ", success.data.showCart);
	
	          if (success.data && success.data.showCart && success.data.showCart.baseResponse && taxDetailRequestData.manualPromotionIDs && taxDetailRequestData.manualPromotionIDs.length > 0) {
	            if (success.data.showCart.baseResponse.successCode == '200' && _this17.erplyShop.isPromotionAppliedSuccessfuly) {
	              _this17.isErplyCampaignValid = true;
	            } else {
	              _this17.isErplyCampaignValid = false;
	            }
	            _this17.erplyCampaignStatus = success.data.showCart.baseResponse.message;
	          }
	          // this.$spinner.hide('appSpinner');
	
	
	          if (success.data.showCart.cartError.length > 0) {
	            _this17.toaster.pop('success', 'Error in tax calculation');
	            _this17.hasCartError = true;
	          } else {
	            _this17.hasCartError = false;
	          }
	          // this.setSelectedBBCoupons();
	        } else {
	          if (_this17.discountCouponAmount) {
	            // this.checkDiscountCoupon({ $error: {}, $$success: {}, $pending: undefined, $name: "discountCouponForm", $dirty: false }, this.appliedDiscountCoupon, false);
	            _this17.$order.getCouponDiscount(_this17.appliedDiscountCoupon, isInStorePickUp, shipToStateId).then(function (success) {
	              taxableDiscountAmount = ctrl.getDiscountValue(ctrl.discountCoupon, 'taxableDiscount');
	              taxableDiscountAmount = Math.round(100 * taxableDiscountAmount) / 100;
	              discountAmount = ctrl.getDiscountValue(ctrl.discountCoupon, 'discount');
	              discountAmount = Math.round(100 * discountAmount) / 100;
	              if (taxableDiscountAmount <= 0) {
	                taxableDiscountAmount = 0;
	              }
	              _this17.calculateTaxUponBBandDiscount(taxableDiscountAmount, discountAmount);
	            }).catch(function (err) {
	
	              _this17.discountCoupon = null;
	              _this17.isDiscountCouponValid = false;
	              _this17.discountCouponID = null;
	              _this17.discountCouponAmount = 0;
	              _this17.appliedDiscountCoupon = null;
	              _this17.discountCouponCode = null;
	              _this17.mobileDiscountCoupon = null;
	              _this17.taxableDiscountAmount = 0;
	              _this17.discountCode = null;
	              _this17.removePromoCookies();
	              // this.getTax();
	              _this17.generateDiscountValidityMsg();
	
	              _this17.cError = true;
	              _this17.discountCouponStatus = err.data.message;
	            });
	          } else {
	            _this17.calculateTaxUponBBandDiscount(taxableDiscountAmount, discountAmount);
	          }
	        }
	        _this17.$spinner.hide('appSpinner');
	      }, function (error) {
	        _this17.isCallingAPI = false;
	        _this17.$auth.printCustomerGenericLogs(error);
	      }).catch(function (err) {
	        _this17.noItemsInCart = true;
	        _this17.isCallingAPI = false;
	        if (!_this17.profile.store.hasErply) {
	          _this17.calculateTaxUponBBandDiscount(taxableDiscountAmount, discountAmount);
	        }
	        _this17.$spinner.hide('appSpinner');
	        _this17.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'isPromotionManaullyApplied',
	    value: function isPromotionManaullyApplied() {
	      // Check for erply store
	      if (this.erplyShop != null && this.erplyShop.manuallyAppliedPromotions != null && this.erplyShop.manuallyAppliedPromotions.length > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'calculateDiscounts',
	    value: function calculateDiscounts(isDiscountApplied, isBBApplied) {
	      var _this18 = this;
	
	      if (this.mode === '') {
	        this.promptForDeliveryType('', "Please select an option for how to receive your order");
	        // this.toaster.pop('success', 'Please choose how to receive your order!');
	        return false;
	      }
	      this.$spinner.show('appSpinner');
	      var $ctrl = this;
	      var isInstorePickup = this.getDeliveryMode();
	      var data = {
	        "isDiscountApplied": isDiscountApplied,
	        "couponIdentifiers": [],
	        "manualPromotionIDs": [],
	        'shippingCharge': +this.getSelectedShipmentCharge() ? this.getSelectedShipmentCharge().toFixed(2) || 0 : 0,
	        'shippingDiscount': +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0
	      };
	      if (isInstorePickup) {
	        data.shippingCharge = 0;
	        data.shippingDiscount = 0;
	      } else {
	        data.shippingCharge = +this.getSelectedShipmentCharge() ? this.getSelectedShipmentCharge().toFixed(2) || 0 : 0;
	        data.shippingDiscount = +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0;
	      }
	
	      if (this.example1model.length > 0) {
	        console.log("this.examplemodel : ", this.example1model);
	        angular.forEach(this.example1model, function (item, key) {
	          // console.log("this.examplemodel each: ", item);
	          if (item != null && item.label != null) {
	            data.couponIdentifiers.push(item.label);
	          }
	        });
	      }
	      if (this.discountCouponCode != null) {
	        data.manualPromotionIDs.push(this.discountCouponCode);
	      }
	      console.log("Multiple BB : ", data);
	
	      var taxDetailRequestData = this.getTaxDetailRequest(isBBApplied);
	      this.$order.getItemTaxDetails(taxDetailRequestData).then(function (success) {
	        _this18.cartItemTaxDetails = success.data.cartItems;
	        _this18.checkForShippingTaxable = success.data.checkForShippingTaxable;
	        if (_this18.profile.store.hasErply) {
	          _this18.erplyShop = success.data.showCart.erplyShopCartResponse;
	          // Set BirdBuck cookies
	          _this18.setErplyCartResponseValue(success.data.showCart);
	          _this18.resetErplyBBAndPromotionCookies(_this18.erplyShop);
	        }
	        if (isDiscountApplied) {
	          if (success.data && success.data.showCart && success.data.showCart.baseResponse) {
	            if (success.data.showCart.baseResponse.successCode == '200' && _this18.erplyShop.isPromotionAppliedSuccessfuly) {
	              $ctrl.isErplyCampaignValid = true;
	            } else {
	              _this18.appliedDiscountCoupon = null;
	              _this18.mobileDiscountCoupon = null;
	              _this18.discountCouponCode = null;
	              $ctrl.isErplyCampaignValid = false;
	            }
	            $ctrl.erplyCampaignStatus = success.data.showCart.baseResponse.message;
	          } else {
	            $ctrl.erplyCampaignStatus = "";
	          }
	          // this.$spinner.hide('appSpinner');
	        }
	        if (isBBApplied) {
	
	          if (success.data && success.data.showCart && success.data.showCart.baseResponse) {
	            if (success.data.showCart.baseResponse.successCode == '200' && _this18.erplyShop.isPromotionAppliedSuccessfuly) {
	              $ctrl.isErplyCampaignValid = true;
	            } else {
	              _this18.appliedDiscountCoupon = null;
	              _this18.mobileDiscountCoupon = null;
	              _this18.discountCouponCode = null;
	              $ctrl.isErplyCampaignValid = false;
	            }
	            $ctrl.erplyCampaignStatus = success.data.showCart.baseResponse.message;
	          } else {
	            $ctrl.erplyCampaignStatus = "";
	          }
	
	          if ($ctrl.erplyShop.erplyBBDiscount > 0) {
	            var usedErplyCoupons = $ctrl.erplyShop.usedBirdBuckcoupons.split(',');
	            $ctrl.getAndSetAppliedErplyBBCoupons(usedErplyCoupons);
	            $ctrl.resetErplyBBAndPromotionCookies();
	            $ctrl.couponStatus = 'Successfully Applied';
	            $ctrl.isCouponValid = true;
	            $ctrl.isTotalNegative = false;
	          } else {
	            _this18.example1model = [];
	            _this18.removeErplyBBDiscountCookie();
	            $ctrl.couponStatus = '';
	            $ctrl.isCouponValid = false;
	            $ctrl.isTotalNegative = true;
	          }
	        }
	        _this18.$spinner.hide('appSpinner');
	      }).catch(function (err) {
	        _this18.noItemsInCart = true;
	        _this18.removeErplyBBDiscountCookie();
	        _this18.$spinner.hide('appSpinner');
	        _this18.$auth.printCustomerGenericLogs(err);
	        // this.calculateTaxUponBBandDiscount(taxableDiscountAmount,discountAmount);
	      });
	    }
	  }, {
	    key: 'getStates',
	    value: function getStates(country, type, time) {
	      // console.log(country);
	      // console.log(type);
	      switch (type) {
	        case 'billingAddress':
	          if (this.profile && time !== 0) {
	            if (this.profile.billingState) {
	              this.profile.billingState.code = '';
	              this.profile.billingZipCode = '';
	            }
	          }
	          var billingStates = '';
	          // console.log(this.billingCountries);
	          angular.forEach(this.billingCountries, function (value) {
	
	            if (country === value.label) {
	              billingStates = value.states;
	            }
	          });
	
	          this.billingStates = billingStates;
	          break;
	        case 'shippingAddress':
	          if (this.profile && time !== 0) {
	            if (this.profile.shippingState) {
	              this.profile.shippingState.code = '';
	              this.profile.shippingZipCode = '';
	            }
	          }
	          var shippingStates = '';
	          // console.log(this.shippingCountries);
	          angular.forEach(this.shippingCountries, function (value) {
	            // console.log(country,"==",value.label);
	            if (country === value.label) {
	              shippingStates = value.states;
	            }
	          });
	
	          this.shippingStates = shippingStates;
	          break;
	        default:
	          break;
	
	      }
	    }
	  }, {
	    key: 'promptForDeliveryType',
	    value: function promptForDeliveryType(title, detail) {
	
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + title + '</h5>' +
	        // '<span ng-bind-html="'+detailed+'" > </span>'+
	        detail + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'setTempDeliveryAddress',
	    value: function setTempDeliveryAddress(addResolved) {
	      console.log("AddResolved : ", addResolved);
	      console.log("AddResolved.shippingAddressLine1 : ", addResolved.shippingAddressLine1);
	      this.addressDetail.shippingAddressLine1 = addResolved.shippingAddressLine1;
	      this.addressDetail.shippingAddressLine2 = addResolved.shippingAddressLine2;
	      this.addressDetail.shippingCity = addResolved.shippingCity;
	      this.addressDetail.shippingZipCode = addResolved.shippingZipCode;
	      var country = '';
	      var state = '';
	      angular.forEach(this.shippingCountries, function (country1) {
	        if (addResolved.shippingCountry.countryCode === country1.label) {
	          country = {
	            "id": parseInt(country1.value),
	            "countryCode": country1.label,
	            "name": country1.name
	          };
	          angular.forEach(country1.states, function (state1) {
	            if (addResolved.shippingState.code === state1.value) {
	              state = {
	                "id": state1.id,
	                "code": state1.value,
	                "name": state1.label
	              };
	            }
	          });
	        }
	      });
	      this.addressDetail.shippingCountry = country;
	      this.addressDetail.shippingState = state;
	      localStorage.setItem('deliveryAddress', JSON.stringify(this.addressDetail));
	    }
	  }, {
	    key: 'infoPopup',
	    value: function infoPopup() {
	      var _this19 = this;
	
	      document.getElementById('popup').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popup').style.display === 'block' && _this19.showPopup === false) {
	          _this19.hideinfoPopup();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'hideinfoPopup',
	    value: function hideinfoPopup() {
	      document.getElementById('popup').style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopuponhover',
	    value: function infoPopuponhover() {
	      document.getElementById('popup').style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'infoPopupFee',
	    value: function infoPopupFee() {
	      var _this20 = this;
	
	      document.getElementById('popup1').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popup1').style.display === 'block' && _this20.showPopupFee === false) {
	          _this20.hideinfoPopupFee();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'hideinfoPopupFee',
	    value: function hideinfoPopupFee() {
	      document.getElementById('popup1').style.display = 'none';
	      this.showPopupFee = false;
	    }
	  }, {
	    key: 'infoPopuponhoverFee',
	    value: function infoPopuponhoverFee() {
	      document.getElementById('popup1').style.display = 'block';
	      this.showPopupFee = true;
	    }
	  }, {
	    key: 'setErplyCartResponseValue',
	    value: function setErplyCartResponseValue(showcart) {
	      console.log("Showcart : ", showcart);
	      this.erplyDis = [];
	      var dis = {};
	      var ctrl = this;
	      var i = 0;
	      angular.forEach(showcart.erplyPromoAndDiscount, function (item, key) {
	        console.log('key', key);
	        console.log('item', item);
	        dis = {};
	        dis.key = key;
	        dis.value = item;
	        dis.sortId = i + 1;
	        i = i + 1;
	        ctrl.erplyDis.push(dis);
	      });
	    }
	  }, {
	    key: 'getAdjustedLabelName',
	    value: function getAdjustedLabelName(promoLabel) {
	      if (promoLabel != null && promoLabel.length > this.promoLengthToBeShown) {
	        return promoLabel.substring(0, this.promoLengthToBeShown - 3) + "...";
	      } else {
	        return promoLabel;
	      }
	    }
	  }, {
	    key: 'hideinfoPromoNamePopup',
	    value: function hideinfoPromoNamePopup(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopupPromoNameonhover',
	    value: function infoPopupPromoNameonhover(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'getRoundoffValue',
	    value: function getRoundoffValue(number, places) {
	      // console.log(" number.toFixed(places) : "+  number.toFixed(places));
	      return parseFloat(number.toFixed(places));
	    }
	  }]);
	
	  return Delivery;
	}(), _class2.$inject = ['$scope', '$rootScope', '$ngRedux', '$state', '$uibModal', 'toaster', 'spinnerService', 'authService', 'orderService', '$q', '$window', '$cookies', '$stateParams', 'APP', '$sce'], _temp)) || _class);
	exports.default = Delivery;

/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = "<!-- DELIVERY FOR SM,XS -->\r\n\r\n\r\n  <div class=\"p-x-0 p-b-1 hidden-md-up\">\r\n\r\n    <!-- Breadcrumb -->\r\n    <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n      <a class=\"nav\" ng-click=\"delivery.goToHomePage()\">\r\n        <img class=\"breadcrumb-logo-icon\" src={{delivery.houseIcon}} alt=\"logo\" />\r\n        <span>Home</span>\r\n      </a>\r\n      <span>Checkout Details</span>\r\n    </nav>\r\n\r\n    <!-- Store Address -->\r\n    <div class=\"row sub-header-bg m-x-0\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      <div class=\"col-xs-6 mt-8 mb-8\">\r\n        <h5>\r\n          <strong>Store Details</strong>\r\n        </h5>\r\n\r\n        <h6 class=\"m-b-0\" ng-bind=\"delivery.profile.store.storeName\"></h6>\r\n        <p class=\"m-b-0\" ng-if=\"delivery.profile.store.addressLine1\">{{delivery.profile.store.addressLine1}}\r\n          {{delivery.profile.store.addressLine2}}</p>\r\n        <p class=\"m-b-0\" ng-if=\"delivery.profile.store.country\">{{delivery.profile.store.city}}\r\n          {{delivery.profile.store.state.name}}, {{delivery.profile.store.country.name}}\r\n          {{delivery.profile.store.zipCode}}</p>\r\n      </div>\r\n      <div class=\"col-xs-6 mt-8 mb-8 text-xs-right\">\r\n        <h5>\r\n          <strong>Today's Store Hours</strong>\r\n        </h5>\r\n        <h6 class=\"m-b-0\">\r\n          {{delivery.formattedTime(delivery.storeOpeningTime())}} -\r\n          {{delivery.formattedTime(delivery.storeClosingTime())}}\r\n        </h6>\r\n        <p class=\"m-b-0\">\r\n          <a class=\"blue-colored\" href=\"tel:{{delivery.profile.store.phoneNumber}}\">\r\n            {{delivery.profile.store.phoneNumber | telFormat}}</a>\r\n        </p>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Delivery mode -->\r\n    <div class=\"row m-x-0 gray-bg p-b-1\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      <div class=\"col-xs-12 mt-8\">\r\n        <h5>\r\n          <strong>Choose How to Receive Your Order</strong>\r\n        </h5>\r\n        <div class=\"error-text\" style=\"    padding-bottom: 15px;   padding-left: 1px !important;\"\r\n          ng-show=\"!delivery.mode || delivery.mode == ''\">\r\n          Select one of the following options:\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 delivery p-r-0\">\r\n        <!-- In Store pickup -->\r\n        <div class=\"form-check\" ng-show=\"delivery.profile.store.isInStorePickup && !delivery.filteredDropShipItem\">\r\n          <label class=\"form-check-label\">\r\n            <input type=\"radio\" class=\"form-check-input\" ng-if=\"!delivery.isCurbside\" ng-model=\"delivery.mode\"\r\n              value=\"In Store Pickup\" ng-click=\"delivery.deliveryModechanges('In Store Pickup');\">\r\n            <input type=\"radio\" class=\"form-check-input\" ng-if=\"delivery.isCurbside\" ng-model=\"delivery.mode\"\r\n              value=\"In Store Pickup1\" ng-click=\"delivery.deliveryModechanges('In Store Pickup');\">\r\n            <span> In-store pickup. </span>\r\n            <p class=\"primary-text delivery-sub-text\" ng-if=\"!delivery.cartContainsOnlyDsc()\">\r\n              FROM STORE ABOVE\r\n            </p>\r\n            <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"delivery.cartContainsOnlyGift()\">Please enter a shipping address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store, leave the Notes section blank.</p> -->\r\n            <p class=\"primary-text delivery-sub-text\"\r\n              ng-if=\"delivery.mode === 'In Store Pickup' && delivery.holidays.length !== 0 && !delivery.cartContainsOnlyDsc()\">\r\n              CLOSED ON:\r\n              <span ng-repeat=\"item in delivery.holidays\" class=\"text-uppercase\">{{item.day | limitTo: 3 }}\r\n                <span ng-hide=\"$last\">, </span>\r\n              </span>\r\n            </p>\r\n          </label>\r\n        </div>\r\n        <!-- Curbside Pickup -->\r\n        <div class=\"form-check\" ng-show=\"delivery.profile.store.isCurbsidePickup && !delivery.filteredDropShipItem\">\r\n          <label class=\"form-check-label\">\r\n            <input type=\"radio\" ng-if=\"!delivery.isCurbside\" class=\"form-check-input\" ng-model=\"delivery.mode\"\r\n              value=\"In Store Pickup1\" ng-click=\"delivery.deliveryModechanges('In Store Pickup', true);\">\r\n            <input type=\"radio\" ng-if=\"delivery.isCurbside\" class=\"form-check-input\" ng-model=\"delivery.mode\"\r\n              value=\"In Store Pickup\" ng-click=\"delivery.deliveryModechanges('In Store Pickup', true);\">\r\n            <span> Curbside pickup. </span>\r\n            <p class=\"primary-text delivery-sub-text\" ng-if=\"!delivery.cartContainsOnlyDsc()\">\r\n              FROM STORE ABOVE\r\n            </p>\r\n            <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"delivery.cartContainsOnlyGift()\">Please enter a shipping address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store, leave the Notes section blank.</p> -->\r\n            <p class=\"primary-text delivery-sub-text\"\r\n              ng-if=\"delivery.mode === 'In Store Pickup' && delivery.holidays.length !== 0 && !delivery.cartContainsOnlyDsc()\">\r\n              CLOSED ON:\r\n              <span ng-repeat=\"item in delivery.holidays\" class=\"text-uppercase\">{{item.day | limitTo: 3 }}\r\n                <span ng-hide=\"$last\">, </span>\r\n              </span>\r\n            </p>\r\n          </label>\r\n        </div>\r\n        <!-- <div class=\"form-check\">\r\n          <label class=\"form-check-label\"\r\n            ng-class=\"!delivery.calculateSameDay() || !delivery.charge.length ? 'disabled' : ''\">\r\n            <input type=\"radio\" class=\"form-check-input\"\r\n              ng-model=\"delivery.mode\" value=\"Same Day Delivery\"\r\n              ng-disabled=\"!delivery.calculateSameDay() || !delivery.charge.length\">\r\n            <span> Same Day Delivery </span>\r\n            <p class=\"primary-text delivery-sub-text\"\r\n            ng-if=\"delivery.getSameDayCharge()\">\r\n              SHIPPING COST: ${{delivery.getSameDayCharge() | number : 2}}\r\n            </p>\r\n          </label>\r\n        </div> -->\r\n        <!-- Shipping -->\r\n        <div class=\"m-b-0\" ng-if=\"!delivery.filteredInstoreItem\">\r\n          <label class=\"form-check-label\" ng-class=\"delivery.cartContainsOnlyDsc() ? 'disabled' : ''\">\r\n            <input type=\"radio\" class=\"form-check-input\" ng-model=\"delivery.mode\" value=\"Next Day Delivery\"\r\n              ng-disabled=\"delivery.cartContainsOnlyDsc()\" ng-click=\"delivery.resetDeliveryMode('Next Day Delivery');\"\r\n              ng-change=\"delivery.deliveryModechanges('Next Day Delivery');delivery.resetCouponValues(); delivery.getTax();\">\r\n            <span>Please ship my order.\r\n              <br>\r\n              <span style=\"font-size: 10px;position: relative;top: -5px !important;\">(Ground shipping is typically 2-5\r\n                business days)</span>\r\n            </span>\r\n            <p class=\"primary-text delivery-sub-text1\"\r\n              ng-if=\"delivery.charge.length && delivery.getNextDayCharge() && !delivery.cartContainsOnlyDsc()\">\r\n              SHIPPING COST: ${{delivery.getNextDayCharge() | number : 2}}\r\n            </p>\r\n\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-6 text-xs-right\">\r\n        <h6 class=\"text-xs-center delivery-info-text\" ng-if=\"!delivery.cartContainsOnlyDsc()\">\r\n          <span ng-if=\"delivery.mode === 'In Store Pickup' && delivery.profile.store.showOrderReadyTime\">Order Ready by\r\n            {{delivery.calculateInStorePick()}} (Store Local Time)</span>\r\n          <span\r\n            ng-if=\"delivery.mode === 'In Store Pickup' && (!delivery.profile.store.showOrderReadyTime || delivery.noTimeForOrderReadyBy)\">We\r\n            will let you know when your order is ready.</span>\r\n        </h6>\r\n        <!-- <h6 class=\"text-xs-center delivery-info-text\">\r\n          <span ng-if=\"delivery.mode === 'Same Day Delivery'\">Estimated Delivery by {{delivery.calculateSameDay()}}</span>\r\n        </h6> -->\r\n        <!-- <h6 class=\"text-xs-center delivery-info-text\">\r\n          <span ng-if=\"delivery.mode === 'Next Day Delivery'\">Estimated Delivery by {{delivery.calculateNextDay()}}</span>\r\n        </h6> -->\r\n      </div>\r\n      <div class=\"col-xs-12 zone-charge\" ng-if=\"delivery.mode == 'Next Day Delivery' && !delivery.cartContainsOnlyGift()\">\r\n        <table class=\"table table-sm m-b-0\">\r\n          <thead>\r\n            <tr>\r\n              <th>Shipping</th>\r\n\r\n              <th>\r\n                <center>{{delivery.zoneDeliveryCharges[0].distanceRange}} </center>\r\n                <center>\r\n                  <span ng-if=\"delivery.profile.store.country.countryCode=='US'\">Miles</span>\r\n                </center>\r\n              </th>\r\n              <th>\r\n                <center>{{delivery.zoneDeliveryCharges[1].distanceRange}} </center>\r\n                <center>\r\n                  <span ng-if=\"delivery.profile.store.country.countryCode=='US'\">Miles</span>\r\n                </center>\r\n              </th>\r\n              <th>\r\n                <center>{{delivery.zoneDeliveryCharges[2].distanceRange}} </center>\r\n                <center>\r\n                  <span ng-if=\"delivery.profile.store.country.countryCode=='US'\">Miles</span>\r\n                </center>\r\n              </th>\r\n\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr>\r\n              <td>Shipping Cost</td>\r\n              <td>\r\n                <center>${{delivery.zoneDeliveryCharges[0].nextDayCharge}}</center>\r\n              </td>\r\n              <td>\r\n                <center>${{delivery.zoneDeliveryCharges[1].nextDayCharge}}</center>\r\n              </td>\r\n              <td>\r\n                <center>${{delivery.zoneDeliveryCharges[2].nextDayCharge}}</center>\r\n              </td>\r\n            </tr>\r\n            <tr ng-show=\"delivery.isFreeShippingOfferAvailable() && delivery.shippingOffer.isOfferEligible\">\r\n\r\n              <td>Shipping Discount</td>\r\n              <td>\r\n                <center>- ${{delivery.getShippingDiscountCharge() | number : 2}}</center>\r\n              </td>\r\n              <td>\r\n                <center>- ${{delivery.getShippingDiscountCharge() | number : 2}}</center>\r\n              </td>\r\n              <td>\r\n                <center>- ${{delivery.getShippingDiscountCharge() | number : 2}}</center>\r\n              </td>\r\n\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n        <!--    &lt;!&ndash;<table class=\"table table-sm m-b-0\">\r\n          <thead>\r\n            <tr>\r\n              <th>Zone</th>\r\n              <th>Distance (mi)</th>\r\n              <th>Up to 70 lbs</th>\r\n              <th>Above 70 lbs</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr ng-repeat=\"zoneData in delivery.zoneDeliveryCharges\">\r\n              <td ng-bind=\"zoneData.zone\"></td>\r\n              <td ng-bind=\"zoneData.distanceRange\"></td>\r\n              <td ng-bind=\"zoneData.nextDayCharge\"></td>\r\n              <td ng-bind=\"zoneData.nextDayChargeover70lbs\"></td>\r\n            </tr>\r\n          </tbody>\r\n        </table>&ndash;&gt;-->\r\n      </div>\r\n      <div class=\"col-xs-12\" ng-if=\"delivery.filteredInstoreItem || delivery.filteredDropShipItem\">\r\n        <span class=\"delivery-type-only\">Your cart contains some items that are {{delivery.filteredInstoreItem ?\r\n          'in-store/curbside pickup' : 'delivery'}} only. If you would like to {{delivery.filteredInstoreItem ? 'have your\r\n          order delivered' : (!delivery.profile.store.isCurbsidePickup ? 'pick up your order in-store' : 'pick up your\r\n          order in-store/curbside')}}, please click <a href=\"#\" ng-click=\"delivery.navigateCart()\">here</a> and remove\r\n          those items or complete a separate order.</span>\r\n      </div>\r\n    </div>\r\n    <form name=\"OrderNotesFormMobile\">\r\n      <div class=\"row m-x-0 gray-bg p-b-1 mt-4 ng-scope\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      \r\n        <div class=\"col-xs-12 mt-8\">\r\n          <strong style=\"font-size: 16px;\">Order Notes <span style=\"font-size: 10px;\">Please provide any additional delivery\r\n              information here (gate access code, apartment number, etc.).</span> </strong>\r\n\r\n          <br>\r\n          <span ng-if=\"delivery.cartDetail.cartItems.length\">\r\n            <textarea class=\"orderNotes\" ng-pattern='delivery.ordernotesPattern' ng-model=\"delivery.orderNotes\" placeholder=\"Add a note...\" rows=4\r\n                      ng-change=\"delivery.orderNotesSession()\" name=\"orderNotesMobile\" cols=\"33\"> </textarea> \r\n            <div ng-show=\"OrderNotesFormMobile.orderNotesMobile.$invalid && OrderNotesFormMobile.orderNotesMobile.$error.pattern\">\r\n              <span style=\"color: red;\">Order notes only allows text, numbers and special characters</span>\r\n            </div>\r\n          </span>\r\n          <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"delivery.cartContainsOnlyGift()\">Please enter a shipping\r\n            address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store,\r\n            leave the Notes section blank.</p> -->\r\n        </div>\r\n      </div>\r\n    </form>\r\n    <div class=\"row m-x-0 gray-bg p-b-1 mt-4 ng-scope\"\r\n      ng-if=\"delivery.cartDetail.cartItems.length && !delivery.cartContainsOnlyGift()\">\r\n      <div class=\"col-xs-12 mt-8\">\r\n        <strong style=\"font-size: 16px;\">Bird Buck Code</strong>\r\n        <div ng-if=\"!delivery.profile.store.hasErply\">\r\n          <form name=\"mobileCouponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n            <div class=\"col-xs-9 p-l-0\"\r\n              ng-class=\"{'has-danger': (mobileCouponForm.$submitted || mobileCouponForm.mobileCouponNumber.$touched) && mobileCouponForm.mobileCouponNumber.$invalid}\">\r\n              <select name=\"mobileCouponNumber\" ng-model=\"delivery.mobileCouponNumber\" class=\"form-control\"\r\n                ng-change=\"delivery.checkBirdbuck(mobileCouponForm, delivery.mobileCouponNumber, true)\">\r\n                <option value=\"\">\r\n                  Select Coupon\r\n                </option>\r\n                <option ng-repeat=\"item in ( delivery.birdBucksList )\" value=\"{{item.couponID}}\">\r\n                  {{item.couponID}} - ${{item.dscAmount}}\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </form>\r\n        </div>\r\n\r\n        <!--  -->\r\n        <div ng-if=\"delivery.profile.store.hasErply\">\r\n          <form name=\"mobileCouponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n            <div class=\"col-xs-9\"\r\n              ng-class=\"{'has-danger': (mobileCouponForm.$submitted || mobileCouponForm.desktopCouponNumber.$touched) && mobileCouponForm.desktopCouponNumber.$invalid}\">\r\n              <div ng-dropdown-multiselect=\"\" options=\"delivery.erplyBirdBucksList\"\r\n                selected-model=\"delivery.example1model\" extra-settings=\"delivery.multiselect_checkbox\">\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-3 text-xs-right p-r-0\">\r\n              <button ng-click=\"delivery.applyDiscounts(false,true)\" class=\"btn btn-primary\">\r\n                Apply\r\n              </button>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n      <!--  -->\r\n\r\n      <div class=\"col-xs-12\">\r\n        <span ng-if=\"delivery.isCouponValid && !delivery.isTotalNegative\"\r\n          class=\"success-msg\">{{delivery.couponStatus}}</span>\r\n        <span ng-if=\"delivery.isCouponValid && delivery.isTotalNegative\"\r\n          class=\"failure-msg error-text\">{{delivery.couponStatus}}</span>\r\n        <span ng-if=\"!delivery.isCouponValid\" class=\"failure-msg error-text\">{{delivery.couponStatus}}</span>\r\n      </div>\r\n      <div class=\"col-xs-12\">\r\n        <small ng-if=\"!delivery.profile.store.hasErply\">Bird Buck Code is on the bottom of your coupon and starts with BB.\r\n          Bird Bucks generated in-store cannot be used online.</small>\r\n        <small ng-if=\"delivery.profile.store.hasErply\">Bird Buck Code.</small>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row m-x-0 gray-bg p-b-1 mt-4 ng-scope\"\r\n      ng-if=\"delivery.cartDetail.cartItems.length && !delivery.cartContainsOnlyGift()\">\r\n      <div class=\"col-xs-12 mt-8\">\r\n        <strong style=\"font-size: 16px;\">Promo Code</strong>\r\n        <br>\r\n\r\n        <form name=\"mobileDiscountCouponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n          <div class=\"col-xs-8 p-l-0\"\r\n            ng-class=\"{'has-danger': (mobileDiscountCouponForm.$submitted || mobileDiscountCouponForm.mobileDiscountCoupon.$touched) && mobileDiscountCouponForm.mobileDiscountCoupon.$invalid}\">\r\n            <input name=\"mobileDiscountCoupon\" type=\"text\" class=\"form-control\" ng-model=\"delivery.discountCouponCode\"\r\n              ng-maxlength=\"50\">\r\n            <div ng-messages=\"mobileDiscountCouponForm.mobileDiscountCoupon.$error\" class=\"form-control-feedback\"\r\n              ng-show=\"mobileDiscountCouponForm.mobileDiscountCoupon.$touched || mobileCouponForm.$submitted\">\r\n              <div ng-message=\"maxlength\">Maximum length should be 50</div>\r\n              <div class=\"error-text\"\r\n                ng-show=\"mobileDiscountCouponForm.errors.mobileDiscountCoupon && !mobileDiscountCouponForm.mobileDiscountCoupon.$error.required\">\r\n                {{mobileDiscountCouponForm.errors.mobileDiscountCoupon[0]}}\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-xs-4 text-xs-right p-r-0\" ng-if=\"delivery.profile.store.hasErply\">\r\n            <button ng-click=\"delivery.applyDiscounts(true,false)\" class=\"btn btn-primary\">\r\n              Apply\r\n            </button>\r\n          </div>\r\n\r\n          <div class=\"col-xs-4 text-xs-right p-r-0\" ng-if=\"!delivery.profile.store.hasErply\">\r\n            <button ng-click=\"delivery.checkDiscountCoupon(mobileDiscountCouponForm, delivery.discountCouponCode,true)\"\r\n              class=\"btn btn-primary\">\r\n              Apply\r\n            </button>\r\n          </div>\r\n        </form>\r\n      </div>\r\n      <div class=\"col-xs-12\" ng-if=\"delivery.profile.store.hasErply\">\r\n        <span ng-if=\"delivery.isErplyCampaignValid\" class=\"success-msg\">{{delivery.erplyCampaignStatus}}</span>\r\n        <span ng-if=\"!delivery.isErplyCampaignValid\"\r\n          class=\"failure-msg error-text\">{{delivery.erplyCampaignStatus}}</span>\r\n      </div>\r\n      <div class=\"col-xs-12\" ng-if=\"!delivery.profile.store.hasErply\">\r\n        <span ng-if=\"delivery.isDiscountCouponValid && !delivery.isDiscountTotalNegative &&!delivery.cError\"\r\n          class=\"success-msg\">{{delivery.discountCouponStatus}}</span>\r\n        <span ng-if=\"delivery.isDiscountCouponValid && (delivery.isDiscountTotalNegative||delivery.cError)\"\r\n          class=\"failure-msg error-text\">{{delivery.discountCouponStatus}}</span>\r\n        <span ng-if=\"!delivery.isDiscountCouponValid\"\r\n          class=\"failure-msg error-text\">{{delivery.discountCouponStatus}}</span>\r\n      </div>\r\n      <div class=\"col-xs-12\">\r\n        <small>Enter your Promo code for the discount on purchase amount</small>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Shipping address with change button -->\r\n    <div class=\"row m-x-0 p-t-1\" ng-if=\"delivery.mode == 'Next Day Delivery' && delivery.cartDetail.cartItems.length\">\r\n      <div class=\"col-sm-6 col-xs-8\">\r\n        <strong style=\"font-size: 18px;\">Shipping Address</strong>\r\n        <div class=\"m-b-0\">\r\n          <h6 class=\"m-b-0\">{{delivery.addressDetail.firstName}} {{delivery.addressDetail.lastName}}</h6>\r\n          <span ng-if=\"delivery.addressDetail.shippingAddressLine1\">\r\n            {{delivery.addressDetail.shippingAddressLine1}}\r\n            <span ng-if=\"delivery.addressDetail.shippingAddressLine2\">\r\n              , {{delivery.addressDetail.shippingAddressLine2}}\r\n            </span>\r\n          </span>\r\n          <br />\r\n          <span ng-if=\"delivery.addressDetail.shippingCountry\">\r\n            {{delivery.addressDetail.shippingCity}} {{delivery.addressDetail.shippingState.name}},\r\n            {{delivery.addressDetail.shippingCountry.countryCode}}\r\n            - {{delivery.addressDetail.shippingZipCode}}\r\n          </span>\r\n          <br />\r\n          <span class=\"primary-text font-weight-bold\">{{delivery.addressDetail.phoneNumber | telFormat}}</span>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6 col-xs-4 text-xs-right\">\r\n        <a href ng-click=\"delivery.changeAddress()\" class=\"btn btn-primary\">Change</a>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row m-x-0 p-l-1 p-t-1 error-text\"\r\n      ng-if=\"(delivery.mode == 'Next Day Delivery' && delivery.notDeliverable) && delivery.cartDetail.cartItems.length\">\r\n      <span ng-if=\"!delivery.isCallingAPI\">\r\n        <span ng-if=\"!showDefaultFedexErrorMessage\" ng-bind-html=\"delivery.$sce.trustAsHtml(delivery.fedexErrorMsg)\">\r\n        </span>\r\n        <span ng-if=\"showDefaultFedexErrorMessage\">\r\n          There seems to be a problem with your address.\r\n          <br /> Please check your entry. Contact the store for assistance at\r\n          <a class=\"blue-colored\"\r\n            href=\"tel:{{delivery.profile.store.phoneNumber}}\">{{delivery.profile.store.phoneNumber | telFormat}}</a>.\r\n        </span>\r\n        </span>\r\n    </div>\r\n\r\n    <!-- Quantity manipulation -->\r\n    <div class=\"row m-x-0 m-b-1\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      <div class=\"col-xs-12 p-x-0\">\r\n        <hr/>\r\n      </div>\r\n      <div class=\"col-xs-12\" ng-if=\"!delivery.profile.store.hasErply\">\r\n        <h5>Subtotal\r\n          <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (delivery.subtotal()  | number : 2)\"></span>\r\n        </h5>\r\n        <hr>\r\n      </div>\r\n\r\n\r\n      <div class=\"col-xs-12\" ng-if=\"delivery.profile.store.hasErply\">\r\n        <h5>Subtotal\r\n          <span class=\"pull-xs-right ng-cloak\"\r\n            ng-bind=\"'$' + (delivery.erplyShop.totalRetailPrice | number : 2)\"></span>\r\n        </h5>\r\n      </div>\r\n\r\n      \r\n\r\n      <div class=\"col-xs-12\" ng-if=\"!delivery.profile.store.hasErply && delivery.discountCouponAmount\">\r\n        <h5>Promo Code\r\n          <span class=\"pull-xs-right\">-${{delivery.discountCouponAmount | number : 2}}</span>\r\n        </h5>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12\" ng-if=\"delivery.profile.store.hasErply && delivery.erplyDis && delivery.erplyDis.length>0\">\r\n        <hr>\r\n        <h5>\r\n          <div class=\"m-b-1\" ng-repeat=\"item in delivery.erplyDis | orderBy: 'sortId'\">\r\n            <span >{{delivery.getAdjustedLabelName(item.key)}}\r\n              <span ng-if=\"item.key.length>delivery.promoLengthToBeShown\">\r\n                <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"delivery.infoPopupPromoNameonhover('desktop_delivery_popup_order',$index,null,item.key)\" ng-mouseleave=\"delivery.hideinfoPromoNamePopup('desktop_delivery_popup_order',$index,null,item.key)\"></i>\r\n                <div id=\"{{'desktop_delivery_popup_order'+$index+item.key}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                    {{item.key}}\r\n                </div>\r\n              </span>  \r\n            </span>\r\n            <span class=\"pull-xs-right\">-${{item.value | number : 2}}</span>\r\n          </div>\r\n        </h5>\r\n        <hr>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12\" ng-if=\"!delivery.profile.store.hasErply && delivery.couponAmount\">\r\n        <h5>Bird Buck Code\r\n          <span class=\"pull-xs-right\">-${{delivery.couponAmount | number : 2}}</span>\r\n        </h5>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12\"\r\n        ng-if=\"(delivery.getSelectedShipmentCharge() - delivery.getShippingDiscountCharge() === 0) && delivery.mode == 'Next Day Delivery'\">\r\n        <h5>FREE Shipping\r\n          <span class=\"pull-xs-right ng-cloak\">$0.00</span>\r\n        </h5>\r\n      </div>\r\n\r\n\r\n      <div class=\"col-xs-12\"\r\n        ng-if=\"delivery.getSelectedShipmentCharge() && (delivery.getSelectedShipmentCharge() - delivery.getShippingDiscountCharge() != 0) && delivery.mode == 'Next Day Delivery'\">\r\n        <h5>Shipping\r\n          <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (delivery.getSelectedShipmentCharge() | number : 2)\"></span>\r\n        </h5>\r\n      </div>\r\n      <div class=\"col-xs-12\"\r\n        ng-if=\"delivery.getShippingDiscountCharge() && (delivery.getSelectedShipmentCharge() - delivery.getShippingDiscountCharge() != 0)&& delivery.mode == 'Next Day Delivery'  && delivery.isShippingDiscountEligible()\">\r\n        <h5>Shipping Discount\r\n          <span class=\"pull-xs-right ng-cloak\"\r\n            ng-bind=\"'- $' + (delivery.getShippingDiscountCharge() | number : 2)\"></span>\r\n        </h5>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"col-xs-12\" ng-if=\"!delivery.profile.store.hasErply\">\r\n        <h5>Tax\r\n          <span class=\"pull-xs-right ng-cloak\"\r\n            ng-bind=\"'$' + (delivery.getTotalTax()-delivery.taxes.deliveryReceiptFee | number : 2)\"></span>\r\n        </h5>\r\n      </div>\r\n      <div class=\"col-xs-12\" ng-if=\"delivery.profile.store.hasErply\">\r\n        <h5>Tax\r\n          <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (delivery.erplyShop.totalTax | number : 2)\"></span>\r\n        </h5>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Buttons and Prices -->\r\n    <div class=\"row m-x-0 m-t-1 light-gray-bg m-b-2 pt-8 pb-8 p-x-1\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      <h3 class=\"font-weight-bold m-b-0 pt-4\">Total\r\n        <span ng-if=\"!delivery.profile.store.hasErply\">\r\n          <span class=\"pull-xs-right\" ng-bind=\"'$' + (delivery.getTotalAmount() | number : 2)\"></span>\r\n        </span>\r\n        <span ng-if=\"delivery.profile.store.hasErply\">\r\n          <span class=\"pull-xs-right\" ng-bind=\"'$' + (delivery.erplyShop.amountToPay | number : 2)\"></span>\r\n          <span>\r\n      </h3>\r\n      <!-- <div class=\"col-xs-4\">\r\n        <button type=\"button\" class=\"btn btn-primary btn-md-text\"\r\n          ng-click=\"delivery.submit()\">Confirm</button>\r\n        <div class=\"p-t-1\">\r\n          <a ui-sref=\"category\">\r\n            <button type=\"button\" class=\"btn btn-primary btn-md-text\">Continue Shopping</button>\r\n          </a>\r\n        </div>\r\n      </div> -->\r\n      <!--  <div class=\"col-xs-8 text-xs-right\">\r\n        <h3 class=\"primary-text font-weight-bold m-b-0 pt-4\">${{(delivery.getSelectedShipmentCharge() + delivery.totalPrice()) | number : 2}}</h3>\r\n        <h3 class=\"font-weight-bold m-b-0 pt-4\">Total\r\n          <span class=\"pull-xs-right\">${{delivery.getTotalAmount() | number : 2}}</span>\r\n        </h3>\r\n      </div> -->\r\n    </div>\r\n\r\n    <!-- <div class=\"row m-x-0 p-x-0 btn-product-detail\"\r\n      ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      <div class=\"col-xs-6 p-x-0\">\r\n        <button type=\"button\" class=\"btn btn-lg btn-primary btn-bdr btn-block\"\r\n          ng-disabled=\"(!delivery.charge.length) && delivery.mode !=='In Store Pickup'\"\r\n          ng-click=\"delivery.submit()\">\r\n            Proceed to Payment\r\n        </button>\r\n      </div>\r\n      <div class=\"col-xs-6 p-x-0\">\r\n        <a ui-sref=\"category\">\r\n          <button type=\"button\" class=\"btn btn-lg btn-primary btn-bdr btn-block\">Continue Shopping</button>\r\n        </a>\r\n      </div>\r\n    </div> -->\r\n\r\n    <div class=\"row m-x-0 p-x-0\" style=\"text-align: center\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n      <span class=\"giftOrder ng-cloak\" ng-if=\"delivery.profile.store.hasGiftOrder\">\r\n        <input type=\"checkbox\" name=\"isGiftOrder\" ng-model=\"delivery.isGiftOrder\"\r\n          class=\"form-control text-xs-left d-inline\" style=\"width: auto;\" required />\r\n        This order is a gift\r\n      </span>\r\n      <div class=\"mt-4 place_order_btn\">\r\n        <!-- <div ng-if=\"!delivery.cardInfo.length\" class=\"p-y-1\">\r\n          <input type=\"checkbox\"\r\n            name=\"agreement\"\r\n            ng-model=\"delivery.agreement\"\r\n            class=\"form-control text-xs-left d-inline\"\r\n            style=\"width: auto;\" />\r\n          <div class=\"d-inline\">\r\n            I agree to the <a ui-sref=\"terms-conditions\" class=\"link-text\">Terms and Conditions.</a>\r\n          </div>\r\n        </div> -->\r\n\r\n        <!-- ng-disabled=\"delivery.isSubmitting  || (!delivery.agreement && !delivery.cardInfo.length)\" -->\r\n\r\n        <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text\"\r\n          ng-disabled=\"(delivery.mode == '') || (delivery.mode =='Next Day Delivery' && delivery.notDeliverable) \r\n          || \r\n            (!delivery.profile.store.isInStorePickup? !(delivery.mode =='Next Day Delivery' || \r\n             (delivery.mode =='In Store Pickup' && delivery.isCurbside)) : false\r\n            )\r\n            ||\r\n            (!delivery.profile.store.isCurbsidePickup? !(delivery.mode =='Next Day Delivery' || \r\n             (delivery.mode =='In Store Pickup' && !delivery.isCurbside)) : false\r\n            )\r\n          || delivery.isCallingAPI || delivery.hasCartError \r\n          || (OrderNotesFormMobile.orderNotesMobile.$error.pattern && OrderNotesFormMobile.orderNotesMobile.$invalid)\"\r\n          ng-click=\"delivery.submit()\">Proceed to Payment\r\n        </button>\r\n      </div>\r\n      <div class=\"mt-4 place_order_btn\">\r\n        <a ui-sref=\"category\">\r\n          <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text\">Continue Shopping</button>\r\n        </a>\r\n      </div>\r\n      <div class=\"mt-4 place_order_btn\"\r\n        ng-show=\"delivery.isFreeShippingOfferAvailable() && !delivery.filteredInstoreItem\">\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='US'\"\r\n          ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n          <img ng-src={{delivery.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n          <span>Your order qualifies for\r\n            <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetail(true)\">\r\n              <u>\r\n                <b>FREE Shipping*</b>\r\n              </u>\r\n            </a>\r\n          </span>\r\n        </div>\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='CA'\"\r\n          ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n          <img ng-src={{delivery.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n          <span>Your order qualifies for\r\n            <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetailCan(true)\">\r\n              <u>\r\n                <b>FREE Shipping*</b>\r\n              </u>\r\n            </a>\r\n          </span>\r\n        </div>\r\n\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"!delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='US'\"\r\n          ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n          <img ng-src={{delivery.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n          <span>Add\r\n            <span class=\"shipping-offer-remaining-amount\">${{delivery.getFreeShippingRemainingAmount() | number : 2}}\r\n            </span>to your order to qualify for\r\n            <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetail(true)\">\r\n              <u>\r\n                <b>FREE Shipping*</b>\r\n              </u>\r\n            </a>\r\n          </span>\r\n        </div>\r\n\r\n        <div class=\"shipping-offer-banner bg-color\"\r\n          ng-show=\"!delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='CA'\"\r\n          ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n          <img ng-src={{delivery.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n          <span>Add\r\n            <span class=\"shipping-offer-remaining-amount\">${{delivery.getFreeShippingRemainingAmount() | number : 2}}\r\n            </span>to your order to qualify for\r\n            <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetail(true)\">\r\n              <u>\r\n                <b>FREE Shipping*</b>\r\n              </u>\r\n            </a>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row p-t-2 m-x-0\" ng-if=\"!delivery.cartDetail.cartItems.length\">\r\n      <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n        <h5 class=\"font-weight-bold\">Order doesn't exist</h5>\r\n        <p class=\"m-t-1\">Please add items in the cart</p>\r\n        <div class=\"m-t-3 p-t-3\">\r\n          <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"category\">Start New Order</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n<!-- DELIVERY PAGE FOR MD -->\r\n<div class=\"p-x-0 hidden-sm-down\">\r\n  \r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"delivery.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{delivery.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Checkout Details</span>\r\n  </nav>\r\n\r\n  <div class=\"row cart_header hidden-sm-down m-x-0 p-t-2 p-x-0\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n    <div class=\"col-md-12\">\r\n      <h4 class=\"font-weight-bold\">Choose How to Receive Your Order</h4>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Order doesn't exist -->\r\n  <div class=\"row p-t-2 m-x-0\" ng-if=\"!delivery.cartDetail.cartItems.length\">\r\n    <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n      <h5 class=\"font-weight-bold\">Order doesn't exist</h5>\r\n      <p class=\"m-t-1\">Please add items in the cart</p>\r\n      <div class=\"m-t-3 p-t-3\">\r\n        <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"category\">Start New Order</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- row after choose delivery mode -->\r\n  <div class=\"row p-x-0 m-x-0\" ng-if=\"delivery.cartDetail.cartItems.length\">\r\n\r\n    <!-- 8 column for delivery selection and product info -->\r\n    <div class=\"col-lg-8  col-md-7 delivery-mode-padding\">\r\n\r\n      <!-- Delivery selection & store -->\r\n      <div class=\"col-md-12 gray-bg delivery p-t-2\">\r\n        <div class=\"error-text\" style=\"    padding-bottom: 15px;   padding-left: 15px !important;\"\r\n          ng-show=\"!delivery.mode || delivery.mode == ''\">\r\n          Select one of the following options:\r\n        </div>\r\n        <!-- instore -->\r\n        <div class=\"col-xs-3 p-r-0\" ng-show=\"delivery.profile.store.isInStorePickup && !delivery.filteredDropShipItem\">\r\n          <div class=\"form-check\">\r\n            <label class=\"form-check-label\">\r\n              <input type=\"radio\" class=\"form-check-input\" ng-if=\"!delivery.isCurbside\" ng-model=\"delivery.mode\"\r\n                value=\"In Store Pickup\" ng-click=\"delivery.deliveryModechanges('In Store Pickup');\">\r\n              <input type=\"radio\" class=\"form-check-input\" ng-if=\"delivery.isCurbside\" ng-model=\"delivery.mode\"\r\n                value=\"In Store Pickup1\" ng-click=\"delivery.deliveryModechanges('In Store Pickup');\">\r\n              <span> In-store pickup. </span>\r\n              <p class=\"primary-text delivery-sub-text\" ng-if=\"!delivery.cartContainsOnlyDsc()\">\r\n                FROM STORE ABOVE\r\n              </p>\r\n              <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"delivery.cartContainsOnlyGift()\">Please enter a shipping address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store, leave the Notes section blank.</p> -->\r\n              <p class=\"primary-text delivery-sub-text\"\r\n                ng-if=\"delivery.mode === 'In Store Pickup' && delivery.holidays.length !== 0 && !delivery.cartContainsOnlyDsc()\">\r\n                CLOSED ON:\r\n                <span ng-repeat=\"item in delivery.holidays\" class=\"text-uppercase\">{{item.day | limitTo: 3 }}\r\n                  <span ng-hide=\"$last\">, </span>\r\n                </span>\r\n\r\n              </p>\r\n            </label>\r\n          </div>\r\n\r\n        </div>\r\n        <!-- curbside -->\r\n        <div class=\"col-xs-3 p-r-0\" ng-show=\"delivery.profile.store.isCurbsidePickup && !delivery.filteredDropShipItem\">\r\n          <div class=\"form-check\">\r\n            <label class=\"form-check-label\">\r\n              <input type=\"radio\" ng-if=\"!delivery.isCurbside\" class=\"form-check-input\" ng-model=\"delivery.mode\"\r\n                value=\"In Store Pickup1\" ng-click=\"delivery.deliveryModechanges('In Store Pickup', true);\">\r\n              <input type=\"radio\" ng-if=\"delivery.isCurbside\" class=\"form-check-input\" ng-model=\"delivery.mode\"\r\n                value=\"In Store Pickup\" ng-click=\"delivery.deliveryModechanges('In Store Pickup', true);\">\r\n              <span> Curbside pickup. </span>\r\n              <p class=\"primary-text delivery-sub-text\" ng-if=\"!delivery.cartContainsOnlyDsc()\">\r\n                FROM STORE ABOVE\r\n              </p>\r\n              <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"delivery.cartContainsOnlyGift()\">Please enter a shipping address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store, leave the Notes section blank.</p> -->\r\n              <p class=\"primary-text delivery-sub-text\"\r\n                ng-if=\"delivery.mode === 'In Store Pickup' && delivery.holidays.length !== 0 && !delivery.cartContainsOnlyDsc()\">\r\n                CLOSED ON:\r\n                <span ng-repeat=\"item in delivery.holidays\" class=\"text-uppercase\">{{item.day | limitTo: 3 }}\r\n                  <span ng-hide=\"$last\">, </span>\r\n                </span>\r\n\r\n              </p>\r\n            </label>\r\n          </div>\r\n\r\n        </div>\r\n        <!--\r\n        <div class=\"col-xs-4 p-r-0\">\r\n          <div class=\"form-check\">\r\n            <label class=\"form-check-label\"\r\n              ng-class=\"!delivery.calculateSameDay() || !delivery.charge.length ? 'disabled' : ''\">\r\n              <input type=\"radio\" class=\"form-check-input\"\r\n                ng-model=\"delivery.mode\" value=\"Same Day Delivery\"\r\n                ng-disabled=\"!delivery.calculateSameDay() || !delivery.charge.length\">\r\n              <span> Same Day Delivery </span>\r\n              <p class=\"primary-text delivery-sub-text\"\r\n                ng-if=\"delivery.getSameDayCharge()\">\r\n                SHIPPING COST: ${{delivery.getSameDayCharge() | number : 2}}\r\n              </p>\r\n            </label>\r\n          </div>\r\n          \r\n          \r\n          <h6 class=\"text-xs-left delivery-info-text-md\">\r\n            <span ng-if=\"delivery.mode === 'Same Day Delivery'\">Estimated Delivery by {{delivery.calculateSameDay()}}</span>\r\n          </h6>\r\n        </div> -->\r\n        <div class=\"col-xs-6 p-r-0\" ng-if=\"!delivery.filteredInstoreItem\">\r\n          <!-- Next day delivery -->\r\n          <div class=\"form-check\">\r\n            <label class=\"form-check-label\" ng-class=\"delivery.cartContainsOnlyDsc() ? 'disabled' : ''\">\r\n              <input type=\"radio\" class=\"form-check-input\" ng-model=\"delivery.mode\" value=\"Next Day Delivery\"\r\n                ng-disabled=\"delivery.cartContainsOnlyDsc()\" ng-click=\"delivery.resetDeliveryMode('Next Day Delivery');\"\r\n                ng-change=\"delivery.deliveryModechanges('Next Day Delivery');delivery.resetCouponValues(); delivery.getTax();\">\r\n              <span>Please ship my order.\r\n                <br>\r\n                <span style=\"font-size: 10px;position: relative;top: -5px !important;\">(Ground shipping is typically 2-5\r\n                  business days)</span>\r\n              </span>\r\n              <p class=\"primary-text delivery-sub-text1\"\r\n                ng-if=\"delivery.charge.length && delivery.getNextDayCharge() && !delivery.cartContainsOnlyDsc()\">\r\n                SHIPPING COST: ${{delivery.getNextDayCharge() | number : 2}}\r\n              </p>\r\n\r\n\r\n            </label>\r\n          </div>\r\n\r\n          <div class=\"zone-charge\" ng-if=\"delivery.mode == 'Next Day Delivery' && !delivery.cartContainsOnlyGift()\">\r\n            <table class=\"table table-sm\">\r\n              <thead>\r\n                <tr>\r\n                  <th>Shipping</th>\r\n\r\n                  <th>\r\n                    <center>{{delivery.zoneDeliveryCharges[0].distanceRange}} </center>\r\n                    <center>\r\n                      <span ng-if=\"delivery.profile.store.country.countryCode=='US'\">Miles</span>\r\n                    </center>\r\n                  </th>\r\n                  <th>\r\n                    <center>{{delivery.zoneDeliveryCharges[1].distanceRange}} </center>\r\n                    <center>\r\n                      <span ng-if=\"delivery.profile.store.country.countryCode=='US'\">Miles</span>\r\n                    </center>\r\n                  </th>\r\n                  <th>\r\n                    <center>{{delivery.zoneDeliveryCharges[2].distanceRange}} </center>\r\n                    <center>\r\n                      <span ng-if=\"delivery.profile.store.country.countryCode=='US'\">Miles</span>\r\n                    </center>\r\n                  </th>\r\n\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr>\r\n                  <td>Shipping Cost</td>\r\n                  <td>\r\n                    <center>${{delivery.zoneDeliveryCharges[0].nextDayCharge}}</center>\r\n                  </td>\r\n                  <td>\r\n                    <center>${{delivery.zoneDeliveryCharges[1].nextDayCharge}}</center>\r\n                  </td>\r\n                  <td>\r\n                    <center>${{delivery.zoneDeliveryCharges[2].nextDayCharge}}</center>\r\n                  </td>\r\n\r\n                </tr>\r\n                <tr ng-show=\"delivery.isFreeShippingOfferAvailable() && delivery.shippingOffer.isOfferEligible\">\r\n\r\n                  <td>Shipping Discount</td>\r\n                  <td>\r\n                    <center>-${{delivery.getShippingDiscountCharge() | number : 2}}</center>\r\n                  </td>\r\n                  <td>\r\n                    <center>-${{delivery.getShippingDiscountCharge() | number : 2}}</center>\r\n                  </td>\r\n                  <td>\r\n                    <center>-${{delivery.getShippingDiscountCharge() | number : 2}}</center>\r\n                  </td>\r\n\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <!--     &lt;!&ndash;<table class=\"table table-sm\">\r\n              <thead>\r\n                <tr>\r\n                  <th>Zone</th>\r\n                  <th>Distance (mi)</th>\r\n                  <th>Up to 70 lbs</th>\r\n                  <th>Above 70 lbs</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"zoneData in delivery.zoneDeliveryCharges\">\r\n                  <td ng-bind=\"zoneData.zone\"></td>\r\n                  <td ng-bind=\"zoneData.distanceRange\"></td>\r\n                  <td ng-bind=\"zoneData.nextDayCharge\"></td>\r\n                  <td ng-bind=\"zoneData.nextDayChargeover70lbs\"></td>\r\n                </tr>\r\n              </tbody>\r\n            </table>&ndash;&gt;-->\r\n          </div>\r\n\r\n          <!-- next day check -->\r\n          <!-- <h6 class=\"text-xs-left delivery-info-text-md\">\r\n            <span ng-if=\"delivery.mode === 'Next Day Delivery'\">Estimated Delivery by {{delivery.calculateNextDay()}}</span>\r\n          </h6> -->\r\n        </div>\r\n        <div class=\"col-xs-6 p-r-0\" ng-if=\"delivery.filteredInstoreItem || delivery.filteredDropShipItem\">\r\n          <span class=\"delivery-type-only\">Your cart contains some items that are {{delivery.filteredInstoreItem ?\r\n            'in-store/curbside pickup' : 'delivery'}} only. If you would like to {{delivery.filteredInstoreItem ? 'have\r\n            your order delivered' : (!delivery.profile.store.isCurbsidePickup ? 'pick up your order in-store' : 'pick up\r\n            your order in-store/curbside')}}, please click <a href=\"#\" ng-click=\"delivery.navigateCart()\">here</a> and\r\n            remove those items or complete a separate order.</span>\r\n        </div>\r\n        <div class=\"col-xs-12\">\r\n          <!-- instore check -->\r\n          <h6 class=\"text-xs-left delivery-info-text-md\" ng-if=\"!delivery.cartContainsOnlyDsc()\">\r\n            <span\r\n              ng-if=\"delivery.mode === 'In Store Pickup' && (delivery.profile.store.showOrderReadyTime && !delivery.noTimeForOrderReadyBy)\">Order\r\n              Ready by {{delivery.calculateInStorePick()}} (Store Local Time)</span>\r\n            <span\r\n              ng-if=\"delivery.mode === 'In Store Pickup' && (!delivery.profile.store.showOrderReadyTime || delivery.noTimeForOrderReadyBy)\">We\r\n              will let you know when your order is ready.</span>\r\n          </h6>\r\n        </div>\r\n\r\n      </div>\r\n\r\n\r\n      <!-- Address -->\r\n      <div class=\"col-xs-12 p-b-2 p-t-2 m-x-0 p-x-0\" ng-if=\"delivery.mode == 'Next Day Delivery'\">\r\n        <div class=\"col-xs-8 p-x-0\">\r\n          <strong style=\"font-size: 18px;\">Shipping Address</strong>\r\n          <p class=\"m-b-0 home-tab-text\">\r\n          <h6 class=\"m-b-0\">{{delivery.addressDetail.firstName}} {{delivery.addressDetail.lastName}}</h6>\r\n          <span ng-if=\"delivery.addressDetail.shippingAddressLine1\">\r\n            {{delivery.addressDetail.shippingAddressLine1}}\r\n          </span>\r\n          <span ng-if=\"delivery.addressDetail.shippingAddressLine2\">\r\n            , {{delivery.addressDetail.shippingAddressLine2}}\r\n          </span>\r\n          <br />\r\n          <span ng-if=\"delivery.addressDetail.shippingCountry\">\r\n            {{delivery.addressDetail.shippingCity}} {{delivery.addressDetail.shippingState.name}},\r\n            {{delivery.addressDetail.shippingCountry.countryCode}}\r\n            {{delivery.addressDetail.shippingZipCode}}\r\n          </span>\r\n          <br />\r\n          <span class=\"primary-text font-weight-bold\">{{delivery.addressDetail.phoneNumber | telFormat}}</span>\r\n          </p>\r\n        </div>\r\n        <div class=\"col-xs-4 p-x-0 text-xs-right\">\r\n          <a href ng-click=\"delivery.changeAddress()\" class=\"btn btn-primary\">Change</a>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row m-x-0 p-l-1 p-t-1 error-text\"\r\n        ng-if=\"delivery.mode == 'Next Day Delivery' && delivery.notDeliverable\">\r\n        <span ng-if=\"!delivery.isCallingAPI\">\r\n            <span ng-if=\"!delivery.showDefaultFedexErrorMessage\"\r\n            ng-bind-html=\"delivery.$sce.trustAsHtml(delivery.fedexErrorMsg)\">\r\n            </span>\r\n            <span ng-if=\"delivery.showDefaultFedexErrorMessage\">\r\n              There seems to be a problem with your address.\r\n              <br /> Please check your entry. Contact the store for assistance at\r\n              <a class=\"blue-colored\"\r\n                href=\"tel:{{delivery.profile.store.phoneNumber}}\">{{delivery.profile.store.phoneNumber | telFormat}}</a>.\r\n            </span>\r\n          </span>\r\n      </div>\r\n      <form name=\"OrderNotesDesktopForm\">\r\n        <!-- <div ng-class=\"delivery.cartContainsOnlyGift()?'p-t-0':'p-t-2'\" class=\"col-xs-12 p-b-1 ng-scope p-x-0\"> -->\r\n        <div class=\"col-xs-12 p-b-1 ng-scope p-x-0 p-t-2\">\r\n            <strong style=\"font-size: 18px;\">Order Notes <span style=\"font-size: 11px;\">Please provide any additional\r\n                delivery information here (gate access code, apartment number, etc.).</span></strong>\r\n            <br>\r\n            <div class=\"col-md-12 gray-bg delivery p-b-2 p-t-2 m-x-0\">\r\n              <div class=\"col-md-5\">\r\n                <span ng-if=\"delivery.cartDetail.cartItems.length\">\r\n                  <textarea class=\"orderNotes\" ng-pattern='delivery.ordernotesPattern' ng-model=\"delivery.orderNotes\" placeholder=\"Add a note...\" rows=4\r\n                    ng-change=\"delivery.orderNotesSession()\" name=\"orderNotesDesktop\" cols=\"33\"> </textarea> \r\n                    <div ng-show=\"OrderNotesDesktopForm.orderNotesDesktop.$invalid && OrderNotesDesktopForm.orderNotesDesktop.$error.pattern\">\r\n                      <span style=\"color: red;\">Order notes only allows Text, Numbers and Special characters</span>\r\n                  </div> \r\n                  </span>\r\n              </div>\r\n              <div class=\"col-md-7 only_gift_cards\">\r\n                <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"delivery.cartContainsOnlyGift()\">Please enter a\r\n                  shipping address in the Notes section, and we will mail free of charge. If you prefer to pick\r\n                  up in-store, leave the Notes section blank.</p> -->\r\n              </div>\r\n            </div>\r\n        </div>\r\n      </form>\r\n      <div class=\"col-xs-6 col-lg-6 col-md-12 p-b-1 p-t-2 ng-scope p-l-0 p-r-0-md\"\r\n        ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n        <strong style=\"font-size: 18px;\">Bird Buck Code</strong>\r\n        <br>\r\n\r\n\r\n        <div class=\"col-md-12 gray-bg delivery p-b-2 p-t-2 m-x-0\" ng-if=\"!delivery.profile.store.hasErply\">\r\n          <form name=\"couponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n            <div class=\"col-sm-9\"\r\n              ng-class=\"{'has-danger': (couponForm.$submitted || couponForm.desktopCouponNumber.$touched) && couponForm.desktopCouponNumber.$invalid}\">\r\n              <select name=\"desktopCouponNumber\" ng-model=\"delivery.desktopCouponNumber\" class=\"form-control fontSize\"\r\n                ng-change=\"delivery.checkBirdbuck(couponForm, delivery.desktopCouponNumber, true)\">\r\n                <option value=\"\">\r\n                  Select Coupon\r\n                </option>\r\n                <option ng-repeat=\"item in ( delivery.birdBucksList )\" value=\"{{item.couponID}}\">\r\n                  {{item.couponID}} - ${{item.dscAmount}}\r\n                </option>\r\n              </select>\r\n            </div>\r\n            <div class=\"col-sm-12\">\r\n              <span ng-if=\"delivery.isCouponValid && !delivery.isTotalNegative\"\r\n                class=\"success-msg\">{{delivery.couponStatus}}</span>\r\n              <span ng-if=\"delivery.isCouponValid && delivery.isTotalNegative\"\r\n                class=\"failure-msg error-text\">{{delivery.couponStatus}}</span>\r\n              <span ng-if=\"delivery.isCouponValid === false\"\r\n                class=\"failure-msg error-text\">{{delivery.couponStatus}}</span>\r\n            </div>\r\n          </form>\r\n        </div>\r\n\r\n        <!-- Erply BirdBuck -->\r\n        <div class=\"col-md-12 gray-bg delivery p-b-2 p-t-2 m-x-0\" ng-if=\"delivery.profile.store.hasErply\">\r\n          <form name=\"couponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n            <div class=\"col-sm-8\"\r\n              ng-class=\"{'has-danger': (couponForm.$submitted || couponForm.desktopCouponNumber.$touched) && couponForm.desktopCouponNumber.$invalid}\">\r\n              <div ng-dropdown-multiselect=\"\" options=\"delivery.erplyBirdBucksList\"\r\n                selected-model=\"delivery.example1model\" extra-settings=\"delivery.multiselect_checkbox\"></div>\r\n            </div>\r\n            <div class=\"col-xs-3 text-xs-right p-r-0\">\r\n              <button ng-click=\"delivery.applyDiscounts(false,true)\" class=\"btn btn-primary\">\r\n                Apply\r\n              </button>\r\n            </div>\r\n            <div class=\"col-sm-12\">\r\n              <span ng-if=\"delivery.isCouponValid && !delivery.isTotalNegative\"\r\n                class=\"success-msg\">{{delivery.couponStatus}}</span>\r\n              <span ng-if=\"delivery.isCouponValid && delivery.isTotalNegative\"\r\n                class=\"failure-msg error-text\">{{delivery.couponStatus}}</span>\r\n              <span ng-if=\"delivery.isCouponValid === false\"\r\n                class=\"failure-msg error-text\">{{delivery.couponStatus}}</span>\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <!--  -->\r\n        <div style=\"min-height: 40px\">\r\n          <small ng-if=\"!delivery.profile.store.hasErply\">Bird Buck Code is on the bottom of your coupon and starts with\r\n            BB. Bird Bucks generated in-store cannot be used online. </small>\r\n          <small ng-if=\"delivery.profile.store.hasErply\">Bird Buck Code.</small>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-6 col-lg-6 col-md-12 p-b-1 p-t-2 ng-scope p-r-0 p-l-0-md\"\r\n        ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n        <strong style=\"font-size: 18px;\">Promo Code</strong>\r\n        <br>\r\n\r\n        <div class=\"col-md-12 gray-bg delivery p-b-2 p-t-2 m-x-0\">\r\n          <form name=\"discountCouponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n            <div class=\"col-sm-8\"\r\n              ng-class=\"{'has-danger': (discountCouponForm.$submitted || discountCouponForm.discountCouponCode.$touched) && discountCouponForm.discountCouponCode.$invalid}\">\r\n              <input name=\"discountCouponCode\" type=\"text\" class=\"form-control\" ng-model=\"delivery.discountCouponCode\"\r\n                ng-maxlength=\"50\" />\r\n              <div ng-messages=\"discountCouponForm.discountCouponCode.$error\" class=\"form-control-feedback\"\r\n                ng-show=\"discountCouponForm.discountCouponCode.$touched || discountCouponForm.$submitted\">\r\n                <div ng-message=\"maxlength\">Maximum length should be 50</div>\r\n                <div class=\"error-text\"\r\n                  ng-show=\"discountCouponForm.errors.discountCouponCode && !discountCouponForm.discountCouponCode.$error.required\">\r\n                  {{discountCouponForm.errors.discountCouponCode[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-4\" ng-if=\"delivery.profile.store.hasErply\">\r\n              <button ng-click=\"delivery.applyDiscounts(true,false)\" class=\"btn btn-primary btn-md-text\">Apply</button>\r\n            </div>\r\n            <div class=\"col-sm-12\" ng-if=\"delivery.profile.store.hasErply\">\r\n              <span ng-if=\"delivery.isErplyCampaignValid\" class=\"success-msg\">{{delivery.erplyCampaignStatus}}</span>\r\n              <span ng-if=\"!delivery.isErplyCampaignValid\"\r\n                class=\"failure-msg error-text\">{{delivery.erplyCampaignStatus}}</span>\r\n            </div>\r\n            <div ng-if=\"!delivery.profile.store.hasErply\">\r\n              <div class=\"col-sm-4\">\r\n                <button ng-click=\"delivery.checkDiscountCoupon(discountCouponForm, delivery.discountCouponCode,true)\"\r\n                  class=\"btn btn-primary btn-md-text\">Apply</button>\r\n              </div>\r\n              <div class=\"col-sm-12\">\r\n                <span ng-if=\"delivery.isDiscountCouponValid && !delivery.isDiscountTotalNegative && !delivery.cError\"\r\n                  class=\"success-msg\">{{delivery.discountCouponStatus}}</span>\r\n                <span ng-if=\"delivery.isDiscountCouponValid && (delivery.isDiscountTotalNegative ||delivery.cError)\"\r\n                  class=\"failure-msg error-text\">{{delivery.discountCouponStatus}}</span>\r\n                <span ng-if=\"delivery.isDiscountCouponValid === false\"\r\n                  class=\"failure-msg error-text\">{{delivery.discountCouponStatus}}</span>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <div style=\"min-height: 40px\">\r\n          <small>Enter your Promo code for the discount on purchase amount</small>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- products in cart -->\r\n      <!-- <div class=\"col-md-12 m-x-0 m-t-2 m-b-2\" ng-if=\"delivery.cartDetail.cartItems.length\" ng-repeat=\"item in delivery.cartDetail.cartItems\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-8 p-r-0\">\r\n            <div class=\"media\">\r\n              <div class=\"media-left media-middle\">\r\n                <a>\r\n                  <img img-lazy-loader=\"{{item.item.smallImageUrl}}\" width=\"70px\" class=\"media-object product-thumbnail\">\r\n                </a>\r\n              </div>\r\n              <div class=\"media-body\">\r\n                <h5>\r\n                  <strong ng-bind=\"item.item.name\"></strong>\r\n                  <p ng-bind=\"item.item.subCategory.name\"></p>\r\n                </h5>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-xs-4 text-xs-right\">\r\n            <p class=\"m-b-0\">Qty: {{item.quantity}}</p>\r\n            <p class=\"m-b-0\">Wt: {{item.item.weight}} lbs</p>\r\n          </div>\r\n        </div>\r\n      </div> -->\r\n    </div>\r\n\r\n    <!-- Prices -->\r\n    <div class=\"col-lg-4 col-md-5 p-y-2 p-r-2\">\r\n      <!-- DSC Points and total price -->\r\n      <div class=\"col-xs-12\">\r\n\r\n        <div class=\"div_border m-x-0 p-x-0\">\r\n          <div class=\"border_pdding\">\r\n            <h5 class=\"font-weight-bold m-y-1\">Order Detail\r\n            </h5>\r\n            <!-- <h6 class=\"m-b-1\" ng-if=\"delivery.isDscMember()\">\r\n              <span>Club Points</span>\r\n              <span class=\"pull-xs-right\">{{delivery.getDSCPoints() | number : 0}}</span>\r\n            </h6>\r\n            <h6 class=\"m-b-1\" ng-if=\"delivery.isDscButExpired()\">\r\n              <span>Club Points</span>\r\n              <span class=\"pull-xs-right\"><s uib-tooltip=\"Your Club Membership has expired\">{{delivery.getDSCPoints() | number : 0}}</s></span>\r\n            </h6> -->\r\n            <h6 class=\"m-b-1\">\r\n              <div ng-if=\"!delivery.profile.store.hasErply\">\r\n                <span>Subtotal</span>\r\n                <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (delivery.subtotal() | number : 2)\"></span>\r\n              </div>\r\n              <div ng-if=\"delivery.profile.store.hasErply\">\r\n                <span>Subtotal</span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.erplyShop.totalRetailPrice | number : 2)\"></span>\r\n              </div>\r\n              <hr ng-if=\"delivery.mode !== ''\">\r\n            </h6>\r\n            <div ng-if=\"!delivery.profile.store.hasErply\">\r\n              <h6 class=\"m-b-1\" ng-if=\"!delivery.profile.store.hasErply && delivery.discountCouponAmount\">\r\n                <span>Promo Code</span>\r\n                <span class=\"pull-xs-right\">-${{delivery.discountCouponAmount | number : 2}}</span>\r\n              </h6>\r\n              <h6 class=\"m-b-1\" ng-if=\"!delivery.profile.store.hasErply && delivery.couponAmount\">\r\n                <span>Bird Buck Code</span>\r\n                <span class=\"pull-xs-right\">-${{delivery.couponAmount | number : 2}}</span>\r\n              </h6>\r\n              <hr ng-if=\"delivery.mode !== ''\">\r\n            </div>\r\n            <div ng-if=\"delivery.profile.store.hasErply\">\r\n              <h6 ng-if=\"delivery.erplyDis && delivery.erplyDis.length>0\">\r\n                <div class=\"m-b-1\" ng-repeat=\"item in delivery.erplyDis | orderBy: 'sortId'\">\r\n                  <span >{{delivery.getAdjustedLabelName(item.key)}}\r\n                    <span ng-if=\"item.key.length>delivery.promoLengthToBeShown\">\r\n                      <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"delivery.infoPopupPromoNameonhover('mobile_delivery_popup_order',$index,null,item.key)\" ng-mouseleave=\"delivery.hideinfoPromoNamePopup('mobile_delivery_popup_order',$index,null,item.key)\"></i>\r\n                      <div id=\"{{'mobile_delivery_popup_order'+$index+item.key}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                          {{item.key}}\r\n                      </div>\r\n                    </span>  \r\n                  </span>\r\n                  <span class=\"pull-xs-right\">-${{item.value | number : 2}}</span>\r\n                </div>\r\n              </h6>\r\n              <hr ng-if=\"delivery.mode !== '' && delivery.erplyDis && delivery.erplyDis.length>0\">\r\n            </div>\r\n\r\n\r\n\r\n            <h6 class=\"m-b-1\"\r\n              ng-if=\"(delivery.getSelectedShipmentCharge() - delivery.getShippingDiscountCharge() === 0) && delivery.mode == 'Next Day Delivery'\">\r\n              <span>FREE Shipping</span>\r\n              <span class=\"pull-xs-right ng-cloak\">$0.00</span>\r\n            </h6>\r\n            <h6 class=\"m-b-1\"\r\n              ng-if=\"delivery.getSelectedShipmentCharge() && (delivery.getSelectedShipmentCharge() - delivery.getShippingDiscountCharge() != 0) && delivery.mode == 'Next Day Delivery'\">\r\n              <div ng-if=\"!delivery.profile.store.hasErply\">\r\n                <span>Shipping</span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.getSelectedShipmentCharge() | number : 2)\"></span>\r\n              </div>\r\n              <div ng-if=\"delivery.profile.store.hasErply\">\r\n                <span>Shipping</span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.erplyShop.shippingCharge | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n            <h6 class=\"m-b-1\"\r\n              ng-if=\"delivery.getShippingDiscountCharge() && (delivery.getSelectedShipmentCharge() - delivery.getShippingDiscountCharge() != 0) && delivery.mode == 'Next Day Delivery'  && delivery.isShippingDiscountEligible()\">\r\n              <span>Shipping Discount </span>\r\n              <span class=\"pull-xs-right ng-cloak\"\r\n                ng-bind=\"'-$' + (delivery.getShippingDiscountCharge() | number : 2)\"></span>\r\n            </h6>\r\n            <h6 class=\"m-b-1\">\r\n              <div ng-if=\"!delivery.profile.store.hasErply && delivery.taxes.deliveryReceiptFee>0\">\r\n                <span style=\"display: inline-flex;\">Retail Delivery Fee\r\n                  <div style=\"position: relative;\">\r\n                    <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"delivery.infoPopup()\"></i>\r\n                    <div id=\"popup\" style=\"display: none; position: absolute;\" class=\"popup-info\"\r\n                      ng-mouseenter=\"delivery.infoPopuponhover()\" ng-mouseleave=\"delivery.hideinfoPopup()\">\r\n                      *The state of Colorado requires a Retail Delivery Fee and any applicable taxes may be applied. For\r\n                      more information about the fee please visit <br /><a target=\"_blank\"\r\n                        href=\"https://tax.colorado.gov/retail-delivery-fee\"><span\r\n                          class=\"tax-link\">https://tax.colorado.gov/retail-delivery-fee</span></a>\r\n                    </div>\r\n                  </div>\r\n                </span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.taxes.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n              <div ng-if=\"delivery.profile.store.hasErply && delivery.erplyShop.deliveryReceiptFee>0\">\r\n                <span style=\"display: inline-flex;\">Retail Delivery Fee\r\n                  <div style=\"position: relative;\">\r\n                    <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"delivery.infoPopupFee()\"></i>\r\n                    <div id=\"popup1\" style=\"display: none; position: absolute;\" class=\"popup-info\"\r\n                      ng-mouseenter=\"delivery.infoPopuponhoverFee()\" ng-mouseleave=\"delivery.hideinfoPopupFee()\">\r\n                      *The state of Colorado requires a Retail Delivery Fee and any applicable taxes may be applied. For\r\n                      more information about the fee please visit <br /><a target=\"_blank\"\r\n                        href=\"https://tax.colorado.gov/retail-delivery-fee\"><span\r\n                          class=\"tax-link\">https://tax.colorado.gov/retail-delivery-fee</span></a>\r\n                    </div>\r\n                  </div>\r\n                </span>\r\n                <!-- <i class=\"fa fa-info-circle\" title=\"On July 1, 2022 the state of Colorado imposed a $0.27 retail delivery fee on all deliveries by motor vehicle to a location in Colorado with at least one item of tangible personal property subject to state sales and use tax.\"></i> -->\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.erplyShop.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n            <h6 class=\"m-b-1\">\r\n              <div ng-if=\"!delivery.profile.store.hasErply\">\r\n                <span>Tax</span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.getTotalTax()-delivery.taxes.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n              <div ng-if=\"delivery.profile.store.hasErply\">\r\n                <span>Tax</span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.erplyShop.totalTax-delivery.erplyShop.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n          </div>\r\n          <!-- total prices -->\r\n          <div class=\"gray-bg p-a-1\">\r\n            <h3 class=\"font-weight-bold m-b-0\">\r\n              <div ng-if=\"!delivery.profile.store.hasErply\">Total\r\n                <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (delivery.getTotalAmount() | number : 2)\"></span>\r\n              </div>\r\n              <div ng-if=\"delivery.profile.store.hasErply\">Total\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (delivery.erplyShop.amountToPay | number : 2)\"></span>\r\n              </div>\r\n            </h3>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Confirm Button -->\r\n        <!-- <div class=\"col-md-12 p-x-0 mt-4\">\r\n          <button type=\"button\" class=\"btn btn-primary btn-md-text btn-block\"\r\n            ng-click=\"delivery.submit()\" \r\n            ng-disabled=\"(!delivery.charge.length) && delivery.mode !=='In Store Pickup'\">\r\n            Proceed to Payment\r\n          </button>\r\n          <div class=\"mt-4\">\r\n            <a ui-sref=\"category\">\r\n              <button type=\"button\" class=\"btn btn-primary btn-md-text btn-block\">Continue Shopping</button>\r\n            </a>\r\n          </div>  \r\n      </div> -->\r\n\r\n        <div class=\"col-md-12 p-x-0 mt-4\" style=\"text-align: center\">\r\n          <span class=\"giftOrder ng-cloak\" ng-if=\"delivery.profile.store.hasGiftOrder\">\r\n            <input type=\"checkbox\" name=\"isGiftOrder\" ng-model=\"delivery.isGiftOrder\"\r\n              class=\"form-control text-xs-left d-inline\" style=\"width: auto;\" required />\r\n            This order is a gift\r\n          </span>\r\n          <!--  <div ng-if=\"!delivery.cardInfo.length\" class=\"p-y-1\">\r\n          <input type=\"checkbox\"\r\n            name=\"agreement\"\r\n            ng-model=\"delivery.agreement\"\r\n            class=\"form-control text-xs-left d-inline\"\r\n            style=\"width: auto;\" />\r\n          <div class=\"d-inline\">\r\n            I agree to the <a ui-sref=\"terms-conditions\" class=\"link-text\">Terms and Conditions.</a>\r\n          </div>\r\n        </div> -->\r\n\r\n          <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text\"\r\n            ng-disabled=\" (delivery.mode == '') \r\n            || (delivery.mode =='Next Day Delivery' && delivery.notDeliverable)\r\n            || \r\n            (!delivery.profile.store.isInStorePickup? !(delivery.mode =='Next Day Delivery' || \r\n             (delivery.mode =='In Store Pickup' && delivery.isCurbside)) : false\r\n            )\r\n            ||\r\n            (!delivery.profile.store.isCurbsidePickup? !(delivery.mode =='Next Day Delivery' || \r\n             (delivery.mode =='In Store Pickup' && !delivery.isCurbside)) : false\r\n            )\r\n            || delivery.isCallingAPI || delivery.hasCartError\r\n            || (OrderNotesDesktopForm.orderNotesDesktop.$invalid && OrderNotesDesktopForm.orderNotesDesktop.$error.pattern)\"\r\n            ng-click=\"delivery.submit()\">Proceed to Payment\r\n          </button>\r\n\r\n          <div class=\"mt-4\">\r\n            <a ui-sref=\"category\">\r\n              <button type=\"button\" class=\"btn btn-primary btn-md-text btn-block\">Continue Shopping</button>\r\n            </a>\r\n          </div>\r\n          <div class=\"mt-4 place_order_btn\"\r\n            ng-show=\"delivery.isFreeShippingOfferAvailable() && !delivery.filteredInstoreItem\">\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='US'\"\r\n              ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{delivery.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Your order qualifies for\r\n                <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetail(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='CA'\"\r\n              ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{delivery.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Your order qualifies for\r\n                <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetailCan(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"!delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='US'\"\r\n              ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{delivery.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Add\r\n                <span class=\"shipping-offer-remaining-amount\">$\r\n                  {{delivery.getFreeShippingRemainingAmount() | number : 2}} </span>to your order to qualify for\r\n                <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetail(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"!delivery.shippingOffer.isOfferEligible && delivery.cartDetail.user.store.country.countryCode =='CA'\"\r\n              ng-if=\"!delivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{delivery.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Add\r\n                <span class=\"shipping-offer-remaining-amount\">$\r\n                  {{delivery.getFreeShippingRemainingAmount() | number : 2}} </span>to your order to qualify for\r\n                <a class=\"blue-colored\" href ng-click=\"delivery.showFreeShippingOfferDetailCan(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* File: delivery.js
	                                   * -----------------
	                                   * File calculates the distances from Google APIs and accordingly gives the
	                                   * user option for selecting delivery option and also calcualtes the prices
	                                   * and various times for the delivery.
	                                   */
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _alert = __webpack_require__(192);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _guestDelivery = __webpack_require__(210);
	
	var _guestDelivery2 = _interopRequireDefault(_guestDelivery);
	
	var _shippingInfo = __webpack_require__(201);
	
	var _shippingInfo2 = _interopRequireDefault(_shippingInfo);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	var _question = __webpack_require__(113);
	
	var _question2 = _interopRequireDefault(_question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var guestDelivery = (_dec = (0, _utils.Component)({
	  controllerAs: 'guestdelivery',
	  template: _guestDelivery2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function guestDelivery($scope, $rootScope, $ngRedux, $state, $uibModal, toaster, $spinner, $auth, $order, $q, $window, $cookies, $stateParams, APP, $sce) {
	    _classCallCheck(this, guestDelivery);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.toaster = toaster;
	    this.$order = $order;
	    this.$auth = $auth;
	    this.$spinner = $spinner;
	    this.$q = $q;
	    this.$sce = $sce;
	    this.$stateParams = $stateParams;
	    this.$cookies = $cookies;
	    this.$window = $window;
	    this.APP = APP;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.alertIcon = _alert2.default;
	    this.info = _question2.default;
	    this.shippingOfferInfoIcon = _shippingInfo2.default;
	    this.shippingOfferAvailableIcon = _shippingTick2.default;
	    this.shippingOffer = {};
	    this.shippingOffer.isOfferEligible = false;
	    this.shippingOffer.thresholdAmount = 1500;
	    this.billingStates = [];
	    this.shippingStates = [];
	    this.isMiscelleneousCategory = 4;
	    this.giftCardMasterCodeStartsWith = '9';
	    this.dscMasterCode = '88888888'; // Named constant
	    this.mode = '';
	    this.noItemsInCart = false;
	    this.isDiscountError = false;
	    this.isCartError = false;
	    this.isCartExceptionError = false;
	    this.isGiftOrder = false;
	    this.shippingAddressValidation = false;
	    this.isAddressValidated = false;
	    this.isEmailNull = false;
	    this.iszipCodeNull = false;
	    this.isPhoneNumberNull = false;
	    this.noTimeForOrderReadyBy = false;
	    this.showDefaultFedexErrorMessage = true;
	    this.fedexErrorMessage = "";
	    this.fedexErrorMessageHtml = "";
	    this.ordernotesPattern = "^[ a-zA-Z0-9~%!@#$^&*()_+={}|\\\\,.?:\"'\/:;<`>-]*$";
	
	    this.promoLengthToBeShown = 25;
	    this.userDetail = this.$rootScope.guestUserDetails ? this.$rootScope.guestUserDetails : sessionStorage.getItem('guestUserDetails') ? JSON.parse(sessionStorage.getItem('guestUserDetails')) : {
	      email: null,
	      firstName: null,
	      lastName: null,
	      addressLine1: null,
	      addressLine2: null,
	      city: null,
	      state: null,
	      zipCode: null,
	      country: null,
	      phoneNumber: null,
	      recipientFirstName: null,
	      recipientLastName: null,
	      shipping: {
	        addressLine1: null,
	        addressLine2: null,
	        city: null,
	        state: null,
	        zipCode: null,
	        country: null,
	        isCopyAsShipping: false
	      }
	    };
	    this.curbSideDetails = this.$rootScope.curbSideDetails ? this.$rootScope.curbSideDetails : sessionStorage.getItem('curbSideDetails') && sessionStorage.getItem('curbSideDetails') !== "undefined" ? JSON.parse(sessionStorage.getItem('curbSideDetails')) : {
	      carName: null,
	      phNo: null
	    };
	    this.userForm;
	    this.curbsideForm;
	    this.estimatedDeliveryDateTime = null;
	    this.couponAmount = 0;
	    this.init();
	    this.taxableDiscountAmount = 0;
	    this.calledTaxCount = 0;
	    this.nextDayDelivery = 'Next Day Delivery';
	    this.inStoreDelivery = 'In Store Pickup';
	    this.instorePickupOnly = 'InStore';
	    this.dropShipOnly = 'DropShip';
	    this.isCurbside = false;
	    $window.scrollTo(0, 0);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(guestDelivery, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        store: state.auth.store,
	        cartDetail: state.order.cartDetail,
	        cardInfo: state.order.paymentInfo,
	        zoneDeliveryCharges: state.order.zoneDeliveryCharges,
	        coupon: state.order.coupon,
	        taxes: state.order.taxes,
	        discountCoupon: state.order.discountCoupon,
	        birdBucksList: state.order.birdBucksList,
	        storeDiscountMap: state.order.storeDiscountMap,
	        orderPoints: state.order.orderPoints,
	        erplyShop: state.order.cartDetail.erplyShopCartResponse,
	        erplyBirdBucksList: state.order.erplyBirdBucksList,
	        guestCartList: state.auth.guestCartList,
	        storeDetail: state.auth.storeDetail,
	        billingCountries: state.auth.countries
	      };
	    }
	  }, {
	    key: 'init',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var $spinner, $order, $q;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                $spinner = this.$spinner, $order = this.$order, $q = this.$q;
	
	                this.cError = false;
	                this.couponAmount = 0;
	                this.taxableDiscountAmount = 0;
	                this.discountCouponAmount = 0;
	                this.discountCouponCode = sessionStorage.getItem('discountCoupon') ? sessionStorage.getItem('discountCoupon') : null;
	                this.orderNotes = sessionStorage.getItem('orderNotesSession');
	
	                if (!this.orderNotes || this.orderNotes == "undefined") {
	                  this.orderNotes = "";
	                }
	
	                $spinner.show('appSpinner');
	
	                if (!this.$auth.isGuestLogin()) {
	                  _context.next = 23;
	                  break;
	                }
	
	                _context.next = 12;
	                return this.$auth.getStore();
	
	              case 12:
	                _context.next = 14;
	                return this.$auth.getCountries();
	
	              case 14:
	                _context.next = 16;
	                return $order.getZoneWiseDeliveryChargesForGuest();
	
	              case 16:
	                _context.next = 18;
	                return this.$auth.getGuestCart();
	
	              case 18:
	
	                if (this.store.country && this.store.country.countryCode) {
	                  this.userDetail.country = this.userDetail.country ? this.userDetail.country : this.store.country.countryCode;
	                  this.countryChange(this.userDetail.country, false);
	                  if (this.userDetail.shipping.country) {
	                    if (this.userDetail.shipping.zipCode) {
	                      this.isShippingAddressAdded = true;
	                    }
	                    this.countryChange(this.userDetail.shipping.country, true);
	                  }
	                }
	
	                _context.next = 21;
	                return this.getGuestCartDetails(true);
	
	              case 21:
	                // await $order.getStoreDiscountMapping();
	                $spinner.hide('appSpinner');
	                this.holidays = this.storeDetail.storeTimings.filter(function (e) {
	                  return e.isHoliday;
	                });
	
	              case 23:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function init() {
	        return _ref.apply(this, arguments);
	      }
	
	      return init;
	    }()
	  }, {
	    key: 'getGuestCartDetails',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var _this = this;
	
	        var hideSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!hideSpinner) {
	                  this.$spinner.show('appSpinner');
	                }
	                this.isCallingAPI = true;
	                _context2.next = 4;
	                return this.$order.getGuestCartDetail(this.createGuestCartRequest()).then(function (success) {
	
	                  if (_this.store.hasErply) {
	                    _this.setErplyCartResponseValue(success.data);
	                  }
	
	                  if (_this.cartDetail) {
	                    _this.processDeliveryType();
	                    if (_this.cartDetail.shopCartResponse) {
	                      _this.discountCouponAmount = _this.cartDetail.shopCartResponse.promoDiscount;
	                    }
	                    if (_this.cartDetail.discountError && _this.cartDetail.discountError.length && _this.cartDetail.discountError.filter(function (ele) {
	                      return ele;
	                    }).length) {
	                      _this.isDiscountError = true;
	                      _this.discountCouponCode = '';
	                      sessionStorage.setItem('discountCoupon', _this.discountCouponCode);
	                      _this.createGuestCartRequest();
	                    } else {
	                      _this.isDiscountError = false;
	                      if (success.data && success.data.baseResponse) {
	                        if (success.data.baseResponse.successCode == '200') {
	                          _this.isErplyCampaignValid = true;
	                        } else {
	                          _this.discountCouponCode = '';
	                          sessionStorage.setItem('discountCoupon', _this.discountCouponCode);
	                          _this.isErplyCampaignValid = false;
	                        }
	                        _this.erplyCampaignStatus = success.data.baseResponse.message;
	                      }
	                    }
	                    if (_this.cartDetail.cartError && _this.cartDetail.cartError.length && _this.cartDetail.cartError.filter(function (ele) {
	                      return ele;
	                    }).length) {
	                      _this.isCartError = true;
	                      if (!_this.store.hasErply && _this.cartDetail.cartError.find(function (ele) {
	                        return ele.includes('Exception occured while connecting the Tax Jar API.');
	                      })) {
	                        _this.isCartExceptionError = true;
	                        _this.cartDetail.cartError = _this.cartDetail.cartError.filter(function (ele) {
	                          return !ele.includes('Exception occured while connecting the Tax Jar API.');
	                        });
	                        _this.toaster.pop('success', 'Error in calculating Tax!');
	                      } else {
	                        _this.isCartExceptionError = false;
	                      }
	                      if (_this.store.hasErply && _this.cartDetail.cartError.find(function (ele) {
	                        return ele.includes('FedexError');
	                      })) {
	                        var ctrl1 = _this;
	                        for (var i = 0; i < _this.cartDetail.cartError.length; i++) {
	                          if (_this.cartDetail.cartError[i].includes("FedexError")) {
	                            _this.fedexErrorMessageHtml = _this.cartDetail.cartError[i].split("|")[1];
	                            _this.showDefaultFedexErrorMessage = false;
	                            _this.fedexErrorMessage = _this.getFedexErrorMessageFromhtmlErrorMsg(_this.fedexErrorMessageHtml);
	                            break;
	                          } else {
	                            _this.showDefaultFedexErrorMessage = true;
	                          }
	                        }
	                      } else {
	                        _this.showDefaultFedexErrorMessage = true;
	                      }
	                      // this.$window.scrollTo(0, 0);
	                    } else {
	                      _this.isCartExceptionError = false;
	                      _this.isCartError = false;
	                    }
	                  }
	                }).catch(function (err) {
	                  _this.$auth.printCustomerGenericLogs(err);
	                }).finally(function () {
	                  _this.isCallingAPI = false;
	                  _this.$spinner.hide('appSpinner');
	                });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getGuestCartDetails() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getGuestCartDetails;
	    }()
	  }, {
	    key: 'getFedexErrorMessageFromhtmlErrorMsg',
	    value: function getFedexErrorMessageFromhtmlErrorMsg(fedexErrorMessageHtml) {
	      fedexErrorMessageHtml = fedexErrorMessageHtml.replace("<br/>", "");
	      return fedexErrorMessageHtml;
	    }
	  }, {
	    key: 'showExcessItemsPopUp',
	    value: function showExcessItemsPopUp() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        backdrop: 'static',
	        keyboard: false,
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Items Limit Reached</h5></div>' + '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12">Your cart has reached the current limit of {{noOfItemsAllowed}} items. Please remove some items from the cart.  You can purchase those items in another order.</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">Go to Cart</button>' + '</div>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	          $scope.noOfItemsAllowed = $ctrl.APP.ORDER.LIMITATIONS.noOfItemsAllowed;
	          $scope.ok = function () {
	            $ctrl.$state.go('guestcart');
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showMessageInPopUp',
	    value: function showMessageInPopUp(message) {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        backdrop: 'static',
	        keyboard: false,
	        template: '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12">{{message}}</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	          $scope.noOfItemsAllowed = $ctrl.APP.ORDER.LIMITATIONS.noOfItemsAllowed;
	          $scope.message = message;
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'createGuestCartRequest',
	    value: function createGuestCartRequest() {
	
	      if (this.guestCartList && this.guestCartList.length > 0) {
	        if (this.guestCartList.length > this.APP.ORDER.LIMITATIONS.noOfItemsAllowed) {
	          this.showExcessItemsPopUp();
	        }
	      }
	
	      var cartData = this.guestCartList.filter(function (data) {
	        return !data.isDscCard;
	      });
	      var request = {
	        isGuest: true,
	        isCheckoutCart: true,
	        email: this.userDetail.email,
	        deliveryType: this.mode ? this.mode : this.inStoreDelivery,
	        shipTo: this.createShipToRequest(),
	        shippingCharge: +this.getSelectedShipmentCharge() ? this.getSelectedShipmentCharge().toFixed(2) || 0 : 0,
	        shippingDiscount: +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0,
	        manualPromotionIDs: this.discountCouponCode ? [this.discountCouponCode] : null,
	        guestCartItems: cartData
	      };
	      sessionStorage.setItem('GuestCartRequest', JSON.stringify(request));
	      console.log("sessionStorage.getItem('GuestCartRequest')", sessionStorage.getItem('GuestCartRequest'));
	      return request;
	    }
	  }, {
	    key: 'onCurbsideChanges',
	    value: function onCurbsideChanges() {
	      sessionStorage.setItem('guestUserDetails', JSON.stringify(this.userDetail));
	      if (this.curbSideDetails && this.curbSideDetails.carName && this.curbSideDetails.phNo) {
	        sessionStorage.setItem('curbSideDetails', JSON.stringify(this.curbSideDetails));
	      }
	    }
	  }, {
	    key: 'validateShippingAddressLine',
	    value: function validateShippingAddressLine() {
	      var _this2 = this;
	
	      if (!this.shippingAddressValidation && this.userDetail && this.userDetail.shipping.addressLine1 && this.$auth.validatingPoBoxAddress(this.store.postboxAddress, this.userDetail.shipping.addressLine1)) {
	        this.shippingAddressValidation = true;
	        setTimeout(function () {
	          _this2.shippingAddressValidation = false;
	        }, 1000);
	      }
	    }
	  }, {
	    key: 'onAddressValueChange',
	    value: function onAddressValueChange() {
	      var _this3 = this;
	
	      var callApi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.isShippingAddressAdded = false;
	      this.isAddressValidated = false;
	      if (this.mode === this.nextDayDelivery) {
	        this.copyToShippingAddress(false);
	        // if (this.userDetail && this.userDetail.shipping.addressLine1 && this.$auth.validatingPoBoxAddress(this.store.postboxAddress, this.userDetail.shipping.addressLine1)) {
	        //   return false;
	        // }
	        if (this.userDetail.shipping.addressLine1 && this.userDetail.shipping.country && this.userDetail.shipping.state && this.userDetail.shipping.zipCode) {
	          this.isShippingAddressAdded = true;
	          setTimeout(function () {
	            if (callApi) {
	              _this3.getGuestCartDetails(true).then().catch(function (err) {
	                _this3.$auth.printCustomerGenericLogs(err);
	              });
	            }
	          }, 500);
	        }
	      }
	      sessionStorage.setItem('guestUserDetails', JSON.stringify(this.userDetail));
	    }
	  }, {
	    key: 'copyToShippingAddress',
	    value: function copyToShippingAddress(apiCall) {
	      var _this4 = this;
	
	      if (this.userDetail.shipping.isCopyAsShipping) {
	        this.userDetail.shipping.addressLine1 = this.userDetail.addressLine1;
	        this.userDetail.shipping.addressLine2 = this.userDetail.addressLine2;
	        this.userDetail.shipping.city = this.userDetail.city;
	        if (this.userDetail.shipping.country !== this.userDetail.country) {
	          this.userDetail.shipping.country = this.userDetail.country;
	          this.countryChange(this.userDetail.shipping.country, true);
	        }
	        this.userDetail.shipping.state = this.userDetail.state;
	        this.userDetail.shipping.zipCode = this.userDetail.zipCode;
	
	        if (this.userDetail.shipping.addressLine1 && this.userDetail.shipping.country && this.userDetail.shipping.state && this.userDetail.shipping.zipCode) {
	          this.isShippingAddressAdded = true;
	        }
	
	        this.userDetail.recipientFirstName = this.userDetail.firstName;
	        this.userDetail.recipientLastName = this.userDetail.lastName;
	        if (apiCall) {
	          this.getGuestCartDetails().then().catch(function (err) {
	            _this4.$auth.printCustomerGenericLogs(err);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'processDeliveryType',
	    value: function processDeliveryType() {
	      var _this5 = this;
	
	      if (this.$rootScope.tempdeliveryMode) {
	
	        if (this.$rootScope.tempdeliveryMode === this.nextDayDelivery && this.cartContainsOnlyDsc()) {
	          this.mode = this.inStoreDelivery;
	          this.resetDeliveryMode(this.mode);
	        } else {
	          this.mode = this.$rootScope.tempdeliveryMode;
	        }
	        if (this.$rootScope.isCurbside) {
	          this.isCurbside = this.$rootScope.isCurbside;
	          this.curbSideDetails = this.$rootScope.curbSideDetails;
	        }
	      } else {
	        this.mode = "";
	      }
	
	      // In store pickup only changes - when items contain deliverytype instore then hide shipping option
	      if (this.cartDetail && this.cartDetail.cartItems && this.cartDetail.cartItems.length > 0) {
	        var filteredInstoreItem = this.cartDetail.cartItems.filter(function (item) {
	          return item.item.deliveryType === _this5.instorePickupOnly;
	        });
	        if (filteredInstoreItem && filteredInstoreItem.length > 0) {
	          this.filteredInstoreItem = true;
	          this.mode = this.inStoreDelivery;
	          this.resetDeliveryMode(this.mode);
	        } else {
	          this.filteredInstoreItem = false;
	        }
	        var filteredDropShipItem = this.cartDetail.cartItems.filter(function (item) {
	          return item.item.deliveryType === _this5.dropShipOnly;
	        });
	        if (filteredDropShipItem && filteredDropShipItem.length > 0) {
	          this.filteredDropShipItem = true;
	          this.mode = this.nextDayDelivery;
	          this.resetDeliveryMode(this.mode);
	        } else {
	          this.filteredDropShipItem = false;
	        }
	      }
	    }
	  }, {
	    key: 'createShipToRequest',
	    value: function createShipToRequest() {
	      if (this.mode === this.nextDayDelivery) {
	        if (this.userDetail && this.userDetail.shipping && this.userDetail.shipping.zipCode && this.userDetail.shipping.addressLine1 && this.userDetail.shipping.city && this.userDetail.shipping.country && this.userDetail.shipping.state) {
	          return {
	            name: this.userDetail.firstName + ' ' + this.userDetail.lastName,
	            addressLine1: this.userDetail.shipping.addressLine1,
	            addressLine2: this.userDetail.shipping.addressLine2,
	            city: this.userDetail.shipping.city,
	            state: this.createStateRequest(this.userDetail.shipping.state, this.userDetail.shipping.country),
	            country: this.createCountryRequest(this.userDetail.shipping.country),
	            zip: this.userDetail.shipping.zipCode,
	            deliveryType: this.mode ? this.mode : this.inStoreDelivery
	          };
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getTotalWeight',
	    value: function getTotalWeight() {
	      return this.cartDetail.cartItems && this.cartDetail.cartItems.map(function (item) {
	        return item.item.weight * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	    }
	  }, {
	    key: 'getShippingDiscountCharge',
	    value: function getShippingDiscountCharge() {
	      if (this.cartContainsOnlyGift()) {
	        return 0.00;
	      }
	      if (this.store.hasErply && this.erplyShop && this.erplyShop.shippingDiscount && this.mode !== this.inStoreDelivery) {
	        return this.erplyShop.shippingDiscount;
	      }
	      if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.shippingDiscount && this.mode !== this.inStoreDelivery) {
	        return this.cartDetail.shopCartResponse.shippingDiscount;
	      }
	      return 0;
	    }
	  }, {
	    key: 'getSelectedShipmentCharge',
	    value: function getSelectedShipmentCharge() {
	      if (this.cartContainsOnlyGift()) {
	        return 0.00;
	      }
	      if (this.store.hasErply && this.erplyShop && this.erplyShop.shippingCharge && this.mode !== this.inStoreDelivery) {
	        return this.erplyShop.shippingCharge;
	      }
	      if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.shippingCharge && this.mode !== this.inStoreDelivery) {
	        return this.cartDetail.shopCartResponse.shippingCharge;
	      }
	      return 0;
	    }
	  }, {
	    key: 'subtotal',
	    value: function subtotal() {
	      return this.store && this.store.hasErply ? this.erplyShop && this.erplyShop.originalPriceTotal ? this.erplyShop.originalPriceTotal : 0 : this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.subTotal ? this.cartDetail.shopCartResponse.subTotal : 0;
	    }
	  }, {
	    key: 'totalPrice',
	    value: function totalPrice() {
	      return this.subtotal() + this.getTotalTax() - this.getTotalDiscount();
	    }
	  }, {
	    key: 'totalAmount',
	    value: function totalAmount() {
	      if (this.store && this.store.hasErply) {
	        return this.erplyShop.amountToPay;
	      } else {
	        return this.subtotal() + this.getSelectedShipmentCharge() + this.getTotalTax() - this.getTotalDiscount() - this.getShippingDiscountCharge();
	      }
	    }
	  }, {
	    key: 'getTotalTax',
	    value: function getTotalTax() {
	      if (this.store && this.store.hasErply && this.erplyShop && this.erplyShop.totalTax && this.mode != '') {
	        return this.erplyShop.totalTax;
	      }
	      if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.totalTax && this.mode != '') {
	        return this.cartDetail.shopCartResponse.totalTax;
	      }
	      return 0;
	    }
	  }, {
	    key: 'getTotalDiscount',
	    value: function getTotalDiscount() {
	      if (this.store && this.store.hasErply && this.erplyShop && this.erplyShop.erplyPromotionDiscount && this.mode != '') {
	        return this.erplyShop.erplyPromotionDiscount;
	      }
	      if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.promoDiscount && this.mode != '') {
	        return this.cartDetail.shopCartResponse.promoDiscount;
	      }
	      return 0;
	    }
	  }, {
	    key: 'shippingGrossPrice',
	    value: function shippingGrossPrice() {
	      var totalGiftCardAmountPurchasing = 0.00;
	      var $ctrl = this;
	      angular.forEach(this.cartDetail.cartItems, function (item, key) {
	        if (item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory && item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith) {
	          totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + item.item.price * item.quantity;
	        }
	      });
	
	      if (this.store.hasErply) {
	        return this.erplyShop && this.erplyShop.subTotal ? this.erplyShop.subTotal - totalGiftCardAmountPurchasing - this.getTotalDiscount() : 0;
	      } else {
	        return this.cartDetail && this.cartDetail.shopCartResponse ? this.cartDetail.shopCartResponse.subTotal - totalGiftCardAmountPurchasing - this.getTotalDiscount() : 0;
	      }
	    }
	  }, {
	    key: 'isShippingDiscountEligible',
	    value: function isShippingDiscountEligible() {
	      var grossPrice = this.shippingGrossPrice();
	      var res = false;
	      var result = false;
	      if (!this.isCartError) {
	        res = this.storeDetail.isFreeShipping && grossPrice >= this.cartDetail.freeshipping.thresholdValue;
	        var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
	        var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
	        var currentDate = new Date();
	        if (res) {
	          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	            result = true;
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'cartContainsGiftCard',
	    value: function cartContainsGiftCard() {
	      var _this6 = this;
	
	      return this.cartDetail && this.cartDetail.cartItems ? this.cartDetail.cartItems.filter(function (item) {
	        var masterCode = item.item.masterProduct.masterCode;
	        var seriesNumber = masterCode.charAt(0);
	        var categoryId = item.item.masterProduct.category.id;
	        return seriesNumber === '9' && categoryId === _this6.isMiscelleneousCategory;
	      }).length : false;
	    }
	  }, {
	    key: 'cartContainsDsc',
	    value: function cartContainsDsc() {
	      var _this7 = this;
	
	      return this.cartDetail && this.cartDetail.cartItems ? this.cartDetail.cartItems.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this7.dscMasterCode;
	      }).length : false;
	    }
	  }, {
	    key: 'cartContainsOnlyDsc',
	    value: function cartContainsOnlyDsc() {
	      // console.log(this.cartContainsGiftCard());
	      var totalItemsInCart = this.cartDetail ? this.cartDetail.cartItems.length : 0;
	      if (this.cartContainsDsc() && totalItemsInCart === this.cartContainsDsc()) {
	        this.mode = this.inStoreDelivery;
	        this.resetDeliveryMode(this.mode);
	        // console.log("If This mode is :", this.mode);
	        return true;
	      } else {
	        if (this.$rootScope.tempdeliveryMode) {
	          this.mode = this.$rootScope.tempdeliveryMode;
	        } else {
	          this.mode = "";
	        }
	        // console.log("Else This mode is :", this.mode);
	        return false;
	      }
	    }
	  }, {
	    key: 'cartContainsOnlyGift',
	    value: function cartContainsOnlyGift() {
	      var totalItemsInCart = this.cartDetail && this.cartDetail.cartItems.length ? this.cartDetail.cartItems.length : 0;
	      return this.cartContainsGiftCard() && totalItemsInCart === this.cartContainsGiftCard();
	    }
	
	    // converts date to UTC date
	
	  }, {
	    key: 'convertDatetoUTC',
	    value: function convertDatetoUTC(date) {
	      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
	    }
	
	    // Function assumes that the timezone is sent in format "+-HH:MM"
	
	  }, {
	    key: 'convertTimezoneToMilliseconds',
	    value: function convertTimezoneToMilliseconds(timezone) {
	      var arr = timezone.split(':');
	      var signAndHours = arr[0];
	      var minutes = +arr[1];
	      var sign = signAndHours.charAt(0);
	      var hours = +signAndHours.substr(1);
	      var milliseconds = (hours * 60 + minutes) * 60000;
	      var result = sign === '+' ? +milliseconds : -milliseconds;
	      return result;
	    }
	
	    // creates date object in Store's timezone. Does not inc daytime saving, Use for current time only.
	    // See momentJs library for daytime features etc. not implementing as we do not require it here.
	
	  }, {
	    key: 'getStoreDate',
	    value: function getStoreDate() {
	      var systemDate = new Date();
	      var UTCDate = this.convertDatetoUTC(systemDate);
	      var timezoneInMilliseconds = this.storeDetail.timeZone && this.convertTimezoneToMilliseconds(this.storeDetail.timeZone);
	      var storeDateInMilliseconds = UTCDate.getTime() + timezoneInMilliseconds;
	      var storeDate = new Date(storeDateInMilliseconds);
	      return storeDate;
	    }
	
	    // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
	
	  }, {
	    key: 'changeStringtoDateObject',
	    value: function changeStringtoDateObject(stringTime) {
	      var timeArray = stringTime.split(':');
	      var hours = timeArray[0];
	      var minutes = timeArray[1];
	      var timeObject = this.getStoreDate();
	      timeObject.setMinutes(minutes);
	      return timeObject.setHours(hours);
	    }
	  }, {
	    key: 'formattedTime',
	    value: function formattedTime(dateTime) {
	      var date = dateTime ? new Date(dateTime) : this.getStoreDate();
	      var hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
	      var time = (hours < 10 ? '0' + hours : hours) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	      var ampm = date.getHours() >= 12 ? ' PM' : ' AM';
	      return time + ampm;
	    }
	  }, {
	    key: 'getStoreTiming',
	    value: function getStoreTiming(date) {
	      var forDate = date || this.getStoreDate();
	      var mapping = {
	        '0': 'Sunday',
	        '1': 'Monday',
	        '2': 'Tuesday',
	        '3': 'Wednesday',
	        '4': 'Thursday',
	        '5': 'Friday',
	        '6': 'Saturday'
	      };
	      var day = mapping[forDate.getDay()];
	      return this.storeDetail.storeTimings && this.storeDetail.storeTimings.filter(function (el) {
	        return el.day === day;
	      })[0];
	    }
	  }, {
	    key: 'storeOpeningTime',
	    value: function storeOpeningTime(forDate) {
	      if (this.storeDetail.storeTimings) {
	        var today = forDate || this.getStoreDate();
	        var open = this.getStoreTiming(forDate).openTime;
	        var hours = open.split(':')[0];
	        var minutes = open.split(':')[1];
	        today.setHours(hours);
	        today.setMinutes(minutes);
	        return today;
	      }
	    }
	  }, {
	    key: 'storeClosingTime',
	    value: function storeClosingTime(forDate) {
	      if (this.storeDetail.storeTimings) {
	        var today = forDate || this.getStoreDate();
	        var close = this.getStoreTiming(forDate).closeTime;
	        var hours = close.split(':')[0];
	        var minutes = close.split(':')[1];
	        today.setHours(hours);
	        today.setMinutes(minutes);
	        return today;
	      }
	    }
	  }, {
	    key: 'getNextWorkingDay',
	    value: function getNextWorkingDay() {
	      var mapping = {
	        'sunday': '0',
	        'monday': '1',
	        'tuesday': '2',
	        'wednesday': '3',
	        'thursday': '4',
	        'friday': '5',
	        'saturday': '6'
	      };
	      var forDate = this.getStoreDate();
	      var workingDays = this.storeDetail.storeTimings.filter(function (el) {
	        return !el.isHoliday;
	      });
	      var nextWorkingDay = void 0;
	      for (var i = 0; i < workingDays.length; i++) {
	        if (forDate.getDay() < mapping[workingDays[i].day.toLowerCase()]) {
	          nextWorkingDay = workingDays[i];
	          break;
	        }
	      }
	      nextWorkingDay = nextWorkingDay || workingDays[0];
	      if (nextWorkingDay && mapping[nextWorkingDay.day.toLowerCase()] == forDate.getDay()) {
	        nextWorkingDay.isSameDay = true;
	      }
	      return nextWorkingDay;
	    }
	  }, {
	    key: 'calculateInStorePick',
	    value: function calculateInStorePick() {
	      if (this.storeDetail.storeTimings) {
	        var orderPlacing = this.getStoreDate();
	        var pickupTime = this.storeClosingTime().setMinutes(this.storeClosingTime().getMinutes() - parseInt(this.storeDetail.inStorePickupTime));
	        if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.storeDetail.fullFillTime)) < pickupTime && !this.getStoreTiming().isHoliday) {
	          var origOrderPlacing = this.getStoreDate();
	          // If Order is placed before opening of Store
	          if (origOrderPlacing < this.storeOpeningTime()) {
	            var opening = this.storeOpeningTime();
	            var finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime)));
	            this.estimatedDeliveryDateTime = opening;
	            return finalTime;
	          }
	          this.estimatedDeliveryDateTime = orderPlacing;
	          return 'Today, ' + this.formattedTime(orderPlacing);
	        } else {
	          return this.calculateNextDay();
	        }
	      }
	    }
	  }, {
	    key: 'calculateSameDay',
	    value: function calculateSameDay() {
	      if (this.storeDetail.storeTimings) {
	        var orderPlacing = this.getStoreDate();
	        var lastDeliveryTime = this.changeStringtoDateObject(this.storeDetail.deliveryPickupTime);
	        if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.storeDetail.fullFillTime)) < lastDeliveryTime &&
	        // let deliveryBoy = this.storeClosingTime().setMinutes(this.storeClosingTime().getMinutes() - this.store.deliveryPickupTime);
	        // if (orderPlacing.setMinutes(orderPlacing.getMinutes() + this.storeDetail.fullFillTime) < deliveryBoy &&
	        !this.getStoreTiming().isHoliday) {
	          var origOrderPlacing = this.getStoreDate();
	          // If Order is placed before opening of Store
	          if (origOrderPlacing < this.storeOpeningTime()) {
	            var opening = this.storeOpeningTime();
	            var finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime)));
	            this.estimatedDeliveryDateTime = opening;
	            return finalTime;
	          }
	          this.estimatedDeliveryDateTime = orderPlacing;
	          return 'Today, ' + this.formattedTime(orderPlacing);
	        }
	        return null;
	      }
	    }
	  }, {
	    key: 'calculateNextDay',
	    value: function calculateNextDay() {
	      if (this.storeDetail.storeTimings) {
	        var date = void 0;
	        var nextDate = void 0;
	        var opening = void 0;
	        for (var z = 1; z <= 7; z++) {
	          date = this.getStoreDate();
	          nextDate = new Date(date.setDate(date.getDate() + z));
	          if (!this.getStoreTiming(nextDate).isHoliday) {
	            opening = this.storeOpeningTime(nextDate);
	            // opening.setDate(opening.getDate() + 1);
	            opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime));
	            this.estimatedDeliveryDateTime = opening;
	
	            if (z == 7) {
	              return 'next ' + this.getNextWorkingDay().day + ', ' + this.formattedTime(opening);
	            }
	            return this.getNextWorkingDay().day + ', ' + this.formattedTime(opening);
	          }
	          if (z == 7) {
	            this.noTimeForOrderReadyBy = true;
	            break;
	          }
	        }
	        // else {
	        //   let d = this.getStoreDate();
	        //   const nextWorkingDate = d.setDate(d.getDate() + (this.getNextWorkingDay().id + 6 - d.getDay()) % 7);
	        //   let opening = this.storeOpeningTime(new Date(nextWorkingDate));
	        //   opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime));
	        //   this.estimatedDeliveryDateTime = opening;
	        //   if (this.getNextWorkingDay().isSameDay) {
	        //     return `next ${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
	        //   } else {
	        //     return `${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
	        //   }
	        // }
	      }
	    }
	  }, {
	    key: 'dateToString',
	    value: function dateToString(dateobj) {
	      var yr = dateobj.getFullYear();
	      var month = dateobj.getMonth() + 1;
	      var date = dateobj.getDate();
	      var hr = dateobj.getHours();
	      var min = dateobj.getMinutes();
	      var sec = dateobj.getSeconds();
	      return '' + yr + '-' + month + '-' + date + ' ' + hr + ':' + min + ':' + sec;
	    }
	  }, {
	    key: 'createCountryRequest',
	    value: function createCountryRequest(countrykey) {
	      var country = this.billingCountries.find(function (ele) {
	        return ele.label === countrykey;
	      });
	      if (country) {
	        return {
	          "id": country.value,
	          "countryCode": country.label,
	          "name": country.name
	        };
	      }
	      return null;
	    }
	  }, {
	    key: 'createStateRequest',
	    value: function createStateRequest(statekey, countrykey) {
	      // console.log("statekey", statekey);
	      // console.log("countrykey", countrykey);
	      // console.log("this.billingCountries", this.billingCountries);
	      countrykey = countrykey.countryCode ? countrykey.countryCode : countrykey;
	      var stateList = this.billingCountries.find(function (ele) {
	        return ele.label === countrykey;
	      }).states;
	      var state = stateList.find(function (ele) {
	        return ele.value === statekey;
	      });
	      if (state) {
	        return {
	          id: state.id,
	          code: state.value,
	          name: state.label,
	          country: this.createCountryRequest(countrykey)
	        };
	      }
	      return null;
	    }
	  }, {
	    key: 'createGuestUserRequest',
	    value: function createGuestUserRequest() {
	      var cartData = this.guestCartList.filter(function (data) {
	        return !data.isDscCard;
	      });
	      var expectedDeliveryTime = null;
	      if (this.mode === this.inStoreDelivery) {
	        expectedDeliveryTime = this.calculateInStorePick();
	      } else if (this.mode === 'Same Day Delivery') {
	        expectedDeliveryTime = this.calculateSameDay();
	      } else {
	        expectedDeliveryTime = this.calculateNextDay();
	      }
	      var dateStr = this.estimatedDeliveryDateTime ? this.dateToString(this.estimatedDeliveryDateTime) : null;
	
	      // Setting User Data in session
	      this.$rootScope.guestUserDetails = this.userDetail;
	      sessionStorage.setItem('guestUserDetails', JSON.stringify(this.userDetail));
	      if (this.curbSideDetails && this.curbSideDetails.carName && this.curbSideDetails.phNo) {
	        this.$rootScope.curbSideDetails = this.curbSideDetails;
	        sessionStorage.setItem('curbSideDetails', JSON.stringify(this.curbSideDetails));
	      }
	      return {
	        guestUser: {
	          email: this.userDetail.email,
	          phoneNumber: this.userDetail && this.userDetail.phoneNumber ? this.userDetail.phoneNumber : null,
	          isActive: false,
	          isEmployee: false,
	          customer: {
	            firstName: this.userDetail.firstName,
	            lastName: this.userDetail.lastName,
	            email: this.userDetail.email,
	            phoneNumber: this.userDetail && this.userDetail.phoneNumber ? this.userDetail.phoneNumber : null
	          },
	          admin: null,
	          billingAddressLine1: this.userDetail.addressLine1,
	          billingAddressLine2: this.userDetail.addressLine2,
	          billingCity: this.userDetail.city,
	          billingState: this.createStateRequest(this.userDetail.state, this.userDetail.country),
	          billingCountry: this.createCountryRequest(this.userDetail.country),
	          billingZipCode: this.userDetail.zipCode,
	          shippingAddressLine1: this.mode === this.nextDayDelivery ? this.userDetail.shipping.addressLine1 : this.userDetail.addressLine1,
	          shippingAddressLine2: this.mode === this.nextDayDelivery ? this.userDetail.shipping.addressLine2 : this.userDetail.addressLine2,
	          shippingCity: this.mode === this.nextDayDelivery ? this.userDetail.shipping.city : this.userDetail.city,
	          shippingState: this.createStateRequest(this.mode === this.nextDayDelivery ? this.userDetail.shipping.state : this.userDetail.state, this.mode === this.nextDayDelivery ? this.userDetail.shipping.country : this.userDetail.country),
	          shippingCountry: this.createCountryRequest(this.mode === this.nextDayDelivery ? this.userDetail.shipping.country : this.userDetail.country),
	          shippingZipCode: this.mode === this.nextDayDelivery ? this.userDetail.shipping.zipCode : this.userDetail.zipCode,
	          isExistingRegistration: false
	        },
	        guestCartItems: cartData,
	        deliveryType: this.mode,
	        isCurbside: this.isCurbside,
	        curbSideDetails: JSON.stringify(this.curbSideDetails),
	        discountCode: this.discountCouponCode,
	        shippingCharge: +this.getSelectedShipmentCharge() ? this.getSelectedShipmentCharge().toFixed(2) || 0 : 0,
	        shippingDiscount: +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0,
	        totalPrice: +parseFloat(this.totalPrice()).toFixed(2),
	        orderNotes: this.orderNotes,
	        manualPromotionIDs: this.discountCouponCode,
	        expectedDeliveryTime: dateStr,
	        estimatedDeliveryDateTime: this.estimatedDeliveryDateTime,
	        isGiftOrder: this.isGiftOrder,
	        recipientFirstName: this.userDetail && this.userDetail.recipientFirstName ? this.userDetail.recipientFirstName : null,
	        recipientLastName: this.userDetail && this.userDetail.recipientLastName ? this.userDetail.recipientLastName : null
	      };
	    }
	  }, {
	    key: 'submitAll',
	    value: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userForm, curbsideForm) {
	        var _this8 = this;
	
	        var isEmailRegistered, userForAddressCheck;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!(this.filteredInstoreItem && this.filteredDropShipItem)) {
	                  _context3.next = 3;
	                  break;
	                }
	
	                this.toaster.pop('success', 'Please modify your cart!');
	                return _context3.abrupt('return', false);
	
	              case 3:
	                if (!userForm.$invalid) {
	                  _context3.next = 7;
	                  break;
	                }
	
	                userForm.$submitted = true;
	                this.toaster.pop('success', 'Please Enter User Information');
	                return _context3.abrupt('return', false);
	
	              case 7:
	                if (!(this.mode === this.inStoreDelivery && this.isCurbside && curbsideForm.$invalid)) {
	                  _context3.next = 11;
	                  break;
	                }
	
	                curbsideForm.$submitted = true;
	                this.toaster.pop('success', 'Please Enter Curb Side Information');
	                return _context3.abrupt('return', false);
	
	              case 11:
	                if (!(this.mode === this.nextDayDelivery && this.$auth.validatingPoBoxAddress(this.store.postboxAddress, this.userDetail.shipping.addressLine1))) {
	                  _context3.next = 13;
	                  break;
	                }
	
	                return _context3.abrupt('return', false);
	
	              case 13:
	                _context3.next = 15;
	                return this.verifyEmail(this.userDetail.email);
	
	              case 15:
	                isEmailRegistered = _context3.sent;
	
	                if (!isEmailRegistered) {
	                  _context3.next = 18;
	                  break;
	                }
	
	                return _context3.abrupt('return');
	
	              case 18:
	
	                // Avalara resolving address
	                if (!this.isAddressValidated && this.mode === this.nextDayDelivery) {
	                  userForAddressCheck = this.getUserDetailForAvalaraAddressCheck(this.userDetail);
	
	                  this.$auth.avalaraResolveAddress(userForAddressCheck, this.store).then(function (resolveAddress) {
	                    console.log("ResolveAddress : ", resolveAddress);
	                    _this8.$auth.openPopUpForAddressResolve(userForAddressCheck, resolveAddress, function (addResolved) {
	                      _this8.$spinner.hide('appSpinner');
	                      console.log("Call back function", addResolved);
	                      if (addResolved.isCanceled) {
	                        console.log("Canceled");
	                      } else {
	                        _this8.isAddressValidated = true;
	                        _this8.userDetail.shipping.addressLine1 = addResolved.shippingAddressLine1;
	                        _this8.userDetail.shipping.addressLine2 = addResolved.shippingAddressLine2;
	                        _this8.userDetail.shipping.city = addResolved.shippingCity;
	                        _this8.userDetail.shipping.state = addResolved.shippingState.code;
	                        _this8.userDetail.shipping.country = addResolved.shippingCountry.countryCode;
	                        _this8.userDetail.shipping.zipCode = addResolved.shippingZipCode;
	                        _this8.guestProceedingToPayment();
	                      }
	                    });
	                  }).catch(function (err) {
	                    _this8.isAddressValidated = true;
	                    _this8.$spinner.hide('appSpinner');
	                    _this8.guestProceedingToPayment();
	                    console.log("Error in edit : ", err);
	                    _this8.$auth.printCustomerGenericLogs(err);
	                  });
	                } else {
	                  this.guestProceedingToPayment();
	                }
	
	              case 19:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function submitAll(_x3, _x4) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return submitAll;
	    }()
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.store.storeName && this.store.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.store.storeName;
	      } else {
	        if (this.store && this.store.storeName) {
	          storeName = this.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'goToMerchantPage',
	    value: function goToMerchantPage(data, method) {
	      method = method || 'post';
	
	      var form = document.createElement('form');
	      form.setAttribute('method', method);
	      form.setAttribute('action', data.message);
	
	      var payIdField = document.createElement('input');
	      payIdField.setAttribute('type', 'hidden');
	      payIdField.setAttribute('name', 'PaymentID');
	      payIdField.setAttribute('value', data.additionalInfo);
	      form.appendChild(payIdField);
	
	      var returnMethodField = document.createElement('input');
	      returnMethodField.setAttribute('type', 'hidden');
	      returnMethodField.setAttribute('name', 'ReturnMethod');
	      returnMethodField.setAttribute('value', 'POST');
	      form.appendChild(returnMethodField);
	
	      document.body.appendChild(form);
	      form.submit();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'getDeviceParameter',
	    value: function getDeviceParameter() {
	      if (window.innerWidth <= 576) {
	        return 'm';
	      } else if (window.innerWidth > 576 && window.innerWidth <= 768) {
	        return 't';
	      } else if (window.innerWidth > 768) {
	        return 'd';
	      }
	    }
	  }, {
	    key: 'resetDeliveryMode',
	    value: function resetDeliveryMode(mode) {
	      this.$rootScope.tempdeliveryMode = mode;
	      this.onAddressValueChange(false);
	    }
	  }, {
	    key: 'generateDiscountValidityMsg',
	    value: function generateDiscountValidityMsg(status) {
	      this.discountCouponStatus = null;
	      this.cError = false;
	      if (status) return;else if (this.isDiscountCouponValid === false) {
	        this.cError = true;
	        this.discountCouponStatus = 'Invalid Code';
	      }
	      if (this.isDiscountCouponEnabled === false) {
	        this.cError = true;
	        return this.discountCouponStatus = 'Invalid Code';
	      }
	      if (this.isDiscountCouponExpired === true) {
	        this.cError = true;
	        return this.discountCouponStatus = 'This Code  was expired.';
	      }
	      if (!this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
	        this.cError = true;
	        return this.discountCouponStatus = "Promo Code cannot be used to purchase a DSC membership or GiftCard.  Please add more product to use a Promo code.";
	      }
	      if (this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
	        this.discountCouponStatus = 'Successfully Applied';
	      } else if (this.isDiscountCouponValid === false) {
	        this.cError = true;
	        this.discountCouponStatus = 'Invalid Code';
	      } else if (this.isDiscountTotalNegative && this.isDiscountCouponValid) {
	        this.cError = true;
	        this.discountCouponStatus = 'Your Subtotal Amount should be more than the Discount Code amount';
	      } else {
	
	        this.discountCouponStatus = null;
	      }
	      return this.discountCouponStatus;
	    }
	  }, {
	    key: 'isFreeShippingOfferAvailable',
	    value: function isFreeShippingOfferAvailable() {
	      if (this.storeDetail && this.cartDetail.freeshipping) {
	        var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
	        var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
	        var currentDate = new Date();
	        var result = false;
	        if (this.storeDetail) {
	          if (this.storeDetail.isFreeShipping) {
	            if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	              result = true;
	            }
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'getFreeShippingRemainingAmount',
	    value: function getFreeShippingRemainingAmount() {
	      if (this.cartDetail) {
	        if (this.cartDetail.freeshipping) {
	          this.shippingOffer.thresholdAmount = this.cartDetail.freeshipping.thresholdValue;
	        }
	      }
	      var remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
	      if (remainingAmount >= 0) {
	        this.shippingOffer.isOfferEligible = true;
	      } else {
	        this.shippingOffer.isOfferEligible = false;
	      }
	      return remainingAmount * -1;
	    }
	  }, {
	    key: 'showFreeShippingOfferDetail',
	    value: function showFreeShippingOfferDetail() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free Shipping within Zone 2';
	      } else {
	        tittle = 'Free Shipping within Zone 2';
	        detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showFreeShippingOfferDetailCan',
	    value: function showFreeShippingOfferDetailCan() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	        tittle = 'Free shipping in Zones 0-1';
	      } else {
	        tittle = 'Free shipping in Zones 0-1';
	        detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'totalRetailPrice',
	    value: function totalRetailPrice() {
	      return this.cartDetail.cartItems.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      });
	    }
	  }, {
	    key: 'applyDiscounts',
	    value: function applyDiscounts(isDiscountApplied) {
	      var _this9 = this;
	
	      var $ctrl = this;
	      this.isEmailNull = false;
	      this.iszipCodeNull = false;
	      this.isPhoneNumberNull = false;
	      if (this.mode === '') {
	        this.promptForDeliveryType('', "Please select an option for how to receive your order");
	        // this.toaster.pop('success', 'Please choose how to receive your order!');
	        return false;
	      }
	      // else if(this.userDetail.email === '' || this.userDetail.email === null || this.userDetail.email === undefined){
	      //   // this.promptForDeliveryType('',"Enter email address");
	      //   this.isEmailNull = true;
	      //     return false;
	      // } else if(this.userDetail.zipCode === '' || this.userDetail.zipCode === null || this.userDetail.zipCode === undefined){
	      //   this.iszipCodeNull = true;
	      //     return false;
	      // } 
	      // else if(this.userDetail.phoneNumber === '' || this.userDetail.phoneNumber === null || this.userDetail.phoneNumber === undefined){
	      //   this.isPhoneNumberNull = true;
	      //     return false;
	      // }
	      else {
	          // Removing Free item when promo code removed
	          // if (this.cartDetail && this.cartDetail.cartItems && this.cartDetail.cartItems.length && this.guestCartList) {
	          //   this.guestCartList.forEach(ele => {
	          //     const findItem = this.cartDetail.cartItems.find(item => ele.itemId === item.item.id);
	          //     // Removing Free item when discount is removed
	          //     if (ele && findItem && findItem.discountTypeApplied === 'FREEITEM' && findItem.isDiscountApplied && this.discountCouponCode !== 'FREEITEM') {
	          //       if (ele.quantity === 1) {
	          //         this.$auth.removetoGuestCart(ele.itemId);
	          //       } else {
	          //         this.updateItemInCart(ele.quantity - 1, ele);
	          //       }
	          //     }
	          //   });
	          // }
	
	          if (isDiscountApplied) {
	            sessionStorage.setItem('discountCoupon', this.discountCouponCode);
	            if (this.discountCouponCode && this.storeDetail.hasErply) {
	              // $ctrl.erplyCampaignStatus = 'Promotion Applied automatically';
	              // $ctrl.isErplyCampaignValid = true;
	            } else {
	                // $ctrl.isErplyCampaignValid = false;
	                // if (this.curbSideDetails) {
	                //   this.$rootScope.curbSideDetails = this.curbSideDetails;
	                // }
	                // this.getGuestCartDetails().then();
	                // this.$auth.getGuestCart();
	              }
	            if (this.curbSideDetails) {
	              this.$rootScope.curbSideDetails = this.curbSideDetails;
	            }
	            this.getGuestCartDetails().then().catch(function (err) {
	              _this9.$auth.printCustomerGenericLogs(err);
	            });
	            this.$auth.getGuestCart();
	            return;
	          }
	        }
	    }
	  }, {
	    key: 'orderNotesSession',
	    value: function orderNotesSession() {
	      sessionStorage.setItem('orderNotesSession', this.orderNotes);
	    }
	  }, {
	    key: 'navigateCart',
	    value: function navigateCart() {
	      this.$state.go('guestcart');
	    }
	  }, {
	    key: 'deliveryModechanges',
	    value: function deliveryModechanges(mode) {
	      var _this10 = this;
	
	      var isCurbside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (mode !== this.nextDayDelivery) {
	        this.isCurbside = isCurbside;
	        this.$rootScope.isCurbside = isCurbside;
	      } else {
	        this.isCurbside = false;
	        this.$rootScope.isCurbside = false;
	        this.userDetail.shipping.country = this.userDetail.shipping.country ? this.userDetail.shipping.country : this.store.country.countryCode;
	        this.countryChange(this.userDetail.shipping.country, true);
	      }
	      this.mode = mode;
	      this.resetDeliveryMode(mode);
	      this.getGuestCartDetails().then().catch(function (err) {
	        _this10.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'getCurbsideDetails',
	    value: function getCurbsideDetails() {
	      var fromSubmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Curbside pickup details</h5></div>\n        <div class="modal-body" id="modal-body">\n          <div class="container-fluid"> \n            <div class="row"> \n              <form name="curbsideForm" ng-submit="submit(curbsideForm)" autocomplete="off" novalidate>\n                <div class="col-md-12 error-text" ng-if="curbsideForm.error.message">{{curbsideForm.error.message}}</div>\n                  <div class="col-md-12">\n                    <div class="form-group">\n                      <label>Car make/model/color * </label>\n                      <input name="carName" type="text" required ng-model="carName" class="form-control"/>\n                    </div>\n                </div>\n                <div class="col-md-12">\n                    <div class="form-group">\n                      <label>Phone Number * </label>\n                      <input name="phNo" type="tel" required ui-mask="(999) 999-9999" ng-model="phNo" class="form-control"/>\n                    </div>\n                </div>\n                <div class="col-md-12" style="margin-top: -3%;">\n                    <div class="form-group">\n                      <label>You will receive an email when your order is placed and a second email when your order is ready.</label><br/>\n                      <strong>Store Instructions</strong><br/>\n                      <label ng-bind="storeInstruction"></label>\n                    </div>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n        <div class="modal-footer m-t-1">\n            <button class="btn" type="button" ng-click="cancel()">Cancel</button>\n            <button class="btn btn-primary m-l-1" type="button" ng-click="ok(curbsideForm)">Submit</button>\n        </div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	          $scope.phNo = $ctrl.profile.phoneNumber;
	          $scope.storeInstruction = $ctrl.store.curbSideInstruction;
	          if ($ctrl.curbSideDetails) {
	            $scope.carName = $ctrl.curbSideDetails.carName ? $ctrl.curbSideDetails.carName : "";
	            $scope.phNo = $ctrl.curbSideDetails.phNo ? $ctrl.curbSideDetails.phNo : $scope.phNo;
	          }
	          // eslint-disable-next-line arrow-parens
	          $scope.ok = function (curbsideForm) {
	            if ($scope.carName && $scope.phNo) {
	              $ctrl.curbSideDetails = {
	                carName: $scope.carName ? $scope.carName : "",
	                phNo: $scope.phNo ? $scope.phNo : ""
	              };
	              $ctrl.$rootScope.curbSideDetails = $ctrl.curbSideDetails;
	              $uibModalInstance.close();
	              if (fromSubmit) {
	                $ctrl.submit();
	              }
	            } else {
	              curbsideForm.error = { message: 'Please fill All details!' };
	            }
	          };
	          $scope.cancel = function () {
	            $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        backdrop: 'static',
	        keyboard: false
	      });
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      return this.$auth.isMobileDevice();
	    }
	  }, {
	    key: 'countryChange',
	    value: function countryChange(country, isShipping) {
	      var fromHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var ctrl = this;
	      if (fromHtml) {
	        if (isShipping) {
	          this.userDetail.shipping.state = null;
	        } else {
	          this.userDetail.state = null;
	        }
	      }
	      angular.forEach(this.billingCountries, function (value) {
	        if (country === value.label) {
	          if (isShipping) {
	            ctrl.shippingStates = value.states;
	          } else {
	            ctrl.billingStates = value.states;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'verifyEmail',
	    value: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(email) {
	        var _this11 = this;
	
	        var showSpinner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	        var isRegistered, ctrl;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                isRegistered = false;
	
	                if (!email) {
	                  _context4.next = 6;
	                  break;
	                }
	
	                if (showSpinner) {
	                  this.$spinner.show('appSpinner');
	                }
	                ctrl = this;
	                _context4.next = 6;
	                return this.$auth.verifyCustomerEmail({
	                  email: email,
	                  store: {
	                    storeURLName: this.store.storeURLName
	                  }
	                }).then(function (success) {
	                  ctrl.$spinner.hide('appSpinner');
	                  isRegistered = false;
	                }, function (error) {
	                  isRegistered = false;
	                  if (error && error.data && error.data.errorCode == 615) {
	                    if (!ctrl.loginPopuOpened) {
	                      ctrl.toaster.pop('success', error.data.message);
	                      ctrl.loginPopup(email);
	                    }
	                    if (!showSpinner) {
	                      setTimeout(function () {
	                        ctrl.loginPopuOpened = false;
	                      }, 1000);
	                    } else {
	                      ctrl.loginPopuOpened = false;
	                    }
	                    isRegistered = true;
	                  }
	                  ctrl.$spinner.hide('appSpinner');
	                }).catch(function (err) {
	                  _this11.$auth.printCustomerGenericLogs(err);
	                });
	
	              case 6:
	                return _context4.abrupt('return', isRegistered);
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function verifyEmail(_x8) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return verifyEmail;
	    }()
	  }, {
	    key: 'loginPopup',
	    value: function loginPopup(email) {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">\n            <div class="row">\n              <div class="col-md-12">\n                <form class="login-form" name="loginForm"\n                  ng-submit="submit(loginForm)"\n                  autocomplete="off"\n                  novalidate>\n                        <div style="color: #a4182d;">Good news! You already have an account. Please login to proceed.<br/></div>\n                        <div class="error-text" ng-bind="loginForm.error.message"></div>\n                        <div class="form-group"\n                            ng-class="{\'has-danger\': (loginForm.$submitted || loginForm.email.$touched) && loginForm.email.$invalid }">\n                          <label>Email&nbsp<span><a href="#" tooltips tooltip-template="Daily Savings Club Members must register with the same email address that is associated with the \'in-store\' account in order to receive membership benefits. If you do not know which email address was provided, please contact the store." tooltip-size="small" tooltip-smart="true" tooltip-class="info-tooltip" tooltip-side="right">\n                          <img src="' + $ctrl.info + '" alt="info"></a></span></label>\n                          <input name="email"\n                                type="email"\n                                ng-pattern="/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+.[A-Za-z0-9_-]*.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+.[A-Za-z0-9_-]*.[A-Za-z]{2,}.[A-Za-z]{2,})$/"\n                                class="form-control"\n                                ng-model="email"\n                                ng-disabled="true"\n                                required>\n                          <div ng-messages="loginForm.email.$error"\n                              class="form-control-feedback"\n                              ng-show="loginForm.email.$touched || loginForm.$submitted">\n                            <div ng-message="required">Enter email address</div>\n                            <div ng-message="pattern">Enter a valid email address</div>\n                            <div ng-message="email">Enter a valid email address</div>\n                            <div class="error-text"\n                                ng-show="loginForm.errors.email && !loginForm.email.$error.required && !loginForm.email.$error.pattern">{{ loginForm.errors.email[0] }}</div>\n                          </div>\n                        </div>\n                        <div class="form-group"\n                            ng-class="{\'has-danger\': (loginForm.$submitted || loginForm.password.$touched) && loginForm.password.$invalid }">\n                          <label>Password</label>\n                          <input name="password"\n                                type="password"\n                                class="form-control"\n                                ng-model="login.password"\n                                ng-minlength="6"\n                                ng-maxlength="60"\n                                required>\n                          <div ng-messages="loginForm.password.$error"\n                              class="form-control-feedback"\n                              ng-if="loginForm.password.$touched || loginForm.$submitted">\n                            <div ng-message="required">Password is required</div>\n                            <div ng-message="minlength">Minimum Password length should be 6</div>\n                            <div ng-message="maxlength">Maximum Password length should be 60</div>\n                            <div class="error-text"\n                                ng-show="loginForm.errors.password && !loginForm.password.$error.required">{{ loginForm.errors.password[0] }}</div>\n                          </div>\n                        </div>\n                      \n                        <p class="text-xs-center gray-text mb-4">\n                          By using this site, you agree to <a target="_blank" ng-click="ok()" ui-sref="tnc" class="link-text">Terms and Conditions</a> and <a target="_blank" ui-sref="rules" class="link-text">Rules</a>.\n                        </p>\n                      \n                        <button type="submit"\n                                class="btn btn-primary btn-block login-margin btn-sm-text mockup-btn">Log in</button>\n                      \n                        <p class="mt-4 m-b-1">\n                          <a ui-sref="forgotPassword" ng-click="ok()" class="link-text gray-text">Forgot Password?</a>\n                        </p>\n                      \n                      </form>\n              </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-primary" type="button" ng-click="ok()">Cancel</button>\n        </div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	          $scope.email = email;
	          $ctrl.loginPopuOpened = true;
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	
	          $scope.isScreenSmall = function () {
	            if ($ctrl.$window.innerHeight < 300) return true;
	          };
	
	          $scope.submit = function (form) {
	            if (form.$invalid) {
	              return;
	            }
	            form.error = {};
	            $ctrl.$spinner.show('appSpinner');
	            $ctrl.$auth.registerLogin({
	              email: form.email.$viewValue,
	              password: form.password.$viewValue
	            }).then(function (success) {
	              $ctrl.$spinner.hide('appSpinner');
	              $uibModalInstance.close();
	              $ctrl.$rootScope.$emit('loginFromPopup', success);
	            }, function (error) {
	              $ctrl.$spinner.hide('appSpinner');
	              if (error.data.errorCode === 621) {
	                $uibModalInstance.close();
	                $ctrl.$state.go('inactive');
	              } else {
	                form.error = error.data;
	              }
	            }).catch(function (err) {
	              $ctrl.$auth.printCustomerGenericLogs(err);
	            });
	          };
	        }]
	      }).result.then(function () {
	        $ctrl.loginPopuOpened = true;
	      }, function () {
	        $ctrl.loginPopuOpened = false;
	      });
	    }
	  }, {
	    key: 'promptForDeliveryType',
	    value: function promptForDeliveryType(title, detail) {
	
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + title + '</h5>' +
	        // '<span ng-bind-html="'+detailed+'" > </span>'+
	        detail + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'updateItemInCart',
	    value: function updateItemInCart(quantity, item) {
	      var guestCartItems = this.guestCartList.map(function (element) {
	        if (element.itemId === item.itemId) {
	          element.quantity = quantity;
	        }
	        return element;
	      });
	      if (guestCartItems) {
	        this.$auth.updatetoGuestCart(guestCartItems);
	      }
	    }
	  }, {
	    key: 'guestProceedingToPayment',
	    value: function guestProceedingToPayment() {
	      var _this12 = this;
	
	      var reqData = this.createGuestUserRequest();
	
	      this.isCallingAPI = true;
	      this.$spinner.show('appSpinner');
	      this.$order.orderGuestCheckout(reqData).then(function (success) {
	        _this12.isCallingAPI = false;
	        _this12.$spinner.hide('appSpinner');
	        if (success.data.userToken) {
	          _this12.$state.go('card-detail', { orderId: success.data.orderId });
	        } else {
	          if (success.data.code == "429") {
	            _this12.showMessageInPopUp(success.data.message);
	          }
	          _this12.toaster.pop('success', 'Please Try again!');
	        }
	      }, function (error) {
	        _this12.isCallingAPI = false;
	        _this12.$spinner.hide('appSpinner');
	        if (error.data.errorCode === 640) {
	          _this12.toaster.pop('success', 'Please select Delivery Option.');
	          return;
	        }
	        if (error.data.errorCode === 645) {
	          _this12.toaster.pop('success', error.data.message);
	          return;
	        }
	        if (error.data.errorCode === 665 || error.data.errorCode === 671) {
	          _this12.$state.go('guestcart');
	          return;
	        }
	        if (error.data.errorCode === 659) {
	          _this12.billingError = error.data.message;
	          var $ctrl = _this12;
	          _this12.$uibModal.open({
	            size: 'sm',
	            template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">{{billingError}}</h5>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' + '</div>',
	            controller: ['$scope', 'orderService', '$uibModalInstance', '$state', function ($scope, $order, $uibModalInstance, $state) {
	              $scope.billingError = $ctrl.billingError;
	              $scope.ok = function () {
	                $uibModalInstance.close();
	                $state.go('profile.edit');
	              };
	              $scope.cancel = function () {
	                return $uibModalInstance.dismiss('cancel');
	              };
	            }]
	          });
	          return;
	        } else {
	          _this12.$uibModal.open({
	            size: 'sm',
	            template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">We can\'t process your order at this time. Please call the store.</h5>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">OK</button>' + '</div>',
	            controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	              $scope.ok = function () {
	                $uibModalInstance.close();
	                location.reload();
	              };
	              $scope.cancel = function () {
	                return $uibModalInstance.dismiss('cancel');
	              };
	            }]
	          });
	        }
	        // this.$uibModal.open({
	        //   size: 'sm',
	        //   template: '<div class="modal-body" id="modal-body">' +
	        //     '<h5 class="font-weight-bold">Price has been updated for this order. Confirm to reload your Cart details.</h5>' +
	        //     '</div>' +
	        //     '<div class="modal-footer">' +
	        //     '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
	        //     '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
	        //     '</div>',
	        //   controller: ['$scope', 'orderService', '$uibModalInstance',
	        //     function ($scope, $order, $uibModalInstance) {
	        //       $scope.ok = () => {
	        //         $uibModalInstance.close();
	        //         location.reload();
	        //       };
	        //       $scope.cancel = () => $uibModalInstance.dismiss('cancel');
	        //     }
	        //   ]
	        // });
	      }).catch(function (err) {
	        _this12.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'getUserDetailForAvalaraAddressCheck',
	    value: function getUserDetailForAvalaraAddressCheck(profile) {
	      return {
	        'phoneNumber': profile.phNo,
	        'customer': profile.customer,
	        'billingAddressLine1': this.userDetail.addressLine1,
	        'billingAddressLine2': this.userDetail.addressLine2,
	        'billingCity': this.userDetail.city,
	        'billingState': this.createStateRequest(this.userDetail.state, this.userDetail.country),
	        'billingCountry': this.createCountryRequest(this.userDetail.country),
	        'billingZipCode': this.userDetail.zipCode,
	        'shippingAddressLine1': this.userDetail.shipping.addressLine1,
	        'shippingAddressLine2': this.userDetail.shipping.addressLine2,
	        'shippingCity': this.userDetail.shipping.city,
	        'shippingState': this.createStateRequest(this.mode === this.nextDayDelivery ? this.userDetail.shipping.state : this.userDetail.state, this.mode === this.nextDayDelivery ? this.userDetail.shipping.country : this.userDetail.country),
	        'shippingCountry': this.createCountryRequest(this.userDetail.shipping.country),
	        'shippingZipCode': this.userDetail.shipping.zipCode,
	        'store': this.store
	      };
	    }
	  }, {
	    key: 'infoPopup',
	    value: function infoPopup() {
	      var _this13 = this;
	
	      document.getElementById('popup').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popup').style.display === 'block' && _this13.showPopup === false) {
	          _this13.hideinfoPopup();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'hideinfoPopup',
	    value: function hideinfoPopup() {
	      document.getElementById('popup').style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopuponhover',
	    value: function infoPopuponhover() {
	      document.getElementById('popup').style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'infoPopupFee',
	    value: function infoPopupFee() {
	      var _this14 = this;
	
	      document.getElementById('popup1').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popup1').style.display === 'block' && _this14.showPopupFee === false) {
	          _this14.hideinfoPopupFee();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'hideinfoPopupFee',
	    value: function hideinfoPopupFee() {
	      document.getElementById('popup1').style.display = 'none';
	      this.showPopupFee = false;
	    }
	  }, {
	    key: 'infoPopuponhoverFee',
	    value: function infoPopuponhoverFee() {
	      document.getElementById('popup1').style.display = 'block';
	      this.showPopupFee = true;
	    }
	  }, {
	    key: 'setErplyCartResponseValue',
	    value: function setErplyCartResponseValue(showcart) {
	      console.log("Showcart : ", showcart);
	      this.erplyDis = [];
	      var dis = {};
	      var ctrl = this;
	      var i = 0;
	      angular.forEach(showcart.erplyPromoAndDiscount, function (item, key) {
	        console.log('key', key);
	        console.log('item', item);
	        dis = {};
	        dis.key = key;
	        dis.value = item;
	        dis.sortId = i + 1;
	        i = i + 1;
	        ctrl.erplyDis.push(dis);
	      });
	      console.log("Guest Delivery - ctrl.erplyDis", ctrl.erplyDis);
	    }
	  }, {
	    key: 'getAdjustedLabelName',
	    value: function getAdjustedLabelName(promoLabel) {
	      if (promoLabel != null && promoLabel.length > this.promoLengthToBeShown) {
	        return promoLabel.substring(0, this.promoLengthToBeShown - 3) + "...";
	      } else {
	        return promoLabel;
	      }
	    }
	  }, {
	    key: 'hideinfoPromoNamePopup',
	    value: function hideinfoPromoNamePopup(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopupPromoNameonhover',
	    value: function infoPopupPromoNameonhover(prefix, index, itemName, promoName) {
	      var divId = "";
	      if (itemName != null) {
	        divId = prefix + '' + index + '' + itemName + '' + promoName;
	      } else {
	        divId = prefix + '' + index + '' + promoName;
	      }
	      document.getElementById(divId).style.display = 'block';
	      this.showPopup = true;
	    }
	  }]);
	
	  return guestDelivery;
	}(), _class2.$inject = ['$scope', '$rootScope', '$ngRedux', '$state', '$uibModal', 'toaster', 'spinnerService', 'authService', 'orderService', '$q', '$window', '$cookies', '$stateParams', 'APP', '$sce'], _temp)) || _class);
	exports.default = guestDelivery;

/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = "<!-- DELIVERY PAGE FOR MD -->\r\n\r\n<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"guestdelivery.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{guestdelivery.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Checkout Details</span>\r\n  </nav>\r\n\r\n  <!-- Tax Error -->\r\n  <div class=\"cart_header p-t-1\" ng-if=\"guestdelivery.isCartError\">\r\n    <div class=\"alert-user oos-msg\">\r\n      <span><img class=\"alert-icon\" src={{guestdelivery.alertIcon}}></span>\r\n      <span class=\"alert-text\" ng-If=\"guestdelivery.isCartExceptionError\">\r\n        Error in calculating Tax!\r\n      </span>\r\n      <span class=\"alert-text\" ng-If=\"guestdelivery.cartDetail.cartError && guestdelivery.cartDetail.cartError.length\">\r\n        <!-- <span ng-if=\"!guestdelivery.store.hasErply\">\r\n          {{guestdelivery.cartDetail.cartError.toString()}}\r\n        </span> -->\r\n        <!-- <span ng-if=\"guestdelivery.store.hasErply\">\r\n          We are unable to deliver to this address. Please contact the store for assistance at \r\n          <a class=\"blue-colored\"\r\n          href=\"tel:{{guestdelivery.store.phoneNumber}}\">{{guestdelivery.store.phoneNumber | telFormat}}</a>.\r\n        </span> -->\r\n        \r\n        <span ng-if=\"guestdelivery.mode !== ''\">\r\n          <span ng-if=\"!guestdelivery.showDefaultFedexErrorMessage\">{{guestdelivery.fedexErrorMessage}}</span>\r\n\r\n          <span ng-if=\"guestdelivery.showDefaultFedexErrorMessage\"> {{guestdelivery.cartDetail.cartError.toString()}} </span>\r\n        </span>\r\n\r\n      </span>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row cart_header m-x-0 p-t-1 p-x-0\"\r\n    ng-if=\"guestdelivery.cartDetail.cartItems.length\">\r\n      <h4 class=\"font-weight-bold\">Choose How to Receive Your Order</h4>\r\n  </div>\r\n\r\n  <!-- Order doesn't exist -->\r\n  <div class=\"row p-t-2 m-x-0\" ng-if=\"!guestdelivery.cartDetail.cartItems.length\">\r\n    <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n      <h5 class=\"font-weight-bold\">Order doesn't exist</h5>\r\n      <p class=\"m-t-1\">Please add items in the cart</p>\r\n      <div class=\"m-t-3 p-t-3\">\r\n        <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"category\">Start New Order</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- row after choose delivery mode -->\r\n  <div class=\"row p-x-0 m-x-0\" ng-if=\"guestdelivery.cartDetail.cartItems.length\">\r\n\r\n    <!-- 8 column for delivery selection and product info -->\r\n    <div class=\"col-lg-8 col-md-7 col-xs-12 p-t-1\">\r\n      <div class=\"row gray-bg\">\r\n        <!-- Delivery selection & store -->\r\n        <div class=\"col-md-12 delivery p-t-2\">\r\n          <div class=\"error-text\" style=\"    padding-bottom: 15px;   padding-left: 15px !important;\"\r\n            ng-show=\"!guestdelivery.mode || guestdelivery.mode == ''\">\r\n            Select one of the following options:\r\n          </div>\r\n          <!-- instore -->\r\n          <div class=\"col-xs-12 col-md-3 p-r-0\" ng-show=\"guestdelivery.store.isInStorePickup && !guestdelivery.filteredDropShipItem\">\r\n            <div class=\"form-check\">\r\n              <label class=\"form-check-label\" >\r\n                <input type=\"radio\" class=\"form-check-input\" ng-if=\"!guestdelivery.isCurbside\" ng-model=\"guestdelivery.mode\" value=\"In Store Pickup\" ng-click=\"guestdelivery.deliveryModechanges('In Store Pickup');\">                \r\n              <input type=\"radio\" class=\"form-check-input\" ng-if=\"!guestdelivery.isCurbside\" ng-model=\"guestdelivery.mode\" value=\"In Store Pickup\" ng-click=\"guestdelivery.deliveryModechanges('In Store Pickup');\">                \r\n                <input type=\"radio\" class=\"form-check-input\" ng-if=\"!guestdelivery.isCurbside\" ng-model=\"guestdelivery.mode\" value=\"In Store Pickup\" ng-click=\"guestdelivery.deliveryModechanges('In Store Pickup');\">                \r\n                <input type=\"radio\" class=\"form-check-input\" ng-if=\"guestdelivery.isCurbside\" ng-model=\"guestdelivery.mode\" value=\"In Store Pickup1\" ng-click=\"guestdelivery.deliveryModechanges('In Store Pickup');\">\r\n                <span> In-store pickup. </span>\r\n                <p class=\"primary-text delivery-sub-text\" ng-if=\"!guestdelivery.cartContainsOnlyDsc()\">\r\n                  FROM STORE ABOVE\r\n                </p>\r\n                <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"guestdelivery.cartContainsOnlyGift()\">Please enter a shipping address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store, leave the Notes section blank.</p> -->\r\n                <p class=\"primary-text delivery-sub-text\"\r\n                  ng-if=\"guestdelivery.mode === 'In Store Pickup' && guestdelivery.holidays.length !== 0 && !guestdelivery.cartContainsOnlyDsc()\">\r\n                  CLOSED ON:\r\n                  <span ng-repeat=\"item in guestdelivery.holidays\" class=\"text-uppercase\">{{item.day | limitTo: 3 }}\r\n                    <span ng-hide=\"$last\">, </span>\r\n                  </span>\r\n\r\n                </p>\r\n              </label>\r\n            </div>\r\n\r\n          </div>\r\n          <!-- curbside -->\r\n          <div class=\"col-xs-12 col-md-3 p-r-0\" ng-show=\"guestdelivery.store.isCurbsidePickup && !guestdelivery.filteredDropShipItem\">\r\n            <div class=\"form-check\">\r\n              <label class=\"form-check-label\" >\r\n                <input type=\"radio\" ng-if=\"!guestdelivery.isCurbside\" class=\"form-check-input\" ng-model=\"guestdelivery.mode\" value=\"In Store Pickup1\" ng-click=\"guestdelivery.deliveryModechanges('In Store Pickup', true);\">\r\n                <input type=\"radio\" ng-if=\"guestdelivery.isCurbside\" class=\"form-check-input\" ng-model=\"guestdelivery.mode\" value=\"In Store Pickup\" ng-click=\"guestdelivery.deliveryModechanges('In Store Pickup', true);\">\r\n                <span> Curbside pickup. </span>\r\n                <p class=\"primary-text delivery-sub-text\" ng-if=\"!guestdelivery.cartContainsOnlyDsc()\">\r\n                  FROM STORE ABOVE\r\n                </p>\r\n                <!-- <p class=\"text-xs-left delivery-info-text-md\" ng-if=\"guestdelivery.cartContainsOnlyGift()\">Please enter a shipping address in the Notes section, and we will mail free of charge. If you prefer to pick up in-store, leave the Notes section blank.</p> -->\r\n                <p class=\"primary-text delivery-sub-text\"\r\n                  ng-if=\"guestdelivery.mode === 'In Store Pickup' && guestdelivery.holidays.length !== 0 && !guestdelivery.cartContainsOnlyDsc()\">\r\n                  CLOSED ON:\r\n                  <span ng-repeat=\"item in guestdelivery.holidays\" class=\"text-uppercase\">{{item.day | limitTo: 3 }}\r\n                    <span ng-hide=\"$last\">, </span>\r\n                  </span>\r\n\r\n                </p>\r\n              </label>\r\n            </div>\r\n\r\n          </div>\r\n\r\n          <div class=\"col-xs-12 col-md-6 p-r-0\" ng-if=\"!guestdelivery.filteredInstoreItem\">\r\n            <!-- Next day delivery -->\r\n            <div class=\"form-check\">\r\n              <label class=\"form-check-label\" ng-class=\"guestdelivery.cartContainsOnlyDsc() ? 'disabled' : ''\">\r\n                <input type=\"radio\" class=\"form-check-input\" ng-model=\"guestdelivery.mode\" value=\"Next Day Delivery\"\r\n                  ng-disabled=\"guestdelivery.cartContainsOnlyDsc()\" ng-click=\"guestdelivery.resetDeliveryMode('Next Day Delivery');\"\r\n                  ng-change=\"guestdelivery.deliveryModechanges('Next Day Delivery');\">\r\n                <span>Please ship my order.\r\n                  <br>\r\n                  <span style=\"font-size: 10px;position: relative;top: -5px !important;\">(Ground shipping is typically 2-5 business days)</span>\r\n                </span>\r\n                <p class=\"primary-text delivery-sub-text1\"\r\n                  ng-if=\"guestdelivery.charge.length && guestdelivery.cartDetail.shopCartResponse.shippingCharge && !guestdelivery.cartContainsOnlyDsc()\">\r\n                  SHIPPING COST: ${{guestdelivery.cartDetail.shopCartResponse.shippingCharge | number : 2}}\r\n                </p>\r\n\r\n\r\n              </label>\r\n            </div>\r\n\r\n            <div class=\"zone-charge\" ng-if=\"guestdelivery.mode == 'Next Day Delivery' && !guestdelivery.cartContainsOnlyGift()\">\r\n              <table class=\"table table-sm\">\r\n                <thead>\r\n                  <tr>\r\n                    <th>Shipping</th>\r\n\r\n                    <th>\r\n                      <center>{{guestdelivery.zoneDeliveryCharges[0].distanceRange}} </center>\r\n                      <center>\r\n                        <span ng-if=\"guestdelivery.store.country.countryCode=='US'\">Miles</span>\r\n                      </center>\r\n                    </th>\r\n                    <th>\r\n                      <center>{{guestdelivery.zoneDeliveryCharges[1].distanceRange}} </center>\r\n                      <center>\r\n                        <span ng-if=\"guestdelivery.store.country.countryCode=='US'\">Miles</span>\r\n                      </center>\r\n                    </th>\r\n                    <th>\r\n                      <center>{{guestdelivery.zoneDeliveryCharges[2].distanceRange}} </center>\r\n                      <center>\r\n                        <span ng-if=\"guestdelivery.store.country.countryCode=='US'\">Miles</span>\r\n                      </center>\r\n                    </th>\r\n\r\n                  </tr>\r\n                </thead>\r\n                <tbody>\r\n                  <tr>\r\n                    <td>Shipping Cost</td>\r\n                    <td>\r\n                      <center>${{guestdelivery.zoneDeliveryCharges[0].nextDayCharge}}</center>\r\n                    </td>\r\n                    <td>\r\n                      <center>${{guestdelivery.zoneDeliveryCharges[1].nextDayCharge}}</center>\r\n                    </td>\r\n                    <td>\r\n                      <center>${{guestdelivery.zoneDeliveryCharges[2].nextDayCharge}}</center>\r\n                    </td>\r\n\r\n                  </tr>\r\n                  <tr ng-show=\"guestdelivery.isFreeShippingOfferAvailable() && guestdelivery.shippingOffer.isOfferEligible\">\r\n\r\n                    <td>Shipping Discount</td>\r\n                    <td>\r\n                      <center>-${{guestdelivery.getShippingDiscountCharge() | number : 2}}</center>\r\n                    </td>\r\n                    <td>\r\n                      <center>-${{guestdelivery.getShippingDiscountCharge() | number : 2}}</center>\r\n                    </td>\r\n                    <td>\r\n                      <center>-${{guestdelivery.getShippingDiscountCharge() | number : 2}}</center>\r\n                    </td>\r\n\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n\r\n            <!-- next day check -->\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-6 p-r-0\" ng-if=\"guestdelivery.filteredInstoreItem || guestdelivery.filteredDropShipItem\">\r\n            <span class=\"delivery-type-only\">Your cart contains some items that are {{guestdelivery.filteredInstoreItem ? 'in-store/curbside pickup' : 'delivery'}} only. If you would like to {{guestdelivery.filteredInstoreItem ? 'have your order delivered' : (!guestdelivery.store.isCurbsidePickup ? 'pick up your order in-store' : 'pick up your order in-store/curbside')}}, please click <a href=\"#\" ng-click=\"guestdelivery.navigateCart()\">here</a> and remove those items or complete a separate order.</span>\r\n          </div>\r\n          <div class=\"col-xs-12\">\r\n            <!-- instore check -->\r\n            <h6 class=\"text-xs-left delivery-info-text-md\" ng-if=\"!guestdelivery.cartContainsOnlyDsc()\">\r\n              <span ng-if=\"guestdelivery.mode === 'In Store Pickup' && (guestdelivery.store.showOrderReadyTime  && !guestdelivery.noTimeForOrderReadyBy)\">Order Ready by {{guestdelivery.calculateInStorePick()}} (Store Local Time)</span>\r\n              <span ng-if=\"guestdelivery.mode === 'In Store Pickup' && (!guestdelivery.store.showOrderReadyTime || guestdelivery.noTimeForOrderReadyBy)\">We will let you know when your order is ready.</span>\r\n            </h6>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row p-b-1 ng-scope p-t-1\">\r\n        <form name=\"userForm\" role=\"form\" class=\"p-r-1 p-l-1\" autocomplete=\"off\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"form-group col-xs-12 col-md-3\"\r\n              ng-class=\"{'has-danger': (userForm.$submitted || userForm.email.$touched || guestdelivery.isEmailNull) && userForm.email.$invalid }\">\r\n              <label>Email* </label>\r\n              <input name=\"email\"\r\n                type=\"email\"\r\n                ng-model=\"guestdelivery.userDetail.email\"\r\n                ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n                class=\"form-control\"\r\n                ng-blur=\"guestdelivery.verifyEmail(guestdelivery.userDetail.email, false);\"\r\n                required />\r\n              <div ng-messages=\"userForm.email.$error\"\r\n                class=\"form-control-feedback\"\r\n                ng-if=\"userForm.email.$touched || userForm.$submitted || guestdelivery.isEmailNull\">\r\n                <div ng-message=\"required\">Enter email address</div>\r\n                <div ng-message=\"pattern\">Enter a valid email address</div>\r\n                <div ng-message=\"email\">Enter a valid email address</div>\r\n                <div class=\"error-text\" ng-show=\"userForm.errors.email && !userForm.email.$error.required && !userForm.email.$error.pattern\">{{userForm.errors.email[0]}}</div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-xs-12 col-md-3\"\r\n              ng-class=\"{'has-danger': (userForm.$submitted || userForm.firstName.$touched) && userForm.firstName.$invalid }\">\r\n              <label>First Name*</label>\r\n              <input name=\"firstName\" ng-model=\"guestdelivery.userDetail.firstName\" type=\"text\" class=\"form-control\" required />\r\n              <div ng-messages=\"userForm.firstName.$error\"\r\n                class=\"form-control-feedback\" ng-if=\"userForm.firstName.$touched || userForm.$submitted\">\r\n                <div ng-message=\"required\">Enter First Name</div>\r\n                <div class=\"error-text\" ng-show=\"userForm.errors.firstName && !userForm.firstName.$error.required\">\r\n                  {{userForm.errors.firstName[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-xs-12 col-md-3\"\r\n              ng-class=\"{'has-danger': (userForm.$submitted || userForm.lastName.$touched) && userForm.lastName.$invalid }\">\r\n              <label>Last Name*</label>\r\n              <input name=\"lastName\" ng-model=\"guestdelivery.userDetail.lastName\" type=\"text\" class=\"form-control\" required />\r\n              <div ng-messages=\"userForm.lastName.$error\"\r\n                class=\"form-control-feedback\" ng-if=\"userForm.lastName.$touched || userForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Last Name</div>\r\n                <div class=\"error-text\" ng-show=\"userForm.errors.lastName && !userForm.lastName.$error.required\">\r\n                  {{userForm.errors.lastName[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-xs-12 col-md-3\"\r\n                ng-class=\"{'has-danger': (userForm.$submitted || userForm.phoneNumber.$touched || guestdelivery.isPhoneNumberNull) && userForm.phoneNumber.$invalid }\">\r\n                <label>Phone*</label>\r\n                <input name=\"phoneNumber\"\r\n                  type=\"tel\"\r\n                  ui-mask=\"(999) 999-9999\"\r\n                  class=\"form-control\"\r\n                  ng-model=\"guestdelivery.userDetail.phoneNumber\"\r\n                  required />\r\n                <div ng-messages=\"userForm.phoneNumber.$error\"\r\n                  class=\"form-control-feedback\"\r\n                  ng-show=\"userForm.phoneNumber.$touched || userForm.$submitted || guestdelivery.isPhoneNumberNull\">\r\n                  <div ng-message=\"required\">Enter Phone Number</div>\r\n                  <div ng-message=\"pattern\">Enter a valid Phone Number</div>\r\n                  <div class=\"error-text\" ng-show=\"userForm.errors.phoneNumber && !userForm.phoneNumber.$error.required && !userForm.phoneNumber.$error.pattern\">\r\n                    {{userForm.errors.phoneNumber[0]}}\r\n                  </div>\r\n                </div>\r\n            </div>          \r\n          </div>\r\n          <fieldset class=\"fieldset p-x-1\">\r\n            <div class=\"row\"> \r\n                <legend class=\"legend\" style=\"font-size: 1rem;\">Billing Address</legend>\r\n                  <div class=\"form-group col-xs-12 col-md-4\"\r\n                    ng-class=\"{'has-danger': (userForm.$submitted || userForm.addressLine1.$touched) && userForm.addressLine1.$invalid }\">\r\n                    <label>Address Line 1*</label>\r\n                    <input name=\"addressLine1\" ng-model=\"guestdelivery.userDetail.addressLine1\" \r\n                    ng-blur=\"guestdelivery.onAddressValueChange();\" \r\n                    ng-minlength=\"3\"\r\n                    type=\"text\" class=\"form-control\" \r\n                    required/>\r\n                    <div ng-messages=\"userForm.addressLine1.$error\"\r\n                      class=\"form-control-feedback error-container\"  ng-if=\"userForm.addressLine1.$touched || userForm.$submitted\">\r\n                      <div ng-message=\"required\">Enter Address Line 1</div>\r\n                      <div class=\"error-text\" ng-show=\"userForm.errors.addressLine1 && !userForm.addressLine1.$error.required\">\r\n                        {{userForm.errors.addressLine1[0]}}\r\n                      </div>\r\n                      <div class=\"error-text\" ng-show=\" userForm.addressLine1.$error.minlength\">\r\n                        Address Line needs to be at least 3 characters.\r\n                      </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group col-xs-12 col-md-4\"\r\n                  ng-class=\"{'has-danger': (userForm.$submitted || userForm.addressLine2.$touched) && userForm.addressLine2.$invalid }\">\r\n                  <label>Address Line 2</label>\r\n                  <input name=\"addressLine2\" ng-model=\"guestdelivery.userDetail.addressLine2\" type=\"text\" class=\"form-control\" />\r\n                  <div ng-messages=\"userForm.addressLine2.$error\"\r\n                    class=\"form-control-feedback\"\r\n                    ng-show=\"userForm.addressLine2.$touched || userForm.$submitted\">\r\n                    <div ng-message=\"required\">Enter Address Line 2</div>\r\n                    <div class=\"error-text\" ng-show=\"userForm.errors.addressLine2 && !userForm.addressLine2.$error.required\">\r\n                      {{userForm.errors.addressLine2[0]}}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group col-xs-12 col-md-4\"\r\n                  ng-class=\"{'has-danger': (userForm.$submitted || userForm.city.$touched) && userForm.city.$invalid }\">\r\n                  <label>City*</label>\r\n                  <input name=\"city\" ng-model=\"guestdelivery.userDetail.city\" type=\"text\" ng-blur=\"guestdelivery.onAddressValueChange();\" class=\"form-control\" maxlength=\"50\" required/>\r\n                  <div ng-messages=\"userForm.city.$error\"\r\n                    class=\"form-control-feedback\" ng-if=\"userForm.city.$touched || userForm.$submitted\">\r\n                    <div ng-message=\"required\">Enter City</div>\r\n                    <div class=\"error-text\" ng-show=\"userForm.errors.city && !userForm.city.$error.required\">{{userForm.errors.city[0]}}</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\"> \r\n                <div class=\"form-group col-xs-12 col-md-4\"\r\n                  ng-class=\"{'has-danger': (userForm.$submitted || userForm.country.$touched) && userForm.country.$invalid }\">\r\n                  <label>Country*</label>\r\n                  <select name=\"country\" ng-model=\"guestdelivery.userDetail.country\" ng-change=\"guestdelivery.countryChange(guestdelivery.userDetail.country, false, true);guestdelivery.onAddressValueChange();\" class=\"form-control\" required>\r\n                    <option value=\"\">Select</option>\r\n                    <option ng-repeat=\"item in guestdelivery.billingCountries\" value=\"{{item.label}}\">\r\n                      {{ item.label }}\r\n                    </option>\r\n                  </select>\r\n                  <div ng-messages=\"userForm.country.$error\"\r\n                    class=\"form-control-feedback\" ng-if=\"userForm.country.$touched || userForm.$submitted\">\r\n                    <div ng-message=\"required\">Select Country</div>\r\n                    <div class=\"error-text\" ng-show=\"userForm.errors.country && !userForm.country.$error.required\">{{userForm.errors.country[0]}}</div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group col-xs-12 col-md-4\"\r\n                    ng-class=\"{'has-danger': (userForm.$submitted || userForm.state.$touched) && userForm.state.$invalid }\">\r\n                    <label>State/Province*</label>\r\n                    <select name=\"state\" ng-model=\"guestdelivery.userDetail.state\" ng-change=\"guestdelivery.onAddressValueChange()\" class=\"form-control\" required>\r\n                      <option value=\"\">Select</option>\r\n                      <option ng-repeat=\"item in guestdelivery.billingStates\" value=\"{{item.value}}\">\r\n                        {{ item.label }}\r\n                      </option>\r\n                    </select>\r\n                    <div ng-messages=\"userForm.state.$error\"\r\n                      class=\"form-control-feedback\" ng-if=\"userForm.state.$touched || userForm.$submitted\">\r\n                      <div ng-message=\"required\">Select State/Province</div>\r\n                      <div class=\"error-text\" ng-show=\"userForm.errors.state && !userForm.state.$error.required\">{{userForm.errors.state[0]}}</div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group col-xs-12 col-md-4\"\r\n                  ng-class=\"{'has-danger': (userForm.$submitted || userForm.zipCode.$touched || guestdelivery.iszipCodeNull) && userForm.zipCode.$invalid }\">\r\n                  <label>Zip/Postal Code*</label>\r\n                  <input name=\"zipCode\" ng-model=\"guestdelivery.userDetail.zipCode\" ng-change=\"guestdelivery.onAddressValueChange()\" ng-if=\"guestdelivery.userDetail.country!=='CA'\" type=\"text\" class=\"form-control\" placeholder=\"XXXXX or XXXXX-XXXX\" \r\n                    ng-pattern=\"/^\\d{5}(-\\d{4})?$/\" required />\r\n                  <input name=\"zipCode\" ng-model=\"guestdelivery.userDetail.zipCode\" ng-change=\"guestdelivery.onAddressValueChange()\" ng-if='guestdelivery.userDetail.country==\"CA\"'\r\n                    type=\"text\" class=\"form-control fontSize\" placeholder=\"XXX XXX\" \r\n                    ng-pattern=\"/^([a-z])(\\d)([a-z])(\\s+)(\\d)([a-z])(\\d)?$/i\" required />\r\n                  <div ng-messages=\"userForm.zipCode.$error\" ng-if=\"userForm.zipCode.$touched || userForm.$submitted  || guestdelivery.iszipCodeNull\"\r\n                    class=\"form-control-feedback\">\r\n                    <div ng-message=\"required\">Enter Zip/Postal Code</div>\r\n                    <div ng-message=\"pattern\">Enter a valid Zip/Postal Code</div>\r\n                    <div class=\"error-text\" ng-show=\"userForm.errors.zipCode && !userForm.zipCode.$error.required && !userForm.zipCode.$error.pattern\">\r\n                      {{userForm.errors.zipCode[0]}}\r\n                    </div>\r\n                  </div>\r\n                </div> \r\n            </div>\r\n          </fieldset>\r\n          <div class=\"form-group col-m-12 m-t-1\" style=\"height: 10px !important;\" ng-if=\"guestdelivery.mode == 'Next Day Delivery'\">\r\n            <strong style=\"float:right;\">\r\n              <input type=\"checkbox\"\r\n              name=\"copyshipping\"\r\n              ng-model=\"guestdelivery.userDetail.shipping.isCopyAsShipping\"\r\n              class=\"form-control text-xs-left d-inline\"\r\n              style=\"width: auto;\" \r\n              ng-change=\"guestdelivery.copyToShippingAddress(true)\"\r\n              /> Same as billing address</strong>\r\n          </div>\r\n          <fieldset class=\"fieldset p-x-1 m-t-1\" ng-if=\"guestdelivery.mode == 'Next Day Delivery'\">\r\n            <legend class=\"legend\" style=\"font-size: 1rem;\">Shipping Address</legend>\r\n            \r\n            <div class=\"form-group col-xs-12 col-md-6\"\r\n              ng-class=\"{'has-danger': (userForm.$submitted || userForm.recipientFirstName.$touched) && userForm.recipientFirstName.$invalid }\">\r\n              <label>Recipient First Name*</label>\r\n              <input name=\"recipientFirstName\" ng-model=\"guestdelivery.userDetail.recipientFirstName\" type=\"text\" class=\"form-control\" required />\r\n              <div ng-messages=\"userForm.recipientFirstName.$error\"\r\n                class=\"form-control-feedback\" ng-if=\"userForm.recipientFirstName.$touched || userForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Recipient First Name</div>\r\n                <div class=\"error-text\" ng-show=\"userForm.errors.recipientFirstName && !userForm.recipientFirstName.$error.required\">\r\n                  {{userForm.errors.recipientFirstName[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-xs-12 col-md-6\"\r\n              ng-class=\"{'has-danger': (userForm.$submitted || userForm.recipientLastName.$touched) && userForm.recipientLastName.$invalid }\">\r\n              <label>Recipient Last Name*</label>\r\n              <input name=\"recipientLastName\" ng-model=\"guestdelivery.userDetail.recipientLastName\" type=\"text\" class=\"form-control\" required />\r\n              <div ng-messages=\"userForm.recipientLastName.$error\"\r\n                class=\"form-control-feedback\" ng-if=\"userForm.recipientLastName.$touched || userForm.$submitted\">\r\n                <div ng-message=\"required\">Enter Recipient Last Name</div>\r\n                <div class=\"error-text\" ng-show=\"userForm.errors.recipientLastName && !userForm.recipientLastName.$error.required\">\r\n                  {{userForm.errors.recipientLastName[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                      <div class=\"form-group col-xs-12 col-md-4\"\r\n                          ng-class=\"{'has-danger': (userForm.$submitted || userForm.shippingaddressLine1.$touched) && userForm.shippingaddressLine1.$invalid }\">\r\n                          <label>Address Line 1*</label>\r\n                          <input name=\"shippingaddressLine1\" \r\n                          ng-minlength=\"3\"\r\n                          ng-model=\"guestdelivery.userDetail.shipping.addressLine1\" \r\n                          ng-blur=\"guestdelivery.onAddressValueChange();guestdelivery.validateShippingAddressLine();\"\r\n                          type=\"text\" class=\"form-control\" \r\n                          ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" required/>\r\n                          <div ng-messages=\"userForm.shippingaddressLine1.$error\"\r\n                            class=\"form-control-feedback error-container\" ng-if=\"userForm.shippingaddressLine1.$touched || userForm.$submitted\">\r\n                            <div ng-message=\"required\">Enter Address Line 1</div>\r\n                            <div class=\"error-text\" ng-show=\"userForm.errors.shippingaddressLine1 && !userForm.shippingaddressLine1.$error.required\">\r\n                              {{userForm.errors.shippingaddressLine1[0]}}\r\n                            </div>\r\n                            <div class=\"error-text\" ng-show=\" userForm.shippingaddressLine1.$error.minlength\">\r\n                              Address Line needs to be at least 3 characters.\r\n                            </div>\r\n                          </div>\r\n                      </div>\r\n                      <div class=\"form-group col-xs-12 col-md-4\"\r\n                        ng-class=\"{'has-danger': (userForm.$submitted || userForm.shippingaddressLine2.$touched) && userForm.shippingaddressLine2.$invalid }\">\r\n                        <label>Address Line 2</label>\r\n                        <input name=\"shippingaddressLine2\" ng-model=\"guestdelivery.userDetail.shipping.addressLine2\" ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" type=\"text\" class=\"form-control\" />\r\n                        <div ng-messages=\"userForm.shippingaddressLine2.$error\"\r\n                          class=\"form-control-feedback\"\r\n                          ng-show=\"userForm.shippingaddressLine2.$touched || userForm.$submitted\">\r\n                          <div ng-message=\"required\">Enter Address Line 2</div>\r\n                          <div class=\"error-text\" ng-show=\"userForm.errors.shippingaddressLine2 && !userForm.shippingaddressLine2.$error.required\">\r\n                            {{userForm.errors.shippingaddressLine2[0]}}\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group col-xs-12 col-md-4\"\r\n                        ng-class=\"{'has-danger': (userForm.$submitted || userForm.shippingcity.$touched) && userForm.shippingcity.$invalid }\">\r\n                        <label>City*</label>\r\n                        <input name=\"shippingcity\" ng-model=\"guestdelivery.userDetail.shipping.city\" ng-blur=\"guestdelivery.onAddressValueChange();\" ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" type=\"text\" class=\"form-control\" maxlength=\"50\" required/>\r\n                        <div ng-messages=\"userForm.shippingcity.$error\"\r\n                          class=\"form-control-feedback\" ng-if=\"userForm.shippingcity.$touched || userForm.$submitted\">\r\n                          <div ng-message=\"required\">Enter City</div>\r\n                          <div class=\"error-text\" ng-show=\"userForm.errors.shippingcity && !userForm.shippingcity.$error.required\">{{userForm.errors.shippingcity[0]}}</div>\r\n                        </div>\r\n                      </div>\r\n                      </div>\r\n                      <div class=\"row\"> \r\n                      <div class=\"form-group col-xs-12 col-md-4\"\r\n                        ng-class=\"{'has-danger': (userForm.$submitted || userForm.shippingcountry.$touched) && userForm.shippingcountry.$invalid }\">\r\n                        <label>Country*</label>\r\n                        <select name=\"shippingcountry\" ng-model=\"guestdelivery.userDetail.shipping.country\" ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" ng-change=\"guestdelivery.countryChange(guestdelivery.userDetail.shipping.country, true, true);guestdelivery.onAddressValueChange();\" class=\"form-control\" required>\r\n                          <option value=\"\">Select</option>\r\n                          <option ng-repeat=\"item in guestdelivery.billingCountries\" value=\"{{item.label}}\">\r\n                            {{ item.label }}\r\n                          </option>\r\n                        </select>\r\n                        <div ng-messages=\"userForm.shippingcountry.$error\"\r\n                          class=\"form-control-feedback\" ng-if=\"userForm.shippingcountry.$touched || userForm.$submitted\">\r\n                          <div ng-message=\"required\">Select Country</div>\r\n                          <div class=\"error-text\" ng-show=\"userForm.errors.shippingcountry && !userForm.shippingcountry.$error.required\">{{userForm.errors.shippingcountry[0]}}</div>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group col-xs-12 col-md-4\"\r\n                          ng-class=\"{'has-danger': (userForm.$submitted || userForm.shippingstate.$touched) && userForm.shippingstate.$invalid }\">\r\n                          <label>State/Province*</label>\r\n                          <select name=\"shippingstate\" ng-model=\"guestdelivery.userDetail.shipping.state\" ng-change=\"guestdelivery.onAddressValueChange()\" ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" class=\"form-control\" required>\r\n                            <option value=\"\">Select</option>\r\n                            <option ng-repeat=\"item in guestdelivery.shippingStates\" value=\"{{item.value}}\">\r\n                              {{ item.label }}\r\n                            </option>\r\n                          </select>\r\n                          <div ng-messages=\"userForm.state.$error\"\r\n                            class=\"form-control-feedback\" ng-if=\"userForm.shippingstate.$touched || userForm.$submitted\">\r\n                            <div ng-message=\"required\">Select State/Province</div>\r\n                            <div class=\"error-text\" ng-show=\"userForm.errors.shippingstate && !userForm.shippingstate.$error.required\">{{userForm.errors.shippingstate[0]}}</div>\r\n                          </div>\r\n                      </div>\r\n                      <div class=\"form-group col-xs-12 col-md-4\"\r\n                        ng-class=\"{'has-danger': (userForm.$submitted || userForm.shippingzipCode.$touched) && userForm.shippingzipCode.$invalid }\">\r\n                        <label>Zip/Postal Code*</label>\r\n                        <input name=\"shippingzipCode\" ng-model=\"guestdelivery.userDetail.shipping.zipCode\" ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" ng-change=\"guestdelivery.onAddressValueChange()\" ng-if=\"guestdelivery.userDetail.shipping.country!=='CA'\" type=\"text\" class=\"form-control\" placeholder=\"XXXXX or XXXXX-XXXX\" \r\n                          ng-pattern=\"/^\\d{5}(-\\d{4})?$/\" required />\r\n                        <input name=\"shippingzipCode\" ng-model=\"guestdelivery.userDetail.shipping.zipCode\" ng-disabled=\"guestdelivery.userDetail.shipping.isCopyAsShipping\" ng-change=\"guestdelivery.onAddressValueChange()\" ng-if='guestdelivery.userDetail.shipping.country==\"CA\"'\r\n                          type=\"text\" class=\"form-control fontSize\" placeholder=\"XXX XXX\" \r\n                          ng-pattern=\"/^([a-z])(\\d)([a-z])(\\s+)(\\d)([a-z])(\\d)?$/i\" required />\r\n                        <div ng-messages=\"userForm.shippingzipCode.$error\" ng-if=\"userForm.shippingzipCode.$touched || userForm.$submitted\"\r\n                          class=\"form-control-feedback\">\r\n                          <div ng-message=\"required\">Enter Zip/Postal Code</div>\r\n                          <div ng-message=\"pattern\">Enter a valid Zip/Postal Code</div>\r\n                          <div class=\"error-text\" ng-show=\"userForm.errors.shippingzipCode && !userForm.shippingzipCode.$error.required && !userForm.shippingzipCode.$error.pattern\">\r\n                            {{userForm.errors.shippingzipCode[0]}}\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n            </div>\r\n          </fieldset>\r\n        </form>\r\n        <form name=\"curbsideForm\" role=\"form\" class=\"p-t-1 p-r-1 p-l-1\" autocomplete=\"off\" novalidate>\r\n          <fieldset class=\"fieldset\" ng-if=\"guestdelivery.isCurbside\">\r\n            <legend class=\"legend\" style=\"font-size: 1rem;\">Curbside pickup details</legend>              \r\n              <div class=\"col-md-12 error-text\" ng-if=\"curbsideForm.error.message\">{{curbsideForm.error.message}}</div>\r\n                <div class=\"col-md-6\">\r\n                  <div class=\"form-group\" \r\n                  ng-class=\"{'has-danger': (curbsideForm.$submitted || curbsideForm.carName.$touched) && curbsideForm.carName.$invalid }\">\r\n                    <label>Car make/model/color * </label>\r\n                    <input name=\"carName\" type=\"text\" required ng-model=\"guestdelivery.curbSideDetails.carName\" ng-change=\"guestdelivery.onCurbsideChanges()\" class=\"form-control\"/>\r\n                    <div ng-messages=\"curbsideForm.carName.$error\"\r\n                      class=\"form-control-feedback\"\r\n                      ng-show=\"curbsideForm.carName.$touched || curbsideForm.$submitted\">\r\n                      <div ng-message=\"required\">Enter Car make/model/color</div>\r\n                      <div class=\"error-text\" ng-show=\"curbsideForm.errors.carName && !curbsideForm.carName.$error.required\">\r\n                        {{curbsideForm.errors.carName[0]}}\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                  <div class=\"form-group\"\r\n                  ng-class=\"{'has-danger': (curbsideForm.$submitted || curbsideForm.phNo.$touched) && curbsideForm.phNo.$invalid }\">\r\n                    <label>Phone Number * </label>\r\n                    <input name=\"phNo\" type=\"tel\" required ui-mask=\"(999) 999-9999\" ng-model=\"guestdelivery.curbSideDetails.phNo\" ng-change=\"guestdelivery.onCurbsideChanges()\" class=\"form-control\"/>\r\n                    <div ng-messages=\"curbsideForm.phNo.$error\"\r\n                      class=\"form-control-feedback\"\r\n                      ng-show=\"curbsideForm.phNo.$touched || curbsideForm.$submitted\">\r\n                      <div ng-message=\"required\">Enter Phone No.</div>\r\n                      <div class=\"error-text\" ng-show=\"curbsideForm.errors.phNo && !curbsideForm.phNo.$error.required\">\r\n                        {{curbsideForm.errors.phNo[0]}}\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n              </div>\r\n              <div class=\"col-md-12\">\r\n                  <div class=\"form-group\">\r\n                    <label>You will receive an email when your order is placed and a second email when your order is ready.</label><br/>\r\n                    <strong>Store Instructions</strong><br/>\r\n                    <label ng-bind=\"storeInstruction\"></label>\r\n                  </div>\r\n              </div>\r\n        </fieldset>\r\n        </form>\r\n      </div>\r\n      \r\n      <div class=\"row m-x-0 p-l-1 error-text\"\r\n        ng-if=\"guestdelivery.mode == 'Next Day Delivery' && guestdelivery.cartDetail.cartError && guestdelivery.cartDetail.cartError.length\">\r\n        <span ng-if=\"!guestdelivery.showDefaultFedexErrorMessage\" ng-bind-html=\"guestdelivery.$sce.trustAsHtml(guestdelivery.fedexErrorMessageHtml)\"></span>\r\n\r\n        </span>\r\n        <span ng-if=\"guestdelivery.showDefaultFedexErrorMessage\">\r\n          There seems to be a problem with your address. Please check your entry.<br/> Contact the store for assistance at\r\n        <a class=\"blue-colored\"\r\n          href=\"tel:{{guestdelivery.store.phoneNumber}}\">{{guestdelivery.store.phoneNumber | telFormat}}</a>.\r\n        </span>\r\n      </div>\r\n      <form name=\"OrderNotesGuestForm\">\r\n        <div class=\"col-xs-12 col-md-12 col-lg-6  p-b-1 ng-scope p-x-0 p-t-1\">\r\n          <strong style=\"font-size: 18px;\">Order Notes</strong>\r\n          <span style=\"font-size: 11px;\">Please provide any additional delivery information here (gate access code, apartment number, etc.).</span>\r\n          <br>\r\n          <div class=\"col-md-12 gray-bg delivery p-b-2 p-t-2 m-x-0\">\r\n            <div class=\"col-md-12\">\r\n              <span ng-if=\"guestdelivery.cartDetail.cartItems.length\">\r\n                <textarea class=\"orderNotes\" name=\"orderNotes\" ng-pattern='guestdelivery.ordernotesPattern' ng-model=\"guestdelivery.orderNotes\" placeholder=\"Add a note...\" rows=4\r\n                ng-change=\"guestdelivery.orderNotesSession()\" cols=\"33\"> </textarea> </span>\r\n                <div ng-show=\"OrderNotesGuestForm.orderNotes.$invalid && OrderNotesGuestForm.orderNotes.$error.pattern\">\r\n                  <span style=\"color: red;\">Order notes only allows text, numbers and special characters</span>\r\n                </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n      <div class=\"col-xs-12 col-md-12 col-lg-6 p-b-1 p-t-1 ng-scope p-r-0 p-l-0-md\"\r\n        ng-if=\"!guestdelivery.cartContainsOnlyGift()\">\r\n        <strong style=\"font-size: 18px;\">Promo Code</strong>\r\n        <br><br>\r\n        <div class=\"col-xs-12 col-lg-12 col-md-12 gray-bg delivery p-b-2 p-t-2 m-x-0\">\r\n          <form name=\"discountCouponForm\" layout=\"column\" autocomplete=\"off\" novalidate>\r\n            <div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"\r\n              ng-class=\"{'has-danger': (discountCouponForm.$submitted || discountCouponForm.discountCouponCode.$touched) && discountCouponForm.discountCouponCode.$invalid}\">\r\n              <input name=\"discountCouponCode\" type=\"text\" class=\"form-control\" ng-model=\"guestdelivery.discountCouponCode\"\r\n                ng-maxlength=\"50\" />\r\n              <div ng-messages=\"discountCouponForm.discountCouponCode.$error\" class=\"form-control-feedback\"\r\n                ng-show=\"discountCouponForm.discountCouponCode.$touched || discountCouponForm.$submitted\">\r\n                <div ng-message=\"maxlength\">Maximum length should be 50</div>\r\n                <div class=\"error-text\"\r\n                  ng-show=\"discountCouponForm.errors.discountCouponCode && !discountCouponForm.discountCouponCode.$error.required\">\r\n                  {{discountCouponForm.errors.discountCouponCode[0]}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"{{guestdelivery.isMobileOnly() ? 'col-xs-12 col-sm-12 col-md-2 col-lg-2 p-t-1' : 'col-xs-12 col-sm-12 col-md-2 col-lg-2'}}\">\r\n              <button ng-click=\"guestdelivery.applyDiscounts(true)\" class=\"btn btn-primary btn-md-text\">Apply</button>\r\n            </div>\r\n            <div ng-if=\"!guestdelivery.store.hasErply\" class=\"col-sm-12\">\r\n              <span ng-if=\"guestdelivery.cartDetail.shopCartResponse.promoDiscount && guestdelivery.cartDetail.shopCartResponse.promoCode && guestdelivery.discountCouponCode\" class=\"success-msg\">Promotion Applied</span>\r\n              <span ng-if=\"guestdelivery.isDiscountError\"\r\n                class=\"failure-msg error-text\">{{guestdelivery.cartDetail.discountError.toString()}}</span>\r\n              <!-- <span ng-if=\"guestdelivery.isErplyCampaignValid\" class=\"success-msg\">{{guestdelivery.erplyCampaignStatus}}</span> -->\r\n            </div>\r\n            <div ng-if=\"guestdelivery.store.hasErply\" class=\"col-sm-12\">\r\n              <!-- <span ng-if=\"guestdelivery.cartDetail.shopCartResponse.promoDiscount && guestdelivery.cartDetail.shopCartResponse.promoCode && guestdelivery.discountCouponCode\" class=\"success-msg\">Promotion Applied</span>\r\n              <span ng-if=\"guestdelivery.isDiscountError\"\r\n                class=\"failure-msg error-text\">{{guestdelivery.cartDetail.discountError.toString()}}</span> -->\r\n              <span ng-if=\"guestdelivery.isErplyCampaignValid\" class=\"success-msg\">{{guestdelivery.erplyCampaignStatus}}</span>\r\n              <span ng-if=\"!guestdelivery.isErplyCampaignValid\" class=\"failure-msg error-text\">{{guestdelivery.erplyCampaignStatus}}</span>\r\n              <!-- <span ng-if=\"guestdelivery.isErplyCampaignValid\" class=\"success-msg\">{{guestdelivery.erplyCampaignStatus}}</span> -->\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <div class=\"col-xs-12\" style=\"min-height: 40px\">\r\n          <small>Enter your Promo code for the discount on purchase amount</small>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Prices -->\r\n    <div class=\"{{guestdelivery.isMobileOnly() ? 'col-xs-12' : 'col-lg-4 col-md-5 col-xs-12 p-t-1'}}\" style=\"position: sticky;top: 150px;\">\r\n      <!-- DSC Points and total price -->\r\n      <div class=\"row col-md-12\">\r\n        <div class=\"div_border m-x-0 p-x-0\">\r\n          <div class=\"border_pdding\">\r\n            <h5 class=\"font-weight-bold m-y-1\">Order Detail\r\n            </h5>\r\n            <h6 class=\"m-b-1\">\r\n              <div>\r\n                <span>Subtotal</span>\r\n                <span ng-if=\"!guestdelivery.store.hasErply\" class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (guestdelivery.subtotal() | number : 2)\"></span>\r\n                <span ng-if=\"guestdelivery.store.hasErply\" class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (guestdelivery.erplyShop.totalRetailPrice | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n\r\n            <h6 class=\"m-b-1\" ng-if=\"!guestdelivery.store.hasErply && guestdelivery.cartDetail.shopCartResponse.promoCode && guestdelivery.cartDetail.shopCartResponse.promoDiscount\">\r\n              <span>Promo Code</span>\r\n              <span class=\"pull-xs-right\">-${{guestdelivery.cartDetail.shopCartResponse.promoDiscount | number : 2}}</span>\r\n            </h6>\r\n\r\n            <div ng-if=\"guestdelivery.store.hasErply && guestdelivery.erplyDis && guestdelivery.erplyDis.length>0\">\r\n              <hr>\r\n              <h6>\r\n                <div class=\"m-b-1\" ng-repeat = \"item in guestdelivery.erplyDis | orderBy: 'sortId'\">\r\n                  <span >{{guestdelivery.getAdjustedLabelName(item.key)}}\r\n                    <span ng-if=\"item.key.length>guestdelivery.promoLengthToBeShown\">\r\n                      <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"guestdelivery.infoPopupPromoNameonhover('guest_delivery_popup_order',$index,null,item.key)\" ng-mouseleave=\"guestdelivery.hideinfoPromoNamePopup('guest_delivery_popup_order',$index,null,item.key)\"></i>\r\n                      <div id=\"{{'guest_delivery_popup_order'+$index+item.key}}\" style=\"display: none; position: absolute;\" class=\"popup-promolabel-info\">\r\n                          {{item.key}}\r\n                      </div>\r\n                    </span>  \r\n                  </span>\r\n                  <span class=\"pull-xs-right\">-${{item.value | number : 2}}</span>\r\n                </div>\r\n              </h6>\r\n              <hr>\r\n            </div>\r\n\r\n            <h6 class=\"m-b-1\"\r\n              ng-if=\"((guestdelivery.getSelectedShipmentCharge() - guestdelivery.getShippingDiscountCharge()) === 0) && guestdelivery.mode == 'Next Day Delivery' && guestdelivery.isShippingAddressAdded && !guestdelivery.isCartError\">\r\n              <span>FREE Shipping</span>\r\n              <span class=\"pull-xs-right ng-cloak\">$0.00</span>\r\n            </h6>\r\n            <h6 class=\"m-b-1\"\r\n              ng-if=\"guestdelivery.getSelectedShipmentCharge() && ((guestdelivery.getSelectedShipmentCharge() - guestdelivery.getShippingDiscountCharge()) != 0) && guestdelivery.mode == 'Next Day Delivery'\">\r\n              <div>\r\n                <span>Shipping</span>\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$' + (guestdelivery.getSelectedShipmentCharge() | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n            <h6 class=\"m-b-1\"\r\n              ng-if=\"guestdelivery.getShippingDiscountCharge() && ((guestdelivery.getSelectedShipmentCharge() - guestdelivery.getShippingDiscountCharge()) != 0) && guestdelivery.mode == 'Next Day Delivery'  && guestdelivery.isShippingDiscountEligible()\">\r\n              <span>Shipping Discount </span>\r\n              <span class=\"pull-xs-right ng-cloak\"\r\n                ng-bind=\"'-$' + (guestdelivery.getShippingDiscountCharge() | number : 2)\"></span>\r\n            </h6>\r\n            <h6 class=\"m-b-1\" ng-if=\"guestdelivery.store.hasErply && guestdelivery.erplyShop.deliveryReceiptFee>0\">\r\n              <div>\r\n                <span>Retail Delivery Fee\r\n                    <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"guestdelivery.infoPopup()\"></i>\r\n                    <div id=\"popup\" style=\"display: none; position: absolute;\" class=\"popup-info\" ng-mouseenter=\"guestdelivery.infoPopuponhover()\" ng-mouseleave=\"guestdelivery.hideinfoPopup()\">\r\n                      *The state of Colorado requires a Retail Delivery Fee and any applicable taxes may be applied. For more information about the fee please visit <br/><a target=\"_blank\"  href=\"https://tax.colorado.gov/retail-delivery-fee\"><span class=\"tax-link\">https://tax.colorado.gov/retail-delivery-fee</span></a>\r\n                    </div>\r\n                </span>\r\n                <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (guestdelivery.erplyShop.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n            <h6 class=\"m-b-1\" ng-if=\"!guestdelivery.store.hasErply && guestdelivery.cartDetail.shopCartResponse.deliveryReceiptFee>0\">\r\n              <div>\r\n                <span>Retail Delivery Fee\r\n                    <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"guestdelivery.infoPopup()\"></i>\r\n                    <div id=\"popup\" style=\"display: none; position: absolute;\" class=\"popup-info\" ng-mouseenter=\"guestdelivery.infoPopuponhover()\" ng-mouseleave=\"guestdelivery.hideinfoPopup()\">\r\n                      *The state of Colorado requires a Retail Delivery Fee and any applicable taxes may be applied. For more information about the fee please visit <br/><a target=\"_blank\"  href=\"https://tax.colorado.gov/retail-delivery-fee\"><span class=\"tax-link\">https://tax.colorado.gov/retail-delivery-fee</span></a>\r\n                    </div>\r\n                </span>\r\n                <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (guestdelivery.cartDetail.shopCartResponse.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n            <h6 class=\"m-b-1\" >\r\n              <div>\r\n                <span>Tax</span>\r\n                <span ng-if=\"guestdelivery.store.hasErply\" class=\"pull-xs-right ng-cloak\" \r\n                    ng-bind=\"'$' + (guestdelivery.getTotalTax()-guestdelivery.erplyShop.deliveryReceiptFee | number : 2)\"></span>\r\n                <span ng-if=\"!guestdelivery.store.hasErply\" class=\"pull-xs-right ng-cloak\" \r\n                    ng-bind=\"'$' + (guestdelivery.getTotalTax()-guestdelivery.cartDetail.shopCartResponse.deliveryReceiptFee | number : 2)\"></span>\r\n              </div>\r\n            </h6>\r\n          </div>\r\n          <!-- total prices -->\r\n          <div class=\"gray-bg p-a-1\">\r\n            <h3 class=\"font-weight-bold m-b-0\">\r\n              <div>Total\r\n                <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'$' + (guestdelivery.totalAmount() | number : 2)\"></span>\r\n              </div>\r\n            </h3>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-12 p-x-0 mt-4\" style=\"text-align: center\">\r\n          <span class=\"giftOrder ng-cloak\" ng-if=\"guestdelivery.store.hasGiftOrder\">\r\n            <input type=\"checkbox\" name=\"isGiftOrder\" ng-model=\"guestdelivery.isGiftOrder\"\r\n                  class=\"form-control text-xs-left d-inline\" style=\"width: auto;\" required /> \r\n                  This order is a gift\r\n          </span>\r\n\r\n          <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text\"\r\n            ng-disabled=\" (guestdelivery.mode == '') || (guestdelivery.mode =='Next Day Delivery' && guestdelivery.notDeliverable) \r\n            ||\r\n              (!guestdelivery.store.isInStorePickup? !(guestdelivery.mode =='Next Day Delivery' || \r\n              (guestdelivery.mode =='In Store Pickup' && guestdelivery.isCurbside)) : false\r\n              )\r\n              ||\r\n              (!guestdelivery.store.isCurbsidePickup? !(guestdelivery.mode =='Next Day Delivery' || \r\n              (guestdelivery.mode =='In Store Pickup' && !guestdelivery.isCurbside)) : false\r\n              )\r\n            || guestdelivery.isCallingAPI || guestdelivery.isCartError\r\n            || (OrderNotesGuestForm.orderNotes.$invalid && OrderNotesGuestForm.orderNotes.$error.pattern)\"\r\n            ng-click=\"guestdelivery.submitAll(userForm, curbsideForm)\">Proceed to Payment\r\n          </button>\r\n\r\n          <div class=\"mt-4\">\r\n            <a ui-sref=\"category\">\r\n              <button type=\"button\" class=\"btn btn-primary btn-md-text btn-block\">Continue Shopping</button>\r\n            </a>\r\n          </div>\r\n          \r\n          <div class=\"mt-4\" ng-show=\"guestdelivery.isFreeShippingOfferAvailable()\">\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"guestdelivery.shippingOffer.isOfferEligible && guestdelivery.store.country.countryCode =='US'\"\r\n              ng-if=\"!guestdelivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{guestdelivery.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Your order qualifies for\r\n                <a class=\"blue-colored\" href ng-click=\"guestdelivery.showFreeShippingOfferDetail(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"guestdelivery.shippingOffer.isOfferEligible && guestdelivery.store.country.countryCode =='CA'\"\r\n              ng-if=\"!guestdelivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{guestdelivery.shippingOfferAvailableIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Your order qualifies for\r\n                <a class=\"blue-colored\" href ng-click=\"guestdelivery.showFreeShippingOfferDetailCan(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"!guestdelivery.shippingOffer.isOfferEligible && guestdelivery.store.country.countryCode =='US'\"\r\n              ng-if=\"!guestdelivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{guestdelivery.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Add\r\n                <span class=\"shipping-offer-remaining-amount\">$\r\n                  {{guestdelivery.getFreeShippingRemainingAmount() | number : 2}} </span>to your order to qualify for\r\n                <a class=\"blue-colored\" href ng-click=\"guestdelivery.showFreeShippingOfferDetail(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n\r\n            <div class=\"shipping-offer-banner bg-color\"\r\n              ng-show=\"!guestdelivery.shippingOffer.isOfferEligible && guestdelivery.store.country.countryCode =='CA'\"\r\n              ng-if=\"!guestdelivery.cartContainsOnlyGift()\">\r\n              <img ng-src={{guestdelivery.shippingOfferInfoIcon}} class=\"shipping-offer-icon  mb-8\" />\r\n              <span>Add\r\n                <span class=\"shipping-offer-remaining-amount\">$\r\n                  {{guestdelivery.getFreeShippingRemainingAmount() | number : 2}} </span>to your order to qualify for\r\n                <a class=\"blue-colored\" href ng-click=\"guestdelivery.showFreeShippingOfferDetailCan(true)\">\r\n                  <u>\r\n                    <b>FREE Shipping*</b>\r\n                  </u>\r\n                </a>\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>"

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _birdFood = __webpack_require__(179);
	
	var _birdFood2 = _interopRequireDefault(_birdFood);
	
	var _power = __webpack_require__(193);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _accessibility = __webpack_require__(212);
	
	var _accessibility2 = _interopRequireDefault(_accessibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Accessibility = (_dec = (0, _utils.Component)({
	  controllerAs: 'accessibility',
	  template: _accessibility2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Accessibility($rootScope, $scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP, ngMeta) {
	    _classCallCheck(this, Accessibility);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.birdFood = _birdFood2.default;
	    this.$state = $state;
	    this.$toaster = $toaster;
	    this.$auth = $auth;
	    this.$window = $window;
	    this.APP = APP;
	    this.ngMeta = ngMeta;
	    this.$spinner = $spinner;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.subCategoryName = '';
	    this.categoryName = '';
	    this.storeName = '';
	  }
	
	  _createClass(Accessibility, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }]);
	
	  return Accessibility;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$stateParams', '$state', 'toaster', 'orderService', 'spinnerService', 'orderActions', 'authService', '$window', 'APP', 'ngMeta'], _temp)) || _class);
	exports.default = Accessibility;

/***/ },
/* 212 */
/***/ function(module, exports) {

	module.exports = "<iframe src=\"https://portal.audioeye.com/accessibility-statement.html?domain=order.wbu.com&fallbackLng=en\" title=\"Accessibility Statement\" style=\"width:100%;height:2300px\" frameborder=1></iframe>"

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _address = __webpack_require__(214);
	
	var _address2 = _interopRequireDefault(_address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DeliveryAddress = (_dec = (0, _utils.Component)({
	  controllerAs: 'address',
	  template: _address2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function DeliveryAddress($scope, $rootScope, $ngRedux, $state, $spinner, $auth, APP, $window, $stateParams, $toaster, $uibModal) {
	    var _this = this;
	
	    _classCallCheck(this, DeliveryAddress);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$rootScope = $rootScope;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$toaster = $toaster;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.APP = APP;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.temp = {};
	    this.$spinner = $spinner;
	    this.$rootScope.deliveryMode = 'Next Day Delivery';
	    this.isSubscriptionAddressChage = false;
	    this.saveAddressToProfile = false;
	    var subScribedInfo = this.$auth.getSubscribedInfo();
	    if (subScribedInfo && subScribedInfo.addressChange) {
	      this.isSubscriptionAddressChage = true;
	    }
	
	    this.$spinner.show('appSpinner');
	
	    var $ctrl;
	    $ctrl = this;
	    $auth.getUserProfile().then(function (success) {
	      var addressObj = localStorage.getItem('deliveryAddress');
	      _this.shippingAddressTempSolution = JSON.parse(JSON.stringify(_this.profile));
	      $ctrl.temp = addressObj ? JSON.parse(addressObj) : success.data;
	      if (!$ctrl.temp.firstName || $ctrl.temp.firstName === undefined) {
	        $ctrl.temp.firstName = $ctrl.temp.customer.firstName;
	        $ctrl.temp.lastName = $ctrl.temp.customer.lastName;
	      }
	    }).finally(function () {
	      _this.$spinner.hide('appSpinner');
	      $auth.getCountries().then(function (success) {
	        // console.log(success);
	        _this.getStates(_this.profile.shippingCountry.countryCode, "shippingAddress", 0);
	      });
	    });
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(DeliveryAddress, [{
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        shippingCountries: state.auth.countries,
	        billingCountries: state.auth.countries
	      };
	    }
	  }, {
	    key: 'getStates',
	    value: function getStates(country, type, time) {
	      // console.log(country);
	      // console.log(type);
	      switch (type) {
	        case 'billingAddress':
	          if (this.profile && time !== 0) {
	            if (this.profile.billingState) {
	              this.profile.billingState.code = '';
	              this.profile.billingZipCode = '';
	            }
	          }
	          var billingStates = '';
	          // console.log(this.billingCountries);
	          angular.forEach(this.billingCountries, function (value) {
	
	            if (country === value.label) {
	              billingStates = value.states;
	            }
	          });
	
	          this.billingStates = billingStates;
	          break;
	        case 'shippingAddress':
	          if (this.profile && time !== 0) {
	            if (this.profile.shippingState) {
	              this.profile.shippingState.code = '';
	              this.profile.shippingZipCode = '';
	            }
	          }
	          var shippingStates = '';
	          // console.log(this.shippingCountries);
	          angular.forEach(this.shippingCountries, function (value) {
	            // console.log(country,"==",value.label);
	            if (country === value.label) {
	              shippingStates = value.states;
	            }
	          });
	
	          this.shippingStates = shippingStates;
	          break;
	        default:
	          break;
	
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      if (form.$invalid) {
	        return;
	      }
	      var userDetail = {};
	      var country = '';
	      var state = '';
	      var profile = this.temp;
	      var $ctrl = this;
	      angular.forEach(this.shippingCountries, function (country1) {
	        if (profile.shippingCountry.countryCode === country1.label) {
	          country = {
	            "id": parseInt(country1.value),
	            "countryCode": country1.label,
	            "name": country1.name
	          };
	          angular.forEach(country1.states, function (state1) {
	            if (profile.shippingState.code === state1.value) {
	              state = {
	                "id": state1.id,
	                "code": state1.value,
	                "name": state1.label
	              };
	            }
	          });
	        }
	      });
	      this.temp.shippingCountry = country;
	      this.temp.shippingState = state;
	      // Validating PO Box character in address 
	      if (this.$auth.validatingPoBoxAddress(this.profile.store.postboxAddress, this.temp.shippingAddressLine1)) {
	        // this.$toaster.pop('success','We do not deliver to PO Boxes. Please enter a street address.');
	        return false;
	      }
	
	      userDetail = {
	        'phoneNumber': this.temp.phoneNumber,
	        'customer': {
	          'firstName': null,
	          'lastName': null,
	          'dateOfBirth': new Date(this.profile.customer.dateOfBirth).getTime(),
	          'addressLine1': null,
	          'addressLine2': null,
	          'city': null,
	          'state': {
	            'code': null
	          },
	          'country': null,
	          'zipCode': null
	        },
	        'billingAddressLine1': this.profile.billingAddressLine1,
	        'billingAddressLine2': this.profile.billingAddressLine2,
	        'billingCity': this.profile.billingCity,
	        'billingState': this.profile.billingState,
	        'billingCountry': this.profile.billingCountry,
	        'billingZipCode': this.profile.billingZipCode,
	        'shippingAddressLine1': this.temp.shippingAddressLine1,
	        'shippingAddressLine2': this.temp.shippingAddressLine2,
	        'shippingCity': this.temp.shippingCity,
	        'shippingState': this.temp.shippingState,
	        'shippingCountry': this.temp.shippingCountry,
	        'shippingZipCode': this.temp.shippingZipCode
	      };
	      if (!this.temp.billingState) {
	        userDetail.billingState = {
	          'code': null
	        };
	      }
	      if (!this.temp.shippingState) {
	        userDetail.shippingState = {
	          'code': null
	        };
	      }
	
	      this.$auth.avalaraResolveAddress(userDetail, this.profile.store).then(function (resolveAddress) {
	        console.log("ResolveAddress : ", resolveAddress);
	        $ctrl.$auth.openPopUpForAddressResolve(userDetail, resolveAddress, function (addResolved) {
	          $ctrl.$spinner.hide('appSpinner');
	          console.log("Call back function", addResolved);
	          if (addResolved.isCanceled) {
	            console.log("Canceled");
	          } else {
	            $ctrl.temp.shippingAddressLine1 = addResolved.shippingAddressLine1;
	            $ctrl.temp.shippingAddressLine2 = addResolved.shippingAddressLine2;
	            $ctrl.temp.shippingCity = addResolved.shippingCity;
	            $ctrl.temp.shippingState = addResolved.shippingState;
	            $ctrl.temp.shippingCountry = addResolved.shippingCountry;
	            $ctrl.temp.shippingZipCode = addResolved.shippingZipCode;
	            $ctrl.temp.phoneNumber = addResolved.phoneNumber;
	
	            if ($ctrl.saveAddressToProfile) {
	              // If checkbox clicked, save address
	              userDetail.shippingAddressLine1 = $ctrl.temp.shippingAddressLine1;
	              userDetail.shippingAddressLine2 = $ctrl.temp.shippingAddressLine2;
	              userDetail.shippingCity = $ctrl.temp.shippingCity;
	              userDetail.shippingState = $ctrl.temp.shippingState;
	              userDetail.shippingCountry = $ctrl.temp.shippingCountry;
	              userDetail.shippingZipCode = $ctrl.temp.shippingZipCode;
	              userDetail.phoneNumber = $ctrl.temp.phoneNumber;
	              userDetail.validatedAddressType = $ctrl.profile.store.validateAddressType;
	              $ctrl.checkAndSaveAddress(userDetail, form);
	            } else {
	              // userDetail = this.profile;
	              addResolved.validatedAddressType = $ctrl.profile.store.validateAddressType;
	              userDetail.shippingAddressLine1 = $ctrl.shippingAddressTempSolution.shippingAddressLine1;
	              userDetail.shippingAddressLine2 = $ctrl.shippingAddressTempSolution.shippingAddressLine2;
	              userDetail.shippingCity = $ctrl.shippingAddressTempSolution.shippingCity;
	              userDetail.shippingState = $ctrl.shippingAddressTempSolution.shippingState;
	              userDetail.shippingCountry = $ctrl.shippingAddressTempSolution.shippingCountry;
	              userDetail.shippingZipCode = $ctrl.shippingAddressTempSolution.shippingZipCode;
	              userDetail.phoneNumber = $ctrl.shippingAddressTempSolution.phoneNumber;
	              userDetail.validatedAddressType = $ctrl.shippingAddressTempSolution.store.validateAddressType;
	              $ctrl.checkAndSaveAddress(userDetail, form);
	            }
	          }
	        });
	      }).catch(function (err) {
	        userDetail = $ctrl.profile;
	        userDetail.validatedAddressType = $ctrl.profile.store.validateAddressType;
	        $ctrl.checkAndSaveAddress(userDetail, form);
	      });
	    }
	  }, {
	    key: 'onZipKeyUp1',
	    value: function onZipKeyUp1() {
	      if (this.profile.shippingZipCode && this.profile.shippingZipCode.length > 5) {
	        this.mask1 = '99999-9999';
	      } else {
	        this.mask1 = '99999';
	      }
	    }
	  }, {
	    key: 'goToSubscriptionDetail',
	    value: function goToSubscriptionDetail() {
	      var subScribedInfo = this.$auth.getSubscribedInfo();
	      if (subScribedInfo && subScribedInfo.addressChange) {
	        this.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });
	      }
	    }
	
	    // avalaraResolveAddress(userDetail, store, form) {
	    //   console.log("Calling Resolve address : ", userDetail);
	    //   // if(store.validateAddressType !== 'NOT_VALIDATE' && store.validateAddressType != this.detail.validatedAddressType){
	    //       userDetail.store = store;
	    //       this.$auth.avalaraResolveAddress(userDetail, store)
	    //       .then( success => {
	    //           console.log("Success validating : ", success);
	    //           var $ctrl = this;
	    //           $ctrl.userDetail = userDetail;
	    //           $ctrl.success = success;
	    //           var modalInstance;
	    //           if(success.data){
	    //             modalInstance = this.$uibModal.open({
	    //               size: 'md',
	    //               template: '<div class="modal-header modalheaderbg btn-primary"><h5>Resolve Shipping Address</h5></div>' +
	    //                 '<div class="modal-body" id="modal-body">' +
	    //                 '<div class="container-fluid">' +
	    //                 '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
	    //                 '<div class="row">' +
	
	    //                 `<div class="col-md-12">
	    //                       <div class="col-md-12 mb-4" style="text-align: center;">
	    //                         <h6><strong>From</strong></h6>
	    //                       </div>
	
	
	    //                       <div class="col-md-12">
	    //                       <div class="col-md-5">
	    //                         <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
	    //                       </div>
	    //                       <div class="col-md-7">
	    //                         {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : '')}}
	    //                       </div>
	    //                       </div>
	
	    //                       <div class="col-md-12">
	    //                       <div class="col-md-5">
	    //                         <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
	    //                       </div>
	    //                       <div class="col-md-7">
	    //                         {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : '')}}
	    //                       </div>
	    //                       </div>
	
	    //                       <div class="col-md-12">
	    //                       <div class="col-md-5">
	    //                         <label style="color: #b58150;font-weight: bold;">City</label>
	    //                       </div>
	    //                       <div class="col-md-7">
	    //                         {{(user.shippingCity ? user.shippingCity.trim() : '')}}
	    //                       </div>
	    //                       </div>
	
	
	    //                       <div class="col-md-12">
	    //                       <div class="col-md-5">
	    //                         <label style="color: #b58150;font-weight: bold;">State</label>
	    //                       </div>
	    //                       <div class="col-md-7">
	    //                         {{(user.shippingState ? user.shippingState.code : '')}}
	    //                       </div>
	    //                       </div>
	
	
	    //                       <div class="col-md-12">
	    //                       <div class="col-md-5">
	    //                         <label style="color: #b58150;font-weight: bold;">Zip</label>
	    //                       </div>
	    //                       <div class="col-md-7">
	    //                         {{(user.shippingZipCode ? user.shippingZipCode.trim() : '')}}
	    //                       </div>
	    //                       </div>
	
	    //                 </div>`
	    //                 +
	
	    //                 `<div ng-if="isValidAddress">
	    //                 <br>
	    //                 <div class="col-md-12">
	    //                 <div class="col-md-12 mb-4" style="text-align: center;">
	    //                   <h6><strong>To</strong></h6>
	    //                 </div>
	
	
	    //                 <div class="col-md-12">
	    //                 <div class="col-md-5">
	    //                   <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
	    //                 </div>
	    //                 <div class="col-md-7">
	    //                   {{(selected.addressLine1 ? selected.addressLine1.trim() : '')}}
	    //                 </div>
	    //                 </div>
	
	    //                 <div class="col-md-12">
	    //                 <div class="col-md-5">
	    //                   <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
	    //                 </div>
	    //                 <div class="col-md-7">
	    //                   {{(selected.addressLine2 ? selected.addressLine2.trim() : '')}}
	    //                 </div>
	    //                 </div>
	
	    //                 <div class="col-md-12">
	    //                 <div class="col-md-5">
	    //                   <label style="color: #b58150;font-weight: bold;">City</label>
	    //                 </div>
	    //                 <div class="col-md-7">
	    //                   {{(selected.city ? selected.city.trim() : '')}}
	    //                 </div>
	    //                 </div>
	
	
	    //                 <div class="col-md-12">
	    //                 <div class="col-md-5">
	    //                   <label style="color: #b58150;font-weight: bold;">State</label>
	    //                 </div>
	    //                 <div class="col-md-7">
	    //                   {{(selected.state ? selected.state.code : '')}}
	    //                 </div>
	    //                 </div>
	
	
	    //                 <div class="col-md-12">
	    //                 <div class="col-md-5">
	    //                   <label style="color: #b58150;font-weight: bold;">Zip</label>
	    //                 </div>
	    //                 <div class="col-md-7">
	    //                   {{(selected.zip ? selected.zip.trim() : '')}}
	    //                 </div>
	    //                 </div>
	    //                 </div>
	    //                 </div>
	
	    //                 <div class="col-md-12" ng-if="!isValidAddress">
	    //                 <br>
	    //                 <div class="col-md-5">
	    //                   <label style="color: #b58150;font-weight: bold;">Given Address not Validated with our records</label>
	    //                 </div>
	    //                 <div class="col-md-7">
	    //                   {{summary}}
	    //                 </div>
	    //                 </div>
	    //                 ` +
	
	    //                 '</div>' +
	    //                 '</div>' +
	    //                 '<div class="modal-footer">' +
	    //                 '<button  ng-if="isValidAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Update</button>' +
	    //                 '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;">Use this address anyway</button>' +
	    //                 '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="fix()" style="float: right;">I will fix the address</button>' +
	
	    //                 '</div>',
	    //             controller: ['$scope', '$state', '$uibModalInstance',
	    //               function ($scope, $state, $uibModalInstance) {
	    //                 $scope.error = { message: '' };
	    //                 $scope.user = $ctrl.userDetail;
	    //                 $scope.isValidAddress = false;
	    //                 $scope.count = 1;
	    //                 if($ctrl.userDetail.store.validateAddressType==='BOTH_BILL_SHIP'){
	    //                   $scope.count = 2;
	    //                 }
	    //                 if($ctrl.success.data.resolutionQuality==='Intersection') {
	    //                   $scope.isValidAddress = true;
	    //                   if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
	    //                     $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
	    //                   }
	    //                   else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
	    //                     $scope.selected = $ctrl.success.data.billingAddresstoResolve;
	    //                   }
	    //                 } else {
	    //                   if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
	    //                     $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
	    //                     $scope.summary  = $ctrl.success.data.shippingAddresstoResolve.summary;
	    //                   }
	    //                   else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
	    //                     $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
	    //                     $scope.summary  = $ctrl.success.data.billingAddresstoResolve.summary;
	    //                   }
	    //                 }
	    //                 $scope.submit = () => {
	    //                   // $ctrl.$spinner.show('appSpinner');
	    //                   console.log("It calls from submit");
	    //                   $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	    //                   $scope.user.shippingAddressLine1 = $scope.selected.addressLine1;
	    //                   // $scope.user.shippingAddressLine2 = $scope.selected.addressLine1;
	    //                   $scope.user.shippingCity = $scope.selected.city;
	    //                   $scope.user.shippingState.code = $scope.selected.state.code;
	    //                   $scope.user.shippingCountry.code = $scope.selected.country.code;
	    //                   $scope.user.shippingZipCode = $scope.selected.zip;
	    //                   $uibModalInstance.close($scope.user);
	    //                 };
	    //                 $scope.cancel = () => $uibModalInstance.dismiss('cancel');
	    //                 $scope.back = () => {
	    //                   $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
	    //                   $uibModalInstance.close($scope.user);
	    //                 };
	    //                 $scope.fix = () => {
	    //                   console.log("In fixing ");
	    //                   // $ctrl.$state.go('profile.edit');
	    //                   // $uibModalInstance.close($scope.user);
	    //                 };
	    //               }
	    //             ],
	    //             resolve: {
	    //             }
	    //           });
	    //           modalInstance.result.then(function (data) {
	    //               console.log('user clicked ok', data);
	    //               $ctrl.checkAndSaveAddress(data, form);
	    //           });
	    //         }
	    //       })
	    //       .catch( error => {
	    //         console.log("Didn't call service resolve address : ", error);
	    //       });
	    //   }
	
	
	  }, {
	    key: 'checkAndSaveAddress',
	    value: function checkAndSaveAddress(userDetail, form) {
	      var _this2 = this;
	
	      // if (this.saveAddressToProfile) {
	      form.error = {};
	      localStorage.setItem('deliveryAddress', JSON.stringify(this.temp));
	      this.$auth.updateUserProfile(userDetail, this.profile.userId).then(function () {
	        var subScribedInfo = _this2.$auth.getSubscribedInfo();
	        if (subScribedInfo && subScribedInfo.addressChange) {
	          _this2.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });
	        } else {
	          _this2.$state.go('delivery');
	        }
	      }).catch(function (err) {
	        return form.error = err.data;
	      });
	      // }
	      // else {
	      //   localStorage.setItem('deliveryAddress', JSON.stringify(this.temp));
	      //   var subScribedInfo = this.$auth.getSubscribedInfo();
	      //   if (subScribedInfo && subScribedInfo.addressChange){
	      //     this.$state.go('subscription-detail', {subscriptionId: subScribedInfo.id, option: subScribedInfo.option});
	      //   }
	      //   else {
	      //     this.$state.go('delivery');
	      //   }
	      // }
	    }
	  }]);
	
	  return DeliveryAddress;
	}(), _class2.$inject = ['$scope', '$rootScope', '$ngRedux', '$state', 'spinnerService', 'authService', 'APP', '$window', '$stateParams', 'toaster', '$uibModal'], _temp)) || _class);
	exports.default = DeliveryAddress;

/***/ },
/* 214 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"address.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{address.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"delivery\" ng-if=\"!address.isSubscriptionAddressChage\">Checkout Details</a>\r\n    <a class=\"nav\" ng-click=\"address.goToSubscriptionDetail()\" ng-if=\"address.isSubscriptionAddressChage\">My Subscription Detail</a>\r\n    <span>Change Address</span>\r\n  </nav>\r\n\r\n  <form name=\"editAddressForm\" layout=\"column\"\r\n    autocomplete=\"off\" novalidate\r\n    ng-submit=\"address.submit(editAddressForm)\">\r\n\r\n    <!--Form Heading -->\r\n    <div class=\"row m-x-0 static-content\">\r\n      <div class=\"col-sm-12 m-t-1\">\r\n        <h5 class=\"font-weight-bold m-b-1\">Shipping Address</h5>\r\n      </div>\r\n      <!--FirstName --> \r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.firstName.$touched) && editAddressForm.firstName.$invalid}\">\r\n        <label>First Name</label>\r\n        <input name=\"firstName\"\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          ng-model=\"address.temp.firstName\" \r\n          required/>\r\n        <div ng-messages=\"editAddressForm.firstName.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.firstName.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter Name</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.firstName && !editAddressForm.firstName.$error.required\">\r\n            {{editAddressForm.errors.firstName[0]}}\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n        <!--LastName -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.lastName.$touched) && editAddressForm.lastName.$invalid}\">\r\n        <label>Last Name</label>\r\n        <input name=\"lastName\"\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          ng-model=\"address.temp.lastName\" \r\n          required/>\r\n        <div ng-messages=\"editAddressForm.lastName.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.lastName.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter Last Name</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.lastName && !editAddressForm.lastName.$error.required\">\r\n            {{editAddressForm.errors.lastName[0]}}\r\n          </div>\r\n        </div>\r\n      </div>\r\n     \r\n\r\n      <!--Address Line 1 -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.shippingAddressLine1.$touched) && editAddressForm.shippingAddressLine1.$invalid}\">\r\n        <label>Address Line 1</label>\r\n        <input name=\"shippingAddressLine1\"\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          ng-minlength=\"3\"\r\n          ng-model=\"address.temp.shippingAddressLine1\" \r\n          required/>\r\n        <div ng-messages=\"editAddressForm.shippingAddressLine1.$error\"\r\n          class=\"form-control-feedback error-container\"\r\n          ng-show=\"editAddressForm.shippingAddressLine1.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter Address Line 1</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.shippingAddressLine1 && !editAddressForm.shippingAddressLine1.$error.required\">\r\n            {{editAddressForm.errors.shippingAddressLine1[0]}}\r\n          </div>\r\n          <div class=\"error-text\" ng-show=\" editAddressForm.shippingAddressLine1.$error.minlength\">\r\n            Address Line needs to be at least 3 characters.\r\n          </div>\r\n  \r\n        </div>\r\n      </div>\r\n      <!--Address Line 2 -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.shippingAddressLine2.$touched) && editAddressForm.shippingAddressLine2.$invalid}\">\r\n        <label>Address Line 2</label>\r\n        <input name=\"shippingAddressLine2\"\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          ng-model=\"address.temp.shippingAddressLine2\" />\r\n        <div ng-messages=\"editAddressForm.shippingAddressLine2.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.shippingAddressLine2.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter Address Line 2</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.shippingAddressLine2 && !editAddressForm.shippingAddressLine2.$error.required\">\r\n            {{editAddressForm.errors.shippingAddressLine2[0]}}\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!--City -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.shippingCity.$touched) && editAddressForm.shippingCity.$invalid}\">\r\n        <label>City</label>\r\n        <input name=\"shippingCity\"\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          ng-model=\"address.temp.shippingCity\"\r\n          maxlength=\"50\" required/>\r\n        <div ng-messages=\"editAddressForm.shippingCity.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.shippingCity.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter City</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.shippingCity && !editAddressForm.shippingCity.$error.required\">{{editAddressForm.errors.shippingCity[0]}}</div>\r\n        </div>\r\n      </div>\r\n      <!--State -->\r\n      \r\n      <!--Country -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.shippingCountry.$touched) && editAddressForm.shippingCountry.$invalid}\">\r\n        <label>Country</label>\r\n        <select name=\"shippingCountry\"\r\n          ng-model=\"address.temp.shippingCountry.countryCode\"\r\n          class=\"form-control\"\r\n          ng-change='address.getStates(address.profile.shippingCountry.countryCode,\"shippingAddress\")'\r\n          required>\r\n          <option value=\"\">Select</option>\r\n          <option ng-repeat=\"item in address.shippingCountries\" value=\"{{item.label}}\">\r\n            {{ item.label }}\r\n          </option>\r\n        </select>\r\n        <div ng-messages=\"editAddressForm.shippingCountry.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.shippingCountry.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Select Country</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.shippingCountry && !editAddressForm.shippingCountry.$error.required\">{{editAddressForm.errors.shippingCountry[0]}}</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.shippingState.$touched) && editAddressForm.shippingState.$invalid}\">\r\n        <label>State/Province</label>\r\n        <select name=\"shippingState\"\r\n          ng-model=\"address.temp.shippingState.code\"\r\n          class=\"form-control\"\r\n          required>\r\n          <option value=\"\">Select</option>\r\n          <option ng-repeat=\"item in address.shippingStates\" value=\"{{item.value}}\">\r\n            {{ item.label }}\r\n          </option>\r\n        </select>\r\n        <div ng-messages=\"editAddressForm.shippingState.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.shippingState.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Select State/Province</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.shippingState && !editAddressForm.shippingState.$error.required\">{{editAddressForm.errors.shippingState[0]}}</div>\r\n        </div>\r\n      </div>\r\n\r\n      \r\n      <!--Zip -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.shippingZipCode.$touched) && editAddressForm.shippingZipCode.$invalid}\">\r\n        <label>Zip/Postal Code</label>\r\n        <input name=\"shippingZipCode\"\r\n        ng-if='address.temp.shippingCountry.countryCode!=\"CA\"'\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          placeholder=\"XXXXX or XXXXX-XXXX\" \r\n          ng-pattern=\"/^\\d{5}(-\\d{4})?$/\"\r\n          ng-model=\"address.temp.shippingZipCode\" required/>\r\n        <input name=\"shippingZipCode\"\r\n          ng-if='address.temp.shippingCountry.countryCode==\"CA\"'\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          placeholder=\"XXX XXX\"\r\n          ng-pattern=\"/^([a-z])(\\d)([a-z])(\\s+)(\\d)([a-z])(\\d)?$/i\"\r\n          ng-model=\"address.temp.shippingZipCode\" required/>\r\n        <div ng-messages=\"editAddressForm.shippingZipCode.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.shippingZipCode.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter Zip/Postal Code</div>\r\n          <div ng-message=\"pattern\">Enter a valid Zip/Postal Code</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.shippingZipCode && !editAddressForm.shippingZipCode.$error.required && !editAddressForm.shippingZipCode.$error.pattern\">\r\n            {{editAddressForm.errors.shippingZipCode[0]}}\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!--Phone -->\r\n      <div class=\"form-group col-sm-4\"\r\n        ng-class=\"{'has-danger': (editAddressForm.$submitted || editAddressForm.phoneNumber.$touched) && editAddressForm.phoneNumber.$invalid}\">\r\n        <label>Phone</label>\r\n        <input name=\"phoneNumber\"\r\n          type=\"tel\"\r\n          ui-mask=\"(999) 999-9999\"\r\n          class=\"form-control\"\r\n          ng-model=\"address.temp.phoneNumber\"\r\n          required />\r\n        <div ng-messages=\"editAddressForm.phoneNumber.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-show=\"editAddressForm.phoneNumber.$touched || editAddressForm.$submitted\">\r\n          <div ng-message=\"required\">Enter Phone Number</div>\r\n          <div ng-message=\"pattern\">Enter a valid Phone Number</div>\r\n          <div class=\"error-text\" ng-show=\"editAddressForm.errors.phoneNumber && !editAddressForm.phoneNumber.$error.required && !editAddressForm.phoneNumber.$error.pattern\">\r\n            {{editAddressForm.errors.phoneNumber[0]}}\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Save Buttons -->\r\n    <div class=\"row m-x-0 static-content\">\r\n      <label class=\"p-a-1\">\r\n        <input type=\"checkbox\" ng-model=\"address.saveAddressToProfile\">\r\n        Save as Shipping Address\r\n      </label> <br>\r\n      <div class=\"col-xs-4 offset-xs-4 offset-sm-0 m-b-1\">\r\n        <button type=\"submit\" class=\"btn btn-primary btn-block btn-md-text\">Save</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n"

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _creditCardIconSupport = __webpack_require__(216);
	
	var _creditCardIconSupport2 = _interopRequireDefault(_creditCardIconSupport);
	
	var _cardDetail = __webpack_require__(217);
	
	var _cardDetail2 = _interopRequireDefault(_cardDetail);
	
	var _paypalMonogram = __webpack_require__(218);
	
	var _paypalMonogram2 = _interopRequireDefault(_paypalMonogram);
	
	var _cardUpdate = __webpack_require__(219);
	
	var _cardUpdate2 = _interopRequireDefault(_cardUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CardDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'cardDetail',
	  template: _cardDetail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function CardDetail($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, $q, $uibModal, Heartland, GlobalPayments) {
	    var _this = this;
	
	    _classCallCheck(this, CardDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    var $main = this;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.$toaster = $toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.paypalMonoIcon = _paypalMonogram2.default;
	    this.cardLogo = _creditCardIconSupport2.default;
	    console.log("This cardlog -- ", this.cardLogo);
	    this.$window = $window;
	    this.$auth = $auth;
	    this.APP = APP;
	    this.$q = $q;
	    this.$uibModal = $uibModal;
	    this.$spinner = $spinner;
	    this.isAllowedToAdd = true;
	    this.isAllowedToRemove = true;
	    this.isAllowToPayOnlyWithGiftCards = false;
	    this.giftCardNumbers = [];
	    this.totalGiftAmount = 0.00;
	    this.waitUntilVerify = false;
	    this.cardNumberRegEx = "/^[0-9]{1,5}$/";
	    this.isMiscelleneousCategory = 4;
	    this.showHeartLandPage = false;
	    this.heartand_Approval = "APPROVAL";
	    this.isErplyStore = false;
	    this.allowErplyZeroDollarTrasaction = false;
	    this.isStoreCreditUsed = false;
	    this.isAllowToPayWithStoreCreditOnly = false;
	    this.amountToBeChargedFromStoreCredit = 0.00;
	    this.storeCreditAmount = 0.00;
	    this.hasErplyCardUpdateInitialized = false;
	    this.showAddCardButton = true;
	    this.Heartland = Heartland;
	    this.GlobalPayments = GlobalPayments;
	    this.hasCardInitializedAlready = false;
	    this.showPlaceOrderButton = false;
	    this.payWithNewCardButton = false;
	    this.payWithSavedCardButton = false;
	    this.payWithPayPalButton = false;
	    this.miscellaneous = "miscellaneous";
	    this.addMiscellaneousPaymentMethod = false;
	    this.showSavedCard = false;
	    this.agreement = true;
	
	    var promise1 = $order.getCartDetail(false);
	    var promise2 = this.$order.getStoreFeatures();
	    this.toDecimalPlaces = 2;
	    this.isPaypalAuthorized = false;
	    this.paymentMethod = {
	      "creditCard": {
	        "savedCard": "savedCard",
	        "newCard": "newCard"
	      },
	      "paypal": {
	        "payNow": "payNow",
	        "payLater": "payLater",
	        "payVault": "payVault"
	      },
	      "giftCard": "giftCard",
	      "storeCredit": "storeCredit",
	      "miscellaneous": this.miscellaneous
	    };
	
	    this.paymentMethods = [{
	      "value": "newCard",
	      "name": "Pay with debit or credit card",
	      "logo": false,
	      "cardLogo": true,
	      "id": "newcard-pay-now",
	      "lastChoosen": false,
	      "type": "unique",
	      "disable": false,
	      "order": 1
	      // {"value":"payLater",
	      //    "name":"Pay with Pay Later",
	      //    "logo": true,
	      //    "id" : "paypal-later-btn-marks"
	      // },
	
	    }];
	
	    this.paymentMethods[0].lastChoosen = true;
	    this.paymentOption = this.paymentMethods[0].value;
	    this.payWithNewCardButton = true;
	
	    this.paypalAutorizationWrapper = {
	      "showPaypal": true,
	      "isPaypalAuthorized": false,
	      "authorizedAmount": 0.00,
	      "authId": null
	    };
	
	    $spinner.show('appSpinner');
	    $order.isGiveXAvailable().then(function (success) {
	      _this.isGiveXAvailable = success.data.givexAvaible;
	    }).catch(function (err) {
	      _this.isGiveXAvailable = false;
	      _this.$auth.printCustomerGenericLogs(err);
	    }).finally(function () {});
	
	    var promise3 = $auth.isGuestLogin() ? $auth.getGuestUserProfile() : $auth.getUserProfile();
	    if (!$auth.isGuestLogin()) {
	      $order.getPaymentInfo().then(function (success) {
	        if (success.data.length > 0) {
	          _this.cardId = success.data[0].id;
	        }
	      }).catch(function (err) {
	        _this.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {});
	    }
	    $order.getOrderAmount(this.$stateParams.orderId).then(function (success) {
	      _this.orderAmount = success.data;
	    }).catch(function (err) {
	      _this.$auth.printCustomerGenericLogs(err);
	    });
	
	    $order.getPaymentKeys().then(function (success) {
	      _this.paymentType = success.data.paymentType;
	      _this.paymentGlobalKey = success.data.globalKey;
	      _this.isErplyStore = success.data.isErplyStore;
	      _this.version = success.data.version;
	      _this.uuid = success.data.uuid;
	      _this.gatewayUrl = success.data.url;
	      _this.env = success.data.enviroment;
	      if (_this.paymentType === _this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	        // Console.log("Print here something to indicate heartland");
	      } else if (_this.paymentType === _this.APP.ORDER.PAYMENT_TYPE.tsys) {
	        _this.env = success.data.enviroment;
	        // Console.log("Print here something to indicate heartland");
	      } else if (_this.paymentType === _this.APP.ORDER.PAYMENT_TYPE.moneris) {
	        // Console.log("Print here something to indicate heartland");
	      }
	    }).catch(function (err) {
	      _this.$auth.printCustomerGenericLogs(err);
	    });
	
	    var promises = [promise1, promise3, promise2];
	    $q.all(promises).then(function () {
	      console.log("this.storeFeatures.paypal", _this.storeFeatures.paypal);
	      if (_this.storeFeatures.paypal.hasEnabledForCustomer) {
	        var head = document.getElementsByTagName('head')[0];
	        var script = document.createElement('script');
	        var clientId = _this.storeFeatures.paypal.clientId;
	        var country = _this.storeFeatures.paypal.countryCode;
	        var merchantId = _this.storeFeatures.paypal.merchantId;
	        var currency = _this.storeFeatures.paypal.currency;
	
	        var source = "https://www.paypal.com/sdk/js?client-id=" + clientId + "&merchant-id=" + merchantId + "&currency=" + currency + "&components=marks,buttons";
	
	        if (_this.cartContainsGiftCard()) {
	          source = source + "&disable-funding=card,paylater";
	          source = source + "&enable-funding=venmo";
	        } else {
	          source = source + "&disable-funding=card";
	          source = source + "&enable-funding=paylater,venmo";
	        }
	
	        if (_this.storeFeatures.paypal.customerHasVault) {
	          source = source + "&intent=capture";
	          _this.savePaypalVault = false;
	        } else {
	          if (_this.storeFeatures.paypal.hasVaultEnabled) {
	            _this.savePaypalVault = false;
	          } else {
	            _this.savePaypalVault = false;
	          }
	        }
	        script.src = source;
	        script.setAttribute("data-partner-attribution-id", _this.storeFeatures.paypal.bnCode);
	        if (_this.storeFeatures.paypal.idToken != null) {
	          script.setAttribute("data-user-id-token", _this.storeFeatures.paypal.idToken);
	        }
	        script.type = 'text/javascript';
	        script.onload = function () {
	          console.error('--Paypal script loaded--');
	          $main.initializePaypal_regular('paypal-now-btn', 1);
	        };
	        script.onerror = function () {
	          console.error('--Paypal script Failed to loaded--');
	        };
	
	        head.appendChild(script);
	      }
	      if ($auth.isGuestLogin()) {
	        _this.profile = _this.guestprofile;
	      }
	      if (_this.profile && _this.profile.customer.storeCredit != null && _this.profile.customer.storeCredit > 0) {
	        console.log("Profile :- ", _this.profile);
	        if (_this.profile.customer.storeCredit != null) {
	          _this.storeCreditAmount = _this.getRoundoffValue(parseFloat(_this.profile.customer.storeCredit), _this.toDecimalPlaces);
	        } else {
	          _this.storeCreditAmount = 0.00;
	        }
	
	        console.log("this.storeCreditAmount---", _this.storeCreditAmount);
	        _this.getStoreCreditAmountToBeCharged();
	      }
	      // Set for paypal vault if customer have vault id
	      // if(this.profile.customer && this.storeFeatures.paypal.customerHasVault) {
	      //   this.savePaypalVault = true;
	      // }
	
	      _this.canZeroDollarErplyTransaction();
	    }).catch(function (err) {
	      _this.$auth.printCustomerGenericLogs(err);
	    }).finally(function () {
	      _this.canShowSaveCard();
	      _this.choosePaymentMethod();
	      _this.$order.printPaymentLogs(_this.$stateParams.orderId, null, " Payment page to choose payment method.").then(function (success) {
	        console.log("Successfully Printed");
	      }).catch(function (err) {
	        console.log("Failed to print logs");
	      });
	      $spinner.hide('appSpinner');
	    });
	
	    $scope.$on('$destroy', disconnect);
	
	    this.giftCardDetails = [];
	    this.giftCardDetails.push(this.getEmptyCardDetails());
	    this.MaxGiftCardsDetails = 3;
	  }
	
	  _createClass(CardDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        canSaveCard: state.auth.profile.saveCard,
	        cardInfo: state.order.paymentInfo,
	        cartDetail: state.order.cartDetail,
	        guestprofile: state.auth.guestprofile,
	        storeFeatures: state.order.storeFeatures
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'submit_withpaypalchanges_backup',
	    value: function submit_withpaypalchanges_backup() {
	      var _this2 = this;
	
	      var $ctrl = this;
	      // Un comment when terms and condition button changes needed
	      // if(!this.agreement){
	      //   this.$toaster.pop('success', 'Please Select Terms and Conditions');
	      //   return;
	      // }
	
	      if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
	        if (this.cardId) {
	          this.cardId = null;
	        }
	      }
	
	      if (!this.cardId && !this.isAllowToPayOnlyWithGiftCards && !this.isAllowToPayWithStoreCreditOnly && !this.paypalAutorizationWrapper.isPaypalAuthorized) {
	        // this.$spinner.show('appSpinner');
	        this.$toaster.pop('success', 'Please select Card to continue.');
	        return;
	      }
	
	      this.isCallingAPI = true;
	      var reqData = {};
	
	      var giftCardsRequest = [];
	      //
	      angular.forEach(this.giftCardDetails, function (item, key) {
	        if (item.isCardVerified && item.amount > 0) {
	
	          $ctrl.$spinner.show('appSpinner');
	          var giftCards = {
	
	            "giftCard": item.cardNumber,
	            "amount": item.amount,
	            "pin": item.cvv
	          };
	          $ctrl.$spinner.hide('appSpinner');
	          giftCardsRequest.push(giftCards);
	        }
	      });
	
	      // getGiftCardPreAuthRequest
	      if (this.isAllowToPayOnlyWithGiftCards) {
	        this.$spinner.show('appSpinner');
	        var getGiftCardPreAuthRequest = {
	          "getGiftCardPreAuthCardRequestList": giftCardsRequest
	        };
	        var data = {
	          "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest
	        };
	        data.orderId = this.$stateParams.orderId;
	        data.totalAmount = this.orderAmount;
	        if (this.isStoreCreditUsed) {
	          data.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	        } else {
	          data.storeCreditAmountToBeCharged = 0.00;
	        }
	
	        this.$order.paymentUsingGiftCards(data).then(function (success) {
	          // this.$spinner.show('appSpinner');
	
	          if (success.data.successCode === '0' && success.data.message === 'Approved') {
	            _this2.$spinner.hide('appSpinner');
	            _this2.$state.go('payment.success', {
	              orderId: _this2.$stateParams.orderId,
	              isCardSaved: true
	            });
	          } else {
	            _this2.$spinner.hide('appSpinner');
	            _this2.$state.go('payment.failure', {
	              orderId: _this2.$stateParams.orderId,
	              logString: JSON.stringify(success),
	              reasonCode: success.data.successCode
	            });
	          }
	        }, function (error) {
	          _this2.$spinner.hide('appSpinner');
	          _this2.$state.go('payment.failure', {
	            orderId: _this2.$stateParams.orderId,
	            logString: JSON.stringify(error),
	            reasonCode: error.data.successCode
	          });
	        }).catch(function (err) {
	          _this2.$auth.printCustomerGenericLogs(err);
	        }).finally(function () {
	          _this2.$spinner.hide('appSpinner');
	          _this2.isCallingAPI = false;
	        });
	      } else if (this.isAllowToPayWithStoreCreditOnly) {
	
	        this.$spinner.show('appSpinner');
	        reqData = {};
	        reqData.orderId = this.$stateParams.orderId;
	        reqData.totalAmount = this.orderAmount;
	        if (this.isStoreCreditUsed) {
	          reqData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	        } else {
	          reqData.storeCreditAmountToBeCharged = 0.00;
	        }
	
	        this.$order.paymentUsingStoreCredit(reqData).then(function (success) {
	          if (success.data.successCode === '200' && success.data.message === 'Approved') {
	            _this2.$spinner.hide('appSpinner');
	            _this2.$state.go('payment.success', {
	              orderId: _this2.$stateParams.orderId,
	              isCardSaved: true
	            });
	          } else {
	            _this2.$spinner.hide('appSpinner');
	            _this2.$state.go('payment.failure', {
	              orderId: _this2.$stateParams.orderId,
	              logString: JSON.stringify(success),
	              reasonCode: success.data.successCode
	            });
	          }
	        }, function (error) {
	          _this2.$spinner.hide('appSpinner');
	          _this2.$state.go('payment.failure', {
	            orderId: _this2.$stateParams.orderId,
	            logString: JSON.stringify(error),
	            reasonCode: error.data.successCode
	          });
	        }).finally(function () {
	          _this2.$spinner.hide('appSpinner');
	          _this2.isCallingAPI = false;
	        });
	      } else {
	
	        if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
	          this.$spinner.show('appSpinner');
	          var orderData = {
	            paypalCreateOrderId: this.paypalAutorizationWrapper.paypalCreateOrderId,
	            authId: this.paypalAutorizationWrapper.authId,
	            orderId: $ctrl.$stateParams.orderId
	          };
	
	          if (this.isStoreCreditUsed) {
	            orderData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	          } else {
	            orderData.storeCreditAmountToBeCharged = 0.00;
	          }
	
	          this.$order.paypalCaptureOrder(orderData).then(function (success) {
	            _this2.$spinner.hide('appSpinner');
	            if (success != null && success.data != null && success.data.successCode == "200") {
	              $ctrl.$state.go('payment.success', {
	                orderId: $ctrl.$stateParams.orderId,
	                isCardSaved: true
	              });
	            } else {
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(success.data.additionalInfo),
	                reasonCode: success.data.successCode
	              });
	            }
	          });
	        } else {
	          var cardNumber = this.cardInfo.filter(function (card) {
	            return card.id === _this2.cardId;
	          })[0].cardNumber;
	          var giftCardData = {
	            "getGiftCardPreAuthCardRequestList": giftCardsRequest
	          };
	          var dataRequest = {
	            "orderId": this.$stateParams.orderId,
	            "cardNumber": cardNumber,
	            "cardId": this.cardId,
	            "getGiftCardPreAuthRequest": giftCardData
	          };
	
	          if (this.isStoreCreditUsed) {
	            dataRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	          } else {
	            dataRequest.storeCreditAmountToBeCharged = 0.00;
	          }
	
	          // Heartland
	          if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	            this.$spinner.show('appSpinner');
	            this.$order.paymentSubmitHeartland(dataRequest).then(function (success) {
	              _this2.$spinner.hide('appSpinner');
	              if (success.data.successCode === '00' && success.data.message === _this2.heartand_Approval) {
	                _this2.$state.go('payment.success', {
	                  orderId: _this2.$stateParams.orderId,
	                  isCardSaved: true
	                });
	              } else {
	                _this2.$state.go('payment.failure', {
	                  orderId: _this2.$stateParams.orderId,
	                  logString: JSON.stringify(success),
	                  reasonCode: success.data.successCode
	                });
	              }
	            }, function (error) {
	              _this2.$spinner.hide('appSpinner');
	              _this2.$state.go('payment.failure', {
	                orderId: _this2.$stateParams.orderId,
	                logString: JSON.stringify(error),
	                reasonCode: error.data.successCode
	              });
	            }).catch(function (err) {
	              _this2.$auth.printCustomerGenericLogs(err);
	            }).finally(function () {
	              _this2.$spinner.hide('appSpinner');
	              _this2.isCallingAPI = false;
	            });
	          }
	
	          // Tsys
	          else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
	              this.$spinner.show('appSpinner');
	              this.$order.paymentSubmitTsys(dataRequest).then(function (success) {
	                _this2.$spinner.hide('appSpinner');
	                if (success.data.successCode === '00' && success.data.message === _this2.heartand_Approval) {
	                  _this2.$state.go('payment.success', {
	                    orderId: _this2.$stateParams.orderId,
	                    isCardSaved: true
	                  });
	                } else {
	                  _this2.$state.go('payment.failure', {
	                    orderId: _this2.$stateParams.orderId,
	                    logString: JSON.stringify(success),
	                    reasonCode: success.data.successCode
	                  });
	                }
	              }, function (error) {
	                _this2.$spinner.hide('appSpinner');
	                _this2.$state.go('payment.failure', {
	                  orderId: _this2.$stateParams.orderId,
	                  logString: JSON.stringify(error),
	                  reasonCode: error.data.successCode
	                });
	              }).catch(function (err) {
	                _this2.$auth.printCustomerGenericLogs(err);
	              }).finally(function () {
	                _this2.$spinner.hide('appSpinner');
	                _this2.isCallingAPI = false;
	              });
	            }
	
	            // Moneris
	            else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
	                this.$spinner.show('appSpinner');
	                this.$order.paymentSubmitMoneris(dataRequest).then(function (success) {
	                  _this2.$spinner.hide('appSpinner');
	                  if (success.data.successCode === '00' && success.data.message === _this2.heartand_Approval) {
	                    _this2.$state.go('payment.success', {
	                      orderId: _this2.$stateParams.orderId,
	                      isCardSaved: true
	                    });
	                  } else {
	                    _this2.$state.go('payment.failure', {
	                      orderId: _this2.$stateParams.orderId,
	                      logString: JSON.stringify(success),
	                      reasonCode: success.data.successCode
	                    });
	                  }
	                }, function (error) {
	                  _this2.$spinner.hide('appSpinner');
	                  _this2.$state.go('payment.failure', {
	                    orderId: _this2.$stateParams.orderId,
	                    logString: JSON.stringify(error),
	                    reasonCode: error.data.successCode
	                  });
	                }).catch(function (err) {
	                  _this2.$auth.printCustomerGenericLogs(err);
	                }).finally(function () {
	                  _this2.$spinner.hide('appSpinner');
	                  _this2.isCallingAPI = false;
	                });
	              }
	
	              // Worldpay
	              else {
	                  this.$spinner.show('appSpinner');
	                  var worldpayData = {};
	                  worldpayData.getGiftCardPreAuthRequest = giftCardData;
	
	                  if (this.isStoreCreditUsed) {
	                    worldpayData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	                  } else {
	                    worldpayData.storeCreditAmountToBeCharged = 0.00;
	                  }
	
	                  this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, worldpayData).then(function (success) {
	                    _this2.$spinner.hide('appSpinner');
	                    if (success.data.successCode === '0' && success.data.message === 'Approved') {
	                      _this2.$state.go('payment.success', {
	                        orderId: _this2.$stateParams.orderId,
	                        isCardSaved: true
	                      });
	                    } else {
	                      _this2.$state.go('payment.failure', {
	                        orderId: _this2.$stateParams.orderId,
	                        logString: JSON.stringify(success),
	                        reasonCode: success.data.successCode
	                      });
	                    }
	                  }, function (error) {
	                    if (error.data) {
	                      _this2.$spinner.hide('appSpinner');
	                      if (error.data.errorCode && error.data.errorCode === 704) {
	                        _this2.$state.go('cart');
	                        _this2.$toaster.pop('success', error.data.message);
	                      } else {
	                        _this2.$state.go('payment.failure', {
	                          orderId: _this2.$stateParams.orderId,
	                          logString: JSON.stringify(error),
	                          reasonCode: error.data.successCode
	                        });
	                      }
	                    }
	                  }).finally(function () {
	                    _this2.$spinner.hide('appSpinner');
	                    _this2.isCallingAPI = false;
	                  });
	                }
	        }
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      var $ctrl = this;
	      // Un comment when terms and condition button changes needed
	      if (!this.agreement) {
	        this.$toaster.pop('success', 'Please Select Terms and Conditions');
	        return;
	      }
	
	      if (!this.cardId && !this.isAllowToPayOnlyWithGiftCards && !this.isAllowToPayWithStoreCreditOnly && !this.payWithPayPalVaultButton) {
	        // this.$spinner.show('appSpinner');
	        this.$toaster.pop('success', 'Please select Card to continue.');
	        return;
	      }
	
	      this.isCallingAPI = true;
	      var reqData = {};
	
	      var giftCardsRequest = [];
	      //
	      angular.forEach(this.giftCardDetails, function (item, key) {
	        if (item.isCardVerified && item.amount > 0) {
	
	          $ctrl.$spinner.show('appSpinner');
	          var giftCards = {
	
	            "giftCard": item.cardNumber,
	            "amount": item.amount,
	            "pin": item.cvv
	          };
	          $ctrl.$spinner.hide('appSpinner');
	          giftCardsRequest.push(giftCards);
	        }
	      });
	
	      // getGiftCardPreAuthRequest
	      if (this.isAllowToPayOnlyWithGiftCards) {
	        this.$spinner.show('appSpinner');
	        var getGiftCardPreAuthRequest = {
	          "getGiftCardPreAuthCardRequestList": giftCardsRequest
	        };
	        var data = {
	          "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest
	        };
	        data.orderId = this.$stateParams.orderId;
	        data.totalAmount = this.orderAmount;
	        if (this.isStoreCreditUsed) {
	          data.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	        } else {
	          data.storeCreditAmountToBeCharged = 0.00;
	        }
	
	        this.$order.paymentUsingGiftCards(data).then(function (success) {
	          // this.$spinner.show('appSpinner');
	
	          if (success.data.successCode === '0' && success.data.message === 'Approved') {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.success', {
	              orderId: _this3.$stateParams.orderId,
	              isCardSaved: true
	            });
	          } else {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.failure', {
	              orderId: _this3.$stateParams.orderId,
	              logString: JSON.stringify(success),
	              reasonCode: success.data.successCode
	            });
	          }
	        }, function (error) {
	          _this3.$spinner.hide('appSpinner');
	          _this3.$state.go('payment.failure', {
	            orderId: _this3.$stateParams.orderId,
	            logString: JSON.stringify(error),
	            reasonCode: error.data.successCode
	          });
	        }).catch(function (err) {
	          _this3.$auth.printCustomerGenericLogs(err);
	        }).finally(function () {
	          _this3.$spinner.hide('appSpinner');
	          _this3.isCallingAPI = false;
	        });
	      } else if (this.isAllowToPayWithStoreCreditOnly) {
	
	        this.$spinner.show('appSpinner');
	        reqData = {};
	        reqData.orderId = this.$stateParams.orderId;
	        reqData.totalAmount = this.orderAmount;
	        if (this.isStoreCreditUsed) {
	          reqData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	        } else {
	          reqData.storeCreditAmountToBeCharged = 0.00;
	        }
	
	        this.$order.paymentUsingStoreCredit(reqData).then(function (success) {
	          if (success.data.successCode === '200' && success.data.message === 'Approved') {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.success', {
	              orderId: _this3.$stateParams.orderId,
	              isCardSaved: true
	            });
	          } else {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.failure', {
	              orderId: _this3.$stateParams.orderId,
	              logString: JSON.stringify(success),
	              reasonCode: success.data.successCode
	            });
	          }
	        }, function (error) {
	          _this3.$spinner.hide('appSpinner');
	          _this3.$state.go('payment.failure', {
	            orderId: _this3.$stateParams.orderId,
	            logString: JSON.stringify(error),
	            reasonCode: error.data.successCode
	          });
	        }).finally(function () {
	          _this3.$spinner.hide('appSpinner');
	          _this3.isCallingAPI = false;
	        });
	      } else if (this.payWithPayPalVaultButton) {
	        // paypal vault
	        this.$spinner.show('appSpinner');
	        var getGiftCardPreAuthRequest1 = {
	          "getGiftCardPreAuthCardRequestList": giftCardsRequest
	        };
	        var dataForPaypalVaultRequest = {
	          "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest1
	        };
	        dataForPaypalVaultRequest.orderId = this.$stateParams.orderId;
	        dataForPaypalVaultRequest.totalAmount = this.orderAmount;
	        if (this.isStoreCreditUsed) {
	          dataForPaypalVaultRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	        } else {
	          dataForPaypalVaultRequest.storeCreditAmountToBeCharged = 0.00;
	        }
	        dataForPaypalVaultRequest.saveVault = this.savePaypalVault;
	        dataForPaypalVaultRequest.proceedingWithVault = true;
	
	        this.$order.paypalCreateVaultOrder(dataForPaypalVaultRequest).then(function (success) {
	          if (success.data.successCode === '200' && success.data.message === 'Approved') {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.success', {
	              orderId: _this3.$stateParams.orderId,
	              isCardSaved: true
	            });
	          } else {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.failure', {
	              orderId: _this3.$stateParams.orderId,
	              logString: JSON.stringify(success),
	              reasonCode: success.data.successCode
	            });
	          }
	        }, function (error) {
	          _this3.$spinner.hide('appSpinner');
	          _this3.$state.go('payment.failure', {
	            orderId: _this3.$stateParams.orderId,
	            logString: JSON.stringify(error),
	            reasonCode: error.data.successCode
	          });
	        }).finally(function () {
	          _this3.$spinner.hide('appSpinner');
	          _this3.isCallingAPI = false;
	        });
	      } else {
	        var cardNumber = this.cardInfo.filter(function (card) {
	          return card.id === _this3.cardId;
	        })[0].cardNumber;
	        var giftCardData = {
	          "getGiftCardPreAuthCardRequestList": giftCardsRequest
	        };
	        var dataRequest = {
	          "orderId": this.$stateParams.orderId,
	          "cardNumber": cardNumber,
	          "cardId": this.cardId,
	          "getGiftCardPreAuthRequest": giftCardData
	        };
	
	        if (this.isStoreCreditUsed) {
	          dataRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	        } else {
	          dataRequest.storeCreditAmountToBeCharged = 0.00;
	        }
	
	        // Heartland
	        if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	          this.$spinner.show('appSpinner');
	          this.$order.paymentSubmitHeartland(dataRequest).then(function (success) {
	            _this3.$spinner.hide('appSpinner');
	            if (success.data.successCode === '00' && success.data.message === _this3.heartand_Approval) {
	              _this3.$state.go('payment.success', {
	                orderId: _this3.$stateParams.orderId,
	                isCardSaved: true
	              });
	            } else {
	              _this3.$state.go('payment.failure', {
	                orderId: _this3.$stateParams.orderId,
	                logString: JSON.stringify(success),
	                reasonCode: success.data.successCode
	              });
	            }
	          }, function (error) {
	            _this3.$spinner.hide('appSpinner');
	            _this3.$state.go('payment.failure', {
	              orderId: _this3.$stateParams.orderId,
	              logString: JSON.stringify(error),
	              reasonCode: error.data.successCode
	            });
	          }).catch(function (err) {
	            _this3.$auth.printCustomerGenericLogs(err);
	          }).finally(function () {
	            _this3.$spinner.hide('appSpinner');
	            _this3.isCallingAPI = false;
	          });
	        }
	
	        // Tsys
	        else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
	            this.$spinner.show('appSpinner');
	            this.$order.paymentSubmitTsys(dataRequest).then(function (success) {
	              _this3.$spinner.hide('appSpinner');
	              if (success.data.successCode === '00' && success.data.message === _this3.heartand_Approval) {
	                _this3.$state.go('payment.success', {
	                  orderId: _this3.$stateParams.orderId,
	                  isCardSaved: true
	                });
	              } else {
	                _this3.$state.go('payment.failure', {
	                  orderId: _this3.$stateParams.orderId,
	                  logString: JSON.stringify(success),
	                  reasonCode: success.data.successCode
	                });
	              }
	            }, function (error) {
	              _this3.$spinner.hide('appSpinner');
	              _this3.$state.go('payment.failure', {
	                orderId: _this3.$stateParams.orderId,
	                logString: JSON.stringify(error),
	                reasonCode: error.data.successCode
	              });
	            }).catch(function (err) {
	              _this3.$auth.printCustomerGenericLogs(err);
	            }).finally(function () {
	              _this3.$spinner.hide('appSpinner');
	              _this3.isCallingAPI = false;
	            });
	          }
	
	          // Moneris
	          else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
	              this.$spinner.show('appSpinner');
	              this.$order.paymentSubmitMoneris(dataRequest).then(function (success) {
	                _this3.$spinner.hide('appSpinner');
	                if (success.data.successCode === '00' && success.data.message === _this3.heartand_Approval) {
	                  _this3.$state.go('payment.success', {
	                    orderId: _this3.$stateParams.orderId,
	                    isCardSaved: true
	                  });
	                } else {
	                  _this3.$state.go('payment.failure', {
	                    orderId: _this3.$stateParams.orderId,
	                    logString: JSON.stringify(success),
	                    reasonCode: success.data.successCode
	                  });
	                }
	              }, function (error) {
	                _this3.$spinner.hide('appSpinner');
	                _this3.$state.go('payment.failure', {
	                  orderId: _this3.$stateParams.orderId,
	                  logString: JSON.stringify(error),
	                  reasonCode: error.data.successCode
	                });
	              }).catch(function (err) {
	                _this3.$auth.printCustomerGenericLogs(err);
	              }).finally(function () {
	                _this3.$spinner.hide('appSpinner');
	                _this3.isCallingAPI = false;
	              });
	            }
	
	            // Worldpay
	            else {
	                this.$spinner.show('appSpinner');
	                var worldpayData = {};
	                worldpayData.getGiftCardPreAuthRequest = giftCardData;
	
	                if (this.isStoreCreditUsed) {
	                  worldpayData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	                } else {
	                  worldpayData.storeCreditAmountToBeCharged = 0.00;
	                }
	
	                this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, worldpayData).then(function (success) {
	                  _this3.$spinner.hide('appSpinner');
	                  if (success.data.successCode === '0' && success.data.message === 'Approved') {
	                    _this3.$state.go('payment.success', {
	                      orderId: _this3.$stateParams.orderId,
	                      isCardSaved: true
	                    });
	                  } else {
	                    _this3.$state.go('payment.failure', {
	                      orderId: _this3.$stateParams.orderId,
	                      logString: JSON.stringify(success),
	                      reasonCode: success.data.successCode
	                    });
	                  }
	                }, function (error) {
	                  if (error.data) {
	                    _this3.$spinner.hide('appSpinner');
	                    if (error.data.errorCode && error.data.errorCode === 704) {
	                      _this3.$state.go('cart');
	                      _this3.$toaster.pop('success', error.data.message);
	                    } else {
	                      _this3.$state.go('payment.failure', {
	                        orderId: _this3.$stateParams.orderId,
	                        logString: JSON.stringify(error),
	                        reasonCode: error.data.successCode
	                      });
	                    }
	                  }
	                }).finally(function () {
	                  _this3.$spinner.hide('appSpinner');
	                  _this3.isCallingAPI = false;
	                });
	              }
	      }
	    }
	  }, {
	    key: 'paymentByNewCard',
	    value: function paymentByNewCard() {
	      var _this4 = this;
	
	      var device = this.getDeviceParameter();
	      this.isCallingAPI = true;
	      // Un comment when terms and condition button changes needed
	      // if(!this.agreement)
	      // {
	      //   this.$toaster.pop('success', 'Please Select Terms and Conditions');
	      //   this.isCallingAPI = false;
	      //   return;
	      // }
	
	      if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
	        // this.$spinner.show('appSpinner');
	        // New card payment doesn't allowed when paypal is used.
	        this.$toaster.pop('success', 'Paypal Authorized succefully.');
	        this.submit();
	        return;
	      }
	
	      var giftCardsRequest = [];
	      angular.forEach(this.giftCardDetails, function (item, key) {
	        if (item.isCardVerified && item.amount > 0) {
	          var giftCards = {
	            "giftCard": item.cardNumber,
	            "amount": item.amount,
	            "pin": item.cvv
	          };
	          giftCardsRequest.push(giftCards);
	        }
	      });
	      var giftCardData = {
	        "getGiftCardPreAuthCardRequestList": giftCardsRequest
	      };
	
	      var dataRequest = {
	        "getGiftCardPreAuthRequest": giftCardData
	      };
	
	      if (this.isStoreCreditUsed) {
	        dataRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
	      } else {
	        dataRequest.storeCreditAmountToBeCharged = 0.00;
	      }
	
	      // New card payment by heartland
	      if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	        this.$spinner.show('appSpinner');
	
	        // Function to save giftcardRequest in orderservice
	        // this.$order.setGiftCardRequest(giftCardsRequest);
	
	        this.showHeartLandPage = true;
	        this.giftCardsRequest = giftCardsRequest;
	        // this.callHeartLandPage(giftCardsRequest);
	        this.callHeartLandCustom(giftCardsRequest, this.getStoreCredit());
	        this.$spinner.hide('appSpinner');
	      }
	      // New card payment by Tsys
	      else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
	          this.$spinner.show('appSpinner');
	          this.showHeartLandPage = false;
	          this.giftCardsRequest = giftCardsRequest;
	          this.callTsysCustom(giftCardsRequest, this.getStoreCredit());
	          this.$spinner.hide('appSpinner');
	        }
	        // New card payment by Moneris
	        else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
	            this.$spinner.show('appSpinner');
	            this.showHeartLandPage = false;
	            this.giftCardsRequest = giftCardsRequest;
	            this.callMonerisCustom(giftCardsRequest, this.getStoreCredit());
	            this.$spinner.hide('appSpinner');
	          }
	          // New card payment by Worldpay
	          else {
	              this.$spinner.show('appSpinner');
	              this.$order.initializePayment(this.$stateParams.orderId, device, dataRequest).then(function (success) {
	                _this4.$spinner.hide('appSpinner');
	                if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
	                  _this4.$toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
	                  return;
	                }
	                _this4.goToMerchantPage(success.data);
	              }, function (err) {
	                // console.log(err);
	                if (err.data) {
	                  if (err.data.errorCode && err.data.errorCode === 704) {
	                    _this4.$state.go('cart');
	                  }
	                }
	                _this4.$spinner.hide('appSpinner');
	                _this4.$toaster.pop('success', err.data.message);
	                _this4.isCallingAPI = false;
	              }).catch(function (err) {
	                _this4.$auth.printCustomerGenericLogs(err);
	              });
	            }
	    }
	  }, {
	    key: 'goToMerchantPage',
	    value: function goToMerchantPage(data, method) {
	      method = method || 'post';
	
	      var form = document.createElement('form');
	      form.setAttribute('method', method);
	      form.setAttribute('action', data.message);
	
	      var payIdField = document.createElement('input');
	      payIdField.setAttribute('type', 'hidden');
	      payIdField.setAttribute('name', 'PaymentID');
	      payIdField.setAttribute('value', data.additionalInfo);
	      form.appendChild(payIdField);
	
	      var returnMethodField = document.createElement('input');
	      returnMethodField.setAttribute('type', 'hidden');
	      returnMethodField.setAttribute('name', 'ReturnMethod');
	      returnMethodField.setAttribute('value', 'POST');
	      form.appendChild(returnMethodField);
	
	      document.body.appendChild(form);
	      form.submit();
	    }
	  }, {
	    key: 'getDeviceParameter',
	    value: function getDeviceParameter() {
	      if (window.innerWidth <= 576) {
	        return 'm';
	      } else if (window.innerWidth > 576 && window.innerWidth <= 768) {
	        return 't';
	      } else if (window.innerWidth > 768) {
	        return 'd';
	      }
	    }
	  }, {
	    key: 'addCard',
	    value: function addCard(index) {
	
	      var amountminusgift = this.orderAmount - this.amountToBeChargedFromStoreCredit - this.getTotalGiftCardAddedAmount();
	      amountminusgift = this.getRoundoffValue(amountminusgift, this.toDecimalPlaces);
	      if (amountminusgift == 0) {
	        this.isAllowedToAdd = false;
	        this.$toaster.pop('success', "Total amount is already covered.");
	        return;
	      }
	
	      this.isAllowedToAddCard();
	      this.canZeroDollarErplyTransaction();
	      if (this.isAllowedToAdd) {
	        if (this.orderAmount <= this.getTotalGiftCardAddedAmount()) {
	          this.$toaster.pop('success', 'Gift Card amount has reached the limit');
	        } else {
	          var isCardVerified = this.giftCardDetails[index].isCardVerified;
	          if (isCardVerified) {
	            if (this.giftCardDetails.length < this.MaxGiftCardsDetails) {
	              this.giftCardDetails.push(this.getEmptyCardDetails());
	            }
	          } else {
	            this.$toaster.pop('success', 'Please apply the card');
	          }
	        }
	      } else {
	        this.$toaster.pop('success', 'Please apply the card');
	      }
	    }
	  }, {
	    key: 'removeCard',
	    value: function removeCard(index) {
	
	      var total = 0;
	      this.isAllowedToAdd = true;
	      if (this.giftCardDetails.length >= 1) {
	        // this.giftCardDetails.push(this.getEmptyCardDetails());
	        if (this.giftCardDetails[index].isCardVerified) {
	          var removeIndex = this.giftCardNumbers.indexOf(this.giftCardDetails[index].cardNumber);
	          this.giftCardNumbers.splice(removeIndex, 1);
	        }
	        this.giftCardDetails.splice(index, 1);
	        // Pushing empty if all giftcards removed
	        if (this.giftCardDetails.length < 1) {
	          this.giftCardDetails.push(this.getEmptyCardDetails());
	        }
	      }
	      var previousTotalAmount = 0.00;
	      for (var i = 0; i < this.giftCardDetails.length; i++) {
	        console.log(this.giftCardDetails[i].actualAmount);
	        if (this.giftCardDetails[i].actualAmount > 0) {
	          total = total + this.giftCardDetails[i].actualAmount;
	
	          if (this.isStoreCreditUsed) {
	            this.amountMinusStoreCredit = this.orderAmount - this.amountToBeChargedFromStoreCredit;
	            if (this.amountMinusStoreCredit >= total) {
	              this.isAllowedToAdd = true;
	              this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
	              previousTotalAmount = previousTotalAmount + this.giftCardDetails[i].amount;
	            } else {
	              if (this.amountMinusStoreCredit - previousTotalAmount > this.giftCardDetails[i].actualAmount) {
	                this.isAllowedToAdd = true;
	                this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
	              } else {
	                this.isAllowedToAdd = false;
	                this.giftCardDetails[i].amount = this.getRoundoffValue(this.amountMinusStoreCredit - previousTotalAmount, this.toDecimalPlaces);
	              }
	            }
	          } else {
	            if (this.orderAmount >= total) {
	              this.isAllowedToAdd = true;
	              this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
	              previousTotalAmount = previousTotalAmount + this.giftCardDetails[i].amount;
	            } else {
	              if (this.orderAmount - previousTotalAmount > this.giftCardDetails[i].actualAmount) {
	                this.isAllowedToAdd = true;
	                this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
	              } else {
	                this.isAllowedToAdd = false;
	                this.giftCardDetails[i].amount = this.getRoundoffValue(this.orderAmount - previousTotalAmount, this.toDecimalPlaces);
	              }
	            }
	          }
	        }
	      }
	      if (this.orderAmount > 0) {
	        this.setIsAllowToPayOnlyWithGiftCards();
	      }
	      this.getStoreCreditAmountToBeCharged();
	      this.canZeroDollarErplyTransaction();
	    }
	  }, {
	    key: 'getRoundoffValue',
	    value: function getRoundoffValue(number, places) {
	      // console.log(" number.toFixed(places) : "+  number.toFixed(places));
	      return parseFloat(number.toFixed(places));
	    }
	  }, {
	    key: 'getEmptyCardDetails',
	    value: function getEmptyCardDetails() {
	      return {
	        "cardNumber": '',
	        "cvv": '',
	        "isCardVerified": false,
	        "amount": 0.00,
	        "isAllowedToAdd": true,
	        "actualAmount": 0.00
	      };
	    }
	  }, {
	    key: 'verifyCard',
	    value: function verifyCard(index) {
	      var _this5 = this;
	
	      this.waitUntilVerify = true;
	      var giftCardExits = this.giftCardNumbers.filter(function (gift) {
	        return gift === _this5.giftCardDetails[index].cardNumber;
	      });
	      // console.log("giftCardExits",giftCardExits);
	      var data = {
	        "giftCard": this.giftCardDetails[index].cardNumber
	      };
	      if (giftCardExits.length != 0) {
	        this.waitUntilVerify = false;
	        this.$toaster.pop('success', 'The gift card has added already');
	      } else {
	        this.validateGiftCardDetails(data, index);
	      }
	      //  this.validateGiftCardDetails(data,index);
	    }
	  }, {
	    key: 'validateGiftCardDetails',
	    value: function validateGiftCardDetails(data, index) {
	      var _this6 = this;
	
	      this.$order.validateGiftCardDetails(data).then(function (success) {
	        // console.log("success", success);
	        if (success.data.amount > 0) {
	          _this6.giftCardDetails[index].actualAmount = success.data.amount;
	          _this6.giftCardDetails[index].amount = _this6.getRoundoffValue(_this6.validateBalanceAmount(index, success.data.amount), _this6.toDecimalPlaces);
	          _this6.giftCardDetails[index].isCardVerified = true;
	          _this6.giftCardNumbers.push(_this6.giftCardDetails[index].cardNumber);
	        } else {
	          _this6.$toaster.pop('success', "Entered Gift card has zero balance and hence can't be applied");
	        }
	        _this6.isAllowedToAddCard();
	        if (_this6.orderAmount > 0) {
	          _this6.setIsAllowToPayOnlyWithGiftCards();
	        }
	        _this6.waitUntilVerify = false;
	      }, function (error) {
	        _this6.waitUntilVerify = false;
	        _this6.$toaster.pop('success', error.data.message);
	        // console.log("error", error);
	        _this6.giftCardDetails[index].amount = 0.00;
	        _this6.giftCardDetails[index].isCardVerified = false;
	      }).catch(function (err) {
	        _this6.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        _this6.choosePaymentMethod();
	        _this6.getStoreCreditAmountToBeCharged();
	        _this6.$spinner.hide('appSpinner');
	      });
	    }
	  }, {
	    key: 'isAllowedToAddCard',
	    value: function isAllowedToAddCard() {
	
	      // Allow to show add or remove if only one giftcard
	      if (this.giftCardDetails.length == 1) {
	        this.isAllowedToAdd = true;
	        this.isAllowedToRemove = true;
	      } else {
	
	        if (this.isStoreCreditUsed) {
	          var amountminusStoreCredit = this.orderAmount - this.getStoreCredit();
	          if (amountminusStoreCredit == 0) {
	            this.isAllowedToAdd = false;
	            this.$toaster.pop('success', 'Total amount has already covered up');
	            return;
	          }
	        }
	        var count = 0;
	        // Validate to add card across all the giftcards
	        angular.forEach(this.giftCardDetails, function (item, key) {
	          if (item) {
	            count = count + (item.isCardVerified ? 1 : 0);
	          }
	        });
	        // console.log("count",count);
	        // console.log(this.giftCardDetails.length);
	        if (count == this.giftCardDetails.length) {
	          this.isAllowedToAdd = true;
	        } else {
	          this.isAllowedToAdd = false;
	        }
	      }
	    }
	  }, {
	    key: 'validateBalanceAmount',
	    value: function validateBalanceAmount(index, amount) {
	      var total = 0.00;
	      var giftCardAmountAddedSofar = 0.00;
	      angular.forEach(this.giftCardDetails, function (item, key) {
	        if (item) {
	          total = total + item.amount;
	        }
	      });
	      giftCardAmountAddedSofar = total;
	      total = total + amount;
	
	      if (this.isStoreCreditUsed) {
	        this.amountMinusStoreCredit = this.orderAmount - this.amountToBeChargedFromStoreCredit;
	        this.amountMinusStoreCredit = this.getRoundoffValue(this.amountMinusStoreCredit, this.toDecimalPlaces);
	        if (this.amountMinusStoreCredit < amount) {
	          if (this.amountMinusStoreCredit - giftCardAmountAddedSofar < amount) {
	            this.isAllowedToAdd = false;
	            return this.amountMinusStoreCredit - giftCardAmountAddedSofar;
	          } else {
	            this.isAllowedToAdd = false;
	            return this.amountMinusStoreCredit;
	          }
	        } else if (this.amountMinusStoreCredit >= total) {
	          this.isAllowedToAdd = true;
	          return amount;
	        } else {
	          this.isAllowedToAdd = false;
	          if (total - this.amountMinusStoreCredit > amount) {
	            return amount;
	          } else {
	            return amount - (total - this.amountMinusStoreCredit);
	          }
	        }
	      } else {
	        if (this.orderAmount < amount) {
	          if (this.orderAmount - giftCardAmountAddedSofar < amount) {
	            this.isAllowedToAdd = false;
	            return this.orderAmount - giftCardAmountAddedSofar;
	          } else {
	            this.isAllowedToAdd = false;
	            return this.orderAmount;
	          }
	        } else if (this.orderAmount >= total) {
	          this.isAllowedToAdd = true;
	          return amount;
	        } else {
	          if (total - this.orderAmount > amount) {
	            this.isAllowedToAdd = false;
	            return amount;
	          } else {
	            this.isAllowedToAdd = false;
	            return amount - (total - this.orderAmount);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      return this.$auth.isMobileDevice();
	    }
	  }, {
	    key: 'getTotalGiftCardAddedAmount',
	    value: function getTotalGiftCardAddedAmount() {
	      var total = 0.00;
	      angular.forEach(this.giftCardDetails, function (item, key) {
	        if (item) {
	          total = total + item.amount;
	        }
	      });
	      return this.getRoundoffValue(total, this.toDecimalPlaces);
	      // return total;
	    }
	
	    // isIpad() {
	    //   return this.$order.isIpad();
	    // }
	
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isIpadPotrait',
	    value: function isIpadPotrait() {
	      if (this.isIpad()) {
	        return this.$window.innerWidth < 785;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'isIpadLandscape',
	    value: function isIpadLandscape() {
	      if (this.isIpad()) {
	        return this.$window.innerWidth > 1037;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'cartContainsOnlyGift',
	    value: function cartContainsOnlyGift() {
	      var totalItemsInCart = this.cartDetail.cartItems.length;
	      var isCardhasGiftOnly = this.cartContainsGiftCard();
	      return isCardhasGiftOnly && totalItemsInCart === this.cartContainsGiftCard();
	    }
	  }, {
	    key: 'cartContainsGiftCard',
	    value: function cartContainsGiftCard() {
	      var _this7 = this;
	
	      return this.cartDetail.cartItems ? this.cartDetail.cartItems.filter(function (item) {
	        var masterCode = item.item.masterProduct.masterCode;
	        var seriesNumber = masterCode.charAt(0);
	        var categoryId = item.item.masterProduct.category.id;
	        return seriesNumber === '9' && categoryId === _this7.isMiscelleneousCategory;
	      }).length : false;
	    }
	  }, {
	    key: 'callHeartLandCustom',
	    value: function callHeartLandCustom(giftCardsRequest, storeCreditAmountCharged) {
	      this.giftCardsRequest = giftCardsRequest;
	      this.showHeartLandPage = true;
	      var useStoreCreditflag = false;
	      if (this.isStoreCreditAmountTobeUsed()) {
	        useStoreCreditflag = true;
	      }
	
	      this.$state.go('payment-detail', { giftcardReq: this.giftCardsRequest, storeCreditAmountToBeCharged: this.amountToBeChargedFromStoreCredit });
	    }
	  }, {
	    key: 'callTsysCustom',
	    value: function callTsysCustom(giftCardsRequest, storeCreditAmountCharged) {
	      this.giftCardsRequest = giftCardsRequest;
	      this.showHeartLandPage = true;
	      var useStoreCreditflag = false;
	      if (this.isStoreCreditAmountTobeUsed()) {
	        useStoreCreditflag = true;
	      }
	
	      this.$state.go('tsys-payment', { giftcardReq: this.giftCardsRequest, storeCreditAmountToBeCharged: this.amountToBeChargedFromStoreCredit });
	    }
	  }, {
	    key: 'callMonerisCustom',
	    value: function callMonerisCustom(giftCardsRequest, storeCreditAmountCharged) {
	      this.giftCardsRequest = giftCardsRequest;
	      this.showHeartLandPage = true;
	      var useStoreCreditflag = false;
	      if (this.isStoreCreditAmountTobeUsed()) {
	        useStoreCreditflag = true;
	      }
	
	      this.$state.go('moneris-payment', { giftcardReq: this.giftCardsRequest, storeCreditAmountToBeCharged: this.amountToBeChargedFromStoreCredit });
	    }
	  }, {
	    key: 'canZeroDollarErplyTransaction',
	    value: function canZeroDollarErplyTransaction() {
	      console.log("this.giftCardDetails[0].isCardVerified : ", this.giftCardDetails[0].isCardVerified);
	      /*
	      if (this.orderAmount == 0.00 && this.isErplyStore && !this.isAllowToPayOnlyWithGiftCards) {
	        if((this.giftCardDetails.length == 1 && !this.giftCardDetails[0].isCardVerified)){
	          this.allowErplyZeroDollarTrasaction = true;
	        } else {
	          this.allowErplyZeroDollarTrasaction = false;
	        }
	      } else {
	        this.allowErplyZeroDollarTrasaction = false;
	      }
	      */
	    }
	  }, {
	    key: 'doErplyZeroDollarTransaction',
	    value: function doErplyZeroDollarTransaction() {
	      var _this8 = this;
	
	      this.$spinner.show('appSpinner');
	      this.$order.doErplyZeroDollarTransaction(this.$stateParams.orderId).then(function (success) {
	        // this.$spinner.show('appSpinner');
	
	        if (success.data.successCode === '0' && success.data.message === 'Approved') {
	          _this8.$spinner.hide('appSpinner');
	          _this8.$state.go('payment.success', {
	            orderId: _this8.$stateParams.orderId,
	            isCardSaved: true
	          });
	        } else {
	          _this8.$spinner.hide('appSpinner');
	          _this8.$state.go('payment.failure', {
	            orderId: _this8.$stateParams.orderId,
	            logString: JSON.stringify(success),
	            reasonCode: success.data.successCode
	          });
	        }
	      }, function (error) {
	        _this8.$spinner.hide('appSpinner');
	        _this8.$state.go('payment.failure', {
	          orderId: _this8.$stateParams.orderId,
	          logString: JSON.stringify(error),
	          reasonCode: error.data.successCode
	        });
	      }).catch(function (err) {
	        _this8.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {
	        _this8.$spinner.hide('appSpinner');
	        _this8.isCallingAPI = false;
	      });
	    }
	  }, {
	    key: 'toggleSaveUserCard',
	    value: function toggleSaveUserCard(saveCard) {
	      console.log("SaveCard : " + saveCard);
	      this.$order.canSaveUserCard(saveCard);
	    }
	  }, {
	    key: 'isGuestProfile',
	    value: function isGuestProfile() {
	      if (!this.profile || !this.profile.customer || this.profile.customer.isGuest) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'canShowSaveCard',
	    value: function canShowSaveCard() {
	      if (this.profile && this.profile.customer) {
	        if (this.profile.customer.isGuest) {
	          this.showSavedCard = false;
	        } else {
	          this.showSavedCard = true;
	          if (this.cardInfo != null && this.cardInfo.length > 0) {
	            this.paymentMethods.push({
	              "value": "savedCard",
	              "name": "Pay with saved card",
	              "logo": false,
	              "cardLogo": true,
	              "id": "savedcard-pay-now",
	              "lastChoosen": false,
	              "type": "unique",
	              "disable": false,
	              "order": 2
	            });
	          }
	        }
	      } else {
	        this.showSavedCard = false;
	      }
	    }
	  }, {
	    key: 'initializePaypal',
	    value: function initializePaypal() {
	      var $ctrl = this;
	      console.log("paypal integration ----> ", window.paypal);
	
	      if (window.paypal && window.paypal.Buttons) {
	        var button = window.paypal.Buttons({
	          style: {
	            shape: "rect",
	            layout: "vertical",
	            color: "white",
	            label: "paypal",
	            tagline: false
	          },
	
	          createOrder: function createOrder() {
	            var _this9 = this;
	
	            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	              var giftCardsRequest, giftCardData, dataRequest, success;
	              return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      giftCardsRequest = [];
	
	                      angular.forEach($ctrl.giftCardDetails, function (item, key) {
	                        if (item.isCardVerified && item.amount > 0) {
	
	                          $ctrl.$spinner.show('appSpinner');
	                          var giftCards = {
	
	                            "giftCard": item.cardNumber,
	                            "amount": item.amount,
	                            "pin": item.cvv
	                          };
	                          $ctrl.$spinner.hide('appSpinner');
	                          giftCardsRequest.push(giftCards);
	                        }
	                      });
	                      giftCardData = {
	                        "getGiftCardPreAuthCardRequestList": giftCardsRequest
	                      };
	                      dataRequest = {
	                        "orderId": $ctrl.$stateParams.orderId,
	                        "getGiftCardPreAuthRequest": giftCardData
	                      };
	                      _context.next = 6;
	                      return $ctrl.$order.paypalCreateOrder(dataRequest);
	
	                    case 6:
	                      success = _context.sent;
	                      return _context.abrupt('return', success.data.id);
	
	                    case 8:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, _this9);
	            }))();
	          },
	          onApprove: function onApprove(data, actions) {
	            var _this10 = this;
	
	            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	              var orderData, success;
	              return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                  switch (_context2.prev = _context2.next) {
	                    case 0:
	                      // console.log("Inside OnApprove data ---", data);
	                      // console.log("Inside OnApprove actions ---", actions);
	                      orderData = {
	                        paypalCreateOrderId: data.orderID,
	                        orderId: $ctrl.$stateParams.orderId
	                      };
	                      _context2.next = 3;
	                      return $ctrl.$order.paypalCaptureOrder(orderData).then(function (success) {
	                        if (success != null && success.data != null && success.data.successCode == "200") {
	                          $ctrl.$state.go('payment.success', {
	                            orderId: $ctrl.$stateParams.orderId,
	                            isCardSaved: true
	                          });
	                        } else {
	                          $ctrl.$state.go('payment.failure', {
	                            orderId: $ctrl.$stateParams.orderId,
	                            logString: JSON.stringify(success.data.additionalInfo),
	                            reasonCode: success.data.successCode
	                          });
	                        }
	                      });
	
	                    case 3:
	                      success = _context2.sent;
	
	                    case 4:
	                    case 'end':
	                      return _context2.stop();
	                  }
	                }
	              }, _callee2, _this10);
	            }))();
	          },
	
	
	          onError: function onError(err) {
	            $ctrl.$state.go('payment.failure', {
	              orderId: $ctrl.$stateParams.orderId,
	              logString: JSON.stringify(err)
	              // reasonCode: error.data.successCode
	            });
	          }
	
	        });
	        if (!button.isEligible()) {
	          // Skip rendering if not eligible
	          return;
	        }
	        button.render("#paypal-button-container");
	      }
	    }
	  }, {
	    key: 'initializePaypal1',
	    value: function initializePaypal1(fundingSource, id) {
	      var $ctrl = this;
	      // console.log("paypal integration ----> ", window.paypal);
	
	      var giftCardsRequest = [];
	      angular.forEach($ctrl.giftCardDetails, function (item, key) {
	        if (item.isCardVerified && item.amount > 0) {
	
	          $ctrl.$spinner.show('appSpinner');
	          var giftCards = {
	
	            "giftCard": item.cardNumber,
	            "amount": item.amount,
	            "pin": item.cvv
	          };
	          $ctrl.$spinner.hide('appSpinner');
	          giftCardsRequest.push(giftCards);
	        }
	      });
	      var giftCardData = {
	        "getGiftCardPreAuthCardRequestList": giftCardsRequest
	      };
	
	      var dataRequest = {
	        "orderId": this.$stateParams.orderId,
	        "getGiftCardPreAuthRequest": giftCardData
	      };
	
	      this.paypalAutorizationWrapper.authorizedAmount = this.getRoundoffValue(this.orderAmount - this.getTotalGiftCardAddedAmount() - this.amountToBeChargedFromStoreCredit, this.toDecimalPlaces);
	
	      // Render PayPal Now (standard paypal funding) if eligible
	      if (window.paypal.FUNDING && window.paypal.Buttons) {
	        var marks = window.paypal.Marks({
	          fundingSource: fundingSource
	        });
	        // Only render if eligible
	        if (marks.isEligible()) {
	          setTimeout(function () {
	            marks.render('#' + id + '-marks');
	          }, 1000);
	        }
	
	        var btn = window.paypal.Buttons({
	          fundingSource: fundingSource,
	          createOrder: function createOrder(data, actions) {
	            return actions.order.create({
	              intent: "AUTHORIZE", // 
	              purchase_units: [{
	                amount: {
	                  value: $ctrl.paypalAutorizationWrapper.authorizedAmount,
	                  currency_code: "USD"
	                }
	              }]
	            });
	          },
	          onApprove: function onApprove(data, actions) {
	            return actions.order.authorize().then(function (authorization) {
	              // console.log("Inside OnApprove data ---", data);
	              // console.log("Inside OnApprove actions ---", actions);
	              if (data && data.orderID) {
	                $ctrl.paypalAutorizationWrapper.paypalCreateOrderId = data.orderID;
	                // console.log("Authorized:", $ctrl.paypalAutorizationWrapper.paypalCreateOrderId, authorization);
	                if (authorization.purchase_units[0] && authorization.purchase_units[0].payments.authorizations[0].id) {
	                  $ctrl.paypalAutorizationWrapper.showPaypal = false;
	                  $ctrl.paypalAutorizationWrapper.isPaypalAuthorized = true;
	                  $ctrl.paypalAutorizationWrapper.authId = authorization.purchase_units[0].payments.authorizations[0].id;
	                  var paypalAuthorizedOrderWrapper = {
	                    'orderId': $ctrl.$stateParams.orderId,
	                    'authId': $ctrl.paypalAutorizationWrapper.authId,
	                    'paypalCreateOrderId': $ctrl.paypalAutorizationWrapper.paypalCreateOrderId
	                  };
	                  $ctrl.$order.savePaypalAuthorizedOrder(paypalAuthorizedOrderWrapper).then(function (success) {
	                    // console.log("Authorized order saved successfully", success);
	                  });
	                  $ctrl.scrollToPaynow();
	                }
	              } else {
	                // $ctrl.paypalAutorizationWrapper.showPaypal = true;
	                $ctrl.paypalAutorizationWrapper.isPaypalAuthorized = false;
	                $ctrl.$toaster.pop('success', 'Authorized Failed');
	              }
	            });
	          }
	        });
	        // Only render if eligible
	        if (btn.isEligible()) {
	          setTimeout(function () {
	            btn.render('#' + id + '-container');
	          }, 1000);
	        } else {
	          // If not eligible, optionally hide or show a fallback message
	          document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
	        }
	      }
	    }
	  }, {
	    key: 'initializePaypal3',
	    value: function initializePaypal3(fundingSource, id) {
	      var $ctrl = this;
	      // console.log("paypal integration ----> ", window.paypal);
	
	      if (window.paypal && window.paypal.Buttons) {
	
	        if (window.paypal.FUNDING && window.paypal.Buttons) {
	          var marks = window.paypal.Marks({
	            fundingSource: fundingSource
	          });
	          // Only render if eligible
	          if (marks.isEligible()) {
	            setTimeout(function () {
	              marks.render('#' + id + '-marks');
	            }, 1000);
	          }
	
	          var btn = window.paypal.Buttons({
	            style: {
	              shape: "rect",
	              layout: "vertical",
	              color: "white",
	              label: "paypal",
	              tagline: false
	            },
	            fundingSource: fundingSource,
	            createOrder: function createOrder() {
	              var _this11 = this;
	
	              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                var giftCardsRequest, giftCardData, dataRequest, success;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        giftCardsRequest = [];
	
	                        angular.forEach($ctrl.giftCardDetails, function (item, key) {
	                          if (item.isCardVerified && item.amount > 0) {
	
	                            $ctrl.$spinner.show('appSpinner');
	                            var giftCards = {
	
	                              "giftCard": item.cardNumber,
	                              "amount": item.amount,
	                              "pin": item.cvv
	                            };
	                            $ctrl.$spinner.hide('appSpinner');
	                            giftCardsRequest.push(giftCards);
	                          }
	                        });
	                        giftCardData = {
	                          "getGiftCardPreAuthCardRequestList": giftCardsRequest
	                        };
	                        dataRequest = {
	                          "orderId": $ctrl.$stateParams.orderId,
	                          "getGiftCardPreAuthRequest": giftCardData
	                        };
	                        _context3.next = 6;
	                        return $ctrl.$order.paypalCreateOrder(dataRequest);
	
	                      case 6:
	                        success = _context3.sent;
	                        return _context3.abrupt('return', success.data.id);
	
	                      case 8:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this11);
	              }))();
	            },
	            onApprove: function onApprove(data, actions) {
	              var _this12 = this;
	
	              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	                var orderData, success;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                  while (1) {
	                    switch (_context4.prev = _context4.next) {
	                      case 0:
	                        // console.log("Inside OnApprove data ---", data);
	                        // console.log("Inside OnApprove actions ---", actions);
	                        orderData = {
	                          paypalCreateOrderId: data.orderID,
	                          orderId: $ctrl.$stateParams.orderId
	                        };
	                        _context4.next = 3;
	                        return $ctrl.$order.paypalCaptureOrder(orderData).then(function (success) {
	                          if (success != null && success.data != null && success.data.successCode == "200") {
	                            $ctrl.$state.go('payment.success', {
	                              orderId: $ctrl.$stateParams.orderId,
	                              isCardSaved: true
	                            });
	                          } else {
	                            $ctrl.$state.go('payment.failure', {
	                              orderId: $ctrl.$stateParams.orderId,
	                              logString: JSON.stringify(success.data.additionalInfo),
	                              reasonCode: success.data.successCode
	                            });
	                          }
	                        });
	
	                      case 3:
	                        success = _context4.sent;
	
	                      case 4:
	                      case 'end':
	                        return _context4.stop();
	                    }
	                  }
	                }, _callee4, _this12);
	              }))();
	            },
	
	
	            onError: function onError(err) {
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(err)
	                // reasonCode: error.data.successCode
	              });
	            }
	
	          });
	
	          // Only render if eligible
	          if (btn.isEligible()) {
	            setTimeout(function () {
	              btn.render('#' + id + '-container');
	            }, 1000);
	          } else {
	            // If not eligible, optionally hide or show a fallback message
	            document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
	          }
	        }
	      }
	    }
	  }, {
	    key: 'initializePaypal4',
	    value: function initializePaypal4(id, paypalLoadingTimes) {
	      var $ctrl = this;
	      this.$spinner.show('appSpinner');
	      // console.log("paypal integration ----> ", window.paypal);
	
	      if (window.paypal && window.paypal.Buttons) {
	
	        if (window.paypal.FUNDING && window.paypal.Buttons) {
	          var marks = window.paypal.Marks({
	            fundingSource: window.paypal.FUNDING.PAYPAL
	          });
	          // Only render if eligible
	          if (marks.isEligible()) {
	            setTimeout(function () {
	              marks.render('#' + id + '-marks');
	            }, 1000);
	          }
	
	          var btn = window.paypal.Buttons({
	            appSwitchWhenAvailable: true,
	            style: {
	              shape: "rect",
	              layout: "vertical",
	              color: "gold",
	              label: "paypal",
	              tagline: false
	            },
	            createOrder: function createOrder() {
	              var _this13 = this;
	
	              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                var giftCardsRequest, giftCardData, dataRequest, success;
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        giftCardsRequest = [];
	
	                        angular.forEach($ctrl.giftCardDetails, function (item, key) {
	                          if (item.isCardVerified && item.amount > 0) {
	
	                            $ctrl.$spinner.show('appSpinner');
	                            var giftCards = {
	
	                              "giftCard": item.cardNumber,
	                              "amount": item.amount,
	                              "pin": item.cvv
	                            };
	
	                            giftCardsRequest.push(giftCards);
	                          }
	                        });
	                        giftCardData = {
	                          "getGiftCardPreAuthCardRequestList": giftCardsRequest
	                        };
	                        dataRequest = {
	                          "orderId": $ctrl.$stateParams.orderId,
	                          "getGiftCardPreAuthRequest": giftCardData
	                        };
	
	
	                        if ($ctrl.isStoreCreditUsed) {
	                          dataRequest.storeCreditAmountToBeCharged = $ctrl.amountToBeChargedFromStoreCredit;
	                        } else {
	                          dataRequest.storeCreditAmountToBeCharged = 0.00;
	                        }
	
	                        dataRequest.saveVault = $ctrl.savePaypalVault;
	
	                        if ($ctrl.storeFeatures.paypal.customerHasVault) {
	                          dataRequest.proceedingWithVault = true;
	                          dataRequest.payment_source = {};
	                        } else {
	                          dataRequest.proceedingWithVault = false;
	                        }
	
	                        if (!dataRequest.proceedingWithVault) {
	                          _context5.next = 12;
	                          break;
	                        }
	
	                        _context5.next = 10;
	                        return $ctrl.$order.paypalCreateOrder(dataRequest).then(function (success) {
	                          $ctrl.$spinner.hide('appSpinner');
	                          if (success != null && success.data != null && success.data.successCode == "200") {
	                            $ctrl.$state.go('payment.success', {
	                              orderId: $ctrl.$stateParams.orderId,
	                              isCardSaved: true
	                            });
	                          } else {
	                            $ctrl.$state.go('payment.failure', {
	                              orderId: $ctrl.$stateParams.orderId,
	                              logString: JSON.stringify(success.data.additionalInfo),
	                              reasonCode: success.data.successCode
	                            });
	                          }
	
	                          return success.data.id;
	                        }).catch(function (error) {
	                          $ctrl.$spinner.hide('appSpinner');
	                        });
	
	                      case 10:
	                        _context5.next = 17;
	                        break;
	
	                      case 12:
	                        _context5.next = 14;
	                        return $ctrl.$order.paypalCreateOrder(dataRequest);
	
	                      case 14:
	                        success = _context5.sent;
	
	                        $ctrl.$spinner.hide('appSpinner');
	                        // console.log("Success info :", success.data.id);
	                        return _context5.abrupt('return', success.data.id);
	
	                      case 17:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, _this13);
	              }))();
	            },
	            onApprove: function onApprove(data, actions) {
	              var _this14 = this;
	
	              return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	                var orderData, success;
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                  while (1) {
	                    switch (_context6.prev = _context6.next) {
	                      case 0:
	                        // console.log("Inside OnApprove data ---", data);
	                        // console.log("Inside OnApprove actions ---", actions);
	                        orderData = {
	                          paypalCreateOrderId: data.orderID,
	                          orderId: $ctrl.$stateParams.orderId
	                        };
	                        _context6.next = 3;
	                        return $ctrl.$order.paypalCaptureOrder(orderData).then(function (success) {
	                          if (success != null && success.data != null && success.data.successCode == "200") {
	                            $ctrl.$state.go('payment.success', {
	                              orderId: $ctrl.$stateParams.orderId,
	                              isCardSaved: true
	                            });
	                          } else {
	                            $ctrl.$state.go('payment.failure', {
	                              orderId: $ctrl.$stateParams.orderId,
	                              logString: JSON.stringify(success.data.additionalInfo),
	                              reasonCode: success.data.successCode
	                            });
	                          }
	                        });
	
	                      case 3:
	                        success = _context6.sent;
	
	                      case 4:
	                      case 'end':
	                        return _context6.stop();
	                    }
	                  }
	                }, _callee6, _this14);
	              }))();
	            },
	
	
	            onError: function onError(err) {
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(err)
	                // reasonCode: error.data.successCode
	              });
	            }
	
	          });
	          // Only render if eligible
	          if (btn.isEligible()) {
	            $ctrl.paymentMethods.push({
	              "value": "payNow",
	              "name": "Pay with PayPal",
	              "logo": true,
	              "cardLogo": false,
	              "id": "paypal-now-btn-marks",
	              "lastChoosen": false,
	              "type": "unique",
	              "disable": false,
	              "order": 3
	            });
	
	            if ($ctrl.storeFeatures.paypal.hasVaultEnabled) {
	              console.log("Check if this is needed");
	              /*
	              if ($ctrl.storeFeatures.paypal.customerHasVault) {
	                $ctrl.paymentMethods.push({
	                  "value": "payVault",
	                  "name": "Pay with PayPal Vault",
	                  "logo": true,
	                  "cardLogo": false,
	                  "id": "paypal-now-btn-marks2",
	                  "lastChoosen": false,
	                  "type": "unique",
	                  "disable": false,
	                  "order": 4
	                });
	                  var marks2 = window.paypal.Marks({
	                  fundingSource: window.paypal.FUNDING.PAYPAL
	                });
	                // Only render if eligible
	                if (marks2.isEligible()) {
	                  setTimeout(() => {
	                    marks2.render('#paypal-now-btn-marks2');
	                  }, 1000);
	                }
	                }
	              */
	            }
	
	            setTimeout(function () {
	              btn.render('#' + id + '-container');
	              $ctrl.$spinner.hide('appSpinner');
	            }, 1000);
	          } else {
	            $ctrl.$spinner.hide('appSpinner');
	            // If not eligible, optionally hide or show a fallback message
	            document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
	          }
	        } else {
	          $ctrl.$spinner.hide('appSpinner');
	          if (paypalLoadingTimes < 2) {
	            console.log("Paypal initializing times : " + paypalLoadingTimes);
	            this.initializePaypal4('paypal-now-btn', paypalLoadingTimes + 1);
	          }
	        }
	      } else {
	        $ctrl.$spinner.hide('appSpinner');
	        if (paypalLoadingTimes < 2) {
	          console.log("Paypal initializing times : " + paypalLoadingTimes);
	          this.initializePaypal4('paypal-now-btn', paypalLoadingTimes + 1);
	        }
	      }
	    }
	  }, {
	    key: 'initializePaypal_regular',
	    value: function initializePaypal_regular(id, paypalLoadingTimes) {
	      var $ctrl = this;
	      this.$spinner.show('appSpinner');
	      // console.log("paypal integration ----> ", window.paypal);
	      this.paypalTextOnButton = "";
	      if (window.paypal && window.paypal.Buttons) {
	
	        this.paypalFundingSources = [window.paypal.FUNDING.PAYPAL, window.paypal.FUNDING.VENMO, window.paypal.FUNDING.PAYLATER, window.paypal.FUNDING.CARD];
	
	        this.paypalFundingSources_keyvalue = {
	          'paypal': { textOnButton: "'PayPal'" },
	          'venmo': { textOnButton: "'venmo'" },
	          'paylater': { textOnButton: "'Pay Later'"
	            // add more if needed
	          } };
	
	        if (window.paypal.FUNDING && window.paypal.Buttons) {
	          var marks = window.paypal.Marks({
	            fundingSource: window.paypal.FUNDING.PAYPAL
	          });
	          // Only render if eligible
	          if (marks.isEligible()) {
	            setTimeout(function () {
	              marks.render('#' + id + '-marks');
	            }, 1000);
	          }
	
	          var btn = window.paypal.Buttons({
	            appSwitchWhenAvailable: false,
	            style: {
	              shape: "rect",
	              layout: "vertical",
	              color: "gold",
	              label: "paypal",
	              tagline: false
	            },
	            onCancel: function onCancel(data) {
	              // console.log(data); 
	              $ctrl.$spinner.hide('appSpinner');
	              if ($ctrl.isGuestProfile()) {
	                $ctrl.$state.go('guestdelivery');
	              } else {
	                $ctrl.$state.go('delivery');
	              }
	            },
	            onClick: function onClick(data, actions) {
	              // console.log("Funding source clicked:", data.fundingSource);
	              switch (data.fundingSource) {
	                case window.paypal.FUNDING.PAYPAL:
	                  $ctrl.updateUserAction($ctrl.APP.ORDER.USER_ACTION.PAYPAL, $ctrl.getAppOrderId());
	                  break;
	                case window.paypal.FUNDING.VENMO:
	                  $ctrl.updateUserAction($ctrl.APP.ORDER.USER_ACTION.VENMO, $ctrl.getAppOrderId());
	                  break;
	                case window.paypal.FUNDING.PAYLATER:
	                  $ctrl.updateUserAction($ctrl.APP.ORDER.USER_ACTION.PAY_LATER, $ctrl.getAppOrderId());
	                  break;
	                default:
	                  break;
	              }
	            },
	            createOrder: function createOrder(data, actions) {
	              var giftCardsRequest = [];
	              $ctrl.$spinner.show('appSpinner');
	              angular.forEach($ctrl.giftCardDetails, function (item, key) {
	                if (item.isCardVerified && item.amount > 0) {
	                  var giftCards = {
	
	                    "giftCard": item.cardNumber,
	                    "amount": item.amount,
	                    "pin": item.cvv
	                  };
	
	                  giftCardsRequest.push(giftCards);
	                }
	              });
	              var giftCardData = {
	                "getGiftCardPreAuthCardRequestList": giftCardsRequest
	              };
	
	              var dataRequest = {
	                "orderId": $ctrl.$stateParams.orderId,
	                "getGiftCardPreAuthRequest": giftCardData
	              };
	
	              if ($ctrl.isStoreCreditUsed) {
	                dataRequest.storeCreditAmountToBeCharged = $ctrl.amountToBeChargedFromStoreCredit;
	              } else {
	                dataRequest.storeCreditAmountToBeCharged = 0.00;
	              }
	
	              if ($ctrl.profile.customer.isGuest) {
	                dataRequest.saveVault = false;
	              } else {
	                dataRequest.saveVault = $ctrl.savePaypalVault;
	              }
	
	              if ($ctrl.storeFeatures.paypal.customerHasVault) {
	                dataRequest.proceedingWithVault = true;
	                dataRequest.payment_source = {};
	              } else {
	                dataRequest.proceedingWithVault = false;
	              }
	
	              return $ctrl.$order.paypalCreateOrder(dataRequest).then(function (success) {
	                // console.log("Success info :", success.data.id);
	                $ctrl.$spinner.hide('appSpinner');
	                return success.data.id;
	              }).catch(function (error) {
	                $ctrl.$spinner.hide('appSpinner');
	                return null;
	              });
	            },
	
	            onApprove: function onApprove(data, actions) {
	              // console.log("Inside OnApprove data ---", data);
	              // console.log("Inside OnApprove actions ---", actions);
	              $ctrl.$spinner.show('appSpinner');
	              var orderData = {
	                paypalCreateOrderId: data.orderID,
	                orderId: $ctrl.$stateParams.orderId
	              };
	
	              return $ctrl.$order.paypalCaptureOrder(orderData).then(function (success) {
	                $ctrl.$spinner.hide('appSpinner');
	                if (success != null && success.data != null && success.data.successCode == "200") {
	                  $ctrl.$state.go('payment.success', {
	                    orderId: $ctrl.$stateParams.orderId,
	                    isCardSaved: true
	                  });
	                } else {
	                  $ctrl.$state.go('payment.failure', {
	                    orderId: $ctrl.$stateParams.orderId,
	                    logString: JSON.stringify(success.data.additionalInfo),
	                    reasonCode: success.data.successCode
	                  });
	                }
	              }).catch(function (error) {
	                $ctrl.$spinner.hide('appSpinner');
	                return null;
	              });
	            },
	
	            onError: function onError(err) {
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(err)
	                // reasonCode: error.data.successCode
	              });
	            }
	
	          });
	          // Only render if eligible 
	
	          if (btn.isEligible()) {
	            var eligibleFundingSources = this.paypalFundingSources.filter(function (funding) {
	              return window.paypal.Buttons({ funding: funding }).isEligible();
	            });
	            // console.log(" -- eligibleFundingSources --", eligibleFundingSources);
	            var tempText = '';
	
	            if (this.storeFeatures.paypal.customerHasVault) {
	              this.paypalTextOnButton = "'Pay Now'";
	            }
	            for (var i = 0; i < eligibleFundingSources.length; i++) {
	              if (this.paypalFundingSources_keyvalue[eligibleFundingSources[i]]) {
	                tempText = this.paypalFundingSources_keyvalue[eligibleFundingSources[i]].textOnButton;
	                if (this.paypalTextOnButton != null && this.paypalTextOnButton.length > 0) {
	                  this.paypalTextOnButton = this.paypalTextOnButton + " or " + tempText;
	                } else {
	                  this.paypalTextOnButton = tempText;
	                }
	              }
	            }
	            $ctrl.paymentMethods.push({
	              "value": "payNow",
	              "name": "Pay with PayPal",
	              "logo": true,
	              "cardLogo": false,
	              "id": "paypal-now-btn-marks",
	              "lastChoosen": false,
	              "type": "unique",
	              "disable": false,
	              "order": 3
	            });
	
	            if ($ctrl.storeFeatures.paypal.hasVaultEnabled) {
	              // console.log("Check if this is needed");
	              /*
	              if ($ctrl.storeFeatures.paypal.customerHasVault) {
	                $ctrl.paymentMethods.push({
	                  "value": "payVault",
	                  "name": "Pay with PayPal Vault",
	                  "logo": true,
	                  "cardLogo": false,
	                  "id": "paypal-now-btn-marks2",
	                  "lastChoosen": false,
	                  "type": "unique",
	                  "disable": false,
	                  "order": 4
	                });
	                  var marks2 = window.paypal.Marks({
	                  fundingSource: window.paypal.FUNDING.PAYPAL
	                });
	                // Only render if eligible
	                if (marks2.isEligible()) {
	                  setTimeout(() => {
	                    marks2.render('#paypal-now-btn-marks2');
	                  }, 1000);
	                }
	                }
	              */
	            }
	
	            setTimeout(function () {
	              btn.render('#' + id + '-container');
	              $ctrl.$spinner.hide('appSpinner');
	            }, 1000);
	          } else {
	            $ctrl.$spinner.hide('appSpinner');
	            // If not eligible, optionally hide or show a fallback message
	            document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
	          }
	        } else {
	          $ctrl.$spinner.hide('appSpinner');
	          if (paypalLoadingTimes < 2) {
	            console.log("Paypal initializing times : " + paypalLoadingTimes);
	            this.initializePaypal_regular('paypal-now-btn', paypalLoadingTimes + 1);
	          }
	        }
	      } else {
	        $ctrl.$spinner.hide('appSpinner');
	        if (paypalLoadingTimes < 2) {
	          console.log("Paypal initializing times : " + paypalLoadingTimes);
	          this.initializePaypal_regular('paypal-now-btn', paypalLoadingTimes + 1);
	        }
	      }
	    }
	  }, {
	    key: 'initializePaypal_returnuser',
	    value: function initializePaypal_returnuser(id, paypalLoadingTimes) {
	      var $ctrl = this;
	      this.$spinner.show('appSpinner');
	      // console.log("paypal integration return user----> ", window.paypal);
	
	      if (window.paypal && window.paypal.Buttons) {
	
	        if (window.paypal.FUNDING && window.paypal.Buttons) {
	          var marks = window.paypal.Marks({
	            fundingSource: window.paypal.FUNDING.PAYPAL
	          });
	          // Only render if eligible
	          if (marks.isEligible()) {
	            setTimeout(function () {
	              marks.render('#' + id + '-marks');
	            }, 1000);
	          }
	
	          var btn = window.paypal.Buttons({
	            appSwitchWhenAvailable: true,
	            style: {
	              shape: "rect",
	              layout: "vertical",
	              color: "gold",
	              label: "paypal",
	              tagline: false
	            },
	            createOrder: function createOrder(data, actions) {
	              var giftCardsRequest = [];
	              angular.forEach($ctrl.giftCardDetails, function (item, key) {
	                if (item.isCardVerified && item.amount > 0) {
	
	                  $ctrl.$spinner.show('appSpinner');
	                  var giftCards = {
	
	                    "giftCard": item.cardNumber,
	                    "amount": item.amount,
	                    "pin": item.cvv
	                  };
	
	                  giftCardsRequest.push(giftCards);
	                }
	              });
	              var giftCardData = {
	                "getGiftCardPreAuthCardRequestList": giftCardsRequest
	              };
	
	              var dataRequest = {
	                "orderId": $ctrl.$stateParams.orderId,
	                "getGiftCardPreAuthRequest": giftCardData
	              };
	
	              if ($ctrl.isStoreCreditUsed) {
	                dataRequest.storeCreditAmountToBeCharged = $ctrl.amountToBeChargedFromStoreCredit;
	              } else {
	                dataRequest.storeCreditAmountToBeCharged = 0.00;
	              }
	
	              dataRequest.saveVault = $ctrl.savePaypalVault;
	
	              if ($ctrl.storeFeatures.paypal.customerHasVault) {
	                dataRequest.proceedingWithVault = true;
	                dataRequest.payment_source = {};
	              } else {
	                dataRequest.proceedingWithVault = false;
	              }
	
	              return $ctrl.$order.paypalCreateOrderReturnUser(dataRequest).then(function (success) {
	                if (success != null && success.data != null && success.data.successCode == "200") {
	                  $ctrl.$state.go('payment.success', {
	                    orderId: $ctrl.$stateParams.orderId,
	                    isCardSaved: true
	                  });
	                } else {
	                  $ctrl.$state.go('payment.failure', {
	                    orderId: $ctrl.$stateParams.orderId,
	                    logString: JSON.stringify(success.data.additionalInfo),
	                    reasonCode: success.data.successCode
	                  });
	                }
	              }).catch(function (error) {
	                return null;
	              });
	            },
	
	            onApprove: function onApprove(data, actions) {
	              // console.log("Inside OnApprove data ---", data);
	              // console.log("Inside OnApprove actions ---", actions);
	              var orderData = {
	                paypalCreateOrderId: data.orderID,
	                orderId: $ctrl.$stateParams.orderId
	              };
	
	              return $ctrl.$order.paypalCaptureOrder(orderData).then(function (success) {
	                if (success != null && success.data != null && success.data.successCode == "200") {
	                  $ctrl.$state.go('payment.success', {
	                    orderId: $ctrl.$stateParams.orderId,
	                    isCardSaved: true
	                  });
	                } else {
	                  $ctrl.$state.go('payment.failure', {
	                    orderId: $ctrl.$stateParams.orderId,
	                    logString: JSON.stringify(success.data.additionalInfo),
	                    reasonCode: success.data.successCode
	                  });
	                }
	              }).catch(function (error) {
	                return null;
	              });
	            },
	
	            onError: function onError(err) {
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(err)
	                // reasonCode: error.data.successCode
	              });
	            }
	
	          });
	          // Only render if eligible
	          if (btn.isEligible()) {
	            $ctrl.paymentMethods.push({
	              "value": "payNow",
	              "name": "Pay with PayPal",
	              "logo": true,
	              "cardLogo": false,
	              "id": "paypal-now-btn-marks",
	              "lastChoosen": false,
	              "type": "unique",
	              "disable": false,
	              "order": 3
	            });
	
	            if ($ctrl.storeFeatures.paypal.hasVaultEnabled) {
	              // console.log("Check if this is needed");
	              /*
	              if ($ctrl.storeFeatures.paypal.customerHasVault) {
	                $ctrl.paymentMethods.push({
	                  "value": "payVault",
	                  "name": "Pay with PayPal Vault",
	                  "logo": true,
	                  "cardLogo": false,
	                  "id": "paypal-now-btn-marks2",
	                  "lastChoosen": false,
	                  "type": "unique",
	                  "disable": false,
	                  "order": 4
	                });
	                  var marks2 = window.paypal.Marks({
	                  fundingSource: window.paypal.FUNDING.PAYPAL
	                });
	                // Only render if eligible
	                if (marks2.isEligible()) {
	                  setTimeout(() => {
	                    marks2.render('#paypal-now-btn-marks2');
	                  }, 1000);
	                }
	                }
	              */
	            }
	
	            setTimeout(function () {
	              btn.render('#' + id + '-container');
	              $ctrl.$spinner.hide('appSpinner');
	            }, 1000);
	          } else {
	            $ctrl.$spinner.hide('appSpinner');
	            // If not eligible, optionally hide or show a fallback message
	            document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
	          }
	        } else {
	          $ctrl.$spinner.hide('appSpinner');
	          if (paypalLoadingTimes < 2) {
	            // console.log("Paypal initializing times : " + paypalLoadingTimes);
	            this.initializePaypal_returnuser('paypal-now-btn', paypalLoadingTimes + 1);
	          }
	        }
	      } else {
	        $ctrl.$spinner.hide('appSpinner');
	        if (paypalLoadingTimes < 2) {
	          // console.log("Paypal initializing times : " + paypalLoadingTimes);
	          this.initializePaypal_returnuser('paypal-now-btn', paypalLoadingTimes + 1);
	        }
	      }
	    }
	  }, {
	    key: 'isValidToProceed',
	    value: function isValidToProceed() {
	      if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
	        this.$toaster.pop('success', 'Paypal has already authorised. Please proceed to pay now.');
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'scrollToPaynow',
	    value: function scrollToPaynow() {
	      var scrollToPaynow = document.getElementById("scroll-to-paynow");
	      if (scrollToPaynow) {
	        // console.log("Scrolling to pay now.");
	        scrollToPaynow.scrollIntoView({
	          behavior: "smooth",
	          block: "start",
	          inline: "nearest"
	        });
	      }
	      this.$toaster.pop('success', 'Please proceed to Pay Now');
	    }
	  }, {
	    key: 'getStoreCreditAmountToBeCharged',
	    value: function getStoreCreditAmountToBeCharged() {
	      this.amountToBeChargedFromStoreCredit = 0.00;
	      if (this.getTotalGiftCardAddedAmount() > 0) {
	        var amountminusgift = this.orderAmount - this.getTotalGiftCardAddedAmount();
	        amountminusgift = this.getRoundoffValue(amountminusgift, this.toDecimalPlaces);
	
	        if (this.storeCreditAmount >= amountminusgift) {
	          this.amountToBeChargedFromStoreCredit = amountminusgift;
	        } else {
	          this.amountToBeChargedFromStoreCredit = this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
	        }
	      } else {
	        if (this.storeCreditAmount > this.orderAmount) {
	          this.amountToBeChargedFromStoreCredit = this.orderAmount;
	        } else {
	          this.amountToBeChargedFromStoreCredit = this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
	        }
	      }
	    }
	  }, {
	    key: 'isStoreCreditAmountTobeUsed',
	    value: function isStoreCreditAmountTobeUsed() {
	
	      if (this.isStoreCreditUsed) {
	        if (this.getStoreCredit() > 0) {
	          return true;
	        } else {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'getStoreCredit',
	    value: function getStoreCredit() {
	
	      var amountminusgift = this.orderAmount - this.getTotalGiftCardAddedAmount();
	      amountminusgift = this.getRoundoffValue(amountminusgift, this.toDecimalPlaces);
	      if (this.isStoreCreditUsed && amountminusgift == 0) {
	        this.isStoreCreditUsed = false;
	        this.amountToBeChargedFromStoreCredit = 0.00;
	        this.$toaster.pop('success', "Total amount is already covered.");
	        return;
	      }
	
	      this.getStoreCreditAmountToBeCharged();
	
	      if (this.isStoreCreditUsed) {
	
	        this.setIsAllowToPayOnlyWithGiftCards();
	
	        if (this.getTotalGiftCardAddedAmount() > 0) {
	          if (this.storeCreditAmount >= amountminusgift) {
	            this.choosePaymentMethod();
	            return amountminusgift;
	          } else {
	            this.choosePaymentMethod();
	            return this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
	          }
	        }
	
	        if (this.storeCreditAmount > this.orderAmount) {
	
	          if (!this.isAllowToPayOnlyWithGiftCards) {
	            this.isAllowToPayWithStoreCreditOnly = true;
	          } else {
	            // If gift cards involved, then we can't pay with storeCredit only.. Gift card api will take care of store credit amount.
	            this.isAllowToPayWithStoreCreditOnly = false;
	          }
	          this.choosePaymentMethod();
	          return this.orderAmount;
	        } else {
	          this.isAllowToPayWithStoreCreditOnly = false;
	          this.choosePaymentMethod();
	          return this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
	        }
	      } else {
	        this.amountToBeChargedFromStoreCredit = 0.00;
	        this.setIsAllowToPayOnlyWithGiftCards();
	        this.isAllowToPayWithStoreCreditOnly = false;
	        this.choosePaymentMethod();
	      }
	      return 0;
	    }
	  }, {
	    key: 'setIsAllowToPayOnlyWithGiftCards',
	    value: function setIsAllowToPayOnlyWithGiftCards() {
	      if (this.getTotalGiftCardAddedAmount() > 0) {
	        if (this.isStoreCreditUsed) {
	          var giftsPlusStoreCredit = this.getRoundoffValue(this.getTotalGiftCardAddedAmount() + this.getRoundoffValue(this.amountToBeChargedFromStoreCredit, this.toDecimalPlaces), this.toDecimalPlaces);
	          // console.log("this.orderAmount---", this.orderAmount);
	          // console.log("giftsPlusStoreCredit---", giftsPlusStoreCredit);
	          this.isAllowToPayOnlyWithGiftCards = this.orderAmount == giftsPlusStoreCredit;
	        } else {
	          this.isAllowToPayOnlyWithGiftCards = this.getTotalGiftCardAddedAmount() == this.orderAmount;
	        }
	      } else {
	        this.isAllowToPayOnlyWithGiftCards = false;
	      }
	    }
	  }, {
	    key: 'infoPopup',
	    value: function infoPopup() {
	      var _this15 = this;
	
	      document.getElementById('popupsavecard').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popupsavecard').style.display === 'block' && _this15.showPopup === false) {
	          _this15.hideinfoPopup();
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'infoPopuponhover',
	    value: function infoPopuponhover() {
	      document.getElementById('popupsavecard').style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'hideinfoPopup',
	    value: function hideinfoPopup() {
	      document.getElementById('popupsavecard').style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'addCreditCardPopUp',
	    value: function addCreditCardPopUp() {
	      var _this16 = this;
	
	      this.showAddCardButton = false;
	      if (!this.hasCardInitializedAlready) {
	        if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
	          this.$spinner.show('appSpinner');
	          setTimeout(function () {
	            _this16.addTsysCreditCard(_this16.GlobalPayments);
	          }, 100);
	        } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	          setTimeout(function () {
	            _this16.addHeartlandCreditCard(_this16.Heartland);
	          }, 100);
	        } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
	          setTimeout(function () {
	            // this.paymentGlobalKey = success.data.globalKey;
	            if (window.innerWidth < 768) {
	              // console.log('inside mobile');
	              document.getElementById("monerisFrameUpdate").src = _this16.gatewayUrl + "?id=" + _this16.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" + "&css_label_pan=;margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
	            } else {
	              document.getElementById("monerisFrameUpdate").src = _this16.gatewayUrl + "?id=" + _this16.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" + "&css_label_pan=;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
	            }
	            _this16.addMonerisCreditCard();
	          }, 100);
	        }
	        this.hasCardInitializedAlready = true;
	      }
	    }
	  }, {
	    key: 'addHeartlandCreditCard',
	    value: function addHeartlandCreditCard(Heartland) {
	      var $ctrl = this;
	      this.hps = new Heartland.HPS({
	        publicKey: $ctrl.paymentGlobalKey,
	        type: 'iframe',
	        // Configure the iframe fields to tell the library where
	        // the iframe should be inserted into the DOM and some
	        // basic options
	        fields: {
	          cardNumber: {
	            target: 'iframesCardNumber',
	            placeholder: 'xxxx xxxx xxxx xxxx'
	          },
	          cardExpiration: {
	            target: 'iframesCardExpiration',
	            placeholder: 'MM / YYYY'
	          },
	          cardCvv: {
	            target: 'iframesCardCvv',
	            placeholder: 'CVV'
	          },
	          submit: {
	            value: 'submit',
	            target: 'iframesSubmit'
	          }
	        },
	        // Collection of CSS to inject into the iframes.
	        // These properties can match the site's styles
	        // to create a seamless experience.
	        style: {
	          'input': {
	            'background': '#fff',
	            'border': '1px solid',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'box-sizing': 'border-box',
	            'font-family': 'serif',
	            'font-size': '16px',
	            'line-height': '1',
	            'margin': '0 .5em 0 0',
	            'max-width': '100%',
	            'outline': '0',
	            'padding': '0.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'width': '100% !important'
	          },
	          '#heartland-field': {
	            'font-family': 'sans-serif',
	            'box-sizing': 'border-box',
	            'display': 'block',
	            'height': '50px',
	            'padding': '6px 12px',
	            'font-size': '14px',
	            'line-height': '1.42857143',
	            'color': '#555',
	            'background-color': '#fff',
	            'border': '1px solid #ccc',
	            'border-radius': '0px',
	            '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
	            'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
	            '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
	            '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
	            'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
	            'width': '100%'
	          },
	          '#heartland-field[name=submit]': {
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'color': '#ffffff',
	            'border': '0px solid transparent',
	            'width': '200px !important',
	            'margin-left': '5px  !important'
	          },
	          '#heartland-field[name=submit]:focus': {
	            'color': '#ffffff',
	            'background-color': '#a4182d',
	            'outline': 'none'
	          },
	          '#heartland-field[name=submit]:hover': {
	            'background-color': ' #a4182d'
	          },
	          '#heartland-field-wrapper #heartland-field:focus': {
	            'border': '1px solid #3989e3',
	            'outline': 'none',
	            'box-shadow': 'none',
	            'height': '50px'
	          },
	          'heartland-field-wrapper #heartland-field': {
	            'height': '50px'
	          },
	          'input[type=submit]': {
	            'box-sizing': 'border-box',
	            'display': 'inline-block',
	            'padding': '6px 12px',
	            'margin-bottom': '0',
	            'font-size': '14px',
	            'font-weight': '400',
	            'line-height': '1.42857143',
	            'text-align': 'center',
	            'white-space': 'nowrap',
	            'vertical-align': 'middle',
	            '-ms-touch-action': 'manipulation',
	            'touch-action': 'manipulation',
	            'cursor': 'pointer',
	            '-webkit-user-select': 'none',
	            '-moz-user-select': 'none',
	            '-ms-user-select': 'none',
	            'user-select': 'none',
	            'background-image': 'none',
	            'border': '1px solid transparent',
	            'border-radius': '4px',
	            'color': '#fff',
	            'background-color': '#a4182d',
	            'border-color': '#2e6da4'
	          },
	          '#heartland-field[placeholder]': {
	            'letter-spacing': '3px'
	          },
	          '#heartland-field[name=cardCvv]': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
	            'background-size': '63px 40px'
	          },
	          'input#heartland-field[name=cardNumber]': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
	            'background-size': '55px 35px'
	          },
	          '#heartland-field.invalid.card-type-visa': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
	            'background-size': '83px 88px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-visa': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
	            'background-size': '82px 86px'
	          },
	          '#heartland-field.invalid.card-type-discover': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
	            'background-size': '85px 90px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-discover': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
	            'background-size': '85px 90px',
	            'background-position-y': '1px'
	          },
	          '#heartland-field.invalid.card-type-amex': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
	            'background-size': '50px 90px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-amex': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
	            'background-size': '50px 90px'
	          },
	          '#heartland-field.invalid.card-type-mastercard': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
	            'background-size': '62px 105px',
	            'background-position-y': '-52px'
	          },
	          '#heartland-field.valid.card-type-mastercard': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
	            'background-size': '62px 105px',
	            'background-position-y': '-1px'
	          },
	          '#heartland-field.invalid.card-type-jcb': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
	            'background-size': '55px 94px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-jcb': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
	            'background-size': '55px 94px',
	            'background-position-y': '2px'
	          },
	          'input#heartland-field[name=cardNumber]::-ms-clear': {
	            'display': 'none'
	          }
	        },
	        // Callback when a token is received from the service
	        onTokenSuccess: function onTokenSuccess(resp) {
	          // console.log('Received Token from Heartland : ', resp.token_value);
	          $ctrl.$spinner.show('appSpinner');
	          var dataReq = {
	            "token": resp.token_value,
	            // "isNewCard": true,
	            "cardLast4": resp.last_four,
	            "cardType": resp.card_type,
	            "cardNumber": resp.card.number,
	            "expiryMonth": resp.exp_month,
	            "expiryYear": resp.exp_year
	          };
	          if (!$ctrl.hasErplyCardUpdateInitialized) {
	            $ctrl.hasErplyCardUpdateInitialized = true;
	            $ctrl.$order.updateCardHeartland(dataReq).then(function (success) {
	              $ctrl.hasErplyCardUpdateInitialized = false;
	              $ctrl.clearIframeFields();
	              $ctrl.showHeartLandPage = false;
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.showAddCardButton = true;
	              if (success.data.successCode === '00') {
	                $ctrl.getSavedCards();
	                $ctrl.$toaster.pop('success', 'Card Updated Successfully');
	                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                // $ctrl.$state.go('cards-management', { 'success': 'success' });
	              } else {
	                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                $ctrl.isCallingAPI = false;
	              }
	            }, function (error) {
	              $ctrl.showAddCardButton = true;
	              $ctrl.hasErplyCardUpdateInitialized = false;
	              $ctrl.clearIframeFields();
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.showHeartLandPage = false;
	              $ctrl.isCallingAPI = false;
	              // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	              //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	              $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	              // var myEl = angular.element( document.querySelector( '#credit-card' ) );
	              // myEl.remove();
	            }).catch(function (err) {
	              $ctrl.showAddCardButton = true;
	              $ctrl.hasErplyCardUpdateInitialized = false;
	              $ctrl.clearIframeFields();
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.showHeartLandPage = false;
	              $ctrl.isCallingAPI = false;
	              // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	              // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	              $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	            });
	          }
	        },
	        // Callback when an error is received from the service
	        onTokenError: function onTokenError(resp) {
	          $ctrl.showAddCardButton = true;
	          $ctrl.hasErplyCardUpdateInitialized = false;
	          $ctrl.clearIframeFields();
	          $ctrl.$spinner.hide('appSpinner');
	          // console.log("Error - ", resp);
	          $ctrl.showHeartLandPage = false;
	          $ctrl.isCallingAPI = false;
	          // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	          // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	          $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	        },
	        // Callback when an event is fired within an iFrame
	        onEvent: function onEvent(ev) {
	          // console.log("HPS event:", ev);
	        }
	      });
	
	      this.$onDestroy = function () {
	        this.hps.dispose();
	      };
	    }
	  }, {
	    key: 'addTsysCreditCard',
	    value: function addTsysCreditCard(GlobalPayments) {
	      var $ctrl = this;
	      GlobalPayments.configure({
	        'X-GP-Api-Key': this.paymentGlobalKey,
	        'X-GP-Environment': this.env,
	        'enableAutocomplete': true
	      });
	
	      var cardForm = GlobalPayments.ui.form({
	        type: 'iframe',
	        fields: {
	          "card-number": {
	            target: "#card-number",
	            placeholder: "xxxx xxxx xxxx xxxx"
	          },
	          "card-expiration": {
	            target: "#card-expiration",
	            placeholder: "MM / YYYY"
	          },
	          "card-cvv": {
	            target: "#card-cvv",
	            placeholder: "xxx"
	          },
	          "submit": {
	            target: "#submit",
	            text: "Submit"
	          }
	        },
	
	        styles: {
	
	          "input": {
	            "outline": "none",
	            "border-width": "0",
	            "letter-spacing": "2px",
	            "width": "20px",
	            "height": "40px"
	          },
	          "input, select": {
	            "padding": "5px 10px",
	            "font-size": "13px",
	            "background": "#f3faff",
	            "border": "1px solid #e0f1ff",
	            "box-sizing": "border-box",
	            "width": "20px",
	            "height": "40px"
	          },
	          "input:focus": {
	            "-webkit-box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
	            "box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
	            "border-color": "#b0dcff !important",
	            "width": "20px",
	            "height": "40px"
	          },
	          "button": {
	            "pointer-events": "none",
	            "opacity": ".5",
	
	            'box-sizing': 'border-box',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'font-size': '15px',
	            'line-height': '1',
	            'width': 'auto !important',
	            'outline': '0',
	            'padding': '.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'border': '0 solid transparent',
	            'color': '#fff',
	            // 'cursor': 'pointer',
	            'flex': '0.61 1 auto !important'
	          },
	          "button:active": {
	            "filter": "brightness(112%)",
	            "text-align": "center"
	          },
	          ".card-number.card-type-visa": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
	            "background-position-y": "0px",
	            "background-size": "70px 75px",
	            "width": "50px"
	          },
	          ".card-number.card-type-mastercard": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
	            "background-position-y": "4px",
	            "background-size": "60px 64px"
	          },
	          ".card-number.card-type-discover": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
	            "background-position-y": "-5px",
	            "background-size": "90px 96px"
	          },
	          ".card-number.card-type-jcb": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
	            "background-position-y": "0px",
	            "background-size": "48px 82px"
	          },
	          ".card-number.card-type-amex": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
	            "background-position-y": "-4px",
	            "background-size": "55px 98px"
	          }
	        }
	      });
	
	      cardForm.on("token-success", function (resp) {
	        // add a payment token to form as a hidden input
	        // console.log("token-success", resp);
	        var token = document.createElement("input");
	        token.type = "hidden";
	        token.name = "temporary_token";
	        token.value = "resp.temporary_token";
	
	        // submit temporary_token to backend, process with our gateway
	        // const form = document.getElementById("payment-form");
	        // form.appendChild(child);
	        // form.submit;
	
	
	        // console.log("Token Success", resp.temporary_token);
	        $ctrl.$spinner.show('appSpinner');
	        var dataReq = {
	          "token": resp.temporary_token,
	          // "isNewCard": true,
	          "cardLast4": resp.last_four,
	          "cardType": resp.card_type,
	          "cardNumber": resp.card.number,
	          "expiryMonth": resp.exp_month,
	          "expiryYear": resp.exp_year
	        };
	
	        if (!$ctrl.hasErplyCardUpdateInitialized) {
	          $ctrl.hasErplyCardUpdateInitialized = true;
	          $ctrl.$order.updateCardTsys(dataReq).then(function (success) {
	            $ctrl.showAddCardButton = true;
	            $ctrl.hasErplyCardUpdateInitialized = false;
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.showHeartLandPage = false;
	            $ctrl.$spinner.hide('appSpinner');
	            if (success.data.successCode === '00') {
	              $ctrl.getSavedCards();
	              $ctrl.$toaster.pop('success', 'Card added Successfully');
	              //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	              // $ctrl.$state.go('cards-management', { 'success': 'success' });
	            } else {
	              //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	              // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	              $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
	              $ctrl.isCallingAPI = false;
	            }
	          }, function (error) {
	            $ctrl.showAddCardButton = true;
	            $ctrl.hasErplyCardUpdateInitialized = false;
	            $ctrl.clearIframeFields();
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.showHeartLandPage = false;
	            $ctrl.isCallingAPI = false;
	            // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	            //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	            $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
	            // var myEl = angular.element( document.querySelector( '#credit-card' ) );
	            // myEl.remove();
	          }).catch(function (err) {
	            $ctrl.showAddCardButton = true;
	            $ctrl.hasErplyCardUpdateInitialized = false;
	            $ctrl.clearIframeFields();
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.showHeartLandPage = false;
	            $ctrl.isCallingAPI = false;
	            // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	            // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	            $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
	          });
	        }
	      });
	
	      cardForm.on("token-error", function (resp) {
	        // console.log("token-error", resp);
	        $ctrl.cardFailure();
	      });
	
	      GlobalPayments.on("error", function (error) {
	        // console.log("error", error);
	        $ctrl.cardFailure();
	      });
	
	      cardForm.on("card-number-test", function (resp) {
	        $ctrl.cardvalid = resp.valid;
	        $ctrl.submitButtonState(cardForm);
	        // console.log("card-number-test", resp);
	      });
	
	      cardForm.on("card-expiration-test", function (resp) {
	        //   console.log("card-expiration-test", resp);
	        $ctrl.expdatevalid = resp.valid;
	        $ctrl.submitButtonState(cardForm);
	        // console.log("card-expiration-test", resp);
	      });
	
	      cardForm.on("card-cvv-test", function (resp) {
	        $ctrl.cvvalid = resp.valid;
	        $ctrl.submitButtonState(cardForm);
	        // console.log("card-cvv-test", resp);
	      });
	
	      cardForm.ready(function () {
	        // console.log("Registration of all credit card fields occurred");
	        $ctrl.$spinner.hide('appSpinner');
	      });
	    }
	
	    // Moneris
	
	  }, {
	    key: 'addMonerisCreditCard',
	    value: function addMonerisCreditCard() {
	      var $ctrl = this;
	
	      $ctrl.respUpdateMsg = function (e) {
	        // console.log("RespUpdateMsg get called ", e);
	        // var respData = eval("(" + e.data + ")");
	        // var resCode = `${respData.responseCode}`;
	        // var resDataKey = `${respData.dataKey}`;
	
	        var parsingJson = JSON.parse(e.data);
	
	        // console.log("Parsing Json : ",parsingJson);
	        // console.log("dataKey : ",parsingJson.dataKey);
	        // console.log("responseCode : ", parsingJson.responseCode);
	
	        var resCode = parsingJson.responseCode;
	        var resDataKey = parsingJson.dataKey;
	
	        if (resCode != null) {
	          //   resCode = resCode.split(',');
	          // console.log("ResCode : ", resCode, " : ResCode length: ", resCode.length);
	          if (resCode.length > 0) {
	            if (resCode[0] == '001') {
	              $ctrl.cardUpdateMoneris(resDataKey);
	            } else {
	              var srcLink = '';
	              if (window.innerWidth < 768) {
	                // console.log('inside mobile');
	                srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" + "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
	
	                if (resCode[0] == 943) {
	                  srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_pan=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
	                } else if (resCode[0] == 944) {
	                  srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_exp=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
	                } else if (resCode[0] == 945) {
	                  srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_cvd=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
	                } else {
	                  // console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
	                  $ctrl.goBack();
	                }
	              } else {
	                srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" +
	                // "&css_textbox_pan=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
	                // "&css_textbox_exp=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
	                // "&css_textbox_cvd=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px;" +
	                // "&css_input_label=";
	                "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
	                if (resCode[0] == 943) {
	                  srcLink = srcLink + "&css_label_pan=color:darkslategrey;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_textbox_pan=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
	                } else if (resCode[0] == 944) {
	                  srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=color:darkslategrey;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_label_cvd=margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_exp=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
	                } else if (resCode[0] == 945) {
	                  srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=color:darkslategrey;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_textbox_cvd=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
	                } else {
	                  console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
	                  $ctrl.goBack();
	                }
	              }
	              document.getElementById("monerisFrameUpdate").src = srcLink;
	            }
	          }
	        }
	      };
	
	      if (!this.APP.ORDER.MONERIS_LOADED.update_page_loaded) {
	        this.APP.ORDER.MONERIS_LOADED.update_page_loaded = true;
	        // console.log("Adding once this.respUpdateMsg : ", this.respUpdateMsg);
	        if (window.addEventListener) {
	          window.addEventListener("message", this.respUpdateMsg, false);
	        } else {
	          if (window.attachEvent) {
	            window.attachEvent("onmessage", this.respUpdateMsg);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'clearIframeFields',
	    value: function clearIframeFields() {
	      var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
	      var iframesG = angular.element(document.querySelector('#iframes'));
	      var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
	      var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
	      var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
	      var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
	    }
	  }, {
	    key: 'cardFailure',
	    value: function cardFailure() {
	      var $ctrl = this;
	      $ctrl.showAddCardButton = true;
	      $ctrl.hasErplyCardUpdateInitialized = false;
	      $ctrl.clearIframeFields();
	      $ctrl.$spinner.hide('appSpinner');
	      $ctrl.showHeartLandPage = false;
	      $ctrl.isCallingAPI = false;
	      $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
	    }
	  }, {
	    key: 'submitButtonState',
	    value: function submitButtonState(cardForm) {
	      var $ctrl = this;
	      // console.log("cardForm := ",cardForm);
	      // console.log($ctrl.cardvalid + ", " + $ctrl.expdatevalid + ", " + $ctrl.cvvalid);
	      if ($ctrl.cvvalid && $ctrl.cardvalid && $ctrl.expdatevalid) {
	        cardForm.addStylesheet({
	          "button": {
	            "pointer-events": "auto",
	            "opacity": "1",
	
	            'box-sizing': 'border-box',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'font-size': '15px',
	            'line-height': '1',
	            'width': 'auto !important',
	            'outline': '0',
	            'padding': '.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'border': '0 solid transparent',
	            'color': '#fff',
	            'cursor': 'pointer',
	            'flex': '0.61 1 auto !important'
	          }
	        });
	      } else {
	        cardForm.addStylesheet({
	          "button": {
	            "pointer-events": "none",
	            "opacity": ".5",
	
	            'box-sizing': 'border-box',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'font-size': '15px',
	            'line-height': '1',
	            'width': 'auto !important',
	            'outline': '0',
	            'padding': '.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'border': '0 solid transparent',
	            'color': '#fff',
	            // 'cursor': 'pointer',
	            'flex': '0.61 1 auto !important'
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cardUpdateMoneris',
	    value: function cardUpdateMoneris(token) {
	      var $ctrl = this;
	      if (!this.hasPaymentInitialized) {
	        this.hasPaymentInitialized = true;
	        $ctrl.$spinner.show('appSpinner');
	        console.log("Adding moneris card");
	
	        var dataReq = {
	          "token": token,
	          "action": "update",
	          // "isNewCard": true,
	          // "cardLast4": resp.last_four,
	          // "cardType": resp.card_type,
	          // "cardNumber": resp.card.number,
	          // "expiryMonth": resp.exp_month,
	          // "expiryYear": resp.exp_year,
	          "cardId": $ctrl.updateCardId
	        };
	
	        $ctrl.$order.updateCardMoneris(dataReq).then(function (success) {
	          $ctrl.showAddCardButton = true;
	          $ctrl.hasPaymentInitialized = false;
	          $ctrl.$spinner.hide('appSpinner');
	          $ctrl.showHeartLandPage = false;
	          $ctrl.hasErplyCardUpdateInitialized = false;
	          if (success.data.successCode === '00') {
	            $ctrl.getSavedCards();
	            $ctrl.$toaster.pop('success', 'Card Updated Successfully');
	            // $ctrl.$state.go('cards-management', { 'success': 'success' });
	          } else {
	            // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	            $ctrl.isCallingAPI = false;
	          }
	        }, function (error) {
	          $ctrl.showAddCardButton = true;
	          $ctrl.hasErplyCardUpdateInitialized = false;
	          $ctrl.clearIframeFields();
	          $ctrl.$spinner.hide('appSpinner');
	          $ctrl.showHeartLandPage = false;
	          $ctrl.isCallingAPI = false;
	          // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	          $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	        }).catch(function (err) {
	          $ctrl.showAddCardButton = true;
	          $ctrl.hasErplyCardUpdateInitialized = false;
	          $ctrl.clearIframeFields();
	          $ctrl.$spinner.hide('appSpinner');
	          $ctrl.showHeartLandPage = false;
	          $ctrl.isCallingAPI = false;
	          // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	          $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	        });
	      } else {
	        console.log(" Moneris Payment already iniitalized");
	      }
	    }
	  }, {
	    key: 'doMonerisSubmit',
	    value: function doMonerisSubmit() {
	      this.$spinner.show('appSpinner');
	      var monFrameRef = document.getElementById('monerisFrameUpdate').contentWindow;
	      console.log("monFrameRef : ", monFrameRef);
	      monFrameRef.postMessage('tokenize', this.gatewayUrl);
	      this.$spinner.hide('appSpinner');
	      return false;
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.showAddCardButton = true;
	    }
	  }, {
	    key: 'getSavedCards',
	    value: function getSavedCards() {
	      var _this17 = this;
	
	      this.$order.getPaymentInfo().then(function (success) {
	        if (success.data.length > 0) {
	          console.log("---success.data.length---", success.data.length, success);
	          _this17.cardId = success.data[success.data.length - 1].id;
	        }
	      }).catch(function (err) {
	        _this17.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {});
	    }
	  }, {
	    key: 'choosePaymentMethod',
	    value: function choosePaymentMethod() {
	      if (this.addMiscellaneousPaymentMethod) {
	        if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
	          var miscellaneousExists = false;
	          for (var i = 0; i < this.paymentMethods.length; i++) {
	            if (this.paymentMethods[i].type == this.miscellaneous) {
	              miscellaneousExists = true;
	              this.paymentOption = this.paymentMethods[i].value;
	            } else {
	              this.paymentMethods[i].disable = true;
	            }
	          }
	          if (!miscellaneousExists) {
	            var newObj = {
	              "name": "Pay with debit or credit card",
	              "logo": false,
	              "cardLogo": false,
	              "id": "unsual-pay-now",
	              "type": this.miscellaneous,
	              "disable": false
	            };
	            if (this.isAllowToPayOnlyWithGiftCards) {
	              newObj.value = "giftCard";
	              newObj.name = "Pay with Gift Card";
	            }
	            if (this.isAllowToPayWithStoreCreditOnly) {
	              newObj.value = "storeCredit";
	              newObj.name = "Pay with Store Credit";
	            }
	            this.paymentOption = newObj.value;
	            newObj.order = 5;
	            this.paymentMethods.push(newObj);
	          }
	        } else {
	          var removingIndex = null;
	          var lastChoosenPaymentOption = "";
	          for (var j = 0; j < this.paymentMethods.length; j++) {
	            if (this.paymentMethods[j].type == this.miscellaneous) {
	              removingIndex = j;
	            } else {
	              this.paymentMethods[j].disable = false;
	              if (this.paymentMethods[j].lastChoosen) {
	                lastChoosenPaymentOption = this.paymentMethods[j].value;
	              }
	            }
	          }
	          if (removingIndex != null) {
	            this.paymentMethods.splice(removingIndex, 1);
	            this.paymentOption = lastChoosenPaymentOption;
	          }
	        }
	      }
	
	      switch (this.paymentOption) {
	        case this.paymentMethod.paypal.payNow:
	          if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
	            this.showPlaceOrderButton = true;
	            this.payWithNewCardButton = false;
	            this.payWithSavedCardButton = false;
	            this.payWithPayPalButton = false;
	            this.payWithPayPalVaultButton = false;
	            this.textOnButton = "Pay Now";
	            this.textOnTerms = "'Pay Now'";
	          } else {
	            this.showPlaceOrderButton = false;
	            this.payWithNewCardButton = false;
	            this.payWithSavedCardButton = false;
	            if (this.paypalTextOnButton != null && this.paypalTextOnButton.length > 0) {
	              this.textOnTerms = this.paypalTextOnButton;
	            } else {
	              this.textOnTerms = "'Pay Now' or 'PayPal' or 'venmo' or 'Pay Later'";
	            }
	            this.payWithPayPalButton = true;
	            this.payWithPayPalVaultButton = false;
	          }
	          break;
	
	        case this.paymentMethod.paypal.payVault:
	          if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
	            this.showPlaceOrderButton = true;
	            this.payWithNewCardButton = false;
	            this.payWithSavedCardButton = false;
	            this.payWithPayPalButton = false;
	            this.payWithPayPalVaultButton = false;
	            this.textOnButton = "Pay Now";
	            this.textOnTerms = "'Pay Now'";
	          } else {
	            this.showPlaceOrderButton = false;
	            this.payWithNewCardButton = false;
	            this.payWithSavedCardButton = false;
	            this.textOnButton = "Pay Now";
	            this.textOnTerms = "'Pay Now'";
	            this.payWithPayPalButton = false;
	            this.payWithPayPalVaultButton = true;
	          }
	          break;
	
	        case this.paymentMethod.creditCard.savedCard:
	          this.showPlaceOrderButton = true;
	          this.payWithSavedCardButton = true;
	          this.payWithNewCardButton = false;
	          this.payWithPayPalButton = false;
	          this.payWithPayPalVaultButton = false;
	          this.textOnButton = "Pay Now";
	          this.textOnTerms = "'Pay Now'";
	          break;
	
	        case this.paymentMethod.creditCard.newCard:
	          this.payWithPayPalButton = false;
	          this.payWithPayPalVaultButton = false;
	          this.payWithSavedCardButton = false;
	          this.textOnButton = "Proceed to enter card details";
	          this.textOnTerms = "'Proceed to enter card details'";
	          if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
	            this.showPlaceOrderButton = true;
	            this.payWithNewCardButton = false;
	          } else {
	            this.payWithNewCardButton = true;
	            this.showPlaceOrderButton = false;
	          }
	          break;
	
	        case this.paymentMethod.storeCredit:
	          this.payWithNewCardButton = false;
	          this.payWithSavedCardButton = false;
	          this.showPlaceOrderButton = true;
	          this.payWithPayPalButton = false;
	          this.payWithPayPalVaultButton = false;
	          this.textOnButton = "Pay Now";
	          this.textOnTerms = "'Pay Now'";
	          break;
	
	        case this.paymentMethod.giftCard:
	          this.payWithNewCardButton = false;
	          this.payWithSavedCardButton = false;
	          this.showPlaceOrderButton = true;
	          this.payWithPayPalButton = false;
	          this.payWithPayPalVaultButton = false;
	          this.textOnButton = "Pay Now";
	          this.textOnTerms = "'Pay Now'";
	          break;
	
	        default:
	          this.payWithNewCardButton = true;
	          this.payWithSavedCardButton = false;
	          this.showPlaceOrderButton = false;
	          this.payWithPayPalButton = false;
	          this.payWithPayPalVaultButton = false;
	          this.textOnButton = "Pay Now";
	          this.textOnTerms = "'Pay Now'";
	          break;
	      }
	    }
	  }, {
	    key: 'updateUserAction',
	    value: function updateUserAction(userAction, comments) {
	      this.$order.updateUserAction(userAction, comments);
	    }
	  }, {
	    key: 'getAppOrderId',
	    value: function getAppOrderId() {
	      return this.$stateParams.orderId;
	    }
	  }]);
	
	  return CardDetail;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', '$stateParams', 'spinnerService', 'orderService', 'authService', '$window', 'APP', '$q', '$uibModal', 'Heartland', 'GlobalPayments'], _temp)) || _class);
	exports.default = CardDetail;

/***/ },
/* 216 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABICAYAAADvTjsnAAAACXBIWXMAAAsSAAALEgHS3X78AAAHeklEQVR4nO2cQWjjSBaG/9kMNhYRDMgsyNjgvVQu06wX5ZK+tGcacrKbhYaG9Bwme7HIcXFO2YZOQzOn1uwxWLBs+jAxGBqGjU6B7HguMQwjcJNhIXXy4iBdImioYGNDYA+yKpadTBJlk2jS9V2cUpXK79WvKtV7ZQIIBAKBQCAQCG6PT866qNUqRQDFW7Xk42TT1s3O5MUpUbRa5Z8Alm/BIIHPX2zd3By/EBJlNEN+uEWDBD5/GJ8xv5uoLN6qKYKAP48XJkUR3A2fjReEKDFEiBJDhCgxRIgSQ4QoMUSIEkOEKDFEiBJDhCgxRIgSQ4QoMUSIEkOEKDFEiBJDhCgx5NOoN570hsgddkLXWO8EsjTDP8dxUp8Bud9H/bqPisiiKIddvCQsdM2mDBqR+ec4dcrQxPmiFPMFNDvtqObcKyIvXxJOzq0jWQm027t0XxWtDE0lyMhKVHPuFZFnCuudwKbszDpZmsGP7/tg/VPhHC95ZtulB48BAM3/tvEoX0B9fzeqSfeGyKLI0szUEjUukqokQvWUAnSij+rCMwC+IHJCQmZWzBQgJrsvNuhDTqTu2ozYcCPLFwC43jBUf9byZbQaeLO4gmK+ANs9gCqno5pzr7iR5Yv1TkCyKZCcxOvOWr4AYHVnA0sPHkNT52DRvajm3CtuZPmih72QIBdR398FG/bgMO8mzPnNEXmmdLN5/IP+J7Q1Zj0JdvsErjczNSt+SmV+tT+x6zolsigzUgI/kcK59U7UjgXx2H0JwghRYogQJYYIUWKIECWGCFFiiBAlhkSOUwCAKDnIyRRc5sFhHjKyAlVWwAZ9UK87VZYTEkg6CwCwnemkC1FycJkHNuzxe4O24/fSo0PIyRTYoA9VVvg9AeNt2aCP41HdeMZAyxD+t+3QKVvHuapfF/l5EZFF0TIEtVKVl3XLmCq/WVyBnPDTLUargeefP+YDXd/fhdFq8PYZWcHW0xcwbQumvY2XxWVoqj9wzU4bclLiZZd52KYtbodpb4ecrz58hhJZAABQr4tm5z20DIG+bQDwTznfLK7w9q+am3hZXAYb9iAnJOiWwfvLyAr+tfTNpf0ybQtEyaKYL3DbV3c2rjS2kZcvTZ0D9bqYN3W4zIOmzgEA5k0dtktR0cqQExK+2Pwr6vu7kBMSVFmBbhm+4elcqD+HeaEnVN82MG/qMFoNyEmJl3XL4ANwHqqswLQtzJs6nr97PVXf7LQxb+qYN/VRez87/WTrbyFfgr7O88uirSm/tAxBMV/A6s4GVnc2ICcvnwMMuNbyxYb9kOFnt+nxdpftD/BPJIv5AjSVoL6/G3piA/EqWgkAUCtV8aS+xpcnNuihopVQ0UqwXQrbodBUgp8rNVCvOyUU9bpgwx5+WP47AMB2D3idO+rz50ptVEe5X7/uy+WPwye5lRd9lAOs6sIz2A7F83evYbQacJgH3TJgtBogSg71/V3olgHqdfGquRl6X3zbavC2wZJHvS50ywBRcqH3CTB6NyYkrO5sTM0Uh3l4Ul/j3zXORTM2WOKuSuSZ4rIjaGoJtXKVlwGgVq5CUwkfkK2nL6DKCur7/wYb9lBdeAY5IeFgwsFauQqiZENHwsX8H6FlCOiR35akc8jMnr7YbYeCDftwjsMp/6XPH4Okc5ATKbBhDy47AlFy/PjZnTgiCJ7qilbCbDLFfQlwRhsZNuz796rgfjU7be6XKiv4sfMeNNHF+qNl/97jqx9HRBYleNGqchrWwd6ZZep1oalzYMMerIMWmp02ivkCL4/T7LT5y5V6XazubIAo/nvHZUdwjv1BsYHQYZh1sAd6dDhlW3G0FNruAe9XldN81gUYrQasgxZc5o12f0fcl0nq+7ugXhfbdC/k16SfcjKFEnno2xfh4G7y34CsA3h55V4E1+WVrZvrQUEEjzFEiBJDhCgx5FpxSpwIgrgg7XNeyuS3wLVEKeYL/GenmVmF765mkykcD/ytqu1QmPY2AD/2KM0twDpo8VhhvfkWW09f4El9Dd89fQE5IfG0CgCeGrkIOZnCevFrECUHo9VAeZRmCQJFouRgLK6gXF/jQeJX717DYR7/7ZlpW1h68CWOB32U62vXGZprcc2I3t/fy4kUtunpQFPP36JqKplKyB0P/K1qsN0NnmSHeVjd2eCB29KDL3k/l8FhHtabb3miknpdsMFphoB6XR7sfbvXQEUrYzYhYb1YRv2XXchJCUTJgnqHd/7z2ciilMkCHuULYIMeiJIFUUZZUZfyv89aOpxjDySd4wHc+C/txyPgqwgS9GMsrvCBd5kXetqD7ymTBVS0MrZ+8VM3DvNQK1Vh2hbq+7sg6SwPMu+KyKI0O++hymk0O21kqAKi5EC9LoiS48FZEPQFBEGdn+4+Tb2YtgXAn3lBHmoyqr4Ih3kw7W2eXJy8v0QewnYptMwcnGPPD2IHPbxqvgVRstAyhAeOUdLt/09E8BgPRPAYd4QoMWRSlA93YoWgOV6YFGUTQpjbpm3rZnP8QkgUWzc/APgTgO8hxLlpPsCfBF/csR0CgUAgEAgEHzn/A8ufkaBtxZ+eAAAAAElFTkSuQmCC"

/***/ },
/* 217 */
/***/ function(module, exports) {

	module.exports = "<div ng-show=\"!cardDetail.showHeartLandPage\" class=\"p-x-0 p-b-1\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"cardDetail.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{cardDetail.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"delivery\">Checkout Details</a>\r\n    <span>Payment</span>\r\n  </nav>\r\n\r\n  <div class=\"row sub-header-bg m-x-0 hidden-md-up\">\r\n    <div class=\"col-xs-6 mt-8 mb-8\">\r\n      <h5>\r\n        <strong>Store Details</strong>\r\n      </h5>\r\n      <h6 class=\"m-b-0\" ng-bind=\"cardDetail.profile.store.storeName\"></h6>\r\n      <p class=\"m-b-0\" ng-if=\"cardDetail.profile.store.addressLine1\">{{cardDetail.profile.store.addressLine1}}\r\n        {{cardDetail.profile.store.addressLine2}}</p>\r\n      <p class=\"m-b-0\" ng-if=\"cardDetail.profile.store.country\">{{cardDetail.profile.store.city}}\r\n        {{cardDetail.profile.store.state.name}}, {{cardDetail.profile.store.country.name}}\r\n        {{cardDetail.profile.store.zipCode}}\r\n      </p>\r\n    </div>\r\n    <div class=\"col-xs-6 mt-8 mb-8 text-xs-right\">\r\n      <h5>\r\n        <strong>Phone Number</strong>\r\n      </h5>\r\n      <p class=\"m-b-0\">\r\n        <a class=\"blue-colored\" href=\"tel:{{cardDetail.profile.store.phoneNumber}}\">\r\n          {{cardDetail.profile.store.phoneNumber | telFormat}}</a>\r\n      </p>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <form name=\"cardDetailForm\">\r\n    <div class=\"row p-t-1 m-x-0 static-content \">\r\n      <div class=\"col-lg-8 col-md-8 col-xs-12\">\r\n\r\n        <div ng-if=\"cardDetail.storeCreditAmount>0\">\r\n          <fieldset class=\"fieldset\">\r\n            <legend class=\"legend\">Store Credit</legend>\r\n            <div>\r\n              <input type=\"checkbox\" name=\"saveCard\" ng-model=\"cardDetail.isStoreCreditUsed\"\r\n                ng-click=\"cardDetail.getStoreCredit()\" class=\"form-control text-xs-left d-inline\"\r\n                style=\"width: auto;\" />\r\n              <span ng-if=\"cardDetail.amountToBeChargedFromStoreCredit==0\">\r\n                <strong>Apply ${{cardDetail.storeCreditAmount | number : 2}} store credit</strong>\r\n              </span>\r\n              <span ng-if=\"cardDetail.amountToBeChargedFromStoreCredit>0\">\r\n                <strong ng-if=\"cardDetail.amountToBeChargedFromStoreCredit>=cardDetail.storeCreditAmount\">Apply\r\n                  ${{cardDetail.amountToBeChargedFromStoreCredit | number : 2}} store credit</strong>\r\n                <strong ng-if=\"cardDetail.amountToBeChargedFromStoreCredit<cardDetail.storeCreditAmount\">Apply\r\n                  ${{cardDetail.amountToBeChargedFromStoreCredit | number : 2}} of your available\r\n                  ${{cardDetail.storeCreditAmount | number : 2}} store credit</strong>\r\n              </span>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <!-- Changes goes here radio buttons -->\r\n\r\n        <fieldset class=\"fieldset\">\r\n          <legend class=\"legend\">Select Payment Option</legend>\r\n\r\n          <div class=\"outer-flex-row\">\r\n\r\n            <div ng-class=\"cardDetail.isMobileOnly()?'layer1-flex-col-mobile':'layer1-flex-col'\">\r\n              <div ng-repeat=\"item in cardDetail.paymentMethods | orderBy:'order'\">\r\n                <label class=\"payment-method-row\" ng-style=\"item.disable? {'background-color':'#ccc'}:''\"\r\n                  ng-click=\"cardDetail.choosePaymentMethod()\" >\r\n                  <div class=\"col col-3 align-left\">\r\n                    <div ng-if=\"!item.cardLogo\" class=\"mark-logo\"><span id=\"{{item.id}}\"></span></div>\r\n                    <!-- <div ng-if=\"!item.cardLogo\" class=\"card-logo\"> \r\n                      <img  src={{cardDetail.paypalMonoIcon}} alt=\"card-logo\" class=\"card-logo-padding\"/>\r\n                      <span id=\"{{item.id}}\"></span></div> -->\r\n                    <div ng-if=\"item.cardLogo\" class=\"card-logo\">\r\n                      <img  src={{cardDetail.cardLogo}} alt=\"card-logo\" class=\"card-logo-padding\"/>\r\n                      <span id=\"{{item.id}}\"></span></div>\r\n                  </div>\r\n                  <div class=\"col col-7 align-left\"><span> {{item.name}}</span></div>\r\n                  <div class=\"col col-2 align-left\">\r\n                    <input type=\"radio\" class=\"custom-right-radio\" ng-model=\"cardDetail.paymentOption\"\r\n                     ng-value=\"item.value\"/>\r\n                  </div>\r\n                </label>\r\n              </div>\r\n            </div>\r\n\r\n            <div ng-class=\"cardDetail.isMobileOnly()?'layer1-flex-col-mobile':'layer1-flex-col'\">\r\n              <div>\r\n                <span\r\n                  ng-if=\"cardDetail.payWithNewCardButton  && cardDetail.showSavedCard\">\r\n                  <input type=\"checkbox\" name=\"saveCard\" ng-model=\"cardDetail.canSaveCard\"\r\n                    ng-click=\"cardDetail.toggleSaveUserCard(cardDetail.canSaveCard)\" /> <strong>Save credit card for future use</strong>\r\n                    <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-click=\"cardDetail.infoPopup()\"\r\n                      ng-mouseenter=\"cardDetail.infoPopuponhover()\" ng-mouseleave=\"cardDetail.hideinfoPopup()\"></i>\r\n                    <div id=\"popupsavecard\" style=\"display: none; position: absolute;\" class=\"popup-savedcard-info\">\r\n                      *Please note: Saved cards will remain on file for up to 6 months. This helps us maintain up-to-date\r\n                      security practices and protect against potential fraud. You&apos;re always welcome to re-enter and re-save\r\n                      your card at any time.\r\n                    </div>\r\n                </span>\r\n                <span ng-if=\"!cardDetail.profile.customer.isGuest\">\r\n                <!--                   \r\n                  <span ng-if=\"cardDetail.payWithPayPalButton && !cardDetail.storeFeatures.paypal.customerHasVault\">\r\n                    <input type=\"checkbox\" name=\"saveVault\" \r\n                    ng-model=\"cardDetail.savePaypalVault\"/>\r\n                    <strong>Save Paypal</strong>\r\n                  </span>\r\n                  <span ng-if=\"cardDetail.payWithPayPalVaultButton && cardDetail.storeFeatures.paypal.customerHasVault\">\r\n                    <input type=\"checkbox\" name=\"saveVault\" \r\n                    ng-model=\"cardDetail.savePaypalVault\"/>\r\n                    <strong>Save Paypal</strong>\r\n                  </span> -->\r\n\r\n                </span>\r\n\r\n                <!-- cardDetail.storeFeatures.paypal.customerHasVault -->\r\n\r\n                <span ng-if=\"cardDetail.payWithSavedCardButton\">\r\n                  <h6 class=\"m-t-1 font-weight-bold\" ng-if=\"cardDetail.cardInfo.length>0\">Select your saved credit card</h6>\r\n                  <div class=\"form-check m-b-0\" ng-repeat=\"item in cardDetail.cardInfo\">\r\n                    <label class=\"form-radio-label mar-l-3\">\r\n                      <input type=\"radio\" class=\"form-radio-input\" ng-model=\"cardDetail.cardId\" ng-value=\"item.id\" />\r\n                      <span>{{item.cardNumber}}</span>\r\n                    </label>\r\n                  </div>\r\n                </span>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </fieldset>\r\n\r\n        <!-- Changes ends here for radio buttons -->\r\n        <!-- \r\n        <fieldset class=\"fieldset\">\r\n          <legend class=\"legend\">Credit Card</legend>\r\n            <div ng-if=\"!cardDetail.isAllowToPayOnlyWithGiftCards\">\r\n              \r\n\r\n\r\n              <div ng-show=\"!cardDetail.showAddCardButton\" id=\"AddCreditCard\">\r\n                <div ng-if=\"cardDetail.paymentType=='HeartLand'\" class=\"hform-wrapper\" style=\"margin-left:20%\">\r\n                  <form id=\"iframes\" action=\"\" method=\"GET\">\r\n                    <div id=\"ss-banner\" style=\"margin-left:10%\"></div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6 p-t-1 p-r-0\" style=\"width:20% !important\">\r\n                        <label for=\"iframesCardNumber\">Card Number</label>\r\n                      </div>\r\n                      <div id=\"iframesCardNumber\" class=\"col-md-6 p-b-1\"></div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6  p-t-1  p-r-0\" style=\"width:20% !important\">\r\n                        <label for=\"iframesCardExpiration\">Card Expiration</label>\r\n                      </div>\r\n                      <div id=\"iframesCardExpiration\" class=\"col-md-6 p-b-1\"></div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6 p-t-1  p-r-0\" style=\"width:20% !important\">\r\n                        <label for=\"iframesCardCvv\">Card CVV</label>\r\n                      </div>\r\n                      <div id=\"iframesCardCvv\" class=\"col-md-6 p-b-1\"></div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-6 m-t-1  col-sm-6 col-lg-6\">\r\n                        <div id=\"iframesSubmit\"></div>\r\n                      </div>\r\n                      <div class=\"col-md-6 m-t-1 col-sm-6 col-lg-6\">\r\n                        <button class=\"back\" ng-click=\"cardDetail.goBack()\">Back</button>\r\n                      </div>\r\n                    </div>\r\n                  </form>\r\n                </div>\r\n                \r\n                <div ng-if=\"cardDetail.paymentType=='Tsys'\">\r\n                  <div id=\"tsys2\" class=\"row\">\r\n                    <div class=\"col-xs-8\">\r\n                      <div class=\"row  m-t-2\">\r\n                        <div class=\"col-xs-4\">\r\n                          <label for=\"card-number\">Card Number</label>\r\n                        </div>\r\n                        <div class=\"col-xs-8\">\r\n                          <div id=\"card-number\" class=\"\"></div>\r\n                        </div>\r\n                      </div>\r\n                \r\n                      <div class=\"row m-t-2\">\r\n                        <div class=\"col-xs-4\">\r\n                          <label for=\"card-expiration\">Card expiration</label>\r\n                        </div>\r\n                        <div class=\"col-xs-8\">\r\n                          <div id=\"card-expiration\" class=\"\"></div>\r\n                        </div>\r\n                      </div>\r\n                \r\n                      <div class=\"row  m-t-2\">\r\n                        <div class=\"col-xs-4\">\r\n                          <label for=\"card-cvv\">Card CVV</label>\r\n                        </div>\r\n                        <div class=\"col-xs-8\">\r\n                          <div id=\"card-cvv\" class=\"\"></div>\r\n                        </div>\r\n                      </div>\r\n                \r\n                      <div class=\"row m-t-2\">\r\n                        <div class=\"col-xs-5\" style=\"float:left\">\r\n                          <div id=\"submit\" class=\"\"></div>\r\n                        </div>\r\n                        <div class=\"col-xs-5\" style=\"float:right\">\r\n                          <button class=\"back-btn\" ng-click=\"cardDetail.goBack()\">Back</button>\r\n                        </div>\r\n                      </div>\r\n                \r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                \r\n                <div ng-if=\"cardDetail.paymentType=='Moneris'\">\r\n                  <div class=\"moneris_payment\">\r\n                    <div id=\"ss-banner-moneris\"></div>\r\n                    <div ng-if=\"cardDetail.mobileView\">\r\n                      <iframe id=\"monerisFrameUpdate\" frameborder='0' width=\"500px\"  height=\"270px\"></iframe>\r\n                    </div>\r\n                    <div ng-if=\"!cardDetail.mobileView\">\r\n                      <iframe id=\"monerisFrameUpdate\" frameborder='0' width=\"500px\"  height=\"230px\"></iframe>\r\n                    </div>\r\n                    <div class=\"mb-50\">\r\n                      <button class=\"back-btn moneris_payment_submit\" ng-click=\"cardDetail.doMonerisSubmit()\">Submit</button>\r\n                      <button class=\"back-btn moneris_payment_back\" ng-click=\"cardDetail.goBack()\">Back</button>\r\n                    </div>\r\n                  </div> \r\n                </div>\r\n                \r\n              </div>\r\n\r\n\r\n\r\n              <h6 class=\"m-t-1 font-weight-bold\" ng-if=\"cardDetail.cardInfo.length>0\">Want to continue with your saved credit card</h6>\r\n              <div class=\"form-check m-b-0\" ng-repeat=\"item in cardDetail.cardInfo\">\r\n                <label class=\"form-radio-label mar-l-3\">\r\n                  <input type=\"radio\" class=\"form-radio-input\" ng-model=\"cardDetail.cardId\" ng-value=\"item.id\"/>\r\n                  <span>{{item.cardNumber}}</span>\r\n                </label>\r\n              </div>\r\n            </div>\r\n          <h6 class=\"m-t-1 m-b-1 font-weight-bold\" ng-if=\"cardDetail.cardInfo.length<1\">\r\n            Click Pay Now button below to enter credit card\r\n\r\n          </h6>\r\n          <span ng-if=\"cardDetail.showSavedCard\">\r\n            <input type=\"checkbox\" name=\"saveCard\" ng-model=\"cardDetail.canSaveCard\"\r\n              ng-click=\"cardDetail.toggleSaveUserCard(cardDetail.canSaveCard)\"\r\n              class=\"form-control text-xs-left d-inline\" style=\"width: auto;\" /> <strong>Save credit card</strong>\r\n            <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-click=\"cardDetail.infoPopup()\"\r\n              ng-mouseenter=\"cardDetail.infoPopuponhover()\" ng-mouseleave=\"cardDetail.hideinfoPopup()\"></i>\r\n            <div id=\"popupsavecard\" style=\"display: none; position: absolute;\" class=\"popup-savedcard-info\">\r\n              *Please note: Saved cards will remain on file for up to 6 months. This helps us maintain up-to-date\r\n              security practices and protect against potential fraud. You&apos;re always welcome to re-enter and re-save\r\n              your card at any time.\r\n            </div>\r\n          </span>\r\n        </fieldset>\r\n      -->\r\n        <!-- Gift card starts -->\r\n        <fieldset class=\"fieldset\"  ng-if=\"cardDetail.isGiveXAvailable && !cardDetail.cartContainsOnlyGift()\">\r\n          <legend class=\"legend\" style=\"margin: 0px\">Gift Card</legend>\r\n          <div class=\"giftcard-payment\">\r\n            <div class=\"row\"\r\n              ng-repeat=\"cards in cardDetail.giftCardDetails\">\r\n              <div ng-class=\"cardDetail.isIpad()?'p-r-0':''\" class=\"col-lg-5 col-md-7 col-xs-7 \">\r\n                <input class=\"form-control\" name=\"cardNumber\" type=\"text\" ng-pattern=\"/^[0-9a-zA-Z-]{1,25}$/\"\r\n                  ng-model=\"cards.cardNumber\" placeholder=\"WBU Gift Card Number\" ng-disabled=\"(cards.isCardVerified)\">\r\n              </div>\r\n\r\n              <div ng-class=\"cardDetail.isIpad()?'p-r-1':''\" class=\" col-lg-2 col-md-5 col-xs-5\" ng-if=\"!cards.isCardVerified\">\r\n                <button class=\"btn btn-primary btn-block btn-md-text\" ng-disabled=\"cardDetailForm.cardCvv.$error.pattern || cardDetailForm.cardNumber.$error.pattern\r\n                  || !cards.cardNumber\" ng-click=\"cardDetail.verifyCard($index)\">Apply</button>\r\n              </div>\r\n              <div ng-class=\"cardDetail.isIpad()?'p-r-1':''\" class=\" col-lg-2 col-md-5 col-xs-5\"\r\n                ng-if=\"cards.isCardVerified\">\r\n                <input class=\"form-control\" type=\"text\" value=\"$ {{ cards.amount | number : 2}}\" placeholder=\"amount\"\r\n                  disabled>\r\n              </div>\r\n              <div ng-class=\"cardDetail.isIpad()?cardDetail.isIpadPotrait()?'p-l-1 p-r-0':'p-x-0':''\"\r\n                class=\"col-lg-3 col-md-7 col-xs-7\">\r\n                <button class=\"btn btn-primary btn-block btn-md-text\" ng-click=\"cardDetail.addCard($index)\">Add Gift Card</button>\r\n              </div>\r\n              <div ng-class=\"cardDetail.isIpad()?'p-r-1':''\" class=\"col-lg-2 col-md-5 col-xs-5\">\r\n                <button class=\"btn btn-primary btn-block btn-md-text\" ng-click=\"cardDetail.removeCard($index)\">Remove</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n        <!-- Gift card ends -->\r\n\r\n\r\n        \r\n      </div>\r\n      <!--  -->\r\n      <div ng-class=\"cardDetail.isIpad()?cardDetail.isIpadPotrait()?'p-r-0':'':''\"\r\n        class=\"col-lg-4 col-md-4 col-xs-12 m-t-1\">\r\n        <div class=\"div_border\">\r\n          <div>\r\n            <div class=\"p-x-1\">\r\n              <h5 class=\"font-weight-bold m-y-1\">Order Detail</h5>\r\n              <h6 class=\"m-b-1\">\r\n                <span>Order Amount</span>\r\n                <span class=\"font-weight-bold pull-xs-right\">$ {{cardDetail.orderAmount | number : 2}}</span>\r\n              </h6>\r\n              <h6 class=\"m-b-1\" ng-if=\"!cardDetail.isIpadPotrait()\">\r\n                <span>Gift Card Applied</span>\r\n                <span class=\" pull-xs-right\">- $ {{cardDetail.getTotalGiftCardAddedAmount() | number : 2}}</span>\r\n              </h6>\r\n              <h6 class=\"m-b-1\" ng-if=\"cardDetail.isIpadPotrait()\">\r\n                <p class=\"m-y-0\">Gift Card</p>\r\n                <span>Applied</span>\r\n                <span class=\" pull-xs-right\">- $ {{cardDetail.getTotalGiftCardAddedAmount() | number : 2}}</span>\r\n              </h6>\r\n              <h6 class=\"m-b-1\"\r\n                ng-if=\"!cardDetail.isIpadPotrait() && cardDetail.storeCreditAmount>0 && cardDetail.isStoreCreditUsed\">\r\n                <span>Store Credit</span>\r\n                <span class=\" pull-xs-right\">- $ {{cardDetail.amountToBeChargedFromStoreCredit | number : 2}}</span>\r\n              </h6>\r\n            </div>\r\n            <div class=\"gray-bg p-a-1\">\r\n              <h3 ng-if=\"cardDetail.isStoreCreditUsed\" class=\"font-weight-bold m-b-0\">Total\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$ ' + (cardDetail.orderAmount-cardDetail.amountToBeChargedFromStoreCredit-cardDetail.getTotalGiftCardAddedAmount() | number : 2)\"></span>\r\n              </h3>\r\n              <h3 ng-if=\"!cardDetail.isStoreCreditUsed\" class=\"font-weight-bold m-b-0\">Total\r\n                <span class=\"pull-xs-right ng-cloak\"\r\n                  ng-bind=\"'$ ' + (cardDetail.orderAmount-cardDetail.getStoreCredit()-cardDetail.getTotalGiftCardAddedAmount() | number : 2)\"></span>\r\n              </h3>\r\n            </div>\r\n            <div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n\r\n        <!-- New changes starts here -->\r\n        <!-- Payment Buttons starts -->\r\n         <div class=\"payment-button\">\r\n            <div class=\"text-xs-center\" id=\"scroll-to-paynow\">\r\n\r\n              <div ng-if=\"(cardDetail.showPlaceOrderButton || cardDetail.payWithPayPalVaultButton) && cardDetail.orderAmount > 0\">\r\n                <div >\r\n                  <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text \"\r\n                    ng-class=\"cardDetail.cardInfo.length>0?'':''\"\r\n                    ng-disabled=\"cardDetail.isCallingAPI || !cardDetail.agreement || cardDetail.waitUntilVerify\"\r\n                    ng-click=\"cardDetail.submit()\">{{cardDetail.textOnButton}}</button>\r\n                </div>\r\n              </div>\r\n\r\n              <div ng-if=\"cardDetail.payWithNewCardButton && cardDetail.orderAmount > 0\">\r\n                <div>\r\n                  <button type=\"button\" class=\"btn btn-primary btn-block btn-md-text\"\r\n                    ng-class=\"cardDetail.cardInfo.length>0?'':''\"\r\n                    ng-disabled=\"cardDetail.isCallingAPI || !cardDetail.agreement || cardDetail.waitUntilVerify\"\r\n                    ng-click=\"cardDetail.paymentByNewCard()\">{{cardDetail.textOnButton}}</button>\r\n                </div>\r\n              </div>\r\n\r\n              <div>\r\n                <div class=\"btn-container\">\r\n                  <div id=\"paypal-now-btn-container\"\r\n                    ng-show=\"cardDetail.payWithPayPalButton  && cardDetail.orderAmount > 0\">\r\n                  </div>\r\n                  <!-- <div id=\"paypal-later-btn-container\" ng-show=\"cardDetail.paymentOption == cardDetail.paymentMethod.paypal.payLater\">\r\n                  </div> -->\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n            <!-- Payment Buttons Ends -->\r\n            \r\n            <div>\r\n              <div class=\"terms-style\">\r\n                By selecting {{cardDetail.textOnTerms}}, I agree to the <a target=\"_blank\" ui-sref=\"terms-conditions\" class=\"link-text\">Terms and Conditions</a> (which include the Refund Policy).\r\n              </div>\r\n            </div>\r\n          </div>\r\n        <!-- New changes ends here -->\r\n      </div>\r\n      <!--  -->\r\n    </div>\r\n  </form>\r\n</div>"

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d63a298578700c5bf26b310223bfb804.png";

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _cardUpdate = __webpack_require__(220);
	
	var _cardUpdate2 = _interopRequireDefault(_cardUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cardUpdate = (_dec = (0, _utils.Component)({
	    controllerAs: 'cardUpdate',
	    template: _cardUpdate2.default
	}), _dec(_class = (_temp = _class2 = function () {
	    function cardUpdate($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, Heartland, GlobalPayments, $uibModal) {
	        var _this = this;
	
	        _classCallCheck(this, cardUpdate);
	
	        this.$onDestroy = function () {
	            // console.log('inside destroy');
	            if (this.APP.ORDER.MONERIS_LOADED.update_page_loaded) {
	                if (window.addEventListener) {
	                    this.APP.ORDER.MONERIS_LOADED.update_page_loaded = false;
	                    window.removeEventListener("message", this.respUpdateMsg, false);
	                } else {
	                    if (window.attachEvent) {
	                        window.attachEvent("onmessage", this.respUpdateMsg);
	                    }
	                }
	            }
	        };
	
	        var disconnect = $ngRedux.connect(this.mapState)(this);
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$order = $order;
	        this.$toaster = $toaster;
	        this.$uibModal = $uibModal;
	        this.logoIcon = _smallLogo2.default;
	        this.houseIcon = _houseIcon2.default;
	        this.$window = $window;
	        this.$auth = $auth;
	        this.APP = APP;
	        this.$spinner = $spinner;
	        this.giftCardNumbers = [];
	        this.totalGiftAmount = 0.00;
	        this.hasErplyCardUpdateInitialized = false;
	        this.heartand_Approval = "APPROVAL";
	        this.count = 0;
	        $spinner.show('appSpinner');
	        if (window.innerWidth < 768) {
	            // console.log('mobileView');
	            this.mobileView = true;
	        } else {
	            this.mobileView = false;
	        }
	        $order.getPaymentKeys().then(function (success) {
	
	            _this.paymentGlobalKey = success.data.globalKey;
	            _this.updateCardId = _this.$stateParams.cardId;
	            _this.paymentType = success.data.paymentType;
	            _this.version = success.data.version;
	            _this.uuid = success.data.uuid;
	            _this.gatewayUrl = success.data.url;
	            if (_this.paymentType === _this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	                setTimeout(function () {
	                    _this.initializeHeartland(Heartland);
	                }, 100);
	            } else if (_this.paymentType === _this.APP.ORDER.PAYMENT_TYPE.tsys) {
	                setTimeout(function () {
	                    // this.paymentGlobalKey = success.data.globalKey;
	                    _this.env = success.data.enviroment;
	                    _this.initializeTsys(GlobalPayments);
	                }, 100);
	                // this.initializeTsys(GlobalPayments);
	            } else if (_this.paymentType === _this.APP.ORDER.PAYMENT_TYPE.moneris) {
	                setTimeout(function () {
	                    // this.paymentGlobalKey = success.data.globalKey;
	                    _this.env = success.data.enviroment;
	                    if (window.innerWidth < 768) {
	                        // console.log('inside mobile');
	                        document.getElementById("monerisFrameUpdate").src = _this.gatewayUrl + "?id=" + _this.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" + "&css_label_pan=;margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
	                    } else {
	                        document.getElementById("monerisFrameUpdate").src = _this.gatewayUrl + "?id=" + _this.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" + "&css_label_pan=;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
	                    }
	
	                    _this.initializeMoneris();
	                }, 100);
	            }
	        }).finally(function () {
	            return $spinner.hide('appSpinner');
	        });
	        if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
	            this.$onDestroy = function () {
	                this.hps.dispose();
	            };
	        }
	    }
	
	    _createClass(cardUpdate, [{
	        key: 'initializeHeartland',
	        value: function initializeHeartland(Heartland) {
	            var $ctrl = this;
	            // console.log("Updating card id : ", this.updateCardId, " ", $ctrl.paymentGlobalKey);
	            this.hps = new Heartland.HPS({
	                publicKey: $ctrl.paymentGlobalKey,
	                type: 'iframe',
	                // Configure the iframe fields to tell the library where
	                // the iframe should be inserted into the DOM and some
	                // basic options
	                fields: {
	                    cardNumber: {
	                        target: 'iframesCardNumber',
	                        placeholder: 'xxxx xxxx xxxx xxxx'
	                    },
	                    cardExpiration: {
	                        target: 'iframesCardExpiration',
	                        placeholder: 'MM / YYYY'
	                    },
	                    cardCvv: {
	                        target: 'iframesCardCvv',
	                        placeholder: 'CVV'
	                    },
	                    submit: {
	                        value: 'submit',
	                        target: 'iframesSubmit'
	                    }
	                },
	                // Collection of CSS to inject into the iframes.
	                // These properties can match the site's styles
	                // to create a seamless experience.
	                style: {
	                    'input': {
	                        'background': '#fff',
	                        'border': '1px solid',
	                        'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	                        'box-sizing': 'border-box',
	                        'font-family': 'serif',
	                        'font-size': '16px',
	                        'line-height': '1',
	                        'margin': '0 .5em 0 0',
	                        'max-width': '100%',
	                        'outline': '0',
	                        'padding': '0.5278em',
	                        'vertical-align': 'baseline',
	                        'height': '50px',
	                        'width': '100% !important'
	                    },
	                    '#heartland-field': {
	                        'font-family': 'sans-serif',
	                        'box-sizing': 'border-box',
	                        'display': 'block',
	                        'height': '50px',
	                        'padding': '6px 12px',
	                        'font-size': '14px',
	                        'line-height': '1.42857143',
	                        'color': '#555',
	                        'background-color': '#fff',
	                        'border': '1px solid #ccc',
	                        'border-radius': '0px',
	                        '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
	                        'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
	                        '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
	                        '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
	                        'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
	                        'width': '100%'
	                    },
	                    '#heartland-field[name=submit]': {
	                        'background-color': '#a4182d',
	                        'font-family': 'sans-serif',
	                        'text-transform': 'uppercase',
	                        'color': '#ffffff',
	                        'border': '0px solid transparent',
	                        'width': '200px !important',
	                        'margin-left': '5px  !important'
	                    },
	                    '#heartland-field[name=submit]:focus': {
	                        'color': '#ffffff',
	                        'background-color': '#a4182d',
	                        'outline': 'none'
	                    },
	                    '#heartland-field[name=submit]:hover': {
	                        'background-color': ' #a4182d'
	                    },
	                    '#heartland-field-wrapper #heartland-field:focus': {
	                        'border': '1px solid #3989e3',
	                        'outline': 'none',
	                        'box-shadow': 'none',
	                        'height': '50px'
	                    },
	                    'heartland-field-wrapper #heartland-field': {
	                        'height': '50px'
	                    },
	                    'input[type=submit]': {
	                        'box-sizing': 'border-box',
	                        'display': 'inline-block',
	                        'padding': '6px 12px',
	                        'margin-bottom': '0',
	                        'font-size': '14px',
	                        'font-weight': '400',
	                        'line-height': '1.42857143',
	                        'text-align': 'center',
	                        'white-space': 'nowrap',
	                        'vertical-align': 'middle',
	                        '-ms-touch-action': 'manipulation',
	                        'touch-action': 'manipulation',
	                        'cursor': 'pointer',
	                        '-webkit-user-select': 'none',
	                        '-moz-user-select': 'none',
	                        '-ms-user-select': 'none',
	                        'user-select': 'none',
	                        'background-image': 'none',
	                        'border': '1px solid transparent',
	                        'border-radius': '4px',
	                        'color': '#fff',
	                        'background-color': '#a4182d',
	                        'border-color': '#2e6da4'
	                    },
	                    '#heartland-field[placeholder]': {
	                        'letter-spacing': '3px'
	                    },
	                    '#heartland-field[name=cardCvv]': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
	                        'background-size': '63px 40px'
	                    },
	                    'input#heartland-field[name=cardNumber]': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
	                        'background-size': '55px 35px'
	                    },
	                    '#heartland-field.invalid.card-type-visa': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
	                        'background-size': '83px 88px',
	                        'background-position-y': '-44px'
	                    },
	                    '#heartland-field.valid.card-type-visa': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
	                        'background-size': '82px 86px'
	                    },
	                    '#heartland-field.invalid.card-type-discover': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
	                        'background-size': '85px 90px',
	                        'background-position-y': '-44px'
	                    },
	                    '#heartland-field.valid.card-type-discover': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
	                        'background-size': '85px 90px',
	                        'background-position-y': '1px'
	                    },
	                    '#heartland-field.invalid.card-type-amex': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
	                        'background-size': '50px 90px',
	                        'background-position-y': '-44px'
	                    },
	                    '#heartland-field.valid.card-type-amex': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
	                        'background-size': '50px 90px'
	                    },
	                    '#heartland-field.invalid.card-type-mastercard': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
	                        'background-size': '62px 105px',
	                        'background-position-y': '-52px'
	                    },
	                    '#heartland-field.valid.card-type-mastercard': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
	                        'background-size': '62px 105px',
	                        'background-position-y': '-1px'
	                    },
	                    '#heartland-field.invalid.card-type-jcb': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
	                        'background-size': '55px 94px',
	                        'background-position-y': '-44px'
	                    },
	                    '#heartland-field.valid.card-type-jcb': {
	                        'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
	                        'background-size': '55px 94px',
	                        'background-position-y': '2px'
	                    },
	                    'input#heartland-field[name=cardNumber]::-ms-clear': {
	                        'display': 'none'
	                    }
	                },
	                // Callback when a token is received from the service
	                onTokenSuccess: function onTokenSuccess(resp) {
	                    var _this2 = this;
	
	                    // console.log('Received Token from Heartland : ', resp.token_value);
	                    $ctrl.$spinner.show('appSpinner');
	                    var dataReq = {
	                        "token": resp.token_value,
	                        // "isNewCard": true,
	                        "cardLast4": resp.last_four,
	                        "cardType": resp.card_type,
	                        "cardNumber": resp.card.number,
	                        "expiryMonth": resp.exp_month,
	                        "expiryYear": resp.exp_year,
	                        "cardId": $ctrl.updateCardId
	                    };
	                    if (!$ctrl.hasErplyCardUpdateInitialized) {
	                        $ctrl.hasErplyCardUpdateInitialized = true;
	                        $ctrl.$order.updateCardHeartland(dataReq).then(function (success) {
	                            $ctrl.hasErplyCardUpdateInitialized = false;
	                            $ctrl.clearIframeFields();
	                            $ctrl.showHeartLandPage = false;
	                            $ctrl.$spinner.hide('appSpinner');
	
	                            if (success.data.successCode == "429") {
	                                _this2.showMessageInPopUp(success.data.message);
	                            } else {
	                                if (success.data.successCode === '00') {
	                                    $ctrl.$toaster.pop('success', 'Card Updated Successfully');
	                                    //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                                    $ctrl.$state.go('cards-management', { 'success': 'success' });
	                                } else {
	                                    //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                                    $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                                    $ctrl.isCallingAPI = false;
	                                }
	                            }
	                        }, function (error) {
	                            $ctrl.hasErplyCardUpdateInitialized = false;
	                            $ctrl.clearIframeFields();
	                            $ctrl.$spinner.hide('appSpinner');
	                            $ctrl.showHeartLandPage = false;
	                            $ctrl.isCallingAPI = false;
	                            $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                            //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                            // var myEl = angular.element( document.querySelector( '#credit-card' ) );
	                            // myEl.remove();
	                        }).catch(function (err) {
	                            $ctrl.hasErplyCardUpdateInitialized = false;
	                            $ctrl.clearIframeFields();
	                            $ctrl.$spinner.hide('appSpinner');
	                            $ctrl.showHeartLandPage = false;
	                            $ctrl.isCallingAPI = false;
	                            // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                            $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                        });
	                    }
	                },
	                // Callback when an error is received from the service
	                onTokenError: function onTokenError(resp) {
	                    $ctrl.hasErplyCardUpdateInitialized = false;
	                    $ctrl.clearIframeFields();
	                    $ctrl.$spinner.hide('appSpinner');
	                    // console.log("Error - ", resp);
	                    $ctrl.showHeartLandPage = false;
	                    $ctrl.isCallingAPI = false;
	                    // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                    $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                },
	                // Callback when an event is fired within an iFrame
	                onEvent: function onEvent(ev) {
	                    // // console.log(ev);
	                }
	            });
	
	            this.$onDestroy = function () {
	                this.hps.dispose();
	            };
	        }
	    }, {
	        key: 'initializeTsys',
	        value: function initializeTsys(GlobalPayments) {
	            var _this3 = this;
	
	            var $ctrl = this;
	            GlobalPayments.configure({
	                'X-GP-Api-Key': this.paymentGlobalKey,
	                'X-GP-Environment': this.env,
	                'enableAutocomplete': true
	            });
	
	            var cardForm = GlobalPayments.ui.form({
	                type: 'iframe',
	                fields: {
	                    "card-number": {
	                        target: "#card-number",
	                        placeholder: "xxxx xxxx xxxx xxxx"
	                    },
	                    "card-expiration": {
	                        target: "#card-expiration",
	                        placeholder: "MM / YYYY"
	                    },
	                    "card-cvv": {
	                        target: "#card-cvv",
	                        placeholder: "xxx"
	                    },
	                    "submit": {
	                        target: "#submit",
	                        text: "Submit"
	                    }
	                },
	
	                styles: {
	
	                    "input": {
	                        "outline": "none",
	                        "border-width": "0",
	                        "letter-spacing": "2px",
	                        "width": "20px",
	                        "height": "40px"
	                    },
	                    "input, select": {
	                        "padding": "5px 10px",
	                        "font-size": "13px",
	                        "background": "#f3faff",
	                        "border": "1px solid #e0f1ff",
	                        "box-sizing": "border-box",
	                        "width": "20px",
	                        "height": "40px"
	                    },
	                    "input:focus": {
	                        "-webkit-box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
	                        "box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
	                        "border-color": "#b0dcff !important",
	                        "width": "20px",
	                        "height": "40px"
	                    },
	                    "button": {
	                        "pointer-events": "none",
	                        "opacity": ".5",
	
	                        'box-sizing': 'border-box',
	                        'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	                        'font-size': '15px',
	                        'line-height': '1',
	                        'width': 'auto !important',
	                        'outline': '0',
	                        'padding': '.5278em',
	                        'vertical-align': 'baseline',
	                        'height': '50px',
	                        'background-color': '#a4182d',
	                        'font-family': 'sans-serif',
	                        'text-transform': 'uppercase',
	                        'border': '0 solid transparent',
	                        'color': '#fff',
	                        // 'cursor': 'pointer',
	                        'flex': '0.61 1 auto !important'
	                    },
	                    "button:active": {
	                        "filter": "brightness(112%)",
	                        "text-align": "center"
	                    },
	                    ".card-number.card-type-visa": {
	                        "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
	                        "background-position-y": "0px",
	                        "background-size": "70px 75px",
	                        "width": "50px"
	                    },
	                    ".card-number.card-type-mastercard": {
	                        "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
	                        "background-position-y": "4px",
	                        "background-size": "60px 64px"
	                    },
	                    ".card-number.card-type-discover": {
	                        "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
	                        "background-position-y": "-5px",
	                        "background-size": "90px 96px"
	                    },
	                    ".card-number.card-type-jcb": {
	                        "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
	                        "background-position-y": "0px",
	                        "background-size": "48px 82px"
	                    },
	                    ".card-number.card-type-amex": {
	                        "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
	                        "background-position-y": "-4px",
	                        "background-size": "55px 98px"
	                    }
	                }
	            });
	
	            cardForm.on("token-success", function (resp) {
	                // add a payment token to form as a hidden input
	                // console.log("token-success", resp);
	                var token = document.createElement("input");
	                token.type = "hidden";
	                token.name = "temporary_token";
	                token.value = "resp.temporary_token";
	
	                // submit temporary_token to backend, process with our gateway
	                // const form = document.getElementById("payment-form");
	                // form.appendChild(child);
	                // form.submit;
	
	
	                // console.log("Token Success", resp.temporary_token);
	                $ctrl.$spinner.show('appSpinner');
	                var dataReq = {
	                    "token": resp.temporary_token,
	                    // "isNewCard": true,
	                    "cardLast4": resp.last_four,
	                    "cardType": resp.card_type,
	                    "cardNumber": resp.card.number,
	                    "expiryMonth": resp.exp_month,
	                    "expiryYear": resp.exp_year,
	                    "cardId": $ctrl.updateCardId
	                };
	
	                if (!$ctrl.hasErplyCardUpdateInitialized) {
	                    $ctrl.hasErplyCardUpdateInitialized = true;
	                    $ctrl.$order.updateCardTsys(dataReq).then(function (success) {
	                        $ctrl.hasErplyCardUpdateInitialized = false;
	                        $ctrl.$spinner.hide('appSpinner');
	                        $ctrl.showHeartLandPage = false;
	                        if (success.data.successCode == "429") {
	                            _this3.showMessageInPopUp(success.data.message);
	                        } else {
	                            if (success.data.successCode === '00') {
	                                $ctrl.$toaster.pop('success', 'Card Updated Successfully');
	                                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                                $ctrl.$state.go('cards-management', { 'success': 'success' });
	                            } else {
	                                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                                $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                                $ctrl.isCallingAPI = false;
	                            }
	                        }
	                    }, function (error) {
	                        $ctrl.hasErplyCardUpdateInitialized = false;
	                        $ctrl.clearIframeFields();
	                        $ctrl.$spinner.hide('appSpinner');
	                        $ctrl.showHeartLandPage = false;
	                        $ctrl.isCallingAPI = false;
	                        $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                        //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                        $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                        // var myEl = angular.element( document.querySelector( '#credit-card' ) );
	                        // myEl.remove();
	                    }).catch(function (err) {
	                        $ctrl.hasErplyCardUpdateInitialized = false;
	                        $ctrl.clearIframeFields();
	                        $ctrl.$spinner.hide('appSpinner');
	                        $ctrl.showHeartLandPage = false;
	                        $ctrl.isCallingAPI = false;
	                        // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
	                        $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                        $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                    });
	                }
	            });
	
	            cardForm.on("token-error", function (resp) {
	                // console.log("token-error", resp);
	                $ctrl.cardFailure();
	            });
	
	            GlobalPayments.on("error", function (error) {
	                // console.log("error", error);
	                $ctrl.cardFailure();
	            });
	
	            cardForm.on("card-number-test", function (resp) {
	                $ctrl.cardvalid = resp.valid;
	                $ctrl.submitButtonState(cardForm);
	                // console.log("card-number-test", resp);
	            });
	
	            cardForm.on("card-expiration-test", function (resp) {
	                //   // console.log("card-expiration-test", resp);
	                $ctrl.expdatevalid = resp.valid;
	                $ctrl.submitButtonState(cardForm);
	                // console.log("card-expiration-test", resp);
	            });
	
	            cardForm.on("card-cvv-test", function (resp) {
	                $ctrl.cvvalid = resp.valid;
	                $ctrl.submitButtonState(cardForm);
	                // console.log("card-cvv-test", resp);
	            });
	        }
	    }, {
	        key: 'clearIframeFields',
	        value: function clearIframeFields() {
	            var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
	            var iframesG = angular.element(document.querySelector('#iframes'));
	            var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
	            var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
	            var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
	            var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
	        }
	    }, {
	        key: 'cardFailure',
	        value: function cardFailure() {
	            var $ctrl = this;
	            $ctrl.hasErplyCardUpdateInitialized = false;
	            $ctrl.clearIframeFields();
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.showHeartLandPage = false;
	            $ctrl.isCallingAPI = false;
	            $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            this.$state.go('cards-management');
	        }
	    }, {
	        key: 'submitButtonState',
	        value: function submitButtonState(cardForm) {
	            var $ctrl = this;
	            // console.log("cardForm := ",cardForm);
	            // console.log($ctrl.cardvalid + ", " + $ctrl.expdatevalid + ", " + $ctrl.cvvalid);
	            if ($ctrl.cvvalid && $ctrl.cardvalid && $ctrl.expdatevalid) {
	                cardForm.addStylesheet({
	                    "button": {
	                        "pointer-events": "auto",
	                        "opacity": "1",
	
	                        'box-sizing': 'border-box',
	                        'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	                        'font-size': '15px',
	                        'line-height': '1',
	                        'width': 'auto !important',
	                        'outline': '0',
	                        'padding': '.5278em',
	                        'vertical-align': 'baseline',
	                        'height': '50px',
	                        'background-color': '#a4182d',
	                        'font-family': 'sans-serif',
	                        'text-transform': 'uppercase',
	                        'border': '0 solid transparent',
	                        'color': '#fff',
	                        'cursor': 'pointer',
	                        'flex': '0.61 1 auto !important'
	                    }
	                });
	            } else {
	                cardForm.addStylesheet({
	                    "button": {
	                        "pointer-events": "none",
	                        "opacity": ".5",
	
	                        'box-sizing': 'border-box',
	                        'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	                        'font-size': '15px',
	                        'line-height': '1',
	                        'width': 'auto !important',
	                        'outline': '0',
	                        'padding': '.5278em',
	                        'vertical-align': 'baseline',
	                        'height': '50px',
	                        'background-color': '#a4182d',
	                        'font-family': 'sans-serif',
	                        'text-transform': 'uppercase',
	                        'border': '0 solid transparent',
	                        'color': '#fff',
	                        // 'cursor': 'pointer',
	                        'flex': '0.61 1 auto !important'
	                    }
	                });
	            }
	        }
	
	        // Moneris
	
	    }, {
	        key: 'initializeMoneris',
	        value: function initializeMoneris() {
	            var $ctrl = this;
	
	            $ctrl.respUpdateMsg = function (e) {
	                // console.log("RespUpdateMsg get called ", e );
	                // var respData = eval("(" + e.data + ")");
	                // var resCode = `${respData.responseCode}`;
	                // var resDataKey = `${respData.dataKey}`;
	
	                var parsingJson = JSON.parse(e.data);
	
	                // console.log("Parsing Json : ",parsingJson);
	                // console.log("dataKey : ",parsingJson.dataKey);
	                // console.log("responseCode : ",parsingJson.responseCode);
	
	                var resCode = parsingJson.responseCode;
	                var resDataKey = parsingJson.dataKey;
	
	                if (resCode != null) {
	                    //   resCode = resCode.split(',');
	                    // console.log("ResCode : ", resCode, " : ResCode length: ", resCode.length);
	                    if (resCode.length > 0) {
	                        if (resCode[0] == '001') {
	                            $ctrl.cardUpdateMoneris(resDataKey);
	                        } else {
	                            var srcLink = '';
	                            if (window.innerWidth < 768) {
	                                // console.log('inside mobile');
	                                srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" + "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
	
	                                if (resCode[0] == 943) {
	                                    srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_pan=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
	                                } else if (resCode[0] == 944) {
	                                    srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_exp=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
	                                } else if (resCode[0] == 945) {
	                                    srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_cvd=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
	                                } else {
	                                    console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
	                                    $ctrl.goBack();
	                                }
	                            } else {
	                                srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" +
	                                // "&css_textbox_pan=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
	                                // "&css_textbox_exp=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
	                                // "&css_textbox_cvd=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px;" +
	                                // "&css_input_label=";
	                                "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
	                                if (resCode[0] == 943) {
	                                    srcLink = srcLink + "&css_label_pan=color:darkslategrey;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_textbox_pan=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
	                                } else if (resCode[0] == 944) {
	                                    srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=color:darkslategrey;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_label_cvd=margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_exp=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
	                                } else if (resCode[0] == 945) {
	                                    srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=color:darkslategrey;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_textbox_cvd=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
	                                } else {
	                                    console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
	                                    $ctrl.goBack();
	                                }
	                            }
	                            document.getElementById("monerisFrameUpdate").src = srcLink;
	                        }
	                    }
	                }
	            };
	
	            if (!this.APP.ORDER.MONERIS_LOADED.update_page_loaded) {
	                this.APP.ORDER.MONERIS_LOADED.update_page_loaded = true;
	                // console.log("Adding once this.respUpdateMsg : ", this.respUpdateMsg);
	                if (window.addEventListener) {
	                    window.addEventListener("message", this.respUpdateMsg, false);
	                } else {
	                    if (window.attachEvent) {
	                        window.attachEvent("onmessage", this.respUpdateMsg);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'doMonerisSubmit',
	        value: function doMonerisSubmit() {
	            this.$spinner.show('appSpinner');
	            var monFrameRef = document.getElementById('monerisFrameUpdate').contentWindow;
	            // console.log("monFrameRef : ", monFrameRef);
	            monFrameRef.postMessage('tokenize', this.gatewayUrl);
	            this.$spinner.hide('appSpinner');
	            return false;
	        }
	    }, {
	        key: 'cardUpdateMoneris',
	        value: function cardUpdateMoneris(token) {
	            var _this4 = this;
	
	            var $ctrl = this;
	            if (!this.hasPaymentInitialized) {
	                this.hasPaymentInitialized = true;
	                $ctrl.$spinner.show('appSpinner');
	                // console.log("Updating moneris card");
	
	                var dataReq = {
	                    "token": token,
	                    "action": "update",
	                    // "isNewCard": true,
	                    // "cardLast4": resp.last_four,
	                    // "cardType": resp.card_type,
	                    // "cardNumber": resp.card.number,
	                    // "expiryMonth": resp.exp_month,
	                    // "expiryYear": resp.exp_year,
	                    "cardId": $ctrl.updateCardId
	                };
	
	                $ctrl.$order.updateCardMoneris(dataReq).then(function (success) {
	                    $ctrl.hasPaymentInitialized = false;
	                    $ctrl.$spinner.hide('appSpinner');
	                    $ctrl.showHeartLandPage = false;
	                    $ctrl.hasErplyCardUpdateInitialized = false;
	
	                    if (success.data.successCode == "429") {
	                        _this4.showMessageInPopUp(success.data.message);
	                    } else {
	                        if (success.data.successCode === '00') {
	                            $ctrl.$toaster.pop('success', 'Card Updated Successfully');
	                            $ctrl.$state.go('cards-management', { 'success': 'success' });
	                        } else {
	                            $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                            $ctrl.isCallingAPI = false;
	                        }
	                    }
	                }, function (error) {
	                    $ctrl.hasErplyCardUpdateInitialized = false;
	                    $ctrl.clearIframeFields();
	                    $ctrl.$spinner.hide('appSpinner');
	                    $ctrl.showHeartLandPage = false;
	                    $ctrl.isCallingAPI = false;
	                    $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                }).catch(function (err) {
	                    $ctrl.hasErplyCardUpdateInitialized = false;
	                    $ctrl.clearIframeFields();
	                    $ctrl.$spinner.hide('appSpinner');
	                    $ctrl.showHeartLandPage = false;
	                    $ctrl.isCallingAPI = false;
	                    $ctrl.$state.go('cards-management', { 'success': 'Failure' });
	                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                });
	            } else {
	                // console.log(" Moneris Payment already iniitalized");
	            }
	        }
	    }, {
	        key: 'showMessageInPopUp',
	        value: function showMessageInPopUp(message) {
	            var $ctrl = this;
	            this.$uibModal.open({
	                size: 'md',
	                backdrop: 'static',
	                keyboard: false,
	                template: '<div class="modal-body" id="modal-body">' + '<div class="container-fluid">' + '<div class="col-md-12">{{message}}</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>' + '</div>',
	                controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	                    $scope.message = message;
	                    $scope.ok = function () {
	                        $uibModalInstance.close();
	                    };
	                }]
	            });
	        }
	    }]);
	
	    return cardUpdate;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', '$stateParams', 'spinnerService', 'orderService', 'authService', '$window', 'APP', 'Heartland', 'GlobalPayments', '$uibModal'], _temp)) || _class);
	exports.default = cardUpdate;

/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"cardUpdate.paymentType=='HeartLand'\" class=\"hform-wrapper\" style=\"margin-left:30%\">\r\n  <form id=\"iframes\" action=\"\" method=\"GET\">\r\n    <div id=\"ss-banner\" style=\"margin-left:10%\"></div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 p-t-1 p-r-0\" style=\"width:20% !important\">\r\n        <label for=\"iframesCardNumber\">Card Number</label>\r\n      </div>\r\n      <div id=\"iframesCardNumber\" class=\"col-md-6 p-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6  p-t-1  p-r-0\" style=\"width:20% !important\">\r\n        <label for=\"iframesCardExpiration\">Card Expiration</label>\r\n      </div>\r\n      <div id=\"iframesCardExpiration\" class=\"col-md-6 p-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 p-t-1  p-r-0\" style=\"width:20% !important\">\r\n        <label for=\"iframesCardCvv\">Card CVV</label>\r\n      </div>\r\n      <div id=\"iframesCardCvv\" class=\"col-md-6 p-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 m-t-1  col-sm-6 col-lg-6\">\r\n        <div id=\"iframesSubmit\"></div>\r\n      </div>\r\n      <div class=\"col-md-6 m-t-1 col-sm-6 col-lg-6\">\r\n        <button class=\"back\" ng-click=\"cardUpdate.goBack()\">Back</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n\r\n<div ng-if=\"cardUpdate.paymentType=='Tsys'\">\r\n  <div id=\"tsys1\" class=\"row\">\r\n    <div class=\"col-xs-5 offset-md-4\">\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-4\">\r\n          <label for=\"card-number\">Card Number</label>\r\n        </div>\r\n        <div class=\"col-xs-8\">\r\n          <div id=\"card-number\" class=\"\"></div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row m-t-1\">\r\n        <div class=\"col-xs-4\">\r\n          <label for=\"card-expiration\">Card expiration</label>\r\n        </div>\r\n        <div class=\"col-xs-8\">\r\n          <div id=\"card-expiration\" class=\"\"></div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row  m-t-1\">\r\n        <div class=\"col-xs-4\">\r\n          <label for=\"card-cvv\">Card CVV</label>\r\n        </div>\r\n        <div class=\"col-xs-8\">\r\n          <div id=\"card-cvv\" class=\"\"></div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row m-t-2\">\r\n        <div class=\"col-xs-6\">\r\n          <div id=\"submit\" class=\"\"></div>\r\n        </div>\r\n        <div class=\"col-xs-6\">\r\n          <button class=\"back-btn\" ng-click=\"cardUpdate.goBack()\">Back</button>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div ng-if=\"cardUpdate.paymentType=='Moneris'\">\r\n  <!-- <iframe id=\"monerisFrameUpdate\" frameborder='0' width=\"300px\" height=\"600px\"></iframe>\r\n  <input type=\"button\" ng-click=\"cardUpdate.doMonerisSubmit()\" value=\"submit\"> -->\r\n\r\n  <div class=\"moneris_payment\">\r\n    <div id=\"ss-banner-moneris\"></div>\r\n    <div ng-if=\"cardUpdate.mobileView\">\r\n      <iframe id=\"monerisFrameUpdate\" frameborder='0' width=\"500px\"  height=\"270px\"></iframe>\r\n    </div>\r\n    <div ng-if=\"!cardUpdate.mobileView\">\r\n      <iframe id=\"monerisFrameUpdate\" frameborder='0' width=\"500px\"  height=\"230px\"></iframe>\r\n    </div>\r\n    <div class=\"mb-50\">\r\n      <button class=\"back-btn moneris_payment_submit\" ng-click=\"cardUpdate.doMonerisSubmit()\">Submit</button>\r\n      <button class=\"back-btn moneris_payment_back\" ng-click=\"cardUpdate.goBack()\">Back</button>\r\n    </div>\r\n  </div> \r\n</div>\r\n\r\n\r\n"

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _orderDetail = __webpack_require__(222);
	
	var _orderDetail2 = _interopRequireDefault(_orderDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrderDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'orderDetail',
	  template: _orderDetail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function OrderDetail($scope, $ngRedux, $state, $stateParams, toaster, $auth, $spinner, $q, $order, $timeout, $cookies, $window, APP, $rootScope, POWERREVIEWS, $uibModal) {
	    var _this = this;
	
	    _classCallCheck(this, OrderDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.toaster = toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$auth = $auth;
	    this.APP = APP;
	    this.$state = $state;
	    this.$window = $window;
	    this.dscMasterCode = '88888888'; // Named constant
	    this.isCardSaved = $stateParams.isCardSaved;
	    this.isGuestLogin = $auth.isGuestLogin();
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.POWERREVIEWS = POWERREVIEWS;
	    this.orderId = $stateParams.orderId;
	
	    var orderSummaryPromise = $order.getOrderSummary($stateParams.orderId).catch(function () {
	      return $state.go('payment.failure');
	    });
	    var userProfilePromise = this.isGuestLogin ? $auth.getGuestUserProfile() : $auth.getUserProfile();
	    if (this.isGuestLogin) {
	      var userDetails = {};
	      userDetails.inOrderPage = true;
	
	      this.$rootScope.inOrderPage = true;
	      var guestUserDetails = sessionStorage.getItem('guestUserDetails') ? JSON.parse(sessionStorage.getItem('guestUserDetails')) : null;
	      if (guestUserDetails && guestUserDetails.email) {
	        this.$rootScope.guestCheckoutEmail = guestUserDetails.email;
	        userDetails.email = guestUserDetails.email;
	        userDetails.firstName = guestUserDetails.firstName;
	        userDetails.lastName = guestUserDetails.lastName;
	        userDetails.orderId = this.$stateParams.orderId;
	        sessionStorage.setItem('userDetailsFromGuestSuccessfulOrder', JSON.stringify(userDetails));
	      }
	    } else {
	      this.$rootScope.inOrderPage = false;
	      this.$rootScope.guestCheckoutEmail = null;
	    }
	    $spinner.show('appSpinner');
	    var promises = [orderSummaryPromise, userProfilePromise];
	    $q.all(promises).finally(function () {
	      if (_this.isGuestLogin) {
	        _this.profile = _this.guestprofile;
	        sessionStorage.setItem('guestOrderCheckedOut', true);
	      }
	      _this.gaTransactionDetails($window);
	      $spinner.hide('appSpinner');
	      sessionStorage.removeItem('guestoauth');
	      sessionStorage.removeItem('isGuestUserLoggedIn');
	      $cookies.remove('guestCart');
	      $cookies.remove('GuestCartRequest');
	      $rootScope.guestUserDetails = null;
	      $auth.removeGuestCart();
	      if (_this.isGuestLogin) {
	        var count = 0;
	        while ($cookies.get('guestCart')) {
	          if (count < 5) {
	            count++;
	            $auth.removeGuestCart();
	          } else {
	            return;
	          }
	        }
	      }
	    });
	
	    localStorage.removeItem('deliveryAddress');
	
	    try {
	      sessionStorage.removeItem('discountCoupon');
	      sessionStorage.removeItem('discountCouponAmount');
	      sessionStorage.removeItem('birdbuckCoupon');
	      sessionStorage.removeItem('erplyBBDiscount');
	      sessionStorage.removeItem('erplyBBCouponCodes');
	      sessionStorage.removeItem('erplyPromotionCodes');
	      sessionStorage.removeItem('erplyPromotionDiscount');
	      sessionStorage.removeItem('orderNotesSession');
	    } catch (e) {
	      $cookies.remove('discountCouponAmount');
	      $cookies.remove('discountCoupon');
	      $cookies.remove('birdbuckCoupon');
	      $cookies.remove('erplyBBDiscount');
	      $cookies.remove('erplyBBCouponCodes');
	      $cookies.remove('erplyPromotionCodes');
	      $cookies.remove('erplyPromotionDiscount');
	      $cookies.remove('orderNotesSession');
	    }
	
	    this.currencyType = 'USD';
	    $timeout(function () {
	      _this.country = _this.profile.store.country.countryCode ? _this.profile.store.country.countryCode : 'US';
	
	      if (_this.profile.store) {
	        _this.currencyType = $order.getCurrencyType(_this.country);
	      }
	      _this.storeName = _this.getStoreName();
	    }, 800);
	
	    $rootScope.curbSideDetails = null;
	    $rootScope.tempdeliveryMode = null;
	    $rootScope.isCurbside = null;
	    if (this.isGuestLogin) {
	      this.registerAndMarketingPopup1();
	    }
	    $scope.$on('$destroy', function () {
	      _this.$rootScope.inOrderPage = false;
	    });
	  }
	
	  _createClass(OrderDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        summary: state.order.orderDetail,
	        guestprofile: state.auth.guestprofile
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'getStoreName',
	    value: function getStoreName() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName == '' || storeName == null) {
	        storeName = this.$auth.getGuestStoreDetail().storeName;
	      }
	      return storeName;
	    }
	  }, {
	    key: 'formattedTime',
	    value: function formattedTime(dateTime) {
	      var date = dateTime ? new Date(dateTime) : new Date();
	      var hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
	      var time = (hours < 10 ? '0' + hours : hours) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	      var ampm = date.getHours() >= 12 ? ' PM' : ' AM';
	      return time + ampm;
	    }
	  }, {
	    key: 'saveCardDetail',
	    value: function saveCardDetail() {
	      var _this2 = this;
	
	      this.$order.saveCardDetail(this.$stateParams.orderId).then(function (success) {
	        return _this2.toaster.pop('success', success.data.message);
	      }).catch(function (err) {
	        _this2.$auth.printCustomerGenericLogs(err);
	      });
	    }
	  }, {
	    key: 'getDSCDiscount',
	    value: function getDSCDiscount() {
	      if (this.profile.customer && this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate)) {
	        var dscItems = this.summary.orderEntries && this.summary.orderEntries.filter(function (item) {
	          return item.subCategory.category.dscCategory;
	        });
	        var totalPrice = dscItems && dscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        return totalPrice * 15 / 100;
	      }
	      return 0;
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'calculateTotalWeight',
	    value: function calculateTotalWeight() {
	      var weightsArray = [];
	      if (this.summary.orderEntries && this.summary.orderEntries.length) {
	        weightsArray = this.summary.orderEntries.map(function (totalWeight) {
	          return totalWeight.quantity * totalWeight.item.weight;
	        });
	      }
	      var totalWeight = 0;
	      for (var i = 0; i < weightsArray.length; i++) {
	        totalWeight += weightsArray[i];
	      }
	      return totalWeight;
	    }
	  }, {
	    key: 'calculateTotalProductWeight',
	    value: function calculateTotalProductWeight(quantity, weight) {
	      return quantity * weight;
	    }
	  }, {
	    key: 'cartContainsOnlyDsc',
	    value: function cartContainsOnlyDsc() {
	      var _this3 = this;
	
	      var dscIsInCart = this.summary.orderEntries.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this3.dscMasterCode;
	      }).length;
	      var totalItemsInCart = this.summary.orderEntries.length;
	      return dscIsInCart && totalItemsInCart === dscIsInCart;
	    }
	  }, {
	    key: 'subscribeNow',
	    value: function subscribeNow(order) {
	      this.$auth.resetSubscriptionCart();
	      this.$state.go('subscription-detail', { subscriptionId: order.orderId, option: 'add' });
	    }
	  }, {
	    key: 'gaTransactionDetails',
	    value: function gaTransactionDetails($window) {
	      var _this4 = this;
	
	      console.log("Sending transaction details to GA");
	      console.log("Order", this.summary);
	      var orderEntries = [];
	      if (this.summary) {
	        if ($window.ga) {
	          $window.ga('require', 'ecommerce');
	
	          var gaTransaction = {
	            'id': this.summary.orderId, // Transaction ID. Required.
	            'affiliation': '', // Affiliation or store name.
	            'revenue': this.summary.amountPaid, // Grand Total.
	            'shipping': this.summary.shippingCharge - this.summary.shippingDiscount, // Shipping.
	            'tax': this.summary.orderTax // Tax.
	          };
	
	          $window.ga('ecommerce:addTransaction', gaTransaction);
	
	          orderEntries = this.summary.orderEntries;
	          var categoryName = '';
	
	          console.log(orderEntries);
	          // Adding items
	          orderEntries.forEach(function (order) {
	            console.log("Order Detail", order);
	            if (order.subCategory) {
	              categoryName = order.subCategory.category.name + " : " + order.subCategory.name;
	            } else {
	              categoryName = order.subCategory.category.name;
	            }
	            var gaItem = {
	              'id': _this4.summary.orderId, // Transaction ID. Required.
	              'name': order.item.name, // Product name. Required.
	              'sku': order.item.masterProduct.masterCode, // SKU/code.
	              'category': categoryName, // Category or variation.
	              'price': order.price, // Unit price.
	              'quantity': order.quantity
	            };
	            $window.ga('ecommerce:addItem', gaItem);
	            gaItem = {};
	            categoryName = '';
	          });
	
	          // Adding BirdBucks if any as an item
	          if (this.summary.appliedBBCoupon) {
	            var bbItem = {
	              'id': this.summary.orderId,
	              'name': 'BirdBuck coupon',
	              'sku': this.summary.appliedBBCoupon,
	              'category': 'BirdBuck coupon',
	              'price': -this.summary.appliedBBCouponAmount,
	              'quantity': 1
	            };
	            $window.ga('ecommerce:addItem', bbItem);
	          }
	
	          // Adding discounts if any as an item
	          if (this.summary.appliedDiscountCoupon) {
	            var discountAmount = this.summary.appliedDiscountCouponAmount ? this.summary.appliedDiscountCouponAmount : 0;
	
	            var promoItem = {
	              'id': this.summary.orderId,
	              'name': 'Promo code',
	              'sku': this.summary.appliedDiscountCoupon,
	              'category': 'Promo code : ' + this.summary.appliedDiscountType,
	              'price': -discountAmount,
	              'quantity': 1
	            };
	            $window.ga('ecommerce:addItem', promoItem);
	          }
	          $window.ga('ecommerce:send');
	        }
	      }
	      if ($window.pwr) {
	        if (this.summary) {
	          try {
	            console.log("Order Power review", this.summary);
	            orderEntries = this.summary.orderEntries;
	            var pwrOrderItems = [];
	            var pwrItem = {};
	            // Adding items
	            orderEntries.forEach(function (order) {
	              pwrItem = {
	                'product_name': order.item.name,
	                'page_id': order.item.masterProduct.masterCode.substring(0, 7),
	                'unit_price': order.price,
	                'quantity': order.quantity
	              };
	              if (order.item.weight) {
	                pwrItem.page_id_variant = order.item.weight;
	              }
	              pwrOrderItems.push(pwrItem);
	            });
	            var tracker = this.POWERREVIEWS.tracker.createTracker({
	              merchantGroupId: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id });
	            var orderFeed = {
	              merchantGroupId: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
	              merchantId: this.APP.AUTH.AUTH_URL.pwr.merchant_id,
	              locale: this.APP.AUTH.AUTH_URL.pwr.locale,
	              merchantUserId: this.summary.user.userId,
	              marketingOptIn: true,
	              userEmail: this.summary.user.email,
	              userFirstName: this.summary.user.customer.firstName,
	              userLastName: this.summary.user.customer.lastName,
	              orderId: this.summary.orderId,
	              orderItems: pwrOrderItems
	            };
	            console.log("Pwr final rview : ", orderFeed);
	            tracker.trackCheckout(orderFeed);
	          } catch (e) {
	            $window.console && $window.console.log(e);
	          }
	        }
	      }
	      console.log("$Window check for pwr : ", $window);
	    }
	  }, {
	    key: 'infoPopup',
	    value: function infoPopup() {
	      var _this5 = this;
	
	      document.getElementById('popup').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popup').style.display === 'block' && _this5.showPopup === false) {
	          _this5.hideinfoPopup();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'hideinfoPopup',
	    value: function hideinfoPopup() {
	      document.getElementById('popup').style.display = 'none';
	      this.showPopup = false;
	    }
	  }, {
	    key: 'infoPopuponhover',
	    value: function infoPopuponhover() {
	      document.getElementById('popup').style.display = 'block';
	      this.showPopup = true;
	    }
	  }, {
	    key: 'infoPopupFee',
	    value: function infoPopupFee() {
	      var _this6 = this;
	
	      document.getElementById('popup1').style.display = 'block';
	      setTimeout(function () {
	        if (document.getElementById('popup1').style.display === 'block' && _this6.showPopupFee === false) {
	          _this6.hideinfoPopupFee();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'hideinfoPopupFee',
	    value: function hideinfoPopupFee() {
	      document.getElementById('popup1').style.display = 'none';
	      this.showPopupFee = false;
	    }
	  }, {
	    key: 'infoPopuponhoverFee',
	    value: function infoPopuponhoverFee() {
	      document.getElementById('popup1').style.display = 'block';
	      this.showPopupFee = true;
	    }
	  }, {
	    key: 'doGuestOptIn',
	    value: function doGuestOptIn() {
	      var data = {};
	      data.orderId = this.$stateParams.orderId;
	      this.$order.doGuestOptIn(data);
	    }
	  }, {
	    key: 'registerAndMarketingPopup1',
	    value: function registerAndMarketingPopup1() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        backdrop: 'static',
	        keyboard: false,
	        template: '\n                <div class="modal-body"><a class="close" href="#" ng-click="cancelMarketingPopUp()">&times;</a>\n                    <div class="d-flex flex-column gap-3" style="margin:10px">\n                        <div class="py-2" style="margin-bottom:3px;">\n                          <strong style="font-size: 18px;">Register an account today!*</strong>\n                          <br />\n                          &#x25CF Keep your order history\n                          <br />\n                          &#x25CF Reorder with ease\n                          <br />\n                          &#x25CF Enjoy exclusive offers\n                          <br />\n                          <br />\n                          *Already a Daily Savings Club Member? Register with the same email you use in-store to access your member savings online instantly.\n                          <br />\n                          <button type="button" class="btn btn-primary btn-block" ng-click="okForRegister()">Register NOW!</button>\n                        </div>\n\n                        <div class="py-2" style="margin-bottom:3px; margin-top:10%">\n                          <strong style="font-size: 18px;">Stay Connected!</strong>\n                          <br />\n                          &#x25CF Join our email community and never miss what&apos;s new.\n                          <br />\n                          &#x25CF Receive helpful bird-feeding tips and seasonal savvy advice.\n                          <br />\n                          &#x25CF Eligible for special offers from your local store.\n                          <br />\n                          <button type="button" class="btn btn-primary btn-block" ng-click="okForMarketing()">Yes, Sign Me Up!</button>\n                        </div> \n                        \n                        \n                        <div class="py-2" style="margin-bottom:3px; margin-top:10%">\n                          <strong style="font-size: 18px;">Dismiss Option</strong>\n                          \n                          <button type="button" class="btn btn-primary btn-block" ng-click="cancelMarketingPopUp()">Maybe Later!</button>\n                        </div>\n\n\n                      </div>\n                </div>\n          ',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', function ($rootScope, $scope, $uibModalInstance, $auth) {
	          $scope.agreement = false;
	          $scope.okForRegister = function () {
	            $ctrl.updateUserActionFromOrder($ctrl.APP.ORDER.USER_ACTION.GUEST_REGISTERATION);
	            $ctrl.$state.go('signup', {
	              storeName: $ctrl.storeName
	            });
	            $uibModalInstance.close();
	          };
	
	          $scope.okForMarketing = function () {
	            $ctrl.updateUserActionFromOrder($ctrl.APP.ORDER.USER_ACTION.GUEST_OPTING);
	            $ctrl.removeUserDetailsFromSession();
	            $ctrl.toaster.pop('success', "You are signed up!");
	            $uibModalInstance.close();
	            $ctrl.doGuestOptIn();
	          };
	
	          $scope.cancelMarketingPopUp = function () {
	            $ctrl.removeUserDetailsFromSession();
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'removeUserDetailsFromSession',
	    value: function removeUserDetailsFromSession() {
	      sessionStorage.removeItem('userDetailsFromGuestSuccessfulOrder');
	    }
	  }, {
	    key: 'updateUserActionFromOrder',
	    value: function updateUserActionFromOrder(userAction) {
	      this.$order.updateUserActionFromOrder(userAction, this.orderId);
	    }
	  }]);
	
	  return OrderDetail;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', '$stateParams', 'toaster', 'authService', 'spinnerService', '$q', 'orderService', '$timeout', '$cookies', '$window', 'APP', '$rootScope', 'POWERREVIEWS', '$uibModal'], _temp)) || _class);
	exports.default = OrderDetail;

/***/ },
/* 222 */
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\" id=\"printbtn\">\r\n    <a class=\"nav\" ng-click=\"orderDetail.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{orderDetail.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span class=\"nav\">Checkout Details</span>\r\n    <span class=\"nav\">Payment</span>\r\n    <span>Order Details</span>\r\n  </nav>\r\n\r\n  <div class=\"row gray-bg m-x-0 p-y-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <h5 class=\"m-b-0 primary-text\">Congratulations!\r\n        <span class=\"pull-xs-right p-x-1 hidden-sm-down\">\r\n            <input id=\"printbtn\" type=\"button\" value=\"Print this page\" onclick=\"window.print();\">\r\n        </span>\r\n      </h5>\r\n      <p class=\"m-b-0 mt-4\">Your order is being processed.</p>\r\n      <p class=\"m-b-0\">The order details have been emailed to you at: {{orderDetail.profile.customer.email}}</p>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0 static-content\">\r\n    <div class=\"col-xs-12 col-md-6\">\r\n      <h6 class=\"mb-4 pt-8\"><strong>Order ID:</strong></h6>\r\n      <h6>{{orderDetail.summary.invoiceNumber}}</h6>\r\n      <h6 class=\"mb-4\"><strong>Placed on: </strong></h6>\r\n      <h6>Today, {{orderDetail.formattedTime(orderDetail.summary.orderTime)}}</h6>\r\n\r\n      <div ng-if=\"orderDetail.summary.deliveryType == 'In Store Pickup' && !orderDetail.cartContainsOnlyDsc\">\r\n        <h6 class=\"mb-4 m-t-2 pt-8\">\r\n          <strong>Pickup time:</strong></h6>\r\n        <h6>{{orderDetail.summary.expectedDeliveryTime}}</h6>\r\n      </div>\r\n\r\n      <div ng-if=\"(orderDetail.summary.deliveryType == 'Next Day Delivery' || orderDetail.summary.deliveryType == 'Same Day Delivery')\">\r\n        <h6 class=\"mb-4 m-t-2 pt-8\">\r\n          <strong>Delivery time:</strong></h6>\r\n        <h6>1-5 Days</h6>\r\n      </div>  \r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\"><strong>Subtotal: </strong>${{orderDetail.summary.orderSubTotalPrice | number : 2 }}</h6>\r\n\r\n\r\n       <h6 class=\"mb-4\" ng-if=\"orderDetail.summary.appliedDiscountCouponAmount\"><strong>Promo Code Amount: </strong>(-)${{orderDetail.summary.appliedDiscountCouponAmount | number : 2 }}</h6>\r\n\r\n\r\n      <h6 class=\"mb-4\" ng-if=\"orderDetail.summary.appliedBBCouponAmount\"><strong>Bird Buck Code Amount: </strong>(-)${{orderDetail.summary.appliedBBCouponAmount | number : 2 }}</h6>\r\n     \r\n\r\n\r\n      <h6 class=\"mb-4\" ng-if=\"(orderDetail.summary.deliveryType == 'Next Day Delivery' || orderDetail.summary.deliveryType == 'Same Day Delivery') && (orderDetail.summary.shippingCharge - orderDetail.summary.shippingDiscount===0)\">\r\n        <strong>FREE Shipping: </strong>$0.00\r\n      </h6>\r\n\r\n\r\n      <h6 class=\"mb-4\" ng-if=\"(orderDetail.summary.deliveryType == 'Next Day Delivery' || orderDetail.summary.deliveryType == 'Same Day Delivery') && (orderDetail.summary.shippingCharge - orderDetail.summary.shippingDiscount !=0)\">\r\n        <strong>Shipping Charge: </strong>${{orderDetail.summary.shippingCharge | number : 2 }}\r\n      </h6>\r\n      <h6 class=\"mb-4\" ng-if=\"(orderDetail.summary.deliveryType == 'Next Day Delivery' || orderDetail.summary.deliveryType == 'Same Day Delivery') && (orderDetail.summary.shippingCharge - orderDetail.summary.shippingDiscount !=0) && (orderDetail.summary.shippingDiscount)\">\r\n        <strong>Shipping Discount: -</strong>${{orderDetail.summary.shippingDiscount | number : 2 }}\r\n      </h6>\r\n      <h6 ng-if=\"orderDetail.summary.deliveryReceiptAmount>0\" class=\"mb-4\"><strong>Retail Delivery Fee</strong>\r\n        <span>\r\n          <i class=\"fa fa-info-circle\" style=\"margin-left:4px\" ng-mouseenter=\"orderDetail.infoPopup()\"></i>\r\n          <div id=\"popup\" style=\"display: none; position: absolute;\" class=\"popup-info\" ng-mouseenter=\"orderDetail.infoPopuponhover()\" ng-mouseleave=\"orderDetail.hideinfoPopup()\">\r\n            *The state of Colorado requires a Retail Delivery Fee and any applicable taxes may be applied. For more information about the fee please visit <br/><a target=\"_blank\"  href=\"https://tax.colorado.gov/retail-delivery-fee\"><span class=\"tax-link\">https://tax.colorado.gov/retail-delivery-fee</span></a>\r\n          </div>\r\n        </span>: ${{orderDetail.summary.deliveryReceiptAmount | number : 2 }}</h6>\r\n      <h6 ng-if=\"orderDetail.summary.deliveryReceiptAmount>0\" class=\"mb-4\"><strong>Tax: </strong>${{orderDetail.summary.orderTax-orderDetail.summary.deliveryReceiptAmount | number : 2 }}</h6>\r\n      <h6 ng-if=\"orderDetail.summary.deliveryReceiptAmount<=0\" class=\"mb-4\"><strong>Tax: </strong>${{orderDetail.summary.orderTax | number : 2 }}</h6>\r\n\r\n      <h6 class=\"mb-4\" ng-if=\"orderDetail.summary.giftCardAmount>0\">\r\n          <strong>Gift Card Amount: - </strong>${{orderDetail.summary.giftCardAmount | number : 2 }}\r\n      </h6>\r\n      <h6 class=\"mb-4\" ng-if=\"orderDetail.summary.chargeFromStoreCredit>0\">\r\n        <strong>Store credit: - </strong>${{orderDetail.summary.chargeFromStoreCredit | number : 2 }}\r\n    </h6>\r\n      <h6 class=\"mb-4\"><strong>Total Paid: </strong>${{orderDetail.summary.amountPaid-orderDetail.summary.giftCardAmount-orderDetail.summary.chargeFromStoreCredit | number : 2 }}</h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"orderDetail.summary.appliedBBCoupon\"><strong>Applied Bird Buck Code: </strong>{{orderDetail.summary.appliedBBCoupon}}</h6>\r\n      \r\n<!--\r\n  // For Coupon Discount   (COMMENTED-COUPON-DISCOUNT-CODE)\r\n  <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"orderDetail.summary.appliedDiscountCoupon\"><strong>Applied Discount Coupon: </strong>{{orderDetail.summary.appliedDiscountCoupon}}</h6> -->\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"orderDetail.isDscButExpired()\"><strong><s uib-tooltip=\"Your Club Membership has expired\">Club Points Earned: </strong>{{orderDetail.summary.dscPoints | number: 2}}</s></h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\"><strong>You Saved: </strong>${{orderDetail.summary.dscDiscount+orderDetail.summary.appliedBBCouponAmount+orderDetail.summary.discountAmount | number: 2 }}</h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\"><strong>Items:</strong></h6>\r\n      <h6 class=\"m-b-1\" ng-repeat=\"item in orderDetail.summary.orderEntries\"><strong>\r\n        {{item.item.name}}</strong><br />\r\n        Quantity: {{item.quantity}}<br />\r\n        <span ng-show=\"item.item.weight\">Weight: {{item.quantity}} x {{item.item.weight  | number : 2}} lbs = {{orderDetail.calculateTotalProductWeight(item.quantity, item.item.weight)  | number : 2}} lbs</span>\r\n      </h6>\r\n      <!-- <h6 class=\"m-b-0\"><strong>Expected Delivery: {{orderDetail.summary.expectedDeliveryTime}}</strong></h6> -->\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\"><strong>Total Order Weight:</strong></h6>\r\n      <h6>{{orderDetail.calculateTotalWeight()  | number : 2}} lbs</h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"!orderDetail.summary.storeDetails.hasErply && orderDetail.summary.dscAmount\">You have earned a {{orderDetail.currencyType}} ${{orderDetail.summary.dscAmount | number: 0}} Bird Buck!</h6>\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"orderDetail.summary.storeDetails.hasErply && orderDetail.summary.noOfIssuedErplyBBCoupons>0\">You have earned {{orderDetail.currencyType}} {{orderDetail.summary.noOfIssuedErplyBBCoupons | number: 0}} * $10 Bird Buck!</h6>\r\n      \r\n      <div class=\"row\" ng-If=\"orderDetail.isGuestLogin && !orderDetail.profile.isRegistered\">\r\n        <h6 class=\"mb-4  pt-8\"><strong>Store Details:</strong></h6>\r\n        <h6>\r\n          <span ng-bind=\"orderDetail.summary.storeDetails.storeName\"></span><br />\r\n          <span ng-if=\"orderDetail.summary.storeDetails.addressLine1\">{{orderDetail.summary.storeDetails.addressLine1}} {{orderDetail.summary.storeDetails.addressLine2}}</span><br />\r\n          <span ng-if=\"orderDetail.summary.storeDetails.country\">{{orderDetail.summary.storeDetails.city}} {{orderDetail.summary.storeDetails.state.name}}, {{orderDetail.summary.storeDetails.country.countryCode}} {{orderDetail.summary.storeDetails.zipCode}}</span><br />\r\n          Phone no. <a class=\"blue-colored\" href=\"tel:{{orderDetail.summary.storeDetails.phoneNumber}}\">{{orderDetail.summary.storeDetails.phoneNumber | telFormat}}</a>\r\n        </h6>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"col-xs-12 col-md-6\">\r\n      <div class=\"row\" ng-If=\"!orderDetail.isGuestLogin || orderDetail.profile.isRegistered\">\r\n        <h6 class=\"mb-4  pt-8\"><strong>Store Details:</strong></h6>\r\n        <h6>\r\n          <span ng-bind=\"orderDetail.summary.storeDetails.storeName\"></span><br />\r\n          <span ng-if=\"orderDetail.summary.storeDetails.addressLine1\">{{orderDetail.summary.storeDetails.addressLine1}} {{orderDetail.summary.storeDetails.addressLine2}}</span><br />\r\n          <span ng-if=\"orderDetail.summary.storeDetails.country\">{{orderDetail.summary.storeDetails.city}} {{orderDetail.summary.storeDetails.state.name}}, {{orderDetail.summary.storeDetails.country.countryCode}} {{orderDetail.summary.storeDetails.zipCode}}</span><br />\r\n          Phone no. <a class=\"blue-colored\" href=\"tel:{{orderDetail.summary.storeDetails.phoneNumber}}\">{{orderDetail.summary.storeDetails.phoneNumber | telFormat}}</a>\r\n        </h6>\r\n      </div>\r\n\r\n      <div class=\"row hideMeInPrint\" ng-If=\"orderDetail.isGuestLogin && !orderDetail.profile.isRegistered\">\r\n        <!-- <signup></signup> -->\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0 static-content\" id=\"printbtn\">\r\n    <div class=\"col-xs-12 col-md-5\">\r\n      <!-- <h6 class=\"p-t-1 mb-4\">The order details have been emailed to you at:</h6>\r\n      <h6>{{orderDetail.profile.customer.email}}</h6> -->\r\n      <!-- <div class=\"form-check\" ng-if=\"!orderDetail.isCardSaved\">\r\n        <label class=\"form-check-label p-t-1\">\r\n          <input type=\"checkbox\" class=\"form-check-input\" ng-model=\"orderDetail.saveCard\" />\r\n            Save card detail for future purchase.\r\n        </label>\r\n      </div> -->\r\n      <div class=\"col-xs-10 offset-xs-1 col-sm-4 offset-sm-0 col-md-6\"\r\n        ng-if=\"!orderDetail.isCardSaved\">\r\n        <button type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-md-text m-b-1\"\r\n          ng-if=\"orderDetail.saveCard\"\r\n          ng-click=\"orderDetail.saveCardDetail()\">Save credit card for future use</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n  <div class=\"col-xs-10 offset-xs-1 col-sm-6 offset-sm-0 col-md-4 static-content\" id=\"printbtn\">\r\n    <a ui-sref=\"category\" class=\"btn btn-primary btn-block btn-md-text m-b-1\">Continue Shopping</a>\r\n  </div>\r\n\r\n\r\n  <div class=\"col-xs-10 offset-xs-1 col-sm-6 offset-sm-0 col-md-4 static-content hideMeInPrint\" id=\"printbtn1\">\r\n    <a href ng-click=\"orderDetail.subscribeNow(orderDetail.summary)\" ng-if='orderDetail.profile.store.isSubscription==true' class=\"btn btn-primary btn-block btn-md-text m-b-1\">Subscribe this order</a>\r\n  </div>\r\n    </div>\r\n</div>\r\n<style type=\"text/css\" media=\"print\">\r\n  .hideMeInPrint { display: none; }\r\n </style>"

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _failure = __webpack_require__(224);
	
	var _failure2 = _interopRequireDefault(_failure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentFailure = (_dec = (0, _utils.Component)({
	  controllerAs: 'paymentFailure',
	  template: _failure2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function PaymentFailure($scope, $ngRedux, $stateParams, $cookies, $state, $window, $auth, $order, APP, spinner, $sce) {
	    _classCallCheck(this, PaymentFailure);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$stateParams = $stateParams;
	    this.$ngRedux = $ngRedux;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.reasonCodeCheck = $stateParams.reasonCode;
	    var logString = $stateParams.logString;
	    var orderId = $stateParams.orderId;
	    var reasonCode = $stateParams.reasonCode;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$order = $order;
	    this.$state = $state;
	    this.$sce = $sce;
	    this.APP = APP;
	    this.spinner = spinner;
	    var text = '';
	
	    var data = {
	      message: logString
	    };
	    this.$order.printPaymentLogs(orderId, data, " Payment failure page.").then(function (success) {
	      console.log("Successfully Printed");
	    }).catch(function (err) {
	      console.log("Failed to print logs");
	    });
	
	    this.isguestLogin = $auth.isGuestLogin();
	
	    /*eslint-disable*/
	    switch (reasonCode) {
	      case '101':
	        text = 'Your card has been declined. Please try again using different card';
	        break;
	      case '0':
	        text = 'Entered CVV number is incorrect. Your payment reversal has been processed.';
	        break;
	      case '100':
	        text = 'Error in Authentication.';
	        break;
	      default:
	        text = this.getErrorMessage(reasonCode);
	    }
	    this.errorMessage = text;
	    /*eslint-enable*/
	
	    try {
	      sessionStorage.removeItem('discountCoupon');
	      sessionStorage.removeItem('birdbuckCoupon');
	      sessionStorage.removeItem('erplyBBDiscount');
	      sessionStorage.removeItem('erplyBBCouponCodes');
	      sessionStorage.removeItem('erplyPromotionCodes');
	      sessionStorage.removeItem('erplyPromotionDiscount');
	      sessionStorage.removeItem('orderNotesSession');
	      sessionStorage.removeItem('guestoauth');
	      sessionStorage.removeItem('isGuestUserLoggedIn');
	    } catch (e) {
	      $cookies.remove('discountCoupon');
	      $cookies.remove('birdbuckCoupon');
	      $cookies.remove('erplyBBDiscount');
	      $cookies.remove('erplyBBCouponCodes');
	      $cookies.remove('erplyPromotionCodes');
	      $cookies.remove('erplyPromotionDiscount');
	      $cookies.remove('orderNotesSession');
	    }
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(PaymentFailure, [{
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      console.log("Failure detail", this.detail);
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.detail.store && this.detail.store.storeName) {
	          storeName = this.detail.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'trustSrc',
	    value: function trustSrc(src) {
	      return this.$sce.trustAsResourceUrl(src);
	    }
	  }, {
	    key: 'getErrorMessage',
	    value: function getErrorMessage(reasonCode) {
	      var h_text = "";
	      switch (reasonCode) {
	        case '04':
	        case 'AVS_N':
	          // h_text = 'Your billing address does not match the address on file with your credit card company. Click <a href="#" style="color: #0000EE;" ng-click="goToProfile()">here</a> to update the billing address in your profile, then try again.';
	          h_text = 'Your billing address does not match the address on file with your credit card company. Click <a style="color: #0000EE;cursor: pointer;" href="/dashboard/profile/user/edit"> here</a> to update the billing address in your profile, then try again.';
	          break;
	        case '14':
	          h_text = 'The entered card number is incorrect.  Please check the number and try again.';
	          break;
	        case '54':
	          h_text = 'Your card has expired.  Please try again using a different card.';
	          break;
	        case '51':
	          h_text = 'Your card has been declined. Please try again using different card';
	          break;
	        case 'N7':
	        case 'CVV_N':
	          h_text = 'The entered CVV number is incorrect.  Please check the number and try again.';
	          break;
	        // case 'EC':
	        // h_text = 'CID FORMAT ERROR';
	        // break;
	        default:
	          h_text = 'We are unable to process your transaction at this time.';
	      }
	      return h_text;
	    }
	  }, {
	    key: 'goToProfile',
	    value: function goToProfile() {
	      this.spinner.show('appSpinner');
	      this.$state.go('profile.edit');
	    }
	  }, {
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        detail: state.auth.profile ? state.auth.profile : state.auth.guestprofile
	      };
	    }
	  }]);
	
	  return PaymentFailure;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$stateParams', '$cookies', '$state', '$window', 'authService', 'orderService', 'APP', 'spinnerService', '$sce'], _temp)) || _class);
	exports.default = PaymentFailure;

/***/ },
/* 224 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"paymentFailure.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{paymentFailure.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"{{paymentFailure.isguestLogin ? 'guestcart' : 'delivery'}}\">Checkout Details</a>\r\n    <span class=\"nav\">Payment</span>\r\n    <span>Failure</span>\r\n  </nav>\r\n\r\n  <div class=\"row gray-bg m-x-0 p-y-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <h5 class=\"m-b-0 primary-text\">Transaction failed!</h5>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0 static-content\">\r\n    <div class=\"col-xs-12 m-t-2 m-b-3\">\r\n      <h5 class=\"m-b-0 primary-text\">Your transaction could not be completed.</h5>\r\n      <p class=\"m-b-2\" ng-if=\"paymentFailure.reasonCodeCheck==4\"><span>Your billing address does not match the address on file with your credit card company. <span ng-if=\"!paymentFailure.isguestLogin\">Click <a href=\"#\" style=\"color: #0000EE;\" ng-click=\"paymentFailure.goToProfile()\">here</a> to update the billing address in your profile, then try again.</span></span></p>\r\n      <p class=\"m-b-2\" ng-if=\"paymentFailure.reasonCodeCheck!=4\" ng-bind-html=\"paymentFailure.$sce.trustAsHtml(paymentFailure.errorMessage)\"></p>\r\n      <p class=\"m-b-0\">Please try again.</p>\r\n      <p>If the problem persists, please contact  the store at <a class=\"blue-colored\" href=\"tel:{{paymentFailure.detail.store.phoneNumber}}\">{{paymentFailure.detail.store.phoneNumber | telFormat}}.</a></p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n  <div class=\"col-xs-10 offset-xs-1 col-sm-6 offset-sm-0 col-md-4 static-content\">\r\n    <a ui-sref=\"{{paymentFailure.isguestLogin ? 'guestcart' : 'delivery'}}\" class=\"btn btn-primary btn-block btn-md-text m-b-1\">Try again</a>\r\n  </div>\r\n    </div>\r\n</div>\r\n"

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _recentOrder = __webpack_require__(226);
	
	var _recentOrder2 = _interopRequireDefault(_recentOrder);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecentOrder = (_dec = (0, _utils.Component)({
	  controllerAs: 'recentOrder',
	  template: _recentOrder2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function RecentOrder($scope, $ngRedux, $spinner, $order, orderActions, $auth, $state, toaster, $cookies, $stateParams, $window, APP) {
	    var _this = this;
	
	    _classCallCheck(this, RecentOrder);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.orderFetched = false;
	    this.$order = $order;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$state = $state;
	    this.$auth = $auth;
	    this.toaster = toaster;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.APP = APP;
	    this.showGotoCart = [];
	    this.shippingOfferAvailableIcon = _shippingTick2.default;
	    try {
	      sessionStorage.removeItem('discountCoupon');
	      sessionStorage.removeItem('discountCouponAmount');
	      sessionStorage.removeItem('birdbuckCoupon');
	      sessionStorage.removeItem('erplyBBDiscount');
	      sessionStorage.removeItem('erplyBBCouponCodes');
	      sessionStorage.removeItem('erplyPromotionCodes');
	      sessionStorage.removeItem('erplyPromotionDiscount');
	      sessionStorage.removeItem('orderNotesSession');
	    } catch (e) {
	      $cookies.remove('discountCouponAmount');
	      $cookies.remove('discountCoupon');
	      $cookies.remove('birdbuckCoupon');
	      $cookies.remove('erplyBBDiscount');
	      $cookies.remove('erplyBBCouponCodes');
	      $cookies.remove('erplyPromotionCodes');
	      $cookies.remove('erplyPromotionDiscount');
	      $cookies.remove('orderNotesSession');
	    }
	
	    $ngRedux.dispatch(orderActions.setRecentOrder([]));
	    $spinner.show('appSpinner');
	    $order.getRecentOrder().finally(function () {
	      _this.orderFetched = true;
	      $spinner.hide('appSpinner');
	    });
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(RecentOrder, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        recentOrder: state.order.recentOrder
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'ReOrder',
	    value: function ReOrder(orderId) {
	      var _this2 = this;
	
	      this.showGotoCart[orderId] = false;
	      this.$order.reOrder(orderId).then(function (success) {
	        _this2.$auth.getUserProfile();
	        if (success.data.successCode === '200') {
	          // this.$state.go('cart');
	          _this2.showGotoCart[orderId] = true;
	        } else {
	          _this2.toaster.pop('success', 'There is a problem retrieving data. Please add order manually.');
	        }
	      }, function (error) {
	        _this2.$auth.printCustomerGenericLogs(error);
	      } // console.log(error)
	      ).catch(function (err) {
	        _this2.$auth.printCustomerGenericLogs(err);
	      }).finally(function () {} // console.log('error')
	      );
	    }
	  }, {
	    key: 'gotoCart',
	    value: function gotoCart(orderId) {
	      this.showGotoCart[orderId] = false;
	      this.$state.go('cart');
	    }
	  }, {
	    key: 'subscribeNow',
	    value: function subscribeNow(order) {
	      this.$auth.resetSubscriptionCart();
	      this.$auth.saveSubscriptionLocalState({});
	      this.$state.go('subscription-detail', { subscriptionId: order.orderId, option: 'add' });
	    }
	  }, {
	    key: 'goToProductPage',
	    value: function goToProductPage(item) {
	
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      // let storeName =  false;
	      if (storeName) {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.masterProduct.category.prettyUrl,
	          subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
	          productId: item.masterProduct.prettyUrl,
	          itemGroupNumber: item.masterProduct.itemGroupNumber,
	          storeName: storeName
	        });
	      } else {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.masterProduct.category.prettyUrl,
	          subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
	          productId: item.masterProduct.prettyUrl,
	          itemGroupNumber: item.masterProduct.itemGroupNumber
	        });
	      }
	    }
	  }]);
	
	  return RecentOrder;
	}(), _class2.$inject = ['$scope', '$ngRedux', 'spinnerService', 'orderService', 'orderActions', 'authService', '$state', 'toaster', '$cookies', '$stateParams', '$window', 'APP'], _temp)) || _class);
	exports.default = RecentOrder;

/***/ },
/* 226 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"recentOrder.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{recentOrder.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>My Orders</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 pt-4\">\r\n    <div class=\"col-xs-12 p-x-0\" ng-repeat=\"order in recentOrder.recentOrder\">\r\n\r\n      <div class=\"media list-header\" style=\"padding: 10px;\">\r\n        <div class=\"col-xs-12 col-sm-12 col-md-6 p-y-0 p-x-0\" style=\"vertical-align:middle;\">\r\n          <b>Invoice-{{order.invoiceNumber}} on {{order.browserOrderTime | date:'medium'}}\r\n          </b>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-12 col-md-6 p-y-0 p-x-0 pull-right rt-align\" style=\"vertical-align:middle;\">\r\n                    <button class=\"btn btn-primary  pull-xs-right\" ng-if=\"!recentOrder.showGotoCart[order.orderId] || recentOrder.showGotoCart[order.orderId] == 'undefined'\" style=\"margin-left: 5px;margin-top: 0;font-size: 0.85rem;height: 34px;\" ng-click=\"recentOrder.ReOrder(order.orderId)\">Buy Again</button>\r\n                    <button class=\"btn btn-primary  pull-xs-right\" ng-if='recentOrder.showGotoCart[order.orderId]' style=\"margin-left: 5px;margin-top: 0;font-size: 0.85rem;height: 34px;\" ng-click=\"recentOrder.gotoCart(order.orderId)\">Go to Cart</button>\r\n         <a ng-click=\"recentOrder.subscribeNow(order)\" ng-if='recentOrder.profile.store.isSubscription==true'> <button class=\"btn btn-primary  pull-xs-right\" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\" >Subscribe Now</button></a>\r\n         <strong><a class=\" pull-xs-right\" ng-if='recentOrder.showGotoCart[order.orderId]' style=\"margin-right: 15px;margin-top: 0px;font-size: 0.85rem;height: 30px;color:seagreen;padding-top: 8px;\"><img ng-src={{recentOrder.shippingOfferAvailableIcon}} class=\"mb-8\" style=\"padding-right: 5px; padding-top: 4px; height: 18px;\"/>Added</a></strong>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row m-x-0\">\r\n        <div class=\"media p-x-2 p-y-1 col-md-6 col-xs-12\" ng-repeat=\"item in order.orderEntries\">\r\n          <div class=\"media-left\" href=\"#\">\r\n            <img img-lazy-loader={{item.item.smallImageUrl}} class=\"media-object list-image-sm-media border-image rounded cursor-pointer\" alt=\" Product image\" height=\"75px\"\r\n            ng-click=\"recentOrder.goToProductPage(item.item)\" />\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <a ng-click=\"recentOrder.goToProductPage(item.item)\">\r\n              <h4 class=\"media-heading\">{{item.item.name}}</h4>\r\n            </a>\r\n            <div>\r\n              Quantity: {{item.quantity}}\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"media p-x-2 p-b-1\">\r\n        <div>Order Status: {{order.orderStatus == 'Closed' ? 'Completed' : order.orderStatus}}</div>\r\n        <div ng-if=\"order.orderStatus!='Canceled'\">Club Points Earned: {{order.dscPoints | number: 2}}</div>\r\n        <div ng-if=\"order.orderStatus!='Canceled'\">Total Amount Paid: ${{order.amountPaid - order.discountAmount | number: 2}}</div>\r\n      </div>\r\n      <hr style=\" border: .5px solid #000\">\r\n    </div>\r\n\r\n    <div class=\"row p-t-3 m-x-0\" ng-if=\"recentOrder.orderFetched && !recentOrder.recentOrder.length\">\r\n      <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n        <h5 class=\"font-weight-bold\" >No recent orders</h5>\r\n        <p class=\"m-t-1\">Place an order to see its details here.</p>\r\n        <div class=\"m-t-3 p-t-3\">\r\n          <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"category\">Start New Order</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _savingsClub = __webpack_require__(228);
	
	var _savingsClub2 = _interopRequireDefault(_savingsClub);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SavingsClub = (_dec = (0, _utils.Component)({
	  controllerAs: 'dsc',
	  template: _savingsClub2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function SavingsClub($scope, $order, $state, $uibModal, $auth, $ngRedux, $spinner, $window, $stateParams, $cookies, APP) {
	    var _this = this;
	
	    _classCallCheck(this, SavingsClub);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.dscCard = _WBUDSCCard2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$order = $order;
	    this.$state = $state;
	    this.agreement = false;
	    this.$uibModal = $uibModal;
	    this.$auth = $auth;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.APP = APP;
	    this.justOnce = 1;
	
	    if ($stateParams.storeName) {
	      this.storeName = $stateParams.storeName;
	    } else {
	      this.storeName = this.$auth.getGuestStoreDetail().storeName;
	    }
	
	    if (this.storeName && !$auth.isLoggedIn()) {
	      $auth.getStoreDetail(this.storeName).then(function (success) {
	        var store = {};
	        store.storeId = success.data.storeId;
	        store.storeName = _this.storeName;
	        $auth.doGuestLogin(store);
	      }, function (error) {
	        _this.$state.go('login');
	      });
	    } else {
	      $spinner.show('appSpinner');
	      $window.scrollTo(0, 0);
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile && this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else if (this.store) {
	          storeName = this.store.storeName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        $order.getCartDetail().finally(function () {
	          $spinner.hide('appSpinner');
	          _this.$auth.getUserProfile();
	        });
	      } else {
	        $spinner.hide('appSpinner');
	      }
	    }
	
	    $scope.$on('$destroy', disconnect);
	
	    // this.isDscAdded = this.isDscAddedinCart();
	  }
	
	  _createClass(SavingsClub, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        detail: state.order.cartDetail,
	        profile: state.auth.profile,
	        store: state.auth.storeDetail
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'buyDsc',
	    value: function buyDsc() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        console.log("Executed after 100 milliseconds");
	      }, 100);
	      if (this.$auth.isGuestLogin()) {
	        var msg = 'add this item to cart';
	        var cart = null;
	        cart = { 'quantity': 1, 'itemId': 88888888, 'isDscCard': true, 'masterProductId': 88888888 };
	        this.$auth.addtoGuestCart(cart);
	        this.$auth.showLoginPopUp(msg);
	      } else {
	        this.$order.buyDscMembership().then(function () {
	          _this2.$auth.getUserProfile();
	          // .then(success => {
	          //   if(this.profile.store.hasErply){
	          //     this.$order.dscPremembership();
	          //   }
	          // })
	          // .catch(error => {
	          //   console.log("Profile call failure in dsc membership purchase");
	          // });
	          _this2.$state.go('cart');
	        });
	      }
	    }
	  }, {
	    key: 'isDscAddedinCart',
	    value: function isDscAddedinCart() {
	      if (this.detail.cartItems != null) {
	        return this.detail.cartItems.some(function (cartItem) {
	          return cartItem.item.storeItemCode === 'C' || cartItem.item.storeItemCode === 'c';
	        });
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return SavingsClub;
	}(), _class2.$inject = ['$scope', 'orderService', '$state', '$uibModal', 'authService', '$ngRedux', 'spinnerService', '$window', '$stateParams', '$cookies', 'APP'], _temp)) || _class);
	exports.default = SavingsClub;

/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = "\r\n<!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n<mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n<!-- Breadcrumb -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"dsc.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{dsc.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>DSC Benefits Info</span>\r\n  </nav>\r\n\r\n<div class=\"static-content\" style=\"background-color: #fff;\">\r\n  <div class=\"row m-x-0 p-b-1 p-t-2\">\r\n    <div class=\"col-xs-12\">\r\n      <h6 class=\"font-weight-bold mb-8\">Daily Savings Club&reg; Exclusive Member Benefits</h6>\r\n      <div class=\"row\">\r\n      <span class=\"inline_block\">\r\n      \t<img ng-src={{dsc.dscCard}} alt=\"image\" class=\"product-image\" />\r\n      </span>\r\n      <span class=\"inline_block\">\r\n      <p>\r\n      \tAs a member of our Daily Savings Club&reg;, for your annual membership fee of $25, you receive:\r\n      </p>\r\n      <ul>\r\n      \t<li>\r\n      \t\t15% OFF regular prices of all bird food every day.\r\n      \t</li>\r\n      \t<li>\r\n          Additional 5% OFF bird food sales prices.\r\n      \t</li>\r\n      \t<li>\r\n          $10 Bird Buck coupon for every $200 purchased throughout the store.\r\n      \t</li>\r\n      \t<li>\r\n          Exclusive members-only promotions.\r\n      \t</li>\r\n        <li>\r\n          FREE gift at signup and renewal!\r\n        </li>\r\n      </ul>\r\n      <div class=\"row col-xs-10 col-sm-6 col-md-6  pt-8\">\r\n        <input type=\"checkbox\" name=\"agreement\" ng-model=\"dsc.agreement\" class=\"form-control text-xs-left d-inline\" style=\"width: auto;\" required=\"\">\r\n        <div class=\"d-inline\"> I agree to the  <a href=\"https://www.wbu.com/dailysavingsclub/terms/\" target=\"_blank\" class=\"link-text\">Terms and Conditions.</a></div>\r\n      </div>\r\n      <div class=\"col-xs-12\">\r\n        <div class=\"row col-xs-10 col-sm-6 col-md-6  pt-8\">\r\n          <button class=\"btn btn-primary btn-block btn-md-text\"  ng-click=\"dsc.buyDsc();dsc.justOnce=dsc.justOnce+1\"\r\n          ng-disabled=\"!dsc.agreement || dsc.justOnce>1 || dsc.isDscAddedinCart()\">Add to Cart</button>\r\n          <div class=\"error-text\"\r\n              ng-show=\"dsc.isDscAddedinCart()\">Item has already been added to the cart</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </span>\r\n      </div>\r\n\r\n   </div>\r\n  </div>\r\n</div>"

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _birdFood = __webpack_require__(179);
	
	var _birdFood2 = _interopRequireDefault(_birdFood);
	
	var _search = __webpack_require__(230);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _tempunavailable_L = __webpack_require__(181);
	
	var _tempunavailable_L2 = _interopRequireDefault(_tempunavailable_L);
	
	var _tempunavailable = __webpack_require__(182);
	
	var _tempunavailable2 = _interopRequireDefault(_tempunavailable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Search = (_dec = (0, _utils.Component)({
	  controllerAs: 'search',
	  template: _search2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Search($scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, authService, $window, $location, APP) {
	    var _this = this;
	
	    _classCallCheck(this, Search);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	
	    this.$state = $state;
	    this.APP = APP;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.birdFood = _birdFood2.default;
	    this.tempUnavailable = _tempunavailable_L2.default;
	    this.tempUnavailable_S = _tempunavailable2.default;
	
	    this.$toaster = $toaster;
	    this.isCallingAPI = true;
	    this.searchTerm = $stateParams.searchTerm ? $stateParams.searchTerm : '';
	    this.$stateParams = $stateParams;
	    this.$auth = authService;
	    this.isMiscelleneousCategory = 4;
	    this.$location = $location;
	    this.pwrProduct = {};
	    $ngRedux.dispatch(orderActions.setSearchResults([]));
	    $spinner.show('appSpinner');
	    $order.getSearchResults(this.searchTerm).then(function (success) {
	      _this.sendInfoToPowerReview();
	    }).finally(function () {
	      $spinner.hide('appSpinner');
	      _this.isCallingAPI = false;
	    });
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Search, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        searchResults: state.order.searchResults
	      };
	    }
	  }, {
	    key: 'goToDSCDetailPage',
	    value: function goToDSCDetailPage() {
	      // console.log('goToDSCDetailPage');
	      this.$state.go('savings-club');
	    }
	    // returns dsc price if it has else return normal price
	
	  }, {
	    key: 'getRegularPrice',
	    value: function getRegularPrice(item) {
	      if (item && item.price) {
	        return ' $' + item.price.toFixed(2);
	      }
	      return '';
	    }
	  }, {
	    key: 'getDscPrice',
	    value: function getDscPrice(item) {
	      if (item && item.price) {
	        return ' $' + (item.price * 85 / 100).toFixed(2);
	      }
	      return '';
	    }
	  }, {
	    key: 'goToGiftPage',
	    value: function goToGiftPage(store) {
	      this.$state.go('gift-card', { 'storeName': store });
	    }
	  }, {
	    key: 'isGiftCard',
	    value: function isGiftCard(masterProduct) {
	
	      var seriesNumber = masterProduct.masterCode.charAt(0);
	      var categoryId = masterProduct.category.id;
	      return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
	    }
	  }, {
	    key: 'getPriceTag',
	    value: function getPriceTag(product, isDsc) {
	      var priceTag;
	      var isDscCategory = product.itemList[0].masterProduct.subCategories[0].category.dscCategory;
	      var maxItem = product.itemList[0];
	      var regularMaxPrice = isDsc ? this.getDscPrice(maxItem) : this.getRegularPrice(maxItem);
	      // checking max price
	      if (product.itemList.length > 1) {
	        var minItem = product.itemList[product.itemList.length - 1];
	
	        var regularMinPrice = isDsc ? this.getDscPrice(minItem) : this.getRegularPrice(minItem);
	        priceTag = regularMaxPrice;
	      } else {
	        priceTag = regularMaxPrice;
	      }
	
	      return priceTag;
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'goToNextState',
	    value: function goToNextState(item) {
	
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (this.isGiftCard(item.itemList[0].masterProduct)) {
	        this.goToGiftPage(storeName);
	        return;
	      }
	      // let storeName =  false;
	      if (storeName) {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.itemList[0].masterProduct.category.prettyUrl,
	          subCategoryId: item.itemList[0].masterProduct.subCategories[0].prettyUrl,
	          productId: item.itemList[0].masterProduct.prettyUrl,
	          itemGroupNumber: item.itemList[0].masterProduct.itemGroupNumber,
	          storeName: storeName
	        });
	      } else {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.itemList[0].masterProduct.category.prettyUrl,
	          subCategoryId: item.itemList[0].masterProduct.subCategories[0].prettyUrl,
	          productId: item.itemList[0].masterProduct.prettyUrl,
	          itemGroupNumber: item.itemList[0].masterProduct.itemGroupNumber,
	          storeName: 'shop'
	        });
	      }
	    }
	  }, {
	    key: 'sendInfoToPowerReview',
	    value: function sendInfoToPowerReview() {
	      if (this.searchResults != null && this.searchResults.length > 0) {
	        var pwrItem = {};
	        var pwrItemList = [];
	        // var pwrIdDiv = document.getElementsByClassName("pwr-review");
	        // console.log("pwrdIdDiv : ", pwrIdDiv);
	        for (var i = 1; i <= this.searchResults.length; i++) {
	          // pwrIdDiv[i-1].id = "category-snippet-" + i;
	          // pwrIdDiv[i-1].setAttribute("id", "category-snippet-" + i);
	          pwrItem = {
	            api_key: this.APP.AUTH.AUTH_URL.pwr.api_key,
	            locale: this.APP.AUTH.AUTH_URL.pwr.locale,
	            merchant_group_id: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
	            merchant_id: this.APP.AUTH.AUTH_URL.pwr.merchant_id,
	            page_id: this.searchResults[i - 1].itemList[0].masterProduct.masterCode.substring(0, 7),
	            components: {
	              CategorySnippet: 'category-snippet-' + i
	            }
	          };
	          if (i > 1) {
	            pwrItem.enable_content_collection_modal = false;
	          }
	          pwrItemList.push(pwrItem);
	        }
	        console.log("pwrItemList : ", pwrItemList);
	        window.pwr = window.pwr || function () {
	          (window.pwr.q = window.pwr.q || []).push(arguments);
	        };
	        setTimeout(function () {
	          window.pwr("render", pwrItemList);
	        }, 1500);
	      }
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isIpad_potrait',
	    value: function isIpad_potrait() {
	      return this.$window.innerWidth < 769 && this.$window.innerWidth > 1247;
	    }
	  }, {
	    key: 'isOutOfStock',
	    value: function isOutOfStock(items) {
	      var isSubcatOutOfStock = false;
	      var j = 0;
	      for (var i = 0; i < items.itemList.length; i++) {
	        if (items.itemList[i].isOutOfStock) {
	          j++;
	        }
	      }
	      if (j == items.itemList.length) {
	        return true;
	      }
	    }
	  }, {
	    key: 'isAvailablebackon',
	    value: function isAvailablebackon(items) {
	      var availableOn = null;
	      for (var i = 0; i < items.itemList.length; i++) {
	        if (items.itemList[i].isOutOfStock) {
	          availableOn = items.itemList[i].availableBackOn;
	          break;
	        }
	      }
	      return availableOn;
	    }
	  }]);
	
	  return Search;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$stateParams', '$state', 'toaster', 'orderService', 'spinnerService', 'orderActions', 'authService', '$window', '$location', 'APP'], _temp)) || _class);
	exports.default = Search;

/***/ },
/* 230 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"search.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{search.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>Search Results</span>\r\n  </nav>\r\n\r\n  <div class=\"row p-t-2 m-x-0 hidden-md-up\">\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <span class=\"p-x-1\" ng-if=\"search.searchResults.length\">\r\n        Showing {{search.searchResults.length}} results for \"<span style=\"color: #A4182D;\">{{search.searchTerm}}</span>\"\r\n      </span>\r\n      <div ng-if=\"!search.isCallingAPI\">\r\n        <span class=\"p-x-1\" ng-if=\"!search.searchResults.length\">\r\n          No results for \"<span style=\"color: #A4182D;\">{{search.searchTerm}}</span>\"\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n    \r\n  <div class=\"row p-t-2 p-x-2 m-x-0 hidden-sm-down\">\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <span class=\"p-x-1\" ng-if=\"search.searchResults.length\">\r\n        Showing {{search.searchResults.length}} results for \"<span style=\"color: #A4182D;\">{{search.searchTerm}}</span>\"\r\n      </span>\r\n      <div ng-if=\"!search.isCallingAPI\">\r\n        <span class=\"p-x-1\" ng-if=\"!search.searchResults.length\">\r\n          No results for \"<span style=\"color: #A4182D;\">{{search.searchTerm}}</span>\"\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- creates list view of products in xs devices -->\r\n  <div class=\"row m-x-0\">\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <div class=\"list-group list-container hidden-md-up\" ng-repeat=\"item in search.searchResults\">\r\n        <a ng-click=\"search.goToNextState(item)\"\r\n          class=\"list-group-item list-group-item-action media\" ng-if=\"item.itemList[0].masterProduct.masterCode != 88888888\">\r\n          <div class=\"{{search.isOutOfStock(item) ? 'm_pngcontainer1 media-left' : 'media-left'}}\">\r\n            <img img-lazy-loader={{item.itemList[0].smallImageUrl}} class=\"media-object\" style=\"max-width: 60px\" />\r\n            <img ng-if=\"search.isOutOfStock(item)\" src={{search.tempUnavailable_S}}  alt=\"smiley\" style=\"max-width: 60px; margin-top: -10px\" class=\"media-object \"/>\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <h4 class=\"media-heading\" ng-bind=\"item.name\"></h4>\r\n            <p class=\"gray-text m-b-0\" ng-bind=\"item.itemList[0].briefDescription\"></p>\r\n          </div>\r\n          <div class=\"media-right\">\r\n            <img src={{search.homeArrow}} class=\"sub-category-icon-arr\" />\r\n          </div>\r\n        </a>\r\n         <button class=\"hidden-btn list-group-item list-group-item-action media\" ng-click=\"search.goToDSCDetailPage()\" ng-if=\"item.itemList[0].masterProduct.masterCode == 88888888\">\r\n           <div class=\"media-left\">\r\n            <img img-lazy-loader={{item.itemList[0].smallImageUrl}} class=\"media-object\" style=\"max-width: 60px\" />\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <h4 class=\"media-heading\" ng-bind=\"item.name\"></h4>\r\n            <p class=\"gray-text m-b-0\" ng-bind=\"item.itemList[0].briefDescription\"></p>\r\n          </div>\r\n          <div class=\"media-right\">\r\n            <img src={{search.homeArrow}} class=\"sub-category-icon-arr\" />\r\n          </div>\r\n      </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- creates normal expanded view on md devices -->\r\n  <div id=\"tiles\" class=\"row p-x-2 m-x-0 hidden-sm-down\">\r\n    <div class=\"col-md-4 col-lg-3  category-item\"\r\n      ng-repeat=\"item in search.searchResults\">\r\n      <a ng-click=\"search.goToNextState(item)\"  ng-if=\"item.itemList[0].masterProduct.masterCode != 88888888\">\r\n        <div class=\"{{search.isOutOfStock(item) ? (search.isIpad_potrait ? 'm_pngcontainer1' : 'pngcontainer1') : ''}}\"> \r\n          <img img-lazy-loader={{item.itemList[0].largeImageUrl}}  alt=\"image\" \r\n          ng-style=\"search.isIpad() ? (search.isIpad_potrait ? {'left':'0px'} :  {'padding-left':'17px'})  : {'padding-left':'17px'}\" \r\n          class=\"product-thumbnail subcat-rounded\" />\r\n          <img  ng-if=\"search.isOutOfStock(item)\" src={{search.tempUnavailable}} \r\n            ng-style=\"search.isIpad() ? (search.isIpad_potrait ? {'left':'0px'} :  {'padding-left':'17px'})  : {'padding-left':'17px'}\" \r\n            class=\"{{search.isOutOfStock(item) ? 'product-thumbnail-override subcat-rounded' : 'product-thumbnail subcat-rounded'}}\" alt=\"smiley\" />\r\n        </div>\r\n        <div class=\" m-b-0\">\r\n          <!-- categoryoryId: {{item.itemList[0].masterProduct.category.prettyUrl}}, \r\n          subCategoryId: {{item.itemList[0].masterProduct.subCategories[0].prettyUrl}}, \r\n          productId: {{item.itemList[0].masterProduct.prettyUrl}} -->\r\n            <!-- <span ng-if=\"search.isOutOfStock(item) && search.isAvailablebackon(item)\" class=\"s_out_of_stock\">Expected availability: {{item.itemList[0].availableBackOn | date:'MM/dd/yyyy'}}<br/></span> -->\r\n            <span class=\"sub-category-text\">{{item.name}}</span>\r\n            <div id=\"{{'category-snippet-'+($index+1)}}\"></div>\r\n          <p>\r\n            <span class=\"gray-text\">{{item.itemList[0].briefDescription}}</span>\r\n             <br>\r\n            <span >\r\n            <span class=\"sub-category-text\" ng-bind=\"search.getPriceTag(item,false)\"> </span> <span  ng-if=\"item.itemList[0].masterProduct.subCategories[0].category.dscCategory\" > {{item.itemList[0].weight}} lbs</span>\r\n            </span>\r\n            <br>\r\n             <span  ng-if=\"item.itemList[0].masterProduct.subCategories[0].category.dscCategory\" >\r\n             <span class=\"sub-category-text\" ng-bind=\"search.getPriceTag(item,true)\"> </span> Daily Savings Club\r\n          </span>\r\n            <br>\r\n            <strong ng-if=\"item.itemList.length > 1\"  style=\"font-style: italic\">click for more sizes</strong>\r\n\r\n\r\n          </p>\r\n\r\n        </div>\r\n      </a>\r\n      <button class=\"hidden-btn\" ng-click=\"search.goToDSCDetailPage()\"  ng-if=\"item.itemList[0].masterProduct.masterCode == 88888888\">\r\n        <img img-lazy-loader={{item.itemList[0].largeImageUrl}} alt=\"image\" class=\"product-thumbnail subcat-rounded\"/>\r\n        <h6 class=\"sub-category-text m-b-0\" ng-bind=\"item.name\"></h6>\r\n        <p class=\"gray-text m-b-0\" ng-bind=\"item.itemList[0].briefDescription\"></p>\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n"

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _wbuPointer = __webpack_require__(149);
	
	var _wbuPointer2 = _interopRequireDefault(_wbuPointer);
	
	var _wbuMapPointer = __webpack_require__(150);
	
	var _wbuMapPointer2 = _interopRequireDefault(_wbuMapPointer);
	
	var _storelocator = __webpack_require__(232);
	
	var _storelocator2 = _interopRequireDefault(_storelocator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StoreLocator = (_dec = (0, _utils.Component)({
	  controllerAs: 'locator',
	  template: _storelocator2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function StoreLocator($scope, $ngRedux, $spinner, $uibModal, $order, NgMap, $stateParams, $auth, $window, $state, APP) {
	    var _this = this;
	
	    _classCallCheck(this, StoreLocator);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.mapPointerLg = _wbuPointer2.default;
	    this.mapPointer = _wbuMapPointer2.default;
	    this.$uibModal = $uibModal;
	    this.$order = $order;
	    this.hasSearched = false;
	    this.hasError = false;
	    this.onMarkerClick = this.onMarkerClick.bind(this);
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	
	    $spinner.show('appSpinner');
	    $order.getStoreLocations().finally(function () {
	      return $spinner.hide('appSpinner');
	    });
	    NgMap.getMap().then(function (map) {
	      //  console.log('map', map);
	      _this.map = map;
	    });
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(StoreLocator, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        store: state.auth.storeDetail,
	        storeLocations: state.order.storeLocations
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'search',
	    value: function search(distance, address, form) {
	      var _this2 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      var myAddressQuery = address;
	      var geocoder = new window.google.maps.Geocoder();
	      geocoder.geocode({ address: myAddressQuery,
	        region: 'no'
	      }, function (results, status) {
	        //  console.log('results', results);
	        if (status === 'OK') {
	          var lat = results[0].geometry.location.lat();
	          var lng = results[0].geometry.location.lng();
	          //  console.log('latlng', lat);
	          //  console.log('latlng', lng);
	          var searchData = {
	            'lat': +lat,
	            'lng': +lng,
	            'distance': +distance
	          };
	          _this2.$order.searchStores(searchData).then(function () {
	            return _this2.hasSearched = true;
	          }, function () {
	            return _this2.hasError = true;
	          });
	        } else {
	          _this2.hasError = true;
	        }
	      });
	    }
	  }, {
	    key: 'showHours',
	    value: function showHours(storeUrlName) {
	      this.storeUrlName = storeUrlName;
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-header modalheaderbg"><h5>Store Hours</h5></div>' + '<div class="modal-body" id="modal-body">' + '<h6 ng-if="!store.storeTimings.length" class="error-text">Timings not Available for this Store</h6>' + '<h6 ng-if="store.storeTimings.length" ng-repeat="item in store.storeTimings">' + '{{item.day}}: {{formattedTime(changeStringtoDateObject(item.openTime))}} to ' + '{{item.isHoliday ? formattedTime(changeStringtoDateObject(item.closeTime)) + " (Off)" ' + ': formattedTime(changeStringtoDateObject(item.closeTime))}}' + '</h6>' + '</div>' + '<div class="modal-footer text-center">' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', '$state', 'authService', function ($scope, $uibModalInstance, $state, authService) {
	          authService.getStoreDetail($ctrl.storeUrlName).then(function (success) {
	            return $scope.store = success.data;
	          });
	
	          $scope.formattedTime = function (dateTime) {
	            var date = dateTime ? new Date(dateTime) : new Date();
	            var hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
	            var time = (hours < 10 ? '0' + hours : hours) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	            var ampm = date.getHours() >= 12 ? ' PM' : ' AM';
	            return time + ampm;
	          };
	
	          // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
	          $scope.changeStringtoDateObject = function (stringTime) {
	            var timeArray = stringTime.split(':');
	            var hours = timeArray[0];
	            var minutes = timeArray[1];
	            var timeObject = new Date();
	            timeObject.setMinutes(minutes);
	            return timeObject.setHours(hours);
	          };
	
	          $scope.ok = function () {
	            return $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'onMarkerClick',
	    value: function onMarkerClick(e, storeObj) {
	      //  console.log('storeObj', storeObj);
	      this.storeObj = storeObj;
	      this.map.showInfoWindow('storeInfo', storeObj.storeCode);
	    }
	  }]);
	
	  return StoreLocator;
	}(), _class2.$inject = ['$scope', '$ngRedux', 'spinnerService', '$uibModal', 'orderService', 'NgMap', '$stateParams', 'authService', '$window', '$state', 'APP'], _temp)) || _class);
	exports.default = StoreLocator;

/***/ },
/* 232 */
/***/ function(module, exports) {

	module.exports = "\r\n<!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n<!--breadcrum section -->\r\n<nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n  <a class=\"nav\" ng-click=\"locator.goToHomePage()\"  >\r\n    <img class=\"breadcrumb-logo-icon\" src={{locator.houseIcon}} alt=\"logo\" />\r\n    <span>Home</span>\r\n  </a>\r\n  <span>Store Locator</span>\r\n</nav>\r\n\r\n<div class=\"p-x-3-md\">\r\n  <div class=\"row m-x-0 p-t-2\">\r\n    <div class=\"col-sm-12\">\r\n      <h5 class=\"font-weight-bold\">Store Locator</h5>\r\n      <p class=\"m-b-0\">Looking for a Wild Birds Unlimited store near you?</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row m-x-0 p-b-1 p-t-1\">\r\n    <div class=\"col-sm-12 col-lg-6\">\r\n\r\n      <div map-lazy-load=\"https://maps.google.com/maps/api/js?key=AIzaSyDGMUklyG2WPRhbUqPvIz9uxyfzxTwCGJ0\">\r\n\r\n        <ng-map zoom=\"16\" class=\"store-locator-map\" zoom-to-include-markers=\"true\">\r\n          <info-window id=\"storeInfo\" max-width=\"200\">\r\n            <div ng-non-bindable=\"\">\r\n              <div class=\"scrollFix\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-12 pb-4 font-weight-bold\" style=\"color: #a4182d\">Wild Birds Unlimited</div>\r\n                  <div class=\"col-xs-12\">\r\n                    <div class=\"m-b-0\">\r\n                      <span class=\"font-weight-bold\">{{locator.storeObj.name}}</span><br />\r\n                      <span>{{locator.storeObj.addressLine1 + ', ' + addressLine2}}<br />\r\n                      {{locator.storeObj.city + ' ' + locator.storeObj.state + ', ' + locator.storeObj.country}}<br/>\r\n                      Phone: {{locator.storeObj.phoneNumber | telFormat}}</span><br />\r\n                      <a href=\"mailto:{{locator.storeObj.email}}\" class=\"blue-colored\">Email</a> | <a class=\"blue-colored\" href ng-click=\"locator.showHours(locator.storeObj.storeUrlName)\">Store Hours</a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </info-window>\r\n\r\n          <marker ng-repeat=\"item in locator.storeLocations\"\r\n            id=\"{{item.storeCode}}\"\r\n            position=\"{{item.pos}}\"\r\n            on-click=\"locator.onMarkerClick(item)\"\r\n            title=\"{{item.name + ', ' + item.city}}\"\r\n            icon={{locator.mapPointer}}\r\n            centered=\"true\">\r\n          </marker>\r\n        </ng-map>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-12 col-lg-6 m-t-md-1\">\r\n\r\n      <div class=\"row bg-color p-b-2 p-t-1 m-x-0\">\r\n        <form name=\"searchForm\" layout=\"column\"\r\n            autocomplete=\"off\" novalidate>\r\n          <div class=\"col-sm-6 col-lg-4 col-xs-4 p-r-0\" ng-class=\"{'has-danger': (searchForm.$submitted || searchForm.address.$touched) && searchForm.address.$invalid}\" class = \"input-group\">\r\n          <label>Address/state</label>\r\n            <input name=\"address\" type=\"text\" class=\"form-control\"\r\n            ng-model=\"locator.address\" required>\r\n          </div>\r\n          <div class=\"col-sm-3 col-lg-4 col-xs-4 p-r-0\" ng-class=\"{'has-danger': (searchForm.$submitted || searchForm.distance.$touched) && searchForm.distance.$invalid}\" class = \"input-group\">\r\n          <label>Radius in Miles</label>\r\n            <input name=\"distance\" type=\"number\" class=\"form-control\"\r\n            ng-model=\"locator.distance\" ng-min=\"0\" required>\r\n          </div>\r\n          <div class=\"col-sm-3 col-lg-4 col-xs-4\">\r\n            <label>&nbsp;</label>\r\n            <button class=\"btn btn-primary btn-md-text form-control p-l-0 p-r-0\"\r\n            ng-click=\"locator.search(locator.distance, locator.address, searchForm)\">Search</button>\r\n          </div>\r\n        </form>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-12 m-t-1\">\r\n          <div class=\"store-locator-wrap\">\r\n            <p class=\"gray-bg m-b-0 store-locator-results\">{{locator.storeLocations.length}} Results found</p>\r\n            <div class=\"store-locator-list\">\r\n\r\n              <div class=\"row m-x-0 store-locator-list-item\" ng-if=\"locator.hasError\">\r\n                <div class=\"col-xs-12 text-xs-center\">\r\n                  <p class=\"m-b-0\">No Results Found.</p>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row m-x-0 store-locator-list-item\"\r\n              \tng-repeat=\"item in locator.storeLocations\">\r\n                <div class=\"col-xs-4 text-xs-center\">\r\n                  <img class=\"mx-auto\" src={{locator.mapPointerLg}} alt=\"logo\" height=\"75\" width=\"75\"/>\r\n                  <p class=\"m-b-0\"></p>\r\n                </div>\r\n                <div class=\"col-xs-8\">\r\n                  <h5 class=\"m-b-0\">\r\n                    <span class=\"font-weight-bold\">{{item.name}}</span><br />\r\n                    <span>{{item.addressLine1 + ', ' + addressLine2}}<br />\r\n                    {{item.city + ' ' + item.state + ', ' + item.country}}<br/>\r\n                    Phone: {{item.phoneNumber | telFormat}}</span><br />\r\n                    <a href=\"mailto:{{item.email}}\" class=\"blue-colored\">Email</a> | <a class=\"blue-colored\" href ng-click=\"locator.showHours(item.storeUrlName)\">Store Hours</a>\r\n                  </h5>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _subscription = __webpack_require__(234);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Subscription = (_dec = (0, _utils.Component)({
	  controllerAs: 'subscription',
	  template: _subscription2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Subscription($scope, $ngRedux, $spinner, $order, orderActions, $auth, $state, toaster, $stateParams, $window, APP) {
	    var _this = this;
	
	    _classCallCheck(this, Subscription);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.orderFetched = false;
	    this.$order = $order;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$state = $state;
	    this.$auth = $auth;
	    this.toaster = toaster;
	    this.cancelingSubscriptionID = "";
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	
	    /*
	        $ngRedux.dispatch(orderActions.setSubscriptions([]));
	    */
	    $spinner.show('appSpinner');
	    $order.getSubscriptions().finally(function () {
	      _this.orderFetched = true;
	      $spinner.hide('appSpinner');
	    });
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Subscription, [{
	    key: 'mapState',
	    value: function mapState(state) {
	
	      var subscription = "";
	      if (state.order.subscriptions.length > 0) {
	        subscription = state.order.subscriptions;
	      }
	
	      return {
	        profile: state.auth.profile,
	        recentOrder: subscription
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'ReOrder',
	    value: function ReOrder(orderId) {
	      var _this2 = this;
	
	      this.$order.reOrder(orderId).then(function (success) {
	        _this2.$auth.getUserProfile();
	        if (success.data.successCode === '200') {
	          _this2.$state.go('cart');
	        } else {
	          _this2.toaster.pop('success', 'There is a problem retrieving data. Please add order manually.');
	        }
	      }, function (error) {} // console.log(error)
	      ).finally(function () {} // console.log('error')
	      );
	    }
	  }, {
	    key: 'cancelSubscription',
	    value: function cancelSubscription(orderId) {
	      var _this3 = this;
	
	      this.cancelingSubscriptionID = "";
	      var ctrl = this;
	      // console.log('orderId--',orderId);
	      this.$order.cancelSubscription(orderId).then(function (success) {
	        if (success.data.successCode === '200') {
	          _this3.toaster.pop('success', 'The subscription is successfully cancelled');
	          var current = ctrl.$state.current;
	          var params = angular.copy(ctrl.$stateParams);
	          ctrl.$state.transitionTo(current, params, { reload: true, inherit: true, notify: true });
	        } else {
	          _this3.toaster.pop('success', 'There is a problem canacelling subscription. Please try again later');
	        }
	      }, function () {
	        _this3.toaster.pop('success', 'There is a problem canacelling subscription. Please try again later');
	      }).finally(function () {}
	      // console.log('error')
	      );
	    }
	  }, {
	    key: 'editSubscription',
	    value: function editSubscription(order) {
	
	      this.$auth.resetSubscriptionCart();
	      this.$auth.saveSubscriptionLocalState({});
	      this.$state.go('subscription-detail', { subscriptionId: order.id, option: 'edit' });
	    }
	  }, {
	    key: 'convertDate',
	    value: function convertDate(cdate) {
	      var date = new Date(cdate);
	      var month = date.getMonth() + 1;
	      var day = date.getDate();
	      var year = date.getFullYear();
	
	      if (month < 10) {
	        month = '0' + month.toString();
	      }
	      if (day < 10) {
	        day = '0' + day.toString();
	      }
	
	      cdate = day + '-' + month + '-' + year;
	
	      return cdate;
	    }
	  }]);
	
	  return Subscription;
	}(), _class2.$inject = ['$scope', '$ngRedux', 'spinnerService', 'orderService', 'orderActions', 'authService', '$state', 'toaster', 'APP', '$window', '$stateParams'], _temp)) || _class);
	exports.default = Subscription;

/***/ },
/* 234 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"subscription.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{subscription.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <span>My Subscription</span>\r\n  </nav>\r\n\r\n  <div class=\"row m-x-0 pt-4\">\r\n    <div class=\"col-xs-12 p-y-0 p-x-0 \" ng-repeat=\"order in subscription.recentOrder\">\r\n      <div class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin \" style=\"padding: 10px;vertical-align:middle;\">\r\n        <div  class=\"col-xs-12 col-sm-12 col-md-6 p-y-0 p-x-0\" style=\"vertical-align:middle;\">\r\n            <b>Subscribed  on {{order.startDate | date:'MMM d, y'}} with {{order.subscriptionInterval.weeksInterval}} Week<span ng-if=\"order.subscriptionInterval.weeksInterval>1\">s</span> frequency ({{order.invoiceNumber}})</b>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-12 col-md-6 p-y-0 p-x-0 pull-right rt-align\" style=\"vertical-align:middle;\">\r\n        <a ng-click=\"subscription.editSubscription(order)\" >\r\n          <button class=\"btn btn-primary\" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\" > <span ng-if=\"order.status\">Edit</span><span ng-if=\"!order.status\">Activate</span>&nbsp <span class=\"hidden-md-down\">Subscription</span> </button></a>\r\n          <button class=\"btn btn-primary\" ng-if=\"order.status\" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\" ng-click=\"subscription.cancelingSubscriptionID=order.id\">Cancel <span class=\"hidden-md-down\">Subscription</span></button>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row m-x-0\" >\r\n        <div class=\"row sub-header-bg m-x-0 p-y-1 cnfm_box\" ng-if=\"subscription.cancelingSubscriptionID==order.id\">\r\n          Are you sure want to cancel subscribe?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\n          <span class=\"hidden-md-up\"><br></span><button class=\"btn btn-primary  \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\" ng-click=\"subscription.cancelingSubscriptionID=''\">&nbsp;&nbsp;&nbsp;No&nbsp;&nbsp;&nbsp;</button>\r\n          &nbsp;&nbsp;<button class=\"btn btn-primary  \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\" ng-click=\"subscription.cancelSubscription(order.id)\">&nbsp;Yes&nbsp;</button>\r\n        </div>\r\n        <div class=\"media p-x-2 p-y-1 col-md-6 col-xs-12\" ng-repeat=\"item in order.subscriptionCart\">\r\n          <div class=\"media-left\" href=\"#\">\r\n            <img img-lazy-loader={{item.item.smallImageUrl}} class=\"media-object list-image-sm-media border-image rounded cursor-pointer\" alt=\" Product image\" height=\"75px\"\r\n                  />\r\n          </div>\r\n          <div class=\"media-body\">\r\n\r\n              <h4 class=\"media-heading\">{{item.item.name}}</h4>\r\n\r\n            <div>\r\n              Quantity: {{item.quantity}}\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"media p-x-2 p-b-1\" ng-if=\"order.status\">\r\n        <div ng-if=\"order.date_on_order_to_be_placed\">Next Order: {{order.date_on_order_to_be_placed | date:'MMM d, y' }}</div>\r\n        <div ng-if=\"order.date_on_last_order_placed\">Last Order: {{order.date_on_last_order_placed | date:'MMM d, y' }}</div>\r\n        \r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row p-t-3 m-x-0\" ng-if=\"subscription.orderFetched  && !subscription.recentOrder.length\">\r\n      <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n        <h5 class=\"font-weight-bold\">No  subscriptions found</h5>\r\n        <p class=\"m-t-1\">Subscribe the products in My Orders.</p>\r\n        <div class=\"m-t-3 p-t-3\">\r\n          <a class=\"btn btn-primary btn-block m-y-2\" ui-sref=\"recent-order\">Start New Subscription</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _birdFood = __webpack_require__(179);
	
	var _birdFood2 = _interopRequireDefault(_birdFood);
	
	var _search = __webpack_require__(147);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _subscriptionProduct = __webpack_require__(236);
	
	var _subscriptionProduct2 = _interopRequireDefault(_subscriptionProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Product = (_dec = (0, _utils.Component)({
	  controllerAs: 'product',
	  template: _subscriptionProduct2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function Product($scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP) {
	    var _this = this;
	
	    _classCallCheck(this, Product);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.birdFood = _birdFood2.default;
	    this.$state = $state;
	    this.$toaster = $toaster;
	    this.$auth = $auth;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	
	    this.APP = APP;
	
	    this.searchIcon = _search2.default;
	    $ngRedux.dispatch(orderActions.setProducts([]));
	    $spinner.show('appSpinner');
	    this.isCallingAPI = true;
	    $order.getSubcribableProducts('seed').finally(function () {
	      $spinner.hide('appSpinner');
	      _this.isCallingAPI = false;
	    });
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(Product, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        list: state.order.subscribableProducts
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'isCategorySubcatSame',
	    value: function isCategorySubcatSame() {
	      return this.list.length && this.list[0].itemList[0].masterProduct.subCategories[0].name === this.list[0].itemList[0].masterProduct.subCategories[0].category.name;
	    }
	
	    // parent is subcategory or category depending on subcategory existance
	
	  }, {
	    key: 'getParentDetails',
	    value: function getParentDetails() {
	      if (this.isCategorySubcatSame()) {
	        return this.list[0].itemList[0].masterProduct.subCategories[0].category;
	      } else {
	        return this.list.length && this.list[0].itemList[0].masterProduct.subCategories[0];
	      }
	    }
	  }, {
	    key: 'goToDSCDetailPage',
	    value: function goToDSCDetailPage() {
	      //  console.log('goToDSCDetailPage');
	      this.$state.go('savings-club');
	    }
	  }, {
	    key: 'goToSubscriptionDetail',
	    value: function goToSubscriptionDetail() {
	      var subScribedInfo = this.$auth.getSubscribedInfo();
	      if (subScribedInfo) {
	        this.$state.go('subscription-detail', { subscriptionId: subScribedInfo.id, option: subScribedInfo.option });
	      }
	    }
	  }, {
	    key: 'goToProductPage',
	    value: function goToProductPage(item) {
	
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      // let storeName =  false;
	      if (storeName) {
	        this.$state.go('product.detail', {
	          categoryId: item.masterProduct.category.prettyUrl,
	          subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
	          productId: item.masterProduct.prettyUrl,
	          itemGroupNumber: item.masterProduct.itemGroupNumber,
	          storeName: storeName,
	          forSubscription: true
	        });
	      } else {
	        this.$state.go('browse-product.detail', {
	          categoryId: item.masterProduct.category.prettyUrl,
	          subCategoryId: item.masterProduct.subCategories[0].prettyUrl,
	          productId: item.masterProduct.prettyUrl,
	          itemGroupNumber: item.masterProduct.itemGroupNumber,
	          forSubscription: true
	        });
	      }
	    }
	  }]);
	
	  return Product;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$stateParams', '$state', 'toaster', 'orderService', 'spinnerService', 'orderActions', 'authService', '$window', 'APP'], _temp)) || _class);
	exports.default = Product;

/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"product.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{product.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\"\r\n\r\n      ui-sref=\"subscription\">\r\n     My Subscriptions\r\n    </a>\r\n    <a class=\"nav\"\r\n        href\r\n       ng-click=\"product.goToSubscriptionDetail()\">\r\n      My Subscription Detail\r\n    </a>\r\n    <span>List of Products</span>\r\n  </nav>\r\n\r\n  <div class=\"row p-t-2 m-x-0 hidden-md-up\">\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <div class=\"col-xs-12 col-md-6 p-y-1\" style=\"vertical-align:middle;\">\r\n        <h4 class=\"font-weight-bold p-b-1 p-x-2\"\r\n        >List of Products</h4></div>\r\n      <div class=\"col-xs-12 col-md-6 p-y-1 ng-binding\" style=\"margin-top: 11px; background: #eceeef;padding: 5px;\">\r\n        <span class=\"input-group\" style=\"text-align: center;\">\r\n            <input type=\"text\" ng-model=\"product.search\" placeholder=\"search\" class=\"form-control\" style=\"background: #FFFFFF;height: 40px;\">\r\n            <span class=\"input-group-btn\">\r\n\r\n                <img src={{product.searchIcon}} style=\"height: 36px;padding: 8px\">\r\n\r\n            </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n    \r\n  <div class=\"row p-t-2 p-x-2 m-x-0 hidden-sm-down\">\r\n    <!-- Product Details -->\r\n\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <div class=\"col-xs-12 col-md-6 p-y-1\" style=\"vertical-align:middle;\">\r\n      <h4 class=\"font-weight-bold p-b-1 p-x-2\"\r\n       >List of Products</h4></div>\r\n      <div class=\"col-sm-3 offset-sm-1 col-md-3 offset-md-3 hidden-sm-down\" style=\"margin-top: 11px; background: #eceeef;padding: 5px;\">\r\n          <span class=\"input-group\" style=\"text-align: center;\">\r\n            <input type=\"text\" ng-model=\"product.search\" placeholder=\"search\" class=\"form-control\" style=\"background: #FFFFFF;height: 40px;\">\r\n            <span class=\"input-group-btn\">\r\n\r\n                <img src={{product.searchIcon}} style=\"height: 36px;padding: 8px\">\r\n\r\n            </span>\r\n          </span>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Large device sub category details -->\r\n  <div class=\"row hidden-sm-down p-x-2 p-b-1 m-x-0\">\r\n    <!-- <div class=\"col-md-6 p-x-2 text-xs-center\">\r\n      <img class=\"product-image\" ng-if=\"product.list[0].itemList\" img-lazy-loader={{product.getParentDetails().largeImageUrl}}>\r\n    </div> -->\r\n    <div class=\"col-md-12 p-x-2 text-xs-left\">\r\n      <p class=\"lead\" ng-bind=\"product.getParentDetails().description\"></p>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- small device sub category details -->\r\n  <div class=\"row m-x-0 hidden-md-up\" ng-if=\"product.getParentDetails().description\">\r\n    <div class=\"col-xs-12 p-x-1\">\r\n      <p ng-bind=\"product.getParentDetails().description\"></p>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0\">\r\n\r\n    <!-- creates list view of products in xs devices -->\r\n    <div class=\"col-xs-12 p-x-0\">\r\n      <div class=\"list-group list-container hidden-md-up\" ng-repeat=\"item in product.list | filter:product.search\">\r\n        <a ng-click=\"product.goToProductPage(item.itemList[0])\"\r\n                 class=\"list-group-item list-group-item-action media\" ng-if=\"item.itemList[0].masterProduct.masterCode != 88888888\">\r\n          <div class=\"media-left\">\r\n            <img img-lazy-loader={{item.itemList[0].smallImageUrl}} class=\"media-object\" style=\"max-width: 60px\" />\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <h4 class=\"media-heading\" ng-bind=\"item.name\"></h4>\r\n            <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n          </div>\r\n          <div class=\"media-right\">\r\n            <img src={{product.homeArrow}} class=\"sub-category-icon-arr\" />\r\n          </div>\r\n        </a>\r\n         <button class=\"hidden-btn list-group-item list-group-item-action media\" ng-click=\"product.goToDSCDetailPage()\" ng-if=\"item.itemList[0].masterProduct.masterCode == 88888888\">\r\n          <div class=\"media-left\">\r\n            <img img-lazy-loader={{item.itemList[0].smallImageUrl}} class=\"media-object\" style=\"max-width: 60px\" />\r\n          </div>\r\n          <div class=\"media-body\">\r\n            <h4 class=\"media-heading\" ng-bind=\"item.name\"></h4>\r\n            <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n          </div>\r\n          <div class=\"media-right\">\r\n            <img src={{product.homeArrow}} class=\"sub-category-icon-arr\" />\r\n          </div>\r\n        </button>\r\n      </div>\r\n      <div class=\"list-group list-container hidden-md-up\" style=\"text-align:center\">\r\n      <h6 ng-if=\"(product.list | filter:product.search).length==0 && !product.isCallingAPI\">No Results found</h6>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div id=\"tiles\" class=\"row p-x-2 m-x-0 hidden-sm-down\">\r\n    <!-- creates normal expanded view on md devices -->\r\n    <div class=\"col-md-3 category-item\"\r\n      ng-repeat=\"item in product.list | filter:product.search\">\r\n      <a ng-click=\"product.goToProductPage(item.itemList[0])\"  ng-if=\"item.itemList[0].masterProduct.masterCode != 88888888\">\r\n        <img img-lazy-loader={{item.itemList[0].largeImageUrl}} alt=\"image\" class=\"product-thumbnail subcat-rounded\"/>\r\n        <h6 class=\"sub-category-text m-b-0\" ng-bind=\"item.name\"></h6>\r\n        <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n      </a>\r\n       <button class=\"hidden-btn\" ng-click=\"product.goToDSCDetailPage()\" ng-if=\"item.itemList[0].masterProduct.masterCode == 88888888\">\r\n        <img img-lazy-loader={{item.itemList[0].largeImageUrl}} alt=\"image\" class=\"product-thumbnail subcat-rounded\" />\r\n        <h6 class=\"sub-category-text m-b-0\" ng-bind=\"item.name\"></h6>\r\n        <p class=\"gray-text m-b-0\">{{item.itemList[0].briefDescription}}</p>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div id=\"tiles2\" class=\"row p-x-2 m-x-0 hidden-sm-down p-y-1\" style=\"text-align:center\">\r\n  <h6 ng-if=\"(product.list | filter:product.search).length==0 && !product.isCallingAPI\">No Results found</h6>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* File: detail.js
	                                   ------------------
	                                   This file does calculations and api calls for detail.html template.
	                                   Important assumptions are noted here for reference.
	                                   * Weight field in template is assumed that
	                                    1 - it would be only 8 char long only.
	                                    2 - it would not be null
	                                    3 - 8th char should not be zero.
	                                  
	                                    if all 3 conditions are met then only weight element will be shown on consumer app. This validation is
	                                    not done at the backoffice app.
	                                  */
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _productDetail = __webpack_require__(238);
	
	var _productDetail2 = _interopRequireDefault(_productDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductsDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'productsDetail',
	  template: _productDetail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function ProductsDetail($rootScope, $scope, $ngRedux, $state, $stateParams, $auth, $order, orderActions, $spinner, toaster, $uibModal, $timeout, $window, APP) {
	    var _this = this;
	
	    _classCallCheck(this, ProductsDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = $auth;
	    this.$order = $order;
	    this.toaster = toaster;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$uibModal = $uibModal;
	
	    this.$window = $window;
	    this.APP = APP;
	
	    this.selectedItem = {};
	    this.isItemAdded = false;
	    this.guestCart = this.$auth.getGuestCart();
	    var isLoggedIn = this.$auth.isLoggedIn();
	    // console.log(isLoggedIn);
	    this.checkForGuestCart();
	    $rootScope.$on('onLoginSuccess', function () {
	      _this.checkForGuestCart();
	    });
	
	    $ngRedux.dispatch(orderActions.setProductDetail({}));
	    $spinner.show('appSpinner');
	    $order.getProducts("1").then(function (success) {
	      var productAvailable = success.data.filter(function (product) {
	        var idArray = product.itemList.filter(function (item) {
	          return item.masterProduct.id === parseInt($stateParams.subsProductId);
	        });
	        return idArray.length ? true : false;
	      }).length;
	      //  console.log('success data', success.data);
	      //  console.log('productAvailable', productAvailable);
	      //  console.log('paramid', $stateParams.productId);
	      if (success.data[0] === null) {
	        _this.productNotFound = true;
	        // this.toaster.pop('success', 'You are trying to access wrong Sub-Category.');
	        // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
	      }
	      if (!productAvailable) {
	        _this.productNotFound = true;
	        // this.toaster.pop('success', 'Product is not available');
	        // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
	      }
	      if ($stateParams.productId) {
	        var productDetail = success.data.filter(function (item) {
	          return item.itemList.filter(function (itemVariety) {
	            return itemVariety.id === parseInt($stateParams.productId);
	          })[0];
	        })[0];
	
	        var largestWeight = 0;
	        var largestWeightItem = productDetail.itemList[0];
	        if (largestWeightItem.weight) {
	          for (var i = 0; i < productDetail.itemList.length; i++) {
	            if (productDetail.itemList[i].weight > largestWeight) {
	              largestWeightItem = productDetail.itemList[i];
	              largestWeight = productDetail.itemList[i].weight;
	            }
	          }
	        }
	        if (!productDetail) {
	          _this.productNotFound = true;
	          // this.toaster.pop('success', 'You are trying to access wrong Product Details.');
	          //  this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
	          return;
	        }
	        _this.selectedItem = largestWeightItem;
	        $ngRedux.dispatch(orderActions.setProductDetail(productDetail));
	      }
	    }).finally(function () {
	      return $spinner.hide('appSpinner');
	    });
	    this.currencyType = 'USD';
	    $timeout(function () {
	      _this.country = _this.profile.store.country.countryCode ? _this.profile.store.country.countryCode : 'US';
	
	      if (_this.profile.store) {
	        // console.log(this.profile);
	        _this.currencyType = $order.getCurrencyType(_this.country);
	      }
	    }, 800);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(ProductsDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        detail: state.order.productDetail
	      };
	    }
	  }, {
	    key: 'addItemToCart',
	    value: function addItemToCart(form) {
	
	      if (form.$invalid) {
	        return;
	      }
	      if (this.$auth.isGuestLogin()) {
	        var cart = null;
	        cart = { 'quantity': this.quantity, 'itemId': this.selectedItem.id, 'categoryId': this.$stateParams.categoryId, 'subCategoryId': this.$stateParams.subCategoryId, 'masterProductId': this.selectedItem.masterProduct.id };
	        this.$auth.addtoGuestCart(cart);
	        var $ctrl = this;
	        var $state = this.$state;
	        this.$uibModal.open({
	          size: 'sm',
	          template: '<div class="modal-body p-1-1 login_redirect_modal" id="modal-body" >You have to login/register to  add this item to cart<hr>' + '<h6><b><center>Do you want to continue?</center></b></h6>' + '</div>' + '<div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()" >Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" ">OK</button>' + '</div>',
	          controller: ['$scope', '$uibModalInstance', 'authService', function ($scope, $uibModalInstance, $auth, $cookies) {
	            $scope.ok = function () {
	              $state.go('login', { 'storeName': $auth.getGuestStoreDetail().storeName });
	              $uibModalInstance.close();
	            };
	            $scope.cancel = function () {
	              try {
	                sessionStorage.removeItem('guestCart');
	              } catch (e) {
	                $cookies.remove('guestCart');
	              }
	              $uibModalInstance.close();
	            };
	          }],
	          resolve: {
	            id: function id() {
	              return $ctrl.id;
	            }
	          }
	        });
	      } else {
	        this.addToCart(this.quantity, this.selectedItem.id);
	      }
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(quantity, itemId) {
	      var _this2 = this;
	
	      this.disableAddToCart = true;
	
	      this.$order.addItemToCart(quantity, itemId).then(function () {
	        _this2.isItemAdded = true;
	        _this2.toaster.pop('success', 'Item added to cart');
	        _this2.$auth.getUserProfile();
	      }, function () {
	        return _this2.toaster.pop('success', 'Item already exists in cart. Click on cart icon on top right.');
	      }).finally(function () {
	        _this2.disableAddToCart = false;
	        if (_this2.guestCart) {
	          _this2.$auth.doGuestLogout();
	        }
	      });
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'buyNow',
	    value: function buyNow(form) {
	      var _this3 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      this.$order.addItemToCart(this.quantity, this.selectedItem.id).finally(function () {
	        return _this3.$state.go('cart');
	      });
	    }
	  }, {
	    key: 'selectWeight',
	    value: function selectWeight(item) {
	      this.selectedItem = item;
	      this.isItemAdded = false;
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'masterCodeChecker',
	    value: function masterCodeChecker(item) {
	      return item.masterProduct.masterCode && (item.masterProduct.masterCode.length === 8 || item.masterProduct.masterCode.length === 9) && item.masterProduct.masterCode[7] !== '0' && item.weight !== null;
	    }
	  }, {
	    key: 'checkForGuestCart',
	    value: function checkForGuestCart() {
	      if (this.guestCart && this.$auth.isLoggedIn()) {
	        this.addToCart(this.guestCart.quantity, this.guestCart.itemId);
	      }
	    }
	  }, {
	    key: 'goToCart',
	    value: function goToCart() {
	      if (this.$auth.isGuestLogin()) {
	        this.$state.go('guestcart', { 'storeName': this.storeName });
	      } else {
	        this.$state.go('cart');
	      }
	    }
	  }]);
	
	  return ProductsDetail;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$state', '$stateParams', 'authService', 'orderService', 'orderActions', 'spinnerService', 'toaster', '$uibModal', '$timeout', '$window', 'APP'], _temp)) || _class);
	exports.default = ProductsDetail;

/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n  <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n  <!--breadcrum section -->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"productsDetail.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{productsDetail.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a class=\"nav\"\r\n      ng-if=\"productsDetail.detail.itemList[0].subCategory.category.name !== productsDetail.detail.itemList[0].subCategory.name\"\r\n      ui-sref=\"sub-category({categoryId: productsDetail.detail.itemList[0].subCategory.category.id})\">\r\n      {{productsDetail.detail.itemList[0].subCategory.category.name}}\r\n    </a>\r\n    <a class=\"nav\" ui-sref=\"product({subCategoryId: productsDetail.detail.itemList[0].subCategory.id})\">\r\n      {{productsDetail.detail.itemList[0].subCategory.name}}\r\n    </a>\r\n    <span>{{productsDetail.detail.name}}</span>\r\n  </nav>\r\n\r\n  <form ng-if=\"productsDetail.selectedItem.id\"\r\n    name=\"productsDetailForm\"\r\n    autocomplete=\"off\"\r\n    novalidate>\r\n\r\n    <!-- Product name at top in MD devices -->\r\n    <div class=\"row m-x-1 p-a-1 hidden-sm-down\">\r\n      <h5 class=\"font-weight-bold m-t-1 \"\r\n        ng-bind=\"productsDetail.detail.name\"></h5>\r\n    </div>\r\n\r\n    <div class=\"row m-x-0\">\r\n      <!-- Product details column -->\r\n      <div class=\"col-xs-12 col-md-6 p-x-2-md\">\r\n        <div class=\"text-xs-center m-y-1\">\r\n          <img src={{productsDetail.selectedItem.largeImageUrl}}\r\n            class=\"product-image img-fluid\" />\r\n        </div>\r\n        <h5 class=\"font-weight-bold m-t-1 hidden-md-up\"\r\n          ng-bind=\"productsDetail.detail.name\"></h5>\r\n        <p ng-bind=\"productsDetail.selectedItem.description\" class=\"p-t-2 prod-detail-desc hidden-sm-down\"></p>\r\n        <p ng-bind=\"productsDetail.selectedItem.description\" class=\"hidden-md-up\"></p>\r\n      </div>\r\n\r\n      <!-- Quantity Details on SM, XS devices-->\r\n      <div class=\"col-xs-12 hidden-md-up p-x-0-xs p-x-2-md\">\r\n        <!--Quantity manipulation column -->\r\n        <div class=\"col-xs-12 p-x-0 p-y-1 bag-detail-bg\">\r\n\r\n          <!-- Bag Weight -->\r\n          <div class=\"col-xs-6\">\r\n            <p class=\"product-text\" \r\n            ng-if=\"productsDetail.filteredList.length && productsDetail.filteredList.length == 1\">Weight</p>\r\n            <p class=\"product-text\" \r\n            ng-if=\"productsDetail.filteredList.length && productsDetail.filteredList.length > 1\"> Select Weight</p>\r\n            <span class=\"tag product-weight\"\r\n              ng-class=\"item.id === productsDetail.selectedItem.id ? 'tag-primary-updated' : 'tag-default-updated'\"\r\n              ng-repeat=\"item in productsDetail.filteredList = (productsDetail.detail.itemList | filter: productsDetail.masterCodeChecker | orderBy: 'weight')\"\r\n              ng-click=\"productsDetail.selectWeight(item)\">\r\n              {{item.weight}}\r\n              <span class=\"lb-text\">lbs</span>\r\n            </span>\r\n          </div>\r\n\r\n          <!-- Quantity -->\r\n          <div class=\"col-xs-6 col-sm-3 pull-xs-right\"\r\n            ng-class=\"{'has-danger': (productsDetailForm.$submitted || productsDetailForm.quantity.$touched) && productsDetailForm.quantity.$invalid}\">\r\n            <p class=\"product-text\">Quantity</p>\r\n            <div class=\"input-group\" style=\"min-width:100px;\">\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  ng-disabled=\"productsDetail.quantity < 2\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"productsDetail.quantity = productsDetail.quantity - 1\">&#150;</button>\r\n              </span>\r\n              <input name=\"quantity\" disabled\r\n                type=\"number\"\r\n                class=\"form-control counter-input\"\r\n                ng-init=\"productsDetail.quantity = 1\"\r\n                ng-model=\"productsDetail.quantity\"\r\n                ng-min=\"1\" ng-max=\"999999\" />\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"productsDetail.quantity = productsDetail.quantity + 1\">+</button>\r\n              </span>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n        \r\n          <!--Regular Dimensions  -->\r\n          <div ng-if=\"productsDetail.selectedItem.productDimensions\">\r\n            <div class=\"col-xs-12\">\r\n              style=\"margin-bottom: 1rem !important; display: inline-flex;\">Dimensions:\r\n              <div style=\"padding-left: 15px !important;\">\r\n                {{productDetail.selectedItem.masterProduct.dimensions}}</div>\r\n            </h6>\r\n          </div>\r\n          </div>\r\n        <!-- Price section if not DSC -->\r\n        <div class=\"col-xs-12 p-x-0 p-y-1 mb-40\" ng-if=\"!productsDetail.selectedItem.subCategory.category.dscCategory\">\r\n          \r\n          <div class=\"col-xs-6\">\r\n            <h6 >Regular Price</h6>\r\n            <h5 class=\"font-weight-bold\">\r\n              {{productsDetail.currencyType}} $ {{productsDetail.selectedItem.price | number : 2}}\r\n            </h5>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Price and DSC section if DSC -->\r\n        <div class=\"col-xs-12 p-x-0 p-y-1 mb-40\" ng-if=\"productsDetail.selectedItem.subCategory.category.dscCategory\">\r\n          <!--Regular price if DSC -->\r\n          <div class=\"col-xs-6\">\r\n            <h6 >Regular Price</h6>\r\n            <h5 class=\"font-weight-bold\">\r\n              <span ng-if=\"!productsDetail.isDscMember()\">{{productsDetail.currencyType}} $ {{productsDetail.selectedItem.price | number : 2}}</span>\r\n              <strike ng-if=\"productsDetail.isDscMember()\">{{productsDetail.currencyType}} $ {{productsDetail.selectedItem.price | number : 2}}</strike>\r\n            </h5>\r\n          </div>\r\n          <!-- DSC Price -->\r\n          <div class=\"col-xs-6 text-xs-right p-l-0\" ng-if=\"productsDetail.selectedItem.subCategory.category.dscCategory\">\r\n            <h6>Daily Savings Club Price</h6>\r\n            <h5 class=\"font-weight-bold\" ng-if=\"productsDetail.selectedItem.price\">\r\n              {{productsDetail.currencyType}} $ {{(productsDetail.selectedItem.price * 85 / 100) | number : 2}}\r\n            </h5>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Quantity Manipulation on Large Devices -->\r\n      <div class=\"col-xs-12 col-md-6 hidden-sm-down p-x-0-xs p-x-2-md\">\r\n\r\n\r\n        <!-- Regular Price and Quantity if not DSC -->\r\n        <div class=\"col-xs-12 p-x-0 bag-detail-bg\" ng-if=\"!productsDetail.selectedItem.subCategory.category.dscCategory\">\r\n\r\n          <!--Regular Price if not DSC -->\r\n          <div class=\"col-xs-6 p-t-2\">\r\n            <h6>Regular Price</h6>\r\n            <h5 class=\" font-weight-bold\">\r\n              {{productsDetail.currencyType}} $ {{productsDetail.selectedItem.price | number : 2}}\r\n            </h5>\r\n          </div>\r\n\r\n          <!-- Quantity -->\r\n          <div class=\"col-xs-6 col-sm-4 p-t-1\"\r\n            ng-class=\"{'has-danger': (productsDetailForm.$submitted || productsDetailForm.quantity.$touched) && productsDetailForm.quantity.$invalid}\">\r\n            <p class=\"product-text-md\">Quantity</p>\r\n            <div class=\"input-group\" style=\"min-width:100px;\">\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  ng-disabled=\"productsDetail.quantity < 2\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"productsDetail.quantity = productsDetail.quantity - 1\">&#150;</button>\r\n              </span>\r\n              <input name=\"quantity\" disabled\r\n                type=\"number\"\r\n                class=\"form-control counter-input\"\r\n                ng-init=\"productsDetail.quantity = 1\"\r\n                ng-model=\"productsDetail.quantity\"\r\n                ng-min=\"1\" ng-max=\"999999\" />\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"productsDetail.quantity = productsDetail.quantity + 1\">+</button>\r\n              </span>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <!-- Regular Price and Quantity if DSC -->\r\n        <div class=\"col-xs-12 p-x-0 bag-detail-bg\" ng-if=\"productsDetail.selectedItem.subCategory.category.dscCategory\">\r\n          <!--Regular price if DSC -->\r\n          <div class=\"col-xs-6 p-t-2\">\r\n            <h6 >Regular Price</h6>\r\n            <h5 class=\" font-weight-bold\">\r\n              <span ng-if=\"!productsDetail.isDscMember()\">{{productsDetail.currencyType}} $ {{productsDetail.selectedItem.price | number : 2}}</span>\r\n              <strike ng-if=\"productsDetail.isDscMember()\">{{productsDetail.currencyType}} $ {{productsDetail.selectedItem.price | number : 2}}</strike>\r\n            </h5>\r\n          </div>\r\n\r\n          <!-- Quantity -->\r\n          <div class=\"col-xs-6 col-sm-4 p-t-1\"\r\n            ng-class=\"{'has-danger': (productsDetailForm.$submitted || productsDetailForm.quantity.$touched) && productsDetailForm.quantity.$invalid}\">\r\n            <p class=\"product-text-md\">Quantity</p>\r\n            <div class=\"input-group\" style=\"min-width:100px;\">\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  ng-disabled=\"productsDetail.quantity < 2\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"productsDetail.quantity = productsDetail.quantity - 1\">&#150;</button>\r\n              </span>\r\n              <input name=\"quantity\" disabled\r\n                type=\"number\"\r\n                class=\"form-control counter-input\"\r\n                ng-init=\"productsDetail.quantity = 1\"\r\n                ng-model=\"productsDetail.quantity\"\r\n                ng-min=\"1\" ng-max=\"999999\" />\r\n              <span class=\"input-group-btn\">\r\n                <button type=\"button\"\r\n                  class=\"btn btn-primary counter-btn\"\r\n                  ng-click=\"productsDetail.quantity = productsDetail.quantity + 1\">+</button>\r\n              </span>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <!-- DSC and Bag Weight -->\r\n        <div class=\"col-xs-12 p-x-0 p-b-1 mb-40\">\r\n          <!-- DSC Price if exists -->\r\n          <div class=\"col-xs-6 text-xs-left\"\r\n          ng-if=\"productsDetail.selectedItem.subCategory.category.dscCategory\">\r\n            <h6>Daily Savings Club Price</h6>\r\n            <h5 class=\"font-weight-bold\" ng-if=\"productsDetail.selectedItem.price\">\r\n              {{productsDetail.currencyType}} $ {{(productsDetail.selectedItem.price * 85 / 100) | number : 2}}\r\n            </h5>\r\n          </div>\r\n          <!-- Bag Weight -->\r\n          <div class=\"col-xs-12 col-sm-12 p-l-0 p-r-0\"\r\n            ng-if=\"productsDetail.filteredList.length\">\r\n            <p class=\"product-text-md\"\r\n            ng-if=\"productsDetail.filteredList.length && productsDetail.filteredList.length == 1\">Weight</p>\r\n            <p class=\"product-text-md\"\r\n            ng-if=\"productsDetail.filteredList.length && productsDetail.filteredList.length > 1\">Select Weight</p>\r\n            <span class=\"tag product-weight\"\r\n              ng-class=\"item.id === productsDetail.selectedItem.id ? 'tag-primary-updated' : 'tag-default-updated'\"\r\n              ng-repeat=\"item in productsDetail.filteredList = (productsDetail.detail.itemList | filter: productsDetail.masterCodeChecker | orderBy: 'weight')\"\r\n              ng-click=\"productsDetail.selectWeight(item)\">\r\n              {{item.weight}}\r\n              <span class=\"lb-text\">lbs</span>\r\n            </span>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <!-- Buttons on Large Devices-->\r\n        <div class=\"row p-x-0 m-x-0 hidden-sm-down\">\r\n          <!-- <div class=\"col-md-8 offset-md-2 m-y-1\">\r\n            <button type=\"button\"\r\n              ng-click=\"productsDetail.buyNow(productsDetailForm)\"\r\n              class=\"btn btn-lg btn-primary btn-block btn-md-text\">BUY NOW</button>\r\n          </div> -->\r\n          <div class=\"col-md-8 offset-md-2\">\r\n            <button type=\"button\"\r\n              class=\"btn btn-lg btn-primary btn-bdr btn-block btn-md-text\"\r\n              ng-disabled=\"productsDetail.disableAddToCart\"\r\n              ng-if=\"!productsDetail.isItemAdded\"\r\n              ng-click=\"productsDetail.addItemToCart(productsDetailForm)\">ADD TO CART\r\n            </button>\r\n            <button type=\"button\"\r\n               ng-click=\"productsDetail.goToCart()\"\r\n              class=\"btn btn-lg btn-primary btn-bdr btn-block btn-md-text\"\r\n              ng-if=\"productsDetail.isItemAdded\">GO TO CART</button>\r\n          </div>\r\n          <div class=\"col-md-8 offset-md-2 mt-4\">\r\n            <a ui-sref=\"category\">\r\n              <button type=\"button\" class=\"btn btn-lg btn-primary btn-block btn-md-text\">KEEP SHOPPING</button>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <!-- Buttons on SM, XS devices -->\r\n    <div class=\"row m-x-0 p-x-0 btn-product-detail hidden-md-up\">\r\n      <div class=\"col-xs-6 p-x-0\">\r\n        <button type=\"button\"\r\n          class=\"btn btn-lg btn-primary btn-bdr btn-block\"\r\n          ng-disabled=\"productsDetail.disableAddToCart\"\r\n          ng-if=\"!productsDetail.isItemAdded\"\r\n          ng-click=\"productsDetail.addItemToCart(productsDetailForm)\">ADD TO CART\r\n        </button>\r\n        <button type=\"button\"\r\n           ng-click=\"productsDetail.goToCart()\"\r\n          class=\"btn btn-lg btn-primary btn-bdr btn-block\"\r\n          ng-if=\"productsDetail.isItemAdded\">GO TO CART</button>\r\n      </div>\r\n      <div class=\"col-xs-6 p-x-0\">\r\n        <a ui-sref=\"category\">\r\n          <button type=\"button\" class=\"btn btn-lg btn-primary btn-block btn-md-text\">KEEP SHOPPING</button>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n"

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _subscriptionDetail = __webpack_require__(240);
	
	var _subscriptionDetail2 = _interopRequireDefault(_subscriptionDetail);
	
	var _close = __webpack_require__(200);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _up = __webpack_require__(184);
	
	var _up2 = _interopRequireDefault(_up);
	
	var _down = __webpack_require__(241);
	
	var _down2 = _interopRequireDefault(_down);
	
	var _alert = __webpack_require__(192);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _shippingInfo = __webpack_require__(201);
	
	var _shippingInfo2 = _interopRequireDefault(_shippingInfo);
	
	var _shippingTick = __webpack_require__(195);
	
	var _shippingTick2 = _interopRequireDefault(_shippingTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SubscriptionDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'subscriptionDetail', template: _subscriptionDetail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function SubscriptionDetail($scope, $ngRedux, $spinner, $auth, $order, $state, $uibModal, $stateParams, $q, toaster, $anchorScroll, $location, $window, APP) {
	    var _this = this;
	
	    _classCallCheck(this, SubscriptionDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.dscMasterCode = '88888888'; // Named constant
	    this.$auth = $auth;
	    this.$state = $state;
	    this.$order = $order;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.closeIcon = _close2.default;
	    this.upIcon = _up2.default;
	    this.downIcon = _down2.default;
	    this.alertIcon = _alert2.default;
	    this.shippingOffer = {};
	    this.min = new Date();
	    this.shippingOffer.isOfferAvailable = false;
	    this.shippingOffer.isOfferEligible = false;
	    this.$stateParams = $stateParams;
	    this.shippingOffer.thresholdAmount = 1500;
	    this.shippingOfferInfoIcon = _shippingInfo2.default;
	    this.shippingOfferAvailableIcon = _shippingTick2.default;
	    this.cardId = "1";
	    this.selectedFrequency = {};
	    this.subStartDate = new Date();
	    this.subMindate = "08-08-2017";
	    this.$spinner = $spinner;
	    this.toaster = toaster;
	    this.freeShipping = {};
	    this.subscriptionStatus = true;
	    this.rateZoneRetryCount = 0;
	    this.notDeliverable = false;
	    // console.log(this.detail);
	
	    this.$location = $location;
	    this.$anchorScroll = $anchorScroll;
	    this.$uibModal = $uibModal;
	    $spinner.show('appSpinner');
	    this.actionOption = $stateParams.option;
	    var ctrl = this;
	    this.subcriptionItemList = [];
	    this.addressDetail = {};
	    var userPromise = void 0,
	        cartPromise = null;
	    this.userShipingZonePromise = null;
	    this.$order.getSubscriptionConfig();
	
	    this.$window = $window;
	
	    this.APP = APP;
	
	    // angular.element(document.querySelectorAll('#tab-1')).trigger('click');
	    // angular.element('#tab-1').trigger('click');
	
	    userPromise = this.$auth.getUserProfile().then(function (success) {
	
	      var addressObj = localStorage.getItem('deliveryAddress');
	      _this.addressDetail = addressObj ? JSON.parse(addressObj) : success.data;
	      if (!_this.addressDetail.firstName) {
	        _this.addressDetail.firstName = _this.addressDetail.customer.firstName;
	        _this.addressDetail.lastName = _this.addressDetail.customer.lastName;
	      }
	      _this.calculateDeliveryOption();
	    });
	    if (this.$stateParams.option === 'add') {
	      var items = ctrl.$auth.getSubscribedItems();
	      if (items.length === 0) {
	        cartPromise = $order.getOrderSummary($stateParams.subscriptionId).finally(function () {
	          $spinner.hide('appSpinner');
	          ctrl.subcriptionItemList = ctrl.summaryDetail.orderEntries;
	          ctrl.freeShipping = ctrl.summaryDetail.freeshipping;
	          ctrl.summaryDetail.orderEntries.forEach(function (entry) {
	            ctrl.$auth.addToSubscriptionCart(entry.item, entry.quantity);
	          });
	        });
	      } else {
	        cartPromise = $order.getOrderSummary($stateParams.subscriptionId).finally(function () {
	          $spinner.hide('appSpinner');
	          ctrl.freeShipping = ctrl.summaryDetail.freeshipping;
	          var localState = ctrl.$auth.getSubscriptionLocalState();
	          ctrl.renderLocalState(localState);
	        });
	        this.subcriptionItemList = items.concat(this.subcriptionItemList);
	      }
	    } else {
	      //   Edit part
	      items = ctrl.$auth.getSubscribedItems();
	      if (items.length === 0) {
	        cartPromise = $order.getSubscriptionsDetail($stateParams.subscriptionId).finally(function () {
	          $spinner.hide('appSpinner');
	          ctrl.subcriptionItemList = ctrl.subscriptionDetail.subscriptionCart;
	          if (ctrl.subscriptionDetail.status) {
	            ctrl.subStartDate = new Date(ctrl.subscriptionDetail.startDate);
	          }
	          ctrl.freeShipping = ctrl.subscriptionDetail.freeshipping;
	          ctrl.detail = ctrl.subscriptionDetail;
	          ctrl.subscriptionStatus = ctrl.subscriptionDetail.status;
	          ctrl.subcriptionItemList.forEach(function (entry) {
	            ctrl.$auth.addToSubscriptionCart(entry.item, entry.quantity);
	          });
	          ctrl.cardId = ctrl.subscriptionDetail.userCard;
	          ctrl.selectedFrequency = ctrl.detail.subscriptionInterval;
	          ctrl.saveLocalState();
	        });
	      } else {
	        cartPromise = $order.getSubscriptionsDetail($stateParams.subscriptionId).finally(function () {
	          $spinner.hide('appSpinner');
	          if (ctrl.subscriptionDetail.status) {
	            ctrl.subStartDate = new Date(ctrl.subscriptionDetail.startDate);
	          }
	          ctrl.freeShipping = ctrl.summaryDetail.freeshipping;
	          var localState = ctrl.$auth.getSubscriptionLocalState();
	          ctrl.renderLocalState(localState);
	        });
	        ctrl.subcriptionItemList = items.concat(ctrl.subcriptionItemList);
	      }
	    }
	    if (cartPromise && userPromise) {
	      var promises = [cartPromise, userPromise, this.userShipingZonePromise];
	      $q.all(promises).then(function () {
	        return _this.getTax();
	      }).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    }
	    if (!cartPromise) {
	      var _promises = [userPromise, this.userShipingZonePromise];
	      $q.all(_promises).then(function () {
	        return _this.getTax();
	      }).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    }
	    /* let orderSummaryPromise = $order.getOrderSummary($stateParams.subscriptionId);*/
	    $order.getAvailableSubscriptionsInterval().finally(function () {
	      if (!ctrl.selectedFrequency) {
	        ctrl.selectedFrequency = ctrl.availableSubscriptionInterval[0];
	      }
	      $spinner.hide('appSpinner');
	    });
	
	    $order.getPaymentInfo().then(function (success) {
	      if (_this.$stateParams.option === 'add') {
	        _this.cardId = success.data[0];
	      } else {
	        var localState = ctrl.$auth.getSubscriptionLocalState();
	        ctrl.renderLocalState(localState);
	        _this.cardId = ctrl.subscriptionDetail.userCard;
	        _this.saveLocalState();
	        localState = ctrl.$auth.getSubscriptionLocalState();
	        ctrl.renderLocalState(localState);
	      }
	    }).finally(function () {
	      return $spinner.hide('appSpinner');
	    });
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(SubscriptionDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile, /*    detail: state.order.cartDetail*/
	        detail: state.order.subscriptionsDetail,
	        cardInfo: state.order.paymentInfo,
	        summaryDetail: state.order.orderDetail,
	        subscriptionDetail: state.order.subscriptionsDetail,
	        availableSubscriptionInterval: state.order.availableSubscriptionsInterval,
	        userShippingZone: state.order.userShippingZone,
	        taxes: state.order.taxes,
	        subsConfig: state.order.subscriptionConfig
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'updateSubscription',
	    value: function updateSubscription(item) {
	      var _this2 = this;
	
	      // console.log(this.subsConfig);
	      var appTax = this.getTotalTax();
	      var appSub = this.getSubtotal();
	      var appTotal = Math.round((appSub + appTax) * 100) / 100;
	      var todayDate = new Date();
	      todayDate.setHours(0, 0, 0, 0);
	      var subSDate = new Date(this.subStartDate);
	      subSDate.setHours(0, 0, 0, 0);
	      var allItems = item;
	      var unSubscribedItems = allItems.filter(function (item) {
	        return item.item.masterProduct.isSubscription === false;
	      });
	      var outOfStockItems = allItems.filter(function (item) {
	        return !_this2.isItemActive(item);
	      });
	      if (outOfStockItems.length > 0) {
	        this.toaster.pop('success', 'Please remove all out of stock products');
	        return;
	      }
	      if (unSubscribedItems.length > 0) {
	        this.toaster.pop('success', 'Please remove all unsubscribable products');
	        return;
	      }
	      if (!this.subscriptionStatus && subSDate < todayDate) {
	        this.openTab('subscribe-detail-tab');
	        this.goToTab('subscribe-detail-tab');
	        this.toaster.pop('success', 'Subscription  start date should be today or future date');
	        return;
	      }
	      if (!this.selectedFrequency || !this.selectedFrequency.weeksInterval) {
	        this.openTab('subscribe-detail-tab');
	        this.goToTab('subscribe-detail-tab');
	        this.toaster.pop('success', 'Please select frequency');
	        return;
	      }
	      if (this.notDeliverable) {
	        this.openTab('delivery-tab');
	        this.goToTab('delivery-tab');
	        this.toaster.pop('success', 'Shipping address is not deliverable');
	        return;
	      }
	      if (this.subsConfig.minSubcriptionAmt && appSub < this.subsConfig.minSubcriptionAmt) {
	        this.toaster.pop('success', 'Subscription is only available if subtotal is minimum $' + this.subsConfig.minSubcriptionAmt);
	        return;
	      }
	      if (!this.agreement) {
	
	        this.openTab('payment-tab');
	        this.goToTab('payment-tab');
	        this.toaster.pop('success', 'Please agree terms & conditions to subscribe');
	        return;
	      }
	
	      appTax = this.getTotalTax();
	      appSub = this.getSubtotal();
	      appTotal = Math.round((appSub + appTax) * 100) / 100;
	
	      if (this.$stateParams.option === 'add') {
	        item = allItems.map(function (item) {
	          return {
	
	            'item': { 'id': item.item.id },
	            'quantity': item.quantity
	          };
	        });
	      }
	
	      var data = {
	        "subscriptionInterval": {
	          "id": this.selectedFrequency.id
	        },
	        "userCard": this.cardId,
	        "subscriptionCart": item,
	        "shipTo": {
	          "addressLine1": this.addressDetail.shippingAddressLine1,
	          "addressLine2": this.addressDetail.shippingAddressLine2,
	          "city": this.addressDetail.shippingCity,
	          "state": this.addressDetail.shippingState,
	          "country": this.addressDetail.shippingCountry,
	          "zip": this.addressDetail.shippingZipCode,
	          "addressType": "Shipping",
	          "deliveryType": "Next Day Delivery",
	          "expectedDeliveryTime": "2017-7-11 7:0:25",
	          "estimatedDeliveryDateTime": "2017-07-11T01:30:25.000Z",
	          "phoneNumber": this.addressDetail.phoneNumber
	        },
	        "approximateShippingCost": +this.getSelectedShipmentCharge().toFixed(2) || 0,
	        "approximateShippingdiscount": 0,
	        "approximateTotal": appTotal,
	        "startDate": this.convertDate(this.subStartDate, 'ymd'),
	        "approximateSubTotal": this.getSubtotal(), /* "approximateSubTotal":58.32,*/
	        "approximateTax": this.getTotalTax()
	      };
	      if (this.$stateParams.option === 'edit') {
	        data.id = this.detail.id;
	      }
	      this.$spinner.show('appSpinner');
	      this.$order.updateSubscriptionsDetail(data).then(function (success) {
	        _this2.$spinner.hide('appSpinner');
	        _this2.toaster.pop('success', success.data.message.split(',')[0]);
	        _this2.$state.go('subscription-success', { 'subscriptionId': success.data.additionalInfo });
	      }).catch(function () {
	        _this2.toaster.pop('success', 'Error in Subscription Update');
	        _this2.$spinner.hide('appSpinner');
	      });
	    }
	  }, {
	    key: 'getTotalAmount',
	    value: function getTotalAmount() {
	
	      return +(this.getSelectedShipmentCharge() + this.getSubtotal() + this.getTotalTax()).toFixed(2);
	    }
	  }, {
	    key: 'changeFrequency',
	    value: function changeFrequency() {
	      if (this.subscriptionStatus) {
	        this.subStartDate = new Date();
	      }
	      this.subscriptionStatus = false;
	      this.saveLocalState();
	    }
	  }, {
	    key: 'getRetailPrice',
	    value: function getRetailPrice(quantity, price) {
	      return quantity * price;
	    }
	  }, {
	    key: 'getClubDiscount',
	    value: function getClubDiscount(quantity, price) {
	      return this.getRetailPrice(quantity, price) - this.getDiscountedPrice(quantity, price);
	    }
	  }, {
	    key: 'getDiscountedPrice',
	    value: function getDiscountedPrice(quantity, price) {
	      return quantity * (Math.round(0.85 * price * 100) / 100);
	    }
	  }, {
	    key: 'totalRetailPrice',
	    value: function totalRetailPrice() {
	      return this.subcriptionItemList.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      });
	    }
	  }, {
	    key: 'getSubtotal',
	    value: function getSubtotal() {
	      var totalPrice = 0;
	      if (this.isDscMember() || this.cartContainsDsc()) {
	        // console.log(this.subcriptionItemList);
	        var dscItems = this.subcriptionItemList.filter(function (item) {
	          return item.item.masterProduct.subCategories[0].category.dscCategory;
	        });
	        var dscTotal = dscItems.map(function (item) {
	          return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var nondscItems = this.subcriptionItemList.filter(function (item) {
	          return !item.item.masterProduct.subCategories[0].category.dscCategory;
	        });
	        var nonDscTotal = nondscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        totalPrice = dscTotal + nonDscTotal;
	      } else {
	        totalPrice = this.totalRetailPrice();
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'getTotalSaving',
	    value: function getTotalSaving() {
	      return this.totalRetailPrice() - this.getSubtotal();
	    }
	
	    // DSC Points is equal to subtotal (Price - discount).
	
	  }, {
	    key: 'getDscPoints',
	    value: function getDscPoints() {
	      return this.getSubtotal();
	    }
	
	    // totalDSC() {
	    //   if (this.isDscMember()) {
	    //     let dscItems = this.detail.cartItems.filter(item => item.item.subCategory.category.dscCategory);
	    //     let totalPrice = dscItems.map(item => item.item.price * item.quantity)
	    //       .reduce((prev, curr) => prev + curr, 0);
	    //     return totalPrice * 15 / 100; // Discount is 15 percent
	    //   }
	    //   return 0;
	    // }
	    // getSubtotal() {
	    //   return this.totalPrice() - this.totalDSC();
	    // }
	
	  }, {
	    key: 'updateItemInCart',
	    value: function updateItemInCart(quantity, itemId) {
	      var tempItems = this.$auth.getSubscribedItems();
	      for (var i = 0; i < tempItems.length; i++) {
	        if (tempItems[i].item.id === itemId) {
	          tempItems[i].quantity = quantity;
	          break;
	        }
	      }
	      this.$auth.setSubscribedItems(tempItems);
	      this.subcriptionItemList = tempItems;
	      this.getTax();
	    }
	  }, {
	    key: 'removeItemFromCart',
	    value: function removeItemFromCart(itemId) {
	      var tempItems = this.$auth.getSubscribedItems();
	      for (var i = 0; i < tempItems.length; i++) {
	        if (tempItems[i].item.id === itemId) {
	          tempItems.splice(i, 1);
	          break;
	        }
	      }
	      this.$auth.setSubscribedItems(tempItems);
	      this.subcriptionItemList = tempItems;
	      this.getTax();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isAnyItemInactive',
	    value: function isAnyItemInactive() {
	      var arr = [];
	      if (this.subcriptionItemList) {
	        arr = this.subcriptionItemList.filter(function (item) {
	          return !(item.item.isActive && item.item.masterProduct.isActive && item.item.price >= item.item.regionalPrice);
	        });
	      }
	      return !(arr.length === 0);
	    }
	  }, {
	    key: 'goToDetailPage',
	    value: function goToDetailPage(item) {
	
	      if (this.isItemDscMembership(item)) {
	        this.$state.go('savings-club');
	      } else {
	        this.$state.go('product.detail', {
	          categoryId: item.subCategory.category.id, subCategoryId: item.subCategory.id, productId: item.item.masterProduct.id
	        });
	      }
	    }
	  }, {
	    key: 'isItemDscMembership',
	    value: function isItemDscMembership(item) {
	      return item.item.masterProduct.masterCode === this.dscMasterCode;
	    }
	  }, {
	    key: 'isItemActive',
	    value: function isItemActive(item) {
	      return item.item.isActive && item.item.masterProduct.isActive && item.item.price >= item.item.regionalPrice;
	    }
	  }, {
	    key: 'getShippingDiscountCharge',
	    value: function getShippingDiscountCharge() {
	      if (this.freeShipping) {
	        if (this.freeShipping.zone && this.isShippingDiscountEligible()) {
	          // console.log(this.freeShipping.zone.nextDayCharge);
	          return this.freeShipping.zone.nextDayCharge;
	        }
	      }
	      return 0;
	    }
	  }, {
	    key: 'isShippingDiscountEligible',
	    value: function isShippingDiscountEligible() {
	      var grossPrice = this.shippingGrossPrice();
	      var res = false;
	      var result = false;
	      if (!this.notDeliverable && this.profile.store && this.freeShipping) {
	        res = this.profile.store.isFreeShipping && grossPrice >= this.freeShipping.thresholdValue;
	        var shippingOfferStartDate = new Date(this.freeShipping.startDate);
	        var shippingOfferEndDate = new Date(this.freeShipping.endDate);
	        var currentDate = new Date();
	        // console.log(shippingOfferStartDate - currentDate);
	        // console.log(shippingOfferEndDate - currentDate);
	        if (res) {
	          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
	            result = true;
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'shippingGrossPrice',
	    value: function shippingGrossPrice() {
	      return this.subtotal();
	    }
	  }, {
	    key: 'isFreeShippingOfferAvailable',
	    value: function isFreeShippingOfferAvailable() {
	      if (this.profile && this.freeShipping) {
	        var shippingOfferStartDate = new Date(this.freeShipping.startDate);
	        var shippingOfferEndDate = new Date(this.freeShipping.endDate);
	        var currentDate = new Date();
	        var result = false;
	        if (this.profile.store) {
	          if (this.profile.store.isFreeShipping) {
	            if (parseInt(currentDate) >= parseInt(shippingOfferStartDate) && parseInt(currentDate) <= parseInt(shippingOfferEndDate)) {
	              result = true;
	            }
	          }
	        }
	      }
	      return result;
	    }
	  }, {
	    key: 'getFreeShippingRemainingAmount',
	    value: function getFreeShippingRemainingAmount() {
	      if (this.detail) {
	        if (this.freeShipping) {
	          this.shippingOffer.thresholdAmount = this.freeShipping.thresholdValue;
	        }
	      }
	      var remainingAmount = this.getSubtotal() - this.shippingOffer.thresholdAmount;
	      if (remainingAmount >= 0) {
	        this.shippingOffer.isOfferEligible = true;
	      } else {
	        this.shippingOffer.isOfferEligible = false;
	      }
	      return remainingAmount * -1;
	    }
	  }, {
	    key: 'showFreeShippingOfferDetail',
	    value: function showFreeShippingOfferDetail() {
	      var $ctrl = this;
	      var detailInfo,
	          tittle = '';
	      if ($ctrl.shippingOffer.isOfferEligible) {
	        detailInfo = '<p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>';
	        tittle = 'Shipping offer is Eligible';
	      } else {
	        tittle = 'Shipping offer is available';
	        detailInfo = '<p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>';
	      }
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">' + tittle + '</h5>' + detailInfo + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', function ($scope, $order, $uibModalInstance) {
	          $scope.ok = function () {
	            $uibModalInstance.close();
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'addProduct',
	    value: function addProduct() {
	      var info = { 'id': this.$stateParams.subscriptionId, 'option': this.$stateParams.option };
	      this.saveLocalState();
	      this.$auth.setSubscribedInfo(info);
	      this.$state.go('subscribable-products');
	    }
	  }, {
	    key: 'addTempSubcribedCartItems',
	    value: function addTempSubcribedCartItems() {
	      var tempItems = this.$auth.getSubscribedItems();
	      this.subcriptionItemList = tempItems.concat(this.subcriptionItemList);
	    }
	  }, {
	    key: 'calculateDeliveryOption',
	    value: function calculateDeliveryOption() {
	      var _this3 = this;
	
	      //  // console.log(profile);
	      var addressInfo = {
	        'addressLine1': this.addressDetail.shippingAddressLine1, 'city': this.addressDetail.shippingCity, 'state': {
	          'code': this.addressDetail.shippingState.code
	        }, 'zip': this.addressDetail.shippingZipCode, 'country': this.addressDetail.shippingCountry
	      };
	      var ctrl = this;
	      ctrl.rateZoneRetryCount++;
	      this.userShipingZonePromise = this.$order.getUserZone(addressInfo).then(function () {
	        _this3.notDeliverable = false;
	        _this3.getTax();
	      }, function (error) {
	
	        if (error.data.errorCode === 200) {
	          if (ctrl.rateZoneRetryCount <= 3) {
	            ctrl.calculateDeliveryOption();
	          } else {
	            ctrl.notDeliverable = true;
	          }
	        } else {
	          ctrl.notDeliverable = true;
	        }
	      });
	    }
	  }, {
	    key: 'ChangeShippingAddress',
	    value: function ChangeShippingAddress() {
	      var info = { 'id': this.$stateParams.subscriptionId, 'option': this.$stateParams.option, 'addressChange': true };
	      this.$auth.setSubscribedInfo(info);
	      this.$state.go('delivery.address');
	    }
	  }, {
	    key: 'getSelectedShipmentCharge',
	    value: function getSelectedShipmentCharge() {
	      if (this.userShippingZone) {
	        return this.userShippingZone.nextDayCharge;
	      }
	      return 0;
	    }
	  }, {
	    key: 'cartContainsDsc',
	    value: function cartContainsDsc() {
	      var _this4 = this;
	
	      return this.subcriptionItemList ? this.subcriptionItemList.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this4.dscMasterCode;
	      }).length : false;
	    }
	  }, {
	    key: 'cartContainsOnlyDsc',
	    value: function cartContainsOnlyDsc() {
	      var totalItemsInCart = this.subcriptionItemList.length;
	      return this.cartContainsDsc() && totalItemsInCart === this.cartContainsDsc();
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'taxableAmount',
	    value: function taxableAmount() {
	      var totalTaxablePrice = 0;
	      if (this.isDscMember() || this.cartContainsDsc()) {
	        var dscItems = this.subcriptionItemList && this.subcriptionItemList.filter(function (item) {
	          return item.item.masterProduct.subCategories[0].category.dscCategory;
	        });
	        var nondscItems = this.subcriptionItemList && this.subcriptionItemList.filter(function (item) {
	          return !item.item.masterProduct.subCategories[0].category.dscCategory;
	        });
	        var taxableDscItems = dscItems.filter(function (item) {
	          return item.item.taxable;
	        });
	        var taxableNonDscItems = nondscItems.filter(function (item) {
	          return item.item.taxable;
	        });
	        var taxableDscAmount = taxableDscItems.map(function (item) {
	          return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var taxableNonDscAmount = taxableNonDscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        totalTaxablePrice = taxableDscAmount + taxableNonDscAmount;
	      } else {
	        var taxableItems = this.subcriptionItemList && this.subcriptionItemList.filter(function (item) {
	          return item.item.taxable;
	        });
	        var taxablePrice = taxableItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        totalTaxablePrice = taxablePrice;
	      }
	      return totalTaxablePrice;
	    }
	  }, {
	    key: 'retailPrice',
	    value: function retailPrice() {
	      return this.subcriptionItemList && this.subcriptionItemList.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	    }
	  }, {
	    key: 'subtotal',
	    value: function subtotal() {
	      var totalPrice = 0;
	      if (this.isDscMember() || this.cartContainsDsc()) {
	        var dscItems = this.subcriptionItemList && this.subcriptionItemList.filter(function (item) {
	          return item.subCategory.category.dscCategory;
	        });
	        var dscTotal = dscItems.map(function (item) {
	          return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var nondscItems = this.subcriptionItemList && this.subcriptionItemList.filter(function (item) {
	          return !item.subCategory.category.dscCategory;
	        });
	        var nonDscTotal = nondscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        totalPrice = dscTotal + nonDscTotal;
	      } else {
	        totalPrice = this.retailPrice();
	      }
	      return totalPrice;
	    }
	  }, {
	    key: 'getTax',
	    value: function getTax() {
	      var _this5 = this;
	
	      // console.log('this.taxableAmount()---', this.taxableAmount());
	      // console.log('this.taxableAmount()---', this.subtotal());
	      // console.log('this.getSelectedShipmentCharge()---', this.getSelectedShipmentCharge());
	      var data;
	      if (this.getSelectedShipmentCharge()) {
	        data = {
	          'shipTo': {
	            'addressLine1': this.addressDetail.shippingAddressLine1,
	            'addressLine2': this.addressDetail.shippingAddressLine2,
	            'city': this.addressDetail.shippingCity,
	            'state': this.addressDetail.shippingState,
	            'country': this.addressDetail.shippingCountry,
	            'zip': this.addressDetail.shippingZipCode,
	            'addressType': 'Shipping',
	            'deliveryType': 'Home Delivery',
	            'expectedDeliveryTime': '',
	            'estimatedDeliveryDateTime': '',
	            'phoneNumber': this.addressDetail.phoneNumber
	          },
	          'totalAmount': this.getSubtotal(),
	          'taxableAmount': this.taxableAmount(),
	          'shippingCharge': this.getSelectedShipmentCharge(),
	          'discount': 0
	        };
	        this.isCallingAPI = true;
	        this.$order.calculateTaxes(data).then(function (success) {
	          // console.log("success",success);
	          if (_this5.taxes.tax.amountToCollect >= 0) {
	            _this5.isCallingAPI = false;
	            var localState = _this5.$auth.getSubscriptionLocalState();
	            _this5.renderLocalState(localState);
	          }
	        }, function (error) {
	          // console.log("taxError",error);
	          _this5.toaster.pop('success', 'Error in tax calculation');
	        }).catch(function (error) {}
	        // console.log("taxError",error)
	        );
	      }
	    }
	  }, {
	    key: 'getTotalTax',
	    value: function getTotalTax() {
	      if (this.taxes.tax) {
	        return this.taxes.tax.amountToCollect;
	      }
	      return 0;
	    }
	  }, {
	    key: 'convertDate',
	    value: function convertDate(date, format) {
	      if (date) {
	        var month = date.getMonth() + 1;
	        var day = date.getDate();
	        var year = date.getFullYear();
	        if (month < 10) {
	          month = '0' + month.toString();
	        }
	        if (day < 10) {
	          day = '0' + day.toString();
	        }
	        var cdate = null;
	        if (format === 'dmy') {
	          cdate = day + '-' + month + '-' + year;
	        } else if (format === 'ymd') {
	          cdate = year + '-' + month + '-' + day;
	        } else {
	          cdate = month + '-' + day + '-' + year;
	        }
	        return cdate;
	      }
	      return null;
	    }
	  }, {
	    key: 'saveLocalState',
	    value: function saveLocalState() {
	      var localState = {};
	      localState.selectedFrequency = this.selectedFrequency;
	      localState.subStartDate = this.subStartDate;
	      localState.agreement = this.agreement;
	      localState.cardId = this.cardId;
	
	      this.$auth.saveSubscriptionLocalState(localState);
	    }
	  }, {
	    key: 'renderLocalState',
	    value: function renderLocalState(localState) {
	      var savedCard = localState.cardId ? localState.cardId : {};
	      var ctrl = this;
	      angular.forEach(this.cardInfo, function (card) {
	        if (card.id === savedCard.id) {
	          ctrl.cardId = card;
	        }
	      });
	      this.selectedFrequency = localState.selectedFrequency ? localState.selectedFrequency : {};
	      this.subStartDate = localState.subStartDate ? new Date(localState.subStartDate) : new Date();
	      this.agreement = localState.agreement ? localState.agreement : false;
	    }
	  }, {
	    key: 'openTab',
	    value: function openTab(id) {
	      var isChecked = document.getElementById(id).checked;
	      if (!isChecked) {
	        // if it not checked open the tab
	        document.getElementById(id).click();
	      }
	    }
	  }, {
	    key: 'goToTab',
	    value: function goToTab(id) {
	      if (this.$location.hash() !== id) {
	        this.$location.hash(id);
	      } else {
	        this.$anchorScroll();
	      }
	    }
	  }, {
	    key: 'discardSubscription',
	    value: function discardSubscription() {
	      this.$auth.resetSubscriptionCart();
	      this.$state.go('subscription');
	    }
	  }]);
	
	  return SubscriptionDetail;
	}(), _class2.$inject = ['$scope', '$ngRedux', 'spinnerService', 'authService', 'orderService', '$state', '$uibModal', '$stateParams', '$q', 'toaster', '$anchorScroll', '$location', '$window', 'APP'], _temp)) || _class);
	exports.default = SubscriptionDetail;

/***/ },
/* 240 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n    <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n    <mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n\r\n    <!--breadcrum section -->\r\n    <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n        <a class=\"nav\" ng-click=\"subscriptionDetail.goToHomePage()\"  >\r\n            <img class=\"breadcrumb-logo-icon\" src={{subscriptionDetail.houseIcon}} alt=\"logo\"/>\r\n\r\n            <span>Home</span>\r\n        </a>\r\n        <a class=\"nav\" ui-sref=\"subscription\">\r\n            <span>My Subscriptions</span>\r\n        </a>\r\n        <span>My Subscription Detail </span>\r\n    </nav>\r\n\r\n    <!-- Out of stock notice -->\r\n    <div class=\"cart_header p-t-1\" ng-if=\"subscriptionDetail.isAnyItemInactive()\">\r\n        <div class=\"alert-user oos-msg\">\r\n            <span><img class=\"alert-icon\" src={{subscriptionDetail.alertIcon}}></span>\r\n      <span class=\"alert-text\">\r\n      Some items in your subscription are out of stock.  Please remove those items to continue with your subscription.\r\n      </span>\r\n        </div>\r\n    </div>\r\n    <!-- Your cart heading -->\r\n\r\n    <!-- Row for cart items and prices -->\r\n    <div class=\"row cart-content-spacing m-y-1 m-x-0 padding-0-sm\"\r\n         ng-if=\"subscriptionDetail.subcriptionItemList.length\">\r\n\r\n        <!-- List of.orderEntries -->\r\n        <div class=\"col-xs-12 col-md-8 m-x-0 p-x-0\">\r\n\r\n            <div class=\"col-xs-6 col-md-6 p-y-1 font-weight-bold m-b-0 text-xs-left ng-binding\"\r\n                 style=\"vertical-align:middle;\">\r\n                <h5 class=\"font-weight-bold  \"><b>Subscription detail</b></h5>\r\n\r\n\r\n            </div>\r\n            <div class=\"col-xs-6 col-md-6 p-y-1 pull-right rt-align hidden-md-down\" style=\"vertical-align:middle;\">\r\n                <button class=\"btn btn-primary  \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\"\r\n                        ng-click=\"subscriptionDetail.addProduct()\">Add Product\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-xs-12 col-md-4 breadcrumb xs-breadcrum-width breadcrum-bottom-margin m-x-0 p-x-0\"\r\n             style=\"border-radius:0px;\">\r\n            <div class=\"col-xs-5  col-md-5   m-b-0 text-xs-left ng-binding\"\r\n                 style=\"vertical-align:middle;    font-size: 11px;\">\r\n                <b>Start Date : {{subscriptionDetail.subStartDate | date:'MMM d, y'}}<br>\r\n                    <span ng-if=\"subscriptionDetail.selectedFrequency.weeksInterval\">Frequency {{subscriptionDetail.selectedFrequency.weeksInterval}} Week<span\r\n                            ng-if='subscriptionDetail.selectedFrequency.weeksInterval > 1'>s</span> </span>\r\n                    <span ng-if=\"!subscriptionDetail.selectedFrequency.weeksInterval\">Select Frequency </span></b>\r\n\r\n            </div>\r\n            <div class=\"col-xs-7 col-md-7 pull-right rt-align\" style=\"vertical-align:middle;\">\r\n                <button class=\"btn btn-primary   \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\"\r\n                        ng-disabled=\"subscriptionDetail.isCallingAPI\"\r\n                        ng-click=\"subscriptionDetail.updateSubscription(subscriptionDetail.subcriptionItemList)\">Save\r\n                </button>\r\n                <button class=\"btn btn-primary \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\"\r\n                        ng-click=\"subscriptionDetail.discardSubscription()\">Cancel\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-xs-6 col-md-6 p-y-1 pull-right rt-align hidden-md-up\" style=\"vertical-align:middle;\">\r\n            <button class=\"btn btn-primary  \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\"\r\n                    ng-click=\"subscriptionDetail.addProduct()\">Add Product\r\n            </button>\r\n        </div>\r\n        <br>\r\n\r\n\r\n        <div class=\"col-xs-12 col-md-8 m-x-0 p-x-0\">\r\n\r\n            <!--  <div class=\"col-xs-6 col-md-6 p-y-1 font-weight-bold m-b-0 text-xs-left ng-binding\" style=\"vertical-align:middle;\">\r\n                <h5 class=\"font-weight-bold  \" ><b>Subscription detail</b></h5>\r\n\r\n\r\n\r\n              </div>\r\n              <div class=\"col-xs-6 col-md-6 p-y-1 pull-right rt-align\" style=\"vertical-align:middle;\">\r\n                <button class=\"btn btn-primary  \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\" ng-click=\"subscriptionDetail.addProduct()\">Add Product</button>\r\n              </div>\r\n              <hr>\r\n              <br>-->\r\n\r\n            <form name=\"cartForm\"\r\n                  ng-repeat=\"item in subscriptionDetail.subcriptionItemList | orderBy : 'item.id'\"\r\n                  autocomplete=\"off\"\r\n                  novalidate\r\n                  ng-if=\"subscriptionDetail.actionOption\">\r\n                <div class=\"row m-x-0 p-x-0\">\r\n                    <!-- Product Image -->\r\n                    <div class=\"col-xs-4  col-md-3 hidden-sm-down\">\r\n                        <button class=\"hidden-btn\"\r\n                                ng-disabled=\"!(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item)) && !item.item.masterProduct.isSubscription\"\r\n                        >\r\n                            <img src={{item.item.mediumImageUrl}}\r\n                                 ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item)) && item.item.masterProduct.isSubscription ? 'product-thumbnail cursor-pointer' : 'product-thumbnail inactive-item'\"/>\r\n                        </button>\r\n                    </div>\r\n\r\n                    <div class=\"col-xs-8 col-md-8 p-r-0 p-l-1 m-x-0\">\r\n                        <div class=\"col-xs-12 col-md-6 m-b-1 p-x-0\">\r\n                            <!-- Out of stock Button -->\r\n                            <button class=\"btn btn-primary remove-btn out-of-stock-btn mb-8\"\r\n                                    ng-if=\"!(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))\">\r\n                                Out Of Stock\r\n                            </button>\r\n                            <button class=\"btn btn-primary  mb-8\"\r\n                                    ng-if=\"!item.item.masterProduct.isSubscription\">\r\n                                Not Subscribable\r\n\r\n                            </button>\r\n                            <!-- Product Name -->\r\n                            <div ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item)) && item.item.masterProduct.isSubscription ? '' : 'inactive-item'\">\r\n                                <button class=\"hidden-btn\"\r\n                                        ng-disabled=\"!(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item)) && !item.item.masterProduct.isSubscription\"\r\n                                >\r\n                                    <h4 class=\"font-weight-bold m-b-0 text-xs-left\"\r\n                                        ng-bind=\"item.item.name\"></h4>\r\n                                </button>\r\n                            </div>\r\n                            <!-- Product Weight -->\r\n                            <div\r\n                                    ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&& item.item.masterProduct.isSubscription ? 'primary-text weight_cell weight-text hidden-sm-down' : 'inactive-item primary-text weight_cell weight-text hidden-sm-down'\">\r\n                                <span ng-show=\"item.item.weight\">{{item.item.weight}} lbs</span>\r\n                            </div>\r\n\r\n                            <!-- Cart Item Individual Price detail -->\r\n                            <div\r\n                                    ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&&item.item.masterProduct.isSubscription ? 'normal-text m-b-0 m-t-1 hidden-sm-down' : 'inactive-item normal-text m-b-0 m-t-1 hidden-sm-down'\">\r\n\r\n                                <!-- Retail price -->\r\n                                <div class=\"col-xs-8 p-a-0\">Retail Price: {{item.quantity}} x ${{item.item.price |\r\n                                    number : 2}} =\r\n                                </div>\r\n                                <div class=\"col-xs-4 p-a-0 text-xs-right\">\r\n                                    ${{subscriptionDetail.getRetailPrice(item.quantity, item.item.price) | number : 2}}\r\n                                </div>\r\n\r\n                                <!-- Club Discount -->\r\n                                <div class=\"col-xs-8 p-a-0\"\r\n                                     ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                    Club Discount\r\n                                    <small class=\"primary-text discount-text\"\r\n                                           ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                        (15% Off)\r\n                                    </small>\r\n                                    :\r\n                                </div>\r\n                                <div class=\"col-xs-4 p-a-0 text-xs-right\"\r\n                                     ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                    -${{subscriptionDetail.getClubDiscount(item.quantity, item.item.price) | number :\r\n                                    2}}\r\n                                </div>\r\n\r\n                                <!-- Your price when not DSC -->\r\n                                <div class=\"col-xs-8 p-a-0 font-weight-bold\"\r\n                                     ng-if=\"!(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) || !item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                    Your Price:\r\n                                </div>\r\n                                <div class=\"col-xs-4 p-a-0 text-xs-right\"\r\n                                     ng-if=\"!(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) || !item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                    ${{subscriptionDetail.getRetailPrice(item.quantity, item.item.price) | number : 2}}\r\n                                </div>\r\n\r\n                                <!-- Your price when DSC -->\r\n                                <div class=\"col-xs-8 p-a-0 font-weight-bold\"\r\n                                     ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                    Your Price:\r\n                                </div>\r\n                                <div class=\"col-xs-4 p-a-0 text-xs-right\"\r\n                                     ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                    ${{subscriptionDetail.getDiscountedPrice(item.quantity, item.item.price) | number :\r\n                                    2}}\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <!-- Quantity, Remove Button and Mobile Calculations -->\r\n                        <div class=\"col-xs-12 col-md-6 p-l-1 p-r-0 m-x-0 p-b-1\">\r\n                            <p ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item)) && item.item.masterProduct.isSubscription ? 'product-text' : 'inactive-item product-text'\">\r\n                                Quantity</p>\r\n\r\n                            <div ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&& item.item.masterProduct.isSubscription ? '' : 'inactive-item'\">\r\n                                <div class=\"form-group height p-x-0 m-x-0\"\r\n                                     ng-class=\"{'has-danger': (cartForm.$submitted || cartForm.quantity.$touched) && cartForm.quantity.$invalid}\">\r\n                                    <div class=\"input-group\">\r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\"\r\n                              ng-disabled=\"item.quantity < 2 || !(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&&!item.item.masterProduct.isSubscription\"\r\n                              class=\"btn btn-primary counter-btn\"\r\n                              ng-click=\"item.quantity = item.quantity - 1; subscriptionDetail.updateItemInCart(item.quantity, item.item.id);subscriptionDetail.getTotalTax()\">\r\n                          &#150;</button>\r\n                    </span>\r\n                                        <input name=\"quantity\" disabled\r\n                                               type=\"number\"\r\n                                               class=\"form-control counter-input\"\r\n                                               ng-model=\"item.quantity\"\r\n                                               ng-min=\"1\" ng-max=\"999999\"/>\r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\"\r\n                              class=\"btn btn-primary counter-btn\"\r\n                              ng-disabled=\"!(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&& !item.item.masterProduct.isSubscription\"\r\n                              ng-click=\"item.quantity = item.quantity + 1; subscriptionDetail.updateItemInCart(item.quantity, item.item.id);subscriptionDetail.getTotalTax()\">\r\n                          +\r\n                      </button>\r\n                    </span>\r\n                                        <!-- <span class=\"primary-text lbs-text weight_cell hidden-sm-down\" style=\"width:65px;\">\r\n                                          <span ng-show=\"item.item.weight\">{{item.item.weight}} lbs</span>\r\n                                        </span> -->\r\n                                    </div>\r\n                                    <div ng-messages=\"cartForm.quantity.$error\"\r\n                                         class=\"form-control-feedback\"\r\n                                         ng-show=\"cartForm.quantity.$touched || cartForm.$submitted\">\r\n                                        <div ng-message=\"required\">Enter Quantity</div>\r\n                                        <div ng-message=\"min\">Enter a valid Quantity</div>\r\n                                        <div ng-message=\"max\">Enter a valid Quantity</div>\r\n                                        <div class=\"error-text\"\r\n                                             ng-show=\"cartForm.errors.quantity && !cartForm.quantity.$error.required\">{{\r\n                                            cartForm.errors.quantity[0] }}\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"lbs-text p-x-0 weight_cell hidden-md-up ng-binding p-t-1\"\r\n                                         ng-show=\"item.item.weight\">\r\n                                        {{item.item.weight}} lbs\r\n                                    </div>\r\n\r\n\r\n                                    <!-- Calculations for Small Devices -->\r\n                                    <div class=\"normal-text m-b-0 m-t-1 hidden-md-up\">\r\n                                        <div class=\"col-xs-8 p-a-0\">Retail Price: {{item.quantity}} x ${{item.item.price\r\n                                            | number : 2}} =\r\n                                        </div>\r\n                                        <div class=\"col-xs-4 p-a-0 text-xs-right\">\r\n                                            ${{subscriptionDetail.getRetailPrice(item.quantity, item.item.price) |\r\n                                            number : 2}}\r\n                                        </div>\r\n                                        <div class=\"col-xs-8 p-a-0\"\r\n                                             ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                            Club Discount\r\n                                            <small class=\"primary-text discount-text\"\r\n                                                   ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                                (15% Off)\r\n                                            </small>\r\n                                            :\r\n                                        </div>\r\n                                        <div class=\"col-xs-4 p-a-0 text-xs-right\"\r\n                                             ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                            -${{subscriptionDetail.getClubDiscount(item.quantity, item.item.price) |\r\n                                            number : 2}}\r\n                                        </div>\r\n                                        <div class=\"col-xs-8 p-a-0 font-weight-bold\"\r\n                                             ng-if=\"!(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) || !item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                            Your Price:\r\n                                        </div>\r\n                                        <div class=\"col-xs-4 p-a-0 text-xs-right\"\r\n                                             ng-if=\"!(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) || !item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                            ${{subscriptionDetail.getRetailPrice(item.quantity, item.item.price) |\r\n                                            number : 2}}\r\n                                        </div>\r\n                                        <div class=\"col-xs-8 p-a-0 font-weight-bold\"\r\n                                             ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                            Your Price:\r\n                                        </div>\r\n                                        <div class=\"col-xs-4 p-a-0 text-xs-right\"\r\n                                             ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc()) && item.item.masterProduct.subCategories[0].category.dscCategory\">\r\n                                            ${{subscriptionDetail.getDiscountedPrice(item.quantity, item.item.price) |\r\n                                            number : 2}}\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"hidden-sm-down\">\r\n                                <button class=\"btn btn-primary btn-block remove-btn\"\r\n                                        ng-click=\"subscriptionDetail.removeItemFromCart(item.item.id);subscriptionDetail.getTotalTax()\">\r\n                                    Remove\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <!-- <div class=\"col-md-1 m-l-0 p-x-0 hidden-sm-down\">\r\n                      <img ng-click=\"cart.removeItemFromCart(item.item.id)\"\r\n                        src={{cart.closeIcon}} class=\"close-icon\"/>\r\n                    </div> -->\r\n\r\n                    <div class=\"col-xs-4 col-md-2 hidden-md-up\">\r\n                        <button class=\"hidden-btn\"\r\n                                ng-disabled=\"!(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&&!item.item.masterProduct.isSubscription\"\r\n                                ng-click=\"subscriptionDetail.goToDetailPage(item)\">\r\n                            <img img-lazy-loader={{item.item.mediumImageUrl}}\r\n                                 ng-class=\"(subscriptionDetail.isItemActive(item) || subscriptionDetail.isItemDscMembership(item))&&item.item.masterProduct.isSubscription ? 'product-thumbnail cursor-pointer' : 'product-thumbnail inactive-item'\"/>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n                <hr class=\"m-x-1 hidden-sm-down\">\r\n\r\n                <!-- Remove button mobile -->\r\n                <div class=\"col-xs-12 m-b-1 p-x-0 hidden-md-up\">\r\n                    <!-- <button type=\"button\" disabled\r\n                      class=\"col-xs-6 btn btn-primary btn-bdr btn-md-text\">Favorite</button> -->\r\n                    <button type=\"button\"\r\n                            class=\"col-xs-12 btn btn-primary btn-md-text\"\r\n                            ng-click=\"subscriptionDetail.removeItemFromCart(item.item.id)\">Remove\r\n                    </button>\r\n                </div>\r\n                <hr class=\"hidden-md-up xs-ruler\">\r\n\r\n            </form>\r\n        </div>\r\n\r\n        <div class=\"col-xs-12 col-md-4 m-x-0 p-x-0\">\r\n            <div class=\"div_border m-x-0 p-x-0\">\r\n                <div class=\"border_pdding\">\r\n                    <h5 class=\"font-weight-bold m-y-1\">Subscription Detail</h5>\r\n                    <h6 class=\"m-b-1\">\r\n                        <span>Subtotal</span>\r\n                        <span class=\"font-weight-bold pull-xs-right\">$ {{subscriptionDetail.getSubtotal() | number : 2}}</span>\r\n                    </h6>\r\n                    <h6 class=\"m-b-1\">\r\n\r\n                        <span>Shipping</span>\r\n                        <span class=\"pull-xs-right ng-cloak\"\r\n                              ng-bind=\"'$ ' + (subscriptionDetail.getSelectedShipmentCharge() | number : 2)\"></span>\r\n                    </h6>\r\n                    <!--  <h6 class=\"m-b-1\" ng-if=\"subscriptionDetail.isShippingDiscountEligible()\" >\r\n\r\n                        <span>Shipping Discount</span>\r\n                        <span class=\"pull-xs-right ng-cloak\" ng-bind=\"'-$ ' + (subscriptionDetail.getShippingDiscountCharge() | number : 2)\"></span>\r\n                      </h6>-->\r\n                    <!-- <h6 class=\"m-b-1\" ng-if=\"(subscriptionDetail.isDscMember() || subscriptionDetail.cartContainsDsc())\">\r\n                       <span>Club Points</span>\r\n                       <span class=\"pull-xs-right\">{{subscriptionDetail.getDscPoints() | number : 2}}</span>\r\n                     </h6>\r\n\r\n                     <h6 class=\"m-b-1\" ng-if=\"subscriptionDetail.isDscButExpired() && !subscriptionDetail.cartContainsDsc()\">\r\n                       <span>Club Points</span>\r\n                       <span class=\"pull-xs-right\"><s uib-tooltip=\"Your Club Membership has expired\">{{subscriptionDetail.getDscPoints() | number : 2}}</s></span>\r\n                     </h6>-->\r\n                    <!--<h6 class=\"m-b-1\">\r\n                      <span>You Saved</span>\r\n                      <span class=\"pull-xs-right\">$ {{subscriptionDetail.getTotalSaving() | number : 2}}</span>\r\n                    </h6>-->\r\n                    <h6 class=\"m-b-1\">\r\n                        <span>Tax</span>\r\n                        <span class=\"pull-xs-right ng-cloak\"\r\n                              ng-bind=\"'$ ' + (subscriptionDetail.getTotalTax() | number : 2)\"></span>\r\n\r\n                    </h6>\r\n                    <!-- <h6 class=\"m-b-1\">\r\n                     <span>Tax</span>\r\n                     <span class=\"pull-xs-right\">$ {{cart.totalTax() | number : 2}}</span>\r\n                    </h6> -->\r\n                    <!-- <h6 class=\"m-b-1\" ng-if=\"(cart.isDscMember() || cart.cartContainsDsc())\">\r\n                      <span>Club Discount</span>\r\n                      <span class=\"pull-xs-right\">(-) $ {{cart.totalDSC() | number : 2}}</span>\r\n                    </h6> -->\r\n                </div>\r\n                <div class=\"row m-x-0  light-gray-bg  p-y-1 p-x-1\">\r\n                    <h3 class=\"font-weight-bold m-b-0 pt-4\">Total\r\n                        <span class=\"pull-xs-right primary-text\"\r\n                              ng-bind=\"'$ ' + (subscriptionDetail.getTotalAmount() | number : 2)\"></span>\r\n                    </h3>\r\n                    <!-- <div class=\"col-xs-4\">\r\n                      <button type=\"button\" class=\"btn btn-primary btn-md-text\"\r\n                        ng-click=\"delivery.submit()\">Confirm</button>\r\n                      <div class=\"p-t-1\">\r\n                        <a ui-sref=\"category\">\r\n                          <button type=\"button\" class=\"btn btn-primary btn-md-text\">Continue Shopping</button>\r\n                        </a>\r\n                      </div>\r\n                    </div> -->\r\n                    <!--  <div class=\"col-xs-8 text-xs-right\">\r\n                       <h3 class=\"primary-text font-weight-bold m-b-0 pt-4\">$ {{(delivery.getSelectedShipmentCharge() + delivery.totalPrice()) | number : 2}}</h3>\r\n                       <h3 class=\"font-weight-bold m-b-0 pt-4\">Total\r\n                         <span class=\"pull-xs-right\">$ {{delivery.getTotalAmount() | number : 2}}</span>\r\n                       </h3>\r\n                     </div> -->\r\n                </div>\r\n\r\n                <!-- <div class=\"gray-bg p-a-1 \">\r\n                  <h3 class=\"font-weight-bold m-b-0\">Order Total\r\n                    <span class=\"pull-xs-right\">$ {{cart.getOrderTotal() | number : 2}}</span>\r\n                  </h3>\r\n                </div> -->\r\n                <!-- <div class=\"gray-bg p-a-1 primary-text\" ng-if=\"cart.totalDSC() > 0\">\r\n                  <h3 class=\"m-b-0 yousaved-font\">You Saved\r\n                    <span class=\"pull-xs-right\">$ {{cart.totalDSC() | number : 2}}</span>\r\n                  </h3>\r\n                </div> -->\r\n            </div>\r\n\r\n            <div class=\"tab-group\">\r\n\r\n                <!-- start tab-1 -->\r\n\r\n\r\n                <div class=\"accrd_tab\" ng-init=\"subscriptionDetail.openTab('subscribe-detail-tab')\">\r\n\r\n                    <input id=\"subscribe-detail-tab\" class=\"accrd_input\" type=\"checkbox\" name=\"tabs\">\r\n                    <label for=\"subscribe-detail-tab\" class=\"btn-primary header-content\">FREQUENCY DETAIL\r\n                        <img class=\"pull-right down\" src={{subscriptionDetail.downIcon}} alt=\"logo\"/></label>\r\n\r\n                    <div class=\"tab-content sub-header-bg ct-align\">\r\n                        It's that easy! Your subscription will be activated and will arrive by your Delivery\r\n                        frequency.<br><br>\r\n\r\n                        <div class=\"row m-x-0\">\r\n\r\n                            <div class=\"col-md-4 col-xs-5 col-sm-5\" style=\"padding-left: 1px\">\r\n                                <span><b>Start Date:</b></span>\r\n                            </div>\r\n                            <div class=\"col-md-6 col-xs-7 col-sm-7\">\r\n                                <input style=\"width:100%;padding: 0.25rem 0.75rem !important;\r\n      border: 1px solid #aaaaaa; \" ng-model=\"subscriptionDetail.subStartDate\"\r\n                                       type=\"date\"\r\n                                       ng-disabled=\"subscriptionDetail.subscriptionStatus\"\r\n                                       ng-change=\"subscriptionDetail.saveLocalState()\"\r\n                                       class=\"\"/>\r\n                            </div>\r\n                            <br> <br>\r\n\r\n                            <div class=\"col-md-4 col-xs-5 col-sm-5\">\r\n                                <span> <b> Frequency:</b></span>\r\n                            </div>\r\n                            <div class=\"col-md-6 col-xs-7 col-sm-7\">\r\n                                <select style=\"width:100%;\" ng-model=\"subscriptionDetail.selectedFrequency\"\r\n                                        ng-change=\"subscriptionDetail.changeFrequency()\"\r\n                                        ng-options=\"( (item.weeksInterval)  + ' Week' + ( (item.weeksInterval > 1 ) ? 's' : '')  ) for item in subscriptionDetail.availableSubscriptionInterval track by item.id\">\r\n                                    <option value=\"\">Select</option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n                <!-- end subscribe-detail-tab -->\r\n\r\n\r\n                <!-- start tab-2 -->\r\n\r\n\r\n                <div class=\"accrd_tab \">\r\n                    <input id=\"delivery-tab\" type=\"checkbox\" class=\"accrd_input\" name=\"tabs\">\r\n                    <label for=\"delivery-tab\" class=\"btn-primary header-content\">DELIVERY DETAIL\r\n                        <img class=\"pull-right down\" src={{subscriptionDetail.downIcon}} alt=\"logo\"/></label>\r\n\r\n                    <div class=\"tab-content sub-header-bg \">\r\n                        <div class=\"col-xs-12 col-md-8 p-y-1\" style=\"vertical-align:middle;\">\r\n\r\n                            <b>Shipping Address</b><br>\r\n                            {{subscriptionDetail.addressDetail.customer.firstName}}\r\n                            {{subscriptionDetail.addressDetail.customer.lastName}}<br>\r\n                            {{subscriptionDetail.addressDetail.shippingAddressLine1}}&nbsp;&nbsp;{{subscriptionDetail.addressDetail.shippingAddressLine2}},<br>\r\n                            {{subscriptionDetail.addressDetail.shippingCity}},{{subscriptionDetail.addressDetail.shippingState.name}}<br>\r\n                            {{subscriptionDetail.addressDetail.shippingCountry.name}}-{{subscriptionDetail.addressDetail.shippingZipCode}}<br>\r\n                            {{subscriptionDetail.addressDetail.phoneNumber | telFormat}}\r\n\r\n                        </div>\r\n                        <div class=\"col-xs-12 col-md-12 p-y-1 pull-right rt-align\" style=\"vertical-align:middle;\">\r\n                            <button class=\"btn btn-primary  \" style=\"margin-top: 0;font-size: 0.85rem;height: 34px;\"\r\n                                    ng-click=\"subscriptionDetail.ChangeShippingAddress()\">Change\r\n                            </button>\r\n                        </div>\r\n                        <div class=\"col-xs-12 col-md-12 row m-x-0 p-l-1 p-t-1 error-text\"\r\n                             ng-if=\"subscriptionDetail.notDeliverable\">\r\n                             There seems to be a problem with your address. Please check your entry. Contact the store for assistance at <a\r\n                                class=\"blue-colored\" href=\"tel:{{subscriptionDetail.profile.store.phoneNumber}}\">{{subscriptionDetail.profile.store.phoneNumber\r\n                            | telFormat}}</a>.\r\n                        </div>\r\n\r\n                    </div>\r\n                </div>\r\n                <!-- end delivery-tab  -->\r\n\r\n                <!-- start payment-tab -->\r\n                <div class=\"accrd_tab \">\r\n\r\n                    <input id=\"payment-tab\" class=\"accrd_input\" type=\"checkbox\" name=\"tabs\">\r\n                    <label for=\"payment-tab\" class=\"btn-primary header-content\">PAYMENT DETAIL\r\n                        <img class=\"pull-right down\" src={{subscriptionDetail.downIcon}} alt=\"logo\"/></label>\r\n\r\n                    <div class=\"tab-content sub-header-bg  \">\r\n                        <div class=\"col-xs-12\">\r\n                            <h5 class=\"m-t-1 font-weight-bold\">Want to continue with your saved card</h5>\r\n\r\n                            <form name=\"cardDetailForm\">\r\n                                <div class=\"form-check m-b-0\" ng-repeat=\"item in subscriptionDetail.cardInfo\">\r\n                                    <label class=\"form-radio-label\">\r\n                                        <input type=\"radio\" ng-change=\"subscriptionDetail.saveLocalState()\"\r\n                                               class=\"form-radio-input\" ng-model=\"$parent.subscriptionDetail.cardId\"\r\n                                               ng-value=\"item\"/>\r\n                                        <span>{{item.cardNumber}}</span>\r\n                                    </label>\r\n                                </div>\r\n\r\n                                <div class=\"form-check m-b-0 m-t-2\">\r\n                                    <input type=\"checkbox\"\r\n                                           name=\"agreement\"\r\n                                           ng-change=\"subscriptionDetail.saveLocalState()\"\r\n                                           ng-model=\"subscriptionDetail.agreement\"\r\n                                           class=\"form-control text-xs-left d-inline\"\r\n                                           style=\"width: auto;\"/>\r\n\r\n                                    <div class=\"d-inline\">\r\n                                        I agree to the <a ui-sref=\"terms-conditions\" class=\"link-text\">Terms and\r\n                                        Conditions</a>.\r\n                                    </div>\r\n                                </div>\r\n\r\n\r\n                            </form>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row p-t-2 m-x-0\"\r\n         ng-if=\"subscriptionDetail.subcriptionItemList && !subscriptionDetail.subcriptionItemList.length\">\r\n        <div class=\"col-lg-4 offset-lg-4 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1 text-xs-center\">\r\n            <h5 class=\"font-weight-bold\">Subscription Cart Empty</h5>\r\n\r\n            <p class=\"m-t-1\">Add Items to subscribe.</p>\r\n\r\n            <div class=\"m-t-3 p-t-3\">\r\n                <a class=\"btn btn-primary btn-block m-y-2\"\r\n                   href ng-click=\"subscriptionDetail.addProduct()\">Add Product</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmZjAxMWNhYS1lN2QxLTQxMTYtOWM1ZC04OTdkMmM4NDQ5ZmIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MkJGN0UyQkQ1RTQwMTFFN0E4OTFDNzEwQzc5RTIzRkMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MkJGN0UyQkM1RTQwMTFFN0E4OTFDNzEwQzc5RTIzRkMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyQkY3RTJCODVFNDAxMUU3QTg5MUM3MTBDNzlFMjNGQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyQkY3RTJCOTVFNDAxMUU3QTg5MUM3MTBDNzlFMjNGQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhzaDcUAAABfSURBVHjaYvz//z8DuYAFSlsC8TwgZiNCz3cgjgbiiwwgm6E4EIh//scPvgGxG0wPsmZCBnxF1ohNMy4DMDTi0gzCAUgGYNWITzPMgPdA7IpLDSOBqBIC4ne4JAECDAD4ugW3/QUzXgAAAABJRU5ErkJggg=="

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _subscriptionSuccess = __webpack_require__(243);
	
	var _subscriptionSuccess2 = _interopRequireDefault(_subscriptionSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SubscriptionSuccess = (_dec = (0, _utils.Component)({
	  controllerAs: 'subscriptionSuccess',
	  template: _subscriptionSuccess2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function SubscriptionSuccess($scope, $ngRedux, $state, $stateParams, toaster, $auth, $spinner, $q, $order, $timeout, $window, APP) {
	    var _this = this;
	
	    _classCallCheck(this, SubscriptionSuccess);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.toaster = toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	    this.dscMasterCode = '88888888'; // Named constant
	    this.isCardSaved = $stateParams.isCardSaved;
	    var orderSummaryPromise = $order.getSubscriptionsDetail($stateParams.subscriptionId).catch(function () {} // console.log("djsfskfd")
	    );
	    /* $state.go('payment.failure')*/
	
	    var userProfilePromise = $auth.getUserProfile();
	
	    $spinner.show('appSpinner');
	    var promises = [orderSummaryPromise, userProfilePromise];
	    $q.all(promises).finally(function () {
	      return $spinner.hide('appSpinner');
	    });
	
	    localStorage.removeItem('deliveryAddress');
	    this.currencyType = 'USD';
	    $timeout(function () {
	      _this.country = _this.profile.store.country.countryCode ? _this.profile.store.country.countryCode : 'US';
	
	      if (_this.profile.store) {
	        // console.log(this.profile);
	        _this.currencyType = $order.getCurrencyType(_this.country);
	      }
	    }, 800);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(SubscriptionSuccess, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        summary: state.order.subscriptionsDetail,
	        userShippingZone: state.order.userShippingZone
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'formattedTime',
	    value: function formattedTime(dateTime) {
	      var date = dateTime ? new Date(dateTime) : new Date();
	      var hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
	      var time = (hours < 10 ? '0' + hours : hours) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	      var ampm = date.getHours() >= 12 ? ' PM' : ' AM';
	      return time + ampm;
	    }
	  }, {
	    key: 'saveCardDetail',
	    value: function saveCardDetail() {
	      var _this2 = this;
	
	      this.$order.saveCardDetail(this.$stateParams.subscriptionId).then(function (success) {
	        return _this2.toaster.pop('success', success.data.message);
	      });
	    }
	  }, {
	    key: 'getDSCDiscount',
	    value: function getDSCDiscount() {
	      if (this.profile.customer && this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate)) {
	        var dscItems = this.summary.orderEntries && this.summary.orderEntries.filter(function (item) {
	          return item.item.subCategory.category.dscCategory;
	        });
	        var totalPrice = dscItems && dscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        return totalPrice * 15 / 100;
	      }
	      return 0;
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'getSelectedShipmentCharge',
	    value: function getSelectedShipmentCharge() {
	      if (this.userShippingZone) {
	        return this.userShippingZone.nextDayCharge;
	      }
	      return 0;
	    }
	  }, {
	    key: 'getSubtotal',
	    value: function getSubtotal() {
	
	      var totalPrice = 0;
	      if ((this.isDscMember() || this.cartContainsDsc()) && this.summary.subscriptionCart) {
	        var dscItems = this.summary.subscriptionCart.filter(function (item) {
	          return item.item.subCategory.category.dscCategory;
	        });
	        var dscTotal = dscItems.map(function (item) {
	          return Math.round(0.85 * item.item.price * 100) / 100 * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var nondscItems = this.summary.subscriptionCart.filter(function (item) {
	          return !item.item.subCategory.category.dscCategory;
	        });
	        var nonDscTotal = nondscItems.map(function (item) {
	          return item.item.price * item.quantity;
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        totalPrice = dscTotal + nonDscTotal;
	      } else {
	        totalPrice = this.totalRetailPrice();
	      }
	      // console.log("Hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
	      // console.log(totalPrice);
	      return totalPrice;
	    }
	  }, {
	    key: 'totalRetailPrice',
	    value: function totalRetailPrice() {
	      return this.summary.subscriptionCart.map(function (item) {
	        return item.item.price * item.quantity;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      });
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'calculateTotalWeight',
	    value: function calculateTotalWeight() {
	      if (this.summary.subscriptionCart) {
	        var weightsArray = this.summary.subscriptionCart.map(function (totalWeight) {
	          return totalWeight.quantity * totalWeight.item.weight;
	        });
	        var totalWeight = 0;
	        for (var i = 0; i < weightsArray.length; i++) {
	          totalWeight += weightsArray[i];
	        }
	        return totalWeight;
	      }
	      return "";
	    }
	  }, {
	    key: 'calculateTotalProductWeight',
	    value: function calculateTotalProductWeight(quantity, weight) {
	      return quantity * weight;
	    }
	  }, {
	    key: 'cartContainsOnlyDsc',
	    value: function cartContainsOnlyDsc() {
	      var _this3 = this;
	
	      var dscIsInCart = this.summary.subscriptionCart.filter(function (item) {
	        return item.item.masterProduct.masterCode === _this3.dscMasterCode;
	      }).length;
	      var totalItemsInCart = this.summary.subscriptionCart.length;
	      return dscIsInCart && totalItemsInCart === dscIsInCart;
	    }
	  }]);
	
	  return SubscriptionSuccess;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', '$stateParams', 'toaster', 'authService', 'spinnerService', '$q', 'orderService', '$timeout', '$window', '$state', 'APP'], _temp)) || _class);
	exports.default = SubscriptionSuccess;

/***/ },
/* 243 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>\r\n-->\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\" id=\"printbtn\">\r\n    <a class=\"nav\" ng-click=\"subscriptionSuccess.goToHomePage()\"  >\r\n      <img class=\"breadcrumb-logo-icon\" src={{subscriptionSuccess.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n    <a ui-sref=\"subscription\" class=\"nav\">\r\n    <span >My Subscription </span></a>\r\n    <span >My Subscription Status </span>\r\n\r\n\r\n  </nav>\r\n\r\n  <div class=\"row gray-bg m-x-0 p-y-1 static-content-spacing\">\r\n    <div class=\"col-xs-12\">\r\n      <h5 class=\"m-b-0 primary-text\">Congratulations!\r\n        <span class=\"pull-xs-right p-x-1 hidden-sm-down\">\r\n            <input id=\"printbtn\" type=\"button\" value=\"Print this page\" onclick=\"window.print();\">\r\n        </span>\r\n      </h5>\r\n      <p class=\"m-b-0 mt-4\">Your Subscription saved Successfully.</p>\r\n      <p class=\"m-b-0\">The Subscription details have been emailed to you at:{{subscriptionSuccess.profile.email}}</p>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0 static-content\">\r\n    <div class=\"col-xs-12 col-md-6\">\r\n      <h6 class=\"mb-4 pt-8\"><strong>Subscription ID:</strong></h6>\r\n      <h6>{{subscriptionSuccess.summary.invoiceNumber}}</h6>\r\n\r\n\r\n\r\n      <h6 class=\"mb-4\"><strong>Start Date: </strong> {{subscriptionSuccess.summary.startDate|date}}</h6>\r\n       <h6 class=\"mb-4\"><strong>Frequency: </strong>{{subscriptionSuccess.summary.subscriptionInterval.weeksInterval}}week(s)</h6>\r\n      <h6 class=\"mb-4\"><strong>Next Order on: </strong>{{subscriptionSuccess.summary.date_on_order_to_be_placed|date}}</h6>\r\n      <div ng-if=\"orderDetail.summary.deliveryType == 'In Store Pickup' && !orderDetail.cartContainsOnlyDsc\">\r\n        <h6 class=\"mb-4 m-t-2 pt-8\">\r\n          <strong>Pickup time:</strong></h6>\r\n        <h6>{{subscriptionSuccess.summary.expectedDeliveryTime}}</h6>\r\n      </div>\r\n\r\n      <div ng-if=\"(orderDetail.summary.deliveryType == 'Next Day Delivery' || orderDetail.summary.deliveryType == 'Same Day Delivery')\">\r\n        <h6 class=\"mb-4 m-t-2 pt-8\">\r\n          <strong>Delivery time:</strong></h6>\r\n        <h6>1-5 Days</h6>\r\n      </div>\r\n\r\n      \r\n      <h6 class=\"mb-4\" ng-if=\"subscriptionSuccess.summary.approximateShippingCost - subscriptionSuccess.summary.approximateShippingdiscount ===0\"> \r\n        <strong>FREE Shipping: </strong>${{subscriptionSuccess.summary.approximateShippingCost | number : 2 }}\r\n      </h6>\r\n\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"subscriptionSuccess.summary.approximateShippingCost - subscriptionSuccess.summary.approximateShippingdiscount !=0\"><strong>Subtotal: </strong>${{subscriptionSuccess.summary.approximateSubTotal | number : 2 }}</h6>\r\n      <h6 class=\"mb-4\" > \r\n        <strong>Shipping Charge: </strong>${{subscriptionSuccess.summary.approximateShippingCost | number : 2 }}\r\n      </h6>\r\n      <h6 class=\"mb-4\" ng-if=\"(subscriptionSuccess.summary.deliveryType == 'Next Day Delivery' || subscriptionSuccess.summary.deliveryType == 'Same Day Delivery') && (subscriptionSuccess.summary.shippingDiscount) && subscriptionSuccess.summary.approximateShippingCost - subscriptionSuccess.summary.approximateShippingdiscount !=0\">\r\n        <strong>Shipping Discount: -</strong>${{subscriptionSuccess.summary.approximateShippingdiscount | number : 2 }}\r\n      </h6>\r\n      <h6 class=\"mb-4\" ng-if=\"subscriptionSuccess.summary.appliedBBCouponAmount\"><strong>Bird Buck Coupon Amount: </strong>(-)${{subscriptionSuccess.summary.appliedBBCouponAmount | number : 2 }}</h6>\r\n      <h6 class=\"mb-4\"><strong>Tax: </strong>${{subscriptionSuccess.summary.approximateTax | number : 2 }}</h6>\r\n      <h6 class=\"mb-4\"><strong>Total approximate amount: </strong>${{subscriptionSuccess.summary.approximateTotal +subscriptionSuccess.summary.approximateShippingCost | number : 2 }}</h6>\r\n\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"subscriptionSuccess.summary.appliedBBCoupon\"><strong>Applied Bird Buck Coupon: </strong>{{subscriptionSuccess.summary.appliedBBCoupon}}</h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"subscriptionSuccess.isDscButExpired()\"><strong><s uib-tooltip=\"Your Club Membership has expired\">Club Points Earned: </strong>{{subscriptionSuccess.summary.dscPoints | number: 2}}</s></h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\"><strong>Items:</strong></h6>\r\n      <h6 class=\"m-b-1\" ng-repeat=\"item in subscriptionSuccess.summary.subscriptionCart\"><strong>\r\n        {{item.item.name}}</strong><br />\r\n        Quantity: {{item.quantity}}<br />\r\n        <span ng-show=\"item.item.weight\">Weight: {{item.quantity}} x {{item.item.weight  | number : 2}} lbs = {{subscriptionSuccess.calculateTotalProductWeight(item.quantity, item.item.weight)  | number : 2}} lbs</span>\r\n      </h6>\r\n      <!-- <h6 class=\"m-b-0\"><strong>Expected Delivery: {{orderDetail.summary.expectedDeliveryTime}}</strong></h6> -->\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\"><strong>Total Order Weight:</strong></h6>\r\n      <h6>{{subscriptionSuccess.calculateTotalWeight()  | number : 2}} lbs</h6>\r\n\r\n      <h6 class=\"mb-4 m-t-2 pt-8\" ng-if=\"subscriptionSuccess.summary.dscAmount\">You have earned a {{subscriptionSuccess.currencyType}} ${{subscriptionSuccess.summary.dscAmount | number: 0}} Bird Buck!</h6>\r\n    \r\n    </div>\r\n    <div class=\"col-xs-12 col-md-6\">\r\n      <h6 class=\"mb-4  pt-8\"><strong>Store Details:</strong></h6>\r\n      <h6>\r\n        <span ng-bind=\"subscriptionSuccess.profile.store.storeName\"></span><br />\r\n        <span ng-if=\"subscriptionSuccess.profile.store.addressLine1\">{{subscriptionSuccess.profile.store.addressLine1}} {{subscriptionSuccess.profile.store.addressLine2}}</span><br />\r\n        <span ng-if=\"subscriptionSuccess.profile.store.country\">{{subscriptionSuccess.summary.storeDetails.city}} {{subscriptionSuccess.profile.store.state.name}}, {{subscriptionSuccess.profile.store.country.countryCode}} {{subscriptionSuccess.profile.store.zipCode}}</span><br />\r\n        Phone no. <a class=\"blue-colored\" href=\"tel:{{subscriptionSuccess.profile.store.phoneNumber}}\">{{subscriptionSuccess.profile.store.phoneNumber | telFormat}}</a>\r\n      </h6>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row m-x-0 \" id=\"printbtn\">\r\n    <div class=\"col-xs-12 col-md-5\">\r\n      <!-- <h6 class=\"p-t-1 mb-4\">The order details have been emailed to you at:</h6>\r\n      <h6>{{orderDetail.profile.customer.email}}</h6> -->\r\n      <!-- <div class=\"form-check\" ng-if=\"!orderDetail.isCardSaved\">\r\n        <label class=\"form-check-label p-t-1\">\r\n          <input type=\"checkbox\" class=\"form-check-input\" ng-model=\"orderDetail.saveCard\" />\r\n            Save card detail for future purchase.\r\n        </label>\r\n      </div> -->\r\n\r\n\r\n       <div class=\"col-xs-10 offset-xs-1 col-sm-4 offset-sm-0 col-md-6\"\r\n        ng-if=\"!subscriptionSuccess.isCardSaved\">\r\n        <button type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-md-text m-b-1\"\r\n          ng-if=\"subscriptionSuccess.saveCard\"\r\n           ng-click=\"subscriptionSuccess.saveCardDetail()\">Save Card</button>\r\n      </div>\r\n    </div>\r\n \r\n  <div class=\"col-xs-10 offset-xs-1 col-sm-6 offset-sm-0 col-md-4 \" id=\"printbtn\">\r\n    <a ng-click=\"subscriptionSuccess.goToHomePage()\"   class=\"btn btn-primary btn-block btn-md-text m-b-1\">Back To Home</a> <br /> <br />\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _ccDel = __webpack_require__(245);
	
	var _ccDel2 = _interopRequireDefault(_ccDel);
	
	var _ccEdit = __webpack_require__(246);
	
	var _ccEdit2 = _interopRequireDefault(_ccEdit);
	
	var _cardsManagement = __webpack_require__(247);
	
	var _cardsManagement2 = _interopRequireDefault(_cardsManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CardDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'cardManage',
	  template: _cardsManagement2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function CardDetail($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $uibModal, APP, $window) {
	    var _this = this;
	
	    _classCallCheck(this, CardDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.APP = APP;
	    this.$order = $order;
	    this.$toaster = $toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.ccdelete = _ccDel2.default;
	    this.ccedit = _ccEdit2.default;
	    this.$uibModal = $uibModal;
	    this.showHeartLandPage = false;
	    this.$spinner = $spinner;
	    this.heartand_Approval = "APPROVAL";
	    $spinner.show('appSpinner');
	    this.updateOrAddCardAllowed = true;
	    $auth.getUserProfile().then(function (success) {
	      console.log("state.auth.profile", success);
	      var userProfile = success.data;
	      if (userProfile.store.paymentType !== _this.APP.ORDER.PAYMENT_TYPE.heartLand && userProfile.store.paymentType !== _this.APP.ORDER.PAYMENT_TYPE.tsys && userProfile.store.paymentType !== _this.APP.ORDER.PAYMENT_TYPE.moneris) {
	        _this.updateOrAddCardAllowed = false;
	      } else {
	        _this.updateOrAddCardAllowed = true;
	      }
	    });
	
	    $order.getPaymentInfo().then(function (success) {
	      if (success.data && success.data.length > 0) {
	        _this.cardId = success.data[0].id;
	      }
	    }).finally(function () {
	      return $spinner.hide('appSpinner');
	    });
	    this.init();
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(CardDetail, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile,
	        cardInfo: state.order.paymentInfo
	      };
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      if (this.$stateParams.status === 'Success') {
	        this.$toaster.pop('success', 'Card Details Updated Successfully');
	      }
	      if (this.$stateParams.status === 'Failed') {
	        this.$toaster.pop('success', 'Card detail not  updated. Please try again later.');
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      if (!this.cardId) {
	        this.$toaster.pop('success', 'Please select Card to continue.');
	        return;
	      }
	      var cardNumber = this.cardInfo.filter(function (card) {
	        return card.id === _this2.cardId;
	      })[0].cardNumber;
	      this.isCallingAPI = true;
	      var giftCardsRequest = [];
	      var data = {
	        "getGiftCardPreAuthCardRequestList": giftCardsRequest
	      };
	      this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, data).then(function (success) {
	        if (success.data.successCode === '0' && success.data.message === 'Approved') {
	          _this2.$state.go('payment.success', {
	            orderId: _this2.$stateParams.orderId,
	            isCardSaved: true
	          });
	        } else {
	          _this2.$state.go('payment.failure', {
	            orderId: _this2.$stateParams.orderId,
	            reasonCode: success.data.successCode
	          });
	        }
	      }, function (error) {
	        return _this2.$state.go('payment.failure', {
	          orderId: _this2.$stateParams.orderId,
	          reasonCode: error.data.successCode
	        });
	      }).finally(function () {
	        return _this2.isCallingAPI = false;
	      });
	    }
	  }, {
	    key: 'paymentByNewCard',
	    value: function paymentByNewCard() {
	      var _this3 = this;
	
	      var device = this.getDeviceParameter();
	      this.isCallingAPI = true;
	      var giftCardsRequest = [];
	      var data = {
	        "getGiftCardPreAuthCardRequestList": giftCardsRequest
	      };
	      this.$order.initializePayment(this.$stateParams.orderId, device, data).then(function (success) {
	        if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
	          _this3.$toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
	          return;
	        }
	        _this3.goToMerchantPage(success.data);
	      }, function (err) {
	        _this3.$toaster.pop('success', err.data.message);
	        _this3.isCallingAPI = false;
	      });
	    }
	
	    /*  goToMerchantPage(data, method) {
	        method = method || 'post';
	    
	        let form = document.createElement('form');
	        form.setAttribute('method', method);
	        form.setAttribute('action', data.message);
	    
	        let payIdField = document.createElement('input');
	        payIdField.setAttribute('type', 'hidden');
	        payIdField.setAttribute('name', 'PaymentID');
	        payIdField.setAttribute('value', data.additionalInfo);
	        form.appendChild(payIdField);
	    
	        let returnMethodField = document.createElement('input');
	        returnMethodField.setAttribute('type', 'hidden');
	        returnMethodField.setAttribute('name', 'ReturnMethod');
	        returnMethodField.setAttribute('value', 'POST');
	        form.appendChild(returnMethodField);
	    
	        document.body.appendChild(form);
	        form.submit();
	      }*/
	
	  }, {
	    key: 'removeCard',
	    value: function removeCard(id) {
	
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Remove Card</h5></div>' + '<div class="modal-body" id="modal-body">' + '<h6>Are you sure?</h6>' + '</div>' + '<div class="modal-footer">' + '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' + '</div>',
	        controller: ['$scope', '$state', 'orderService', '$uibModalInstance', function ($scope, $state, $order, $uibModalInstance) {
	          $scope.ok = function () {
	            $order.removeCreditCard(id).then(function (success) {
	              $ctrl.$toaster.pop('success', success.data.message);$order.getPaymentInfo().then(function (success) {
	                return $ctrl.cardId = success.data[0].id;
	              });
	            }, function (err) {
	              $ctrl.$toaster.pop('success', err.data.message);
	              $ctrl.isCallingAPI = false;
	            });
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'goToMerchantPage',
	    value: function goToMerchantPage(data, method) {
	
	      // method = method || 'post';
	
	      // let form = document.createElement('form');
	      // form.setAttribute('method', method);
	      // form.setAttribute('action', data.message);
	
	      // let payIdField = document.createElement('input');
	      // payIdField.setAttribute('type', 'hidden');
	      // payIdField.setAttribute('name', 'PaymentID');
	      // payIdField.setAttribute('value', data.additionalInfo);
	      // form.appendChild(payIdField);
	
	      // let returnMethodField = document.createElement('input');
	      // returnMethodField.setAttribute('type', 'hidden');
	      // returnMethodField.setAttribute('name', 'ReturnMethod');
	      // returnMethodField.setAttribute('value', 'POST');
	      // form.appendChild(returnMethodField);
	
	      // document.body.appendChild(form);
	      // form.submit();
	
	    }
	  }, {
	    key: 'addCard',
	    value: function addCard() {
	      var device = this.getDeviceParameter();
	      var $ctrl = this;
	      if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.heartLand) {
	        $ctrl.callHeartLandCustom(null, device);
	      } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.tsys) {
	        // $ctrl.callTsysCustom(id, device);
	        $ctrl.callHeartLandCustom(null, device);
	      } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.moneris) {
	        // $ctrl.callTsysCustom(id, device);
	        $ctrl.callMonerisCustom(null, device);
	      } else {
	        $ctrl.$order.updateCreditCard(null, device).then(function (success) {
	          if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
	            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	            return;
	          }
	          $ctrl.goToMerchantPage(success.data);
	        }, function (err) {
	          $ctrl.$toaster.pop('success', err.data.message);
	          $ctrl.isCallingAPI = false;
	        });
	      }
	    }
	  }, {
	    key: 'updateCard',
	    value: function updateCard(id) {
	      var device = this.getDeviceParameter();
	      // console.log("Here _-----------");
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-header modalheaderbg btn-primary"><h5>Update Card</h5></div>' + '<div class="modal-body" id="modal-body">' + '<h6>Are you sure?</h6>' + '</div>' + '<div class="modal-footer">' + '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' + '</div>',
	        controller: ['$scope', '$state', 'orderService', '$uibModalInstance', function ($scope, $state, $order, $uibModalInstance) {
	          $scope.ok = function () {
	
	            if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.heartLand) {
	              $ctrl.callHeartLandCustom(id, device);
	            } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.tsys) {
	              // $ctrl.callTsysCustom(id, device);
	              $ctrl.callHeartLandCustom(id, device);
	            } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.moneris) {
	              // $ctrl.callTsysCustom(id, device);
	              $ctrl.callMonerisCustom(id, device);
	            } else {
	              $ctrl.$order.updateCreditCard(id, device).then(function (success) {
	                if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
	                  $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
	                  return;
	                }
	                $ctrl.goToMerchantPage(success.data);
	              }, function (err) {
	                $ctrl.$toaster.pop('success', err.data.message);
	                $ctrl.isCallingAPI = false;
	              });
	            }
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }],
	        resolve: {}
	      });
	    }
	  }, {
	    key: 'getDeviceParameter',
	    value: function getDeviceParameter() {
	      if (window.innerWidth <= 576) {
	        return 'm';
	      } else if (window.innerWidth > 576 && window.innerWidth <= 768) {
	        return 't';
	      } else if (window.innerWidth > 768) {
	        return 'd';
	      }
	    }
	  }, {
	    key: 'callHeartLandCustom',
	    value: function callHeartLandCustom(id, device) {
	      this.showHeartLandPage = true;
	      this.$state.go('card-update', { 'cardId': id });
	      // this.templateUrl="payment-detail.html";
	    }
	  }, {
	    key: 'callTsysCustom',
	    value: function callTsysCustom(id, device) {
	      this.showHeartLandPage = true;
	      this.$state.go('tsyscard-update', { 'cardId': id });
	      // this.templateUrl="payment-detail.html";
	    }
	  }, {
	    key: 'callMonerisCustom',
	    value: function callMonerisCustom(id, device) {
	      this.showHeartLandPage = true;
	      this.$state.go('card-update', { 'cardId': id });
	      // this.templateUrl="payment-detail.html";
	    }
	  }]);
	
	  return CardDetail;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', '$stateParams', 'spinnerService', 'orderService', 'authService', '$uibModal', 'APP', '$window'], _temp)) || _class);
	exports.default = CardDetail;

/***/ },
/* 245 */
/***/ function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ },
/* 246 */
/***/ function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = "<div class=\"p-x-0 p-b-1\">\r\n\r\n  <!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n\r\n  <nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n    <a class=\"nav\" ng-click=\"cardManage.goToHomePage()\">\r\n      <img class=\"breadcrumb-logo-icon\" src={{cardManage.houseIcon}} alt=\"logo\" />\r\n      <span>Home</span>\r\n    </a>\r\n\r\n    <span>Manage Credit cards</span>\r\n  </nav>\r\n\r\n\r\n  <div class=\"row p-t-2 m-x-0 static-content\">\r\n    <div class=\"col-xs-12\">\r\n      <h5 class=\"m-t-1 font-weight-bold\">Manage Credit cards {{cardManage.updateOrAddCardAllowed}}</h5><br>\r\n      <form name=\"cardDetailForm\">\r\n         <div class=\"solid-box\"  ng-if=\"!cardManage.updateOrAddCardAllowed\">\r\n          <p>The feature for adding and updating credit cards is temporarily disabled. </p>\r\n          <p>If you need to add your credit card, you can do so through checkout by clicking on 'Pay with a New Card' and proceeding to 'Pay Now'. </p>\r\n          <p>If you need to update your credit card, you need to first remove the appropriate card below.  Then, add the updated card through checkout by clicking on 'Pay with a New Card' and proceeding to 'Pay Now'.</p>\r\n          \r\n        </div> \r\n        <br><br>\r\n        <div class=\"form-check  row\" ng-repeat=\"item in cardManage.cardInfo\" ng-if=\"cardManage.cardInfo.length>0\">\r\n          <label class=\"form-radio-label col-md-6 col-xs-12\" style='margin-bottom: -8px;'>\r\n            <span class=\"\">{{item.cardNumber}}</span>\r\n\r\n            <!-- <img class=\"home-list-icon pull-right cursor-pointer \" ng-click=\"cardManage.removeCard(item.id)\"\r\n              src={{cardManage.ccdelete}} alt=\"logo\" />\r\n            <img class=\"home-list-icon pull-right cursor-pointer\" ng-click=\"cardManage.updateCard(item.id)\"\r\n              src={{cardManage.ccedit}} alt=\"logo\" /> -->\r\n              \r\n              \r\n              <div style=\"margin-left:30px\">\r\n                <button type=\"button\"\r\n                  class=\"btn btn-primary  m-t-2\"  ng-disabled=\"cardManage.isCallingAPI\" \r\n                  ng-click=\"cardManage.removeCard(item.id)\">Remove card</button>\r\n                <button type=\"button\"\r\n                  class=\"btn btn-primary  m-t-2\"  ng-disabled=\"cardManage.isCallingAPI\" \r\n                  ng-if=\"cardManage.updateOrAddCardAllowed\"\r\n                  ng-click=\"cardManage.updateCard(item.id)\">Update card</button>\r\n              </div>\r\n\r\n            <hr class=\"m-t-2\">\r\n          </label>\r\n        </div>\r\n\r\n        <div class=\"form-check  row\" ng-if=\"cardManage.updateOrAddCardAllowed\">\r\n          <label class=\"form-radio-label col-md-6 col-xs-12\" style='margin-bottom: -8px;' > \r\n          <button type=\"button\"\r\n            class=\"btn btn-primary m-t-2\"  ng-disabled=\"cardManage.isCallingAPI\" \r\n            ng-click=\"cardManage.addCard()\">Add card</button>\r\n            <hr class=\"m-t-2\">\r\n          </label>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _wbuGiftcard = __webpack_require__(249);
	
	var _wbuGiftcard2 = _interopRequireDefault(_wbuGiftcard);
	
	var _giftCard = __webpack_require__(250);
	
	var _giftCard2 = _interopRequireDefault(_giftCard);
	
	var _search = __webpack_require__(147);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _wbuPointer = __webpack_require__(149);
	
	var _wbuPointer2 = _interopRequireDefault(_wbuPointer);
	
	var _wbuMapPointer = __webpack_require__(150);
	
	var _wbuMapPointer2 = _interopRequireDefault(_wbuMapPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var giftCard = (_dec = (0, _utils.Component)({
	  controllerAs: 'giftCard',
	  template: _giftCard2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function giftCard($scope, $order, $state, $uibModal, $auth, $ngRedux, $spinner, $window, $stateParams, $cookies, APP, $rootScope, toaster, $timeout) {
	    var _this = this;
	
	    _classCallCheck(this, giftCard);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.dscCard = _WBUDSCCard2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$order = $order;
	    this.$state = $state;
	    this.gCard = _wbuGiftcard2.default;
	    // this.giftImage = 
	    this.toaster = toaster;
	    this.searchIcon = _search2.default;
	    this.agreement = false;
	    this.$uibModal = $uibModal;
	    this.$auth = $auth;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.APP = APP;
	    this.selectedGift = '';
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.higlightedmarkerIcon = _wbuPointer2.default;
	    this.markerIcon = _wbuMapPointer2.default;
	    this.$order.getStoreFeatures();
	
	    if ($stateParams.storeName) {
	      this.storeName = $stateParams.storeName;
	    } else {
	      this.storeName = this.$auth.getGuestStoreDetail().storeName;
	    }
	
	    if (this.storeName && !$auth.isLoggedIn()) {
	
	      $auth.getStoreDetail(this.storeName).then(function (success) {
	        var store = {};
	        store.storeId = success.data.storeId;
	        store.storeName = _this.storeName;
	        $auth.doGuestLogin(store);
	        $order.getGiftCards();
	      }, function (error) {
	        _this.$state.go('login');
	      });
	    } else {
	      $spinner.show('appSpinner');
	      $window.scrollTo(0, 0);
	      var storeName = '';
	      if (this.$stateParams.storeName) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile && this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else if (this.store) {
	          storeName = this.store.storeName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      var $ctrl;
	      $ctrl = this;
	      $order.getGiftCards().then(function () {
	        // $ctrl.gCard =  $ctrl.giftCards[0].largeImageUrl;
	        // console.log('Gift Loaded');
	      });
	      if (storeName) {
	
	        $order.getCartDetail().finally(function () {
	          $spinner.hide('appSpinner');
	          _this.$auth.getUserProfile();
	        });
	      } else {
	        $spinner.hide('appSpinner');
	      }
	    }
	
	    var listener3 = $rootScope.$on('storeSelected', function () {
	      _this.confirmChangeStore($rootScope.selectedStoreId, $rootScope.selectedStore);
	    });
	
	    $scope.$on('$destroy', disconnect);
	    listener3();
	
	    // this.isDscAdded = this.isDscAddedinCart();
	  }
	
	  _createClass(giftCard, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      // console.log(state);
	      return {
	        detail: state.order.cartDetail,
	        profile: state.auth.profile,
	        store: state.auth.storeDetail,
	        giftCards: state.order.giftCards,
	        storeFeatures: state.order.storeFeatures
	      };
	    }
	  }, {
	    key: 'isStoreSelected',
	    value: function isStoreSelected() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      return storeName && storeName != '';
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'buyGiftCard',
	    value: function buyGiftCard(quantity, masterCode) {
	      var _this2 = this;
	
	      if (this.$auth.isGuestLogin()) {
	        var msg = 'add this item to cart';
	        var cart = null;
	
	        cart = { 'quantity': quantity,
	          'itemId': this.selectedItemId,
	          'categoryId': this.selectedGift.masterProduct.category.id,
	          'subCategoryId': this.selectedGift.masterProduct.subCategories[0].id,
	          'isGiftCard': true,
	          'isDscCard': false,
	          'masterProductId': this.selectedGift.masterProduct.masterCode,
	          'deliveryType': this.selectedGift.deliveryType };
	
	        this.$auth.addtoGuestCart(cart);
	        this.toaster.pop('success', "Gift card added to cart");
	        // this.$auth.showLoginPopUp(msg);
	      } else {
	        this.$order.buyGiftCard(quantity, masterCode).then(function () {
	          // this.$auth.getUserProfile();
	          _this2.$state.go('cart');
	        });
	      }
	    }
	  }, {
	    key: 'isDscAddedinCart',
	    value: function isDscAddedinCart() {
	      return this.detail.cartItems.some(function (cartItem) {
	        return cartItem.item.storeItemCode === 'C';
	      });
	    }
	  }, {
	    key: 'confirmChangeStore',
	    value: function confirmChangeStore(storeId, store) {
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.storeId = storeId;
	      $ctrl.store = store;
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<div class="password-container margin-ten">' + '<input class="form-control" type="password" id="passwordIdGiftCard" ng-model="password" placeholder="Enter Password">' + '<i class="far fa-eye-slash" ng-click="togglePassword(\'passwordIdGiftCard\',\'togglePasswordGiftCard\')" id="togglePasswordGiftCard"\n                style="cursor: pointer;"></i></div>' + '<h5 class="font-weight-bold">Please enter your password to change your store</h5>' + '<p class="font-weight-bold" style="font-size:smaller">Please Note: You are changing your active home store. All WBU stores are locally owned and operated, and Daily Savings Club memberships are only valid at the store where purchased.  You may purchase a new DSC membership at your new home store. Club discounts, points balance, and Bird Bucks will be displayed for your active store if applicable. You may switch back to your original home store at any time and all eligible points, discounts, and Bird Bucks will be available. </p>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-disabled="!password" ng-click="ok()">OK</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Go Back</button>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', 'authService', '$stateParams', '$state', '$window', function ($scope, $uibModalInstance, $auth, $stateParams, $state, $window) {
	
	          $scope.togglePassword = function (passwordId, toggleId) {
	            $ctrl.$auth.togglePassword(passwordId, toggleId);
	          };
	
	          $scope.ok = function () {
	            // console.log($scope.password,  $ctrl.storeId);
	
	            var data = {
	              "newStoreId": $ctrl.storeId,
	              "password": $scope.password
	
	            };
	            $auth.changeStore(data).then(function (data) {
	              console.log("data", data);
	              // console.log(data);
	              if (data.status == 200) {
	                $ctrl.toaster.pop('success', data.statusText);
	                $ctrl.$timeout(function () {
	                  $stateParams.storeName = $ctrl.store;
	                  $state.go('gift-card', { 'storeName': $stateParams.storeName });
	                  //  location.reload();
	                  $uibModalInstance.close();
	                  // location.reload(); 
	                }, 1500);
	              } else {
	                $ctrl.toaster.pop('success', data.statusText);
	              }
	              // 
	            }).catch(function (err) {
	              $ctrl.toaster.pop('success', err.data.message);
	            });
	
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'showLoginPopUp',
	    value: function showLoginPopUp() {
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" > {{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          this.$state = $state;
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	          NgMap.getMap().then(function (map) {
	            // console.log('map', map);
	            $scope.map = map;
	          });
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	            // console.log('storeObj', storeObj);
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	
	            };
	            // if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.showRedirectStores = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              // console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            // if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.showRedirectStores = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              // console.log(success.data);
	              // this.test();
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	          $scope.selectStore = function (index, store, item) {
	            $scope.showStoreInfo(item, index, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.long = store.lng;
	          };
	
	          // InfoWindow fix for googlemap
	          $scope.changeStyle = function () {
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                      }
	                    }
	                  }
	                } catch (e) {
	                  // console.log("Some Error");
	                }
	              }
	            } else {
	                // console.log("Else part :");
	              }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToProductPage = function (store, item) {
	            $rootScope.selectedStoreId = store.id;
	            $rootScope.$emit('storeSelected');
	            $uibModalInstance.close();
	          };
	          $scope.goToSignUp = function (store, item) {
	            $rootScope.selectedStoreId = store.id;
	            $rootScope.selectedStore = item;
	            // $rootScope.$emit('storeSelected');
	            $ctrl.confirmChangeStore(store.id, item);
	            // $uibModalInstance.close();
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'openStoreSelector',
	    value: function openStoreSelector() {
	
	      if (this.$auth.isLoggedIn()) {
	        this.showLoginPopUp();
	        return;
	      }
	
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"   ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div id="searchResults" ng-if="stores.length > 0" style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore(store, $index)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" > {{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          this.$state = $state;
	
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	
	          NgMap.getMap().then(function (map) {
	            // console.log('map', map);
	            $scope.map = map;
	          });
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	            // console.log('storeObj', storeObj);
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	
	            };
	            // if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.showRedirectStores = true;
	            // }
	            $scope.stores = [];
	            var stores = $auth.getStoresbyZipcode(data);
	
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              // console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            // if ($ctrl.storeName==null || $ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.showRedirectStores = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              // console.log(success.data);
	              var elmnt = document.getElementById("searchResults");
	              elmnt.scrollTo(0, 0);
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	          $scope.selectStore = function (store, index) {
	            var item = store.storeURLName;
	            $scope.showStoreInfo(item, index, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.selectedIndex = index + 1;
	            $scope.long = store.lng;
	          };
	
	          // InfoWindow fix for googlemap
	          $scope.changeStyle = function () {
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                      }
	                    }
	                  }
	                } catch (e) {
	                  // console.log("Some Error");
	                }
	              }
	            } else {
	                // console.log("Else part :");
	              }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToSignUp = function (store, item) {
	            // console.log($stateParams);
	            $stateParams.storeName = item;
	            $auth.doGuestLogin(store);
	
	            // $window.location.href =  '/'+$stateParams.storeName;
	            $state.go('gift-card', { 'storeName': $stateParams.storeName });
	            // location.reload();
	            $uibModalInstance.close();
	            // $window.location.href = '/'+$stateParams.storeName + '/' +
	            // $stateParams.categoryId + '/'+ $stateParams.subCategoryId + '/' + $stateParams.productId;
	            // $uibModalInstance.close();
	            //  this.$state.go('signup', {
	            //    storeName: item
	            //  });
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'setGiftAmount',
	    value: function setGiftAmount(gift) {
	      this.selectedGift = gift;
	      this.isSelectedPrice = gift.price;
	      this.giftAmount = gift.price;
	      //  this.gCard = gift.largeImageUrl;
	      this.selectedMasterProduct = gift.masterProduct.masterCode;
	      this.selectedItemId = gift.id;
	    }
	  }]);
	
	  return giftCard;
	}(), _class2.$inject = ['$scope', 'orderService', '$state', '$uibModal', 'authService', '$ngRedux', 'spinnerService', '$window', '$stateParams', '$cookies', 'APP', '$rootScope', 'toaster', '$timeout'], _temp)) || _class);
	exports.default = giftCard;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9fa2aed881cd7f3dea4eb5d773a29bd4.png";

/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports = "<!--<navigation-bar class=\"sm-md-down\"></navigation-bar>-->\r\n<mobile-navigationbar class=\"hidden-md-up\"></mobile-navigationbar>\r\n<!-- Breadcrumb -->\r\n<nav class=\"breadcrumb xs-breadcrum-width breadcrum-bottom-margin bottom-shadow\">\r\n  <a class=\"nav\" ng-click=\"giftCard.goToHomePage()\">\r\n    <img class=\"breadcrumb-logo-icon\" src={{giftCard.houseIcon}} alt=\"logo\" />\r\n    <span>Home</span>\r\n  </a>\r\n  <span>Gift Card</span>\r\n</nav>\r\n\r\n<div class=\"static-content\" style=\"background-color: #fff;\">\r\n  <div class=\"row m-x-0 p-b-1 p-t-2\">\r\n    <div class=\"col-xs-12\">\r\n      <h6 class=\"font-weight-bold mb-8\">Gift Card</h6>\r\n      <div class=\"row\">\r\n        <span class=\"col-md-4 col-xs-12\">\r\n          <img style=\"width:100%;\" ng-src={{giftCard.gCard}} alt=\"image\" class=\"product-image\" />\r\n        </span>\r\n        <span class=\"col-md-8 col-xs-12\">\r\n          <div class=\"row col-xs-12\">\r\n            <form name=\"myForm\" class=\"row\">\r\n              <label class=\"col-md-12 pt-8\" ng-if=\"giftCard.giftCards && giftCard.giftCards.length > 0 && giftCard.isStoreSelected() \"><strong> Choose Gift\r\n                amount</strong> </label>\r\n              <label class=\"col-md-12 pt-8\" ng-if=\"giftCard.giftCards && giftCard.giftCards.length > 0 && giftCard.isStoreSelected() \">Get exactly what they want every time with a Wild Birds Unlimited gift card! Redeemable in-store and online at participating Wild Birds Unlimited locations.<span ng-if=\"giftCard.storeFeatures.paypal.hasEnabledForCustomer\"> Pay Later is not available for gift card purchases.</span></label> \r\n\r\n              <br />\r\n              <div class=\"col-md-12 pt-8\">\r\n                <label ng-if=\"(!giftCard.giftCards || !giftCard.giftCards.length ||  !giftCard.isStoreSelected() ) && (giftCard.store | json) !== '{}'\"> This store does not offer gift cards online.  To purchase gift cards, please call the store at {{giftCard.store.phoneNumber | telFormat}}. </label> <br />\r\n                <label ng-if=\"(!giftCard.giftCards || !giftCard.giftCards.length ||  !giftCard.isStoreSelected() ) && (giftCard.store | json) === '{}'\"> This store does not offer gift cards online.  To purchase gift cards, please call the store admin.</label> <br />\r\n                <button ng-if=\"giftCard.giftCards && giftCard.giftCards.length > 0 && giftCard.isStoreSelected()\" ng-repeat=\"card in giftCard.giftCards\" class=\"giftCard_priceCard\" ng-class=\" (giftCard.isSelectedPrice === card.price) ? 'selectedPrice' : ''\"\r\n                  ng-click=\"giftCard.setGiftAmount(card)\">${{card.price}}</button>\r\n\r\n                <div role=\"alert\" class=\"col-md-12 pt-8 error-text\">\r\n                  <span ng-show=\"!myForm.$valid && (myForm.input.$error.max || myForm.input.$error.min)\">\r\n                    Please Enter amount in the range between 25 to 200</span>\r\n                </div>\r\n                <br /> <br />\r\n            </form>\r\n\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 col-sm-6 col-md-6  pt-8\">\r\n              <button ng-if=\"!giftCard.giftCards ||  !giftCard.giftCards.length || !giftCard.isStoreSelected()\" class=\"btn btn-primary btn-block btn-md-text\"\r\n                ng-click=\"giftCard.openStoreSelector()\">Change Store</button>\r\n              <button ng-if=\"giftCard.giftCards && giftCard.giftCards.length > 0 && giftCard.store && giftCard.isStoreSelected() \" class=\"btn btn-primary btn-block btn-md-text\"\r\n                ng-click=\"giftCard.buyGiftCard(1,giftCard.selectedMasterProduct)\" ng-disabled=\"!giftCard.selectedMasterProduct\">Add\r\n                to Cart</button>\r\n              <!-- <div class=\"error-text\" ng-show=\"giftCard.isDscAddedinCart()\">Item has already been added to the cart</div> -->\r\n            </div>\r\n          </div>\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _paymentDetail = __webpack_require__(252);
	
	var _paymentDetail2 = _interopRequireDefault(_paymentDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var paymentDetail = (_dec = (0, _utils.Component)({
	  controllerAs: 'paymentDetail',
	  template: _paymentDetail2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function paymentDetail($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, Heartland) {
	    var _this = this;
	
	    _classCallCheck(this, paymentDetail);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    console.log("Calling payment-detail");
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.$toaster = $toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.APP = APP;
	    this.$spinner = $spinner;
	    this.giftCardNumbers = [];
	    this.totalGiftAmount = 0.00;
	
	    this.hasErplyPaymentInitialized = false;
	    this.heartand_Approval = "APPROVAL";
	    console.log("this.$stateParams.giftcardReq : ", this.$stateParams.giftcardReq);
	    this.giftCardsRequest = this.$stateParams.giftcardReq;
	    this.storeCreditAmountToBeCharged = this.$stateParams.storeCreditAmountToBeCharged;
	    $spinner.show('appSpinner');
	    $order.getOrderAmount(this.$stateParams.orderId).then(function (success) {
	      _this.orderAmount = success.data;
	      $order.getPaymentKeys().then(function (success) {
	        console.log("success -- ", success);
	        _this.paymentGlobalKey = success.data.globalKey;
	        // ----
	        _this.initializeHeartland(Heartland);
	      }).finally(function () {
	        _this.$order.printPaymentLogs(_this.$stateParams.orderId, null, " Heartland payment page.").then(function (success) {
	          console.log("Successfully Printed");
	        }).catch(function (err) {
	          console.log("Failed to print logs");
	        });
	        $spinner.hide('appSpinner');
	      });
	    });
	
	    this.$onDestroy = function () {
	      this.hps.dispose();
	    };
	  }
	
	  _createClass(paymentDetail, [{
	    key: 'initializeHeartland',
	    value: function initializeHeartland(Heartland) {
	      var defaultHPS = this.defaultHPS();
	      // console.log("defaultHPS: ",defaultHPS);
	      if (this.isMobileOnly()) {
	        defaultHPS.style['#heartland-field[name=submit]'] = {
	          'background-color': '#a4182d',
	          'font-family': 'sans-serif',
	          'text-transform': 'uppercase',
	          'color': '#ffffff',
	          'border': '0px solid transparent'
	          // 'width': '200px !important',
	          // 'margin-left':'5px  !important'
	        };
	      } else {
	        defaultHPS.style['#heartland-field[name=submit]'] = {
	          'background-color': '#a4182d',
	          'font-family': 'sans-serif',
	          'text-transform': 'uppercase',
	          'color': '#ffffff',
	          'border': '0px solid transparent',
	          'width': '200px !important',
	          'margin-left': '5px  !important'
	        };
	      }
	      // console.log("defaultHPS1: ",defaultHPS);
	      this.hps = new Heartland.HPS(defaultHPS);
	
	      this.$onDestroy = function () {
	        this.hps.dispose();
	      };
	    }
	  }, {
	    key: 'clearIframeFields',
	    value: function clearIframeFields() {
	      var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
	      var iframesG = angular.element(document.querySelector('#iframes'));
	      var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
	      var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
	      var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
	      var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      if (this.isGuestProfile()) {
	        this.$state.go('guestdelivery');
	      } else {
	        this.$state.go('delivery');
	      }
	    }
	  }, {
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'isGuestProfile',
	    value: function isGuestProfile() {
	      if (!this.profile || !this.profile.customer || this.profile.customer.isGuest) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'round',
	    value: function round(value) {
	      return value.toFixed(2);
	    }
	  }, {
	    key: 'getTotalGiftCardAddedAmount',
	    value: function getTotalGiftCardAddedAmount() {
	      var total = 0.00;
	      angular.forEach(this.giftCardsRequest, function (item, key) {
	        if (item) {
	          total = total + item.amount;
	        }
	      });
	      return total;
	    }
	  }, {
	    key: 'getStoreCreditAmount',
	    value: function getStoreCreditAmount() {
	      var storeCreditAmount = 0.00;
	      if (this.storeCreditAmountToBeCharged != null && this.storeCreditAmountToBeCharged > 0) {
	        storeCreditAmount = this.storeCreditAmountToBeCharged;
	      } else {
	        storeCreditAmount = 0.00;
	      }
	      return storeCreditAmount;
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      // return ( this.$window.innerWidth < 752 && this.$window.innerHeight < 752 );
	      return this.$window.innerWidth < 784;
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'defaultHPS',
	    value: function defaultHPS() {
	      var $ctrl = this;
	      return {
	        publicKey: this.paymentGlobalKey,
	        type: 'iframe',
	        // Configure the iframe fields to tell the library where
	        // the iframe should be inserted into the DOM and some
	        // basic options
	        fields: {
	          cardNumber: {
	            target: 'iframesCardNumber',
	            placeholder: 'xxxx xxxx xxxx xxxx'
	          },
	          cardExpiration: {
	            target: 'iframesCardExpiration',
	            placeholder: 'MM / YYYY'
	          },
	          cardCvv: {
	            target: 'iframesCardCvv',
	            placeholder: 'CVV'
	          },
	          submit: {
	            value: 'Pay $' + this.round($ctrl.orderAmount - this.getTotalGiftCardAddedAmount() - this.getStoreCreditAmount()),
	            target: 'iframesSubmit'
	          }
	        },
	        // Collection of CSS to inject into the iframes.
	        // These properties can match the site's styles
	        // to create a seamless experience.
	        style: {
	          'input': {
	            'background': '#fff',
	            'border': '1px solid',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'box-sizing': 'border-box',
	            'font-family': 'serif',
	            'font-size': '16px',
	            'line-height': '1',
	            'margin': '0 .5em 0 0',
	            'max-width': '100%',
	            'outline': '0',
	            'padding': '0.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'width': '100% !important'
	          },
	          '#heartland-field': {
	            'font-family': 'sans-serif',
	            'box-sizing': 'border-box',
	            'display': 'block',
	            'height': '50px',
	            'padding': '6px 12px',
	            'font-size': '14px',
	            'line-height': '1.42857143',
	            'color': '#555',
	            'background-color': '#fff',
	            'border': '1px solid #ccc',
	            'border-radius': '0px',
	            '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
	            'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
	            '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
	            '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
	            'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
	            'width': '100%'
	
	          },
	          '#heartland-field[name=submit]': {
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'color': '#ffffff',
	            'border': '0px solid transparent'
	            // 'width': '200px !important',
	            // 'margin-left':'5px  !important'
	          },
	          '#heartland-field[name=submit]:focus': {
	            'color': '#ffffff',
	            'background-color': '#a4182d',
	            'outline': 'none'
	          },
	          '#heartland-field[name=submit]:hover': {
	            'background-color': '#a4182d'
	          },
	          '#heartland-field-wrapper #heartland-field:focus': {
	            'border': '1px solid #3989e3',
	            'outline': 'none',
	            'box-shadow': 'none',
	            'height': '50px'
	          },
	          'heartland-field-wrapper #heartland-field': {
	            'height': '50px'
	
	          },
	          'input[type=submit]': {
	            'box-sizing': 'border-box',
	            'display': 'inline-block',
	            'padding': '6px 12px',
	            'margin-bottom': '0',
	            'font-size': '14px',
	            'font-weight': '400',
	            'line-height': '1.42857143',
	            'text-align': 'center',
	            'white-space': 'nowrap',
	            'vertical-align': 'middle',
	            '-ms-touch-action': 'manipulation',
	            'touch-action': 'manipulation',
	            'cursor': 'pointer',
	            '-webkit-user-select': 'none',
	            '-moz-user-select': 'none',
	            '-ms-user-select': 'none',
	            'user-select': 'none',
	            'background-image': 'none',
	            'border': '1px solid transparent',
	            'border-radius': '4px',
	            'color': '#fff',
	            'background-color': '#a4182d',
	            'border-color': '#2e6da4'
	
	          },
	          '#heartland-field[placeholder]': {
	            'letter-spacing': '3px'
	          },
	          '#heartland-field[name=cardCvv]': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
	            'background-size': '63px 40px'
	          },
	          'input#heartland-field[name=cardNumber]': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
	            'background-size': '55px 35px'
	          },
	          '#heartland-field.invalid.card-type-visa': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
	            'background-size': '83px 88px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-visa': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
	            'background-size': '82px 86px'
	          },
	          '#heartland-field.invalid.card-type-discover': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
	            'background-size': '85px 90px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-discover': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
	            'background-size': '85px 90px',
	            'background-position-y': '1px'
	          },
	          '#heartland-field.invalid.card-type-amex': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
	            'background-size': '50px 90px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-amex': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
	            'background-size': '50px 90px'
	          },
	          '#heartland-field.invalid.card-type-mastercard': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
	            'background-size': '62px 105px',
	            'background-position-y': '-52px'
	          },
	          '#heartland-field.valid.card-type-mastercard': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
	            'background-size': '62px 105px',
	            'background-position-y': '-1px'
	          },
	          '#heartland-field.invalid.card-type-jcb': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
	            'background-size': '55px 94px',
	            'background-position-y': '-44px'
	          },
	          '#heartland-field.valid.card-type-jcb': {
	            'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
	            'background-size': '55px 94px',
	            'background-position-y': '2px'
	          },
	          'input#heartland-field[name=cardNumber]::-ms-clear': {
	            'display': 'none'
	          }
	        },
	        // Callback when a token is received from the service
	        onTokenSuccess: function onTokenSuccess(resp) {
	          console.log("Token Success", resp.token_value);
	          $ctrl.$spinner.show('appSpinner');
	          var dataReq = {
	            "token": resp.token_value,
	            "orderId": $ctrl.$stateParams.orderId,
	            // "isNewCard": true,
	            "cardLast4": resp.last_four,
	            "cardType": resp.card_type,
	            "cardNumber": resp.card.number,
	            "expiryMonth": resp.exp_month,
	            "expiryYear": resp.exp_year,
	            "getGiftCardPreAuthRequest": {
	              "getGiftCardPreAuthCardRequestList": $ctrl.giftCardsRequest
	            },
	            "storeCreditAmountToBeCharged": $ctrl.storeCreditAmountToBeCharged
	          };
	
	          if (!$ctrl.hasErplyPaymentInitialized) {
	            $ctrl.hasErplyPaymentInitialized = true;
	            $ctrl.$order.initializePaymentHeartland(dataReq).then(function (success) {
	              $ctrl.hasErplyPaymentInitialized = false;
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.showHeartLandPage = false;
	              if (success.data.successCode === '00' && success.data.message === $ctrl.heartand_Approval) {
	                $ctrl.$state.go('payment.success', {
	                  orderId: $ctrl.$stateParams.orderId,
	                  isCardSaved: true
	                });
	              } else {
	                $ctrl.$state.go('payment.failure', {
	                  orderId: $ctrl.$stateParams.orderId,
	                  logString: JSON.stringify(success) + " - Heartland payment failed.",
	                  reasonCode: success.data.successCode
	                });
	              }
	            }, function (error) {
	              $ctrl.hasErplyPaymentInitialized = false;
	              $ctrl.showHeartLandPage = false;
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(error) + " - Heartland payment failed with some error."
	              });
	            }).catch(function (err) {
	              $ctrl.hasErplyPaymentInitialized = false;
	              $ctrl.showHeartLandPage = false;
	              console.log("Api call failure -  ", err);
	              $ctrl.$spinner.hide('appSpinner');
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(err) + " - Heartland payment failed error printed in catch."
	              });
	            });
	          }
	        },
	        // Callback when an error is received from the service
	        onTokenError: function onTokenError(resp) {
	          $ctrl.hasErplyPaymentInitialized = false;
	          $ctrl.showHeartLandPage = false;
	          console.log("Token Failed, card details might be wrong");
	          // $ctrl.$state.go('payment.failure', {
	          //   orderId: $ctrl.$stateParams.orderId
	          // });
	        },
	        // Callback when an event is fired within an iFrame
	        onEvent: function onEvent(ev) {
	          // console.log(ev);
	        }
	      };
	    }
	  }]);
	
	  return paymentDetail;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', '$stateParams', 'spinnerService', 'orderService', 'authService', '$window', 'APP', 'Heartland'], _temp)) || _class);
	exports.default = paymentDetail;

/***/ },
/* 252 */
/***/ function(module, exports) {

	module.exports = "<div class=\"hform-wrapper\" style=\"margin-left:30%\" ng-if=\"!paymentDetail.isMobileOnly()\">\r\n  <form id=\"iframes\" action=\"\" method=\"GET\" >\r\n    <div id=\"ss-banner\" style=\"margin-left:10%\"></div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 p-t-1 p-r-0\" style=\"width:20% !important\">\r\n        <label for=\"iframesCardNumber\">Card Number</label>\r\n      </div>\r\n      <div id=\"iframesCardNumber\" class=\"col-md-6 p-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6  p-t-1  p-r-0\" style=\"width:20% !important\">\r\n        <label for=\"iframesCardExpiration\">Card Expiration</label>\r\n      </div>\r\n      <div id=\"iframesCardExpiration\" class=\"col-md-6 p-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 p-t-1  p-r-0\" style=\"width:20% !important\">\r\n        <label for=\"iframesCardCvv\">Card CVV</label>\r\n      </div>\r\n      <div id=\"iframesCardCvv\" class=\"col-md-6 p-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6 m-t-1  col-sm-6 col-lg-6\">\r\n        <div id=\"iframesSubmit\"></div>\r\n      </div>\r\n      <div class=\"col-md-6 m-t-1 col-sm-6 col-lg-6\">\r\n        <button class=\"back\" ng-click=\"paymentDetail.goBack()\">Back</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n\r\n\r\n\r\n<div ng-if=\"paymentDetail.isMobileOnly()\">\r\n  <div style=\"margin:10px\">\r\n  <form id=\"iframes\" action=\"\" method=\"GET\" >\r\n    <div id=\"ss-banner\"></div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6\">\r\n        <label for=\"iframesCardNumber\">Card Number</label>\r\n      </div>\r\n      <div id=\"iframesCardNumber\" class=\"col-md-6 m-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6\">\r\n        <label for=\"iframesCardExpiration\">Card Expiration</label>\r\n      </div>\r\n      <div id=\"iframesCardExpiration\" class=\"col-md-6 m-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6\">\r\n        <label for=\"iframesCardCvv\">Card CVV</label>\r\n      </div>\r\n      <div id=\"iframesCardCvv\" class=\"col-md-6 m-b-1\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-6  m-b-1\">\r\n        <div id=\"iframesSubmit\"></div>\r\n      </div>\r\n      <div class=\"col-md-6  m-b-1\">\r\n        <button class=\"mobile_back\" ng-click=\"paymentDetail.goBack()\">Back</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n</div>\r\n\r\n\r\n<!-- <div class=\"form-row\">\r\n      <label for=\"iframesCardNumber\">Card Number:</label>\r\n      <div id=\"iframesCardNumber\"></div>\r\n    </div> -->\r\n\r\n<!-- <div class=\"form-row\">\r\n      <label for=\"iframesCardExpiration\">Card Expiration:</label>\r\n      <div id=\"iframesCardExpiration\"></div>\r\n    </div> -->\r\n\r\n<!-- <div class=\"form-row\">\r\n      <label for=\"iframesCardCvv\">Card CVV:</label>\r\n      <div id=\"iframesCardCvv\"></div>\r\n    </div> -->"

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _tsysPayment = __webpack_require__(254);
	
	var _tsysPayment2 = _interopRequireDefault(_tsysPayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var tsysPayment = (_dec = (0, _utils.Component)({
	  controllerAs: 'tsysPayment',
	  template: _tsysPayment2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function tsysPayment($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, GlobalPayments) {
	    var _this = this;
	
	    _classCallCheck(this, tsysPayment);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    console.log("Calling tsys-payment");
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.$toaster = $toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.APP = APP;
	    this.$spinner = $spinner;
	    this.giftCardNumbers = [];
	    this.totalGiftAmount = 0.00;
	
	    this.hasErplyPaymentInitialized = false;
	    this.heartand_Approval = "APPROVAL";
	    console.log("this.$stateParams.giftcardReq : ", this.$stateParams.giftcardReq);
	    this.giftCardsRequest = this.$stateParams.giftcardReq;
	    this.storeCreditAmountToBeCharged = this.$stateParams.storeCreditAmountToBeCharged;
	    $spinner.show('appSpinner');
	    $order.getOrderAmount(this.$stateParams.orderId).then(function (success) {
	      _this.orderAmount = success.data;
	      $order.getPaymentKeys().then(function (success) {
	        console.log("success -- ", success);
	        _this.paymentGlobalKey = success.data.globalKey;
	        _this.version = success.data.version;
	        _this.uuid = success.data.uuid;
	        _this.env = success.data.enviroment;
	        // ----
	        _this.initializeTsys(GlobalPayments);
	      }).finally(function () {
	        _this.$order.printPaymentLogs(_this.$stateParams.orderId, null, " Tsys payment page.").then(function (success) {
	          console.log("Successfully Printed");
	        }).catch(function (err) {
	          console.log("Failed to print logs");
	        });
	        $spinner.hide('appSpinner');
	      });
	    });
	
	    this.$onDestroy = function () {
	      this.hps.dispose();
	    };
	  }
	
	  _createClass(tsysPayment, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'isGuestProfile',
	    value: function isGuestProfile() {
	      if (!this.profile || !this.profile.customer || this.profile.customer.isGuest) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'initializeTsys',
	    value: function initializeTsys(GlobalPayments) {
	      var $ctrl = this;
	      GlobalPayments.configure({
	        'X-GP-Api-Key': this.paymentGlobalKey,
	        'X-GP-Environment': this.env,
	        'enableAutocomplete': true
	      });
	      var default_tsys = this.default_Tsys();
	
	      // console.log("Default_tsys : ", default_tsys.styles.button);
	      if (!this.isMobileOnly()) {
	        default_tsys.styles.button.width = "auto !important";
	      }
	
	      var cardForm = GlobalPayments.ui.form(default_tsys);
	
	      cardForm.on("token-success", function (resp) {
	        // add a payment token to form as a hidden input
	        console.log("token-success", resp);
	        var token = document.createElement("input");
	        token.type = "hidden";
	        token.name = "temporary_token";
	        token.value = "resp.temporary_token";
	
	        // submit temporary_token to backend, process with our gateway
	        // const form = document.getElementById("payment-form");
	        // form.appendChild(child);
	        // form.submit;
	
	        console.log("Token Success", resp.temporary_token);
	        $ctrl.$spinner.show('appSpinner');
	        var dataReq = {
	          "token": resp.temporary_token,
	          "orderId": $ctrl.$stateParams.orderId,
	          // "isNewCard": true,
	          "cardLast4": resp.card.masked_card_number,
	          "cardType": resp.card.type,
	          "cardNumber": resp.card.masked_card_number,
	          "expiryMonth": resp.card.expiry_month,
	          "expiryYear": resp.card.expiry_year,
	          "getGiftCardPreAuthRequest": {
	            "getGiftCardPreAuthCardRequestList": $ctrl.giftCardsRequest
	          },
	          "storeCreditAmountToBeCharged": $ctrl.storeCreditAmountToBeCharged
	        };
	
	        if (!$ctrl.hasErplyPaymentInitialized) {
	          $ctrl.hasErplyPaymentInitialized = true;
	          $ctrl.$order.initializePaymentTsys(dataReq).then(function (success) {
	            $ctrl.hasErplyPaymentInitialized = false;
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.showHeartLandPage = false;
	            if (success.data.successCode === '00' && success.data.message === $ctrl.heartand_Approval) {
	              $ctrl.$state.go('payment.success', {
	                orderId: $ctrl.$stateParams.orderId,
	                logString: JSON.stringify(success) + " - Tsys payment success.",
	                isCardSaved: true
	              });
	            } else {
	              $ctrl.$state.go('payment.failure', {
	                orderId: $ctrl.$stateParams.orderId,
	                reasonCode: success.data.successCode,
	                logString: JSON.stringify(success) + " - Tsys payment failed."
	              });
	            }
	          }, function (error) {
	            $ctrl.hasErplyPaymentInitialized = false;
	            $ctrl.showHeartLandPage = false;
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.$state.go('payment.failure', {
	              orderId: $ctrl.$stateParams.orderId,
	              logString: JSON.stringify(error) + " - Tsys payment failed with some error."
	            });
	          }).catch(function (err) {
	            $ctrl.hasErplyPaymentInitialized = false;
	            $ctrl.showHeartLandPage = false;
	            console.log("Api call failure -  ", err);
	            $ctrl.$spinner.hide('appSpinner');
	            $ctrl.$state.go('payment.failure', {
	              orderId: $ctrl.$stateParams.orderId,
	              logString: JSON.stringify(err) + " - Tsys payment failed error printed in catch."
	            });
	          });
	        }
	      });
	
	      cardForm.on("token-error", function (resp) {
	        // show error to the consumer 
	        console.log("token-error", resp);
	        $ctrl.hasErplyPaymentInitialized = false;
	        $ctrl.showHeartLandPage = false;
	        $ctrl.$spinner.hide('appSpinner');
	        $ctrl.$state.go('payment.failure', {
	          orderId: $ctrl.$stateParams.orderId,
	          logString: JSON.stringify(resp) + " - Tsys token-error. --Need to check--"
	        });
	      });
	
	      GlobalPayments.on("error", function (error) {
	        console.log("Global error", error);
	        $ctrl.hasErplyPaymentInitialized = false;
	        $ctrl.showHeartLandPage = false;
	        console.log("Api call failure -  ", error);
	        $ctrl.$spinner.hide('appSpinner');
	        $ctrl.$state.go('payment.failure', {
	          orderId: $ctrl.$stateParams.orderId,
	          logString: JSON.stringify(error) + " - Tsys GlobalPayments error. --Need to check--"
	        });
	      });
	
	      cardForm.on("card-number-test", function (resp) {
	        console.log("card-number-test", resp);
	        $ctrl.cardvalid = resp.valid;
	        $ctrl.submitButtonState(cardForm);
	        // console.log("card-number-test", resp);
	      });
	
	      cardForm.on("card-expiration-test", function (resp) {
	        // resp.valid will be “true” or “false”
	        console.log("card-expiration-test", resp);
	        $ctrl.expdatevalid = resp.valid;
	        $ctrl.submitButtonState(cardForm);
	        // console.log("card-expiration-test", resp);
	      });
	
	      cardForm.on("card-cvv-test", function (resp) {
	        console.log("card-cvv-tes", resp);
	        $ctrl.cvvalid = resp.valid;
	        $ctrl.submitButtonState(cardForm);
	        // console.log("card-cvv-test", resp);
	      });
	
	      // this.$onDestroy = function () {
	      //   this.cardForm.dispose();
	      // };
	    }
	  }, {
	    key: 'clearIframeFields',
	    value: function clearIframeFields() {
	      var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
	      var iframesG = angular.element(document.querySelector('#iframes'));
	      var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
	      var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
	      var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
	      var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      if (this.isGuestProfile()) {
	        this.$state.go('guestdelivery');
	      } else {
	        this.$state.go('delivery');
	      }
	    }
	  }, {
	    key: 'round',
	    value: function round(value) {
	      return value.toFixed(2);
	    }
	  }, {
	    key: 'getTotalGiftCardAddedAmount',
	    value: function getTotalGiftCardAddedAmount() {
	      var total = 0.00;
	      angular.forEach(this.giftCardsRequest, function (item, key) {
	        if (item) {
	          total = total + item.amount;
	        }
	      });
	      return total;
	    }
	  }, {
	    key: 'getStoreCreditAmount',
	    value: function getStoreCreditAmount() {
	      var storeCreditAmount = 0.00;
	      if (this.storeCreditAmountToBeCharged != null && this.storeCreditAmountToBeCharged > 0) {
	        storeCreditAmount = this.storeCreditAmountToBeCharged;
	      } else {
	        storeCreditAmount = 0.00;
	      }
	      return storeCreditAmount;
	    }
	  }, {
	    key: 'submitButtonState',
	    value: function submitButtonState(cardForm) {
	      var $ctrl = this;
	      // console.log("cardForm := ",cardForm);
	      // console.log($ctrl.cardvalid + ", " + $ctrl.expdatevalid + ", " + $ctrl.cvvalid);
	      if ($ctrl.cvvalid && $ctrl.cardvalid && $ctrl.expdatevalid) {
	        cardForm.addStylesheet({
	          "button": {
	            "pointer-events": "auto",
	            "opacity": "1",
	
	            'box-sizing': 'border-box',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'font-size': '15px',
	            'line-height': '1',
	            // 'width': 'auto !important',
	            'outline': '0',
	            'padding': '.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'border': '0 solid transparent',
	            'color': '#fff',
	            'cursor': 'pointer',
	            'flex': '0.61 1 auto !important'
	          }
	        });
	      } else {
	        cardForm.addStylesheet({
	          "button": {
	            "pointer-events": "none",
	            "opacity": ".5",
	
	            'box-sizing': 'border-box',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'font-size': '15px',
	            'line-height': '1',
	            // 'width': 'auto !important',
	            'outline': '0',
	            'padding': '.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'border': '0 solid transparent',
	            'color': '#fff',
	            // 'cursor': 'pointer',
	            'flex': '0.61 1 auto !important'
	          }
	        });
	      }
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      // return ( this.$window.innerWidth < 752 && this.$window.innerHeight < 752 );
	      return this.$window.innerWidth < 784;
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'default_Tsys',
	    value: function default_Tsys() {
	      var $ctrl = this;
	      return {
	        type: 'iframe',
	        fields: {
	          'card-number': {
	            target: '#card-number',
	            placeholder: 'xxxx xxxx xxxx xxxx'
	          },
	          'card-expiration': {
	            target: '#card-expiration',
	            placeholder: 'MM / YYYY'
	          },
	          'card-cvv': {
	            target: '#card-cvv',
	            placeholder: 'xxx'
	          },
	          'submit': {
	            text: 'Pay $' + this.round($ctrl.orderAmount - this.getTotalGiftCardAddedAmount() - this.getStoreCreditAmount()),
	            target: '#submit'
	          }
	        },
	
	        styles: {
	
	          "input": {
	            "outline": "none",
	            "border-width": "0",
	            "letter-spacing": "2px",
	            "width": "20px",
	            "height": "40px"
	          },
	          "input, select": {
	            "padding": "5px 10px",
	            "font-size": "13px",
	            "background": "#f3faff",
	            "border": "1px solid #e0f1ff",
	            "box-sizing": "border-box",
	            "width": "20px",
	            "height": "40px"
	          },
	          "input:focus": {
	            "-webkit-box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
	            "box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
	            "border-color": "#b0dcff !important",
	            "width": "20px",
	            "height": "40px"
	          },
	          "button": {
	            "pointer-events": "none",
	            "opacity": ".5",
	
	            'box-sizing': 'border-box',
	            'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
	            'font-size': '15px',
	            'line-height': '1',
	            // 'width': 'auto !important',
	            'outline': '0',
	            'padding': '.5278em',
	            'vertical-align': 'baseline',
	            'height': '50px',
	            'background-color': '#a4182d',
	            'font-family': 'sans-serif',
	            'text-transform': 'uppercase',
	            'border': '0 solid transparent',
	            'color': '#fff',
	            // 'cursor': 'pointer',
	            'flex': '0.61 1 auto !important'
	          },
	          "button:active": {
	            "filter": "brightness(112%)",
	            "text-align": "center"
	          },
	          ".card-number.card-type-visa": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
	            "background-position-y": "0px",
	            "background-size": "70px 75px",
	            "width": "50px"
	          },
	          ".card-number.card-type-mastercard": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
	            "background-position-y": "4px",
	            "background-size": "60px 64px"
	          },
	          ".card-number.card-type-discover": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
	            "background-position-y": "-5px",
	            "background-size": "90px 96px"
	          },
	          ".card-number.card-type-jcb": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
	            "background-position-y": "0px",
	            "background-size": "48px 82px"
	          },
	          ".card-number.card-type-amex": {
	            "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
	            "background-position-y": "-4px",
	            "background-size": "55px 98px"
	          }
	        }
	      };
	    }
	  }]);
	
	  return tsysPayment;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', '$stateParams', 'spinnerService', 'orderService', 'authService', '$window', 'APP', 'GlobalPayments'], _temp)) || _class);
	exports.default = tsysPayment;

/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = "<div id=\"tsys1\" class=\"row\" ng-if=\"!tsysPayment.isMobileOnly()\">\r\n    <div class=\"col-xs-5 offset-md-4\">\r\n        <div class=\"row\">\r\n            <div class=\"col-xs-4\">\r\n                <label for=\"card-number\">Card Number</label>\r\n            </div>\r\n            <div class=\"col-xs-8\">\r\n                <div id=\"card-number\" class=\"\"></div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row m-t-1\">\r\n            <div class=\"col-xs-4\">\r\n                <label for=\"card-expiration\">Card expiration</label>\r\n            </div>\r\n            <div class=\"col-xs-8\">\r\n                <div id=\"card-expiration\" class=\"\"></div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row  m-t-1\">\r\n            <div class=\"col-xs-4\">\r\n                <label for=\"card-cvv\">Card CVV</label>\r\n            </div>\r\n            <div class=\"col-xs-8\">\r\n                <div id=\"card-cvv\" class=\"\"></div>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"row m-t-2\">\r\n             <div class=\"col-xs-6\">\r\n                <div id=\"submit\" class=\"\"></div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-6\">\r\n                <button class=\"back-btn\" ng-click=\"tsysPayment.goBack()\">Back</button>\r\n            </div>\r\n        </div>\r\n        \r\n    </div>\r\n</div>\r\n\r\n<!-- Mobile -->\r\n<div id=\"tsys1\" class=\"row\" ng-if=\"tsysPayment.isMobileOnly()\">\r\n    <div class=\"col-xs-5 offset-md-4\">\r\n            <div class=\"col-xs-12\" style=\"margin-top:5px\">\r\n                <label for=\"card-number\">Card Number</label>\r\n            </div>\r\n            <div class=\"col-xs-12\" style=\"margin-top:5px\">\r\n                <div id=\"card-number\" class=\"\"></div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-12\" style=\"margin-top:5px\">\r\n                <label for=\"card-expiration\">Card expiration</label>\r\n            </div>\r\n            <div class=\"col-xs-12\" style=\"margin-top:5px\">\r\n                <div id=\"card-expiration\" class=\"\"></div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-12\" style=\"margin-top:5px\">\r\n                <label for=\"card-cvv\">Card CVV</label>\r\n            </div>\r\n            <div class=\"col-xs-12\" style=\"margin-top:5px\">\r\n                <div id=\"card-cvv\" class=\"\"></div>\r\n            </div>\r\n        \r\n             <div class=\"col-xs-12\" style=\"margin-top:10px\">\r\n                <div id=\"submit\" class=\"\"></div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-12\" style=\"margin-top:10px\">\r\n                <button class=\"back-btn_mobile\" ng-click=\"tsysPayment.goBack()\">Back</button>\r\n            </div>\r\n    </div>\r\n</div>"

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _monerisPayment = __webpack_require__(256);
	
	var _monerisPayment2 = _interopRequireDefault(_monerisPayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var monerisPayment = (_dec = (0, _utils.Component)({
	  controllerAs: 'monerisPayment',
	  template: _monerisPayment2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function monerisPayment($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, MonerisCheckout) {
	    var _this = this;
	
	    _classCallCheck(this, monerisPayment);
	
	    this.$onDestroy = function () {
	      console.log('inside destroy');
	      if (this.APP.ORDER.MONERIS_LOADED.loaded) {
	        if (window.addEventListener) {
	          this.APP.ORDER.MONERIS_LOADED.loaded = false;
	          window.removeEventListener("message", this.respMsg, false);
	        } else {
	          if (window.attachEvent) {
	            window.detachEvent("onmessage", this.respMsg);
	          }
	        }
	      }
	    };
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    console.log("Calling moneris-payment");
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$order = $order;
	    this.$toaster = $toaster;
	    this.logoIcon = _smallLogo2.default;
	    this.houseIcon = _houseIcon2.default;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.APP = APP;
	    this.$spinner = $spinner;
	    this.giftCardNumbers = [];
	    this.totalGiftAmount = 0.00;
	    this.moneris_Approval = "APPROVAL";
	    this.hasPaymentInitialized = false;
	    console.log("Moneris this.$stateParams.giftcardReq : ", this.$stateParams.giftcardReq);
	    this.giftCardsRequest = this.$stateParams.giftcardReq;
	    this.storeCreditAmountToBeCharged = this.$stateParams.storeCreditAmountToBeCharged;
	    this.count = 0;
	    this.respMsg;
	
	    var $ctrl = this;
	    $spinner.show('appSpinner');
	    if (window.innerWidth < 768) {
	      console.log('mobileView');
	      this.mobileView = true;
	    } else {
	      this.mobileView = false;
	    }
	    $order.getOrderAmount(this.$stateParams.orderId).then(function (success) {
	      _this.orderAmount = success.data;
	      _this.amountToPay = _this.round(_this.orderAmount - _this.getTotalGiftCardAddedAmount() - _this.getStoreCreditAmount());
	      if (window.innerWidth < 768) {
	        console.log('inside mobile');
	      }
	      $order.getPaymentKeys().then(function (success) {
	        console.log("success -- ", success);
	        _this.paymentGlobalKey = success.data.globalKey;
	        _this.monerisUrl = success.data.url;
	        if (window.innerWidth < 768) {
	          console.log('inside mobile');
	          document.getElementById("monerisFrame").src = _this.monerisUrl + "?id=" + _this.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&enable_exp_formatting=1&enable_cc_formatting=1" + "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" + "&css_label_pan=;margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
	        } else {
	          // src="https://esqa.moneris.com/HPPtoken/index.php?id=htP312OIJMXU6F6&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&css_textbox_pan=width:250px;&enable_exp=1&css_textbox_exp=width:250px;&enable_cvd=1&css_textbox_cvd=width:250px;&display_labels=1&css_label_pan=color:green;" 
	          document.getElementById("monerisFrame").src = _this.monerisUrl + "?id=" + _this.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&enable_exp_formatting=1&enable_cc_formatting=1" + "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" + "&css_label_pan=;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
	        }
	        _this.env = success.data.enviroment;
	      }).finally(function () {
	        _this.$order.printPaymentLogs(_this.$stateParams.orderId, null, " Moneris payment page.").then(function (success) {
	          console.log("Successfully Printed");
	        }).catch(function (err) {
	          console.log("Failed to print logs");
	        });
	        $spinner.hide('appSpinner');
	      });
	    });
	
	    $ctrl.respMsg = function (e) {
	      console.log("RespMsg get called ", e);
	      // var respData = eval("(" + e.data + ")");
	      // var resCode = `${respData.responseCode}`;
	      // var resDataKey = `${respData.dataKey}`;
	
	      var parsingJson = JSON.parse(e.data);
	
	      // console.log("Parsing Json : ",parsingJson);
	      // console.log("dataKey : ",parsingJson.dataKey);
	      console.log("responseCode : ", parsingJson.responseCode);
	
	      var resCode = parsingJson.responseCode;
	      var resDataKey = parsingJson.dataKey;
	
	      if (resCode != null) {
	        // resCode = resCode.split(',');
	        console.log("ResCode : ", resCode, " : ResCode length: ", resCode.length);
	        if (resCode.length > 0) {
	          if (resCode[0] == '001') {
	            $ctrl.chargeNewCardMoneris(resDataKey, $ctrl.count);
	          } else {
	            var srcLink = '';
	            if (window.innerWidth < 768) {
	              console.log('inside mobile');
	              srcLink = $ctrl.monerisUrl + "?id=" + $ctrl.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&enable_exp_formatting=1&enable_cc_formatting=1" + "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
	
	              if (resCode[0] == 943) {
	                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_pan=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
	              } else if (resCode[0] == 944) {
	                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_exp=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
	              } else if (resCode[0] == 945) {
	                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_cvd=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
	              } else {
	                $ctrl.$toaster.pop('success', 'Payment Not success. Please contact store');
	                console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
	                $ctrl.goBack();
	              }
	            } else {
	              srcLink = $ctrl.monerisUrl + "?id=" + $ctrl.paymentGlobalKey + "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" + "&enable_exp_formatting=1&enable_cc_formatting=1" + "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
	
	              if (resCode[0] == 943) {
	                srcLink = srcLink + "&css_label_pan=color: darkslategrey;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_textbox_pan=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
	              } else if (resCode[0] == 944) {
	                srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=color: darkslategrey;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_label_cvd=margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_textbox_exp=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
	              } else if (resCode[0] == 945) {
	                srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" + "&css_label_cvd=color: darkslategrey;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" + "&css_textbox_cvd=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" + "padding: 6px 12px;line-height: 1.42;" + "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
	              } else {
	                $ctrl.$toaster.pop('success', 'Payment Not success. Please contact store');
	                console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
	                $ctrl.goBack();
	              }
	            }
	            document.getElementById("monerisFrame").src = srcLink;
	          }
	        }
	      }
	    };
	
	    if (!this.APP.ORDER.MONERIS_LOADED.loaded) {
	      this.APP.ORDER.MONERIS_LOADED.loaded = true;
	      console.log("Adding once this.respMsg : ", this.respMsg);
	      if (window.addEventListener) {
	        window.addEventListener("message", this.respMsg, false);
	      } else {
	        if (window.attachEvent) {
	          window.attachEvent("onmessage", this.respMsg);
	        }
	      }
	    }
	  }
	
	  _createClass(monerisPayment, [{
	    key: 'goBack',
	    value: function goBack() {
	      if (this.isGuestProfile()) {
	        this.$state.go('guestdelivery');
	      } else {
	        this.$state.go('delivery');
	      }
	    }
	  }, {
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        profile: state.auth.profile
	      };
	    }
	  }, {
	    key: 'isGuestProfile',
	    value: function isGuestProfile() {
	      if (!this.profile || !this.profile.customer || this.profile.customer.isGuest) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'round',
	    value: function round(value) {
	      return value.toFixed(2);
	    }
	  }, {
	    key: 'doMonerisSubmit',
	    value: function doMonerisSubmit() {
	      this.$spinner.show('appSpinner');
	      var monFrameRef = document.getElementById('monerisFrame').contentWindow;
	      console.log("monFrameRef : ", monFrameRef);
	      monFrameRef.postMessage('tokenize', this.monerisUrl);
	      this.$spinner.hide('appSpinner');
	      return false;
	    }
	  }, {
	    key: 'getTotalGiftCardAddedAmount',
	    value: function getTotalGiftCardAddedAmount() {
	      var total = 0.00;
	      angular.forEach(this.giftCardsRequest, function (item, key) {
	        if (item) {
	          total = total + item.amount;
	        }
	      });
	      return total;
	    }
	  }, {
	    key: 'getStoreCreditAmount',
	    value: function getStoreCreditAmount() {
	      var storeCreditAmount = 0.00;
	      if (this.storeCreditAmountToBeCharged != null && this.storeCreditAmountToBeCharged > 0) {
	        storeCreditAmount = this.storeCreditAmountToBeCharged;
	      } else {
	        storeCreditAmount = 0.00;
	      }
	      return storeCreditAmount;
	    }
	  }, {
	    key: 'chargeNewCardMoneris',
	    value: function chargeNewCardMoneris(token, callCount) {
	      var $ctrl = this;
	
	      console.log("Inide charge card Count : ", callCount);
	      console.log("$ctrl.hasPaymentInitialized : ", $ctrl.hasPaymentInitialized);
	      if (!$ctrl.hasPaymentInitialized) {
	        $ctrl.hasPaymentInitialized = true;
	        $ctrl.$spinner.show('appSpinner');
	        console.log("Charging moneris card");
	        var dataReq = {
	          "token": token,
	          "action": "charge",
	          "orderId": $ctrl.$stateParams.orderId,
	          // "isNewCard": true,
	          // "cardLast4": resp.card.masked_card_number,
	          "getGiftCardPreAuthRequest": {
	            "getGiftCardPreAuthCardRequestList": $ctrl.giftCardsRequest
	          },
	          "storeCreditAmountToBeCharged": $ctrl.storeCreditAmountToBeCharged
	        };
	        $ctrl.$order.monerisProcess(dataReq).then(function (success) {
	          $ctrl.hasPaymentInitialized = false;
	          $ctrl.$spinner.hide('appSpinner');
	          $ctrl.showHeartLandPage = false;
	          if (success.data.successCode === '00' && success.data.message === $ctrl.moneris_Approval) {
	            $ctrl.$state.go('payment.success', {
	              orderId: $ctrl.$stateParams.orderId,
	              isCardSaved: true
	            });
	          } else {
	            $ctrl.$state.go('payment.failure', {
	              orderId: $ctrl.$stateParams.orderId,
	              logString: JSON.stringify(success) + " - Moneris payment failed.",
	              reasonCode: success.data.successCode
	            });
	          }
	        }, function (error) {
	          $ctrl.hasPaymentInitialized = false;
	          $ctrl.showHeartLandPage = false;
	          $ctrl.$spinner.hide('appSpinner');
	          $ctrl.$state.go('payment.failure', {
	            orderId: $ctrl.$stateParams.orderId,
	            logString: JSON.stringify(error) + " - Moneris payment failed with some error."
	          });
	        }).catch(function (err) {
	          $ctrl.hasPaymentInitialized = false;
	          $ctrl.showHeartLandPage = false;
	          console.log("Api call failure -  ", err);
	          $ctrl.$spinner.hide('appSpinner');
	          $ctrl.$state.go('payment.failure', {
	            orderId: $ctrl.$stateParams.orderId,
	            logString: JSON.stringify(err) + " - Moneris payment failed error printed in catch."
	          });
	        });
	      } else {
	        console.log(" Moneris Payment already iniitalized");
	      }
	    }
	  }]);
	
	  return monerisPayment;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', '$stateParams', 'spinnerService', 'orderService', 'authService', '$window', 'APP', 'MonerisCheckout'], _temp)) || _class);
	exports.default = monerisPayment;

/***/ },
/* 256 */
/***/ function(module, exports) {

	module.exports = "<html>\r\n<head>\r\n<title> Outer Frame - Merchant Page</title>\r\n</head>\r\n<body>\r\n\r\n\t\t<!-- <input type=\"text\" ng-model=\"monerisPayment.dummytoken\"></input><button ng-click=\"monerisPayment.chargeNewCardMoneris()\">Click here to pass token</button> -->\r\n\t\t<!-- <div id=\"monerisResponse\"></div> -->\r\n\t\t\t<div class=\"moneris_payment\">\r\n\t\t\t\t<div id=\"ss-banner-moneris\"></div>\r\n\t\t\t\t<div ng-if=\"monerisPayment.mobileView\">\r\n\t\t\t\t\t<iframe id=\"monerisFrame\" frameborder='0' width=\"500px\"  height=\"270px\"></iframe>\r\n\t\t\t\t  </div>\r\n\t\t\t\t  <div ng-if=\"!monerisPayment.mobileView\">\r\n\t\t\t\t\t<iframe id=\"monerisFrame\" frameborder='0' width=\"500px\"  height=\"230px\"></iframe>\r\n\t\t\t\t  </div>\r\n\t\t\t\t\r\n\t\t\t\t<div class=\"mb-50\">\r\n\t\t\t\t\t<button class=\"back-btn moneris_payment_submit\" ng-click=\"monerisPayment.doMonerisSubmit()\">PAY ${{monerisPayment.amountToPay}}</button>\r\n\t\t\t\t\t<button class=\"back-btn moneris_payment_back\" ng-click=\"monerisPayment.goBack()\">Back</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div> \r\n</body>\r\n</html>"

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sidenav = __webpack_require__(258);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _header = __webpack_require__(260);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _authHeader = __webpack_require__(271);
	
	var _authHeader2 = _interopRequireDefault(_authHeader);
	
	var _navigationBar = __webpack_require__(273);
	
	var _navigationBar2 = _interopRequireDefault(_navigationBar);
	
	var _mobileNavBar = __webpack_require__(276);
	
	var _mobileNavBar2 = _interopRequireDefault(_mobileNavBar);
	
	var _directive = __webpack_require__(279);
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _directive3 = __webpack_require__(281);
	
	var _directive4 = _interopRequireDefault(_directive3);
	
	var _telFormat = __webpack_require__(282);
	
	var _telFormat2 = _interopRequireDefault(_telFormat);
	
	var _navLogin = __webpack_require__(283);
	
	var _navLogin2 = _interopRequireDefault(_navLogin);
	
	var _navMenu = __webpack_require__(285);
	
	var _navMenu2 = _interopRequireDefault(_navMenu);
	
	var _productPromo = __webpack_require__(287);
	
	var _productPromo2 = _interopRequireDefault(_productPromo);
	
	var _storePromo = __webpack_require__(290);
	
	var _storePromo2 = _interopRequireDefault(_storePromo);
	
	var _storeSelector = __webpack_require__(292);
	
	var _storeSelector2 = _interopRequireDefault(_storeSelector);
	
	var _directive5 = __webpack_require__(294);
	
	var _directive6 = _interopRequireDefault(_directive5);
	
	var _constants = __webpack_require__(82);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.components', []).component('sidenav', _sidenav2.default).component('header', _header2.default).constant('APP', _constants2.default).component('authHeader', _authHeader2.default).component('navigationBar', _navigationBar2.default).component('mobileNavigationbar', _mobileNavBar2.default).directive('imgLazyLoader', _directive2.default).directive('imgLazyLoaderLarge', _directive4.default).component('navlogin', _navLogin2.default).component('navMenu', _navMenu2.default).component('productPromo', _productPromo2.default).component('storePromo', _storePromo2.default).component('storeSelector', _storeSelector2.default).filter('telFormat', _telFormat2.default).directive('thumbnailSlider', _directive6.default);

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _user = __webpack_require__(146);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _hamburger = __webpack_require__(189);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _sidenav = __webpack_require__(259);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'sidenav',
	  template: _sidenav2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function SidenavContainer($rootScope, $scope, $ngRedux, $state, $location, toaster, $auth, $order, $uibModal, $stateParams, APP, $cookies) {
	    _classCallCheck(this, SidenavContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.toaster = toaster;
	    this.$auth = $auth;
	    this.user = _user2.default;
	    this.logo = _smallLogo2.default;
	    this.back = _hamburger2.default;
	    this.$uibModal = $uibModal;
	    this.APP = APP;
	    this.$stateParams = $stateParams;
	    this.$cookies = $cookies;
	    this.version_number = APP.AUTH.AUTH_URL.version.num;
	
	    var guestStore = null;
	    try {
	      guestStore = sessionStorage.getItem('guestStoreName');
	    } catch (e) {
	      guestStore = $cookies.get('guestStoreName');
	    }
	    if (guestStore) {
	      $order.getGiftCards();
	    }
	    // $order.getCategories();
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(SidenavContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	
	      return {
	        profile: state.auth.profile,
	        categories: state.order.categories,
	        giftCards: state.order.giftCards
	      };
	    }
	  }, {
	    key: 'closeSideNav',
	    value: function closeSideNav() {
	      this.$rootScope.$emit('closeSideNav');
	    }
	  }, {
	    key: 'goToOrders',
	    value: function goToOrders() {
	
	      if (!this.$auth.isLoggedIn()) {
	        var msg = 'access this';
	        this.$auth.showLoginPopUp(msg);
	      } else {
	        this.$state.go('recent-order');
	      }
	    }
	  }, {
	    key: 'goToSubscriptions',
	    value: function goToSubscriptions() {
	
	      if (!this.$auth.isLoggedIn()) {
	        var msg = 'access this';
	        this.$auth.showLoginPopUp(msg);
	      } else {
	        this.$state.go('subscription');
	      }
	    }
	  }, {
	    key: 'goToSavingsClub',
	    value: function goToSavingsClub() {
	      this.closeSideNav();
	      this.$state.go('savings-club', { 'storeName': this.$auth.getGuestStoreDetail().storeName });
	    }
	  }, {
	    key: 'goToNextState',
	    value: function goToNextState(item) {
	      // console.log(item);
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        if (item.category.name === item.subCategoryList[0].name) {
	          this.$state.go('browse-product', {
	            categoryId: item.category.prettyUrl,
	            subCategoryId: item.subCategoryList[0].prettyUrl,
	            storeName: storeName
	          });
	        } else {
	          // console.log('sc',item.category.id);
	          this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl,
	            storeName: storeName });
	        }
	      } else {
	        if (item.category.name === item.subCategoryList[0].name) {
	          this.$state.go('browse-product', {
	            categoryId: item.category.prettyUrl,
	            subCategoryId: item.subCategoryList[0].prettyUrl,
	            storeName: 'shop'
	          });
	        } else {
	          // console.log('sc',item.category.id);
	          this.$state.go('browse-sub-category', { categoryId: item.category.prettyUrl, storeName: 'shop' });
	        }
	      }
	    }
	  }, {
	    key: 'openToast',
	    value: function openToast() {
	      this.toaster.pop('success', 'This Feature will be available soon');
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.$auth.logout(this.profile);
	    }
	  }, {
	    key: 'syncedToday',
	    value: function syncedToday() {
	      var syncDate = new Date(this.profile.customer.lastSyncDateTime);
	      var currentDate = new Date();
	      return syncDate.getDate() === currentDate.getDate();
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$auth.isLoggedIn();
	    }
	  }]);
	
	  return SidenavContainer;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$state', '$location', 'toaster', 'authService', 'orderService', '$uibModal', '$stateParams', 'APP', '$cookies'], _temp)) || _class);
	exports.default = SidenavContainer;

/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gray-bg\" ng-click=\"sidenav.closeSideNav()\">\r\n\r\n  <div class=\"media\">\r\n    <div class=\"media-left sidenav-link sidenav-p-y sidenav-p-l sidenav-mobile-top sidenav-back-color\">\r\n      <img alt=\"User\"\r\n        ng-src=\"{{sidenav.back}}\"\r\n        class=\"media-object sidenav-user-img\" />\r\n    </div>\r\n    <div class=\"media-body sidenav-p-y sidenav-p-l\">\r\n      <h6 class=\"m-b-0\">\r\n        <strong class=\"sidenav-font\">Hello,\r\n          <span ng-if=\"sidenav.profile.customer.firstName\">{{sidenav.profile.customer.firstName.length > 12 ?\r\n        (sidenav.profile.customer.firstName | limitTo : 12) : sidenav.profile.customer.firstName}}\r\n        </span>\r\n          <span ng-if=\"!sidenav.profile.customer.email\">Guest</span></strong></h6>\r\n      <p class=\"font-weight-normal m-b-0 sidenav-sub-text\">\r\n          <span ng-if=\"sidenav.profile.billingCity\">\r\n            <small><strong>{{sidenav.profile.billingCity}},</strong></small>\r\n          </span>\r\n          <span ng-if=\"sidenav.profile.billingState.name\"><small><strong>{{sidenav.profile.billingState.name}}</strong></small></span>\r\n      </p>\r\n    </div>\r\n\r\n    <div class=\"media-right sidenav-p-y sidenav-p-r sidenav-mobile-top p-l-0\" ng-if=\"sidenav.profile.customer.email\">\r\n      <button class=\"btn btn-primary edit-btn\" ui-sref=\"profile\"  >View Profile</button>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n<div class=\"dsc-padding dsr-bg\" ng-if=\"sidenav.isDscMember() || sidenav.isDscButExpired()\">\r\n  <h6 class=\"dsc-bold\">Daily Savings Club Member</h6>\r\n  <div><small>Valid Through: {{sidenav.profile.customer.dscExpireDate | date: 'MM/dd/yyyy'}}</small></div>\r\n  <div ng-if=\"sidenav.isDscMember()\"><small>Current Points: {{(sidenav.profile.customer.totalPoints | number: 2) || 0}}</small></div>\r\n  <div ng-if=\"sidenav.isDscButExpired()\"><s uib-tooltip=\"Your Club Membership has expired\"><small>Current Points Balance: {{(sidenav.profile.customer.totalPoints | number : 2) || 0}}</small></s></div>\r\n</div>\r\n\r\n<div class=\"list-group p-a-0 sidenav-list\">\r\n  <a href class=\"list-group-item list-group-item-action\"\r\n    ng-repeat=\"item in sidenav.categories\"\r\n    ng-bind=\"item.category.name\"\r\n    ng-click=\"sidenav.goToNextState(item); sidenav.closeSideNav();\"></a>\r\n  <a href ng-click=\"sidenav.goToOrders(); sidenav.closeSideNav()\" class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\">My Orders</a>\r\n  <a href ng-click=\"sidenav.goToSubscriptions(); sidenav.closeSideNav()\" class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\" ng-if=\"sidenav.profile.store.isSubscription\">My Subscriptions</a> \r\n  <a ng-if=\"sidenav.isLoggedIn()\" ui-sref=\"changepassword\"  class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\" >Change Password</a>\r\n  <a ng-if=\"sidenav.isLoggedIn()\" ui-sref=\"cards-management\"  class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\" >Manage Credit Cards</a>\r\n  <a href  class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.goToSavingsClub()\">Daily Savings Club</a>\r\n  <a ui-sref=\"gift-card\" class=\"list-group-item list-group-item-action\">Gift Card</a>\r\n  <!--<a ui-sref=\"settings\" ng-if=\"sidenav.profile.customer.email\" class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\">Preferences</a>-->\r\n  <a ui-sref=\"terms-conditions\" class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\">Terms of Use</a>\r\n  <a ui-sref=\"rules-faq\" class=\"list-group-item list-group-item-action\" ng-if=\"sidenav.profile.customer.email\"\r\n    ng-click=\"sidenav.closeSideNav()\">Rules / FAQ</a>\r\n  <a ui-sref=\"privacy\" class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\">Privacy</a>\r\n <!-- <a ui-sref=\"storelocator\" class=\"list-group-item list-group-item-action\"\r\n    ng-click=\"sidenav.closeSideNav()\">Store Locator</a>-->\r\n  <a href class=\"list-group-item list-group-item-action\" ng-if=\"sidenav.profile.customer.email\"\r\n    ng-click=\"sidenav.closeSideNav(); sidenav.logout();\">Logout</a>\r\n</div>\r\n\r\n<div class=\"sidemenu-logo m-t-2\">\r\n  <img src=\"{{sidenav.logo}}\" />\r\n  <div> <small>V - {{sidenav.version_number}}</small></div>\r\n</div>\r\n"

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _back = __webpack_require__(261);
	
	var _back2 = _interopRequireDefault(_back);
	
	var _menu = __webpack_require__(262);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _logoS = __webpack_require__(110);
	
	var _logoS2 = _interopRequireDefault(_logoS);
	
	var _cart = __webpack_require__(263);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _appLogo = __webpack_require__(264);
	
	var _appLogo2 = _interopRequireDefault(_appLogo);
	
	var _delete = __webpack_require__(265);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _search = __webpack_require__(147);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	var _header = __webpack_require__(266);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _cartIcon = __webpack_require__(267);
	
	var _cartIcon2 = _interopRequireDefault(_cartIcon);
	
	var _headerText = __webpack_require__(268);
	
	var _headerText2 = _interopRequireDefault(_headerText);
	
	var _storeIcon = __webpack_require__(269);
	
	var _storeIcon2 = _interopRequireDefault(_storeIcon);
	
	var _wbuPointer = __webpack_require__(149);
	
	var _wbuPointer2 = _interopRequireDefault(_wbuPointer);
	
	var _wbuMapPointer = __webpack_require__(150);
	
	var _wbuMapPointer2 = _interopRequireDefault(_wbuMapPointer);
	
	var _dropDown = __webpack_require__(270);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HeaderContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'header',
	  template: _header2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function HeaderContainer($rootScope, $scope, $ngRedux, $window, $state, $uibModal, $interval, $aside, $auth, $order, $cookies, $location, $timeout, $stateParams, toaster, APP, $spinner) {
	    var _this = this;
	
	    _classCallCheck(this, HeaderContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$window = $window;
	    this.$aside = $aside;
	    this.$uibModal = $uibModal;
	    this.$order = $order;
	    this.$interval = $interval;
	    this.$state = $state;
	    this.$spinner = $spinner;
	    this.backIcon = _back2.default;
	    this.menuIcon = _menu2.default;
	    this.Headertext = _headerText2.default;
	    this.logo = _logoS2.default;
	    this.$cookies = $cookies;
	    this.$location = $location;
	    this.cart = _cart2.default;
	    this.cartIcon = _cartIcon2.default;
	    this.StoreIcon = _storeIcon2.default;
	    this.APP = APP;
	    this.dropDown = _dropDown2.default;
	    this.myData = "Logo";
	    this.templateUrl = 'login.html';
	    this.popoverTriggerOption = "outsideClick";
	    this.deleteIcon = _delete2.default;
	    this.searchIcon = _search2.default;
	    this.shopLogo = _appLogo2.default;
	    this.promosliderClass = "";
	    this.promotionText = "";
	    this.promosliderClass = "";
	    this.nextIndex = 0;
	    this.$stateParams = $stateParams;
	    this.markerIcon = _wbuMapPointer2.default;
	    this.higlightedmarkerIcon = _wbuPointer2.default;
	    this.toaster = toaster;
	    this.isMiscelleneousCategory = 4;
	    this.hasBirdbuckCoupons = false;
	    // this.popovercontent = subCategories;
	
	
	    this.navStates = [{
	      current: 'home',
	      heading: 'Welcome'
	    }, {
	      current: 'cart',
	      heading: 'My Cart'
	    }, {
	      current: 'guestCart',
	      heading: 'Guest Cart'
	    }, {
	      current: 'guestdelivery',
	      heading: 'Guest Checkout'
	    }, {
	      current: 'profile',
	      heading: 'Profile Setting'
	    }, {
	      current: 'profile.edit',
	      heading: 'Profile Setting'
	    }, {
	      current: 'category',
	      heading: 'Choose Category'
	    }, {
	      current: 'sub-category',
	      heading: 'Choose Sub-Category'
	    }, {
	      current: 'product',
	      heading: 'Choose Product'
	    }, {
	      current: 'product.detail',
	      heading: 'Product Detail'
	    }, {
	      current: 'store-detail',
	      heading: 'Store Details'
	    }, {
	      current: 'delivery',
	      heading: 'Delivery'
	    }, {
	      current: 'delivery.address',
	      heading: 'Delivery Address'
	    }, {
	      current: 'settings',
	      heading: 'Settings'
	    }, {
	      current: 'terms-conditions',
	      heading: 'Terms and Conditions'
	    }, {
	      current: 'rules-faq',
	      heading: 'Rules / FAQ'
	    }, {
	      current: 'faq-birds-critters',
	      heading: 'Birds & Critters'
	    }, {
	      current: 'faq-franchising',
	      heading: 'Franchising'
	    }, {
	      current: 'faq-product-warranties',
	      heading: 'Product Warranties'
	    }, {
	      current: 'privacy',
	      heading: 'Privacy'
	    }, {
	      current: 'card-detail',
	      heading: 'Card Detail'
	    }, {
	      current: 'payment.success',
	      heading: 'Confirmed'
	    }, {
	      current: 'payment.failure',
	      heading: 'Failed'
	    }, {
	      current: 'recent-order',
	      heading: 'Your Orders'
	    }, {
	      current: 'accessibility',
	      heading: 'Accessibility Statement'
	    }];
	    this.$auth = $auth;
	    this.$timeout = $timeout;
	    if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      this.storeName = $stateParams.storeName;
	    } else {
	      this.storeName = this.$auth.getGuestStoreDetail().storeName;
	    }
	    if (this.storeName && !$auth.isLoggedIn()) {
	      $auth.getStoreDetail(this.storeName).then(function (success) {
	        var store = {};
	        store.storeId = success.data.storeId;
	        store.storeName = _this.storeName;
	        $auth.doGuestLogin(store);
	        if (!_this.$stateParams.categoryId || _this.subCategories.length == 0) {
	          _this.$order.getCategories();
	          _this.$order.getTiles();
	        }
	        var storeId = null;
	        _this.guestStore = $auth.getGuestStoreDetail();
	
	        var guestStore = null;
	        if ($auth.isGuestLogin()) {
	          try {
	            guestStore = sessionStorage.getItem('guestStoreName');
	          } catch (e) {
	            guestStore = $cookies.get('guestStoreName');
	          }
	          if (!_this.profile.store.storeId) {
	            _this.$auth.getStoreDetail(guestStore).then(function (success) {
	              // console.log(success);
	              _this.getPromos(success.storeId);
	            });
	          } else {
	            _this.getPromos(_this.profile.store.storeId);
	          }
	          $auth.getGuestCart();
	        }
	      }, function (error) {
	        // console.log(error);
	        // this.$state.go('login');
	        // this.$state.go('login');
	        /*   let store = {};
	           store.storeId = '';
	           store.storeName = 'shop';
	           $auth.doGuestLogin(store);
	           if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
	             this.$order.getCategories();
	           }
	           this.getPromos(store.storeName);*/
	        _this.$state.go('category', {
	          storeName: ''
	        });
	      });
	    } else if (!this.storeName && !$auth.isLoggedIn()) {
	      var store = {};
	      store.storeId = '';
	      store.storeName = '';
	      $auth.doGuestLogin(store);
	      $auth.getGuestCart();
	      if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
	        this.$order.getCategories();
	        this.$order.getTiles();
	      }
	      this.getPromos(store.storeName);
	    } else {
	
	      $auth.getUserProfile().then(function () {
	        _this.getPromos(_this.profile.store.storeId);
	      });
	
	      $auth.getBBDetails().then(function (success) {
	        console.log("BB details ", success.data);
	        if (success && success.data) {
	          _this.hasBirdbuckCoupons = success.data.hasBirdbucks;
	        }
	      });
	      // Commented for UI Issue
	      this.checkIdleTime = this.checkIdleTime.bind(this);
	      this.sessionTimeout();
	      this.templateUrl = 'menu.html';
	      this.popoverTriggerOption = 'focus';
	      if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
	        this.$order.getCategories();
	        this.$order.getTiles();
	      }
	    }
	
	    var listener1 = $rootScope.$on('guestLoginConfirmed', function () {
	      return _this.guestLoginConfirmed();
	    });
	    var listener2 = $rootScope.$on('closeSideNav', function () {
	      return $rootScope.asideInstance.close();
	    });
	    var listener3 = $rootScope.$on('onLoginSuccess', function () {
	      return _this.toggleHeader();
	    });
	    var listener4 = $rootScope.$on('forbidden', function () {
	      return _this.gotToHome();
	    });
	    var listener5 = $rootScope.$on('onStoreSelection', function () {
	      return _this.toggleHeaderGuest();
	    });
	    // eslint-disable-next-line arrow-parens
	    var listener6 = $rootScope.$on('loginFromPopup', function ($event, data) {
	      return _this.loginFromPopup(data);
	    });
	    $scope.$on('$destroy', function () {
	      $interval.cancel(_this.stopCheckIdleTime);
	      disconnect();
	      listener1();
	      listener2();
	      listener3();
	      listener4();
	      listener5();
	      listener6();
	    });
	  }
	
	  _createClass(HeaderContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      var obj = {
	        profile: state.auth.profile,
	        subCategories: state.order.categories,
	        tiles: state.order.tiles,
	        products: state.order.products,
	        productDetail: state.order.productDetail,
	        cartDetail: state.order.cartDetail,
	        promo: state.order.promoImage,
	        guestCartCount: state.auth.guestCartList && state.auth.guestCartList.length && state.auth.guestCartList.filter(function (data) {
	          return !data.isDscCard;
	        }).length ? state.auth.guestCartList.filter(function (data) {
	          return !data.isDscCard;
	        }).map(function (data) {
	          return data.quantity;
	        }).reduce(function (total, data) {
	          return total + data;
	        }) : 0
	      };
	
	      if (!obj.profile.store) {
	        obj.profile = {
	          'store': state.auth.storeDetail
	        };
	      }
	      return obj;
	    }
	  }, {
	    key: 'openStoreSelector',
	    value: function openStoreSelector() {
	      this.$rootScope.$emit('onStoreSelection');
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div style="max-height:441px; overflow-y: auto; overflow-x: hidden;"><div  ng-click="goToSignUp(store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1 " >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          var _this2 = this;
	
	          this.$state = $state;
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.count = '';
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	
	          NgMap.getMap().then(function (map) {
	            console.log('map', map);
	            $scope.map = map;
	          });
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	            console.log('storeObj', storeObj);
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	
	            };
	            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.isSEORequest = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.isSEORequest = true;
	            // }
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              console.log(success.data);
	              // this.test();
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	          $scope.selectStore = function (store, item) {
	            $scope.showStoreInfo(item, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.long = store.lng;
	          };
	
	          // InfoWindow fix for googlemap
	          $scope.changeStyle = function () {
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                      }
	                    }
	                  }
	                } catch (e) {
	                  // console.log("Some Error");
	                }
	              }
	            } else {
	                // console.log("Else part :");
	              }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToProductPage = function (store, item) {
	            console.log($stateParams);
	            $stateParams.storeName = item;
	            $window.location.href = '/' + $stateParams.storeName + '/' + $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
	            // $uibModalInstance.close();
	            //  this.$state.go('signup', {
	            //    storeName: item
	            //  });
	          };
	          $scope.goToSignUp = function (store, item) {
	            console.log($stateParams);
	            // $stateParams.storeName = item;
	            // $window.location.href = '/'+$stateParams.storeName + '/' +
	            // $stateParams.categoryId + '/'+ $stateParams.subCategoryId + '/' + $stateParams.productId;
	
	            $uibModalInstance.close();
	            _this2.$state.go('signup', {
	              storeName: item
	            });
	          };
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'sessionTimeout',
	    value: function sessionTimeout() {
	      var _this3 = this;
	
	      this.IDLE_TIMEOUT = 1800; // 1800; // seconds
	      this.idleCounter = 0;
	      document.onclick = function () {
	        return _this3.idleCounter = 0;
	      };
	      // document.onmousemove = () => this.idleCounter = 0;
	      document.onkeypress = function () {
	        return _this3.idleCounter = 0;
	      };
	      this.stopCheckIdleTime = this.$interval(this.checkIdleTime, 1000);
	    }
	  }, {
	    key: 'checkIdleTime',
	    value: function checkIdleTime() {
	      this.idleCounter++;
	      // console.log('idleCounter', this.idleCounter);
	      if (this.idleCounter >= this.IDLE_TIMEOUT) {
	        this.askForLogout();
	        this.$interval.cancel(this.stopCheckIdleTime);
	      }
	    }
	  }, {
	    key: 'isStoreAvailabe',
	    value: function isStoreAvailabe() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        return storeName;
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'goToRegister',
	    value: function goToRegister() {
	      if (this.isStoreAvailabe()) {
	        this.$window.location.href = '/signup/' + this.isStoreAvailabe();
	      } else {
	        this.openStoreSelector();
	      }
	    }
	  }, {
	    key: 'goToLogin',
	    value: function goToLogin() {
	      var storeName = '';
	      console.log(this.$stateParams);
	      // if(this.guestStore&&this.guestStore.storeName) {
	      //   storeName = '/'+this.guestStore.storeName;
	      // }
	      // this.$window.location.href = '/login' + storeName;
	
	      //
	      if (this.guestStore && this.guestStore.storeName) {
	        storeName = this.guestStore.storeName;
	      }
	      this.$state.go('login', {
	        productId: this.$stateParams.productId,
	        categoryId: this.$stateParams.categoryId,
	        subCategoryId: this.$stateParams.subCategoryId,
	        storeName: storeName
	      });
	      //  
	    }
	  }, {
	    key: 'askForLogout',
	    value: function askForLogout() {
	      var $ctrl = this;
	      this.$uibModal.open({
	        sizede: 'sm',
	        backdrop: false,
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">Your session will expire in one minute. Do you want to continue shopping?</h5>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="continueShopping()">Yes</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="logout()">No</button>' + '</div>',
	        controller: ['$scope', '$rootScope', '$interval', 'authService', 'orderService', '$uibModalInstance', function ($scope, $rootScope, $interval, $auth, $order, $uibModalInstance) {
	          var Timer = 60;
	          var counter = 0;
	          $scope.lastCheck = function () {
	            counter++;
	            // console.log('counter', counter);
	            if (counter >= Timer) $scope.logout();
	          };
	          var stopLastCheck = $interval($scope.lastCheck, 1000);
	
	          $scope.continueShopping = function () {
	            $ctrl.sessionTimeout();
	            $interval.cancel(stopLastCheck);
	            $uibModalInstance.close();
	          };
	
	          $scope.logout = function () {
	            $uibModalInstance.dismiss('cancel');
	            $interval.cancel(stopLastCheck);
	            $rootScope.$emit('closeSideNav');
	            $auth.logout($ctrl.profile);
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'getHeaderTitle',
	    value: function getHeaderTitle(obj) {
	      if (this.$window.innerWidth <= 0) {
	        if (obj.current === 'home') {
	          return this.profile.customer ? 'Welcome ' + this.profile.customer.firstName : 'Welcome';
	        } else if (obj.current === 'sub-category') {
	          return this.subCategories.length ? this.subCategories[0].category.name : 'Choose Category';
	        } else if (obj.current === 'product') {
	          return this.products.length ? this.products[0].itemList[0].subCategory.name : 'Choose Product';
	        } else if (obj.current === 'product.detail') {
	          return this.productDetail.name ? this.productDetail.name : 'Product Detail';
	        } else {
	          return obj.heading;
	        }
	      } else {
	        return this.profile.customer ? 'Welcome ' + this.profile.customer.firstName : 'Welcome';
	      }
	    }
	  }, {
	    key: 'getPrevState',
	    value: function getPrevState() {
	      var _this4 = this;
	
	      return this.navStates.filter(function (state) {
	        return state.current === _this4.$state.current.name;
	      })[0];
	    }
	  }, {
	    key: 'goToPrevState',
	    value: function goToPrevState() {
	      this.$window.history.back();
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      if (!this.searchTerm || this.searchTerm == '') {
	        this.toaster.pop('success', 'Search text should not be empty');
	        return;
	      }
	      this.$state.go('search', {
	        storeName: this.profile.store.storeURLName,
	        searchTerm: this.searchTerm
	      });
	    }
	  }, {
	    key: 'openAside',
	    value: function openAside(position) {
	      this.$rootScope.asideInstance = this.$aside.open({
	        template: '<sidenav></sidenav>',
	        placement: position,
	        backdrop: true
	      });
	    }
	  }, {
	    key: 'removeCart',
	    value: function removeCart() {
	      this.$uibModal.open({
	        size: 'sm',
	        template: '<div class="modal-body" id="modal-body">' + '<h5 class="font-weight-bold">Are you sure you want to remove all items in your cart?</h5>' + '</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' + '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' + '</div>',
	        controller: ['$scope', 'orderService', '$uibModalInstance', 'authService', function ($scope, $order, $uibModalInstance, $auth) {
	          var _this5 = this;
	
	          $scope.ok = function () {
	            $order.removeCart().then(function () {
	              $order.getCartDetail();
	              _this5.$rootScope.deliveryMode = null;
	              $auth.getUserProfile();
	            });
	            $uibModalInstance.close();
	          };
	          $scope.cancel = function () {
	            return $uibModalInstance.dismiss('cancel');
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'isMobileOnly',
	    value: function isMobileOnly() {
	      return this.$window.innerWidth < 543;
	    }
	  }, {
	    key: 'getDscPoints',
	    value: function getDscPoints() {
	      return Math.floor(this.profile.customer.totalPoints);
	    }
	  }, {
	    key: 'getDscExpireDate',
	    value: function getDscExpireDate() {
	      if (!this.profile.customer) return false;
	      return new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isDscMember',
	    value: function isDscMember(userData) {
	      // console.log("userData--",userData)
	      if (userData && userData.user && userData.user.customer) {
	        if (!userData.user.customer) return false;
	        return userData.user.customer.dscId === 'C' && new Date() <= new Date(userData.user.customer.dscExpireDate);
	      } else {
	        if (!this.profile.customer) return false;
	        return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
	      }
	    }
	  }, {
	    key: 'isDscButExpired',
	    value: function isDscButExpired() {
	      if (!this.profile.customer) return false;
	      return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
	    }
	  }, {
	    key: 'isRenewButtonToBeShown',
	    value: function isRenewButtonToBeShown() {
	      if (!this.profile.customer) return false;
	
	      if (this.profile.customer.dscExpireDate) {
	
	        var d1 = new Date(this.profile.customer.dscExpireDate);
	        var renewCriteriadate = new Date(d1.setDate(d1.getDate() - 45));
	
	        //  console.log("Date: ", new Date());
	        // console.log("!this.canUserJoin() ", !this.canUserJoin() );
	        // console.log("renewCriteriadate", renewCriteriadate);
	        // console.log("this.profile.customer.email", this.profile.customer.email);
	        // console.log("renewCriteriadate<new Date()", renewCriteriadate<new Date());
	        return !this.canUserJoin() && this.profile.customer.email && renewCriteriadate < new Date();
	      }
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.$auth.logout();
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'selectedItem',
	    value: function selectedItem(item) {
	      // console.log(selectedItem);
	    }
	  }, {
	    key: 'goToNextState',
	    value: function goToNextState(item) {
	      // console.log(item);
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.profile.store && this.profile.store.storeName) {
	          storeName = this.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        if (this.isMiscellaneousCategory(item)) {
	          this.goToGiftPage(storeName);
	        } else {
	          if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
	            this.$state.go('browse-product', {
	              categoryId: item.category.prettyUrl,
	              subCategoryId: item.subCategoryList[0].prettyUrl,
	              storeName: storeName
	            });
	          } else {
	            // console.log('sc',item.category.id);
	            this.$state.go('browse-sub-category', {
	              categoryId: item.category.prettyUrl,
	              storeName: storeName
	            });
	          }
	        }
	      } else {
	        if (this.isMiscellaneousCategory(item)) {
	          this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
	        } else {
	          if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
	            this.$state.go('browse-product', {
	              categoryId: item.category.prettyUrl,
	              subCategoryId: item.subCategoryList[0].prettyUrl,
	              storeName: this.$auth.getGuestStoreDetail().storeName
	            });
	          } else {
	            // console.log('sc',item.category.id);
	            this.$state.go('browse-sub-category', {
	              categoryId: item.category.prettyUrl, storeName: 'shop'
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'toggleHeader',
	    value: function toggleHeader() {
	      if (this.$auth.isLoggedIn()) {
	        // console.log('logged in');
	        this.$auth.getUserProfile();
	        this.checkIdleTime = this.checkIdleTime.bind(this);
	        this.sessionTimeout();
	        this.templateUrl = 'menu.html';
	        this.popoverTriggerOption = 'outsideClick';
	        document.getElementById('headerAction').click();
	      }
	    }
	  }, {
	    key: 'toggleHeaderGuest',
	    value: function toggleHeaderGuest() {
	
	      // this.checkIdleTime = this.checkIdleTime.bind(this);
	      // this.sessionTimeout();
	      this.checkIdleTime = this.checkIdleTime.bind(this);
	      this.sessionTimeout();
	      this.templateUrl = 'login.html';
	      this.popoverTriggerOption = 'outsideClick';
	      document.getElementById('headerAction').click();
	    }
	  }, {
	    key: 'goToCart',
	    value: function goToCart() {
	      if (this.$auth.isGuestLogin()) {
	        if (this.profile.store && this.profile.store.hasGuestCheckout) {
	          this.$state.go('guestcart', { 'storeName': this.storeName });
	        } else {
	          var msg = 'access this';
	          this.$auth.showLoginPopUp(msg);
	        }
	      } else {
	        this.$state.go('cart');
	      }
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.$location.path().indexOf('auth') === -1 && this.$state.current.name !== 'login' && this.$state.current.name !== 'signup';
	    }
	  }, {
	    key: 'guestLoginConfirmed',
	    value: function guestLoginConfirmed() {
	      if (this.$auth.isMobileDevice()) {
	        this.$state.go('login', {
	          'storeName': this.$auth.getGuestStoreDetail().storeName,
	          productId: this.$stateParams.productId,
	          categoryId: this.$stateParams.categoryId,
	          subCategoryId: this.$stateParams.subCategoryId
	        });
	      } else {
	        this.$timeout(function () {
	          document.getElementById('headerAction').click();
	        }, 100);
	      }
	    }
	  }, {
	    key: 'getPromos',
	    value: function getPromos(storeId) {
	      var _this6 = this;
	
	      this.$order.getPromoImage(storeId).then(function () {
	        _this6.$rootScope.promo = _this6.promo;
	        // if(this.isMobileOnly()){
	        //   this.bannerSlider_Mob();
	        // } else {
	        //   this.bannerSlider();
	        // }
	        _this6.bannerSlider();
	
	        _this6.$rootScope.$emit('rotateBanner');
	        _this6.$rootScope.$emit('rotateMobileBanner');
	      });
	    }
	  }, {
	    key: 'canUserJoin',
	    value: function canUserJoin() {
	      return !this.$auth.isLoggedIn() || !(this.isDscMember() || this.isDscButExpired());
	    }
	  }, {
	    key: 'goToSavingsClub',
	    value: function goToSavingsClub() {
	      this.$state.go('savings-club', {
	        'storeName': this.$auth.getGuestStoreDetail().storeName
	      });
	    }
	  }, {
	    key: 'gotToHome',
	    value: function gotToHome() {
	      if (this.profile.store.storeName) {
	        this.$window.location.href = '/' + this.profile.store.storeName;
	      } else {
	        this.$window.location.href = '/';
	      }
	    }
	  }, {
	    key: 'bannerSlider',
	    value: function bannerSlider() {
	      var _this7 = this;
	
	      this.promosliderClass = "";
	
	      if (this.promo) {
	        this.promotionText = this.promo.promotionText[0];
	        this.promosliderClass = "promotion-slider";
	        this.$interval(function () {
	          // console.log("Interval :",this.nextIndex," | ",new Date());
	          _this7.nextIndex = _this7.promo.promotionText.length - 1 == _this7.nextIndex ? 0 : _this7.nextIndex + 1;
	          _this7.promotionText = _this7.promo.promotionText[_this7.nextIndex];
	          _this7.promosliderClass = "promotion-slider";
	        }, 10000);
	      }
	    }
	  }, {
	    key: 'bannerSlider_Mob',
	    value: function bannerSlider_Mob() {
	
	      this.promosliderClass = "";
	
	      if (this.promo) {
	        this.promotionText = this.promo.promotionText[0];
	        this.promosliderClass = "promotion-slider";
	        var i = 0;
	        var sliderDocElement = document.getElementById("promotion-slider");
	        var testWidth = sliderDocElement.clientWidth;
	        var finalTextWidth = sliderDocElement.clientWidth;
	        var defaultDelay = 10;
	        var newDelay = 10;
	        var text = this.promotionText;
	        console.log("TestWidth : ", testWidth);
	        var timeOutValue = 10;
	        var setTimeForAnimeDuration = "10s";
	        var $ctrl = this;
	        var r = document.querySelector(':root');
	
	        //    Initial
	        finalTextWidth = document.createElement("canvas").getContext("2d").measureText(text).width;
	
	        if (finalTextWidth < testWidth) {
	          newDelay = 10;
	        } else {
	          newDelay = defaultDelay * (finalTextWidth / testWidth);
	        }
	
	        setTimeForAnimeDuration = newDelay + "s";
	        timeOutValue = newDelay * 1000;
	        r.style.setProperty('--li-transform-animation-duration', setTimeForAnimeDuration);
	        sliderDocElement.classList.remove("promotion-slider");
	        void sliderDocElement.offsetWidth;
	        sliderDocElement.classList.add("promotion-slider");
	
	        sliderDocElement.innerHTML = "<span '>" + $ctrl.promotionText + "</span>";
	
	        var timer = setTimeout(function promoDelay() {
	          $ctrl.nextIndex = $ctrl.promo.promotionText.length - 1 == $ctrl.nextIndex ? 0 : $ctrl.nextIndex + 1;
	          $ctrl.promotionText = $ctrl.promo.promotionText[$ctrl.nextIndex];
	          text = $ctrl.promotionText;
	          finalTextWidth = document.createElement("canvas").getContext("2d").measureText(text).width;
	
	          if (finalTextWidth < testWidth) {
	            newDelay = 10;
	          } else {
	            newDelay = defaultDelay * (finalTextWidth / testWidth);
	          }
	
	          setTimeForAnimeDuration = newDelay + "s";
	          timeOutValue = newDelay * 1000;
	          r.style.setProperty('--li-transform-animation-duration', setTimeForAnimeDuration);
	          console.log("Text: " + $ctrl.promotionText + ", SetTimeForAnimeDuration : ", setTimeForAnimeDuration, ", TimeOutValue : ", timeOutValue);
	
	          // To Reset the animation, remove and add same class, void offsetwidth is avoid some glitch
	          // https://css-tricks.com/restart-css-animation/
	          sliderDocElement.classList.remove("promotion-slider");
	          void sliderDocElement.offsetWidth;
	          sliderDocElement.classList.add("promotion-slider");
	
	          sliderDocElement.innerHTML = "<span '>" + $ctrl.promotionText + "</span>";
	
	          timer = setTimeout(promoDelay, timeOutValue);
	        }, timeOutValue);
	
	        /*
	        this.$interval(() => {
	          // console.log("Interval :",this.nextIndex," | ",new Date());
	          this.nextIndex = (this.promo.promotionText.length - 1 == this.nextIndex) ? 0 : this.nextIndex + 1;
	          this.promotionText = this.promo.promotionText[this.nextIndex];
	          document.getElementById("promotion-slider").innerHTML = "<span  style='position: absolute;'>"+this.promotionText+"</span>";
	          this.promosliderClass = "promotion-slider";
	          }, 10000);
	        */
	      }
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }, {
	    key: 'isMiscellaneousCategory',
	    value: function isMiscellaneousCategory(item) {
	      if (item) {
	        if (item.category.id === this.isMiscelleneousCategory) {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    }
	  }, {
	    key: 'goToGiftPage',
	    value: function goToGiftPage(store) {
	      this.$state.go('gift-card', { 'storeName': store });
	    }
	  }, {
	    key: 'loginFromPopup',
	    value: function loginFromPopup(success) {
	      console.log("Success loged in --- ", success);
	      if (success.data && success.data.store && success.data.store.storeCode == this.APP.ORDER.CLOSED_STORE.storeCode) {
	        this.$state.go('profile');
	      } else {
	        if (success.data.dscPop) {
	          this.dscPopContent = success.data.dscPop;
	          this.dscPopUp(success.data.dscPop, success);
	        } else {
	          this.loadFunction(success);
	        }
	      }
	    }
	  }, {
	    key: 'dscPopUp',
	    value: function dscPopUp(dscPop, successData) {
	      this.$rootScope.$emit('onLoginSuccess');
	      this.dscPop = dscPop;
	      var $ctrl = this;
	      this.$uibModal.open({
	        size: 'md',
	        template: '<div class="static-content" style="background-color: #fff;">' + '<div class="row m-x-0 p-b-1 p-t-2">' + '<div class="col-xs-12">' +
	        // '<h6 class="font-weight-bold mb-8">Daily Savings Club&reg; Exclusive Member Benefits</h6>'+
	        '<div class="row">' +
	        // '<span class="inline_block">'+
	        // '<img img-lazy-loader={{dscCard}} alt="image" class="product-image" />'+
	        // '</span>'+
	        '<span class="inline_block">' + '<p ng-if="dscPop.dscExpired==0"> Your Daily Savings Club membership will expire in less than 30 days. Renew today so you don&apos;t miss any savings!</p>' + '<p ng-if="dscPop.dscExpired==1"> Your Daily Savings Club membership has expired. Renew today so you don&apos;t miss any savings! </p>' +
	        // '<span>'+
	        // '<span>Renew to add as a member of our Daily Savings Club®, for your annual membership fee of $25, you receive:</span>'+
	        // '</span>'+
	        '<div>' + '<span style="line-height: 13px;">' + '<span class="white-med-bold-text " style="display:inline-block">' + '<button  class="renew_dsc_button btn btn-primary detail-btn mockup-btn" ui-sref="savings-club" ng-click="cancel()">Renew</button>' + '</span>' + '</span>' + '<div style="line-height: 13px;float:right;">' + '<span class="white-med-bold-text " style="display:inline-block">' + '<button  style="width:100%" class="pull-xs-right renew_dsc_button btn btn-primary detail-btn mockup-btn" ng-click="ok()">No, Thanks</button>' + '</span>' + '</div>' + '</div>' + '</span>' + '</div>' + '</div>' + '</div>' + '</div>',
	        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	          var _this8 = this;
	
	          $scope.dscCard = _WBUDSCCard2.default;
	          $scope.dscPop = dscPop;
	          $scope.cancel = function () {
	            $ctrl.userAction(_this8.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON);
	            $uibModalInstance.close();
	          };
	          $scope.ok = function () {
	            $uibModalInstance.close();
	            $ctrl.loadFunction(successData);
	          };
	        }]
	      });
	    }
	  }, {
	    key: 'loadFunction',
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(success) {
	        var _this9 = this;
	
	        var profile, guestCartList, subscription, store, guestCart, guestCartListFiltered;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                profile = success.data.user;
	
	                this.$rootScope.$emit('FreeShipping', profile.store.storeName);
	                guestCartList = this.$auth.getGuestCart();
	                subscription = this.$auth.getSubscriptionId();
	
	                sessionStorage.removeItem('guestoauth');
	                sessionStorage.removeItem('isGuestUserLoggedIn');
	
	                if (!(!profile.shippingAddressLine1 || !profile.shippingState || !profile.shippingCity || !profile.shippingZipCode || !profile.shippingCountry || !profile.billingCountry || !profile.billingAddressLine1 || !profile.billingState || !profile.billingCity || !profile.billingZipCode)) {
	                  _context.next = 13;
	                  break;
	                }
	
	                this.$auth.doGuestLogout();
	                this.$rootScope.$emit('onLoginSuccess');
	                this.toaster.pop('success', 'You need to complete your Profile');
	                this.$state.go('profile.edit');
	                _context.next = 48;
	                break;
	
	              case 13:
	                if (!subscription) {
	                  _context.next = 18;
	                  break;
	                }
	
	                this.$auth.resetSubscriptionCart();
	                this.$state.go('subscription-detail', { subscriptionId: subscription.id, option: 'edit' });
	                _context.next = 48;
	                break;
	
	              case 18:
	                // If store not matched with guest login then redirect to home
	                store = this.$auth.getGuestStoreDetail();
	
	                if (store.storeId != profile.store.storeId) {
	                  this.$auth.doGuestLogout();
	                  this.$auth.removeGuestCart();
	                  if (this.$stateParams.itemGroupNumber) {
	                    this.$state.go('browse-product.detail', {
	                      categoryId: this.$stateParams.categoryId,
	                      subCategoryId: this.$stateParams.subCategoryId,
	                      productId: this.$stateParams.productId,
	                      masterCode: this.$stateParams.itemGroupNumber,
	                      storeName: profile.store.storeURLName
	                    });
	                  } else if (this.$stateParams.productId) {
	                    this.$state.go('browse-product.detail', {
	                      categoryId: this.$stateParams.categoryId,
	                      subCategoryId: this.$stateParams.subCategoryId,
	                      productId: this.$stateParams.productId,
	                      storeName: profile.store.storeURLName
	                    });
	                  } else if (this.$stateParams.subCategoryId) {
	                    this.$state.go('browse-product', {
	                      categoryId: this.$stateParams.categoryId,
	                      subCategoryId: this.$stateParams.subCategoryId,
	                      storeName: profile.store.storeURLName
	                    });
	                  } else if (this.$stateParams.categoryId) {
	                    this.$state.go('browse-sub-category', {
	                      categoryId: this.$stateParams.categoryId,
	                      storeName: profile.store.storeURLName
	                    });
	                  } else {
	                    this.$state.go('category', { 'storeName': profile.store.storeURLName });
	                  }
	                }
	
	                if (!(guestCartList && guestCartList.length)) {
	                  _context.next = 43;
	                  break;
	                }
	
	                this.$spinner.show('appSpinner');
	
	                if (!guestCartList.find(function (data) {
	                  return data.isDscCard;
	                })) {
	                  _context.next = 28;
	                  break;
	                }
	
	                this.$window.scrollTo(0, 0);
	                _context.next = 26;
	                return this.$order.getCartDetail().then(function (success) {
	                  _this9.detail = success.data;
	                  if (!_this9.isDscAddedinCart()) {
	                    console.log("Dsc item from guest gets added by addMultipleItemToCart function");
	                    // this.$order.buyDscMembership()
	                    //   .then(() => {
	                    //   });
	                  }
	                }).catch(function (err) {
	                  // this.$order.buyDscMembership()
	                  //   .then(() => {
	                  //   });
	                });
	
	              case 26:
	                _context.next = 33;
	                break;
	
	              case 28:
	                if (!guestCartList.find(function (data) {
	                  return data.isGiftCard;
	                })) {
	                  _context.next = 33;
	                  break;
	                }
	
	                guestCart = guestCartList.find(function (data) {
	                  return data.isGiftCard;
	                });
	
	                this.$window.scrollTo(0, 0);
	                _context.next = 33;
	                return this.$order.getCartDetail().then(function (success) {
	                  _this9.detail = success.data;
	                  _this9.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId).then(function () {});
	                }).catch(function (err) {
	                  _this9.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId).then(function () {});
	                });
	
	              case 33:
	                guestCartListFiltered = guestCartList.filter(function (guestItem) {
	                  return !guestItem.isGiftCard || !guestItem.isDscCard;
	                });
	                _context.next = 36;
	                return this.$order.addMultipleItemToCart({ guestCartItems: guestCartListFiltered }).then();
	
	              case 36:
	                this.$spinner.hide('appSpinner');
	                this.$auth.doGuestLogout();
	                this.$auth.removeGuestCart();
	                this.$rootScope.$emit('onLoginSuccess');
	                this.$state.go('cart');
	                _context.next = 48;
	                break;
	
	              case 43:
	                this.redirectUsertoStore(success.data);
	                this.$auth.doGuestLogout();
	                this.$auth.removeGuestCart();
	                this.$rootScope.$emit('onLoginSuccess');
	                if (this.$rootScope.inOrderPage) {
	                  this.$state.go('profile');
	                }
	
	              case 48:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadFunction(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadFunction;
	    }()
	  }, {
	    key: 'isDscAddedinCart',
	    value: function isDscAddedinCart() {
	      return this.detail.cartItems.some(function (cartItem) {
	        return cartItem.item.storeItemCode === 'C';
	      });
	    }
	  }, {
	    key: 'redirectUsertoStore',
	    value: function redirectUsertoStore(userData) {
	      var _this10 = this;
	
	      var $ctrl;
	      $ctrl = this;
	      console.log("--userData=--", userData);
	      if (this.isDscMember(userData)) {
	        if (this.$stateParams.productId) {
	          if (userData && userData.store) {
	            this.$window.location.href = '/' + userData.store.storeURLName + '/' + this.$stateParams.categoryId + '/' + this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
	          } else {
	            this.$window.location.href = '/' + userData.store.storeURLName;
	          }
	        } else {
	          this.$window.location.href = '/' + userData.store.storeURLName;
	        }
	        return;
	      } else {
	        var isDsc = false;
	        this.$auth.getAllStores().then(function (success) {
	          angular.forEach(success.data, function (store) {
	            if (store.dscId == 'C') {
	              isDsc = true;
	            }
	          });
	          if (isDsc) {
	            _this10.$window.location.href = '/dashboard/profile/user';
	          } else {
	            return;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'userAction',
	    value: function userAction(_userAction) {
	      this.$order.updateUserAction(_userAction);
	    }
	  }, {
	    key: 'showA2HS',
	    value: function showA2HS() {
	      console.log("--window.addToHomescreen--", window.addToHomescreen);
	      if (window.addToHomescreen) {
	        window.addToHomescreen();
	      }
	    }
	  }]);
	
	  return HeaderContainer;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$window', '$state', '$uibModal', '$interval', '$aside', 'authService', 'orderService', '$cookies', '$location', '$timeout', '$stateParams', 'toaster', 'APP', 'spinnerService'], _temp)) || _class);
	exports.default = HeaderContainer;

/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABDUlEQVRoQ+3ZSw7CMAxFUb+dwU7oyig7YWdBHURiEBXFn2cHyLzSPXErNQpk8YXF++UPyJ5gygRaaxcATw88HdBau4nIXUR2AJsVQQW8xfduM4IGGMR3xNXyOlEAJ/EbgN3yGoUDIuMPeCggOj4UwIgPA7DiQwDMeHcAO94VkBHvBsiKdwFkxpsB2fEmQIV4NaBKvApQKX4aUC1+ClAx/rcAh7biFKbPA9UQ04Bqk1ABKiHUgCoIE6ACwgzIRrgAMhFugCyEKyAD4Q5gI0IATEQYgIUIBTAQ4YBoBAXwAVH/gqNfYAx+xR8Ajjsz9aJNYIAwx08dKdVbNHhw6WtWz41Im4Angv4NeMZ/xQReQJ3GMe66PmUAAAAASUVORK5CYII="

/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAiCAYAAABMfblJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVVJREFUeNrslbFOAkEQhu8ENdpBZWIFiT1mW+yOlu4afZAz4QXgFWh8CivoKI28wVlZEggWaihY/zGzyWSyFEduMZKb5Et2ZuduMv/O3sXW2uiQdhId2OpifQsewDmwJTe1BgNyYiHpG2gFamwLalrSl4BKfriF7JDk7YCzkiWNwTeY64LHOaV/ei2a4A6cBjjDL/Csz3AGuoEao6G50JJeBlSy5pO0D3ocK1vST989rK5F6deC7CbQGW5Args+gfsAXVPBBbjSQ/MOrkP/nqoprQr+r4JLMBH+hGNuzwoMQ+sh5xiVbzxxPIFrwThrgLbw3V4iciP2nbWFr/Nl3CtpCpICKo1Fl4XPcMoSJLyOlMQkYabij5xv9i2Y7ijY4+/iSMVXHMv2KfjKL3DrIrKuPEq5oZn6hmYJDBgyhmNuT1qm9olU+LSXc27O/m/e8X+8fwQYAAWtEdHZO0K3AAAAAElFTkSuQmCC"

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhJREFUeNrsmUloFFEQhrtNZDS4oKCBIChGFBHEiCCIooioh4kaJCpoDnrxEj17Sw4e9OqCiBeFubmgBNxQXAJuBx0VFPclKu7RxHGJZsa/8G+pPGYmmenXkx7ogo/u9/LmdVW/elX1Om4mk3HKWYY4ZS6RAZEBkQGRAYMrlbrhum4DLttBNeg1DP0FdoOd7FsNdoAxxtggX3YaHEbuav7fK4nMA3JLuvLwBdTyp8l+xgZFt9bZdKEr/bzN0WAF758Mktd87+M1upSACw3HJQ5quFzyRxdsArM47BTHCCe8hQT7wV1QYVlh0WMi2AKGgffQuTqXC+WSrWoJP4Mp9P1Hqr8lwLc+A3TxOe/yuVAuuQA+8l4Urwed4KIa0wRGBmTACHpC0WH0Abih2o28ngQ9vJfNvSiseUCUPKfac8B0cAZ0qP61YU5ksmE/8X4oWM+IoA1bwAAQSgOegquqvRTEQEL11ZTajQotJY4akWEuc0dSZfZ4KUuUQh8k0egD76vAEsbpNjVG+iaF1YAOJjJP6rkfZDOn2DcOzA+rAfK2T/PqMDvPZohNqnHrwlxOy0Z+aeSE3+Cs6psHJofVgOegXbVXsUY5Bn6qoi9uUc8Uy4j854EC5AjYwPQuhdYy5onrYKFyo3usbl0fyoviU3MWiQMs5kwZBV6oQm4f+zcbtbskum7wzQfy+x9qzj7FXLEGiOxRk94HY8EEVTUGRVcx1Wg2Oa4OP9PoOq/A3lz+akmu5TvQFDKRlNXnQR3bB8FGZVCVZUNcRrtn0DnldxM7PA9cUgbIRl7M/j98mBvACqRtrYBXNrQxjDr0/56AFPekHTo3+I1CnsS4gUv5VSJtaxM7/Fa0y/xSELBctulC3uaaSTdKsR3jJrbl8ylGPOENdO60sYl1prwNxoOV6qz82uJbr2OYljkf28jEpsiB/qaR2GotKb8GfFVzH7KVibVsy7LZWi0oX8lcE0gmHohr2ZDevPNaWgGp/e+ot/TQ4nmgkUWdN3dC62wjCulvRU1c9oTxBcOPVNCI5c6/D8oHoPPbrGG0HCX6F1NkQGRAZEBkgC/5K8AA1CjOBTuw43UAAAAASUVORK5CYII="

/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 265 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"hidden-md-up navbar navbar-dark secondary-bg\" style=\"padding:0px;\">\r\n  <div class=\"media-left hidden-md-up\">\r\n    <a href ng-click=\"header.openAside('left')\">\r\n      <img src={{header.menuIcon}} style=\"margin-top: 8px;\" class=\"menu-icon navbar-brand\">\r\n    </a>\r\n  </div>\r\n  <div class=\"media-body\">\r\n    <!-- <span class=\"navbar-brand p-y-1 pl-8\">{{header.getHeaderTitle(header.getPrevState())}}</span> -->\r\n    <span class=\"navbar-brand welcome-padding\" style=\"line-height: 17px; padding-bottom: 11px; padding-top: 11px;\">\r\n      <!-- <b ng-click=\"header.showA2HS()\">Add to Home Screen</b> -->\r\n      <span style=\"font-size: 12px;\">Welcome</span>\r\n      <br>\r\n      <span style=\"font-size: 16px;\" ng-if=\"header.profile.customer.email\"> \r\n        {{(header.profile.customer.firstName.length > 12 && header.isMobileOnly()) ? (header.profile.customer.firstName | limitTo\r\n        : 12) : header.profile.customer.firstName}}</span>\r\n      <span style=\"font-size: 16px;\" ng-if=\"!header.profile.customer.email\"> Guest</span>\r\n    </span>\r\n    <span ng-if=\"header.hasBirdbuckCoupons\" id=\"mcp_bird_buck\"></span>\r\n    <span ng-if=\"!(header.isDscMember() || header.isDscButExpired()) && header.profile.customer.email\"\r\n      class=\"media-left\" style=\" float: right; color: #fff;padding: 9px 10px; line-height: 13px;position: relative;\">\r\n      <span style=\"display:inline-block; position: relative;top: 1px;\">\r\n        <span style=\"font-size: 12px;\">Daily Savings Club</span>\r\n        <!-- <br>\r\n        <span style=\"font-size: 20px;\">savings</span>\r\n        <br>\r\n        <span style=\"font-size: 11px;padding-left: 20px;\">CLUB</span> -->\r\n      </span>\r\n      <span class=\"\" style=\"display:inline-block\">\r\n\r\n        <button class=\"btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\"\r\n          style=\"margin-top: 0px !important; width:70px;padding: 0px !important\">Join Now</button>\r\n      </span>\r\n      <br>\r\n      <span style=\"vertical-align: super;text-align:center;position: relative;top: 6px;\">\r\n        <span style=\"font-size: 12px;\">Save 15% Everyday on Bird Food</span>\r\n        </span>\r\n        \r\n      <!-- </a> -->\r\n    </span>\r\n    <span ng-if=\"header.isDscMember() && header.profile.customer.email && !header.canUserJoin()\" class=\"media-left\"\r\n      style=\"float: right;color: #fff;padding: 9px 10px;line-height: 13px;position: relative;\">\r\n      <span style=\"display:inline-block; position: relative;top: 1px;\">\r\n        <span style=\"font-size: 12px;\">Daily Savings Club</span>\r\n        <!-- <br>\r\n        <span style=\"font-size: 20px;\">savings</span>\r\n        <br>\r\n        <span style=\"font-size: 11px;padding-left: 20px;\">CLUB</span> -->\r\n      </span>\r\n      <span class=\"\" style=\"display:inline-block\">\r\n\r\n        <button ng-if=\"header.isRenewButtonToBeShown()\" class=\"btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\"\r\n          ng-click=\"header.userAction(header.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n          style=\"margin-top: 0px !important; width:70px;\">Renew</button>\r\n      </span>\r\n      <br>\r\n      <span style=\"vertical-align: super;text-align:center;position: relative;top: 6px;\">\r\n      <span style=\"font-size: 12px;\">Membership thru\r\n        {{header.getDscExpireDate()| date: 'MM/dd/yyyy' }} </span>\r\n      </span>\r\n      <br>\r\n      <span style=\"display:inline-block;vertical-align: super; position: relative;top: 8px;\">\r\n      <span style=\"font-size: 12px;\">{{(header.getDscPoints() | number: 0) || 0}} points </span>\r\n      <span ng-if=\"header.hasBirdbuckCoupons\" style=\"font-size: 12px;\">| Bird Bucks available</span>\r\n    </span>\r\n      \r\n        <!-- <span style=\"font-size: 20px;font-weight: 600;\">{{(header.getDscPoints() | number: 0) || 0}} points</span> -->\r\n        <!-- <br>\r\n        <span style=\"font-size: 11px;\"></span> -->\r\n      <!-- </span> -->\r\n    </span>\r\n    <span ng-if=\"header.isDscButExpired() && header.profile.customer.email\" class=\"media-left\"\r\n      style=\"float: right;color: #fff;padding: 9px 10px;line-height: 13px;position: relative;\">\r\n      <!-- <a ui-sref=\"savings-club\"> -->\r\n        <span style=\"display:inline-block; position: relative;top: 1px;\">\r\n          <span style=\"font-size: 12px;\">Daily Savings Club</span>\r\n        </span>\r\n        <span class=\"\" style=\"display:inline-block\">\r\n\r\n          <button ng-if=\"header.isRenewButtonToBeShown()\" class=\"btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\"\r\n            ng-click=\"header.userAction(header.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n            style=\"margin-top: 0px !important; width:70px;\">Renew</button>\r\n        </span>\r\n        <br>\r\n        <span style=\"vertical-align: super;text-align:center;position: relative;top: 6px;\">\r\n        <span style=\"font-size: 12px;color: #e29a35\">Membership Expired </span>\r\n        <br>\r\n        <span style=\"display:inline-block;vertical-align: super; position: relative;top: 3px;\">\r\n        <span style=\"font-size: 12px;\">{{(header.getDscPoints() | number: 0) || 0}} points </span>\r\n        <span ng-if=\"header.hasBirdbuckCoupons\" style=\"font-size: 12px;\">| Bird Bucks available</span>\r\n      </span>\r\n    </span>\r\n      <!-- </a> -->\r\n    </span>\r\n  </div>\r\n\r\n  <div class=\"media-left header_link_box\" style=\"width:51%; text-align:center;\" ng-if=\"!header.profile.customer.email\">\r\n    <!--      <a href ng-click=\"header.openAside('left')\" style=\"color:white !important;\">\r\n          <a hrefLogin&nbsp;|&nbsp;Register\r\n          </a>-->\r\n    <span>\r\n      <button class=\"btn btn-primary \" style=\"margin-right: 10px;\" ng-click=\"header.goToRegister()\">Register</button>\r\n      <button class=\"btn btn-primary \" ng-click=\"header.goToLogin()\">Login</button>\r\n      <!-- <a  ng-hide=\"header.profile.store && header.profile.store.storeName\"\r\n       popover-placement=\"bottom\"\r\n       uib-popover-template=\"header.templateUrl\"\r\n       popover-trigger=\"header.popoverTriggerOption\"\r\n       tooltip-trigger=\"header.popoverTriggerOption\"\r\n       popover-append-to-body=\"true\"\r\n       popover-popup-close-delay=\"0\"\r\n       tabindex=\"0\"\r\n       id=\"headerAction1\"\r\n       class=\"btn-default nav-menu-action-btn  cursor-pointer\"> -->\r\n      <!-- <button class=\"btn btn-primary \" ng-if=\"!isStoreAvailabe()\"  ng-click=\"header.openStoreSelector()\">Register</button> -->\r\n      <!-- <button class=\"btn btn-primary \" ng-if=\"!isStoreAvailabe()\"  ng-click=\"header.goToLogin()\">Login</button>  -->\r\n      <!-- </a> -->\r\n    </span>\r\n  </div>\r\n  <div class=\"media-left \" style=\"position: relative;border-left: 0.5px solid white;top: 5px !important;padding-right: 5px;\"><span></span></div>\r\n  <div class=\"media-left p-r-0 \" ng-style=\"header.profile.customer.email ? '' :{'padding-left':'5px'}\">\r\n    <a ng-click=\"header.goToCart()\" class=\"cart-link\" ng-style=\"header.profile.customer.email ? '' :{'position':'relative'}\">\r\n      <img src={{header.cartIcon}} class=\" pull-xs-right\" style=\"height: 35px;\" ng-style=\"header.profile.customer.email ? {'margin-top': '7px', 'padding-right': '22px'} :{'margin-top': '7px', 'padding-right': '22px'}\"/>\r\n      <span class=\"tag cart-badge\" style=\"margin-left: 55px;\" ng-if=\"header.profile.cartTotalItems\">{{header.profile.cartTotalItems}}</span>\r\n      <span class=\"tag cart-badge\" style=\"margin-left: 40px;\" ng-if=\"!header.profile.cartTotalItems && header.guestCartCount\">{{header.guestCartCount}}</span>\r\n    </a>\r\n    <!-- <a href class=\"cart-link\" ng-click=\"header.removeCart()\"\r\n      ng-if=\"header.getPrevState().current === 'cart' && header.cartDetail.cartItems.length\">\r\n      <img src={{header.deleteIcon}} class=\"cart-icon pull-xs-right\" />\r\n    </a>   -->\r\n      <span ng-if=\"header.profile.customer.email && header.profile.customer.firstName!=''\">\r\n        <button class=\"btn btn-primary mockup-btn\" ui-sref=\"recent-order\"\r\n        style=\"width: 66px; float: right; padding: 0px; position: relative; left: 5px; margin-right: 11px; height: 24px;\">Buy Again</button>\r\n      </span>\r\n  </div>\r\n</nav>\r\n<nav class=\"navbar navbar-light  hidden-md-up mobile-promoText\">\r\n  <form name=\"searchForm\" class=\"navbar-searchForm\" ng-submit=\"header.search()\" autocomplete=\"off\">\r\n    <div class=\"col-xs-12 hidden-md-up\" style=\"padding: 0;\">\r\n      <span class=\"input-group\" style=\"text-align: center;padding: 3px;\">\r\n        <input type=\"text\" ng-model=\"header.searchTerm\" class=\"form-control\" style=\"background: #EADACB;\"\r\n          placeholder=\"What Can we Help You Find?\">\r\n        <span class=\"input-group-btn\">\r\n          <button class=\"btn btn-primary btn-sm\" type=\"submit\"\r\n            style=\"background-color: #D5B395;border-color: #D5B395;padding: 0\">\r\n            <img src=\"{{header.searchIcon}}\" style=\"height: 36px;padding: 8px\">\r\n          </button>\r\n        </span>\r\n      </span>\r\n    </div>\r\n  </form>\r\n</nav>\r\n<nav class=\" hidden-md-up  promotion-banner\" style=\"padding: 0px !important;\">\r\n\r\n  <div class=\"promotion-banner\">\r\n    <!--FREE Shipping on Orders $75 or More-->\r\n\r\n     <div id=\"promotion-slider\">\r\n      <span>{{header.promotionText}}</span>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</nav>\r\n<div class=\"navbar-fixed-top hidden-sm-down\">\r\n  <nav class=\"navbar navbar-dark  hidden-sm-down\">\r\n    <div class=\"row hidden-sm-down wbu-header-wrapper\">\r\n      <div class=\"m-y-1\">\r\n\r\n        <div class=\"col-lg-4 col-md-3 p-x-0\">\r\n          <!-- App Logo-->\r\n          <div class=\"col-lg-5 col-md-12\">\r\n            <span style=\"text-align: center\" class=\"logo-block\">\r\n              <a ng-click=\"header.goToHomePage()\">\r\n                <img ng-src=\"{{header.shopLogo}}\" width=\"100\" style=\"cursor: pointer\">\r\n              </a>\r\n            </span>\r\n          </div>\r\n          <div class=\"col-lg-7 col-md-12 \">\r\n            <!--Store Address detail-->\r\n            <span class=\"address-block hidden-md-down\">\r\n              <div ng-if=\"header.profile.store && header.profile.store.storeName\">\r\n                <h6 class=\"m-b-0 white-med-bold-text\" ng-if=\"header.profile.store.storeName\">\r\n                  <strong>{{header.profile.store.storeName}}, {{header.profile.store.state.code}}\r\n                    {{header.profile.store.zipCode}}\r\n                  </strong>\r\n                </h6>\r\n                <p class=\"m-b-0 white-med-normal-text \">\r\n                  {{header.profile.store.addressLine1 ? header.profile.store.addressLine1 : ''}}\r\n                  <br> {{header.profile.store.phoneNumber | telFormat}}\r\n                </p>\r\n                <div>\r\n                  <button id=\"detailBtn\" class=\"btn btn-primary detail-btn mockup-btn \"\r\n                    ui-sref=\"store-detail\">Detail</button>\r\n                </div>\r\n              </div>\r\n              <div class=\"m-b-0 no-store-text\"\r\n                ng-if=\"!header.profile.store || !header.profile.store.storeName || header.profile.store.storeName ==''\">\r\n                <!-- Where Bird Feeding <br /> Meets Convenience\" -->\r\n                <img src=\"{{header.Headertext}}\" style=\"width: 100%;padding: 8px\">\r\n              </div>\r\n\r\n              <div style=\"display:none;\" ng-hide=\"header.profile.store.storeName\" class=\"col-md-12 p-x-0\">\r\n                <!--  popover-trigger=\"'focus'\"-->\r\n                <a popover-placement=\"bottom\" uib-popover-template=\"header.templateUrlStore\"\r\n                  popover-trigger=\"header.popoverTriggerOptionStore\" tooltip-trigger=\"header.popoverTriggerOptionStore\"\r\n                  popover-append-to-body=\"true\" popover-popup-close-delay=\"0\" tabindex=\"0\" id=\"headerStoreAction\"\r\n                  class=\"btn-default nav-menu-action-btn  cursor-pointer\">\r\n                  <button class=\"btn btn-primary\" style=\"font-size: 14px !important;\">\r\n                    <img src=\"{{header.StoreIcon}}\" style=\"width: 15px;\"> Choose Store</button>\r\n                </a>\r\n                <script type=\"text/ng-template\" id=\"store.html\">\r\n                   <store-selector></store-selector>\r\n                </script>\r\n\r\n              </div>\r\n            </span>\r\n            <h6 class=\"m-b-0 m-t-1 white-med-bold-text hidden-lg-up\" style=\"text-align: center;margin-top: 3px\"\r\n              ui-sref=\"store-detail\" ng-if=\"header.profile.store && header.profile.store.storeName\">\r\n              {{header.profile.store.storeName}}\r\n\r\n            </h6>\r\n\r\n          </div>\r\n        </div>\r\n        <!--Search and product category navigation-->\r\n        <div class=\"col-lg-4 col-md-5\">\r\n          <div class=\"row\">\r\n            <form class=\"navbar-searchForm\" name=\"searchForm\" ng-submit=\"header.search()\" autocomplete=\"off\">\r\n              <div style=\"padding: 0;\">\r\n                <span class=\"input-group\" style=\"text-align: center;padding: 3px;\">\r\n                  <input type=\"text\" placeholder=\"What can we help you find ?\" ng-model=\"header.searchTerm\"\r\n                    class=\"form-control\" style=\"background: #ffffff; border-color: #000000; height:37px;\">\r\n                  <span class=\"input-group-btn\">\r\n                    <button class=\"btn btn-primary btn-sm\" type=\"submit\"\r\n                      style=\"background-color: #ffffff;border-color: #000000;padding: 0;border-left:none; height:37px;\">\r\n                      <img src=\"{{header.searchIcon}}\" style=\"height: 100%;padding: 8px\">\r\n                    </button>\r\n                  </span>\r\n                </span>\r\n              </div>\r\n            </form>\r\n          </div>\r\n          <!--Category Menu-->\r\n          <nav class=\"row m-y-1\">\r\n\r\n            <ul class=\"wbu-nav-menu row \">\r\n              <li class=\"ellipsis-text col-md-4\" ng-repeat=\"item in header.subCategories\"  ng-if=\"$index <= 1\">\r\n                  \r\n                <a href=\"\"  ng-click=\"header.goToNextState(item)\">\r\n                  {{item.category.name }}\r\n                  \r\n                </a>\r\n\r\n              </li>\r\n              <li class=\"col-md-4\" style=\"color: #ffffff; white-space: nowrap;\r\n              overflow: visible;\">\r\n               \r\n              <div>\r\n               <a  popover-trigger=\"header.popoverTriggerOption\" tooltip-trigger=\"header.popoverTriggerOption\"\r\n               popover-append-to-body=\"true\" popover-popup-close-delay=\"100\" tabindex=\"0\" id=\"dropdownAction\"\r\n               uib-popover-template=\"'example.html'\"\r\n               popover-placement=\"bottom\"  class=\"btn-default nav-menu-action-btn  cursor-pointer\"  >\r\n                  <span>More  <img src=\"{{header.dropDown}}\" style=\"width:10px;\"></span>\r\n              </a> </div>\r\n              <!-- popover-trigger=\"outsideClick\" -->\r\n              <script  type=\"text/ng-template\" id=\"example.html\">\r\n \r\n\r\n                      <span class=\" list-group-item list-group-item-action categoryList\" ng-repeat=\"item in header.subCategories\" ng-if=\"$index >= 2\" ng-click=\"header.goToNextState(item)\">\r\n                      {{item.category.name }}\r\n                        \r\n                     </span>\r\n                  \r\n              </script>\r\n              </li>\r\n              <!-- <li style=\"margin-left:90px;color: #ffffff; white-space: nowrap;\r\n              overflow: visible;\">More</li>\r\n              <li><div class=\"dropdown\">\r\n                  <div ><img src=\"{{header.dropDown}}\" style=\"width:10px;vertical-align: middle; margin-left: 5px\"></div>\r\n                  <div class=\"dropdown-content list-group nav-menu\">\r\n                    \r\n                    <span class=\"list-group-item list-group-item-action\" ng-repeat=\"item in header.subCategories\" ng-if=\"$index >= 2\" ng-click=\"header.goToNextState(item)\">\r\n                    {{item.category.name }}\r\n                      \r\n                   </span>\r\n                  \r\n              \r\n                  </div>\r\n                </div>\r\n              </li> -->\r\n           \r\n \r\n           \r\n            </ul>\r\n\r\n      <!--                \r\n            <img src=\"{{header.dropDown}}\" style=\"width:10px;\">\r\n                            <select ng-model=\"header.selectedheaderitem\" \r\n                              ng-options=\"item as item.category.name for item  in header.subCategories\"\r\n                              ng-change=\"header.goToNextState(header.selectedheaderitem)\">\r\n                              <option value=\"hello\"> </option>\r\n                            </select> --> \r\n\r\n          </nav>\r\n\r\n        </div>\r\n\r\n        <!--Account Information-->\r\n        <div class=\"col-lg-4 col-md-4 \" style=\"margin-top: -14px\">\r\n          <!--DSC Label-->\r\n          <div class=\"row m-l-1\">\r\n            <span ng-if=\"header.canUserJoin()\" style=\"line-height: 13px; cursor: pointer\" ui-sref=\"savings-club\">\r\n              <!-- <a href ng-click=\"header.goToSavingsClub()\"> -->\r\n\r\n              <span class=\"dsc-info-block white-med-normal-text\" style=\"padding-left: 0px\" ng-style=\"header.profile.customer.email ? {'margin-top': '10px'} :{'margin-top': '-5px'}\">\r\n                <span style=\"font-size: 14px !important; font-weight: 600 !important;padding-right: 5px;\">Daily Savings Club</span>\r\n                <span class=\"white-med-bold-text  hidden-md-down\" style=\"\">\r\n\r\n                  <button class=\" join-dsc-button btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\">Join\r\n                    Now</button>\r\n                </span>\r\n                <span class=\"white-med-bold-text hidden-lg-up \" style=\"\">\r\n                  <button class=\" join-dsc-button btn btn-primary detail-btn mockup-btn\"\r\n                    style=\"\" ui-sref=\"savings-club\">Join Now</button>\r\n                </span>\r\n                <br>\r\n                <span style=\"display:inline-block;vertical-align: super;margin-top: 8px \">\r\n                  <span style=\"font-size: 12px;\">Save 15% Everyday on Bird Food</span>\r\n                </span>\r\n              </span>\r\n              \r\n              <!-- </a> -->\r\n              \r\n            </span>\r\n            <span ui-sref=\"savings-club\"\r\n              ng-if=\"!header.canUserJoin() && header.isDscMember() && header.profile.customer.email\"\r\n              class=\"cursor-pointer\" style=\"line-height: 13px;\">\r\n              \r\n              <span class=\"dsc-info-block white-med-normal-text\" style=\"padding-left: 0px\" ng-style=\"header.profile.customer.email ? {'margin-top': '10px'} :{'margin-top': '-5px'}\">\r\n                <span style=\"font-size: 14px !important; font-weight: 600 !important;padding-right: 5px;\">Daily Savings Club</span>\r\n                <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n\r\n                  <button ng-if=\"header.isRenewButtonToBeShown()\"\r\n                  ng-click=\"header.userAction(header.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                  class=\"hidden-md-down renew-button btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\"\r\n                    style=\"\">Renew</button>\r\n                </span>\r\n                <br>\r\n                <span style=\"display:inline-block;vertical-align: super;margin-top: 8px \">\r\n                  <span style=\"font-size: 12px;\">Membership thru\r\n                    {{header.getDscExpireDate()| date: 'MM/dd/yyyy' }} | </span>\r\n                  </span>\r\n                  <span style=\"display:inline-block;vertical-align: super; \">\r\n                  <span style=\"font-size: 12px;\">{{(header.getDscPoints() | number: 0) || 0}} points </span>\r\n                  <span  ng-if=\"header.hasBirdbuckCoupons\" style=\"font-size: 12px;\">| Bird Bucks available</span>\r\n                </span>\r\n              </span>\r\n              \r\n\r\n            </span>\r\n            <span ng-if=\"header.isDscButExpired() && header.profile.customer.email && !header.canUserJoin()\"\r\n              style=\"line-height: 13px;\">\r\n              \r\n              <span class=\"dsc-info-block white-med-normal-text\" style=\"padding-left: 0px\" ng-style=\"header.profile.customer.email ? {'margin-top': '10px'} :{'margin-top': '-5px'}\">\r\n                <span style=\"font-size: 14px !important; font-weight: 600 !important;padding-right: 5px;\">Daily Savings Club</span>\r\n                <span class=\"white-med-bold-text \" style=\"display:inline-block\">\r\n\r\n                  <button ng-if=\"header.isRenewButtonToBeShown()\" ng-click=\"header.userAction(header.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON)\"\r\n                  class=\"hidden-md-down renew-button btn btn-primary detail-btn mockup-btn\" ui-sref=\"savings-club\"\r\n                    style=\"\">Renew</button>\r\n                </span>\r\n                <br>\r\n                <span style=\"display:inline-block;vertical-align: super;margin-top: 8px \">\r\n                  <span style=\"font-size: 12px; color: #e29a35\">Membership Expired </span>\r\n                </span>\r\n                  <span style=\"display:inline-block;vertical-align: super; \">\r\n                  <span ng-if=\"header.hasBirdbuckCoupons\" style=\"font-size: 12px;\">&nbsp;| {{(header.getDscPoints() | number: 0) || 0}} points | Bird Bucks available</span>\r\n                </span>\r\n                \r\n              </span>\r\n            </span>\r\n            <!--DSC Label-->\r\n          </div>\r\n          <div style=\"border-top: 1px solid white; margin-left: 16px;\" ng-style=\"header.profile.customer.email ? {'width':'371px'} : {'width': '249px'}\"></div>\r\n          <div class=\"row mt-2 m-l-1\" style=\"margin-top: 7px\">\r\n            <div class=\"col-md-5 p-x-0\" ng-style=\"header.isIpad() ? {'width':'45%'} : ''\">\r\n              <!--  popover-trigger=\"'focus'\"-->\r\n              <a popover-placement=\"bottom\" uib-popover-template=\"header.templateUrl\"\r\n                popover-trigger=\"header.popoverTriggerOption\" tooltip-trigger=\"header.popoverTriggerOption\"\r\n                popover-append-to-body=\"true\" popover-popup-close-delay=\"100\" tabindex=\"0\" id=\"headerAction\"\r\n                class=\"btn-default nav-menu-action-btn  cursor-pointer\">\r\n                <span ng-class=\"header.isIpad()?'white-small-normal-text':'white-med-normal-text'\"\r\n                  ng-if=\"header.profile.customer.email&&header.profile.customer.firstName!=''\">\r\n                  {{(header.profile.customer.firstName.length > 12 && header.isMobileOnly()) ? (header.profile.customer.firstName) : header.profile.customer.firstName|\r\n                  limitTo : 12}}'s Account\r\n                  <img src=\"{{header.dropDown}}\" style=\"width:10px;\">\r\n                </span>\r\n                <span ng-class=\"header.isIpad()?'white-small-normal-text':'white-med-normal-text'\"\r\n                  ng-if=\"header.profile.customer.email&&header.profile.customer.firstName==''\">\r\n                  My Account\r\n                  <img src=\"{{header.dropDown}}\" style=\"width:10px;\">\r\n                </span>\r\n                <span ng-class=\"header.isIpad()?'white-small-normal-text':'white-med-normal-text'\" class=\"\"\r\n                  ng-if=\"!header.profile.customer.email\">\r\n                  <!-- {{header.profile.store.storeName ? 'Register /' :''}}  -->\r\n                  Register / Login\r\n                  <img src=\"{{header.dropDown}}\" style=\"width:10px;\">\r\n                </span>\r\n              </a>\r\n\r\n              <script type=\"text/ng-template\" id=\"menu.html\">\r\n                      <nav-menu></nav-menu>\r\n                   </script>\r\n              <script type=\"text/ng-template\" id=\"login.html\">\r\n                      <navlogin></navlogin>\r\n                      \r\n                   </script>\r\n            </div>\r\n            <div class=\"col-md-3 p-x-0\" style=\"width: 28% !important\" ng-if=\"header.profile.customer.email&&header.profile.customer.firstName!=''\">\r\n              \r\n                <span ng-class=\"header.isIpad()?'white-small-normal-text':'white-med-normal-text'\">\r\n                  <button class=\"hidden-md-down detail-btn btn btn-primary mockup-btn\" ui-sref=\"recent-order\"\r\n                  style=\"width: 90px !important; margin-top: 0px;\">Buy Again</button>\r\n                </span>\r\n            </div>\r\n            <div class=\"col-md-4 p-x-0\" ng-style=\"header.isIpad() ? {'width':'45%'} : {'width': '30%'}\">\r\n\r\n              <a ng-click=\"header.goToCart()\"\r\n                class=\"btn-default nav-menu-action-btn white-med-normal-text  cursor-pointer m-r-2\">\r\n                <img class=\"header-cart-icon\" ng-src=\"{{header.cartIcon}}\">\r\n                <span\r\n                  style=\"font-weight: 600; color: #e29a35 !important;\">{{header.profile.cartTotalItems!=null?header.profile.cartTotalItems:(header.guestCartCount ? header.guestCartCount : 0)}}</span>\r\n                items\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--<div class=\"media-body\">\r\n       &lt;!&ndash; <span class=\"navbar-brand p-y-1 pl-8\">{{header.getHeaderTitle(header.getPrevState())}}</span> &ndash;&gt;\r\n       <span class=\"navbar-brand welcome-padding\" style=\"line-height: 14px; padding-bottom: 11px; padding-top: 11px;\">\r\n          <span style=\"font-size: 12px;\">Welcome</span><br>\r\n           <span style=\"font-size: 16px;\" ng-if=\"header.profile.customer.email\">\r\n           {{(header.profile.customer.firstName.length > 12 && header.isMobileOnly()) ? \r\n           (header.profile.customer.firstName | limitTo : 12) : header.profile.customer.firstName}}</span>\r\n         <span style=\"font-size: 16px;\"  ng-if=\"!header.profile.customer.email\"> Guest</span>\r\n       </span>\r\n       \r\n       \r\n       \r\n       \r\n       \r\n       \r\n       </div>-->\r\n    <!--<div class=\"media-left p-r-0 cart-wrap\" ng-if=\"header.profile.customer.email\">\r\n       <a ui-sref=\"cart\" class=\"cart-link\"\r\n         ng-if=\"header.getPrevState().current !== 'cart'\">\r\n         &lt;!&ndash; header.getPrevState().current !== 'home' &&\r\n         header.getPrevState().current !== 'profile' &&\r\n         header.getPrevState().current !== 'profile.edit' &&\r\n         header.getPrevState().current !== 'store-detail' &&\r\n         header.getPrevState().current !== 'delivery' &&\r\n         header.getPrevState().current !== 'delivery.address' &&\r\n         header.getPrevState().current !== 'settings' &&\r\n         header.getPrevState().current !== 'terms-conditions' &&\r\n         header.getPrevState().current !== 'rules-faq' &&\r\n         header.getPrevState().current !== 'faq-birds-critters' &&\r\n         header.getPrevState().current !== 'faq-franchising' &&\r\n         header.getPrevState().current !== 'faq-product-warranties' &&\r\n         header.getPrevState().current !== 'privacy' &&\r\n         header.getPrevState().current !== 'payment.success' &&\r\n         header.getPrevState().current !== 'payment.failure'\"> &ndash;&gt;\r\n         <img src={{header.cart}} class=\"cart-icon pull-xs-right\" />\r\n         <span class=\"tag cart-badge\"\r\n           ng-if=\"header.profile.cartTotalItems\">{{header.profile.cartTotalItems}}</span>\r\n       </a>\r\n       <a href class=\"cart-link\"\r\n         ng-click=\"header.removeCart()\"\r\n         ng-if=\"header.getPrevState().current === 'cart' && header.cartDetail.cartItems.length\">\r\n         <img src={{header.deleteIcon}} class=\"cart-icon pull-xs-right\" />\r\n       </a>\r\n       </div>-->\r\n  </nav>\r\n  <nav>\r\n    <div class=\"row promotion-banner\">\r\n      <!--FREE Shipping on Orders $75 or More-->\r\n\r\n      <div id=\"promotion-slider\">\r\n        {{header.promotionText}}\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </nav>\r\n</div>"

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "31802c327ad2d5936d5a12775822fa3d.png";

/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABGdBTUEAALGPC/xhBQAABU9JREFUaAXtm0uIHFUUhrtNfMYRI6LG+Oi4UDFGEVF8RHDADOogcWeQLPLQRUIC2QguXLiPG10rCYKgCzEKgqIJghFUEMY3PtDWkAk65iFJyOQxGb+/raq5dftUdXX37Ux1zxz4U/ece+6p899nVfWkWmkh09PTo7g8Dha1cJ3t6sMk8Ha1Wt2bl0g1rxKy66jfkedTsrqz5LMK0nuy8sokDNnzaTQOrsxqXFL7NxC+Myu387IqsD8B+o2s6NzBYN2tgiV5hDdYDfrElpm7OaXpoWsh9idY4BF8Dv0fzzbbqmbhdi+JI+hLmNqTnt1WIfw88GXM9p59K4mO+cmiP104M5x/MgJsLRzgHDuS61Yj348LpUHDlUbjSWxXFAowC07KDShHV86i1Px0rE3LWvC7WA+H/MZl0aPcdnn5aH9a59nSKj1yKTjqdlNUHkl7lk8jzxEj7zo2c2NuMKByvdHoD2zWTCgVa+UIlKsvj7iJ+kSs6byDKaNHtlJLlKP1GGxxqlTolpv9rkE3F35ZmZNvLcrZpXICZXGcszvC62Ojc91Nz9UdvdTFKNfdXpIXoafPZHpgAdjvdktUXuM1Lr1K3msMHl+lEsdh1HA6hO3ClGMfKMoZKHdfGm9QCyMOzxhcNN0/p5VRlWnSEXA50DP4v+A06ES6jeMu1fj+Wyg8W4XQ1RT03ms5xc6DcNVJc4tIbgKDTlYDJo4v6J+yf6tSsqFkSIR/CBWtD+Ic1aZl7UofYBfakY04r/Aa7Ef3X849lybVivMbXq80eeYbdPbe67vEu7Rv/4JD/GXfmKez+T1MvU94IlCc8Q7i3EU+TYTnwmaVGqc5Sdh6E9KDQ7uS/d7ZXqRQcSwOUxrhCSOfJYatlUkP6SHEinOqg8AWh30irJ3Ul2E2ocI9Hfku94OgLw0U5xojdqaJe15C5f2Gwy96D9ab0kHgy2ajgWmi4Ra/saOHijNq3twwcu+XnPvHxTMUrmq4U9gZW52rXpxvM+KlTPIBx5x2fvG4fFKNDEU+IC/OOPUtRxofzc4p4MuHyW2pWQEsp1PYNXpN01s2sBmIUCsRkRBxJojzVJK4U8C+ELwITgNLHpR7QgSP19A3ODHc4u8oe8CByKgNYRjcFOlFL6HifM8NPwV/Az08XQdWAWujwlx5gweXtSq4hBeh69vzBaroQn6m7UngP3W1G/LbqEG3cRRmGYTrKmiXbgiG4xTUY93IjzR+FGiD0Sh0Kl/T8DHQbZz8+zOt69bkL2h7E7/L4jtQHgKytSP6Svo60GxrCOVO4vj3rEXh0he8LMIn/daOrt9z3gP3pSPNaNQ9AN4HeXF0IrwLmh7240jUFY1jbaK1OE6yhmUgaJ3LjSo7cjvlG8D14P9zrFL5i/I+sJelcIxrSyH2EE4rQU/jEP874HNI1jB1MyLCwJfajEf5SySfyyHZtMpPJUyGWR8AuopOL+t7th4QloHUsikQeBofnddvsVx0vAWV4IQhq5ifgMyNrCCDTcR6CNJnCvoXcuvFlB4OQFbJq8MUK6j0gvDSgBmGjNVIqxeEA/INHyr4Gs5I8TPsr2bUxeYnKayOlV5dzxXhX9l8duaRYIOqUd9zwnNuSs8Tzpt2g1A3P8KDMIp5HOZHOK93BqGuyDm8jTPySBtkrf9voG/F77SIcatRvzo6n42qTJP+qCZTUq9uBK/j6X8tyGzcRxXJF485v4atH9b6aCDNVPWtPeHlj/B2KqfMZv1p1G/f23iOT/5ALrWGxYl1rE1nBCTfhmVvUy7G/x6wuM12sfthCl+CydjQwVU/LHwE2TG37X/nVZuiOYOHeQAAAABJRU5ErkJggg=="

/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAIAAADDkPmOAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQ+SURBVDhPTVRbbxtFFD5z2dm1EzvXtjRSCm3UAkXiJlEhHgoSv4RX/gDiH/HCOxIvFIFaRNMKFVUiBVSiJmnqxF7bsXd3bodv1inleD07MzvznW++c+aIL7/+asOcfXH9cZ+nanK0mjMZbUel7vScyJ0wUQhBJCgodpKi91FollmMIkpv8BjbITZkLRWKtP/meOfe9EpDhSxrPaiX/ypXait6y2vRBT8sTbfHJKOQTIpIExF6Eg7g1xilMmIlgmaGU3zzJBypSByfVUv/1Bsj153Cqws0D+bQb9c2J9WVonA2UmbwZ84AFQHNWrDUQegoFSkZs+gM+5w4w5FCFthY6qkXUT2otp6HjTqoxpMUQtaOd0/WTtTOeCai6nX6F8jSgnWEEiyAK1moKDEOLnoXyWUy5JpyoWTQcZa5UtGD5rU9d2XoCtCNAXuk8p5P52KP36z15tgZyvu1B3SrAzF0SGrEtsuKIDIrjYBQIaL2kSq2E+F/HvX2+NqBXQNfbGYSMs8yaGhduHtA98P7Q3FxHAsn84DjEOS0WWwUe6ATdBegIjOtTJZpRCJG57km9dReemKvH/vNkRURK9vIq3c/+ZwjY2hdfGFz09tYUjMtrRYuizajRrNXDGEADrUhoFOIJvamiHsn1VBd/H12/dC/cTBWVR080GDtifGC+2idPy7tnYPu7vzqGXW90AmFK8kzSQ1RsFJjMoRA3BC4coOeEyv7zbWj6vKw6dR1cAFIsAQqrYN5DEJk68NgYh+ONvfVjSCN95b8HKkKVUlHsI3G6NxA+GY+cDwvVlb+mF/4e3b5WbM+GNa1xTGAnbSDJNKDRcsajtC4wC+m8ddyu6TlrLtKnSXQjbOJ894r0TAhF+fzKu/39HLv0UAO5Ot/VusnZV03iXGSIomBxELwgZj6rTCtj3ntHx/zD+MPaXmLY8HIW5xAMEjgigSRkelb2RmGpSd0Y/fswmHZ1AjUS9CFgbV666Pb/5tLVxroUOh53Rm49W11iIQuun0vVECeSxWD6PQ2np6pn8Y37o539oehaoC7YHZuCuuUVDdvfQqHcJIsZWTij5mU7LYYya3tboWTZkpqGSjEyhfH4eIvkx2IdjDhxp6L+58lHNkmKeDbQpDu5fkSdJhCiOU8PhyufnvywfMqt1EtSVbenob17w4u/TbZOjpDCrQynIu52Jr4LQy4yQnGWJXQW8OCl+j+ybR/b/4eygXZs4nt/Di6iqzYL2NtfVp6jvPKFuBo1du3bgO0FSI1ye3CcSsPvvgoa7E8qE1V+e9HNx9NN08baXExoMMrislSPWrJAQEd9c7HnyVp2/rYsm9D2T7njqSwQZTcv3+6fuTXptHgcie2LUpa1W5UUDZJCxXSD8VAFqn+QnGldXpQG3Jj8KQhCjNeEuGTk0ZUolsxapaQmAIMrHWOZUWRL3XR5CZtSF7y3PwL7m7GnCRekpwAAAAASUVORK5CYII="

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _dec, _class;
	
	var _utils = __webpack_require__(71);
	
	var _logoS = __webpack_require__(110);
	
	var _logoS2 = _interopRequireDefault(_logoS);
	
	var _authHeader = __webpack_require__(272);
	
	var _authHeader2 = _interopRequireDefault(_authHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthHeaderContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'header',
	  template: _authHeader2.default
	}), _dec(_class = function AuthHeaderContainer() {
	  _classCallCheck(this, AuthHeaderContainer);
	
	  this.logo = _logoS2.default;
	}) || _class);
	exports.default = AuthHeaderContainer;

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-light bg-color header-shadow text-xs-center\">\r\n  <a href=\"/\">\r\n    <img ng-src={{header.logo}} alt=\"Wild Birds Unlimited\" height=\"45\" />\r\n  </a>\r\n</nav>\r\n"

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _newOrder = __webpack_require__(136);
	
	var _newOrder2 = _interopRequireDefault(_newOrder);
	
	var _recentOrder = __webpack_require__(137);
	
	var _recentOrder2 = _interopRequireDefault(_recentOrder);
	
	var _favorites = __webpack_require__(138);
	
	var _favorites2 = _interopRequireDefault(_favorites);
	
	var _subscribe = __webpack_require__(274);
	
	var _subscribe2 = _interopRequireDefault(_subscribe);
	
	var _homeArrow = __webpack_require__(139);
	
	var _homeArrow2 = _interopRequireDefault(_homeArrow);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _navigationBar = __webpack_require__(275);
	
	var _navigationBar2 = _interopRequireDefault(_navigationBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavBarContainer = (_dec = (0, _utils.Component)({
	  controllerAs: 'navBar',
	  template: _navigationBar2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function NavBarContainer($scope, $ngRedux, $state, toaster, $auth, $uibModal, $cookies, $window, $stateParams, APP) {
	    _classCallCheck(this, NavBarContainer);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$state = $state;
	    this.homeArrow = _homeArrow2.default;
	    this.logoIcon = _smallLogo2.default;
	    this.newOrderImg = _newOrder2.default;
	    this.recentOrderImg = _recentOrder2.default;
	    this.favoriteImg = _favorites2.default;
	    this.subscriptionImg = _subscribe2.default;
	    this.toaster = toaster;
	    this.$uibModal = $uibModal;
	    this.$auth = $auth;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = $auth;
	    this.$state = $state;
	    this.APP = APP;
	    var guestStore = null;
	    if ($auth.isGuestLogin()) {
	      try {
	        guestStore = sessionStorage.getItem('guestStoreName');
	      } catch (e) {
	        guestStore = $cookies.get('guestStoreName');
	      }
	      if (!this.profile.store) {
	        this.$auth.getStoreDetail(guestStore);
	      }
	
	      $scope.$on('$destroy', disconnect);
	    }
	  }
	
	  _createClass(NavBarContainer, [{
	    key: 'mapState',
	    value: function mapState(state) {
	
	      var obj = {
	        profile: state.auth.profile,
	        list: state.order.categories
	      };
	      if (!obj.profile.store) {
	        obj.profile = { 'store': state.auth.storeDetail };
	      }
	      return obj;
	    }
	  }, {
	    key: 'openToast',
	    value: function openToast() {
	      this.toaster.pop('success', 'This Feature will be available soon');
	    }
	  }, {
	    key: 'navigateToHome',
	    value: function navigateToHome() {
	      if (this.$state.current.name !== 'category') {
	        this.$state.go('category', { 'storeName': this.$auth.getGuestStoreDetail().storeName });
	      } else {
	        this.toaster.pop('success', 'Choose category');
	      }
	    }
	  }, {
	    key: 'navigateToRecentOrder',
	    value: function navigateToRecentOrder() {
	
	      if (this.$auth.isGuestLogin()) {
	        var msg = 'access this';
	        this.$auth.showLoginPopUp(msg);
	      } else {
	        if (this.$state.current.name !== 'recent-order') {
	          this.$state.go('recent-order');
	        } else {
	          this.toaster.pop('success', 'Already on orders page');
	        }
	      }
	    }
	  }, {
	    key: 'goToHomePage',
	    value: function goToHomePage() {
	      var storeName = '';
	      if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	        storeName = this.$stateParams.storeName;
	      } else {
	        if (this.obj.profile.store && this.obj.profile.store.storeName) {
	          storeName = this.obj.profile.store.storeURLName;
	        } else {
	          storeName = this.$auth.getGuestStoreDetail().storeName;
	        }
	      }
	      if (storeName) {
	        this.$window.location.href = '/' + storeName;
	      } else {
	        this.$state.go('home');
	      }
	    }
	  }, {
	    key: 'navigateToSubscriptions',
	    value: function navigateToSubscriptions() {
	      if (this.$auth.isGuestLogin()) {
	        var msg = 'access this';
	        this.$auth.showLoginPopUp(msg);
	      } else {
	        if (this.$state.current.name !== 'subscription') {
	          if (this.profile.store.isSubscription === true) {
	            this.$state.go('subscription');
	          } else {
	            this.toaster.pop('success', 'Subscription is not Available For this store');
	          }
	        } else {
	          this.toaster.pop('success', 'Already on subscription page');
	        }
	      }
	    }
	  }]);
	
	  return NavBarContainer;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'toaster', 'authService', '$uibModal', '$cookies', '$stateParams', '$window', 'APP'], _temp)) || _class);
	exports.default = NavBarContainer;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f6ea3b780c980f3c097e482cc1260a0f.png";

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = "<!-- Nav bar only appears for Tablets and up devices -->\r\n<div class=\"row m-x-0 hidden-sm-down bottom-shadow\">\r\n  <!-- Store Details Column -->\r\n  <div class=\"col-md-3 p-x-0\">\r\n    <div class=\"row sub-header-bg m-x-0 p-y-1\">\r\n\r\n      <!-- Home logo icon -->\r\n      <div class=\"col-md-12\">\r\n        <div class=\"media\">\r\n          <div class=\"media-left\">\r\n            <a ng-click=\"navBar.goToHomePage()\"  ><img class=\"subheader-logo-icon\" src={{navBar.logoIcon}} alt=\"image\"/></a>\r\n          </div>\r\n          <!-- Store Address -->\r\n          <div class=\"media-body\">\r\n            <h6 class=\"m-b-0\" ><!-- ng-if=\"navBar.profile.store.storeName\" -->\r\n              <strong>{{navBar.profile.store.storeName}}, {{navBar.profile.store.state.code}} {{navBar.profile.store.zipCode}}</strong>\r\n            </h6>\r\n            <p class=\"m-b-0\">\r\n              {{navBar.profile.store.addressLine1 ? navBar.profile.store.addressLine1 + ',' : ''}} {{navBar.profile.store.addressLine2 ? navBar.profile.store.addressLine2 + ',' : ''}} \r\n              {{navBar.profile.store.phoneNumber | telFormat}}\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Detail Button -->\r\n      <div class=\"col-md-12 text-md-center\">\r\n        <button class=\"btn btn-primary detail-btn\" ui-sref=\"store-detail\">Detail</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- New Order -->\r\n  <div class=\"col-md-3 p-a-1 bdr-right cursor-pointer\" ng-click=\"navBar.navigateToHome()\">\r\n    <a href>\r\n      <img src={{navBar.newOrderImg}} class=\"home-list-icon d-block mb-8\"/>\r\n      <span class=\"home-tab-text\">Start new order</span>\r\n      <img src={{navBar.homeArrow}} class=\"home-list-icon-arr pull-xs-right\"/>\r\n    </a>\r\n  </div>\r\n\r\n  <!-- Recent order -->\r\n  <div class=\"col-md-3 p-a-1 bdr-right cursor-pointer\" ng-click=\"navBar.navigateToRecentOrder()\">\r\n    <a href>\r\n      <img src={{navBar.recentOrderImg}} class=\"home-list-icon d-block mb-8\"/>\r\n      <span class=\"home-tab-text\">My orders</span>\r\n      <img src={{navBar.homeArrow}} class=\"home-list-icon-arr pull-xs-right\"/>\r\n    </a>\r\n  </div> \r\n\r\n  <!-- Favourites -->\r\n  <!-- <div class=\"col-md-3 p-a-1 cursor-pointer\" ng-click=\"navBar.navigateToSubscriptions()\" >\r\n    <a href>\r\n      <img src={{navBar.subscriptionImg}} class=\"home-list-icon d-block mb-8\"/>\r\n      <span class=\"home-tab-text\">My Subscriptions</span>\r\n      <img src={{navBar.homeArrow}} class=\"home-list-icon-arr pull-xs-right\"/>\r\n    </a>\r\n  </div> -->\r\n\r\n</div>"

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _smallLogo = __webpack_require__(140);
	
	var _smallLogo2 = _interopRequireDefault(_smallLogo);
	
	var _mobileNavBar = __webpack_require__(277);
	
	var _mobileNavBar2 = _interopRequireDefault(_mobileNavBar);
	
	var _secondaryPagesLogo = __webpack_require__(278);
	
	var _secondaryPagesLogo2 = _interopRequireDefault(_secondaryPagesLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MobileNavBar = (_dec = (0, _utils.Component)({
	  controllerAs: 'mobileNav',
	  template: _mobileNavBar2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function MobileNavBar($scope, $ngRedux, $state, $auth, $cookies) {
	    _classCallCheck(this, MobileNavBar);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$state = $state;
	    this.logoIcon = _smallLogo2.default;
	    this.$auth = $auth;
	    var guestStore = null;
	    this.homeIcon = _secondaryPagesLogo2.default;
	    try {
	      guestStore = sessionStorage.getItem('guestStoreName');
	    } catch (e) {
	      guestStore = $cookies.get('guestStoreName');
	    }
	    this.$auth.getStoreDetail(guestStore);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(MobileNavBar, [{
	    key: 'mapState',
	    value: function mapState(state) {
	
	      var obj = {
	        profile: state.auth.profile,
	        list: state.order.categories
	      };
	      if (!obj.profile.store) {
	        obj.profile = { 'store': state.auth.storeDetail };
	      }
	      return obj;
	    }
	  }]);
	
	  return MobileNavBar;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'authService', '$cookies'], _temp)) || _class);
	exports.default = MobileNavBar;

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row sub-header-bg m-x-0 p-y-1 hidden-md-up\" ng-if=\"mobileNav.profile.store.storeName\" style=\"padding: 0% 5%;\">\r\n  <div class=\"col-sm-3 col-xs-3\" ng-if=\"mobileNav.profile.store.storeName\">\r\n    <img style=\"position: relative;right: 30px;width: 113px;\" src={{mobileNav.homeIcon}} alt=\"image\" />\r\n  </div>\r\n  <div class=\"col-sm-6 col-xs-6\" ng-if=\"mobileNav.profile.store.storeName\" style=\"top: 13px\">\r\n    <div class=\"media\" >\r\n\r\n      <div class=\"media-body\">\r\n        <h6 class=\"m-b-0\" ng-if=\"mobileNav.profile.store.storeName\">\r\n          <strong>{{mobileNav.profile.store.storeName}}, {{mobileNav.profile.store.state.code}} {{mobileNav.profile.store.zipCode}}</strong>\r\n        </h6>\r\n        <p class=\"m-b-0\" ng-if=\"mobileNav.profile.store.storeName\">\r\n          {{mobileNav.profile.store.addressLine1 ? mobileNav.profile.store.addressLine1  : ''}}\r\n          <br>\r\n          {{mobileNav.profile.store.phoneNumber | telFormat}}\r\n        </p>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-sm-3 col-xs-3 text-xs-right\" ng-if=\"mobileNav.profile.store.storeName\" style=\"top: 16px;\">\r\n    <button class=\"btn btn-primary\" ui-sref=\"store-detail\">Detail</button>\r\n  </div>\r\n</div>"

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "45739977470e4f7817fbefc72bac6183.png";

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imgLazyLoader;
	
	var _placeholder = __webpack_require__(280);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function imgLazyLoader() {
	  return {
	    restrict: 'A',
	    scope: {
	      imgLazyLoader: '@',
	      bgImg: '@'
	    },
	    link: function link(scope, element) {
	      if (scope.bgImg) {
	        var elem = angular.element('<img />').attr('src', scope.imgLazyLoader);
	        // element.css('background-image', 'url(' + placeHolder + ')');
	        elem.one('load', function () {
	          elem.remove();
	          element.css('background-image', 'url(' + scope.imgLazyLoader + ')');
	        });
	      } else {
	        element.attr('src', '');
	        element.one('load', function () {
	          element.attr('src', scope.imgLazyLoader);
	        });
	        element.one('error', function () {
	          return element.attr('src', _placeholder2.default);
	        });
	      }
	    }
	  };
	}

/***/ },
/* 280 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imgLazyLoaderLarge;
	// import placeHolder from './../../../images/placeholderLarge.jpg';
	
	function imgLazyLoaderLarge() {
	  return {
	    restrict: 'A',
	    scope: {
	      imgLazyLoaderLarge: '@',
	      bgImg: '@'
	    },
	    link: function link(scope, element) {/*
	                                         if (scope.bgImg) {
	                                         let elem = angular.element('<img />').attr('src', scope.imgLazyLoaderLarge);
	                                         element.css('background-image', 'url(' + placeHolder + ')');
	                                         elem.one('load', () => {
	                                         elem.remove();
	                                         element.css('background-image', 'url(' + scope.imgLazyLoaderLarge + ')');
	                                         });
	                                         }
	                                         else {
	                                         element.attr('src', placeHolder);
	                                         element.one('load', () => {
	                                         element.attr('src', scope.imgLazyLoaderLarge);
	                                         });
	                                         element.one('error', () => element.attr('src', placeHolder));
	                                         }
	                                         */}
	  };
	}

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = telFormat;
	function telFormat() {
	  return function (tel) {
	    if (!tel) return '';
	    var country = void 0,
	        city = void 0,
	        number = void 0;
	    var value = tel.toString().trim().replace(/^\+/, '');
	    if (value.match(/[^0-9]/)) return tel;
	
	    switch (value.length) {
	      case 10:
	        // +1PPP####### -> C (PPP) ###-####
	        country = 1;
	        city = value.slice(0, 3);
	        number = value.slice(3);
	        break;
	      case 11:
	        // +CPPP####### -> CCC (PP) ###-####
	        country = value[0];
	        city = value.slice(1, 4);
	        number = value.slice(4);
	        break;
	      case 12:
	        // +CCCPP####### -> CCC (PP) ###-####
	        country = value.slice(0, 3);
	        city = value.slice(3, 5);
	        number = value.slice(5);
	        break;
	      default:
	        return tel;
	    }
	
	    if (country === 1) country = '';
	    number = number.slice(0, 3) + '-' + number.slice(3);
	
	    return (country + ' (' + city + ') ' + number).trim();
	  };
	}

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _navLogin = __webpack_require__(284);
	
	var _navLogin2 = _interopRequireDefault(_navLogin);
	
	var _question = __webpack_require__(113);
	
	var _question2 = _interopRequireDefault(_question);
	
	var _WBUDSCCard = __webpack_require__(144);
	
	var _WBUDSCCard2 = _interopRequireDefault(_WBUDSCCard);
	
	var _houseIcon = __webpack_require__(141);
	
	var _houseIcon2 = _interopRequireDefault(_houseIcon);
	
	var _search = __webpack_require__(147);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _wbuPointer = __webpack_require__(149);
	
	var _wbuPointer2 = _interopRequireDefault(_wbuPointer);
	
	var _wbuMapPointer = __webpack_require__(150);
	
	var _wbuMapPointer2 = _interopRequireDefault(_wbuMapPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var navlogin = (_dec = (0, _utils.Component)({
	  controllerAs: 'login',
	  template: _navLogin2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function navlogin($rootScope, $scope, $ngRedux, $state, $stateParams, $cookies, $spinner, authService, $toaster, $window, $order, $uibModal, $q, APP) {
	    _classCallCheck(this, navlogin);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$rootScope = $rootScope;
	    this.$cookies = $cookies;
	    this.$state = $state;
	    this.toaster = $toaster;
	    this.storeName = $stateParams.storeName;
	    this.authService = authService;
	    this.$window = $window;
	    this.$spinner = $spinner;
	    this.$order = $order;
	    this.info = _question2.default;
	    this.$uibModal = $uibModal;
	    this.dscCard = _WBUDSCCard2.default;
	    this.searchIcon = _search2.default;
	    this.markerIcon = _wbuMapPointer2.default;
	    this.higlightedmarkerIcon = _wbuPointer2.default;
	    this.$q = $q;
	    this.$stateParams = $stateParams;
	    this.APP = APP;
	    if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
	      this.storeName = $stateParams.storeName;
	    } else {
	      this.storeName = authService.getGuestStoreDetail().storeName;
	    }
	    if ($stateParams.storeName) {
	      $spinner.show('appSpinner');
	      authService.getStoreDetail($stateParams.storeName).finally(function () {
	        return $spinner.hide('appSpinner');
	      });
	    }
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(navlogin, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      return {
	        store: state.auth.storeDetail,
	        storesList: state.auth.storesList
	      };
	    }
	  }, {
	    key: 'isScreenSmall',
	    value: function isScreenSmall() {
	      if (this.$window.innerHeight < 300) return true;
	    }
	  }, {
	    key: 'openStoreSelector',
	    value: function openStoreSelector() {
	      this.$rootScope.$emit('onStoreSelection');
	      var msg = 'Text';
	      var $ctrl;
	      $ctrl = this;
	      $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
	      $ctrl.markerIcon = this.markerIcon;
	      this.$uibModal.open({
	        size: 'lg',
	        template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' + '<div class="row">' + '<div class="col-md-3 p-l-0 p-r-0">' + '<div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div style="padding: 0;">' + '<form class="input-group" style="text-align: center;padding: 3px;">' + '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' + '<span class="input-group-btn"  >' + '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' + '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' + '</button>' + '</span>' + '</form>' + '</div>' + '</div>' + '</div>' + '<br/><div class="col-md-12 p-l-1 p-r-1">' + '<div class="col-md-12 p-l-0 p-r-0">' + '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' + ' <div style="max-height:441px;  overflow-y: auto; overflow-x: hidden;"><div  ng-click="selectStore($index,store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' + '<div  class="row store-nm-div">' + '<div class="col-md-8 col-xs-8 p-r-0 p-l-1" >{{$index + 1}}) {{store.city}}' + '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>' + '</div> ' + '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' + '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' + '<span  class="search-span">Shop Now</span>' + '</button>' + '</div>' + '</div>' + '</div> </div>' + '<div class="col-md-12 p-r-0 p-l-0 closest-div">' + '<div class="col-md-12 p-r-0 p-l-0">' + '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' + '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' + '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' + '<info-window id="storeInfo" max-width="200">' + '<div ng-non-bindable="">' + '<div class="scrollFix">' + '<div class="row">' + '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}' + '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>' + '</div>' +
	        //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
	        //  '<div class="col-xs-12">'+
	        //    '<div class="m-b-0">'+
	        //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
	        //    '<span>{{storeObj.addressLine1}}<br />'+
	        //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
	        //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
	        //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
	        //    '</div>'+
	        //  '</div>'+
	        '</div>' + '</div>' + '</div>' + '</info-window>' + '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' + '</map>' + '</div>',
	        controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap', function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
	          var _this = this;
	
	          this.$state = $state;
	          $scope.selectedStoreClass = "selectedStore";
	          $scope.notSelectedClass = "";
	          $scope.lat = '37.274053';
	          $scope.long = '-103.535156';
	          $scope.zoom = 4;
	          $scope.count = 5;
	          $scope.noStoresFound = false;
	          $scope.stores = [];
	          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
	          $scope.markerIcon = $ctrl.markerIcon;
	          $scope.notMoreThanone = 0;
	          NgMap.getMap().then(function (map) {
	            console.log('map', map);
	            $scope.map = map;
	          });
	
	          $scope.showStoreInfo = function (e, index, storeObj) {
	            console.log('storeObj', storeObj);
	            $scope.changeStyle();
	            $scope.selectedStore = storeObj.storeURLName;
	            $scope.storeIndex = index + 1;
	
	            $scope.storeObj = storeObj;
	            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
	          };
	
	          $scope.ok = function () {
	            //  $uibModalInstance.close();
	            $scope.count = 5;
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": 5
	
	            };
	
	            // THough if its a SEO site, Hard coding isSEORequest to false, in order to not to display the store which needs to be redirected while registering.
	            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.isSEORequest = true;
	            // }
	            // data.isSEORequest = false;
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              $scope.lat = $scope.stores[0].lat;
	              $scope.long = $scope.stores[0].lng;
	              $scope.zoom = 4;
	              $scope.noStoresFound = false;
	              console.log(success.data);
	              if ($scope.stores.length == 0) {
	                $scope.noStoresFound = true;
	              }
	
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            }, function (error) {
	              $scope.noStoresFound = true;
	            });
	          };
	
	          $scope.loadMore = function () {
	            //  $uibModalInstance.close();
	            if ($scope.count) {
	              $scope.count = $scope.count + 5;
	            } else {
	              $scope.count = 10;
	            }
	            var data = {
	              "searchKey": $scope.zipcode,
	              "noOfStores": $scope.count
	
	            };
	            // THough if its a SEO site, Hard coding isSEORequest to false, in order to not to display the store which needs to be redirected while registering.
	            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
	            //   data.isSEORequest = true;
	            // }
	            // data.isSEORequest = false;
	            var stores = $auth.getStoresbyZipcode(data);
	            stores.then(function (success) {
	              $scope.stores = success.data;
	              console.log(success.data);
	              // this.test();
	              // $state.go('signup', {
	              //   storeName: 'indianapolis'
	              // });
	            });
	          };
	
	          $scope.cancel = function () {
	
	            $uibModalInstance.close();
	          };
	
	          $scope.selectStore = function (index, store, item) {
	            // $scope.changeStyle();
	
	            $scope.showStoreInfo(item, index, store);
	            $scope.selectedStore = item;
	            $scope.storeObj = store;
	            $scope.lat = store.lat;
	            $scope.long = store.lng;
	          };
	
	          $scope.changeStyle = function () {
	            console.log("$scope.notMoreThanone", $scope.notMoreThanone);
	            if ($scope.notMoreThanone < 2) {
	              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
	              // var selectorText = '.gm-style-iw-a::after';
	              var selectorText = '.gm-style .gm-style-iw-c';
	              var replace_infowindow = 'replace-infowindow';
	              var arrow_selector = '.gm-style-iw-a::after';
	              var replace_arrow_selector = 'replace_arrow_a::after';
	              var theRules = [];
	              // console.log(document.styleSheets[29].cssRules.length);
	              for (var i = 0; i < document.styleSheets.length; i++) {
	                try {
	                  if (document.styleSheets[i].cssRules) {
	                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
	                      // console.log(document.styleSheets[i].cssRules[j].selectorText);
	                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow || document.styleSheets[i].cssRules[j].selectorText == arrow_selector || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                        console.log("Inside:", document.styleSheets[i].cssRules[j].selectorText, " JValue :", j);
	                        // document.styleSheets[i].cssRules[j].selectorText="gm-style-iw-t::after";
	                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
	                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
	                        } else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
	                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
	                        }
	                        console.log("Inside:", document.styleSheets[i].cssRules[j]);
	                      }
	                    }
	                  }
	                } catch (e) {
	                  console.log("Some Error");
	                }
	              }
	              // else if (document.styleSheets[0].rules) {
	              //     theRules = document.styleSheets[0].rules;
	              // }
	              // console.log("theRules : ", theRules);
	              // for (var n in theRules)
	              // {
	              //     cosole.log("Rules :",theRules[n].selectorText);
	              //     if (theRules[n].selectorText == selectorText)   {
	              //         theRules[n].style.color = 'blue';
	              //     }
	              // }
	            } else {
	              console.log("Else part :");
	            }
	            $scope.notMoreThanone = $scope.notMoreThanone + 1;
	          };
	
	          $scope.goToProductPage = function (store, item) {
	            console.log($stateParams);
	            $stateParams.storeName = item;
	            $window.location.href = '/' + $stateParams.storeName + '/' + $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
	            // $uibModalInstance.close();
	            //  this.$state.go('signup', {
	            //    storeName: item
	            //  });
	          };
	
	          $scope.formatMobileNum = function (num, format) {
	
	            var unFormattedNum = num;
	            var position1 = 0;
	            var position2 = 4;
	            var position3 = 9;
	            var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
	            var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
	            var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
	            return FormattedNum;
	          };
	
	          $scope.goToSignUp = function (store, item) {
	            console.log($stateParams);
	            // $stateParams.storeName = item;
	            // $window.location.href = '/'+$stateParams.storeName + '/' +
	            // $stateParams.categoryId + '/'+ $stateParams.subCategoryId + '/' + $stateParams.productId;
	
	            $uibModalInstance.close();
	            _this.$state.go('signup', {
	              storeName: item
	            });
	          };
	        }]
	
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this2 = this;
	
	      if (form.$invalid) {
	        return;
	      }
	      var isCancel = false;
	      form.error = {};
	      this.$spinner.show('appSpinner');
	      this.authService.registerLogin({
	        email: this.email,
	        password: this.password
	      }).then(function (success) {
	        _this2.$spinner.hide('appSpinner');
	        _this2.$rootScope.$emit('loginFromPopup', success);
	      }, function (error) {
	        _this2.$spinner.hide('appSpinner');
	        if (error.data.errorCode === 621) {
	          _this2.noEmailError = true;
	          _this2.$state.go('inactive');
	        } else {
	          _this2.noEmailError = false;
	          form.error = error.data;
	        }
	      });
	    }
	  }, {
	    key: 'togglePassword',
	    value: function togglePassword(passwordIdTag, togglei) {
	      var x = document.getElementById(passwordIdTag);
	      var y = document.getElementById(togglei);
	      console.log("Password tag ", x);
	      if (x.type === "password") {
	        x.type = "text";
	        y.classList.remove('fa-eye-slash');
	        y.classList.add('fa-eye');
	      } else {
	        x.type = "password";
	        y.classList.remove('fa-eye');
	        y.classList.add('fa-eye-slash');
	      }
	    }
	  }]);
	
	  return navlogin;
	}(), _class2.$inject = ['$rootScope', '$scope', '$ngRedux', '$state', '$stateParams', '$cookies', 'spinnerService', 'authService', 'toaster', '$window', 'orderService', '$uibModal', '$q', 'APP'], _temp)) || _class);
	exports.default = navlogin;

/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports = "<form class=\"login-form\" name=\"loginForm\"\r\n      ng-submit=\"login.submit(loginForm)\"\r\n      autocomplete=\"off\"\r\n      novalidate>\r\n  <div class=\"error-text\" ng-bind=\"loginForm.error.message\"></div>\r\n  <div class=\"form-group\"\r\n       ng-class=\"{'has-danger': (loginForm.$submitted || loginForm.email.$touched) && loginForm.email.$invalid }\">\r\n    <label>Email&nbsp<span><a href=\"#\" tooltips tooltip-template=\"Daily Savings Club Members must register with the same email address that is associated with the 'in-store' account in order to receive membership benefits. If you do not know which email address was provided, please contact the store.\" tooltip-size=\"small\" tooltip-smart=\"true\" tooltip-class=\"info-tooltip\" tooltip-side=\"right\"><img src=\"{{login.info}}\" alt=\"info\"></a></span></label>\r\n    <input name=\"email\"\r\n           type=\"email\"\r\n           ng-pattern=\"/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]*\\.[A-Za-z]{2,}\\.[A-Za-z]{2,})$/\"\r\n           class=\"form-control\"\r\n           ng-model=\"login.email\"\r\n           required>\r\n    <div ng-messages=\"loginForm.email.$error\"\r\n         class=\"form-control-feedback\"\r\n         ng-show=\"loginForm.email.$touched || loginForm.$submitted\">\r\n      <div ng-message=\"required\">Enter email address</div>\r\n      <div ng-message=\"pattern\">Enter a valid email address</div>\r\n      <div ng-message=\"email\">Enter a valid email address</div>\r\n      <div class=\"error-text\"\r\n           ng-show=\"loginForm.errors.email && !loginForm.email.$error.required && !loginForm.email.$error.pattern\">{{ loginForm.errors.email[0] }}</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"form-group\"\r\n       ng-class=\"{'has-danger': (loginForm.$submitted || loginForm.password.$touched) && loginForm.password.$invalid }\">\r\n    <label>Password</label>\r\n    <div class=\"password-container\">\r\n      <input name=\"password\" type=\"password\"\r\n            class=\"form-control\" ng-model=\"login.password\"\r\n            ng-minlength=\"6\" ng-maxlength=\"60\"\r\n            id=\"passwordIdNav\" required>\r\n      <i class=\"far fa-eye-slash\"\r\n         ng-click=\"login.togglePassword('passwordIdNav','togglePasswordNav')\" id=\"togglePasswordNav\" style=\"cursor: pointer;\">\r\n    </i>\r\n    </div>\r\n      <div ng-messages=\"loginForm.password.$error\"\r\n          class=\"form-control-feedback\"\r\n          ng-if=\"loginForm.password.$touched || loginForm.$submitted\">\r\n        <div ng-message=\"required\">Password is required</div>\r\n        <div ng-message=\"minlength\">Minimum Password length should be 6</div>\r\n        <div ng-message=\"maxlength\">Maximum Password length should be 60</div>\r\n        <div class=\"error-text\"\r\n            ng-show=\"loginForm.errors.password && !loginForm.password.$error.required\">{{ loginForm.errors.password[0] }}</div>\r\n      </div>\r\n  </div>\r\n\r\n  <p class=\"text-xs-center gray-text mb-4\">\r\n    By using this site, you agree to <a target=\"_blank\" ui-sref=\"tnc\" class=\"link-text\">Terms and Conditions</a> and <a target=\"_blank\" ui-sref=\"rules\" class=\"link-text\">Rules</a>.\r\n  </p>\r\n\r\n  <button type=\"submit\"\r\n          class=\"btn btn-primary btn-block login-margin btn-sm-text mockup-btn\">Log in</button>\r\n\r\n  <p class=\"mt-4 m-b-1\">\r\n    <a ui-sref=\"forgotPassword\" class=\"link-text gray-text\">Forgot Password?</a>\r\n    <span ng-if=\"login.isScreenSmall()\" class=\"pull-xs-right\">Don't have an account?</span>\r\n  </p>\r\n  <p class=\"mb-4 pull-xs-right\" ng-if=\"!login.isScreenSmall()\">Don't have an account?</p>\r\n\r\n  <button ng-if=\"login.storeName\" type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-sm-text mockup-btn\"\r\n          ui-sref=\"signup({storeName: login.storeName})\">\r\n          <span>Register here</span>\r\n          </button>\r\n  <button ng-if=\"!login.storeName\" type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-sm-text mockup-btn\"\r\n          ng-click=\"login.openStoreSelector()\">\r\n    <span>Register here</span>\r\n  </button>\r\n\r\n</form>"

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _navMenu = __webpack_require__(286);
	
	var _navMenu2 = _interopRequireDefault(_navMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var navMenu = (_dec = (0, _utils.Component)({
	  controllerAs: 'ctrl',
	  template: _navMenu2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function navMenu($scope, $ngRedux, $state, $auth, $order, $cookies) {
	    _classCallCheck(this, navMenu);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    this.$order = $order;
	    this.$state = $state;
	    this.$auth = $auth;
	    var guestStore = null;
	    try {
	      guestStore = sessionStorage.getItem('guestStoreName');
	    } catch (e) {
	      guestStore = $cookies.get('guestStoreName');
	    }
	    this.$auth.getStoreDetail(guestStore);
	    $order.getGiftCards();
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(navMenu, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      var obj = {
	        profile: state.auth.profile,
	        list: state.order.categories,
	        giftCards: state.order.giftCards
	      };
	      if (!obj.profile.store) {
	        obj.profile = { 'store': state.auth.storeDetail };
	      }
	      return obj;
	    }
	  }, {
	    key: 'doLogout',
	    value: function doLogout() {
	      this.$auth.logout(this.profile);
	    }
	  }, {
	    key: 'goTo',
	    value: function goTo() {
	      // console.log('go to');
	    }
	  }]);
	
	  return navMenu;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'authService', 'orderService', '$cookies'], _temp)) || _class);
	exports.default = navMenu;

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"list-group nav-menu\">\r\n    <a ui-sref=\"recent-order\"  class=\"list-group-item list-group-item-action\">My Orders</a>\r\n    <a ui-sref=\"subscription\" ng-if='ctrl.profile.store.isSubscription==true' class=\"list-group-item list-group-item-action\">My Subscriptions</a>\r\n    <a ui-sref=\"profile\" class=\"list-group-item list-group-item-action\">My Profile</a>\r\n    <a ui-sref=\"changepassword\" class=\"list-group-item list-group-item-action\">Change Password</a>\r\n    <a ui-sref=\"cards-management\" class=\"list-group-item list-group-item-action\">Manage Credit Cards</a>\r\n    <a ui-sref=\"savings-club\" class=\"list-group-item list-group-item-action\">Daily Savings Club</a>\r\n    <a ui-sref=\"gift-card\" ng-if=\"ctrl.giftCards && ctrl.giftCards.length > 0\" class=\"list-group-item list-group-item-action\">Gift Card</a>\r\n   <!-- <a ui-sref=\"settings\" class=\"list-group-item list-group-item-action\">Preferences</a> -->\r\n    <a ui-sref=\"terms-conditions\" class=\"list-group-item list-group-item-action\">Terms of Use</a>\r\n    <a ui-sref=\"rules-faq\" class=\"list-group-item list-group-item-action\">Rules / FAQ</a>\r\n    <a target=\"_blank\" href=\"https://www.wbu.com/privacy-statement/\" class=\"list-group-item list-group-item-action\">Privacy</a>\r\n    <a href class=\"btn mockup-btn btn-primary list-group-item list-group-item-action\" style=\"text-align: center; color: #ffffff\" ng-click=\"ctrl.doLogout()\">Logout</a>\r\n  </div><!--\r\n  <div class=\"row\">\r\n  <ul class=\"list-group list-group-flush\">\r\n    <li class=\"list-group-item\">Cras justo odio</li>\r\n    <li class=\"list-group-item\">Dapibus ac facilisis in</li>\r\n    <li class=\"list-group-item\">Morbi leo risus</li>\r\n    <li class=\"list-group-item\">Porta ac consectetur ac</li>\r\n    <li class=\"list-group-item\">Vestibulum at eros</li>\r\n  </ul>\r\n  \r\n  </div>-->"

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _productPromo = __webpack_require__(288);
	
	var _productPromo2 = _interopRequireDefault(_productPromo);
	
	var _Artboard = __webpack_require__(289);
	
	var _Artboard2 = _interopRequireDefault(_Artboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var productPromo = (_dec = (0, _utils.Component)({
	  controllerAs: 'ctrl',
	  template: _productPromo2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function productPromo($scope, $ngRedux, $state, $auth, $cookies, $window) {
	    _classCallCheck(this, productPromo);
	
	    this.promoImage = _Artboard2.default;
	    this.$window = $window;
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(productPromo, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      var obj = {
	        profile: state.auth.profile,
	        list: state.order.categories
	      };
	      if (!obj.profile.store) {
	        obj.profile = { 'store': state.auth.storeDetail };
	      }
	      return obj;
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }]);
	
	  return productPromo;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'authService', '$cookies', '$window'], _temp)) || _class);
	exports.default = productPromo;

/***/ },
/* 288 */
/***/ function(module, exports) {

	module.exports = "<div class=\"product-promo-box rounded row\" >\r\n        <img class=\"not-all-pdts-available-dsk\" ng-src=\"{{ctrl.promoImage}}\"\r\n        alt=\"icon\" >\r\n<!-- <span ng-class=\"ctrl.isIpad() ? 'col-md-8':  'col-md-10'\" style=\"padding:0px;\" >Not all products are available at every WBU Store Location</span> -->\r\n</div>"

/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _storePromo = __webpack_require__(291);
	
	var _storePromo2 = _interopRequireDefault(_storePromo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import promoImagePlaceholder from './../../../images/store_promo_placeholder.png';
	
	var storePromo = (_dec = (0, _utils.Component)({
	  controllerAs: 'ctrl',
	  template: _storePromo2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function storePromo($scope, $ngRedux, $state, $auth, $cookies, $sce, $window) {
	    _classCallCheck(this, storePromo);
	
	    this.deliberatelyTrustDangerousSnippet = function (data) {
	
	      return this.$sce.trustAsHtml(data);
	    };
	
	    this.$sce = $sce;
	    this.$window = $window;
	    // this.promoImagePlaceholder = promoImagePlaceholder;
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(storePromo, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      var obj = {
	        profile: state.auth.profile,
	        list: state.order.categories
	      };
	      if (!obj.profile.store) {
	        obj.profile = { 'store': state.auth.storeDetail };
	      }
	      return obj;
	    }
	  }, {
	    key: 'getImageHeight',
	    value: function getImageHeight() {
	      var shippingImageHeight = document.getElementById('store_promo_img').clientHeight;
	      // var titleHeight =document.getElementById('store-promo-head').clientHeight; 
	      return shippingImageHeight + 'px';
	    }
	  }, {
	    key: 'getDescHeight',
	    value: function getDescHeight() {
	      var shippingImageHeight = document.getElementById('store_promo_img').clientHeight;
	      // var titleHeight =document.getElementById('store-promo-head').clientHeight; 
	      return shippingImageHeight - 120 + 'px';
	    }
	  }, {
	    key: 'getBodyHeight',
	    value: function getBodyHeight() {
	      var shippingImageHeight = document.getElementById('store_promo_img').clientHeight;
	      return shippingImageHeight - 53 + 'px';
	    }
	  }, {
	    key: 'isIpad',
	    value: function isIpad() {
	
	      return this.$window.innerWidth < 1248 && this.$window.innerWidth > 767;
	    }
	  }]);
	
	  return storePromo;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'authService', '$cookies', '$sce', '$window'], _temp)) || _class);
	exports.default = storePromo;

/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"!ctrl.isIpad()\" class=\"rounded store-promo-box hidden-md-up \" style=\"padding-top:36px;\">\r\n\r\n        <div class=\"row body-content hidden-md-up\">\r\n                <div class=\"col-md-12 col-sm-12 col-xs-12  items\">\r\n                        <div class=\"row\">\r\n                                <div class=\"col-md-12 headline\" style=\"text-align: center;\" title=\"{{$root.promo.storePromo.headline}}\">{{$root.promo.storePromo.headline}}</div>\r\n                        </div> <br>\r\n                        <div class=\"row m-t-10\">\r\n                                <div class=\"col-md-8 col-sm-12 col-xs-12 image\">\r\n                                        <img ng-if=\"$root.promo.storePromo.image_m && $root.promo.storePromo.image_m !=''\"\r\n                                                ng-src=\" {{$root.promo.storePromo.image_m}}\" alt=\"Add Photo\" class=\"img-fluid rounded cursor-pointer\">\r\n                                        <img ng-if=\"!$root.promo.storePromo.image_m\" ng-src=\"{{ctrl.promoImagePlaceholder}}\"\r\n                                                alt=\"Add Photo\" class=\"img-fluid rounded cursor-pointer\">\r\n\r\n                                </div>\r\n                                <div class=\"col-md-4 col-sm-12 col-xs-12 title\" style=\"text-align: left; font-size: 14px; font-weight: 600;\">\r\n                                        {{$root.promo.storePromo.title}}</div>\r\n                                <div class=\"col-md-4 col-sm-12 col-xs-12 subtitle\" style=\"text-align: left;\">\r\n                                        {{$root.promo.storePromo.subTitle}}</div>\r\n                        </div>\r\n                </div>\r\n                <br />\r\n                <div class=\"col-md-12 col-sm-12 col-xs-12 \">\r\n                        <div class=\"row\">\r\n\r\n                                <div class=\"col-md-12 promotext\" style=\"max-height: 303px;\" data-html=\"true\"\r\n                                        ng-bind-html=\"ctrl.deliberatelyTrustDangerousSnippet($root.promo.storePromo.promoText)\">\r\n                                </div>\r\n                        </div>\r\n                </div>\r\n        </div>\r\n</div>\r\n<div class=\"rounded store-promo-box \" style=\"display:none;\"  ng-if=\"ctrl.isIpad()\"\r\n        style=\"padding-top:36px;\">\r\n\r\n        <div class=\"row body-content \">\r\n                <div class=\"col-md-12 col-sm-12 col-xs-12  items\">\r\n                        <div class=\"row\" style=\"text-align: center;\">\r\n                                <div class=\"col-md-12 headline\" title=\"{{$root.promo.storePromo.headline}}\">{{$root.promo.storePromo.headline}}</div>\r\n                        </div> <br>\r\n                        <div class=\"row m-t-10\">\r\n                                <div class=\"col-md-6 col-sm-8 col-xs-8 image\">\r\n                                        <img ng-if=\"$root.promo.storePromo.image_m && $root.promo.storePromo.image_m !=''\"\r\n                                                ng-src=\" {{$root.promo.storePromo.image_m}}\" alt=\"Add Photo\" class=\"img-fluid rounded cursor-pointer\">\r\n                                        <img ng-if=\"!$root.promo.storePromo.image_m\" ng-src=\"{{ctrl.promoImagePlaceholder}}\"\r\n                                                alt=\"Add Photo\" class=\"img-fluid rounded cursor-pointer\">\r\n                                </div>\r\n                                <div class=\"col-md-6 col-sm-4 col-xs-4 title\"> {{$root.promo.storePromo.title}}</div>\r\n                                <div class=\"col-md-6 col-sm-4 col-xs-4 subtitle\"> {{$root.promo.storePromo.subTitle}}</div>\r\n                        </div>\r\n                </div>\r\n                <br />\r\n                <div class=\"col-md-12 col-sm-12 col-xs-12 \">\r\n                        <div class=\"row\" ng-style=\"ctrl.isIpad() ? {'max-height':ctrl.getDescHeight()} :''\" style=\" overflow: auto;\">\r\n\r\n                                <div class=\"col-md-12 promotext\" data-html=\"true\" ng-bind-html=\"ctrl.deliberatelyTrustDangerousSnippet($root.promo.storePromo.promoText)\">\r\n                                </div>\r\n                        </div>\r\n                </div>\r\n        </div>\r\n</div>\r\n<div class=\"rounded store-promo-box hidden-sm-down \" ng-style=\"ctrl.isIpad() ? {'height':ctrl.getImageHeight()} :{'height':ctrl.getImageHeight()}\">\r\n        <div class=\"row body-content hidden-sm-down\" ng-style=\"ctrl.isIpad() ? {'height':ctrl.getBodyHeight()} :{'height':ctrl.getBodyHeight()}\"> \r\n                <div ng-class=\"ctrl.isIpad()?'col-md-5':'col-md-4'\" class=\" items\">\r\n                        <div class=\"row\">\r\n                                <div class=\"col-md-12 image\">\r\n                                        <img ng-if=\"$root.promo.storePromo.image_d\" ng-src=\" {{$root.promo.storePromo.image_d}}\"\r\n                                                ng-src=\" {{$root.promo.storePromo.image_d}}\" alt=\"Add Photo\" class=\"img-fluid rounded\">\r\n                                        <img ng-if=\"!$root.promo.storePromo.image_d\" ng-src=\"{{ctrl.promoImagePlaceholder}}\"\r\n                                                alt=\"Add Photo\" class=\"img-fluid rounded\">\r\n                                </div>\r\n                                <div class=\"col-md-12 title\"> {{$root.promo.storePromo.title}}</div>\r\n                                <div class=\"col-md-12 subtitle\"> {{$root.promo.storePromo.subTitle}}</div>\r\n                        </div>\r\n                </div>\r\n                <div ng-class=\"ctrl.isIpad()?'col-md-7':'col-md-8'\" class=\" items\">\r\n                        <div class=\"row\"  style=\" overflow: auto;\">\r\n                                <div class=\"col-md-12 headline\" title=\"{{$root.promo.storePromo.headline}}\">{{$root.promo.storePromo.headline}}\r\n                                </div>\r\n                                <div class=\"col-md-12 promotext\" ng-style=\"ctrl.isIpad() ? {'max-height':ctrl.getDescHeight()} :{'max-height':ctrl.getDescHeight()}\" ng-bind-html=\"ctrl.deliberatelyTrustDangerousSnippet($root.promo.storePromo.promoText)\">\r\n                                </div>\r\n                        </div>\r\n                </div>\r\n        </div>\r\n\r\n</div>"

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _utils = __webpack_require__(71);
	
	var _storeSelector = __webpack_require__(293);
	
	var _storeSelector2 = _interopRequireDefault(_storeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var storeSelector = (_dec = (0, _utils.Component)({
	  controllerAs: 'store',
	  template: _storeSelector2.default
	}), _dec(_class = (_temp = _class2 = function () {
	  function storeSelector($scope, $ngRedux, $state, $auth, $cookies) {
	    _classCallCheck(this, storeSelector);
	
	    var disconnect = $ngRedux.connect(this.mapState)(this);
	
	    this.$state = $state;
	    this.$auth = $auth;
	    var guestStore = null;
	    try {
	      guestStore = sessionStorage.getItem('guestStoreName');
	    } catch (e) {
	      guestStore = $cookies.get('guestStoreName');
	    }
	    this.$auth.getStoreDetail(guestStore);
	    $scope.$on('$destroy', disconnect);
	  }
	
	  _createClass(storeSelector, [{
	    key: 'mapState',
	    value: function mapState(state) {
	      var obj = {
	        profile: state.auth.profile,
	        list: state.order.categories
	      };
	      if (!obj.profile.store) {
	        obj.profile = { 'store': state.auth.storeDetail };
	      }
	      return obj;
	    }
	  }, {
	    key: 'doLogout',
	    value: function doLogout() {
	      this.$auth.logout(this.profile);
	    }
	  }, {
	    key: 'goTo',
	    value: function goTo() {
	      // console.log('go to');
	    }
	  }]);
	
	  return storeSelector;
	}(), _class2.$inject = ['$scope', '$ngRedux', '$state', 'authService', '$cookies'], _temp)) || _class);
	exports.default = storeSelector;

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = "<form class=\"store-form\" name=\"storeForm\"\r\n      \r\n      autocomplete=\"off\"\r\n      novalidate>\r\n  <div class=\"error-text\" ng-bind=\"storeForm.error.message\"></div>\r\n <label>ZipCode<span><br>\r\n    <input name=\"zipcode\"\r\n           type=\"text\"\r\n           class=\"form-control\"\r\n           ng-model=\"store.zipcode\"\r\n           required>\r\n  <br>\r\n\r\n  <button type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-sm-text mockup-btn\"\r\n          >\r\n    <span>Search Store</span>\r\n  </button>\r\n\r\n</form>"

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = thumbnailSlider;
	function thumbnailSlider() {
		return {
			restrict: 'A',
			link: function link(scope, elem, attr) {
				scope.scrollToRight = function () {
					elem[0].scrollLeft += Number(attr.thumbnailSlider);
				};
	
				scope.scrollToLeft = function () {
					elem[0].scrollLeft -= Number(attr.thumbnailSlider);
				};
			}
		};
	}

/***/ },
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(300);
	module.exports = exports = 'angulartics.google.adwords.remarketing.tag';

/***/ },
/* 300 */
/***/ function(module, exports) {

	(function(window, angular, undefined) {'use strict';
	
	    /**
	     * @ngdoc overview
	     * @name angulartics.google.adwords.remarketing.tag
	     * Enables remarketing support for Google Adwords Remaketing Tag (https://adwords.google.com/)
	     */
	    angular.module('angulartics.google.adwords.remarketing.tag', ['angulartics'])
	        .config(['$analyticsProvider', function ($analyticsProvider) {
	            angulartics.waitForVendorApi('google_trackConversion', 500, function (trackConversion) {
	                $analyticsProvider.registerPageTrack(function (path) {
	                    trackConversion({
	                        google_conversion_id: window._gart_conversion_id,
	                        google_remarketing_only: true
	                    });
	                });
	            });
	        }]);
	})(window, window.angular);

/***/ }
]);


// WEBPACK FOOTER //
// main.js